export const data = {
  "4.5": {
    "2020-2070": {
      "2": {
        "51001": {
          "name": "Accomack",
          "median": 1.07,
          "10%": 1.0,
          "90%": 1.19,
          "25%": 1.03,
          "75%": 1.12
        },
        "42001": {
          "name": "Adams",
          "median": 1.11,
          "10%": 1.0,
          "90%": 1.23,
          "25%": 1.04,
          "75%": 1.16
        },
        "51003": {
          "name": "Albemarle",
          "median": 1.12,
          "10%": 1.0,
          "90%": 1.24,
          "25%": 1.05,
          "75%": 1.14
        },
        "51510": {
          "name": "Alexandria",
          "median": 1.07,
          "10%": 0.96,
          "90%": 1.13,
          "25%": 1.02,
          "75%": 1.1
        },
        "24001": {
          "name": "Allegany",
          "median": 1.08,
          "10%": 1.0,
          "90%": 1.18,
          "25%": 1.04,
          "75%": 1.12
        },
        "36003": {
          "name": "Allegany",
          "median": 1.09,
          "10%": 1.01,
          "90%": 1.19,
          "25%": 1.06,
          "75%": 1.14
        },
        "51005": {
          "name": "Alleghany",
          "median": 1.09,
          "10%": 0.99,
          "90%": 1.17,
          "25%": 1.03,
          "75%": 1.14
        },
        "42003": {
          "name": "Allegheny",
          "median": 1.08,
          "10%": 1.01,
          "90%": 1.15,
          "25%": 1.04,
          "75%": 1.11
        },
        "51007": {
          "name": "Amelia",
          "median": 1.07,
          "10%": 0.97,
          "90%": 1.18,
          "25%": 1.01,
          "75%": 1.13
        },
        "51009": {
          "name": "Amherst",
          "median": 1.1,
          "10%": 0.99,
          "90%": 1.2,
          "25%": 1.04,
          "75%": 1.15
        },
        "24003": {
          "name": "Anne Arundel",
          "median": 1.06,
          "10%": 1.0,
          "90%": 1.15,
          "25%": 1.03,
          "75%": 1.1
        },
        "51011": {
          "name": "Appomattox",
          "median": 1.11,
          "10%": 0.99,
          "90%": 1.26,
          "25%": 1.06,
          "75%": 1.19
        },
        "51013": {
          "name": "Arlington",
          "median": 1.07,
          "10%": 0.97,
          "90%": 1.13,
          "25%": 1.03,
          "75%": 1.09
        },
        "42005": {
          "name": "Armstrong",
          "median": 1.07,
          "10%": 1.02,
          "90%": 1.12,
          "25%": 1.05,
          "75%": 1.1
        },
        "34001": {
          "name": "Atlantic",
          "median": 1.11,
          "10%": 1.0,
          "90%": 1.15,
          "25%": 1.05,
          "75%": 1.13
        },
        "51015": {
          "name": "Augusta",
          "median": 1.1,
          "10%": 0.99,
          "90%": 1.21,
          "25%": 1.04,
          "75%": 1.16
        },
        "24005": {
          "name": "Baltimore",
          "median": 1.07,
          "10%": 1.0,
          "90%": 1.15,
          "25%": 1.03,
          "75%": 1.12
        },
        "24510": {
          "name": "Baltimore",
          "median": 1.08,
          "10%": 0.99,
          "90%": 1.16,
          "25%": 1.01,
          "75%": 1.12
        },
        "54001": {
          "name": "Barbour",
          "median": 1.05,
          "10%": 0.99,
          "90%": 1.11,
          "25%": 1.02,
          "75%": 1.09
        },
        "51017": {
          "name": "Bath",
          "median": 1.1,
          "10%": 1.04,
          "90%": 1.19,
          "25%": 1.06,
          "75%": 1.15
        },
        "42007": {
          "name": "Beaver",
          "median": 1.07,
          "10%": 1.01,
          "90%": 1.16,
          "25%": 1.05,
          "75%": 1.11
        },
        "42009": {
          "name": "Bedford",
          "median": 1.1,
          "10%": 1.01,
          "90%": 1.15,
          "25%": 1.05,
          "75%": 1.13
        },
        "51019": {
          "name": "Bedford",
          "median": 1.1,
          "10%": 1.0,
          "90%": 1.18,
          "25%": 1.06,
          "75%": 1.15
        },
        "54003": {
          "name": "Berkeley",
          "median": 1.09,
          "10%": 0.98,
          "90%": 1.2,
          "25%": 1.05,
          "75%": 1.17
        },
        "42011": {
          "name": "Berks",
          "median": 1.1,
          "10%": 1.03,
          "90%": 1.16,
          "25%": 1.06,
          "75%": 1.13
        },
        "42013": {
          "name": "Blair",
          "median": 1.09,
          "10%": 1.02,
          "90%": 1.15,
          "25%": 1.06,
          "75%": 1.12
        },
        "51021": {
          "name": "Bland",
          "median": 1.08,
          "10%": 1.01,
          "90%": 1.17,
          "25%": 1.03,
          "75%": 1.12
        },
        "54005": {
          "name": "Boone",
          "median": 1.07,
          "10%": 1.02,
          "90%": 1.16,
          "25%": 1.04,
          "75%": 1.11
        },
        "51023": {
          "name": "Botetourt",
          "median": 1.11,
          "10%": 1.0,
          "90%": 1.18,
          "25%": 1.06,
          "75%": 1.15
        },
        "42015": {
          "name": "Bradford",
          "median": 1.07,
          "10%": 1.02,
          "90%": 1.16,
          "25%": 1.04,
          "75%": 1.1
        },
        "54007": {
          "name": "Braxton",
          "median": 1.06,
          "10%": 1.03,
          "90%": 1.15,
          "25%": 1.04,
          "75%": 1.12
        },
        "51520": {
          "name": "Bristol",
          "median": 1.07,
          "10%": 1.02,
          "90%": 1.15,
          "25%": 1.04,
          "75%": 1.12
        },
        "36005": {
          "name": "Bronx",
          "median": 1.09,
          "10%": 0.99,
          "90%": 1.18,
          "25%": 1.04,
          "75%": 1.14
        },
        "54009": {
          "name": "Brooke",
          "median": 1.1,
          "10%": 1.01,
          "90%": 1.21,
          "25%": 1.06,
          "75%": 1.14
        },
        "36007": {
          "name": "Broome",
          "median": 1.08,
          "10%": 0.99,
          "90%": 1.16,
          "25%": 1.05,
          "75%": 1.14
        },
        "51025": {
          "name": "Brunswick",
          "median": 1.08,
          "10%": 1.02,
          "90%": 1.17,
          "25%": 1.04,
          "75%": 1.13
        },
        "51027": {
          "name": "Buchanan",
          "median": 1.08,
          "10%": 0.99,
          "90%": 1.15,
          "25%": 1.04,
          "75%": 1.11
        },
        "51029": {
          "name": "Buckingham",
          "median": 1.09,
          "10%": 0.99,
          "90%": 1.2,
          "25%": 1.02,
          "75%": 1.12
        },
        "42017": {
          "name": "Bucks",
          "median": 1.08,
          "10%": 1.0,
          "90%": 1.16,
          "25%": 1.03,
          "75%": 1.12
        },
        "51530": {
          "name": "Buena Vista",
          "median": 1.09,
          "10%": 0.98,
          "90%": 1.25,
          "25%": 1.06,
          "75%": 1.16
        },
        "34005": {
          "name": "Burlington",
          "median": 1.07,
          "10%": 0.99,
          "90%": 1.14,
          "25%": 1.04,
          "75%": 1.1
        },
        "42019": {
          "name": "Butler",
          "median": 1.07,
          "10%": 1.02,
          "90%": 1.14,
          "25%": 1.06,
          "75%": 1.11
        },
        "54011": {
          "name": "Cabell",
          "median": 1.08,
          "10%": 1.01,
          "90%": 1.17,
          "25%": 1.03,
          "75%": 1.11
        },
        "54013": {
          "name": "Calhoun",
          "median": 1.1,
          "10%": 1.03,
          "90%": 1.18,
          "25%": 1.05,
          "75%": 1.13
        },
        "24009": {
          "name": "Calvert",
          "median": 1.07,
          "10%": 1.01,
          "90%": 1.16,
          "25%": 1.03,
          "75%": 1.11
        },
        "42021": {
          "name": "Cambria",
          "median": 1.05,
          "10%": 1.0,
          "90%": 1.12,
          "25%": 1.02,
          "75%": 1.08
        },
        "34007": {
          "name": "Camden",
          "median": 1.07,
          "10%": 1.01,
          "90%": 1.15,
          "25%": 1.04,
          "75%": 1.13
        },
        "42023": {
          "name": "Cameron",
          "median": 1.08,
          "10%": 1.01,
          "90%": 1.17,
          "25%": 1.04,
          "75%": 1.12
        },
        "51031": {
          "name": "Campbell",
          "median": 1.11,
          "10%": 1.01,
          "90%": 1.22,
          "25%": 1.08,
          "75%": 1.16
        },
        "34009": {
          "name": "Cape May",
          "median": 1.09,
          "10%": 0.99,
          "90%": 1.15,
          "25%": 1.04,
          "75%": 1.13
        },
        "42025": {
          "name": "Carbon",
          "median": 1.08,
          "10%": 1.02,
          "90%": 1.13,
          "25%": 1.05,
          "75%": 1.12
        },
        "24011": {
          "name": "Caroline",
          "median": 1.07,
          "10%": 0.98,
          "90%": 1.17,
          "25%": 1.02,
          "75%": 1.11
        },
        "51033": {
          "name": "Caroline",
          "median": 1.07,
          "10%": 1.0,
          "90%": 1.17,
          "25%": 1.03,
          "75%": 1.14
        },
        "24013": {
          "name": "Carroll",
          "median": 1.12,
          "10%": 1.02,
          "90%": 1.2,
          "25%": 1.06,
          "75%": 1.16
        },
        "51035": {
          "name": "Carroll",
          "median": 1.09,
          "10%": 1.03,
          "90%": 1.19,
          "25%": 1.05,
          "75%": 1.15
        },
        "24015": {
          "name": "Cecil",
          "median": 1.1,
          "10%": 1.01,
          "90%": 1.17,
          "25%": 1.04,
          "75%": 1.13
        },
        "42027": {
          "name": "Centre",
          "median": 1.09,
          "10%": 1.04,
          "90%": 1.17,
          "25%": 1.06,
          "75%": 1.13
        },
        "24017": {
          "name": "Charles",
          "median": 1.07,
          "10%": 1.0,
          "90%": 1.17,
          "25%": 1.03,
          "75%": 1.13
        },
        "51036": {
          "name": "Charles City",
          "median": 1.07,
          "10%": 0.98,
          "90%": 1.15,
          "25%": 1.02,
          "75%": 1.11
        },
        "51037": {
          "name": "Charlotte",
          "median": 1.09,
          "10%": 0.99,
          "90%": 1.16,
          "25%": 1.06,
          "75%": 1.14
        },
        "51540": {
          "name": "Charlottesville",
          "median": 1.09,
          "10%": 0.97,
          "90%": 1.21,
          "25%": 1.05,
          "75%": 1.13
        },
        "36015": {
          "name": "Chemung",
          "median": 1.07,
          "10%": 1.01,
          "90%": 1.17,
          "25%": 1.03,
          "75%": 1.12
        },
        "36017": {
          "name": "Chenango",
          "median": 1.08,
          "10%": 1.01,
          "90%": 1.14,
          "25%": 1.05,
          "75%": 1.12
        },
        "51550": {
          "name": "Chesapeake",
          "median": 1.07,
          "10%": 0.99,
          "90%": 1.2,
          "25%": 1.02,
          "75%": 1.14
        },
        "42029": {
          "name": "Chester",
          "median": 1.09,
          "10%": 1.01,
          "90%": 1.17,
          "25%": 1.04,
          "75%": 1.12
        },
        "51041": {
          "name": "Chesterfield",
          "median": 1.06,
          "10%": 0.98,
          "90%": 1.2,
          "25%": 1.01,
          "75%": 1.13
        },
        "42031": {
          "name": "Clarion",
          "median": 1.09,
          "10%": 1.04,
          "90%": 1.14,
          "25%": 1.06,
          "75%": 1.11
        },
        "51043": {
          "name": "Clarke",
          "median": 1.12,
          "10%": 1.01,
          "90%": 1.22,
          "25%": 1.05,
          "75%": 1.2
        },
        "54015": {
          "name": "Clay",
          "median": 1.05,
          "10%": 1.0,
          "90%": 1.16,
          "25%": 1.03,
          "75%": 1.1
        },
        "42033": {
          "name": "Clearfield",
          "median": 1.1,
          "10%": 1.04,
          "90%": 1.15,
          "25%": 1.06,
          "75%": 1.13
        },
        "42035": {
          "name": "Clinton",
          "median": 1.09,
          "10%": 1.02,
          "90%": 1.15,
          "25%": 1.04,
          "75%": 1.13
        },
        "51570": {
          "name": "Colonial Heights",
          "median": 1.06,
          "10%": 0.94,
          "90%": 1.18,
          "25%": 1.0,
          "75%": 1.14
        },
        "42037": {
          "name": "Columbia",
          "median": 1.08,
          "10%": 1.02,
          "90%": 1.19,
          "25%": 1.04,
          "75%": 1.12
        },
        "36023": {
          "name": "Cortland",
          "median": 1.09,
          "10%": 1.04,
          "90%": 1.14,
          "25%": 1.06,
          "75%": 1.12
        },
        "51580": {
          "name": "Covington",
          "median": 1.08,
          "10%": 0.97,
          "90%": 1.16,
          "25%": 1.02,
          "75%": 1.13
        },
        "51045": {
          "name": "Craig",
          "median": 1.08,
          "10%": 0.99,
          "90%": 1.17,
          "25%": 1.05,
          "75%": 1.15
        },
        "42039": {
          "name": "Crawford",
          "median": 1.07,
          "10%": 1.01,
          "90%": 1.14,
          "25%": 1.03,
          "75%": 1.11
        },
        "51047": {
          "name": "Culpeper",
          "median": 1.08,
          "10%": 1.01,
          "90%": 1.2,
          "25%": 1.03,
          "75%": 1.12
        },
        "34011": {
          "name": "Cumberland",
          "median": 1.075,
          "10%": 1.01,
          "90%": 1.13,
          "25%": 1.04,
          "75%": 1.11
        },
        "42041": {
          "name": "Cumberland",
          "median": 1.11,
          "10%": 1.01,
          "90%": 1.22,
          "25%": 1.04,
          "75%": 1.16
        },
        "51049": {
          "name": "Cumberland",
          "median": 1.07,
          "10%": 0.99,
          "90%": 1.2,
          "25%": 1.02,
          "75%": 1.14
        },
        "51590": {
          "name": "Danville",
          "median": 1.12,
          "10%": 0.99,
          "90%": 1.19,
          "25%": 1.05,
          "75%": 1.16
        },
        "42043": {
          "name": "Dauphin",
          "median": 1.1,
          "10%": 1.01,
          "90%": 1.21,
          "25%": 1.04,
          "75%": 1.15
        },
        "36025": {
          "name": "Delaware",
          "median": 1.09,
          "10%": 1.01,
          "90%": 1.16,
          "25%": 1.05,
          "75%": 1.13
        },
        "42045": {
          "name": "Delaware",
          "median": 1.09,
          "10%": 0.99,
          "90%": 1.17,
          "25%": 1.05,
          "75%": 1.13
        },
        "51051": {
          "name": "Dickenson",
          "median": 1.07,
          "10%": 0.99,
          "90%": 1.14,
          "25%": 1.01,
          "75%": 1.12
        },
        "51053": {
          "name": "Dinwiddie",
          "median": 1.07,
          "10%": 1.0,
          "90%": 1.18,
          "25%": 1.03,
          "75%": 1.15
        },
        "11001": {
          "name": "District of Columbia",
          "median": 1.07,
          "10%": 0.98,
          "90%": 1.16,
          "25%": 1.02,
          "75%": 1.1
        },
        "54017": {
          "name": "Doddridge",
          "median": 1.04,
          "10%": 0.99,
          "90%": 1.14,
          "25%": 1.02,
          "75%": 1.08
        },
        "24019": {
          "name": "Dorchester",
          "median": 1.06,
          "10%": 0.96,
          "90%": 1.17,
          "25%": 1.02,
          "75%": 1.1
        },
        "42047": {
          "name": "Elk",
          "median": 1.08,
          "10%": 1.01,
          "90%": 1.14,
          "25%": 1.04,
          "75%": 1.12
        },
        "51595": {
          "name": "Emporia",
          "median": 1.05,
          "10%": 0.96,
          "90%": 1.12,
          "25%": 1.0,
          "75%": 1.09
        },
        "42049": {
          "name": "Erie",
          "median": 1.08,
          "10%": 1.01,
          "90%": 1.15,
          "25%": 1.05,
          "75%": 1.11
        },
        "51057": {
          "name": "Essex",
          "median": 1.06,
          "10%": 0.96,
          "90%": 1.2,
          "25%": 1.0,
          "75%": 1.11
        },
        "51059": {
          "name": "Fairfax",
          "median": 1.06,
          "10%": 0.99,
          "90%": 1.13,
          "25%": 1.02,
          "75%": 1.09
        },
        "51600": {
          "name": "Fairfax",
          "median": 1.05,
          "10%": 0.98,
          "90%": 1.15,
          "25%": 1.01,
          "75%": 1.1
        },
        "51610": {
          "name": "Falls Church",
          "median": 1.07,
          "10%": 0.98,
          "90%": 1.18,
          "25%": 1.04,
          "75%": 1.1
        },
        "51061": {
          "name": "Fauquier",
          "median": 1.09,
          "10%": 1.0,
          "90%": 1.19,
          "25%": 1.04,
          "75%": 1.14
        },
        "42051": {
          "name": "Fayette",
          "median": 1.05,
          "10%": 1.0,
          "90%": 1.12,
          "25%": 1.02,
          "75%": 1.08
        },
        "54019": {
          "name": "Fayette",
          "median": 1.06,
          "10%": 0.98,
          "90%": 1.16,
          "25%": 1.04,
          "75%": 1.11
        },
        "51063": {
          "name": "Floyd",
          "median": 1.09,
          "10%": 1.01,
          "90%": 1.21,
          "25%": 1.04,
          "75%": 1.17
        },
        "51065": {
          "name": "Fluvanna",
          "median": 1.09,
          "10%": 0.98,
          "90%": 1.23,
          "25%": 1.04,
          "75%": 1.16
        },
        "42053": {
          "name": "Forest",
          "median": 1.07,
          "10%": 1.02,
          "90%": 1.15,
          "25%": 1.05,
          "75%": 1.12
        },
        "42055": {
          "name": "Franklin",
          "median": 1.09,
          "10%": 1.0,
          "90%": 1.19,
          "25%": 1.04,
          "75%": 1.14
        },
        "51067": {
          "name": "Franklin",
          "median": 1.09,
          "10%": 0.99,
          "90%": 1.19,
          "25%": 1.05,
          "75%": 1.14
        },
        "51620": {
          "name": "Franklin",
          "median": 1.08,
          "10%": 0.98,
          "90%": 1.18,
          "25%": 1.05,
          "75%": 1.13
        },
        "24021": {
          "name": "Frederick",
          "median": 1.11,
          "10%": 1.0,
          "90%": 1.2,
          "25%": 1.06,
          "75%": 1.14
        },
        "51069": {
          "name": "Frederick",
          "median": 1.1,
          "10%": 0.99,
          "90%": 1.22,
          "25%": 1.05,
          "75%": 1.14
        },
        "51630": {
          "name": "Fredericksburg",
          "median": 1.09,
          "10%": 0.98,
          "90%": 1.18,
          "25%": 1.04,
          "75%": 1.13
        },
        "42057": {
          "name": "Fulton",
          "median": 1.11,
          "10%": 1.0,
          "90%": 1.21,
          "25%": 1.05,
          "75%": 1.16
        },
        "51640": {
          "name": "Galax",
          "median": 1.08,
          "10%": 0.99,
          "90%": 1.22,
          "25%": 1.02,
          "75%": 1.18
        },
        "24023": {
          "name": "Garrett",
          "median": 1.06,
          "10%": 1.0,
          "90%": 1.1,
          "25%": 1.03,
          "75%": 1.08
        },
        "51071": {
          "name": "Giles",
          "median": 1.09,
          "10%": 1.0,
          "90%": 1.18,
          "25%": 1.04,
          "75%": 1.13
        },
        "54021": {
          "name": "Gilmer",
          "median": 1.08,
          "10%": 1.03,
          "90%": 1.17,
          "25%": 1.05,
          "75%": 1.13
        },
        "34015": {
          "name": "Gloucester",
          "median": 1.08,
          "10%": 0.99,
          "90%": 1.18,
          "25%": 1.05,
          "75%": 1.12
        },
        "51073": {
          "name": "Gloucester",
          "median": 1.06,
          "10%": 0.99,
          "90%": 1.15,
          "25%": 1.03,
          "75%": 1.11
        },
        "51075": {
          "name": "Goochland",
          "median": 1.08,
          "10%": 0.95,
          "90%": 1.25,
          "25%": 1.02,
          "75%": 1.15
        },
        "54023": {
          "name": "Grant",
          "median": 1.05,
          "10%": 0.98,
          "90%": 1.15,
          "25%": 1.02,
          "75%": 1.09
        },
        "51077": {
          "name": "Grayson",
          "median": 1.09,
          "10%": 1.02,
          "90%": 1.19,
          "25%": 1.06,
          "75%": 1.14
        },
        "54025": {
          "name": "Greenbrier",
          "median": 1.08,
          "10%": 1.02,
          "90%": 1.16,
          "25%": 1.03,
          "75%": 1.13
        },
        "36039": {
          "name": "Greene",
          "median": 1.1,
          "10%": 1.02,
          "90%": 1.21,
          "25%": 1.04,
          "75%": 1.14
        },
        "42059": {
          "name": "Greene",
          "median": 1.09,
          "10%": 1.02,
          "90%": 1.17,
          "25%": 1.05,
          "75%": 1.12
        },
        "51079": {
          "name": "Greene",
          "median": 1.1,
          "10%": 0.99,
          "90%": 1.21,
          "25%": 1.02,
          "75%": 1.16
        },
        "51081": {
          "name": "Greensville",
          "median": 1.06,
          "10%": 0.97,
          "90%": 1.14,
          "25%": 1.02,
          "75%": 1.08
        },
        "51083": {
          "name": "Halifax",
          "median": 1.11,
          "10%": 1.01,
          "90%": 1.16,
          "25%": 1.07,
          "75%": 1.13
        },
        "54027": {
          "name": "Hampshire",
          "median": 1.07,
          "10%": 1.01,
          "90%": 1.16,
          "25%": 1.02,
          "75%": 1.12
        },
        "51650": {
          "name": "Hampton",
          "median": 1.08,
          "10%": 0.99,
          "90%": 1.15,
          "25%": 1.02,
          "75%": 1.12
        },
        "54029": {
          "name": "Hancock",
          "median": 1.09,
          "10%": 1.02,
          "90%": 1.18,
          "25%": 1.05,
          "75%": 1.13
        },
        "51085": {
          "name": "Hanover",
          "median": 1.08,
          "10%": 0.99,
          "90%": 1.23,
          "25%": 1.03,
          "75%": 1.13
        },
        "54031": {
          "name": "Hardy",
          "median": 1.08,
          "10%": 1.0,
          "90%": 1.18,
          "25%": 1.03,
          "75%": 1.12
        },
        "24025": {
          "name": "Harford",
          "median": 1.07,
          "10%": 1.01,
          "90%": 1.15,
          "25%": 1.04,
          "75%": 1.12
        },
        "54033": {
          "name": "Harrison",
          "median": 1.07,
          "10%": 1.0,
          "90%": 1.12,
          "25%": 1.04,
          "75%": 1.1
        },
        "51660": {
          "name": "Harrisonburg",
          "median": 1.06,
          "10%": 0.98,
          "90%": 1.17,
          "25%": 1.03,
          "75%": 1.12
        },
        "51087": {
          "name": "Henrico",
          "median": 1.06,
          "10%": 1.01,
          "90%": 1.18,
          "25%": 1.03,
          "75%": 1.13
        },
        "51089": {
          "name": "Henry",
          "median": 1.09,
          "10%": 1.01,
          "90%": 1.18,
          "25%": 1.03,
          "75%": 1.13
        },
        "36043": {
          "name": "Herkimer",
          "median": 1.03,
          "10%": 0.97,
          "90%": 1.09,
          "25%": 1.01,
          "75%": 1.07
        },
        "51091": {
          "name": "Highland",
          "median": 1.09,
          "10%": 1.02,
          "90%": 1.18,
          "25%": 1.05,
          "75%": 1.14
        },
        "51670": {
          "name": "Hopewell",
          "median": 1.05,
          "10%": 0.89,
          "90%": 1.19,
          "25%": 0.98,
          "75%": 1.11
        },
        "24027": {
          "name": "Howard",
          "median": 1.08,
          "10%": 1.01,
          "90%": 1.16,
          "25%": 1.03,
          "75%": 1.12
        },
        "34019": {
          "name": "Hunterdon",
          "median": 1.08,
          "10%": 1.01,
          "90%": 1.17,
          "25%": 1.05,
          "75%": 1.14
        },
        "42061": {
          "name": "Huntingdon",
          "median": 1.1,
          "10%": 1.04,
          "90%": 1.18,
          "25%": 1.07,
          "75%": 1.14
        },
        "42063": {
          "name": "Indiana",
          "median": 1.06,
          "10%": 1.02,
          "90%": 1.11,
          "25%": 1.04,
          "75%": 1.08
        },
        "51093": {
          "name": "Isle of Wight",
          "median": 1.09,
          "10%": 0.98,
          "90%": 1.2,
          "25%": 1.04,
          "75%": 1.14
        },
        "54035": {
          "name": "Jackson",
          "median": 1.08,
          "10%": 1.02,
          "90%": 1.17,
          "25%": 1.05,
          "75%": 1.13
        },
        "51095": {
          "name": "James City",
          "median": 1.06,
          "10%": 0.97,
          "90%": 1.16,
          "25%": 1.02,
          "75%": 1.09
        },
        "42065": {
          "name": "Jefferson",
          "median": 1.09,
          "10%": 1.01,
          "90%": 1.14,
          "25%": 1.05,
          "75%": 1.12
        },
        "54037": {
          "name": "Jefferson",
          "median": 1.1,
          "10%": 0.99,
          "90%": 1.24,
          "25%": 1.05,
          "75%": 1.18
        },
        "42067": {
          "name": "Juniata",
          "median": 1.1,
          "10%": 1.04,
          "90%": 1.21,
          "25%": 1.07,
          "75%": 1.13
        },
        "54039": {
          "name": "Kanawha",
          "median": 1.06,
          "10%": 0.97,
          "90%": 1.15,
          "25%": 1.01,
          "75%": 1.1
        },
        "10001": {
          "name": "Kent",
          "median": 1.07,
          "10%": 1.0,
          "90%": 1.15,
          "25%": 1.03,
          "75%": 1.12
        },
        "24029": {
          "name": "Kent",
          "median": 1.07,
          "10%": 0.99,
          "90%": 1.2,
          "25%": 1.04,
          "75%": 1.09
        },
        "51099": {
          "name": "King George",
          "median": 1.07,
          "10%": 0.98,
          "90%": 1.2,
          "25%": 1.02,
          "75%": 1.14
        },
        "51101": {
          "name": "King William",
          "median": 1.06,
          "10%": 1.0,
          "90%": 1.15,
          "25%": 1.02,
          "75%": 1.1
        },
        "51097": {
          "name": "King and Queen",
          "median": 1.07,
          "10%": 0.979,
          "90%": 1.15,
          "25%": 1.03,
          "75%": 1.1
        },
        "42069": {
          "name": "Lackawanna",
          "median": 1.09,
          "10%": 1.02,
          "90%": 1.16,
          "25%": 1.05,
          "75%": 1.13
        },
        "42071": {
          "name": "Lancaster",
          "median": 1.08,
          "10%": 1.01,
          "90%": 1.15,
          "25%": 1.04,
          "75%": 1.12
        },
        "51103": {
          "name": "Lancaster",
          "median": 1.07,
          "10%": 0.99,
          "90%": 1.15,
          "25%": 1.02,
          "75%": 1.12
        },
        "42073": {
          "name": "Lawrence",
          "median": 1.08,
          "10%": 0.99,
          "90%": 1.14,
          "25%": 1.04,
          "75%": 1.11
        },
        "42075": {
          "name": "Lebanon",
          "median": 1.08,
          "10%": 1.0,
          "90%": 1.15,
          "25%": 1.02,
          "75%": 1.12
        },
        "51105": {
          "name": "Lee",
          "median": 1.1,
          "10%": 1.0,
          "90%": 1.16,
          "25%": 1.03,
          "75%": 1.13
        },
        "42077": {
          "name": "Lehigh",
          "median": 1.1,
          "10%": 1.02,
          "90%": 1.17,
          "25%": 1.07,
          "75%": 1.15
        },
        "54041": {
          "name": "Lewis",
          "median": 1.06,
          "10%": 1.02,
          "90%": 1.13,
          "25%": 1.04,
          "75%": 1.09
        },
        "51678": {
          "name": "Lexington",
          "median": 1.09,
          "10%": 1.02,
          "90%": 1.2,
          "25%": 1.05,
          "75%": 1.15
        },
        "54043": {
          "name": "Lincoln",
          "median": 1.06,
          "10%": 1.0,
          "90%": 1.16,
          "25%": 1.03,
          "75%": 1.11
        },
        "36051": {
          "name": "Livingston",
          "median": 1.08,
          "10%": 1.02,
          "90%": 1.18,
          "25%": 1.06,
          "75%": 1.13
        },
        "54045": {
          "name": "Logan",
          "median": 1.07,
          "10%": 1.01,
          "90%": 1.15,
          "25%": 1.0375,
          "75%": 1.12
        },
        "51107": {
          "name": "Loudoun",
          "median": 1.1,
          "10%": 1.0,
          "90%": 1.2,
          "25%": 1.05,
          "75%": 1.14
        },
        "51109": {
          "name": "Louisa",
          "median": 1.09,
          "10%": 0.98,
          "90%": 1.21,
          "25%": 1.03,
          "75%": 1.14
        },
        "51111": {
          "name": "Lunenburg",
          "median": 1.09,
          "10%": 1.02,
          "90%": 1.16,
          "25%": 1.06,
          "75%": 1.13
        },
        "42079": {
          "name": "Luzerne",
          "median": 1.09,
          "10%": 1.02,
          "90%": 1.16,
          "25%": 1.04,
          "75%": 1.13
        },
        "42081": {
          "name": "Lycoming",
          "median": 1.08,
          "10%": 1.02,
          "90%": 1.18,
          "25%": 1.05,
          "75%": 1.11
        },
        "51680": {
          "name": "Lynchburg",
          "median": 1.09,
          "10%": 1.03,
          "90%": 1.17,
          "25%": 1.06,
          "75%": 1.13
        },
        "36053": {
          "name": "Madison",
          "median": 1.07,
          "10%": 1.0,
          "90%": 1.14,
          "25%": 1.03,
          "75%": 1.11
        },
        "51113": {
          "name": "Madison",
          "median": 1.08,
          "10%": 1.0,
          "90%": 1.18,
          "25%": 1.02,
          "75%": 1.13
        },
        "51683": {
          "name": "Manassas",
          "median": 1.06,
          "10%": 0.99,
          "90%": 1.17,
          "25%": 1.02,
          "75%": 1.1025
        },
        "51685": {
          "name": "Manassas Park",
          "median": 1.05,
          "10%": 0.99,
          "90%": 1.17,
          "25%": 1.02,
          "75%": 1.11
        },
        "54049": {
          "name": "Marion",
          "median": 1.06,
          "10%": 0.97,
          "90%": 1.15,
          "25%": 1.03,
          "75%": 1.11
        },
        "54051": {
          "name": "Marshall",
          "median": 1.09,
          "10%": 1.02,
          "90%": 1.15,
          "25%": 1.04,
          "75%": 1.13
        },
        "51690": {
          "name": "Martinsville",
          "median": 1.09,
          "10%": 1.0,
          "90%": 1.18,
          "25%": 1.03,
          "75%": 1.12
        },
        "54053": {
          "name": "Mason",
          "median": 1.1,
          "10%": 1.02,
          "90%": 1.16,
          "25%": 1.04,
          "75%": 1.15
        },
        "51115": {
          "name": "Mathews",
          "median": 1.08,
          "10%": 0.98,
          "90%": 1.15,
          "25%": 1.03,
          "75%": 1.1
        },
        "54047": {
          "name": "McDowell",
          "median": 1.08,
          "10%": 1.0,
          "90%": 1.16,
          "25%": 1.04,
          "75%": 1.1
        },
        "42083": {
          "name": "McKean",
          "median": 1.08,
          "10%": 1.01,
          "90%": 1.16,
          "25%": 1.06,
          "75%": 1.13
        },
        "51117": {
          "name": "Mecklenburg",
          "median": 1.08,
          "10%": 1.02,
          "90%": 1.13,
          "25%": 1.06,
          "75%": 1.1
        },
        "34021": {
          "name": "Mercer",
          "median": 1.05,
          "10%": 0.98,
          "90%": 1.17,
          "25%": 1.03,
          "75%": 1.1
        },
        "42085": {
          "name": "Mercer",
          "median": 1.09,
          "10%": 1.01,
          "90%": 1.15,
          "25%": 1.05,
          "75%": 1.13
        },
        "54055": {
          "name": "Mercer",
          "median": 1.08,
          "10%": 0.99,
          "90%": 1.17,
          "25%": 1.04,
          "75%": 1.13
        },
        "51119": {
          "name": "Middlesex",
          "median": 1.07,
          "10%": 0.99,
          "90%": 1.13,
          "25%": 1.04,
          "75%": 1.11
        },
        "42087": {
          "name": "Mifflin",
          "median": 1.11,
          "10%": 1.05,
          "90%": 1.21,
          "25%": 1.08,
          "75%": 1.15
        },
        "54057": {
          "name": "Mineral",
          "median": 1.08,
          "10%": 1.0,
          "90%": 1.14,
          "25%": 1.03,
          "75%": 1.11
        },
        "54059": {
          "name": "Mingo",
          "median": 1.08,
          "10%": 1.01,
          "90%": 1.16,
          "25%": 1.05,
          "75%": 1.13
        },
        "34025": {
          "name": "Monmouth",
          "median": 1.07,
          "10%": 1.0,
          "90%": 1.17,
          "25%": 1.02,
          "75%": 1.14
        },
        "54061": {
          "name": "Monongalia",
          "median": 1.06,
          "10%": 0.97,
          "90%": 1.12,
          "25%": 1.01,
          "75%": 1.09
        },
        "42089": {
          "name": "Monroe",
          "median": 1.11,
          "10%": 1.03,
          "90%": 1.16,
          "25%": 1.06,
          "75%": 1.14
        },
        "54063": {
          "name": "Monroe",
          "median": 1.07,
          "10%": 0.98,
          "90%": 1.15,
          "25%": 1.02,
          "75%": 1.13
        },
        "24031": {
          "name": "Montgomery",
          "median": 1.08,
          "10%": 1.0,
          "90%": 1.12,
          "25%": 1.04,
          "75%": 1.1
        },
        "36057": {
          "name": "Montgomery",
          "median": 1.065,
          "10%": 1.01,
          "90%": 1.13,
          "25%": 1.04,
          "75%": 1.11
        },
        "42091": {
          "name": "Montgomery",
          "median": 1.08,
          "10%": 1.01,
          "90%": 1.15,
          "25%": 1.03,
          "75%": 1.12
        },
        "51121": {
          "name": "Montgomery",
          "median": 1.1,
          "10%": 1.03,
          "90%": 1.2,
          "25%": 1.06,
          "75%": 1.15
        },
        "42093": {
          "name": "Montour",
          "median": 1.09,
          "10%": 1.01,
          "90%": 1.19,
          "25%": 1.04,
          "75%": 1.13
        },
        "54065": {
          "name": "Morgan",
          "median": 1.1,
          "10%": 0.99,
          "90%": 1.21,
          "25%": 1.03,
          "75%": 1.14
        },
        "34027": {
          "name": "Morris",
          "median": 1.1,
          "10%": 1.02,
          "90%": 1.17,
          "25%": 1.05,
          "75%": 1.15
        },
        "36059": {
          "name": "Nassau",
          "median": 1.08,
          "10%": 0.98,
          "90%": 1.16,
          "25%": 1.04,
          "75%": 1.12
        },
        "51125": {
          "name": "Nelson",
          "median": 1.08,
          "10%": 0.98,
          "90%": 1.21,
          "25%": 1.03,
          "75%": 1.18
        },
        "10003": {
          "name": "New Castle",
          "median": 1.09,
          "10%": 0.99,
          "90%": 1.18,
          "25%": 1.03,
          "75%": 1.16
        },
        "51127": {
          "name": "New Kent",
          "median": 1.07,
          "10%": 0.99,
          "90%": 1.15,
          "25%": 1.04,
          "75%": 1.1
        },
        "36061": {
          "name": "New York",
          "median": 1.07,
          "10%": 1.0,
          "90%": 1.17,
          "25%": 1.02,
          "75%": 1.11
        },
        "51700": {
          "name": "Newport News",
          "median": 1.08,
          "10%": 0.99,
          "90%": 1.18,
          "25%": 1.02,
          "75%": 1.13
        },
        "54067": {
          "name": "Nicholas",
          "median": 1.07,
          "10%": 1.01,
          "90%": 1.15,
          "25%": 1.03,
          "75%": 1.1
        },
        "51710": {
          "name": "Norfolk",
          "median": 1.07,
          "10%": 0.99,
          "90%": 1.21,
          "25%": 1.03,
          "75%": 1.13
        },
        "42095": {
          "name": "Northampton",
          "median": 1.11,
          "10%": 1.0,
          "90%": 1.16,
          "25%": 1.06,
          "75%": 1.13
        },
        "51131": {
          "name": "Northampton",
          "median": 1.06,
          "10%": 1.0,
          "90%": 1.19,
          "25%": 1.02,
          "75%": 1.13
        },
        "42097": {
          "name": "Northumberland",
          "median": 1.09,
          "10%": 1.0,
          "90%": 1.18,
          "25%": 1.06,
          "75%": 1.12
        },
        "51133": {
          "name": "Northumberland",
          "median": 1.07,
          "10%": 0.97,
          "90%": 1.18,
          "25%": 1.01,
          "75%": 1.13
        },
        "51720": {
          "name": "Norton",
          "median": 1.09,
          "10%": 0.99,
          "90%": 1.16,
          "25%": 1.01,
          "75%": 1.13
        },
        "51135": {
          "name": "Nottoway",
          "median": 1.09,
          "10%": 0.99,
          "90%": 1.16,
          "25%": 1.04,
          "75%": 1.12
        },
        "34029": {
          "name": "Ocean",
          "median": 1.07,
          "10%": 1.01,
          "90%": 1.15,
          "25%": 1.04,
          "75%": 1.11
        },
        "54069": {
          "name": "Ohio",
          "median": 1.08,
          "10%": 1.0,
          "90%": 1.15,
          "25%": 1.04,
          "75%": 1.13
        },
        "36065": {
          "name": "Oneida",
          "median": 1.07,
          "10%": 1.02,
          "90%": 1.17,
          "25%": 1.04,
          "75%": 1.11
        },
        "36067": {
          "name": "Onondaga",
          "median": 1.07,
          "10%": 1.0,
          "90%": 1.16,
          "25%": 1.04,
          "75%": 1.14
        },
        "36069": {
          "name": "Ontario",
          "median": 1.08,
          "10%": 0.99,
          "90%": 1.16,
          "25%": 1.06,
          "75%": 1.12
        },
        "36071": {
          "name": "Orange",
          "median": 1.07,
          "10%": 1.0,
          "90%": 1.15,
          "25%": 1.05,
          "75%": 1.1
        },
        "51137": {
          "name": "Orange",
          "median": 1.09,
          "10%": 1.01,
          "90%": 1.18,
          "25%": 1.04,
          "75%": 1.15
        },
        "36077": {
          "name": "Otsego",
          "median": 1.08,
          "10%": 1.0,
          "90%": 1.15,
          "25%": 1.04,
          "75%": 1.12
        },
        "51139": {
          "name": "Page",
          "median": 1.08,
          "10%": 1.0,
          "90%": 1.18,
          "25%": 1.03,
          "75%": 1.15
        },
        "51141": {
          "name": "Patrick",
          "median": 1.07,
          "10%": 1.02,
          "90%": 1.19,
          "25%": 1.04,
          "75%": 1.14
        },
        "54071": {
          "name": "Pendleton",
          "median": 1.08,
          "10%": 1.02,
          "90%": 1.23,
          "25%": 1.04,
          "75%": 1.15
        },
        "42099": {
          "name": "Perry",
          "median": 1.11,
          "10%": 1.0,
          "90%": 1.25,
          "25%": 1.06,
          "75%": 1.16
        },
        "51730": {
          "name": "Petersburg",
          "median": 1.06,
          "10%": 0.95,
          "90%": 1.17,
          "25%": 1.0,
          "75%": 1.13
        },
        "42101": {
          "name": "Philadelphia",
          "median": 1.08,
          "10%": 1.0,
          "90%": 1.16,
          "25%": 1.05,
          "75%": 1.11
        },
        "42103": {
          "name": "Pike",
          "median": 1.11,
          "10%": 1.0,
          "90%": 1.16,
          "25%": 1.07,
          "75%": 1.13
        },
        "51143": {
          "name": "Pittsylvania",
          "median": 1.12,
          "10%": 1.03,
          "90%": 1.18,
          "25%": 1.06,
          "75%": 1.16
        },
        "54073": {
          "name": "Pleasants",
          "median": 1.08,
          "10%": 1.02,
          "90%": 1.14,
          "25%": 1.03,
          "75%": 1.11
        },
        "54075": {
          "name": "Pocahontas",
          "median": 1.07,
          "10%": 1.02,
          "90%": 1.15,
          "25%": 1.03,
          "75%": 1.11
        },
        "51735": {
          "name": "Poquoson",
          "median": 1.07,
          "10%": 0.99,
          "90%": 1.14,
          "25%": 1.02,
          "75%": 1.11
        },
        "51740": {
          "name": "Portsmouth",
          "median": 1.08,
          "10%": 1.01,
          "90%": 1.21,
          "25%": 1.04,
          "75%": 1.15
        },
        "42105": {
          "name": "Potter",
          "median": 1.08,
          "10%": 1.01,
          "90%": 1.17,
          "25%": 1.06,
          "75%": 1.12
        },
        "51145": {
          "name": "Powhatan",
          "median": 1.06,
          "10%": 0.94,
          "90%": 1.22,
          "25%": 1.01,
          "75%": 1.13
        },
        "54077": {
          "name": "Preston",
          "median": 1.05,
          "10%": 1.01,
          "90%": 1.13,
          "25%": 1.02,
          "75%": 1.08
        },
        "51147": {
          "name": "Prince Edward",
          "median": 1.08,
          "10%": 1.02,
          "90%": 1.17,
          "25%": 1.05,
          "75%": 1.14
        },
        "51149": {
          "name": "Prince George",
          "median": 1.07,
          "10%": 0.97,
          "90%": 1.17,
          "25%": 0.99,
          "75%": 1.12
        },
        "24033": {
          "name": "Prince George's",
          "median": 1.06,
          "10%": 1.0,
          "90%": 1.16,
          "25%": 1.03,
          "75%": 1.1
        },
        "51153": {
          "name": "Prince William",
          "median": 1.07,
          "10%": 1.01,
          "90%": 1.17,
          "25%": 1.03,
          "75%": 1.1
        },
        "51155": {
          "name": "Pulaski",
          "median": 1.1,
          "10%": 1.04,
          "90%": 1.19,
          "25%": 1.05,
          "75%": 1.16
        },
        "54079": {
          "name": "Putnam",
          "median": 1.08,
          "10%": 1.0,
          "90%": 1.17,
          "25%": 1.03,
          "75%": 1.13
        },
        "24035": {
          "name": "Queen Anne's",
          "median": 1.07,
          "10%": 1.02,
          "90%": 1.21,
          "25%": 1.04,
          "75%": 1.1
        },
        "51750": {
          "name": "Radford",
          "median": 1.11,
          "10%": 1.03,
          "90%": 1.19,
          "25%": 1.05,
          "75%": 1.16
        },
        "54081": {
          "name": "Raleigh",
          "median": 1.07,
          "10%": 1.02,
          "90%": 1.17,
          "25%": 1.05,
          "75%": 1.12
        },
        "54083": {
          "name": "Randolph",
          "median": 1.06,
          "10%": 1.01,
          "90%": 1.12,
          "25%": 1.04,
          "75%": 1.09
        },
        "51157": {
          "name": "Rappahannock",
          "median": 1.08,
          "10%": 0.99,
          "90%": 1.2,
          "25%": 1.02,
          "75%": 1.14
        },
        "36085": {
          "name": "Richmond",
          "median": 1.06,
          "10%": 1.0,
          "90%": 1.17,
          "25%": 1.03,
          "75%": 1.13
        },
        "51159": {
          "name": "Richmond",
          "median": 1.05,
          "10%": 0.95,
          "90%": 1.24,
          "25%": 0.99,
          "75%": 1.11
        },
        "51760": {
          "name": "Richmond",
          "median": 1.06,
          "10%": 1.0,
          "90%": 1.16,
          "25%": 1.03,
          "75%": 1.13
        },
        "54085": {
          "name": "Ritchie",
          "median": 1.09,
          "10%": 1.03,
          "90%": 1.15,
          "25%": 1.06,
          "75%": 1.12
        },
        "54087": {
          "name": "Roane",
          "median": 1.08,
          "10%": 1.01,
          "90%": 1.18,
          "25%": 1.05,
          "75%": 1.13
        },
        "51161": {
          "name": "Roanoke",
          "median": 1.11,
          "10%": 1.01,
          "90%": 1.2,
          "25%": 1.06,
          "75%": 1.16
        },
        "51770": {
          "name": "Roanoke",
          "median": 1.1,
          "10%": 1.01,
          "90%": 1.2,
          "25%": 1.04,
          "75%": 1.16
        },
        "51163": {
          "name": "Rockbridge",
          "median": 1.1,
          "10%": 1.01,
          "90%": 1.21,
          "25%": 1.03,
          "75%": 1.18
        },
        "51165": {
          "name": "Rockingham",
          "median": 1.09,
          "10%": 0.99,
          "90%": 1.18,
          "25%": 1.03,
          "75%": 1.13
        },
        "51167": {
          "name": "Russell",
          "median": 1.06,
          "10%": 1.0,
          "90%": 1.14,
          "25%": 1.03,
          "75%": 1.12
        },
        "34033": {
          "name": "Salem",
          "median": 1.09,
          "10%": 0.99,
          "90%": 1.17,
          "25%": 1.02,
          "75%": 1.15
        },
        "51775": {
          "name": "Salem",
          "median": 1.12,
          "10%": 1.0,
          "90%": 1.21,
          "25%": 1.06,
          "75%": 1.17
        },
        "36095": {
          "name": "Schoharie",
          "median": 1.08,
          "10%": 1.02,
          "90%": 1.19,
          "25%": 1.04,
          "75%": 1.13
        },
        "36097": {
          "name": "Schuyler",
          "median": 1.1,
          "10%": 1.01,
          "90%": 1.19,
          "25%": 1.05,
          "75%": 1.14
        },
        "42107": {
          "name": "Schuylkill",
          "median": 1.09,
          "10%": 1.01,
          "90%": 1.16,
          "25%": 1.05,
          "75%": 1.13
        },
        "51169": {
          "name": "Scott",
          "median": 1.1,
          "10%": 1.01,
          "90%": 1.17,
          "25%": 1.04,
          "75%": 1.13
        },
        "51171": {
          "name": "Shenandoah",
          "median": 1.09,
          "10%": 1.01,
          "90%": 1.19,
          "25%": 1.03,
          "75%": 1.14
        },
        "51173": {
          "name": "Smyth",
          "median": 1.07,
          "10%": 1.02,
          "90%": 1.151,
          "25%": 1.04,
          "75%": 1.1
        },
        "42109": {
          "name": "Snyder",
          "median": 1.09,
          "10%": 1.01,
          "90%": 1.19,
          "25%": 1.06,
          "75%": 1.14
        },
        "24039": {
          "name": "Somerset",
          "median": 1.09,
          "10%": 0.98,
          "90%": 1.17,
          "25%": 1.04,
          "75%": 1.14
        },
        "42111": {
          "name": "Somerset",
          "median": 1.07,
          "10%": 1.02,
          "90%": 1.12,
          "25%": 1.05,
          "75%": 1.09
        },
        "51175": {
          "name": "Southampton",
          "median": 1.07,
          "10%": 0.99,
          "90%": 1.18,
          "25%": 1.03,
          "75%": 1.12
        },
        "51177": {
          "name": "Spotsylvania",
          "median": 1.08,
          "10%": 1.01,
          "90%": 1.16,
          "25%": 1.05,
          "75%": 1.14
        },
        "24037": {
          "name": "St. Mary's",
          "median": 1.08,
          "10%": 1.0,
          "90%": 1.16,
          "25%": 1.02,
          "75%": 1.13
        },
        "51179": {
          "name": "Stafford",
          "median": 1.09,
          "10%": 0.99,
          "90%": 1.21,
          "25%": 1.05,
          "75%": 1.15
        },
        "51790": {
          "name": "Staunton",
          "median": 1.09,
          "10%": 0.96,
          "90%": 1.2,
          "25%": 1.02,
          "75%": 1.15
        },
        "36101": {
          "name": "Steuben",
          "median": 1.1,
          "10%": 1.03,
          "90%": 1.18,
          "25%": 1.07,
          "75%": 1.14
        },
        "51800": {
          "name": "Suffolk",
          "median": 1.09,
          "10%": 0.99,
          "90%": 1.19,
          "25%": 1.04,
          "75%": 1.14
        },
        "36105": {
          "name": "Sullivan",
          "median": 1.09,
          "10%": 1.02,
          "90%": 1.16,
          "25%": 1.05,
          "75%": 1.13
        },
        "42113": {
          "name": "Sullivan",
          "median": 1.08,
          "10%": 1.0,
          "90%": 1.18,
          "25%": 1.04,
          "75%": 1.11
        },
        "54089": {
          "name": "Summers",
          "median": 1.08,
          "10%": 1.01,
          "90%": 1.14,
          "25%": 1.03,
          "75%": 1.12
        },
        "51181": {
          "name": "Surry",
          "median": 1.07,
          "10%": 0.99,
          "90%": 1.18,
          "25%": 1.03,
          "75%": 1.11
        },
        "42115": {
          "name": "Susquehanna",
          "median": 1.08,
          "10%": 1.02,
          "90%": 1.15,
          "25%": 1.04,
          "75%": 1.11
        },
        "10005": {
          "name": "Sussex",
          "median": 1.08,
          "10%": 1.0,
          "90%": 1.14,
          "25%": 1.04,
          "75%": 1.1
        },
        "34037": {
          "name": "Sussex",
          "median": 1.1,
          "10%": 1.0,
          "90%": 1.17,
          "25%": 1.06,
          "75%": 1.13
        },
        "51183": {
          "name": "Sussex",
          "median": 1.07,
          "10%": 0.98,
          "90%": 1.17,
          "25%": 1.02,
          "75%": 1.12
        },
        "24041": {
          "name": "Talbot",
          "median": 1.04,
          "10%": 0.97,
          "90%": 1.16,
          "25%": 1.0,
          "75%": 1.12
        },
        "54091": {
          "name": "Taylor",
          "median": 1.07,
          "10%": 1.0,
          "90%": 1.15,
          "25%": 1.02,
          "75%": 1.1
        },
        "51185": {
          "name": "Tazewell",
          "median": 1.06,
          "10%": 1.01,
          "90%": 1.15,
          "25%": 1.04,
          "75%": 1.09
        },
        "36107": {
          "name": "Tioga",
          "median": 1.08,
          "10%": 1.0,
          "90%": 1.15,
          "25%": 1.03,
          "75%": 1.12
        },
        "42117": {
          "name": "Tioga",
          "median": 1.1,
          "10%": 1.03,
          "90%": 1.16,
          "25%": 1.05,
          "75%": 1.13
        },
        "36109": {
          "name": "Tompkins",
          "median": 1.1,
          "10%": 1.03,
          "90%": 1.14,
          "25%": 1.06,
          "75%": 1.13
        },
        "54093": {
          "name": "Tucker",
          "median": 1.04,
          "10%": 0.98,
          "90%": 1.11,
          "25%": 1.01,
          "75%": 1.09
        },
        "54095": {
          "name": "Tyler",
          "median": 1.05,
          "10%": 0.96,
          "90%": 1.15,
          "25%": 1.01,
          "75%": 1.09
        },
        "36111": {
          "name": "Ulster",
          "median": 1.09,
          "10%": 1.01,
          "90%": 1.21,
          "25%": 1.05,
          "75%": 1.14
        },
        "42119": {
          "name": "Union",
          "median": 1.09,
          "10%": 0.99,
          "90%": 1.2,
          "25%": 1.05,
          "75%": 1.14
        },
        "54097": {
          "name": "Upshur",
          "median": 1.04,
          "10%": 1.0,
          "90%": 1.11,
          "25%": 1.02,
          "75%": 1.08
        },
        "42121": {
          "name": "Venango",
          "median": 1.08,
          "10%": 1.04,
          "90%": 1.14,
          "25%": 1.06,
          "75%": 1.11
        },
        "51810": {
          "name": "Virginia Beach",
          "median": 1.08,
          "10%": 0.96,
          "90%": 1.21,
          "25%": 1.04,
          "75%": 1.12
        },
        "34041": {
          "name": "Warren",
          "median": 1.1,
          "10%": 1.02,
          "90%": 1.17,
          "25%": 1.07,
          "75%": 1.14
        },
        "42123": {
          "name": "Warren",
          "median": 1.07,
          "10%": 1.01,
          "90%": 1.16,
          "25%": 1.04,
          "75%": 1.13
        },
        "51187": {
          "name": "Warren",
          "median": 1.08,
          "10%": 1.01,
          "90%": 1.24,
          "25%": 1.04,
          "75%": 1.16
        },
        "24043": {
          "name": "Washington",
          "median": 1.08,
          "10%": 1.0,
          "90%": 1.22,
          "25%": 1.05,
          "75%": 1.16
        },
        "42125": {
          "name": "Washington",
          "median": 1.08,
          "10%": 1.02,
          "90%": 1.16,
          "25%": 1.05,
          "75%": 1.13
        },
        "51191": {
          "name": "Washington",
          "median": 1.06,
          "10%": 1.0,
          "90%": 1.14,
          "25%": 1.03,
          "75%": 1.11
        },
        "42127": {
          "name": "Wayne",
          "median": 1.09,
          "10%": 1.02,
          "90%": 1.15,
          "25%": 1.05,
          "75%": 1.13
        },
        "54099": {
          "name": "Wayne",
          "median": 1.08,
          "10%": 1.01,
          "90%": 1.16,
          "25%": 1.05,
          "75%": 1.1025
        },
        "51820": {
          "name": "Waynesboro",
          "median": 1.1,
          "10%": 0.98,
          "90%": 1.26,
          "25%": 1.03,
          "75%": 1.17
        },
        "54101": {
          "name": "Webster",
          "median": 1.06,
          "10%": 1.0,
          "90%": 1.14,
          "25%": 1.03,
          "75%": 1.09
        },
        "36119": {
          "name": "Westchester",
          "median": 1.09,
          "10%": 0.99,
          "90%": 1.17,
          "25%": 1.02,
          "75%": 1.12
        },
        "42129": {
          "name": "Westmoreland",
          "median": 1.05,
          "10%": 1.01,
          "90%": 1.12,
          "25%": 1.04,
          "75%": 1.09
        },
        "51193": {
          "name": "Westmoreland",
          "median": 1.06,
          "10%": 0.96,
          "90%": 1.22,
          "25%": 1.0,
          "75%": 1.12
        },
        "54103": {
          "name": "Wetzel",
          "median": 1.08,
          "10%": 1.0,
          "90%": 1.15,
          "25%": 1.05,
          "75%": 1.11
        },
        "24045": {
          "name": "Wicomico",
          "median": 1.07,
          "10%": 1.01,
          "90%": 1.14,
          "25%": 1.04,
          "75%": 1.1
        },
        "51830": {
          "name": "Williamsburg",
          "median": 1.04,
          "10%": 0.97,
          "90%": 1.14,
          "25%": 1.0,
          "75%": 1.08
        },
        "51840": {
          "name": "Winchester",
          "median": 1.11,
          "10%": 1.01,
          "90%": 1.21,
          "25%": 1.07,
          "75%": 1.15
        },
        "54105": {
          "name": "Wirt",
          "median": 1.1,
          "10%": 1.04,
          "90%": 1.17,
          "25%": 1.07,
          "75%": 1.14
        },
        "51195": {
          "name": "Wise",
          "median": 1.09,
          "10%": 1.0,
          "90%": 1.15,
          "25%": 1.03,
          "75%": 1.13
        },
        "54107": {
          "name": "Wood",
          "median": 1.08,
          "10%": 1.02,
          "90%": 1.18,
          "25%": 1.05,
          "75%": 1.14
        },
        "24047": {
          "name": "Worcester",
          "median": 1.07,
          "10%": 0.99,
          "90%": 1.17,
          "25%": 1.04,
          "75%": 1.11
        },
        "42131": {
          "name": "Wyoming",
          "median": 1.08,
          "10%": 1.03,
          "90%": 1.17,
          "25%": 1.04,
          "75%": 1.12
        },
        "54109": {
          "name": "Wyoming",
          "median": 1.09,
          "10%": 1.0,
          "90%": 1.15,
          "25%": 1.05,
          "75%": 1.12
        },
        "51197": {
          "name": "Wythe",
          "median": 1.07,
          "10%": 1.02,
          "90%": 1.17,
          "25%": 1.04,
          "75%": 1.13
        },
        "36123": {
          "name": "Yates",
          "median": 1.1,
          "10%": 1.03,
          "90%": 1.17,
          "25%": 1.06,
          "75%": 1.14
        },
        "42133": {
          "name": "York",
          "median": 1.09,
          "10%": 1.0,
          "90%": 1.16,
          "25%": 1.03,
          "75%": 1.12
        },
        "51199": {
          "name": "York",
          "median": 1.07,
          "10%": 0.99,
          "90%": 1.18,
          "25%": 1.02,
          "75%": 1.09
        },
        "max": 1.12,
        "min": 1
      },
      "5": {
        "51001": {
          "name": "Accomack",
          "median": 1.075,
          "10%": 0.96,
          "90%": 1.21,
          "25%": 1.02,
          "75%": 1.12
        },
        "42001": {
          "name": "Adams",
          "median": 1.11,
          "10%": 0.97,
          "90%": 1.25,
          "25%": 1.03,
          "75%": 1.2
        },
        "51003": {
          "name": "Albemarle",
          "median": 1.12,
          "10%": 0.96,
          "90%": 1.27,
          "25%": 1.03,
          "75%": 1.15
        },
        "51510": {
          "name": "Alexandria",
          "median": 1.05,
          "10%": 0.91,
          "90%": 1.16,
          "25%": 1.0,
          "75%": 1.1
        },
        "24001": {
          "name": "Allegany",
          "median": 1.09,
          "10%": 0.98,
          "90%": 1.18,
          "25%": 1.05,
          "75%": 1.13
        },
        "36003": {
          "name": "Allegany",
          "median": 1.07,
          "10%": 1.0,
          "90%": 1.2,
          "25%": 1.04,
          "75%": 1.15
        },
        "51005": {
          "name": "Alleghany",
          "median": 1.1,
          "10%": 1.0,
          "90%": 1.22,
          "25%": 1.03,
          "75%": 1.17
        },
        "42003": {
          "name": "Allegheny",
          "median": 1.07,
          "10%": 0.99,
          "90%": 1.16,
          "25%": 1.03,
          "75%": 1.12
        },
        "51007": {
          "name": "Amelia",
          "median": 1.06,
          "10%": 0.94,
          "90%": 1.24,
          "25%": 1.02,
          "75%": 1.17
        },
        "51009": {
          "name": "Amherst",
          "median": 1.11,
          "10%": 0.98,
          "90%": 1.23,
          "25%": 1.02,
          "75%": 1.17
        },
        "24003": {
          "name": "Anne Arundel",
          "median": 1.05,
          "10%": 0.98,
          "90%": 1.16,
          "25%": 1.02,
          "75%": 1.1
        },
        "51011": {
          "name": "Appomattox",
          "median": 1.12,
          "10%": 0.97,
          "90%": 1.26,
          "25%": 1.04,
          "75%": 1.22
        },
        "51013": {
          "name": "Arlington",
          "median": 1.05,
          "10%": 0.95,
          "90%": 1.14,
          "25%": 1.0,
          "75%": 1.1
        },
        "42005": {
          "name": "Armstrong",
          "median": 1.08,
          "10%": 1.02,
          "90%": 1.12,
          "25%": 1.06,
          "75%": 1.1
        },
        "34001": {
          "name": "Atlantic",
          "median": 1.12,
          "10%": 0.99,
          "90%": 1.17,
          "25%": 1.05,
          "75%": 1.15
        },
        "51015": {
          "name": "Augusta",
          "median": 1.11,
          "10%": 0.96,
          "90%": 1.27,
          "25%": 1.02,
          "75%": 1.18
        },
        "24005": {
          "name": "Baltimore",
          "median": 1.08,
          "10%": 0.98,
          "90%": 1.18,
          "25%": 1.02,
          "75%": 1.13
        },
        "24510": {
          "name": "Baltimore",
          "median": 1.09,
          "10%": 0.95,
          "90%": 1.19,
          "25%": 0.99,
          "75%": 1.13
        },
        "54001": {
          "name": "Barbour",
          "median": 1.07,
          "10%": 1.0,
          "90%": 1.12,
          "25%": 1.03,
          "75%": 1.1
        },
        "51017": {
          "name": "Bath",
          "median": 1.11,
          "10%": 1.02,
          "90%": 1.24,
          "25%": 1.05,
          "75%": 1.18
        },
        "42007": {
          "name": "Beaver",
          "median": 1.06,
          "10%": 1.0,
          "90%": 1.16,
          "25%": 1.02,
          "75%": 1.1
        },
        "42009": {
          "name": "Bedford",
          "median": 1.11,
          "10%": 0.98,
          "90%": 1.2,
          "25%": 1.04,
          "75%": 1.16
        },
        "51019": {
          "name": "Bedford",
          "median": 1.11,
          "10%": 0.99,
          "90%": 1.21,
          "25%": 1.06,
          "75%": 1.16
        },
        "54003": {
          "name": "Berkeley",
          "median": 1.09,
          "10%": 0.969,
          "90%": 1.26,
          "25%": 1.04,
          "75%": 1.18
        },
        "42011": {
          "name": "Berks",
          "median": 1.1,
          "10%": 1.02,
          "90%": 1.2,
          "25%": 1.05,
          "75%": 1.14
        },
        "42013": {
          "name": "Blair",
          "median": 1.1,
          "10%": 1.02,
          "90%": 1.17,
          "25%": 1.06,
          "75%": 1.14
        },
        "51021": {
          "name": "Bland",
          "median": 1.08,
          "10%": 1.01,
          "90%": 1.19,
          "25%": 1.03,
          "75%": 1.14
        },
        "54005": {
          "name": "Boone",
          "median": 1.07,
          "10%": 1.01,
          "90%": 1.17,
          "25%": 1.05,
          "75%": 1.12
        },
        "51023": {
          "name": "Botetourt",
          "median": 1.12,
          "10%": 0.99,
          "90%": 1.22,
          "25%": 1.05,
          "75%": 1.17
        },
        "42015": {
          "name": "Bradford",
          "median": 1.08,
          "10%": 1.0,
          "90%": 1.2,
          "25%": 1.03,
          "75%": 1.11
        },
        "54007": {
          "name": "Braxton",
          "median": 1.07,
          "10%": 1.02,
          "90%": 1.17,
          "25%": 1.03,
          "75%": 1.12
        },
        "51520": {
          "name": "Bristol",
          "median": 1.07,
          "10%": 1.01,
          "90%": 1.16,
          "25%": 1.03,
          "75%": 1.12
        },
        "36005": {
          "name": "Bronx",
          "median": 1.08,
          "10%": 0.99,
          "90%": 1.2,
          "25%": 1.03,
          "75%": 1.12
        },
        "54009": {
          "name": "Brooke",
          "median": 1.1,
          "10%": 1.0,
          "90%": 1.24,
          "25%": 1.04,
          "75%": 1.17
        },
        "36007": {
          "name": "Broome",
          "median": 1.09,
          "10%": 1.0,
          "90%": 1.17,
          "25%": 1.05,
          "75%": 1.14
        },
        "51025": {
          "name": "Brunswick",
          "median": 1.09,
          "10%": 1.0,
          "90%": 1.22,
          "25%": 1.03,
          "75%": 1.16
        },
        "51027": {
          "name": "Buchanan",
          "median": 1.08,
          "10%": 0.99,
          "90%": 1.15,
          "25%": 1.03,
          "75%": 1.11
        },
        "51029": {
          "name": "Buckingham",
          "median": 1.08,
          "10%": 0.96,
          "90%": 1.22,
          "25%": 1.01,
          "75%": 1.15
        },
        "42017": {
          "name": "Bucks",
          "median": 1.08,
          "10%": 1.0,
          "90%": 1.15,
          "25%": 1.03,
          "75%": 1.12
        },
        "51530": {
          "name": "Buena Vista",
          "median": 1.09,
          "10%": 0.95,
          "90%": 1.31,
          "25%": 1.05,
          "75%": 1.18
        },
        "34005": {
          "name": "Burlington",
          "median": 1.06,
          "10%": 0.99,
          "90%": 1.16,
          "25%": 1.02,
          "75%": 1.11
        },
        "42019": {
          "name": "Butler",
          "median": 1.06,
          "10%": 1.02,
          "90%": 1.12,
          "25%": 1.04,
          "75%": 1.1
        },
        "54011": {
          "name": "Cabell",
          "median": 1.07,
          "10%": 1.01,
          "90%": 1.18,
          "25%": 1.03,
          "75%": 1.12
        },
        "54013": {
          "name": "Calhoun",
          "median": 1.11,
          "10%": 1.0,
          "90%": 1.2,
          "25%": 1.05,
          "75%": 1.14
        },
        "24009": {
          "name": "Calvert",
          "median": 1.06,
          "10%": 0.97,
          "90%": 1.16,
          "25%": 1.01,
          "75%": 1.12
        },
        "42021": {
          "name": "Cambria",
          "median": 1.07,
          "10%": 0.99,
          "90%": 1.13,
          "25%": 1.02,
          "75%": 1.09
        },
        "34007": {
          "name": "Camden",
          "median": 1.08,
          "10%": 1.0,
          "90%": 1.16,
          "25%": 1.03,
          "75%": 1.13
        },
        "42023": {
          "name": "Cameron",
          "median": 1.08,
          "10%": 1.0,
          "90%": 1.15,
          "25%": 1.03,
          "75%": 1.13
        },
        "51031": {
          "name": "Campbell",
          "median": 1.12,
          "10%": 1.01,
          "90%": 1.22,
          "25%": 1.07,
          "75%": 1.18
        },
        "34009": {
          "name": "Cape May",
          "median": 1.11,
          "10%": 1.0,
          "90%": 1.18,
          "25%": 1.05,
          "75%": 1.14
        },
        "42025": {
          "name": "Carbon",
          "median": 1.09,
          "10%": 1.0,
          "90%": 1.15,
          "25%": 1.05,
          "75%": 1.12
        },
        "24011": {
          "name": "Caroline",
          "median": 1.07,
          "10%": 0.97,
          "90%": 1.2,
          "25%": 1.02,
          "75%": 1.12
        },
        "51033": {
          "name": "Caroline",
          "median": 1.07,
          "10%": 0.97,
          "90%": 1.19,
          "25%": 1.02,
          "75%": 1.15
        },
        "24013": {
          "name": "Carroll",
          "median": 1.12,
          "10%": 0.99,
          "90%": 1.22,
          "25%": 1.06,
          "75%": 1.17
        },
        "51035": {
          "name": "Carroll",
          "median": 1.09,
          "10%": 1.03,
          "90%": 1.2,
          "25%": 1.05,
          "75%": 1.14
        },
        "24015": {
          "name": "Cecil",
          "median": 1.1,
          "10%": 0.99,
          "90%": 1.17,
          "25%": 1.03,
          "75%": 1.14
        },
        "42027": {
          "name": "Centre",
          "median": 1.1,
          "10%": 1.03,
          "90%": 1.17,
          "25%": 1.07,
          "75%": 1.14
        },
        "24017": {
          "name": "Charles",
          "median": 1.08,
          "10%": 0.96,
          "90%": 1.22,
          "25%": 1.0,
          "75%": 1.15
        },
        "51036": {
          "name": "Charles City",
          "median": 1.05,
          "10%": 0.94,
          "90%": 1.16,
          "25%": 0.99,
          "75%": 1.11
        },
        "51037": {
          "name": "Charlotte",
          "median": 1.11,
          "10%": 0.98,
          "90%": 1.19,
          "25%": 1.05,
          "75%": 1.15
        },
        "51540": {
          "name": "Charlottesville",
          "median": 1.11,
          "10%": 0.94,
          "90%": 1.22,
          "25%": 1.05,
          "75%": 1.14
        },
        "36015": {
          "name": "Chemung",
          "median": 1.07,
          "10%": 1.01,
          "90%": 1.19,
          "25%": 1.03,
          "75%": 1.14
        },
        "36017": {
          "name": "Chenango",
          "median": 1.07,
          "10%": 1.01,
          "90%": 1.16,
          "25%": 1.04,
          "75%": 1.13
        },
        "51550": {
          "name": "Chesapeake",
          "median": 1.09,
          "10%": 0.98,
          "90%": 1.24,
          "25%": 1.0,
          "75%": 1.15
        },
        "42029": {
          "name": "Chester",
          "median": 1.1,
          "10%": 1.0,
          "90%": 1.19,
          "25%": 1.03,
          "75%": 1.14
        },
        "51041": {
          "name": "Chesterfield",
          "median": 1.08,
          "10%": 0.96,
          "90%": 1.26,
          "25%": 1.0,
          "75%": 1.13
        },
        "42031": {
          "name": "Clarion",
          "median": 1.09,
          "10%": 1.01,
          "90%": 1.15,
          "25%": 1.06,
          "75%": 1.12
        },
        "51043": {
          "name": "Clarke",
          "median": 1.1,
          "10%": 0.97,
          "90%": 1.24,
          "25%": 1.02,
          "75%": 1.19
        },
        "54015": {
          "name": "Clay",
          "median": 1.04,
          "10%": 1.0,
          "90%": 1.17,
          "25%": 1.02,
          "75%": 1.09
        },
        "42033": {
          "name": "Clearfield",
          "median": 1.1,
          "10%": 1.03,
          "90%": 1.16,
          "25%": 1.07,
          "75%": 1.13
        },
        "42035": {
          "name": "Clinton",
          "median": 1.09,
          "10%": 1.01,
          "90%": 1.17,
          "25%": 1.06,
          "75%": 1.14
        },
        "51570": {
          "name": "Colonial Heights",
          "median": 1.07,
          "10%": 0.9,
          "90%": 1.22,
          "25%": 0.99,
          "75%": 1.15
        },
        "42037": {
          "name": "Columbia",
          "median": 1.09,
          "10%": 1.0,
          "90%": 1.24,
          "25%": 1.06,
          "75%": 1.14
        },
        "36023": {
          "name": "Cortland",
          "median": 1.1,
          "10%": 1.01,
          "90%": 1.17,
          "25%": 1.04,
          "75%": 1.13
        },
        "51580": {
          "name": "Covington",
          "median": 1.09,
          "10%": 0.98,
          "90%": 1.19,
          "25%": 1.01,
          "75%": 1.14
        },
        "51045": {
          "name": "Craig",
          "median": 1.1,
          "10%": 0.97,
          "90%": 1.2,
          "25%": 1.04,
          "75%": 1.14
        },
        "42039": {
          "name": "Crawford",
          "median": 1.06,
          "10%": 1.0,
          "90%": 1.15,
          "25%": 1.03,
          "75%": 1.13
        },
        "51047": {
          "name": "Culpeper",
          "median": 1.09,
          "10%": 0.97,
          "90%": 1.2,
          "25%": 1.03,
          "75%": 1.13
        },
        "34011": {
          "name": "Cumberland",
          "median": 1.08,
          "10%": 1.0,
          "90%": 1.15,
          "25%": 1.04,
          "75%": 1.12
        },
        "42041": {
          "name": "Cumberland",
          "median": 1.12,
          "10%": 1.0,
          "90%": 1.27,
          "25%": 1.02,
          "75%": 1.2
        },
        "51049": {
          "name": "Cumberland",
          "median": 1.08,
          "10%": 0.95,
          "90%": 1.23,
          "25%": 1.01,
          "75%": 1.17
        },
        "51590": {
          "name": "Danville",
          "median": 1.11,
          "10%": 0.97,
          "90%": 1.2,
          "25%": 1.03,
          "75%": 1.1725
        },
        "42043": {
          "name": "Dauphin",
          "median": 1.12,
          "10%": 0.98,
          "90%": 1.28,
          "25%": 1.05,
          "75%": 1.2
        },
        "36025": {
          "name": "Delaware",
          "median": 1.08,
          "10%": 1.01,
          "90%": 1.17,
          "25%": 1.04,
          "75%": 1.14
        },
        "42045": {
          "name": "Delaware",
          "median": 1.09,
          "10%": 0.98,
          "90%": 1.23,
          "25%": 1.04,
          "75%": 1.16
        },
        "51051": {
          "name": "Dickenson",
          "median": 1.08,
          "10%": 0.99,
          "90%": 1.15,
          "25%": 1.0,
          "75%": 1.11
        },
        "51053": {
          "name": "Dinwiddie",
          "median": 1.08,
          "10%": 0.97,
          "90%": 1.2,
          "25%": 1.02,
          "75%": 1.16
        },
        "11001": {
          "name": "District of Columbia",
          "median": 1.06,
          "10%": 0.96,
          "90%": 1.16,
          "25%": 1.01,
          "75%": 1.13
        },
        "54017": {
          "name": "Doddridge",
          "median": 1.05,
          "10%": 0.98,
          "90%": 1.13,
          "25%": 1.0,
          "75%": 1.08
        },
        "24019": {
          "name": "Dorchester",
          "median": 1.05,
          "10%": 0.92,
          "90%": 1.18,
          "25%": 1.01,
          "75%": 1.1
        },
        "42047": {
          "name": "Elk",
          "median": 1.07,
          "10%": 1.0,
          "90%": 1.14,
          "25%": 1.03,
          "75%": 1.11
        },
        "51595": {
          "name": "Emporia",
          "median": 1.05,
          "10%": 0.96,
          "90%": 1.14,
          "25%": 0.99,
          "75%": 1.1
        },
        "42049": {
          "name": "Erie",
          "median": 1.09,
          "10%": 1.0,
          "90%": 1.15,
          "25%": 1.0475,
          "75%": 1.12
        },
        "51057": {
          "name": "Essex",
          "median": 1.04,
          "10%": 0.91,
          "90%": 1.27,
          "25%": 0.98,
          "75%": 1.09
        },
        "51059": {
          "name": "Fairfax",
          "median": 1.04,
          "10%": 0.97,
          "90%": 1.14,
          "25%": 1.01,
          "75%": 1.09
        },
        "51600": {
          "name": "Fairfax",
          "median": 1.04,
          "10%": 0.959,
          "90%": 1.14,
          "25%": 1.0,
          "75%": 1.0925
        },
        "51610": {
          "name": "Falls Church",
          "median": 1.06,
          "10%": 0.96,
          "90%": 1.18,
          "25%": 1.01,
          "75%": 1.1
        },
        "51061": {
          "name": "Fauquier",
          "median": 1.1,
          "10%": 0.99,
          "90%": 1.19,
          "25%": 1.01,
          "75%": 1.16
        },
        "42051": {
          "name": "Fayette",
          "median": 1.05,
          "10%": 1.0,
          "90%": 1.15,
          "25%": 1.02,
          "75%": 1.09
        },
        "54019": {
          "name": "Fayette",
          "median": 1.06,
          "10%": 0.96,
          "90%": 1.18,
          "25%": 1.03,
          "75%": 1.12
        },
        "51063": {
          "name": "Floyd",
          "median": 1.09,
          "10%": 1.01,
          "90%": 1.2,
          "25%": 1.05,
          "75%": 1.16
        },
        "51065": {
          "name": "Fluvanna",
          "median": 1.1,
          "10%": 0.94,
          "90%": 1.311,
          "25%": 1.01,
          "75%": 1.17
        },
        "42053": {
          "name": "Forest",
          "median": 1.06,
          "10%": 1.01,
          "90%": 1.16,
          "25%": 1.03,
          "75%": 1.11
        },
        "42055": {
          "name": "Franklin",
          "median": 1.09,
          "10%": 0.98,
          "90%": 1.19,
          "25%": 1.05,
          "75%": 1.16
        },
        "51067": {
          "name": "Franklin",
          "median": 1.11,
          "10%": 0.98,
          "90%": 1.21,
          "25%": 1.02,
          "75%": 1.16
        },
        "51620": {
          "name": "Franklin",
          "median": 1.1,
          "10%": 0.97,
          "90%": 1.22,
          "25%": 1.05,
          "75%": 1.15
        },
        "24021": {
          "name": "Frederick",
          "median": 1.1,
          "10%": 0.96,
          "90%": 1.21,
          "25%": 1.07,
          "75%": 1.18
        },
        "51069": {
          "name": "Frederick",
          "median": 1.08,
          "10%": 0.98,
          "90%": 1.27,
          "25%": 1.05,
          "75%": 1.17
        },
        "51630": {
          "name": "Fredericksburg",
          "median": 1.1,
          "10%": 0.94,
          "90%": 1.2,
          "25%": 1.03,
          "75%": 1.17
        },
        "42057": {
          "name": "Fulton",
          "median": 1.12,
          "10%": 0.98,
          "90%": 1.27,
          "25%": 1.07,
          "75%": 1.17
        },
        "51640": {
          "name": "Galax",
          "median": 1.08,
          "10%": 0.95,
          "90%": 1.24,
          "25%": 1.0,
          "75%": 1.2
        },
        "24023": {
          "name": "Garrett",
          "median": 1.06,
          "10%": 0.99,
          "90%": 1.12,
          "25%": 1.04,
          "75%": 1.1
        },
        "51071": {
          "name": "Giles",
          "median": 1.1,
          "10%": 0.99,
          "90%": 1.2,
          "25%": 1.03,
          "75%": 1.14
        },
        "54021": {
          "name": "Gilmer",
          "median": 1.09,
          "10%": 1.02,
          "90%": 1.19,
          "25%": 1.04,
          "75%": 1.14
        },
        "34015": {
          "name": "Gloucester",
          "median": 1.09,
          "10%": 0.98,
          "90%": 1.22,
          "25%": 1.04,
          "75%": 1.14
        },
        "51073": {
          "name": "Gloucester",
          "median": 1.06,
          "10%": 0.96,
          "90%": 1.15,
          "25%": 1.02,
          "75%": 1.12
        },
        "51075": {
          "name": "Goochland",
          "median": 1.09,
          "10%": 0.9,
          "90%": 1.35,
          "25%": 0.99,
          "75%": 1.19
        },
        "54023": {
          "name": "Grant",
          "median": 1.05,
          "10%": 0.99,
          "90%": 1.18,
          "25%": 1.02,
          "75%": 1.11
        },
        "51077": {
          "name": "Grayson",
          "median": 1.09,
          "10%": 1.01,
          "90%": 1.19,
          "25%": 1.05,
          "75%": 1.13
        },
        "54025": {
          "name": "Greenbrier",
          "median": 1.08,
          "10%": 1.01,
          "90%": 1.19,
          "25%": 1.0275,
          "75%": 1.14
        },
        "36039": {
          "name": "Greene",
          "median": 1.12,
          "10%": 1.0,
          "90%": 1.21,
          "25%": 1.03,
          "75%": 1.16
        },
        "42059": {
          "name": "Greene",
          "median": 1.08,
          "10%": 1.02,
          "90%": 1.17,
          "25%": 1.05,
          "75%": 1.13
        },
        "51079": {
          "name": "Greene",
          "median": 1.1,
          "10%": 0.95,
          "90%": 1.25,
          "25%": 1.02,
          "75%": 1.18
        },
        "51081": {
          "name": "Greensville",
          "median": 1.05,
          "10%": 0.97,
          "90%": 1.17,
          "25%": 1.0,
          "75%": 1.1
        },
        "51083": {
          "name": "Halifax",
          "median": 1.11,
          "10%": 1.0,
          "90%": 1.18,
          "25%": 1.07,
          "75%": 1.15
        },
        "54027": {
          "name": "Hampshire",
          "median": 1.09,
          "10%": 0.99,
          "90%": 1.19,
          "25%": 1.03,
          "75%": 1.15
        },
        "51650": {
          "name": "Hampton",
          "median": 1.06,
          "10%": 0.97,
          "90%": 1.18,
          "25%": 0.99,
          "75%": 1.14
        },
        "54029": {
          "name": "Hancock",
          "median": 1.09,
          "10%": 0.99,
          "90%": 1.19,
          "25%": 1.04,
          "75%": 1.14
        },
        "51085": {
          "name": "Hanover",
          "median": 1.08,
          "10%": 0.97,
          "90%": 1.271,
          "25%": 1.03,
          "75%": 1.13
        },
        "54031": {
          "name": "Hardy",
          "median": 1.07,
          "10%": 1.0,
          "90%": 1.25,
          "25%": 1.02,
          "75%": 1.13
        },
        "24025": {
          "name": "Harford",
          "median": 1.07,
          "10%": 0.97,
          "90%": 1.17,
          "25%": 1.02,
          "75%": 1.12
        },
        "54033": {
          "name": "Harrison",
          "median": 1.07,
          "10%": 1.0,
          "90%": 1.14,
          "25%": 1.02,
          "75%": 1.1
        },
        "51660": {
          "name": "Harrisonburg",
          "median": 1.09,
          "10%": 0.97,
          "90%": 1.19,
          "25%": 1.01,
          "75%": 1.15
        },
        "51087": {
          "name": "Henrico",
          "median": 1.07,
          "10%": 0.98,
          "90%": 1.22,
          "25%": 1.02,
          "75%": 1.14
        },
        "51089": {
          "name": "Henry",
          "median": 1.1,
          "10%": 0.98,
          "90%": 1.19,
          "25%": 1.01,
          "75%": 1.16
        },
        "36043": {
          "name": "Herkimer",
          "median": 1.04,
          "10%": 0.95,
          "90%": 1.1,
          "25%": 0.99,
          "75%": 1.08
        },
        "51091": {
          "name": "Highland",
          "median": 1.09,
          "10%": 0.99,
          "90%": 1.19,
          "25%": 1.04,
          "75%": 1.15
        },
        "51670": {
          "name": "Hopewell",
          "median": 1.04,
          "10%": 0.88,
          "90%": 1.19,
          "25%": 0.96,
          "75%": 1.11
        },
        "24027": {
          "name": "Howard",
          "median": 1.08,
          "10%": 0.98,
          "90%": 1.17,
          "25%": 1.01,
          "75%": 1.14
        },
        "34019": {
          "name": "Hunterdon",
          "median": 1.09,
          "10%": 1.0,
          "90%": 1.2,
          "25%": 1.04,
          "75%": 1.12
        },
        "42061": {
          "name": "Huntingdon",
          "median": 1.11,
          "10%": 1.03,
          "90%": 1.18,
          "25%": 1.08,
          "75%": 1.15
        },
        "42063": {
          "name": "Indiana",
          "median": 1.06,
          "10%": 1.0,
          "90%": 1.12,
          "25%": 1.04,
          "75%": 1.09
        },
        "51093": {
          "name": "Isle of Wight",
          "median": 1.09,
          "10%": 0.98,
          "90%": 1.22,
          "25%": 1.03,
          "75%": 1.16
        },
        "54035": {
          "name": "Jackson",
          "median": 1.09,
          "10%": 1.01,
          "90%": 1.18,
          "25%": 1.05,
          "75%": 1.1325
        },
        "51095": {
          "name": "James City",
          "median": 1.05,
          "10%": 0.95,
          "90%": 1.16,
          "25%": 1.01,
          "75%": 1.08
        },
        "42065": {
          "name": "Jefferson",
          "median": 1.08,
          "10%": 1.0,
          "90%": 1.15,
          "25%": 1.05,
          "75%": 1.12
        },
        "54037": {
          "name": "Jefferson",
          "median": 1.09,
          "10%": 0.96,
          "90%": 1.23,
          "25%": 1.02,
          "75%": 1.17
        },
        "42067": {
          "name": "Juniata",
          "median": 1.11,
          "10%": 1.02,
          "90%": 1.22,
          "25%": 1.05,
          "75%": 1.16
        },
        "54039": {
          "name": "Kanawha",
          "median": 1.05,
          "10%": 0.97,
          "90%": 1.15,
          "25%": 1.01,
          "75%": 1.09
        },
        "10001": {
          "name": "Kent",
          "median": 1.06,
          "10%": 0.98,
          "90%": 1.17,
          "25%": 1.03,
          "75%": 1.12
        },
        "24029": {
          "name": "Kent",
          "median": 1.06,
          "10%": 0.98,
          "90%": 1.2,
          "25%": 1.02,
          "75%": 1.1
        },
        "51099": {
          "name": "King George",
          "median": 1.06,
          "10%": 0.92,
          "90%": 1.22,
          "25%": 1.01,
          "75%": 1.15
        },
        "51101": {
          "name": "King William",
          "median": 1.06,
          "10%": 0.97,
          "90%": 1.17,
          "25%": 1.01,
          "75%": 1.09
        },
        "51097": {
          "name": "King and Queen",
          "median": 1.05,
          "10%": 0.96,
          "90%": 1.17,
          "25%": 1.0,
          "75%": 1.09
        },
        "42069": {
          "name": "Lackawanna",
          "median": 1.1,
          "10%": 1.02,
          "90%": 1.19,
          "25%": 1.06,
          "75%": 1.16
        },
        "42071": {
          "name": "Lancaster",
          "median": 1.09,
          "10%": 1.0,
          "90%": 1.18,
          "25%": 1.04,
          "75%": 1.14
        },
        "51103": {
          "name": "Lancaster",
          "median": 1.06,
          "10%": 0.94,
          "90%": 1.16,
          "25%": 1.0,
          "75%": 1.11
        },
        "42073": {
          "name": "Lawrence",
          "median": 1.07,
          "10%": 0.99,
          "90%": 1.13,
          "25%": 1.03,
          "75%": 1.1
        },
        "42075": {
          "name": "Lebanon",
          "median": 1.09,
          "10%": 0.99,
          "90%": 1.17,
          "25%": 1.03,
          "75%": 1.12
        },
        "51105": {
          "name": "Lee",
          "median": 1.1,
          "10%": 0.98,
          "90%": 1.19,
          "25%": 1.04,
          "75%": 1.13
        },
        "42077": {
          "name": "Lehigh",
          "median": 1.11,
          "10%": 1.0,
          "90%": 1.19,
          "25%": 1.05,
          "75%": 1.16
        },
        "54041": {
          "name": "Lewis",
          "median": 1.06,
          "10%": 1.01,
          "90%": 1.14,
          "25%": 1.03,
          "75%": 1.1
        },
        "51678": {
          "name": "Lexington",
          "median": 1.09,
          "10%": 0.98,
          "90%": 1.22,
          "25%": 1.04,
          "75%": 1.16
        },
        "54043": {
          "name": "Lincoln",
          "median": 1.06,
          "10%": 1.0,
          "90%": 1.17,
          "25%": 1.02,
          "75%": 1.11
        },
        "36051": {
          "name": "Livingston",
          "median": 1.09,
          "10%": 0.98,
          "90%": 1.2,
          "25%": 1.05,
          "75%": 1.14
        },
        "54045": {
          "name": "Logan",
          "median": 1.08,
          "10%": 1.01,
          "90%": 1.15,
          "25%": 1.04,
          "75%": 1.12
        },
        "51107": {
          "name": "Loudoun",
          "median": 1.1,
          "10%": 0.98,
          "90%": 1.22,
          "25%": 1.04,
          "75%": 1.16
        },
        "51109": {
          "name": "Louisa",
          "median": 1.08,
          "10%": 0.97,
          "90%": 1.27,
          "25%": 1.02,
          "75%": 1.16
        },
        "51111": {
          "name": "Lunenburg",
          "median": 1.1,
          "10%": 1.009,
          "90%": 1.19,
          "25%": 1.06,
          "75%": 1.14
        },
        "42079": {
          "name": "Luzerne",
          "median": 1.09,
          "10%": 1.02,
          "90%": 1.18,
          "25%": 1.05,
          "75%": 1.15
        },
        "42081": {
          "name": "Lycoming",
          "median": 1.09,
          "10%": 1.01,
          "90%": 1.18,
          "25%": 1.05,
          "75%": 1.14
        },
        "51680": {
          "name": "Lynchburg",
          "median": 1.1,
          "10%": 1.02,
          "90%": 1.19,
          "25%": 1.06,
          "75%": 1.14
        },
        "36053": {
          "name": "Madison",
          "median": 1.06,
          "10%": 0.98,
          "90%": 1.15,
          "25%": 1.01,
          "75%": 1.12
        },
        "51113": {
          "name": "Madison",
          "median": 1.09,
          "10%": 0.96,
          "90%": 1.22,
          "25%": 1.02,
          "75%": 1.14
        },
        "51683": {
          "name": "Manassas",
          "median": 1.05,
          "10%": 0.98,
          "90%": 1.191,
          "25%": 1.0,
          "75%": 1.12
        },
        "51685": {
          "name": "Manassas Park",
          "median": 1.04,
          "10%": 0.97,
          "90%": 1.18,
          "25%": 0.99,
          "75%": 1.11
        },
        "54049": {
          "name": "Marion",
          "median": 1.06,
          "10%": 0.97,
          "90%": 1.13,
          "25%": 1.01,
          "75%": 1.1
        },
        "54051": {
          "name": "Marshall",
          "median": 1.09,
          "10%": 1.02,
          "90%": 1.17,
          "25%": 1.04,
          "75%": 1.13
        },
        "51690": {
          "name": "Martinsville",
          "median": 1.1,
          "10%": 0.96,
          "90%": 1.2,
          "25%": 1.01,
          "75%": 1.16
        },
        "54053": {
          "name": "Mason",
          "median": 1.11,
          "10%": 1.009,
          "90%": 1.2,
          "25%": 1.04,
          "75%": 1.17
        },
        "51115": {
          "name": "Mathews",
          "median": 1.08,
          "10%": 0.94,
          "90%": 1.18,
          "25%": 0.98,
          "75%": 1.12
        },
        "54047": {
          "name": "McDowell",
          "median": 1.08,
          "10%": 0.99,
          "90%": 1.18,
          "25%": 1.04,
          "75%": 1.13
        },
        "42083": {
          "name": "McKean",
          "median": 1.08,
          "10%": 1.01,
          "90%": 1.15,
          "25%": 1.04,
          "75%": 1.11
        },
        "51117": {
          "name": "Mecklenburg",
          "median": 1.09,
          "10%": 1.02,
          "90%": 1.14,
          "25%": 1.05,
          "75%": 1.11
        },
        "34021": {
          "name": "Mercer",
          "median": 1.06,
          "10%": 0.99,
          "90%": 1.16,
          "25%": 1.02,
          "75%": 1.11
        },
        "42085": {
          "name": "Mercer",
          "median": 1.09,
          "10%": 1.0,
          "90%": 1.17,
          "25%": 1.05,
          "75%": 1.12
        },
        "54055": {
          "name": "Mercer",
          "median": 1.08,
          "10%": 1.0,
          "90%": 1.2,
          "25%": 1.04,
          "75%": 1.15
        },
        "51119": {
          "name": "Middlesex",
          "median": 1.05,
          "10%": 0.96,
          "90%": 1.16,
          "25%": 1.0,
          "75%": 1.1
        },
        "42087": {
          "name": "Mifflin",
          "median": 1.12,
          "10%": 1.04,
          "90%": 1.21,
          "25%": 1.08,
          "75%": 1.17
        },
        "54057": {
          "name": "Mineral",
          "median": 1.09,
          "10%": 0.99,
          "90%": 1.19,
          "25%": 1.05,
          "75%": 1.13
        },
        "54059": {
          "name": "Mingo",
          "median": 1.09,
          "10%": 1.02,
          "90%": 1.17,
          "25%": 1.04,
          "75%": 1.14
        },
        "34025": {
          "name": "Monmouth",
          "median": 1.07,
          "10%": 0.98,
          "90%": 1.17,
          "25%": 1.01,
          "75%": 1.13
        },
        "54061": {
          "name": "Monongalia",
          "median": 1.06,
          "10%": 0.98,
          "90%": 1.13,
          "25%": 1.01,
          "75%": 1.09
        },
        "42089": {
          "name": "Monroe",
          "median": 1.11,
          "10%": 1.02,
          "90%": 1.18,
          "25%": 1.06,
          "75%": 1.16
        },
        "54063": {
          "name": "Monroe",
          "median": 1.09,
          "10%": 0.97,
          "90%": 1.16,
          "25%": 1.01,
          "75%": 1.13
        },
        "24031": {
          "name": "Montgomery",
          "median": 1.08,
          "10%": 0.99,
          "90%": 1.13,
          "25%": 1.04,
          "75%": 1.1
        },
        "36057": {
          "name": "Montgomery",
          "median": 1.06,
          "10%": 1.0,
          "90%": 1.14,
          "25%": 1.03,
          "75%": 1.11
        },
        "42091": {
          "name": "Montgomery",
          "median": 1.09,
          "10%": 0.999,
          "90%": 1.16,
          "25%": 1.05,
          "75%": 1.12
        },
        "51121": {
          "name": "Montgomery",
          "median": 1.11,
          "10%": 1.01,
          "90%": 1.22,
          "25%": 1.07,
          "75%": 1.16
        },
        "42093": {
          "name": "Montour",
          "median": 1.11,
          "10%": 1.01,
          "90%": 1.23,
          "25%": 1.06,
          "75%": 1.17
        },
        "54065": {
          "name": "Morgan",
          "median": 1.12,
          "10%": 0.96,
          "90%": 1.25,
          "25%": 1.03,
          "75%": 1.17
        },
        "34027": {
          "name": "Morris",
          "median": 1.11,
          "10%": 0.99,
          "90%": 1.24,
          "25%": 1.04,
          "75%": 1.15
        },
        "36059": {
          "name": "Nassau",
          "median": 1.09,
          "10%": 0.99,
          "90%": 1.17,
          "25%": 1.04,
          "75%": 1.13
        },
        "51125": {
          "name": "Nelson",
          "median": 1.1,
          "10%": 0.95,
          "90%": 1.29,
          "25%": 1.03,
          "75%": 1.21
        },
        "10003": {
          "name": "New Castle",
          "median": 1.11,
          "10%": 0.97,
          "90%": 1.23,
          "25%": 1.01,
          "75%": 1.19
        },
        "51127": {
          "name": "New Kent",
          "median": 1.06,
          "10%": 0.97,
          "90%": 1.15,
          "25%": 1.01,
          "75%": 1.1
        },
        "36061": {
          "name": "New York",
          "median": 1.07,
          "10%": 0.97,
          "90%": 1.19,
          "25%": 1.01,
          "75%": 1.14
        },
        "51700": {
          "name": "Newport News",
          "median": 1.07,
          "10%": 0.97,
          "90%": 1.18,
          "25%": 1.01,
          "75%": 1.15
        },
        "54067": {
          "name": "Nicholas",
          "median": 1.06,
          "10%": 1.0,
          "90%": 1.14,
          "25%": 1.02,
          "75%": 1.11
        },
        "51710": {
          "name": "Norfolk",
          "median": 1.06,
          "10%": 0.94,
          "90%": 1.29,
          "25%": 1.01,
          "75%": 1.15
        },
        "42095": {
          "name": "Northampton",
          "median": 1.1,
          "10%": 0.99,
          "90%": 1.17,
          "25%": 1.07,
          "75%": 1.13
        },
        "51131": {
          "name": "Northampton",
          "median": 1.07,
          "10%": 0.95,
          "90%": 1.19,
          "25%": 1.01,
          "75%": 1.14
        },
        "42097": {
          "name": "Northumberland",
          "median": 1.11,
          "10%": 1.0,
          "90%": 1.25,
          "25%": 1.06,
          "75%": 1.15
        },
        "51133": {
          "name": "Northumberland",
          "median": 1.06,
          "10%": 0.9,
          "90%": 1.24,
          "25%": 0.99,
          "75%": 1.12
        },
        "51720": {
          "name": "Norton",
          "median": 1.09,
          "10%": 0.98,
          "90%": 1.18,
          "25%": 1.01,
          "75%": 1.15
        },
        "51135": {
          "name": "Nottoway",
          "median": 1.09,
          "10%": 0.98,
          "90%": 1.19,
          "25%": 1.02,
          "75%": 1.14
        },
        "34029": {
          "name": "Ocean",
          "median": 1.07,
          "10%": 1.01,
          "90%": 1.16,
          "25%": 1.03,
          "75%": 1.13
        },
        "54069": {
          "name": "Ohio",
          "median": 1.09,
          "10%": 1.0,
          "90%": 1.18,
          "25%": 1.02,
          "75%": 1.13
        },
        "36065": {
          "name": "Oneida",
          "median": 1.08,
          "10%": 1.0,
          "90%": 1.17,
          "25%": 1.03,
          "75%": 1.13
        },
        "36067": {
          "name": "Onondaga",
          "median": 1.08,
          "10%": 0.99,
          "90%": 1.2,
          "25%": 1.02,
          "75%": 1.14
        },
        "36069": {
          "name": "Ontario",
          "median": 1.09,
          "10%": 0.99,
          "90%": 1.19,
          "25%": 1.04,
          "75%": 1.12
        },
        "36071": {
          "name": "Orange",
          "median": 1.07,
          "10%": 0.99,
          "90%": 1.18,
          "25%": 1.03,
          "75%": 1.12
        },
        "51137": {
          "name": "Orange",
          "median": 1.09,
          "10%": 0.96,
          "90%": 1.21,
          "25%": 1.04,
          "75%": 1.16
        },
        "36077": {
          "name": "Otsego",
          "median": 1.07,
          "10%": 1.0,
          "90%": 1.15,
          "25%": 1.02,
          "75%": 1.11
        },
        "51139": {
          "name": "Page",
          "median": 1.09,
          "10%": 0.99,
          "90%": 1.261,
          "25%": 1.01,
          "75%": 1.16
        },
        "51141": {
          "name": "Patrick",
          "median": 1.07,
          "10%": 0.99,
          "90%": 1.2,
          "25%": 1.03,
          "75%": 1.13
        },
        "54071": {
          "name": "Pendleton",
          "median": 1.1,
          "10%": 0.99,
          "90%": 1.31,
          "25%": 1.04,
          "75%": 1.17
        },
        "42099": {
          "name": "Perry",
          "median": 1.12,
          "10%": 0.97,
          "90%": 1.27,
          "25%": 1.04,
          "75%": 1.18
        },
        "51730": {
          "name": "Petersburg",
          "median": 1.08,
          "10%": 0.9,
          "90%": 1.21,
          "25%": 1.0,
          "75%": 1.13
        },
        "42101": {
          "name": "Philadelphia",
          "median": 1.09,
          "10%": 0.99,
          "90%": 1.15,
          "25%": 1.03,
          "75%": 1.12
        },
        "42103": {
          "name": "Pike",
          "median": 1.11,
          "10%": 1.0,
          "90%": 1.19,
          "25%": 1.05,
          "75%": 1.15
        },
        "51143": {
          "name": "Pittsylvania",
          "median": 1.12,
          "10%": 1.01,
          "90%": 1.21,
          "25%": 1.06,
          "75%": 1.17
        },
        "54073": {
          "name": "Pleasants",
          "median": 1.07,
          "10%": 1.0,
          "90%": 1.16,
          "25%": 1.03,
          "75%": 1.11
        },
        "54075": {
          "name": "Pocahontas",
          "median": 1.06,
          "10%": 1.0,
          "90%": 1.19,
          "25%": 1.03,
          "75%": 1.12
        },
        "51735": {
          "name": "Poquoson",
          "median": 1.06,
          "10%": 0.97,
          "90%": 1.17,
          "25%": 0.99,
          "75%": 1.1425
        },
        "51740": {
          "name": "Portsmouth",
          "median": 1.06,
          "10%": 0.96,
          "90%": 1.28,
          "25%": 1.01,
          "75%": 1.15
        },
        "42105": {
          "name": "Potter",
          "median": 1.08,
          "10%": 1.0,
          "90%": 1.18,
          "25%": 1.05,
          "75%": 1.13
        },
        "51145": {
          "name": "Powhatan",
          "median": 1.07,
          "10%": 0.88,
          "90%": 1.32,
          "25%": 0.99,
          "75%": 1.15
        },
        "54077": {
          "name": "Preston",
          "median": 1.06,
          "10%": 1.0,
          "90%": 1.14,
          "25%": 1.03,
          "75%": 1.09
        },
        "51147": {
          "name": "Prince Edward",
          "median": 1.09,
          "10%": 1.0,
          "90%": 1.2,
          "25%": 1.03,
          "75%": 1.15
        },
        "51149": {
          "name": "Prince George",
          "median": 1.05,
          "10%": 0.94,
          "90%": 1.18,
          "25%": 0.97,
          "75%": 1.13
        },
        "24033": {
          "name": "Prince George's",
          "median": 1.07,
          "10%": 0.98,
          "90%": 1.16,
          "25%": 1.01,
          "75%": 1.12
        },
        "51153": {
          "name": "Prince William",
          "median": 1.06,
          "10%": 0.99,
          "90%": 1.19,
          "25%": 1.02,
          "75%": 1.11
        },
        "51155": {
          "name": "Pulaski",
          "median": 1.1,
          "10%": 1.03,
          "90%": 1.21,
          "25%": 1.05,
          "75%": 1.16
        },
        "54079": {
          "name": "Putnam",
          "median": 1.06,
          "10%": 1.0,
          "90%": 1.18,
          "25%": 1.02,
          "75%": 1.13
        },
        "24035": {
          "name": "Queen Anne's",
          "median": 1.05,
          "10%": 0.98,
          "90%": 1.22,
          "25%": 1.03,
          "75%": 1.11
        },
        "51750": {
          "name": "Radford",
          "median": 1.13,
          "10%": 1.01,
          "90%": 1.22,
          "25%": 1.06,
          "75%": 1.18
        },
        "54081": {
          "name": "Raleigh",
          "median": 1.09,
          "10%": 1.01,
          "90%": 1.19,
          "25%": 1.04,
          "75%": 1.12
        },
        "54083": {
          "name": "Randolph",
          "median": 1.07,
          "10%": 1.01,
          "90%": 1.14,
          "25%": 1.04,
          "75%": 1.09
        },
        "51157": {
          "name": "Rappahannock",
          "median": 1.08,
          "10%": 0.97,
          "90%": 1.23,
          "25%": 1.02,
          "75%": 1.14
        },
        "36085": {
          "name": "Richmond",
          "median": 1.06,
          "10%": 0.97,
          "90%": 1.19,
          "25%": 1.01,
          "75%": 1.12
        },
        "51159": {
          "name": "Richmond",
          "median": 1.03,
          "10%": 0.88,
          "90%": 1.32,
          "25%": 0.97,
          "75%": 1.11
        },
        "51760": {
          "name": "Richmond",
          "median": 1.08,
          "10%": 0.98,
          "90%": 1.2,
          "25%": 1.02,
          "75%": 1.13
        },
        "54085": {
          "name": "Ritchie",
          "median": 1.09,
          "10%": 1.03,
          "90%": 1.15,
          "25%": 1.05,
          "75%": 1.12
        },
        "54087": {
          "name": "Roane",
          "median": 1.07,
          "10%": 1.02,
          "90%": 1.19,
          "25%": 1.04,
          "75%": 1.12
        },
        "51161": {
          "name": "Roanoke",
          "median": 1.13,
          "10%": 1.01,
          "90%": 1.24,
          "25%": 1.05,
          "75%": 1.19
        },
        "51770": {
          "name": "Roanoke",
          "median": 1.12,
          "10%": 0.99,
          "90%": 1.26,
          "25%": 1.03,
          "75%": 1.18
        },
        "51163": {
          "name": "Rockbridge",
          "median": 1.11,
          "10%": 0.99,
          "90%": 1.25,
          "25%": 1.04,
          "75%": 1.21
        },
        "51165": {
          "name": "Rockingham",
          "median": 1.09,
          "10%": 0.98,
          "90%": 1.22,
          "25%": 1.02,
          "75%": 1.15
        },
        "51167": {
          "name": "Russell",
          "median": 1.05,
          "10%": 0.99,
          "90%": 1.16,
          "25%": 1.02,
          "75%": 1.09
        },
        "34033": {
          "name": "Salem",
          "median": 1.09,
          "10%": 0.98,
          "90%": 1.21,
          "25%": 1.02,
          "75%": 1.17
        },
        "51775": {
          "name": "Salem",
          "median": 1.12,
          "10%": 0.98,
          "90%": 1.27,
          "25%": 1.04,
          "75%": 1.2
        },
        "36095": {
          "name": "Schoharie",
          "median": 1.09,
          "10%": 0.99,
          "90%": 1.19,
          "25%": 1.04,
          "75%": 1.14
        },
        "36097": {
          "name": "Schuyler",
          "median": 1.11,
          "10%": 1.01,
          "90%": 1.21,
          "25%": 1.04,
          "75%": 1.17
        },
        "42107": {
          "name": "Schuylkill",
          "median": 1.11,
          "10%": 0.99,
          "90%": 1.19,
          "25%": 1.05,
          "75%": 1.15
        },
        "51169": {
          "name": "Scott",
          "median": 1.09,
          "10%": 1.0,
          "90%": 1.19,
          "25%": 1.04,
          "75%": 1.14
        },
        "51171": {
          "name": "Shenandoah",
          "median": 1.09,
          "10%": 0.99,
          "90%": 1.22,
          "25%": 1.03,
          "75%": 1.15
        },
        "51173": {
          "name": "Smyth",
          "median": 1.06,
          "10%": 1.01,
          "90%": 1.15,
          "25%": 1.03,
          "75%": 1.11
        },
        "42109": {
          "name": "Snyder",
          "median": 1.1,
          "10%": 1.0,
          "90%": 1.25,
          "25%": 1.06,
          "75%": 1.16
        },
        "24039": {
          "name": "Somerset",
          "median": 1.09,
          "10%": 1.0,
          "90%": 1.17,
          "25%": 1.04,
          "75%": 1.14
        },
        "42111": {
          "name": "Somerset",
          "median": 1.08,
          "10%": 1.01,
          "90%": 1.13,
          "25%": 1.05,
          "75%": 1.1
        },
        "51175": {
          "name": "Southampton",
          "median": 1.06,
          "10%": 0.98,
          "90%": 1.22,
          "25%": 1.03,
          "75%": 1.14
        },
        "51177": {
          "name": "Spotsylvania",
          "median": 1.08,
          "10%": 0.98,
          "90%": 1.17,
          "25%": 1.04,
          "75%": 1.14
        },
        "24037": {
          "name": "St. Mary's",
          "median": 1.07,
          "10%": 0.95,
          "90%": 1.18,
          "25%": 0.98,
          "75%": 1.12
        },
        "51179": {
          "name": "Stafford",
          "median": 1.09,
          "10%": 0.96,
          "90%": 1.22,
          "25%": 1.03,
          "75%": 1.16
        },
        "51790": {
          "name": "Staunton",
          "median": 1.09,
          "10%": 0.93,
          "90%": 1.31,
          "25%": 1.02,
          "75%": 1.19
        },
        "36101": {
          "name": "Steuben",
          "median": 1.09,
          "10%": 1.03,
          "90%": 1.19,
          "25%": 1.05,
          "75%": 1.15
        },
        "51800": {
          "name": "Suffolk",
          "median": 1.1,
          "10%": 0.97,
          "90%": 1.21,
          "25%": 1.03,
          "75%": 1.17
        },
        "36105": {
          "name": "Sullivan",
          "median": 1.09,
          "10%": 1.02,
          "90%": 1.18,
          "25%": 1.05,
          "75%": 1.14
        },
        "42113": {
          "name": "Sullivan",
          "median": 1.09,
          "10%": 0.98,
          "90%": 1.2,
          "25%": 1.04,
          "75%": 1.15
        },
        "54089": {
          "name": "Summers",
          "median": 1.08,
          "10%": 1.0,
          "90%": 1.14,
          "25%": 1.03,
          "75%": 1.12
        },
        "51181": {
          "name": "Surry",
          "median": 1.07,
          "10%": 0.97,
          "90%": 1.2,
          "25%": 1.02,
          "75%": 1.11
        },
        "42115": {
          "name": "Susquehanna",
          "median": 1.08,
          "10%": 1.0,
          "90%": 1.19,
          "25%": 1.04,
          "75%": 1.12
        },
        "10005": {
          "name": "Sussex",
          "median": 1.08,
          "10%": 0.98,
          "90%": 1.15,
          "25%": 1.03,
          "75%": 1.11
        },
        "34037": {
          "name": "Sussex",
          "median": 1.11,
          "10%": 1.0,
          "90%": 1.19,
          "25%": 1.06,
          "75%": 1.14
        },
        "51183": {
          "name": "Sussex",
          "median": 1.06,
          "10%": 0.98,
          "90%": 1.19,
          "25%": 1.01,
          "75%": 1.14
        },
        "24041": {
          "name": "Talbot",
          "median": 1.03,
          "10%": 0.94,
          "90%": 1.18,
          "25%": 0.97,
          "75%": 1.13
        },
        "54091": {
          "name": "Taylor",
          "median": 1.06,
          "10%": 1.0,
          "90%": 1.17,
          "25%": 1.04,
          "75%": 1.1
        },
        "51185": {
          "name": "Tazewell",
          "median": 1.07,
          "10%": 1.01,
          "90%": 1.16,
          "25%": 1.02,
          "75%": 1.1
        },
        "36107": {
          "name": "Tioga",
          "median": 1.08,
          "10%": 0.99,
          "90%": 1.18,
          "25%": 1.03,
          "75%": 1.13
        },
        "42117": {
          "name": "Tioga",
          "median": 1.09,
          "10%": 1.01,
          "90%": 1.17,
          "25%": 1.05,
          "75%": 1.15
        },
        "36109": {
          "name": "Tompkins",
          "median": 1.1,
          "10%": 1.01,
          "90%": 1.17,
          "25%": 1.05,
          "75%": 1.15
        },
        "54093": {
          "name": "Tucker",
          "median": 1.05,
          "10%": 0.99,
          "90%": 1.13,
          "25%": 1.01,
          "75%": 1.09
        },
        "54095": {
          "name": "Tyler",
          "median": 1.04,
          "10%": 0.95,
          "90%": 1.13,
          "25%": 1.01,
          "75%": 1.09
        },
        "36111": {
          "name": "Ulster",
          "median": 1.1,
          "10%": 1.02,
          "90%": 1.26,
          "25%": 1.04,
          "75%": 1.15
        },
        "42119": {
          "name": "Union",
          "median": 1.1,
          "10%": 0.99,
          "90%": 1.19,
          "25%": 1.06,
          "75%": 1.15
        },
        "54097": {
          "name": "Upshur",
          "median": 1.04,
          "10%": 0.99,
          "90%": 1.13,
          "25%": 1.01,
          "75%": 1.1
        },
        "42121": {
          "name": "Venango",
          "median": 1.07,
          "10%": 1.04,
          "90%": 1.15,
          "25%": 1.05,
          "75%": 1.1
        },
        "51810": {
          "name": "Virginia Beach",
          "median": 1.08,
          "10%": 0.94,
          "90%": 1.31,
          "25%": 1.02,
          "75%": 1.14
        },
        "34041": {
          "name": "Warren",
          "median": 1.11,
          "10%": 1.0,
          "90%": 1.24,
          "25%": 1.05,
          "75%": 1.16
        },
        "42123": {
          "name": "Warren",
          "median": 1.07,
          "10%": 1.02,
          "90%": 1.15,
          "25%": 1.03,
          "75%": 1.1
        },
        "51187": {
          "name": "Warren",
          "median": 1.09,
          "10%": 0.98,
          "90%": 1.27,
          "25%": 1.03,
          "75%": 1.19
        },
        "24043": {
          "name": "Washington",
          "median": 1.09,
          "10%": 1.0,
          "90%": 1.23,
          "25%": 1.03,
          "75%": 1.16
        },
        "42125": {
          "name": "Washington",
          "median": 1.08,
          "10%": 1.01,
          "90%": 1.17,
          "25%": 1.04,
          "75%": 1.14
        },
        "51191": {
          "name": "Washington",
          "median": 1.06,
          "10%": 0.99,
          "90%": 1.15,
          "25%": 1.01,
          "75%": 1.11
        },
        "42127": {
          "name": "Wayne",
          "median": 1.1,
          "10%": 1.01,
          "90%": 1.19,
          "25%": 1.05,
          "75%": 1.14
        },
        "54099": {
          "name": "Wayne",
          "median": 1.07,
          "10%": 1.01,
          "90%": 1.18,
          "25%": 1.04,
          "75%": 1.11
        },
        "51820": {
          "name": "Waynesboro",
          "median": 1.11,
          "10%": 0.92,
          "90%": 1.32,
          "25%": 1.02,
          "75%": 1.21
        },
        "54101": {
          "name": "Webster",
          "median": 1.05,
          "10%": 0.99,
          "90%": 1.15,
          "25%": 1.01,
          "75%": 1.09
        },
        "36119": {
          "name": "Westchester",
          "median": 1.08,
          "10%": 0.98,
          "90%": 1.18,
          "25%": 1.01,
          "75%": 1.13
        },
        "42129": {
          "name": "Westmoreland",
          "median": 1.05,
          "10%": 0.99,
          "90%": 1.11,
          "25%": 1.02,
          "75%": 1.09
        },
        "51193": {
          "name": "Westmoreland",
          "median": 1.04,
          "10%": 0.91,
          "90%": 1.28,
          "25%": 0.9675,
          "75%": 1.1
        },
        "54103": {
          "name": "Wetzel",
          "median": 1.09,
          "10%": 1.0,
          "90%": 1.14,
          "25%": 1.04,
          "75%": 1.11
        },
        "24045": {
          "name": "Wicomico",
          "median": 1.06,
          "10%": 1.0,
          "90%": 1.14,
          "25%": 1.03,
          "75%": 1.11
        },
        "51830": {
          "name": "Williamsburg",
          "median": 1.04,
          "10%": 0.94,
          "90%": 1.13,
          "25%": 0.99,
          "75%": 1.09
        },
        "51840": {
          "name": "Winchester",
          "median": 1.1,
          "10%": 0.99,
          "90%": 1.24,
          "25%": 1.06,
          "75%": 1.17
        },
        "54105": {
          "name": "Wirt",
          "median": 1.1,
          "10%": 1.03,
          "90%": 1.18,
          "25%": 1.07,
          "75%": 1.16
        },
        "51195": {
          "name": "Wise",
          "median": 1.09,
          "10%": 0.99,
          "90%": 1.17,
          "25%": 1.02,
          "75%": 1.14
        },
        "54107": {
          "name": "Wood",
          "median": 1.08,
          "10%": 1.02,
          "90%": 1.21,
          "25%": 1.04,
          "75%": 1.11
        },
        "24047": {
          "name": "Worcester",
          "median": 1.07,
          "10%": 0.96,
          "90%": 1.19,
          "25%": 1.02,
          "75%": 1.13
        },
        "42131": {
          "name": "Wyoming",
          "median": 1.08,
          "10%": 1.03,
          "90%": 1.21,
          "25%": 1.05,
          "75%": 1.14
        },
        "54109": {
          "name": "Wyoming",
          "median": 1.1,
          "10%": 0.98,
          "90%": 1.17,
          "25%": 1.06,
          "75%": 1.14
        },
        "51197": {
          "name": "Wythe",
          "median": 1.07,
          "10%": 1.01,
          "90%": 1.17,
          "25%": 1.04,
          "75%": 1.12
        },
        "36123": {
          "name": "Yates",
          "median": 1.1,
          "10%": 1.0,
          "90%": 1.2,
          "25%": 1.05,
          "75%": 1.16
        },
        "42133": {
          "name": "York",
          "median": 1.1,
          "10%": 0.99,
          "90%": 1.18,
          "25%": 1.02,
          "75%": 1.15
        },
        "51199": {
          "name": "York",
          "median": 1.05,
          "10%": 0.96,
          "90%": 1.16,
          "25%": 1.0,
          "75%": 1.1
        },
        "max": 1.13,
        "min": 1
      },
      "10": {
        "51001": {
          "name": "Accomack",
          "median": 1.07,
          "10%": 0.92,
          "90%": 1.24,
          "25%": 1.02,
          "75%": 1.13
        },
        "42001": {
          "name": "Adams",
          "median": 1.1,
          "10%": 0.93,
          "90%": 1.28,
          "25%": 1.01,
          "75%": 1.21
        },
        "51003": {
          "name": "Albemarle",
          "median": 1.12,
          "10%": 0.91,
          "90%": 1.29,
          "25%": 1.03,
          "75%": 1.16
        },
        "51510": {
          "name": "Alexandria",
          "median": 1.05,
          "10%": 0.9,
          "90%": 1.18,
          "25%": 0.9875,
          "75%": 1.13
        },
        "24001": {
          "name": "Allegany",
          "median": 1.09,
          "10%": 0.96,
          "90%": 1.22,
          "25%": 1.05,
          "75%": 1.16
        },
        "36003": {
          "name": "Allegany",
          "median": 1.08,
          "10%": 0.99,
          "90%": 1.22,
          "25%": 1.03,
          "75%": 1.15
        },
        "51005": {
          "name": "Alleghany",
          "median": 1.09,
          "10%": 0.99,
          "90%": 1.25,
          "25%": 1.04,
          "75%": 1.19
        },
        "42003": {
          "name": "Allegheny",
          "median": 1.07,
          "10%": 0.99,
          "90%": 1.16,
          "25%": 1.02,
          "75%": 1.11
        },
        "51007": {
          "name": "Amelia",
          "median": 1.07,
          "10%": 0.93,
          "90%": 1.3,
          "25%": 1.0,
          "75%": 1.21
        },
        "51009": {
          "name": "Amherst",
          "median": 1.12,
          "10%": 0.98,
          "90%": 1.27,
          "25%": 1.01,
          "75%": 1.18
        },
        "24003": {
          "name": "Anne Arundel",
          "median": 1.04,
          "10%": 0.96,
          "90%": 1.18,
          "25%": 1.01,
          "75%": 1.12
        },
        "51011": {
          "name": "Appomattox",
          "median": 1.12,
          "10%": 0.96,
          "90%": 1.29,
          "25%": 1.02,
          "75%": 1.2
        },
        "51013": {
          "name": "Arlington",
          "median": 1.05,
          "10%": 0.94,
          "90%": 1.17,
          "25%": 0.99,
          "75%": 1.12
        },
        "42005": {
          "name": "Armstrong",
          "median": 1.07,
          "10%": 1.01,
          "90%": 1.14,
          "25%": 1.04,
          "75%": 1.11
        },
        "34001": {
          "name": "Atlantic",
          "median": 1.12,
          "10%": 0.98,
          "90%": 1.2,
          "25%": 1.05,
          "75%": 1.16
        },
        "51015": {
          "name": "Augusta",
          "median": 1.12,
          "10%": 0.94,
          "90%": 1.32,
          "25%": 1.02,
          "75%": 1.2
        },
        "24005": {
          "name": "Baltimore",
          "median": 1.09,
          "10%": 0.96,
          "90%": 1.21,
          "25%": 1.02,
          "75%": 1.13
        },
        "24510": {
          "name": "Baltimore",
          "median": 1.09,
          "10%": 0.94,
          "90%": 1.23,
          "25%": 0.98,
          "75%": 1.14
        },
        "54001": {
          "name": "Barbour",
          "median": 1.07,
          "10%": 0.99,
          "90%": 1.14,
          "25%": 1.02,
          "75%": 1.11
        },
        "51017": {
          "name": "Bath",
          "median": 1.12,
          "10%": 1.01,
          "90%": 1.27,
          "25%": 1.04,
          "75%": 1.2
        },
        "42007": {
          "name": "Beaver",
          "median": 1.06,
          "10%": 0.979,
          "90%": 1.16,
          "25%": 1.02,
          "75%": 1.1
        },
        "42009": {
          "name": "Bedford",
          "median": 1.13,
          "10%": 0.97,
          "90%": 1.22,
          "25%": 1.04,
          "75%": 1.17
        },
        "51019": {
          "name": "Bedford",
          "median": 1.12,
          "10%": 0.99,
          "90%": 1.23,
          "25%": 1.06,
          "75%": 1.17
        },
        "54003": {
          "name": "Berkeley",
          "median": 1.11,
          "10%": 0.96,
          "90%": 1.27,
          "25%": 1.03,
          "75%": 1.18
        },
        "42011": {
          "name": "Berks",
          "median": 1.1,
          "10%": 1.0,
          "90%": 1.21,
          "25%": 1.04,
          "75%": 1.15
        },
        "42013": {
          "name": "Blair",
          "median": 1.11,
          "10%": 1.03,
          "90%": 1.18,
          "25%": 1.06,
          "75%": 1.15
        },
        "51021": {
          "name": "Bland",
          "median": 1.09,
          "10%": 1.0,
          "90%": 1.2,
          "25%": 1.02,
          "75%": 1.15
        },
        "54005": {
          "name": "Boone",
          "median": 1.07,
          "10%": 1.01,
          "90%": 1.17,
          "25%": 1.05,
          "75%": 1.13
        },
        "51023": {
          "name": "Botetourt",
          "median": 1.14,
          "10%": 0.99,
          "90%": 1.26,
          "25%": 1.04,
          "75%": 1.19
        },
        "42015": {
          "name": "Bradford",
          "median": 1.09,
          "10%": 1.0,
          "90%": 1.24,
          "25%": 1.02,
          "75%": 1.14
        },
        "54007": {
          "name": "Braxton",
          "median": 1.07,
          "10%": 0.99,
          "90%": 1.18,
          "25%": 1.02,
          "75%": 1.13
        },
        "51520": {
          "name": "Bristol",
          "median": 1.07,
          "10%": 1.01,
          "90%": 1.16,
          "25%": 1.03,
          "75%": 1.12
        },
        "36005": {
          "name": "Bronx",
          "median": 1.07,
          "10%": 0.97,
          "90%": 1.22,
          "25%": 1.02,
          "75%": 1.11
        },
        "54009": {
          "name": "Brooke",
          "median": 1.1,
          "10%": 0.99,
          "90%": 1.26,
          "25%": 1.02,
          "75%": 1.18
        },
        "36007": {
          "name": "Broome",
          "median": 1.09,
          "10%": 1.02,
          "90%": 1.18,
          "25%": 1.05,
          "75%": 1.14
        },
        "51025": {
          "name": "Brunswick",
          "median": 1.08,
          "10%": 0.98,
          "90%": 1.24,
          "25%": 1.02,
          "75%": 1.1725
        },
        "51027": {
          "name": "Buchanan",
          "median": 1.07,
          "10%": 1.0,
          "90%": 1.15,
          "25%": 1.03,
          "75%": 1.11
        },
        "51029": {
          "name": "Buckingham",
          "median": 1.1,
          "10%": 0.94,
          "90%": 1.21,
          "25%": 1.01,
          "75%": 1.17
        },
        "42017": {
          "name": "Bucks",
          "median": 1.07,
          "10%": 0.99,
          "90%": 1.15,
          "25%": 1.03,
          "75%": 1.12
        },
        "51530": {
          "name": "Buena Vista",
          "median": 1.1,
          "10%": 0.94,
          "90%": 1.33,
          "25%": 1.05,
          "75%": 1.21
        },
        "34005": {
          "name": "Burlington",
          "median": 1.06,
          "10%": 0.99,
          "90%": 1.18,
          "25%": 1.02,
          "75%": 1.13
        },
        "42019": {
          "name": "Butler",
          "median": 1.07,
          "10%": 1.01,
          "90%": 1.12,
          "25%": 1.03,
          "75%": 1.1
        },
        "54011": {
          "name": "Cabell",
          "median": 1.06,
          "10%": 1.0,
          "90%": 1.18,
          "25%": 1.03,
          "75%": 1.13
        },
        "54013": {
          "name": "Calhoun",
          "median": 1.11,
          "10%": 0.99,
          "90%": 1.21,
          "25%": 1.05,
          "75%": 1.15
        },
        "24009": {
          "name": "Calvert",
          "median": 1.06,
          "10%": 0.94,
          "90%": 1.18,
          "25%": 0.99,
          "75%": 1.13
        },
        "42021": {
          "name": "Cambria",
          "median": 1.07,
          "10%": 0.98,
          "90%": 1.14,
          "25%": 1.01,
          "75%": 1.12
        },
        "34007": {
          "name": "Camden",
          "median": 1.08,
          "10%": 1.0,
          "90%": 1.18,
          "25%": 1.04,
          "75%": 1.14
        },
        "42023": {
          "name": "Cameron",
          "median": 1.09,
          "10%": 0.99,
          "90%": 1.17,
          "25%": 1.03,
          "75%": 1.13
        },
        "51031": {
          "name": "Campbell",
          "median": 1.12,
          "10%": 0.98,
          "90%": 1.23,
          "25%": 1.0775,
          "75%": 1.19
        },
        "34009": {
          "name": "Cape May",
          "median": 1.12,
          "10%": 1.0,
          "90%": 1.2,
          "25%": 1.05,
          "75%": 1.15
        },
        "42025": {
          "name": "Carbon",
          "median": 1.09,
          "10%": 0.99,
          "90%": 1.18,
          "25%": 1.05,
          "75%": 1.13
        },
        "24011": {
          "name": "Caroline",
          "median": 1.07,
          "10%": 0.95,
          "90%": 1.24,
          "25%": 1.01,
          "75%": 1.13
        },
        "51033": {
          "name": "Caroline",
          "median": 1.055,
          "10%": 0.94,
          "90%": 1.22,
          "25%": 1.01,
          "75%": 1.15
        },
        "24013": {
          "name": "Carroll",
          "median": 1.12,
          "10%": 0.98,
          "90%": 1.24,
          "25%": 1.05,
          "75%": 1.2
        },
        "51035": {
          "name": "Carroll",
          "median": 1.085,
          "10%": 1.03,
          "90%": 1.2,
          "25%": 1.05,
          "75%": 1.14
        },
        "24015": {
          "name": "Cecil",
          "median": 1.09,
          "10%": 0.98,
          "90%": 1.17,
          "25%": 1.01,
          "75%": 1.13
        },
        "42027": {
          "name": "Centre",
          "median": 1.11,
          "10%": 1.02,
          "90%": 1.18,
          "25%": 1.08,
          "75%": 1.15
        },
        "24017": {
          "name": "Charles",
          "median": 1.08,
          "10%": 0.93,
          "90%": 1.27,
          "25%": 0.98,
          "75%": 1.17
        },
        "51036": {
          "name": "Charles City",
          "median": 1.04,
          "10%": 0.94,
          "90%": 1.19,
          "25%": 0.98,
          "75%": 1.11
        },
        "51037": {
          "name": "Charlotte",
          "median": 1.11,
          "10%": 0.97,
          "90%": 1.22,
          "25%": 1.04,
          "75%": 1.16
        },
        "51540": {
          "name": "Charlottesville",
          "median": 1.11,
          "10%": 0.93,
          "90%": 1.25,
          "25%": 1.02,
          "75%": 1.18
        },
        "36015": {
          "name": "Chemung",
          "median": 1.08,
          "10%": 1.01,
          "90%": 1.2,
          "25%": 1.04,
          "75%": 1.15
        },
        "36017": {
          "name": "Chenango",
          "median": 1.07,
          "10%": 1.0,
          "90%": 1.17,
          "25%": 1.03,
          "75%": 1.14
        },
        "51550": {
          "name": "Chesapeake",
          "median": 1.09,
          "10%": 0.96,
          "90%": 1.31,
          "25%": 0.99,
          "75%": 1.18
        },
        "42029": {
          "name": "Chester",
          "median": 1.11,
          "10%": 0.97,
          "90%": 1.2,
          "25%": 1.03,
          "75%": 1.16
        },
        "51041": {
          "name": "Chesterfield",
          "median": 1.07,
          "10%": 0.94,
          "90%": 1.31,
          "25%": 1.01,
          "75%": 1.16
        },
        "42031": {
          "name": "Clarion",
          "median": 1.08,
          "10%": 0.99,
          "90%": 1.16,
          "25%": 1.05,
          "75%": 1.13
        },
        "51043": {
          "name": "Clarke",
          "median": 1.09,
          "10%": 0.96,
          "90%": 1.24,
          "25%": 1.0,
          "75%": 1.18
        },
        "54015": {
          "name": "Clay",
          "median": 1.04,
          "10%": 0.99,
          "90%": 1.16,
          "25%": 1.02,
          "75%": 1.09
        },
        "42033": {
          "name": "Clearfield",
          "median": 1.09,
          "10%": 1.04,
          "90%": 1.16,
          "25%": 1.06,
          "75%": 1.13
        },
        "42035": {
          "name": "Clinton",
          "median": 1.1,
          "10%": 1.0,
          "90%": 1.18,
          "25%": 1.06,
          "75%": 1.15
        },
        "51570": {
          "name": "Colonial Heights",
          "median": 1.08,
          "10%": 0.89,
          "90%": 1.25,
          "25%": 0.97,
          "75%": 1.16
        },
        "42037": {
          "name": "Columbia",
          "median": 1.1,
          "10%": 0.99,
          "90%": 1.25,
          "25%": 1.07,
          "75%": 1.18
        },
        "36023": {
          "name": "Cortland",
          "median": 1.1,
          "10%": 1.0,
          "90%": 1.18,
          "25%": 1.03,
          "75%": 1.15
        },
        "51580": {
          "name": "Covington",
          "median": 1.1,
          "10%": 0.97,
          "90%": 1.23,
          "25%": 1.03,
          "75%": 1.16
        },
        "51045": {
          "name": "Craig",
          "median": 1.11,
          "10%": 0.97,
          "90%": 1.22,
          "25%": 1.03,
          "75%": 1.15
        },
        "42039": {
          "name": "Crawford",
          "median": 1.07,
          "10%": 1.0,
          "90%": 1.17,
          "25%": 1.03,
          "75%": 1.13
        },
        "51047": {
          "name": "Culpeper",
          "median": 1.09,
          "10%": 0.96,
          "90%": 1.18,
          "25%": 1.01,
          "75%": 1.13
        },
        "34011": {
          "name": "Cumberland",
          "median": 1.08,
          "10%": 0.99,
          "90%": 1.17,
          "25%": 1.03,
          "75%": 1.13
        },
        "42041": {
          "name": "Cumberland",
          "median": 1.13,
          "10%": 0.98,
          "90%": 1.3,
          "25%": 1.01,
          "75%": 1.21
        },
        "51049": {
          "name": "Cumberland",
          "median": 1.07,
          "10%": 0.93,
          "90%": 1.26,
          "25%": 1.0,
          "75%": 1.18
        },
        "51590": {
          "name": "Danville",
          "median": 1.11,
          "10%": 0.96,
          "90%": 1.22,
          "25%": 1.03,
          "75%": 1.18
        },
        "42043": {
          "name": "Dauphin",
          "median": 1.13,
          "10%": 0.96,
          "90%": 1.32,
          "25%": 1.05,
          "75%": 1.21
        },
        "36025": {
          "name": "Delaware",
          "median": 1.08,
          "10%": 1.0,
          "90%": 1.2,
          "25%": 1.04,
          "75%": 1.15
        },
        "42045": {
          "name": "Delaware",
          "median": 1.09,
          "10%": 0.97,
          "90%": 1.26,
          "25%": 1.03,
          "75%": 1.19
        },
        "51051": {
          "name": "Dickenson",
          "median": 1.08,
          "10%": 0.98,
          "90%": 1.15,
          "25%": 1.01,
          "75%": 1.12
        },
        "51053": {
          "name": "Dinwiddie",
          "median": 1.09,
          "10%": 0.96,
          "90%": 1.22,
          "25%": 1.02,
          "75%": 1.16
        },
        "11001": {
          "name": "District of Columbia",
          "median": 1.07,
          "10%": 0.95,
          "90%": 1.2,
          "25%": 0.99,
          "75%": 1.13
        },
        "54017": {
          "name": "Doddridge",
          "median": 1.05,
          "10%": 0.96,
          "90%": 1.15,
          "25%": 1.0,
          "75%": 1.08
        },
        "24019": {
          "name": "Dorchester",
          "median": 1.05,
          "10%": 0.9,
          "90%": 1.18,
          "25%": 0.98,
          "75%": 1.11
        },
        "42047": {
          "name": "Elk",
          "median": 1.07,
          "10%": 0.99,
          "90%": 1.14,
          "25%": 1.03,
          "75%": 1.1
        },
        "51595": {
          "name": "Emporia",
          "median": 1.04,
          "10%": 0.95,
          "90%": 1.18,
          "25%": 0.99,
          "75%": 1.12
        },
        "42049": {
          "name": "Erie",
          "median": 1.09,
          "10%": 1.0,
          "90%": 1.17,
          "25%": 1.03,
          "75%": 1.13
        },
        "51057": {
          "name": "Essex",
          "median": 1.04,
          "10%": 0.88,
          "90%": 1.28,
          "25%": 0.98,
          "75%": 1.08
        },
        "51059": {
          "name": "Fairfax",
          "median": 1.04,
          "10%": 0.96,
          "90%": 1.17,
          "25%": 0.99,
          "75%": 1.09
        },
        "51600": {
          "name": "Fairfax",
          "median": 1.04,
          "10%": 0.93,
          "90%": 1.15,
          "25%": 0.99,
          "75%": 1.1
        },
        "51610": {
          "name": "Falls Church",
          "median": 1.05,
          "10%": 0.94,
          "90%": 1.18,
          "25%": 1.0,
          "75%": 1.12
        },
        "51061": {
          "name": "Fauquier",
          "median": 1.1,
          "10%": 0.969,
          "90%": 1.22,
          "25%": 1.0,
          "75%": 1.16
        },
        "42051": {
          "name": "Fayette",
          "median": 1.06,
          "10%": 1.0,
          "90%": 1.17,
          "25%": 1.02,
          "75%": 1.11
        },
        "54019": {
          "name": "Fayette",
          "median": 1.07,
          "10%": 0.95,
          "90%": 1.17,
          "25%": 1.02,
          "75%": 1.13
        },
        "51063": {
          "name": "Floyd",
          "median": 1.09,
          "10%": 0.99,
          "90%": 1.2,
          "25%": 1.05,
          "75%": 1.15
        },
        "51065": {
          "name": "Fluvanna",
          "median": 1.1,
          "10%": 0.92,
          "90%": 1.38,
          "25%": 0.99,
          "75%": 1.2
        },
        "42053": {
          "name": "Forest",
          "median": 1.06,
          "10%": 1.01,
          "90%": 1.16,
          "25%": 1.02,
          "75%": 1.11
        },
        "42055": {
          "name": "Franklin",
          "median": 1.11,
          "10%": 1.0,
          "90%": 1.2,
          "25%": 1.05,
          "75%": 1.1625
        },
        "51067": {
          "name": "Franklin",
          "median": 1.12,
          "10%": 0.97,
          "90%": 1.23,
          "25%": 1.01,
          "75%": 1.2
        },
        "51620": {
          "name": "Franklin",
          "median": 1.1,
          "10%": 0.95,
          "90%": 1.25,
          "25%": 1.04,
          "75%": 1.18
        },
        "24021": {
          "name": "Frederick",
          "median": 1.11,
          "10%": 0.95,
          "90%": 1.22,
          "25%": 1.05,
          "75%": 1.19
        },
        "51069": {
          "name": "Frederick",
          "median": 1.09,
          "10%": 0.97,
          "90%": 1.28,
          "25%": 1.04,
          "75%": 1.18
        },
        "51630": {
          "name": "Fredericksburg",
          "median": 1.11,
          "10%": 0.92,
          "90%": 1.23,
          "25%": 1.02,
          "75%": 1.19
        },
        "42057": {
          "name": "Fulton",
          "median": 1.15,
          "10%": 0.99,
          "90%": 1.26,
          "25%": 1.03,
          "75%": 1.2
        },
        "51640": {
          "name": "Galax",
          "median": 1.1,
          "10%": 0.93,
          "90%": 1.25,
          "25%": 0.98,
          "75%": 1.2
        },
        "24023": {
          "name": "Garrett",
          "median": 1.07,
          "10%": 0.99,
          "90%": 1.15,
          "25%": 1.03,
          "75%": 1.11
        },
        "51071": {
          "name": "Giles",
          "median": 1.11,
          "10%": 0.98,
          "90%": 1.2,
          "25%": 1.03,
          "75%": 1.15
        },
        "54021": {
          "name": "Gilmer",
          "median": 1.09,
          "10%": 0.99,
          "90%": 1.2,
          "25%": 1.04,
          "75%": 1.15
        },
        "34015": {
          "name": "Gloucester",
          "median": 1.1,
          "10%": 0.98,
          "90%": 1.231,
          "25%": 1.04,
          "75%": 1.15
        },
        "51073": {
          "name": "Gloucester",
          "median": 1.05,
          "10%": 0.92,
          "90%": 1.17,
          "25%": 0.99,
          "75%": 1.12
        },
        "51075": {
          "name": "Goochland",
          "median": 1.09,
          "10%": 0.88,
          "90%": 1.41,
          "25%": 0.98,
          "75%": 1.21
        },
        "54023": {
          "name": "Grant",
          "median": 1.06,
          "10%": 0.99,
          "90%": 1.2,
          "25%": 1.02,
          "75%": 1.12
        },
        "51077": {
          "name": "Grayson",
          "median": 1.08,
          "10%": 1.0,
          "90%": 1.19,
          "25%": 1.05,
          "75%": 1.13
        },
        "54025": {
          "name": "Greenbrier",
          "median": 1.07,
          "10%": 1.0,
          "90%": 1.2,
          "25%": 1.02,
          "75%": 1.16
        },
        "36039": {
          "name": "Greene",
          "median": 1.12,
          "10%": 0.97,
          "90%": 1.22,
          "25%": 1.03,
          "75%": 1.18
        },
        "42059": {
          "name": "Greene",
          "median": 1.08,
          "10%": 1.03,
          "90%": 1.19,
          "25%": 1.05,
          "75%": 1.13
        },
        "51079": {
          "name": "Greene",
          "median": 1.1,
          "10%": 0.92,
          "90%": 1.27,
          "25%": 1.02,
          "75%": 1.2
        },
        "51081": {
          "name": "Greensville",
          "median": 1.05,
          "10%": 0.96,
          "90%": 1.19,
          "25%": 0.99,
          "75%": 1.13
        },
        "51083": {
          "name": "Halifax",
          "median": 1.13,
          "10%": 0.98,
          "90%": 1.21,
          "25%": 1.06,
          "75%": 1.17
        },
        "54027": {
          "name": "Hampshire",
          "median": 1.1,
          "10%": 0.97,
          "90%": 1.25,
          "25%": 1.03,
          "75%": 1.16
        },
        "51650": {
          "name": "Hampton",
          "median": 1.05,
          "10%": 0.95,
          "90%": 1.22,
          "25%": 0.98,
          "75%": 1.15
        },
        "54029": {
          "name": "Hancock",
          "median": 1.08,
          "10%": 0.97,
          "90%": 1.21,
          "25%": 1.03,
          "75%": 1.15
        },
        "51085": {
          "name": "Hanover",
          "median": 1.08,
          "10%": 0.96,
          "90%": 1.29,
          "25%": 1.02,
          "75%": 1.14
        },
        "54031": {
          "name": "Hardy",
          "median": 1.08,
          "10%": 0.98,
          "90%": 1.27,
          "25%": 1.02,
          "75%": 1.14
        },
        "24025": {
          "name": "Harford",
          "median": 1.07,
          "10%": 0.95,
          "90%": 1.21,
          "25%": 1.0,
          "75%": 1.12
        },
        "54033": {
          "name": "Harrison",
          "median": 1.07,
          "10%": 0.99,
          "90%": 1.16,
          "25%": 1.02,
          "75%": 1.12
        },
        "51660": {
          "name": "Harrisonburg",
          "median": 1.095,
          "10%": 0.95,
          "90%": 1.23,
          "25%": 1.0,
          "75%": 1.19
        },
        "51087": {
          "name": "Henrico",
          "median": 1.08,
          "10%": 0.95,
          "90%": 1.26,
          "25%": 1.01,
          "75%": 1.14
        },
        "51089": {
          "name": "Henry",
          "median": 1.12,
          "10%": 0.96,
          "90%": 1.23,
          "25%": 0.99,
          "75%": 1.17
        },
        "36043": {
          "name": "Herkimer",
          "median": 1.04,
          "10%": 0.93,
          "90%": 1.11,
          "25%": 0.98,
          "75%": 1.09
        },
        "51091": {
          "name": "Highland",
          "median": 1.09,
          "10%": 0.98,
          "90%": 1.21,
          "25%": 1.03,
          "75%": 1.16
        },
        "51670": {
          "name": "Hopewell",
          "median": 1.03,
          "10%": 0.9,
          "90%": 1.22,
          "25%": 0.97,
          "75%": 1.12
        },
        "24027": {
          "name": "Howard",
          "median": 1.08,
          "10%": 0.97,
          "90%": 1.19,
          "25%": 1.0,
          "75%": 1.15
        },
        "34019": {
          "name": "Hunterdon",
          "median": 1.09,
          "10%": 0.98,
          "90%": 1.25,
          "25%": 1.03,
          "75%": 1.14
        },
        "42061": {
          "name": "Huntingdon",
          "median": 1.12,
          "10%": 1.03,
          "90%": 1.21,
          "25%": 1.07,
          "75%": 1.16
        },
        "42063": {
          "name": "Indiana",
          "median": 1.06,
          "10%": 0.98,
          "90%": 1.15,
          "25%": 1.03,
          "75%": 1.1
        },
        "51093": {
          "name": "Isle of Wight",
          "median": 1.09,
          "10%": 0.96,
          "90%": 1.26,
          "25%": 1.02,
          "75%": 1.18
        },
        "54035": {
          "name": "Jackson",
          "median": 1.09,
          "10%": 1.01,
          "90%": 1.2,
          "25%": 1.04,
          "75%": 1.14
        },
        "51095": {
          "name": "James City",
          "median": 1.04,
          "10%": 0.91,
          "90%": 1.17,
          "25%": 0.99,
          "75%": 1.08
        },
        "42065": {
          "name": "Jefferson",
          "median": 1.08,
          "10%": 1.01,
          "90%": 1.17,
          "25%": 1.03,
          "75%": 1.12
        },
        "54037": {
          "name": "Jefferson",
          "median": 1.09,
          "10%": 0.95,
          "90%": 1.24,
          "25%": 1.02,
          "75%": 1.16
        },
        "42067": {
          "name": "Juniata",
          "median": 1.11,
          "10%": 1.0,
          "90%": 1.23,
          "25%": 1.04,
          "75%": 1.17
        },
        "54039": {
          "name": "Kanawha",
          "median": 1.04,
          "10%": 0.95,
          "90%": 1.16,
          "25%": 1.01,
          "75%": 1.09
        },
        "10001": {
          "name": "Kent",
          "median": 1.06,
          "10%": 0.96,
          "90%": 1.18,
          "25%": 1.01,
          "75%": 1.12
        },
        "24029": {
          "name": "Kent",
          "median": 1.07,
          "10%": 0.95,
          "90%": 1.24,
          "25%": 0.99,
          "75%": 1.13
        },
        "51099": {
          "name": "King George",
          "median": 1.06,
          "10%": 0.89,
          "90%": 1.231,
          "25%": 1.0,
          "75%": 1.15
        },
        "51101": {
          "name": "King William",
          "median": 1.04,
          "10%": 0.96,
          "90%": 1.19,
          "25%": 1.0,
          "75%": 1.11
        },
        "51097": {
          "name": "King and Queen",
          "median": 1.04,
          "10%": 0.93,
          "90%": 1.18,
          "25%": 0.99,
          "75%": 1.1
        },
        "42069": {
          "name": "Lackawanna",
          "median": 1.14,
          "10%": 0.99,
          "90%": 1.21,
          "25%": 1.07,
          "75%": 1.17
        },
        "42071": {
          "name": "Lancaster",
          "median": 1.1,
          "10%": 0.98,
          "90%": 1.23,
          "25%": 1.03,
          "75%": 1.15
        },
        "51103": {
          "name": "Lancaster",
          "median": 1.04,
          "10%": 0.9,
          "90%": 1.21,
          "25%": 0.98,
          "75%": 1.1
        },
        "42073": {
          "name": "Lawrence",
          "median": 1.05,
          "10%": 0.99,
          "90%": 1.15,
          "25%": 1.01,
          "75%": 1.11
        },
        "42075": {
          "name": "Lebanon",
          "median": 1.1,
          "10%": 0.98,
          "90%": 1.19,
          "25%": 1.02,
          "75%": 1.14
        },
        "51105": {
          "name": "Lee",
          "median": 1.09,
          "10%": 0.97,
          "90%": 1.22,
          "25%": 1.03,
          "75%": 1.15
        },
        "42077": {
          "name": "Lehigh",
          "median": 1.1,
          "10%": 0.99,
          "90%": 1.2,
          "25%": 1.05,
          "75%": 1.16
        },
        "54041": {
          "name": "Lewis",
          "median": 1.07,
          "10%": 1.0,
          "90%": 1.16,
          "25%": 1.03,
          "75%": 1.11
        },
        "51678": {
          "name": "Lexington",
          "median": 1.09,
          "10%": 0.98,
          "90%": 1.23,
          "25%": 1.02,
          "75%": 1.15
        },
        "54043": {
          "name": "Lincoln",
          "median": 1.06,
          "10%": 1.0,
          "90%": 1.17,
          "25%": 1.02,
          "75%": 1.11
        },
        "36051": {
          "name": "Livingston",
          "median": 1.09,
          "10%": 0.99,
          "90%": 1.24,
          "25%": 1.05,
          "75%": 1.15
        },
        "54045": {
          "name": "Logan",
          "median": 1.09,
          "10%": 1.0,
          "90%": 1.16,
          "25%": 1.05,
          "75%": 1.12
        },
        "51107": {
          "name": "Loudoun",
          "median": 1.1,
          "10%": 0.97,
          "90%": 1.23,
          "25%": 1.02,
          "75%": 1.17
        },
        "51109": {
          "name": "Louisa",
          "median": 1.08,
          "10%": 0.96,
          "90%": 1.28,
          "25%": 1.02,
          "75%": 1.19
        },
        "51111": {
          "name": "Lunenburg",
          "median": 1.11,
          "10%": 0.959,
          "90%": 1.23,
          "25%": 1.06,
          "75%": 1.16
        },
        "42079": {
          "name": "Luzerne",
          "median": 1.1,
          "10%": 1.02,
          "90%": 1.2,
          "25%": 1.06,
          "75%": 1.16
        },
        "42081": {
          "name": "Lycoming",
          "median": 1.1,
          "10%": 1.0,
          "90%": 1.21,
          "25%": 1.06,
          "75%": 1.17
        },
        "51680": {
          "name": "Lynchburg",
          "median": 1.11,
          "10%": 1.0,
          "90%": 1.2,
          "25%": 1.05,
          "75%": 1.15
        },
        "36053": {
          "name": "Madison",
          "median": 1.06,
          "10%": 0.96,
          "90%": 1.17,
          "25%": 1.01,
          "75%": 1.13
        },
        "51113": {
          "name": "Madison",
          "median": 1.09,
          "10%": 0.93,
          "90%": 1.28,
          "25%": 1.02,
          "75%": 1.16
        },
        "51683": {
          "name": "Manassas",
          "median": 1.04,
          "10%": 0.96,
          "90%": 1.22,
          "25%": 0.99,
          "75%": 1.12
        },
        "51685": {
          "name": "Manassas Park",
          "median": 1.03,
          "10%": 0.96,
          "90%": 1.22,
          "25%": 0.97,
          "75%": 1.11
        },
        "54049": {
          "name": "Marion",
          "median": 1.05,
          "10%": 0.96,
          "90%": 1.15,
          "25%": 1.0,
          "75%": 1.12
        },
        "54051": {
          "name": "Marshall",
          "median": 1.08,
          "10%": 1.0,
          "90%": 1.18,
          "25%": 1.04,
          "75%": 1.14
        },
        "51690": {
          "name": "Martinsville",
          "median": 1.12,
          "10%": 0.93,
          "90%": 1.23,
          "25%": 0.98,
          "75%": 1.17
        },
        "54053": {
          "name": "Mason",
          "median": 1.1,
          "10%": 1.0,
          "90%": 1.21,
          "25%": 1.05,
          "75%": 1.17
        },
        "51115": {
          "name": "Mathews",
          "median": 1.08,
          "10%": 0.91,
          "90%": 1.19,
          "25%": 0.98,
          "75%": 1.14
        },
        "54047": {
          "name": "McDowell",
          "median": 1.08,
          "10%": 0.99,
          "90%": 1.18,
          "25%": 1.04,
          "75%": 1.14
        },
        "42083": {
          "name": "McKean",
          "median": 1.08,
          "10%": 0.99,
          "90%": 1.15,
          "25%": 1.04,
          "75%": 1.11
        },
        "51117": {
          "name": "Mecklenburg",
          "median": 1.1,
          "10%": 0.98,
          "90%": 1.16,
          "25%": 1.04,
          "75%": 1.13
        },
        "34021": {
          "name": "Mercer",
          "median": 1.06,
          "10%": 0.96,
          "90%": 1.17,
          "25%": 1.01,
          "75%": 1.12
        },
        "42085": {
          "name": "Mercer",
          "median": 1.08,
          "10%": 1.0,
          "90%": 1.18,
          "25%": 1.04,
          "75%": 1.12
        },
        "54055": {
          "name": "Mercer",
          "median": 1.09,
          "10%": 0.99,
          "90%": 1.21,
          "25%": 1.04,
          "75%": 1.15
        },
        "51119": {
          "name": "Middlesex",
          "median": 1.04,
          "10%": 0.91,
          "90%": 1.2,
          "25%": 0.99,
          "75%": 1.1
        },
        "42087": {
          "name": "Mifflin",
          "median": 1.125,
          "10%": 1.02,
          "90%": 1.22,
          "25%": 1.08,
          "75%": 1.18
        },
        "54057": {
          "name": "Mineral",
          "median": 1.09,
          "10%": 0.99,
          "90%": 1.22,
          "25%": 1.05,
          "75%": 1.14
        },
        "54059": {
          "name": "Mingo",
          "median": 1.1,
          "10%": 1.02,
          "90%": 1.18,
          "25%": 1.04,
          "75%": 1.15
        },
        "34025": {
          "name": "Monmouth",
          "median": 1.07,
          "10%": 0.97,
          "90%": 1.2,
          "25%": 1.0,
          "75%": 1.12
        },
        "54061": {
          "name": "Monongalia",
          "median": 1.06,
          "10%": 0.99,
          "90%": 1.15,
          "25%": 1.01,
          "75%": 1.11
        },
        "42089": {
          "name": "Monroe",
          "median": 1.12,
          "10%": 1.01,
          "90%": 1.19,
          "25%": 1.06,
          "75%": 1.16
        },
        "54063": {
          "name": "Monroe",
          "median": 1.09,
          "10%": 0.97,
          "90%": 1.17,
          "25%": 1.02,
          "75%": 1.14
        },
        "24031": {
          "name": "Montgomery",
          "median": 1.09,
          "10%": 0.98,
          "90%": 1.15,
          "25%": 1.03,
          "75%": 1.12
        },
        "36057": {
          "name": "Montgomery",
          "median": 1.06,
          "10%": 0.999,
          "90%": 1.16,
          "25%": 1.02,
          "75%": 1.11
        },
        "42091": {
          "name": "Montgomery",
          "median": 1.09,
          "10%": 0.99,
          "90%": 1.18,
          "25%": 1.04,
          "75%": 1.14
        },
        "51121": {
          "name": "Montgomery",
          "median": 1.12,
          "10%": 1.0,
          "90%": 1.241,
          "25%": 1.07,
          "75%": 1.1725
        },
        "42093": {
          "name": "Montour",
          "median": 1.13,
          "10%": 1.0,
          "90%": 1.28,
          "25%": 1.06,
          "75%": 1.21
        },
        "54065": {
          "name": "Morgan",
          "median": 1.12,
          "10%": 0.94,
          "90%": 1.29,
          "25%": 1.03,
          "75%": 1.18
        },
        "34027": {
          "name": "Morris",
          "median": 1.12,
          "10%": 0.98,
          "90%": 1.28,
          "25%": 1.03,
          "75%": 1.18
        },
        "36059": {
          "name": "Nassau",
          "median": 1.09,
          "10%": 0.98,
          "90%": 1.201,
          "25%": 1.03,
          "75%": 1.15
        },
        "51125": {
          "name": "Nelson",
          "median": 1.11,
          "10%": 0.92,
          "90%": 1.37,
          "25%": 1.02,
          "75%": 1.23
        },
        "10003": {
          "name": "New Castle",
          "median": 1.12,
          "10%": 0.96,
          "90%": 1.25,
          "25%": 1.0,
          "75%": 1.2
        },
        "51127": {
          "name": "New Kent",
          "median": 1.05,
          "10%": 0.95,
          "90%": 1.19,
          "25%": 1.0,
          "75%": 1.09
        },
        "36061": {
          "name": "New York",
          "median": 1.07,
          "10%": 0.93,
          "90%": 1.18,
          "25%": 1.01,
          "75%": 1.13
        },
        "51700": {
          "name": "Newport News",
          "median": 1.06,
          "10%": 0.93,
          "90%": 1.21,
          "25%": 1.0,
          "75%": 1.14
        },
        "54067": {
          "name": "Nicholas",
          "median": 1.05,
          "10%": 0.97,
          "90%": 1.14,
          "25%": 1.0,
          "75%": 1.12
        },
        "51710": {
          "name": "Norfolk",
          "median": 1.06,
          "10%": 0.92,
          "90%": 1.36,
          "25%": 0.99,
          "75%": 1.15
        },
        "42095": {
          "name": "Northampton",
          "median": 1.1,
          "10%": 0.99,
          "90%": 1.18,
          "25%": 1.05,
          "75%": 1.14
        },
        "51131": {
          "name": "Northampton",
          "median": 1.07,
          "10%": 0.92,
          "90%": 1.2,
          "25%": 1.0,
          "75%": 1.15
        },
        "42097": {
          "name": "Northumberland",
          "median": 1.13,
          "10%": 0.99,
          "90%": 1.3,
          "25%": 1.07,
          "75%": 1.2
        },
        "51133": {
          "name": "Northumberland",
          "median": 1.04,
          "10%": 0.86,
          "90%": 1.27,
          "25%": 0.96,
          "75%": 1.11
        },
        "51720": {
          "name": "Norton",
          "median": 1.09,
          "10%": 0.96,
          "90%": 1.21,
          "25%": 1.01,
          "75%": 1.16
        },
        "51135": {
          "name": "Nottoway",
          "median": 1.095,
          "10%": 0.96,
          "90%": 1.22,
          "25%": 1.02,
          "75%": 1.17
        },
        "34029": {
          "name": "Ocean",
          "median": 1.07,
          "10%": 0.99,
          "90%": 1.18,
          "25%": 1.02,
          "75%": 1.14
        },
        "54069": {
          "name": "Ohio",
          "median": 1.09,
          "10%": 0.98,
          "90%": 1.21,
          "25%": 1.02,
          "75%": 1.14
        },
        "36065": {
          "name": "Oneida",
          "median": 1.07,
          "10%": 0.98,
          "90%": 1.17,
          "25%": 1.03,
          "75%": 1.14
        },
        "36067": {
          "name": "Onondaga",
          "median": 1.09,
          "10%": 0.98,
          "90%": 1.23,
          "25%": 1.02,
          "75%": 1.14
        },
        "36069": {
          "name": "Ontario",
          "median": 1.09,
          "10%": 0.99,
          "90%": 1.22,
          "25%": 1.03,
          "75%": 1.13
        },
        "36071": {
          "name": "Orange",
          "median": 1.08,
          "10%": 0.98,
          "90%": 1.2,
          "25%": 1.02,
          "75%": 1.14
        },
        "51137": {
          "name": "Orange",
          "median": 1.09,
          "10%": 0.94,
          "90%": 1.23,
          "25%": 1.03,
          "75%": 1.18
        },
        "36077": {
          "name": "Otsego",
          "median": 1.05,
          "10%": 0.98,
          "90%": 1.16,
          "25%": 1.02,
          "75%": 1.11
        },
        "51139": {
          "name": "Page",
          "median": 1.1,
          "10%": 0.98,
          "90%": 1.32,
          "25%": 1.0,
          "75%": 1.18
        },
        "51141": {
          "name": "Patrick",
          "median": 1.08,
          "10%": 0.99,
          "90%": 1.2,
          "25%": 1.03,
          "75%": 1.14
        },
        "54071": {
          "name": "Pendleton",
          "median": 1.1,
          "10%": 0.97,
          "90%": 1.33,
          "25%": 1.04,
          "75%": 1.1825
        },
        "42099": {
          "name": "Perry",
          "median": 1.12,
          "10%": 0.97,
          "90%": 1.27,
          "25%": 1.03,
          "75%": 1.2
        },
        "51730": {
          "name": "Petersburg",
          "median": 1.07,
          "10%": 0.88,
          "90%": 1.22,
          "25%": 0.99,
          "75%": 1.15
        },
        "42101": {
          "name": "Philadelphia",
          "median": 1.08,
          "10%": 0.98,
          "90%": 1.17,
          "25%": 1.03,
          "75%": 1.13
        },
        "42103": {
          "name": "Pike",
          "median": 1.1,
          "10%": 1.0,
          "90%": 1.21,
          "25%": 1.04,
          "75%": 1.15
        },
        "51143": {
          "name": "Pittsylvania",
          "median": 1.12,
          "10%": 1.0,
          "90%": 1.22,
          "25%": 1.07,
          "75%": 1.17
        },
        "54073": {
          "name": "Pleasants",
          "median": 1.06,
          "10%": 0.99,
          "90%": 1.18,
          "25%": 1.02,
          "75%": 1.12
        },
        "54075": {
          "name": "Pocahontas",
          "median": 1.06,
          "10%": 0.99,
          "90%": 1.22,
          "25%": 1.02,
          "75%": 1.14
        },
        "51735": {
          "name": "Poquoson",
          "median": 1.05,
          "10%": 0.94,
          "90%": 1.21,
          "25%": 0.98,
          "75%": 1.15
        },
        "51740": {
          "name": "Portsmouth",
          "median": 1.05,
          "10%": 0.93,
          "90%": 1.33,
          "25%": 0.99,
          "75%": 1.15
        },
        "42105": {
          "name": "Potter",
          "median": 1.09,
          "10%": 0.99,
          "90%": 1.19,
          "25%": 1.04,
          "75%": 1.15
        },
        "51145": {
          "name": "Powhatan",
          "median": 1.08,
          "10%": 0.87,
          "90%": 1.39,
          "25%": 0.98,
          "75%": 1.18
        },
        "54077": {
          "name": "Preston",
          "median": 1.05,
          "10%": 1.0,
          "90%": 1.18,
          "25%": 1.03,
          "75%": 1.12
        },
        "51147": {
          "name": "Prince Edward",
          "median": 1.08,
          "10%": 0.99,
          "90%": 1.23,
          "25%": 1.03,
          "75%": 1.1425
        },
        "51149": {
          "name": "Prince George",
          "median": 1.04,
          "10%": 0.92,
          "90%": 1.2,
          "25%": 0.97,
          "75%": 1.15
        },
        "24033": {
          "name": "Prince George's",
          "median": 1.06,
          "10%": 0.97,
          "90%": 1.18,
          "25%": 1.0,
          "75%": 1.14
        },
        "51153": {
          "name": "Prince William",
          "median": 1.05,
          "10%": 0.97,
          "90%": 1.19,
          "25%": 0.99,
          "75%": 1.12
        },
        "51155": {
          "name": "Pulaski",
          "median": 1.12,
          "10%": 1.02,
          "90%": 1.22,
          "25%": 1.06,
          "75%": 1.17
        },
        "54079": {
          "name": "Putnam",
          "median": 1.06,
          "10%": 0.98,
          "90%": 1.18,
          "25%": 1.02,
          "75%": 1.13
        },
        "24035": {
          "name": "Queen Anne's",
          "median": 1.05,
          "10%": 0.95,
          "90%": 1.24,
          "25%": 1.01,
          "75%": 1.12
        },
        "51750": {
          "name": "Radford",
          "median": 1.14,
          "10%": 0.99,
          "90%": 1.25,
          "25%": 1.06,
          "75%": 1.2
        },
        "54081": {
          "name": "Raleigh",
          "median": 1.09,
          "10%": 0.98,
          "90%": 1.2,
          "25%": 1.04,
          "75%": 1.14
        },
        "54083": {
          "name": "Randolph",
          "median": 1.07,
          "10%": 1.0,
          "90%": 1.15,
          "25%": 1.04,
          "75%": 1.1
        },
        "51157": {
          "name": "Rappahannock",
          "median": 1.09,
          "10%": 0.96,
          "90%": 1.27,
          "25%": 1.0,
          "75%": 1.13
        },
        "36085": {
          "name": "Richmond",
          "median": 1.05,
          "10%": 0.93,
          "90%": 1.23,
          "25%": 0.99,
          "75%": 1.13
        },
        "51159": {
          "name": "Richmond",
          "median": 1.01,
          "10%": 0.84,
          "90%": 1.34,
          "25%": 0.97,
          "75%": 1.13
        },
        "51760": {
          "name": "Richmond",
          "median": 1.09,
          "10%": 0.96,
          "90%": 1.24,
          "25%": 1.01,
          "75%": 1.14
        },
        "54085": {
          "name": "Ritchie",
          "median": 1.09,
          "10%": 1.01,
          "90%": 1.16,
          "25%": 1.04,
          "75%": 1.13
        },
        "54087": {
          "name": "Roane",
          "median": 1.07,
          "10%": 1.0,
          "90%": 1.21,
          "25%": 1.04,
          "75%": 1.13
        },
        "51161": {
          "name": "Roanoke",
          "median": 1.12,
          "10%": 1.01,
          "90%": 1.26,
          "25%": 1.03,
          "75%": 1.23
        },
        "51770": {
          "name": "Roanoke",
          "median": 1.14,
          "10%": 0.96,
          "90%": 1.29,
          "25%": 1.02,
          "75%": 1.22
        },
        "51163": {
          "name": "Rockbridge",
          "median": 1.12,
          "10%": 0.98,
          "90%": 1.27,
          "25%": 1.04,
          "75%": 1.22
        },
        "51165": {
          "name": "Rockingham",
          "median": 1.09,
          "10%": 0.96,
          "90%": 1.24,
          "25%": 1.01,
          "75%": 1.17
        },
        "51167": {
          "name": "Russell",
          "median": 1.05,
          "10%": 0.99,
          "90%": 1.18,
          "25%": 1.02,
          "75%": 1.1
        },
        "34033": {
          "name": "Salem",
          "median": 1.1,
          "10%": 0.97,
          "90%": 1.22,
          "25%": 1.0,
          "75%": 1.19
        },
        "51775": {
          "name": "Salem",
          "median": 1.12,
          "10%": 0.96,
          "90%": 1.31,
          "25%": 1.04,
          "75%": 1.23
        },
        "36095": {
          "name": "Schoharie",
          "median": 1.1,
          "10%": 0.97,
          "90%": 1.2,
          "25%": 1.03,
          "75%": 1.15
        },
        "36097": {
          "name": "Schuyler",
          "median": 1.11,
          "10%": 1.02,
          "90%": 1.23,
          "25%": 1.06,
          "75%": 1.19
        },
        "42107": {
          "name": "Schuylkill",
          "median": 1.11,
          "10%": 0.98,
          "90%": 1.23,
          "25%": 1.04,
          "75%": 1.18
        },
        "51169": {
          "name": "Scott",
          "median": 1.1,
          "10%": 0.99,
          "90%": 1.21,
          "25%": 1.03,
          "75%": 1.14
        },
        "51171": {
          "name": "Shenandoah",
          "median": 1.09,
          "10%": 0.97,
          "90%": 1.26,
          "25%": 1.02,
          "75%": 1.16
        },
        "51173": {
          "name": "Smyth",
          "median": 1.07,
          "10%": 1.0,
          "90%": 1.16,
          "25%": 1.03,
          "75%": 1.12
        },
        "42109": {
          "name": "Snyder",
          "median": 1.12,
          "10%": 1.0,
          "90%": 1.25,
          "25%": 1.06,
          "75%": 1.18
        },
        "24039": {
          "name": "Somerset",
          "median": 1.08,
          "10%": 0.99,
          "90%": 1.2,
          "25%": 1.03,
          "75%": 1.14
        },
        "42111": {
          "name": "Somerset",
          "median": 1.08,
          "10%": 1.01,
          "90%": 1.15,
          "25%": 1.04,
          "75%": 1.11
        },
        "51175": {
          "name": "Southampton",
          "median": 1.07,
          "10%": 0.95,
          "90%": 1.251,
          "25%": 1.03,
          "75%": 1.14
        },
        "51177": {
          "name": "Spotsylvania",
          "median": 1.07,
          "10%": 0.94,
          "90%": 1.2,
          "25%": 1.03,
          "75%": 1.14
        },
        "24037": {
          "name": "St. Mary's",
          "median": 1.06,
          "10%": 0.91,
          "90%": 1.2,
          "25%": 0.95,
          "75%": 1.12
        },
        "51179": {
          "name": "Stafford",
          "median": 1.1,
          "10%": 0.94,
          "90%": 1.24,
          "25%": 1.03,
          "75%": 1.17
        },
        "51790": {
          "name": "Staunton",
          "median": 1.09,
          "10%": 0.91,
          "90%": 1.37,
          "25%": 1.0,
          "75%": 1.2
        },
        "36101": {
          "name": "Steuben",
          "median": 1.08,
          "10%": 1.02,
          "90%": 1.2,
          "25%": 1.04,
          "75%": 1.16
        },
        "51800": {
          "name": "Suffolk",
          "median": 1.115,
          "10%": 0.95,
          "90%": 1.26,
          "25%": 1.03,
          "75%": 1.19
        },
        "36105": {
          "name": "Sullivan",
          "median": 1.08,
          "10%": 1.01,
          "90%": 1.2,
          "25%": 1.06,
          "75%": 1.15
        },
        "42113": {
          "name": "Sullivan",
          "median": 1.11,
          "10%": 0.96,
          "90%": 1.23,
          "25%": 1.04,
          "75%": 1.17
        },
        "54089": {
          "name": "Summers",
          "median": 1.07,
          "10%": 1.0,
          "90%": 1.17,
          "25%": 1.03,
          "75%": 1.13
        },
        "51181": {
          "name": "Surry",
          "median": 1.07,
          "10%": 0.93,
          "90%": 1.2,
          "25%": 1.01,
          "75%": 1.13
        },
        "42115": {
          "name": "Susquehanna",
          "median": 1.1,
          "10%": 1.02,
          "90%": 1.21,
          "25%": 1.06,
          "75%": 1.13
        },
        "10005": {
          "name": "Sussex",
          "median": 1.07,
          "10%": 0.96,
          "90%": 1.17,
          "25%": 1.02,
          "75%": 1.11
        },
        "34037": {
          "name": "Sussex",
          "median": 1.12,
          "10%": 0.98,
          "90%": 1.2,
          "25%": 1.05,
          "75%": 1.16
        },
        "51183": {
          "name": "Sussex",
          "median": 1.05,
          "10%": 0.98,
          "90%": 1.211,
          "25%": 1.0,
          "75%": 1.16
        },
        "24041": {
          "name": "Talbot",
          "median": 1.03,
          "10%": 0.93,
          "90%": 1.21,
          "25%": 0.96,
          "75%": 1.12
        },
        "54091": {
          "name": "Taylor",
          "median": 1.07,
          "10%": 1.0,
          "90%": 1.17,
          "25%": 1.04,
          "75%": 1.11
        },
        "51185": {
          "name": "Tazewell",
          "median": 1.07,
          "10%": 1.0,
          "90%": 1.16,
          "25%": 1.02,
          "75%": 1.11
        },
        "36107": {
          "name": "Tioga",
          "median": 1.09,
          "10%": 0.99,
          "90%": 1.2,
          "25%": 1.04,
          "75%": 1.14
        },
        "42117": {
          "name": "Tioga",
          "median": 1.1,
          "10%": 0.99,
          "90%": 1.2,
          "25%": 1.04,
          "75%": 1.15
        },
        "36109": {
          "name": "Tompkins",
          "median": 1.09,
          "10%": 1.01,
          "90%": 1.2,
          "25%": 1.04,
          "75%": 1.16
        },
        "54093": {
          "name": "Tucker",
          "median": 1.07,
          "10%": 0.98,
          "90%": 1.16,
          "25%": 1.01,
          "75%": 1.1
        },
        "54095": {
          "name": "Tyler",
          "median": 1.04,
          "10%": 0.95,
          "90%": 1.14,
          "25%": 1.0,
          "75%": 1.09
        },
        "36111": {
          "name": "Ulster",
          "median": 1.1,
          "10%": 1.01,
          "90%": 1.29,
          "25%": 1.05,
          "75%": 1.17
        },
        "42119": {
          "name": "Union",
          "median": 1.12,
          "10%": 0.98,
          "90%": 1.21,
          "25%": 1.06,
          "75%": 1.17
        },
        "54097": {
          "name": "Upshur",
          "median": 1.06,
          "10%": 0.98,
          "90%": 1.14,
          "25%": 1.01,
          "75%": 1.11
        },
        "42121": {
          "name": "Venango",
          "median": 1.07,
          "10%": 1.02,
          "90%": 1.14,
          "25%": 1.04,
          "75%": 1.1
        },
        "51810": {
          "name": "Virginia Beach",
          "median": 1.09,
          "10%": 0.94,
          "90%": 1.34,
          "25%": 1.0,
          "75%": 1.15
        },
        "34041": {
          "name": "Warren",
          "median": 1.11,
          "10%": 0.99,
          "90%": 1.25,
          "25%": 1.04,
          "75%": 1.18
        },
        "42123": {
          "name": "Warren",
          "median": 1.06,
          "10%": 1.01,
          "90%": 1.18,
          "25%": 1.03,
          "75%": 1.11
        },
        "51187": {
          "name": "Warren",
          "median": 1.1,
          "10%": 0.97,
          "90%": 1.28,
          "25%": 1.03,
          "75%": 1.2
        },
        "24043": {
          "name": "Washington",
          "median": 1.11,
          "10%": 0.98,
          "90%": 1.23,
          "25%": 1.02,
          "75%": 1.17
        },
        "42125": {
          "name": "Washington",
          "median": 1.08,
          "10%": 1.0,
          "90%": 1.18,
          "25%": 1.04,
          "75%": 1.12
        },
        "51191": {
          "name": "Washington",
          "median": 1.06,
          "10%": 0.98,
          "90%": 1.15,
          "25%": 1.01,
          "75%": 1.11
        },
        "42127": {
          "name": "Wayne",
          "median": 1.11,
          "10%": 1.01,
          "90%": 1.22,
          "25%": 1.05,
          "75%": 1.15
        },
        "54099": {
          "name": "Wayne",
          "median": 1.07,
          "10%": 1.0,
          "90%": 1.2,
          "25%": 1.03,
          "75%": 1.13
        },
        "51820": {
          "name": "Waynesboro",
          "median": 1.12,
          "10%": 0.9,
          "90%": 1.35,
          "25%": 1.02,
          "75%": 1.22
        },
        "54101": {
          "name": "Webster",
          "median": 1.04,
          "10%": 0.98,
          "90%": 1.16,
          "25%": 1.0,
          "75%": 1.1
        },
        "36119": {
          "name": "Westchester",
          "median": 1.07,
          "10%": 0.97,
          "90%": 1.2,
          "25%": 1.0,
          "75%": 1.15
        },
        "42129": {
          "name": "Westmoreland",
          "median": 1.06,
          "10%": 0.99,
          "90%": 1.13,
          "25%": 1.01,
          "75%": 1.1
        },
        "51193": {
          "name": "Westmoreland",
          "median": 1.04,
          "10%": 0.86,
          "90%": 1.27,
          "25%": 0.95,
          "75%": 1.09
        },
        "54103": {
          "name": "Wetzel",
          "median": 1.08,
          "10%": 1.0,
          "90%": 1.16,
          "25%": 1.03,
          "75%": 1.11
        },
        "24045": {
          "name": "Wicomico",
          "median": 1.06,
          "10%": 0.97,
          "90%": 1.14,
          "25%": 1.02,
          "75%": 1.11
        },
        "51830": {
          "name": "Williamsburg",
          "median": 1.03,
          "10%": 0.9,
          "90%": 1.14,
          "25%": 0.97,
          "75%": 1.08
        },
        "51840": {
          "name": "Winchester",
          "median": 1.1,
          "10%": 0.95,
          "90%": 1.26,
          "25%": 1.04,
          "75%": 1.16
        },
        "54105": {
          "name": "Wirt",
          "median": 1.11,
          "10%": 1.01,
          "90%": 1.19,
          "25%": 1.07,
          "75%": 1.16
        },
        "51195": {
          "name": "Wise",
          "median": 1.08,
          "10%": 0.98,
          "90%": 1.19,
          "25%": 1.02,
          "75%": 1.15
        },
        "54107": {
          "name": "Wood",
          "median": 1.08,
          "10%": 1.0,
          "90%": 1.21,
          "25%": 1.04,
          "75%": 1.12
        },
        "24047": {
          "name": "Worcester",
          "median": 1.06,
          "10%": 0.95,
          "90%": 1.22,
          "25%": 0.99,
          "75%": 1.14
        },
        "42131": {
          "name": "Wyoming",
          "median": 1.1,
          "10%": 1.02,
          "90%": 1.23,
          "25%": 1.06,
          "75%": 1.15
        },
        "54109": {
          "name": "Wyoming",
          "median": 1.11,
          "10%": 0.97,
          "90%": 1.18,
          "25%": 1.06,
          "75%": 1.14
        },
        "51197": {
          "name": "Wythe",
          "median": 1.07,
          "10%": 1.01,
          "90%": 1.18,
          "25%": 1.04,
          "75%": 1.13
        },
        "36123": {
          "name": "Yates",
          "median": 1.11,
          "10%": 0.99,
          "90%": 1.24,
          "25%": 1.04,
          "75%": 1.18
        },
        "42133": {
          "name": "York",
          "median": 1.11,
          "10%": 0.97,
          "90%": 1.23,
          "25%": 1.01,
          "75%": 1.18
        },
        "51199": {
          "name": "York",
          "median": 1.04,
          "10%": 0.93,
          "90%": 1.171,
          "25%": 0.98,
          "75%": 1.11
        },
        "max": 1.15,
        "min": 1
      },
      "25": {
        "51001": {
          "name": "Accomack",
          "median": 1.07,
          "10%": 0.89,
          "90%": 1.26,
          "25%": 1.01,
          "75%": 1.16
        },
        "42001": {
          "name": "Adams",
          "median": 1.08,
          "10%": 0.86,
          "90%": 1.34,
          "25%": 0.97,
          "75%": 1.19
        },
        "51003": {
          "name": "Albemarle",
          "median": 1.12,
          "10%": 0.89,
          "90%": 1.33,
          "25%": 1.03,
          "75%": 1.21
        },
        "51510": {
          "name": "Alexandria",
          "median": 1.05,
          "10%": 0.89,
          "90%": 1.25,
          "25%": 0.95,
          "75%": 1.17
        },
        "24001": {
          "name": "Allegany",
          "median": 1.1,
          "10%": 0.97,
          "90%": 1.29,
          "25%": 1.04,
          "75%": 1.19
        },
        "36003": {
          "name": "Allegany",
          "median": 1.07,
          "10%": 0.95,
          "90%": 1.26,
          "25%": 1.02,
          "75%": 1.16
        },
        "51005": {
          "name": "Alleghany",
          "median": 1.11,
          "10%": 0.98,
          "90%": 1.35,
          "25%": 1.05,
          "75%": 1.24
        },
        "42003": {
          "name": "Allegheny",
          "median": 1.07,
          "10%": 0.96,
          "90%": 1.19,
          "25%": 1.02,
          "75%": 1.13
        },
        "51007": {
          "name": "Amelia",
          "median": 1.1,
          "10%": 0.92,
          "90%": 1.39,
          "25%": 0.99,
          "75%": 1.29
        },
        "51009": {
          "name": "Amherst",
          "median": 1.12,
          "10%": 0.96,
          "90%": 1.32,
          "25%": 1.02,
          "75%": 1.21
        },
        "24003": {
          "name": "Anne Arundel",
          "median": 1.05,
          "10%": 0.91,
          "90%": 1.22,
          "25%": 0.98,
          "75%": 1.14
        },
        "51011": {
          "name": "Appomattox",
          "median": 1.11,
          "10%": 0.94,
          "90%": 1.32,
          "25%": 1.01,
          "75%": 1.2125
        },
        "51013": {
          "name": "Arlington",
          "median": 1.05,
          "10%": 0.9,
          "90%": 1.24,
          "25%": 0.97,
          "75%": 1.15
        },
        "42005": {
          "name": "Armstrong",
          "median": 1.07,
          "10%": 0.98,
          "90%": 1.19,
          "25%": 1.02,
          "75%": 1.13
        },
        "34001": {
          "name": "Atlantic",
          "median": 1.11,
          "10%": 0.94,
          "90%": 1.26,
          "25%": 1.05,
          "75%": 1.19
        },
        "51015": {
          "name": "Augusta",
          "median": 1.12,
          "10%": 0.91,
          "90%": 1.34,
          "25%": 0.99,
          "75%": 1.21
        },
        "24005": {
          "name": "Baltimore",
          "median": 1.08,
          "10%": 0.92,
          "90%": 1.26,
          "25%": 1.01,
          "75%": 1.16
        },
        "24510": {
          "name": "Baltimore",
          "median": 1.07,
          "10%": 0.9,
          "90%": 1.27,
          "25%": 0.96,
          "75%": 1.17
        },
        "54001": {
          "name": "Barbour",
          "median": 1.06,
          "10%": 0.97,
          "90%": 1.19,
          "25%": 1.01,
          "75%": 1.12
        },
        "51017": {
          "name": "Bath",
          "median": 1.11,
          "10%": 0.98,
          "90%": 1.33,
          "25%": 1.0475,
          "75%": 1.23
        },
        "42007": {
          "name": "Beaver",
          "median": 1.06,
          "10%": 0.95,
          "90%": 1.17,
          "25%": 1.0,
          "75%": 1.13
        },
        "42009": {
          "name": "Bedford",
          "median": 1.16,
          "10%": 0.97,
          "90%": 1.27,
          "25%": 1.06,
          "75%": 1.2
        },
        "51019": {
          "name": "Bedford",
          "median": 1.13,
          "10%": 0.98,
          "90%": 1.25,
          "25%": 1.06,
          "75%": 1.19
        },
        "54003": {
          "name": "Berkeley",
          "median": 1.12,
          "10%": 0.93,
          "90%": 1.27,
          "25%": 1.01,
          "75%": 1.17
        },
        "42011": {
          "name": "Berks",
          "median": 1.1,
          "10%": 0.98,
          "90%": 1.24,
          "25%": 1.03,
          "75%": 1.18
        },
        "42013": {
          "name": "Blair",
          "median": 1.14,
          "10%": 1.02,
          "90%": 1.22,
          "25%": 1.05,
          "75%": 1.18
        },
        "51021": {
          "name": "Bland",
          "median": 1.1,
          "10%": 0.98,
          "90%": 1.23,
          "25%": 1.02,
          "75%": 1.17
        },
        "54005": {
          "name": "Boone",
          "median": 1.08,
          "10%": 1.0,
          "90%": 1.2,
          "25%": 1.04,
          "75%": 1.14
        },
        "51023": {
          "name": "Botetourt",
          "median": 1.15,
          "10%": 0.98,
          "90%": 1.32,
          "25%": 1.03,
          "75%": 1.23
        },
        "42015": {
          "name": "Bradford",
          "median": 1.13,
          "10%": 0.97,
          "90%": 1.28,
          "25%": 1.03,
          "75%": 1.19
        },
        "54007": {
          "name": "Braxton",
          "median": 1.06,
          "10%": 0.96,
          "90%": 1.23,
          "25%": 1.0,
          "75%": 1.14
        },
        "51520": {
          "name": "Bristol",
          "median": 1.08,
          "10%": 0.98,
          "90%": 1.2,
          "25%": 1.02,
          "75%": 1.14
        },
        "36005": {
          "name": "Bronx",
          "median": 1.04,
          "10%": 0.94,
          "90%": 1.23,
          "25%": 0.99,
          "75%": 1.12
        },
        "54009": {
          "name": "Brooke",
          "median": 1.09,
          "10%": 0.96,
          "90%": 1.3,
          "25%": 1.02,
          "75%": 1.2
        },
        "36007": {
          "name": "Broome",
          "median": 1.11,
          "10%": 1.03,
          "90%": 1.19,
          "25%": 1.06,
          "75%": 1.15
        },
        "51025": {
          "name": "Brunswick",
          "median": 1.08,
          "10%": 0.93,
          "90%": 1.29,
          "25%": 1.01,
          "75%": 1.21
        },
        "51027": {
          "name": "Buchanan",
          "median": 1.06,
          "10%": 1.0,
          "90%": 1.15,
          "25%": 1.02,
          "75%": 1.12
        },
        "51029": {
          "name": "Buckingham",
          "median": 1.11,
          "10%": 0.92,
          "90%": 1.26,
          "25%": 1.01,
          "75%": 1.18
        },
        "42017": {
          "name": "Bucks",
          "median": 1.07,
          "10%": 0.97,
          "90%": 1.19,
          "25%": 1.02,
          "75%": 1.14
        },
        "51530": {
          "name": "Buena Vista",
          "median": 1.11,
          "10%": 0.92,
          "90%": 1.33,
          "25%": 1.03,
          "75%": 1.22
        },
        "34005": {
          "name": "Burlington",
          "median": 1.07,
          "10%": 0.97,
          "90%": 1.2,
          "25%": 1.01,
          "75%": 1.16
        },
        "42019": {
          "name": "Butler",
          "median": 1.06,
          "10%": 0.98,
          "90%": 1.14,
          "25%": 1.02,
          "75%": 1.1
        },
        "54011": {
          "name": "Cabell",
          "median": 1.05,
          "10%": 0.97,
          "90%": 1.19,
          "25%": 1.0,
          "75%": 1.14
        },
        "54013": {
          "name": "Calhoun",
          "median": 1.12,
          "10%": 0.96,
          "90%": 1.24,
          "25%": 1.04,
          "75%": 1.17
        },
        "24009": {
          "name": "Calvert",
          "median": 1.05,
          "10%": 0.91,
          "90%": 1.23,
          "25%": 0.97,
          "75%": 1.14
        },
        "42021": {
          "name": "Cambria",
          "median": 1.07,
          "10%": 0.96,
          "90%": 1.17,
          "25%": 1.01,
          "75%": 1.14
        },
        "34007": {
          "name": "Camden",
          "median": 1.08,
          "10%": 0.99,
          "90%": 1.24,
          "25%": 1.03,
          "75%": 1.16
        },
        "42023": {
          "name": "Cameron",
          "median": 1.1,
          "10%": 0.98,
          "90%": 1.19,
          "25%": 1.03,
          "75%": 1.16
        },
        "51031": {
          "name": "Campbell",
          "median": 1.11,
          "10%": 0.94,
          "90%": 1.25,
          "25%": 1.06,
          "75%": 1.2
        },
        "34009": {
          "name": "Cape May",
          "median": 1.13,
          "10%": 0.98,
          "90%": 1.24,
          "25%": 1.05,
          "75%": 1.17
        },
        "42025": {
          "name": "Carbon",
          "median": 1.09,
          "10%": 1.0,
          "90%": 1.23,
          "25%": 1.05,
          "75%": 1.15
        },
        "24011": {
          "name": "Caroline",
          "median": 1.07,
          "10%": 0.92,
          "90%": 1.29,
          "25%": 0.99,
          "75%": 1.16
        },
        "51033": {
          "name": "Caroline",
          "median": 1.04,
          "10%": 0.89,
          "90%": 1.26,
          "25%": 0.98,
          "75%": 1.16
        },
        "24013": {
          "name": "Carroll",
          "median": 1.12,
          "10%": 0.96,
          "90%": 1.28,
          "25%": 1.03,
          "75%": 1.22
        },
        "51035": {
          "name": "Carroll",
          "median": 1.09,
          "10%": 1.01,
          "90%": 1.2,
          "25%": 1.05,
          "75%": 1.15
        },
        "24015": {
          "name": "Cecil",
          "median": 1.08,
          "10%": 0.97,
          "90%": 1.191,
          "25%": 1.0,
          "75%": 1.13
        },
        "42027": {
          "name": "Centre",
          "median": 1.11,
          "10%": 1.0,
          "90%": 1.23,
          "25%": 1.07,
          "75%": 1.17
        },
        "24017": {
          "name": "Charles",
          "median": 1.1,
          "10%": 0.88,
          "90%": 1.32,
          "25%": 0.96,
          "75%": 1.22
        },
        "51036": {
          "name": "Charles City",
          "median": 1.04,
          "10%": 0.91,
          "90%": 1.19,
          "25%": 0.96,
          "75%": 1.11
        },
        "51037": {
          "name": "Charlotte",
          "median": 1.11,
          "10%": 0.96,
          "90%": 1.24,
          "25%": 1.03,
          "75%": 1.18
        },
        "51540": {
          "name": "Charlottesville",
          "median": 1.11,
          "10%": 0.91,
          "90%": 1.3,
          "25%": 1.01,
          "75%": 1.22
        },
        "36015": {
          "name": "Chemung",
          "median": 1.1,
          "10%": 1.0,
          "90%": 1.22,
          "25%": 1.04,
          "75%": 1.16
        },
        "36017": {
          "name": "Chenango",
          "median": 1.06,
          "10%": 0.98,
          "90%": 1.21,
          "25%": 1.02,
          "75%": 1.16
        },
        "51550": {
          "name": "Chesapeake",
          "median": 1.09,
          "10%": 0.919,
          "90%": 1.33,
          "25%": 0.99,
          "75%": 1.21
        },
        "42029": {
          "name": "Chester",
          "median": 1.12,
          "10%": 0.949,
          "90%": 1.22,
          "25%": 1.03,
          "75%": 1.17
        },
        "51041": {
          "name": "Chesterfield",
          "median": 1.08,
          "10%": 0.93,
          "90%": 1.36,
          "25%": 1.0,
          "75%": 1.2
        },
        "42031": {
          "name": "Clarion",
          "median": 1.08,
          "10%": 0.96,
          "90%": 1.2,
          "25%": 1.05,
          "75%": 1.14
        },
        "51043": {
          "name": "Clarke",
          "median": 1.08,
          "10%": 0.91,
          "90%": 1.25,
          "25%": 0.99,
          "75%": 1.17
        },
        "54015": {
          "name": "Clay",
          "median": 1.03,
          "10%": 0.97,
          "90%": 1.17,
          "25%": 1.0,
          "75%": 1.1
        },
        "42033": {
          "name": "Clearfield",
          "median": 1.09,
          "10%": 1.03,
          "90%": 1.19,
          "25%": 1.05,
          "75%": 1.14
        },
        "42035": {
          "name": "Clinton",
          "median": 1.11,
          "10%": 0.97,
          "90%": 1.23,
          "25%": 1.05,
          "75%": 1.19
        },
        "51570": {
          "name": "Colonial Heights",
          "median": 1.08,
          "10%": 0.88,
          "90%": 1.29,
          "25%": 0.96,
          "75%": 1.18
        },
        "42037": {
          "name": "Columbia",
          "median": 1.13,
          "10%": 0.98,
          "90%": 1.28,
          "25%": 1.06,
          "75%": 1.22
        },
        "36023": {
          "name": "Cortland",
          "median": 1.1,
          "10%": 0.98,
          "90%": 1.25,
          "25%": 1.03,
          "75%": 1.16
        },
        "51580": {
          "name": "Covington",
          "median": 1.1,
          "10%": 0.96,
          "90%": 1.33,
          "25%": 1.03,
          "75%": 1.19
        },
        "51045": {
          "name": "Craig",
          "median": 1.13,
          "10%": 0.96,
          "90%": 1.26,
          "25%": 1.01,
          "75%": 1.19
        },
        "42039": {
          "name": "Crawford",
          "median": 1.07,
          "10%": 0.99,
          "90%": 1.2,
          "25%": 1.03,
          "75%": 1.15
        },
        "51047": {
          "name": "Culpeper",
          "median": 1.08,
          "10%": 0.96,
          "90%": 1.2,
          "25%": 0.99,
          "75%": 1.15
        },
        "34011": {
          "name": "Cumberland",
          "median": 1.09,
          "10%": 0.95,
          "90%": 1.23,
          "25%": 1.01,
          "75%": 1.14
        },
        "42041": {
          "name": "Cumberland",
          "median": 1.13,
          "10%": 0.93,
          "90%": 1.34,
          "25%": 1.0,
          "75%": 1.23
        },
        "51049": {
          "name": "Cumberland",
          "median": 1.05,
          "10%": 0.92,
          "90%": 1.32,
          "25%": 0.99,
          "75%": 1.19
        },
        "51590": {
          "name": "Danville",
          "median": 1.12,
          "10%": 0.96,
          "90%": 1.25,
          "25%": 1.01,
          "75%": 1.18
        },
        "42043": {
          "name": "Dauphin",
          "median": 1.15,
          "10%": 0.91,
          "90%": 1.37,
          "25%": 1.05,
          "75%": 1.25
        },
        "36025": {
          "name": "Delaware",
          "median": 1.09,
          "10%": 0.98,
          "90%": 1.24,
          "25%": 1.04,
          "75%": 1.17
        },
        "42045": {
          "name": "Delaware",
          "median": 1.1,
          "10%": 0.95,
          "90%": 1.31,
          "25%": 1.02,
          "75%": 1.22
        },
        "51051": {
          "name": "Dickenson",
          "median": 1.07,
          "10%": 0.98,
          "90%": 1.17,
          "25%": 1.01,
          "75%": 1.13
        },
        "51053": {
          "name": "Dinwiddie",
          "median": 1.09,
          "10%": 0.94,
          "90%": 1.26,
          "25%": 1.02,
          "75%": 1.17
        },
        "11001": {
          "name": "District of Columbia",
          "median": 1.08,
          "10%": 0.93,
          "90%": 1.24,
          "25%": 0.97,
          "75%": 1.16
        },
        "54017": {
          "name": "Doddridge",
          "median": 1.05,
          "10%": 0.94,
          "90%": 1.18,
          "25%": 0.98,
          "75%": 1.12
        },
        "24019": {
          "name": "Dorchester",
          "median": 1.05,
          "10%": 0.87,
          "90%": 1.2,
          "25%": 0.97,
          "75%": 1.12
        },
        "42047": {
          "name": "Elk",
          "median": 1.07,
          "10%": 0.98,
          "90%": 1.14,
          "25%": 1.02,
          "75%": 1.1
        },
        "51595": {
          "name": "Emporia",
          "median": 1.03,
          "10%": 0.92,
          "90%": 1.26,
          "25%": 0.98,
          "75%": 1.16
        },
        "42049": {
          "name": "Erie",
          "median": 1.09,
          "10%": 0.98,
          "90%": 1.2,
          "25%": 1.01,
          "75%": 1.15
        },
        "51057": {
          "name": "Essex",
          "median": 1.02,
          "10%": 0.86,
          "90%": 1.29,
          "25%": 0.94,
          "75%": 1.08
        },
        "51059": {
          "name": "Fairfax",
          "median": 1.05,
          "10%": 0.93,
          "90%": 1.21,
          "25%": 0.98,
          "75%": 1.13
        },
        "51600": {
          "name": "Fairfax",
          "median": 1.04,
          "10%": 0.91,
          "90%": 1.22,
          "25%": 0.97,
          "75%": 1.11
        },
        "51610": {
          "name": "Falls Church",
          "median": 1.05,
          "10%": 0.92,
          "90%": 1.25,
          "25%": 0.98,
          "75%": 1.15
        },
        "51061": {
          "name": "Fauquier",
          "median": 1.105,
          "10%": 0.93,
          "90%": 1.24,
          "25%": 0.98,
          "75%": 1.16
        },
        "42051": {
          "name": "Fayette",
          "median": 1.08,
          "10%": 0.98,
          "90%": 1.23,
          "25%": 1.03,
          "75%": 1.14
        },
        "54019": {
          "name": "Fayette",
          "median": 1.07,
          "10%": 0.92,
          "90%": 1.2,
          "25%": 1.01,
          "75%": 1.14
        },
        "51063": {
          "name": "Floyd",
          "median": 1.1,
          "10%": 0.97,
          "90%": 1.21,
          "25%": 1.05,
          "75%": 1.16
        },
        "51065": {
          "name": "Fluvanna",
          "median": 1.12,
          "10%": 0.88,
          "90%": 1.43,
          "25%": 0.96,
          "75%": 1.25
        },
        "42053": {
          "name": "Forest",
          "median": 1.05,
          "10%": 0.99,
          "90%": 1.17,
          "25%": 1.02,
          "75%": 1.11
        },
        "42055": {
          "name": "Franklin",
          "median": 1.13,
          "10%": 0.99,
          "90%": 1.23,
          "25%": 1.07,
          "75%": 1.19
        },
        "51067": {
          "name": "Franklin",
          "median": 1.13,
          "10%": 0.96,
          "90%": 1.27,
          "25%": 1.0275,
          "75%": 1.21
        },
        "51620": {
          "name": "Franklin",
          "median": 1.13,
          "10%": 0.9,
          "90%": 1.32,
          "25%": 1.02,
          "75%": 1.21
        },
        "24021": {
          "name": "Frederick",
          "median": 1.12,
          "10%": 0.93,
          "90%": 1.25,
          "25%": 1.02,
          "75%": 1.18
        },
        "51069": {
          "name": "Frederick",
          "median": 1.11,
          "10%": 0.93,
          "90%": 1.29,
          "25%": 1.02,
          "75%": 1.2
        },
        "51630": {
          "name": "Fredericksburg",
          "median": 1.11,
          "10%": 0.88,
          "90%": 1.26,
          "25%": 1.0,
          "75%": 1.22
        },
        "42057": {
          "name": "Fulton",
          "median": 1.17,
          "10%": 0.95,
          "90%": 1.27,
          "25%": 1.03,
          "75%": 1.23
        },
        "51640": {
          "name": "Galax",
          "median": 1.09,
          "10%": 0.9,
          "90%": 1.28,
          "25%": 0.96,
          "75%": 1.18
        },
        "24023": {
          "name": "Garrett",
          "median": 1.07,
          "10%": 0.99,
          "90%": 1.21,
          "25%": 1.02,
          "75%": 1.14
        },
        "51071": {
          "name": "Giles",
          "median": 1.11,
          "10%": 0.96,
          "90%": 1.23,
          "25%": 1.04,
          "75%": 1.17
        },
        "54021": {
          "name": "Gilmer",
          "median": 1.08,
          "10%": 0.95,
          "90%": 1.24,
          "25%": 1.02,
          "75%": 1.17
        },
        "34015": {
          "name": "Gloucester",
          "median": 1.11,
          "10%": 0.979,
          "90%": 1.25,
          "25%": 1.03,
          "75%": 1.18
        },
        "51073": {
          "name": "Gloucester",
          "median": 1.03,
          "10%": 0.86,
          "90%": 1.24,
          "25%": 0.95,
          "75%": 1.12
        },
        "51075": {
          "name": "Goochland",
          "median": 1.09,
          "10%": 0.84,
          "90%": 1.461,
          "25%": 0.95,
          "75%": 1.26
        },
        "54023": {
          "name": "Grant",
          "median": 1.08,
          "10%": 0.97,
          "90%": 1.23,
          "25%": 1.03,
          "75%": 1.15
        },
        "51077": {
          "name": "Grayson",
          "median": 1.08,
          "10%": 1.0,
          "90%": 1.221,
          "25%": 1.04,
          "75%": 1.14
        },
        "54025": {
          "name": "Greenbrier",
          "median": 1.07,
          "10%": 0.96,
          "90%": 1.25,
          "25%": 1.01,
          "75%": 1.17
        },
        "36039": {
          "name": "Greene",
          "median": 1.13,
          "10%": 0.94,
          "90%": 1.27,
          "25%": 1.05,
          "75%": 1.2
        },
        "42059": {
          "name": "Greene",
          "median": 1.1,
          "10%": 1.01,
          "90%": 1.22,
          "25%": 1.05,
          "75%": 1.14
        },
        "51079": {
          "name": "Greene",
          "median": 1.11,
          "10%": 0.879,
          "90%": 1.31,
          "25%": 1.02,
          "75%": 1.25
        },
        "51081": {
          "name": "Greensville",
          "median": 1.04,
          "10%": 0.94,
          "90%": 1.23,
          "25%": 0.98,
          "75%": 1.17
        },
        "51083": {
          "name": "Halifax",
          "median": 1.14,
          "10%": 0.97,
          "90%": 1.24,
          "25%": 1.04,
          "75%": 1.19
        },
        "54027": {
          "name": "Hampshire",
          "median": 1.11,
          "10%": 0.96,
          "90%": 1.31,
          "25%": 1.03,
          "75%": 1.19
        },
        "51650": {
          "name": "Hampton",
          "median": 1.05,
          "10%": 0.9,
          "90%": 1.3,
          "25%": 0.98,
          "75%": 1.17
        },
        "54029": {
          "name": "Hancock",
          "median": 1.07,
          "10%": 0.94,
          "90%": 1.24,
          "25%": 1.01,
          "75%": 1.17
        },
        "51085": {
          "name": "Hanover",
          "median": 1.08,
          "10%": 0.94,
          "90%": 1.28,
          "25%": 1.0,
          "75%": 1.17
        },
        "54031": {
          "name": "Hardy",
          "median": 1.09,
          "10%": 0.95,
          "90%": 1.32,
          "25%": 1.03,
          "75%": 1.16
        },
        "24025": {
          "name": "Harford",
          "median": 1.07,
          "10%": 0.91,
          "90%": 1.25,
          "25%": 0.98,
          "75%": 1.14
        },
        "54033": {
          "name": "Harrison",
          "median": 1.07,
          "10%": 0.97,
          "90%": 1.2,
          "25%": 1.01,
          "75%": 1.12
        },
        "51660": {
          "name": "Harrisonburg",
          "median": 1.09,
          "10%": 0.89,
          "90%": 1.31,
          "25%": 0.98,
          "75%": 1.23
        },
        "51087": {
          "name": "Henrico",
          "median": 1.09,
          "10%": 0.93,
          "90%": 1.28,
          "25%": 0.99,
          "75%": 1.16
        },
        "51089": {
          "name": "Henry",
          "median": 1.13,
          "10%": 0.93,
          "90%": 1.3,
          "25%": 0.98,
          "75%": 1.2
        },
        "36043": {
          "name": "Herkimer",
          "median": 1.04,
          "10%": 0.9,
          "90%": 1.13,
          "25%": 0.96,
          "75%": 1.1
        },
        "51091": {
          "name": "Highland",
          "median": 1.08,
          "10%": 0.96,
          "90%": 1.24,
          "25%": 1.01,
          "75%": 1.17
        },
        "51670": {
          "name": "Hopewell",
          "median": 1.03,
          "10%": 0.9,
          "90%": 1.25,
          "25%": 0.97,
          "75%": 1.14
        },
        "24027": {
          "name": "Howard",
          "median": 1.1,
          "10%": 0.93,
          "90%": 1.21,
          "25%": 0.98,
          "75%": 1.18
        },
        "34019": {
          "name": "Hunterdon",
          "median": 1.11,
          "10%": 0.93,
          "90%": 1.32,
          "25%": 0.99,
          "75%": 1.18
        },
        "42061": {
          "name": "Huntingdon",
          "median": 1.13,
          "10%": 1.01,
          "90%": 1.27,
          "25%": 1.06,
          "75%": 1.18
        },
        "42063": {
          "name": "Indiana",
          "median": 1.06,
          "10%": 0.96,
          "90%": 1.22,
          "25%": 1.01,
          "75%": 1.14
        },
        "51093": {
          "name": "Isle of Wight",
          "median": 1.12,
          "10%": 0.89,
          "90%": 1.29,
          "25%": 1.0,
          "75%": 1.2
        },
        "54035": {
          "name": "Jackson",
          "median": 1.08,
          "10%": 1.01,
          "90%": 1.23,
          "25%": 1.04,
          "75%": 1.14
        },
        "51095": {
          "name": "James City",
          "median": 1.03,
          "10%": 0.86,
          "90%": 1.18,
          "25%": 0.93,
          "75%": 1.1
        },
        "42065": {
          "name": "Jefferson",
          "median": 1.06,
          "10%": 1.0,
          "90%": 1.21,
          "25%": 1.03,
          "75%": 1.14
        },
        "54037": {
          "name": "Jefferson",
          "median": 1.06,
          "10%": 0.93,
          "90%": 1.24,
          "25%": 1.0,
          "75%": 1.14
        },
        "42067": {
          "name": "Juniata",
          "median": 1.11,
          "10%": 0.97,
          "90%": 1.27,
          "25%": 1.03,
          "75%": 1.19
        },
        "54039": {
          "name": "Kanawha",
          "median": 1.04,
          "10%": 0.94,
          "90%": 1.17,
          "25%": 1.01,
          "75%": 1.1
        },
        "10001": {
          "name": "Kent",
          "median": 1.06,
          "10%": 0.91,
          "90%": 1.19,
          "25%": 0.97,
          "75%": 1.13
        },
        "24029": {
          "name": "Kent",
          "median": 1.06,
          "10%": 0.91,
          "90%": 1.23,
          "25%": 0.98,
          "75%": 1.15
        },
        "51099": {
          "name": "King George",
          "median": 1.05,
          "10%": 0.87,
          "90%": 1.25,
          "25%": 0.97,
          "75%": 1.16
        },
        "51101": {
          "name": "King William",
          "median": 1.03,
          "10%": 0.929,
          "90%": 1.22,
          "25%": 0.99,
          "75%": 1.12
        },
        "51097": {
          "name": "King and Queen",
          "median": 1.02,
          "10%": 0.88,
          "90%": 1.23,
          "25%": 0.97,
          "75%": 1.1
        },
        "42069": {
          "name": "Lackawanna",
          "median": 1.16,
          "10%": 0.97,
          "90%": 1.27,
          "25%": 1.09,
          "75%": 1.2
        },
        "42071": {
          "name": "Lancaster",
          "median": 1.1,
          "10%": 0.96,
          "90%": 1.28,
          "25%": 1.01,
          "75%": 1.17
        },
        "51103": {
          "name": "Lancaster",
          "median": 1.03,
          "10%": 0.84,
          "90%": 1.24,
          "25%": 0.93,
          "75%": 1.09
        },
        "42073": {
          "name": "Lawrence",
          "median": 1.05,
          "10%": 0.97,
          "90%": 1.19,
          "25%": 1.0,
          "75%": 1.12
        },
        "42075": {
          "name": "Lebanon",
          "median": 1.11,
          "10%": 0.96,
          "90%": 1.27,
          "25%": 1.01,
          "75%": 1.17
        },
        "51105": {
          "name": "Lee",
          "median": 1.1,
          "10%": 0.96,
          "90%": 1.28,
          "25%": 1.03,
          "75%": 1.16
        },
        "42077": {
          "name": "Lehigh",
          "median": 1.1,
          "10%": 0.99,
          "90%": 1.23,
          "25%": 1.04,
          "75%": 1.17
        },
        "54041": {
          "name": "Lewis",
          "median": 1.07,
          "10%": 0.98,
          "90%": 1.19,
          "25%": 1.02,
          "75%": 1.13
        },
        "51678": {
          "name": "Lexington",
          "median": 1.08,
          "10%": 0.93,
          "90%": 1.28,
          "25%": 1.0,
          "75%": 1.16
        },
        "54043": {
          "name": "Lincoln",
          "median": 1.06,
          "10%": 0.97,
          "90%": 1.19,
          "25%": 1.01,
          "75%": 1.12
        },
        "36051": {
          "name": "Livingston",
          "median": 1.11,
          "10%": 0.99,
          "90%": 1.27,
          "25%": 1.05,
          "75%": 1.19
        },
        "54045": {
          "name": "Logan",
          "median": 1.1,
          "10%": 1.0,
          "90%": 1.2,
          "25%": 1.05,
          "75%": 1.14
        },
        "51107": {
          "name": "Loudoun",
          "median": 1.09,
          "10%": 0.94,
          "90%": 1.24,
          "25%": 0.99,
          "75%": 1.17
        },
        "51109": {
          "name": "Louisa",
          "median": 1.09,
          "10%": 0.91,
          "90%": 1.311,
          "25%": 1.01,
          "75%": 1.21
        },
        "51111": {
          "name": "Lunenburg",
          "median": 1.12,
          "10%": 0.92,
          "90%": 1.28,
          "25%": 1.05,
          "75%": 1.2
        },
        "42079": {
          "name": "Luzerne",
          "median": 1.12,
          "10%": 1.01,
          "90%": 1.21,
          "25%": 1.07,
          "75%": 1.18
        },
        "42081": {
          "name": "Lycoming",
          "median": 1.13,
          "10%": 0.99,
          "90%": 1.25,
          "25%": 1.06,
          "75%": 1.2
        },
        "51680": {
          "name": "Lynchburg",
          "median": 1.11,
          "10%": 0.97,
          "90%": 1.21,
          "25%": 1.04,
          "75%": 1.17
        },
        "36053": {
          "name": "Madison",
          "median": 1.06,
          "10%": 0.94,
          "90%": 1.18,
          "25%": 0.99,
          "75%": 1.14
        },
        "51113": {
          "name": "Madison",
          "median": 1.09,
          "10%": 0.9,
          "90%": 1.33,
          "25%": 1.0,
          "75%": 1.22
        },
        "51683": {
          "name": "Manassas",
          "median": 1.02,
          "10%": 0.94,
          "90%": 1.22,
          "25%": 0.98,
          "75%": 1.12
        },
        "51685": {
          "name": "Manassas Park",
          "median": 1.02,
          "10%": 0.93,
          "90%": 1.23,
          "25%": 0.96,
          "75%": 1.11
        },
        "54049": {
          "name": "Marion",
          "median": 1.05,
          "10%": 0.94,
          "90%": 1.19,
          "25%": 0.97,
          "75%": 1.15
        },
        "54051": {
          "name": "Marshall",
          "median": 1.08,
          "10%": 0.97,
          "90%": 1.24,
          "25%": 1.02,
          "75%": 1.16
        },
        "51690": {
          "name": "Martinsville",
          "median": 1.13,
          "10%": 0.9,
          "90%": 1.31,
          "25%": 0.96,
          "75%": 1.2
        },
        "54053": {
          "name": "Mason",
          "median": 1.095,
          "10%": 1.0,
          "90%": 1.25,
          "25%": 1.05,
          "75%": 1.18
        },
        "51115": {
          "name": "Mathews",
          "median": 1.08,
          "10%": 0.85,
          "90%": 1.24,
          "25%": 0.95,
          "75%": 1.15
        },
        "54047": {
          "name": "McDowell",
          "median": 1.09,
          "10%": 0.99,
          "90%": 1.18,
          "25%": 1.04,
          "75%": 1.15
        },
        "42083": {
          "name": "McKean",
          "median": 1.07,
          "10%": 0.96,
          "90%": 1.16,
          "25%": 1.02,
          "75%": 1.12
        },
        "51117": {
          "name": "Mecklenburg",
          "median": 1.11,
          "10%": 0.96,
          "90%": 1.2,
          "25%": 1.03,
          "75%": 1.16
        },
        "34021": {
          "name": "Mercer",
          "median": 1.07,
          "10%": 0.94,
          "90%": 1.25,
          "25%": 1.01,
          "75%": 1.15
        },
        "42085": {
          "name": "Mercer",
          "median": 1.07,
          "10%": 0.99,
          "90%": 1.2,
          "25%": 1.03,
          "75%": 1.12
        },
        "54055": {
          "name": "Mercer",
          "median": 1.1,
          "10%": 0.99,
          "90%": 1.22,
          "25%": 1.04,
          "75%": 1.16
        },
        "51119": {
          "name": "Middlesex",
          "median": 1.04,
          "10%": 0.86,
          "90%": 1.24,
          "25%": 0.95,
          "75%": 1.1
        },
        "42087": {
          "name": "Mifflin",
          "median": 1.13,
          "10%": 0.98,
          "90%": 1.26,
          "25%": 1.07,
          "75%": 1.18
        },
        "54057": {
          "name": "Mineral",
          "median": 1.1,
          "10%": 1.0,
          "90%": 1.3,
          "25%": 1.05,
          "75%": 1.18
        },
        "54059": {
          "name": "Mingo",
          "median": 1.11,
          "10%": 1.01,
          "90%": 1.23,
          "25%": 1.04,
          "75%": 1.16
        },
        "34025": {
          "name": "Monmouth",
          "median": 1.07,
          "10%": 0.93,
          "90%": 1.22,
          "25%": 0.99,
          "75%": 1.15
        },
        "54061": {
          "name": "Monongalia",
          "median": 1.07,
          "10%": 0.98,
          "90%": 1.2,
          "25%": 1.01,
          "75%": 1.13
        },
        "42089": {
          "name": "Monroe",
          "median": 1.12,
          "10%": 0.98,
          "90%": 1.22,
          "25%": 1.06,
          "75%": 1.16
        },
        "54063": {
          "name": "Monroe",
          "median": 1.09,
          "10%": 0.96,
          "90%": 1.2,
          "25%": 1.02,
          "75%": 1.16
        },
        "24031": {
          "name": "Montgomery",
          "median": 1.1,
          "10%": 0.97,
          "90%": 1.21,
          "25%": 1.01,
          "75%": 1.15
        },
        "36057": {
          "name": "Montgomery",
          "median": 1.05,
          "10%": 0.98,
          "90%": 1.19,
          "25%": 1.02,
          "75%": 1.13
        },
        "42091": {
          "name": "Montgomery",
          "median": 1.1,
          "10%": 0.97,
          "90%": 1.19,
          "25%": 1.03,
          "75%": 1.16
        },
        "51121": {
          "name": "Montgomery",
          "median": 1.13,
          "10%": 0.98,
          "90%": 1.26,
          "25%": 1.06,
          "75%": 1.2
        },
        "42093": {
          "name": "Montour",
          "median": 1.16,
          "10%": 0.98,
          "90%": 1.33,
          "25%": 1.04,
          "75%": 1.27
        },
        "54065": {
          "name": "Morgan",
          "median": 1.14,
          "10%": 0.93,
          "90%": 1.31,
          "25%": 1.05,
          "75%": 1.21
        },
        "34027": {
          "name": "Morris",
          "median": 1.12,
          "10%": 0.93,
          "90%": 1.35,
          "25%": 1.0275,
          "75%": 1.24
        },
        "36059": {
          "name": "Nassau",
          "median": 1.1,
          "10%": 0.96,
          "90%": 1.25,
          "25%": 1.02,
          "75%": 1.18
        },
        "51125": {
          "name": "Nelson",
          "median": 1.13,
          "10%": 0.89,
          "90%": 1.45,
          "25%": 1.02,
          "75%": 1.25
        },
        "10003": {
          "name": "New Castle",
          "median": 1.12,
          "10%": 0.94,
          "90%": 1.27,
          "25%": 0.99,
          "75%": 1.19
        },
        "51127": {
          "name": "New Kent",
          "median": 1.03,
          "10%": 0.91,
          "90%": 1.211,
          "25%": 0.98,
          "75%": 1.11
        },
        "36061": {
          "name": "New York",
          "median": 1.06,
          "10%": 0.89,
          "90%": 1.2,
          "25%": 0.98,
          "75%": 1.13
        },
        "51700": {
          "name": "Newport News",
          "median": 1.05,
          "10%": 0.9,
          "90%": 1.27,
          "25%": 0.97,
          "75%": 1.16
        },
        "54067": {
          "name": "Nicholas",
          "median": 1.03,
          "10%": 0.95,
          "90%": 1.15,
          "25%": 0.98,
          "75%": 1.12
        },
        "51710": {
          "name": "Norfolk",
          "median": 1.06,
          "10%": 0.88,
          "90%": 1.45,
          "25%": 0.96,
          "75%": 1.19
        },
        "42095": {
          "name": "Northampton",
          "median": 1.1,
          "10%": 0.959,
          "90%": 1.191,
          "25%": 1.02,
          "75%": 1.14
        },
        "51131": {
          "name": "Northampton",
          "median": 1.07,
          "10%": 0.889,
          "90%": 1.22,
          "25%": 0.98,
          "75%": 1.18
        },
        "42097": {
          "name": "Northumberland",
          "median": 1.15,
          "10%": 0.98,
          "90%": 1.33,
          "25%": 1.07,
          "75%": 1.27
        },
        "51133": {
          "name": "Northumberland",
          "median": 1.02,
          "10%": 0.83,
          "90%": 1.29,
          "25%": 0.91,
          "75%": 1.09
        },
        "51720": {
          "name": "Norton",
          "median": 1.11,
          "10%": 0.92,
          "90%": 1.26,
          "25%": 1.0,
          "75%": 1.2
        },
        "51135": {
          "name": "Nottoway",
          "median": 1.11,
          "10%": 0.93,
          "90%": 1.28,
          "25%": 1.02,
          "75%": 1.21
        },
        "34029": {
          "name": "Ocean",
          "median": 1.07,
          "10%": 0.98,
          "90%": 1.21,
          "25%": 1.01,
          "75%": 1.15
        },
        "54069": {
          "name": "Ohio",
          "median": 1.08,
          "10%": 0.97,
          "90%": 1.25,
          "25%": 1.02,
          "75%": 1.17
        },
        "36065": {
          "name": "Oneida",
          "median": 1.07,
          "10%": 0.96,
          "90%": 1.19,
          "25%": 1.02,
          "75%": 1.15
        },
        "36067": {
          "name": "Onondaga",
          "median": 1.09,
          "10%": 0.95,
          "90%": 1.28,
          "25%": 1.02,
          "75%": 1.15
        },
        "36069": {
          "name": "Ontario",
          "median": 1.09,
          "10%": 0.99,
          "90%": 1.27,
          "25%": 1.04,
          "75%": 1.18
        },
        "36071": {
          "name": "Orange",
          "median": 1.11,
          "10%": 0.98,
          "90%": 1.26,
          "25%": 1.01,
          "75%": 1.19
        },
        "51137": {
          "name": "Orange",
          "median": 1.1,
          "10%": 0.93,
          "90%": 1.25,
          "25%": 1.02,
          "75%": 1.19
        },
        "36077": {
          "name": "Otsego",
          "median": 1.05,
          "10%": 0.97,
          "90%": 1.2,
          "25%": 1.0,
          "75%": 1.1
        },
        "51139": {
          "name": "Page",
          "median": 1.09,
          "10%": 0.94,
          "90%": 1.39,
          "25%": 0.99,
          "75%": 1.23
        },
        "51141": {
          "name": "Patrick",
          "median": 1.1,
          "10%": 0.97,
          "90%": 1.24,
          "25%": 1.03,
          "75%": 1.18
        },
        "54071": {
          "name": "Pendleton",
          "median": 1.09,
          "10%": 0.93,
          "90%": 1.31,
          "25%": 1.02,
          "75%": 1.22
        },
        "42099": {
          "name": "Perry",
          "median": 1.13,
          "10%": 0.93,
          "90%": 1.29,
          "25%": 1.0,
          "75%": 1.2025
        },
        "51730": {
          "name": "Petersburg",
          "median": 1.06,
          "10%": 0.88,
          "90%": 1.25,
          "25%": 0.97,
          "75%": 1.18
        },
        "42101": {
          "name": "Philadelphia",
          "median": 1.08,
          "10%": 0.96,
          "90%": 1.2,
          "25%": 1.01,
          "75%": 1.14
        },
        "42103": {
          "name": "Pike",
          "median": 1.1,
          "10%": 1.0,
          "90%": 1.25,
          "25%": 1.04,
          "75%": 1.18
        },
        "51143": {
          "name": "Pittsylvania",
          "median": 1.12,
          "10%": 0.97,
          "90%": 1.25,
          "25%": 1.07,
          "75%": 1.17
        },
        "54073": {
          "name": "Pleasants",
          "median": 1.06,
          "10%": 0.95,
          "90%": 1.2,
          "25%": 1.01,
          "75%": 1.13
        },
        "54075": {
          "name": "Pocahontas",
          "median": 1.07,
          "10%": 0.97,
          "90%": 1.24,
          "25%": 1.01,
          "75%": 1.18
        },
        "51735": {
          "name": "Poquoson",
          "median": 1.04,
          "10%": 0.9,
          "90%": 1.27,
          "25%": 0.97,
          "75%": 1.18
        },
        "51740": {
          "name": "Portsmouth",
          "median": 1.05,
          "10%": 0.88,
          "90%": 1.42,
          "25%": 0.96,
          "75%": 1.2
        },
        "42105": {
          "name": "Potter",
          "median": 1.09,
          "10%": 0.98,
          "90%": 1.21,
          "25%": 1.02,
          "75%": 1.15
        },
        "51145": {
          "name": "Powhatan",
          "median": 1.09,
          "10%": 0.87,
          "90%": 1.44,
          "25%": 0.97,
          "75%": 1.22
        },
        "54077": {
          "name": "Preston",
          "median": 1.07,
          "10%": 0.99,
          "90%": 1.24,
          "25%": 1.03,
          "75%": 1.15
        },
        "51147": {
          "name": "Prince Edward",
          "median": 1.08,
          "10%": 0.97,
          "90%": 1.27,
          "25%": 1.03,
          "75%": 1.17
        },
        "51149": {
          "name": "Prince George",
          "median": 1.03,
          "10%": 0.9,
          "90%": 1.21,
          "25%": 0.97,
          "75%": 1.17
        },
        "24033": {
          "name": "Prince George's",
          "median": 1.07,
          "10%": 0.95,
          "90%": 1.23,
          "25%": 0.99,
          "75%": 1.17
        },
        "51153": {
          "name": "Prince William",
          "median": 1.05,
          "10%": 0.94,
          "90%": 1.2,
          "25%": 0.98,
          "75%": 1.13
        },
        "51155": {
          "name": "Pulaski",
          "median": 1.12,
          "10%": 1.02,
          "90%": 1.23,
          "25%": 1.06,
          "75%": 1.19
        },
        "54079": {
          "name": "Putnam",
          "median": 1.07,
          "10%": 0.97,
          "90%": 1.2,
          "25%": 1.01,
          "75%": 1.14
        },
        "24035": {
          "name": "Queen Anne's",
          "median": 1.05,
          "10%": 0.91,
          "90%": 1.24,
          "25%": 0.97,
          "75%": 1.14
        },
        "51750": {
          "name": "Radford",
          "median": 1.15,
          "10%": 0.99,
          "90%": 1.311,
          "25%": 1.04,
          "75%": 1.24
        },
        "54081": {
          "name": "Raleigh",
          "median": 1.1,
          "10%": 0.95,
          "90%": 1.25,
          "25%": 1.02,
          "75%": 1.17
        },
        "54083": {
          "name": "Randolph",
          "median": 1.08,
          "10%": 0.98,
          "90%": 1.19,
          "25%": 1.04,
          "75%": 1.13
        },
        "51157": {
          "name": "Rappahannock",
          "median": 1.08,
          "10%": 0.93,
          "90%": 1.281,
          "25%": 0.99,
          "75%": 1.14
        },
        "36085": {
          "name": "Richmond",
          "median": 1.04,
          "10%": 0.89,
          "90%": 1.27,
          "25%": 0.96,
          "75%": 1.16
        },
        "51159": {
          "name": "Richmond",
          "median": 1.0,
          "10%": 0.81,
          "90%": 1.33,
          "25%": 0.93,
          "75%": 1.12
        },
        "51760": {
          "name": "Richmond",
          "median": 1.08,
          "10%": 0.93,
          "90%": 1.31,
          "25%": 0.99,
          "75%": 1.19
        },
        "54085": {
          "name": "Ritchie",
          "median": 1.1,
          "10%": 0.98,
          "90%": 1.18,
          "25%": 1.03,
          "75%": 1.15
        },
        "54087": {
          "name": "Roane",
          "median": 1.07,
          "10%": 0.99,
          "90%": 1.22,
          "25%": 1.03,
          "75%": 1.13
        },
        "51161": {
          "name": "Roanoke",
          "median": 1.14,
          "10%": 0.99,
          "90%": 1.31,
          "25%": 1.02,
          "75%": 1.24
        },
        "51770": {
          "name": "Roanoke",
          "median": 1.17,
          "10%": 0.95,
          "90%": 1.371,
          "25%": 1.01,
          "75%": 1.27
        },
        "51163": {
          "name": "Rockbridge",
          "median": 1.12,
          "10%": 0.96,
          "90%": 1.31,
          "25%": 1.05,
          "75%": 1.23
        },
        "51165": {
          "name": "Rockingham",
          "median": 1.09,
          "10%": 0.93,
          "90%": 1.34,
          "25%": 0.99,
          "75%": 1.22
        },
        "51167": {
          "name": "Russell",
          "median": 1.05,
          "10%": 0.97,
          "90%": 1.21,
          "25%": 1.01,
          "75%": 1.1
        },
        "34033": {
          "name": "Salem",
          "median": 1.1,
          "10%": 0.96,
          "90%": 1.24,
          "25%": 1.0,
          "75%": 1.2
        },
        "51775": {
          "name": "Salem",
          "median": 1.15,
          "10%": 0.96,
          "90%": 1.36,
          "25%": 1.03,
          "75%": 1.27
        },
        "36095": {
          "name": "Schoharie",
          "median": 1.11,
          "10%": 0.95,
          "90%": 1.23,
          "25%": 1.03,
          "75%": 1.17
        },
        "36097": {
          "name": "Schuyler",
          "median": 1.12,
          "10%": 1.02,
          "90%": 1.24,
          "25%": 1.07,
          "75%": 1.19
        },
        "42107": {
          "name": "Schuylkill",
          "median": 1.11,
          "10%": 0.97,
          "90%": 1.28,
          "25%": 1.04,
          "75%": 1.22
        },
        "51169": {
          "name": "Scott",
          "median": 1.1,
          "10%": 0.96,
          "90%": 1.22,
          "25%": 1.0,
          "75%": 1.17
        },
        "51171": {
          "name": "Shenandoah",
          "median": 1.09,
          "10%": 0.95,
          "90%": 1.33,
          "25%": 1.0,
          "75%": 1.18
        },
        "51173": {
          "name": "Smyth",
          "median": 1.08,
          "10%": 0.98,
          "90%": 1.19,
          "25%": 1.03,
          "75%": 1.13
        },
        "42109": {
          "name": "Snyder",
          "median": 1.14,
          "10%": 0.97,
          "90%": 1.32,
          "25%": 1.06,
          "75%": 1.23
        },
        "24039": {
          "name": "Somerset",
          "median": 1.07,
          "10%": 0.95,
          "90%": 1.25,
          "25%": 1.02,
          "75%": 1.15
        },
        "42111": {
          "name": "Somerset",
          "median": 1.08,
          "10%": 1.0,
          "90%": 1.18,
          "25%": 1.04,
          "75%": 1.13
        },
        "51175": {
          "name": "Southampton",
          "median": 1.08,
          "10%": 0.96,
          "90%": 1.28,
          "25%": 1.02,
          "75%": 1.16
        },
        "51177": {
          "name": "Spotsylvania",
          "median": 1.07,
          "10%": 0.9,
          "90%": 1.24,
          "25%": 1.02,
          "75%": 1.15
        },
        "24037": {
          "name": "St. Mary's",
          "median": 1.04,
          "10%": 0.86,
          "90%": 1.22,
          "25%": 0.93,
          "75%": 1.11
        },
        "51179": {
          "name": "Stafford",
          "median": 1.1,
          "10%": 0.89,
          "90%": 1.27,
          "25%": 1.02,
          "75%": 1.19
        },
        "51790": {
          "name": "Staunton",
          "median": 1.1,
          "10%": 0.89,
          "90%": 1.41,
          "25%": 0.96,
          "75%": 1.21
        },
        "36101": {
          "name": "Steuben",
          "median": 1.08,
          "10%": 0.99,
          "90%": 1.23,
          "25%": 1.04,
          "75%": 1.16
        },
        "51800": {
          "name": "Suffolk",
          "median": 1.12,
          "10%": 0.93,
          "90%": 1.33,
          "25%": 1.01,
          "75%": 1.21
        },
        "36105": {
          "name": "Sullivan",
          "median": 1.1,
          "10%": 0.98,
          "90%": 1.23,
          "25%": 1.06,
          "75%": 1.17
        },
        "42113": {
          "name": "Sullivan",
          "median": 1.14,
          "10%": 0.93,
          "90%": 1.27,
          "25%": 1.06,
          "75%": 1.21
        },
        "54089": {
          "name": "Summers",
          "median": 1.07,
          "10%": 0.98,
          "90%": 1.23,
          "25%": 1.02,
          "75%": 1.14
        },
        "51181": {
          "name": "Surry",
          "median": 1.05,
          "10%": 0.91,
          "90%": 1.22,
          "25%": 0.98,
          "75%": 1.16
        },
        "42115": {
          "name": "Susquehanna",
          "median": 1.12,
          "10%": 1.03,
          "90%": 1.23,
          "25%": 1.07,
          "75%": 1.17
        },
        "10005": {
          "name": "Sussex",
          "median": 1.06,
          "10%": 0.93,
          "90%": 1.21,
          "25%": 1.01,
          "75%": 1.12
        },
        "34037": {
          "name": "Sussex",
          "median": 1.13,
          "10%": 0.97,
          "90%": 1.24,
          "25%": 1.03,
          "75%": 1.19
        },
        "51183": {
          "name": "Sussex",
          "median": 1.05,
          "10%": 0.95,
          "90%": 1.24,
          "25%": 0.99,
          "75%": 1.18
        },
        "24041": {
          "name": "Talbot",
          "median": 1.03,
          "10%": 0.89,
          "90%": 1.24,
          "25%": 0.95,
          "75%": 1.14
        },
        "54091": {
          "name": "Taylor",
          "median": 1.08,
          "10%": 0.98,
          "90%": 1.21,
          "25%": 1.02,
          "75%": 1.14
        },
        "51185": {
          "name": "Tazewell",
          "median": 1.08,
          "10%": 0.99,
          "90%": 1.17,
          "25%": 1.01,
          "75%": 1.14
        },
        "36107": {
          "name": "Tioga",
          "median": 1.11,
          "10%": 0.99,
          "90%": 1.25,
          "25%": 1.06,
          "75%": 1.18
        },
        "42117": {
          "name": "Tioga",
          "median": 1.11,
          "10%": 0.98,
          "90%": 1.26,
          "25%": 1.02,
          "75%": 1.17
        },
        "36109": {
          "name": "Tompkins",
          "median": 1.11,
          "10%": 0.99,
          "90%": 1.27,
          "25%": 1.05,
          "75%": 1.18
        },
        "54093": {
          "name": "Tucker",
          "median": 1.07,
          "10%": 0.97,
          "90%": 1.18,
          "25%": 1.01,
          "75%": 1.12
        },
        "54095": {
          "name": "Tyler",
          "median": 1.04,
          "10%": 0.94,
          "90%": 1.15,
          "25%": 1.0,
          "75%": 1.11
        },
        "36111": {
          "name": "Ulster",
          "median": 1.12,
          "10%": 0.99,
          "90%": 1.31,
          "25%": 1.06,
          "75%": 1.19
        },
        "42119": {
          "name": "Union",
          "median": 1.14,
          "10%": 0.98,
          "90%": 1.25,
          "25%": 1.04,
          "75%": 1.21
        },
        "54097": {
          "name": "Upshur",
          "median": 1.07,
          "10%": 0.96,
          "90%": 1.19,
          "25%": 0.99,
          "75%": 1.12
        },
        "42121": {
          "name": "Venango",
          "median": 1.07,
          "10%": 0.98,
          "90%": 1.18,
          "25%": 1.03,
          "75%": 1.12
        },
        "51810": {
          "name": "Virginia Beach",
          "median": 1.09,
          "10%": 0.92,
          "90%": 1.38,
          "25%": 0.98,
          "75%": 1.19
        },
        "34041": {
          "name": "Warren",
          "median": 1.12,
          "10%": 0.95,
          "90%": 1.27,
          "25%": 1.01,
          "75%": 1.19
        },
        "42123": {
          "name": "Warren",
          "median": 1.05,
          "10%": 1.0,
          "90%": 1.19,
          "25%": 1.03,
          "75%": 1.13
        },
        "51187": {
          "name": "Warren",
          "median": 1.12,
          "10%": 0.94,
          "90%": 1.29,
          "25%": 1.0,
          "75%": 1.2
        },
        "24043": {
          "name": "Washington",
          "median": 1.12,
          "10%": 0.92,
          "90%": 1.25,
          "25%": 1.02,
          "75%": 1.18
        },
        "42125": {
          "name": "Washington",
          "median": 1.08,
          "10%": 0.98,
          "90%": 1.2,
          "25%": 1.03,
          "75%": 1.15
        },
        "51191": {
          "name": "Washington",
          "median": 1.06,
          "10%": 0.96,
          "90%": 1.16,
          "25%": 1.0,
          "75%": 1.11
        },
        "42127": {
          "name": "Wayne",
          "median": 1.13,
          "10%": 0.99,
          "90%": 1.25,
          "25%": 1.06,
          "75%": 1.18
        },
        "54099": {
          "name": "Wayne",
          "median": 1.07,
          "10%": 0.98,
          "90%": 1.22,
          "25%": 1.02,
          "75%": 1.15
        },
        "51820": {
          "name": "Waynesboro",
          "median": 1.13,
          "10%": 0.89,
          "90%": 1.37,
          "25%": 1.01,
          "75%": 1.24
        },
        "54101": {
          "name": "Webster",
          "median": 1.04,
          "10%": 0.96,
          "90%": 1.19,
          "25%": 0.98,
          "75%": 1.13
        },
        "36119": {
          "name": "Westchester",
          "median": 1.06,
          "10%": 0.95,
          "90%": 1.23,
          "25%": 0.99,
          "75%": 1.16
        },
        "42129": {
          "name": "Westmoreland",
          "median": 1.07,
          "10%": 0.96,
          "90%": 1.17,
          "25%": 1.0,
          "75%": 1.13
        },
        "51193": {
          "name": "Westmoreland",
          "median": 1.02,
          "10%": 0.84,
          "90%": 1.24,
          "25%": 0.94,
          "75%": 1.11
        },
        "54103": {
          "name": "Wetzel",
          "median": 1.08,
          "10%": 0.979,
          "90%": 1.2,
          "25%": 1.02,
          "75%": 1.13
        },
        "24045": {
          "name": "Wicomico",
          "median": 1.05,
          "10%": 0.93,
          "90%": 1.16,
          "25%": 1.0,
          "75%": 1.11
        },
        "51830": {
          "name": "Williamsburg",
          "median": 1.02,
          "10%": 0.83,
          "90%": 1.18,
          "25%": 0.9,
          "75%": 1.09
        },
        "51840": {
          "name": "Winchester",
          "median": 1.11,
          "10%": 0.92,
          "90%": 1.27,
          "25%": 1.02,
          "75%": 1.2
        },
        "54105": {
          "name": "Wirt",
          "median": 1.12,
          "10%": 0.98,
          "90%": 1.22,
          "25%": 1.06,
          "75%": 1.17
        },
        "51195": {
          "name": "Wise",
          "median": 1.09,
          "10%": 0.95,
          "90%": 1.22,
          "25%": 1.01,
          "75%": 1.18
        },
        "54107": {
          "name": "Wood",
          "median": 1.09,
          "10%": 0.97,
          "90%": 1.22,
          "25%": 1.02,
          "75%": 1.16
        },
        "24047": {
          "name": "Worcester",
          "median": 1.06,
          "10%": 0.93,
          "90%": 1.25,
          "25%": 0.98,
          "75%": 1.17
        },
        "42131": {
          "name": "Wyoming",
          "median": 1.13,
          "10%": 1.0,
          "90%": 1.26,
          "25%": 1.08,
          "75%": 1.2
        },
        "54109": {
          "name": "Wyoming",
          "median": 1.13,
          "10%": 0.98,
          "90%": 1.2,
          "25%": 1.05,
          "75%": 1.16
        },
        "51197": {
          "name": "Wythe",
          "median": 1.07,
          "10%": 1.0,
          "90%": 1.19,
          "25%": 1.04,
          "75%": 1.15
        },
        "36123": {
          "name": "Yates",
          "median": 1.14,
          "10%": 0.98,
          "90%": 1.32,
          "25%": 1.06,
          "75%": 1.2
        },
        "42133": {
          "name": "York",
          "median": 1.11,
          "10%": 0.95,
          "90%": 1.29,
          "25%": 1.0,
          "75%": 1.23
        },
        "51199": {
          "name": "York",
          "median": 1.03,
          "10%": 0.88,
          "90%": 1.21,
          "25%": 0.93,
          "75%": 1.13
        },
        "max": 1.17,
        "min": 1
      },
      "50": {
        "51001": {
          "name": "Accomack",
          "median": 1.07,
          "10%": 0.88,
          "90%": 1.28,
          "25%": 0.99,
          "75%": 1.2
        },
        "42001": {
          "name": "Adams",
          "median": 1.06,
          "10%": 0.81,
          "90%": 1.39,
          "25%": 0.95,
          "75%": 1.16
        },
        "51003": {
          "name": "Albemarle",
          "median": 1.12,
          "10%": 0.9,
          "90%": 1.38,
          "25%": 1.02,
          "75%": 1.24
        },
        "51510": {
          "name": "Alexandria",
          "median": 1.06,
          "10%": 0.87,
          "90%": 1.3,
          "25%": 0.94,
          "75%": 1.21
        },
        "24001": {
          "name": "Allegany",
          "median": 1.1,
          "10%": 0.98,
          "90%": 1.37,
          "25%": 1.03,
          "75%": 1.22
        },
        "36003": {
          "name": "Allegany",
          "median": 1.07,
          "10%": 0.92,
          "90%": 1.28,
          "25%": 1.0,
          "75%": 1.18
        },
        "51005": {
          "name": "Alleghany",
          "median": 1.13,
          "10%": 0.97,
          "90%": 1.42,
          "25%": 1.04,
          "75%": 1.27
        },
        "42003": {
          "name": "Allegheny",
          "median": 1.09,
          "10%": 0.93,
          "90%": 1.22,
          "25%": 1.02,
          "75%": 1.15
        },
        "51007": {
          "name": "Amelia",
          "median": 1.13,
          "10%": 0.88,
          "90%": 1.49,
          "25%": 0.98,
          "75%": 1.35
        },
        "51009": {
          "name": "Amherst",
          "median": 1.12,
          "10%": 0.94,
          "90%": 1.36,
          "25%": 1.03,
          "75%": 1.24
        },
        "24003": {
          "name": "Anne Arundel",
          "median": 1.05,
          "10%": 0.88,
          "90%": 1.29,
          "25%": 0.96,
          "75%": 1.16
        },
        "51011": {
          "name": "Appomattox",
          "median": 1.11,
          "10%": 0.9,
          "90%": 1.37,
          "25%": 1.01,
          "75%": 1.22
        },
        "51013": {
          "name": "Arlington",
          "median": 1.05,
          "10%": 0.89,
          "90%": 1.28,
          "25%": 0.96,
          "75%": 1.19
        },
        "42005": {
          "name": "Armstrong",
          "median": 1.08,
          "10%": 0.94,
          "90%": 1.24,
          "25%": 1.01,
          "75%": 1.16
        },
        "34001": {
          "name": "Atlantic",
          "median": 1.11,
          "10%": 0.9,
          "90%": 1.3,
          "25%": 1.03,
          "75%": 1.21
        },
        "51015": {
          "name": "Augusta",
          "median": 1.12,
          "10%": 0.88,
          "90%": 1.33,
          "25%": 0.99,
          "75%": 1.21
        },
        "24005": {
          "name": "Baltimore",
          "median": 1.08,
          "10%": 0.91,
          "90%": 1.32,
          "25%": 1.0,
          "75%": 1.18
        },
        "24510": {
          "name": "Baltimore",
          "median": 1.06,
          "10%": 0.86,
          "90%": 1.32,
          "25%": 0.94,
          "75%": 1.18
        },
        "54001": {
          "name": "Barbour",
          "median": 1.06,
          "10%": 0.94,
          "90%": 1.23,
          "25%": 1.0,
          "75%": 1.13
        },
        "51017": {
          "name": "Bath",
          "median": 1.11,
          "10%": 0.96,
          "90%": 1.36,
          "25%": 1.04,
          "75%": 1.27
        },
        "42007": {
          "name": "Beaver",
          "median": 1.07,
          "10%": 0.9,
          "90%": 1.21,
          "25%": 0.99,
          "75%": 1.14
        },
        "42009": {
          "name": "Bedford",
          "median": 1.17,
          "10%": 0.96,
          "90%": 1.31,
          "25%": 1.07,
          "75%": 1.24
        },
        "51019": {
          "name": "Bedford",
          "median": 1.13,
          "10%": 0.98,
          "90%": 1.3,
          "25%": 1.06,
          "75%": 1.2
        },
        "54003": {
          "name": "Berkeley",
          "median": 1.12,
          "10%": 0.92,
          "90%": 1.31,
          "25%": 1.01,
          "75%": 1.18
        },
        "42011": {
          "name": "Berks",
          "median": 1.1,
          "10%": 0.96,
          "90%": 1.26,
          "25%": 1.02,
          "75%": 1.2
        },
        "42013": {
          "name": "Blair",
          "median": 1.15,
          "10%": 1.0,
          "90%": 1.26,
          "25%": 1.06,
          "75%": 1.2
        },
        "51021": {
          "name": "Bland",
          "median": 1.11,
          "10%": 0.97,
          "90%": 1.28,
          "25%": 1.01,
          "75%": 1.19
        },
        "54005": {
          "name": "Boone",
          "median": 1.09,
          "10%": 0.97,
          "90%": 1.23,
          "25%": 1.03,
          "75%": 1.15
        },
        "51023": {
          "name": "Botetourt",
          "median": 1.15,
          "10%": 0.98,
          "90%": 1.38,
          "25%": 1.04,
          "75%": 1.26
        },
        "42015": {
          "name": "Bradford",
          "median": 1.15,
          "10%": 0.94,
          "90%": 1.35,
          "25%": 1.05,
          "75%": 1.24
        },
        "54007": {
          "name": "Braxton",
          "median": 1.06,
          "10%": 0.92,
          "90%": 1.26,
          "25%": 0.98,
          "75%": 1.14
        },
        "51520": {
          "name": "Bristol",
          "median": 1.08,
          "10%": 0.95,
          "90%": 1.23,
          "25%": 1.0,
          "75%": 1.16
        },
        "36005": {
          "name": "Bronx",
          "median": 1.03,
          "10%": 0.91,
          "90%": 1.24,
          "25%": 0.96,
          "75%": 1.13
        },
        "54009": {
          "name": "Brooke",
          "median": 1.09,
          "10%": 0.92,
          "90%": 1.32,
          "25%": 1.0,
          "75%": 1.21
        },
        "36007": {
          "name": "Broome",
          "median": 1.11,
          "10%": 1.02,
          "90%": 1.22,
          "25%": 1.06,
          "75%": 1.18
        },
        "51025": {
          "name": "Brunswick",
          "median": 1.07,
          "10%": 0.91,
          "90%": 1.35,
          "25%": 1.0,
          "75%": 1.24
        },
        "51027": {
          "name": "Buchanan",
          "median": 1.07,
          "10%": 0.99,
          "90%": 1.17,
          "25%": 1.01,
          "75%": 1.12
        },
        "51029": {
          "name": "Buckingham",
          "median": 1.12,
          "10%": 0.91,
          "90%": 1.31,
          "25%": 0.99,
          "75%": 1.19
        },
        "42017": {
          "name": "Bucks",
          "median": 1.07,
          "10%": 0.96,
          "90%": 1.25,
          "25%": 1.01,
          "75%": 1.15
        },
        "51530": {
          "name": "Buena Vista",
          "median": 1.11,
          "10%": 0.89,
          "90%": 1.34,
          "25%": 1.01,
          "75%": 1.24
        },
        "34005": {
          "name": "Burlington",
          "median": 1.08,
          "10%": 0.96,
          "90%": 1.24,
          "25%": 1.0,
          "75%": 1.17
        },
        "42019": {
          "name": "Butler",
          "median": 1.06,
          "10%": 0.95,
          "90%": 1.19,
          "25%": 1.01,
          "75%": 1.11
        },
        "54011": {
          "name": "Cabell",
          "median": 1.05,
          "10%": 0.94,
          "90%": 1.21,
          "25%": 0.99,
          "75%": 1.14
        },
        "54013": {
          "name": "Calhoun",
          "median": 1.11,
          "10%": 0.939,
          "90%": 1.3,
          "25%": 1.03,
          "75%": 1.19
        },
        "24009": {
          "name": "Calvert",
          "median": 1.04,
          "10%": 0.88,
          "90%": 1.27,
          "25%": 0.96,
          "75%": 1.18
        },
        "42021": {
          "name": "Cambria",
          "median": 1.08,
          "10%": 0.93,
          "90%": 1.23,
          "25%": 1.0,
          "75%": 1.16
        },
        "34007": {
          "name": "Camden",
          "median": 1.09,
          "10%": 0.96,
          "90%": 1.26,
          "25%": 1.03,
          "75%": 1.19
        },
        "42023": {
          "name": "Cameron",
          "median": 1.11,
          "10%": 0.94,
          "90%": 1.23,
          "25%": 1.02,
          "75%": 1.18
        },
        "51031": {
          "name": "Campbell",
          "median": 1.11,
          "10%": 0.92,
          "90%": 1.27,
          "25%": 1.04,
          "75%": 1.21
        },
        "34009": {
          "name": "Cape May",
          "median": 1.14,
          "10%": 0.93,
          "90%": 1.29,
          "25%": 1.05,
          "75%": 1.2
        },
        "42025": {
          "name": "Carbon",
          "median": 1.1,
          "10%": 0.99,
          "90%": 1.28,
          "25%": 1.05,
          "75%": 1.17
        },
        "24011": {
          "name": "Caroline",
          "median": 1.08,
          "10%": 0.87,
          "90%": 1.39,
          "25%": 0.96,
          "75%": 1.2
        },
        "51033": {
          "name": "Caroline",
          "median": 1.06,
          "10%": 0.85,
          "90%": 1.28,
          "25%": 0.95,
          "75%": 1.16
        },
        "24013": {
          "name": "Carroll",
          "median": 1.12,
          "10%": 0.94,
          "90%": 1.33,
          "25%": 1.02,
          "75%": 1.23
        },
        "51035": {
          "name": "Carroll",
          "median": 1.09,
          "10%": 1.0,
          "90%": 1.23,
          "25%": 1.04,
          "75%": 1.16
        },
        "24015": {
          "name": "Cecil",
          "median": 1.06,
          "10%": 0.94,
          "90%": 1.23,
          "25%": 0.99,
          "75%": 1.14
        },
        "42027": {
          "name": "Centre",
          "median": 1.11,
          "10%": 0.99,
          "90%": 1.26,
          "25%": 1.06,
          "75%": 1.2
        },
        "24017": {
          "name": "Charles",
          "median": 1.11,
          "10%": 0.86,
          "90%": 1.39,
          "25%": 0.93,
          "75%": 1.24
        },
        "51036": {
          "name": "Charles City",
          "median": 1.03,
          "10%": 0.87,
          "90%": 1.19,
          "25%": 0.95,
          "75%": 1.12
        },
        "51037": {
          "name": "Charlotte",
          "median": 1.11,
          "10%": 0.95,
          "90%": 1.27,
          "25%": 1.02,
          "75%": 1.2
        },
        "51540": {
          "name": "Charlottesville",
          "median": 1.12,
          "10%": 0.87,
          "90%": 1.39,
          "25%": 1.01,
          "75%": 1.25
        },
        "36015": {
          "name": "Chemung",
          "median": 1.11,
          "10%": 1.0,
          "90%": 1.25,
          "25%": 1.05,
          "75%": 1.18
        },
        "36017": {
          "name": "Chenango",
          "median": 1.07,
          "10%": 0.97,
          "90%": 1.24,
          "25%": 1.02,
          "75%": 1.17
        },
        "51550": {
          "name": "Chesapeake",
          "median": 1.09,
          "10%": 0.87,
          "90%": 1.36,
          "25%": 1.0,
          "75%": 1.24
        },
        "42029": {
          "name": "Chester",
          "median": 1.12,
          "10%": 0.93,
          "90%": 1.24,
          "25%": 1.03,
          "75%": 1.19
        },
        "51041": {
          "name": "Chesterfield",
          "median": 1.09,
          "10%": 0.89,
          "90%": 1.42,
          "25%": 0.99,
          "75%": 1.23
        },
        "42031": {
          "name": "Clarion",
          "median": 1.08,
          "10%": 0.93,
          "90%": 1.231,
          "25%": 1.04,
          "75%": 1.15
        },
        "51043": {
          "name": "Clarke",
          "median": 1.06,
          "10%": 0.87,
          "90%": 1.26,
          "25%": 0.98,
          "75%": 1.16
        },
        "54015": {
          "name": "Clay",
          "median": 1.03,
          "10%": 0.94,
          "90%": 1.19,
          "25%": 0.98,
          "75%": 1.12
        },
        "42033": {
          "name": "Clearfield",
          "median": 1.09,
          "10%": 1.0,
          "90%": 1.22,
          "25%": 1.05,
          "75%": 1.15
        },
        "42035": {
          "name": "Clinton",
          "median": 1.13,
          "10%": 0.94,
          "90%": 1.27,
          "25%": 1.05,
          "75%": 1.22
        },
        "51570": {
          "name": "Colonial Heights",
          "median": 1.09,
          "10%": 0.87,
          "90%": 1.32,
          "25%": 0.94,
          "75%": 1.2
        },
        "42037": {
          "name": "Columbia",
          "median": 1.14,
          "10%": 0.98,
          "90%": 1.35,
          "25%": 1.06,
          "75%": 1.26
        },
        "36023": {
          "name": "Cortland",
          "median": 1.1,
          "10%": 0.96,
          "90%": 1.34,
          "25%": 1.03,
          "75%": 1.17
        },
        "51580": {
          "name": "Covington",
          "median": 1.11,
          "10%": 0.95,
          "90%": 1.42,
          "25%": 1.0375,
          "75%": 1.23
        },
        "51045": {
          "name": "Craig",
          "median": 1.14,
          "10%": 0.96,
          "90%": 1.31,
          "25%": 1.01,
          "75%": 1.22
        },
        "42039": {
          "name": "Crawford",
          "median": 1.09,
          "10%": 0.98,
          "90%": 1.24,
          "25%": 1.03,
          "75%": 1.17
        },
        "51047": {
          "name": "Culpeper",
          "median": 1.06,
          "10%": 0.95,
          "90%": 1.23,
          "25%": 0.98,
          "75%": 1.17
        },
        "34011": {
          "name": "Cumberland",
          "median": 1.1,
          "10%": 0.91,
          "90%": 1.29,
          "25%": 0.99,
          "75%": 1.17
        },
        "42041": {
          "name": "Cumberland",
          "median": 1.12,
          "10%": 0.91,
          "90%": 1.4,
          "25%": 0.99,
          "75%": 1.25
        },
        "51049": {
          "name": "Cumberland",
          "median": 1.05,
          "10%": 0.91,
          "90%": 1.37,
          "25%": 0.98,
          "75%": 1.21
        },
        "51590": {
          "name": "Danville",
          "median": 1.12,
          "10%": 0.95,
          "90%": 1.28,
          "25%": 1.0,
          "75%": 1.2
        },
        "42043": {
          "name": "Dauphin",
          "median": 1.15,
          "10%": 0.9,
          "90%": 1.43,
          "25%": 1.04,
          "75%": 1.32
        },
        "36025": {
          "name": "Delaware",
          "median": 1.115,
          "10%": 0.97,
          "90%": 1.27,
          "25%": 1.03,
          "75%": 1.19
        },
        "42045": {
          "name": "Delaware",
          "median": 1.1,
          "10%": 0.93,
          "90%": 1.34,
          "25%": 1.0,
          "75%": 1.2325
        },
        "51051": {
          "name": "Dickenson",
          "median": 1.07,
          "10%": 0.96,
          "90%": 1.2,
          "25%": 1.0,
          "75%": 1.14
        },
        "51053": {
          "name": "Dinwiddie",
          "median": 1.09,
          "10%": 0.92,
          "90%": 1.31,
          "25%": 1.01,
          "75%": 1.21
        },
        "11001": {
          "name": "District of Columbia",
          "median": 1.1,
          "10%": 0.92,
          "90%": 1.29,
          "25%": 0.9675,
          "75%": 1.2
        },
        "54017": {
          "name": "Doddridge",
          "median": 1.055,
          "10%": 0.91,
          "90%": 1.24,
          "25%": 0.98,
          "75%": 1.16
        },
        "24019": {
          "name": "Dorchester",
          "median": 1.06,
          "10%": 0.85,
          "90%": 1.23,
          "25%": 0.95,
          "75%": 1.13
        },
        "42047": {
          "name": "Elk",
          "median": 1.07,
          "10%": 0.95,
          "90%": 1.17,
          "25%": 1.0,
          "75%": 1.12
        },
        "51595": {
          "name": "Emporia",
          "median": 1.03,
          "10%": 0.88,
          "90%": 1.33,
          "25%": 0.96,
          "75%": 1.18
        },
        "42049": {
          "name": "Erie",
          "median": 1.08,
          "10%": 0.94,
          "90%": 1.24,
          "25%": 1.01,
          "75%": 1.17
        },
        "51057": {
          "name": "Essex",
          "median": 1.01,
          "10%": 0.83,
          "90%": 1.29,
          "25%": 0.92,
          "75%": 1.07
        },
        "51059": {
          "name": "Fairfax",
          "median": 1.05,
          "10%": 0.93,
          "90%": 1.25,
          "25%": 0.98,
          "75%": 1.16
        },
        "51600": {
          "name": "Fairfax",
          "median": 1.04,
          "10%": 0.88,
          "90%": 1.27,
          "25%": 0.96,
          "75%": 1.13
        },
        "51610": {
          "name": "Falls Church",
          "median": 1.05,
          "10%": 0.88,
          "90%": 1.3,
          "25%": 0.97,
          "75%": 1.2
        },
        "51061": {
          "name": "Fauquier",
          "median": 1.09,
          "10%": 0.89,
          "90%": 1.25,
          "25%": 0.97,
          "75%": 1.18
        },
        "42051": {
          "name": "Fayette",
          "median": 1.09,
          "10%": 0.96,
          "90%": 1.29,
          "25%": 1.03,
          "75%": 1.17
        },
        "54019": {
          "name": "Fayette",
          "median": 1.08,
          "10%": 0.91,
          "90%": 1.23,
          "25%": 0.99,
          "75%": 1.14
        },
        "51063": {
          "name": "Floyd",
          "median": 1.11,
          "10%": 0.96,
          "90%": 1.24,
          "25%": 1.04,
          "75%": 1.18
        },
        "51065": {
          "name": "Fluvanna",
          "median": 1.12,
          "10%": 0.84,
          "90%": 1.481,
          "25%": 0.93,
          "75%": 1.3
        },
        "42053": {
          "name": "Forest",
          "median": 1.05,
          "10%": 0.95,
          "90%": 1.2,
          "25%": 1.0,
          "75%": 1.13
        },
        "42055": {
          "name": "Franklin",
          "median": 1.14,
          "10%": 0.98,
          "90%": 1.28,
          "25%": 1.07,
          "75%": 1.2
        },
        "51067": {
          "name": "Franklin",
          "median": 1.14,
          "10%": 0.95,
          "90%": 1.3,
          "25%": 1.04,
          "75%": 1.23
        },
        "51620": {
          "name": "Franklin",
          "median": 1.14,
          "10%": 0.9,
          "90%": 1.36,
          "25%": 1.0,
          "75%": 1.24
        },
        "24021": {
          "name": "Frederick",
          "median": 1.12,
          "10%": 0.88,
          "90%": 1.3,
          "25%": 0.99,
          "75%": 1.18
        },
        "51069": {
          "name": "Frederick",
          "median": 1.1,
          "10%": 0.91,
          "90%": 1.32,
          "25%": 1.0,
          "75%": 1.22
        },
        "51630": {
          "name": "Fredericksburg",
          "median": 1.115,
          "10%": 0.84,
          "90%": 1.31,
          "25%": 0.97,
          "75%": 1.24
        },
        "42057": {
          "name": "Fulton",
          "median": 1.185,
          "10%": 0.92,
          "90%": 1.32,
          "25%": 1.06,
          "75%": 1.25
        },
        "51640": {
          "name": "Galax",
          "median": 1.07,
          "10%": 0.87,
          "90%": 1.31,
          "25%": 0.95,
          "75%": 1.2
        },
        "24023": {
          "name": "Garrett",
          "median": 1.07,
          "10%": 0.99,
          "90%": 1.25,
          "25%": 1.01,
          "75%": 1.16
        },
        "51071": {
          "name": "Giles",
          "median": 1.1,
          "10%": 0.94,
          "90%": 1.26,
          "25%": 1.04,
          "75%": 1.17
        },
        "54021": {
          "name": "Gilmer",
          "median": 1.07,
          "10%": 0.92,
          "90%": 1.3,
          "25%": 0.99,
          "75%": 1.2
        },
        "34015": {
          "name": "Gloucester",
          "median": 1.11,
          "10%": 0.96,
          "90%": 1.29,
          "25%": 1.0175,
          "75%": 1.2
        },
        "51073": {
          "name": "Gloucester",
          "median": 1.01,
          "10%": 0.82,
          "90%": 1.27,
          "25%": 0.9,
          "75%": 1.12
        },
        "51075": {
          "name": "Goochland",
          "median": 1.09,
          "10%": 0.81,
          "90%": 1.55,
          "25%": 0.93,
          "75%": 1.31
        },
        "54023": {
          "name": "Grant",
          "median": 1.09,
          "10%": 0.95,
          "90%": 1.28,
          "25%": 1.03,
          "75%": 1.16
        },
        "51077": {
          "name": "Grayson",
          "median": 1.07,
          "10%": 0.99,
          "90%": 1.26,
          "25%": 1.03,
          "75%": 1.15
        },
        "54025": {
          "name": "Greenbrier",
          "median": 1.07,
          "10%": 0.93,
          "90%": 1.27,
          "25%": 1.0,
          "75%": 1.18
        },
        "36039": {
          "name": "Greene",
          "median": 1.14,
          "10%": 0.91,
          "90%": 1.3,
          "25%": 1.05,
          "75%": 1.23
        },
        "42059": {
          "name": "Greene",
          "median": 1.11,
          "10%": 0.99,
          "90%": 1.26,
          "25%": 1.05,
          "75%": 1.16
        },
        "51079": {
          "name": "Greene",
          "median": 1.12,
          "10%": 0.84,
          "90%": 1.37,
          "25%": 1.02,
          "75%": 1.28
        },
        "51081": {
          "name": "Greensville",
          "median": 1.04,
          "10%": 0.92,
          "90%": 1.29,
          "25%": 0.97,
          "75%": 1.2
        },
        "51083": {
          "name": "Halifax",
          "median": 1.15,
          "10%": 0.97,
          "90%": 1.26,
          "25%": 1.03,
          "75%": 1.22
        },
        "54027": {
          "name": "Hampshire",
          "median": 1.12,
          "10%": 0.96,
          "90%": 1.38,
          "25%": 1.02,
          "75%": 1.23
        },
        "51650": {
          "name": "Hampton",
          "median": 1.06,
          "10%": 0.87,
          "90%": 1.37,
          "25%": 0.97,
          "75%": 1.22
        },
        "54029": {
          "name": "Hancock",
          "median": 1.07,
          "10%": 0.91,
          "90%": 1.26,
          "25%": 0.99,
          "75%": 1.18
        },
        "51085": {
          "name": "Hanover",
          "median": 1.08,
          "10%": 0.91,
          "90%": 1.28,
          "25%": 0.99,
          "75%": 1.19
        },
        "54031": {
          "name": "Hardy",
          "median": 1.11,
          "10%": 0.94,
          "90%": 1.37,
          "25%": 1.03,
          "75%": 1.2
        },
        "24025": {
          "name": "Harford",
          "median": 1.09,
          "10%": 0.87,
          "90%": 1.31,
          "25%": 0.96,
          "75%": 1.16
        },
        "54033": {
          "name": "Harrison",
          "median": 1.08,
          "10%": 0.95,
          "90%": 1.23,
          "25%": 1.0,
          "75%": 1.13
        },
        "51660": {
          "name": "Harrisonburg",
          "median": 1.09,
          "10%": 0.84,
          "90%": 1.4,
          "25%": 0.97,
          "75%": 1.27
        },
        "51087": {
          "name": "Henrico",
          "median": 1.09,
          "10%": 0.91,
          "90%": 1.3,
          "25%": 0.98,
          "75%": 1.2
        },
        "51089": {
          "name": "Henry",
          "median": 1.14,
          "10%": 0.91,
          "90%": 1.35,
          "25%": 0.99,
          "75%": 1.24
        },
        "36043": {
          "name": "Herkimer",
          "median": 1.06,
          "10%": 0.87,
          "90%": 1.151,
          "25%": 0.96,
          "75%": 1.12
        },
        "51091": {
          "name": "Highland",
          "median": 1.08,
          "10%": 0.94,
          "90%": 1.29,
          "25%": 0.99,
          "75%": 1.18
        },
        "51670": {
          "name": "Hopewell",
          "median": 1.04,
          "10%": 0.86,
          "90%": 1.28,
          "25%": 0.96,
          "75%": 1.17
        },
        "24027": {
          "name": "Howard",
          "median": 1.11,
          "10%": 0.89,
          "90%": 1.25,
          "25%": 0.97,
          "75%": 1.2
        },
        "34019": {
          "name": "Hunterdon",
          "median": 1.11,
          "10%": 0.9,
          "90%": 1.38,
          "25%": 0.96,
          "75%": 1.21
        },
        "42061": {
          "name": "Huntingdon",
          "median": 1.13,
          "10%": 1.0,
          "90%": 1.3,
          "25%": 1.06,
          "75%": 1.21
        },
        "42063": {
          "name": "Indiana",
          "median": 1.07,
          "10%": 0.94,
          "90%": 1.28,
          "25%": 1.0,
          "75%": 1.17
        },
        "51093": {
          "name": "Isle of Wight",
          "median": 1.14,
          "10%": 0.87,
          "90%": 1.33,
          "25%": 0.98,
          "75%": 1.23
        },
        "54035": {
          "name": "Jackson",
          "median": 1.09,
          "10%": 0.98,
          "90%": 1.27,
          "25%": 1.03,
          "75%": 1.16
        },
        "51095": {
          "name": "James City",
          "median": 1.01,
          "10%": 0.81,
          "90%": 1.201,
          "25%": 0.89,
          "75%": 1.11
        },
        "42065": {
          "name": "Jefferson",
          "median": 1.05,
          "10%": 0.97,
          "90%": 1.24,
          "25%": 1.02,
          "75%": 1.16
        },
        "54037": {
          "name": "Jefferson",
          "median": 1.05,
          "10%": 0.9,
          "90%": 1.24,
          "25%": 0.99,
          "75%": 1.11
        },
        "42067": {
          "name": "Juniata",
          "median": 1.1,
          "10%": 0.96,
          "90%": 1.31,
          "25%": 1.02,
          "75%": 1.21
        },
        "54039": {
          "name": "Kanawha",
          "median": 1.05,
          "10%": 0.92,
          "90%": 1.18,
          "25%": 1.01,
          "75%": 1.12
        },
        "10001": {
          "name": "Kent",
          "median": 1.06,
          "10%": 0.88,
          "90%": 1.25,
          "25%": 0.96,
          "75%": 1.15
        },
        "24029": {
          "name": "Kent",
          "median": 1.06,
          "10%": 0.87,
          "90%": 1.25,
          "25%": 0.96,
          "75%": 1.16
        },
        "51099": {
          "name": "King George",
          "median": 1.04,
          "10%": 0.84,
          "90%": 1.28,
          "25%": 0.95,
          "75%": 1.17
        },
        "51101": {
          "name": "King William",
          "median": 1.03,
          "10%": 0.87,
          "90%": 1.27,
          "25%": 0.97,
          "75%": 1.14
        },
        "51097": {
          "name": "King and Queen",
          "median": 1.01,
          "10%": 0.84,
          "90%": 1.25,
          "25%": 0.94,
          "75%": 1.13
        },
        "42069": {
          "name": "Lackawanna",
          "median": 1.16,
          "10%": 0.94,
          "90%": 1.31,
          "25%": 1.09,
          "75%": 1.22
        },
        "42071": {
          "name": "Lancaster",
          "median": 1.1,
          "10%": 0.93,
          "90%": 1.32,
          "25%": 0.99,
          "75%": 1.21
        },
        "51103": {
          "name": "Lancaster",
          "median": 1.01,
          "10%": 0.8,
          "90%": 1.29,
          "25%": 0.92,
          "75%": 1.09
        },
        "42073": {
          "name": "Lawrence",
          "median": 1.06,
          "10%": 0.94,
          "90%": 1.25,
          "25%": 0.98,
          "75%": 1.13
        },
        "42075": {
          "name": "Lebanon",
          "median": 1.12,
          "10%": 0.92,
          "90%": 1.321,
          "25%": 1.01,
          "75%": 1.22
        },
        "51105": {
          "name": "Lee",
          "median": 1.11,
          "10%": 0.95,
          "90%": 1.34,
          "25%": 1.0175,
          "75%": 1.19
        },
        "42077": {
          "name": "Lehigh",
          "median": 1.1,
          "10%": 0.96,
          "90%": 1.25,
          "25%": 1.02,
          "75%": 1.19
        },
        "54041": {
          "name": "Lewis",
          "median": 1.07,
          "10%": 0.96,
          "90%": 1.21,
          "25%": 1.0,
          "75%": 1.15
        },
        "51678": {
          "name": "Lexington",
          "median": 1.07,
          "10%": 0.9,
          "90%": 1.331,
          "25%": 0.98,
          "75%": 1.17
        },
        "54043": {
          "name": "Lincoln",
          "median": 1.07,
          "10%": 0.93,
          "90%": 1.211,
          "25%": 0.99,
          "75%": 1.14
        },
        "36051": {
          "name": "Livingston",
          "median": 1.13,
          "10%": 1.0,
          "90%": 1.32,
          "25%": 1.06,
          "75%": 1.21
        },
        "54045": {
          "name": "Logan",
          "median": 1.1,
          "10%": 0.98,
          "90%": 1.24,
          "25%": 1.05,
          "75%": 1.16
        },
        "51107": {
          "name": "Loudoun",
          "median": 1.08,
          "10%": 0.91,
          "90%": 1.25,
          "25%": 0.98,
          "75%": 1.17
        },
        "51109": {
          "name": "Louisa",
          "median": 1.1,
          "10%": 0.87,
          "90%": 1.36,
          "25%": 0.98,
          "75%": 1.25
        },
        "51111": {
          "name": "Lunenburg",
          "median": 1.13,
          "10%": 0.9,
          "90%": 1.32,
          "25%": 1.04,
          "75%": 1.24
        },
        "42079": {
          "name": "Luzerne",
          "median": 1.14,
          "10%": 0.99,
          "90%": 1.26,
          "25%": 1.07,
          "75%": 1.2
        },
        "42081": {
          "name": "Lycoming",
          "median": 1.15,
          "10%": 0.97,
          "90%": 1.32,
          "25%": 1.05,
          "75%": 1.22
        },
        "51680": {
          "name": "Lynchburg",
          "median": 1.12,
          "10%": 0.95,
          "90%": 1.26,
          "25%": 1.01,
          "75%": 1.18
        },
        "36053": {
          "name": "Madison",
          "median": 1.06,
          "10%": 0.92,
          "90%": 1.2,
          "25%": 0.97,
          "75%": 1.15
        },
        "51113": {
          "name": "Madison",
          "median": 1.09,
          "10%": 0.88,
          "90%": 1.39,
          "25%": 0.99,
          "75%": 1.26
        },
        "51683": {
          "name": "Manassas",
          "median": 1.02,
          "10%": 0.919,
          "90%": 1.23,
          "25%": 0.97,
          "75%": 1.12
        },
        "51685": {
          "name": "Manassas Park",
          "median": 1.01,
          "10%": 0.92,
          "90%": 1.25,
          "25%": 0.95,
          "75%": 1.11
        },
        "54049": {
          "name": "Marion",
          "median": 1.05,
          "10%": 0.91,
          "90%": 1.24,
          "25%": 0.96,
          "75%": 1.17
        },
        "54051": {
          "name": "Marshall",
          "median": 1.08,
          "10%": 0.93,
          "90%": 1.31,
          "25%": 1.01,
          "75%": 1.19
        },
        "51690": {
          "name": "Martinsville",
          "median": 1.14,
          "10%": 0.87,
          "90%": 1.38,
          "25%": 0.96,
          "75%": 1.24
        },
        "54053": {
          "name": "Mason",
          "median": 1.09,
          "10%": 0.99,
          "90%": 1.271,
          "25%": 1.04,
          "75%": 1.17
        },
        "51115": {
          "name": "Mathews",
          "median": 1.07,
          "10%": 0.79,
          "90%": 1.29,
          "25%": 0.93,
          "75%": 1.17
        },
        "54047": {
          "name": "McDowell",
          "median": 1.08,
          "10%": 0.98,
          "90%": 1.21,
          "25%": 1.03,
          "75%": 1.16
        },
        "42083": {
          "name": "McKean",
          "median": 1.07,
          "10%": 0.93,
          "90%": 1.19,
          "25%": 0.99,
          "75%": 1.14
        },
        "51117": {
          "name": "Mecklenburg",
          "median": 1.12,
          "10%": 0.95,
          "90%": 1.23,
          "25%": 1.02,
          "75%": 1.18
        },
        "34021": {
          "name": "Mercer",
          "median": 1.08,
          "10%": 0.92,
          "90%": 1.31,
          "25%": 0.98,
          "75%": 1.19
        },
        "42085": {
          "name": "Mercer",
          "median": 1.07,
          "10%": 0.97,
          "90%": 1.21,
          "25%": 1.03,
          "75%": 1.13
        },
        "54055": {
          "name": "Mercer",
          "median": 1.09,
          "10%": 0.99,
          "90%": 1.23,
          "25%": 1.05,
          "75%": 1.17
        },
        "51119": {
          "name": "Middlesex",
          "median": 1.03,
          "10%": 0.81,
          "90%": 1.29,
          "25%": 0.92,
          "75%": 1.1
        },
        "42087": {
          "name": "Mifflin",
          "median": 1.13,
          "10%": 0.95,
          "90%": 1.29,
          "25%": 1.06,
          "75%": 1.19
        },
        "54057": {
          "name": "Mineral",
          "median": 1.09,
          "10%": 1.0,
          "90%": 1.34,
          "25%": 1.05,
          "75%": 1.23
        },
        "54059": {
          "name": "Mingo",
          "median": 1.11,
          "10%": 1.01,
          "90%": 1.28,
          "25%": 1.05,
          "75%": 1.18
        },
        "34025": {
          "name": "Monmouth",
          "median": 1.05,
          "10%": 0.92,
          "90%": 1.26,
          "25%": 0.99,
          "75%": 1.19
        },
        "54061": {
          "name": "Monongalia",
          "median": 1.08,
          "10%": 0.97,
          "90%": 1.26,
          "25%": 1.01,
          "75%": 1.14
        },
        "42089": {
          "name": "Monroe",
          "median": 1.11,
          "10%": 0.97,
          "90%": 1.25,
          "25%": 1.04,
          "75%": 1.18
        },
        "54063": {
          "name": "Monroe",
          "median": 1.07,
          "10%": 0.96,
          "90%": 1.26,
          "25%": 1.02,
          "75%": 1.17
        },
        "24031": {
          "name": "Montgomery",
          "median": 1.12,
          "10%": 0.94,
          "90%": 1.241,
          "25%": 1.0,
          "75%": 1.19
        },
        "36057": {
          "name": "Montgomery",
          "median": 1.05,
          "10%": 0.94,
          "90%": 1.22,
          "25%": 1.0,
          "75%": 1.16
        },
        "42091": {
          "name": "Montgomery",
          "median": 1.1,
          "10%": 0.95,
          "90%": 1.22,
          "25%": 1.02,
          "75%": 1.16
        },
        "51121": {
          "name": "Montgomery",
          "median": 1.13,
          "10%": 0.97,
          "90%": 1.3,
          "25%": 1.05,
          "75%": 1.22
        },
        "42093": {
          "name": "Montour",
          "median": 1.18,
          "10%": 0.96,
          "90%": 1.38,
          "25%": 1.03,
          "75%": 1.3
        },
        "54065": {
          "name": "Morgan",
          "median": 1.16,
          "10%": 0.9,
          "90%": 1.35,
          "25%": 1.06,
          "75%": 1.23
        },
        "34027": {
          "name": "Morris",
          "median": 1.14,
          "10%": 0.91,
          "90%": 1.42,
          "25%": 1.01,
          "75%": 1.28
        },
        "36059": {
          "name": "Nassau",
          "median": 1.11,
          "10%": 0.94,
          "90%": 1.32,
          "25%": 1.01,
          "75%": 1.21
        },
        "51125": {
          "name": "Nelson",
          "median": 1.15,
          "10%": 0.859,
          "90%": 1.48,
          "25%": 1.0,
          "75%": 1.26
        },
        "10003": {
          "name": "New Castle",
          "median": 1.1,
          "10%": 0.91,
          "90%": 1.3,
          "25%": 0.99,
          "75%": 1.18
        },
        "51127": {
          "name": "New Kent",
          "median": 1.02,
          "10%": 0.88,
          "90%": 1.2,
          "25%": 0.97,
          "75%": 1.12
        },
        "36061": {
          "name": "New York",
          "median": 1.04,
          "10%": 0.84,
          "90%": 1.22,
          "25%": 0.95,
          "75%": 1.14
        },
        "51700": {
          "name": "Newport News",
          "median": 1.04,
          "10%": 0.86,
          "90%": 1.311,
          "25%": 0.94,
          "75%": 1.19
        },
        "54067": {
          "name": "Nicholas",
          "median": 1.03,
          "10%": 0.92,
          "90%": 1.17,
          "25%": 0.96,
          "75%": 1.12
        },
        "51710": {
          "name": "Norfolk",
          "median": 1.075,
          "10%": 0.85,
          "90%": 1.51,
          "25%": 0.93,
          "75%": 1.24
        },
        "42095": {
          "name": "Northampton",
          "median": 1.08,
          "10%": 0.93,
          "90%": 1.22,
          "25%": 1.0,
          "75%": 1.15
        },
        "51131": {
          "name": "Northampton",
          "median": 1.07,
          "10%": 0.86,
          "90%": 1.27,
          "25%": 0.96,
          "75%": 1.21
        },
        "42097": {
          "name": "Northumberland",
          "median": 1.16,
          "10%": 0.94,
          "90%": 1.41,
          "25%": 1.07,
          "75%": 1.31
        },
        "51133": {
          "name": "Northumberland",
          "median": 1.0,
          "10%": 0.79,
          "90%": 1.31,
          "25%": 0.88,
          "75%": 1.1
        },
        "51720": {
          "name": "Norton",
          "median": 1.13,
          "10%": 0.88,
          "90%": 1.3,
          "25%": 1.0,
          "75%": 1.24
        },
        "51135": {
          "name": "Nottoway",
          "median": 1.13,
          "10%": 0.9,
          "90%": 1.37,
          "25%": 1.0,
          "75%": 1.27
        },
        "34029": {
          "name": "Ocean",
          "median": 1.08,
          "10%": 0.96,
          "90%": 1.24,
          "25%": 1.0,
          "75%": 1.17
        },
        "54069": {
          "name": "Ohio",
          "median": 1.09,
          "10%": 0.94,
          "90%": 1.3,
          "25%": 1.0,
          "75%": 1.2
        },
        "36065": {
          "name": "Oneida",
          "median": 1.07,
          "10%": 0.93,
          "90%": 1.23,
          "25%": 1.02,
          "75%": 1.15
        },
        "36067": {
          "name": "Onondaga",
          "median": 1.1,
          "10%": 0.92,
          "90%": 1.33,
          "25%": 1.01,
          "75%": 1.17
        },
        "36069": {
          "name": "Ontario",
          "median": 1.12,
          "10%": 0.99,
          "90%": 1.31,
          "25%": 1.05,
          "75%": 1.22
        },
        "36071": {
          "name": "Orange",
          "median": 1.14,
          "10%": 0.95,
          "90%": 1.34,
          "25%": 1.01,
          "75%": 1.23
        },
        "51137": {
          "name": "Orange",
          "median": 1.12,
          "10%": 0.93,
          "90%": 1.28,
          "25%": 1.02,
          "75%": 1.23
        },
        "36077": {
          "name": "Otsego",
          "median": 1.05,
          "10%": 0.94,
          "90%": 1.23,
          "25%": 1.0,
          "75%": 1.11
        },
        "51139": {
          "name": "Page",
          "median": 1.12,
          "10%": 0.9,
          "90%": 1.48,
          "25%": 0.97,
          "75%": 1.27
        },
        "51141": {
          "name": "Patrick",
          "median": 1.11,
          "10%": 0.96,
          "90%": 1.32,
          "25%": 1.02,
          "75%": 1.21
        },
        "54071": {
          "name": "Pendleton",
          "median": 1.09,
          "10%": 0.91,
          "90%": 1.32,
          "25%": 1.01,
          "75%": 1.23
        },
        "42099": {
          "name": "Perry",
          "median": 1.12,
          "10%": 0.9,
          "90%": 1.29,
          "25%": 0.99,
          "75%": 1.21
        },
        "51730": {
          "name": "Petersburg",
          "median": 1.07,
          "10%": 0.87,
          "90%": 1.29,
          "25%": 0.94,
          "75%": 1.19
        },
        "42101": {
          "name": "Philadelphia",
          "median": 1.08,
          "10%": 0.96,
          "90%": 1.23,
          "25%": 1.0,
          "75%": 1.14
        },
        "42103": {
          "name": "Pike",
          "median": 1.1,
          "10%": 0.99,
          "90%": 1.31,
          "25%": 1.04,
          "75%": 1.2
        },
        "51143": {
          "name": "Pittsylvania",
          "median": 1.12,
          "10%": 0.97,
          "90%": 1.29,
          "25%": 1.06,
          "75%": 1.18
        },
        "54073": {
          "name": "Pleasants",
          "median": 1.05,
          "10%": 0.93,
          "90%": 1.23,
          "25%": 0.99,
          "75%": 1.14
        },
        "54075": {
          "name": "Pocahontas",
          "median": 1.08,
          "10%": 0.95,
          "90%": 1.28,
          "25%": 1.0,
          "75%": 1.21
        },
        "51735": {
          "name": "Poquoson",
          "median": 1.03,
          "10%": 0.87,
          "90%": 1.34,
          "25%": 0.95,
          "75%": 1.22
        },
        "51740": {
          "name": "Portsmouth",
          "median": 1.06,
          "10%": 0.84,
          "90%": 1.49,
          "25%": 0.94,
          "75%": 1.26
        },
        "42105": {
          "name": "Potter",
          "median": 1.1,
          "10%": 0.96,
          "90%": 1.25,
          "25%": 1.01,
          "75%": 1.16
        },
        "51145": {
          "name": "Powhatan",
          "median": 1.1,
          "10%": 0.85,
          "90%": 1.53,
          "25%": 0.95,
          "75%": 1.27
        },
        "54077": {
          "name": "Preston",
          "median": 1.1,
          "10%": 0.98,
          "90%": 1.28,
          "25%": 1.03,
          "75%": 1.18
        },
        "51147": {
          "name": "Prince Edward",
          "median": 1.08,
          "10%": 0.94,
          "90%": 1.32,
          "25%": 1.01,
          "75%": 1.2
        },
        "51149": {
          "name": "Prince George",
          "median": 1.04,
          "10%": 0.89,
          "90%": 1.23,
          "25%": 0.95,
          "75%": 1.18
        },
        "24033": {
          "name": "Prince George's",
          "median": 1.08,
          "10%": 0.92,
          "90%": 1.3,
          "25%": 0.99,
          "75%": 1.18
        },
        "51153": {
          "name": "Prince William",
          "median": 1.04,
          "10%": 0.92,
          "90%": 1.22,
          "25%": 0.97,
          "75%": 1.14
        },
        "51155": {
          "name": "Pulaski",
          "median": 1.12,
          "10%": 1.02,
          "90%": 1.28,
          "25%": 1.05,
          "75%": 1.2
        },
        "54079": {
          "name": "Putnam",
          "median": 1.07,
          "10%": 0.94,
          "90%": 1.24,
          "25%": 1.01,
          "75%": 1.15
        },
        "24035": {
          "name": "Queen Anne's",
          "median": 1.05,
          "10%": 0.87,
          "90%": 1.27,
          "25%": 0.96,
          "75%": 1.15
        },
        "51750": {
          "name": "Radford",
          "median": 1.15,
          "10%": 0.99,
          "90%": 1.36,
          "25%": 1.04,
          "75%": 1.27
        },
        "54081": {
          "name": "Raleigh",
          "median": 1.12,
          "10%": 0.92,
          "90%": 1.28,
          "25%": 1.01,
          "75%": 1.19
        },
        "54083": {
          "name": "Randolph",
          "median": 1.09,
          "10%": 0.96,
          "90%": 1.24,
          "25%": 1.02,
          "75%": 1.15
        },
        "51157": {
          "name": "Rappahannock",
          "median": 1.09,
          "10%": 0.9,
          "90%": 1.33,
          "25%": 0.98,
          "75%": 1.16
        },
        "36085": {
          "name": "Richmond",
          "median": 1.04,
          "10%": 0.84,
          "90%": 1.3,
          "25%": 0.94,
          "75%": 1.19
        },
        "51159": {
          "name": "Richmond",
          "median": 1.0,
          "10%": 0.8,
          "90%": 1.3,
          "25%": 0.9,
          "75%": 1.12
        },
        "51760": {
          "name": "Richmond",
          "median": 1.08,
          "10%": 0.9,
          "90%": 1.37,
          "25%": 0.98,
          "75%": 1.25
        },
        "54085": {
          "name": "Ritchie",
          "median": 1.1,
          "10%": 0.95,
          "90%": 1.22,
          "25%": 1.02,
          "75%": 1.17
        },
        "54087": {
          "name": "Roane",
          "median": 1.06,
          "10%": 0.96,
          "90%": 1.24,
          "25%": 1.02,
          "75%": 1.15
        },
        "51161": {
          "name": "Roanoke",
          "median": 1.16,
          "10%": 0.98,
          "90%": 1.37,
          "25%": 1.02,
          "75%": 1.26
        },
        "51770": {
          "name": "Roanoke",
          "median": 1.19,
          "10%": 0.95,
          "90%": 1.45,
          "25%": 1.02,
          "75%": 1.3
        },
        "51163": {
          "name": "Rockbridge",
          "median": 1.12,
          "10%": 0.95,
          "90%": 1.34,
          "25%": 1.04,
          "75%": 1.24
        },
        "51165": {
          "name": "Rockingham",
          "median": 1.08,
          "10%": 0.88,
          "90%": 1.37,
          "25%": 0.96,
          "75%": 1.24
        },
        "51167": {
          "name": "Russell",
          "median": 1.05,
          "10%": 0.95,
          "90%": 1.22,
          "25%": 1.0,
          "75%": 1.1
        },
        "34033": {
          "name": "Salem",
          "median": 1.08,
          "10%": 0.95,
          "90%": 1.29,
          "25%": 1.0,
          "75%": 1.21
        },
        "51775": {
          "name": "Salem",
          "median": 1.16,
          "10%": 0.96,
          "90%": 1.42,
          "25%": 1.02,
          "75%": 1.29
        },
        "36095": {
          "name": "Schoharie",
          "median": 1.11,
          "10%": 0.92,
          "90%": 1.27,
          "25%": 1.02,
          "75%": 1.18
        },
        "36097": {
          "name": "Schuyler",
          "median": 1.12,
          "10%": 1.02,
          "90%": 1.28,
          "25%": 1.07,
          "75%": 1.2
        },
        "42107": {
          "name": "Schuylkill",
          "median": 1.12,
          "10%": 0.96,
          "90%": 1.35,
          "25%": 1.04,
          "75%": 1.24
        },
        "51169": {
          "name": "Scott",
          "median": 1.11,
          "10%": 0.94,
          "90%": 1.24,
          "25%": 1.0,
          "75%": 1.18
        },
        "51171": {
          "name": "Shenandoah",
          "median": 1.09,
          "10%": 0.91,
          "90%": 1.36,
          "25%": 0.98,
          "75%": 1.21
        },
        "51173": {
          "name": "Smyth",
          "median": 1.09,
          "10%": 0.97,
          "90%": 1.2,
          "25%": 1.02,
          "75%": 1.13
        },
        "42109": {
          "name": "Snyder",
          "median": 1.16,
          "10%": 0.93,
          "90%": 1.38,
          "25%": 1.05,
          "75%": 1.27
        },
        "24039": {
          "name": "Somerset",
          "median": 1.06,
          "10%": 0.89,
          "90%": 1.29,
          "25%": 0.9975,
          "75%": 1.16
        },
        "42111": {
          "name": "Somerset",
          "median": 1.08,
          "10%": 1.0,
          "90%": 1.22,
          "25%": 1.04,
          "75%": 1.15
        },
        "51175": {
          "name": "Southampton",
          "median": 1.09,
          "10%": 0.95,
          "90%": 1.31,
          "25%": 1.01,
          "75%": 1.2
        },
        "51177": {
          "name": "Spotsylvania",
          "median": 1.07,
          "10%": 0.87,
          "90%": 1.26,
          "25%": 0.99,
          "75%": 1.17
        },
        "24037": {
          "name": "St. Mary's",
          "median": 1.02,
          "10%": 0.839,
          "90%": 1.23,
          "25%": 0.92,
          "75%": 1.11
        },
        "51179": {
          "name": "Stafford",
          "median": 1.09,
          "10%": 0.86,
          "90%": 1.32,
          "25%": 1.01,
          "75%": 1.21
        },
        "51790": {
          "name": "Staunton",
          "median": 1.11,
          "10%": 0.87,
          "90%": 1.46,
          "25%": 0.95,
          "75%": 1.22
        },
        "36101": {
          "name": "Steuben",
          "median": 1.09,
          "10%": 0.96,
          "90%": 1.28,
          "25%": 1.03,
          "75%": 1.17
        },
        "51800": {
          "name": "Suffolk",
          "median": 1.14,
          "10%": 0.92,
          "90%": 1.35,
          "25%": 0.98,
          "75%": 1.24
        },
        "36105": {
          "name": "Sullivan",
          "median": 1.12,
          "10%": 0.97,
          "90%": 1.27,
          "25%": 1.06,
          "75%": 1.2
        },
        "42113": {
          "name": "Sullivan",
          "median": 1.16,
          "10%": 0.92,
          "90%": 1.34,
          "25%": 1.06,
          "75%": 1.24
        },
        "54089": {
          "name": "Summers",
          "median": 1.08,
          "10%": 0.94,
          "90%": 1.28,
          "25%": 1.0,
          "75%": 1.15
        },
        "51181": {
          "name": "Surry",
          "median": 1.07,
          "10%": 0.88,
          "90%": 1.26,
          "25%": 0.96,
          "75%": 1.16
        },
        "42115": {
          "name": "Susquehanna",
          "median": 1.15,
          "10%": 1.02,
          "90%": 1.28,
          "25%": 1.09,
          "75%": 1.22
        },
        "10005": {
          "name": "Sussex",
          "median": 1.05,
          "10%": 0.9,
          "90%": 1.25,
          "25%": 0.99,
          "75%": 1.13
        },
        "34037": {
          "name": "Sussex",
          "median": 1.14,
          "10%": 0.94,
          "90%": 1.31,
          "25%": 1.03,
          "75%": 1.22
        },
        "51183": {
          "name": "Sussex",
          "median": 1.06,
          "10%": 0.92,
          "90%": 1.27,
          "25%": 0.98,
          "75%": 1.2
        },
        "24041": {
          "name": "Talbot",
          "median": 1.04,
          "10%": 0.87,
          "90%": 1.3,
          "25%": 0.94,
          "75%": 1.15
        },
        "54091": {
          "name": "Taylor",
          "median": 1.08,
          "10%": 0.96,
          "90%": 1.27,
          "25%": 1.02,
          "75%": 1.15
        },
        "51185": {
          "name": "Tazewell",
          "median": 1.09,
          "10%": 0.97,
          "90%": 1.2,
          "25%": 1.01,
          "75%": 1.15
        },
        "36107": {
          "name": "Tioga",
          "median": 1.13,
          "10%": 0.99,
          "90%": 1.31,
          "25%": 1.07,
          "75%": 1.21
        },
        "42117": {
          "name": "Tioga",
          "median": 1.11,
          "10%": 0.95,
          "90%": 1.31,
          "25%": 1.0,
          "75%": 1.2
        },
        "36109": {
          "name": "Tompkins",
          "median": 1.12,
          "10%": 0.99,
          "90%": 1.34,
          "25%": 1.06,
          "75%": 1.19
        },
        "54093": {
          "name": "Tucker",
          "median": 1.08,
          "10%": 0.96,
          "90%": 1.22,
          "25%": 1.01,
          "75%": 1.15
        },
        "54095": {
          "name": "Tyler",
          "median": 1.04,
          "10%": 0.91,
          "90%": 1.2,
          "25%": 0.99,
          "75%": 1.12
        },
        "36111": {
          "name": "Ulster",
          "median": 1.14,
          "10%": 0.97,
          "90%": 1.35,
          "25%": 1.07,
          "75%": 1.23
        },
        "42119": {
          "name": "Union",
          "median": 1.14,
          "10%": 0.97,
          "90%": 1.32,
          "25%": 1.04,
          "75%": 1.2325
        },
        "54097": {
          "name": "Upshur",
          "median": 1.07,
          "10%": 0.94,
          "90%": 1.25,
          "25%": 0.99,
          "75%": 1.16
        },
        "42121": {
          "name": "Venango",
          "median": 1.07,
          "10%": 0.94,
          "90%": 1.23,
          "25%": 1.02,
          "75%": 1.15
        },
        "51810": {
          "name": "Virginia Beach",
          "median": 1.1,
          "10%": 0.89,
          "90%": 1.42,
          "25%": 0.98,
          "75%": 1.21
        },
        "34041": {
          "name": "Warren",
          "median": 1.12,
          "10%": 0.91,
          "90%": 1.31,
          "25%": 0.99,
          "75%": 1.2
        },
        "42123": {
          "name": "Warren",
          "median": 1.05,
          "10%": 0.97,
          "90%": 1.23,
          "25%": 1.01,
          "75%": 1.15
        },
        "51187": {
          "name": "Warren",
          "median": 1.11,
          "10%": 0.9,
          "90%": 1.34,
          "25%": 0.97,
          "75%": 1.21
        },
        "24043": {
          "name": "Washington",
          "median": 1.12,
          "10%": 0.88,
          "90%": 1.3,
          "25%": 1.01,
          "75%": 1.2
        },
        "42125": {
          "name": "Washington",
          "median": 1.1,
          "10%": 0.96,
          "90%": 1.24,
          "25%": 1.03,
          "75%": 1.17
        },
        "51191": {
          "name": "Washington",
          "median": 1.06,
          "10%": 0.95,
          "90%": 1.17,
          "25%": 1.0,
          "75%": 1.12
        },
        "42127": {
          "name": "Wayne",
          "median": 1.13,
          "10%": 0.97,
          "90%": 1.31,
          "25%": 1.05,
          "75%": 1.21
        },
        "54099": {
          "name": "Wayne",
          "median": 1.08,
          "10%": 0.96,
          "90%": 1.24,
          "25%": 1.01,
          "75%": 1.17
        },
        "51820": {
          "name": "Waynesboro",
          "median": 1.12,
          "10%": 0.86,
          "90%": 1.4,
          "25%": 0.99,
          "75%": 1.25
        },
        "54101": {
          "name": "Webster",
          "median": 1.03,
          "10%": 0.93,
          "90%": 1.22,
          "25%": 0.96,
          "75%": 1.15
        },
        "36119": {
          "name": "Westchester",
          "median": 1.08,
          "10%": 0.92,
          "90%": 1.27,
          "25%": 0.98,
          "75%": 1.18
        },
        "42129": {
          "name": "Westmoreland",
          "median": 1.08,
          "10%": 0.94,
          "90%": 1.23,
          "25%": 1.0,
          "75%": 1.15
        },
        "51193": {
          "name": "Westmoreland",
          "median": 0.99,
          "10%": 0.83,
          "90%": 1.23,
          "25%": 0.92,
          "75%": 1.12
        },
        "54103": {
          "name": "Wetzel",
          "median": 1.08,
          "10%": 0.95,
          "90%": 1.25,
          "25%": 1.01,
          "75%": 1.15
        },
        "24045": {
          "name": "Wicomico",
          "median": 1.05,
          "10%": 0.92,
          "90%": 1.19,
          "25%": 0.98,
          "75%": 1.12
        },
        "51830": {
          "name": "Williamsburg",
          "median": 1.0,
          "10%": 0.77,
          "90%": 1.24,
          "25%": 0.87,
          "75%": 1.1
        },
        "51840": {
          "name": "Winchester",
          "median": 1.1,
          "10%": 0.88,
          "90%": 1.32,
          "25%": 0.99,
          "75%": 1.23
        },
        "54105": {
          "name": "Wirt",
          "median": 1.11,
          "10%": 0.95,
          "90%": 1.26,
          "25%": 1.04,
          "75%": 1.19
        },
        "51195": {
          "name": "Wise",
          "median": 1.1,
          "10%": 0.92,
          "90%": 1.25,
          "25%": 1.0,
          "75%": 1.19
        },
        "54107": {
          "name": "Wood",
          "median": 1.09,
          "10%": 0.94,
          "90%": 1.27,
          "25%": 1.0,
          "75%": 1.17
        },
        "24047": {
          "name": "Worcester",
          "median": 1.06,
          "10%": 0.9,
          "90%": 1.27,
          "25%": 0.97,
          "75%": 1.2
        },
        "42131": {
          "name": "Wyoming",
          "median": 1.15,
          "10%": 0.97,
          "90%": 1.31,
          "25%": 1.09,
          "75%": 1.23
        },
        "54109": {
          "name": "Wyoming",
          "median": 1.13,
          "10%": 0.97,
          "90%": 1.23,
          "25%": 1.05,
          "75%": 1.17
        },
        "51197": {
          "name": "Wythe",
          "median": 1.07,
          "10%": 0.99,
          "90%": 1.22,
          "25%": 1.03,
          "75%": 1.16
        },
        "36123": {
          "name": "Yates",
          "median": 1.15,
          "10%": 0.96,
          "90%": 1.36,
          "25%": 1.07,
          "75%": 1.22
        },
        "42133": {
          "name": "York",
          "median": 1.11,
          "10%": 0.93,
          "90%": 1.37,
          "25%": 0.99,
          "75%": 1.27
        },
        "51199": {
          "name": "York",
          "median": 1.03,
          "10%": 0.83,
          "90%": 1.25,
          "25%": 0.9,
          "75%": 1.14
        },
        "max": 1.19,
        "min": 0.99
      },
      "100": {
        "51001": {
          "name": "Accomack",
          "median": 1.07,
          "10%": 0.87,
          "90%": 1.33,
          "25%": 0.96,
          "75%": 1.2225
        },
        "42001": {
          "name": "Adams",
          "median": 1.05,
          "10%": 0.78,
          "90%": 1.42,
          "25%": 0.9,
          "75%": 1.16
        },
        "51003": {
          "name": "Albemarle",
          "median": 1.13,
          "10%": 0.89,
          "90%": 1.43,
          "25%": 1.0,
          "75%": 1.28
        },
        "51510": {
          "name": "Alexandria",
          "median": 1.07,
          "10%": 0.84,
          "90%": 1.38,
          "25%": 0.94,
          "75%": 1.2225
        },
        "24001": {
          "name": "Allegany",
          "median": 1.11,
          "10%": 0.97,
          "90%": 1.46,
          "25%": 1.02,
          "75%": 1.25
        },
        "36003": {
          "name": "Allegany",
          "median": 1.08,
          "10%": 0.89,
          "90%": 1.321,
          "25%": 0.99,
          "75%": 1.2
        },
        "51005": {
          "name": "Alleghany",
          "median": 1.16,
          "10%": 0.94,
          "90%": 1.51,
          "25%": 1.05,
          "75%": 1.31
        },
        "42003": {
          "name": "Allegheny",
          "median": 1.11,
          "10%": 0.899,
          "90%": 1.26,
          "25%": 1.02,
          "75%": 1.16
        },
        "51007": {
          "name": "Amelia",
          "median": 1.15,
          "10%": 0.83,
          "90%": 1.66,
          "25%": 0.94,
          "75%": 1.41
        },
        "51009": {
          "name": "Amherst",
          "median": 1.14,
          "10%": 0.92,
          "90%": 1.39,
          "25%": 1.02,
          "75%": 1.25
        },
        "24003": {
          "name": "Anne Arundel",
          "median": 1.05,
          "10%": 0.86,
          "90%": 1.39,
          "25%": 0.95,
          "75%": 1.18
        },
        "51011": {
          "name": "Appomattox",
          "median": 1.12,
          "10%": 0.86,
          "90%": 1.41,
          "25%": 1.01,
          "75%": 1.26
        },
        "51013": {
          "name": "Arlington",
          "median": 1.05,
          "10%": 0.87,
          "90%": 1.32,
          "25%": 0.95,
          "75%": 1.22
        },
        "42005": {
          "name": "Armstrong",
          "median": 1.11,
          "10%": 0.89,
          "90%": 1.291,
          "25%": 0.98,
          "75%": 1.19
        },
        "34001": {
          "name": "Atlantic",
          "median": 1.12,
          "10%": 0.85,
          "90%": 1.35,
          "25%": 1.0,
          "75%": 1.23
        },
        "51015": {
          "name": "Augusta",
          "median": 1.11,
          "10%": 0.85,
          "90%": 1.3,
          "25%": 0.99,
          "75%": 1.2025
        },
        "24005": {
          "name": "Baltimore",
          "median": 1.07,
          "10%": 0.89,
          "90%": 1.43,
          "25%": 0.99,
          "75%": 1.2
        },
        "24510": {
          "name": "Baltimore",
          "median": 1.08,
          "10%": 0.83,
          "90%": 1.4,
          "25%": 0.92,
          "75%": 1.19
        },
        "54001": {
          "name": "Barbour",
          "median": 1.05,
          "10%": 0.93,
          "90%": 1.3,
          "25%": 0.99,
          "75%": 1.16
        },
        "51017": {
          "name": "Bath",
          "median": 1.12,
          "10%": 0.95,
          "90%": 1.42,
          "25%": 1.04,
          "75%": 1.29
        },
        "42007": {
          "name": "Beaver",
          "median": 1.08,
          "10%": 0.86,
          "90%": 1.25,
          "25%": 0.97,
          "75%": 1.18
        },
        "42009": {
          "name": "Bedford",
          "median": 1.17,
          "10%": 0.96,
          "90%": 1.35,
          "25%": 1.08,
          "75%": 1.28
        },
        "51019": {
          "name": "Bedford",
          "median": 1.14,
          "10%": 0.97,
          "90%": 1.37,
          "25%": 1.06,
          "75%": 1.22
        },
        "54003": {
          "name": "Berkeley",
          "median": 1.12,
          "10%": 0.89,
          "90%": 1.31,
          "25%": 1.0,
          "75%": 1.2
        },
        "42011": {
          "name": "Berks",
          "median": 1.11,
          "10%": 0.93,
          "90%": 1.29,
          "25%": 1.01,
          "75%": 1.22
        },
        "42013": {
          "name": "Blair",
          "median": 1.15,
          "10%": 0.97,
          "90%": 1.31,
          "25%": 1.08,
          "75%": 1.22
        },
        "51021": {
          "name": "Bland",
          "median": 1.14,
          "10%": 0.95,
          "90%": 1.34,
          "25%": 1.01,
          "75%": 1.23
        },
        "54005": {
          "name": "Boone",
          "median": 1.09,
          "10%": 0.96,
          "90%": 1.25,
          "25%": 1.02,
          "75%": 1.17
        },
        "51023": {
          "name": "Botetourt",
          "median": 1.16,
          "10%": 0.98,
          "90%": 1.41,
          "25%": 1.04,
          "75%": 1.3
        },
        "42015": {
          "name": "Bradford",
          "median": 1.18,
          "10%": 0.91,
          "90%": 1.45,
          "25%": 1.08,
          "75%": 1.29
        },
        "54007": {
          "name": "Braxton",
          "median": 1.05,
          "10%": 0.88,
          "90%": 1.29,
          "25%": 0.97,
          "75%": 1.15
        },
        "51520": {
          "name": "Bristol",
          "median": 1.09,
          "10%": 0.91,
          "90%": 1.29,
          "25%": 0.9875,
          "75%": 1.19
        },
        "36005": {
          "name": "Bronx",
          "median": 1.03,
          "10%": 0.86,
          "90%": 1.24,
          "25%": 0.94,
          "75%": 1.15
        },
        "54009": {
          "name": "Brooke",
          "median": 1.08,
          "10%": 0.85,
          "90%": 1.38,
          "25%": 0.97,
          "75%": 1.24
        },
        "36007": {
          "name": "Broome",
          "median": 1.12,
          "10%": 1.01,
          "90%": 1.27,
          "25%": 1.06,
          "75%": 1.2
        },
        "51025": {
          "name": "Brunswick",
          "median": 1.07,
          "10%": 0.87,
          "90%": 1.41,
          "25%": 0.98,
          "75%": 1.27
        },
        "51027": {
          "name": "Buchanan",
          "median": 1.07,
          "10%": 0.97,
          "90%": 1.19,
          "25%": 1.01,
          "75%": 1.13
        },
        "51029": {
          "name": "Buckingham",
          "median": 1.13,
          "10%": 0.91,
          "90%": 1.36,
          "25%": 0.97,
          "75%": 1.22
        },
        "42017": {
          "name": "Bucks",
          "median": 1.07,
          "10%": 0.92,
          "90%": 1.31,
          "25%": 1.0,
          "75%": 1.16
        },
        "51530": {
          "name": "Buena Vista",
          "median": 1.12,
          "10%": 0.85,
          "90%": 1.38,
          "25%": 1.01,
          "75%": 1.24
        },
        "34005": {
          "name": "Burlington",
          "median": 1.09,
          "10%": 0.94,
          "90%": 1.29,
          "25%": 1.0,
          "75%": 1.21
        },
        "42019": {
          "name": "Butler",
          "median": 1.06,
          "10%": 0.91,
          "90%": 1.21,
          "25%": 0.99,
          "75%": 1.13
        },
        "54011": {
          "name": "Cabell",
          "median": 1.04,
          "10%": 0.89,
          "90%": 1.25,
          "25%": 0.97,
          "75%": 1.16
        },
        "54013": {
          "name": "Calhoun",
          "median": 1.11,
          "10%": 0.89,
          "90%": 1.34,
          "25%": 1.02,
          "75%": 1.19
        },
        "24009": {
          "name": "Calvert",
          "median": 1.02,
          "10%": 0.84,
          "90%": 1.33,
          "25%": 0.95,
          "75%": 1.22
        },
        "42021": {
          "name": "Cambria",
          "median": 1.09,
          "10%": 0.91,
          "90%": 1.31,
          "25%": 0.99,
          "75%": 1.19
        },
        "34007": {
          "name": "Camden",
          "median": 1.11,
          "10%": 0.93,
          "90%": 1.31,
          "25%": 1.02,
          "75%": 1.22
        },
        "42023": {
          "name": "Cameron",
          "median": 1.13,
          "10%": 0.92,
          "90%": 1.29,
          "25%": 1.01,
          "75%": 1.21
        },
        "51031": {
          "name": "Campbell",
          "median": 1.12,
          "10%": 0.9,
          "90%": 1.31,
          "25%": 1.02,
          "75%": 1.21
        },
        "34009": {
          "name": "Cape May",
          "median": 1.15,
          "10%": 0.89,
          "90%": 1.35,
          "25%": 1.04,
          "75%": 1.23
        },
        "42025": {
          "name": "Carbon",
          "median": 1.11,
          "10%": 0.97,
          "90%": 1.34,
          "25%": 1.04,
          "75%": 1.2
        },
        "24011": {
          "name": "Caroline",
          "median": 1.06,
          "10%": 0.83,
          "90%": 1.49,
          "25%": 0.94,
          "75%": 1.22
        },
        "51033": {
          "name": "Caroline",
          "median": 1.06,
          "10%": 0.81,
          "90%": 1.32,
          "25%": 0.92,
          "75%": 1.17
        },
        "24013": {
          "name": "Carroll",
          "median": 1.13,
          "10%": 0.91,
          "90%": 1.4,
          "25%": 1.0,
          "75%": 1.23
        },
        "51035": {
          "name": "Carroll",
          "median": 1.1,
          "10%": 0.98,
          "90%": 1.27,
          "25%": 1.04,
          "75%": 1.19
        },
        "24015": {
          "name": "Cecil",
          "median": 1.04,
          "10%": 0.89,
          "90%": 1.28,
          "25%": 0.97,
          "75%": 1.16
        },
        "42027": {
          "name": "Centre",
          "median": 1.12,
          "10%": 0.96,
          "90%": 1.31,
          "25%": 1.03,
          "75%": 1.22
        },
        "24017": {
          "name": "Charles",
          "median": 1.13,
          "10%": 0.82,
          "90%": 1.471,
          "25%": 0.92,
          "75%": 1.29
        },
        "51036": {
          "name": "Charles City",
          "median": 1.03,
          "10%": 0.839,
          "90%": 1.211,
          "25%": 0.9475,
          "75%": 1.12
        },
        "51037": {
          "name": "Charlotte",
          "median": 1.11,
          "10%": 0.92,
          "90%": 1.3,
          "25%": 1.01,
          "75%": 1.22
        },
        "51540": {
          "name": "Charlottesville",
          "median": 1.16,
          "10%": 0.84,
          "90%": 1.51,
          "25%": 1.0,
          "75%": 1.29
        },
        "36015": {
          "name": "Chemung",
          "median": 1.12,
          "10%": 1.0,
          "90%": 1.29,
          "25%": 1.05,
          "75%": 1.19
        },
        "36017": {
          "name": "Chenango",
          "median": 1.07,
          "10%": 0.95,
          "90%": 1.3,
          "25%": 1.01,
          "75%": 1.18
        },
        "51550": {
          "name": "Chesapeake",
          "median": 1.11,
          "10%": 0.85,
          "90%": 1.46,
          "25%": 1.0,
          "75%": 1.26
        },
        "42029": {
          "name": "Chester",
          "median": 1.11,
          "10%": 0.93,
          "90%": 1.28,
          "25%": 1.02,
          "75%": 1.19
        },
        "51041": {
          "name": "Chesterfield",
          "median": 1.14,
          "10%": 0.86,
          "90%": 1.51,
          "25%": 0.98,
          "75%": 1.29
        },
        "42031": {
          "name": "Clarion",
          "median": 1.07,
          "10%": 0.9,
          "90%": 1.29,
          "25%": 1.02,
          "75%": 1.19
        },
        "51043": {
          "name": "Clarke",
          "median": 1.03,
          "10%": 0.84,
          "90%": 1.27,
          "25%": 0.95,
          "75%": 1.14
        },
        "54015": {
          "name": "Clay",
          "median": 1.03,
          "10%": 0.9,
          "90%": 1.21,
          "25%": 0.96,
          "75%": 1.12
        },
        "42033": {
          "name": "Clearfield",
          "median": 1.1,
          "10%": 0.96,
          "90%": 1.28,
          "25%": 1.04,
          "75%": 1.17
        },
        "42035": {
          "name": "Clinton",
          "median": 1.15,
          "10%": 0.91,
          "90%": 1.34,
          "25%": 1.03,
          "75%": 1.24
        },
        "51570": {
          "name": "Colonial Heights",
          "median": 1.09,
          "10%": 0.85,
          "90%": 1.36,
          "25%": 0.95,
          "75%": 1.22
        },
        "42037": {
          "name": "Columbia",
          "median": 1.17,
          "10%": 0.97,
          "90%": 1.44,
          "25%": 1.04,
          "75%": 1.32
        },
        "36023": {
          "name": "Cortland",
          "median": 1.11,
          "10%": 0.92,
          "90%": 1.43,
          "25%": 1.03,
          "75%": 1.2
        },
        "51580": {
          "name": "Covington",
          "median": 1.17,
          "10%": 0.94,
          "90%": 1.49,
          "25%": 1.06,
          "75%": 1.29
        },
        "51045": {
          "name": "Craig",
          "median": 1.15,
          "10%": 0.93,
          "90%": 1.34,
          "25%": 1.02,
          "75%": 1.25
        },
        "42039": {
          "name": "Crawford",
          "median": 1.1,
          "10%": 0.96,
          "90%": 1.3,
          "25%": 1.02,
          "75%": 1.19
        },
        "51047": {
          "name": "Culpeper",
          "median": 1.06,
          "10%": 0.92,
          "90%": 1.27,
          "25%": 0.98,
          "75%": 1.19
        },
        "34011": {
          "name": "Cumberland",
          "median": 1.1,
          "10%": 0.87,
          "90%": 1.35,
          "25%": 0.97,
          "75%": 1.21
        },
        "42041": {
          "name": "Cumberland",
          "median": 1.09,
          "10%": 0.89,
          "90%": 1.45,
          "25%": 0.99,
          "75%": 1.29
        },
        "51049": {
          "name": "Cumberland",
          "median": 1.05,
          "10%": 0.89,
          "90%": 1.41,
          "25%": 0.98,
          "75%": 1.25
        },
        "51590": {
          "name": "Danville",
          "median": 1.11,
          "10%": 0.92,
          "90%": 1.33,
          "25%": 1.0,
          "75%": 1.24
        },
        "42043": {
          "name": "Dauphin",
          "median": 1.14,
          "10%": 0.86,
          "90%": 1.51,
          "25%": 1.03,
          "75%": 1.36
        },
        "36025": {
          "name": "Delaware",
          "median": 1.13,
          "10%": 0.97,
          "90%": 1.32,
          "25%": 1.03,
          "75%": 1.24
        },
        "42045": {
          "name": "Delaware",
          "median": 1.09,
          "10%": 0.89,
          "90%": 1.39,
          "25%": 0.97,
          "75%": 1.24
        },
        "51051": {
          "name": "Dickenson",
          "median": 1.08,
          "10%": 0.95,
          "90%": 1.22,
          "25%": 1.0,
          "75%": 1.14
        },
        "51053": {
          "name": "Dinwiddie",
          "median": 1.11,
          "10%": 0.89,
          "90%": 1.35,
          "25%": 0.99,
          "75%": 1.23
        },
        "11001": {
          "name": "District of Columbia",
          "median": 1.11,
          "10%": 0.91,
          "90%": 1.38,
          "25%": 0.96,
          "75%": 1.26
        },
        "54017": {
          "name": "Doddridge",
          "median": 1.06,
          "10%": 0.88,
          "90%": 1.291,
          "25%": 0.96,
          "75%": 1.19
        },
        "24019": {
          "name": "Dorchester",
          "median": 1.07,
          "10%": 0.83,
          "90%": 1.27,
          "25%": 0.93,
          "75%": 1.15
        },
        "42047": {
          "name": "Elk",
          "median": 1.07,
          "10%": 0.94,
          "90%": 1.22,
          "25%": 0.98,
          "75%": 1.14
        },
        "51595": {
          "name": "Emporia",
          "median": 1.04,
          "10%": 0.85,
          "90%": 1.43,
          "25%": 0.93,
          "75%": 1.21
        },
        "42049": {
          "name": "Erie",
          "median": 1.09,
          "10%": 0.91,
          "90%": 1.29,
          "25%": 0.99,
          "75%": 1.19
        },
        "51057": {
          "name": "Essex",
          "median": 0.99,
          "10%": 0.77,
          "90%": 1.35,
          "25%": 0.89,
          "75%": 1.08
        },
        "51059": {
          "name": "Fairfax",
          "median": 1.05,
          "10%": 0.91,
          "90%": 1.29,
          "25%": 0.97,
          "75%": 1.17
        },
        "51600": {
          "name": "Fairfax",
          "median": 1.05,
          "10%": 0.86,
          "90%": 1.3,
          "25%": 0.96,
          "75%": 1.17
        },
        "51610": {
          "name": "Falls Church",
          "median": 1.07,
          "10%": 0.87,
          "90%": 1.35,
          "25%": 0.95,
          "75%": 1.21
        },
        "51061": {
          "name": "Fauquier",
          "median": 1.08,
          "10%": 0.86,
          "90%": 1.29,
          "25%": 0.95,
          "75%": 1.19
        },
        "42051": {
          "name": "Fayette",
          "median": 1.12,
          "10%": 0.949,
          "90%": 1.4,
          "25%": 1.02,
          "75%": 1.21
        },
        "54019": {
          "name": "Fayette",
          "median": 1.07,
          "10%": 0.88,
          "90%": 1.27,
          "25%": 0.98,
          "75%": 1.14
        },
        "51063": {
          "name": "Floyd",
          "median": 1.12,
          "10%": 0.94,
          "90%": 1.26,
          "25%": 1.05,
          "75%": 1.18
        },
        "51065": {
          "name": "Fluvanna",
          "median": 1.13,
          "10%": 0.8,
          "90%": 1.57,
          "25%": 0.92,
          "75%": 1.3
        },
        "42053": {
          "name": "Forest",
          "median": 1.05,
          "10%": 0.92,
          "90%": 1.26,
          "25%": 0.98,
          "75%": 1.16
        },
        "42055": {
          "name": "Franklin",
          "median": 1.14,
          "10%": 0.98,
          "90%": 1.35,
          "25%": 1.06,
          "75%": 1.24
        },
        "51067": {
          "name": "Franklin",
          "median": 1.16,
          "10%": 0.94,
          "90%": 1.34,
          "25%": 1.04,
          "75%": 1.26
        },
        "51620": {
          "name": "Franklin",
          "median": 1.15,
          "10%": 0.85,
          "90%": 1.41,
          "25%": 1.01,
          "75%": 1.28
        },
        "24021": {
          "name": "Frederick",
          "median": 1.1,
          "10%": 0.84,
          "90%": 1.33,
          "25%": 0.97,
          "75%": 1.2
        },
        "51069": {
          "name": "Frederick",
          "median": 1.1,
          "10%": 0.9,
          "90%": 1.36,
          "25%": 0.98,
          "75%": 1.23
        },
        "51630": {
          "name": "Fredericksburg",
          "median": 1.11,
          "10%": 0.8,
          "90%": 1.4,
          "25%": 0.94,
          "75%": 1.27
        },
        "42057": {
          "name": "Fulton",
          "median": 1.18,
          "10%": 0.91,
          "90%": 1.35,
          "25%": 1.07,
          "75%": 1.26
        },
        "51640": {
          "name": "Galax",
          "median": 1.04,
          "10%": 0.84,
          "90%": 1.34,
          "25%": 0.95,
          "75%": 1.25
        },
        "24023": {
          "name": "Garrett",
          "median": 1.08,
          "10%": 0.98,
          "90%": 1.31,
          "25%": 1.01,
          "75%": 1.18
        },
        "51071": {
          "name": "Giles",
          "median": 1.11,
          "10%": 0.92,
          "90%": 1.32,
          "25%": 1.03,
          "75%": 1.19
        },
        "54021": {
          "name": "Gilmer",
          "median": 1.06,
          "10%": 0.87,
          "90%": 1.34,
          "25%": 0.96,
          "75%": 1.2
        },
        "34015": {
          "name": "Gloucester",
          "median": 1.12,
          "10%": 0.93,
          "90%": 1.35,
          "25%": 1.01,
          "75%": 1.23
        },
        "51073": {
          "name": "Gloucester",
          "median": 0.99,
          "10%": 0.78,
          "90%": 1.33,
          "25%": 0.86,
          "75%": 1.15
        },
        "51075": {
          "name": "Goochland",
          "median": 1.1,
          "10%": 0.79,
          "90%": 1.66,
          "25%": 0.93,
          "75%": 1.36
        },
        "54023": {
          "name": "Grant",
          "median": 1.1,
          "10%": 0.93,
          "90%": 1.33,
          "25%": 1.03,
          "75%": 1.21
        },
        "51077": {
          "name": "Grayson",
          "median": 1.06,
          "10%": 0.97,
          "90%": 1.31,
          "25%": 1.02,
          "75%": 1.16
        },
        "54025": {
          "name": "Greenbrier",
          "median": 1.07,
          "10%": 0.9,
          "90%": 1.28,
          "25%": 0.98,
          "75%": 1.2
        },
        "36039": {
          "name": "Greene",
          "median": 1.16,
          "10%": 0.89,
          "90%": 1.37,
          "25%": 1.05,
          "75%": 1.26
        },
        "42059": {
          "name": "Greene",
          "median": 1.11,
          "10%": 0.97,
          "90%": 1.33,
          "25%": 1.03,
          "75%": 1.2
        },
        "51079": {
          "name": "Greene",
          "median": 1.13,
          "10%": 0.82,
          "90%": 1.441,
          "25%": 1.0,
          "75%": 1.29
        },
        "51081": {
          "name": "Greensville",
          "median": 1.04,
          "10%": 0.88,
          "90%": 1.35,
          "25%": 0.96,
          "75%": 1.23
        },
        "51083": {
          "name": "Halifax",
          "median": 1.16,
          "10%": 0.96,
          "90%": 1.31,
          "25%": 1.03,
          "75%": 1.25
        },
        "54027": {
          "name": "Hampshire",
          "median": 1.12,
          "10%": 0.949,
          "90%": 1.42,
          "25%": 1.02,
          "75%": 1.29
        },
        "51650": {
          "name": "Hampton",
          "median": 1.06,
          "10%": 0.84,
          "90%": 1.42,
          "25%": 0.93,
          "75%": 1.24
        },
        "54029": {
          "name": "Hancock",
          "median": 1.09,
          "10%": 0.87,
          "90%": 1.28,
          "25%": 0.95,
          "75%": 1.2
        },
        "51085": {
          "name": "Hanover",
          "median": 1.08,
          "10%": 0.86,
          "90%": 1.3,
          "25%": 0.96,
          "75%": 1.21
        },
        "54031": {
          "name": "Hardy",
          "median": 1.12,
          "10%": 0.92,
          "90%": 1.4,
          "25%": 1.03,
          "75%": 1.24
        },
        "24025": {
          "name": "Harford",
          "median": 1.1,
          "10%": 0.84,
          "90%": 1.4,
          "25%": 0.93,
          "75%": 1.22
        },
        "54033": {
          "name": "Harrison",
          "median": 1.08,
          "10%": 0.92,
          "90%": 1.31,
          "25%": 0.98,
          "75%": 1.15
        },
        "51660": {
          "name": "Harrisonburg",
          "median": 1.09,
          "10%": 0.81,
          "90%": 1.48,
          "25%": 0.92,
          "75%": 1.32
        },
        "51087": {
          "name": "Henrico",
          "median": 1.08,
          "10%": 0.88,
          "90%": 1.35,
          "25%": 0.97,
          "75%": 1.24
        },
        "51089": {
          "name": "Henry",
          "median": 1.15,
          "10%": 0.89,
          "90%": 1.43,
          "25%": 0.98,
          "75%": 1.3
        },
        "36043": {
          "name": "Herkimer",
          "median": 1.06,
          "10%": 0.85,
          "90%": 1.19,
          "25%": 0.95,
          "75%": 1.13
        },
        "51091": {
          "name": "Highland",
          "median": 1.1,
          "10%": 0.92,
          "90%": 1.34,
          "25%": 0.98,
          "75%": 1.19
        },
        "51670": {
          "name": "Hopewell",
          "median": 1.06,
          "10%": 0.84,
          "90%": 1.33,
          "25%": 0.94,
          "75%": 1.2
        },
        "24027": {
          "name": "Howard",
          "median": 1.12,
          "10%": 0.87,
          "90%": 1.32,
          "25%": 0.95,
          "75%": 1.23
        },
        "34019": {
          "name": "Hunterdon",
          "median": 1.11,
          "10%": 0.87,
          "90%": 1.44,
          "25%": 0.94,
          "75%": 1.26
        },
        "42061": {
          "name": "Huntingdon",
          "median": 1.14,
          "10%": 0.99,
          "90%": 1.38,
          "25%": 1.05,
          "75%": 1.23
        },
        "42063": {
          "name": "Indiana",
          "median": 1.08,
          "10%": 0.91,
          "90%": 1.36,
          "25%": 0.99,
          "75%": 1.22
        },
        "51093": {
          "name": "Isle of Wight",
          "median": 1.15,
          "10%": 0.83,
          "90%": 1.38,
          "25%": 0.95,
          "75%": 1.27
        },
        "54035": {
          "name": "Jackson",
          "median": 1.09,
          "10%": 0.96,
          "90%": 1.34,
          "25%": 1.02,
          "75%": 1.18
        },
        "51095": {
          "name": "James City",
          "median": 1.0,
          "10%": 0.74,
          "90%": 1.27,
          "25%": 0.84,
          "75%": 1.12
        },
        "42065": {
          "name": "Jefferson",
          "median": 1.05,
          "10%": 0.93,
          "90%": 1.28,
          "25%": 1.0,
          "75%": 1.17
        },
        "54037": {
          "name": "Jefferson",
          "median": 1.03,
          "10%": 0.88,
          "90%": 1.23,
          "25%": 0.97,
          "75%": 1.1
        },
        "42067": {
          "name": "Juniata",
          "median": 1.09,
          "10%": 0.93,
          "90%": 1.35,
          "25%": 1.01,
          "75%": 1.24
        },
        "54039": {
          "name": "Kanawha",
          "median": 1.06,
          "10%": 0.91,
          "90%": 1.2,
          "25%": 1.01,
          "75%": 1.15
        },
        "10001": {
          "name": "Kent",
          "median": 1.05,
          "10%": 0.84,
          "90%": 1.3,
          "25%": 0.92,
          "75%": 1.15
        },
        "24029": {
          "name": "Kent",
          "median": 1.07,
          "10%": 0.83,
          "90%": 1.29,
          "25%": 0.94,
          "75%": 1.18
        },
        "51099": {
          "name": "King George",
          "median": 1.03,
          "10%": 0.79,
          "90%": 1.31,
          "25%": 0.91,
          "75%": 1.2
        },
        "51101": {
          "name": "King William",
          "median": 1.02,
          "10%": 0.82,
          "90%": 1.31,
          "25%": 0.95,
          "75%": 1.13
        },
        "51097": {
          "name": "King and Queen",
          "median": 1.0,
          "10%": 0.79,
          "90%": 1.27,
          "25%": 0.92,
          "75%": 1.13
        },
        "42069": {
          "name": "Lackawanna",
          "median": 1.17,
          "10%": 0.9,
          "90%": 1.41,
          "25%": 1.09,
          "75%": 1.27
        },
        "42071": {
          "name": "Lancaster",
          "median": 1.09,
          "10%": 0.9,
          "90%": 1.39,
          "25%": 0.97,
          "75%": 1.24
        },
        "51103": {
          "name": "Lancaster",
          "median": 1.0,
          "10%": 0.76,
          "90%": 1.36,
          "25%": 0.88,
          "75%": 1.13
        },
        "42073": {
          "name": "Lawrence",
          "median": 1.06,
          "10%": 0.909,
          "90%": 1.32,
          "25%": 0.97,
          "75%": 1.15
        },
        "42075": {
          "name": "Lebanon",
          "median": 1.12,
          "10%": 0.89,
          "90%": 1.38,
          "25%": 0.99,
          "75%": 1.26
        },
        "51105": {
          "name": "Lee",
          "median": 1.11,
          "10%": 0.9,
          "90%": 1.41,
          "25%": 1.01,
          "75%": 1.22
        },
        "42077": {
          "name": "Lehigh",
          "median": 1.09,
          "10%": 0.92,
          "90%": 1.27,
          "25%": 1.0,
          "75%": 1.21
        },
        "54041": {
          "name": "Lewis",
          "median": 1.07,
          "10%": 0.93,
          "90%": 1.26,
          "25%": 0.99,
          "75%": 1.18
        },
        "51678": {
          "name": "Lexington",
          "median": 1.06,
          "10%": 0.86,
          "90%": 1.39,
          "25%": 0.96,
          "75%": 1.18
        },
        "54043": {
          "name": "Lincoln",
          "median": 1.08,
          "10%": 0.91,
          "90%": 1.24,
          "25%": 0.96,
          "75%": 1.17
        },
        "36051": {
          "name": "Livingston",
          "median": 1.15,
          "10%": 0.99,
          "90%": 1.36,
          "25%": 1.06,
          "75%": 1.2525
        },
        "54045": {
          "name": "Logan",
          "median": 1.1,
          "10%": 0.95,
          "90%": 1.28,
          "25%": 1.03,
          "75%": 1.19
        },
        "51107": {
          "name": "Loudoun",
          "median": 1.07,
          "10%": 0.89,
          "90%": 1.27,
          "25%": 0.96,
          "75%": 1.18
        },
        "51109": {
          "name": "Louisa",
          "median": 1.13,
          "10%": 0.85,
          "90%": 1.38,
          "25%": 0.97,
          "75%": 1.28
        },
        "51111": {
          "name": "Lunenburg",
          "median": 1.14,
          "10%": 0.89,
          "90%": 1.4,
          "25%": 1.01,
          "75%": 1.27
        },
        "42079": {
          "name": "Luzerne",
          "median": 1.16,
          "10%": 0.97,
          "90%": 1.33,
          "25%": 1.06,
          "75%": 1.23
        },
        "42081": {
          "name": "Lycoming",
          "median": 1.18,
          "10%": 0.96,
          "90%": 1.42,
          "25%": 1.05,
          "75%": 1.27
        },
        "51680": {
          "name": "Lynchburg",
          "median": 1.12,
          "10%": 0.92,
          "90%": 1.331,
          "25%": 1.0,
          "75%": 1.19
        },
        "36053": {
          "name": "Madison",
          "median": 1.06,
          "10%": 0.9,
          "90%": 1.22,
          "25%": 0.96,
          "75%": 1.15
        },
        "51113": {
          "name": "Madison",
          "median": 1.09,
          "10%": 0.85,
          "90%": 1.48,
          "25%": 0.98,
          "75%": 1.27
        },
        "51683": {
          "name": "Manassas",
          "median": 1.02,
          "10%": 0.89,
          "90%": 1.24,
          "25%": 0.95,
          "75%": 1.14
        },
        "51685": {
          "name": "Manassas Park",
          "median": 1.01,
          "10%": 0.89,
          "90%": 1.28,
          "25%": 0.9475,
          "75%": 1.14
        },
        "54049": {
          "name": "Marion",
          "median": 1.07,
          "10%": 0.879,
          "90%": 1.31,
          "25%": 0.95,
          "75%": 1.2
        },
        "54051": {
          "name": "Marshall",
          "median": 1.09,
          "10%": 0.88,
          "90%": 1.41,
          "25%": 0.99,
          "75%": 1.23
        },
        "51690": {
          "name": "Martinsville",
          "median": 1.14,
          "10%": 0.83,
          "90%": 1.44,
          "25%": 0.96,
          "75%": 1.29
        },
        "54053": {
          "name": "Mason",
          "median": 1.1,
          "10%": 0.96,
          "90%": 1.31,
          "25%": 1.03,
          "75%": 1.19
        },
        "51115": {
          "name": "Mathews",
          "median": 1.06,
          "10%": 0.75,
          "90%": 1.35,
          "25%": 0.89,
          "75%": 1.18
        },
        "54047": {
          "name": "McDowell",
          "median": 1.08,
          "10%": 0.97,
          "90%": 1.24,
          "25%": 1.02,
          "75%": 1.16
        },
        "42083": {
          "name": "McKean",
          "median": 1.08,
          "10%": 0.89,
          "90%": 1.23,
          "25%": 0.97,
          "75%": 1.16
        },
        "51117": {
          "name": "Mecklenburg",
          "median": 1.13,
          "10%": 0.92,
          "90%": 1.29,
          "25%": 1.01,
          "75%": 1.21
        },
        "34021": {
          "name": "Mercer",
          "median": 1.1,
          "10%": 0.87,
          "90%": 1.4,
          "25%": 0.95,
          "75%": 1.25
        },
        "42085": {
          "name": "Mercer",
          "median": 1.08,
          "10%": 0.94,
          "90%": 1.25,
          "25%": 1.01,
          "75%": 1.15
        },
        "54055": {
          "name": "Mercer",
          "median": 1.1,
          "10%": 0.98,
          "90%": 1.28,
          "25%": 1.04,
          "75%": 1.19
        },
        "51119": {
          "name": "Middlesex",
          "median": 1.03,
          "10%": 0.77,
          "90%": 1.31,
          "25%": 0.88,
          "75%": 1.11
        },
        "42087": {
          "name": "Mifflin",
          "median": 1.13,
          "10%": 0.91,
          "90%": 1.32,
          "25%": 1.05,
          "75%": 1.22
        },
        "54057": {
          "name": "Mineral",
          "median": 1.1,
          "10%": 0.98,
          "90%": 1.41,
          "25%": 1.04,
          "75%": 1.28
        },
        "54059": {
          "name": "Mingo",
          "median": 1.11,
          "10%": 1.0,
          "90%": 1.34,
          "25%": 1.05,
          "75%": 1.22
        },
        "34025": {
          "name": "Monmouth",
          "median": 1.05,
          "10%": 0.89,
          "90%": 1.33,
          "25%": 0.98,
          "75%": 1.2
        },
        "54061": {
          "name": "Monongalia",
          "median": 1.09,
          "10%": 0.97,
          "90%": 1.3,
          "25%": 1.02,
          "75%": 1.17
        },
        "42089": {
          "name": "Monroe",
          "median": 1.12,
          "10%": 0.95,
          "90%": 1.3,
          "25%": 1.03,
          "75%": 1.21
        },
        "54063": {
          "name": "Monroe",
          "median": 1.07,
          "10%": 0.94,
          "90%": 1.33,
          "25%": 1.01,
          "75%": 1.18
        },
        "24031": {
          "name": "Montgomery",
          "median": 1.13,
          "10%": 0.93,
          "90%": 1.31,
          "25%": 0.99,
          "75%": 1.21
        },
        "36057": {
          "name": "Montgomery",
          "median": 1.07,
          "10%": 0.91,
          "90%": 1.27,
          "25%": 0.99,
          "75%": 1.18
        },
        "42091": {
          "name": "Montgomery",
          "median": 1.1,
          "10%": 0.92,
          "90%": 1.28,
          "25%": 1.0,
          "75%": 1.18
        },
        "51121": {
          "name": "Montgomery",
          "median": 1.13,
          "10%": 0.96,
          "90%": 1.36,
          "25%": 1.04,
          "75%": 1.23
        },
        "42093": {
          "name": "Montour",
          "median": 1.19,
          "10%": 0.92,
          "90%": 1.48,
          "25%": 1.02,
          "75%": 1.35
        },
        "54065": {
          "name": "Morgan",
          "median": 1.15,
          "10%": 0.87,
          "90%": 1.38,
          "25%": 1.06,
          "75%": 1.25
        },
        "34027": {
          "name": "Morris",
          "median": 1.14,
          "10%": 0.87,
          "90%": 1.49,
          "25%": 0.98,
          "75%": 1.32
        },
        "36059": {
          "name": "Nassau",
          "median": 1.12,
          "10%": 0.91,
          "90%": 1.35,
          "25%": 0.99,
          "75%": 1.25
        },
        "51125": {
          "name": "Nelson",
          "median": 1.18,
          "10%": 0.82,
          "90%": 1.52,
          "25%": 0.99,
          "75%": 1.29
        },
        "10003": {
          "name": "New Castle",
          "median": 1.1,
          "10%": 0.9,
          "90%": 1.3,
          "25%": 0.98,
          "75%": 1.17
        },
        "51127": {
          "name": "New Kent",
          "median": 1.01,
          "10%": 0.85,
          "90%": 1.22,
          "25%": 0.93,
          "75%": 1.12
        },
        "36061": {
          "name": "New York",
          "median": 1.03,
          "10%": 0.8,
          "90%": 1.25,
          "25%": 0.92,
          "75%": 1.16
        },
        "51700": {
          "name": "Newport News",
          "median": 1.05,
          "10%": 0.81,
          "90%": 1.36,
          "25%": 0.9,
          "75%": 1.22
        },
        "54067": {
          "name": "Nicholas",
          "median": 1.03,
          "10%": 0.88,
          "90%": 1.2,
          "25%": 0.94,
          "75%": 1.12
        },
        "51710": {
          "name": "Norfolk",
          "median": 1.08,
          "10%": 0.8,
          "90%": 1.59,
          "25%": 0.89,
          "75%": 1.31
        },
        "42095": {
          "name": "Northampton",
          "median": 1.07,
          "10%": 0.89,
          "90%": 1.25,
          "25%": 0.97,
          "75%": 1.17
        },
        "51131": {
          "name": "Northampton",
          "median": 1.07,
          "10%": 0.81,
          "90%": 1.32,
          "25%": 0.93,
          "75%": 1.24
        },
        "42097": {
          "name": "Northumberland",
          "median": 1.17,
          "10%": 0.93,
          "90%": 1.52,
          "25%": 1.06,
          "75%": 1.35
        },
        "51133": {
          "name": "Northumberland",
          "median": 0.98,
          "10%": 0.74,
          "90%": 1.35,
          "25%": 0.86,
          "75%": 1.12
        },
        "51720": {
          "name": "Norton",
          "median": 1.14,
          "10%": 0.83,
          "90%": 1.38,
          "25%": 0.98,
          "75%": 1.27
        },
        "51135": {
          "name": "Nottoway",
          "median": 1.14,
          "10%": 0.86,
          "90%": 1.48,
          "25%": 0.99,
          "75%": 1.32
        },
        "34029": {
          "name": "Ocean",
          "median": 1.07,
          "10%": 0.94,
          "90%": 1.29,
          "25%": 0.99,
          "75%": 1.18
        },
        "54069": {
          "name": "Ohio",
          "median": 1.09,
          "10%": 0.87,
          "90%": 1.39,
          "25%": 0.97,
          "75%": 1.24
        },
        "36065": {
          "name": "Oneida",
          "median": 1.08,
          "10%": 0.91,
          "90%": 1.28,
          "25%": 1.01,
          "75%": 1.15
        },
        "36067": {
          "name": "Onondaga",
          "median": 1.11,
          "10%": 0.9,
          "90%": 1.4,
          "25%": 1.0,
          "75%": 1.19
        },
        "36069": {
          "name": "Ontario",
          "median": 1.14,
          "10%": 0.99,
          "90%": 1.42,
          "25%": 1.05,
          "75%": 1.27
        },
        "36071": {
          "name": "Orange",
          "median": 1.17,
          "10%": 0.92,
          "90%": 1.44,
          "25%": 1.02,
          "75%": 1.28
        },
        "51137": {
          "name": "Orange",
          "median": 1.12,
          "10%": 0.93,
          "90%": 1.33,
          "25%": 1.0,
          "75%": 1.24
        },
        "36077": {
          "name": "Otsego",
          "median": 1.06,
          "10%": 0.93,
          "90%": 1.26,
          "25%": 0.99,
          "75%": 1.16
        },
        "51139": {
          "name": "Page",
          "median": 1.13,
          "10%": 0.86,
          "90%": 1.6,
          "25%": 0.97,
          "75%": 1.3
        },
        "51141": {
          "name": "Patrick",
          "median": 1.13,
          "10%": 0.93,
          "90%": 1.4,
          "25%": 1.01,
          "75%": 1.23
        },
        "54071": {
          "name": "Pendleton",
          "median": 1.1,
          "10%": 0.87,
          "90%": 1.4,
          "25%": 0.98,
          "75%": 1.24
        },
        "42099": {
          "name": "Perry",
          "median": 1.11,
          "10%": 0.88,
          "90%": 1.31,
          "25%": 0.97,
          "75%": 1.22
        },
        "51730": {
          "name": "Petersburg",
          "median": 1.07,
          "10%": 0.83,
          "90%": 1.34,
          "25%": 0.95,
          "75%": 1.21
        },
        "42101": {
          "name": "Philadelphia",
          "median": 1.08,
          "10%": 0.93,
          "90%": 1.27,
          "25%": 0.98,
          "75%": 1.16
        },
        "42103": {
          "name": "Pike",
          "median": 1.1,
          "10%": 0.96,
          "90%": 1.4,
          "25%": 1.03,
          "75%": 1.22
        },
        "51143": {
          "name": "Pittsylvania",
          "median": 1.12,
          "10%": 0.97,
          "90%": 1.33,
          "25%": 1.06,
          "75%": 1.2
        },
        "54073": {
          "name": "Pleasants",
          "median": 1.06,
          "10%": 0.9,
          "90%": 1.26,
          "25%": 0.98,
          "75%": 1.15
        },
        "54075": {
          "name": "Pocahontas",
          "median": 1.09,
          "10%": 0.94,
          "90%": 1.351,
          "25%": 0.99,
          "75%": 1.24
        },
        "51735": {
          "name": "Poquoson",
          "median": 1.03,
          "10%": 0.84,
          "90%": 1.4,
          "25%": 0.91,
          "75%": 1.26
        },
        "51740": {
          "name": "Portsmouth",
          "median": 1.09,
          "10%": 0.78,
          "90%": 1.54,
          "25%": 0.91,
          "75%": 1.32
        },
        "42105": {
          "name": "Potter",
          "median": 1.11,
          "10%": 0.94,
          "90%": 1.31,
          "25%": 1.0,
          "75%": 1.18
        },
        "51145": {
          "name": "Powhatan",
          "median": 1.1,
          "10%": 0.84,
          "90%": 1.63,
          "25%": 0.96,
          "75%": 1.31
        },
        "54077": {
          "name": "Preston",
          "median": 1.12,
          "10%": 0.96,
          "90%": 1.32,
          "25%": 1.03,
          "75%": 1.21
        },
        "51147": {
          "name": "Prince Edward",
          "median": 1.09,
          "10%": 0.91,
          "90%": 1.37,
          "25%": 1.0,
          "75%": 1.22
        },
        "51149": {
          "name": "Prince George",
          "median": 1.06,
          "10%": 0.87,
          "90%": 1.24,
          "25%": 0.94,
          "75%": 1.19
        },
        "24033": {
          "name": "Prince George's",
          "median": 1.09,
          "10%": 0.91,
          "90%": 1.4,
          "25%": 0.98,
          "75%": 1.21
        },
        "51153": {
          "name": "Prince William",
          "median": 1.04,
          "10%": 0.89,
          "90%": 1.26,
          "25%": 0.96,
          "75%": 1.14
        },
        "51155": {
          "name": "Pulaski",
          "median": 1.13,
          "10%": 1.0,
          "90%": 1.32,
          "25%": 1.04,
          "75%": 1.22
        },
        "54079": {
          "name": "Putnam",
          "median": 1.07,
          "10%": 0.9,
          "90%": 1.28,
          "25%": 1.0,
          "75%": 1.18
        },
        "24035": {
          "name": "Queen Anne's",
          "median": 1.04,
          "10%": 0.83,
          "90%": 1.32,
          "25%": 0.95,
          "75%": 1.17
        },
        "51750": {
          "name": "Radford",
          "median": 1.16,
          "10%": 0.96,
          "90%": 1.48,
          "25%": 1.03,
          "75%": 1.3
        },
        "54081": {
          "name": "Raleigh",
          "median": 1.13,
          "10%": 0.9,
          "90%": 1.33,
          "25%": 0.99,
          "75%": 1.22
        },
        "54083": {
          "name": "Randolph",
          "median": 1.11,
          "10%": 0.95,
          "90%": 1.31,
          "25%": 1.0,
          "75%": 1.2
        },
        "51157": {
          "name": "Rappahannock",
          "median": 1.09,
          "10%": 0.87,
          "90%": 1.39,
          "25%": 0.98,
          "75%": 1.18
        },
        "36085": {
          "name": "Richmond",
          "median": 1.04,
          "10%": 0.8,
          "90%": 1.36,
          "25%": 0.92,
          "75%": 1.21
        },
        "51159": {
          "name": "Richmond",
          "median": 0.99,
          "10%": 0.77,
          "90%": 1.3,
          "25%": 0.87,
          "75%": 1.11
        },
        "51760": {
          "name": "Richmond",
          "median": 1.08,
          "10%": 0.85,
          "90%": 1.47,
          "25%": 0.97,
          "75%": 1.3
        },
        "54085": {
          "name": "Ritchie",
          "median": 1.11,
          "10%": 0.92,
          "90%": 1.28,
          "25%": 1.0,
          "75%": 1.2
        },
        "54087": {
          "name": "Roane",
          "median": 1.06,
          "10%": 0.93,
          "90%": 1.27,
          "25%": 1.02,
          "75%": 1.18
        },
        "51161": {
          "name": "Roanoke",
          "median": 1.17,
          "10%": 0.95,
          "90%": 1.44,
          "25%": 1.02,
          "75%": 1.28
        },
        "51770": {
          "name": "Roanoke",
          "median": 1.22,
          "10%": 0.93,
          "90%": 1.51,
          "25%": 1.0,
          "75%": 1.34
        },
        "51163": {
          "name": "Rockbridge",
          "median": 1.12,
          "10%": 0.91,
          "90%": 1.37,
          "25%": 1.04,
          "75%": 1.25
        },
        "51165": {
          "name": "Rockingham",
          "median": 1.08,
          "10%": 0.84,
          "90%": 1.43,
          "25%": 0.94,
          "75%": 1.25
        },
        "51167": {
          "name": "Russell",
          "median": 1.05,
          "10%": 0.94,
          "90%": 1.22,
          "25%": 0.99,
          "75%": 1.12
        },
        "34033": {
          "name": "Salem",
          "median": 1.07,
          "10%": 0.94,
          "90%": 1.35,
          "25%": 1.0,
          "75%": 1.22
        },
        "51775": {
          "name": "Salem",
          "median": 1.16,
          "10%": 0.94,
          "90%": 1.47,
          "25%": 1.01,
          "75%": 1.31
        },
        "36095": {
          "name": "Schoharie",
          "median": 1.11,
          "10%": 0.9,
          "90%": 1.32,
          "25%": 1.01,
          "75%": 1.2
        },
        "36097": {
          "name": "Schuyler",
          "median": 1.13,
          "10%": 1.01,
          "90%": 1.32,
          "25%": 1.06,
          "75%": 1.21
        },
        "42107": {
          "name": "Schuylkill",
          "median": 1.14,
          "10%": 0.93,
          "90%": 1.43,
          "25%": 1.04,
          "75%": 1.27
        },
        "51169": {
          "name": "Scott",
          "median": 1.11,
          "10%": 0.9,
          "90%": 1.28,
          "25%": 0.98,
          "75%": 1.19
        },
        "51171": {
          "name": "Shenandoah",
          "median": 1.1,
          "10%": 0.89,
          "90%": 1.39,
          "25%": 0.97,
          "75%": 1.23
        },
        "51173": {
          "name": "Smyth",
          "median": 1.1,
          "10%": 0.95,
          "90%": 1.23,
          "25%": 1.02,
          "75%": 1.15
        },
        "42109": {
          "name": "Snyder",
          "median": 1.16,
          "10%": 0.89,
          "90%": 1.49,
          "25%": 1.06,
          "75%": 1.3
        },
        "24039": {
          "name": "Somerset",
          "median": 1.05,
          "10%": 0.85,
          "90%": 1.34,
          "25%": 0.96,
          "75%": 1.17
        },
        "42111": {
          "name": "Somerset",
          "median": 1.09,
          "10%": 1.0,
          "90%": 1.26,
          "25%": 1.04,
          "75%": 1.17
        },
        "51175": {
          "name": "Southampton",
          "median": 1.08,
          "10%": 0.93,
          "90%": 1.33,
          "25%": 1.0,
          "75%": 1.22
        },
        "51177": {
          "name": "Spotsylvania",
          "median": 1.07,
          "10%": 0.83,
          "90%": 1.28,
          "25%": 0.96,
          "75%": 1.2
        },
        "24037": {
          "name": "St. Mary's",
          "median": 1.0,
          "10%": 0.8,
          "90%": 1.24,
          "25%": 0.89,
          "75%": 1.11
        },
        "51179": {
          "name": "Stafford",
          "median": 1.1,
          "10%": 0.82,
          "90%": 1.36,
          "25%": 0.98,
          "75%": 1.22
        },
        "51790": {
          "name": "Staunton",
          "median": 1.11,
          "10%": 0.85,
          "90%": 1.47,
          "25%": 0.94,
          "75%": 1.23
        },
        "36101": {
          "name": "Steuben",
          "median": 1.09,
          "10%": 0.93,
          "90%": 1.33,
          "25%": 1.02,
          "75%": 1.18
        },
        "51800": {
          "name": "Suffolk",
          "median": 1.16,
          "10%": 0.86,
          "90%": 1.4,
          "25%": 0.97,
          "75%": 1.29
        },
        "36105": {
          "name": "Sullivan",
          "median": 1.14,
          "10%": 0.96,
          "90%": 1.35,
          "25%": 1.06,
          "75%": 1.23
        },
        "42113": {
          "name": "Sullivan",
          "median": 1.19,
          "10%": 0.91,
          "90%": 1.42,
          "25%": 1.07,
          "75%": 1.29
        },
        "54089": {
          "name": "Summers",
          "median": 1.09,
          "10%": 0.9,
          "90%": 1.38,
          "25%": 0.99,
          "75%": 1.17
        },
        "51181": {
          "name": "Surry",
          "median": 1.08,
          "10%": 0.81,
          "90%": 1.3,
          "25%": 0.93,
          "75%": 1.17
        },
        "42115": {
          "name": "Susquehanna",
          "median": 1.18,
          "10%": 0.999,
          "90%": 1.37,
          "25%": 1.1,
          "75%": 1.26
        },
        "10005": {
          "name": "Sussex",
          "median": 1.04,
          "10%": 0.87,
          "90%": 1.31,
          "25%": 0.97,
          "75%": 1.16
        },
        "34037": {
          "name": "Sussex",
          "median": 1.17,
          "10%": 0.9,
          "90%": 1.381,
          "25%": 1.0275,
          "75%": 1.25
        },
        "51183": {
          "name": "Sussex",
          "median": 1.06,
          "10%": 0.89,
          "90%": 1.32,
          "25%": 0.97,
          "75%": 1.22
        },
        "24041": {
          "name": "Talbot",
          "median": 1.06,
          "10%": 0.84,
          "90%": 1.34,
          "25%": 0.93,
          "75%": 1.15
        },
        "54091": {
          "name": "Taylor",
          "median": 1.07,
          "10%": 0.94,
          "90%": 1.32,
          "25%": 1.01,
          "75%": 1.17
        },
        "51185": {
          "name": "Tazewell",
          "median": 1.1,
          "10%": 0.96,
          "90%": 1.25,
          "25%": 1.0,
          "75%": 1.17
        },
        "36107": {
          "name": "Tioga",
          "median": 1.15,
          "10%": 0.99,
          "90%": 1.42,
          "25%": 1.07,
          "75%": 1.27
        },
        "42117": {
          "name": "Tioga",
          "median": 1.12,
          "10%": 0.93,
          "90%": 1.39,
          "25%": 0.99,
          "75%": 1.25
        },
        "36109": {
          "name": "Tompkins",
          "median": 1.13,
          "10%": 1.0,
          "90%": 1.421,
          "25%": 1.07,
          "75%": 1.2
        },
        "54093": {
          "name": "Tucker",
          "median": 1.1,
          "10%": 0.94,
          "90%": 1.3,
          "25%": 1.01,
          "75%": 1.17
        },
        "54095": {
          "name": "Tyler",
          "median": 1.04,
          "10%": 0.89,
          "90%": 1.26,
          "25%": 0.99,
          "75%": 1.15
        },
        "36111": {
          "name": "Ulster",
          "median": 1.16,
          "10%": 0.97,
          "90%": 1.38,
          "25%": 1.07,
          "75%": 1.27
        },
        "42119": {
          "name": "Union",
          "median": 1.14,
          "10%": 0.96,
          "90%": 1.42,
          "25%": 1.04,
          "75%": 1.27
        },
        "54097": {
          "name": "Upshur",
          "median": 1.07,
          "10%": 0.92,
          "90%": 1.33,
          "25%": 0.98,
          "75%": 1.21
        },
        "42121": {
          "name": "Venango",
          "median": 1.07,
          "10%": 0.89,
          "90%": 1.3,
          "25%": 0.99,
          "75%": 1.18
        },
        "51810": {
          "name": "Virginia Beach",
          "median": 1.1,
          "10%": 0.85,
          "90%": 1.47,
          "25%": 0.96,
          "75%": 1.24
        },
        "34041": {
          "name": "Warren",
          "median": 1.13,
          "10%": 0.86,
          "90%": 1.31,
          "25%": 0.97,
          "75%": 1.21
        },
        "42123": {
          "name": "Warren",
          "median": 1.06,
          "10%": 0.95,
          "90%": 1.28,
          "25%": 1.0,
          "75%": 1.18
        },
        "51187": {
          "name": "Warren",
          "median": 1.12,
          "10%": 0.88,
          "90%": 1.41,
          "25%": 0.96,
          "75%": 1.26
        },
        "24043": {
          "name": "Washington",
          "median": 1.11,
          "10%": 0.85,
          "90%": 1.31,
          "25%": 1.01,
          "75%": 1.22
        },
        "42125": {
          "name": "Washington",
          "median": 1.11,
          "10%": 0.93,
          "90%": 1.32,
          "25%": 1.02,
          "75%": 1.19
        },
        "51191": {
          "name": "Washington",
          "median": 1.06,
          "10%": 0.94,
          "90%": 1.18,
          "25%": 0.99,
          "75%": 1.14
        },
        "42127": {
          "name": "Wayne",
          "median": 1.14,
          "10%": 0.95,
          "90%": 1.4,
          "25%": 1.05,
          "75%": 1.24
        },
        "54099": {
          "name": "Wayne",
          "median": 1.09,
          "10%": 0.93,
          "90%": 1.29,
          "25%": 1.01,
          "75%": 1.2
        },
        "51820": {
          "name": "Waynesboro",
          "median": 1.14,
          "10%": 0.839,
          "90%": 1.42,
          "25%": 0.99,
          "75%": 1.26
        },
        "54101": {
          "name": "Webster",
          "median": 1.02,
          "10%": 0.91,
          "90%": 1.27,
          "25%": 0.95,
          "75%": 1.17
        },
        "36119": {
          "name": "Westchester",
          "median": 1.08,
          "10%": 0.88,
          "90%": 1.29,
          "25%": 0.97,
          "75%": 1.2
        },
        "42129": {
          "name": "Westmoreland",
          "median": 1.1,
          "10%": 0.93,
          "90%": 1.31,
          "25%": 1.0,
          "75%": 1.2
        },
        "51193": {
          "name": "Westmoreland",
          "median": 0.97,
          "10%": 0.8,
          "90%": 1.29,
          "25%": 0.9,
          "75%": 1.14
        },
        "54103": {
          "name": "Wetzel",
          "median": 1.1,
          "10%": 0.91,
          "90%": 1.34,
          "25%": 0.98,
          "75%": 1.2
        },
        "24045": {
          "name": "Wicomico",
          "median": 1.06,
          "10%": 0.87,
          "90%": 1.21,
          "25%": 0.95,
          "75%": 1.13
        },
        "51830": {
          "name": "Williamsburg",
          "median": 0.98,
          "10%": 0.68,
          "90%": 1.32,
          "25%": 0.83,
          "75%": 1.12
        },
        "51840": {
          "name": "Winchester",
          "median": 1.07,
          "10%": 0.84,
          "90%": 1.4,
          "25%": 0.95,
          "75%": 1.25
        },
        "54105": {
          "name": "Wirt",
          "median": 1.11,
          "10%": 0.9,
          "90%": 1.3,
          "25%": 1.03,
          "75%": 1.21
        },
        "51195": {
          "name": "Wise",
          "median": 1.12,
          "10%": 0.86,
          "90%": 1.29,
          "25%": 0.99,
          "75%": 1.21
        },
        "54107": {
          "name": "Wood",
          "median": 1.09,
          "10%": 0.9,
          "90%": 1.34,
          "25%": 0.99,
          "75%": 1.2025
        },
        "24047": {
          "name": "Worcester",
          "median": 1.055,
          "10%": 0.86,
          "90%": 1.31,
          "25%": 0.98,
          "75%": 1.2
        },
        "42131": {
          "name": "Wyoming",
          "median": 1.19,
          "10%": 0.95,
          "90%": 1.4,
          "25%": 1.1,
          "75%": 1.29
        },
        "54109": {
          "name": "Wyoming",
          "median": 1.13,
          "10%": 0.97,
          "90%": 1.28,
          "25%": 1.03,
          "75%": 1.19
        },
        "51197": {
          "name": "Wythe",
          "median": 1.08,
          "10%": 0.97,
          "90%": 1.27,
          "25%": 1.02,
          "75%": 1.17
        },
        "36123": {
          "name": "Yates",
          "median": 1.16,
          "10%": 0.95,
          "90%": 1.46,
          "25%": 1.07,
          "75%": 1.29
        },
        "42133": {
          "name": "York",
          "median": 1.1,
          "10%": 0.91,
          "90%": 1.47,
          "25%": 0.99,
          "75%": 1.29
        },
        "51199": {
          "name": "York",
          "median": 1.02,
          "10%": 0.78,
          "90%": 1.31,
          "25%": 0.86,
          "75%": 1.17
        },
        "max": 1.22,
        "min": 0.97
      }
    },
    "2050-2100": {
      "2": {
        "51001": {
          "name": "Accomack",
          "median": 1.125,
          "10%": 1.06,
          "90%": 1.23,
          "25%": 1.08,
          "75%": 1.22
        },
        "42001": {
          "name": "Adams",
          "median": 1.14,
          "10%": 1.07,
          "90%": 1.25,
          "25%": 1.07,
          "75%": 1.2
        },
        "51003": {
          "name": "Albemarle",
          "median": 1.14,
          "10%": 0.97,
          "90%": 1.17,
          "25%": 1.06,
          "75%": 1.16
        },
        "51510": {
          "name": "Alexandria",
          "median": 1.11,
          "10%": 1.03,
          "90%": 1.27,
          "25%": 1.06,
          "75%": 1.19
        },
        "24001": {
          "name": "Allegany",
          "median": 1.135,
          "10%": 1.03,
          "90%": 1.37,
          "25%": 1.07,
          "75%": 1.16
        },
        "36003": {
          "name": "Allegany",
          "median": 1.12,
          "10%": 0.96,
          "90%": 1.23,
          "25%": 1.01,
          "75%": 1.17
        },
        "51005": {
          "name": "Alleghany",
          "median": 1.145,
          "10%": 1.05,
          "90%": 1.23,
          "25%": 1.08,
          "75%": 1.18
        },
        "42003": {
          "name": "Allegheny",
          "median": 1.15,
          "10%": 1.02,
          "90%": 1.25,
          "25%": 1.11,
          "75%": 1.22
        },
        "51007": {
          "name": "Amelia",
          "median": 1.11,
          "10%": 1.02,
          "90%": 1.23,
          "25%": 1.09,
          "75%": 1.13
        },
        "51009": {
          "name": "Amherst",
          "median": 1.16,
          "10%": 1.04,
          "90%": 1.22,
          "25%": 1.06,
          "75%": 1.18
        },
        "24003": {
          "name": "Anne Arundel",
          "median": 1.135,
          "10%": 1.01,
          "90%": 1.26,
          "25%": 1.04,
          "75%": 1.17
        },
        "51011": {
          "name": "Appomattox",
          "median": 1.11,
          "10%": 1.07,
          "90%": 1.2,
          "25%": 1.08,
          "75%": 1.18
        },
        "51013": {
          "name": "Arlington",
          "median": 1.11,
          "10%": 1.03,
          "90%": 1.27,
          "25%": 1.06,
          "75%": 1.19
        },
        "42005": {
          "name": "Armstrong",
          "median": 1.11,
          "10%": 1.04,
          "90%": 1.21,
          "25%": 1.07,
          "75%": 1.21
        },
        "34001": {
          "name": "Atlantic",
          "median": 1.115,
          "10%": 1.07,
          "90%": 1.16,
          "25%": 1.08,
          "75%": 1.15
        },
        "51015": {
          "name": "Augusta",
          "median": 1.13,
          "10%": 1.0,
          "90%": 1.23,
          "25%": 1.07,
          "75%": 1.15
        },
        "24005": {
          "name": "Baltimore",
          "median": 1.15,
          "10%": 0.98,
          "90%": 1.26,
          "25%": 1.07,
          "75%": 1.17
        },
        "24510": {
          "name": "Baltimore",
          "median": 1.14,
          "10%": 1.01,
          "90%": 1.24,
          "25%": 1.05,
          "75%": 1.18
        },
        "54001": {
          "name": "Barbour",
          "median": 1.14,
          "10%": 1.05,
          "90%": 1.27,
          "25%": 1.08,
          "75%": 1.21
        },
        "51017": {
          "name": "Bath",
          "median": 1.13,
          "10%": 1.03,
          "90%": 1.23,
          "25%": 1.09,
          "75%": 1.17
        },
        "42007": {
          "name": "Beaver",
          "median": 1.13,
          "10%": 1.04,
          "90%": 1.24,
          "25%": 1.06,
          "75%": 1.17
        },
        "42009": {
          "name": "Bedford",
          "median": 1.155,
          "10%": 1.05,
          "90%": 1.24,
          "25%": 1.06,
          "75%": 1.19
        },
        "51019": {
          "name": "Bedford",
          "median": 1.19,
          "10%": 1.08,
          "90%": 1.22,
          "25%": 1.11,
          "75%": 1.2
        },
        "54003": {
          "name": "Berkeley",
          "median": 1.12,
          "10%": 1.09,
          "90%": 1.29,
          "25%": 1.1,
          "75%": 1.21
        },
        "42011": {
          "name": "Berks",
          "median": 1.145,
          "10%": 1.01,
          "90%": 1.21,
          "25%": 1.05,
          "75%": 1.19
        },
        "42013": {
          "name": "Blair",
          "median": 1.13,
          "10%": 1.09,
          "90%": 1.241,
          "25%": 1.1,
          "75%": 1.17
        },
        "51021": {
          "name": "Bland",
          "median": 1.135,
          "10%": 1.1,
          "90%": 1.17,
          "25%": 1.11,
          "75%": 1.16
        },
        "54005": {
          "name": "Boone",
          "median": 1.175,
          "10%": 1.08,
          "90%": 1.25,
          "25%": 1.13,
          "75%": 1.22
        },
        "51023": {
          "name": "Botetourt",
          "median": 1.18,
          "10%": 1.08,
          "90%": 1.23,
          "25%": 1.1,
          "75%": 1.2
        },
        "42015": {
          "name": "Bradford",
          "median": 1.135,
          "10%": 1.05,
          "90%": 1.31,
          "25%": 1.09,
          "75%": 1.17
        },
        "54007": {
          "name": "Braxton",
          "median": 1.16,
          "10%": 1.06,
          "90%": 1.28,
          "25%": 1.08,
          "75%": 1.22
        },
        "51520": {
          "name": "Bristol",
          "median": 1.16,
          "10%": 1.1,
          "90%": 1.23,
          "25%": 1.13,
          "75%": 1.2
        },
        "36005": {
          "name": "Bronx",
          "median": 1.11,
          "10%": 0.99,
          "90%": 1.19,
          "25%": 1.01,
          "75%": 1.13
        },
        "54009": {
          "name": "Brooke",
          "median": 1.15,
          "10%": 1.03,
          "90%": 1.26,
          "25%": 1.11,
          "75%": 1.21
        },
        "36007": {
          "name": "Broome",
          "median": 1.135,
          "10%": 1.04,
          "90%": 1.2,
          "25%": 1.1,
          "75%": 1.19
        },
        "51025": {
          "name": "Brunswick",
          "median": 1.17,
          "10%": 1.09,
          "90%": 1.19,
          "25%": 1.11,
          "75%": 1.18
        },
        "51027": {
          "name": "Buchanan",
          "median": 1.16,
          "10%": 1.09,
          "90%": 1.22,
          "25%": 1.12,
          "75%": 1.18
        },
        "51029": {
          "name": "Buckingham",
          "median": 1.14,
          "10%": 1.01,
          "90%": 1.19,
          "25%": 1.08,
          "75%": 1.18
        },
        "42017": {
          "name": "Bucks",
          "median": 1.135,
          "10%": 1.02,
          "90%": 1.18,
          "25%": 1.08,
          "75%": 1.18
        },
        "51530": {
          "name": "Buena Vista",
          "median": 1.155,
          "10%": 1.04,
          "90%": 1.24,
          "25%": 1.06,
          "75%": 1.19
        },
        "34005": {
          "name": "Burlington",
          "median": 1.13,
          "10%": 1.06,
          "90%": 1.17,
          "25%": 1.07,
          "75%": 1.17
        },
        "42019": {
          "name": "Butler",
          "median": 1.11,
          "10%": 1.02,
          "90%": 1.25,
          "25%": 1.09,
          "75%": 1.18
        },
        "54011": {
          "name": "Cabell",
          "median": 1.16,
          "10%": 1.08,
          "90%": 1.3,
          "25%": 1.12,
          "75%": 1.23
        },
        "54013": {
          "name": "Calhoun",
          "median": 1.19,
          "10%": 1.09,
          "90%": 1.27,
          "25%": 1.12,
          "75%": 1.26
        },
        "24009": {
          "name": "Calvert",
          "median": 1.11,
          "10%": 1.02,
          "90%": 1.27,
          "25%": 1.04,
          "75%": 1.16
        },
        "42021": {
          "name": "Cambria",
          "median": 1.15,
          "10%": 1.04,
          "90%": 1.21,
          "25%": 1.11,
          "75%": 1.19
        },
        "34007": {
          "name": "Camden",
          "median": 1.14,
          "10%": 1.04,
          "90%": 1.16,
          "25%": 1.06,
          "75%": 1.16
        },
        "42023": {
          "name": "Cameron",
          "median": 1.11,
          "10%": 1.01,
          "90%": 1.24,
          "25%": 1.1,
          "75%": 1.17
        },
        "51031": {
          "name": "Campbell",
          "median": 1.145,
          "10%": 1.06,
          "90%": 1.2,
          "25%": 1.11,
          "75%": 1.18
        },
        "34009": {
          "name": "Cape May",
          "median": 1.1,
          "10%": 1.04,
          "90%": 1.17,
          "25%": 1.08,
          "75%": 1.16
        },
        "42025": {
          "name": "Carbon",
          "median": 1.13,
          "10%": 1.04,
          "90%": 1.19,
          "25%": 1.09,
          "75%": 1.16
        },
        "24011": {
          "name": "Caroline",
          "median": 1.13,
          "10%": 1.03,
          "90%": 1.21,
          "25%": 1.05,
          "75%": 1.2
        },
        "51033": {
          "name": "Caroline",
          "median": 1.1,
          "10%": 0.99,
          "90%": 1.31,
          "25%": 1.08,
          "75%": 1.1
        },
        "24013": {
          "name": "Carroll",
          "median": 1.13,
          "10%": 1.01,
          "90%": 1.25,
          "25%": 1.1,
          "75%": 1.19
        },
        "51035": {
          "name": "Carroll",
          "median": 1.14,
          "10%": 1.05,
          "90%": 1.21,
          "25%": 1.08,
          "75%": 1.16
        },
        "24015": {
          "name": "Cecil",
          "median": 1.16,
          "10%": 0.99,
          "90%": 1.22,
          "25%": 1.04,
          "75%": 1.2
        },
        "42027": {
          "name": "Centre",
          "median": 1.15,
          "10%": 1.1,
          "90%": 1.25,
          "25%": 1.13,
          "75%": 1.19
        },
        "24017": {
          "name": "Charles",
          "median": 1.12,
          "10%": 1.01,
          "90%": 1.3,
          "25%": 1.05,
          "75%": 1.13
        },
        "51036": {
          "name": "Charles City",
          "median": 1.1,
          "10%": 1.07,
          "90%": 1.22,
          "25%": 1.09,
          "75%": 1.15
        },
        "51037": {
          "name": "Charlotte",
          "median": 1.145,
          "10%": 1.08,
          "90%": 1.2,
          "25%": 1.1,
          "75%": 1.18
        },
        "51540": {
          "name": "Charlottesville",
          "median": 1.11,
          "10%": 0.95,
          "90%": 1.16,
          "25%": 1.04,
          "75%": 1.15
        },
        "36015": {
          "name": "Chemung",
          "median": 1.13,
          "10%": 0.99,
          "90%": 1.22,
          "25%": 1.09,
          "75%": 1.18
        },
        "36017": {
          "name": "Chenango",
          "median": 1.125,
          "10%": 1.06,
          "90%": 1.2,
          "25%": 1.09,
          "75%": 1.14
        },
        "51550": {
          "name": "Chesapeake",
          "median": 1.115,
          "10%": 1.05,
          "90%": 1.21,
          "25%": 1.06,
          "75%": 1.19
        },
        "42029": {
          "name": "Chester",
          "median": 1.16,
          "10%": 1.0,
          "90%": 1.21,
          "25%": 1.01,
          "75%": 1.19
        },
        "51041": {
          "name": "Chesterfield",
          "median": 1.1,
          "10%": 1.03,
          "90%": 1.24,
          "25%": 1.07,
          "75%": 1.14
        },
        "42031": {
          "name": "Clarion",
          "median": 1.1,
          "10%": 0.99,
          "90%": 1.24,
          "25%": 1.07,
          "75%": 1.16
        },
        "51043": {
          "name": "Clarke",
          "median": 1.135,
          "10%": 1.06,
          "90%": 1.27,
          "25%": 1.1,
          "75%": 1.22
        },
        "54015": {
          "name": "Clay",
          "median": 1.15,
          "10%": 1.08,
          "90%": 1.26,
          "25%": 1.09,
          "75%": 1.24
        },
        "42033": {
          "name": "Clearfield",
          "median": 1.15,
          "10%": 1.05,
          "90%": 1.18,
          "25%": 1.11,
          "75%": 1.18
        },
        "42035": {
          "name": "Clinton",
          "median": 1.14,
          "10%": 1.07,
          "90%": 1.24,
          "25%": 1.13,
          "75%": 1.19
        },
        "51570": {
          "name": "Colonial Heights",
          "median": 1.1,
          "10%": 1.07,
          "90%": 1.22,
          "25%": 1.08,
          "75%": 1.16
        },
        "42037": {
          "name": "Columbia",
          "median": 1.12,
          "10%": 1.08,
          "90%": 1.21,
          "25%": 1.09,
          "75%": 1.15
        },
        "36023": {
          "name": "Cortland",
          "median": 1.11,
          "10%": 1.01,
          "90%": 1.15,
          "25%": 1.11,
          "75%": 1.13
        },
        "51580": {
          "name": "Covington",
          "median": 1.16,
          "10%": 1.06,
          "90%": 1.23,
          "25%": 1.1,
          "75%": 1.19
        },
        "51045": {
          "name": "Craig",
          "median": 1.18,
          "10%": 1.08,
          "90%": 1.22,
          "25%": 1.09,
          "75%": 1.2
        },
        "42039": {
          "name": "Crawford",
          "median": 1.09,
          "10%": 0.97,
          "90%": 1.24,
          "25%": 1.01,
          "75%": 1.19
        },
        "51047": {
          "name": "Culpeper",
          "median": 1.12,
          "10%": 0.97,
          "90%": 1.21,
          "25%": 1.05,
          "75%": 1.17
        },
        "34011": {
          "name": "Cumberland",
          "median": 1.085,
          "10%": 1.05,
          "90%": 1.23,
          "25%": 1.06,
          "75%": 1.14
        },
        "42041": {
          "name": "Cumberland",
          "median": 1.16,
          "10%": 1.08,
          "90%": 1.24,
          "25%": 1.11,
          "75%": 1.22
        },
        "51049": {
          "name": "Cumberland",
          "median": 1.12,
          "10%": 1.01,
          "90%": 1.19,
          "25%": 1.09,
          "75%": 1.18
        },
        "51590": {
          "name": "Danville",
          "median": 1.17,
          "10%": 1.09,
          "90%": 1.22,
          "25%": 1.14,
          "75%": 1.19
        },
        "42043": {
          "name": "Dauphin",
          "median": 1.15,
          "10%": 1.08,
          "90%": 1.25,
          "25%": 1.1,
          "75%": 1.23
        },
        "36025": {
          "name": "Delaware",
          "median": 1.16,
          "10%": 1.08,
          "90%": 1.22,
          "25%": 1.14,
          "75%": 1.18
        },
        "42045": {
          "name": "Delaware",
          "median": 1.13,
          "10%": 1.03,
          "90%": 1.19,
          "25%": 1.05,
          "75%": 1.16
        },
        "51051": {
          "name": "Dickenson",
          "median": 1.16,
          "10%": 1.07,
          "90%": 1.25,
          "25%": 1.1,
          "75%": 1.18
        },
        "51053": {
          "name": "Dinwiddie",
          "median": 1.1,
          "10%": 1.06,
          "90%": 1.22,
          "25%": 1.08,
          "75%": 1.15
        },
        "11001": {
          "name": "District of Columbia",
          "median": 1.12,
          "10%": 1.03,
          "90%": 1.28,
          "25%": 1.05,
          "75%": 1.16
        },
        "54017": {
          "name": "Doddridge",
          "median": 1.15,
          "10%": 1.1,
          "90%": 1.41,
          "25%": 1.11,
          "75%": 1.24
        },
        "24019": {
          "name": "Dorchester",
          "median": 1.12,
          "10%": 1.06,
          "90%": 1.21,
          "25%": 1.07,
          "75%": 1.17
        },
        "42047": {
          "name": "Elk",
          "median": 1.11,
          "10%": 1.02,
          "90%": 1.19,
          "25%": 1.1,
          "75%": 1.16
        },
        "51595": {
          "name": "Emporia",
          "median": 1.17,
          "10%": 1.09,
          "90%": 1.2,
          "25%": 1.11,
          "75%": 1.19
        },
        "42049": {
          "name": "Erie",
          "median": 1.1,
          "10%": 0.98,
          "90%": 1.24,
          "25%": 1.03,
          "75%": 1.2025
        },
        "51057": {
          "name": "Essex",
          "median": 1.09,
          "10%": 1.01,
          "90%": 1.28,
          "25%": 1.06,
          "75%": 1.13
        },
        "51059": {
          "name": "Fairfax",
          "median": 1.11,
          "10%": 1.03,
          "90%": 1.27,
          "25%": 1.07,
          "75%": 1.19
        },
        "51600": {
          "name": "Fairfax",
          "median": 1.11,
          "10%": 1.03,
          "90%": 1.27,
          "25%": 1.06,
          "75%": 1.19
        },
        "51610": {
          "name": "Falls Church",
          "median": 1.11,
          "10%": 1.03,
          "90%": 1.27,
          "25%": 1.06,
          "75%": 1.19
        },
        "51061": {
          "name": "Fauquier",
          "median": 1.13,
          "10%": 0.97,
          "90%": 1.22,
          "25%": 1.05,
          "75%": 1.18
        },
        "42051": {
          "name": "Fayette",
          "median": 1.18,
          "10%": 0.98,
          "90%": 1.29,
          "25%": 1.1,
          "75%": 1.21
        },
        "54019": {
          "name": "Fayette",
          "median": 1.115,
          "10%": 1.09,
          "90%": 1.24,
          "25%": 1.1,
          "75%": 1.21
        },
        "51063": {
          "name": "Floyd",
          "median": 1.13,
          "10%": 1.08,
          "90%": 1.21,
          "25%": 1.09,
          "75%": 1.15
        },
        "51065": {
          "name": "Fluvanna",
          "median": 1.12,
          "10%": 0.99,
          "90%": 1.2,
          "25%": 1.1,
          "75%": 1.17
        },
        "42053": {
          "name": "Forest",
          "median": 1.08,
          "10%": 0.99,
          "90%": 1.25,
          "25%": 1.05,
          "75%": 1.16
        },
        "42055": {
          "name": "Franklin",
          "median": 1.14,
          "10%": 1.1,
          "90%": 1.28,
          "25%": 1.11,
          "75%": 1.21
        },
        "51067": {
          "name": "Franklin",
          "median": 1.18,
          "10%": 1.1,
          "90%": 1.19,
          "25%": 1.12,
          "75%": 1.19
        },
        "51620": {
          "name": "Franklin",
          "median": 1.16,
          "10%": 1.07,
          "90%": 1.2,
          "25%": 1.0875,
          "75%": 1.19
        },
        "24021": {
          "name": "Frederick",
          "median": 1.13,
          "10%": 1.04,
          "90%": 1.25,
          "25%": 1.11,
          "75%": 1.2
        },
        "51069": {
          "name": "Frederick",
          "median": 1.13,
          "10%": 1.08,
          "90%": 1.28,
          "25%": 1.09,
          "75%": 1.22
        },
        "51630": {
          "name": "Fredericksburg",
          "median": 1.1,
          "10%": 1.0,
          "90%": 1.34,
          "25%": 1.08,
          "75%": 1.13
        },
        "42057": {
          "name": "Fulton",
          "median": 1.14,
          "10%": 1.07,
          "90%": 1.24,
          "25%": 1.09,
          "75%": 1.17
        },
        "51640": {
          "name": "Galax",
          "median": 1.14,
          "10%": 1.05,
          "90%": 1.21,
          "25%": 1.0775,
          "75%": 1.16
        },
        "24023": {
          "name": "Garrett",
          "median": 1.15,
          "10%": 1.01,
          "90%": 1.37,
          "25%": 1.09,
          "75%": 1.17
        },
        "51071": {
          "name": "Giles",
          "median": 1.17,
          "10%": 1.08,
          "90%": 1.2,
          "25%": 1.09,
          "75%": 1.19
        },
        "54021": {
          "name": "Gilmer",
          "median": 1.165,
          "10%": 1.07,
          "90%": 1.28,
          "25%": 1.09,
          "75%": 1.27
        },
        "34015": {
          "name": "Gloucester",
          "median": 1.12,
          "10%": 1.03,
          "90%": 1.18,
          "25%": 1.06,
          "75%": 1.16
        },
        "51073": {
          "name": "Gloucester",
          "median": 1.12,
          "10%": 1.06,
          "90%": 1.19,
          "25%": 1.09,
          "75%": 1.12
        },
        "51075": {
          "name": "Goochland",
          "median": 1.12,
          "10%": 1.0,
          "90%": 1.22,
          "25%": 1.09,
          "75%": 1.17
        },
        "54023": {
          "name": "Grant",
          "median": 1.115,
          "10%": 1.02,
          "90%": 1.29,
          "25%": 1.08,
          "75%": 1.18
        },
        "51077": {
          "name": "Grayson",
          "median": 1.135,
          "10%": 1.09,
          "90%": 1.19,
          "25%": 1.09,
          "75%": 1.15
        },
        "54025": {
          "name": "Greenbrier",
          "median": 1.12,
          "10%": 1.05,
          "90%": 1.21,
          "25%": 1.05,
          "75%": 1.14
        },
        "36039": {
          "name": "Greene",
          "median": 1.12,
          "10%": 1.1,
          "90%": 1.16,
          "25%": 1.1,
          "75%": 1.15
        },
        "42059": {
          "name": "Greene",
          "median": 1.19,
          "10%": 0.99,
          "90%": 1.32,
          "25%": 1.13,
          "75%": 1.22
        },
        "51079": {
          "name": "Greene",
          "median": 1.11,
          "10%": 0.95,
          "90%": 1.16,
          "25%": 1.04,
          "75%": 1.15
        },
        "51081": {
          "name": "Greensville",
          "median": 1.16,
          "10%": 1.1,
          "90%": 1.2,
          "25%": 1.11,
          "75%": 1.19
        },
        "51083": {
          "name": "Halifax",
          "median": 1.16,
          "10%": 1.09,
          "90%": 1.21,
          "25%": 1.15,
          "75%": 1.18
        },
        "54027": {
          "name": "Hampshire",
          "median": 1.13,
          "10%": 1.05,
          "90%": 1.32,
          "25%": 1.11,
          "75%": 1.15
        },
        "51650": {
          "name": "Hampton",
          "median": 1.09,
          "10%": 1.05,
          "90%": 1.14,
          "25%": 1.06,
          "75%": 1.11
        },
        "54029": {
          "name": "Hancock",
          "median": 1.13,
          "10%": 1.04,
          "90%": 1.21,
          "25%": 1.06,
          "75%": 1.17
        },
        "51085": {
          "name": "Hanover",
          "median": 1.09,
          "10%": 0.99,
          "90%": 1.25,
          "25%": 1.08,
          "75%": 1.12
        },
        "54031": {
          "name": "Hardy",
          "median": 1.13,
          "10%": 1.04,
          "90%": 1.28,
          "25%": 1.06,
          "75%": 1.17
        },
        "24025": {
          "name": "Harford",
          "median": 1.16,
          "10%": 0.98,
          "90%": 1.25,
          "25%": 1.06,
          "75%": 1.2
        },
        "54033": {
          "name": "Harrison",
          "median": 1.15,
          "10%": 1.07,
          "90%": 1.33,
          "25%": 1.1,
          "75%": 1.21
        },
        "51660": {
          "name": "Harrisonburg",
          "median": 1.125,
          "10%": 0.98,
          "90%": 1.2,
          "25%": 1.06,
          "75%": 1.15
        },
        "51087": {
          "name": "Henrico",
          "median": 1.1,
          "10%": 1.03,
          "90%": 1.24,
          "25%": 1.07,
          "75%": 1.13
        },
        "51089": {
          "name": "Henry",
          "median": 1.16,
          "10%": 1.11,
          "90%": 1.19,
          "25%": 1.13,
          "75%": 1.17
        },
        "36043": {
          "name": "Herkimer",
          "median": 1.055,
          "10%": 1.0,
          "90%": 1.14,
          "25%": 1.04,
          "75%": 1.1025
        },
        "51091": {
          "name": "Highland",
          "median": 1.11,
          "10%": 1.02,
          "90%": 1.23,
          "25%": 1.08,
          "75%": 1.16
        },
        "51670": {
          "name": "Hopewell",
          "median": 1.1,
          "10%": 1.07,
          "90%": 1.22,
          "25%": 1.08,
          "75%": 1.16
        },
        "24027": {
          "name": "Howard",
          "median": 1.15,
          "10%": 1.0,
          "90%": 1.24,
          "25%": 1.07,
          "75%": 1.16
        },
        "34019": {
          "name": "Hunterdon",
          "median": 1.11,
          "10%": 1.05,
          "90%": 1.16,
          "25%": 1.08,
          "75%": 1.15
        },
        "42061": {
          "name": "Huntingdon",
          "median": 1.145,
          "10%": 1.1,
          "90%": 1.25,
          "25%": 1.11,
          "75%": 1.17
        },
        "42063": {
          "name": "Indiana",
          "median": 1.13,
          "10%": 1.04,
          "90%": 1.2,
          "25%": 1.1,
          "75%": 1.19
        },
        "51093": {
          "name": "Isle of Wight",
          "median": 1.16,
          "10%": 1.08,
          "90%": 1.19,
          "25%": 1.09,
          "75%": 1.18
        },
        "54035": {
          "name": "Jackson",
          "median": 1.21,
          "10%": 1.05,
          "90%": 1.28,
          "25%": 1.06,
          "75%": 1.25
        },
        "51095": {
          "name": "James City",
          "median": 1.12,
          "10%": 1.06,
          "90%": 1.22,
          "25%": 1.11,
          "75%": 1.16
        },
        "42065": {
          "name": "Jefferson",
          "median": 1.1,
          "10%": 1.03,
          "90%": 1.2,
          "25%": 1.09,
          "75%": 1.16
        },
        "54037": {
          "name": "Jefferson",
          "median": 1.15,
          "10%": 1.03,
          "90%": 1.25,
          "25%": 1.1,
          "75%": 1.22
        },
        "42067": {
          "name": "Juniata",
          "median": 1.16,
          "10%": 1.08,
          "90%": 1.22,
          "25%": 1.11,
          "75%": 1.21
        },
        "54039": {
          "name": "Kanawha",
          "median": 1.17,
          "10%": 1.07,
          "90%": 1.26,
          "25%": 1.12,
          "75%": 1.25
        },
        "10001": {
          "name": "Kent",
          "median": 1.12,
          "10%": 1.03,
          "90%": 1.23,
          "25%": 1.05,
          "75%": 1.17
        },
        "24029": {
          "name": "Kent",
          "median": 1.14,
          "10%": 1.01,
          "90%": 1.27,
          "25%": 1.03,
          "75%": 1.21
        },
        "51099": {
          "name": "King George",
          "median": 1.1,
          "10%": 1.01,
          "90%": 1.37,
          "25%": 1.08,
          "75%": 1.11
        },
        "51101": {
          "name": "King William",
          "median": 1.08,
          "10%": 0.99,
          "90%": 1.25,
          "25%": 1.06,
          "75%": 1.12
        },
        "51097": {
          "name": "King and Queen",
          "median": 1.08,
          "10%": 1.02,
          "90%": 1.24,
          "25%": 1.05,
          "75%": 1.13
        },
        "42069": {
          "name": "Lackawanna",
          "median": 1.15,
          "10%": 1.07,
          "90%": 1.19,
          "25%": 1.07,
          "75%": 1.17
        },
        "42071": {
          "name": "Lancaster",
          "median": 1.155,
          "10%": 0.99,
          "90%": 1.22,
          "25%": 1.08,
          "75%": 1.21
        },
        "51103": {
          "name": "Lancaster",
          "median": 1.1,
          "10%": 1.04,
          "90%": 1.22,
          "25%": 1.08,
          "75%": 1.13
        },
        "42073": {
          "name": "Lawrence",
          "median": 1.125,
          "10%": 1.01,
          "90%": 1.25,
          "25%": 1.07,
          "75%": 1.17
        },
        "42075": {
          "name": "Lebanon",
          "median": 1.14,
          "10%": 1.02,
          "90%": 1.24,
          "25%": 1.1,
          "75%": 1.22
        },
        "51105": {
          "name": "Lee",
          "median": 1.195,
          "10%": 1.04,
          "90%": 1.25,
          "25%": 1.09,
          "75%": 1.25
        },
        "42077": {
          "name": "Lehigh",
          "median": 1.13,
          "10%": 1.05,
          "90%": 1.18,
          "25%": 1.08,
          "75%": 1.15
        },
        "54041": {
          "name": "Lewis",
          "median": 1.14,
          "10%": 1.07,
          "90%": 1.28,
          "25%": 1.09,
          "75%": 1.23
        },
        "51678": {
          "name": "Lexington",
          "median": 1.155,
          "10%": 1.04,
          "90%": 1.24,
          "25%": 1.06,
          "75%": 1.19
        },
        "54043": {
          "name": "Lincoln",
          "median": 1.185,
          "10%": 1.08,
          "90%": 1.291,
          "25%": 1.13,
          "75%": 1.23
        },
        "36051": {
          "name": "Livingston",
          "median": 1.095,
          "10%": 0.96,
          "90%": 1.25,
          "25%": 0.97,
          "75%": 1.12
        },
        "54045": {
          "name": "Logan",
          "median": 1.15,
          "10%": 1.1,
          "90%": 1.24,
          "25%": 1.1,
          "75%": 1.18
        },
        "51107": {
          "name": "Loudoun",
          "median": 1.14,
          "10%": 1.02,
          "90%": 1.25,
          "25%": 1.09,
          "75%": 1.21
        },
        "51109": {
          "name": "Louisa",
          "median": 1.12,
          "10%": 0.98,
          "90%": 1.2,
          "25%": 1.07,
          "75%": 1.15
        },
        "51111": {
          "name": "Lunenburg",
          "median": 1.13,
          "10%": 1.11,
          "90%": 1.21,
          "25%": 1.12,
          "75%": 1.17
        },
        "42079": {
          "name": "Luzerne",
          "median": 1.13,
          "10%": 1.069,
          "90%": 1.17,
          "25%": 1.08,
          "75%": 1.16
        },
        "42081": {
          "name": "Lycoming",
          "median": 1.145,
          "10%": 1.08,
          "90%": 1.21,
          "25%": 1.11,
          "75%": 1.17
        },
        "51680": {
          "name": "Lynchburg",
          "median": 1.16,
          "10%": 1.06,
          "90%": 1.2,
          "25%": 1.12,
          "75%": 1.19
        },
        "36053": {
          "name": "Madison",
          "median": 1.1,
          "10%": 1.03,
          "90%": 1.17,
          "25%": 1.09,
          "75%": 1.13
        },
        "51113": {
          "name": "Madison",
          "median": 1.12,
          "10%": 0.94,
          "90%": 1.16,
          "25%": 1.03,
          "75%": 1.16
        },
        "51683": {
          "name": "Manassas",
          "median": 1.12,
          "10%": 1.02,
          "90%": 1.26,
          "25%": 1.06,
          "75%": 1.19
        },
        "51685": {
          "name": "Manassas Park",
          "median": 1.11,
          "10%": 1.03,
          "90%": 1.27,
          "25%": 1.06,
          "75%": 1.19
        },
        "54049": {
          "name": "Marion",
          "median": 1.18,
          "10%": 1.03,
          "90%": 1.32,
          "25%": 1.11,
          "75%": 1.19
        },
        "54051": {
          "name": "Marshall",
          "median": 1.17,
          "10%": 1.07,
          "90%": 1.27,
          "25%": 1.1,
          "75%": 1.2
        },
        "51690": {
          "name": "Martinsville",
          "median": 1.16,
          "10%": 1.11,
          "90%": 1.2,
          "25%": 1.14,
          "75%": 1.18
        },
        "54053": {
          "name": "Mason",
          "median": 1.175,
          "10%": 1.06,
          "90%": 1.27,
          "25%": 1.07,
          "75%": 1.24
        },
        "51115": {
          "name": "Mathews",
          "median": 1.09,
          "10%": 1.05,
          "90%": 1.14,
          "25%": 1.06,
          "75%": 1.12
        },
        "54047": {
          "name": "McDowell",
          "median": 1.14,
          "10%": 1.12,
          "90%": 1.18,
          "25%": 1.13,
          "75%": 1.15
        },
        "42083": {
          "name": "McKean",
          "median": 1.08,
          "10%": 0.99,
          "90%": 1.27,
          "25%": 1.01,
          "75%": 1.19
        },
        "51117": {
          "name": "Mecklenburg",
          "median": 1.15,
          "10%": 1.11,
          "90%": 1.21,
          "25%": 1.13,
          "75%": 1.18
        },
        "34021": {
          "name": "Mercer",
          "median": 1.11,
          "10%": 1.01,
          "90%": 1.21,
          "25%": 1.07,
          "75%": 1.19
        },
        "42085": {
          "name": "Mercer",
          "median": 1.11,
          "10%": 0.95,
          "90%": 1.25,
          "25%": 1.06,
          "75%": 1.25
        },
        "54055": {
          "name": "Mercer",
          "median": 1.13,
          "10%": 1.1,
          "90%": 1.18,
          "25%": 1.11,
          "75%": 1.16
        },
        "51119": {
          "name": "Middlesex",
          "median": 1.09,
          "10%": 1.04,
          "90%": 1.23,
          "25%": 1.05,
          "75%": 1.14
        },
        "42087": {
          "name": "Mifflin",
          "median": 1.155,
          "10%": 1.11,
          "90%": 1.26,
          "25%": 1.12,
          "75%": 1.2
        },
        "54057": {
          "name": "Mineral",
          "median": 1.12,
          "10%": 1.03,
          "90%": 1.34,
          "25%": 1.11,
          "75%": 1.16
        },
        "54059": {
          "name": "Mingo",
          "median": 1.155,
          "10%": 1.09,
          "90%": 1.27,
          "25%": 1.1,
          "75%": 1.18
        },
        "34025": {
          "name": "Monmouth",
          "median": 1.12,
          "10%": 1.04,
          "90%": 1.22,
          "25%": 1.06,
          "75%": 1.19
        },
        "54061": {
          "name": "Monongalia",
          "median": 1.19,
          "10%": 0.99,
          "90%": 1.31,
          "25%": 1.11,
          "75%": 1.21
        },
        "42089": {
          "name": "Monroe",
          "median": 1.12,
          "10%": 1.07,
          "90%": 1.17,
          "25%": 1.0875,
          "75%": 1.15
        },
        "54063": {
          "name": "Monroe",
          "median": 1.15,
          "10%": 1.06,
          "90%": 1.2,
          "25%": 1.07,
          "75%": 1.17
        },
        "24031": {
          "name": "Montgomery",
          "median": 1.145,
          "10%": 1.0,
          "90%": 1.25,
          "25%": 1.11,
          "75%": 1.19
        },
        "36057": {
          "name": "Montgomery",
          "median": 1.125,
          "10%": 1.08,
          "90%": 1.17,
          "25%": 1.11,
          "75%": 1.15
        },
        "42091": {
          "name": "Montgomery",
          "median": 1.145,
          "10%": 1.02,
          "90%": 1.2,
          "25%": 1.06,
          "75%": 1.18
        },
        "51121": {
          "name": "Montgomery",
          "median": 1.2,
          "10%": 1.09,
          "90%": 1.22,
          "25%": 1.11,
          "75%": 1.21
        },
        "42093": {
          "name": "Montour",
          "median": 1.14,
          "10%": 1.1,
          "90%": 1.23,
          "25%": 1.11,
          "75%": 1.17
        },
        "54065": {
          "name": "Morgan",
          "median": 1.13,
          "10%": 1.08,
          "90%": 1.28,
          "25%": 1.08,
          "75%": 1.17
        },
        "34027": {
          "name": "Morris",
          "median": 1.105,
          "10%": 1.05,
          "90%": 1.19,
          "25%": 1.06,
          "75%": 1.15
        },
        "36059": {
          "name": "Nassau",
          "median": 1.09,
          "10%": 1.03,
          "90%": 1.2,
          "25%": 1.08,
          "75%": 1.14
        },
        "51125": {
          "name": "Nelson",
          "median": 1.15,
          "10%": 0.99,
          "90%": 1.19,
          "25%": 1.07,
          "75%": 1.18
        },
        "10003": {
          "name": "New Castle",
          "median": 1.155,
          "10%": 1.0,
          "90%": 1.21,
          "25%": 1.03,
          "75%": 1.21
        },
        "51127": {
          "name": "New Kent",
          "median": 1.09,
          "10%": 1.06,
          "90%": 1.24,
          "25%": 1.06,
          "75%": 1.13
        },
        "36061": {
          "name": "New York",
          "median": 1.1,
          "10%": 1.03,
          "90%": 1.24,
          "25%": 1.05,
          "75%": 1.14
        },
        "51700": {
          "name": "Newport News",
          "median": 1.13,
          "10%": 1.06,
          "90%": 1.17,
          "25%": 1.09,
          "75%": 1.14
        },
        "54067": {
          "name": "Nicholas",
          "median": 1.1,
          "10%": 1.05,
          "90%": 1.25,
          "25%": 1.06,
          "75%": 1.23
        },
        "51710": {
          "name": "Norfolk",
          "median": 1.115,
          "10%": 1.05,
          "90%": 1.21,
          "25%": 1.06,
          "75%": 1.19
        },
        "42095": {
          "name": "Northampton",
          "median": 1.12,
          "10%": 1.05,
          "90%": 1.17,
          "25%": 1.1,
          "75%": 1.13
        },
        "51131": {
          "name": "Northampton",
          "median": 1.11,
          "10%": 1.04,
          "90%": 1.2,
          "25%": 1.06,
          "75%": 1.18
        },
        "42097": {
          "name": "Northumberland",
          "median": 1.14,
          "10%": 1.1,
          "90%": 1.23,
          "25%": 1.11,
          "75%": 1.18
        },
        "51133": {
          "name": "Northumberland",
          "median": 1.1,
          "10%": 1.04,
          "90%": 1.21,
          "25%": 1.07,
          "75%": 1.14
        },
        "51720": {
          "name": "Norton",
          "median": 1.19,
          "10%": 1.08,
          "90%": 1.27,
          "25%": 1.1,
          "75%": 1.23
        },
        "51135": {
          "name": "Nottoway",
          "median": 1.11,
          "10%": 1.03,
          "90%": 1.22,
          "25%": 1.1,
          "75%": 1.14
        },
        "34029": {
          "name": "Ocean",
          "median": 1.11,
          "10%": 1.08,
          "90%": 1.19,
          "25%": 1.08,
          "75%": 1.19
        },
        "54069": {
          "name": "Ohio",
          "median": 1.15,
          "10%": 1.03,
          "90%": 1.26,
          "25%": 1.11,
          "75%": 1.21
        },
        "36065": {
          "name": "Oneida",
          "median": 1.11,
          "10%": 1.03,
          "90%": 1.16,
          "25%": 1.1,
          "75%": 1.16
        },
        "36067": {
          "name": "Onondaga",
          "median": 1.11,
          "10%": 1.03,
          "90%": 1.16,
          "25%": 1.09,
          "75%": 1.14
        },
        "36069": {
          "name": "Ontario",
          "median": 1.11,
          "10%": 0.98,
          "90%": 1.18,
          "25%": 0.99,
          "75%": 1.12
        },
        "36071": {
          "name": "Orange",
          "median": 1.11,
          "10%": 1.07,
          "90%": 1.16,
          "25%": 1.08,
          "75%": 1.15
        },
        "51137": {
          "name": "Orange",
          "median": 1.115,
          "10%": 0.97,
          "90%": 1.19,
          "25%": 1.06,
          "75%": 1.16
        },
        "36077": {
          "name": "Otsego",
          "median": 1.13,
          "10%": 1.09,
          "90%": 1.19,
          "25%": 1.12,
          "75%": 1.14
        },
        "51139": {
          "name": "Page",
          "median": 1.16,
          "10%": 0.96,
          "90%": 1.19,
          "25%": 1.04,
          "75%": 1.17
        },
        "51141": {
          "name": "Patrick",
          "median": 1.11,
          "10%": 1.07,
          "90%": 1.21,
          "25%": 1.08,
          "75%": 1.13
        },
        "54071": {
          "name": "Pendleton",
          "median": 1.13,
          "10%": 1.0,
          "90%": 1.22,
          "25%": 1.04,
          "75%": 1.18
        },
        "42099": {
          "name": "Perry",
          "median": 1.165,
          "10%": 1.08,
          "90%": 1.23,
          "25%": 1.11,
          "75%": 1.22
        },
        "51730": {
          "name": "Petersburg",
          "median": 1.1,
          "10%": 1.07,
          "90%": 1.22,
          "25%": 1.08,
          "75%": 1.16
        },
        "42101": {
          "name": "Philadelphia",
          "median": 1.14,
          "10%": 1.039,
          "90%": 1.19,
          "25%": 1.06,
          "75%": 1.15
        },
        "42103": {
          "name": "Pike",
          "median": 1.12,
          "10%": 1.08,
          "90%": 1.19,
          "25%": 1.1,
          "75%": 1.16
        },
        "51143": {
          "name": "Pittsylvania",
          "median": 1.16,
          "10%": 1.09,
          "90%": 1.22,
          "25%": 1.15,
          "75%": 1.19
        },
        "54073": {
          "name": "Pleasants",
          "median": 1.14,
          "10%": 1.05,
          "90%": 1.31,
          "25%": 1.1,
          "75%": 1.2
        },
        "54075": {
          "name": "Pocahontas",
          "median": 1.09,
          "10%": 1.04,
          "90%": 1.21,
          "25%": 1.04,
          "75%": 1.14
        },
        "51735": {
          "name": "Poquoson",
          "median": 1.09,
          "10%": 1.05,
          "90%": 1.14,
          "25%": 1.06,
          "75%": 1.11
        },
        "51740": {
          "name": "Portsmouth",
          "median": 1.115,
          "10%": 1.05,
          "90%": 1.21,
          "25%": 1.06,
          "75%": 1.19
        },
        "42105": {
          "name": "Potter",
          "median": 1.09,
          "10%": 1.01,
          "90%": 1.31,
          "25%": 1.07,
          "75%": 1.13
        },
        "51145": {
          "name": "Powhatan",
          "median": 1.11,
          "10%": 1.0,
          "90%": 1.22,
          "25%": 1.09,
          "75%": 1.15
        },
        "54077": {
          "name": "Preston",
          "median": 1.16,
          "10%": 1.01,
          "90%": 1.27,
          "25%": 1.08,
          "75%": 1.2
        },
        "51147": {
          "name": "Prince Edward",
          "median": 1.125,
          "10%": 1.05,
          "90%": 1.18,
          "25%": 1.09,
          "75%": 1.17
        },
        "51149": {
          "name": "Prince George",
          "median": 1.1,
          "10%": 1.07,
          "90%": 1.22,
          "25%": 1.08,
          "75%": 1.16
        },
        "24033": {
          "name": "Prince George's",
          "median": 1.12,
          "10%": 1.02,
          "90%": 1.28,
          "25%": 1.04,
          "75%": 1.17
        },
        "51153": {
          "name": "Prince William",
          "median": 1.12,
          "10%": 1.0,
          "90%": 1.24,
          "25%": 1.06,
          "75%": 1.18
        },
        "51155": {
          "name": "Pulaski",
          "median": 1.16,
          "10%": 1.08,
          "90%": 1.2,
          "25%": 1.1,
          "75%": 1.17
        },
        "54079": {
          "name": "Putnam",
          "median": 1.19,
          "10%": 1.06,
          "90%": 1.28,
          "25%": 1.11,
          "75%": 1.25
        },
        "24035": {
          "name": "Queen Anne's",
          "median": 1.13,
          "10%": 1.01,
          "90%": 1.26,
          "25%": 1.05,
          "75%": 1.23
        },
        "51750": {
          "name": "Radford",
          "median": 1.17,
          "10%": 1.08,
          "90%": 1.2,
          "25%": 1.09,
          "75%": 1.1825
        },
        "54081": {
          "name": "Raleigh",
          "median": 1.13,
          "10%": 1.09,
          "90%": 1.23,
          "25%": 1.1,
          "75%": 1.19
        },
        "54083": {
          "name": "Randolph",
          "median": 1.105,
          "10%": 1.04,
          "90%": 1.2,
          "25%": 1.07,
          "75%": 1.14
        },
        "51157": {
          "name": "Rappahannock",
          "median": 1.14,
          "10%": 0.94,
          "90%": 1.2,
          "25%": 1.03,
          "75%": 1.19
        },
        "36085": {
          "name": "Richmond",
          "median": 1.095,
          "10%": 1.03,
          "90%": 1.24,
          "25%": 1.05,
          "75%": 1.14
        },
        "51159": {
          "name": "Richmond",
          "median": 1.09,
          "10%": 1.02,
          "90%": 1.26,
          "25%": 1.04,
          "75%": 1.14
        },
        "51760": {
          "name": "Richmond",
          "median": 1.095,
          "10%": 1.01,
          "90%": 1.241,
          "25%": 1.07,
          "75%": 1.12
        },
        "54085": {
          "name": "Ritchie",
          "median": 1.15,
          "10%": 1.07,
          "90%": 1.341,
          "25%": 1.1,
          "75%": 1.22
        },
        "54087": {
          "name": "Roane",
          "median": 1.2,
          "10%": 1.09,
          "90%": 1.27,
          "25%": 1.11,
          "75%": 1.26
        },
        "51161": {
          "name": "Roanoke",
          "median": 1.2,
          "10%": 1.09,
          "90%": 1.23,
          "25%": 1.12,
          "75%": 1.22
        },
        "51770": {
          "name": "Roanoke",
          "median": 1.195,
          "10%": 1.099,
          "90%": 1.23,
          "25%": 1.11,
          "75%": 1.22
        },
        "51163": {
          "name": "Rockbridge",
          "median": 1.16,
          "10%": 1.04,
          "90%": 1.23,
          "25%": 1.08,
          "75%": 1.18
        },
        "51165": {
          "name": "Rockingham",
          "median": 1.14,
          "10%": 0.98,
          "90%": 1.21,
          "25%": 1.05,
          "75%": 1.16
        },
        "51167": {
          "name": "Russell",
          "median": 1.155,
          "10%": 1.11,
          "90%": 1.2,
          "25%": 1.13,
          "75%": 1.18
        },
        "34033": {
          "name": "Salem",
          "median": 1.11,
          "10%": 1.03,
          "90%": 1.18,
          "25%": 1.06,
          "75%": 1.17
        },
        "51775": {
          "name": "Salem",
          "median": 1.2,
          "10%": 1.09,
          "90%": 1.23,
          "25%": 1.12,
          "75%": 1.22
        },
        "36095": {
          "name": "Schoharie",
          "median": 1.13,
          "10%": 1.1,
          "90%": 1.17,
          "25%": 1.11,
          "75%": 1.15
        },
        "36097": {
          "name": "Schuyler",
          "median": 1.135,
          "10%": 0.99,
          "90%": 1.19,
          "25%": 1.08,
          "75%": 1.1725
        },
        "42107": {
          "name": "Schuylkill",
          "median": 1.12,
          "10%": 1.06,
          "90%": 1.22,
          "25%": 1.11,
          "75%": 1.14
        },
        "51169": {
          "name": "Scott",
          "median": 1.18,
          "10%": 1.099,
          "90%": 1.25,
          "25%": 1.1,
          "75%": 1.21
        },
        "51171": {
          "name": "Shenandoah",
          "median": 1.16,
          "10%": 0.99,
          "90%": 1.22,
          "25%": 1.04,
          "75%": 1.18
        },
        "51173": {
          "name": "Smyth",
          "median": 1.12,
          "10%": 1.1,
          "90%": 1.2,
          "25%": 1.11,
          "75%": 1.13
        },
        "42109": {
          "name": "Snyder",
          "median": 1.17,
          "10%": 1.08,
          "90%": 1.23,
          "25%": 1.11,
          "75%": 1.18
        },
        "24039": {
          "name": "Somerset",
          "median": 1.11,
          "10%": 1.08,
          "90%": 1.16,
          "25%": 1.09,
          "75%": 1.15
        },
        "42111": {
          "name": "Somerset",
          "median": 1.13,
          "10%": 1.0,
          "90%": 1.32,
          "25%": 1.09,
          "75%": 1.18
        },
        "51175": {
          "name": "Southampton",
          "median": 1.13,
          "10%": 1.09,
          "90%": 1.21,
          "25%": 1.12,
          "75%": 1.2
        },
        "51177": {
          "name": "Spotsylvania",
          "median": 1.095,
          "10%": 0.99,
          "90%": 1.28,
          "25%": 1.08,
          "75%": 1.16
        },
        "24037": {
          "name": "St. Mary's",
          "median": 1.095,
          "10%": 1.01,
          "90%": 1.28,
          "25%": 1.04,
          "75%": 1.13
        },
        "51179": {
          "name": "Stafford",
          "median": 1.1,
          "10%": 1.0,
          "90%": 1.32,
          "25%": 1.08,
          "75%": 1.14
        },
        "51790": {
          "name": "Staunton",
          "median": 1.12,
          "10%": 1.0,
          "90%": 1.24,
          "25%": 1.07,
          "75%": 1.15
        },
        "36101": {
          "name": "Steuben",
          "median": 1.115,
          "10%": 0.97,
          "90%": 1.17,
          "25%": 1.05,
          "75%": 1.16
        },
        "51800": {
          "name": "Suffolk",
          "median": 1.16,
          "10%": 1.06,
          "90%": 1.2,
          "25%": 1.08,
          "75%": 1.19
        },
        "36105": {
          "name": "Sullivan",
          "median": 1.13,
          "10%": 1.04,
          "90%": 1.24,
          "25%": 1.1,
          "75%": 1.16
        },
        "42113": {
          "name": "Sullivan",
          "median": 1.13,
          "10%": 1.079,
          "90%": 1.2,
          "25%": 1.11,
          "75%": 1.19
        },
        "54089": {
          "name": "Summers",
          "median": 1.13,
          "10%": 1.05,
          "90%": 1.19,
          "25%": 1.07,
          "75%": 1.15
        },
        "51181": {
          "name": "Surry",
          "median": 1.12,
          "10%": 1.07,
          "90%": 1.22,
          "25%": 1.11,
          "75%": 1.14
        },
        "42115": {
          "name": "Susquehanna",
          "median": 1.16,
          "10%": 1.04,
          "90%": 1.25,
          "25%": 1.1,
          "75%": 1.22
        },
        "10005": {
          "name": "Sussex",
          "median": 1.13,
          "10%": 1.06,
          "90%": 1.17,
          "25%": 1.07,
          "75%": 1.16
        },
        "34037": {
          "name": "Sussex",
          "median": 1.13,
          "10%": 1.089,
          "90%": 1.17,
          "25%": 1.09,
          "75%": 1.14
        },
        "51183": {
          "name": "Sussex",
          "median": 1.13,
          "10%": 1.1,
          "90%": 1.2,
          "25%": 1.12,
          "75%": 1.19
        },
        "24041": {
          "name": "Talbot",
          "median": 1.115,
          "10%": 1.0,
          "90%": 1.27,
          "25%": 1.07,
          "75%": 1.23
        },
        "54091": {
          "name": "Taylor",
          "median": 1.14,
          "10%": 1.06,
          "90%": 1.29,
          "25%": 1.09,
          "75%": 1.21
        },
        "51185": {
          "name": "Tazewell",
          "median": 1.13,
          "10%": 1.11,
          "90%": 1.17,
          "25%": 1.12,
          "75%": 1.14
        },
        "36107": {
          "name": "Tioga",
          "median": 1.145,
          "10%": 0.97,
          "90%": 1.2,
          "25%": 1.12,
          "75%": 1.17
        },
        "42117": {
          "name": "Tioga",
          "median": 1.11,
          "10%": 1.04,
          "90%": 1.31,
          "25%": 1.08,
          "75%": 1.13
        },
        "36109": {
          "name": "Tompkins",
          "median": 1.13,
          "10%": 0.99,
          "90%": 1.19,
          "25%": 1.11,
          "75%": 1.15
        },
        "54093": {
          "name": "Tucker",
          "median": 1.135,
          "10%": 1.03,
          "90%": 1.27,
          "25%": 1.08,
          "75%": 1.19
        },
        "54095": {
          "name": "Tyler",
          "median": 1.16,
          "10%": 1.09,
          "90%": 1.36,
          "25%": 1.1,
          "75%": 1.22
        },
        "36111": {
          "name": "Ulster",
          "median": 1.12,
          "10%": 1.04,
          "90%": 1.19,
          "25%": 1.1,
          "75%": 1.15
        },
        "42119": {
          "name": "Union",
          "median": 1.165,
          "10%": 1.08,
          "90%": 1.211,
          "25%": 1.1,
          "75%": 1.18
        },
        "54097": {
          "name": "Upshur",
          "median": 1.12,
          "10%": 1.05,
          "90%": 1.21,
          "25%": 1.09,
          "75%": 1.19
        },
        "42121": {
          "name": "Venango",
          "median": 1.11,
          "10%": 0.96,
          "90%": 1.27,
          "25%": 1.07,
          "75%": 1.17
        },
        "51810": {
          "name": "Virginia Beach",
          "median": 1.13,
          "10%": 1.05,
          "90%": 1.19,
          "25%": 1.06,
          "75%": 1.19
        },
        "34041": {
          "name": "Warren",
          "median": 1.115,
          "10%": 1.06,
          "90%": 1.15,
          "25%": 1.09,
          "75%": 1.14
        },
        "42123": {
          "name": "Warren",
          "median": 1.075,
          "10%": 0.98,
          "90%": 1.27,
          "25%": 0.99,
          "75%": 1.21
        },
        "51187": {
          "name": "Warren",
          "median": 1.14,
          "10%": 0.95,
          "90%": 1.2,
          "25%": 1.04,
          "75%": 1.19
        },
        "24043": {
          "name": "Washington",
          "median": 1.12,
          "10%": 1.1,
          "90%": 1.31,
          "25%": 1.11,
          "75%": 1.21
        },
        "42125": {
          "name": "Washington",
          "median": 1.19,
          "10%": 1.01,
          "90%": 1.25,
          "25%": 1.16,
          "75%": 1.24
        },
        "51191": {
          "name": "Washington",
          "median": 1.14,
          "10%": 1.11,
          "90%": 1.19,
          "25%": 1.12,
          "75%": 1.16
        },
        "42127": {
          "name": "Wayne",
          "median": 1.14,
          "10%": 1.09,
          "90%": 1.24,
          "25%": 1.1,
          "75%": 1.21
        },
        "54099": {
          "name": "Wayne",
          "median": 1.165,
          "10%": 1.08,
          "90%": 1.28,
          "25%": 1.12,
          "75%": 1.21
        },
        "51820": {
          "name": "Waynesboro",
          "median": 1.125,
          "10%": 0.98,
          "90%": 1.2,
          "25%": 1.06,
          "75%": 1.15
        },
        "54101": {
          "name": "Webster",
          "median": 1.09,
          "10%": 1.03,
          "90%": 1.22,
          "25%": 1.08,
          "75%": 1.17
        },
        "36119": {
          "name": "Westchester",
          "median": 1.11,
          "10%": 0.99,
          "90%": 1.19,
          "25%": 1.01,
          "75%": 1.13
        },
        "42129": {
          "name": "Westmoreland",
          "median": 1.16,
          "10%": 0.98,
          "90%": 1.22,
          "25%": 1.11,
          "75%": 1.2
        },
        "51193": {
          "name": "Westmoreland",
          "median": 1.09,
          "10%": 0.99,
          "90%": 1.31,
          "25%": 1.04,
          "75%": 1.12
        },
        "54103": {
          "name": "Wetzel",
          "median": 1.17,
          "10%": 1.06,
          "90%": 1.29,
          "25%": 1.1075,
          "75%": 1.2
        },
        "24045": {
          "name": "Wicomico",
          "median": 1.11,
          "10%": 1.08,
          "90%": 1.17,
          "25%": 1.09,
          "75%": 1.17
        },
        "51830": {
          "name": "Williamsburg",
          "median": 1.12,
          "10%": 1.06,
          "90%": 1.22,
          "25%": 1.11,
          "75%": 1.16
        },
        "51840": {
          "name": "Winchester",
          "median": 1.13,
          "10%": 1.08,
          "90%": 1.28,
          "25%": 1.09,
          "75%": 1.23
        },
        "54105": {
          "name": "Wirt",
          "median": 1.17,
          "10%": 1.06,
          "90%": 1.29,
          "25%": 1.11,
          "75%": 1.23
        },
        "51195": {
          "name": "Wise",
          "median": 1.19,
          "10%": 1.08,
          "90%": 1.23,
          "25%": 1.09,
          "75%": 1.21
        },
        "54107": {
          "name": "Wood",
          "median": 1.145,
          "10%": 1.049,
          "90%": 1.26,
          "25%": 1.09,
          "75%": 1.19
        },
        "24047": {
          "name": "Worcester",
          "median": 1.12,
          "10%": 1.06,
          "90%": 1.21,
          "25%": 1.09,
          "75%": 1.21
        },
        "42131": {
          "name": "Wyoming",
          "median": 1.155,
          "10%": 1.06,
          "90%": 1.2,
          "25%": 1.09,
          "75%": 1.19
        },
        "54109": {
          "name": "Wyoming",
          "median": 1.13,
          "10%": 1.11,
          "90%": 1.2,
          "25%": 1.11,
          "75%": 1.2
        },
        "51197": {
          "name": "Wythe",
          "median": 1.13,
          "10%": 1.08,
          "90%": 1.18,
          "25%": 1.09,
          "75%": 1.17
        },
        "36123": {
          "name": "Yates",
          "median": 1.11,
          "10%": 0.99,
          "90%": 1.17,
          "25%": 0.99,
          "75%": 1.13
        },
        "42133": {
          "name": "York",
          "median": 1.14,
          "10%": 0.99,
          "90%": 1.25,
          "25%": 1.11,
          "75%": 1.21
        },
        "51199": {
          "name": "York",
          "median": 1.12,
          "10%": 1.06,
          "90%": 1.17,
          "25%": 1.09,
          "75%": 1.14
        },
        "max": 1.21,
        "min": 1
      },
      "5": {
        "51001": {
          "name": "Accomack",
          "median": 1.145,
          "10%": 1.06,
          "90%": 1.291,
          "25%": 1.07,
          "75%": 1.27
        },
        "42001": {
          "name": "Adams",
          "median": 1.16,
          "10%": 1.06,
          "90%": 1.36,
          "25%": 1.12,
          "75%": 1.19
        },
        "51003": {
          "name": "Albemarle",
          "median": 1.12,
          "10%": 0.94,
          "90%": 1.2,
          "25%": 1.05,
          "75%": 1.18
        },
        "51510": {
          "name": "Alexandria",
          "median": 1.14,
          "10%": 0.96,
          "90%": 1.27,
          "25%": 1.07,
          "75%": 1.21
        },
        "24001": {
          "name": "Allegany",
          "median": 1.15,
          "10%": 1.0,
          "90%": 1.44,
          "25%": 1.11,
          "75%": 1.18
        },
        "36003": {
          "name": "Allegany",
          "median": 1.12,
          "10%": 0.96,
          "90%": 1.22,
          "25%": 0.99,
          "75%": 1.21
        },
        "51005": {
          "name": "Alleghany",
          "median": 1.17,
          "10%": 1.03,
          "90%": 1.3,
          "25%": 1.04,
          "75%": 1.21
        },
        "42003": {
          "name": "Allegheny",
          "median": 1.12,
          "10%": 1.0,
          "90%": 1.29,
          "25%": 1.09,
          "75%": 1.22
        },
        "51007": {
          "name": "Amelia",
          "median": 1.1,
          "10%": 1.04,
          "90%": 1.27,
          "25%": 1.0675,
          "75%": 1.17
        },
        "51009": {
          "name": "Amherst",
          "median": 1.18,
          "10%": 1.03,
          "90%": 1.26,
          "25%": 1.04,
          "75%": 1.19
        },
        "24003": {
          "name": "Anne Arundel",
          "median": 1.16,
          "10%": 0.98,
          "90%": 1.36,
          "25%": 1.02,
          "75%": 1.21
        },
        "51011": {
          "name": "Appomattox",
          "median": 1.12,
          "10%": 1.05,
          "90%": 1.25,
          "25%": 1.07,
          "75%": 1.2
        },
        "51013": {
          "name": "Arlington",
          "median": 1.14,
          "10%": 0.96,
          "90%": 1.27,
          "25%": 1.07,
          "75%": 1.21
        },
        "42005": {
          "name": "Armstrong",
          "median": 1.13,
          "10%": 1.01,
          "90%": 1.21,
          "25%": 1.07,
          "75%": 1.21
        },
        "34001": {
          "name": "Atlantic",
          "median": 1.12,
          "10%": 1.07,
          "90%": 1.17,
          "25%": 1.1,
          "75%": 1.16
        },
        "51015": {
          "name": "Augusta",
          "median": 1.11,
          "10%": 0.96,
          "90%": 1.26,
          "25%": 1.04,
          "75%": 1.15
        },
        "24005": {
          "name": "Baltimore",
          "median": 1.145,
          "10%": 0.97,
          "90%": 1.32,
          "25%": 1.05,
          "75%": 1.19
        },
        "24510": {
          "name": "Baltimore",
          "median": 1.175,
          "10%": 0.98,
          "90%": 1.31,
          "25%": 1.03,
          "75%": 1.21
        },
        "54001": {
          "name": "Barbour",
          "median": 1.14,
          "10%": 1.03,
          "90%": 1.27,
          "25%": 1.07,
          "75%": 1.26
        },
        "51017": {
          "name": "Bath",
          "median": 1.13,
          "10%": 1.01,
          "90%": 1.29,
          "25%": 1.07,
          "75%": 1.16
        },
        "42007": {
          "name": "Beaver",
          "median": 1.1,
          "10%": 1.01,
          "90%": 1.28,
          "25%": 1.07,
          "75%": 1.18
        },
        "42009": {
          "name": "Bedford",
          "median": 1.16,
          "10%": 1.02,
          "90%": 1.26,
          "25%": 1.1,
          "75%": 1.23
        },
        "51019": {
          "name": "Bedford",
          "median": 1.21,
          "10%": 1.05,
          "90%": 1.26,
          "25%": 1.16,
          "75%": 1.25
        },
        "54003": {
          "name": "Berkeley",
          "median": 1.12,
          "10%": 1.08,
          "90%": 1.31,
          "25%": 1.09,
          "75%": 1.23
        },
        "42011": {
          "name": "Berks",
          "median": 1.15,
          "10%": 0.97,
          "90%": 1.23,
          "25%": 1.05,
          "75%": 1.21
        },
        "42013": {
          "name": "Blair",
          "median": 1.13,
          "10%": 1.07,
          "90%": 1.28,
          "25%": 1.12,
          "75%": 1.17
        },
        "51021": {
          "name": "Bland",
          "median": 1.17,
          "10%": 1.11,
          "90%": 1.2,
          "25%": 1.12,
          "75%": 1.19
        },
        "54005": {
          "name": "Boone",
          "median": 1.17,
          "10%": 1.09,
          "90%": 1.26,
          "25%": 1.1,
          "75%": 1.23
        },
        "51023": {
          "name": "Botetourt",
          "median": 1.2,
          "10%": 1.06,
          "90%": 1.28,
          "25%": 1.09,
          "75%": 1.23
        },
        "42015": {
          "name": "Bradford",
          "median": 1.12,
          "10%": 1.08,
          "90%": 1.32,
          "25%": 1.1,
          "75%": 1.17
        },
        "54007": {
          "name": "Braxton",
          "median": 1.17,
          "10%": 1.04,
          "90%": 1.35,
          "25%": 1.09,
          "75%": 1.24
        },
        "51520": {
          "name": "Bristol",
          "median": 1.17,
          "10%": 1.07,
          "90%": 1.28,
          "25%": 1.1,
          "75%": 1.18
        },
        "36005": {
          "name": "Bronx",
          "median": 1.12,
          "10%": 0.98,
          "90%": 1.18,
          "25%": 1.02,
          "75%": 1.17
        },
        "54009": {
          "name": "Brooke",
          "median": 1.13,
          "10%": 1.04,
          "90%": 1.27,
          "25%": 1.09,
          "75%": 1.24
        },
        "36007": {
          "name": "Broome",
          "median": 1.135,
          "10%": 1.07,
          "90%": 1.19,
          "25%": 1.1,
          "75%": 1.18
        },
        "51025": {
          "name": "Brunswick",
          "median": 1.18,
          "10%": 1.07,
          "90%": 1.21,
          "25%": 1.15,
          "75%": 1.19
        },
        "51027": {
          "name": "Buchanan",
          "median": 1.155,
          "10%": 1.08,
          "90%": 1.22,
          "25%": 1.14,
          "75%": 1.21
        },
        "51029": {
          "name": "Buckingham",
          "median": 1.14,
          "10%": 0.98,
          "90%": 1.26,
          "25%": 1.07,
          "75%": 1.21
        },
        "42017": {
          "name": "Bucks",
          "median": 1.105,
          "10%": 1.05,
          "90%": 1.18,
          "25%": 1.07,
          "75%": 1.16
        },
        "51530": {
          "name": "Buena Vista",
          "median": 1.17,
          "10%": 1.02,
          "90%": 1.28,
          "25%": 1.04,
          "75%": 1.2
        },
        "34005": {
          "name": "Burlington",
          "median": 1.135,
          "10%": 1.08,
          "90%": 1.17,
          "25%": 1.11,
          "75%": 1.16
        },
        "42019": {
          "name": "Butler",
          "median": 1.09,
          "10%": 1.01,
          "90%": 1.28,
          "25%": 1.06,
          "75%": 1.19
        },
        "54011": {
          "name": "Cabell",
          "median": 1.165,
          "10%": 1.08,
          "90%": 1.27,
          "25%": 1.09,
          "75%": 1.26
        },
        "54013": {
          "name": "Calhoun",
          "median": 1.21,
          "10%": 1.11,
          "90%": 1.3,
          "25%": 1.11,
          "75%": 1.26
        },
        "24009": {
          "name": "Calvert",
          "median": 1.115,
          "10%": 0.98,
          "90%": 1.41,
          "25%": 1.0,
          "75%": 1.19
        },
        "42021": {
          "name": "Cambria",
          "median": 1.15,
          "10%": 1.01,
          "90%": 1.23,
          "25%": 1.11,
          "75%": 1.19
        },
        "34007": {
          "name": "Camden",
          "median": 1.12,
          "10%": 1.05,
          "90%": 1.22,
          "25%": 1.1,
          "75%": 1.15
        },
        "42023": {
          "name": "Cameron",
          "median": 1.11,
          "10%": 0.99,
          "90%": 1.22,
          "25%": 1.1,
          "75%": 1.18
        },
        "51031": {
          "name": "Campbell",
          "median": 1.17,
          "10%": 1.04,
          "90%": 1.27,
          "25%": 1.13,
          "75%": 1.2
        },
        "34009": {
          "name": "Cape May",
          "median": 1.1,
          "10%": 1.04,
          "90%": 1.18,
          "25%": 1.07,
          "75%": 1.16
        },
        "42025": {
          "name": "Carbon",
          "median": 1.14,
          "10%": 1.05,
          "90%": 1.2,
          "25%": 1.08,
          "75%": 1.16
        },
        "24011": {
          "name": "Caroline",
          "median": 1.13,
          "10%": 1.02,
          "90%": 1.26,
          "25%": 1.04,
          "75%": 1.22
        },
        "51033": {
          "name": "Caroline",
          "median": 1.1,
          "10%": 0.98,
          "90%": 1.38,
          "25%": 1.07,
          "75%": 1.12
        },
        "24013": {
          "name": "Carroll",
          "median": 1.16,
          "10%": 0.99,
          "90%": 1.32,
          "25%": 1.13,
          "75%": 1.18
        },
        "51035": {
          "name": "Carroll",
          "median": 1.17,
          "10%": 1.04,
          "90%": 1.22,
          "25%": 1.07,
          "75%": 1.19
        },
        "24015": {
          "name": "Cecil",
          "median": 1.13,
          "10%": 0.97,
          "90%": 1.25,
          "25%": 1.02,
          "75%": 1.19
        },
        "42027": {
          "name": "Centre",
          "median": 1.16,
          "10%": 1.08,
          "90%": 1.26,
          "25%": 1.13,
          "75%": 1.2
        },
        "24017": {
          "name": "Charles",
          "median": 1.12,
          "10%": 0.96,
          "90%": 1.41,
          "25%": 1.03,
          "75%": 1.17
        },
        "51036": {
          "name": "Charles City",
          "median": 1.12,
          "10%": 1.03,
          "90%": 1.23,
          "25%": 1.1,
          "75%": 1.1825
        },
        "51037": {
          "name": "Charlotte",
          "median": 1.15,
          "10%": 1.05,
          "90%": 1.24,
          "25%": 1.1,
          "75%": 1.19
        },
        "51540": {
          "name": "Charlottesville",
          "median": 1.1,
          "10%": 0.92,
          "90%": 1.161,
          "25%": 1.03,
          "75%": 1.15
        },
        "36015": {
          "name": "Chemung",
          "median": 1.14,
          "10%": 1.02,
          "90%": 1.22,
          "25%": 1.07,
          "75%": 1.21
        },
        "36017": {
          "name": "Chenango",
          "median": 1.1,
          "10%": 1.08,
          "90%": 1.19,
          "25%": 1.09,
          "75%": 1.15
        },
        "51550": {
          "name": "Chesapeake",
          "median": 1.12,
          "10%": 1.0,
          "90%": 1.22,
          "25%": 1.04,
          "75%": 1.16
        },
        "42029": {
          "name": "Chester",
          "median": 1.14,
          "10%": 0.96,
          "90%": 1.24,
          "25%": 1.0,
          "75%": 1.19
        },
        "51041": {
          "name": "Chesterfield",
          "median": 1.1,
          "10%": 1.05,
          "90%": 1.27,
          "25%": 1.08,
          "75%": 1.13
        },
        "42031": {
          "name": "Clarion",
          "median": 1.1,
          "10%": 0.98,
          "90%": 1.26,
          "25%": 1.04,
          "75%": 1.13
        },
        "51043": {
          "name": "Clarke",
          "median": 1.12,
          "10%": 1.04,
          "90%": 1.28,
          "25%": 1.09,
          "75%": 1.24
        },
        "54015": {
          "name": "Clay",
          "median": 1.155,
          "10%": 1.079,
          "90%": 1.29,
          "25%": 1.09,
          "75%": 1.26
        },
        "42033": {
          "name": "Clearfield",
          "median": 1.16,
          "10%": 1.03,
          "90%": 1.19,
          "25%": 1.1,
          "75%": 1.18
        },
        "42035": {
          "name": "Clinton",
          "median": 1.155,
          "10%": 1.07,
          "90%": 1.22,
          "25%": 1.11,
          "75%": 1.19
        },
        "51570": {
          "name": "Colonial Heights",
          "median": 1.13,
          "10%": 1.03,
          "90%": 1.24,
          "25%": 1.09,
          "75%": 1.1625
        },
        "42037": {
          "name": "Columbia",
          "median": 1.13,
          "10%": 1.08,
          "90%": 1.23,
          "25%": 1.12,
          "75%": 1.21
        },
        "36023": {
          "name": "Cortland",
          "median": 1.1,
          "10%": 1.04,
          "90%": 1.13,
          "25%": 1.09,
          "75%": 1.11
        },
        "51580": {
          "name": "Covington",
          "median": 1.18,
          "10%": 1.05,
          "90%": 1.28,
          "25%": 1.06,
          "75%": 1.21
        },
        "51045": {
          "name": "Craig",
          "median": 1.22,
          "10%": 1.05,
          "90%": 1.28,
          "25%": 1.1,
          "75%": 1.25
        },
        "42039": {
          "name": "Crawford",
          "median": 1.125,
          "10%": 0.96,
          "90%": 1.31,
          "25%": 0.99,
          "75%": 1.27
        },
        "51047": {
          "name": "Culpeper",
          "median": 1.135,
          "10%": 0.92,
          "90%": 1.2,
          "25%": 1.05,
          "75%": 1.18
        },
        "34011": {
          "name": "Cumberland",
          "median": 1.08,
          "10%": 1.03,
          "90%": 1.2,
          "25%": 1.05,
          "75%": 1.14
        },
        "42041": {
          "name": "Cumberland",
          "median": 1.16,
          "10%": 1.11,
          "90%": 1.32,
          "25%": 1.12,
          "75%": 1.25
        },
        "51049": {
          "name": "Cumberland",
          "median": 1.135,
          "10%": 1.0,
          "90%": 1.23,
          "25%": 1.08,
          "75%": 1.22
        },
        "51590": {
          "name": "Danville",
          "median": 1.2,
          "10%": 1.07,
          "90%": 1.26,
          "25%": 1.14,
          "75%": 1.22
        },
        "42043": {
          "name": "Dauphin",
          "median": 1.17,
          "10%": 1.06,
          "90%": 1.28,
          "25%": 1.11,
          "75%": 1.25
        },
        "36025": {
          "name": "Delaware",
          "median": 1.18,
          "10%": 1.05,
          "90%": 1.23,
          "25%": 1.1,
          "75%": 1.2
        },
        "42045": {
          "name": "Delaware",
          "median": 1.09,
          "10%": 1.02,
          "90%": 1.27,
          "25%": 1.05,
          "75%": 1.13
        },
        "51051": {
          "name": "Dickenson",
          "median": 1.16,
          "10%": 1.04,
          "90%": 1.25,
          "25%": 1.14,
          "75%": 1.23
        },
        "51053": {
          "name": "Dinwiddie",
          "median": 1.115,
          "10%": 1.05,
          "90%": 1.25,
          "25%": 1.1,
          "75%": 1.14
        },
        "11001": {
          "name": "District of Columbia",
          "median": 1.16,
          "10%": 0.96,
          "90%": 1.33,
          "25%": 1.05,
          "75%": 1.18
        },
        "54017": {
          "name": "Doddridge",
          "median": 1.16,
          "10%": 1.11,
          "90%": 1.4,
          "25%": 1.12,
          "75%": 1.27
        },
        "24019": {
          "name": "Dorchester",
          "median": 1.115,
          "10%": 1.04,
          "90%": 1.28,
          "25%": 1.06,
          "75%": 1.21
        },
        "42047": {
          "name": "Elk",
          "median": 1.1,
          "10%": 1.02,
          "90%": 1.22,
          "25%": 1.09,
          "75%": 1.16
        },
        "51595": {
          "name": "Emporia",
          "median": 1.18,
          "10%": 1.06,
          "90%": 1.21,
          "25%": 1.14,
          "75%": 1.2
        },
        "42049": {
          "name": "Erie",
          "median": 1.135,
          "10%": 0.98,
          "90%": 1.29,
          "25%": 1.0,
          "75%": 1.25
        },
        "51057": {
          "name": "Essex",
          "median": 1.08,
          "10%": 1.03,
          "90%": 1.34,
          "25%": 1.03,
          "75%": 1.12
        },
        "51059": {
          "name": "Fairfax",
          "median": 1.145,
          "10%": 0.96,
          "90%": 1.27,
          "25%": 1.07,
          "75%": 1.21
        },
        "51600": {
          "name": "Fairfax",
          "median": 1.14,
          "10%": 0.96,
          "90%": 1.27,
          "25%": 1.07,
          "75%": 1.21
        },
        "51610": {
          "name": "Falls Church",
          "median": 1.14,
          "10%": 0.96,
          "90%": 1.27,
          "25%": 1.07,
          "75%": 1.21
        },
        "51061": {
          "name": "Fauquier",
          "median": 1.14,
          "10%": 0.929,
          "90%": 1.2,
          "25%": 1.05,
          "75%": 1.18
        },
        "42051": {
          "name": "Fayette",
          "median": 1.18,
          "10%": 0.96,
          "90%": 1.32,
          "25%": 1.07,
          "75%": 1.27
        },
        "54019": {
          "name": "Fayette",
          "median": 1.13,
          "10%": 1.06,
          "90%": 1.27,
          "25%": 1.09,
          "75%": 1.23
        },
        "51063": {
          "name": "Floyd",
          "median": 1.16,
          "10%": 1.06,
          "90%": 1.23,
          "25%": 1.09,
          "75%": 1.18
        },
        "51065": {
          "name": "Fluvanna",
          "median": 1.12,
          "10%": 0.98,
          "90%": 1.27,
          "25%": 1.08,
          "75%": 1.2
        },
        "42053": {
          "name": "Forest",
          "median": 1.07,
          "10%": 0.98,
          "90%": 1.28,
          "25%": 1.04,
          "75%": 1.17
        },
        "42055": {
          "name": "Franklin",
          "median": 1.16,
          "10%": 1.12,
          "90%": 1.33,
          "25%": 1.12,
          "75%": 1.21
        },
        "51067": {
          "name": "Franklin",
          "median": 1.2,
          "10%": 1.09,
          "90%": 1.24,
          "25%": 1.16,
          "75%": 1.22
        },
        "51620": {
          "name": "Franklin",
          "median": 1.15,
          "10%": 1.04,
          "90%": 1.22,
          "25%": 1.06,
          "75%": 1.2
        },
        "24021": {
          "name": "Frederick",
          "median": 1.15,
          "10%": 1.01,
          "90%": 1.31,
          "25%": 1.13,
          "75%": 1.2
        },
        "51069": {
          "name": "Frederick",
          "median": 1.12,
          "10%": 1.05,
          "90%": 1.3,
          "25%": 1.08,
          "75%": 1.26
        },
        "51630": {
          "name": "Fredericksburg",
          "median": 1.11,
          "10%": 0.96,
          "90%": 1.43,
          "25%": 1.08,
          "75%": 1.13
        },
        "42057": {
          "name": "Fulton",
          "median": 1.16,
          "10%": 1.07,
          "90%": 1.27,
          "25%": 1.11,
          "75%": 1.2
        },
        "51640": {
          "name": "Galax",
          "median": 1.17,
          "10%": 1.04,
          "90%": 1.22,
          "25%": 1.07,
          "75%": 1.19
        },
        "24023": {
          "name": "Garrett",
          "median": 1.16,
          "10%": 0.96,
          "90%": 1.4,
          "25%": 1.08,
          "75%": 1.21
        },
        "51071": {
          "name": "Giles",
          "median": 1.2,
          "10%": 1.06,
          "90%": 1.26,
          "25%": 1.1,
          "75%": 1.24
        },
        "54021": {
          "name": "Gilmer",
          "median": 1.17,
          "10%": 1.06,
          "90%": 1.33,
          "25%": 1.1,
          "75%": 1.28
        },
        "34015": {
          "name": "Gloucester",
          "median": 1.09,
          "10%": 1.03,
          "90%": 1.27,
          "25%": 1.07,
          "75%": 1.13
        },
        "51073": {
          "name": "Gloucester",
          "median": 1.11,
          "10%": 1.03,
          "90%": 1.21,
          "25%": 1.07,
          "75%": 1.18
        },
        "51075": {
          "name": "Goochland",
          "median": 1.13,
          "10%": 0.99,
          "90%": 1.28,
          "25%": 1.08,
          "75%": 1.22
        },
        "54023": {
          "name": "Grant",
          "median": 1.125,
          "10%": 1.0,
          "90%": 1.25,
          "25%": 1.05,
          "75%": 1.23
        },
        "51077": {
          "name": "Grayson",
          "median": 1.15,
          "10%": 1.1,
          "90%": 1.21,
          "25%": 1.11,
          "75%": 1.18
        },
        "54025": {
          "name": "Greenbrier",
          "median": 1.13,
          "10%": 1.01,
          "90%": 1.28,
          "25%": 1.05,
          "75%": 1.15
        },
        "36039": {
          "name": "Greene",
          "median": 1.14,
          "10%": 1.05,
          "90%": 1.17,
          "25%": 1.08,
          "75%": 1.16
        },
        "42059": {
          "name": "Greene",
          "median": 1.21,
          "10%": 1.01,
          "90%": 1.33,
          "25%": 1.13,
          "75%": 1.23
        },
        "51079": {
          "name": "Greene",
          "median": 1.1,
          "10%": 0.92,
          "90%": 1.16,
          "25%": 1.04,
          "75%": 1.15
        },
        "51081": {
          "name": "Greensville",
          "median": 1.17,
          "10%": 1.07,
          "90%": 1.21,
          "25%": 1.14,
          "75%": 1.19
        },
        "51083": {
          "name": "Halifax",
          "median": 1.18,
          "10%": 1.06,
          "90%": 1.24,
          "25%": 1.16,
          "75%": 1.2
        },
        "54027": {
          "name": "Hampshire",
          "median": 1.14,
          "10%": 1.03,
          "90%": 1.33,
          "25%": 1.11,
          "75%": 1.19
        },
        "51650": {
          "name": "Hampton",
          "median": 1.095,
          "10%": 1.02,
          "90%": 1.17,
          "25%": 1.04,
          "75%": 1.12
        },
        "54029": {
          "name": "Hancock",
          "median": 1.12,
          "10%": 1.02,
          "90%": 1.26,
          "25%": 1.05,
          "75%": 1.16
        },
        "51085": {
          "name": "Hanover",
          "median": 1.09,
          "10%": 1.0,
          "90%": 1.3,
          "25%": 1.0775,
          "75%": 1.15
        },
        "54031": {
          "name": "Hardy",
          "median": 1.14,
          "10%": 1.02,
          "90%": 1.26,
          "25%": 1.04,
          "75%": 1.2
        },
        "24025": {
          "name": "Harford",
          "median": 1.16,
          "10%": 0.96,
          "90%": 1.3,
          "25%": 1.05,
          "75%": 1.21
        },
        "54033": {
          "name": "Harrison",
          "median": 1.14,
          "10%": 1.07,
          "90%": 1.35,
          "25%": 1.08,
          "75%": 1.28
        },
        "51660": {
          "name": "Harrisonburg",
          "median": 1.105,
          "10%": 0.96,
          "90%": 1.21,
          "25%": 1.0,
          "75%": 1.15
        },
        "51087": {
          "name": "Henrico",
          "median": 1.1,
          "10%": 1.06,
          "90%": 1.27,
          "25%": 1.07,
          "75%": 1.12
        },
        "51089": {
          "name": "Henry",
          "median": 1.15,
          "10%": 1.11,
          "90%": 1.23,
          "25%": 1.13,
          "75%": 1.21
        },
        "36043": {
          "name": "Herkimer",
          "median": 1.07,
          "10%": 0.97,
          "90%": 1.15,
          "25%": 1.01,
          "75%": 1.12
        },
        "51091": {
          "name": "Highland",
          "median": 1.1,
          "10%": 0.99,
          "90%": 1.29,
          "25%": 1.06,
          "75%": 1.14
        },
        "51670": {
          "name": "Hopewell",
          "median": 1.13,
          "10%": 1.03,
          "90%": 1.24,
          "25%": 1.09,
          "75%": 1.1625
        },
        "24027": {
          "name": "Howard",
          "median": 1.18,
          "10%": 0.98,
          "90%": 1.3,
          "25%": 1.06,
          "75%": 1.2
        },
        "34019": {
          "name": "Hunterdon",
          "median": 1.11,
          "10%": 1.05,
          "90%": 1.16,
          "25%": 1.06,
          "75%": 1.14
        },
        "42061": {
          "name": "Huntingdon",
          "median": 1.15,
          "10%": 1.09,
          "90%": 1.28,
          "25%": 1.14,
          "75%": 1.19
        },
        "42063": {
          "name": "Indiana",
          "median": 1.15,
          "10%": 1.01,
          "90%": 1.21,
          "25%": 1.08,
          "75%": 1.2
        },
        "51093": {
          "name": "Isle of Wight",
          "median": 1.14,
          "10%": 1.05,
          "90%": 1.21,
          "25%": 1.08,
          "75%": 1.19
        },
        "54035": {
          "name": "Jackson",
          "median": 1.22,
          "10%": 1.05,
          "90%": 1.29,
          "25%": 1.07,
          "75%": 1.2625
        },
        "51095": {
          "name": "James City",
          "median": 1.12,
          "10%": 1.04,
          "90%": 1.23,
          "25%": 1.1,
          "75%": 1.22
        },
        "42065": {
          "name": "Jefferson",
          "median": 1.09,
          "10%": 1.01,
          "90%": 1.22,
          "25%": 1.07,
          "75%": 1.18
        },
        "54037": {
          "name": "Jefferson",
          "median": 1.15,
          "10%": 1.0,
          "90%": 1.25,
          "25%": 1.1,
          "75%": 1.23
        },
        "42067": {
          "name": "Juniata",
          "median": 1.18,
          "10%": 1.1,
          "90%": 1.25,
          "25%": 1.11,
          "75%": 1.23
        },
        "54039": {
          "name": "Kanawha",
          "median": 1.18,
          "10%": 1.09,
          "90%": 1.26,
          "25%": 1.1,
          "75%": 1.25
        },
        "10001": {
          "name": "Kent",
          "median": 1.12,
          "10%": 1.02,
          "90%": 1.22,
          "25%": 1.04,
          "75%": 1.19
        },
        "24029": {
          "name": "Kent",
          "median": 1.115,
          "10%": 1.0,
          "90%": 1.33,
          "25%": 1.01,
          "75%": 1.22
        },
        "51099": {
          "name": "King George",
          "median": 1.1,
          "10%": 0.97,
          "90%": 1.48,
          "25%": 1.07,
          "75%": 1.12
        },
        "51101": {
          "name": "King William",
          "median": 1.075,
          "10%": 1.03,
          "90%": 1.27,
          "25%": 1.04,
          "75%": 1.11
        },
        "51097": {
          "name": "King and Queen",
          "median": 1.09,
          "10%": 1.03,
          "90%": 1.27,
          "25%": 1.05,
          "75%": 1.11
        },
        "42069": {
          "name": "Lackawanna",
          "median": 1.16,
          "10%": 1.07,
          "90%": 1.2,
          "25%": 1.09,
          "75%": 1.19
        },
        "42071": {
          "name": "Lancaster",
          "median": 1.17,
          "10%": 0.95,
          "90%": 1.24,
          "25%": 1.09,
          "75%": 1.23
        },
        "51103": {
          "name": "Lancaster",
          "median": 1.11,
          "10%": 1.0,
          "90%": 1.27,
          "25%": 1.05,
          "75%": 1.18
        },
        "42073": {
          "name": "Lawrence",
          "median": 1.12,
          "10%": 1.0,
          "90%": 1.28,
          "25%": 1.03,
          "75%": 1.18
        },
        "42075": {
          "name": "Lebanon",
          "median": 1.17,
          "10%": 0.98,
          "90%": 1.27,
          "25%": 1.11,
          "75%": 1.24
        },
        "51105": {
          "name": "Lee",
          "median": 1.19,
          "10%": 0.97,
          "90%": 1.23,
          "25%": 1.12,
          "75%": 1.22
        },
        "42077": {
          "name": "Lehigh",
          "median": 1.13,
          "10%": 1.05,
          "90%": 1.19,
          "25%": 1.07,
          "75%": 1.16
        },
        "54041": {
          "name": "Lewis",
          "median": 1.15,
          "10%": 1.06,
          "90%": 1.3,
          "25%": 1.09,
          "75%": 1.28
        },
        "51678": {
          "name": "Lexington",
          "median": 1.17,
          "10%": 1.02,
          "90%": 1.28,
          "25%": 1.04,
          "75%": 1.2
        },
        "54043": {
          "name": "Lincoln",
          "median": 1.195,
          "10%": 1.08,
          "90%": 1.26,
          "25%": 1.09,
          "75%": 1.25
        },
        "36051": {
          "name": "Livingston",
          "median": 1.065,
          "10%": 0.94,
          "90%": 1.25,
          "25%": 0.97,
          "75%": 1.15
        },
        "54045": {
          "name": "Logan",
          "median": 1.17,
          "10%": 1.07,
          "90%": 1.25,
          "25%": 1.12,
          "75%": 1.21
        },
        "51107": {
          "name": "Loudoun",
          "median": 1.155,
          "10%": 0.98,
          "90%": 1.24,
          "25%": 1.11,
          "75%": 1.22
        },
        "51109": {
          "name": "Louisa",
          "median": 1.13,
          "10%": 0.96,
          "90%": 1.24,
          "25%": 1.08,
          "75%": 1.19
        },
        "51111": {
          "name": "Lunenburg",
          "median": 1.16,
          "10%": 1.09,
          "90%": 1.27,
          "25%": 1.14,
          "75%": 1.18
        },
        "42079": {
          "name": "Luzerne",
          "median": 1.14,
          "10%": 1.08,
          "90%": 1.2,
          "25%": 1.09,
          "75%": 1.18
        },
        "42081": {
          "name": "Lycoming",
          "median": 1.15,
          "10%": 1.08,
          "90%": 1.25,
          "25%": 1.11,
          "75%": 1.18
        },
        "51680": {
          "name": "Lynchburg",
          "median": 1.17,
          "10%": 1.04,
          "90%": 1.28,
          "25%": 1.15,
          "75%": 1.23
        },
        "36053": {
          "name": "Madison",
          "median": 1.1,
          "10%": 1.04,
          "90%": 1.16,
          "25%": 1.06,
          "75%": 1.12
        },
        "51113": {
          "name": "Madison",
          "median": 1.1,
          "10%": 0.91,
          "90%": 1.17,
          "25%": 1.03,
          "75%": 1.16
        },
        "51683": {
          "name": "Manassas",
          "median": 1.14,
          "10%": 0.95,
          "90%": 1.25,
          "25%": 1.06,
          "75%": 1.21
        },
        "51685": {
          "name": "Manassas Park",
          "median": 1.14,
          "10%": 0.96,
          "90%": 1.27,
          "25%": 1.07,
          "75%": 1.21
        },
        "54049": {
          "name": "Marion",
          "median": 1.185,
          "10%": 1.04,
          "90%": 1.34,
          "25%": 1.11,
          "75%": 1.24
        },
        "54051": {
          "name": "Marshall",
          "median": 1.18,
          "10%": 1.06,
          "90%": 1.24,
          "25%": 1.07,
          "75%": 1.22
        },
        "51690": {
          "name": "Martinsville",
          "median": 1.16,
          "10%": 1.11,
          "90%": 1.24,
          "25%": 1.13,
          "75%": 1.22
        },
        "54053": {
          "name": "Mason",
          "median": 1.19,
          "10%": 1.06,
          "90%": 1.28,
          "25%": 1.07,
          "75%": 1.26
        },
        "51115": {
          "name": "Mathews",
          "median": 1.095,
          "10%": 1.02,
          "90%": 1.18,
          "25%": 1.04,
          "75%": 1.13
        },
        "54047": {
          "name": "McDowell",
          "median": 1.14,
          "10%": 1.12,
          "90%": 1.21,
          "25%": 1.12,
          "75%": 1.19
        },
        "42083": {
          "name": "McKean",
          "median": 1.085,
          "10%": 0.96,
          "90%": 1.27,
          "25%": 1.02,
          "75%": 1.22
        },
        "51117": {
          "name": "Mecklenburg",
          "median": 1.17,
          "10%": 1.08,
          "90%": 1.26,
          "25%": 1.16,
          "75%": 1.21
        },
        "34021": {
          "name": "Mercer",
          "median": 1.13,
          "10%": 1.03,
          "90%": 1.18,
          "25%": 1.06,
          "75%": 1.17
        },
        "42085": {
          "name": "Mercer",
          "median": 1.09,
          "10%": 0.93,
          "90%": 1.28,
          "25%": 1.06,
          "75%": 1.27
        },
        "54055": {
          "name": "Mercer",
          "median": 1.16,
          "10%": 1.12,
          "90%": 1.2,
          "25%": 1.13,
          "75%": 1.19
        },
        "51119": {
          "name": "Middlesex",
          "median": 1.11,
          "10%": 1.01,
          "90%": 1.27,
          "25%": 1.05,
          "75%": 1.14
        },
        "42087": {
          "name": "Mifflin",
          "median": 1.17,
          "10%": 1.09,
          "90%": 1.27,
          "25%": 1.12,
          "75%": 1.23
        },
        "54057": {
          "name": "Mineral",
          "median": 1.13,
          "10%": 1.0,
          "90%": 1.35,
          "25%": 1.12,
          "75%": 1.18
        },
        "54059": {
          "name": "Mingo",
          "median": 1.19,
          "10%": 1.07,
          "90%": 1.24,
          "25%": 1.12,
          "75%": 1.23
        },
        "34025": {
          "name": "Monmouth",
          "median": 1.14,
          "10%": 0.98,
          "90%": 1.23,
          "25%": 1.11,
          "75%": 1.2
        },
        "54061": {
          "name": "Monongalia",
          "median": 1.195,
          "10%": 0.99,
          "90%": 1.34,
          "25%": 1.1,
          "75%": 1.24
        },
        "42089": {
          "name": "Monroe",
          "median": 1.15,
          "10%": 1.07,
          "90%": 1.18,
          "25%": 1.1,
          "75%": 1.17
        },
        "54063": {
          "name": "Monroe",
          "median": 1.17,
          "10%": 1.03,
          "90%": 1.26,
          "25%": 1.05,
          "75%": 1.19
        },
        "24031": {
          "name": "Montgomery",
          "median": 1.17,
          "10%": 0.97,
          "90%": 1.27,
          "25%": 1.13,
          "75%": 1.2
        },
        "36057": {
          "name": "Montgomery",
          "median": 1.145,
          "10%": 1.03,
          "90%": 1.18,
          "25%": 1.12,
          "75%": 1.17
        },
        "42091": {
          "name": "Montgomery",
          "median": 1.11,
          "10%": 1.03,
          "90%": 1.22,
          "25%": 1.04,
          "75%": 1.16
        },
        "51121": {
          "name": "Montgomery",
          "median": 1.24,
          "10%": 1.06,
          "90%": 1.281,
          "25%": 1.14,
          "75%": 1.27
        },
        "42093": {
          "name": "Montour",
          "median": 1.15,
          "10%": 1.1,
          "90%": 1.25,
          "25%": 1.13,
          "75%": 1.23
        },
        "54065": {
          "name": "Morgan",
          "median": 1.14,
          "10%": 1.06,
          "90%": 1.33,
          "25%": 1.11,
          "75%": 1.22
        },
        "34027": {
          "name": "Morris",
          "median": 1.1,
          "10%": 1.01,
          "90%": 1.19,
          "25%": 1.04,
          "75%": 1.16
        },
        "36059": {
          "name": "Nassau",
          "median": 1.1,
          "10%": 1.01,
          "90%": 1.25,
          "25%": 1.09,
          "75%": 1.13
        },
        "51125": {
          "name": "Nelson",
          "median": 1.14,
          "10%": 0.96,
          "90%": 1.26,
          "25%": 1.06,
          "75%": 1.21
        },
        "10003": {
          "name": "New Castle",
          "median": 1.12,
          "10%": 0.97,
          "90%": 1.24,
          "25%": 1.01,
          "75%": 1.2
        },
        "51127": {
          "name": "New Kent",
          "median": 1.11,
          "10%": 1.04,
          "90%": 1.25,
          "25%": 1.07,
          "75%": 1.12
        },
        "36061": {
          "name": "New York",
          "median": 1.105,
          "10%": 0.97,
          "90%": 1.21,
          "25%": 1.04,
          "75%": 1.18
        },
        "51700": {
          "name": "Newport News",
          "median": 1.12,
          "10%": 1.04,
          "90%": 1.19,
          "25%": 1.07,
          "75%": 1.19
        },
        "54067": {
          "name": "Nicholas",
          "median": 1.11,
          "10%": 1.03,
          "90%": 1.29,
          "25%": 1.04,
          "75%": 1.2325
        },
        "51710": {
          "name": "Norfolk",
          "median": 1.12,
          "10%": 1.0,
          "90%": 1.22,
          "25%": 1.04,
          "75%": 1.16
        },
        "42095": {
          "name": "Northampton",
          "median": 1.12,
          "10%": 1.03,
          "90%": 1.16,
          "25%": 1.1,
          "75%": 1.15
        },
        "51131": {
          "name": "Northampton",
          "median": 1.115,
          "10%": 0.99,
          "90%": 1.18,
          "25%": 1.05,
          "75%": 1.17
        },
        "42097": {
          "name": "Northumberland",
          "median": 1.16,
          "10%": 1.11,
          "90%": 1.26,
          "25%": 1.12,
          "75%": 1.24
        },
        "51133": {
          "name": "Northumberland",
          "median": 1.11,
          "10%": 1.0,
          "90%": 1.28,
          "25%": 1.05,
          "75%": 1.19
        },
        "51720": {
          "name": "Norton",
          "median": 1.19,
          "10%": 1.04,
          "90%": 1.22,
          "25%": 1.08,
          "75%": 1.2
        },
        "51135": {
          "name": "Nottoway",
          "median": 1.115,
          "10%": 1.04,
          "90%": 1.27,
          "25%": 1.07,
          "75%": 1.19
        },
        "34029": {
          "name": "Ocean",
          "median": 1.14,
          "10%": 1.05,
          "90%": 1.21,
          "25%": 1.1,
          "75%": 1.2
        },
        "54069": {
          "name": "Ohio",
          "median": 1.13,
          "10%": 1.04,
          "90%": 1.27,
          "25%": 1.09,
          "75%": 1.24
        },
        "36065": {
          "name": "Oneida",
          "median": 1.11,
          "10%": 1.0,
          "90%": 1.18,
          "25%": 1.07,
          "75%": 1.13
        },
        "36067": {
          "name": "Onondaga",
          "median": 1.09,
          "10%": 1.04,
          "90%": 1.15,
          "25%": 1.06,
          "75%": 1.13
        },
        "36069": {
          "name": "Ontario",
          "median": 1.1,
          "10%": 0.94,
          "90%": 1.18,
          "25%": 0.99,
          "75%": 1.12
        },
        "36071": {
          "name": "Orange",
          "median": 1.11,
          "10%": 1.05,
          "90%": 1.18,
          "25%": 1.06,
          "75%": 1.14
        },
        "51137": {
          "name": "Orange",
          "median": 1.11,
          "10%": 0.92,
          "90%": 1.19,
          "25%": 1.06,
          "75%": 1.17
        },
        "36077": {
          "name": "Otsego",
          "median": 1.13,
          "10%": 1.09,
          "90%": 1.21,
          "25%": 1.09,
          "75%": 1.15
        },
        "51139": {
          "name": "Page",
          "median": 1.14,
          "10%": 0.93,
          "90%": 1.19,
          "25%": 1.01,
          "75%": 1.17
        },
        "51141": {
          "name": "Patrick",
          "median": 1.14,
          "10%": 1.05,
          "90%": 1.22,
          "25%": 1.07,
          "75%": 1.15
        },
        "54071": {
          "name": "Pendleton",
          "median": 1.11,
          "10%": 0.96,
          "90%": 1.27,
          "25%": 1.03,
          "75%": 1.18
        },
        "42099": {
          "name": "Perry",
          "median": 1.155,
          "10%": 1.11,
          "90%": 1.3,
          "25%": 1.12,
          "75%": 1.25
        },
        "51730": {
          "name": "Petersburg",
          "median": 1.13,
          "10%": 1.03,
          "90%": 1.24,
          "25%": 1.09,
          "75%": 1.1625
        },
        "42101": {
          "name": "Philadelphia",
          "median": 1.11,
          "10%": 1.04,
          "90%": 1.24,
          "25%": 1.06,
          "75%": 1.13
        },
        "42103": {
          "name": "Pike",
          "median": 1.13,
          "10%": 1.1,
          "90%": 1.21,
          "25%": 1.12,
          "75%": 1.16
        },
        "51143": {
          "name": "Pittsylvania",
          "median": 1.18,
          "10%": 1.08,
          "90%": 1.26,
          "25%": 1.14,
          "75%": 1.22
        },
        "54073": {
          "name": "Pleasants",
          "median": 1.165,
          "10%": 1.03,
          "90%": 1.38,
          "25%": 1.1,
          "75%": 1.22
        },
        "54075": {
          "name": "Pocahontas",
          "median": 1.08,
          "10%": 0.99,
          "90%": 1.27,
          "25%": 1.02,
          "75%": 1.16
        },
        "51735": {
          "name": "Poquoson",
          "median": 1.09,
          "10%": 1.02,
          "90%": 1.17,
          "25%": 1.04,
          "75%": 1.12
        },
        "51740": {
          "name": "Portsmouth",
          "median": 1.12,
          "10%": 1.0,
          "90%": 1.22,
          "25%": 1.04,
          "75%": 1.16
        },
        "42105": {
          "name": "Potter",
          "median": 1.08,
          "10%": 1.02,
          "90%": 1.3,
          "25%": 1.05,
          "75%": 1.12
        },
        "51145": {
          "name": "Powhatan",
          "median": 1.13,
          "10%": 1.0,
          "90%": 1.29,
          "25%": 1.08,
          "75%": 1.19
        },
        "54077": {
          "name": "Preston",
          "median": 1.15,
          "10%": 0.99,
          "90%": 1.27,
          "25%": 1.07,
          "75%": 1.26
        },
        "51147": {
          "name": "Prince Edward",
          "median": 1.145,
          "10%": 1.04,
          "90%": 1.22,
          "25%": 1.07,
          "75%": 1.2
        },
        "51149": {
          "name": "Prince George",
          "median": 1.13,
          "10%": 1.03,
          "90%": 1.24,
          "25%": 1.09,
          "75%": 1.1625
        },
        "24033": {
          "name": "Prince George's",
          "median": 1.14,
          "10%": 0.97,
          "90%": 1.4,
          "25%": 1.01,
          "75%": 1.21
        },
        "51153": {
          "name": "Prince William",
          "median": 1.14,
          "10%": 0.94,
          "90%": 1.22,
          "25%": 1.06,
          "75%": 1.21
        },
        "51155": {
          "name": "Pulaski",
          "median": 1.18,
          "10%": 1.06,
          "90%": 1.25,
          "25%": 1.11,
          "75%": 1.22
        },
        "54079": {
          "name": "Putnam",
          "median": 1.19,
          "10%": 1.08,
          "90%": 1.27,
          "25%": 1.09,
          "75%": 1.26
        },
        "24035": {
          "name": "Queen Anne's",
          "median": 1.115,
          "10%": 1.0,
          "90%": 1.31,
          "25%": 1.03,
          "75%": 1.24
        },
        "51750": {
          "name": "Radford",
          "median": 1.2,
          "10%": 1.06,
          "90%": 1.26,
          "25%": 1.09,
          "75%": 1.24
        },
        "54081": {
          "name": "Raleigh",
          "median": 1.15,
          "10%": 1.08,
          "90%": 1.27,
          "25%": 1.11,
          "75%": 1.21
        },
        "54083": {
          "name": "Randolph",
          "median": 1.095,
          "10%": 1.01,
          "90%": 1.28,
          "25%": 1.04,
          "75%": 1.17
        },
        "51157": {
          "name": "Rappahannock",
          "median": 1.14,
          "10%": 0.92,
          "90%": 1.19,
          "25%": 1.01,
          "75%": 1.17
        },
        "36085": {
          "name": "Richmond",
          "median": 1.105,
          "10%": 0.97,
          "90%": 1.21,
          "25%": 1.04,
          "75%": 1.18
        },
        "51159": {
          "name": "Richmond",
          "median": 1.09,
          "10%": 1.01,
          "90%": 1.32,
          "25%": 1.04,
          "75%": 1.12
        },
        "51760": {
          "name": "Richmond",
          "median": 1.08,
          "10%": 1.04,
          "90%": 1.27,
          "25%": 1.06,
          "75%": 1.12
        },
        "54085": {
          "name": "Ritchie",
          "median": 1.165,
          "10%": 1.06,
          "90%": 1.39,
          "25%": 1.11,
          "75%": 1.24
        },
        "54087": {
          "name": "Roane",
          "median": 1.2,
          "10%": 1.11,
          "90%": 1.31,
          "25%": 1.11,
          "75%": 1.26
        },
        "51161": {
          "name": "Roanoke",
          "median": 1.25,
          "10%": 1.069,
          "90%": 1.29,
          "25%": 1.15,
          "75%": 1.27
        },
        "51770": {
          "name": "Roanoke",
          "median": 1.24,
          "10%": 1.07,
          "90%": 1.28,
          "25%": 1.17,
          "75%": 1.27
        },
        "51163": {
          "name": "Rockbridge",
          "median": 1.17,
          "10%": 1.03,
          "90%": 1.28,
          "25%": 1.04,
          "75%": 1.18
        },
        "51165": {
          "name": "Rockingham",
          "median": 1.12,
          "10%": 0.95,
          "90%": 1.23,
          "25%": 1.04,
          "75%": 1.15
        },
        "51167": {
          "name": "Russell",
          "median": 1.16,
          "10%": 1.08,
          "90%": 1.22,
          "25%": 1.1075,
          "75%": 1.19
        },
        "34033": {
          "name": "Salem",
          "median": 1.09,
          "10%": 1.03,
          "90%": 1.25,
          "25%": 1.06,
          "75%": 1.14
        },
        "51775": {
          "name": "Salem",
          "median": 1.25,
          "10%": 1.06,
          "90%": 1.29,
          "25%": 1.15,
          "75%": 1.27
        },
        "36095": {
          "name": "Schoharie",
          "median": 1.15,
          "10%": 1.04,
          "90%": 1.18,
          "25%": 1.11,
          "75%": 1.17
        },
        "36097": {
          "name": "Schuyler",
          "median": 1.14,
          "10%": 1.02,
          "90%": 1.19,
          "25%": 1.06,
          "75%": 1.18
        },
        "42107": {
          "name": "Schuylkill",
          "median": 1.14,
          "10%": 1.06,
          "90%": 1.25,
          "25%": 1.12,
          "75%": 1.23
        },
        "51169": {
          "name": "Scott",
          "median": 1.18,
          "10%": 1.05,
          "90%": 1.23,
          "25%": 1.11,
          "75%": 1.21
        },
        "51171": {
          "name": "Shenandoah",
          "median": 1.15,
          "10%": 0.96,
          "90%": 1.2,
          "25%": 1.02,
          "75%": 1.18
        },
        "51173": {
          "name": "Smyth",
          "median": 1.13,
          "10%": 1.1,
          "90%": 1.22,
          "25%": 1.1,
          "75%": 1.16
        },
        "42109": {
          "name": "Snyder",
          "median": 1.17,
          "10%": 1.09,
          "90%": 1.26,
          "25%": 1.12,
          "75%": 1.24
        },
        "24039": {
          "name": "Somerset",
          "median": 1.135,
          "10%": 1.05,
          "90%": 1.22,
          "25%": 1.07,
          "75%": 1.2
        },
        "42111": {
          "name": "Somerset",
          "median": 1.17,
          "10%": 0.96,
          "90%": 1.34,
          "25%": 1.08,
          "75%": 1.2
        },
        "51175": {
          "name": "Southampton",
          "median": 1.12,
          "10%": 1.08,
          "90%": 1.23,
          "25%": 1.09,
          "75%": 1.22
        },
        "51177": {
          "name": "Spotsylvania",
          "median": 1.105,
          "10%": 0.94,
          "90%": 1.32,
          "25%": 1.08,
          "75%": 1.17
        },
        "24037": {
          "name": "St. Mary's",
          "median": 1.09,
          "10%": 0.98,
          "90%": 1.42,
          "25%": 0.99,
          "75%": 1.16
        },
        "51179": {
          "name": "Stafford",
          "median": 1.12,
          "10%": 0.96,
          "90%": 1.39,
          "25%": 1.07,
          "75%": 1.14
        },
        "51790": {
          "name": "Staunton",
          "median": 1.09,
          "10%": 0.96,
          "90%": 1.27,
          "25%": 1.04,
          "75%": 1.15
        },
        "36101": {
          "name": "Steuben",
          "median": 1.09,
          "10%": 0.98,
          "90%": 1.18,
          "25%": 1.03,
          "75%": 1.13
        },
        "51800": {
          "name": "Suffolk",
          "median": 1.14,
          "10%": 1.04,
          "90%": 1.22,
          "25%": 1.06,
          "75%": 1.19
        },
        "36105": {
          "name": "Sullivan",
          "median": 1.12,
          "10%": 1.03,
          "90%": 1.271,
          "25%": 1.11,
          "75%": 1.14
        },
        "42113": {
          "name": "Sullivan",
          "median": 1.12,
          "10%": 1.1,
          "90%": 1.25,
          "25%": 1.11,
          "75%": 1.2
        },
        "54089": {
          "name": "Summers",
          "median": 1.13,
          "10%": 1.04,
          "90%": 1.24,
          "25%": 1.06,
          "75%": 1.1625
        },
        "51181": {
          "name": "Surry",
          "median": 1.12,
          "10%": 1.04,
          "90%": 1.23,
          "25%": 1.1,
          "75%": 1.2
        },
        "42115": {
          "name": "Susquehanna",
          "median": 1.15,
          "10%": 1.06,
          "90%": 1.28,
          "25%": 1.11,
          "75%": 1.18
        },
        "10005": {
          "name": "Sussex",
          "median": 1.14,
          "10%": 1.03,
          "90%": 1.2,
          "25%": 1.05,
          "75%": 1.16
        },
        "34037": {
          "name": "Sussex",
          "median": 1.12,
          "10%": 1.06,
          "90%": 1.17,
          "25%": 1.1,
          "75%": 1.16
        },
        "51183": {
          "name": "Sussex",
          "median": 1.14,
          "10%": 1.07,
          "90%": 1.21,
          "25%": 1.11,
          "75%": 1.2
        },
        "24041": {
          "name": "Talbot",
          "median": 1.12,
          "10%": 0.98,
          "90%": 1.341,
          "25%": 1.06,
          "75%": 1.27
        },
        "54091": {
          "name": "Taylor",
          "median": 1.14,
          "10%": 1.04,
          "90%": 1.29,
          "25%": 1.07,
          "75%": 1.27
        },
        "51185": {
          "name": "Tazewell",
          "median": 1.14,
          "10%": 1.11,
          "90%": 1.2,
          "25%": 1.13,
          "75%": 1.18
        },
        "36107": {
          "name": "Tioga",
          "median": 1.14,
          "10%": 0.99,
          "90%": 1.21,
          "25%": 1.11,
          "75%": 1.19
        },
        "42117": {
          "name": "Tioga",
          "median": 1.1,
          "10%": 1.059,
          "90%": 1.33,
          "25%": 1.06,
          "75%": 1.13
        },
        "36109": {
          "name": "Tompkins",
          "median": 1.125,
          "10%": 1.02,
          "90%": 1.18,
          "25%": 1.07,
          "75%": 1.17
        },
        "54093": {
          "name": "Tucker",
          "median": 1.125,
          "10%": 1.0,
          "90%": 1.25,
          "25%": 1.07,
          "75%": 1.22
        },
        "54095": {
          "name": "Tyler",
          "median": 1.17,
          "10%": 1.09,
          "90%": 1.34,
          "25%": 1.1,
          "75%": 1.25
        },
        "36111": {
          "name": "Ulster",
          "median": 1.13,
          "10%": 1.03,
          "90%": 1.23,
          "25%": 1.08,
          "75%": 1.16
        },
        "42119": {
          "name": "Union",
          "median": 1.16,
          "10%": 1.08,
          "90%": 1.25,
          "25%": 1.12,
          "75%": 1.23
        },
        "54097": {
          "name": "Upshur",
          "median": 1.115,
          "10%": 1.02,
          "90%": 1.29,
          "25%": 1.08,
          "75%": 1.18
        },
        "42121": {
          "name": "Venango",
          "median": 1.095,
          "10%": 0.96,
          "90%": 1.29,
          "25%": 1.04,
          "75%": 1.2
        },
        "51810": {
          "name": "Virginia Beach",
          "median": 1.115,
          "10%": 1.0,
          "90%": 1.21,
          "25%": 1.03,
          "75%": 1.17
        },
        "34041": {
          "name": "Warren",
          "median": 1.115,
          "10%": 1.06,
          "90%": 1.151,
          "25%": 1.08,
          "75%": 1.14
        },
        "42123": {
          "name": "Warren",
          "median": 1.075,
          "10%": 0.96,
          "90%": 1.3,
          "25%": 0.97,
          "75%": 1.25
        },
        "51187": {
          "name": "Warren",
          "median": 1.14,
          "10%": 0.93,
          "90%": 1.2,
          "25%": 1.01,
          "75%": 1.17
        },
        "24043": {
          "name": "Washington",
          "median": 1.13,
          "10%": 1.11,
          "90%": 1.36,
          "25%": 1.12,
          "75%": 1.2
        },
        "42125": {
          "name": "Washington",
          "median": 1.16,
          "10%": 1.0,
          "90%": 1.29,
          "25%": 1.12,
          "75%": 1.23
        },
        "51191": {
          "name": "Washington",
          "median": 1.14,
          "10%": 1.09,
          "90%": 1.2,
          "25%": 1.1,
          "75%": 1.17
        },
        "42127": {
          "name": "Wayne",
          "median": 1.14,
          "10%": 1.09,
          "90%": 1.31,
          "25%": 1.11,
          "75%": 1.17
        },
        "54099": {
          "name": "Wayne",
          "median": 1.175,
          "10%": 1.07,
          "90%": 1.26,
          "25%": 1.09,
          "75%": 1.24
        },
        "51820": {
          "name": "Waynesboro",
          "median": 1.105,
          "10%": 0.96,
          "90%": 1.21,
          "25%": 1.0,
          "75%": 1.15
        },
        "54101": {
          "name": "Webster",
          "median": 1.09,
          "10%": 0.99,
          "90%": 1.29,
          "25%": 1.08,
          "75%": 1.18
        },
        "36119": {
          "name": "Westchester",
          "median": 1.12,
          "10%": 0.98,
          "90%": 1.18,
          "25%": 1.02,
          "75%": 1.17
        },
        "42129": {
          "name": "Westmoreland",
          "median": 1.135,
          "10%": 0.96,
          "90%": 1.24,
          "25%": 1.07,
          "75%": 1.2
        },
        "51193": {
          "name": "Westmoreland",
          "median": 1.085,
          "10%": 0.96,
          "90%": 1.46,
          "25%": 0.99,
          "75%": 1.15
        },
        "54103": {
          "name": "Wetzel",
          "median": 1.19,
          "10%": 1.07,
          "90%": 1.261,
          "25%": 1.08,
          "75%": 1.22
        },
        "24045": {
          "name": "Wicomico",
          "median": 1.135,
          "10%": 1.04,
          "90%": 1.22,
          "25%": 1.07,
          "75%": 1.19
        },
        "51830": {
          "name": "Williamsburg",
          "median": 1.12,
          "10%": 1.04,
          "90%": 1.23,
          "25%": 1.1,
          "75%": 1.22
        },
        "51840": {
          "name": "Winchester",
          "median": 1.12,
          "10%": 1.05,
          "90%": 1.3,
          "25%": 1.08,
          "75%": 1.26
        },
        "54105": {
          "name": "Wirt",
          "median": 1.185,
          "10%": 1.06,
          "90%": 1.32,
          "25%": 1.1,
          "75%": 1.25
        },
        "51195": {
          "name": "Wise",
          "median": 1.18,
          "10%": 1.03,
          "90%": 1.23,
          "25%": 1.1,
          "75%": 1.22
        },
        "54107": {
          "name": "Wood",
          "median": 1.16,
          "10%": 1.01,
          "90%": 1.29,
          "25%": 1.08,
          "75%": 1.2
        },
        "24047": {
          "name": "Worcester",
          "median": 1.125,
          "10%": 1.03,
          "90%": 1.26,
          "25%": 1.09,
          "75%": 1.21
        },
        "42131": {
          "name": "Wyoming",
          "median": 1.155,
          "10%": 1.08,
          "90%": 1.22,
          "25%": 1.1,
          "75%": 1.18
        },
        "54109": {
          "name": "Wyoming",
          "median": 1.155,
          "10%": 1.08,
          "90%": 1.23,
          "25%": 1.12,
          "75%": 1.22
        },
        "51197": {
          "name": "Wythe",
          "median": 1.17,
          "10%": 1.09,
          "90%": 1.2,
          "25%": 1.11,
          "75%": 1.19
        },
        "36123": {
          "name": "Yates",
          "median": 1.1,
          "10%": 0.94,
          "90%": 1.15,
          "25%": 1.01,
          "75%": 1.12
        },
        "42133": {
          "name": "York",
          "median": 1.145,
          "10%": 0.97,
          "90%": 1.29,
          "25%": 1.11,
          "75%": 1.2
        },
        "51199": {
          "name": "York",
          "median": 1.11,
          "10%": 1.04,
          "90%": 1.21,
          "25%": 1.07,
          "75%": 1.19
        },
        "max": 1.25,
        "min": 1
      },
      "10": {
        "51001": {
          "name": "Accomack",
          "median": 1.13,
          "10%": 1.04,
          "90%": 1.32,
          "25%": 1.04,
          "75%": 1.28
        },
        "42001": {
          "name": "Adams",
          "median": 1.18,
          "10%": 1.05,
          "90%": 1.45,
          "25%": 1.15,
          "75%": 1.2
        },
        "51003": {
          "name": "Albemarle",
          "median": 1.135,
          "10%": 0.94,
          "90%": 1.23,
          "25%": 1.04,
          "75%": 1.18
        },
        "51510": {
          "name": "Alexandria",
          "median": 1.18,
          "10%": 0.91,
          "90%": 1.27,
          "25%": 1.09,
          "75%": 1.22
        },
        "24001": {
          "name": "Allegany",
          "median": 1.17,
          "10%": 1.0,
          "90%": 1.5,
          "25%": 1.16,
          "75%": 1.2
        },
        "36003": {
          "name": "Allegany",
          "median": 1.13,
          "10%": 0.98,
          "90%": 1.25,
          "25%": 1.0,
          "75%": 1.19
        },
        "51005": {
          "name": "Alleghany",
          "median": 1.19,
          "10%": 0.99,
          "90%": 1.36,
          "25%": 1.03,
          "75%": 1.23
        },
        "42003": {
          "name": "Allegheny",
          "median": 1.09,
          "10%": 1.0,
          "90%": 1.31,
          "25%": 1.07,
          "75%": 1.23
        },
        "51007": {
          "name": "Amelia",
          "median": 1.1,
          "10%": 1.04,
          "90%": 1.29,
          "25%": 1.07,
          "75%": 1.21
        },
        "51009": {
          "name": "Amherst",
          "median": 1.18,
          "10%": 1.03,
          "90%": 1.28,
          "25%": 1.04,
          "75%": 1.22
        },
        "24003": {
          "name": "Anne Arundel",
          "median": 1.17,
          "10%": 0.96,
          "90%": 1.43,
          "25%": 1.01,
          "75%": 1.24
        },
        "51011": {
          "name": "Appomattox",
          "median": 1.16,
          "10%": 1.03,
          "90%": 1.29,
          "25%": 1.08,
          "75%": 1.2
        },
        "51013": {
          "name": "Arlington",
          "median": 1.18,
          "10%": 0.91,
          "90%": 1.27,
          "25%": 1.09,
          "75%": 1.22
        },
        "42005": {
          "name": "Armstrong",
          "median": 1.135,
          "10%": 0.99,
          "90%": 1.22,
          "25%": 1.05,
          "75%": 1.21
        },
        "34001": {
          "name": "Atlantic",
          "median": 1.12,
          "10%": 1.06,
          "90%": 1.18,
          "25%": 1.1,
          "75%": 1.15
        },
        "51015": {
          "name": "Augusta",
          "median": 1.08,
          "10%": 0.96,
          "90%": 1.28,
          "25%": 1.02,
          "75%": 1.16
        },
        "24005": {
          "name": "Baltimore",
          "median": 1.16,
          "10%": 0.97,
          "90%": 1.361,
          "25%": 1.03,
          "75%": 1.21
        },
        "24510": {
          "name": "Baltimore",
          "median": 1.2,
          "10%": 0.98,
          "90%": 1.37,
          "25%": 1.02,
          "75%": 1.24
        },
        "54001": {
          "name": "Barbour",
          "median": 1.13,
          "10%": 1.0,
          "90%": 1.31,
          "25%": 1.05,
          "75%": 1.23
        },
        "51017": {
          "name": "Bath",
          "median": 1.125,
          "10%": 1.0,
          "90%": 1.36,
          "25%": 1.03,
          "75%": 1.16
        },
        "42007": {
          "name": "Beaver",
          "median": 1.08,
          "10%": 0.99,
          "90%": 1.31,
          "25%": 1.06,
          "75%": 1.2
        },
        "42009": {
          "name": "Bedford",
          "median": 1.16,
          "10%": 1.02,
          "90%": 1.29,
          "25%": 1.13,
          "75%": 1.24
        },
        "51019": {
          "name": "Bedford",
          "median": 1.24,
          "10%": 1.04,
          "90%": 1.3,
          "25%": 1.1975,
          "75%": 1.28
        },
        "54003": {
          "name": "Berkeley",
          "median": 1.13,
          "10%": 1.07,
          "90%": 1.35,
          "25%": 1.08,
          "75%": 1.24
        },
        "42011": {
          "name": "Berks",
          "median": 1.14,
          "10%": 0.95,
          "90%": 1.25,
          "25%": 1.07,
          "75%": 1.23
        },
        "42013": {
          "name": "Blair",
          "median": 1.14,
          "10%": 1.06,
          "90%": 1.28,
          "25%": 1.13,
          "75%": 1.17
        },
        "51021": {
          "name": "Bland",
          "median": 1.2,
          "10%": 1.12,
          "90%": 1.25,
          "25%": 1.13,
          "75%": 1.22
        },
        "54005": {
          "name": "Boone",
          "median": 1.145,
          "10%": 1.06,
          "90%": 1.28,
          "25%": 1.1,
          "75%": 1.25
        },
        "51023": {
          "name": "Botetourt",
          "median": 1.23,
          "10%": 1.03,
          "90%": 1.33,
          "25%": 1.1,
          "75%": 1.25
        },
        "42015": {
          "name": "Bradford",
          "median": 1.13,
          "10%": 1.07,
          "90%": 1.33,
          "25%": 1.11,
          "75%": 1.19
        },
        "54007": {
          "name": "Braxton",
          "median": 1.16,
          "10%": 1.02,
          "90%": 1.39,
          "25%": 1.1,
          "75%": 1.26
        },
        "51520": {
          "name": "Bristol",
          "median": 1.17,
          "10%": 1.03,
          "90%": 1.32,
          "25%": 1.06,
          "75%": 1.21
        },
        "36005": {
          "name": "Bronx",
          "median": 1.13,
          "10%": 0.97,
          "90%": 1.23,
          "25%": 1.0,
          "75%": 1.16
        },
        "54009": {
          "name": "Brooke",
          "median": 1.13,
          "10%": 1.06,
          "90%": 1.28,
          "25%": 1.07,
          "75%": 1.25
        },
        "36007": {
          "name": "Broome",
          "median": 1.14,
          "10%": 1.1,
          "90%": 1.21,
          "25%": 1.1,
          "75%": 1.17
        },
        "51025": {
          "name": "Brunswick",
          "median": 1.18,
          "10%": 1.03,
          "90%": 1.22,
          "25%": 1.16,
          "75%": 1.2
        },
        "51027": {
          "name": "Buchanan",
          "median": 1.16,
          "10%": 1.06,
          "90%": 1.27,
          "25%": 1.13,
          "75%": 1.24
        },
        "51029": {
          "name": "Buckingham",
          "median": 1.15,
          "10%": 0.99,
          "90%": 1.3,
          "25%": 1.06,
          "75%": 1.22
        },
        "42017": {
          "name": "Bucks",
          "median": 1.11,
          "10%": 1.05,
          "90%": 1.17,
          "25%": 1.07,
          "75%": 1.14
        },
        "51530": {
          "name": "Buena Vista",
          "median": 1.18,
          "10%": 1.02,
          "90%": 1.3,
          "25%": 1.03,
          "75%": 1.21
        },
        "34005": {
          "name": "Burlington",
          "median": 1.14,
          "10%": 1.08,
          "90%": 1.18,
          "25%": 1.1,
          "75%": 1.17
        },
        "42019": {
          "name": "Butler",
          "median": 1.08,
          "10%": 1.02,
          "90%": 1.28,
          "25%": 1.04,
          "75%": 1.2
        },
        "54011": {
          "name": "Cabell",
          "median": 1.16,
          "10%": 1.07,
          "90%": 1.27,
          "25%": 1.09,
          "75%": 1.25
        },
        "54013": {
          "name": "Calhoun",
          "median": 1.17,
          "10%": 1.1,
          "90%": 1.33,
          "25%": 1.12,
          "75%": 1.26
        },
        "24009": {
          "name": "Calvert",
          "median": 1.12,
          "10%": 0.95,
          "90%": 1.49,
          "25%": 0.99,
          "75%": 1.23
        },
        "42021": {
          "name": "Cambria",
          "median": 1.14,
          "10%": 1.0,
          "90%": 1.23,
          "25%": 1.1,
          "75%": 1.17
        },
        "34007": {
          "name": "Camden",
          "median": 1.12,
          "10%": 1.04,
          "90%": 1.24,
          "25%": 1.08,
          "75%": 1.16
        },
        "42023": {
          "name": "Cameron",
          "median": 1.1,
          "10%": 1.0,
          "90%": 1.2,
          "25%": 1.09,
          "75%": 1.18
        },
        "51031": {
          "name": "Campbell",
          "median": 1.18,
          "10%": 1.04,
          "90%": 1.31,
          "25%": 1.16,
          "75%": 1.22
        },
        "34009": {
          "name": "Cape May",
          "median": 1.09,
          "10%": 1.05,
          "90%": 1.19,
          "25%": 1.06,
          "75%": 1.17
        },
        "42025": {
          "name": "Carbon",
          "median": 1.15,
          "10%": 1.06,
          "90%": 1.23,
          "25%": 1.08,
          "75%": 1.18
        },
        "24011": {
          "name": "Caroline",
          "median": 1.125,
          "10%": 1.02,
          "90%": 1.32,
          "25%": 1.03,
          "75%": 1.24
        },
        "51033": {
          "name": "Caroline",
          "median": 1.095,
          "10%": 0.99,
          "90%": 1.42,
          "25%": 1.07,
          "75%": 1.13
        },
        "24013": {
          "name": "Carroll",
          "median": 1.18,
          "10%": 0.98,
          "90%": 1.38,
          "25%": 1.13,
          "75%": 1.2
        },
        "51035": {
          "name": "Carroll",
          "median": 1.2,
          "10%": 1.03,
          "90%": 1.25,
          "25%": 1.09,
          "75%": 1.22
        },
        "24015": {
          "name": "Cecil",
          "median": 1.11,
          "10%": 0.96,
          "90%": 1.26,
          "25%": 1.0075,
          "75%": 1.19
        },
        "42027": {
          "name": "Centre",
          "median": 1.17,
          "10%": 1.07,
          "90%": 1.25,
          "25%": 1.11,
          "75%": 1.23
        },
        "24017": {
          "name": "Charles",
          "median": 1.12,
          "10%": 0.93,
          "90%": 1.47,
          "25%": 1.03,
          "75%": 1.2
        },
        "51036": {
          "name": "Charles City",
          "median": 1.12,
          "10%": 1.0,
          "90%": 1.25,
          "25%": 1.09,
          "75%": 1.23
        },
        "51037": {
          "name": "Charlotte",
          "median": 1.18,
          "10%": 1.03,
          "90%": 1.24,
          "25%": 1.12,
          "75%": 1.21
        },
        "51540": {
          "name": "Charlottesville",
          "median": 1.1,
          "10%": 0.92,
          "90%": 1.17,
          "25%": 1.04,
          "75%": 1.16
        },
        "36015": {
          "name": "Chemung",
          "median": 1.15,
          "10%": 1.05,
          "90%": 1.26,
          "25%": 1.06,
          "75%": 1.18
        },
        "36017": {
          "name": "Chenango",
          "median": 1.1,
          "10%": 1.08,
          "90%": 1.19,
          "25%": 1.09,
          "75%": 1.17
        },
        "51550": {
          "name": "Chesapeake",
          "median": 1.09,
          "10%": 0.95,
          "90%": 1.26,
          "25%": 1.01,
          "75%": 1.17
        },
        "42029": {
          "name": "Chester",
          "median": 1.13,
          "10%": 0.94,
          "90%": 1.25,
          "25%": 1.0,
          "75%": 1.18
        },
        "51041": {
          "name": "Chesterfield",
          "median": 1.1,
          "10%": 1.02,
          "90%": 1.29,
          "25%": 1.08,
          "75%": 1.17
        },
        "42031": {
          "name": "Clarion",
          "median": 1.1,
          "10%": 0.98,
          "90%": 1.26,
          "25%": 1.03,
          "75%": 1.13
        },
        "51043": {
          "name": "Clarke",
          "median": 1.14,
          "10%": 1.01,
          "90%": 1.28,
          "25%": 1.08,
          "75%": 1.24
        },
        "54015": {
          "name": "Clay",
          "median": 1.16,
          "10%": 1.04,
          "90%": 1.31,
          "25%": 1.06,
          "75%": 1.26
        },
        "42033": {
          "name": "Clearfield",
          "median": 1.16,
          "10%": 1.03,
          "90%": 1.19,
          "25%": 1.09,
          "75%": 1.18
        },
        "42035": {
          "name": "Clinton",
          "median": 1.15,
          "10%": 1.08,
          "90%": 1.23,
          "25%": 1.09,
          "75%": 1.2
        },
        "51570": {
          "name": "Colonial Heights",
          "median": 1.12,
          "10%": 0.99,
          "90%": 1.27,
          "25%": 1.09,
          "75%": 1.23
        },
        "42037": {
          "name": "Columbia",
          "median": 1.15,
          "10%": 1.09,
          "90%": 1.29,
          "25%": 1.12,
          "75%": 1.23
        },
        "36023": {
          "name": "Cortland",
          "median": 1.1,
          "10%": 1.05,
          "90%": 1.12,
          "25%": 1.09,
          "75%": 1.11
        },
        "51580": {
          "name": "Covington",
          "median": 1.2,
          "10%": 1.02,
          "90%": 1.33,
          "25%": 1.05,
          "75%": 1.22
        },
        "51045": {
          "name": "Craig",
          "median": 1.26,
          "10%": 1.01,
          "90%": 1.33,
          "25%": 1.11,
          "75%": 1.29
        },
        "42039": {
          "name": "Crawford",
          "median": 1.15,
          "10%": 0.97,
          "90%": 1.37,
          "25%": 0.99,
          "75%": 1.33
        },
        "51047": {
          "name": "Culpeper",
          "median": 1.16,
          "10%": 0.91,
          "90%": 1.2,
          "25%": 1.06,
          "75%": 1.19
        },
        "34011": {
          "name": "Cumberland",
          "median": 1.08,
          "10%": 1.01,
          "90%": 1.17,
          "25%": 1.05,
          "75%": 1.15
        },
        "42041": {
          "name": "Cumberland",
          "median": 1.16,
          "10%": 1.12,
          "90%": 1.38,
          "25%": 1.13,
          "75%": 1.27
        },
        "51049": {
          "name": "Cumberland",
          "median": 1.15,
          "10%": 1.01,
          "90%": 1.271,
          "25%": 1.06,
          "75%": 1.24
        },
        "51590": {
          "name": "Danville",
          "median": 1.23,
          "10%": 1.07,
          "90%": 1.27,
          "25%": 1.11,
          "75%": 1.25
        },
        "42043": {
          "name": "Dauphin",
          "median": 1.17,
          "10%": 1.04,
          "90%": 1.33,
          "25%": 1.11,
          "75%": 1.25
        },
        "36025": {
          "name": "Delaware",
          "median": 1.2,
          "10%": 1.03,
          "90%": 1.24,
          "25%": 1.07,
          "75%": 1.22
        },
        "42045": {
          "name": "Delaware",
          "median": 1.07,
          "10%": 1.01,
          "90%": 1.31,
          "25%": 1.05,
          "75%": 1.13
        },
        "51051": {
          "name": "Dickenson",
          "median": 1.16,
          "10%": 1.02,
          "90%": 1.29,
          "25%": 1.14,
          "75%": 1.26
        },
        "51053": {
          "name": "Dinwiddie",
          "median": 1.12,
          "10%": 1.02,
          "90%": 1.26,
          "25%": 1.09,
          "75%": 1.17
        },
        "11001": {
          "name": "District of Columbia",
          "median": 1.17,
          "10%": 0.919,
          "90%": 1.36,
          "25%": 1.06,
          "75%": 1.23
        },
        "54017": {
          "name": "Doddridge",
          "median": 1.21,
          "10%": 1.12,
          "90%": 1.36,
          "25%": 1.13,
          "75%": 1.27
        },
        "24019": {
          "name": "Dorchester",
          "median": 1.1,
          "10%": 1.03,
          "90%": 1.341,
          "25%": 1.04,
          "75%": 1.23
        },
        "42047": {
          "name": "Elk",
          "median": 1.1,
          "10%": 1.02,
          "90%": 1.21,
          "25%": 1.08,
          "75%": 1.17
        },
        "51595": {
          "name": "Emporia",
          "median": 1.175,
          "10%": 1.03,
          "90%": 1.21,
          "25%": 1.16,
          "75%": 1.19
        },
        "42049": {
          "name": "Erie",
          "median": 1.16,
          "10%": 0.98,
          "90%": 1.33,
          "25%": 0.99,
          "75%": 1.3
        },
        "51057": {
          "name": "Essex",
          "median": 1.08,
          "10%": 1.01,
          "90%": 1.37,
          "25%": 1.04,
          "75%": 1.13
        },
        "51059": {
          "name": "Fairfax",
          "median": 1.18,
          "10%": 0.91,
          "90%": 1.27,
          "25%": 1.09,
          "75%": 1.22
        },
        "51600": {
          "name": "Fairfax",
          "median": 1.18,
          "10%": 0.91,
          "90%": 1.27,
          "25%": 1.09,
          "75%": 1.22
        },
        "51610": {
          "name": "Falls Church",
          "median": 1.18,
          "10%": 0.91,
          "90%": 1.27,
          "25%": 1.09,
          "75%": 1.22
        },
        "51061": {
          "name": "Fauquier",
          "median": 1.15,
          "10%": 0.9,
          "90%": 1.2,
          "25%": 1.06,
          "75%": 1.19
        },
        "42051": {
          "name": "Fayette",
          "median": 1.18,
          "10%": 0.94,
          "90%": 1.34,
          "25%": 1.06,
          "75%": 1.3
        },
        "54019": {
          "name": "Fayette",
          "median": 1.135,
          "10%": 1.04,
          "90%": 1.29,
          "25%": 1.06,
          "75%": 1.25
        },
        "51063": {
          "name": "Floyd",
          "median": 1.19,
          "10%": 1.05,
          "90%": 1.27,
          "25%": 1.12,
          "75%": 1.22
        },
        "51065": {
          "name": "Fluvanna",
          "median": 1.135,
          "10%": 0.97,
          "90%": 1.3,
          "25%": 1.06,
          "75%": 1.26
        },
        "42053": {
          "name": "Forest",
          "median": 1.06,
          "10%": 0.99,
          "90%": 1.3,
          "25%": 1.04,
          "75%": 1.19
        },
        "42055": {
          "name": "Franklin",
          "median": 1.18,
          "10%": 1.13,
          "90%": 1.4,
          "25%": 1.13,
          "75%": 1.21
        },
        "51067": {
          "name": "Franklin",
          "median": 1.22,
          "10%": 1.08,
          "90%": 1.28,
          "25%": 1.2,
          "75%": 1.26
        },
        "51620": {
          "name": "Franklin",
          "median": 1.14,
          "10%": 1.0,
          "90%": 1.271,
          "25%": 1.04,
          "75%": 1.21
        },
        "24021": {
          "name": "Frederick",
          "median": 1.17,
          "10%": 0.99,
          "90%": 1.35,
          "25%": 1.15,
          "75%": 1.21
        },
        "51069": {
          "name": "Frederick",
          "median": 1.12,
          "10%": 1.03,
          "90%": 1.31,
          "25%": 1.05,
          "75%": 1.26
        },
        "51630": {
          "name": "Fredericksburg",
          "median": 1.11,
          "10%": 0.94,
          "90%": 1.48,
          "25%": 1.07,
          "75%": 1.15
        },
        "42057": {
          "name": "Fulton",
          "median": 1.21,
          "10%": 1.07,
          "90%": 1.34,
          "25%": 1.14,
          "75%": 1.23
        },
        "51640": {
          "name": "Galax",
          "median": 1.2,
          "10%": 1.03,
          "90%": 1.25,
          "25%": 1.09,
          "75%": 1.22
        },
        "24023": {
          "name": "Garrett",
          "median": 1.16,
          "10%": 0.94,
          "90%": 1.39,
          "25%": 1.07,
          "75%": 1.2425
        },
        "51071": {
          "name": "Giles",
          "median": 1.24,
          "10%": 1.05,
          "90%": 1.31,
          "25%": 1.13,
          "75%": 1.28
        },
        "54021": {
          "name": "Gilmer",
          "median": 1.18,
          "10%": 1.05,
          "90%": 1.36,
          "25%": 1.1,
          "75%": 1.28
        },
        "34015": {
          "name": "Gloucester",
          "median": 1.09,
          "10%": 1.02,
          "90%": 1.31,
          "25%": 1.05,
          "75%": 1.13
        },
        "51073": {
          "name": "Gloucester",
          "median": 1.1,
          "10%": 1.02,
          "90%": 1.22,
          "25%": 1.05,
          "75%": 1.21
        },
        "51075": {
          "name": "Goochland",
          "median": 1.14,
          "10%": 1.0,
          "90%": 1.34,
          "25%": 1.07,
          "75%": 1.25
        },
        "54023": {
          "name": "Grant",
          "median": 1.12,
          "10%": 0.99,
          "90%": 1.27,
          "25%": 1.02,
          "75%": 1.2
        },
        "51077": {
          "name": "Grayson",
          "median": 1.17,
          "10%": 1.12,
          "90%": 1.23,
          "25%": 1.14,
          "75%": 1.2
        },
        "54025": {
          "name": "Greenbrier",
          "median": 1.13,
          "10%": 0.97,
          "90%": 1.34,
          "25%": 1.06,
          "75%": 1.19
        },
        "36039": {
          "name": "Greene",
          "median": 1.155,
          "10%": 1.0,
          "90%": 1.21,
          "25%": 1.05,
          "75%": 1.17
        },
        "42059": {
          "name": "Greene",
          "median": 1.22,
          "10%": 1.03,
          "90%": 1.34,
          "25%": 1.13,
          "75%": 1.27
        },
        "51079": {
          "name": "Greene",
          "median": 1.095,
          "10%": 0.92,
          "90%": 1.17,
          "25%": 1.03,
          "75%": 1.16
        },
        "51081": {
          "name": "Greensville",
          "median": 1.18,
          "10%": 1.03,
          "90%": 1.2,
          "25%": 1.16,
          "75%": 1.19
        },
        "51083": {
          "name": "Halifax",
          "median": 1.2,
          "10%": 1.04,
          "90%": 1.24,
          "25%": 1.1675,
          "75%": 1.22
        },
        "54027": {
          "name": "Hampshire",
          "median": 1.15,
          "10%": 1.01,
          "90%": 1.33,
          "25%": 1.1,
          "75%": 1.21
        },
        "51650": {
          "name": "Hampton",
          "median": 1.09,
          "10%": 0.98,
          "90%": 1.21,
          "25%": 1.04,
          "75%": 1.16
        },
        "54029": {
          "name": "Hancock",
          "median": 1.11,
          "10%": 0.98,
          "90%": 1.3,
          "25%": 1.06,
          "75%": 1.19
        },
        "51085": {
          "name": "Hanover",
          "median": 1.09,
          "10%": 1.02,
          "90%": 1.33,
          "25%": 1.08,
          "75%": 1.16
        },
        "54031": {
          "name": "Hardy",
          "median": 1.15,
          "10%": 1.01,
          "90%": 1.24,
          "25%": 1.03,
          "75%": 1.22
        },
        "24025": {
          "name": "Harford",
          "median": 1.16,
          "10%": 0.96,
          "90%": 1.32,
          "25%": 1.03,
          "75%": 1.21
        },
        "54033": {
          "name": "Harrison",
          "median": 1.14,
          "10%": 1.06,
          "90%": 1.33,
          "25%": 1.08,
          "75%": 1.3
        },
        "51660": {
          "name": "Harrisonburg",
          "median": 1.085,
          "10%": 0.94,
          "90%": 1.22,
          "25%": 0.96,
          "75%": 1.15
        },
        "51087": {
          "name": "Henrico",
          "median": 1.11,
          "10%": 1.04,
          "90%": 1.3,
          "25%": 1.09,
          "75%": 1.13
        },
        "51089": {
          "name": "Henry",
          "median": 1.17,
          "10%": 1.11,
          "90%": 1.26,
          "25%": 1.13,
          "75%": 1.24
        },
        "36043": {
          "name": "Herkimer",
          "median": 1.07,
          "10%": 0.95,
          "90%": 1.19,
          "25%": 0.99,
          "75%": 1.11
        },
        "51091": {
          "name": "Highland",
          "median": 1.08,
          "10%": 0.97,
          "90%": 1.35,
          "25%": 1.02,
          "75%": 1.15
        },
        "51670": {
          "name": "Hopewell",
          "median": 1.12,
          "10%": 0.99,
          "90%": 1.27,
          "25%": 1.09,
          "75%": 1.23
        },
        "24027": {
          "name": "Howard",
          "median": 1.19,
          "10%": 0.97,
          "90%": 1.34,
          "25%": 1.06,
          "75%": 1.24
        },
        "34019": {
          "name": "Hunterdon",
          "median": 1.12,
          "10%": 1.03,
          "90%": 1.18,
          "25%": 1.07,
          "75%": 1.13
        },
        "42061": {
          "name": "Huntingdon",
          "median": 1.17,
          "10%": 1.08,
          "90%": 1.28,
          "25%": 1.14,
          "75%": 1.2125
        },
        "42063": {
          "name": "Indiana",
          "median": 1.13,
          "10%": 0.99,
          "90%": 1.25,
          "25%": 1.06,
          "75%": 1.2
        },
        "51093": {
          "name": "Isle of Wight",
          "median": 1.12,
          "10%": 1.02,
          "90%": 1.25,
          "25%": 1.07,
          "75%": 1.2
        },
        "54035": {
          "name": "Jackson",
          "median": 1.2,
          "10%": 1.06,
          "90%": 1.31,
          "25%": 1.09,
          "75%": 1.2325
        },
        "51095": {
          "name": "James City",
          "median": 1.11,
          "10%": 1.02,
          "90%": 1.26,
          "25%": 1.09,
          "75%": 1.21
        },
        "42065": {
          "name": "Jefferson",
          "median": 1.1,
          "10%": 1.0,
          "90%": 1.21,
          "25%": 1.05,
          "75%": 1.19
        },
        "54037": {
          "name": "Jefferson",
          "median": 1.17,
          "10%": 0.97,
          "90%": 1.26,
          "25%": 1.11,
          "75%": 1.22
        },
        "42067": {
          "name": "Juniata",
          "median": 1.205,
          "10%": 1.11,
          "90%": 1.29,
          "25%": 1.11,
          "75%": 1.2525
        },
        "54039": {
          "name": "Kanawha",
          "median": 1.17,
          "10%": 1.06,
          "90%": 1.27,
          "25%": 1.1,
          "75%": 1.25
        },
        "10001": {
          "name": "Kent",
          "median": 1.115,
          "10%": 1.02,
          "90%": 1.21,
          "25%": 1.03,
          "75%": 1.2
        },
        "24029": {
          "name": "Kent",
          "median": 1.085,
          "10%": 1.0,
          "90%": 1.34,
          "25%": 1.01,
          "75%": 1.22
        },
        "51099": {
          "name": "King George",
          "median": 1.105,
          "10%": 0.95,
          "90%": 1.53,
          "25%": 1.06,
          "75%": 1.14
        },
        "51101": {
          "name": "King William",
          "median": 1.09,
          "10%": 1.03,
          "90%": 1.27,
          "25%": 1.04,
          "75%": 1.12
        },
        "51097": {
          "name": "King and Queen",
          "median": 1.09,
          "10%": 1.01,
          "90%": 1.28,
          "25%": 1.03,
          "75%": 1.12
        },
        "42069": {
          "name": "Lackawanna",
          "median": 1.15,
          "10%": 1.08,
          "90%": 1.221,
          "25%": 1.1,
          "75%": 1.2
        },
        "42071": {
          "name": "Lancaster",
          "median": 1.17,
          "10%": 0.93,
          "90%": 1.27,
          "25%": 1.09,
          "75%": 1.25
        },
        "51103": {
          "name": "Lancaster",
          "median": 1.11,
          "10%": 0.98,
          "90%": 1.3,
          "25%": 1.02,
          "75%": 1.23
        },
        "42073": {
          "name": "Lawrence",
          "median": 1.115,
          "10%": 1.01,
          "90%": 1.3,
          "25%": 1.02,
          "75%": 1.18
        },
        "42075": {
          "name": "Lebanon",
          "median": 1.2,
          "10%": 0.95,
          "90%": 1.3,
          "25%": 1.1075,
          "75%": 1.26
        },
        "51105": {
          "name": "Lee",
          "median": 1.18,
          "10%": 0.92,
          "90%": 1.22,
          "25%": 1.14,
          "75%": 1.2
        },
        "42077": {
          "name": "Lehigh",
          "median": 1.135,
          "10%": 1.05,
          "90%": 1.22,
          "25%": 1.07,
          "75%": 1.18
        },
        "54041": {
          "name": "Lewis",
          "median": 1.15,
          "10%": 1.04,
          "90%": 1.34,
          "25%": 1.09,
          "75%": 1.27
        },
        "51678": {
          "name": "Lexington",
          "median": 1.18,
          "10%": 1.02,
          "90%": 1.3,
          "25%": 1.03,
          "75%": 1.21
        },
        "54043": {
          "name": "Lincoln",
          "median": 1.19,
          "10%": 1.06,
          "90%": 1.26,
          "25%": 1.09,
          "75%": 1.24
        },
        "36051": {
          "name": "Livingston",
          "median": 1.11,
          "10%": 0.95,
          "90%": 1.25,
          "25%": 0.97,
          "75%": 1.18
        },
        "54045": {
          "name": "Logan",
          "median": 1.15,
          "10%": 1.05,
          "90%": 1.29,
          "25%": 1.1075,
          "75%": 1.25
        },
        "51107": {
          "name": "Loudoun",
          "median": 1.17,
          "10%": 0.959,
          "90%": 1.24,
          "25%": 1.12,
          "75%": 1.21
        },
        "51109": {
          "name": "Louisa",
          "median": 1.13,
          "10%": 0.96,
          "90%": 1.28,
          "25%": 1.08,
          "75%": 1.22
        },
        "51111": {
          "name": "Lunenburg",
          "median": 1.17,
          "10%": 1.06,
          "90%": 1.3,
          "25%": 1.12,
          "75%": 1.23
        },
        "42079": {
          "name": "Luzerne",
          "median": 1.15,
          "10%": 1.09,
          "90%": 1.231,
          "25%": 1.11,
          "75%": 1.2
        },
        "42081": {
          "name": "Lycoming",
          "median": 1.16,
          "10%": 1.04,
          "90%": 1.3,
          "25%": 1.14,
          "75%": 1.19
        },
        "51680": {
          "name": "Lynchburg",
          "median": 1.19,
          "10%": 1.04,
          "90%": 1.311,
          "25%": 1.17,
          "75%": 1.24
        },
        "36053": {
          "name": "Madison",
          "median": 1.09,
          "10%": 1.05,
          "90%": 1.15,
          "25%": 1.05,
          "75%": 1.13
        },
        "51113": {
          "name": "Madison",
          "median": 1.11,
          "10%": 0.91,
          "90%": 1.17,
          "25%": 1.03,
          "75%": 1.16
        },
        "51683": {
          "name": "Manassas",
          "median": 1.18,
          "10%": 0.91,
          "90%": 1.24,
          "25%": 1.08,
          "75%": 1.22
        },
        "51685": {
          "name": "Manassas Park",
          "median": 1.18,
          "10%": 0.91,
          "90%": 1.27,
          "25%": 1.09,
          "75%": 1.22
        },
        "54049": {
          "name": "Marion",
          "median": 1.18,
          "10%": 1.04,
          "90%": 1.33,
          "25%": 1.11,
          "75%": 1.29
        },
        "54051": {
          "name": "Marshall",
          "median": 1.18,
          "10%": 1.04,
          "90%": 1.26,
          "25%": 1.08,
          "75%": 1.2
        },
        "51690": {
          "name": "Martinsville",
          "median": 1.19,
          "10%": 1.1,
          "90%": 1.28,
          "25%": 1.13,
          "75%": 1.26
        },
        "54053": {
          "name": "Mason",
          "median": 1.195,
          "10%": 1.07,
          "90%": 1.31,
          "25%": 1.08,
          "75%": 1.24
        },
        "51115": {
          "name": "Mathews",
          "median": 1.1,
          "10%": 0.99,
          "90%": 1.211,
          "25%": 1.03,
          "75%": 1.17
        },
        "54047": {
          "name": "McDowell",
          "median": 1.13,
          "10%": 1.1,
          "90%": 1.27,
          "25%": 1.11,
          "75%": 1.22
        },
        "42083": {
          "name": "McKean",
          "median": 1.09,
          "10%": 0.95,
          "90%": 1.27,
          "25%": 1.04,
          "75%": 1.23
        },
        "51117": {
          "name": "Mecklenburg",
          "median": 1.19,
          "10%": 1.05,
          "90%": 1.28,
          "25%": 1.13,
          "75%": 1.23
        },
        "34021": {
          "name": "Mercer",
          "median": 1.14,
          "10%": 1.01,
          "90%": 1.161,
          "25%": 1.1,
          "75%": 1.16
        },
        "42085": {
          "name": "Mercer",
          "median": 1.105,
          "10%": 0.94,
          "90%": 1.3,
          "25%": 1.04,
          "75%": 1.28
        },
        "54055": {
          "name": "Mercer",
          "median": 1.19,
          "10%": 1.12,
          "90%": 1.25,
          "25%": 1.14,
          "75%": 1.22
        },
        "51119": {
          "name": "Middlesex",
          "median": 1.1,
          "10%": 0.99,
          "90%": 1.3,
          "25%": 1.03,
          "75%": 1.17
        },
        "42087": {
          "name": "Mifflin",
          "median": 1.19,
          "10%": 1.08,
          "90%": 1.28,
          "25%": 1.12,
          "75%": 1.26
        },
        "54057": {
          "name": "Mineral",
          "median": 1.15,
          "10%": 0.99,
          "90%": 1.33,
          "25%": 1.11,
          "75%": 1.21
        },
        "54059": {
          "name": "Mingo",
          "median": 1.17,
          "10%": 1.07,
          "90%": 1.27,
          "25%": 1.12,
          "75%": 1.26
        },
        "34025": {
          "name": "Monmouth",
          "median": 1.17,
          "10%": 0.94,
          "90%": 1.241,
          "25%": 1.13,
          "75%": 1.21
        },
        "54061": {
          "name": "Monongalia",
          "median": 1.2,
          "10%": 1.0,
          "90%": 1.36,
          "25%": 1.11,
          "75%": 1.29
        },
        "42089": {
          "name": "Monroe",
          "median": 1.15,
          "10%": 1.07,
          "90%": 1.2,
          "25%": 1.1,
          "75%": 1.18
        },
        "54063": {
          "name": "Monroe",
          "median": 1.19,
          "10%": 1.0,
          "90%": 1.31,
          "25%": 1.07,
          "75%": 1.21
        },
        "24031": {
          "name": "Montgomery",
          "median": 1.19,
          "10%": 0.94,
          "90%": 1.3,
          "25%": 1.14,
          "75%": 1.25
        },
        "36057": {
          "name": "Montgomery",
          "median": 1.14,
          "10%": 0.999,
          "90%": 1.22,
          "25%": 1.11,
          "75%": 1.18
        },
        "42091": {
          "name": "Montgomery",
          "median": 1.085,
          "10%": 1.02,
          "90%": 1.191,
          "25%": 1.05,
          "75%": 1.14
        },
        "51121": {
          "name": "Montgomery",
          "median": 1.28,
          "10%": 1.04,
          "90%": 1.34,
          "25%": 1.16,
          "75%": 1.32
        },
        "42093": {
          "name": "Montour",
          "median": 1.17,
          "10%": 1.08,
          "90%": 1.321,
          "25%": 1.13,
          "75%": 1.24
        },
        "54065": {
          "name": "Morgan",
          "median": 1.16,
          "10%": 1.05,
          "90%": 1.39,
          "25%": 1.13,
          "75%": 1.25
        },
        "34027": {
          "name": "Morris",
          "median": 1.11,
          "10%": 0.97,
          "90%": 1.22,
          "25%": 1.02,
          "75%": 1.14
        },
        "36059": {
          "name": "Nassau",
          "median": 1.12,
          "10%": 1.01,
          "90%": 1.29,
          "25%": 1.1,
          "75%": 1.13
        },
        "51125": {
          "name": "Nelson",
          "median": 1.155,
          "10%": 0.96,
          "90%": 1.31,
          "25%": 1.06,
          "75%": 1.22
        },
        "10003": {
          "name": "New Castle",
          "median": 1.08,
          "10%": 0.97,
          "90%": 1.25,
          "25%": 0.99,
          "75%": 1.18
        },
        "51127": {
          "name": "New Kent",
          "median": 1.11,
          "10%": 1.02,
          "90%": 1.25,
          "25%": 1.07,
          "75%": 1.15
        },
        "36061": {
          "name": "New York",
          "median": 1.1,
          "10%": 0.92,
          "90%": 1.21,
          "25%": 1.01,
          "75%": 1.19
        },
        "51700": {
          "name": "Newport News",
          "median": 1.11,
          "10%": 1.03,
          "90%": 1.22,
          "25%": 1.05,
          "75%": 1.19
        },
        "54067": {
          "name": "Nicholas",
          "median": 1.12,
          "10%": 1.0,
          "90%": 1.33,
          "25%": 1.02,
          "75%": 1.26
        },
        "51710": {
          "name": "Norfolk",
          "median": 1.09,
          "10%": 0.95,
          "90%": 1.26,
          "25%": 1.01,
          "75%": 1.17
        },
        "42095": {
          "name": "Northampton",
          "median": 1.13,
          "10%": 1.03,
          "90%": 1.18,
          "25%": 1.09,
          "75%": 1.15
        },
        "51131": {
          "name": "Northampton",
          "median": 1.1,
          "10%": 0.95,
          "90%": 1.18,
          "25%": 1.04,
          "75%": 1.16
        },
        "42097": {
          "name": "Northumberland",
          "median": 1.18,
          "10%": 1.1,
          "90%": 1.33,
          "25%": 1.11,
          "75%": 1.24
        },
        "51133": {
          "name": "Northumberland",
          "median": 1.11,
          "10%": 0.98,
          "90%": 1.32,
          "25%": 1.02,
          "75%": 1.24
        },
        "51720": {
          "name": "Norton",
          "median": 1.16,
          "10%": 0.98,
          "90%": 1.24,
          "25%": 1.1,
          "75%": 1.21
        },
        "51135": {
          "name": "Nottoway",
          "median": 1.11,
          "10%": 1.04,
          "90%": 1.29,
          "25%": 1.07,
          "75%": 1.23
        },
        "34029": {
          "name": "Ocean",
          "median": 1.165,
          "10%": 1.03,
          "90%": 1.22,
          "25%": 1.11,
          "75%": 1.21
        },
        "54069": {
          "name": "Ohio",
          "median": 1.13,
          "10%": 1.06,
          "90%": 1.28,
          "25%": 1.07,
          "75%": 1.25
        },
        "36065": {
          "name": "Oneida",
          "median": 1.11,
          "10%": 0.98,
          "90%": 1.21,
          "25%": 1.06,
          "75%": 1.12
        },
        "36067": {
          "name": "Onondaga",
          "median": 1.1,
          "10%": 1.04,
          "90%": 1.14,
          "25%": 1.06,
          "75%": 1.13
        },
        "36069": {
          "name": "Ontario",
          "median": 1.105,
          "10%": 0.93,
          "90%": 1.17,
          "25%": 1.03,
          "75%": 1.13
        },
        "36071": {
          "name": "Orange",
          "median": 1.11,
          "10%": 1.02,
          "90%": 1.21,
          "25%": 1.04,
          "75%": 1.17
        },
        "51137": {
          "name": "Orange",
          "median": 1.13,
          "10%": 0.91,
          "90%": 1.22,
          "25%": 1.07,
          "75%": 1.19
        },
        "36077": {
          "name": "Otsego",
          "median": 1.13,
          "10%": 1.06,
          "90%": 1.24,
          "25%": 1.08,
          "75%": 1.17
        },
        "51139": {
          "name": "Page",
          "median": 1.13,
          "10%": 0.92,
          "90%": 1.21,
          "25%": 1.01,
          "75%": 1.1625
        },
        "51141": {
          "name": "Patrick",
          "median": 1.17,
          "10%": 1.06,
          "90%": 1.26,
          "25%": 1.07,
          "75%": 1.2
        },
        "54071": {
          "name": "Pendleton",
          "median": 1.085,
          "10%": 0.95,
          "90%": 1.3,
          "25%": 1.02,
          "75%": 1.19
        },
        "42099": {
          "name": "Perry",
          "median": 1.16,
          "10%": 1.12,
          "90%": 1.36,
          "25%": 1.13,
          "75%": 1.27
        },
        "51730": {
          "name": "Petersburg",
          "median": 1.12,
          "10%": 0.99,
          "90%": 1.27,
          "25%": 1.09,
          "75%": 1.23
        },
        "42101": {
          "name": "Philadelphia",
          "median": 1.08,
          "10%": 1.03,
          "90%": 1.24,
          "25%": 1.06,
          "75%": 1.12
        },
        "42103": {
          "name": "Pike",
          "median": 1.13,
          "10%": 1.11,
          "90%": 1.22,
          "25%": 1.12,
          "75%": 1.17
        },
        "51143": {
          "name": "Pittsylvania",
          "median": 1.21,
          "10%": 1.08,
          "90%": 1.28,
          "25%": 1.12,
          "75%": 1.26
        },
        "54073": {
          "name": "Pleasants",
          "median": 1.19,
          "10%": 1.02,
          "90%": 1.4,
          "25%": 1.1,
          "75%": 1.24
        },
        "54075": {
          "name": "Pocahontas",
          "median": 1.07,
          "10%": 0.95,
          "90%": 1.331,
          "25%": 1.01,
          "75%": 1.18
        },
        "51735": {
          "name": "Poquoson",
          "median": 1.09,
          "10%": 0.98,
          "90%": 1.21,
          "25%": 1.04,
          "75%": 1.16
        },
        "51740": {
          "name": "Portsmouth",
          "median": 1.09,
          "10%": 0.95,
          "90%": 1.26,
          "25%": 1.01,
          "75%": 1.17
        },
        "42105": {
          "name": "Potter",
          "median": 1.07,
          "10%": 1.02,
          "90%": 1.28,
          "25%": 1.03,
          "75%": 1.12
        },
        "51145": {
          "name": "Powhatan",
          "median": 1.135,
          "10%": 1.02,
          "90%": 1.34,
          "25%": 1.07,
          "75%": 1.21
        },
        "54077": {
          "name": "Preston",
          "median": 1.145,
          "10%": 0.96,
          "90%": 1.3,
          "25%": 1.06,
          "75%": 1.27
        },
        "51147": {
          "name": "Prince Edward",
          "median": 1.19,
          "10%": 1.04,
          "90%": 1.25,
          "25%": 1.06,
          "75%": 1.23
        },
        "51149": {
          "name": "Prince George",
          "median": 1.12,
          "10%": 0.99,
          "90%": 1.27,
          "25%": 1.09,
          "75%": 1.23
        },
        "24033": {
          "name": "Prince George's",
          "median": 1.15,
          "10%": 0.93,
          "90%": 1.48,
          "25%": 1.01,
          "75%": 1.25
        },
        "51153": {
          "name": "Prince William",
          "median": 1.18,
          "10%": 0.91,
          "90%": 1.21,
          "25%": 1.07,
          "75%": 1.21
        },
        "51155": {
          "name": "Pulaski",
          "median": 1.22,
          "10%": 1.05,
          "90%": 1.291,
          "25%": 1.14,
          "75%": 1.26
        },
        "54079": {
          "name": "Putnam",
          "median": 1.18,
          "10%": 1.09,
          "90%": 1.3,
          "25%": 1.1,
          "75%": 1.23
        },
        "24035": {
          "name": "Queen Anne's",
          "median": 1.09,
          "10%": 1.0,
          "90%": 1.34,
          "25%": 1.02,
          "75%": 1.24
        },
        "51750": {
          "name": "Radford",
          "median": 1.23,
          "10%": 1.06,
          "90%": 1.31,
          "25%": 1.12,
          "75%": 1.28
        },
        "54081": {
          "name": "Raleigh",
          "median": 1.15,
          "10%": 1.069,
          "90%": 1.31,
          "25%": 1.09,
          "75%": 1.23
        },
        "54083": {
          "name": "Randolph",
          "median": 1.095,
          "10%": 0.97,
          "90%": 1.35,
          "25%": 1.01,
          "75%": 1.1925
        },
        "51157": {
          "name": "Rappahannock",
          "median": 1.13,
          "10%": 0.92,
          "90%": 1.2,
          "25%": 0.99,
          "75%": 1.17
        },
        "36085": {
          "name": "Richmond",
          "median": 1.1,
          "10%": 0.92,
          "90%": 1.21,
          "25%": 1.01,
          "75%": 1.19
        },
        "51159": {
          "name": "Richmond",
          "median": 1.08,
          "10%": 0.99,
          "90%": 1.35,
          "25%": 1.03,
          "75%": 1.14
        },
        "51760": {
          "name": "Richmond",
          "median": 1.09,
          "10%": 1.05,
          "90%": 1.3,
          "25%": 1.07,
          "75%": 1.13
        },
        "54085": {
          "name": "Ritchie",
          "median": 1.21,
          "10%": 1.05,
          "90%": 1.39,
          "25%": 1.11,
          "75%": 1.25
        },
        "54087": {
          "name": "Roane",
          "median": 1.17,
          "10%": 1.09,
          "90%": 1.34,
          "25%": 1.13,
          "75%": 1.25
        },
        "51161": {
          "name": "Roanoke",
          "median": 1.29,
          "10%": 1.04,
          "90%": 1.35,
          "25%": 1.18,
          "75%": 1.32
        },
        "51770": {
          "name": "Roanoke",
          "median": 1.28,
          "10%": 1.05,
          "90%": 1.34,
          "25%": 1.2,
          "75%": 1.31
        },
        "51163": {
          "name": "Rockbridge",
          "median": 1.18,
          "10%": 1.02,
          "90%": 1.31,
          "25%": 1.03,
          "75%": 1.21
        },
        "51165": {
          "name": "Rockingham",
          "median": 1.11,
          "10%": 0.94,
          "90%": 1.25,
          "25%": 1.03,
          "75%": 1.15
        },
        "51167": {
          "name": "Russell",
          "median": 1.165,
          "10%": 1.05,
          "90%": 1.241,
          "25%": 1.08,
          "75%": 1.22
        },
        "34033": {
          "name": "Salem",
          "median": 1.08,
          "10%": 1.02,
          "90%": 1.29,
          "25%": 1.04,
          "75%": 1.13
        },
        "51775": {
          "name": "Salem",
          "median": 1.29,
          "10%": 1.04,
          "90%": 1.35,
          "25%": 1.17,
          "75%": 1.33
        },
        "36095": {
          "name": "Schoharie",
          "median": 1.15,
          "10%": 1.0,
          "90%": 1.21,
          "25%": 1.09,
          "75%": 1.19
        },
        "36097": {
          "name": "Schuyler",
          "median": 1.15,
          "10%": 1.04,
          "90%": 1.22,
          "25%": 1.05,
          "75%": 1.17
        },
        "42107": {
          "name": "Schuylkill",
          "median": 1.16,
          "10%": 1.06,
          "90%": 1.29,
          "25%": 1.12,
          "75%": 1.26
        },
        "51169": {
          "name": "Scott",
          "median": 1.14,
          "10%": 1.0,
          "90%": 1.26,
          "25%": 1.11,
          "75%": 1.21
        },
        "51171": {
          "name": "Shenandoah",
          "median": 1.14,
          "10%": 0.94,
          "90%": 1.22,
          "25%": 1.01,
          "75%": 1.17
        },
        "51173": {
          "name": "Smyth",
          "median": 1.14,
          "10%": 1.09,
          "90%": 1.24,
          "25%": 1.11,
          "75%": 1.18
        },
        "42109": {
          "name": "Snyder",
          "median": 1.17,
          "10%": 1.08,
          "90%": 1.31,
          "25%": 1.14,
          "75%": 1.26
        },
        "24039": {
          "name": "Somerset",
          "median": 1.15,
          "10%": 1.03,
          "90%": 1.28,
          "25%": 1.04,
          "75%": 1.23
        },
        "42111": {
          "name": "Somerset",
          "median": 1.195,
          "10%": 0.95,
          "90%": 1.35,
          "25%": 1.08,
          "75%": 1.21
        },
        "51175": {
          "name": "Southampton",
          "median": 1.14,
          "10%": 1.04,
          "90%": 1.25,
          "25%": 1.07,
          "75%": 1.23
        },
        "51177": {
          "name": "Spotsylvania",
          "median": 1.14,
          "10%": 0.92,
          "90%": 1.361,
          "25%": 1.09,
          "75%": 1.21
        },
        "24037": {
          "name": "St. Mary's",
          "median": 1.08,
          "10%": 0.97,
          "90%": 1.5,
          "25%": 0.98,
          "75%": 1.18
        },
        "51179": {
          "name": "Stafford",
          "median": 1.13,
          "10%": 0.93,
          "90%": 1.43,
          "25%": 1.08,
          "75%": 1.17
        },
        "51790": {
          "name": "Staunton",
          "median": 1.07,
          "10%": 0.95,
          "90%": 1.3,
          "25%": 1.01,
          "75%": 1.15
        },
        "36101": {
          "name": "Steuben",
          "median": 1.08,
          "10%": 1.0,
          "90%": 1.18,
          "25%": 1.02,
          "75%": 1.14
        },
        "51800": {
          "name": "Suffolk",
          "median": 1.13,
          "10%": 1.0,
          "90%": 1.27,
          "25%": 1.04,
          "75%": 1.21
        },
        "36105": {
          "name": "Sullivan",
          "median": 1.12,
          "10%": 1.04,
          "90%": 1.3,
          "25%": 1.09,
          "75%": 1.19
        },
        "42113": {
          "name": "Sullivan",
          "median": 1.14,
          "10%": 1.09,
          "90%": 1.31,
          "25%": 1.11,
          "75%": 1.21
        },
        "54089": {
          "name": "Summers",
          "median": 1.13,
          "10%": 1.0,
          "90%": 1.29,
          "25%": 1.09,
          "75%": 1.18
        },
        "51181": {
          "name": "Surry",
          "median": 1.12,
          "10%": 1.02,
          "90%": 1.24,
          "25%": 1.1,
          "75%": 1.22
        },
        "42115": {
          "name": "Susquehanna",
          "median": 1.13,
          "10%": 1.09,
          "90%": 1.31,
          "25%": 1.12,
          "75%": 1.19
        },
        "10005": {
          "name": "Sussex",
          "median": 1.145,
          "10%": 1.02,
          "90%": 1.24,
          "25%": 1.04,
          "75%": 1.19
        },
        "34037": {
          "name": "Sussex",
          "median": 1.14,
          "10%": 1.04,
          "90%": 1.17,
          "25%": 1.11,
          "75%": 1.16
        },
        "51183": {
          "name": "Sussex",
          "median": 1.155,
          "10%": 1.029,
          "90%": 1.23,
          "25%": 1.11,
          "75%": 1.21
        },
        "24041": {
          "name": "Talbot",
          "median": 1.09,
          "10%": 0.98,
          "90%": 1.41,
          "25%": 1.04,
          "75%": 1.3
        },
        "54091": {
          "name": "Taylor",
          "median": 1.13,
          "10%": 1.02,
          "90%": 1.31,
          "25%": 1.06,
          "75%": 1.27
        },
        "51185": {
          "name": "Tazewell",
          "median": 1.14,
          "10%": 1.1,
          "90%": 1.25,
          "25%": 1.12,
          "75%": 1.21
        },
        "36107": {
          "name": "Tioga",
          "median": 1.13,
          "10%": 1.04,
          "90%": 1.21,
          "25%": 1.1,
          "75%": 1.2
        },
        "42117": {
          "name": "Tioga",
          "median": 1.13,
          "10%": 1.03,
          "90%": 1.34,
          "25%": 1.06,
          "75%": 1.15
        },
        "36109": {
          "name": "Tompkins",
          "median": 1.13,
          "10%": 1.04,
          "90%": 1.2,
          "25%": 1.06,
          "75%": 1.1525
        },
        "54093": {
          "name": "Tucker",
          "median": 1.09,
          "10%": 0.97,
          "90%": 1.28,
          "25%": 1.03,
          "75%": 1.19
        },
        "54095": {
          "name": "Tyler",
          "median": 1.2,
          "10%": 1.09,
          "90%": 1.31,
          "25%": 1.11,
          "75%": 1.26
        },
        "36111": {
          "name": "Ulster",
          "median": 1.14,
          "10%": 1.01,
          "90%": 1.26,
          "25%": 1.03,
          "75%": 1.2125
        },
        "42119": {
          "name": "Union",
          "median": 1.17,
          "10%": 1.06,
          "90%": 1.3,
          "25%": 1.14,
          "75%": 1.24
        },
        "54097": {
          "name": "Upshur",
          "median": 1.1,
          "10%": 0.99,
          "90%": 1.37,
          "25%": 1.07,
          "75%": 1.19
        },
        "42121": {
          "name": "Venango",
          "median": 1.105,
          "10%": 0.979,
          "90%": 1.3,
          "25%": 1.01,
          "75%": 1.22
        },
        "51810": {
          "name": "Virginia Beach",
          "median": 1.08,
          "10%": 0.95,
          "90%": 1.24,
          "25%": 1.01,
          "75%": 1.19
        },
        "34041": {
          "name": "Warren",
          "median": 1.115,
          "10%": 1.05,
          "90%": 1.17,
          "25%": 1.07,
          "75%": 1.14
        },
        "42123": {
          "name": "Warren",
          "median": 1.08,
          "10%": 0.95,
          "90%": 1.34,
          "25%": 0.99,
          "75%": 1.2925
        },
        "51187": {
          "name": "Warren",
          "median": 1.13,
          "10%": 0.93,
          "90%": 1.2,
          "25%": 0.99,
          "75%": 1.17
        },
        "24043": {
          "name": "Washington",
          "median": 1.14,
          "10%": 1.13,
          "90%": 1.42,
          "25%": 1.13,
          "75%": 1.2
        },
        "42125": {
          "name": "Washington",
          "median": 1.13,
          "10%": 1.01,
          "90%": 1.33,
          "25%": 1.07,
          "75%": 1.23
        },
        "51191": {
          "name": "Washington",
          "median": 1.15,
          "10%": 1.05,
          "90%": 1.21,
          "25%": 1.08,
          "75%": 1.2
        },
        "42127": {
          "name": "Wayne",
          "median": 1.14,
          "10%": 1.08,
          "90%": 1.35,
          "25%": 1.12,
          "75%": 1.19
        },
        "54099": {
          "name": "Wayne",
          "median": 1.18,
          "10%": 1.06,
          "90%": 1.25,
          "25%": 1.08,
          "75%": 1.24
        },
        "51820": {
          "name": "Waynesboro",
          "median": 1.085,
          "10%": 0.94,
          "90%": 1.22,
          "25%": 0.96,
          "75%": 1.15
        },
        "54101": {
          "name": "Webster",
          "median": 1.09,
          "10%": 0.96,
          "90%": 1.35,
          "25%": 1.06,
          "75%": 1.2
        },
        "36119": {
          "name": "Westchester",
          "median": 1.13,
          "10%": 0.97,
          "90%": 1.23,
          "25%": 1.0,
          "75%": 1.16
        },
        "42129": {
          "name": "Westmoreland",
          "median": 1.14,
          "10%": 0.95,
          "90%": 1.251,
          "25%": 1.04,
          "75%": 1.21
        },
        "51193": {
          "name": "Westmoreland",
          "median": 1.075,
          "10%": 0.96,
          "90%": 1.54,
          "25%": 0.98,
          "75%": 1.17
        },
        "54103": {
          "name": "Wetzel",
          "median": 1.19,
          "10%": 1.06,
          "90%": 1.26,
          "25%": 1.08,
          "75%": 1.23
        },
        "24045": {
          "name": "Wicomico",
          "median": 1.135,
          "10%": 1.02,
          "90%": 1.28,
          "25%": 1.04,
          "75%": 1.22
        },
        "51830": {
          "name": "Williamsburg",
          "median": 1.11,
          "10%": 1.02,
          "90%": 1.26,
          "25%": 1.09,
          "75%": 1.21
        },
        "51840": {
          "name": "Winchester",
          "median": 1.12,
          "10%": 1.03,
          "90%": 1.31,
          "25%": 1.05,
          "75%": 1.26
        },
        "54105": {
          "name": "Wirt",
          "median": 1.175,
          "10%": 1.06,
          "90%": 1.32,
          "25%": 1.09,
          "75%": 1.27
        },
        "51195": {
          "name": "Wise",
          "median": 1.15,
          "10%": 0.99,
          "90%": 1.27,
          "25%": 1.12,
          "75%": 1.25
        },
        "54107": {
          "name": "Wood",
          "median": 1.18,
          "10%": 0.98,
          "90%": 1.29,
          "25%": 1.08,
          "75%": 1.23
        },
        "24047": {
          "name": "Worcester",
          "median": 1.125,
          "10%": 1.01,
          "90%": 1.31,
          "25%": 1.06,
          "75%": 1.21
        },
        "42131": {
          "name": "Wyoming",
          "median": 1.135,
          "10%": 1.1,
          "90%": 1.251,
          "25%": 1.12,
          "75%": 1.2
        },
        "54109": {
          "name": "Wyoming",
          "median": 1.14,
          "10%": 1.07,
          "90%": 1.28,
          "25%": 1.11,
          "75%": 1.26
        },
        "51197": {
          "name": "Wythe",
          "median": 1.18,
          "10%": 1.1,
          "90%": 1.23,
          "25%": 1.14,
          "75%": 1.21
        },
        "36123": {
          "name": "Yates",
          "median": 1.1,
          "10%": 0.92,
          "90%": 1.15,
          "25%": 1.05,
          "75%": 1.13
        },
        "42133": {
          "name": "York",
          "median": 1.16,
          "10%": 0.96,
          "90%": 1.32,
          "25%": 1.08,
          "75%": 1.21
        },
        "51199": {
          "name": "York",
          "median": 1.1,
          "10%": 1.02,
          "90%": 1.24,
          "25%": 1.05,
          "75%": 1.19
        },
        "max": 1.29,
        "min": 1
      },
      "25": {
        "51001": {
          "name": "Accomack",
          "median": 1.14,
          "10%": 0.98,
          "90%": 1.38,
          "25%": 1.02,
          "75%": 1.3
        },
        "42001": {
          "name": "Adams",
          "median": 1.19,
          "10%": 1.02,
          "90%": 1.591,
          "25%": 1.17,
          "75%": 1.3
        },
        "51003": {
          "name": "Albemarle",
          "median": 1.13,
          "10%": 0.97,
          "90%": 1.27,
          "25%": 1.02,
          "75%": 1.21
        },
        "51510": {
          "name": "Alexandria",
          "median": 1.22,
          "10%": 0.84,
          "90%": 1.33,
          "25%": 1.14,
          "75%": 1.29
        },
        "24001": {
          "name": "Allegany",
          "median": 1.21,
          "10%": 1.0,
          "90%": 1.57,
          "25%": 1.18,
          "75%": 1.27
        },
        "36003": {
          "name": "Allegany",
          "median": 1.14,
          "10%": 0.99,
          "90%": 1.3,
          "25%": 1.0775,
          "75%": 1.18
        },
        "51005": {
          "name": "Alleghany",
          "median": 1.19,
          "10%": 0.92,
          "90%": 1.46,
          "25%": 1.04,
          "75%": 1.26
        },
        "42003": {
          "name": "Allegheny",
          "median": 1.08,
          "10%": 1.02,
          "90%": 1.34,
          "25%": 1.04,
          "75%": 1.25
        },
        "51007": {
          "name": "Amelia",
          "median": 1.11,
          "10%": 0.99,
          "90%": 1.31,
          "25%": 1.07,
          "75%": 1.29
        },
        "51009": {
          "name": "Amherst",
          "median": 1.18,
          "10%": 1.01,
          "90%": 1.31,
          "25%": 1.08,
          "75%": 1.28
        },
        "24003": {
          "name": "Anne Arundel",
          "median": 1.17,
          "10%": 0.94,
          "90%": 1.52,
          "25%": 1.02,
          "75%": 1.31
        },
        "51011": {
          "name": "Appomattox",
          "median": 1.19,
          "10%": 0.99,
          "90%": 1.33,
          "25%": 1.09,
          "75%": 1.27
        },
        "51013": {
          "name": "Arlington",
          "median": 1.22,
          "10%": 0.84,
          "90%": 1.33,
          "25%": 1.14,
          "75%": 1.29
        },
        "42005": {
          "name": "Armstrong",
          "median": 1.12,
          "10%": 0.99,
          "90%": 1.29,
          "25%": 1.0,
          "75%": 1.22
        },
        "34001": {
          "name": "Atlantic",
          "median": 1.12,
          "10%": 1.05,
          "90%": 1.2,
          "25%": 1.06,
          "75%": 1.18
        },
        "51015": {
          "name": "Augusta",
          "median": 1.04,
          "10%": 0.96,
          "90%": 1.311,
          "25%": 0.98,
          "75%": 1.18
        },
        "24005": {
          "name": "Baltimore",
          "median": 1.19,
          "10%": 0.98,
          "90%": 1.42,
          "25%": 1.02,
          "75%": 1.25
        },
        "24510": {
          "name": "Baltimore",
          "median": 1.2,
          "10%": 0.98,
          "90%": 1.42,
          "25%": 1.04,
          "75%": 1.31
        },
        "54001": {
          "name": "Barbour",
          "median": 1.07,
          "10%": 0.94,
          "90%": 1.36,
          "25%": 1.01,
          "75%": 1.23
        },
        "51017": {
          "name": "Bath",
          "median": 1.11,
          "10%": 0.97,
          "90%": 1.441,
          "25%": 1.0,
          "75%": 1.2
        },
        "42007": {
          "name": "Beaver",
          "median": 1.06,
          "10%": 0.97,
          "90%": 1.32,
          "25%": 1.01,
          "75%": 1.23
        },
        "42009": {
          "name": "Bedford",
          "median": 1.19,
          "10%": 1.03,
          "90%": 1.35,
          "25%": 1.16,
          "75%": 1.26
        },
        "51019": {
          "name": "Bedford",
          "median": 1.29,
          "10%": 1.04,
          "90%": 1.4,
          "25%": 1.24,
          "75%": 1.35
        },
        "54003": {
          "name": "Berkeley",
          "median": 1.165,
          "10%": 1.05,
          "90%": 1.41,
          "25%": 1.07,
          "75%": 1.22
        },
        "42011": {
          "name": "Berks",
          "median": 1.17,
          "10%": 0.94,
          "90%": 1.28,
          "25%": 1.06,
          "75%": 1.26
        },
        "42013": {
          "name": "Blair",
          "median": 1.16,
          "10%": 1.06,
          "90%": 1.27,
          "25%": 1.14,
          "75%": 1.2
        },
        "51021": {
          "name": "Bland",
          "median": 1.23,
          "10%": 1.14,
          "90%": 1.36,
          "25%": 1.1575,
          "75%": 1.29
        },
        "54005": {
          "name": "Boone",
          "median": 1.14,
          "10%": 0.99,
          "90%": 1.3,
          "25%": 1.06,
          "75%": 1.28
        },
        "51023": {
          "name": "Botetourt",
          "median": 1.26,
          "10%": 0.98,
          "90%": 1.41,
          "25%": 1.12,
          "75%": 1.35
        },
        "42015": {
          "name": "Bradford",
          "median": 1.17,
          "10%": 1.02,
          "90%": 1.32,
          "25%": 1.1275,
          "75%": 1.24
        },
        "54007": {
          "name": "Braxton",
          "median": 1.13,
          "10%": 0.99,
          "90%": 1.44,
          "25%": 1.1,
          "75%": 1.28
        },
        "51520": {
          "name": "Bristol",
          "median": 1.16,
          "10%": 0.95,
          "90%": 1.38,
          "25%": 1.0,
          "75%": 1.23
        },
        "36005": {
          "name": "Bronx",
          "median": 1.12,
          "10%": 0.96,
          "90%": 1.3,
          "25%": 0.98,
          "75%": 1.18
        },
        "54009": {
          "name": "Brooke",
          "median": 1.14,
          "10%": 1.03,
          "90%": 1.32,
          "25%": 1.06,
          "75%": 1.22
        },
        "36007": {
          "name": "Broome",
          "median": 1.14,
          "10%": 1.1,
          "90%": 1.25,
          "25%": 1.11,
          "75%": 1.19
        },
        "51025": {
          "name": "Brunswick",
          "median": 1.16,
          "10%": 0.99,
          "90%": 1.24,
          "25%": 1.12,
          "75%": 1.21
        },
        "51027": {
          "name": "Buchanan",
          "median": 1.17,
          "10%": 1.03,
          "90%": 1.38,
          "25%": 1.1,
          "75%": 1.31
        },
        "51029": {
          "name": "Buckingham",
          "median": 1.18,
          "10%": 1.02,
          "90%": 1.36,
          "25%": 1.04,
          "75%": 1.23
        },
        "42017": {
          "name": "Bucks",
          "median": 1.1,
          "10%": 1.01,
          "90%": 1.15,
          "25%": 1.07,
          "75%": 1.13
        },
        "51530": {
          "name": "Buena Vista",
          "median": 1.18,
          "10%": 1.0,
          "90%": 1.32,
          "25%": 1.07,
          "75%": 1.26
        },
        "34005": {
          "name": "Burlington",
          "median": 1.12,
          "10%": 1.06,
          "90%": 1.24,
          "25%": 1.08,
          "75%": 1.18
        },
        "42019": {
          "name": "Butler",
          "median": 1.085,
          "10%": 1.01,
          "90%": 1.28,
          "25%": 1.05,
          "75%": 1.23
        },
        "54011": {
          "name": "Cabell",
          "median": 1.13,
          "10%": 1.04,
          "90%": 1.26,
          "25%": 1.09,
          "75%": 1.23
        },
        "54013": {
          "name": "Calhoun",
          "median": 1.19,
          "10%": 1.07,
          "90%": 1.38,
          "25%": 1.09,
          "75%": 1.25
        },
        "24009": {
          "name": "Calvert",
          "median": 1.12,
          "10%": 0.92,
          "90%": 1.6,
          "25%": 1.0,
          "75%": 1.29
        },
        "42021": {
          "name": "Cambria",
          "median": 1.13,
          "10%": 0.99,
          "90%": 1.22,
          "25%": 1.08,
          "75%": 1.18
        },
        "34007": {
          "name": "Camden",
          "median": 1.105,
          "10%": 1.02,
          "90%": 1.25,
          "25%": 1.04,
          "75%": 1.21
        },
        "42023": {
          "name": "Cameron",
          "median": 1.09,
          "10%": 1.03,
          "90%": 1.18,
          "25%": 1.06,
          "75%": 1.16
        },
        "51031": {
          "name": "Campbell",
          "median": 1.23,
          "10%": 1.03,
          "90%": 1.37,
          "25%": 1.17,
          "75%": 1.31
        },
        "34009": {
          "name": "Cape May",
          "median": 1.1,
          "10%": 1.02,
          "90%": 1.2,
          "25%": 1.05,
          "75%": 1.16
        },
        "42025": {
          "name": "Carbon",
          "median": 1.15,
          "10%": 1.07,
          "90%": 1.29,
          "25%": 1.09,
          "75%": 1.22
        },
        "24011": {
          "name": "Caroline",
          "median": 1.14,
          "10%": 0.97,
          "90%": 1.391,
          "25%": 1.03,
          "75%": 1.27
        },
        "51033": {
          "name": "Caroline",
          "median": 1.105,
          "10%": 1.0,
          "90%": 1.43,
          "25%": 1.06,
          "75%": 1.16
        },
        "24013": {
          "name": "Carroll",
          "median": 1.19,
          "10%": 0.98,
          "90%": 1.48,
          "25%": 1.11,
          "75%": 1.28
        },
        "51035": {
          "name": "Carroll",
          "median": 1.25,
          "10%": 1.03,
          "90%": 1.33,
          "25%": 1.18,
          "75%": 1.27
        },
        "24015": {
          "name": "Cecil",
          "median": 1.09,
          "10%": 0.96,
          "90%": 1.26,
          "25%": 0.98,
          "75%": 1.18
        },
        "42027": {
          "name": "Centre",
          "median": 1.18,
          "10%": 1.06,
          "90%": 1.3,
          "25%": 1.08,
          "75%": 1.22
        },
        "24017": {
          "name": "Charles",
          "median": 1.13,
          "10%": 0.89,
          "90%": 1.54,
          "25%": 1.04,
          "75%": 1.27
        },
        "51036": {
          "name": "Charles City",
          "median": 1.125,
          "10%": 0.95,
          "90%": 1.291,
          "25%": 1.08,
          "75%": 1.25
        },
        "51037": {
          "name": "Charlotte",
          "median": 1.2,
          "10%": 0.98,
          "90%": 1.29,
          "25%": 1.14,
          "75%": 1.24
        },
        "51540": {
          "name": "Charlottesville",
          "median": 1.095,
          "10%": 0.95,
          "90%": 1.22,
          "25%": 1.02,
          "75%": 1.17
        },
        "36015": {
          "name": "Chemung",
          "median": 1.12,
          "10%": 1.01,
          "90%": 1.36,
          "25%": 1.07,
          "75%": 1.1625
        },
        "36017": {
          "name": "Chenango",
          "median": 1.11,
          "10%": 1.06,
          "90%": 1.21,
          "25%": 1.08,
          "75%": 1.18
        },
        "51550": {
          "name": "Chesapeake",
          "median": 1.09,
          "10%": 0.86,
          "90%": 1.34,
          "25%": 0.96,
          "75%": 1.24
        },
        "42029": {
          "name": "Chester",
          "median": 1.1,
          "10%": 0.92,
          "90%": 1.261,
          "25%": 1.0,
          "75%": 1.16
        },
        "51041": {
          "name": "Chesterfield",
          "median": 1.14,
          "10%": 0.98,
          "90%": 1.31,
          "25%": 1.04,
          "75%": 1.27
        },
        "42031": {
          "name": "Clarion",
          "median": 1.08,
          "10%": 0.99,
          "90%": 1.26,
          "25%": 1.01,
          "75%": 1.17
        },
        "51043": {
          "name": "Clarke",
          "median": 1.16,
          "10%": 0.96,
          "90%": 1.3,
          "25%": 1.06,
          "75%": 1.21
        },
        "54015": {
          "name": "Clay",
          "median": 1.2,
          "10%": 0.99,
          "90%": 1.33,
          "25%": 1.02,
          "75%": 1.27
        },
        "42033": {
          "name": "Clearfield",
          "median": 1.15,
          "10%": 1.03,
          "90%": 1.19,
          "25%": 1.08,
          "75%": 1.18
        },
        "42035": {
          "name": "Clinton",
          "median": 1.15,
          "10%": 1.03,
          "90%": 1.25,
          "25%": 1.1,
          "75%": 1.2
        },
        "51570": {
          "name": "Colonial Heights",
          "median": 1.145,
          "10%": 0.929,
          "90%": 1.32,
          "25%": 1.09,
          "75%": 1.27
        },
        "42037": {
          "name": "Columbia",
          "median": 1.19,
          "10%": 1.09,
          "90%": 1.411,
          "25%": 1.1,
          "75%": 1.25
        },
        "36023": {
          "name": "Cortland",
          "median": 1.11,
          "10%": 1.03,
          "90%": 1.18,
          "25%": 1.0975,
          "75%": 1.12
        },
        "51580": {
          "name": "Covington",
          "median": 1.22,
          "10%": 0.95,
          "90%": 1.41,
          "25%": 1.0675,
          "75%": 1.29
        },
        "51045": {
          "name": "Craig",
          "median": 1.31,
          "10%": 0.96,
          "90%": 1.43,
          "25%": 1.12,
          "75%": 1.35
        },
        "42039": {
          "name": "Crawford",
          "median": 1.14,
          "10%": 1.0,
          "90%": 1.51,
          "25%": 1.03,
          "75%": 1.41
        },
        "51047": {
          "name": "Culpeper",
          "median": 1.16,
          "10%": 0.91,
          "90%": 1.23,
          "25%": 1.07,
          "75%": 1.2
        },
        "34011": {
          "name": "Cumberland",
          "median": 1.07,
          "10%": 0.98,
          "90%": 1.18,
          "25%": 1.01,
          "75%": 1.14
        },
        "42041": {
          "name": "Cumberland",
          "median": 1.16,
          "10%": 1.11,
          "90%": 1.49,
          "25%": 1.13,
          "75%": 1.29
        },
        "51049": {
          "name": "Cumberland",
          "median": 1.21,
          "10%": 1.01,
          "90%": 1.35,
          "25%": 1.05,
          "75%": 1.28
        },
        "51590": {
          "name": "Danville",
          "median": 1.25,
          "10%": 1.06,
          "90%": 1.29,
          "25%": 1.08,
          "75%": 1.27
        },
        "42043": {
          "name": "Dauphin",
          "median": 1.17,
          "10%": 1.01,
          "90%": 1.401,
          "25%": 1.09,
          "75%": 1.26
        },
        "36025": {
          "name": "Delaware",
          "median": 1.2,
          "10%": 0.99,
          "90%": 1.32,
          "25%": 1.06,
          "75%": 1.24
        },
        "42045": {
          "name": "Delaware",
          "median": 1.05,
          "10%": 0.97,
          "90%": 1.32,
          "25%": 1.0,
          "75%": 1.15
        },
        "51051": {
          "name": "Dickenson",
          "median": 1.155,
          "10%": 0.99,
          "90%": 1.41,
          "25%": 1.12,
          "75%": 1.34
        },
        "51053": {
          "name": "Dinwiddie",
          "median": 1.15,
          "10%": 0.979,
          "90%": 1.29,
          "25%": 1.06,
          "75%": 1.25
        },
        "11001": {
          "name": "District of Columbia",
          "median": 1.19,
          "10%": 0.85,
          "90%": 1.42,
          "25%": 1.1,
          "75%": 1.33
        },
        "54017": {
          "name": "Doddridge",
          "median": 1.23,
          "10%": 1.13,
          "90%": 1.32,
          "25%": 1.14,
          "75%": 1.28
        },
        "24019": {
          "name": "Dorchester",
          "median": 1.115,
          "10%": 0.98,
          "90%": 1.43,
          "25%": 1.03,
          "75%": 1.26
        },
        "42047": {
          "name": "Elk",
          "median": 1.1,
          "10%": 1.04,
          "90%": 1.21,
          "25%": 1.07,
          "75%": 1.18
        },
        "51595": {
          "name": "Emporia",
          "median": 1.16,
          "10%": 0.99,
          "90%": 1.24,
          "25%": 1.13,
          "75%": 1.2
        },
        "42049": {
          "name": "Erie",
          "median": 1.16,
          "10%": 0.99,
          "90%": 1.41,
          "25%": 1.0,
          "75%": 1.36
        },
        "51057": {
          "name": "Essex",
          "median": 1.08,
          "10%": 0.99,
          "90%": 1.4,
          "25%": 1.01,
          "75%": 1.15
        },
        "51059": {
          "name": "Fairfax",
          "median": 1.21,
          "10%": 0.85,
          "90%": 1.33,
          "25%": 1.14,
          "75%": 1.29
        },
        "51600": {
          "name": "Fairfax",
          "median": 1.22,
          "10%": 0.84,
          "90%": 1.33,
          "25%": 1.14,
          "75%": 1.29
        },
        "51610": {
          "name": "Falls Church",
          "median": 1.22,
          "10%": 0.84,
          "90%": 1.33,
          "25%": 1.14,
          "75%": 1.29
        },
        "51061": {
          "name": "Fauquier",
          "median": 1.14,
          "10%": 0.89,
          "90%": 1.26,
          "25%": 1.07,
          "75%": 1.21
        },
        "42051": {
          "name": "Fayette",
          "median": 1.18,
          "10%": 0.93,
          "90%": 1.36,
          "25%": 1.06,
          "75%": 1.33
        },
        "54019": {
          "name": "Fayette",
          "median": 1.155,
          "10%": 0.98,
          "90%": 1.35,
          "25%": 1.02,
          "75%": 1.27
        },
        "51063": {
          "name": "Floyd",
          "median": 1.25,
          "10%": 1.03,
          "90%": 1.37,
          "25%": 1.19,
          "75%": 1.3
        },
        "51065": {
          "name": "Fluvanna",
          "median": 1.185,
          "10%": 0.98,
          "90%": 1.39,
          "25%": 1.04,
          "75%": 1.32
        },
        "42053": {
          "name": "Forest",
          "median": 1.09,
          "10%": 1.02,
          "90%": 1.31,
          "25%": 1.03,
          "75%": 1.24
        },
        "42055": {
          "name": "Franklin",
          "median": 1.2,
          "10%": 1.15,
          "90%": 1.511,
          "25%": 1.16,
          "75%": 1.22
        },
        "51067": {
          "name": "Franklin",
          "median": 1.28,
          "10%": 1.07,
          "90%": 1.37,
          "25%": 1.23,
          "75%": 1.32
        },
        "51620": {
          "name": "Franklin",
          "median": 1.12,
          "10%": 0.95,
          "90%": 1.361,
          "25%": 1.0,
          "75%": 1.25
        },
        "24021": {
          "name": "Frederick",
          "median": 1.18,
          "10%": 0.97,
          "90%": 1.43,
          "25%": 1.16,
          "75%": 1.32
        },
        "51069": {
          "name": "Frederick",
          "median": 1.15,
          "10%": 0.969,
          "90%": 1.35,
          "25%": 1.0,
          "75%": 1.23
        },
        "51630": {
          "name": "Fredericksburg",
          "median": 1.12,
          "10%": 0.92,
          "90%": 1.5,
          "25%": 1.07,
          "75%": 1.19
        },
        "42057": {
          "name": "Fulton",
          "median": 1.24,
          "10%": 1.08,
          "90%": 1.46,
          "25%": 1.16,
          "75%": 1.27
        },
        "51640": {
          "name": "Galax",
          "median": 1.25,
          "10%": 1.029,
          "90%": 1.331,
          "25%": 1.18,
          "75%": 1.27
        },
        "24023": {
          "name": "Garrett",
          "median": 1.17,
          "10%": 0.92,
          "90%": 1.36,
          "25%": 1.05,
          "75%": 1.28
        },
        "51071": {
          "name": "Giles",
          "median": 1.3,
          "10%": 1.05,
          "90%": 1.41,
          "25%": 1.19,
          "75%": 1.36
        },
        "54021": {
          "name": "Gilmer",
          "median": 1.17,
          "10%": 1.03,
          "90%": 1.39,
          "25%": 1.11,
          "75%": 1.28
        },
        "34015": {
          "name": "Gloucester",
          "median": 1.055,
          "10%": 0.989,
          "90%": 1.33,
          "25%": 1.01,
          "75%": 1.16
        },
        "51073": {
          "name": "Gloucester",
          "median": 1.09,
          "10%": 0.99,
          "90%": 1.26,
          "25%": 1.02,
          "75%": 1.23
        },
        "51075": {
          "name": "Goochland",
          "median": 1.13,
          "10%": 1.01,
          "90%": 1.45,
          "25%": 1.07,
          "75%": 1.28
        },
        "54023": {
          "name": "Grant",
          "median": 1.08,
          "10%": 0.97,
          "90%": 1.32,
          "25%": 0.99,
          "75%": 1.17
        },
        "51077": {
          "name": "Grayson",
          "median": 1.21,
          "10%": 1.13,
          "90%": 1.27,
          "25%": 1.18,
          "75%": 1.23
        },
        "54025": {
          "name": "Greenbrier",
          "median": 1.11,
          "10%": 0.9,
          "90%": 1.431,
          "25%": 1.08,
          "75%": 1.26
        },
        "36039": {
          "name": "Greene",
          "median": 1.135,
          "10%": 0.93,
          "90%": 1.33,
          "25%": 0.99,
          "75%": 1.25
        },
        "42059": {
          "name": "Greene",
          "median": 1.22,
          "10%": 1.08,
          "90%": 1.36,
          "25%": 1.15,
          "75%": 1.32
        },
        "51079": {
          "name": "Greene",
          "median": 1.1,
          "10%": 0.95,
          "90%": 1.22,
          "25%": 1.01,
          "75%": 1.17
        },
        "51081": {
          "name": "Greensville",
          "median": 1.17,
          "10%": 0.98,
          "90%": 1.25,
          "25%": 1.13,
          "75%": 1.19
        },
        "51083": {
          "name": "Halifax",
          "median": 1.2,
          "10%": 1.01,
          "90%": 1.29,
          "25%": 1.1475,
          "75%": 1.26
        },
        "54027": {
          "name": "Hampshire",
          "median": 1.18,
          "10%": 0.999,
          "90%": 1.32,
          "25%": 1.07,
          "75%": 1.25
        },
        "51650": {
          "name": "Hampton",
          "median": 1.07,
          "10%": 0.93,
          "90%": 1.27,
          "25%": 1.01,
          "75%": 1.22
        },
        "54029": {
          "name": "Hancock",
          "median": 1.09,
          "10%": 0.93,
          "90%": 1.37,
          "25%": 1.05,
          "75%": 1.25
        },
        "51085": {
          "name": "Hanover",
          "median": 1.1,
          "10%": 1.06,
          "90%": 1.37,
          "25%": 1.08,
          "75%": 1.18
        },
        "54031": {
          "name": "Hardy",
          "median": 1.17,
          "10%": 1.0,
          "90%": 1.26,
          "25%": 1.02,
          "75%": 1.19
        },
        "24025": {
          "name": "Harford",
          "median": 1.15,
          "10%": 0.96,
          "90%": 1.34,
          "25%": 1.0,
          "75%": 1.2
        },
        "54033": {
          "name": "Harrison",
          "median": 1.12,
          "10%": 1.02,
          "90%": 1.34,
          "25%": 1.08,
          "75%": 1.29
        },
        "51660": {
          "name": "Harrisonburg",
          "median": 1.07,
          "10%": 0.87,
          "90%": 1.26,
          "25%": 0.97,
          "75%": 1.16
        },
        "51087": {
          "name": "Henrico",
          "median": 1.14,
          "10%": 1.02,
          "90%": 1.33,
          "25%": 1.09,
          "75%": 1.1825
        },
        "51089": {
          "name": "Henry",
          "median": 1.23,
          "10%": 1.1,
          "90%": 1.34,
          "25%": 1.13,
          "75%": 1.28
        },
        "36043": {
          "name": "Herkimer",
          "median": 1.09,
          "10%": 0.92,
          "90%": 1.26,
          "25%": 0.97,
          "75%": 1.1
        },
        "51091": {
          "name": "Highland",
          "median": 1.05,
          "10%": 0.96,
          "90%": 1.43,
          "25%": 0.97,
          "75%": 1.18
        },
        "51670": {
          "name": "Hopewell",
          "median": 1.145,
          "10%": 0.929,
          "90%": 1.32,
          "25%": 1.09,
          "75%": 1.27
        },
        "24027": {
          "name": "Howard",
          "median": 1.2,
          "10%": 0.96,
          "90%": 1.4,
          "25%": 1.07,
          "75%": 1.33
        },
        "34019": {
          "name": "Hunterdon",
          "median": 1.12,
          "10%": 0.989,
          "90%": 1.21,
          "25%": 1.06,
          "75%": 1.16
        },
        "42061": {
          "name": "Huntingdon",
          "median": 1.19,
          "10%": 1.07,
          "90%": 1.3,
          "25%": 1.16,
          "75%": 1.25
        },
        "42063": {
          "name": "Indiana",
          "median": 1.11,
          "10%": 0.97,
          "90%": 1.301,
          "25%": 1.03,
          "75%": 1.2
        },
        "51093": {
          "name": "Isle of Wight",
          "median": 1.1,
          "10%": 0.98,
          "90%": 1.33,
          "25%": 1.02,
          "75%": 1.2325
        },
        "54035": {
          "name": "Jackson",
          "median": 1.17,
          "10%": 1.08,
          "90%": 1.32,
          "25%": 1.11,
          "75%": 1.22
        },
        "51095": {
          "name": "James City",
          "median": 1.1,
          "10%": 0.99,
          "90%": 1.29,
          "25%": 1.06,
          "75%": 1.19
        },
        "42065": {
          "name": "Jefferson",
          "median": 1.11,
          "10%": 1.0,
          "90%": 1.21,
          "25%": 1.03,
          "75%": 1.2
        },
        "54037": {
          "name": "Jefferson",
          "median": 1.15,
          "10%": 0.93,
          "90%": 1.26,
          "25%": 1.11,
          "75%": 1.22
        },
        "42067": {
          "name": "Juniata",
          "median": 1.2,
          "10%": 1.11,
          "90%": 1.41,
          "25%": 1.13,
          "75%": 1.28
        },
        "54039": {
          "name": "Kanawha",
          "median": 1.19,
          "10%": 1.0,
          "90%": 1.29,
          "25%": 1.04,
          "75%": 1.25
        },
        "10001": {
          "name": "Kent",
          "median": 1.13,
          "10%": 0.99,
          "90%": 1.21,
          "25%": 1.02,
          "75%": 1.19
        },
        "24029": {
          "name": "Kent",
          "median": 1.09,
          "10%": 0.99,
          "90%": 1.34,
          "25%": 1.02,
          "75%": 1.21
        },
        "51099": {
          "name": "King George",
          "median": 1.09,
          "10%": 0.93,
          "90%": 1.541,
          "25%": 1.05,
          "75%": 1.21
        },
        "51101": {
          "name": "King William",
          "median": 1.085,
          "10%": 1.02,
          "90%": 1.27,
          "25%": 1.04,
          "75%": 1.13
        },
        "51097": {
          "name": "King and Queen",
          "median": 1.09,
          "10%": 0.98,
          "90%": 1.28,
          "25%": 1.01,
          "75%": 1.18
        },
        "42069": {
          "name": "Lackawanna",
          "median": 1.14,
          "10%": 1.09,
          "90%": 1.28,
          "25%": 1.11,
          "75%": 1.23
        },
        "42071": {
          "name": "Lancaster",
          "median": 1.175,
          "10%": 0.91,
          "90%": 1.32,
          "25%": 1.09,
          "75%": 1.26
        },
        "51103": {
          "name": "Lancaster",
          "median": 1.11,
          "10%": 0.96,
          "90%": 1.36,
          "25%": 0.97,
          "75%": 1.32
        },
        "42073": {
          "name": "Lawrence",
          "median": 1.13,
          "10%": 0.99,
          "90%": 1.31,
          "25%": 1.03,
          "75%": 1.21
        },
        "42075": {
          "name": "Lebanon",
          "median": 1.22,
          "10%": 0.93,
          "90%": 1.36,
          "25%": 1.1,
          "75%": 1.29
        },
        "51105": {
          "name": "Lee",
          "median": 1.17,
          "10%": 0.859,
          "90%": 1.27,
          "25%": 1.05,
          "75%": 1.2125
        },
        "42077": {
          "name": "Lehigh",
          "median": 1.14,
          "10%": 1.06,
          "90%": 1.27,
          "25%": 1.08,
          "75%": 1.21
        },
        "54041": {
          "name": "Lewis",
          "median": 1.145,
          "10%": 1.01,
          "90%": 1.39,
          "25%": 1.09,
          "75%": 1.26
        },
        "51678": {
          "name": "Lexington",
          "median": 1.18,
          "10%": 1.0,
          "90%": 1.32,
          "25%": 1.07,
          "75%": 1.26
        },
        "54043": {
          "name": "Lincoln",
          "median": 1.155,
          "10%": 1.02,
          "90%": 1.25,
          "25%": 1.04,
          "75%": 1.23
        },
        "36051": {
          "name": "Livingston",
          "median": 1.18,
          "10%": 0.95,
          "90%": 1.25,
          "25%": 1.0,
          "75%": 1.23
        },
        "54045": {
          "name": "Logan",
          "median": 1.14,
          "10%": 1.02,
          "90%": 1.35,
          "25%": 1.07,
          "75%": 1.32
        },
        "51107": {
          "name": "Loudoun",
          "median": 1.17,
          "10%": 0.91,
          "90%": 1.25,
          "25%": 1.12,
          "75%": 1.23
        },
        "51109": {
          "name": "Louisa",
          "median": 1.16,
          "10%": 0.97,
          "90%": 1.35,
          "25%": 1.09,
          "75%": 1.25
        },
        "51111": {
          "name": "Lunenburg",
          "median": 1.19,
          "10%": 1.0,
          "90%": 1.32,
          "25%": 1.08,
          "75%": 1.3
        },
        "42079": {
          "name": "Luzerne",
          "median": 1.14,
          "10%": 1.1,
          "90%": 1.29,
          "25%": 1.12,
          "75%": 1.23
        },
        "42081": {
          "name": "Lycoming",
          "median": 1.18,
          "10%": 0.98,
          "90%": 1.39,
          "25%": 1.13,
          "75%": 1.22
        },
        "51680": {
          "name": "Lynchburg",
          "median": 1.24,
          "10%": 1.05,
          "90%": 1.38,
          "25%": 1.16,
          "75%": 1.33
        },
        "36053": {
          "name": "Madison",
          "median": 1.11,
          "10%": 1.03,
          "90%": 1.16,
          "25%": 1.05,
          "75%": 1.14
        },
        "51113": {
          "name": "Madison",
          "median": 1.12,
          "10%": 0.94,
          "90%": 1.21,
          "25%": 1.04,
          "75%": 1.17
        },
        "51683": {
          "name": "Manassas",
          "median": 1.21,
          "10%": 0.85,
          "90%": 1.3,
          "25%": 1.12,
          "75%": 1.25
        },
        "51685": {
          "name": "Manassas Park",
          "median": 1.22,
          "10%": 0.84,
          "90%": 1.33,
          "25%": 1.14,
          "75%": 1.29
        },
        "54049": {
          "name": "Marion",
          "median": 1.19,
          "10%": 1.049,
          "90%": 1.35,
          "25%": 1.11,
          "75%": 1.29
        },
        "54051": {
          "name": "Marshall",
          "median": 1.16,
          "10%": 1.02,
          "90%": 1.31,
          "25%": 1.1,
          "75%": 1.21
        },
        "51690": {
          "name": "Martinsville",
          "median": 1.24,
          "10%": 1.07,
          "90%": 1.36,
          "25%": 1.12,
          "75%": 1.29
        },
        "54053": {
          "name": "Mason",
          "median": 1.17,
          "10%": 1.1,
          "90%": 1.33,
          "25%": 1.11,
          "75%": 1.26
        },
        "51115": {
          "name": "Mathews",
          "median": 1.08,
          "10%": 0.94,
          "90%": 1.281,
          "25%": 1.02,
          "75%": 1.23
        },
        "54047": {
          "name": "McDowell",
          "median": 1.13,
          "10%": 1.06,
          "90%": 1.37,
          "25%": 1.09,
          "75%": 1.27
        },
        "42083": {
          "name": "McKean",
          "median": 1.09,
          "10%": 0.93,
          "90%": 1.25,
          "25%": 1.07,
          "75%": 1.22
        },
        "51117": {
          "name": "Mecklenburg",
          "median": 1.22,
          "10%": 1.0,
          "90%": 1.3,
          "25%": 1.07,
          "75%": 1.26
        },
        "34021": {
          "name": "Mercer",
          "median": 1.13,
          "10%": 0.97,
          "90%": 1.251,
          "25%": 1.1,
          "75%": 1.17
        },
        "42085": {
          "name": "Mercer",
          "median": 1.165,
          "10%": 0.98,
          "90%": 1.31,
          "25%": 1.02,
          "75%": 1.29
        },
        "54055": {
          "name": "Mercer",
          "median": 1.21,
          "10%": 1.13,
          "90%": 1.341,
          "25%": 1.16,
          "75%": 1.29
        },
        "51119": {
          "name": "Middlesex",
          "median": 1.105,
          "10%": 0.95,
          "90%": 1.33,
          "25%": 0.98,
          "75%": 1.26
        },
        "42087": {
          "name": "Mifflin",
          "median": 1.2,
          "10%": 1.07,
          "90%": 1.38,
          "25%": 1.1,
          "75%": 1.26
        },
        "54057": {
          "name": "Mineral",
          "median": 1.18,
          "10%": 0.99,
          "90%": 1.29,
          "25%": 1.08,
          "75%": 1.25
        },
        "54059": {
          "name": "Mingo",
          "median": 1.18,
          "10%": 1.06,
          "90%": 1.35,
          "25%": 1.08,
          "75%": 1.3
        },
        "34025": {
          "name": "Monmouth",
          "median": 1.18,
          "10%": 0.89,
          "90%": 1.29,
          "25%": 1.14,
          "75%": 1.24
        },
        "54061": {
          "name": "Monongalia",
          "median": 1.2,
          "10%": 1.02,
          "90%": 1.38,
          "25%": 1.12,
          "75%": 1.35
        },
        "42089": {
          "name": "Monroe",
          "median": 1.13,
          "10%": 1.08,
          "90%": 1.23,
          "25%": 1.1,
          "75%": 1.19
        },
        "54063": {
          "name": "Monroe",
          "median": 1.2,
          "10%": 0.94,
          "90%": 1.41,
          "25%": 1.11,
          "75%": 1.2625
        },
        "24031": {
          "name": "Montgomery",
          "median": 1.19,
          "10%": 0.92,
          "90%": 1.37,
          "25%": 1.15,
          "75%": 1.32
        },
        "36057": {
          "name": "Montgomery",
          "median": 1.15,
          "10%": 0.949,
          "90%": 1.29,
          "25%": 1.08,
          "75%": 1.19
        },
        "42091": {
          "name": "Montgomery",
          "median": 1.09,
          "10%": 0.98,
          "90%": 1.14,
          "25%": 1.02,
          "75%": 1.12
        },
        "51121": {
          "name": "Montgomery",
          "median": 1.35,
          "10%": 1.01,
          "90%": 1.45,
          "25%": 1.19,
          "75%": 1.4
        },
        "42093": {
          "name": "Montour",
          "median": 1.2,
          "10%": 1.04,
          "90%": 1.49,
          "25%": 1.13,
          "75%": 1.24
        },
        "54065": {
          "name": "Morgan",
          "median": 1.19,
          "10%": 1.05,
          "90%": 1.51,
          "25%": 1.16,
          "75%": 1.29
        },
        "34027": {
          "name": "Morris",
          "median": 1.09,
          "10%": 0.92,
          "90%": 1.26,
          "25%": 0.99,
          "75%": 1.21
        },
        "36059": {
          "name": "Nassau",
          "median": 1.12,
          "10%": 1.01,
          "90%": 1.34,
          "25%": 1.09,
          "75%": 1.16
        },
        "51125": {
          "name": "Nelson",
          "median": 1.13,
          "10%": 1.01,
          "90%": 1.4,
          "25%": 1.06,
          "75%": 1.24
        },
        "10003": {
          "name": "New Castle",
          "median": 1.06,
          "10%": 0.96,
          "90%": 1.25,
          "25%": 0.97,
          "75%": 1.17
        },
        "51127": {
          "name": "New Kent",
          "median": 1.09,
          "10%": 1.0,
          "90%": 1.25,
          "25%": 1.07,
          "75%": 1.21
        },
        "36061": {
          "name": "New York",
          "median": 1.07,
          "10%": 0.84,
          "90%": 1.29,
          "25%": 0.97,
          "75%": 1.24
        },
        "51700": {
          "name": "Newport News",
          "median": 1.095,
          "10%": 1.0,
          "90%": 1.25,
          "25%": 1.02,
          "75%": 1.21
        },
        "54067": {
          "name": "Nicholas",
          "median": 1.125,
          "10%": 0.92,
          "90%": 1.38,
          "25%": 0.97,
          "75%": 1.31
        },
        "51710": {
          "name": "Norfolk",
          "median": 1.09,
          "10%": 0.86,
          "90%": 1.34,
          "25%": 0.96,
          "75%": 1.24
        },
        "42095": {
          "name": "Northampton",
          "median": 1.13,
          "10%": 1.03,
          "90%": 1.23,
          "25%": 1.07,
          "75%": 1.18
        },
        "51131": {
          "name": "Northampton",
          "median": 1.09,
          "10%": 0.89,
          "90%": 1.19,
          "25%": 1.03,
          "75%": 1.16
        },
        "42097": {
          "name": "Northumberland",
          "median": 1.22,
          "10%": 1.08,
          "90%": 1.481,
          "25%": 1.11,
          "75%": 1.25
        },
        "51133": {
          "name": "Northumberland",
          "median": 1.125,
          "10%": 0.96,
          "90%": 1.39,
          "25%": 0.97,
          "75%": 1.33
        },
        "51720": {
          "name": "Norton",
          "median": 1.12,
          "10%": 0.88,
          "90%": 1.29,
          "25%": 1.03,
          "75%": 1.24
        },
        "51135": {
          "name": "Nottoway",
          "median": 1.13,
          "10%": 1.0,
          "90%": 1.32,
          "25%": 1.09,
          "75%": 1.29
        },
        "34029": {
          "name": "Ocean",
          "median": 1.18,
          "10%": 1.0,
          "90%": 1.26,
          "25%": 1.1,
          "75%": 1.23
        },
        "54069": {
          "name": "Ohio",
          "median": 1.14,
          "10%": 1.03,
          "90%": 1.32,
          "25%": 1.06,
          "75%": 1.22
        },
        "36065": {
          "name": "Oneida",
          "median": 1.09,
          "10%": 0.97,
          "90%": 1.24,
          "25%": 1.04,
          "75%": 1.14
        },
        "36067": {
          "name": "Onondaga",
          "median": 1.11,
          "10%": 1.01,
          "90%": 1.16,
          "25%": 1.08,
          "75%": 1.14
        },
        "36069": {
          "name": "Ontario",
          "median": 1.13,
          "10%": 0.949,
          "90%": 1.2,
          "25%": 1.08,
          "75%": 1.18
        },
        "36071": {
          "name": "Orange",
          "median": 1.11,
          "10%": 0.98,
          "90%": 1.27,
          "25%": 1.0,
          "75%": 1.24
        },
        "51137": {
          "name": "Orange",
          "median": 1.16,
          "10%": 0.919,
          "90%": 1.26,
          "25%": 1.08,
          "75%": 1.22
        },
        "36077": {
          "name": "Otsego",
          "median": 1.11,
          "10%": 1.01,
          "90%": 1.29,
          "25%": 1.05,
          "75%": 1.22
        },
        "51139": {
          "name": "Page",
          "median": 1.09,
          "10%": 0.92,
          "90%": 1.25,
          "25%": 1.0,
          "75%": 1.15
        },
        "51141": {
          "name": "Patrick",
          "median": 1.23,
          "10%": 1.04,
          "90%": 1.35,
          "25%": 1.1375,
          "75%": 1.3
        },
        "54071": {
          "name": "Pendleton",
          "median": 1.045,
          "10%": 0.93,
          "90%": 1.36,
          "25%": 0.99,
          "75%": 1.2025
        },
        "42099": {
          "name": "Perry",
          "median": 1.16,
          "10%": 1.11,
          "90%": 1.471,
          "25%": 1.13,
          "75%": 1.29
        },
        "51730": {
          "name": "Petersburg",
          "median": 1.145,
          "10%": 0.929,
          "90%": 1.32,
          "25%": 1.09,
          "75%": 1.27
        },
        "42101": {
          "name": "Philadelphia",
          "median": 1.08,
          "10%": 0.99,
          "90%": 1.21,
          "25%": 1.03,
          "75%": 1.13
        },
        "42103": {
          "name": "Pike",
          "median": 1.15,
          "10%": 1.09,
          "90%": 1.22,
          "25%": 1.12,
          "75%": 1.18
        },
        "51143": {
          "name": "Pittsylvania",
          "median": 1.26,
          "10%": 1.07,
          "90%": 1.31,
          "25%": 1.0975,
          "75%": 1.28
        },
        "54073": {
          "name": "Pleasants",
          "median": 1.22,
          "10%": 1.03,
          "90%": 1.4,
          "25%": 1.1,
          "75%": 1.29
        },
        "54075": {
          "name": "Pocahontas",
          "median": 1.05,
          "10%": 0.89,
          "90%": 1.431,
          "25%": 1.0,
          "75%": 1.21
        },
        "51735": {
          "name": "Poquoson",
          "median": 1.07,
          "10%": 0.93,
          "90%": 1.27,
          "25%": 1.01,
          "75%": 1.22
        },
        "51740": {
          "name": "Portsmouth",
          "median": 1.09,
          "10%": 0.86,
          "90%": 1.34,
          "25%": 0.96,
          "75%": 1.24
        },
        "42105": {
          "name": "Potter",
          "median": 1.07,
          "10%": 0.97,
          "90%": 1.24,
          "25%": 1.03,
          "75%": 1.14
        },
        "51145": {
          "name": "Powhatan",
          "median": 1.125,
          "10%": 1.05,
          "90%": 1.43,
          "25%": 1.06,
          "75%": 1.24
        },
        "54077": {
          "name": "Preston",
          "median": 1.11,
          "10%": 0.92,
          "90%": 1.35,
          "25%": 1.02,
          "75%": 1.26
        },
        "51147": {
          "name": "Prince Edward",
          "median": 1.19,
          "10%": 1.0,
          "90%": 1.31,
          "25%": 1.09,
          "75%": 1.27
        },
        "51149": {
          "name": "Prince George",
          "median": 1.145,
          "10%": 0.93,
          "90%": 1.32,
          "25%": 1.09,
          "75%": 1.27
        },
        "24033": {
          "name": "Prince George's",
          "median": 1.16,
          "10%": 0.87,
          "90%": 1.6,
          "25%": 1.02,
          "75%": 1.33
        },
        "51153": {
          "name": "Prince William",
          "median": 1.19,
          "10%": 0.86,
          "90%": 1.29,
          "25%": 1.11,
          "75%": 1.22
        },
        "51155": {
          "name": "Pulaski",
          "median": 1.28,
          "10%": 1.05,
          "90%": 1.39,
          "25%": 1.2075,
          "75%": 1.34
        },
        "54079": {
          "name": "Putnam",
          "median": 1.15,
          "10%": 1.07,
          "90%": 1.31,
          "25%": 1.11,
          "75%": 1.21
        },
        "24035": {
          "name": "Queen Anne's",
          "median": 1.1,
          "10%": 1.01,
          "90%": 1.37,
          "25%": 1.02,
          "75%": 1.24
        },
        "51750": {
          "name": "Radford",
          "median": 1.3,
          "10%": 1.05,
          "90%": 1.411,
          "25%": 1.19,
          "75%": 1.35
        },
        "54081": {
          "name": "Raleigh",
          "median": 1.135,
          "10%": 1.03,
          "90%": 1.41,
          "25%": 1.06,
          "75%": 1.3
        },
        "54083": {
          "name": "Randolph",
          "median": 1.095,
          "10%": 0.9,
          "90%": 1.46,
          "25%": 0.98,
          "75%": 1.24
        },
        "51157": {
          "name": "Rappahannock",
          "median": 1.09,
          "10%": 0.92,
          "90%": 1.24,
          "25%": 0.98,
          "75%": 1.1525
        },
        "36085": {
          "name": "Richmond",
          "median": 1.07,
          "10%": 0.84,
          "90%": 1.29,
          "25%": 0.97,
          "75%": 1.24
        },
        "51159": {
          "name": "Richmond",
          "median": 1.06,
          "10%": 0.95,
          "90%": 1.38,
          "25%": 0.99,
          "75%": 1.17
        },
        "51760": {
          "name": "Richmond",
          "median": 1.12,
          "10%": 1.049,
          "90%": 1.32,
          "25%": 1.08,
          "75%": 1.16
        },
        "54085": {
          "name": "Ritchie",
          "median": 1.23,
          "10%": 1.07,
          "90%": 1.37,
          "25%": 1.1175,
          "75%": 1.29
        },
        "54087": {
          "name": "Roane",
          "median": 1.19,
          "10%": 1.07,
          "90%": 1.38,
          "25%": 1.08,
          "75%": 1.25
        },
        "51161": {
          "name": "Roanoke",
          "median": 1.35,
          "10%": 1.01,
          "90%": 1.46,
          "25%": 1.21,
          "75%": 1.4
        },
        "51770": {
          "name": "Roanoke",
          "median": 1.34,
          "10%": 1.03,
          "90%": 1.47,
          "25%": 1.26,
          "75%": 1.36
        },
        "51163": {
          "name": "Rockbridge",
          "median": 1.19,
          "10%": 0.98,
          "90%": 1.34,
          "25%": 1.05,
          "75%": 1.26
        },
        "51165": {
          "name": "Rockingham",
          "median": 1.07,
          "10%": 0.93,
          "90%": 1.281,
          "25%": 0.9875,
          "75%": 1.16
        },
        "51167": {
          "name": "Russell",
          "median": 1.17,
          "10%": 0.99,
          "90%": 1.29,
          "25%": 1.04,
          "75%": 1.27
        },
        "34033": {
          "name": "Salem",
          "median": 1.05,
          "10%": 0.98,
          "90%": 1.3,
          "25%": 1.0,
          "75%": 1.15
        },
        "51775": {
          "name": "Salem",
          "median": 1.35,
          "10%": 1.01,
          "90%": 1.47,
          "25%": 1.19,
          "75%": 1.4
        },
        "36095": {
          "name": "Schoharie",
          "median": 1.155,
          "10%": 0.959,
          "90%": 1.29,
          "25%": 1.05,
          "75%": 1.22
        },
        "36097": {
          "name": "Schuyler",
          "median": 1.13,
          "10%": 1.0,
          "90%": 1.29,
          "25%": 1.08,
          "75%": 1.17
        },
        "42107": {
          "name": "Schuylkill",
          "median": 1.2,
          "10%": 1.05,
          "90%": 1.42,
          "25%": 1.1,
          "75%": 1.29
        },
        "51169": {
          "name": "Scott",
          "median": 1.14,
          "10%": 0.9,
          "90%": 1.32,
          "25%": 1.02,
          "75%": 1.23
        },
        "51171": {
          "name": "Shenandoah",
          "median": 1.12,
          "10%": 0.91,
          "90%": 1.25,
          "25%": 1.01,
          "75%": 1.15
        },
        "51173": {
          "name": "Smyth",
          "median": 1.155,
          "10%": 1.1,
          "90%": 1.27,
          "25%": 1.11,
          "75%": 1.22
        },
        "42109": {
          "name": "Snyder",
          "median": 1.2,
          "10%": 1.07,
          "90%": 1.431,
          "25%": 1.15,
          "75%": 1.27
        },
        "24039": {
          "name": "Somerset",
          "median": 1.17,
          "10%": 0.98,
          "90%": 1.41,
          "25%": 1.03,
          "75%": 1.28
        },
        "42111": {
          "name": "Somerset",
          "median": 1.2,
          "10%": 0.93,
          "90%": 1.35,
          "25%": 1.08,
          "75%": 1.22
        },
        "51175": {
          "name": "Southampton",
          "median": 1.175,
          "10%": 0.99,
          "90%": 1.34,
          "25%": 1.02,
          "75%": 1.2625
        },
        "51177": {
          "name": "Spotsylvania",
          "median": 1.14,
          "10%": 0.9,
          "90%": 1.42,
          "25%": 1.1,
          "75%": 1.28
        },
        "24037": {
          "name": "St. Mary's",
          "median": 1.1,
          "10%": 0.96,
          "90%": 1.59,
          "25%": 0.98,
          "75%": 1.23
        },
        "51179": {
          "name": "Stafford",
          "median": 1.14,
          "10%": 0.91,
          "90%": 1.45,
          "25%": 1.09,
          "75%": 1.22
        },
        "51790": {
          "name": "Staunton",
          "median": 1.04,
          "10%": 0.94,
          "90%": 1.34,
          "25%": 0.97,
          "75%": 1.17
        },
        "36101": {
          "name": "Steuben",
          "median": 1.09,
          "10%": 1.0,
          "90%": 1.19,
          "25%": 1.05,
          "75%": 1.16
        },
        "51800": {
          "name": "Suffolk",
          "median": 1.11,
          "10%": 0.95,
          "90%": 1.36,
          "25%": 0.99,
          "75%": 1.25
        },
        "36105": {
          "name": "Sullivan",
          "median": 1.12,
          "10%": 1.03,
          "90%": 1.33,
          "25%": 1.06,
          "75%": 1.28
        },
        "42113": {
          "name": "Sullivan",
          "median": 1.18,
          "10%": 1.05,
          "90%": 1.4,
          "25%": 1.13,
          "75%": 1.23
        },
        "54089": {
          "name": "Summers",
          "median": 1.14,
          "10%": 0.94,
          "90%": 1.4,
          "25%": 1.11,
          "75%": 1.23
        },
        "51181": {
          "name": "Surry",
          "median": 1.11,
          "10%": 0.99,
          "90%": 1.28,
          "25%": 1.07,
          "75%": 1.2025
        },
        "42115": {
          "name": "Susquehanna",
          "median": 1.14,
          "10%": 1.08,
          "90%": 1.36,
          "25%": 1.11,
          "75%": 1.24
        },
        "10005": {
          "name": "Sussex",
          "median": 1.145,
          "10%": 0.98,
          "90%": 1.331,
          "25%": 1.0,
          "75%": 1.23
        },
        "34037": {
          "name": "Sussex",
          "median": 1.16,
          "10%": 1.019,
          "90%": 1.19,
          "25%": 1.11,
          "75%": 1.17
        },
        "51183": {
          "name": "Sussex",
          "median": 1.19,
          "10%": 0.96,
          "90%": 1.29,
          "25%": 1.09,
          "75%": 1.24
        },
        "24041": {
          "name": "Talbot",
          "median": 1.095,
          "10%": 0.98,
          "90%": 1.511,
          "25%": 1.01,
          "75%": 1.34
        },
        "54091": {
          "name": "Taylor",
          "median": 1.08,
          "10%": 0.96,
          "90%": 1.35,
          "25%": 1.03,
          "75%": 1.25
        },
        "51185": {
          "name": "Tazewell",
          "median": 1.15,
          "10%": 1.09,
          "90%": 1.35,
          "25%": 1.11,
          "75%": 1.27
        },
        "36107": {
          "name": "Tioga",
          "median": 1.16,
          "10%": 1.04,
          "90%": 1.27,
          "25%": 1.1,
          "75%": 1.19
        },
        "42117": {
          "name": "Tioga",
          "median": 1.14,
          "10%": 0.98,
          "90%": 1.36,
          "25%": 1.05,
          "75%": 1.23
        },
        "36109": {
          "name": "Tompkins",
          "median": 1.13,
          "10%": 1.0,
          "90%": 1.26,
          "25%": 1.1,
          "75%": 1.17
        },
        "54093": {
          "name": "Tucker",
          "median": 1.06,
          "10%": 0.93,
          "90%": 1.34,
          "25%": 0.97,
          "75%": 1.18
        },
        "54095": {
          "name": "Tyler",
          "median": 1.2,
          "10%": 1.09,
          "90%": 1.29,
          "25%": 1.13,
          "75%": 1.27
        },
        "36111": {
          "name": "Ulster",
          "median": 1.14,
          "10%": 0.97,
          "90%": 1.32,
          "25%": 1.0,
          "75%": 1.27
        },
        "42119": {
          "name": "Union",
          "median": 1.2,
          "10%": 1.04,
          "90%": 1.421,
          "25%": 1.16,
          "75%": 1.26
        },
        "54097": {
          "name": "Upshur",
          "median": 1.07,
          "10%": 0.929,
          "90%": 1.47,
          "25%": 1.03,
          "75%": 1.24
        },
        "42121": {
          "name": "Venango",
          "median": 1.15,
          "10%": 0.97,
          "90%": 1.31,
          "25%": 1.01,
          "75%": 1.26
        },
        "51810": {
          "name": "Virginia Beach",
          "median": 1.08,
          "10%": 0.86,
          "90%": 1.3,
          "25%": 0.96,
          "75%": 1.25
        },
        "34041": {
          "name": "Warren",
          "median": 1.12,
          "10%": 1.02,
          "90%": 1.19,
          "25%": 1.09,
          "75%": 1.1525
        },
        "42123": {
          "name": "Warren",
          "median": 1.09,
          "10%": 0.95,
          "90%": 1.41,
          "25%": 1.02,
          "75%": 1.34
        },
        "51187": {
          "name": "Warren",
          "median": 1.1,
          "10%": 0.93,
          "90%": 1.231,
          "25%": 0.98,
          "75%": 1.16
        },
        "24043": {
          "name": "Washington",
          "median": 1.18,
          "10%": 1.14,
          "90%": 1.51,
          "25%": 1.15,
          "75%": 1.21
        },
        "42125": {
          "name": "Washington",
          "median": 1.1,
          "10%": 1.01,
          "90%": 1.38,
          "25%": 1.0475,
          "75%": 1.22
        },
        "51191": {
          "name": "Washington",
          "median": 1.155,
          "10%": 1.01,
          "90%": 1.25,
          "25%": 1.05,
          "75%": 1.23
        },
        "42127": {
          "name": "Wayne",
          "median": 1.14,
          "10%": 1.06,
          "90%": 1.401,
          "25%": 1.12,
          "75%": 1.25
        },
        "54099": {
          "name": "Wayne",
          "median": 1.15,
          "10%": 1.03,
          "90%": 1.24,
          "25%": 1.0575,
          "75%": 1.23
        },
        "51820": {
          "name": "Waynesboro",
          "median": 1.07,
          "10%": 0.87,
          "90%": 1.26,
          "25%": 0.97,
          "75%": 1.16
        },
        "54101": {
          "name": "Webster",
          "median": 1.09,
          "10%": 0.9,
          "90%": 1.44,
          "25%": 1.03,
          "75%": 1.25
        },
        "36119": {
          "name": "Westchester",
          "median": 1.12,
          "10%": 0.96,
          "90%": 1.3,
          "25%": 0.98,
          "75%": 1.18
        },
        "42129": {
          "name": "Westmoreland",
          "median": 1.13,
          "10%": 0.94,
          "90%": 1.27,
          "25%": 1.03,
          "75%": 1.23
        },
        "51193": {
          "name": "Westmoreland",
          "median": 1.09,
          "10%": 0.96,
          "90%": 1.61,
          "25%": 0.97,
          "75%": 1.21
        },
        "54103": {
          "name": "Wetzel",
          "median": 1.18,
          "10%": 1.05,
          "90%": 1.31,
          "25%": 1.11,
          "75%": 1.22
        },
        "24045": {
          "name": "Wicomico",
          "median": 1.15,
          "10%": 0.99,
          "90%": 1.41,
          "25%": 1.01,
          "75%": 1.27
        },
        "51830": {
          "name": "Williamsburg",
          "median": 1.1,
          "10%": 0.99,
          "90%": 1.29,
          "25%": 1.06,
          "75%": 1.19
        },
        "51840": {
          "name": "Winchester",
          "median": 1.15,
          "10%": 0.969,
          "90%": 1.35,
          "25%": 1.0,
          "75%": 1.23
        },
        "54105": {
          "name": "Wirt",
          "median": 1.205,
          "10%": 1.07,
          "90%": 1.32,
          "25%": 1.09,
          "75%": 1.29
        },
        "51195": {
          "name": "Wise",
          "median": 1.14,
          "10%": 0.91,
          "90%": 1.35,
          "25%": 1.06,
          "75%": 1.29
        },
        "54107": {
          "name": "Wood",
          "median": 1.18,
          "10%": 0.96,
          "90%": 1.3,
          "25%": 1.07,
          "75%": 1.28
        },
        "24047": {
          "name": "Worcester",
          "median": 1.11,
          "10%": 0.98,
          "90%": 1.39,
          "25%": 1.02,
          "75%": 1.26
        },
        "42131": {
          "name": "Wyoming",
          "median": 1.15,
          "10%": 1.1,
          "90%": 1.3,
          "25%": 1.11,
          "75%": 1.24
        },
        "54109": {
          "name": "Wyoming",
          "median": 1.11,
          "10%": 1.03,
          "90%": 1.38,
          "25%": 1.07,
          "75%": 1.31
        },
        "51197": {
          "name": "Wythe",
          "median": 1.23,
          "10%": 1.12,
          "90%": 1.29,
          "25%": 1.19,
          "75%": 1.26
        },
        "36123": {
          "name": "Yates",
          "median": 1.14,
          "10%": 0.92,
          "90%": 1.17,
          "25%": 1.11,
          "75%": 1.16
        },
        "42133": {
          "name": "York",
          "median": 1.16,
          "10%": 0.96,
          "90%": 1.38,
          "25%": 1.04,
          "75%": 1.27
        },
        "51199": {
          "name": "York",
          "median": 1.09,
          "10%": 1.0,
          "90%": 1.27,
          "25%": 1.02,
          "75%": 1.21
        },
        "max": 1.35,
        "min": 1
      },
      "50": {
        "51001": {
          "name": "Accomack",
          "median": 1.12,
          "10%": 0.929,
          "90%": 1.43,
          "25%": 1.0,
          "75%": 1.35
        },
        "42001": {
          "name": "Adams",
          "median": 1.2,
          "10%": 0.99,
          "90%": 1.74,
          "25%": 1.15,
          "75%": 1.42
        },
        "51003": {
          "name": "Albemarle",
          "median": 1.1,
          "10%": 1.0,
          "90%": 1.32,
          "25%": 1.02,
          "75%": 1.25
        },
        "51510": {
          "name": "Alexandria",
          "median": 1.24,
          "10%": 0.8,
          "90%": 1.401,
          "25%": 1.17,
          "75%": 1.33
        },
        "24001": {
          "name": "Allegany",
          "median": 1.24,
          "10%": 1.01,
          "90%": 1.64,
          "25%": 1.19,
          "75%": 1.35
        },
        "36003": {
          "name": "Allegany",
          "median": 1.15,
          "10%": 1.0,
          "90%": 1.36,
          "25%": 1.1,
          "75%": 1.19
        },
        "51005": {
          "name": "Alleghany",
          "median": 1.19,
          "10%": 0.85,
          "90%": 1.56,
          "25%": 1.06,
          "75%": 1.3725
        },
        "42003": {
          "name": "Allegheny",
          "median": 1.08,
          "10%": 1.0,
          "90%": 1.35,
          "25%": 1.02,
          "75%": 1.26
        },
        "51007": {
          "name": "Amelia",
          "median": 1.135,
          "10%": 0.96,
          "90%": 1.38,
          "25%": 1.05,
          "75%": 1.31
        },
        "51009": {
          "name": "Amherst",
          "median": 1.19,
          "10%": 1.0,
          "90%": 1.36,
          "25%": 1.12,
          "75%": 1.3
        },
        "24003": {
          "name": "Anne Arundel",
          "median": 1.17,
          "10%": 0.939,
          "90%": 1.59,
          "25%": 1.04,
          "75%": 1.37
        },
        "51011": {
          "name": "Appomattox",
          "median": 1.21,
          "10%": 0.96,
          "90%": 1.4,
          "25%": 1.12,
          "75%": 1.33
        },
        "51013": {
          "name": "Arlington",
          "median": 1.24,
          "10%": 0.8,
          "90%": 1.401,
          "25%": 1.17,
          "75%": 1.33
        },
        "42005": {
          "name": "Armstrong",
          "median": 1.135,
          "10%": 0.95,
          "90%": 1.34,
          "25%": 0.99,
          "75%": 1.24
        },
        "34001": {
          "name": "Atlantic",
          "median": 1.11,
          "10%": 1.02,
          "90%": 1.22,
          "25%": 1.05,
          "75%": 1.2
        },
        "51015": {
          "name": "Augusta",
          "median": 1.02,
          "10%": 0.95,
          "90%": 1.35,
          "25%": 0.98,
          "75%": 1.2
        },
        "24005": {
          "name": "Baltimore",
          "median": 1.21,
          "10%": 0.99,
          "90%": 1.47,
          "25%": 1.02,
          "75%": 1.29
        },
        "24510": {
          "name": "Baltimore",
          "median": 1.2,
          "10%": 0.98,
          "90%": 1.48,
          "25%": 1.07,
          "75%": 1.37
        },
        "54001": {
          "name": "Barbour",
          "median": 1.04,
          "10%": 0.88,
          "90%": 1.39,
          "25%": 0.9775,
          "75%": 1.28
        },
        "51017": {
          "name": "Bath",
          "median": 1.1,
          "10%": 0.91,
          "90%": 1.521,
          "25%": 1.0,
          "75%": 1.23
        },
        "42007": {
          "name": "Beaver",
          "median": 1.05,
          "10%": 0.94,
          "90%": 1.33,
          "25%": 0.97,
          "75%": 1.26
        },
        "42009": {
          "name": "Bedford",
          "median": 1.23,
          "10%": 1.04,
          "90%": 1.41,
          "25%": 1.17,
          "75%": 1.27
        },
        "51019": {
          "name": "Bedford",
          "median": 1.31,
          "10%": 1.04,
          "90%": 1.54,
          "25%": 1.25,
          "75%": 1.39
        },
        "54003": {
          "name": "Berkeley",
          "median": 1.18,
          "10%": 1.03,
          "90%": 1.46,
          "25%": 1.06,
          "75%": 1.25
        },
        "42011": {
          "name": "Berks",
          "median": 1.17,
          "10%": 0.94,
          "90%": 1.321,
          "25%": 1.04,
          "75%": 1.27
        },
        "42013": {
          "name": "Blair",
          "median": 1.17,
          "10%": 1.08,
          "90%": 1.27,
          "25%": 1.15,
          "75%": 1.22
        },
        "51021": {
          "name": "Bland",
          "median": 1.24,
          "10%": 1.16,
          "90%": 1.48,
          "25%": 1.18,
          "75%": 1.36
        },
        "54005": {
          "name": "Boone",
          "median": 1.14,
          "10%": 0.93,
          "90%": 1.33,
          "25%": 1.0,
          "75%": 1.28
        },
        "51023": {
          "name": "Botetourt",
          "median": 1.28,
          "10%": 0.93,
          "90%": 1.52,
          "25%": 1.15,
          "75%": 1.41
        },
        "42015": {
          "name": "Bradford",
          "median": 1.21,
          "10%": 0.98,
          "90%": 1.34,
          "25%": 1.14,
          "75%": 1.3
        },
        "54007": {
          "name": "Braxton",
          "median": 1.12,
          "10%": 0.97,
          "90%": 1.47,
          "25%": 1.09,
          "75%": 1.3
        },
        "51520": {
          "name": "Bristol",
          "median": 1.155,
          "10%": 0.86,
          "90%": 1.43,
          "25%": 0.95,
          "75%": 1.24
        },
        "36005": {
          "name": "Bronx",
          "median": 1.13,
          "10%": 0.94,
          "90%": 1.38,
          "25%": 0.96,
          "75%": 1.19
        },
        "54009": {
          "name": "Brooke",
          "median": 1.12,
          "10%": 0.99,
          "90%": 1.36,
          "25%": 1.04,
          "75%": 1.23
        },
        "36007": {
          "name": "Broome",
          "median": 1.14,
          "10%": 1.1,
          "90%": 1.3,
          "25%": 1.12,
          "75%": 1.24
        },
        "51025": {
          "name": "Brunswick",
          "median": 1.14,
          "10%": 0.94,
          "90%": 1.28,
          "25%": 1.07,
          "75%": 1.24
        },
        "51027": {
          "name": "Buchanan",
          "median": 1.19,
          "10%": 0.99,
          "90%": 1.49,
          "25%": 1.07,
          "75%": 1.38
        },
        "51029": {
          "name": "Buckingham",
          "median": 1.2,
          "10%": 1.02,
          "90%": 1.41,
          "25%": 1.05,
          "75%": 1.27
        },
        "42017": {
          "name": "Bucks",
          "median": 1.09,
          "10%": 0.96,
          "90%": 1.191,
          "25%": 1.04,
          "75%": 1.11
        },
        "51530": {
          "name": "Buena Vista",
          "median": 1.17,
          "10%": 0.98,
          "90%": 1.34,
          "25%": 1.11,
          "75%": 1.31
        },
        "34005": {
          "name": "Burlington",
          "median": 1.11,
          "10%": 1.02,
          "90%": 1.32,
          "25%": 1.07,
          "75%": 1.2
        },
        "42019": {
          "name": "Butler",
          "median": 1.09,
          "10%": 0.98,
          "90%": 1.271,
          "25%": 1.06,
          "75%": 1.26
        },
        "54011": {
          "name": "Cabell",
          "median": 1.13,
          "10%": 1.01,
          "90%": 1.25,
          "25%": 1.0775,
          "75%": 1.21
        },
        "54013": {
          "name": "Calhoun",
          "median": 1.2,
          "10%": 1.03,
          "90%": 1.41,
          "25%": 1.06,
          "75%": 1.24
        },
        "24009": {
          "name": "Calvert",
          "median": 1.12,
          "10%": 0.9,
          "90%": 1.69,
          "25%": 1.01,
          "75%": 1.34
        },
        "42021": {
          "name": "Cambria",
          "median": 1.09,
          "10%": 0.98,
          "90%": 1.23,
          "25%": 1.06,
          "75%": 1.19
        },
        "34007": {
          "name": "Camden",
          "median": 1.095,
          "10%": 0.98,
          "90%": 1.271,
          "25%": 1.01,
          "75%": 1.23
        },
        "42023": {
          "name": "Cameron",
          "median": 1.08,
          "10%": 1.03,
          "90%": 1.16,
          "25%": 1.06,
          "75%": 1.14
        },
        "51031": {
          "name": "Campbell",
          "median": 1.25,
          "10%": 1.03,
          "90%": 1.451,
          "25%": 1.16,
          "75%": 1.36
        },
        "34009": {
          "name": "Cape May",
          "median": 1.12,
          "10%": 0.97,
          "90%": 1.2,
          "25%": 1.04,
          "75%": 1.15
        },
        "42025": {
          "name": "Carbon",
          "median": 1.13,
          "10%": 1.08,
          "90%": 1.35,
          "25%": 1.09,
          "75%": 1.27
        },
        "24011": {
          "name": "Caroline",
          "median": 1.2,
          "10%": 0.909,
          "90%": 1.47,
          "25%": 1.04,
          "75%": 1.3025
        },
        "51033": {
          "name": "Caroline",
          "median": 1.1,
          "10%": 1.009,
          "90%": 1.421,
          "25%": 1.06,
          "75%": 1.2
        },
        "24013": {
          "name": "Carroll",
          "median": 1.21,
          "10%": 0.98,
          "90%": 1.57,
          "25%": 1.08,
          "75%": 1.37
        },
        "51035": {
          "name": "Carroll",
          "median": 1.29,
          "10%": 1.03,
          "90%": 1.44,
          "25%": 1.23,
          "75%": 1.32
        },
        "24015": {
          "name": "Cecil",
          "median": 1.07,
          "10%": 0.95,
          "90%": 1.26,
          "25%": 0.97,
          "75%": 1.17
        },
        "42027": {
          "name": "Centre",
          "median": 1.17,
          "10%": 1.05,
          "90%": 1.35,
          "25%": 1.07,
          "75%": 1.22
        },
        "24017": {
          "name": "Charles",
          "median": 1.15,
          "10%": 0.86,
          "90%": 1.571,
          "25%": 1.06,
          "75%": 1.33
        },
        "51036": {
          "name": "Charles City",
          "median": 1.13,
          "10%": 0.91,
          "90%": 1.351,
          "25%": 1.06,
          "75%": 1.25
        },
        "51037": {
          "name": "Charlotte",
          "median": 1.2,
          "10%": 0.95,
          "90%": 1.38,
          "25%": 1.16,
          "75%": 1.28
        },
        "51540": {
          "name": "Charlottesville",
          "median": 1.115,
          "10%": 0.989,
          "90%": 1.261,
          "25%": 1.02,
          "75%": 1.19
        },
        "36015": {
          "name": "Chemung",
          "median": 1.12,
          "10%": 0.97,
          "90%": 1.45,
          "25%": 1.05,
          "75%": 1.19
        },
        "36017": {
          "name": "Chenango",
          "median": 1.12,
          "10%": 1.049,
          "90%": 1.25,
          "25%": 1.07,
          "75%": 1.19
        },
        "51550": {
          "name": "Chesapeake",
          "median": 1.09,
          "10%": 0.81,
          "90%": 1.42,
          "25%": 0.91,
          "75%": 1.3
        },
        "42029": {
          "name": "Chester",
          "median": 1.09,
          "10%": 0.91,
          "90%": 1.26,
          "25%": 0.96,
          "75%": 1.15
        },
        "51041": {
          "name": "Chesterfield",
          "median": 1.185,
          "10%": 0.95,
          "90%": 1.37,
          "25%": 1.01,
          "75%": 1.31
        },
        "42031": {
          "name": "Clarion",
          "median": 1.07,
          "10%": 0.99,
          "90%": 1.26,
          "25%": 1.03,
          "75%": 1.2
        },
        "51043": {
          "name": "Clarke",
          "median": 1.16,
          "10%": 0.92,
          "90%": 1.32,
          "25%": 1.03,
          "75%": 1.25
        },
        "54015": {
          "name": "Clay",
          "median": 1.21,
          "10%": 0.94,
          "90%": 1.36,
          "25%": 0.9775,
          "75%": 1.27
        },
        "42033": {
          "name": "Clearfield",
          "median": 1.14,
          "10%": 1.04,
          "90%": 1.19,
          "25%": 1.06,
          "75%": 1.17
        },
        "42035": {
          "name": "Clinton",
          "median": 1.15,
          "10%": 0.98,
          "90%": 1.29,
          "25%": 1.1,
          "75%": 1.21
        },
        "51570": {
          "name": "Colonial Heights",
          "median": 1.175,
          "10%": 0.88,
          "90%": 1.37,
          "25%": 1.09,
          "75%": 1.2925
        },
        "42037": {
          "name": "Columbia",
          "median": 1.21,
          "10%": 1.07,
          "90%": 1.54,
          "25%": 1.1075,
          "75%": 1.28
        },
        "36023": {
          "name": "Cortland",
          "median": 1.11,
          "10%": 1.01,
          "90%": 1.27,
          "25%": 1.09,
          "75%": 1.15
        },
        "51580": {
          "name": "Covington",
          "median": 1.22,
          "10%": 0.88,
          "90%": 1.53,
          "25%": 1.08,
          "75%": 1.4
        },
        "51045": {
          "name": "Craig",
          "median": 1.33,
          "10%": 0.91,
          "90%": 1.54,
          "25%": 1.14,
          "75%": 1.41
        },
        "42039": {
          "name": "Crawford",
          "median": 1.18,
          "10%": 1.02,
          "90%": 1.66,
          "25%": 1.0775,
          "75%": 1.5
        },
        "51047": {
          "name": "Culpeper",
          "median": 1.17,
          "10%": 0.92,
          "90%": 1.29,
          "25%": 1.08,
          "75%": 1.22
        },
        "34011": {
          "name": "Cumberland",
          "median": 1.06,
          "10%": 0.94,
          "90%": 1.19,
          "25%": 0.99,
          "75%": 1.14
        },
        "42041": {
          "name": "Cumberland",
          "median": 1.17,
          "10%": 1.08,
          "90%": 1.6,
          "25%": 1.1,
          "75%": 1.31
        },
        "51049": {
          "name": "Cumberland",
          "median": 1.21,
          "10%": 0.99,
          "90%": 1.42,
          "25%": 1.06,
          "75%": 1.32
        },
        "51590": {
          "name": "Danville",
          "median": 1.23,
          "10%": 1.04,
          "90%": 1.331,
          "25%": 1.08,
          "75%": 1.3
        },
        "42043": {
          "name": "Dauphin",
          "median": 1.18,
          "10%": 0.98,
          "90%": 1.49,
          "25%": 1.06,
          "75%": 1.29
        },
        "36025": {
          "name": "Delaware",
          "median": 1.2,
          "10%": 0.96,
          "90%": 1.401,
          "25%": 1.06,
          "75%": 1.28
        },
        "42045": {
          "name": "Delaware",
          "median": 1.05,
          "10%": 0.9,
          "90%": 1.32,
          "25%": 0.96,
          "75%": 1.1625
        },
        "51051": {
          "name": "Dickenson",
          "median": 1.165,
          "10%": 0.96,
          "90%": 1.54,
          "25%": 1.09,
          "75%": 1.4025
        },
        "51053": {
          "name": "Dinwiddie",
          "median": 1.18,
          "10%": 0.94,
          "90%": 1.33,
          "25%": 1.03,
          "75%": 1.29
        },
        "11001": {
          "name": "District of Columbia",
          "median": 1.21,
          "10%": 0.8,
          "90%": 1.48,
          "25%": 1.14,
          "75%": 1.41
        },
        "54017": {
          "name": "Doddridge",
          "median": 1.23,
          "10%": 1.13,
          "90%": 1.32,
          "25%": 1.15,
          "75%": 1.28
        },
        "24019": {
          "name": "Dorchester",
          "median": 1.135,
          "10%": 0.92,
          "90%": 1.53,
          "25%": 1.04,
          "75%": 1.3025
        },
        "42047": {
          "name": "Elk",
          "median": 1.11,
          "10%": 1.059,
          "90%": 1.21,
          "25%": 1.07,
          "75%": 1.16
        },
        "51595": {
          "name": "Emporia",
          "median": 1.13,
          "10%": 0.94,
          "90%": 1.28,
          "25%": 1.08,
          "75%": 1.23
        },
        "42049": {
          "name": "Erie",
          "median": 1.15,
          "10%": 0.99,
          "90%": 1.51,
          "25%": 1.02,
          "75%": 1.41
        },
        "51057": {
          "name": "Essex",
          "median": 1.08,
          "10%": 0.98,
          "90%": 1.39,
          "25%": 1.0,
          "75%": 1.17
        },
        "51059": {
          "name": "Fairfax",
          "median": 1.235,
          "10%": 0.8,
          "90%": 1.41,
          "25%": 1.1675,
          "75%": 1.33
        },
        "51600": {
          "name": "Fairfax",
          "median": 1.24,
          "10%": 0.8,
          "90%": 1.401,
          "25%": 1.17,
          "75%": 1.33
        },
        "51610": {
          "name": "Falls Church",
          "median": 1.24,
          "10%": 0.8,
          "90%": 1.401,
          "25%": 1.17,
          "75%": 1.33
        },
        "51061": {
          "name": "Fauquier",
          "median": 1.145,
          "10%": 0.89,
          "90%": 1.33,
          "25%": 1.0675,
          "75%": 1.23
        },
        "42051": {
          "name": "Fayette",
          "median": 1.18,
          "10%": 0.92,
          "90%": 1.37,
          "25%": 1.07,
          "75%": 1.34
        },
        "54019": {
          "name": "Fayette",
          "median": 1.17,
          "10%": 0.92,
          "90%": 1.4,
          "25%": 0.99,
          "75%": 1.3
        },
        "51063": {
          "name": "Floyd",
          "median": 1.32,
          "10%": 1.02,
          "90%": 1.47,
          "25%": 1.24,
          "75%": 1.39
        },
        "51065": {
          "name": "Fluvanna",
          "median": 1.2,
          "10%": 1.0,
          "90%": 1.501,
          "25%": 1.03,
          "75%": 1.36
        },
        "42053": {
          "name": "Forest",
          "median": 1.13,
          "10%": 1.0,
          "90%": 1.34,
          "25%": 1.03,
          "75%": 1.3
        },
        "42055": {
          "name": "Franklin",
          "median": 1.21,
          "10%": 1.16,
          "90%": 1.64,
          "25%": 1.18,
          "75%": 1.27
        },
        "51067": {
          "name": "Franklin",
          "median": 1.32,
          "10%": 1.06,
          "90%": 1.451,
          "25%": 1.26,
          "75%": 1.38
        },
        "51620": {
          "name": "Franklin",
          "median": 1.1,
          "10%": 0.919,
          "90%": 1.44,
          "25%": 0.95,
          "75%": 1.31
        },
        "24021": {
          "name": "Frederick",
          "median": 1.18,
          "10%": 0.95,
          "90%": 1.52,
          "25%": 1.16,
          "75%": 1.41
        },
        "51069": {
          "name": "Frederick",
          "median": 1.17,
          "10%": 0.91,
          "90%": 1.37,
          "25%": 0.9575,
          "75%": 1.23
        },
        "51630": {
          "name": "Fredericksburg",
          "median": 1.12,
          "10%": 0.91,
          "90%": 1.501,
          "25%": 1.06,
          "75%": 1.26
        },
        "42057": {
          "name": "Fulton",
          "median": 1.26,
          "10%": 1.1,
          "90%": 1.59,
          "25%": 1.18,
          "75%": 1.32
        },
        "51640": {
          "name": "Galax",
          "median": 1.29,
          "10%": 1.03,
          "90%": 1.44,
          "25%": 1.23,
          "75%": 1.32
        },
        "24023": {
          "name": "Garrett",
          "median": 1.15,
          "10%": 0.9,
          "90%": 1.34,
          "25%": 1.03,
          "75%": 1.3
        },
        "51071": {
          "name": "Giles",
          "median": 1.35,
          "10%": 1.05,
          "90%": 1.54,
          "25%": 1.26,
          "75%": 1.42
        },
        "54021": {
          "name": "Gilmer",
          "median": 1.16,
          "10%": 1.01,
          "90%": 1.42,
          "25%": 1.11,
          "75%": 1.29
        },
        "34015": {
          "name": "Gloucester",
          "median": 1.06,
          "10%": 0.91,
          "90%": 1.33,
          "25%": 0.98,
          "75%": 1.21
        },
        "51073": {
          "name": "Gloucester",
          "median": 1.07,
          "10%": 0.97,
          "90%": 1.29,
          "25%": 1.0,
          "75%": 1.24
        },
        "51075": {
          "name": "Goochland",
          "median": 1.155,
          "10%": 1.03,
          "90%": 1.53,
          "25%": 1.06,
          "75%": 1.31
        },
        "54023": {
          "name": "Grant",
          "median": 1.04,
          "10%": 0.919,
          "90%": 1.36,
          "25%": 0.98,
          "75%": 1.17
        },
        "51077": {
          "name": "Grayson",
          "median": 1.24,
          "10%": 1.15,
          "90%": 1.31,
          "25%": 1.21,
          "75%": 1.28
        },
        "54025": {
          "name": "Greenbrier",
          "median": 1.1,
          "10%": 0.84,
          "90%": 1.52,
          "25%": 1.06,
          "75%": 1.35
        },
        "36039": {
          "name": "Greene",
          "median": 1.13,
          "10%": 0.86,
          "90%": 1.461,
          "25%": 0.94,
          "75%": 1.31
        },
        "42059": {
          "name": "Greene",
          "median": 1.22,
          "10%": 1.11,
          "90%": 1.421,
          "25%": 1.15,
          "75%": 1.32
        },
        "51079": {
          "name": "Greene",
          "median": 1.1,
          "10%": 0.97,
          "90%": 1.27,
          "25%": 1.0,
          "75%": 1.19
        },
        "51081": {
          "name": "Greensville",
          "median": 1.17,
          "10%": 0.939,
          "90%": 1.3,
          "25%": 1.09,
          "75%": 1.2025
        },
        "51083": {
          "name": "Halifax",
          "median": 1.2,
          "10%": 1.0,
          "90%": 1.35,
          "25%": 1.11,
          "75%": 1.3
        },
        "54027": {
          "name": "Hampshire",
          "median": 1.205,
          "10%": 0.97,
          "90%": 1.31,
          "25%": 1.04,
          "75%": 1.29
        },
        "51650": {
          "name": "Hampton",
          "median": 1.075,
          "10%": 0.88,
          "90%": 1.34,
          "25%": 0.97,
          "75%": 1.25
        },
        "54029": {
          "name": "Hancock",
          "median": 1.09,
          "10%": 0.89,
          "90%": 1.42,
          "25%": 1.0175,
          "75%": 1.31
        },
        "51085": {
          "name": "Hanover",
          "median": 1.13,
          "10%": 1.06,
          "90%": 1.411,
          "25%": 1.08,
          "75%": 1.2
        },
        "54031": {
          "name": "Hardy",
          "median": 1.15,
          "10%": 0.98,
          "90%": 1.29,
          "25%": 1.01,
          "75%": 1.19
        },
        "24025": {
          "name": "Harford",
          "median": 1.14,
          "10%": 0.96,
          "90%": 1.351,
          "25%": 0.99,
          "75%": 1.2
        },
        "54033": {
          "name": "Harrison",
          "median": 1.12,
          "10%": 0.97,
          "90%": 1.36,
          "25%": 1.06,
          "75%": 1.3
        },
        "51660": {
          "name": "Harrisonburg",
          "median": 1.07,
          "10%": 0.839,
          "90%": 1.29,
          "25%": 0.98,
          "75%": 1.18
        },
        "51087": {
          "name": "Henrico",
          "median": 1.15,
          "10%": 1.01,
          "90%": 1.36,
          "25%": 1.09,
          "75%": 1.2525
        },
        "51089": {
          "name": "Henry",
          "median": 1.275,
          "10%": 1.1,
          "90%": 1.42,
          "25%": 1.12,
          "75%": 1.33
        },
        "36043": {
          "name": "Herkimer",
          "median": 1.09,
          "10%": 0.9,
          "90%": 1.32,
          "25%": 0.96,
          "75%": 1.11
        },
        "51091": {
          "name": "Highland",
          "median": 1.03,
          "10%": 0.91,
          "90%": 1.5,
          "25%": 0.96,
          "75%": 1.21
        },
        "51670": {
          "name": "Hopewell",
          "median": 1.175,
          "10%": 0.88,
          "90%": 1.37,
          "25%": 1.09,
          "75%": 1.2925
        },
        "24027": {
          "name": "Howard",
          "median": 1.19,
          "10%": 0.96,
          "90%": 1.47,
          "25%": 1.09,
          "75%": 1.39
        },
        "34019": {
          "name": "Hunterdon",
          "median": 1.12,
          "10%": 0.95,
          "90%": 1.25,
          "25%": 1.05,
          "75%": 1.2
        },
        "42061": {
          "name": "Huntingdon",
          "median": 1.19,
          "10%": 1.07,
          "90%": 1.4,
          "25%": 1.15,
          "75%": 1.25
        },
        "42063": {
          "name": "Indiana",
          "median": 1.085,
          "10%": 0.95,
          "90%": 1.35,
          "25%": 0.98,
          "75%": 1.2
        },
        "51093": {
          "name": "Isle of Wight",
          "median": 1.09,
          "10%": 0.94,
          "90%": 1.4,
          "25%": 0.99,
          "75%": 1.29
        },
        "54035": {
          "name": "Jackson",
          "median": 1.18,
          "10%": 1.02,
          "90%": 1.311,
          "25%": 1.13,
          "75%": 1.22
        },
        "51095": {
          "name": "James City",
          "median": 1.08,
          "10%": 0.95,
          "90%": 1.3,
          "25%": 1.02,
          "75%": 1.17
        },
        "42065": {
          "name": "Jefferson",
          "median": 1.11,
          "10%": 1.0,
          "90%": 1.21,
          "25%": 1.02,
          "75%": 1.19
        },
        "54037": {
          "name": "Jefferson",
          "median": 1.14,
          "10%": 0.89,
          "90%": 1.3,
          "25%": 1.1,
          "75%": 1.25
        },
        "42067": {
          "name": "Juniata",
          "median": 1.2,
          "10%": 1.09,
          "90%": 1.55,
          "25%": 1.15,
          "75%": 1.31
        },
        "54039": {
          "name": "Kanawha",
          "median": 1.195,
          "10%": 0.94,
          "90%": 1.31,
          "25%": 0.99,
          "75%": 1.25
        },
        "10001": {
          "name": "Kent",
          "median": 1.115,
          "10%": 0.95,
          "90%": 1.22,
          "25%": 1.02,
          "75%": 1.19
        },
        "24029": {
          "name": "Kent",
          "median": 1.08,
          "10%": 0.99,
          "90%": 1.33,
          "25%": 1.03,
          "75%": 1.2
        },
        "51099": {
          "name": "King George",
          "median": 1.09,
          "10%": 0.91,
          "90%": 1.51,
          "25%": 1.04,
          "75%": 1.3
        },
        "51101": {
          "name": "King William",
          "median": 1.08,
          "10%": 1.01,
          "90%": 1.27,
          "25%": 1.04,
          "75%": 1.19
        },
        "51097": {
          "name": "King and Queen",
          "median": 1.08,
          "10%": 0.96,
          "90%": 1.29,
          "25%": 0.98,
          "75%": 1.25
        },
        "42069": {
          "name": "Lackawanna",
          "median": 1.13,
          "10%": 1.07,
          "90%": 1.34,
          "25%": 1.11,
          "75%": 1.26
        },
        "42071": {
          "name": "Lancaster",
          "median": 1.19,
          "10%": 0.91,
          "90%": 1.38,
          "25%": 1.08,
          "75%": 1.26
        },
        "51103": {
          "name": "Lancaster",
          "median": 1.125,
          "10%": 0.92,
          "90%": 1.42,
          "25%": 0.95,
          "75%": 1.39
        },
        "42073": {
          "name": "Lawrence",
          "median": 1.13,
          "10%": 0.99,
          "90%": 1.32,
          "25%": 1.04,
          "75%": 1.26
        },
        "42075": {
          "name": "Lebanon",
          "median": 1.22,
          "10%": 0.91,
          "90%": 1.44,
          "25%": 1.09,
          "75%": 1.2925
        },
        "51105": {
          "name": "Lee",
          "median": 1.155,
          "10%": 0.8,
          "90%": 1.32,
          "25%": 0.97,
          "75%": 1.23
        },
        "42077": {
          "name": "Lehigh",
          "median": 1.12,
          "10%": 1.07,
          "90%": 1.34,
          "25%": 1.08,
          "75%": 1.26
        },
        "54041": {
          "name": "Lewis",
          "median": 1.14,
          "10%": 0.98,
          "90%": 1.42,
          "25%": 1.09,
          "75%": 1.25
        },
        "51678": {
          "name": "Lexington",
          "median": 1.17,
          "10%": 0.98,
          "90%": 1.34,
          "25%": 1.11,
          "75%": 1.31
        },
        "54043": {
          "name": "Lincoln",
          "median": 1.14,
          "10%": 0.989,
          "90%": 1.25,
          "25%": 1.01,
          "75%": 1.22
        },
        "36051": {
          "name": "Livingston",
          "median": 1.21,
          "10%": 0.97,
          "90%": 1.36,
          "25%": 1.04,
          "75%": 1.2525
        },
        "54045": {
          "name": "Logan",
          "median": 1.13,
          "10%": 0.99,
          "90%": 1.42,
          "25%": 1.03,
          "75%": 1.34
        },
        "51107": {
          "name": "Loudoun",
          "median": 1.15,
          "10%": 0.88,
          "90%": 1.31,
          "25%": 1.12,
          "75%": 1.24
        },
        "51109": {
          "name": "Louisa",
          "median": 1.19,
          "10%": 0.99,
          "90%": 1.4,
          "25%": 1.09,
          "75%": 1.29
        },
        "51111": {
          "name": "Lunenburg",
          "median": 1.2,
          "10%": 0.94,
          "90%": 1.35,
          "25%": 1.04,
          "75%": 1.31
        },
        "42079": {
          "name": "Luzerne",
          "median": 1.16,
          "10%": 1.1,
          "90%": 1.351,
          "25%": 1.12,
          "75%": 1.25
        },
        "42081": {
          "name": "Lycoming",
          "median": 1.2,
          "10%": 0.94,
          "90%": 1.49,
          "25%": 1.13,
          "75%": 1.29
        },
        "51680": {
          "name": "Lynchburg",
          "median": 1.255,
          "10%": 1.06,
          "90%": 1.5,
          "25%": 1.14,
          "75%": 1.38
        },
        "36053": {
          "name": "Madison",
          "median": 1.11,
          "10%": 1.02,
          "90%": 1.19,
          "25%": 1.04,
          "75%": 1.15
        },
        "51113": {
          "name": "Madison",
          "median": 1.12,
          "10%": 0.98,
          "90%": 1.27,
          "25%": 1.05,
          "75%": 1.18
        },
        "51683": {
          "name": "Manassas",
          "median": 1.22,
          "10%": 0.81,
          "90%": 1.39,
          "25%": 1.17,
          "75%": 1.28
        },
        "51685": {
          "name": "Manassas Park",
          "median": 1.24,
          "10%": 0.8,
          "90%": 1.401,
          "25%": 1.17,
          "75%": 1.33
        },
        "54049": {
          "name": "Marion",
          "median": 1.17,
          "10%": 1.05,
          "90%": 1.41,
          "25%": 1.1,
          "75%": 1.29
        },
        "54051": {
          "name": "Marshall",
          "median": 1.15,
          "10%": 1.01,
          "90%": 1.351,
          "25%": 1.08,
          "75%": 1.24
        },
        "51690": {
          "name": "Martinsville",
          "median": 1.29,
          "10%": 1.05,
          "90%": 1.44,
          "25%": 1.13,
          "75%": 1.32
        },
        "54053": {
          "name": "Mason",
          "median": 1.19,
          "10%": 1.1,
          "90%": 1.33,
          "25%": 1.13,
          "75%": 1.28
        },
        "51115": {
          "name": "Mathews",
          "median": 1.065,
          "10%": 0.89,
          "90%": 1.36,
          "25%": 1.0,
          "75%": 1.26
        },
        "54047": {
          "name": "McDowell",
          "median": 1.135,
          "10%": 1.03,
          "90%": 1.461,
          "25%": 1.0775,
          "75%": 1.33
        },
        "42083": {
          "name": "McKean",
          "median": 1.1,
          "10%": 0.92,
          "90%": 1.24,
          "25%": 1.0775,
          "75%": 1.2
        },
        "51117": {
          "name": "Mecklenburg",
          "median": 1.23,
          "10%": 0.93,
          "90%": 1.32,
          "25%": 1.02,
          "75%": 1.29
        },
        "34021": {
          "name": "Mercer",
          "median": 1.11,
          "10%": 0.94,
          "90%": 1.401,
          "25%": 1.07,
          "75%": 1.21
        },
        "42085": {
          "name": "Mercer",
          "median": 1.21,
          "10%": 0.99,
          "90%": 1.341,
          "25%": 1.03,
          "75%": 1.3
        },
        "54055": {
          "name": "Mercer",
          "median": 1.23,
          "10%": 1.13,
          "90%": 1.46,
          "25%": 1.18,
          "75%": 1.36
        },
        "51119": {
          "name": "Middlesex",
          "median": 1.1,
          "10%": 0.91,
          "90%": 1.36,
          "25%": 0.94,
          "75%": 1.33
        },
        "42087": {
          "name": "Mifflin",
          "median": 1.18,
          "10%": 1.07,
          "90%": 1.48,
          "25%": 1.09,
          "75%": 1.28
        },
        "54057": {
          "name": "Mineral",
          "median": 1.2,
          "10%": 0.99,
          "90%": 1.29,
          "25%": 1.04,
          "75%": 1.25
        },
        "54059": {
          "name": "Mingo",
          "median": 1.18,
          "10%": 1.04,
          "90%": 1.4,
          "25%": 1.07,
          "75%": 1.32
        },
        "34025": {
          "name": "Monmouth",
          "median": 1.18,
          "10%": 0.86,
          "90%": 1.39,
          "25%": 1.13,
          "75%": 1.25
        },
        "54061": {
          "name": "Monongalia",
          "median": 1.19,
          "10%": 1.04,
          "90%": 1.42,
          "25%": 1.1175,
          "75%": 1.36
        },
        "42089": {
          "name": "Monroe",
          "median": 1.12,
          "10%": 1.08,
          "90%": 1.25,
          "25%": 1.09,
          "75%": 1.21
        },
        "54063": {
          "name": "Monroe",
          "median": 1.21,
          "10%": 0.89,
          "90%": 1.511,
          "25%": 1.1575,
          "75%": 1.35
        },
        "24031": {
          "name": "Montgomery",
          "median": 1.2,
          "10%": 0.9,
          "90%": 1.47,
          "25%": 1.15,
          "75%": 1.3525
        },
        "36057": {
          "name": "Montgomery",
          "median": 1.14,
          "10%": 0.9,
          "90%": 1.37,
          "25%": 1.04,
          "75%": 1.2
        },
        "42091": {
          "name": "Montgomery",
          "median": 1.07,
          "10%": 0.939,
          "90%": 1.13,
          "25%": 1.0,
          "75%": 1.1
        },
        "51121": {
          "name": "Montgomery",
          "median": 1.4,
          "10%": 0.99,
          "90%": 1.55,
          "25%": 1.23,
          "75%": 1.48
        },
        "42093": {
          "name": "Montour",
          "median": 1.23,
          "10%": 1.0,
          "90%": 1.64,
          "25%": 1.14,
          "75%": 1.2725
        },
        "54065": {
          "name": "Morgan",
          "median": 1.23,
          "10%": 1.06,
          "90%": 1.63,
          "25%": 1.18,
          "75%": 1.33
        },
        "34027": {
          "name": "Morris",
          "median": 1.08,
          "10%": 0.86,
          "90%": 1.29,
          "25%": 0.97,
          "75%": 1.26
        },
        "36059": {
          "name": "Nassau",
          "median": 1.13,
          "10%": 1.01,
          "90%": 1.39,
          "25%": 1.08,
          "75%": 1.2
        },
        "51125": {
          "name": "Nelson",
          "median": 1.1,
          "10%": 1.04,
          "90%": 1.48,
          "25%": 1.06,
          "75%": 1.26
        },
        "10003": {
          "name": "New Castle",
          "median": 1.04,
          "10%": 0.95,
          "90%": 1.24,
          "25%": 0.97,
          "75%": 1.15
        },
        "51127": {
          "name": "New Kent",
          "median": 1.08,
          "10%": 0.99,
          "90%": 1.27,
          "25%": 1.06,
          "75%": 1.23
        },
        "36061": {
          "name": "New York",
          "median": 1.025,
          "10%": 0.79,
          "90%": 1.4,
          "25%": 0.92,
          "75%": 1.26
        },
        "51700": {
          "name": "Newport News",
          "median": 1.095,
          "10%": 0.97,
          "90%": 1.26,
          "25%": 1.0,
          "75%": 1.22
        },
        "54067": {
          "name": "Nicholas",
          "median": 1.135,
          "10%": 0.869,
          "90%": 1.43,
          "25%": 0.93,
          "75%": 1.3525
        },
        "51710": {
          "name": "Norfolk",
          "median": 1.09,
          "10%": 0.81,
          "90%": 1.42,
          "25%": 0.91,
          "75%": 1.3
        },
        "42095": {
          "name": "Northampton",
          "median": 1.13,
          "10%": 1.03,
          "90%": 1.29,
          "25%": 1.05,
          "75%": 1.22
        },
        "51131": {
          "name": "Northampton",
          "median": 1.07,
          "10%": 0.84,
          "90%": 1.19,
          "25%": 1.01,
          "75%": 1.16
        },
        "42097": {
          "name": "Northumberland",
          "median": 1.23,
          "10%": 1.05,
          "90%": 1.62,
          "25%": 1.1,
          "75%": 1.28
        },
        "51133": {
          "name": "Northumberland",
          "median": 1.14,
          "10%": 0.92,
          "90%": 1.45,
          "25%": 0.95,
          "75%": 1.41
        },
        "51720": {
          "name": "Norton",
          "median": 1.12,
          "10%": 0.789,
          "90%": 1.36,
          "25%": 0.9475,
          "75%": 1.26
        },
        "51135": {
          "name": "Nottoway",
          "median": 1.13,
          "10%": 0.96,
          "90%": 1.39,
          "25%": 1.09,
          "75%": 1.31
        },
        "34029": {
          "name": "Ocean",
          "median": 1.19,
          "10%": 0.97,
          "90%": 1.29,
          "25%": 1.08,
          "75%": 1.24
        },
        "54069": {
          "name": "Ohio",
          "median": 1.12,
          "10%": 0.99,
          "90%": 1.36,
          "25%": 1.04,
          "75%": 1.23
        },
        "36065": {
          "name": "Oneida",
          "median": 1.07,
          "10%": 0.97,
          "90%": 1.261,
          "25%": 1.01,
          "75%": 1.17
        },
        "36067": {
          "name": "Onondaga",
          "median": 1.12,
          "10%": 0.99,
          "90%": 1.22,
          "25%": 1.09,
          "75%": 1.16
        },
        "36069": {
          "name": "Ontario",
          "median": 1.17,
          "10%": 0.97,
          "90%": 1.27,
          "25%": 1.12,
          "75%": 1.2
        },
        "36071": {
          "name": "Orange",
          "median": 1.1,
          "10%": 0.96,
          "90%": 1.37,
          "25%": 0.98,
          "75%": 1.26
        },
        "51137": {
          "name": "Orange",
          "median": 1.16,
          "10%": 0.94,
          "90%": 1.31,
          "25%": 1.09,
          "75%": 1.27
        },
        "36077": {
          "name": "Otsego",
          "median": 1.1,
          "10%": 0.97,
          "90%": 1.35,
          "25%": 1.02,
          "75%": 1.27
        },
        "51139": {
          "name": "Page",
          "median": 1.045,
          "10%": 0.92,
          "90%": 1.3,
          "25%": 0.99,
          "75%": 1.14
        },
        "51141": {
          "name": "Patrick",
          "median": 1.28,
          "10%": 1.03,
          "90%": 1.48,
          "25%": 1.18,
          "75%": 1.39
        },
        "54071": {
          "name": "Pendleton",
          "median": 1.02,
          "10%": 0.92,
          "90%": 1.4,
          "25%": 0.96,
          "75%": 1.21
        },
        "42099": {
          "name": "Perry",
          "median": 1.17,
          "10%": 1.09,
          "90%": 1.6,
          "25%": 1.12,
          "75%": 1.31
        },
        "51730": {
          "name": "Petersburg",
          "median": 1.175,
          "10%": 0.88,
          "90%": 1.37,
          "25%": 1.09,
          "75%": 1.2925
        },
        "42101": {
          "name": "Philadelphia",
          "median": 1.07,
          "10%": 0.93,
          "90%": 1.19,
          "25%": 1.02,
          "75%": 1.14
        },
        "42103": {
          "name": "Pike",
          "median": 1.17,
          "10%": 1.06,
          "90%": 1.22,
          "25%": 1.12,
          "75%": 1.2
        },
        "51143": {
          "name": "Pittsylvania",
          "median": 1.26,
          "10%": 1.07,
          "90%": 1.36,
          "25%": 1.09,
          "75%": 1.33
        },
        "54073": {
          "name": "Pleasants",
          "median": 1.23,
          "10%": 1.049,
          "90%": 1.4,
          "25%": 1.1,
          "75%": 1.34
        },
        "54075": {
          "name": "Pocahontas",
          "median": 1.035,
          "10%": 0.84,
          "90%": 1.54,
          "25%": 0.96,
          "75%": 1.25
        },
        "51735": {
          "name": "Poquoson",
          "median": 1.07,
          "10%": 0.88,
          "90%": 1.34,
          "25%": 0.97,
          "75%": 1.25
        },
        "51740": {
          "name": "Portsmouth",
          "median": 1.09,
          "10%": 0.81,
          "90%": 1.42,
          "25%": 0.91,
          "75%": 1.3
        },
        "42105": {
          "name": "Potter",
          "median": 1.07,
          "10%": 0.93,
          "90%": 1.21,
          "25%": 1.01,
          "75%": 1.16
        },
        "51145": {
          "name": "Powhatan",
          "median": 1.195,
          "10%": 1.05,
          "90%": 1.5,
          "25%": 1.06,
          "75%": 1.3125
        },
        "54077": {
          "name": "Preston",
          "median": 1.085,
          "10%": 0.88,
          "90%": 1.371,
          "25%": 0.98,
          "75%": 1.25
        },
        "51147": {
          "name": "Prince Edward",
          "median": 1.205,
          "10%": 0.96,
          "90%": 1.36,
          "25%": 1.12,
          "75%": 1.31
        },
        "51149": {
          "name": "Prince George",
          "median": 1.17,
          "10%": 0.88,
          "90%": 1.37,
          "25%": 1.09,
          "75%": 1.29
        },
        "24033": {
          "name": "Prince George's",
          "median": 1.18,
          "10%": 0.83,
          "90%": 1.68,
          "25%": 1.05,
          "75%": 1.4
        },
        "51153": {
          "name": "Prince William",
          "median": 1.18,
          "10%": 0.83,
          "90%": 1.38,
          "25%": 1.14,
          "75%": 1.2525
        },
        "51155": {
          "name": "Pulaski",
          "median": 1.335,
          "10%": 1.04,
          "90%": 1.491,
          "25%": 1.25,
          "75%": 1.41
        },
        "54079": {
          "name": "Putnam",
          "median": 1.15,
          "10%": 1.06,
          "90%": 1.31,
          "25%": 1.08,
          "75%": 1.2
        },
        "24035": {
          "name": "Queen Anne's",
          "median": 1.12,
          "10%": 1.0,
          "90%": 1.39,
          "25%": 1.02,
          "75%": 1.23
        },
        "51750": {
          "name": "Radford",
          "median": 1.35,
          "10%": 1.05,
          "90%": 1.54,
          "25%": 1.26,
          "75%": 1.41
        },
        "54081": {
          "name": "Raleigh",
          "median": 1.11,
          "10%": 0.989,
          "90%": 1.49,
          "25%": 1.01,
          "75%": 1.38
        },
        "54083": {
          "name": "Randolph",
          "median": 1.085,
          "10%": 0.85,
          "90%": 1.56,
          "25%": 0.9475,
          "75%": 1.28
        },
        "51157": {
          "name": "Rappahannock",
          "median": 1.04,
          "10%": 0.93,
          "90%": 1.31,
          "25%": 0.97,
          "75%": 1.15
        },
        "36085": {
          "name": "Richmond",
          "median": 1.025,
          "10%": 0.79,
          "90%": 1.4,
          "25%": 0.92,
          "75%": 1.26
        },
        "51159": {
          "name": "Richmond",
          "median": 1.075,
          "10%": 0.93,
          "90%": 1.4,
          "25%": 0.95,
          "75%": 1.23
        },
        "51760": {
          "name": "Richmond",
          "median": 1.14,
          "10%": 1.03,
          "90%": 1.35,
          "25%": 1.08,
          "75%": 1.2
        },
        "54085": {
          "name": "Ritchie",
          "median": 1.24,
          "10%": 1.09,
          "90%": 1.36,
          "25%": 1.12,
          "75%": 1.32
        },
        "54087": {
          "name": "Roane",
          "median": 1.19,
          "10%": 1.03,
          "90%": 1.41,
          "25%": 1.06,
          "75%": 1.24
        },
        "51161": {
          "name": "Roanoke",
          "median": 1.39,
          "10%": 0.999,
          "90%": 1.571,
          "25%": 1.24,
          "75%": 1.47
        },
        "51770": {
          "name": "Roanoke",
          "median": 1.375,
          "10%": 1.02,
          "90%": 1.631,
          "25%": 1.29,
          "75%": 1.42
        },
        "51163": {
          "name": "Rockbridge",
          "median": 1.19,
          "10%": 0.95,
          "90%": 1.38,
          "25%": 1.09,
          "75%": 1.31
        },
        "51165": {
          "name": "Rockingham",
          "median": 1.05,
          "10%": 0.92,
          "90%": 1.31,
          "25%": 0.96,
          "75%": 1.16
        },
        "51167": {
          "name": "Russell",
          "median": 1.17,
          "10%": 0.94,
          "90%": 1.34,
          "25%": 1.0,
          "75%": 1.3025
        },
        "34033": {
          "name": "Salem",
          "median": 1.04,
          "10%": 0.92,
          "90%": 1.3,
          "25%": 0.98,
          "75%": 1.18
        },
        "51775": {
          "name": "Salem",
          "median": 1.39,
          "10%": 0.989,
          "90%": 1.57,
          "25%": 1.2175,
          "75%": 1.48
        },
        "36095": {
          "name": "Schoharie",
          "median": 1.165,
          "10%": 0.91,
          "90%": 1.37,
          "25%": 1.01,
          "75%": 1.25
        },
        "36097": {
          "name": "Schuyler",
          "median": 1.12,
          "10%": 0.97,
          "90%": 1.351,
          "25%": 1.07,
          "75%": 1.2
        },
        "42107": {
          "name": "Schuylkill",
          "median": 1.24,
          "10%": 1.04,
          "90%": 1.52,
          "25%": 1.09,
          "75%": 1.31
        },
        "51169": {
          "name": "Scott",
          "median": 1.13,
          "10%": 0.81,
          "90%": 1.381,
          "25%": 0.9475,
          "75%": 1.26
        },
        "51171": {
          "name": "Shenandoah",
          "median": 1.09,
          "10%": 0.899,
          "90%": 1.28,
          "25%": 1.01,
          "75%": 1.15
        },
        "51173": {
          "name": "Smyth",
          "median": 1.17,
          "10%": 1.1,
          "90%": 1.3,
          "25%": 1.12,
          "75%": 1.24
        },
        "42109": {
          "name": "Snyder",
          "median": 1.24,
          "10%": 1.05,
          "90%": 1.56,
          "25%": 1.15,
          "75%": 1.3
        },
        "24039": {
          "name": "Somerset",
          "median": 1.17,
          "10%": 0.92,
          "90%": 1.531,
          "25%": 1.02,
          "75%": 1.32
        },
        "42111": {
          "name": "Somerset",
          "median": 1.21,
          "10%": 0.92,
          "90%": 1.35,
          "25%": 1.08,
          "75%": 1.25
        },
        "51175": {
          "name": "Southampton",
          "median": 1.17,
          "10%": 0.94,
          "90%": 1.44,
          "25%": 0.9775,
          "75%": 1.32
        },
        "51177": {
          "name": "Spotsylvania",
          "median": 1.15,
          "10%": 0.89,
          "90%": 1.46,
          "25%": 1.1,
          "75%": 1.33
        },
        "24037": {
          "name": "St. Mary's",
          "median": 1.1,
          "10%": 0.92,
          "90%": 1.64,
          "25%": 0.97,
          "75%": 1.26
        },
        "51179": {
          "name": "Stafford",
          "median": 1.155,
          "10%": 0.89,
          "90%": 1.45,
          "25%": 1.08,
          "75%": 1.27
        },
        "51790": {
          "name": "Staunton",
          "median": 1.03,
          "10%": 0.93,
          "90%": 1.37,
          "25%": 0.96,
          "75%": 1.18
        },
        "36101": {
          "name": "Steuben",
          "median": 1.1,
          "10%": 0.98,
          "90%": 1.21,
          "25%": 1.05,
          "75%": 1.19
        },
        "51800": {
          "name": "Suffolk",
          "median": 1.11,
          "10%": 0.9,
          "90%": 1.44,
          "25%": 0.95,
          "75%": 1.31
        },
        "36105": {
          "name": "Sullivan",
          "median": 1.13,
          "10%": 1.03,
          "90%": 1.38,
          "25%": 1.06,
          "75%": 1.32
        },
        "42113": {
          "name": "Sullivan",
          "median": 1.2,
          "10%": 1.01,
          "90%": 1.501,
          "25%": 1.15,
          "75%": 1.28
        },
        "54089": {
          "name": "Summers",
          "median": 1.14,
          "10%": 0.89,
          "90%": 1.51,
          "25%": 1.09,
          "75%": 1.29
        },
        "51181": {
          "name": "Surry",
          "median": 1.11,
          "10%": 0.96,
          "90%": 1.3,
          "25%": 1.04,
          "75%": 1.2
        },
        "42115": {
          "name": "Susquehanna",
          "median": 1.17,
          "10%": 1.05,
          "90%": 1.4,
          "25%": 1.09,
          "75%": 1.31
        },
        "10005": {
          "name": "Sussex",
          "median": 1.16,
          "10%": 0.909,
          "90%": 1.431,
          "25%": 0.98,
          "75%": 1.27
        },
        "34037": {
          "name": "Sussex",
          "median": 1.16,
          "10%": 0.98,
          "90%": 1.241,
          "25%": 1.11,
          "75%": 1.18
        },
        "51183": {
          "name": "Sussex",
          "median": 1.17,
          "10%": 0.91,
          "90%": 1.35,
          "25%": 1.07,
          "75%": 1.29
        },
        "24041": {
          "name": "Talbot",
          "median": 1.125,
          "10%": 0.97,
          "90%": 1.611,
          "25%": 1.01,
          "75%": 1.37
        },
        "54091": {
          "name": "Taylor",
          "median": 1.05,
          "10%": 0.9,
          "90%": 1.38,
          "25%": 1.0,
          "75%": 1.3
        },
        "51185": {
          "name": "Tazewell",
          "median": 1.16,
          "10%": 1.07,
          "90%": 1.44,
          "25%": 1.1,
          "75%": 1.32
        },
        "36107": {
          "name": "Tioga",
          "median": 1.16,
          "10%": 1.0,
          "90%": 1.39,
          "25%": 1.1275,
          "75%": 1.24
        },
        "42117": {
          "name": "Tioga",
          "median": 1.16,
          "10%": 0.94,
          "90%": 1.39,
          "25%": 1.05,
          "75%": 1.33
        },
        "36109": {
          "name": "Tompkins",
          "median": 1.13,
          "10%": 0.97,
          "90%": 1.36,
          "25%": 1.09,
          "75%": 1.24
        },
        "54093": {
          "name": "Tucker",
          "median": 1.02,
          "10%": 0.89,
          "90%": 1.37,
          "25%": 0.93,
          "75%": 1.1925
        },
        "54095": {
          "name": "Tyler",
          "median": 1.2,
          "10%": 1.1,
          "90%": 1.3,
          "25%": 1.13,
          "75%": 1.27
        },
        "36111": {
          "name": "Ulster",
          "median": 1.135,
          "10%": 0.93,
          "90%": 1.38,
          "25%": 0.97,
          "75%": 1.29
        },
        "42119": {
          "name": "Union",
          "median": 1.23,
          "10%": 1.01,
          "90%": 1.55,
          "25%": 1.16,
          "75%": 1.2825
        },
        "54097": {
          "name": "Upshur",
          "median": 1.06,
          "10%": 0.87,
          "90%": 1.56,
          "25%": 0.98,
          "75%": 1.3
        },
        "42121": {
          "name": "Venango",
          "median": 1.17,
          "10%": 0.94,
          "90%": 1.31,
          "25%": 1.02,
          "75%": 1.29
        },
        "51810": {
          "name": "Virginia Beach",
          "median": 1.1,
          "10%": 0.81,
          "90%": 1.37,
          "25%": 0.91,
          "75%": 1.29
        },
        "34041": {
          "name": "Warren",
          "median": 1.14,
          "10%": 0.99,
          "90%": 1.21,
          "25%": 1.11,
          "75%": 1.18
        },
        "42123": {
          "name": "Warren",
          "median": 1.135,
          "10%": 0.96,
          "90%": 1.48,
          "25%": 1.02,
          "75%": 1.38
        },
        "51187": {
          "name": "Warren",
          "median": 1.06,
          "10%": 0.93,
          "90%": 1.3,
          "25%": 0.97,
          "75%": 1.15
        },
        "24043": {
          "name": "Washington",
          "median": 1.19,
          "10%": 1.14,
          "90%": 1.6,
          "25%": 1.16,
          "75%": 1.29
        },
        "42125": {
          "name": "Washington",
          "median": 1.08,
          "10%": 0.98,
          "90%": 1.43,
          "25%": 1.03,
          "75%": 1.2225
        },
        "51191": {
          "name": "Washington",
          "median": 1.16,
          "10%": 0.98,
          "90%": 1.27,
          "25%": 1.01,
          "75%": 1.25
        },
        "42127": {
          "name": "Wayne",
          "median": 1.15,
          "10%": 1.04,
          "90%": 1.45,
          "25%": 1.11,
          "75%": 1.31
        },
        "54099": {
          "name": "Wayne",
          "median": 1.16,
          "10%": 0.99,
          "90%": 1.24,
          "25%": 1.06,
          "75%": 1.21
        },
        "51820": {
          "name": "Waynesboro",
          "median": 1.07,
          "10%": 0.839,
          "90%": 1.29,
          "25%": 0.98,
          "75%": 1.18
        },
        "54101": {
          "name": "Webster",
          "median": 1.08,
          "10%": 0.86,
          "90%": 1.54,
          "25%": 1.0,
          "75%": 1.3
        },
        "36119": {
          "name": "Westchester",
          "median": 1.13,
          "10%": 0.94,
          "90%": 1.38,
          "25%": 0.96,
          "75%": 1.19
        },
        "42129": {
          "name": "Westmoreland",
          "median": 1.125,
          "10%": 0.94,
          "90%": 1.28,
          "25%": 1.01,
          "75%": 1.25
        },
        "51193": {
          "name": "Westmoreland",
          "median": 1.1,
          "10%": 0.94,
          "90%": 1.65,
          "25%": 0.97,
          "75%": 1.24
        },
        "54103": {
          "name": "Wetzel",
          "median": 1.17,
          "10%": 1.049,
          "90%": 1.36,
          "25%": 1.11,
          "75%": 1.24
        },
        "24045": {
          "name": "Wicomico",
          "median": 1.16,
          "10%": 0.94,
          "90%": 1.521,
          "25%": 1.01,
          "75%": 1.31
        },
        "51830": {
          "name": "Williamsburg",
          "median": 1.08,
          "10%": 0.95,
          "90%": 1.3,
          "25%": 1.02,
          "75%": 1.17
        },
        "51840": {
          "name": "Winchester",
          "median": 1.165,
          "10%": 0.91,
          "90%": 1.37,
          "25%": 0.95,
          "75%": 1.23
        },
        "54105": {
          "name": "Wirt",
          "median": 1.2,
          "10%": 1.07,
          "90%": 1.32,
          "25%": 1.1,
          "75%": 1.3
        },
        "51195": {
          "name": "Wise",
          "median": 1.13,
          "10%": 0.85,
          "90%": 1.42,
          "25%": 1.0,
          "75%": 1.33
        },
        "54107": {
          "name": "Wood",
          "median": 1.18,
          "10%": 0.95,
          "90%": 1.35,
          "25%": 1.07,
          "75%": 1.27
        },
        "24047": {
          "name": "Worcester",
          "median": 1.11,
          "10%": 0.959,
          "90%": 1.47,
          "25%": 0.98,
          "75%": 1.3025
        },
        "42131": {
          "name": "Wyoming",
          "median": 1.18,
          "10%": 1.07,
          "90%": 1.37,
          "25%": 1.08,
          "75%": 1.29
        },
        "54109": {
          "name": "Wyoming",
          "median": 1.09,
          "10%": 1.0,
          "90%": 1.46,
          "25%": 1.03,
          "75%": 1.36
        },
        "51197": {
          "name": "Wythe",
          "median": 1.27,
          "10%": 1.13,
          "90%": 1.35,
          "25%": 1.2275,
          "75%": 1.3
        },
        "36123": {
          "name": "Yates",
          "median": 1.16,
          "10%": 0.92,
          "90%": 1.241,
          "25%": 1.12,
          "75%": 1.2
        },
        "42133": {
          "name": "York",
          "median": 1.175,
          "10%": 0.96,
          "90%": 1.441,
          "25%": 1.0075,
          "75%": 1.32
        },
        "51199": {
          "name": "York",
          "median": 1.08,
          "10%": 0.97,
          "90%": 1.28,
          "25%": 1.0,
          "75%": 1.22
        },
        "max": 1.4,
        "min": 1
      },
      "100": {
        "51001": {
          "name": "Accomack",
          "median": 1.08,
          "10%": 0.88,
          "90%": 1.39,
          "25%": 0.99,
          "75%": 1.23
        },
        "42001": {
          "name": "Adams",
          "median": 1.09,
          "10%": 0.85,
          "90%": 1.41,
          "25%": 0.98,
          "75%": 1.26
        },
        "51003": {
          "name": "Albemarle",
          "median": 1.14,
          "10%": 0.92,
          "90%": 1.43,
          "25%": 1.03,
          "75%": 1.26
        },
        "51510": {
          "name": "Alexandria",
          "median": 1.14,
          "10%": 0.8,
          "90%": 1.47,
          "25%": 0.92,
          "75%": 1.31
        },
        "24001": {
          "name": "Allegany",
          "median": 1.13,
          "10%": 0.97,
          "90%": 1.43,
          "25%": 1.04,
          "75%": 1.28
        },
        "36003": {
          "name": "Allegany",
          "median": 1.15,
          "10%": 0.87,
          "90%": 1.34,
          "25%": 1.04,
          "75%": 1.22
        },
        "51005": {
          "name": "Alleghany",
          "median": 1.15,
          "10%": 0.98,
          "90%": 1.52,
          "25%": 1.06,
          "75%": 1.31
        },
        "42003": {
          "name": "Allegheny",
          "median": 1.08,
          "10%": 0.94,
          "90%": 1.39,
          "25%": 1.01,
          "75%": 1.28
        },
        "51007": {
          "name": "Amelia",
          "median": 1.18,
          "10%": 0.85,
          "90%": 1.62,
          "25%": 1.04,
          "75%": 1.42
        },
        "51009": {
          "name": "Amherst",
          "median": 1.16,
          "10%": 0.92,
          "90%": 1.42,
          "25%": 1.04,
          "75%": 1.32
        },
        "24003": {
          "name": "Anne Arundel",
          "median": 1.09,
          "10%": 0.89,
          "90%": 1.46,
          "25%": 0.97,
          "75%": 1.21
        },
        "51011": {
          "name": "Appomattox",
          "median": 1.12,
          "10%": 0.93,
          "90%": 1.56,
          "25%": 1.0,
          "75%": 1.3425
        },
        "51013": {
          "name": "Arlington",
          "median": 1.1,
          "10%": 0.88,
          "90%": 1.38,
          "25%": 0.96,
          "75%": 1.27
        },
        "42005": {
          "name": "Armstrong",
          "median": 1.13,
          "10%": 0.91,
          "90%": 1.481,
          "25%": 1.0,
          "75%": 1.34
        },
        "34001": {
          "name": "Atlantic",
          "median": 1.09,
          "10%": 0.86,
          "90%": 1.4,
          "25%": 0.98,
          "75%": 1.25
        },
        "51015": {
          "name": "Augusta",
          "median": 1.13,
          "10%": 0.88,
          "90%": 1.33,
          "25%": 1.0,
          "75%": 1.24
        },
        "24005": {
          "name": "Baltimore",
          "median": 1.1,
          "10%": 0.92,
          "90%": 1.43,
          "25%": 1.0,
          "75%": 1.26
        },
        "24510": {
          "name": "Baltimore",
          "median": 1.06,
          "10%": 0.81,
          "90%": 1.5,
          "25%": 0.96,
          "75%": 1.31
        },
        "54001": {
          "name": "Barbour",
          "median": 1.1,
          "10%": 0.95,
          "90%": 1.38,
          "25%": 1.01,
          "75%": 1.24
        },
        "51017": {
          "name": "Bath",
          "median": 1.12,
          "10%": 0.99,
          "90%": 1.43,
          "25%": 1.04,
          "75%": 1.28
        },
        "42007": {
          "name": "Beaver",
          "median": 1.12,
          "10%": 0.88,
          "90%": 1.36,
          "25%": 1.0,
          "75%": 1.23
        },
        "42009": {
          "name": "Bedford",
          "median": 1.18,
          "10%": 0.98,
          "90%": 1.42,
          "25%": 1.07,
          "75%": 1.3
        },
        "51019": {
          "name": "Bedford",
          "median": 1.16,
          "10%": 0.97,
          "90%": 1.37,
          "25%": 1.05,
          "75%": 1.27
        },
        "54003": {
          "name": "Berkeley",
          "median": 1.11,
          "10%": 0.91,
          "90%": 1.3,
          "25%": 1.02,
          "75%": 1.2
        },
        "42011": {
          "name": "Berks",
          "median": 1.18,
          "10%": 0.93,
          "90%": 1.43,
          "25%": 1.01,
          "75%": 1.33
        },
        "42013": {
          "name": "Blair",
          "median": 1.18,
          "10%": 1.01,
          "90%": 1.4,
          "25%": 1.08,
          "75%": 1.29
        },
        "51021": {
          "name": "Bland",
          "median": 1.14,
          "10%": 0.97,
          "90%": 1.44,
          "25%": 1.02,
          "75%": 1.29
        },
        "54005": {
          "name": "Boone",
          "median": 1.12,
          "10%": 0.95,
          "90%": 1.29,
          "25%": 1.02,
          "75%": 1.2
        },
        "51023": {
          "name": "Botetourt",
          "median": 1.17,
          "10%": 0.96,
          "90%": 1.49,
          "25%": 1.06,
          "75%": 1.33
        },
        "42015": {
          "name": "Bradford",
          "median": 1.21,
          "10%": 0.92,
          "90%": 1.52,
          "25%": 1.08,
          "75%": 1.35
        },
        "54007": {
          "name": "Braxton",
          "median": 1.11,
          "10%": 0.92,
          "90%": 1.37,
          "25%": 1.0,
          "75%": 1.21
        },
        "51520": {
          "name": "Bristol",
          "median": 1.14,
          "10%": 0.93,
          "90%": 1.33,
          "25%": 1.06,
          "75%": 1.21
        },
        "36005": {
          "name": "Bronx",
          "median": 1.02,
          "10%": 0.78,
          "90%": 1.25,
          "25%": 0.92,
          "75%": 1.13
        },
        "54009": {
          "name": "Brooke",
          "median": 1.12,
          "10%": 0.93,
          "90%": 1.46,
          "25%": 1.03,
          "75%": 1.28
        },
        "36007": {
          "name": "Broome",
          "median": 1.13,
          "10%": 0.99,
          "90%": 1.35,
          "25%": 1.06,
          "75%": 1.23
        },
        "51025": {
          "name": "Brunswick",
          "median": 1.175,
          "10%": 0.94,
          "90%": 1.44,
          "25%": 1.04,
          "75%": 1.31
        },
        "51027": {
          "name": "Buchanan",
          "median": 1.07,
          "10%": 0.95,
          "90%": 1.32,
          "25%": 1.01,
          "75%": 1.14
        },
        "51029": {
          "name": "Buckingham",
          "median": 1.14,
          "10%": 0.92,
          "90%": 1.42,
          "25%": 1.04,
          "75%": 1.3
        },
        "42017": {
          "name": "Bucks",
          "median": 1.09,
          "10%": 0.92,
          "90%": 1.38,
          "25%": 1.01,
          "75%": 1.22
        },
        "51530": {
          "name": "Buena Vista",
          "median": 1.11,
          "10%": 0.88,
          "90%": 1.4,
          "25%": 0.97,
          "75%": 1.25
        },
        "34005": {
          "name": "Burlington",
          "median": 1.07,
          "10%": 0.92,
          "90%": 1.3,
          "25%": 1.01,
          "75%": 1.18
        },
        "42019": {
          "name": "Butler",
          "median": 1.08,
          "10%": 0.94,
          "90%": 1.36,
          "25%": 1.01,
          "75%": 1.23
        },
        "54011": {
          "name": "Cabell",
          "median": 1.09,
          "10%": 0.97,
          "90%": 1.24,
          "25%": 1.03,
          "75%": 1.18
        },
        "54013": {
          "name": "Calhoun",
          "median": 1.16,
          "10%": 0.92,
          "90%": 1.44,
          "25%": 1.03,
          "75%": 1.28
        },
        "24009": {
          "name": "Calvert",
          "median": 1.05,
          "10%": 0.83,
          "90%": 1.41,
          "25%": 0.97,
          "75%": 1.25
        },
        "42021": {
          "name": "Cambria",
          "median": 1.14,
          "10%": 0.98,
          "90%": 1.34,
          "25%": 1.06,
          "75%": 1.23
        },
        "34007": {
          "name": "Camden",
          "median": 1.09,
          "10%": 0.93,
          "90%": 1.36,
          "25%": 1.01,
          "75%": 1.25
        },
        "42023": {
          "name": "Cameron",
          "median": 1.14,
          "10%": 0.96,
          "90%": 1.42,
          "25%": 1.04,
          "75%": 1.27
        },
        "51031": {
          "name": "Campbell",
          "median": 1.14,
          "10%": 0.99,
          "90%": 1.36,
          "25%": 1.04,
          "75%": 1.26
        },
        "34009": {
          "name": "Cape May",
          "median": 1.14,
          "10%": 0.94,
          "90%": 1.34,
          "25%": 1.02,
          "75%": 1.27
        },
        "42025": {
          "name": "Carbon",
          "median": 1.16,
          "10%": 1.0,
          "90%": 1.43,
          "25%": 1.07,
          "75%": 1.28
        },
        "24011": {
          "name": "Caroline",
          "median": 1.12,
          "10%": 0.81,
          "90%": 1.45,
          "25%": 0.95,
          "75%": 1.29
        },
        "51033": {
          "name": "Caroline",
          "median": 1.06,
          "10%": 0.87,
          "90%": 1.35,
          "25%": 0.95,
          "75%": 1.17
        },
        "24013": {
          "name": "Carroll",
          "median": 1.15,
          "10%": 0.92,
          "90%": 1.421,
          "25%": 1.02,
          "75%": 1.29
        },
        "51035": {
          "name": "Carroll",
          "median": 1.12,
          "10%": 0.99,
          "90%": 1.36,
          "25%": 1.06,
          "75%": 1.21
        },
        "24015": {
          "name": "Cecil",
          "median": 1.08,
          "10%": 0.86,
          "90%": 1.29,
          "25%": 0.95,
          "75%": 1.22
        },
        "42027": {
          "name": "Centre",
          "median": 1.18,
          "10%": 1.0,
          "90%": 1.38,
          "25%": 1.06,
          "75%": 1.3
        },
        "24017": {
          "name": "Charles",
          "median": 1.1,
          "10%": 0.85,
          "90%": 1.591,
          "25%": 0.93,
          "75%": 1.4
        },
        "51036": {
          "name": "Charles City",
          "median": 1.05,
          "10%": 0.85,
          "90%": 1.32,
          "25%": 0.92,
          "75%": 1.16
        },
        "51037": {
          "name": "Charlotte",
          "median": 1.17,
          "10%": 0.96,
          "90%": 1.38,
          "25%": 1.05,
          "75%": 1.27
        },
        "51540": {
          "name": "Charlottesville",
          "median": 1.15,
          "10%": 0.94,
          "90%": 1.43,
          "25%": 1.04,
          "75%": 1.3
        },
        "36015": {
          "name": "Chemung",
          "median": 1.13,
          "10%": 0.98,
          "90%": 1.37,
          "25%": 1.07,
          "75%": 1.23
        },
        "36017": {
          "name": "Chenango",
          "median": 1.12,
          "10%": 1.0,
          "90%": 1.36,
          "25%": 1.05,
          "75%": 1.23
        },
        "51550": {
          "name": "Chesapeake",
          "median": 1.14,
          "10%": 0.92,
          "90%": 1.47,
          "25%": 1.03,
          "75%": 1.33
        },
        "42029": {
          "name": "Chester",
          "median": 1.11,
          "10%": 0.91,
          "90%": 1.32,
          "25%": 1.01,
          "75%": 1.22
        },
        "51041": {
          "name": "Chesterfield",
          "median": 1.2,
          "10%": 0.92,
          "90%": 1.47,
          "25%": 0.99,
          "75%": 1.29
        },
        "42031": {
          "name": "Clarion",
          "median": 1.13,
          "10%": 1.0,
          "90%": 1.38,
          "25%": 1.06,
          "75%": 1.26
        },
        "51043": {
          "name": "Clarke",
          "median": 1.06,
          "10%": 0.87,
          "90%": 1.21,
          "25%": 0.98,
          "75%": 1.14
        },
        "54015": {
          "name": "Clay",
          "median": 1.06,
          "10%": 0.94,
          "90%": 1.31,
          "25%": 0.99,
          "75%": 1.13
        },
        "42033": {
          "name": "Clearfield",
          "median": 1.16,
          "10%": 1.02,
          "90%": 1.36,
          "25%": 1.06,
          "75%": 1.25
        },
        "42035": {
          "name": "Clinton",
          "median": 1.16,
          "10%": 0.95,
          "90%": 1.53,
          "25%": 1.07,
          "75%": 1.32
        },
        "51570": {
          "name": "Colonial Heights",
          "median": 1.11,
          "10%": 0.88,
          "90%": 1.37,
          "25%": 1.0,
          "75%": 1.25
        },
        "42037": {
          "name": "Columbia",
          "median": 1.23,
          "10%": 1.0,
          "90%": 1.63,
          "25%": 1.09,
          "75%": 1.39
        },
        "36023": {
          "name": "Cortland",
          "median": 1.14,
          "10%": 0.95,
          "90%": 1.38,
          "25%": 1.07,
          "75%": 1.27
        },
        "51580": {
          "name": "Covington",
          "median": 1.13,
          "10%": 0.93,
          "90%": 1.51,
          "25%": 1.0375,
          "75%": 1.31
        },
        "51045": {
          "name": "Craig",
          "median": 1.18,
          "10%": 0.95,
          "90%": 1.48,
          "25%": 1.02,
          "75%": 1.36
        },
        "42039": {
          "name": "Crawford",
          "median": 1.13,
          "10%": 0.98,
          "90%": 1.48,
          "25%": 1.05,
          "75%": 1.27
        },
        "51047": {
          "name": "Culpeper",
          "median": 1.1,
          "10%": 0.92,
          "90%": 1.26,
          "25%": 1.01,
          "75%": 1.2
        },
        "34011": {
          "name": "Cumberland",
          "median": 1.08,
          "10%": 0.85,
          "90%": 1.45,
          "25%": 0.97,
          "75%": 1.24
        },
        "42041": {
          "name": "Cumberland",
          "median": 1.13,
          "10%": 0.94,
          "90%": 1.5,
          "25%": 1.03,
          "75%": 1.32
        },
        "51049": {
          "name": "Cumberland",
          "median": 1.15,
          "10%": 0.91,
          "90%": 1.44,
          "25%": 0.99,
          "75%": 1.3
        },
        "51590": {
          "name": "Danville",
          "median": 1.11,
          "10%": 0.85,
          "90%": 1.42,
          "25%": 0.99,
          "75%": 1.29
        },
        "42043": {
          "name": "Dauphin",
          "median": 1.18,
          "10%": 0.94,
          "90%": 1.6,
          "25%": 1.07,
          "75%": 1.32
        },
        "36025": {
          "name": "Delaware",
          "median": 1.14,
          "10%": 0.99,
          "90%": 1.4,
          "25%": 1.06,
          "75%": 1.3
        },
        "42045": {
          "name": "Delaware",
          "median": 1.13,
          "10%": 0.9,
          "90%": 1.4,
          "25%": 1.01,
          "75%": 1.28
        },
        "51051": {
          "name": "Dickenson",
          "median": 1.08,
          "10%": 0.94,
          "90%": 1.31,
          "25%": 1.0,
          "75%": 1.15
        },
        "51053": {
          "name": "Dinwiddie",
          "median": 1.11,
          "10%": 0.93,
          "90%": 1.37,
          "25%": 0.9775,
          "75%": 1.26
        },
        "11001": {
          "name": "District of Columbia",
          "median": 1.12,
          "10%": 0.9,
          "90%": 1.43,
          "25%": 1.01,
          "75%": 1.3
        },
        "54017": {
          "name": "Doddridge",
          "median": 1.15,
          "10%": 0.94,
          "90%": 1.36,
          "25%": 1.02,
          "75%": 1.26
        },
        "24019": {
          "name": "Dorchester",
          "median": 1.075,
          "10%": 0.82,
          "90%": 1.33,
          "25%": 0.94,
          "75%": 1.2
        },
        "42047": {
          "name": "Elk",
          "median": 1.11,
          "10%": 0.95,
          "90%": 1.37,
          "25%": 1.06,
          "75%": 1.21
        },
        "51595": {
          "name": "Emporia",
          "median": 1.12,
          "10%": 0.88,
          "90%": 1.5,
          "25%": 0.98,
          "75%": 1.31
        },
        "42049": {
          "name": "Erie",
          "median": 1.08,
          "10%": 0.92,
          "90%": 1.47,
          "25%": 0.99,
          "75%": 1.25
        },
        "51057": {
          "name": "Essex",
          "median": 1.0,
          "10%": 0.78,
          "90%": 1.28,
          "25%": 0.93,
          "75%": 1.11
        },
        "51059": {
          "name": "Fairfax",
          "median": 1.11,
          "10%": 0.9,
          "90%": 1.37,
          "25%": 0.99,
          "75%": 1.23
        },
        "51600": {
          "name": "Fairfax",
          "median": 1.06,
          "10%": 0.86,
          "90%": 1.33,
          "25%": 0.98,
          "75%": 1.22
        },
        "51610": {
          "name": "Falls Church",
          "median": 1.08,
          "10%": 0.87,
          "90%": 1.33,
          "25%": 0.97,
          "75%": 1.24
        },
        "51061": {
          "name": "Fauquier",
          "median": 1.06,
          "10%": 0.88,
          "90%": 1.32,
          "25%": 0.96,
          "75%": 1.17
        },
        "42051": {
          "name": "Fayette",
          "median": 1.15,
          "10%": 0.96,
          "90%": 1.47,
          "25%": 1.04,
          "75%": 1.32
        },
        "54019": {
          "name": "Fayette",
          "median": 1.1,
          "10%": 0.92,
          "90%": 1.31,
          "25%": 1.0,
          "75%": 1.21
        },
        "51063": {
          "name": "Floyd",
          "median": 1.15,
          "10%": 0.95,
          "90%": 1.41,
          "25%": 1.02,
          "75%": 1.28
        },
        "51065": {
          "name": "Fluvanna",
          "median": 1.17,
          "10%": 0.9,
          "90%": 1.65,
          "25%": 1.01,
          "75%": 1.38
        },
        "42053": {
          "name": "Forest",
          "median": 1.14,
          "10%": 0.9,
          "90%": 1.37,
          "25%": 1.05,
          "75%": 1.26
        },
        "42055": {
          "name": "Franklin",
          "median": 1.16,
          "10%": 0.99,
          "90%": 1.35,
          "25%": 1.07,
          "75%": 1.24
        },
        "51067": {
          "name": "Franklin",
          "median": 1.22,
          "10%": 0.88,
          "90%": 1.48,
          "25%": 1.01,
          "75%": 1.34
        },
        "51620": {
          "name": "Franklin",
          "median": 1.16,
          "10%": 0.92,
          "90%": 1.42,
          "25%": 1.01,
          "75%": 1.28
        },
        "24021": {
          "name": "Frederick",
          "median": 1.11,
          "10%": 0.91,
          "90%": 1.32,
          "25%": 0.98,
          "75%": 1.22
        },
        "51069": {
          "name": "Frederick",
          "median": 1.13,
          "10%": 0.89,
          "90%": 1.29,
          "25%": 1.02,
          "75%": 1.23
        },
        "51630": {
          "name": "Fredericksburg",
          "median": 1.12,
          "10%": 0.82,
          "90%": 1.41,
          "25%": 0.93,
          "75%": 1.2625
        },
        "42057": {
          "name": "Fulton",
          "median": 1.19,
          "10%": 0.9,
          "90%": 1.38,
          "25%": 1.03,
          "75%": 1.3
        },
        "51640": {
          "name": "Galax",
          "median": 1.08,
          "10%": 0.88,
          "90%": 1.36,
          "25%": 0.96,
          "75%": 1.21
        },
        "24023": {
          "name": "Garrett",
          "median": 1.12,
          "10%": 0.96,
          "90%": 1.36,
          "25%": 1.03,
          "75%": 1.22
        },
        "51071": {
          "name": "Giles",
          "median": 1.15,
          "10%": 0.97,
          "90%": 1.46,
          "25%": 1.05,
          "75%": 1.31
        },
        "54021": {
          "name": "Gilmer",
          "median": 1.12,
          "10%": 0.92,
          "90%": 1.4,
          "25%": 1.0,
          "75%": 1.27
        },
        "34015": {
          "name": "Gloucester",
          "median": 1.15,
          "10%": 0.92,
          "90%": 1.41,
          "25%": 1.02,
          "75%": 1.26
        },
        "51073": {
          "name": "Gloucester",
          "median": 1.05,
          "10%": 0.8,
          "90%": 1.29,
          "25%": 0.94,
          "75%": 1.2
        },
        "51075": {
          "name": "Goochland",
          "median": 1.14,
          "10%": 0.89,
          "90%": 1.68,
          "25%": 1.03,
          "75%": 1.39
        },
        "54023": {
          "name": "Grant",
          "median": 1.1,
          "10%": 0.94,
          "90%": 1.39,
          "25%": 0.99,
          "75%": 1.24
        },
        "51077": {
          "name": "Grayson",
          "median": 1.09,
          "10%": 0.94,
          "90%": 1.31,
          "25%": 1.02,
          "75%": 1.21
        },
        "54025": {
          "name": "Greenbrier",
          "median": 1.12,
          "10%": 0.92,
          "90%": 1.36,
          "25%": 1.01,
          "75%": 1.21
        },
        "36039": {
          "name": "Greene",
          "median": 1.19,
          "10%": 0.97,
          "90%": 1.44,
          "25%": 1.06,
          "75%": 1.29
        },
        "42059": {
          "name": "Greene",
          "median": 1.17,
          "10%": 0.97,
          "90%": 1.39,
          "25%": 1.1,
          "75%": 1.26
        },
        "51079": {
          "name": "Greene",
          "median": 1.18,
          "10%": 0.88,
          "90%": 1.42,
          "25%": 0.99,
          "75%": 1.33
        },
        "51081": {
          "name": "Greensville",
          "median": 1.13,
          "10%": 0.93,
          "90%": 1.46,
          "25%": 1.01,
          "75%": 1.29
        },
        "51083": {
          "name": "Halifax",
          "median": 1.16,
          "10%": 0.96,
          "90%": 1.38,
          "25%": 1.06,
          "75%": 1.29
        },
        "54027": {
          "name": "Hampshire",
          "median": 1.19,
          "10%": 0.97,
          "90%": 1.45,
          "25%": 1.04,
          "75%": 1.31
        },
        "51650": {
          "name": "Hampton",
          "median": 1.12,
          "10%": 0.87,
          "90%": 1.37,
          "25%": 1.02,
          "75%": 1.28
        },
        "54029": {
          "name": "Hancock",
          "median": 1.07,
          "10%": 0.88,
          "90%": 1.4,
          "25%": 0.98,
          "75%": 1.27
        },
        "51085": {
          "name": "Hanover",
          "median": 1.1,
          "10%": 0.93,
          "90%": 1.37,
          "25%": 1.0,
          "75%": 1.22
        },
        "54031": {
          "name": "Hardy",
          "median": 1.17,
          "10%": 0.94,
          "90%": 1.37,
          "25%": 1.01,
          "75%": 1.27
        },
        "24025": {
          "name": "Harford",
          "median": 1.1,
          "10%": 0.89,
          "90%": 1.361,
          "25%": 0.9575,
          "75%": 1.25
        },
        "54033": {
          "name": "Harrison",
          "median": 1.09,
          "10%": 0.95,
          "90%": 1.361,
          "25%": 1.0,
          "75%": 1.22
        },
        "51660": {
          "name": "Harrisonburg",
          "median": 1.12,
          "10%": 0.79,
          "90%": 1.45,
          "25%": 1.0,
          "75%": 1.29
        },
        "51087": {
          "name": "Henrico",
          "median": 1.13,
          "10%": 0.93,
          "90%": 1.37,
          "25%": 0.99,
          "75%": 1.28
        },
        "51089": {
          "name": "Henry",
          "median": 1.23,
          "10%": 0.88,
          "90%": 1.5,
          "25%": 0.99,
          "75%": 1.38
        },
        "36043": {
          "name": "Herkimer",
          "median": 1.07,
          "10%": 0.94,
          "90%": 1.3,
          "25%": 0.99,
          "75%": 1.14
        },
        "51091": {
          "name": "Highland",
          "median": 1.08,
          "10%": 0.89,
          "90%": 1.42,
          "25%": 0.97,
          "75%": 1.25
        },
        "51670": {
          "name": "Hopewell",
          "median": 1.08,
          "10%": 0.85,
          "90%": 1.38,
          "25%": 0.92,
          "75%": 1.24
        },
        "24027": {
          "name": "Howard",
          "median": 1.09,
          "10%": 0.9,
          "90%": 1.46,
          "25%": 1.0,
          "75%": 1.27
        },
        "34019": {
          "name": "Hunterdon",
          "median": 1.13,
          "10%": 0.85,
          "90%": 1.491,
          "25%": 0.95,
          "75%": 1.29
        },
        "42061": {
          "name": "Huntingdon",
          "median": 1.2,
          "10%": 0.96,
          "90%": 1.43,
          "25%": 1.07,
          "75%": 1.29
        },
        "42063": {
          "name": "Indiana",
          "median": 1.16,
          "10%": 0.93,
          "90%": 1.44,
          "25%": 1.06,
          "75%": 1.27
        },
        "51093": {
          "name": "Isle of Wight",
          "median": 1.14,
          "10%": 0.9,
          "90%": 1.43,
          "25%": 1.04,
          "75%": 1.3
        },
        "54035": {
          "name": "Jackson",
          "median": 1.13,
          "10%": 0.97,
          "90%": 1.37,
          "25%": 1.02,
          "75%": 1.23
        },
        "51095": {
          "name": "James City",
          "median": 1.05,
          "10%": 0.77,
          "90%": 1.32,
          "25%": 0.9,
          "75%": 1.2
        },
        "42065": {
          "name": "Jefferson",
          "median": 1.15,
          "10%": 0.99,
          "90%": 1.37,
          "25%": 1.06,
          "75%": 1.25
        },
        "54037": {
          "name": "Jefferson",
          "median": 1.04,
          "10%": 0.88,
          "90%": 1.24,
          "25%": 0.96,
          "75%": 1.13
        },
        "42067": {
          "name": "Juniata",
          "median": 1.17,
          "10%": 0.98,
          "90%": 1.5,
          "25%": 1.06,
          "75%": 1.31
        },
        "54039": {
          "name": "Kanawha",
          "median": 1.06,
          "10%": 0.93,
          "90%": 1.26,
          "25%": 1.0,
          "75%": 1.16
        },
        "10001": {
          "name": "Kent",
          "median": 1.08,
          "10%": 0.87,
          "90%": 1.28,
          "25%": 0.95,
          "75%": 1.2
        },
        "24029": {
          "name": "Kent",
          "median": 1.07,
          "10%": 0.87,
          "90%": 1.34,
          "25%": 0.99,
          "75%": 1.21
        },
        "51099": {
          "name": "King George",
          "median": 1.05,
          "10%": 0.82,
          "90%": 1.36,
          "25%": 0.89,
          "75%": 1.22
        },
        "51101": {
          "name": "King William",
          "median": 1.07,
          "10%": 0.83,
          "90%": 1.29,
          "25%": 0.99,
          "75%": 1.17
        },
        "51097": {
          "name": "King and Queen",
          "median": 1.05,
          "10%": 0.79,
          "90%": 1.24,
          "25%": 0.93,
          "75%": 1.14
        },
        "42069": {
          "name": "Lackawanna",
          "median": 1.18,
          "10%": 0.99,
          "90%": 1.52,
          "25%": 1.06,
          "75%": 1.34
        },
        "42071": {
          "name": "Lancaster",
          "median": 1.1,
          "10%": 0.94,
          "90%": 1.41,
          "25%": 1.03,
          "75%": 1.28
        },
        "51103": {
          "name": "Lancaster",
          "median": 1.03,
          "10%": 0.8,
          "90%": 1.37,
          "25%": 0.93,
          "75%": 1.17
        },
        "42073": {
          "name": "Lawrence",
          "median": 1.13,
          "10%": 0.9,
          "90%": 1.42,
          "25%": 1.02,
          "75%": 1.3
        },
        "42075": {
          "name": "Lebanon",
          "median": 1.2,
          "10%": 0.92,
          "90%": 1.47,
          "25%": 1.02,
          "75%": 1.32
        },
        "51105": {
          "name": "Lee",
          "median": 1.18,
          "10%": 0.93,
          "90%": 1.44,
          "25%": 1.06,
          "75%": 1.28
        },
        "42077": {
          "name": "Lehigh",
          "median": 1.13,
          "10%": 0.94,
          "90%": 1.36,
          "25%": 1.03,
          "75%": 1.25
        },
        "54041": {
          "name": "Lewis",
          "median": 1.11,
          "10%": 0.94,
          "90%": 1.35,
          "25%": 1.0,
          "75%": 1.24
        },
        "51678": {
          "name": "Lexington",
          "median": 1.11,
          "10%": 0.89,
          "90%": 1.37,
          "25%": 0.99,
          "75%": 1.25
        },
        "54043": {
          "name": "Lincoln",
          "median": 1.11,
          "10%": 0.96,
          "90%": 1.24,
          "25%": 1.0,
          "75%": 1.18
        },
        "36051": {
          "name": "Livingston",
          "median": 1.14,
          "10%": 1.0,
          "90%": 1.42,
          "25%": 1.09,
          "75%": 1.27
        },
        "54045": {
          "name": "Logan",
          "median": 1.13,
          "10%": 0.94,
          "90%": 1.4,
          "25%": 1.01,
          "75%": 1.27
        },
        "51107": {
          "name": "Loudoun",
          "median": 1.12,
          "10%": 0.9,
          "90%": 1.28,
          "25%": 1.02,
          "75%": 1.21
        },
        "51109": {
          "name": "Louisa",
          "median": 1.15,
          "10%": 0.92,
          "90%": 1.42,
          "25%": 1.01,
          "75%": 1.27
        },
        "51111": {
          "name": "Lunenburg",
          "median": 1.22,
          "10%": 0.92,
          "90%": 1.43,
          "25%": 1.05,
          "75%": 1.34
        },
        "42079": {
          "name": "Luzerne",
          "median": 1.175,
          "10%": 0.98,
          "90%": 1.44,
          "25%": 1.1,
          "75%": 1.31
        },
        "42081": {
          "name": "Lycoming",
          "median": 1.19,
          "10%": 0.97,
          "90%": 1.56,
          "25%": 1.11,
          "75%": 1.34
        },
        "51680": {
          "name": "Lynchburg",
          "median": 1.14,
          "10%": 0.92,
          "90%": 1.47,
          "25%": 1.02,
          "75%": 1.29
        },
        "36053": {
          "name": "Madison",
          "median": 1.1,
          "10%": 0.9,
          "90%": 1.31,
          "25%": 1.04,
          "75%": 1.22
        },
        "51113": {
          "name": "Madison",
          "median": 1.16,
          "10%": 0.88,
          "90%": 1.46,
          "25%": 0.99,
          "75%": 1.31
        },
        "51683": {
          "name": "Manassas",
          "median": 1.05,
          "10%": 0.9,
          "90%": 1.45,
          "25%": 0.95,
          "75%": 1.24
        },
        "51685": {
          "name": "Manassas Park",
          "median": 1.05,
          "10%": 0.88,
          "90%": 1.45,
          "25%": 0.94,
          "75%": 1.24
        },
        "54049": {
          "name": "Marion",
          "median": 1.1,
          "10%": 0.91,
          "90%": 1.35,
          "25%": 1.02,
          "75%": 1.21
        },
        "54051": {
          "name": "Marshall",
          "median": 1.12,
          "10%": 0.93,
          "90%": 1.48,
          "25%": 1.03,
          "75%": 1.31
        },
        "51690": {
          "name": "Martinsville",
          "median": 1.23,
          "10%": 0.83,
          "90%": 1.55,
          "25%": 1.01,
          "75%": 1.37
        },
        "54053": {
          "name": "Mason",
          "median": 1.12,
          "10%": 0.94,
          "90%": 1.35,
          "25%": 1.05,
          "75%": 1.27
        },
        "51115": {
          "name": "Mathews",
          "median": 1.09,
          "10%": 0.82,
          "90%": 1.38,
          "25%": 0.95,
          "75%": 1.21
        },
        "54047": {
          "name": "McDowell",
          "median": 1.09,
          "10%": 0.94,
          "90%": 1.33,
          "25%": 1.0,
          "75%": 1.21
        },
        "42083": {
          "name": "McKean",
          "median": 1.12,
          "10%": 0.91,
          "90%": 1.3,
          "25%": 1.03,
          "75%": 1.22
        },
        "51117": {
          "name": "Mecklenburg",
          "median": 1.18,
          "10%": 0.94,
          "90%": 1.38,
          "25%": 1.07,
          "75%": 1.28
        },
        "34021": {
          "name": "Mercer",
          "median": 1.06,
          "10%": 0.87,
          "90%": 1.41,
          "25%": 0.93,
          "75%": 1.24
        },
        "42085": {
          "name": "Mercer",
          "median": 1.11,
          "10%": 0.96,
          "90%": 1.35,
          "25%": 1.04,
          "75%": 1.21
        },
        "54055": {
          "name": "Mercer",
          "median": 1.13,
          "10%": 0.98,
          "90%": 1.4,
          "25%": 1.05,
          "75%": 1.28
        },
        "51119": {
          "name": "Middlesex",
          "median": 1.04,
          "10%": 0.79,
          "90%": 1.27,
          "25%": 0.93,
          "75%": 1.17
        },
        "42087": {
          "name": "Mifflin",
          "median": 1.17,
          "10%": 0.99,
          "90%": 1.46,
          "25%": 1.06,
          "75%": 1.28
        },
        "54057": {
          "name": "Mineral",
          "median": 1.15,
          "10%": 0.98,
          "90%": 1.4,
          "25%": 1.05,
          "75%": 1.29
        },
        "54059": {
          "name": "Mingo",
          "median": 1.18,
          "10%": 1.0,
          "90%": 1.44,
          "25%": 1.06,
          "75%": 1.33
        },
        "34025": {
          "name": "Monmouth",
          "median": 1.07,
          "10%": 0.87,
          "90%": 1.34,
          "25%": 0.95,
          "75%": 1.18
        },
        "54061": {
          "name": "Monongalia",
          "median": 1.11,
          "10%": 0.98,
          "90%": 1.38,
          "25%": 1.03,
          "75%": 1.22
        },
        "42089": {
          "name": "Monroe",
          "median": 1.17,
          "10%": 0.96,
          "90%": 1.38,
          "25%": 1.04,
          "75%": 1.3
        },
        "54063": {
          "name": "Monroe",
          "median": 1.13,
          "10%": 0.94,
          "90%": 1.34,
          "25%": 1.04,
          "75%": 1.23
        },
        "24031": {
          "name": "Montgomery",
          "median": 1.1,
          "10%": 0.95,
          "90%": 1.36,
          "25%": 1.01,
          "75%": 1.19
        },
        "36057": {
          "name": "Montgomery",
          "median": 1.11,
          "10%": 0.93,
          "90%": 1.34,
          "25%": 1.0,
          "75%": 1.2
        },
        "42091": {
          "name": "Montgomery",
          "median": 1.1,
          "10%": 0.95,
          "90%": 1.35,
          "25%": 1.01,
          "75%": 1.23
        },
        "51121": {
          "name": "Montgomery",
          "median": 1.15,
          "10%": 0.95,
          "90%": 1.52,
          "25%": 1.03,
          "75%": 1.38
        },
        "42093": {
          "name": "Montour",
          "median": 1.24,
          "10%": 0.94,
          "90%": 1.7,
          "25%": 1.08,
          "75%": 1.43
        },
        "54065": {
          "name": "Morgan",
          "median": 1.16,
          "10%": 0.93,
          "90%": 1.35,
          "25%": 1.04,
          "75%": 1.26
        },
        "34027": {
          "name": "Morris",
          "median": 1.16,
          "10%": 0.88,
          "90%": 1.55,
          "25%": 1.0,
          "75%": 1.36
        },
        "36059": {
          "name": "Nassau",
          "median": 1.11,
          "10%": 0.9,
          "90%": 1.38,
          "25%": 1.02,
          "75%": 1.25
        },
        "51125": {
          "name": "Nelson",
          "median": 1.15,
          "10%": 0.94,
          "90%": 1.55,
          "25%": 1.03,
          "75%": 1.41
        },
        "10003": {
          "name": "New Castle",
          "median": 1.11,
          "10%": 0.9,
          "90%": 1.32,
          "25%": 0.96,
          "75%": 1.26
        },
        "51127": {
          "name": "New Kent",
          "median": 1.07,
          "10%": 0.83,
          "90%": 1.26,
          "25%": 0.95,
          "75%": 1.15
        },
        "36061": {
          "name": "New York",
          "median": 1.04,
          "10%": 0.83,
          "90%": 1.37,
          "25%": 0.93,
          "75%": 1.14
        },
        "51700": {
          "name": "Newport News",
          "median": 1.09,
          "10%": 0.88,
          "90%": 1.33,
          "25%": 0.97,
          "75%": 1.23
        },
        "54067": {
          "name": "Nicholas",
          "median": 1.05,
          "10%": 0.9,
          "90%": 1.29,
          "25%": 0.97,
          "75%": 1.18
        },
        "51710": {
          "name": "Norfolk",
          "median": 1.13,
          "10%": 0.88,
          "90%": 1.58,
          "25%": 0.98,
          "75%": 1.41
        },
        "42095": {
          "name": "Northampton",
          "median": 1.11,
          "10%": 0.91,
          "90%": 1.36,
          "25%": 1.0,
          "75%": 1.21
        },
        "51131": {
          "name": "Northampton",
          "median": 1.08,
          "10%": 0.89,
          "90%": 1.32,
          "25%": 0.97,
          "75%": 1.19
        },
        "42097": {
          "name": "Northumberland",
          "median": 1.25,
          "10%": 0.96,
          "90%": 1.73,
          "25%": 1.09,
          "75%": 1.45
        },
        "51133": {
          "name": "Northumberland",
          "median": 1.0,
          "10%": 0.79,
          "90%": 1.4,
          "25%": 0.91,
          "75%": 1.18
        },
        "51720": {
          "name": "Norton",
          "median": 1.15,
          "10%": 0.92,
          "90%": 1.38,
          "25%": 1.04,
          "75%": 1.26
        },
        "51135": {
          "name": "Nottoway",
          "median": 1.23,
          "10%": 0.9,
          "90%": 1.47,
          "25%": 1.04,
          "75%": 1.35
        },
        "34029": {
          "name": "Ocean",
          "median": 1.1,
          "10%": 0.95,
          "90%": 1.26,
          "25%": 1.01,
          "75%": 1.17
        },
        "54069": {
          "name": "Ohio",
          "median": 1.16,
          "10%": 0.939,
          "90%": 1.5,
          "25%": 1.02,
          "75%": 1.3
        },
        "36065": {
          "name": "Oneida",
          "median": 1.12,
          "10%": 0.95,
          "90%": 1.35,
          "25%": 1.06,
          "75%": 1.23
        },
        "36067": {
          "name": "Onondaga",
          "median": 1.12,
          "10%": 0.95,
          "90%": 1.34,
          "25%": 1.0,
          "75%": 1.24
        },
        "36069": {
          "name": "Ontario",
          "median": 1.17,
          "10%": 0.99,
          "90%": 1.45,
          "25%": 1.05,
          "75%": 1.28
        },
        "36071": {
          "name": "Orange",
          "median": 1.21,
          "10%": 0.92,
          "90%": 1.55,
          "25%": 1.05,
          "75%": 1.39
        },
        "51137": {
          "name": "Orange",
          "median": 1.12,
          "10%": 0.9,
          "90%": 1.32,
          "25%": 0.99,
          "75%": 1.24
        },
        "36077": {
          "name": "Otsego",
          "median": 1.09,
          "10%": 0.96,
          "90%": 1.33,
          "25%": 1.02,
          "75%": 1.2
        },
        "51139": {
          "name": "Page",
          "median": 1.12,
          "10%": 0.89,
          "90%": 1.48,
          "25%": 0.97,
          "75%": 1.33
        },
        "51141": {
          "name": "Patrick",
          "median": 1.18,
          "10%": 0.92,
          "90%": 1.49,
          "25%": 1.05,
          "75%": 1.32
        },
        "54071": {
          "name": "Pendleton",
          "median": 1.06,
          "10%": 0.88,
          "90%": 1.54,
          "25%": 0.97,
          "75%": 1.23
        },
        "42099": {
          "name": "Perry",
          "median": 1.13,
          "10%": 0.94,
          "90%": 1.41,
          "25%": 1.04,
          "75%": 1.28
        },
        "51730": {
          "name": "Petersburg",
          "median": 1.09,
          "10%": 0.88,
          "90%": 1.36,
          "25%": 0.97,
          "75%": 1.23
        },
        "42101": {
          "name": "Philadelphia",
          "median": 1.1,
          "10%": 0.89,
          "90%": 1.39,
          "25%": 0.99,
          "75%": 1.24
        },
        "42103": {
          "name": "Pike",
          "median": 1.14,
          "10%": 0.95,
          "90%": 1.5,
          "25%": 1.05,
          "75%": 1.31
        },
        "51143": {
          "name": "Pittsylvania",
          "median": 1.14,
          "10%": 0.91,
          "90%": 1.4,
          "25%": 1.02,
          "75%": 1.29
        },
        "54073": {
          "name": "Pleasants",
          "median": 1.07,
          "10%": 0.94,
          "90%": 1.31,
          "25%": 1.01,
          "75%": 1.17
        },
        "54075": {
          "name": "Pocahontas",
          "median": 1.09,
          "10%": 0.96,
          "90%": 1.42,
          "25%": 1.0,
          "75%": 1.27
        },
        "51735": {
          "name": "Poquoson",
          "median": 1.11,
          "10%": 0.86,
          "90%": 1.35,
          "25%": 1.0,
          "75%": 1.2325
        },
        "51740": {
          "name": "Portsmouth",
          "median": 1.14,
          "10%": 0.88,
          "90%": 1.51,
          "25%": 0.96,
          "75%": 1.4
        },
        "42105": {
          "name": "Potter",
          "median": 1.16,
          "10%": 0.94,
          "90%": 1.36,
          "25%": 1.02,
          "75%": 1.25
        },
        "51145": {
          "name": "Powhatan",
          "median": 1.13,
          "10%": 0.85,
          "90%": 1.63,
          "25%": 1.0,
          "75%": 1.36
        },
        "54077": {
          "name": "Preston",
          "median": 1.15,
          "10%": 0.95,
          "90%": 1.42,
          "25%": 1.04,
          "75%": 1.26
        },
        "51147": {
          "name": "Prince Edward",
          "median": 1.12,
          "10%": 0.92,
          "90%": 1.42,
          "25%": 1.01,
          "75%": 1.28
        },
        "51149": {
          "name": "Prince George",
          "median": 1.06,
          "10%": 0.88,
          "90%": 1.37,
          "25%": 0.96,
          "75%": 1.22
        },
        "24033": {
          "name": "Prince George's",
          "median": 1.11,
          "10%": 0.93,
          "90%": 1.48,
          "25%": 0.99,
          "75%": 1.2525
        },
        "51153": {
          "name": "Prince William",
          "median": 1.07,
          "10%": 0.91,
          "90%": 1.39,
          "25%": 1.0,
          "75%": 1.21
        },
        "51155": {
          "name": "Pulaski",
          "median": 1.14,
          "10%": 0.97,
          "90%": 1.46,
          "25%": 1.07,
          "75%": 1.29
        },
        "54079": {
          "name": "Putnam",
          "median": 1.09,
          "10%": 0.94,
          "90%": 1.27,
          "25%": 1.02,
          "75%": 1.18
        },
        "24035": {
          "name": "Queen Anne's",
          "median": 1.085,
          "10%": 0.84,
          "90%": 1.4,
          "25%": 0.98,
          "75%": 1.22
        },
        "51750": {
          "name": "Radford",
          "median": 1.19,
          "10%": 0.95,
          "90%": 1.53,
          "25%": 1.06,
          "75%": 1.39
        },
        "54081": {
          "name": "Raleigh",
          "median": 1.095,
          "10%": 0.88,
          "90%": 1.49,
          "25%": 0.97,
          "75%": 1.3
        },
        "54083": {
          "name": "Randolph",
          "median": 1.14,
          "10%": 0.95,
          "90%": 1.41,
          "25%": 1.02,
          "75%": 1.24
        },
        "51157": {
          "name": "Rappahannock",
          "median": 1.1,
          "10%": 0.88,
          "90%": 1.34,
          "25%": 0.97,
          "75%": 1.21
        },
        "36085": {
          "name": "Richmond",
          "median": 1.04,
          "10%": 0.79,
          "90%": 1.33,
          "25%": 0.9,
          "75%": 1.18
        },
        "51159": {
          "name": "Richmond",
          "median": 1.02,
          "10%": 0.749,
          "90%": 1.29,
          "25%": 0.89,
          "75%": 1.1
        },
        "51760": {
          "name": "Richmond",
          "median": 1.15,
          "10%": 0.93,
          "90%": 1.42,
          "25%": 1.01,
          "75%": 1.31
        },
        "54085": {
          "name": "Ritchie",
          "median": 1.13,
          "10%": 0.99,
          "90%": 1.37,
          "25%": 1.06,
          "75%": 1.24
        },
        "54087": {
          "name": "Roane",
          "median": 1.09,
          "10%": 0.94,
          "90%": 1.37,
          "25%": 1.01,
          "75%": 1.25
        },
        "51161": {
          "name": "Roanoke",
          "median": 1.21,
          "10%": 0.95,
          "90%": 1.54,
          "25%": 1.03,
          "75%": 1.43
        },
        "51770": {
          "name": "Roanoke",
          "median": 1.26,
          "10%": 0.89,
          "90%": 1.63,
          "25%": 1.01,
          "75%": 1.43
        },
        "51163": {
          "name": "Rockbridge",
          "median": 1.16,
          "10%": 0.91,
          "90%": 1.38,
          "25%": 1.06,
          "75%": 1.29
        },
        "51165": {
          "name": "Rockingham",
          "median": 1.13,
          "10%": 0.9,
          "90%": 1.4,
          "25%": 0.98,
          "75%": 1.26
        },
        "51167": {
          "name": "Russell",
          "median": 1.08,
          "10%": 0.95,
          "90%": 1.27,
          "25%": 1.01,
          "75%": 1.19
        },
        "34033": {
          "name": "Salem",
          "median": 1.11,
          "10%": 0.91,
          "90%": 1.38,
          "25%": 1.01,
          "75%": 1.26
        },
        "51775": {
          "name": "Salem",
          "median": 1.2,
          "10%": 0.88,
          "90%": 1.651,
          "25%": 1.04,
          "75%": 1.44
        },
        "36095": {
          "name": "Schoharie",
          "median": 1.11,
          "10%": 0.93,
          "90%": 1.35,
          "25%": 1.02,
          "75%": 1.21
        },
        "36097": {
          "name": "Schuyler",
          "median": 1.11,
          "10%": 0.92,
          "90%": 1.42,
          "25%": 1.03,
          "75%": 1.28
        },
        "42107": {
          "name": "Schuylkill",
          "median": 1.26,
          "10%": 0.91,
          "90%": 1.6,
          "25%": 1.03,
          "75%": 1.41
        },
        "51169": {
          "name": "Scott",
          "median": 1.14,
          "10%": 0.93,
          "90%": 1.27,
          "25%": 1.04,
          "75%": 1.22
        },
        "51171": {
          "name": "Shenandoah",
          "median": 1.13,
          "10%": 0.92,
          "90%": 1.3,
          "25%": 1.02,
          "75%": 1.22
        },
        "51173": {
          "name": "Smyth",
          "median": 1.13,
          "10%": 0.98,
          "90%": 1.31,
          "25%": 1.05,
          "75%": 1.21
        },
        "42109": {
          "name": "Snyder",
          "median": 1.21,
          "10%": 0.99,
          "90%": 1.65,
          "25%": 1.11,
          "75%": 1.39
        },
        "24039": {
          "name": "Somerset",
          "median": 1.035,
          "10%": 0.86,
          "90%": 1.34,
          "25%": 0.95,
          "75%": 1.2
        },
        "42111": {
          "name": "Somerset",
          "median": 1.13,
          "10%": 0.98,
          "90%": 1.36,
          "25%": 1.02,
          "75%": 1.24
        },
        "51175": {
          "name": "Southampton",
          "median": 1.15,
          "10%": 0.96,
          "90%": 1.37,
          "25%": 1.02,
          "75%": 1.24
        },
        "51177": {
          "name": "Spotsylvania",
          "median": 1.06,
          "10%": 0.88,
          "90%": 1.31,
          "25%": 0.96,
          "75%": 1.23
        },
        "24037": {
          "name": "St. Mary's",
          "median": 1.04,
          "10%": 0.76,
          "90%": 1.31,
          "25%": 0.9,
          "75%": 1.17
        },
        "51179": {
          "name": "Stafford",
          "median": 1.1,
          "10%": 0.87,
          "90%": 1.37,
          "25%": 0.96,
          "75%": 1.26
        },
        "51790": {
          "name": "Staunton",
          "median": 1.13,
          "10%": 0.86,
          "90%": 1.39,
          "25%": 0.94,
          "75%": 1.3
        },
        "36101": {
          "name": "Steuben",
          "median": 1.09,
          "10%": 0.95,
          "90%": 1.32,
          "25%": 1.02,
          "75%": 1.21
        },
        "51800": {
          "name": "Suffolk",
          "median": 1.15,
          "10%": 0.9,
          "90%": 1.45,
          "25%": 1.05,
          "75%": 1.33
        },
        "36105": {
          "name": "Sullivan",
          "median": 1.2,
          "10%": 1.01,
          "90%": 1.43,
          "25%": 1.06,
          "75%": 1.34
        },
        "42113": {
          "name": "Sullivan",
          "median": 1.2,
          "10%": 0.9,
          "90%": 1.54,
          "25%": 1.0675,
          "75%": 1.33
        },
        "54089": {
          "name": "Summers",
          "median": 1.14,
          "10%": 0.91,
          "90%": 1.36,
          "25%": 1.0,
          "75%": 1.26
        },
        "51181": {
          "name": "Surry",
          "median": 1.08,
          "10%": 0.9,
          "90%": 1.37,
          "25%": 0.95,
          "75%": 1.23
        },
        "42115": {
          "name": "Susquehanna",
          "median": 1.18,
          "10%": 1.01,
          "90%": 1.43,
          "25%": 1.07,
          "75%": 1.29
        },
        "10005": {
          "name": "Sussex",
          "median": 1.06,
          "10%": 0.86,
          "90%": 1.29,
          "25%": 0.95,
          "75%": 1.19
        },
        "34037": {
          "name": "Sussex",
          "median": 1.18,
          "10%": 0.91,
          "90%": 1.49,
          "25%": 1.0475,
          "75%": 1.36
        },
        "51183": {
          "name": "Sussex",
          "median": 1.1,
          "10%": 0.88,
          "90%": 1.391,
          "25%": 0.98,
          "75%": 1.23
        },
        "24041": {
          "name": "Talbot",
          "median": 1.09,
          "10%": 0.83,
          "90%": 1.41,
          "25%": 0.95,
          "75%": 1.24
        },
        "54091": {
          "name": "Taylor",
          "median": 1.11,
          "10%": 0.92,
          "90%": 1.41,
          "25%": 1.04,
          "75%": 1.28
        },
        "51185": {
          "name": "Tazewell",
          "median": 1.11,
          "10%": 0.99,
          "90%": 1.38,
          "25%": 1.04,
          "75%": 1.2
        },
        "36107": {
          "name": "Tioga",
          "median": 1.17,
          "10%": 0.98,
          "90%": 1.46,
          "25%": 1.05,
          "75%": 1.3
        },
        "42117": {
          "name": "Tioga",
          "median": 1.18,
          "10%": 0.93,
          "90%": 1.45,
          "25%": 1.06,
          "75%": 1.32
        },
        "36109": {
          "name": "Tompkins",
          "median": 1.16,
          "10%": 0.97,
          "90%": 1.39,
          "25%": 1.06,
          "75%": 1.26
        },
        "54093": {
          "name": "Tucker",
          "median": 1.15,
          "10%": 0.9,
          "90%": 1.37,
          "25%": 1.03,
          "75%": 1.25
        },
        "54095": {
          "name": "Tyler",
          "median": 1.08,
          "10%": 0.96,
          "90%": 1.34,
          "25%": 0.99,
          "75%": 1.18
        },
        "36111": {
          "name": "Ulster",
          "median": 1.18,
          "10%": 1.01,
          "90%": 1.4,
          "25%": 1.08,
          "75%": 1.34
        },
        "42119": {
          "name": "Union",
          "median": 1.19,
          "10%": 1.03,
          "90%": 1.54,
          "25%": 1.1,
          "75%": 1.3
        },
        "54097": {
          "name": "Upshur",
          "median": 1.12,
          "10%": 0.94,
          "90%": 1.51,
          "25%": 0.99,
          "75%": 1.27
        },
        "42121": {
          "name": "Venango",
          "median": 1.15,
          "10%": 0.95,
          "90%": 1.38,
          "25%": 1.04,
          "75%": 1.27
        },
        "51810": {
          "name": "Virginia Beach",
          "median": 1.13,
          "10%": 0.91,
          "90%": 1.52,
          "25%": 1.0,
          "75%": 1.32
        },
        "34041": {
          "name": "Warren",
          "median": 1.16,
          "10%": 0.92,
          "90%": 1.4,
          "25%": 1.01,
          "75%": 1.27
        },
        "42123": {
          "name": "Warren",
          "median": 1.16,
          "10%": 0.94,
          "90%": 1.44,
          "25%": 1.04,
          "75%": 1.26
        },
        "51187": {
          "name": "Warren",
          "median": 1.09,
          "10%": 0.9,
          "90%": 1.31,
          "25%": 0.99,
          "75%": 1.2
        },
        "24043": {
          "name": "Washington",
          "median": 1.13,
          "10%": 0.93,
          "90%": 1.32,
          "25%": 1.03,
          "75%": 1.21
        },
        "42125": {
          "name": "Washington",
          "median": 1.15,
          "10%": 0.96,
          "90%": 1.39,
          "25%": 1.04,
          "75%": 1.27
        },
        "51191": {
          "name": "Washington",
          "median": 1.11,
          "10%": 0.94,
          "90%": 1.27,
          "25%": 1.01,
          "75%": 1.18
        },
        "42127": {
          "name": "Wayne",
          "median": 1.17,
          "10%": 0.97,
          "90%": 1.49,
          "25%": 1.05,
          "75%": 1.33
        },
        "54099": {
          "name": "Wayne",
          "median": 1.17,
          "10%": 0.94,
          "90%": 1.38,
          "25%": 1.04,
          "75%": 1.26
        },
        "51820": {
          "name": "Waynesboro",
          "median": 1.14,
          "10%": 0.87,
          "90%": 1.38,
          "25%": 1.02,
          "75%": 1.28
        },
        "54101": {
          "name": "Webster",
          "median": 1.09,
          "10%": 0.93,
          "90%": 1.37,
          "25%": 0.99,
          "75%": 1.2
        },
        "36119": {
          "name": "Westchester",
          "median": 1.11,
          "10%": 0.85,
          "90%": 1.32,
          "25%": 0.98,
          "75%": 1.22
        },
        "42129": {
          "name": "Westmoreland",
          "median": 1.11,
          "10%": 0.93,
          "90%": 1.41,
          "25%": 1.01,
          "75%": 1.26
        },
        "51193": {
          "name": "Westmoreland",
          "median": 0.98,
          "10%": 0.75,
          "90%": 1.29,
          "25%": 0.9,
          "75%": 1.13
        },
        "54103": {
          "name": "Wetzel",
          "median": 1.11,
          "10%": 1.0,
          "90%": 1.4,
          "25%": 1.05,
          "75%": 1.22
        },
        "24045": {
          "name": "Wicomico",
          "median": 1.05,
          "10%": 0.84,
          "90%": 1.31,
          "25%": 0.97,
          "75%": 1.1625
        },
        "51830": {
          "name": "Williamsburg",
          "median": 1.04,
          "10%": 0.75,
          "90%": 1.34,
          "25%": 0.87,
          "75%": 1.19
        },
        "51840": {
          "name": "Winchester",
          "median": 1.12,
          "10%": 0.86,
          "90%": 1.34,
          "25%": 1.0,
          "75%": 1.23
        },
        "54105": {
          "name": "Wirt",
          "median": 1.17,
          "10%": 0.96,
          "90%": 1.41,
          "25%": 1.05,
          "75%": 1.3
        },
        "51195": {
          "name": "Wise",
          "median": 1.13,
          "10%": 0.93,
          "90%": 1.32,
          "25%": 1.03,
          "75%": 1.23
        },
        "54107": {
          "name": "Wood",
          "median": 1.14,
          "10%": 0.96,
          "90%": 1.4,
          "25%": 1.04,
          "75%": 1.26
        },
        "24047": {
          "name": "Worcester",
          "median": 1.06,
          "10%": 0.84,
          "90%": 1.37,
          "25%": 0.96,
          "75%": 1.18
        },
        "42131": {
          "name": "Wyoming",
          "median": 1.2,
          "10%": 0.99,
          "90%": 1.5,
          "25%": 1.09,
          "75%": 1.34
        },
        "54109": {
          "name": "Wyoming",
          "median": 1.11,
          "10%": 0.98,
          "90%": 1.4,
          "25%": 1.02,
          "75%": 1.26
        },
        "51197": {
          "name": "Wythe",
          "median": 1.09,
          "10%": 0.93,
          "90%": 1.34,
          "25%": 1.0,
          "75%": 1.23
        },
        "36123": {
          "name": "Yates",
          "median": 1.17,
          "10%": 0.93,
          "90%": 1.49,
          "25%": 1.05,
          "75%": 1.29
        },
        "42133": {
          "name": "York",
          "median": 1.14,
          "10%": 0.95,
          "90%": 1.52,
          "25%": 1.01,
          "75%": 1.31
        },
        "51199": {
          "name": "York",
          "median": 1.08,
          "10%": 0.85,
          "90%": 1.29,
          "25%": 0.92,
          "75%": 1.21
        },
        "max": 1.26,
        "min": 0.98
      }
    }
  },
  "8.5": {
    "2020-2070": {
      "2": {
        "51001": {
          "name": "Accomack",
          "median": 1.12,
          "10%": 1.01,
          "90%": 1.2,
          "25%": 1.06,
          "75%": 1.16
        },
        "42001": {
          "name": "Adams",
          "median": 1.12,
          "10%": 1.04,
          "90%": 1.24,
          "25%": 1.08,
          "75%": 1.18
        },
        "51003": {
          "name": "Albemarle",
          "median": 1.12,
          "10%": 1.05,
          "90%": 1.25,
          "25%": 1.0775,
          "75%": 1.19
        },
        "51510": {
          "name": "Alexandria",
          "median": 1.08,
          "10%": 1.0,
          "90%": 1.17,
          "25%": 1.04,
          "75%": 1.11
        },
        "24001": {
          "name": "Allegany",
          "median": 1.11,
          "10%": 1.07,
          "90%": 1.2,
          "25%": 1.08,
          "75%": 1.14
        },
        "36003": {
          "name": "Allegany",
          "median": 1.12,
          "10%": 1.03,
          "90%": 1.2,
          "25%": 1.08,
          "75%": 1.16
        },
        "51005": {
          "name": "Alleghany",
          "median": 1.11,
          "10%": 1.03,
          "90%": 1.21,
          "25%": 1.06,
          "75%": 1.16
        },
        "42003": {
          "name": "Allegheny",
          "median": 1.11,
          "10%": 1.02,
          "90%": 1.18,
          "25%": 1.05,
          "75%": 1.15
        },
        "51007": {
          "name": "Amelia",
          "median": 1.09,
          "10%": 1.0,
          "90%": 1.21,
          "25%": 1.04,
          "75%": 1.15
        },
        "51009": {
          "name": "Amherst",
          "median": 1.12,
          "10%": 1.04,
          "90%": 1.26,
          "25%": 1.07,
          "75%": 1.19
        },
        "24003": {
          "name": "Anne Arundel",
          "median": 1.08,
          "10%": 1.03,
          "90%": 1.17,
          "25%": 1.05,
          "75%": 1.11
        },
        "51011": {
          "name": "Appomattox",
          "median": 1.14,
          "10%": 1.04,
          "90%": 1.28,
          "25%": 1.06,
          "75%": 1.19
        },
        "51013": {
          "name": "Arlington",
          "median": 1.07,
          "10%": 0.99,
          "90%": 1.16,
          "25%": 1.05,
          "75%": 1.12
        },
        "42005": {
          "name": "Armstrong",
          "median": 1.09,
          "10%": 1.01,
          "90%": 1.17,
          "25%": 1.07,
          "75%": 1.15
        },
        "34001": {
          "name": "Atlantic",
          "median": 1.12,
          "10%": 1.04,
          "90%": 1.21,
          "25%": 1.07,
          "75%": 1.16
        },
        "51015": {
          "name": "Augusta",
          "median": 1.12,
          "10%": 1.05,
          "90%": 1.25,
          "25%": 1.08,
          "75%": 1.19
        },
        "24005": {
          "name": "Baltimore",
          "median": 1.09,
          "10%": 1.03,
          "90%": 1.19,
          "25%": 1.05,
          "75%": 1.13
        },
        "24510": {
          "name": "Baltimore",
          "median": 1.11,
          "10%": 1.02,
          "90%": 1.18,
          "25%": 1.05,
          "75%": 1.14
        },
        "54001": {
          "name": "Barbour",
          "median": 1.07,
          "10%": 1.02,
          "90%": 1.16,
          "25%": 1.04,
          "75%": 1.1
        },
        "51017": {
          "name": "Bath",
          "median": 1.12,
          "10%": 1.06,
          "90%": 1.21,
          "25%": 1.08,
          "75%": 1.18
        },
        "42007": {
          "name": "Beaver",
          "median": 1.11,
          "10%": 1.04,
          "90%": 1.18,
          "25%": 1.06,
          "75%": 1.14
        },
        "42009": {
          "name": "Bedford",
          "median": 1.12,
          "10%": 1.05,
          "90%": 1.2,
          "25%": 1.09,
          "75%": 1.16
        },
        "51019": {
          "name": "Bedford",
          "median": 1.13,
          "10%": 1.03,
          "90%": 1.24,
          "25%": 1.06,
          "75%": 1.19
        },
        "54003": {
          "name": "Berkeley",
          "median": 1.13,
          "10%": 1.05,
          "90%": 1.24,
          "25%": 1.1,
          "75%": 1.17
        },
        "42011": {
          "name": "Berks",
          "median": 1.13,
          "10%": 1.03,
          "90%": 1.211,
          "25%": 1.06,
          "75%": 1.17
        },
        "42013": {
          "name": "Blair",
          "median": 1.13,
          "10%": 1.04,
          "90%": 1.19,
          "25%": 1.1,
          "75%": 1.15
        },
        "51021": {
          "name": "Bland",
          "median": 1.1,
          "10%": 1.03,
          "90%": 1.17,
          "25%": 1.05,
          "75%": 1.12
        },
        "54005": {
          "name": "Boone",
          "median": 1.1,
          "10%": 1.04,
          "90%": 1.16,
          "25%": 1.06,
          "75%": 1.13
        },
        "51023": {
          "name": "Botetourt",
          "median": 1.12,
          "10%": 1.04,
          "90%": 1.22,
          "25%": 1.07,
          "75%": 1.19
        },
        "42015": {
          "name": "Bradford",
          "median": 1.08,
          "10%": 1.03,
          "90%": 1.18,
          "25%": 1.05,
          "75%": 1.12
        },
        "54007": {
          "name": "Braxton",
          "median": 1.08,
          "10%": 1.03,
          "90%": 1.17,
          "25%": 1.05,
          "75%": 1.14
        },
        "51520": {
          "name": "Bristol",
          "median": 1.1,
          "10%": 1.04,
          "90%": 1.19,
          "25%": 1.07,
          "75%": 1.15
        },
        "36005": {
          "name": "Bronx",
          "median": 1.12,
          "10%": 1.01,
          "90%": 1.23,
          "25%": 1.07,
          "75%": 1.19
        },
        "54009": {
          "name": "Brooke",
          "median": 1.12,
          "10%": 1.029,
          "90%": 1.19,
          "25%": 1.07,
          "75%": 1.15
        },
        "36007": {
          "name": "Broome",
          "median": 1.1,
          "10%": 1.03,
          "90%": 1.19,
          "25%": 1.06,
          "75%": 1.14
        },
        "51025": {
          "name": "Brunswick",
          "median": 1.08,
          "10%": 1.01,
          "90%": 1.21,
          "25%": 1.05,
          "75%": 1.13
        },
        "51027": {
          "name": "Buchanan",
          "median": 1.1,
          "10%": 1.04,
          "90%": 1.18,
          "25%": 1.06,
          "75%": 1.15
        },
        "51029": {
          "name": "Buckingham",
          "median": 1.11,
          "10%": 1.02,
          "90%": 1.24,
          "25%": 1.06,
          "75%": 1.16
        },
        "42017": {
          "name": "Bucks",
          "median": 1.1,
          "10%": 1.02,
          "90%": 1.18,
          "25%": 1.06,
          "75%": 1.15
        },
        "51530": {
          "name": "Buena Vista",
          "median": 1.12,
          "10%": 1.04,
          "90%": 1.3,
          "25%": 1.07,
          "75%": 1.21
        },
        "34005": {
          "name": "Burlington",
          "median": 1.1,
          "10%": 1.02,
          "90%": 1.19,
          "25%": 1.05,
          "75%": 1.14
        },
        "42019": {
          "name": "Butler",
          "median": 1.11,
          "10%": 1.01,
          "90%": 1.19,
          "25%": 1.07,
          "75%": 1.14
        },
        "54011": {
          "name": "Cabell",
          "median": 1.11,
          "10%": 1.01,
          "90%": 1.16,
          "25%": 1.05,
          "75%": 1.14
        },
        "54013": {
          "name": "Calhoun",
          "median": 1.13,
          "10%": 1.04,
          "90%": 1.18,
          "25%": 1.09,
          "75%": 1.16
        },
        "24009": {
          "name": "Calvert",
          "median": 1.08,
          "10%": 1.01,
          "90%": 1.17,
          "25%": 1.05,
          "75%": 1.14
        },
        "42021": {
          "name": "Cambria",
          "median": 1.07,
          "10%": 1.01,
          "90%": 1.15,
          "25%": 1.05,
          "75%": 1.12
        },
        "34007": {
          "name": "Camden",
          "median": 1.1,
          "10%": 1.04,
          "90%": 1.19,
          "25%": 1.05,
          "75%": 1.15
        },
        "42023": {
          "name": "Cameron",
          "median": 1.1,
          "10%": 1.01,
          "90%": 1.19,
          "25%": 1.07,
          "75%": 1.15
        },
        "51031": {
          "name": "Campbell",
          "median": 1.14,
          "10%": 1.03,
          "90%": 1.26,
          "25%": 1.07,
          "75%": 1.19
        },
        "34009": {
          "name": "Cape May",
          "median": 1.09,
          "10%": 1.01,
          "90%": 1.19,
          "25%": 1.06,
          "75%": 1.15
        },
        "42025": {
          "name": "Carbon",
          "median": 1.11,
          "10%": 1.01,
          "90%": 1.18,
          "25%": 1.06,
          "75%": 1.15
        },
        "24011": {
          "name": "Caroline",
          "median": 1.09,
          "10%": 1.03,
          "90%": 1.19,
          "25%": 1.05,
          "75%": 1.16
        },
        "51033": {
          "name": "Caroline",
          "median": 1.08,
          "10%": 1.02,
          "90%": 1.19,
          "25%": 1.05,
          "75%": 1.14
        },
        "24013": {
          "name": "Carroll",
          "median": 1.13,
          "10%": 1.03,
          "90%": 1.26,
          "25%": 1.08,
          "75%": 1.17
        },
        "51035": {
          "name": "Carroll",
          "median": 1.12,
          "10%": 1.03,
          "90%": 1.24,
          "25%": 1.09,
          "75%": 1.17
        },
        "24015": {
          "name": "Cecil",
          "median": 1.13,
          "10%": 1.04,
          "90%": 1.2,
          "25%": 1.07,
          "75%": 1.18
        },
        "42027": {
          "name": "Centre",
          "median": 1.12,
          "10%": 1.03,
          "90%": 1.181,
          "25%": 1.08,
          "75%": 1.16
        },
        "24017": {
          "name": "Charles",
          "median": 1.09,
          "10%": 1.02,
          "90%": 1.17,
          "25%": 1.05,
          "75%": 1.12
        },
        "51036": {
          "name": "Charles City",
          "median": 1.08,
          "10%": 1.0,
          "90%": 1.19,
          "25%": 1.03,
          "75%": 1.13
        },
        "51037": {
          "name": "Charlotte",
          "median": 1.11,
          "10%": 1.03,
          "90%": 1.2,
          "25%": 1.07,
          "75%": 1.16
        },
        "51540": {
          "name": "Charlottesville",
          "median": 1.11,
          "10%": 1.02,
          "90%": 1.25,
          "25%": 1.07,
          "75%": 1.18
        },
        "36015": {
          "name": "Chemung",
          "median": 1.09,
          "10%": 1.02,
          "90%": 1.19,
          "25%": 1.07,
          "75%": 1.13
        },
        "36017": {
          "name": "Chenango",
          "median": 1.09,
          "10%": 1.03,
          "90%": 1.18,
          "25%": 1.06,
          "75%": 1.14
        },
        "51550": {
          "name": "Chesapeake",
          "median": 1.11,
          "10%": 0.98,
          "90%": 1.19,
          "25%": 1.04,
          "75%": 1.15
        },
        "42029": {
          "name": "Chester",
          "median": 1.11,
          "10%": 1.02,
          "90%": 1.21,
          "25%": 1.06,
          "75%": 1.1625
        },
        "51041": {
          "name": "Chesterfield",
          "median": 1.1,
          "10%": 1.0,
          "90%": 1.19,
          "25%": 1.04,
          "75%": 1.14
        },
        "42031": {
          "name": "Clarion",
          "median": 1.11,
          "10%": 1.05,
          "90%": 1.19,
          "25%": 1.07,
          "75%": 1.13
        },
        "51043": {
          "name": "Clarke",
          "median": 1.15,
          "10%": 1.04,
          "90%": 1.27,
          "25%": 1.1,
          "75%": 1.22
        },
        "54015": {
          "name": "Clay",
          "median": 1.08,
          "10%": 1.01,
          "90%": 1.14,
          "25%": 1.05,
          "75%": 1.12
        },
        "42033": {
          "name": "Clearfield",
          "median": 1.12,
          "10%": 1.04,
          "90%": 1.17,
          "25%": 1.08,
          "75%": 1.14
        },
        "42035": {
          "name": "Clinton",
          "median": 1.12,
          "10%": 1.04,
          "90%": 1.18,
          "25%": 1.06,
          "75%": 1.16
        },
        "51570": {
          "name": "Colonial Heights",
          "median": 1.09,
          "10%": 0.96,
          "90%": 1.18,
          "25%": 1.03,
          "75%": 1.15
        },
        "42037": {
          "name": "Columbia",
          "median": 1.12,
          "10%": 1.02,
          "90%": 1.18,
          "25%": 1.09,
          "75%": 1.15
        },
        "36023": {
          "name": "Cortland",
          "median": 1.09,
          "10%": 1.04,
          "90%": 1.2,
          "25%": 1.07,
          "75%": 1.14
        },
        "51580": {
          "name": "Covington",
          "median": 1.1,
          "10%": 1.0,
          "90%": 1.21,
          "25%": 1.07,
          "75%": 1.16
        },
        "51045": {
          "name": "Craig",
          "median": 1.12,
          "10%": 1.04,
          "90%": 1.24,
          "25%": 1.08,
          "75%": 1.16
        },
        "42039": {
          "name": "Crawford",
          "median": 1.11,
          "10%": 1.01,
          "90%": 1.2,
          "25%": 1.06,
          "75%": 1.16
        },
        "51047": {
          "name": "Culpeper",
          "median": 1.14,
          "10%": 1.03,
          "90%": 1.21,
          "25%": 1.09,
          "75%": 1.16
        },
        "34011": {
          "name": "Cumberland",
          "median": 1.1,
          "10%": 1.03,
          "90%": 1.19,
          "25%": 1.06,
          "75%": 1.15
        },
        "42041": {
          "name": "Cumberland",
          "median": 1.14,
          "10%": 1.06,
          "90%": 1.24,
          "25%": 1.09,
          "75%": 1.18
        },
        "51049": {
          "name": "Cumberland",
          "median": 1.09,
          "10%": 1.02,
          "90%": 1.23,
          "25%": 1.04,
          "75%": 1.16
        },
        "51590": {
          "name": "Danville",
          "median": 1.12,
          "10%": 1.02,
          "90%": 1.24,
          "25%": 1.07,
          "75%": 1.17
        },
        "42043": {
          "name": "Dauphin",
          "median": 1.13,
          "10%": 1.05,
          "90%": 1.23,
          "25%": 1.09,
          "75%": 1.18
        },
        "36025": {
          "name": "Delaware",
          "median": 1.12,
          "10%": 1.04,
          "90%": 1.18,
          "25%": 1.07,
          "75%": 1.16
        },
        "42045": {
          "name": "Delaware",
          "median": 1.11,
          "10%": 1.04,
          "90%": 1.21,
          "25%": 1.06,
          "75%": 1.17
        },
        "51051": {
          "name": "Dickenson",
          "median": 1.1,
          "10%": 1.04,
          "90%": 1.18,
          "25%": 1.06,
          "75%": 1.13
        },
        "51053": {
          "name": "Dinwiddie",
          "median": 1.09,
          "10%": 1.01,
          "90%": 1.21,
          "25%": 1.04,
          "75%": 1.14
        },
        "11001": {
          "name": "District of Columbia",
          "median": 1.07,
          "10%": 0.98,
          "90%": 1.19,
          "25%": 1.05,
          "75%": 1.15
        },
        "54017": {
          "name": "Doddridge",
          "median": 1.06,
          "10%": 1.02,
          "90%": 1.15,
          "25%": 1.03,
          "75%": 1.1
        },
        "24019": {
          "name": "Dorchester",
          "median": 1.08,
          "10%": 1.0,
          "90%": 1.19,
          "25%": 1.04,
          "75%": 1.13
        },
        "42047": {
          "name": "Elk",
          "median": 1.11,
          "10%": 0.99,
          "90%": 1.19,
          "25%": 1.06,
          "75%": 1.16
        },
        "51595": {
          "name": "Emporia",
          "median": 1.06,
          "10%": 0.99,
          "90%": 1.14,
          "25%": 1.02,
          "75%": 1.11
        },
        "42049": {
          "name": "Erie",
          "median": 1.12,
          "10%": 1.01,
          "90%": 1.2,
          "25%": 1.05,
          "75%": 1.16
        },
        "51057": {
          "name": "Essex",
          "median": 1.09,
          "10%": 0.98,
          "90%": 1.2,
          "25%": 1.04,
          "75%": 1.14
        },
        "51059": {
          "name": "Fairfax",
          "median": 1.08,
          "10%": 1.0,
          "90%": 1.17,
          "25%": 1.04,
          "75%": 1.1
        },
        "51600": {
          "name": "Fairfax",
          "median": 1.06,
          "10%": 0.98,
          "90%": 1.18,
          "25%": 1.04,
          "75%": 1.11
        },
        "51610": {
          "name": "Falls Church",
          "median": 1.07,
          "10%": 1.0,
          "90%": 1.18,
          "25%": 1.04,
          "75%": 1.12
        },
        "51061": {
          "name": "Fauquier",
          "median": 1.13,
          "10%": 1.04,
          "90%": 1.21,
          "25%": 1.07,
          "75%": 1.17
        },
        "42051": {
          "name": "Fayette",
          "median": 1.08,
          "10%": 1.01,
          "90%": 1.14,
          "25%": 1.05,
          "75%": 1.13
        },
        "54019": {
          "name": "Fayette",
          "median": 1.09,
          "10%": 1.03,
          "90%": 1.16,
          "25%": 1.05,
          "75%": 1.12
        },
        "51063": {
          "name": "Floyd",
          "median": 1.13,
          "10%": 1.02,
          "90%": 1.24,
          "25%": 1.08,
          "75%": 1.21
        },
        "51065": {
          "name": "Fluvanna",
          "median": 1.11,
          "10%": 1.03,
          "90%": 1.25,
          "25%": 1.06,
          "75%": 1.16
        },
        "42053": {
          "name": "Forest",
          "median": 1.11,
          "10%": 1.04,
          "90%": 1.2,
          "25%": 1.07,
          "75%": 1.17
        },
        "42055": {
          "name": "Franklin",
          "median": 1.12,
          "10%": 1.05,
          "90%": 1.21,
          "25%": 1.08,
          "75%": 1.16
        },
        "51067": {
          "name": "Franklin",
          "median": 1.13,
          "10%": 1.0,
          "90%": 1.26,
          "25%": 1.06,
          "75%": 1.19
        },
        "51620": {
          "name": "Franklin",
          "median": 1.11,
          "10%": 1.01,
          "90%": 1.21,
          "25%": 1.05,
          "75%": 1.15
        },
        "24021": {
          "name": "Frederick",
          "median": 1.12,
          "10%": 1.04,
          "90%": 1.24,
          "25%": 1.08,
          "75%": 1.18
        },
        "51069": {
          "name": "Frederick",
          "median": 1.14,
          "10%": 1.05,
          "90%": 1.24,
          "25%": 1.09,
          "75%": 1.19
        },
        "51630": {
          "name": "Fredericksburg",
          "median": 1.09,
          "10%": 1.0,
          "90%": 1.19,
          "25%": 1.04,
          "75%": 1.15
        },
        "42057": {
          "name": "Fulton",
          "median": 1.14,
          "10%": 1.04,
          "90%": 1.23,
          "25%": 1.11,
          "75%": 1.18
        },
        "51640": {
          "name": "Galax",
          "median": 1.13,
          "10%": 1.01,
          "90%": 1.23,
          "25%": 1.07,
          "75%": 1.18
        },
        "24023": {
          "name": "Garrett",
          "median": 1.08,
          "10%": 1.03,
          "90%": 1.17,
          "25%": 1.05,
          "75%": 1.12
        },
        "51071": {
          "name": "Giles",
          "median": 1.11,
          "10%": 1.04,
          "90%": 1.22,
          "25%": 1.07,
          "75%": 1.15
        },
        "54021": {
          "name": "Gilmer",
          "median": 1.12,
          "10%": 1.03,
          "90%": 1.18,
          "25%": 1.07,
          "75%": 1.15
        },
        "34015": {
          "name": "Gloucester",
          "median": 1.12,
          "10%": 1.04,
          "90%": 1.21,
          "25%": 1.06,
          "75%": 1.17
        },
        "51073": {
          "name": "Gloucester",
          "median": 1.09,
          "10%": 1.03,
          "90%": 1.18,
          "25%": 1.04,
          "75%": 1.13
        },
        "51075": {
          "name": "Goochland",
          "median": 1.09,
          "10%": 1.01,
          "90%": 1.23,
          "25%": 1.05,
          "75%": 1.16
        },
        "54023": {
          "name": "Grant",
          "median": 1.08,
          "10%": 1.01,
          "90%": 1.19,
          "25%": 1.04,
          "75%": 1.14
        },
        "51077": {
          "name": "Grayson",
          "median": 1.11,
          "10%": 1.04,
          "90%": 1.21,
          "25%": 1.09,
          "75%": 1.16
        },
        "54025": {
          "name": "Greenbrier",
          "median": 1.12,
          "10%": 1.05,
          "90%": 1.18,
          "25%": 1.06,
          "75%": 1.13
        },
        "36039": {
          "name": "Greene",
          "median": 1.15,
          "10%": 1.03,
          "90%": 1.24,
          "25%": 1.09,
          "75%": 1.21
        },
        "42059": {
          "name": "Greene",
          "median": 1.11,
          "10%": 1.05,
          "90%": 1.21,
          "25%": 1.07,
          "75%": 1.15
        },
        "51079": {
          "name": "Greene",
          "median": 1.12,
          "10%": 1.03,
          "90%": 1.23,
          "25%": 1.07,
          "75%": 1.19
        },
        "51081": {
          "name": "Greensville",
          "median": 1.07,
          "10%": 1.0,
          "90%": 1.16,
          "25%": 1.04,
          "75%": 1.13
        },
        "51083": {
          "name": "Halifax",
          "median": 1.13,
          "10%": 1.0,
          "90%": 1.22,
          "25%": 1.07,
          "75%": 1.16
        },
        "54027": {
          "name": "Hampshire",
          "median": 1.11,
          "10%": 1.04,
          "90%": 1.2,
          "25%": 1.07,
          "75%": 1.16
        },
        "51650": {
          "name": "Hampton",
          "median": 1.09,
          "10%": 0.98,
          "90%": 1.2,
          "25%": 1.05,
          "75%": 1.15
        },
        "54029": {
          "name": "Hancock",
          "median": 1.13,
          "10%": 1.05,
          "90%": 1.23,
          "25%": 1.08,
          "75%": 1.16
        },
        "51085": {
          "name": "Hanover",
          "median": 1.09,
          "10%": 1.02,
          "90%": 1.17,
          "25%": 1.05,
          "75%": 1.13
        },
        "54031": {
          "name": "Hardy",
          "median": 1.11,
          "10%": 1.04,
          "90%": 1.18,
          "25%": 1.07,
          "75%": 1.16
        },
        "24025": {
          "name": "Harford",
          "median": 1.11,
          "10%": 1.03,
          "90%": 1.2,
          "25%": 1.06,
          "75%": 1.14
        },
        "54033": {
          "name": "Harrison",
          "median": 1.09,
          "10%": 1.03,
          "90%": 1.17,
          "25%": 1.04,
          "75%": 1.12
        },
        "51660": {
          "name": "Harrisonburg",
          "median": 1.09,
          "10%": 1.02,
          "90%": 1.21,
          "25%": 1.05,
          "75%": 1.16
        },
        "51087": {
          "name": "Henrico",
          "median": 1.09,
          "10%": 1.01,
          "90%": 1.16,
          "25%": 1.04,
          "75%": 1.14
        },
        "51089": {
          "name": "Henry",
          "median": 1.12,
          "10%": 1.02,
          "90%": 1.23,
          "25%": 1.06,
          "75%": 1.18
        },
        "36043": {
          "name": "Herkimer",
          "median": 1.05,
          "10%": 0.99,
          "90%": 1.13,
          "25%": 1.02,
          "75%": 1.08
        },
        "51091": {
          "name": "Highland",
          "median": 1.12,
          "10%": 1.04,
          "90%": 1.19,
          "25%": 1.07,
          "75%": 1.17
        },
        "51670": {
          "name": "Hopewell",
          "median": 1.08,
          "10%": 0.94,
          "90%": 1.19,
          "25%": 1.0,
          "75%": 1.15
        },
        "24027": {
          "name": "Howard",
          "median": 1.1,
          "10%": 1.03,
          "90%": 1.2,
          "25%": 1.05,
          "75%": 1.17
        },
        "34019": {
          "name": "Hunterdon",
          "median": 1.1,
          "10%": 1.02,
          "90%": 1.22,
          "25%": 1.06,
          "75%": 1.16
        },
        "42061": {
          "name": "Huntingdon",
          "median": 1.13,
          "10%": 1.06,
          "90%": 1.2,
          "25%": 1.1,
          "75%": 1.16
        },
        "42063": {
          "name": "Indiana",
          "median": 1.08,
          "10%": 1.0,
          "90%": 1.15,
          "25%": 1.05,
          "75%": 1.12
        },
        "51093": {
          "name": "Isle of Wight",
          "median": 1.11,
          "10%": 0.99,
          "90%": 1.2,
          "25%": 1.06,
          "75%": 1.16
        },
        "54035": {
          "name": "Jackson",
          "median": 1.11,
          "10%": 1.03,
          "90%": 1.17,
          "25%": 1.05,
          "75%": 1.15
        },
        "51095": {
          "name": "James City",
          "median": 1.07,
          "10%": 1.01,
          "90%": 1.18,
          "25%": 1.04,
          "75%": 1.14
        },
        "42065": {
          "name": "Jefferson",
          "median": 1.1,
          "10%": 1.02,
          "90%": 1.17,
          "25%": 1.07,
          "75%": 1.14
        },
        "54037": {
          "name": "Jefferson",
          "median": 1.14,
          "10%": 1.03,
          "90%": 1.25,
          "25%": 1.09,
          "75%": 1.18
        },
        "42067": {
          "name": "Juniata",
          "median": 1.12,
          "10%": 1.07,
          "90%": 1.22,
          "25%": 1.1,
          "75%": 1.18
        },
        "54039": {
          "name": "Kanawha",
          "median": 1.08,
          "10%": 0.99,
          "90%": 1.15,
          "25%": 1.04,
          "75%": 1.13
        },
        "10001": {
          "name": "Kent",
          "median": 1.11,
          "10%": 1.03,
          "90%": 1.18,
          "25%": 1.05,
          "75%": 1.14
        },
        "24029": {
          "name": "Kent",
          "median": 1.09,
          "10%": 1.02,
          "90%": 1.18,
          "25%": 1.05,
          "75%": 1.14
        },
        "51099": {
          "name": "King George",
          "median": 1.08,
          "10%": 1.0,
          "90%": 1.2,
          "25%": 1.03,
          "75%": 1.15
        },
        "51101": {
          "name": "King William",
          "median": 1.07,
          "10%": 1.02,
          "90%": 1.16,
          "25%": 1.04,
          "75%": 1.12
        },
        "51097": {
          "name": "King and Queen",
          "median": 1.08,
          "10%": 1.0,
          "90%": 1.18,
          "25%": 1.05,
          "75%": 1.12
        },
        "42069": {
          "name": "Lackawanna",
          "median": 1.12,
          "10%": 1.0,
          "90%": 1.21,
          "25%": 1.06,
          "75%": 1.17
        },
        "42071": {
          "name": "Lancaster",
          "median": 1.11,
          "10%": 1.04,
          "90%": 1.22,
          "25%": 1.06,
          "75%": 1.16
        },
        "51103": {
          "name": "Lancaster",
          "median": 1.1,
          "10%": 1.0,
          "90%": 1.18,
          "25%": 1.04,
          "75%": 1.13
        },
        "42073": {
          "name": "Lawrence",
          "median": 1.1,
          "10%": 1.03,
          "90%": 1.18,
          "25%": 1.06,
          "75%": 1.15
        },
        "42075": {
          "name": "Lebanon",
          "median": 1.1,
          "10%": 1.02,
          "90%": 1.19,
          "25%": 1.06,
          "75%": 1.16
        },
        "51105": {
          "name": "Lee",
          "median": 1.12,
          "10%": 1.04,
          "90%": 1.18,
          "25%": 1.08,
          "75%": 1.15
        },
        "42077": {
          "name": "Lehigh",
          "median": 1.13,
          "10%": 1.01,
          "90%": 1.22,
          "25%": 1.06,
          "75%": 1.17
        },
        "54041": {
          "name": "Lewis",
          "median": 1.08,
          "10%": 1.02,
          "90%": 1.15,
          "25%": 1.05,
          "75%": 1.11
        },
        "51678": {
          "name": "Lexington",
          "median": 1.1,
          "10%": 1.03,
          "90%": 1.24,
          "25%": 1.05,
          "75%": 1.18
        },
        "54043": {
          "name": "Lincoln",
          "median": 1.09,
          "10%": 1.02,
          "90%": 1.16,
          "25%": 1.05,
          "75%": 1.13
        },
        "36051": {
          "name": "Livingston",
          "median": 1.11,
          "10%": 1.01,
          "90%": 1.18,
          "25%": 1.06,
          "75%": 1.15
        },
        "54045": {
          "name": "Logan",
          "median": 1.09,
          "10%": 1.03,
          "90%": 1.16,
          "25%": 1.06,
          "75%": 1.12
        },
        "51107": {
          "name": "Loudoun",
          "median": 1.12,
          "10%": 1.04,
          "90%": 1.2,
          "25%": 1.07,
          "75%": 1.17
        },
        "51109": {
          "name": "Louisa",
          "median": 1.1,
          "10%": 1.03,
          "90%": 1.23,
          "25%": 1.05,
          "75%": 1.16
        },
        "51111": {
          "name": "Lunenburg",
          "median": 1.1,
          "10%": 1.01,
          "90%": 1.23,
          "25%": 1.06,
          "75%": 1.15
        },
        "42079": {
          "name": "Luzerne",
          "median": 1.1,
          "10%": 1.01,
          "90%": 1.18,
          "25%": 1.08,
          "75%": 1.15
        },
        "42081": {
          "name": "Lycoming",
          "median": 1.1,
          "10%": 1.04,
          "90%": 1.17,
          "25%": 1.07,
          "75%": 1.14
        },
        "51680": {
          "name": "Lynchburg",
          "median": 1.1,
          "10%": 1.01,
          "90%": 1.19,
          "25%": 1.07,
          "75%": 1.17
        },
        "36053": {
          "name": "Madison",
          "median": 1.09,
          "10%": 1.01,
          "90%": 1.17,
          "25%": 1.05,
          "75%": 1.13
        },
        "51113": {
          "name": "Madison",
          "median": 1.11,
          "10%": 1.02,
          "90%": 1.22,
          "25%": 1.06,
          "75%": 1.18
        },
        "51683": {
          "name": "Manassas",
          "median": 1.07,
          "10%": 0.98,
          "90%": 1.17,
          "25%": 1.04,
          "75%": 1.11
        },
        "51685": {
          "name": "Manassas Park",
          "median": 1.07,
          "10%": 0.98,
          "90%": 1.18,
          "25%": 1.04,
          "75%": 1.1
        },
        "54049": {
          "name": "Marion",
          "median": 1.08,
          "10%": 1.01,
          "90%": 1.18,
          "25%": 1.04,
          "75%": 1.13
        },
        "54051": {
          "name": "Marshall",
          "median": 1.1,
          "10%": 1.05,
          "90%": 1.19,
          "25%": 1.07,
          "75%": 1.15
        },
        "51690": {
          "name": "Martinsville",
          "median": 1.12,
          "10%": 1.02,
          "90%": 1.24,
          "25%": 1.06,
          "75%": 1.17
        },
        "54053": {
          "name": "Mason",
          "median": 1.12,
          "10%": 1.02,
          "90%": 1.2,
          "25%": 1.06,
          "75%": 1.16
        },
        "51115": {
          "name": "Mathews",
          "median": 1.09,
          "10%": 1.01,
          "90%": 1.19,
          "25%": 1.05,
          "75%": 1.15
        },
        "54047": {
          "name": "McDowell",
          "median": 1.11,
          "10%": 1.05,
          "90%": 1.19,
          "25%": 1.07,
          "75%": 1.15
        },
        "42083": {
          "name": "McKean",
          "median": 1.11,
          "10%": 1.02,
          "90%": 1.19,
          "25%": 1.07,
          "75%": 1.15
        },
        "51117": {
          "name": "Mecklenburg",
          "median": 1.09,
          "10%": 1.03,
          "90%": 1.2,
          "25%": 1.05,
          "75%": 1.14
        },
        "34021": {
          "name": "Mercer",
          "median": 1.09,
          "10%": 1.0,
          "90%": 1.17,
          "25%": 1.05,
          "75%": 1.14
        },
        "42085": {
          "name": "Mercer",
          "median": 1.12,
          "10%": 1.04,
          "90%": 1.22,
          "25%": 1.08,
          "75%": 1.16
        },
        "54055": {
          "name": "Mercer",
          "median": 1.1,
          "10%": 1.04,
          "90%": 1.2,
          "25%": 1.07,
          "75%": 1.15
        },
        "51119": {
          "name": "Middlesex",
          "median": 1.08,
          "10%": 1.01,
          "90%": 1.17,
          "25%": 1.04,
          "75%": 1.13
        },
        "42087": {
          "name": "Mifflin",
          "median": 1.14,
          "10%": 1.05,
          "90%": 1.21,
          "25%": 1.1,
          "75%": 1.18
        },
        "54057": {
          "name": "Mineral",
          "median": 1.1,
          "10%": 1.03,
          "90%": 1.19,
          "25%": 1.06,
          "75%": 1.15
        },
        "54059": {
          "name": "Mingo",
          "median": 1.1,
          "10%": 1.04,
          "90%": 1.16,
          "25%": 1.07,
          "75%": 1.13
        },
        "34025": {
          "name": "Monmouth",
          "median": 1.1,
          "10%": 1.02,
          "90%": 1.22,
          "25%": 1.04,
          "75%": 1.15
        },
        "54061": {
          "name": "Monongalia",
          "median": 1.08,
          "10%": 1.03,
          "90%": 1.18,
          "25%": 1.05,
          "75%": 1.12
        },
        "42089": {
          "name": "Monroe",
          "median": 1.13,
          "10%": 1.01,
          "90%": 1.22,
          "25%": 1.04,
          "75%": 1.19
        },
        "54063": {
          "name": "Monroe",
          "median": 1.09,
          "10%": 1.03,
          "90%": 1.16,
          "25%": 1.05,
          "75%": 1.13
        },
        "24031": {
          "name": "Montgomery",
          "median": 1.09,
          "10%": 1.02,
          "90%": 1.2,
          "25%": 1.05,
          "75%": 1.14
        },
        "36057": {
          "name": "Montgomery",
          "median": 1.12,
          "10%": 1.03,
          "90%": 1.19,
          "25%": 1.0675,
          "75%": 1.15
        },
        "42091": {
          "name": "Montgomery",
          "median": 1.1,
          "10%": 1.0,
          "90%": 1.21,
          "25%": 1.06,
          "75%": 1.16
        },
        "51121": {
          "name": "Montgomery",
          "median": 1.14,
          "10%": 1.02,
          "90%": 1.26,
          "25%": 1.1,
          "75%": 1.19
        },
        "42093": {
          "name": "Montour",
          "median": 1.13,
          "10%": 1.04,
          "90%": 1.2,
          "25%": 1.08,
          "75%": 1.16
        },
        "54065": {
          "name": "Morgan",
          "median": 1.14,
          "10%": 1.05,
          "90%": 1.25,
          "25%": 1.09,
          "75%": 1.18
        },
        "34027": {
          "name": "Morris",
          "median": 1.11,
          "10%": 1.02,
          "90%": 1.25,
          "25%": 1.05,
          "75%": 1.22
        },
        "36059": {
          "name": "Nassau",
          "median": 1.12,
          "10%": 1.02,
          "90%": 1.19,
          "25%": 1.07,
          "75%": 1.16
        },
        "51125": {
          "name": "Nelson",
          "median": 1.11,
          "10%": 1.05,
          "90%": 1.27,
          "25%": 1.07,
          "75%": 1.2
        },
        "10003": {
          "name": "New Castle",
          "median": 1.11,
          "10%": 1.04,
          "90%": 1.21,
          "25%": 1.07,
          "75%": 1.19
        },
        "51127": {
          "name": "New Kent",
          "median": 1.08,
          "10%": 1.02,
          "90%": 1.16,
          "25%": 1.05,
          "75%": 1.12
        },
        "36061": {
          "name": "New York",
          "median": 1.1,
          "10%": 1.03,
          "90%": 1.2,
          "25%": 1.06,
          "75%": 1.17
        },
        "51700": {
          "name": "Newport News",
          "median": 1.1,
          "10%": 1.0,
          "90%": 1.21,
          "25%": 1.05,
          "75%": 1.15
        },
        "54067": {
          "name": "Nicholas",
          "median": 1.08,
          "10%": 1.02,
          "90%": 1.17,
          "25%": 1.05,
          "75%": 1.12
        },
        "51710": {
          "name": "Norfolk",
          "median": 1.09,
          "10%": 1.0,
          "90%": 1.2,
          "25%": 1.03,
          "75%": 1.1425
        },
        "42095": {
          "name": "Northampton",
          "median": 1.11,
          "10%": 1.01,
          "90%": 1.21,
          "25%": 1.05,
          "75%": 1.16
        },
        "51131": {
          "name": "Northampton",
          "median": 1.11,
          "10%": 1.03,
          "90%": 1.22,
          "25%": 1.06,
          "75%": 1.15
        },
        "42097": {
          "name": "Northumberland",
          "median": 1.12,
          "10%": 1.06,
          "90%": 1.2,
          "25%": 1.09,
          "75%": 1.16
        },
        "51133": {
          "name": "Northumberland",
          "median": 1.09,
          "10%": 0.99,
          "90%": 1.19,
          "25%": 1.04,
          "75%": 1.14
        },
        "51720": {
          "name": "Norton",
          "median": 1.11,
          "10%": 1.01,
          "90%": 1.2,
          "25%": 1.05,
          "75%": 1.15
        },
        "51135": {
          "name": "Nottoway",
          "median": 1.09,
          "10%": 0.99,
          "90%": 1.26,
          "25%": 1.04,
          "75%": 1.14
        },
        "34029": {
          "name": "Ocean",
          "median": 1.1,
          "10%": 1.01,
          "90%": 1.2,
          "25%": 1.04,
          "75%": 1.15
        },
        "54069": {
          "name": "Ohio",
          "median": 1.1,
          "10%": 1.04,
          "90%": 1.17,
          "25%": 1.07,
          "75%": 1.14
        },
        "36065": {
          "name": "Oneida",
          "median": 1.09,
          "10%": 1.03,
          "90%": 1.17,
          "25%": 1.06,
          "75%": 1.11
        },
        "36067": {
          "name": "Onondaga",
          "median": 1.09,
          "10%": 1.04,
          "90%": 1.18,
          "25%": 1.07,
          "75%": 1.13
        },
        "36069": {
          "name": "Ontario",
          "median": 1.1,
          "10%": 1.0,
          "90%": 1.18,
          "25%": 1.04,
          "75%": 1.13
        },
        "36071": {
          "name": "Orange",
          "median": 1.1,
          "10%": 1.02,
          "90%": 1.22,
          "25%": 1.05,
          "75%": 1.17
        },
        "51137": {
          "name": "Orange",
          "median": 1.13,
          "10%": 1.04,
          "90%": 1.23,
          "25%": 1.07,
          "75%": 1.17
        },
        "36077": {
          "name": "Otsego",
          "median": 1.1,
          "10%": 1.04,
          "90%": 1.19,
          "25%": 1.06,
          "75%": 1.14
        },
        "51139": {
          "name": "Page",
          "median": 1.13,
          "10%": 1.02,
          "90%": 1.21,
          "25%": 1.1,
          "75%": 1.17
        },
        "51141": {
          "name": "Patrick",
          "median": 1.12,
          "10%": 1.02,
          "90%": 1.23,
          "25%": 1.06,
          "75%": 1.18
        },
        "54071": {
          "name": "Pendleton",
          "median": 1.13,
          "10%": 1.03,
          "90%": 1.22,
          "25%": 1.08,
          "75%": 1.17
        },
        "42099": {
          "name": "Perry",
          "median": 1.13,
          "10%": 1.07,
          "90%": 1.25,
          "25%": 1.1,
          "75%": 1.18
        },
        "51730": {
          "name": "Petersburg",
          "median": 1.09,
          "10%": 0.98,
          "90%": 1.19,
          "25%": 1.02,
          "75%": 1.13
        },
        "42101": {
          "name": "Philadelphia",
          "median": 1.12,
          "10%": 1.02,
          "90%": 1.19,
          "25%": 1.06,
          "75%": 1.16
        },
        "42103": {
          "name": "Pike",
          "median": 1.12,
          "10%": 1.0,
          "90%": 1.2,
          "25%": 1.05,
          "75%": 1.18
        },
        "51143": {
          "name": "Pittsylvania",
          "median": 1.14,
          "10%": 1.01,
          "90%": 1.25,
          "25%": 1.09,
          "75%": 1.2
        },
        "54073": {
          "name": "Pleasants",
          "median": 1.08,
          "10%": 1.02,
          "90%": 1.19,
          "25%": 1.04,
          "75%": 1.14
        },
        "54075": {
          "name": "Pocahontas",
          "median": 1.1,
          "10%": 1.05,
          "90%": 1.18,
          "25%": 1.07,
          "75%": 1.14
        },
        "51735": {
          "name": "Poquoson",
          "median": 1.09,
          "10%": 0.99,
          "90%": 1.19,
          "25%": 1.05,
          "75%": 1.15
        },
        "51740": {
          "name": "Portsmouth",
          "median": 1.11,
          "10%": 0.99,
          "90%": 1.22,
          "25%": 1.03,
          "75%": 1.15
        },
        "42105": {
          "name": "Potter",
          "median": 1.12,
          "10%": 1.02,
          "90%": 1.19,
          "25%": 1.07,
          "75%": 1.15
        },
        "51145": {
          "name": "Powhatan",
          "median": 1.07,
          "10%": 0.99,
          "90%": 1.18,
          "25%": 1.02,
          "75%": 1.14
        },
        "54077": {
          "name": "Preston",
          "median": 1.07,
          "10%": 1.03,
          "90%": 1.16,
          "25%": 1.05,
          "75%": 1.11
        },
        "51147": {
          "name": "Prince Edward",
          "median": 1.1,
          "10%": 1.02,
          "90%": 1.21,
          "25%": 1.05,
          "75%": 1.15
        },
        "51149": {
          "name": "Prince George",
          "median": 1.09,
          "10%": 0.98,
          "90%": 1.18,
          "25%": 1.01,
          "75%": 1.14
        },
        "24033": {
          "name": "Prince George's",
          "median": 1.08,
          "10%": 1.02,
          "90%": 1.18,
          "25%": 1.05,
          "75%": 1.14
        },
        "51153": {
          "name": "Prince William",
          "median": 1.09,
          "10%": 1.01,
          "90%": 1.16,
          "25%": 1.05,
          "75%": 1.13
        },
        "51155": {
          "name": "Pulaski",
          "median": 1.11,
          "10%": 1.05,
          "90%": 1.22,
          "25%": 1.08,
          "75%": 1.17
        },
        "54079": {
          "name": "Putnam",
          "median": 1.11,
          "10%": 1.02,
          "90%": 1.17,
          "25%": 1.06,
          "75%": 1.15
        },
        "24035": {
          "name": "Queen Anne's",
          "median": 1.1,
          "10%": 1.03,
          "90%": 1.18,
          "25%": 1.05,
          "75%": 1.14
        },
        "51750": {
          "name": "Radford",
          "median": 1.12,
          "10%": 1.02,
          "90%": 1.24,
          "25%": 1.09,
          "75%": 1.19
        },
        "54081": {
          "name": "Raleigh",
          "median": 1.09,
          "10%": 1.02,
          "90%": 1.2,
          "25%": 1.07,
          "75%": 1.13
        },
        "54083": {
          "name": "Randolph",
          "median": 1.08,
          "10%": 1.03,
          "90%": 1.16,
          "25%": 1.05,
          "75%": 1.11
        },
        "51157": {
          "name": "Rappahannock",
          "median": 1.14,
          "10%": 1.05,
          "90%": 1.23,
          "25%": 1.08,
          "75%": 1.18
        },
        "36085": {
          "name": "Richmond",
          "median": 1.09,
          "10%": 1.0,
          "90%": 1.23,
          "25%": 1.04,
          "75%": 1.15
        },
        "51159": {
          "name": "Richmond",
          "median": 1.09,
          "10%": 0.97,
          "90%": 1.2,
          "25%": 1.04,
          "75%": 1.15
        },
        "51760": {
          "name": "Richmond",
          "median": 1.08,
          "10%": 1.01,
          "90%": 1.15,
          "25%": 1.04,
          "75%": 1.14
        },
        "54085": {
          "name": "Ritchie",
          "median": 1.1,
          "10%": 1.03,
          "90%": 1.19,
          "25%": 1.07,
          "75%": 1.14
        },
        "54087": {
          "name": "Roane",
          "median": 1.1,
          "10%": 1.03,
          "90%": 1.17,
          "25%": 1.08,
          "75%": 1.14
        },
        "51161": {
          "name": "Roanoke",
          "median": 1.14,
          "10%": 1.03,
          "90%": 1.25,
          "25%": 1.09,
          "75%": 1.21
        },
        "51770": {
          "name": "Roanoke",
          "median": 1.13,
          "10%": 0.999,
          "90%": 1.25,
          "25%": 1.08,
          "75%": 1.19
        },
        "51163": {
          "name": "Rockbridge",
          "median": 1.12,
          "10%": 1.04,
          "90%": 1.26,
          "25%": 1.07,
          "75%": 1.2
        },
        "51165": {
          "name": "Rockingham",
          "median": 1.12,
          "10%": 1.03,
          "90%": 1.21,
          "25%": 1.06,
          "75%": 1.16
        },
        "51167": {
          "name": "Russell",
          "median": 1.09,
          "10%": 1.03,
          "90%": 1.17,
          "25%": 1.06,
          "75%": 1.14
        },
        "34033": {
          "name": "Salem",
          "median": 1.11,
          "10%": 1.04,
          "90%": 1.21,
          "25%": 1.06,
          "75%": 1.18
        },
        "51775": {
          "name": "Salem",
          "median": 1.14,
          "10%": 1.02,
          "90%": 1.26,
          "25%": 1.09,
          "75%": 1.19
        },
        "36095": {
          "name": "Schoharie",
          "median": 1.14,
          "10%": 1.03,
          "90%": 1.2,
          "25%": 1.09,
          "75%": 1.17
        },
        "36097": {
          "name": "Schuyler",
          "median": 1.11,
          "10%": 1.04,
          "90%": 1.22,
          "25%": 1.06,
          "75%": 1.15
        },
        "42107": {
          "name": "Schuylkill",
          "median": 1.11,
          "10%": 1.02,
          "90%": 1.19,
          "25%": 1.08,
          "75%": 1.15
        },
        "51169": {
          "name": "Scott",
          "median": 1.13,
          "10%": 1.05,
          "90%": 1.18,
          "25%": 1.08,
          "75%": 1.15
        },
        "51171": {
          "name": "Shenandoah",
          "median": 1.13,
          "10%": 1.04,
          "90%": 1.21,
          "25%": 1.08,
          "75%": 1.18
        },
        "51173": {
          "name": "Smyth",
          "median": 1.11,
          "10%": 1.05,
          "90%": 1.18,
          "25%": 1.08,
          "75%": 1.14
        },
        "42109": {
          "name": "Snyder",
          "median": 1.12,
          "10%": 1.05,
          "90%": 1.22,
          "25%": 1.09,
          "75%": 1.16
        },
        "24039": {
          "name": "Somerset",
          "median": 1.1,
          "10%": 1.02,
          "90%": 1.22,
          "25%": 1.06,
          "75%": 1.16
        },
        "42111": {
          "name": "Somerset",
          "median": 1.09,
          "10%": 1.04,
          "90%": 1.17,
          "25%": 1.07,
          "75%": 1.12
        },
        "51175": {
          "name": "Southampton",
          "median": 1.09,
          "10%": 0.97,
          "90%": 1.21,
          "25%": 1.04,
          "75%": 1.15
        },
        "51177": {
          "name": "Spotsylvania",
          "median": 1.11,
          "10%": 1.01,
          "90%": 1.2,
          "25%": 1.05,
          "75%": 1.15
        },
        "24037": {
          "name": "St. Mary's",
          "median": 1.09,
          "10%": 1.01,
          "90%": 1.17,
          "25%": 1.05,
          "75%": 1.13
        },
        "51179": {
          "name": "Stafford",
          "median": 1.1,
          "10%": 1.01,
          "90%": 1.21,
          "25%": 1.05,
          "75%": 1.15
        },
        "51790": {
          "name": "Staunton",
          "median": 1.12,
          "10%": 1.02,
          "90%": 1.25,
          "25%": 1.07,
          "75%": 1.19
        },
        "36101": {
          "name": "Steuben",
          "median": 1.11,
          "10%": 1.04,
          "90%": 1.18,
          "25%": 1.08,
          "75%": 1.15
        },
        "51800": {
          "name": "Suffolk",
          "median": 1.11,
          "10%": 1.01,
          "90%": 1.19,
          "25%": 1.06,
          "75%": 1.15
        },
        "36105": {
          "name": "Sullivan",
          "median": 1.12,
          "10%": 1.02,
          "90%": 1.21,
          "25%": 1.07,
          "75%": 1.17
        },
        "42113": {
          "name": "Sullivan",
          "median": 1.09,
          "10%": 1.03,
          "90%": 1.18,
          "25%": 1.05,
          "75%": 1.13
        },
        "54089": {
          "name": "Summers",
          "median": 1.09,
          "10%": 1.03,
          "90%": 1.17,
          "25%": 1.05,
          "75%": 1.12
        },
        "51181": {
          "name": "Surry",
          "median": 1.1,
          "10%": 0.98,
          "90%": 1.21,
          "25%": 1.06,
          "75%": 1.15
        },
        "42115": {
          "name": "Susquehanna",
          "median": 1.09,
          "10%": 1.03,
          "90%": 1.18,
          "25%": 1.05,
          "75%": 1.15
        },
        "10005": {
          "name": "Sussex",
          "median": 1.09,
          "10%": 1.03,
          "90%": 1.19,
          "25%": 1.06,
          "75%": 1.13
        },
        "34037": {
          "name": "Sussex",
          "median": 1.13,
          "10%": 1.0,
          "90%": 1.24,
          "25%": 1.07,
          "75%": 1.16
        },
        "51183": {
          "name": "Sussex",
          "median": 1.09,
          "10%": 1.0,
          "90%": 1.2,
          "25%": 1.04,
          "75%": 1.16
        },
        "24041": {
          "name": "Talbot",
          "median": 1.07,
          "10%": 1.01,
          "90%": 1.19,
          "25%": 1.04,
          "75%": 1.12
        },
        "54091": {
          "name": "Taylor",
          "median": 1.08,
          "10%": 1.03,
          "90%": 1.18,
          "25%": 1.05,
          "75%": 1.11
        },
        "51185": {
          "name": "Tazewell",
          "median": 1.09,
          "10%": 1.06,
          "90%": 1.17,
          "25%": 1.07,
          "75%": 1.12
        },
        "36107": {
          "name": "Tioga",
          "median": 1.08,
          "10%": 1.01,
          "90%": 1.16,
          "25%": 1.04,
          "75%": 1.13
        },
        "42117": {
          "name": "Tioga",
          "median": 1.11,
          "10%": 1.03,
          "90%": 1.2,
          "25%": 1.07,
          "75%": 1.14
        },
        "36109": {
          "name": "Tompkins",
          "median": 1.1,
          "10%": 1.03,
          "90%": 1.2,
          "25%": 1.07,
          "75%": 1.15
        },
        "54093": {
          "name": "Tucker",
          "median": 1.07,
          "10%": 1.02,
          "90%": 1.17,
          "25%": 1.03,
          "75%": 1.12
        },
        "54095": {
          "name": "Tyler",
          "median": 1.07,
          "10%": 1.0,
          "90%": 1.16,
          "25%": 1.03,
          "75%": 1.13
        },
        "36111": {
          "name": "Ulster",
          "median": 1.14,
          "10%": 1.04,
          "90%": 1.27,
          "25%": 1.08,
          "75%": 1.2
        },
        "42119": {
          "name": "Union",
          "median": 1.12,
          "10%": 1.05,
          "90%": 1.2,
          "25%": 1.08,
          "75%": 1.16
        },
        "54097": {
          "name": "Upshur",
          "median": 1.06,
          "10%": 1.02,
          "90%": 1.14,
          "25%": 1.04,
          "75%": 1.1
        },
        "42121": {
          "name": "Venango",
          "median": 1.11,
          "10%": 1.05,
          "90%": 1.22,
          "25%": 1.07,
          "75%": 1.15
        },
        "51810": {
          "name": "Virginia Beach",
          "median": 1.11,
          "10%": 1.0,
          "90%": 1.21,
          "25%": 1.06,
          "75%": 1.17
        },
        "34041": {
          "name": "Warren",
          "median": 1.12,
          "10%": 1.01,
          "90%": 1.23,
          "25%": 1.07,
          "75%": 1.18
        },
        "42123": {
          "name": "Warren",
          "median": 1.11,
          "10%": 1.03,
          "90%": 1.23,
          "25%": 1.05,
          "75%": 1.16
        },
        "51187": {
          "name": "Warren",
          "median": 1.14,
          "10%": 1.05,
          "90%": 1.24,
          "25%": 1.1,
          "75%": 1.18
        },
        "24043": {
          "name": "Washington",
          "median": 1.14,
          "10%": 1.05,
          "90%": 1.24,
          "25%": 1.1,
          "75%": 1.16
        },
        "42125": {
          "name": "Washington",
          "median": 1.11,
          "10%": 1.01,
          "90%": 1.19,
          "25%": 1.06,
          "75%": 1.15
        },
        "51191": {
          "name": "Washington",
          "median": 1.1,
          "10%": 1.04,
          "90%": 1.17,
          "25%": 1.06,
          "75%": 1.15
        },
        "42127": {
          "name": "Wayne",
          "median": 1.115,
          "10%": 1.01,
          "90%": 1.19,
          "25%": 1.04,
          "75%": 1.15
        },
        "54099": {
          "name": "Wayne",
          "median": 1.09,
          "10%": 1.02,
          "90%": 1.16,
          "25%": 1.05,
          "75%": 1.13
        },
        "51820": {
          "name": "Waynesboro",
          "median": 1.12,
          "10%": 1.05,
          "90%": 1.26,
          "25%": 1.08,
          "75%": 1.19
        },
        "54101": {
          "name": "Webster",
          "median": 1.09,
          "10%": 1.03,
          "90%": 1.15,
          "25%": 1.05,
          "75%": 1.11
        },
        "36119": {
          "name": "Westchester",
          "median": 1.12,
          "10%": 1.04,
          "90%": 1.22,
          "25%": 1.07,
          "75%": 1.18
        },
        "42129": {
          "name": "Westmoreland",
          "median": 1.09,
          "10%": 1.01,
          "90%": 1.16,
          "25%": 1.06,
          "75%": 1.12
        },
        "51193": {
          "name": "Westmoreland",
          "median": 1.09,
          "10%": 0.97,
          "90%": 1.19,
          "25%": 1.04,
          "75%": 1.13
        },
        "54103": {
          "name": "Wetzel",
          "median": 1.11,
          "10%": 1.03,
          "90%": 1.17,
          "25%": 1.08,
          "75%": 1.14
        },
        "24045": {
          "name": "Wicomico",
          "median": 1.09,
          "10%": 1.02,
          "90%": 1.2,
          "25%": 1.05,
          "75%": 1.15
        },
        "51830": {
          "name": "Williamsburg",
          "median": 1.06,
          "10%": 1.0,
          "90%": 1.18,
          "25%": 1.03,
          "75%": 1.13
        },
        "51840": {
          "name": "Winchester",
          "median": 1.15,
          "10%": 1.03,
          "90%": 1.24,
          "25%": 1.08,
          "75%": 1.19
        },
        "54105": {
          "name": "Wirt",
          "median": 1.13,
          "10%": 1.05,
          "90%": 1.2,
          "25%": 1.08,
          "75%": 1.17
        },
        "51195": {
          "name": "Wise",
          "median": 1.1,
          "10%": 1.03,
          "90%": 1.19,
          "25%": 1.06,
          "75%": 1.15
        },
        "54107": {
          "name": "Wood",
          "median": 1.1,
          "10%": 1.02,
          "90%": 1.19,
          "25%": 1.07,
          "75%": 1.18
        },
        "24047": {
          "name": "Worcester",
          "median": 1.11,
          "10%": 1.02,
          "90%": 1.21,
          "25%": 1.05,
          "75%": 1.16
        },
        "42131": {
          "name": "Wyoming",
          "median": 1.11,
          "10%": 1.02,
          "90%": 1.18,
          "25%": 1.06,
          "75%": 1.14
        },
        "54109": {
          "name": "Wyoming",
          "median": 1.1,
          "10%": 1.03,
          "90%": 1.2,
          "25%": 1.06,
          "75%": 1.16
        },
        "51197": {
          "name": "Wythe",
          "median": 1.1,
          "10%": 1.05,
          "90%": 1.17,
          "25%": 1.07,
          "75%": 1.14
        },
        "36123": {
          "name": "Yates",
          "median": 1.09,
          "10%": 1.03,
          "90%": 1.19,
          "25%": 1.07,
          "75%": 1.13
        },
        "42133": {
          "name": "York",
          "median": 1.11,
          "10%": 1.02,
          "90%": 1.19,
          "25%": 1.06,
          "75%": 1.14
        },
        "51199": {
          "name": "York",
          "median": 1.09,
          "10%": 1.02,
          "90%": 1.19,
          "25%": 1.05,
          "75%": 1.12
        },
        "max": 1.15,
        "min": 1
      },
      "5": {
        "51001": {
          "name": "Accomack",
          "median": 1.12,
          "10%": 1.0,
          "90%": 1.2,
          "25%": 1.07,
          "75%": 1.17
        },
        "42001": {
          "name": "Adams",
          "median": 1.13,
          "10%": 1.02,
          "90%": 1.25,
          "25%": 1.06,
          "75%": 1.2
        },
        "51003": {
          "name": "Albemarle",
          "median": 1.12,
          "10%": 1.01,
          "90%": 1.31,
          "25%": 1.06,
          "75%": 1.2
        },
        "51510": {
          "name": "Alexandria",
          "median": 1.08,
          "10%": 0.97,
          "90%": 1.22,
          "25%": 1.03,
          "75%": 1.13
        },
        "24001": {
          "name": "Allegany",
          "median": 1.12,
          "10%": 1.05,
          "90%": 1.23,
          "25%": 1.07,
          "75%": 1.16
        },
        "36003": {
          "name": "Allegany",
          "median": 1.11,
          "10%": 1.0,
          "90%": 1.21,
          "25%": 1.06,
          "75%": 1.16
        },
        "51005": {
          "name": "Alleghany",
          "median": 1.12,
          "10%": 1.03,
          "90%": 1.26,
          "25%": 1.06,
          "75%": 1.19
        },
        "42003": {
          "name": "Allegheny",
          "median": 1.09,
          "10%": 0.99,
          "90%": 1.2,
          "25%": 1.05,
          "75%": 1.1425
        },
        "51007": {
          "name": "Amelia",
          "median": 1.09,
          "10%": 0.99,
          "90%": 1.25,
          "25%": 1.03,
          "75%": 1.15
        },
        "51009": {
          "name": "Amherst",
          "median": 1.14,
          "10%": 1.03,
          "90%": 1.29,
          "25%": 1.07,
          "75%": 1.22
        },
        "24003": {
          "name": "Anne Arundel",
          "median": 1.08,
          "10%": 1.0,
          "90%": 1.2,
          "25%": 1.03,
          "75%": 1.14
        },
        "51011": {
          "name": "Appomattox",
          "median": 1.14,
          "10%": 1.01,
          "90%": 1.3,
          "25%": 1.06,
          "75%": 1.21
        },
        "51013": {
          "name": "Arlington",
          "median": 1.07,
          "10%": 0.99,
          "90%": 1.19,
          "25%": 1.02,
          "75%": 1.12
        },
        "42005": {
          "name": "Armstrong",
          "median": 1.1,
          "10%": 1.01,
          "90%": 1.2,
          "25%": 1.06,
          "75%": 1.17
        },
        "34001": {
          "name": "Atlantic",
          "median": 1.12,
          "10%": 1.03,
          "90%": 1.22,
          "25%": 1.06,
          "75%": 1.17
        },
        "51015": {
          "name": "Augusta",
          "median": 1.12,
          "10%": 1.029,
          "90%": 1.29,
          "25%": 1.07,
          "75%": 1.22
        },
        "24005": {
          "name": "Baltimore",
          "median": 1.09,
          "10%": 1.01,
          "90%": 1.22,
          "25%": 1.05,
          "75%": 1.1425
        },
        "24510": {
          "name": "Baltimore",
          "median": 1.09,
          "10%": 1.01,
          "90%": 1.23,
          "25%": 1.04,
          "75%": 1.15
        },
        "54001": {
          "name": "Barbour",
          "median": 1.07,
          "10%": 1.02,
          "90%": 1.16,
          "25%": 1.03,
          "75%": 1.13
        },
        "51017": {
          "name": "Bath",
          "median": 1.14,
          "10%": 1.04,
          "90%": 1.26,
          "25%": 1.08,
          "75%": 1.2
        },
        "42007": {
          "name": "Beaver",
          "median": 1.11,
          "10%": 1.01,
          "90%": 1.18,
          "25%": 1.05,
          "75%": 1.14
        },
        "42009": {
          "name": "Bedford",
          "median": 1.12,
          "10%": 1.05,
          "90%": 1.24,
          "25%": 1.09,
          "75%": 1.17
        },
        "51019": {
          "name": "Bedford",
          "median": 1.15,
          "10%": 1.03,
          "90%": 1.27,
          "25%": 1.06,
          "75%": 1.21
        },
        "54003": {
          "name": "Berkeley",
          "median": 1.13,
          "10%": 1.04,
          "90%": 1.27,
          "25%": 1.09,
          "75%": 1.2
        },
        "42011": {
          "name": "Berks",
          "median": 1.13,
          "10%": 1.01,
          "90%": 1.26,
          "25%": 1.05,
          "75%": 1.19
        },
        "42013": {
          "name": "Blair",
          "median": 1.13,
          "10%": 1.04,
          "90%": 1.23,
          "25%": 1.08,
          "75%": 1.17
        },
        "51021": {
          "name": "Bland",
          "median": 1.1,
          "10%": 1.01,
          "90%": 1.21,
          "25%": 1.06,
          "75%": 1.13
        },
        "54005": {
          "name": "Boone",
          "median": 1.11,
          "10%": 1.03,
          "90%": 1.16,
          "25%": 1.05,
          "75%": 1.13
        },
        "51023": {
          "name": "Botetourt",
          "median": 1.16,
          "10%": 1.04,
          "90%": 1.26,
          "25%": 1.08,
          "75%": 1.22
        },
        "42015": {
          "name": "Bradford",
          "median": 1.09,
          "10%": 0.99,
          "90%": 1.2,
          "25%": 1.04,
          "75%": 1.13
        },
        "54007": {
          "name": "Braxton",
          "median": 1.07,
          "10%": 1.02,
          "90%": 1.17,
          "25%": 1.04,
          "75%": 1.14
        },
        "51520": {
          "name": "Bristol",
          "median": 1.11,
          "10%": 1.03,
          "90%": 1.2,
          "25%": 1.06,
          "75%": 1.14
        },
        "36005": {
          "name": "Bronx",
          "median": 1.12,
          "10%": 1.0,
          "90%": 1.24,
          "25%": 1.05,
          "75%": 1.18
        },
        "54009": {
          "name": "Brooke",
          "median": 1.12,
          "10%": 0.99,
          "90%": 1.23,
          "25%": 1.06,
          "75%": 1.16
        },
        "36007": {
          "name": "Broome",
          "median": 1.1,
          "10%": 1.01,
          "90%": 1.21,
          "25%": 1.05,
          "75%": 1.15
        },
        "51025": {
          "name": "Brunswick",
          "median": 1.09,
          "10%": 0.97,
          "90%": 1.25,
          "25%": 1.03,
          "75%": 1.15
        },
        "51027": {
          "name": "Buchanan",
          "median": 1.11,
          "10%": 1.01,
          "90%": 1.2,
          "25%": 1.05,
          "75%": 1.14
        },
        "51029": {
          "name": "Buckingham",
          "median": 1.11,
          "10%": 1.01,
          "90%": 1.25,
          "25%": 1.05,
          "75%": 1.17
        },
        "42017": {
          "name": "Bucks",
          "median": 1.09,
          "10%": 1.01,
          "90%": 1.19,
          "25%": 1.04,
          "75%": 1.15
        },
        "51530": {
          "name": "Buena Vista",
          "median": 1.13,
          "10%": 1.02,
          "90%": 1.33,
          "25%": 1.06,
          "75%": 1.24
        },
        "34005": {
          "name": "Burlington",
          "median": 1.1,
          "10%": 1.0,
          "90%": 1.2,
          "25%": 1.04,
          "75%": 1.15
        },
        "42019": {
          "name": "Butler",
          "median": 1.1,
          "10%": 1.0,
          "90%": 1.19,
          "25%": 1.07,
          "75%": 1.15
        },
        "54011": {
          "name": "Cabell",
          "median": 1.1,
          "10%": 1.01,
          "90%": 1.18,
          "25%": 1.05,
          "75%": 1.15
        },
        "54013": {
          "name": "Calhoun",
          "median": 1.13,
          "10%": 1.03,
          "90%": 1.21,
          "25%": 1.07,
          "75%": 1.18
        },
        "24009": {
          "name": "Calvert",
          "median": 1.08,
          "10%": 1.0,
          "90%": 1.19,
          "25%": 1.03,
          "75%": 1.15
        },
        "42021": {
          "name": "Cambria",
          "median": 1.07,
          "10%": 1.01,
          "90%": 1.18,
          "25%": 1.04,
          "75%": 1.14
        },
        "34007": {
          "name": "Camden",
          "median": 1.09,
          "10%": 1.03,
          "90%": 1.2,
          "25%": 1.06,
          "75%": 1.16
        },
        "42023": {
          "name": "Cameron",
          "median": 1.11,
          "10%": 1.0,
          "90%": 1.19,
          "25%": 1.06,
          "75%": 1.16
        },
        "51031": {
          "name": "Campbell",
          "median": 1.15,
          "10%": 1.02,
          "90%": 1.25,
          "25%": 1.08,
          "75%": 1.19
        },
        "34009": {
          "name": "Cape May",
          "median": 1.1,
          "10%": 1.02,
          "90%": 1.22,
          "25%": 1.05,
          "75%": 1.17
        },
        "42025": {
          "name": "Carbon",
          "median": 1.12,
          "10%": 0.98,
          "90%": 1.23,
          "25%": 1.05,
          "75%": 1.19
        },
        "24011": {
          "name": "Caroline",
          "median": 1.1,
          "10%": 1.01,
          "90%": 1.2,
          "25%": 1.05,
          "75%": 1.15
        },
        "51033": {
          "name": "Caroline",
          "median": 1.09,
          "10%": 0.99,
          "90%": 1.23,
          "25%": 1.04,
          "75%": 1.16
        },
        "24013": {
          "name": "Carroll",
          "median": 1.11,
          "10%": 1.02,
          "90%": 1.25,
          "25%": 1.07,
          "75%": 1.17
        },
        "51035": {
          "name": "Carroll",
          "median": 1.12,
          "10%": 1.02,
          "90%": 1.23,
          "25%": 1.08,
          "75%": 1.18
        },
        "24015": {
          "name": "Cecil",
          "median": 1.11,
          "10%": 1.02,
          "90%": 1.22,
          "25%": 1.06,
          "75%": 1.2
        },
        "42027": {
          "name": "Centre",
          "median": 1.12,
          "10%": 1.009,
          "90%": 1.21,
          "25%": 1.09,
          "75%": 1.18
        },
        "24017": {
          "name": "Charles",
          "median": 1.09,
          "10%": 0.99,
          "90%": 1.21,
          "25%": 1.03,
          "75%": 1.16
        },
        "51036": {
          "name": "Charles City",
          "median": 1.07,
          "10%": 0.98,
          "90%": 1.2,
          "25%": 1.02,
          "75%": 1.13
        },
        "51037": {
          "name": "Charlotte",
          "median": 1.11,
          "10%": 1.03,
          "90%": 1.22,
          "25%": 1.05,
          "75%": 1.18
        },
        "51540": {
          "name": "Charlottesville",
          "median": 1.13,
          "10%": 1.0,
          "90%": 1.29,
          "25%": 1.05,
          "75%": 1.19
        },
        "36015": {
          "name": "Chemung",
          "median": 1.1,
          "10%": 1.01,
          "90%": 1.19,
          "25%": 1.06,
          "75%": 1.15
        },
        "36017": {
          "name": "Chenango",
          "median": 1.09,
          "10%": 1.0,
          "90%": 1.18,
          "25%": 1.04,
          "75%": 1.14
        },
        "51550": {
          "name": "Chesapeake",
          "median": 1.1,
          "10%": 0.97,
          "90%": 1.25,
          "25%": 1.04,
          "75%": 1.18
        },
        "42029": {
          "name": "Chester",
          "median": 1.12,
          "10%": 1.0,
          "90%": 1.27,
          "25%": 1.05,
          "75%": 1.19
        },
        "51041": {
          "name": "Chesterfield",
          "median": 1.1,
          "10%": 0.97,
          "90%": 1.23,
          "25%": 1.03,
          "75%": 1.15
        },
        "42031": {
          "name": "Clarion",
          "median": 1.11,
          "10%": 1.04,
          "90%": 1.21,
          "25%": 1.07,
          "75%": 1.15
        },
        "51043": {
          "name": "Clarke",
          "median": 1.13,
          "10%": 1.01,
          "90%": 1.27,
          "25%": 1.09,
          "75%": 1.21
        },
        "54015": {
          "name": "Clay",
          "median": 1.08,
          "10%": 1.0,
          "90%": 1.14,
          "25%": 1.04,
          "75%": 1.12
        },
        "42033": {
          "name": "Clearfield",
          "median": 1.11,
          "10%": 1.03,
          "90%": 1.19,
          "25%": 1.06,
          "75%": 1.16
        },
        "42035": {
          "name": "Clinton",
          "median": 1.12,
          "10%": 1.0,
          "90%": 1.2,
          "25%": 1.06,
          "75%": 1.17
        },
        "51570": {
          "name": "Colonial Heights",
          "median": 1.08,
          "10%": 0.95,
          "90%": 1.23,
          "25%": 1.04,
          "75%": 1.14
        },
        "42037": {
          "name": "Columbia",
          "median": 1.13,
          "10%": 0.99,
          "90%": 1.24,
          "25%": 1.08,
          "75%": 1.19
        },
        "36023": {
          "name": "Cortland",
          "median": 1.1,
          "10%": 1.03,
          "90%": 1.2,
          "25%": 1.06,
          "75%": 1.14
        },
        "51580": {
          "name": "Covington",
          "median": 1.12,
          "10%": 1.01,
          "90%": 1.27,
          "25%": 1.05,
          "75%": 1.19
        },
        "51045": {
          "name": "Craig",
          "median": 1.14,
          "10%": 1.04,
          "90%": 1.26,
          "25%": 1.08,
          "75%": 1.21
        },
        "42039": {
          "name": "Crawford",
          "median": 1.12,
          "10%": 1.0,
          "90%": 1.23,
          "25%": 1.05,
          "75%": 1.18
        },
        "51047": {
          "name": "Culpeper",
          "median": 1.13,
          "10%": 1.05,
          "90%": 1.22,
          "25%": 1.08,
          "75%": 1.17
        },
        "34011": {
          "name": "Cumberland",
          "median": 1.11,
          "10%": 1.02,
          "90%": 1.2,
          "25%": 1.07,
          "75%": 1.17
        },
        "42041": {
          "name": "Cumberland",
          "median": 1.14,
          "10%": 1.05,
          "90%": 1.27,
          "25%": 1.09,
          "75%": 1.18
        },
        "51049": {
          "name": "Cumberland",
          "median": 1.1,
          "10%": 0.99,
          "90%": 1.26,
          "25%": 1.04,
          "75%": 1.16
        },
        "51590": {
          "name": "Danville",
          "median": 1.11,
          "10%": 1.03,
          "90%": 1.25,
          "25%": 1.07,
          "75%": 1.18
        },
        "42043": {
          "name": "Dauphin",
          "median": 1.14,
          "10%": 1.03,
          "90%": 1.301,
          "25%": 1.09,
          "75%": 1.2
        },
        "36025": {
          "name": "Delaware",
          "median": 1.11,
          "10%": 1.03,
          "90%": 1.21,
          "25%": 1.07,
          "75%": 1.17
        },
        "42045": {
          "name": "Delaware",
          "median": 1.11,
          "10%": 1.03,
          "90%": 1.24,
          "25%": 1.07,
          "75%": 1.2
        },
        "51051": {
          "name": "Dickenson",
          "median": 1.08,
          "10%": 1.01,
          "90%": 1.19,
          "25%": 1.05,
          "75%": 1.14
        },
        "51053": {
          "name": "Dinwiddie",
          "median": 1.08,
          "10%": 1.0,
          "90%": 1.23,
          "25%": 1.02,
          "75%": 1.15
        },
        "11001": {
          "name": "District of Columbia",
          "median": 1.07,
          "10%": 0.97,
          "90%": 1.22,
          "25%": 1.03,
          "75%": 1.13
        },
        "54017": {
          "name": "Doddridge",
          "median": 1.05,
          "10%": 1.01,
          "90%": 1.18,
          "25%": 1.02,
          "75%": 1.11
        },
        "24019": {
          "name": "Dorchester",
          "median": 1.07,
          "10%": 0.96,
          "90%": 1.22,
          "25%": 1.03,
          "75%": 1.14
        },
        "42047": {
          "name": "Elk",
          "median": 1.11,
          "10%": 0.98,
          "90%": 1.19,
          "25%": 1.06,
          "75%": 1.16
        },
        "51595": {
          "name": "Emporia",
          "median": 1.06,
          "10%": 0.98,
          "90%": 1.17,
          "25%": 1.02,
          "75%": 1.12
        },
        "42049": {
          "name": "Erie",
          "median": 1.12,
          "10%": 1.02,
          "90%": 1.22,
          "25%": 1.04,
          "75%": 1.17
        },
        "51057": {
          "name": "Essex",
          "median": 1.11,
          "10%": 0.96,
          "90%": 1.21,
          "25%": 1.01,
          "75%": 1.16
        },
        "51059": {
          "name": "Fairfax",
          "median": 1.07,
          "10%": 0.99,
          "90%": 1.181,
          "25%": 1.04,
          "75%": 1.11
        },
        "51600": {
          "name": "Fairfax",
          "median": 1.07,
          "10%": 0.99,
          "90%": 1.19,
          "25%": 1.02,
          "75%": 1.11
        },
        "51610": {
          "name": "Falls Church",
          "median": 1.08,
          "10%": 0.98,
          "90%": 1.19,
          "25%": 1.02,
          "75%": 1.13
        },
        "51061": {
          "name": "Fauquier",
          "median": 1.13,
          "10%": 1.02,
          "90%": 1.26,
          "25%": 1.07,
          "75%": 1.19
        },
        "42051": {
          "name": "Fayette",
          "median": 1.07,
          "10%": 1.0,
          "90%": 1.17,
          "25%": 1.04,
          "75%": 1.13
        },
        "54019": {
          "name": "Fayette",
          "median": 1.09,
          "10%": 1.02,
          "90%": 1.2,
          "25%": 1.06,
          "75%": 1.13
        },
        "51063": {
          "name": "Floyd",
          "median": 1.14,
          "10%": 1.03,
          "90%": 1.27,
          "25%": 1.06,
          "75%": 1.2
        },
        "51065": {
          "name": "Fluvanna",
          "median": 1.11,
          "10%": 1.01,
          "90%": 1.32,
          "25%": 1.04,
          "75%": 1.2
        },
        "42053": {
          "name": "Forest",
          "median": 1.11,
          "10%": 1.0,
          "90%": 1.25,
          "25%": 1.05,
          "75%": 1.17
        },
        "42055": {
          "name": "Franklin",
          "median": 1.12,
          "10%": 1.04,
          "90%": 1.26,
          "25%": 1.07,
          "75%": 1.18
        },
        "51067": {
          "name": "Franklin",
          "median": 1.15,
          "10%": 1.02,
          "90%": 1.28,
          "25%": 1.07,
          "75%": 1.21
        },
        "51620": {
          "name": "Franklin",
          "median": 1.1,
          "10%": 0.99,
          "90%": 1.23,
          "25%": 1.06,
          "75%": 1.18
        },
        "24021": {
          "name": "Frederick",
          "median": 1.11,
          "10%": 1.01,
          "90%": 1.27,
          "25%": 1.06,
          "75%": 1.18
        },
        "51069": {
          "name": "Frederick",
          "median": 1.13,
          "10%": 1.03,
          "90%": 1.3,
          "25%": 1.08,
          "75%": 1.2
        },
        "51630": {
          "name": "Fredericksburg",
          "median": 1.11,
          "10%": 0.97,
          "90%": 1.23,
          "25%": 1.04,
          "75%": 1.17
        },
        "42057": {
          "name": "Fulton",
          "median": 1.15,
          "10%": 1.04,
          "90%": 1.26,
          "25%": 1.1,
          "75%": 1.21
        },
        "51640": {
          "name": "Galax",
          "median": 1.13,
          "10%": 0.97,
          "90%": 1.23,
          "25%": 1.04,
          "75%": 1.18
        },
        "24023": {
          "name": "Garrett",
          "median": 1.08,
          "10%": 1.02,
          "90%": 1.211,
          "25%": 1.05,
          "75%": 1.12
        },
        "51071": {
          "name": "Giles",
          "median": 1.12,
          "10%": 1.04,
          "90%": 1.23,
          "25%": 1.08,
          "75%": 1.17
        },
        "54021": {
          "name": "Gilmer",
          "median": 1.11,
          "10%": 1.02,
          "90%": 1.18,
          "25%": 1.07,
          "75%": 1.16
        },
        "34015": {
          "name": "Gloucester",
          "median": 1.115,
          "10%": 1.04,
          "90%": 1.22,
          "25%": 1.07,
          "75%": 1.17
        },
        "51073": {
          "name": "Gloucester",
          "median": 1.1,
          "10%": 1.0,
          "90%": 1.19,
          "25%": 1.03,
          "75%": 1.14
        },
        "51075": {
          "name": "Goochland",
          "median": 1.1,
          "10%": 0.98,
          "90%": 1.28,
          "25%": 1.02,
          "75%": 1.19
        },
        "54023": {
          "name": "Grant",
          "median": 1.08,
          "10%": 1.01,
          "90%": 1.23,
          "25%": 1.04,
          "75%": 1.14
        },
        "51077": {
          "name": "Grayson",
          "median": 1.12,
          "10%": 1.02,
          "90%": 1.21,
          "25%": 1.08,
          "75%": 1.16
        },
        "54025": {
          "name": "Greenbrier",
          "median": 1.12,
          "10%": 1.02,
          "90%": 1.2,
          "25%": 1.07,
          "75%": 1.16
        },
        "36039": {
          "name": "Greene",
          "median": 1.17,
          "10%": 1.04,
          "90%": 1.28,
          "25%": 1.08,
          "75%": 1.23
        },
        "42059": {
          "name": "Greene",
          "median": 1.1,
          "10%": 1.04,
          "90%": 1.21,
          "25%": 1.07,
          "75%": 1.16
        },
        "51079": {
          "name": "Greene",
          "median": 1.12,
          "10%": 0.99,
          "90%": 1.29,
          "25%": 1.06,
          "75%": 1.21
        },
        "51081": {
          "name": "Greensville",
          "median": 1.08,
          "10%": 0.97,
          "90%": 1.18,
          "25%": 1.03,
          "75%": 1.13
        },
        "51083": {
          "name": "Halifax",
          "median": 1.13,
          "10%": 1.03,
          "90%": 1.22,
          "25%": 1.07,
          "75%": 1.18
        },
        "54027": {
          "name": "Hampshire",
          "median": 1.13,
          "10%": 1.05,
          "90%": 1.25,
          "25%": 1.07,
          "75%": 1.19
        },
        "51650": {
          "name": "Hampton",
          "median": 1.09,
          "10%": 0.98,
          "90%": 1.2,
          "25%": 1.03,
          "75%": 1.17
        },
        "54029": {
          "name": "Hancock",
          "median": 1.13,
          "10%": 1.02,
          "90%": 1.24,
          "25%": 1.05,
          "75%": 1.18
        },
        "51085": {
          "name": "Hanover",
          "median": 1.08,
          "10%": 0.99,
          "90%": 1.21,
          "25%": 1.04,
          "75%": 1.15
        },
        "54031": {
          "name": "Hardy",
          "median": 1.12,
          "10%": 1.03,
          "90%": 1.24,
          "25%": 1.06,
          "75%": 1.17
        },
        "24025": {
          "name": "Harford",
          "median": 1.11,
          "10%": 1.0,
          "90%": 1.22,
          "25%": 1.06,
          "75%": 1.15
        },
        "54033": {
          "name": "Harrison",
          "median": 1.08,
          "10%": 1.02,
          "90%": 1.2,
          "25%": 1.04,
          "75%": 1.11
        },
        "51660": {
          "name": "Harrisonburg",
          "median": 1.1,
          "10%": 1.01,
          "90%": 1.27,
          "25%": 1.05,
          "75%": 1.17
        },
        "51087": {
          "name": "Henrico",
          "median": 1.08,
          "10%": 1.0,
          "90%": 1.19,
          "25%": 1.03,
          "75%": 1.15
        },
        "51089": {
          "name": "Henry",
          "median": 1.14,
          "10%": 1.01,
          "90%": 1.29,
          "25%": 1.08,
          "75%": 1.22
        },
        "36043": {
          "name": "Herkimer",
          "median": 1.05,
          "10%": 0.97,
          "90%": 1.12,
          "25%": 1.01,
          "75%": 1.09
        },
        "51091": {
          "name": "Highland",
          "median": 1.12,
          "10%": 1.04,
          "90%": 1.23,
          "25%": 1.06,
          "75%": 1.18
        },
        "51670": {
          "name": "Hopewell",
          "median": 1.06,
          "10%": 0.93,
          "90%": 1.23,
          "25%": 0.99,
          "75%": 1.13
        },
        "24027": {
          "name": "Howard",
          "median": 1.1,
          "10%": 1.02,
          "90%": 1.23,
          "25%": 1.06,
          "75%": 1.17
        },
        "34019": {
          "name": "Hunterdon",
          "median": 1.1,
          "10%": 1.0,
          "90%": 1.27,
          "25%": 1.05,
          "75%": 1.19
        },
        "42061": {
          "name": "Huntingdon",
          "median": 1.13,
          "10%": 1.04,
          "90%": 1.23,
          "25%": 1.09,
          "75%": 1.19
        },
        "42063": {
          "name": "Indiana",
          "median": 1.09,
          "10%": 1.0,
          "90%": 1.16,
          "25%": 1.03,
          "75%": 1.14
        },
        "51093": {
          "name": "Isle of Wight",
          "median": 1.12,
          "10%": 0.97,
          "90%": 1.23,
          "25%": 1.06,
          "75%": 1.18
        },
        "54035": {
          "name": "Jackson",
          "median": 1.12,
          "10%": 1.01,
          "90%": 1.2,
          "25%": 1.05,
          "75%": 1.17
        },
        "51095": {
          "name": "James City",
          "median": 1.08,
          "10%": 0.97,
          "90%": 1.2,
          "25%": 1.02,
          "75%": 1.13
        },
        "42065": {
          "name": "Jefferson",
          "median": 1.12,
          "10%": 1.01,
          "90%": 1.18,
          "25%": 1.06,
          "75%": 1.16
        },
        "54037": {
          "name": "Jefferson",
          "median": 1.12,
          "10%": 1.01,
          "90%": 1.25,
          "25%": 1.07,
          "75%": 1.2
        },
        "42067": {
          "name": "Juniata",
          "median": 1.13,
          "10%": 1.06,
          "90%": 1.27,
          "25%": 1.09,
          "75%": 1.19
        },
        "54039": {
          "name": "Kanawha",
          "median": 1.07,
          "10%": 0.98,
          "90%": 1.15,
          "25%": 1.04,
          "75%": 1.12
        },
        "10001": {
          "name": "Kent",
          "median": 1.1,
          "10%": 1.01,
          "90%": 1.19,
          "25%": 1.05,
          "75%": 1.15
        },
        "24029": {
          "name": "Kent",
          "median": 1.09,
          "10%": 0.99,
          "90%": 1.18,
          "25%": 1.03,
          "75%": 1.14
        },
        "51099": {
          "name": "King George",
          "median": 1.08,
          "10%": 0.98,
          "90%": 1.23,
          "25%": 1.01,
          "75%": 1.17
        },
        "51101": {
          "name": "King William",
          "median": 1.08,
          "10%": 0.98,
          "90%": 1.19,
          "25%": 1.03,
          "75%": 1.13
        },
        "51097": {
          "name": "King and Queen",
          "median": 1.1,
          "10%": 0.99,
          "90%": 1.18,
          "25%": 1.02,
          "75%": 1.13
        },
        "42069": {
          "name": "Lackawanna",
          "median": 1.13,
          "10%": 0.98,
          "90%": 1.25,
          "25%": 1.05,
          "75%": 1.2
        },
        "42071": {
          "name": "Lancaster",
          "median": 1.12,
          "10%": 1.01,
          "90%": 1.26,
          "25%": 1.06,
          "75%": 1.19
        },
        "51103": {
          "name": "Lancaster",
          "median": 1.09,
          "10%": 0.98,
          "90%": 1.19,
          "25%": 1.01,
          "75%": 1.15
        },
        "42073": {
          "name": "Lawrence",
          "median": 1.09,
          "10%": 1.01,
          "90%": 1.191,
          "25%": 1.06,
          "75%": 1.16
        },
        "42075": {
          "name": "Lebanon",
          "median": 1.1,
          "10%": 1.01,
          "90%": 1.24,
          "25%": 1.05,
          "75%": 1.18
        },
        "51105": {
          "name": "Lee",
          "median": 1.12,
          "10%": 1.05,
          "90%": 1.22,
          "25%": 1.09,
          "75%": 1.17
        },
        "42077": {
          "name": "Lehigh",
          "median": 1.14,
          "10%": 0.99,
          "90%": 1.26,
          "25%": 1.05,
          "75%": 1.2
        },
        "54041": {
          "name": "Lewis",
          "median": 1.08,
          "10%": 1.0,
          "90%": 1.15,
          "25%": 1.06,
          "75%": 1.11
        },
        "51678": {
          "name": "Lexington",
          "median": 1.09,
          "10%": 1.01,
          "90%": 1.25,
          "25%": 1.03,
          "75%": 1.19
        },
        "54043": {
          "name": "Lincoln",
          "median": 1.1,
          "10%": 1.02,
          "90%": 1.16,
          "25%": 1.05,
          "75%": 1.14
        },
        "36051": {
          "name": "Livingston",
          "median": 1.1,
          "10%": 0.99,
          "90%": 1.2,
          "25%": 1.05,
          "75%": 1.15
        },
        "54045": {
          "name": "Logan",
          "median": 1.1,
          "10%": 1.02,
          "90%": 1.18,
          "25%": 1.07,
          "75%": 1.14
        },
        "51107": {
          "name": "Loudoun",
          "median": 1.11,
          "10%": 1.02,
          "90%": 1.25,
          "25%": 1.06,
          "75%": 1.18
        },
        "51109": {
          "name": "Louisa",
          "median": 1.11,
          "10%": 0.99,
          "90%": 1.28,
          "25%": 1.05,
          "75%": 1.17
        },
        "51111": {
          "name": "Lunenburg",
          "median": 1.11,
          "10%": 1.0,
          "90%": 1.25,
          "25%": 1.04,
          "75%": 1.17
        },
        "42079": {
          "name": "Luzerne",
          "median": 1.12,
          "10%": 0.99,
          "90%": 1.2,
          "25%": 1.07,
          "75%": 1.17
        },
        "42081": {
          "name": "Lycoming",
          "median": 1.1,
          "10%": 1.03,
          "90%": 1.18,
          "25%": 1.06,
          "75%": 1.15
        },
        "51680": {
          "name": "Lynchburg",
          "median": 1.12,
          "10%": 1.02,
          "90%": 1.22,
          "25%": 1.06,
          "75%": 1.18
        },
        "36053": {
          "name": "Madison",
          "median": 1.08,
          "10%": 1.0,
          "90%": 1.17,
          "25%": 1.05,
          "75%": 1.13
        },
        "51113": {
          "name": "Madison",
          "median": 1.11,
          "10%": 0.99,
          "90%": 1.24,
          "25%": 1.05,
          "75%": 1.18
        },
        "51683": {
          "name": "Manassas",
          "median": 1.07,
          "10%": 0.96,
          "90%": 1.19,
          "25%": 1.02,
          "75%": 1.11
        },
        "51685": {
          "name": "Manassas Park",
          "median": 1.07,
          "10%": 0.97,
          "90%": 1.2,
          "25%": 1.02,
          "75%": 1.11
        },
        "54049": {
          "name": "Marion",
          "median": 1.07,
          "10%": 0.98,
          "90%": 1.18,
          "25%": 1.03,
          "75%": 1.12
        },
        "54051": {
          "name": "Marshall",
          "median": 1.11,
          "10%": 1.04,
          "90%": 1.18,
          "25%": 1.07,
          "75%": 1.15
        },
        "51690": {
          "name": "Martinsville",
          "median": 1.15,
          "10%": 1.0,
          "90%": 1.33,
          "25%": 1.08,
          "75%": 1.23
        },
        "54053": {
          "name": "Mason",
          "median": 1.12,
          "10%": 1.02,
          "90%": 1.23,
          "25%": 1.07,
          "75%": 1.17
        },
        "51115": {
          "name": "Mathews",
          "median": 1.12,
          "10%": 0.97,
          "90%": 1.21,
          "25%": 1.04,
          "75%": 1.16
        },
        "54047": {
          "name": "McDowell",
          "median": 1.11,
          "10%": 1.03,
          "90%": 1.21,
          "25%": 1.06,
          "75%": 1.15
        },
        "42083": {
          "name": "McKean",
          "median": 1.12,
          "10%": 0.99,
          "90%": 1.19,
          "25%": 1.06,
          "75%": 1.15
        },
        "51117": {
          "name": "Mecklenburg",
          "median": 1.1,
          "10%": 0.99,
          "90%": 1.21,
          "25%": 1.05,
          "75%": 1.15
        },
        "34021": {
          "name": "Mercer",
          "median": 1.07,
          "10%": 0.98,
          "90%": 1.17,
          "25%": 1.03,
          "75%": 1.13
        },
        "42085": {
          "name": "Mercer",
          "median": 1.12,
          "10%": 1.02,
          "90%": 1.24,
          "25%": 1.06,
          "75%": 1.18
        },
        "54055": {
          "name": "Mercer",
          "median": 1.11,
          "10%": 1.04,
          "90%": 1.2,
          "25%": 1.08,
          "75%": 1.14
        },
        "51119": {
          "name": "Middlesex",
          "median": 1.09,
          "10%": 0.98,
          "90%": 1.18,
          "25%": 1.02,
          "75%": 1.14
        },
        "42087": {
          "name": "Mifflin",
          "median": 1.15,
          "10%": 1.05,
          "90%": 1.24,
          "25%": 1.09,
          "75%": 1.2
        },
        "54057": {
          "name": "Mineral",
          "median": 1.11,
          "10%": 1.02,
          "90%": 1.25,
          "25%": 1.06,
          "75%": 1.16
        },
        "54059": {
          "name": "Mingo",
          "median": 1.1,
          "10%": 1.05,
          "90%": 1.19,
          "25%": 1.07,
          "75%": 1.14
        },
        "34025": {
          "name": "Monmouth",
          "median": 1.09,
          "10%": 1.0,
          "90%": 1.2,
          "25%": 1.03,
          "75%": 1.16
        },
        "54061": {
          "name": "Monongalia",
          "median": 1.07,
          "10%": 1.02,
          "90%": 1.19,
          "25%": 1.03,
          "75%": 1.12
        },
        "42089": {
          "name": "Monroe",
          "median": 1.15,
          "10%": 0.99,
          "90%": 1.25,
          "25%": 1.05,
          "75%": 1.21
        },
        "54063": {
          "name": "Monroe",
          "median": 1.1,
          "10%": 1.02,
          "90%": 1.19,
          "25%": 1.05,
          "75%": 1.14
        },
        "24031": {
          "name": "Montgomery",
          "median": 1.09,
          "10%": 1.02,
          "90%": 1.2,
          "25%": 1.04,
          "75%": 1.15
        },
        "36057": {
          "name": "Montgomery",
          "median": 1.11,
          "10%": 1.01,
          "90%": 1.22,
          "25%": 1.06,
          "75%": 1.17
        },
        "42091": {
          "name": "Montgomery",
          "median": 1.09,
          "10%": 1.01,
          "90%": 1.25,
          "25%": 1.05,
          "75%": 1.18
        },
        "51121": {
          "name": "Montgomery",
          "median": 1.16,
          "10%": 1.04,
          "90%": 1.27,
          "25%": 1.09,
          "75%": 1.21
        },
        "42093": {
          "name": "Montour",
          "median": 1.14,
          "10%": 1.03,
          "90%": 1.26,
          "25%": 1.07,
          "75%": 1.19
        },
        "54065": {
          "name": "Morgan",
          "median": 1.14,
          "10%": 1.05,
          "90%": 1.28,
          "25%": 1.07,
          "75%": 1.2
        },
        "34027": {
          "name": "Morris",
          "median": 1.11,
          "10%": 1.01,
          "90%": 1.311,
          "25%": 1.06,
          "75%": 1.26
        },
        "36059": {
          "name": "Nassau",
          "median": 1.11,
          "10%": 1.01,
          "90%": 1.22,
          "25%": 1.06,
          "75%": 1.18
        },
        "51125": {
          "name": "Nelson",
          "median": 1.13,
          "10%": 1.01,
          "90%": 1.34,
          "25%": 1.06,
          "75%": 1.23
        },
        "10003": {
          "name": "New Castle",
          "median": 1.11,
          "10%": 1.03,
          "90%": 1.25,
          "25%": 1.06,
          "75%": 1.21
        },
        "51127": {
          "name": "New Kent",
          "median": 1.09,
          "10%": 0.99,
          "90%": 1.17,
          "25%": 1.02,
          "75%": 1.14
        },
        "36061": {
          "name": "New York",
          "median": 1.1,
          "10%": 1.0,
          "90%": 1.24,
          "25%": 1.06,
          "75%": 1.16
        },
        "51700": {
          "name": "Newport News",
          "median": 1.11,
          "10%": 0.97,
          "90%": 1.21,
          "25%": 1.05,
          "75%": 1.16
        },
        "54067": {
          "name": "Nicholas",
          "median": 1.09,
          "10%": 1.02,
          "90%": 1.18,
          "25%": 1.05,
          "75%": 1.13
        },
        "51710": {
          "name": "Norfolk",
          "median": 1.1,
          "10%": 0.99,
          "90%": 1.26,
          "25%": 1.03,
          "75%": 1.18
        },
        "42095": {
          "name": "Northampton",
          "median": 1.12,
          "10%": 1.0,
          "90%": 1.25,
          "25%": 1.04,
          "75%": 1.18
        },
        "51131": {
          "name": "Northampton",
          "median": 1.11,
          "10%": 1.0,
          "90%": 1.23,
          "25%": 1.05,
          "75%": 1.17
        },
        "42097": {
          "name": "Northumberland",
          "median": 1.14,
          "10%": 1.03,
          "90%": 1.26,
          "25%": 1.07,
          "75%": 1.19
        },
        "51133": {
          "name": "Northumberland",
          "median": 1.1,
          "10%": 0.96,
          "90%": 1.22,
          "25%": 1.02,
          "75%": 1.17
        },
        "51720": {
          "name": "Norton",
          "median": 1.11,
          "10%": 0.99,
          "90%": 1.23,
          "25%": 1.05,
          "75%": 1.18
        },
        "51135": {
          "name": "Nottoway",
          "median": 1.09,
          "10%": 0.98,
          "90%": 1.25,
          "25%": 1.03,
          "75%": 1.15
        },
        "34029": {
          "name": "Ocean",
          "median": 1.09,
          "10%": 1.01,
          "90%": 1.22,
          "25%": 1.04,
          "75%": 1.15
        },
        "54069": {
          "name": "Ohio",
          "median": 1.11,
          "10%": 1.03,
          "90%": 1.2,
          "25%": 1.06,
          "75%": 1.15
        },
        "36065": {
          "name": "Oneida",
          "median": 1.09,
          "10%": 1.02,
          "90%": 1.18,
          "25%": 1.05,
          "75%": 1.12
        },
        "36067": {
          "name": "Onondaga",
          "median": 1.1,
          "10%": 1.03,
          "90%": 1.18,
          "25%": 1.06,
          "75%": 1.15
        },
        "36069": {
          "name": "Ontario",
          "median": 1.09,
          "10%": 0.97,
          "90%": 1.16,
          "25%": 1.03,
          "75%": 1.13
        },
        "36071": {
          "name": "Orange",
          "median": 1.1,
          "10%": 0.99,
          "90%": 1.27,
          "25%": 1.06,
          "75%": 1.2
        },
        "51137": {
          "name": "Orange",
          "median": 1.13,
          "10%": 1.0,
          "90%": 1.26,
          "25%": 1.07,
          "75%": 1.19
        },
        "36077": {
          "name": "Otsego",
          "median": 1.09,
          "10%": 1.02,
          "90%": 1.2,
          "25%": 1.04,
          "75%": 1.16
        },
        "51139": {
          "name": "Page",
          "median": 1.12,
          "10%": 1.02,
          "90%": 1.3,
          "25%": 1.07,
          "75%": 1.17
        },
        "51141": {
          "name": "Patrick",
          "median": 1.12,
          "10%": 1.0,
          "90%": 1.25,
          "25%": 1.06,
          "75%": 1.1925
        },
        "54071": {
          "name": "Pendleton",
          "median": 1.13,
          "10%": 1.01,
          "90%": 1.3,
          "25%": 1.08,
          "75%": 1.19
        },
        "42099": {
          "name": "Perry",
          "median": 1.14,
          "10%": 1.06,
          "90%": 1.26,
          "25%": 1.09,
          "75%": 1.19
        },
        "51730": {
          "name": "Petersburg",
          "median": 1.07,
          "10%": 0.95,
          "90%": 1.22,
          "25%": 1.03,
          "75%": 1.13
        },
        "42101": {
          "name": "Philadelphia",
          "median": 1.12,
          "10%": 1.01,
          "90%": 1.2,
          "25%": 1.05,
          "75%": 1.16
        },
        "42103": {
          "name": "Pike",
          "median": 1.14,
          "10%": 0.99,
          "90%": 1.24,
          "25%": 1.04,
          "75%": 1.18
        },
        "51143": {
          "name": "Pittsylvania",
          "median": 1.14,
          "10%": 1.03,
          "90%": 1.28,
          "25%": 1.11,
          "75%": 1.21
        },
        "54073": {
          "name": "Pleasants",
          "median": 1.06,
          "10%": 1.01,
          "90%": 1.2,
          "25%": 1.02,
          "75%": 1.14
        },
        "54075": {
          "name": "Pocahontas",
          "median": 1.11,
          "10%": 1.03,
          "90%": 1.19,
          "25%": 1.06,
          "75%": 1.16
        },
        "51735": {
          "name": "Poquoson",
          "median": 1.09,
          "10%": 0.97,
          "90%": 1.19,
          "25%": 1.04,
          "75%": 1.1625
        },
        "51740": {
          "name": "Portsmouth",
          "median": 1.09,
          "10%": 0.98,
          "90%": 1.26,
          "25%": 1.03,
          "75%": 1.17
        },
        "42105": {
          "name": "Potter",
          "median": 1.12,
          "10%": 1.01,
          "90%": 1.2,
          "25%": 1.06,
          "75%": 1.16
        },
        "51145": {
          "name": "Powhatan",
          "median": 1.08,
          "10%": 0.98,
          "90%": 1.24,
          "25%": 1.02,
          "75%": 1.15
        },
        "54077": {
          "name": "Preston",
          "median": 1.07,
          "10%": 1.02,
          "90%": 1.19,
          "25%": 1.05,
          "75%": 1.12
        },
        "51147": {
          "name": "Prince Edward",
          "median": 1.1,
          "10%": 1.0,
          "90%": 1.22,
          "25%": 1.06,
          "75%": 1.17
        },
        "51149": {
          "name": "Prince George",
          "median": 1.07,
          "10%": 0.96,
          "90%": 1.23,
          "25%": 1.02,
          "75%": 1.13
        },
        "24033": {
          "name": "Prince George's",
          "median": 1.08,
          "10%": 1.0,
          "90%": 1.2,
          "25%": 1.04,
          "75%": 1.14
        },
        "51153": {
          "name": "Prince William",
          "median": 1.09,
          "10%": 1.0,
          "90%": 1.18,
          "25%": 1.05,
          "75%": 1.14
        },
        "51155": {
          "name": "Pulaski",
          "median": 1.12,
          "10%": 1.03,
          "90%": 1.23,
          "25%": 1.08,
          "75%": 1.19
        },
        "54079": {
          "name": "Putnam",
          "median": 1.1,
          "10%": 1.02,
          "90%": 1.17,
          "25%": 1.04,
          "75%": 1.16
        },
        "24035": {
          "name": "Queen Anne's",
          "median": 1.09,
          "10%": 1.0,
          "90%": 1.17,
          "25%": 1.03,
          "75%": 1.15
        },
        "51750": {
          "name": "Radford",
          "median": 1.13,
          "10%": 1.02,
          "90%": 1.25,
          "25%": 1.09,
          "75%": 1.22
        },
        "54081": {
          "name": "Raleigh",
          "median": 1.11,
          "10%": 1.01,
          "90%": 1.21,
          "25%": 1.06,
          "75%": 1.16
        },
        "54083": {
          "name": "Randolph",
          "median": 1.09,
          "10%": 1.02,
          "90%": 1.17,
          "25%": 1.04,
          "75%": 1.13
        },
        "51157": {
          "name": "Rappahannock",
          "median": 1.14,
          "10%": 1.03,
          "90%": 1.23,
          "25%": 1.08,
          "75%": 1.19
        },
        "36085": {
          "name": "Richmond",
          "median": 1.08,
          "10%": 0.98,
          "90%": 1.26,
          "25%": 1.02,
          "75%": 1.15
        },
        "51159": {
          "name": "Richmond",
          "median": 1.11,
          "10%": 0.93,
          "90%": 1.24,
          "25%": 1.01,
          "75%": 1.18
        },
        "51760": {
          "name": "Richmond",
          "median": 1.08,
          "10%": 0.99,
          "90%": 1.19,
          "25%": 1.03,
          "75%": 1.17
        },
        "54085": {
          "name": "Ritchie",
          "median": 1.1,
          "10%": 1.03,
          "90%": 1.2,
          "25%": 1.06,
          "75%": 1.15
        },
        "54087": {
          "name": "Roane",
          "median": 1.11,
          "10%": 1.03,
          "90%": 1.19,
          "25%": 1.06,
          "75%": 1.15
        },
        "51161": {
          "name": "Roanoke",
          "median": 1.17,
          "10%": 1.01,
          "90%": 1.31,
          "25%": 1.1,
          "75%": 1.25
        },
        "51770": {
          "name": "Roanoke",
          "median": 1.16,
          "10%": 1.0,
          "90%": 1.31,
          "25%": 1.08,
          "75%": 1.23
        },
        "51163": {
          "name": "Rockbridge",
          "median": 1.15,
          "10%": 1.02,
          "90%": 1.28,
          "25%": 1.06,
          "75%": 1.22
        },
        "51165": {
          "name": "Rockingham",
          "median": 1.12,
          "10%": 1.01,
          "90%": 1.24,
          "25%": 1.05,
          "75%": 1.17
        },
        "51167": {
          "name": "Russell",
          "median": 1.1,
          "10%": 1.01,
          "90%": 1.19,
          "25%": 1.07,
          "75%": 1.13
        },
        "34033": {
          "name": "Salem",
          "median": 1.11,
          "10%": 1.04,
          "90%": 1.23,
          "25%": 1.06,
          "75%": 1.19
        },
        "51775": {
          "name": "Salem",
          "median": 1.175,
          "10%": 1.01,
          "90%": 1.33,
          "25%": 1.09,
          "75%": 1.26
        },
        "36095": {
          "name": "Schoharie",
          "median": 1.13,
          "10%": 1.03,
          "90%": 1.23,
          "25%": 1.08,
          "75%": 1.18
        },
        "36097": {
          "name": "Schuyler",
          "median": 1.11,
          "10%": 1.02,
          "90%": 1.25,
          "25%": 1.06,
          "75%": 1.16
        },
        "42107": {
          "name": "Schuylkill",
          "median": 1.13,
          "10%": 1.0,
          "90%": 1.23,
          "25%": 1.07,
          "75%": 1.18
        },
        "51169": {
          "name": "Scott",
          "median": 1.13,
          "10%": 1.05,
          "90%": 1.19,
          "25%": 1.07,
          "75%": 1.17
        },
        "51171": {
          "name": "Shenandoah",
          "median": 1.13,
          "10%": 1.02,
          "90%": 1.24,
          "25%": 1.07,
          "75%": 1.17
        },
        "51173": {
          "name": "Smyth",
          "median": 1.11,
          "10%": 1.05,
          "90%": 1.19,
          "25%": 1.07,
          "75%": 1.15
        },
        "42109": {
          "name": "Snyder",
          "median": 1.13,
          "10%": 1.04,
          "90%": 1.26,
          "25%": 1.08,
          "75%": 1.17
        },
        "24039": {
          "name": "Somerset",
          "median": 1.1,
          "10%": 1.01,
          "90%": 1.28,
          "25%": 1.05,
          "75%": 1.16
        },
        "42111": {
          "name": "Somerset",
          "median": 1.1,
          "10%": 1.04,
          "90%": 1.18,
          "25%": 1.06,
          "75%": 1.13
        },
        "51175": {
          "name": "Southampton",
          "median": 1.1,
          "10%": 0.99,
          "90%": 1.23,
          "25%": 1.03,
          "75%": 1.18
        },
        "51177": {
          "name": "Spotsylvania",
          "median": 1.11,
          "10%": 0.98,
          "90%": 1.25,
          "25%": 1.04,
          "75%": 1.16
        },
        "24037": {
          "name": "St. Mary's",
          "median": 1.09,
          "10%": 0.97,
          "90%": 1.2,
          "25%": 1.03,
          "75%": 1.16
        },
        "51179": {
          "name": "Stafford",
          "median": 1.11,
          "10%": 1.01,
          "90%": 1.25,
          "25%": 1.05,
          "75%": 1.17
        },
        "51790": {
          "name": "Staunton",
          "median": 1.13,
          "10%": 1.03,
          "90%": 1.36,
          "25%": 1.07,
          "75%": 1.21
        },
        "36101": {
          "name": "Steuben",
          "median": 1.11,
          "10%": 1.01,
          "90%": 1.19,
          "25%": 1.07,
          "75%": 1.15
        },
        "51800": {
          "name": "Suffolk",
          "median": 1.12,
          "10%": 0.97,
          "90%": 1.22,
          "25%": 1.05,
          "75%": 1.18
        },
        "36105": {
          "name": "Sullivan",
          "median": 1.14,
          "10%": 1.0,
          "90%": 1.24,
          "25%": 1.06,
          "75%": 1.19
        },
        "42113": {
          "name": "Sullivan",
          "median": 1.11,
          "10%": 0.99,
          "90%": 1.2,
          "25%": 1.04,
          "75%": 1.16
        },
        "54089": {
          "name": "Summers",
          "median": 1.09,
          "10%": 1.01,
          "90%": 1.18,
          "25%": 1.05,
          "75%": 1.14
        },
        "51181": {
          "name": "Surry",
          "median": 1.1,
          "10%": 0.99,
          "90%": 1.21,
          "25%": 1.05,
          "75%": 1.16
        },
        "42115": {
          "name": "Susquehanna",
          "median": 1.09,
          "10%": 1.01,
          "90%": 1.2,
          "25%": 1.05,
          "75%": 1.15
        },
        "10005": {
          "name": "Sussex",
          "median": 1.1,
          "10%": 1.02,
          "90%": 1.21,
          "25%": 1.04,
          "75%": 1.13
        },
        "34037": {
          "name": "Sussex",
          "median": 1.13,
          "10%": 1.0,
          "90%": 1.29,
          "25%": 1.06,
          "75%": 1.18
        },
        "51183": {
          "name": "Sussex",
          "median": 1.1,
          "10%": 0.97,
          "90%": 1.22,
          "25%": 1.02,
          "75%": 1.17
        },
        "24041": {
          "name": "Talbot",
          "median": 1.07,
          "10%": 0.99,
          "90%": 1.2,
          "25%": 1.02,
          "75%": 1.12
        },
        "54091": {
          "name": "Taylor",
          "median": 1.07,
          "10%": 1.01,
          "90%": 1.2,
          "25%": 1.04,
          "75%": 1.15
        },
        "51185": {
          "name": "Tazewell",
          "median": 1.09,
          "10%": 1.05,
          "90%": 1.19,
          "25%": 1.06,
          "75%": 1.12
        },
        "36107": {
          "name": "Tioga",
          "median": 1.09,
          "10%": 1.0,
          "90%": 1.18,
          "25%": 1.04,
          "75%": 1.13
        },
        "42117": {
          "name": "Tioga",
          "median": 1.11,
          "10%": 1.01,
          "90%": 1.2,
          "25%": 1.06,
          "75%": 1.14
        },
        "36109": {
          "name": "Tompkins",
          "median": 1.11,
          "10%": 1.03,
          "90%": 1.18,
          "25%": 1.06,
          "75%": 1.15
        },
        "54093": {
          "name": "Tucker",
          "median": 1.08,
          "10%": 1.0,
          "90%": 1.19,
          "25%": 1.03,
          "75%": 1.13
        },
        "54095": {
          "name": "Tyler",
          "median": 1.06,
          "10%": 0.98,
          "90%": 1.18,
          "25%": 1.01,
          "75%": 1.11
        },
        "36111": {
          "name": "Ulster",
          "median": 1.13,
          "10%": 1.04,
          "90%": 1.31,
          "25%": 1.08,
          "75%": 1.22
        },
        "42119": {
          "name": "Union",
          "median": 1.11,
          "10%": 1.04,
          "90%": 1.23,
          "25%": 1.08,
          "75%": 1.15
        },
        "54097": {
          "name": "Upshur",
          "median": 1.08,
          "10%": 1.0,
          "90%": 1.15,
          "25%": 1.04,
          "75%": 1.1
        },
        "42121": {
          "name": "Venango",
          "median": 1.12,
          "10%": 1.01,
          "90%": 1.22,
          "25%": 1.07,
          "75%": 1.16
        },
        "51810": {
          "name": "Virginia Beach",
          "median": 1.11,
          "10%": 0.99,
          "90%": 1.28,
          "25%": 1.07,
          "75%": 1.19
        },
        "34041": {
          "name": "Warren",
          "median": 1.12,
          "10%": 1.01,
          "90%": 1.28,
          "25%": 1.05,
          "75%": 1.22
        },
        "42123": {
          "name": "Warren",
          "median": 1.1,
          "10%": 1.01,
          "90%": 1.25,
          "25%": 1.05,
          "75%": 1.17
        },
        "51187": {
          "name": "Warren",
          "median": 1.15,
          "10%": 1.05,
          "90%": 1.26,
          "25%": 1.09,
          "75%": 1.2
        },
        "24043": {
          "name": "Washington",
          "median": 1.13,
          "10%": 1.05,
          "90%": 1.27,
          "25%": 1.09,
          "75%": 1.19
        },
        "42125": {
          "name": "Washington",
          "median": 1.1,
          "10%": 0.99,
          "90%": 1.2,
          "25%": 1.04,
          "75%": 1.16
        },
        "51191": {
          "name": "Washington",
          "median": 1.1,
          "10%": 1.03,
          "90%": 1.17,
          "25%": 1.06,
          "75%": 1.13
        },
        "42127": {
          "name": "Wayne",
          "median": 1.12,
          "10%": 0.99,
          "90%": 1.23,
          "25%": 1.02,
          "75%": 1.17
        },
        "54099": {
          "name": "Wayne",
          "median": 1.09,
          "10%": 1.03,
          "90%": 1.18,
          "25%": 1.05,
          "75%": 1.13
        },
        "51820": {
          "name": "Waynesboro",
          "median": 1.13,
          "10%": 1.02,
          "90%": 1.36,
          "25%": 1.08,
          "75%": 1.23
        },
        "54101": {
          "name": "Webster",
          "median": 1.08,
          "10%": 1.02,
          "90%": 1.16,
          "25%": 1.04,
          "75%": 1.11
        },
        "36119": {
          "name": "Westchester",
          "median": 1.12,
          "10%": 1.02,
          "90%": 1.23,
          "25%": 1.07,
          "75%": 1.19
        },
        "42129": {
          "name": "Westmoreland",
          "median": 1.07,
          "10%": 1.0,
          "90%": 1.17,
          "25%": 1.05,
          "75%": 1.13
        },
        "51193": {
          "name": "Westmoreland",
          "median": 1.09,
          "10%": 0.94,
          "90%": 1.22,
          "25%": 1.0,
          "75%": 1.17
        },
        "54103": {
          "name": "Wetzel",
          "median": 1.11,
          "10%": 1.02,
          "90%": 1.18,
          "25%": 1.06,
          "75%": 1.13
        },
        "24045": {
          "name": "Wicomico",
          "median": 1.1,
          "10%": 0.99,
          "90%": 1.24,
          "25%": 1.04,
          "75%": 1.16
        },
        "51830": {
          "name": "Williamsburg",
          "median": 1.08,
          "10%": 0.96,
          "90%": 1.19,
          "25%": 1.01,
          "75%": 1.12
        },
        "51840": {
          "name": "Winchester",
          "median": 1.13,
          "10%": 1.02,
          "90%": 1.28,
          "25%": 1.08,
          "75%": 1.21
        },
        "54105": {
          "name": "Wirt",
          "median": 1.15,
          "10%": 1.02,
          "90%": 1.23,
          "25%": 1.08,
          "75%": 1.19
        },
        "51195": {
          "name": "Wise",
          "median": 1.1,
          "10%": 1.01,
          "90%": 1.22,
          "25%": 1.06,
          "75%": 1.16
        },
        "54107": {
          "name": "Wood",
          "median": 1.1,
          "10%": 1.01,
          "90%": 1.21,
          "25%": 1.06,
          "75%": 1.18
        },
        "24047": {
          "name": "Worcester",
          "median": 1.11,
          "10%": 1.0,
          "90%": 1.24,
          "25%": 1.06,
          "75%": 1.17
        },
        "42131": {
          "name": "Wyoming",
          "median": 1.11,
          "10%": 1.0,
          "90%": 1.19,
          "25%": 1.07,
          "75%": 1.16
        },
        "54109": {
          "name": "Wyoming",
          "median": 1.11,
          "10%": 1.03,
          "90%": 1.24,
          "25%": 1.06,
          "75%": 1.15
        },
        "51197": {
          "name": "Wythe",
          "median": 1.11,
          "10%": 1.02,
          "90%": 1.19,
          "25%": 1.05,
          "75%": 1.15
        },
        "36123": {
          "name": "Yates",
          "median": 1.1,
          "10%": 0.99,
          "90%": 1.18,
          "25%": 1.06,
          "75%": 1.14
        },
        "42133": {
          "name": "York",
          "median": 1.12,
          "10%": 1.01,
          "90%": 1.23,
          "25%": 1.06,
          "75%": 1.16
        },
        "51199": {
          "name": "York",
          "median": 1.09,
          "10%": 0.98,
          "90%": 1.19,
          "25%": 1.04,
          "75%": 1.14
        },
        "max": 1.175,
        "min": 1
      },
      "10": {
        "51001": {
          "name": "Accomack",
          "median": 1.13,
          "10%": 0.99,
          "90%": 1.21,
          "25%": 1.06,
          "75%": 1.17
        },
        "42001": {
          "name": "Adams",
          "median": 1.12,
          "10%": 0.99,
          "90%": 1.27,
          "25%": 1.03,
          "75%": 1.2
        },
        "51003": {
          "name": "Albemarle",
          "median": 1.13,
          "10%": 0.97,
          "90%": 1.33,
          "25%": 1.05,
          "75%": 1.21
        },
        "51510": {
          "name": "Alexandria",
          "median": 1.08,
          "10%": 0.94,
          "90%": 1.24,
          "25%": 1.01,
          "75%": 1.17
        },
        "24001": {
          "name": "Allegany",
          "median": 1.13,
          "10%": 1.03,
          "90%": 1.26,
          "25%": 1.07,
          "75%": 1.19
        },
        "36003": {
          "name": "Allegany",
          "median": 1.1,
          "10%": 0.99,
          "90%": 1.22,
          "25%": 1.04,
          "75%": 1.17
        },
        "51005": {
          "name": "Alleghany",
          "median": 1.13,
          "10%": 1.02,
          "90%": 1.29,
          "25%": 1.06,
          "75%": 1.2
        },
        "42003": {
          "name": "Allegheny",
          "median": 1.09,
          "10%": 0.99,
          "90%": 1.21,
          "25%": 1.03,
          "75%": 1.16
        },
        "51007": {
          "name": "Amelia",
          "median": 1.09,
          "10%": 0.98,
          "90%": 1.31,
          "25%": 1.02,
          "75%": 1.16
        },
        "51009": {
          "name": "Amherst",
          "median": 1.15,
          "10%": 1.01,
          "90%": 1.3,
          "25%": 1.06,
          "75%": 1.23
        },
        "24003": {
          "name": "Anne Arundel",
          "median": 1.07,
          "10%": 0.97,
          "90%": 1.22,
          "25%": 1.0,
          "75%": 1.15
        },
        "51011": {
          "name": "Appomattox",
          "median": 1.14,
          "10%": 0.99,
          "90%": 1.31,
          "25%": 1.06,
          "75%": 1.22
        },
        "51013": {
          "name": "Arlington",
          "median": 1.08,
          "10%": 0.95,
          "90%": 1.22,
          "25%": 1.0175,
          "75%": 1.16
        },
        "42005": {
          "name": "Armstrong",
          "median": 1.1,
          "10%": 0.99,
          "90%": 1.24,
          "25%": 1.06,
          "75%": 1.18
        },
        "34001": {
          "name": "Atlantic",
          "median": 1.11,
          "10%": 1.02,
          "90%": 1.25,
          "25%": 1.06,
          "75%": 1.18
        },
        "51015": {
          "name": "Augusta",
          "median": 1.12,
          "10%": 1.01,
          "90%": 1.31,
          "25%": 1.07,
          "75%": 1.22
        },
        "24005": {
          "name": "Baltimore",
          "median": 1.1,
          "10%": 0.98,
          "90%": 1.23,
          "25%": 1.04,
          "75%": 1.14
        },
        "24510": {
          "name": "Baltimore",
          "median": 1.09,
          "10%": 0.98,
          "90%": 1.26,
          "25%": 1.03,
          "75%": 1.17
        },
        "54001": {
          "name": "Barbour",
          "median": 1.07,
          "10%": 1.01,
          "90%": 1.18,
          "25%": 1.02,
          "75%": 1.15
        },
        "51017": {
          "name": "Bath",
          "median": 1.14,
          "10%": 1.03,
          "90%": 1.32,
          "25%": 1.08,
          "75%": 1.2
        },
        "42007": {
          "name": "Beaver",
          "median": 1.09,
          "10%": 0.99,
          "90%": 1.22,
          "25%": 1.04,
          "75%": 1.15
        },
        "42009": {
          "name": "Bedford",
          "median": 1.14,
          "10%": 1.05,
          "90%": 1.25,
          "25%": 1.09,
          "75%": 1.18
        },
        "51019": {
          "name": "Bedford",
          "median": 1.15,
          "10%": 1.03,
          "90%": 1.3,
          "25%": 1.07,
          "75%": 1.22
        },
        "54003": {
          "name": "Berkeley",
          "median": 1.13,
          "10%": 1.02,
          "90%": 1.29,
          "25%": 1.08,
          "75%": 1.2
        },
        "42011": {
          "name": "Berks",
          "median": 1.12,
          "10%": 0.99,
          "90%": 1.29,
          "25%": 1.04,
          "75%": 1.22
        },
        "42013": {
          "name": "Blair",
          "median": 1.14,
          "10%": 1.05,
          "90%": 1.25,
          "25%": 1.08,
          "75%": 1.18
        },
        "51021": {
          "name": "Bland",
          "median": 1.11,
          "10%": 1.01,
          "90%": 1.19,
          "25%": 1.05,
          "75%": 1.15
        },
        "54005": {
          "name": "Boone",
          "median": 1.11,
          "10%": 1.01,
          "90%": 1.16,
          "25%": 1.05,
          "75%": 1.14
        },
        "51023": {
          "name": "Botetourt",
          "median": 1.17,
          "10%": 1.03,
          "90%": 1.3,
          "25%": 1.07,
          "75%": 1.24
        },
        "42015": {
          "name": "Bradford",
          "median": 1.08,
          "10%": 0.97,
          "90%": 1.22,
          "25%": 1.04,
          "75%": 1.16
        },
        "54007": {
          "name": "Braxton",
          "median": 1.08,
          "10%": 1.01,
          "90%": 1.17,
          "25%": 1.04,
          "75%": 1.14
        },
        "51520": {
          "name": "Bristol",
          "median": 1.11,
          "10%": 1.02,
          "90%": 1.21,
          "25%": 1.04,
          "75%": 1.16
        },
        "36005": {
          "name": "Bronx",
          "median": 1.12,
          "10%": 0.98,
          "90%": 1.25,
          "25%": 1.04,
          "75%": 1.18
        },
        "54009": {
          "name": "Brooke",
          "median": 1.12,
          "10%": 0.97,
          "90%": 1.26,
          "25%": 1.05,
          "75%": 1.17
        },
        "36007": {
          "name": "Broome",
          "median": 1.09,
          "10%": 1.01,
          "90%": 1.23,
          "25%": 1.04,
          "75%": 1.17
        },
        "51025": {
          "name": "Brunswick",
          "median": 1.1,
          "10%": 0.95,
          "90%": 1.27,
          "25%": 1.0,
          "75%": 1.16
        },
        "51027": {
          "name": "Buchanan",
          "median": 1.09,
          "10%": 1.0,
          "90%": 1.21,
          "25%": 1.04,
          "75%": 1.15
        },
        "51029": {
          "name": "Buckingham",
          "median": 1.11,
          "10%": 0.99,
          "90%": 1.28,
          "25%": 1.04,
          "75%": 1.19
        },
        "42017": {
          "name": "Bucks",
          "median": 1.1,
          "10%": 1.01,
          "90%": 1.2,
          "25%": 1.03,
          "75%": 1.16
        },
        "51530": {
          "name": "Buena Vista",
          "median": 1.13,
          "10%": 0.98,
          "90%": 1.35,
          "25%": 1.06,
          "75%": 1.25
        },
        "34005": {
          "name": "Burlington",
          "median": 1.09,
          "10%": 1.0,
          "90%": 1.2,
          "25%": 1.03,
          "75%": 1.15
        },
        "42019": {
          "name": "Butler",
          "median": 1.1,
          "10%": 0.99,
          "90%": 1.21,
          "25%": 1.05,
          "75%": 1.16
        },
        "54011": {
          "name": "Cabell",
          "median": 1.11,
          "10%": 1.01,
          "90%": 1.2,
          "25%": 1.04,
          "75%": 1.16
        },
        "54013": {
          "name": "Calhoun",
          "median": 1.13,
          "10%": 1.02,
          "90%": 1.25,
          "25%": 1.07,
          "75%": 1.19
        },
        "24009": {
          "name": "Calvert",
          "median": 1.07,
          "10%": 0.98,
          "90%": 1.23,
          "25%": 1.03,
          "75%": 1.17
        },
        "42021": {
          "name": "Cambria",
          "median": 1.08,
          "10%": 1.0,
          "90%": 1.2,
          "25%": 1.04,
          "75%": 1.16
        },
        "34007": {
          "name": "Camden",
          "median": 1.09,
          "10%": 1.02,
          "90%": 1.22,
          "25%": 1.05,
          "75%": 1.16
        },
        "42023": {
          "name": "Cameron",
          "median": 1.11,
          "10%": 0.99,
          "90%": 1.21,
          "25%": 1.05,
          "75%": 1.16
        },
        "51031": {
          "name": "Campbell",
          "median": 1.15,
          "10%": 1.01,
          "90%": 1.28,
          "25%": 1.09,
          "75%": 1.21
        },
        "34009": {
          "name": "Cape May",
          "median": 1.11,
          "10%": 1.01,
          "90%": 1.24,
          "25%": 1.05,
          "75%": 1.17
        },
        "42025": {
          "name": "Carbon",
          "median": 1.12,
          "10%": 0.97,
          "90%": 1.25,
          "25%": 1.05,
          "75%": 1.21
        },
        "24011": {
          "name": "Caroline",
          "median": 1.1,
          "10%": 0.99,
          "90%": 1.22,
          "25%": 1.04,
          "75%": 1.15
        },
        "51033": {
          "name": "Caroline",
          "median": 1.1,
          "10%": 0.98,
          "90%": 1.23,
          "25%": 1.02,
          "75%": 1.17
        },
        "24013": {
          "name": "Carroll",
          "median": 1.11,
          "10%": 1.0,
          "90%": 1.26,
          "25%": 1.06,
          "75%": 1.18
        },
        "51035": {
          "name": "Carroll",
          "median": 1.12,
          "10%": 1.03,
          "90%": 1.23,
          "25%": 1.07,
          "75%": 1.18
        },
        "24015": {
          "name": "Cecil",
          "median": 1.12,
          "10%": 1.01,
          "90%": 1.24,
          "25%": 1.05,
          "75%": 1.21
        },
        "42027": {
          "name": "Centre",
          "median": 1.12,
          "10%": 1.01,
          "90%": 1.23,
          "25%": 1.08,
          "75%": 1.19
        },
        "24017": {
          "name": "Charles",
          "median": 1.09,
          "10%": 0.97,
          "90%": 1.23,
          "25%": 1.02,
          "75%": 1.19
        },
        "51036": {
          "name": "Charles City",
          "median": 1.08,
          "10%": 0.98,
          "90%": 1.22,
          "25%": 1.01,
          "75%": 1.14
        },
        "51037": {
          "name": "Charlotte",
          "median": 1.11,
          "10%": 1.02,
          "90%": 1.25,
          "25%": 1.05,
          "75%": 1.19
        },
        "51540": {
          "name": "Charlottesville",
          "median": 1.13,
          "10%": 0.97,
          "90%": 1.3,
          "25%": 1.04,
          "75%": 1.2
        },
        "36015": {
          "name": "Chemung",
          "median": 1.11,
          "10%": 1.0,
          "90%": 1.2,
          "25%": 1.05,
          "75%": 1.16
        },
        "36017": {
          "name": "Chenango",
          "median": 1.09,
          "10%": 0.99,
          "90%": 1.21,
          "25%": 1.04,
          "75%": 1.14
        },
        "51550": {
          "name": "Chesapeake",
          "median": 1.11,
          "10%": 0.97,
          "90%": 1.28,
          "25%": 1.04,
          "75%": 1.2
        },
        "42029": {
          "name": "Chester",
          "median": 1.11,
          "10%": 0.99,
          "90%": 1.31,
          "25%": 1.03,
          "75%": 1.2
        },
        "51041": {
          "name": "Chesterfield",
          "median": 1.1,
          "10%": 0.97,
          "90%": 1.26,
          "25%": 1.02,
          "75%": 1.17
        },
        "42031": {
          "name": "Clarion",
          "median": 1.11,
          "10%": 1.03,
          "90%": 1.22,
          "25%": 1.07,
          "75%": 1.16
        },
        "51043": {
          "name": "Clarke",
          "median": 1.12,
          "10%": 1.0,
          "90%": 1.28,
          "25%": 1.07,
          "75%": 1.2
        },
        "54015": {
          "name": "Clay",
          "median": 1.08,
          "10%": 1.0,
          "90%": 1.16,
          "25%": 1.03,
          "75%": 1.12
        },
        "42033": {
          "name": "Clearfield",
          "median": 1.1,
          "10%": 1.02,
          "90%": 1.21,
          "25%": 1.06,
          "75%": 1.17
        },
        "42035": {
          "name": "Clinton",
          "median": 1.12,
          "10%": 0.98,
          "90%": 1.23,
          "25%": 1.05,
          "75%": 1.18
        },
        "51570": {
          "name": "Colonial Heights",
          "median": 1.09,
          "10%": 0.93,
          "90%": 1.26,
          "25%": 1.03,
          "75%": 1.15
        },
        "42037": {
          "name": "Columbia",
          "median": 1.14,
          "10%": 0.98,
          "90%": 1.28,
          "25%": 1.08,
          "75%": 1.2
        },
        "36023": {
          "name": "Cortland",
          "median": 1.09,
          "10%": 1.02,
          "90%": 1.22,
          "25%": 1.05,
          "75%": 1.16
        },
        "51580": {
          "name": "Covington",
          "median": 1.13,
          "10%": 0.99,
          "90%": 1.31,
          "25%": 1.04,
          "75%": 1.21
        },
        "51045": {
          "name": "Craig",
          "median": 1.15,
          "10%": 1.03,
          "90%": 1.3,
          "25%": 1.08,
          "75%": 1.21
        },
        "42039": {
          "name": "Crawford",
          "median": 1.12,
          "10%": 1.0,
          "90%": 1.24,
          "25%": 1.04,
          "75%": 1.19
        },
        "51047": {
          "name": "Culpeper",
          "median": 1.13,
          "10%": 1.03,
          "90%": 1.22,
          "25%": 1.07,
          "75%": 1.18
        },
        "34011": {
          "name": "Cumberland",
          "median": 1.11,
          "10%": 1.0,
          "90%": 1.24,
          "25%": 1.05,
          "75%": 1.19
        },
        "42041": {
          "name": "Cumberland",
          "median": 1.13,
          "10%": 1.03,
          "90%": 1.3,
          "25%": 1.08,
          "75%": 1.17
        },
        "51049": {
          "name": "Cumberland",
          "median": 1.1,
          "10%": 0.97,
          "90%": 1.28,
          "25%": 1.04,
          "75%": 1.16
        },
        "51590": {
          "name": "Danville",
          "median": 1.12,
          "10%": 1.04,
          "90%": 1.28,
          "25%": 1.07,
          "75%": 1.19
        },
        "42043": {
          "name": "Dauphin",
          "median": 1.14,
          "10%": 1.0,
          "90%": 1.35,
          "25%": 1.08,
          "75%": 1.22
        },
        "36025": {
          "name": "Delaware",
          "median": 1.11,
          "10%": 1.02,
          "90%": 1.24,
          "25%": 1.06,
          "75%": 1.18
        },
        "42045": {
          "name": "Delaware",
          "median": 1.11,
          "10%": 1.01,
          "90%": 1.27,
          "25%": 1.06,
          "75%": 1.2
        },
        "51051": {
          "name": "Dickenson",
          "median": 1.08,
          "10%": 1.0,
          "90%": 1.19,
          "25%": 1.05,
          "75%": 1.14
        },
        "51053": {
          "name": "Dinwiddie",
          "median": 1.09,
          "10%": 0.98,
          "90%": 1.25,
          "25%": 1.02,
          "75%": 1.15
        },
        "11001": {
          "name": "District of Columbia",
          "median": 1.07,
          "10%": 0.95,
          "90%": 1.24,
          "25%": 1.02,
          "75%": 1.16
        },
        "54017": {
          "name": "Doddridge",
          "median": 1.05,
          "10%": 0.99,
          "90%": 1.18,
          "25%": 1.02,
          "75%": 1.11
        },
        "24019": {
          "name": "Dorchester",
          "median": 1.06,
          "10%": 0.95,
          "90%": 1.24,
          "25%": 1.02,
          "75%": 1.15
        },
        "42047": {
          "name": "Elk",
          "median": 1.115,
          "10%": 0.98,
          "90%": 1.2,
          "25%": 1.04,
          "75%": 1.17
        },
        "51595": {
          "name": "Emporia",
          "median": 1.07,
          "10%": 0.96,
          "90%": 1.19,
          "25%": 1.0,
          "75%": 1.15
        },
        "42049": {
          "name": "Erie",
          "median": 1.13,
          "10%": 1.01,
          "90%": 1.24,
          "25%": 1.04,
          "75%": 1.17
        },
        "51057": {
          "name": "Essex",
          "median": 1.11,
          "10%": 0.95,
          "90%": 1.22,
          "25%": 1.0,
          "75%": 1.18
        },
        "51059": {
          "name": "Fairfax",
          "median": 1.07,
          "10%": 0.98,
          "90%": 1.21,
          "25%": 1.04,
          "75%": 1.12
        },
        "51600": {
          "name": "Fairfax",
          "median": 1.07,
          "10%": 0.97,
          "90%": 1.21,
          "25%": 1.01,
          "75%": 1.13
        },
        "51610": {
          "name": "Falls Church",
          "median": 1.07,
          "10%": 0.96,
          "90%": 1.22,
          "25%": 1.01,
          "75%": 1.14
        },
        "51061": {
          "name": "Fauquier",
          "median": 1.12,
          "10%": 1.01,
          "90%": 1.27,
          "25%": 1.07,
          "75%": 1.2
        },
        "42051": {
          "name": "Fayette",
          "median": 1.07,
          "10%": 0.99,
          "90%": 1.19,
          "25%": 1.02,
          "75%": 1.14
        },
        "54019": {
          "name": "Fayette",
          "median": 1.09,
          "10%": 1.0,
          "90%": 1.2,
          "25%": 1.06,
          "75%": 1.13
        },
        "51063": {
          "name": "Floyd",
          "median": 1.14,
          "10%": 1.01,
          "90%": 1.29,
          "25%": 1.06,
          "75%": 1.2
        },
        "51065": {
          "name": "Fluvanna",
          "median": 1.11,
          "10%": 0.99,
          "90%": 1.35,
          "25%": 1.04,
          "75%": 1.21
        },
        "42053": {
          "name": "Forest",
          "median": 1.12,
          "10%": 0.99,
          "90%": 1.25,
          "25%": 1.04,
          "75%": 1.17
        },
        "42055": {
          "name": "Franklin",
          "median": 1.11,
          "10%": 1.02,
          "90%": 1.29,
          "25%": 1.07,
          "75%": 1.19
        },
        "51067": {
          "name": "Franklin",
          "median": 1.15,
          "10%": 1.01,
          "90%": 1.29,
          "25%": 1.07,
          "75%": 1.23
        },
        "51620": {
          "name": "Franklin",
          "median": 1.1,
          "10%": 0.96,
          "90%": 1.26,
          "25%": 1.04,
          "75%": 1.21
        },
        "24021": {
          "name": "Frederick",
          "median": 1.11,
          "10%": 1.0,
          "90%": 1.29,
          "25%": 1.05,
          "75%": 1.19
        },
        "51069": {
          "name": "Frederick",
          "median": 1.13,
          "10%": 1.02,
          "90%": 1.33,
          "25%": 1.08,
          "75%": 1.19
        },
        "51630": {
          "name": "Fredericksburg",
          "median": 1.13,
          "10%": 0.96,
          "90%": 1.28,
          "25%": 1.03,
          "75%": 1.19
        },
        "42057": {
          "name": "Fulton",
          "median": 1.15,
          "10%": 1.05,
          "90%": 1.29,
          "25%": 1.09,
          "75%": 1.22
        },
        "51640": {
          "name": "Galax",
          "median": 1.13,
          "10%": 0.95,
          "90%": 1.25,
          "25%": 1.02,
          "75%": 1.18
        },
        "24023": {
          "name": "Garrett",
          "median": 1.08,
          "10%": 1.01,
          "90%": 1.22,
          "25%": 1.04,
          "75%": 1.12
        },
        "51071": {
          "name": "Giles",
          "median": 1.14,
          "10%": 1.03,
          "90%": 1.23,
          "25%": 1.07,
          "75%": 1.18
        },
        "54021": {
          "name": "Gilmer",
          "median": 1.11,
          "10%": 1.0,
          "90%": 1.2,
          "25%": 1.06,
          "75%": 1.16
        },
        "34015": {
          "name": "Gloucester",
          "median": 1.11,
          "10%": 1.04,
          "90%": 1.22,
          "25%": 1.07,
          "75%": 1.17
        },
        "51073": {
          "name": "Gloucester",
          "median": 1.09,
          "10%": 0.98,
          "90%": 1.22,
          "25%": 1.02,
          "75%": 1.15
        },
        "51075": {
          "name": "Goochland",
          "median": 1.12,
          "10%": 0.95,
          "90%": 1.33,
          "25%": 1.01,
          "75%": 1.2
        },
        "54023": {
          "name": "Grant",
          "median": 1.08,
          "10%": 1.01,
          "90%": 1.25,
          "25%": 1.04,
          "75%": 1.14
        },
        "51077": {
          "name": "Grayson",
          "median": 1.12,
          "10%": 1.01,
          "90%": 1.23,
          "25%": 1.07,
          "75%": 1.16
        },
        "54025": {
          "name": "Greenbrier",
          "median": 1.12,
          "10%": 1.05,
          "90%": 1.22,
          "25%": 1.08,
          "75%": 1.17
        },
        "36039": {
          "name": "Greene",
          "median": 1.19,
          "10%": 1.02,
          "90%": 1.31,
          "25%": 1.08,
          "75%": 1.24
        },
        "42059": {
          "name": "Greene",
          "median": 1.11,
          "10%": 1.02,
          "90%": 1.21,
          "25%": 1.06,
          "75%": 1.17
        },
        "51079": {
          "name": "Greene",
          "median": 1.12,
          "10%": 0.97,
          "90%": 1.3,
          "25%": 1.04,
          "75%": 1.22
        },
        "51081": {
          "name": "Greensville",
          "median": 1.09,
          "10%": 0.95,
          "90%": 1.21,
          "25%": 1.01,
          "75%": 1.15
        },
        "51083": {
          "name": "Halifax",
          "median": 1.14,
          "10%": 1.03,
          "90%": 1.26,
          "25%": 1.08,
          "75%": 1.2
        },
        "54027": {
          "name": "Hampshire",
          "median": 1.13,
          "10%": 1.03,
          "90%": 1.29,
          "25%": 1.07,
          "75%": 1.2
        },
        "51650": {
          "name": "Hampton",
          "median": 1.1,
          "10%": 0.96,
          "90%": 1.22,
          "25%": 1.03,
          "75%": 1.17
        },
        "54029": {
          "name": "Hancock",
          "median": 1.12,
          "10%": 1.0,
          "90%": 1.23,
          "25%": 1.03,
          "75%": 1.19
        },
        "51085": {
          "name": "Hanover",
          "median": 1.09,
          "10%": 0.98,
          "90%": 1.24,
          "25%": 1.02,
          "75%": 1.16
        },
        "54031": {
          "name": "Hardy",
          "median": 1.11,
          "10%": 1.03,
          "90%": 1.25,
          "25%": 1.05,
          "75%": 1.17
        },
        "24025": {
          "name": "Harford",
          "median": 1.11,
          "10%": 0.98,
          "90%": 1.24,
          "25%": 1.05,
          "75%": 1.17
        },
        "54033": {
          "name": "Harrison",
          "median": 1.07,
          "10%": 1.0,
          "90%": 1.21,
          "25%": 1.03,
          "75%": 1.13
        },
        "51660": {
          "name": "Harrisonburg",
          "median": 1.1,
          "10%": 0.99,
          "90%": 1.3,
          "25%": 1.03,
          "75%": 1.18
        },
        "51087": {
          "name": "Henrico",
          "median": 1.09,
          "10%": 0.98,
          "90%": 1.22,
          "25%": 1.02,
          "75%": 1.17
        },
        "51089": {
          "name": "Henry",
          "median": 1.15,
          "10%": 1.01,
          "90%": 1.35,
          "25%": 1.08,
          "75%": 1.25
        },
        "36043": {
          "name": "Herkimer",
          "median": 1.05,
          "10%": 0.96,
          "90%": 1.14,
          "25%": 1.01,
          "75%": 1.1
        },
        "51091": {
          "name": "Highland",
          "median": 1.11,
          "10%": 1.02,
          "90%": 1.26,
          "25%": 1.05,
          "75%": 1.19
        },
        "51670": {
          "name": "Hopewell",
          "median": 1.07,
          "10%": 0.94,
          "90%": 1.25,
          "25%": 0.98,
          "75%": 1.13
        },
        "24027": {
          "name": "Howard",
          "median": 1.1,
          "10%": 0.99,
          "90%": 1.26,
          "25%": 1.06,
          "75%": 1.17
        },
        "34019": {
          "name": "Hunterdon",
          "median": 1.11,
          "10%": 1.0,
          "90%": 1.3,
          "25%": 1.04,
          "75%": 1.2
        },
        "42061": {
          "name": "Huntingdon",
          "median": 1.15,
          "10%": 1.02,
          "90%": 1.25,
          "25%": 1.07,
          "75%": 1.21
        },
        "42063": {
          "name": "Indiana",
          "median": 1.1,
          "10%": 0.99,
          "90%": 1.2,
          "25%": 1.03,
          "75%": 1.16
        },
        "51093": {
          "name": "Isle of Wight",
          "median": 1.12,
          "10%": 0.96,
          "90%": 1.25,
          "25%": 1.05,
          "75%": 1.19
        },
        "54035": {
          "name": "Jackson",
          "median": 1.12,
          "10%": 1.0,
          "90%": 1.22,
          "25%": 1.06,
          "75%": 1.18
        },
        "51095": {
          "name": "James City",
          "median": 1.08,
          "10%": 0.96,
          "90%": 1.21,
          "25%": 1.0,
          "75%": 1.15
        },
        "42065": {
          "name": "Jefferson",
          "median": 1.12,
          "10%": 1.0,
          "90%": 1.2,
          "25%": 1.05,
          "75%": 1.17
        },
        "54037": {
          "name": "Jefferson",
          "median": 1.12,
          "10%": 1.0,
          "90%": 1.26,
          "25%": 1.05,
          "75%": 1.19
        },
        "42067": {
          "name": "Juniata",
          "median": 1.12,
          "10%": 1.05,
          "90%": 1.28,
          "25%": 1.08,
          "75%": 1.2
        },
        "54039": {
          "name": "Kanawha",
          "median": 1.06,
          "10%": 0.98,
          "90%": 1.14,
          "25%": 1.02,
          "75%": 1.11
        },
        "10001": {
          "name": "Kent",
          "median": 1.1,
          "10%": 0.99,
          "90%": 1.2,
          "25%": 1.03,
          "75%": 1.15
        },
        "24029": {
          "name": "Kent",
          "median": 1.09,
          "10%": 0.97,
          "90%": 1.2,
          "25%": 1.01,
          "75%": 1.15
        },
        "51099": {
          "name": "King George",
          "median": 1.09,
          "10%": 0.96,
          "90%": 1.28,
          "25%": 0.99,
          "75%": 1.19
        },
        "51101": {
          "name": "King William",
          "median": 1.08,
          "10%": 0.97,
          "90%": 1.21,
          "25%": 1.02,
          "75%": 1.15
        },
        "51097": {
          "name": "King and Queen",
          "median": 1.1,
          "10%": 0.97,
          "90%": 1.19,
          "25%": 1.0,
          "75%": 1.14
        },
        "42069": {
          "name": "Lackawanna",
          "median": 1.14,
          "10%": 0.97,
          "90%": 1.27,
          "25%": 1.05,
          "75%": 1.23
        },
        "42071": {
          "name": "Lancaster",
          "median": 1.14,
          "10%": 0.99,
          "90%": 1.3,
          "25%": 1.05,
          "75%": 1.21
        },
        "51103": {
          "name": "Lancaster",
          "median": 1.1,
          "10%": 0.96,
          "90%": 1.18,
          "25%": 1.0,
          "75%": 1.15
        },
        "42073": {
          "name": "Lawrence",
          "median": 1.1,
          "10%": 1.0,
          "90%": 1.23,
          "25%": 1.05,
          "75%": 1.16
        },
        "42075": {
          "name": "Lebanon",
          "median": 1.11,
          "10%": 0.99,
          "90%": 1.27,
          "25%": 1.05,
          "75%": 1.2
        },
        "51105": {
          "name": "Lee",
          "median": 1.13,
          "10%": 1.05,
          "90%": 1.25,
          "25%": 1.09,
          "75%": 1.19
        },
        "42077": {
          "name": "Lehigh",
          "median": 1.13,
          "10%": 0.98,
          "90%": 1.3,
          "25%": 1.05,
          "75%": 1.21
        },
        "54041": {
          "name": "Lewis",
          "median": 1.08,
          "10%": 0.99,
          "90%": 1.17,
          "25%": 1.05,
          "75%": 1.14
        },
        "51678": {
          "name": "Lexington",
          "median": 1.09,
          "10%": 0.98,
          "90%": 1.26,
          "25%": 1.03,
          "75%": 1.19
        },
        "54043": {
          "name": "Lincoln",
          "median": 1.09,
          "10%": 1.02,
          "90%": 1.18,
          "25%": 1.04,
          "75%": 1.15
        },
        "36051": {
          "name": "Livingston",
          "median": 1.1,
          "10%": 0.97,
          "90%": 1.21,
          "25%": 1.04,
          "75%": 1.1625
        },
        "54045": {
          "name": "Logan",
          "median": 1.11,
          "10%": 1.02,
          "90%": 1.19,
          "25%": 1.06,
          "75%": 1.15
        },
        "51107": {
          "name": "Loudoun",
          "median": 1.11,
          "10%": 1.0,
          "90%": 1.28,
          "25%": 1.05,
          "75%": 1.19
        },
        "51109": {
          "name": "Louisa",
          "median": 1.12,
          "10%": 0.98,
          "90%": 1.29,
          "25%": 1.05,
          "75%": 1.18
        },
        "51111": {
          "name": "Lunenburg",
          "median": 1.12,
          "10%": 0.99,
          "90%": 1.27,
          "25%": 1.03,
          "75%": 1.18
        },
        "42079": {
          "name": "Luzerne",
          "median": 1.14,
          "10%": 0.98,
          "90%": 1.22,
          "25%": 1.06,
          "75%": 1.18
        },
        "42081": {
          "name": "Lycoming",
          "median": 1.1,
          "10%": 1.02,
          "90%": 1.2,
          "25%": 1.05,
          "75%": 1.17
        },
        "51680": {
          "name": "Lynchburg",
          "median": 1.12,
          "10%": 1.03,
          "90%": 1.231,
          "25%": 1.08,
          "75%": 1.19
        },
        "36053": {
          "name": "Madison",
          "median": 1.08,
          "10%": 0.98,
          "90%": 1.2,
          "25%": 1.03,
          "75%": 1.15
        },
        "51113": {
          "name": "Madison",
          "median": 1.12,
          "10%": 0.97,
          "90%": 1.26,
          "25%": 1.05,
          "75%": 1.18
        },
        "51683": {
          "name": "Manassas",
          "median": 1.07,
          "10%": 0.96,
          "90%": 1.21,
          "25%": 1.01,
          "75%": 1.12
        },
        "51685": {
          "name": "Manassas Park",
          "median": 1.06,
          "10%": 0.96,
          "90%": 1.22,
          "25%": 1.01,
          "75%": 1.11
        },
        "54049": {
          "name": "Marion",
          "median": 1.07,
          "10%": 0.97,
          "90%": 1.21,
          "25%": 1.02,
          "75%": 1.11
        },
        "54051": {
          "name": "Marshall",
          "median": 1.12,
          "10%": 1.03,
          "90%": 1.18,
          "25%": 1.06,
          "75%": 1.15
        },
        "51690": {
          "name": "Martinsville",
          "median": 1.15,
          "10%": 0.98,
          "90%": 1.39,
          "25%": 1.09,
          "75%": 1.28
        },
        "54053": {
          "name": "Mason",
          "median": 1.13,
          "10%": 1.02,
          "90%": 1.25,
          "25%": 1.07,
          "75%": 1.2
        },
        "51115": {
          "name": "Mathews",
          "median": 1.12,
          "10%": 0.96,
          "90%": 1.22,
          "25%": 1.03,
          "75%": 1.17
        },
        "54047": {
          "name": "McDowell",
          "median": 1.11,
          "10%": 1.03,
          "90%": 1.22,
          "25%": 1.05,
          "75%": 1.15
        },
        "42083": {
          "name": "McKean",
          "median": 1.11,
          "10%": 0.98,
          "90%": 1.21,
          "25%": 1.05,
          "75%": 1.15
        },
        "51117": {
          "name": "Mecklenburg",
          "median": 1.1,
          "10%": 0.99,
          "90%": 1.23,
          "25%": 1.05,
          "75%": 1.15
        },
        "34021": {
          "name": "Mercer",
          "median": 1.07,
          "10%": 0.98,
          "90%": 1.201,
          "25%": 1.01,
          "75%": 1.13
        },
        "42085": {
          "name": "Mercer",
          "median": 1.12,
          "10%": 1.01,
          "90%": 1.26,
          "25%": 1.05,
          "75%": 1.19
        },
        "54055": {
          "name": "Mercer",
          "median": 1.12,
          "10%": 1.05,
          "90%": 1.211,
          "25%": 1.08,
          "75%": 1.16
        },
        "51119": {
          "name": "Middlesex",
          "median": 1.09,
          "10%": 0.98,
          "90%": 1.18,
          "25%": 1.01,
          "75%": 1.14
        },
        "42087": {
          "name": "Mifflin",
          "median": 1.15,
          "10%": 1.03,
          "90%": 1.26,
          "25%": 1.08,
          "75%": 1.22
        },
        "54057": {
          "name": "Mineral",
          "median": 1.11,
          "10%": 1.01,
          "90%": 1.26,
          "25%": 1.08,
          "75%": 1.17
        },
        "54059": {
          "name": "Mingo",
          "median": 1.11,
          "10%": 1.03,
          "90%": 1.21,
          "25%": 1.07,
          "75%": 1.15
        },
        "34025": {
          "name": "Monmouth",
          "median": 1.09,
          "10%": 0.98,
          "90%": 1.23,
          "25%": 1.01,
          "75%": 1.16
        },
        "54061": {
          "name": "Monongalia",
          "median": 1.07,
          "10%": 1.0,
          "90%": 1.2,
          "25%": 1.03,
          "75%": 1.12
        },
        "42089": {
          "name": "Monroe",
          "median": 1.15,
          "10%": 0.97,
          "90%": 1.28,
          "25%": 1.05,
          "75%": 1.24
        },
        "54063": {
          "name": "Monroe",
          "median": 1.12,
          "10%": 1.02,
          "90%": 1.2,
          "25%": 1.06,
          "75%": 1.14
        },
        "24031": {
          "name": "Montgomery",
          "median": 1.08,
          "10%": 1.01,
          "90%": 1.21,
          "25%": 1.03,
          "75%": 1.16
        },
        "36057": {
          "name": "Montgomery",
          "median": 1.11,
          "10%": 1.0,
          "90%": 1.25,
          "25%": 1.05,
          "75%": 1.2
        },
        "42091": {
          "name": "Montgomery",
          "median": 1.09,
          "10%": 1.01,
          "90%": 1.28,
          "25%": 1.04,
          "75%": 1.19
        },
        "51121": {
          "name": "Montgomery",
          "median": 1.16,
          "10%": 1.02,
          "90%": 1.26,
          "25%": 1.09,
          "75%": 1.22
        },
        "42093": {
          "name": "Montour",
          "median": 1.15,
          "10%": 1.02,
          "90%": 1.3,
          "25%": 1.06,
          "75%": 1.21
        },
        "54065": {
          "name": "Morgan",
          "median": 1.13,
          "10%": 1.03,
          "90%": 1.32,
          "25%": 1.07,
          "75%": 1.22
        },
        "34027": {
          "name": "Morris",
          "median": 1.11,
          "10%": 0.99,
          "90%": 1.36,
          "25%": 1.05,
          "75%": 1.27
        },
        "36059": {
          "name": "Nassau",
          "median": 1.11,
          "10%": 0.99,
          "90%": 1.24,
          "25%": 1.05,
          "75%": 1.19
        },
        "51125": {
          "name": "Nelson",
          "median": 1.14,
          "10%": 0.97,
          "90%": 1.39,
          "25%": 1.05,
          "75%": 1.25
        },
        "10003": {
          "name": "New Castle",
          "median": 1.12,
          "10%": 1.0,
          "90%": 1.26,
          "25%": 1.05,
          "75%": 1.23
        },
        "51127": {
          "name": "New Kent",
          "median": 1.09,
          "10%": 0.98,
          "90%": 1.19,
          "25%": 1.02,
          "75%": 1.16
        },
        "36061": {
          "name": "New York",
          "median": 1.1,
          "10%": 0.96,
          "90%": 1.26,
          "25%": 1.04,
          "75%": 1.17
        },
        "51700": {
          "name": "Newport News",
          "median": 1.11,
          "10%": 0.97,
          "90%": 1.23,
          "25%": 1.04,
          "75%": 1.16
        },
        "54067": {
          "name": "Nicholas",
          "median": 1.09,
          "10%": 1.01,
          "90%": 1.19,
          "25%": 1.04,
          "75%": 1.13
        },
        "51710": {
          "name": "Norfolk",
          "median": 1.1,
          "10%": 0.97,
          "90%": 1.3,
          "25%": 1.03,
          "75%": 1.21
        },
        "42095": {
          "name": "Northampton",
          "median": 1.11,
          "10%": 0.99,
          "90%": 1.29,
          "25%": 1.05,
          "75%": 1.2
        },
        "51131": {
          "name": "Northampton",
          "median": 1.11,
          "10%": 0.97,
          "90%": 1.23,
          "25%": 1.04,
          "75%": 1.17
        },
        "42097": {
          "name": "Northumberland",
          "median": 1.15,
          "10%": 1.02,
          "90%": 1.31,
          "25%": 1.07,
          "75%": 1.21
        },
        "51133": {
          "name": "Northumberland",
          "median": 1.11,
          "10%": 0.93,
          "90%": 1.25,
          "25%": 1.02,
          "75%": 1.18
        },
        "51720": {
          "name": "Norton",
          "median": 1.11,
          "10%": 0.98,
          "90%": 1.25,
          "25%": 1.05,
          "75%": 1.2
        },
        "51135": {
          "name": "Nottoway",
          "median": 1.1,
          "10%": 0.96,
          "90%": 1.27,
          "25%": 1.02,
          "75%": 1.17
        },
        "34029": {
          "name": "Ocean",
          "median": 1.09,
          "10%": 1.0,
          "90%": 1.23,
          "25%": 1.04,
          "75%": 1.15
        },
        "54069": {
          "name": "Ohio",
          "median": 1.11,
          "10%": 1.01,
          "90%": 1.2,
          "25%": 1.06,
          "75%": 1.16
        },
        "36065": {
          "name": "Oneida",
          "median": 1.08,
          "10%": 1.0,
          "90%": 1.21,
          "25%": 1.04,
          "75%": 1.14
        },
        "36067": {
          "name": "Onondaga",
          "median": 1.11,
          "10%": 1.02,
          "90%": 1.23,
          "25%": 1.06,
          "75%": 1.16
        },
        "36069": {
          "name": "Ontario",
          "median": 1.08,
          "10%": 0.97,
          "90%": 1.18,
          "25%": 1.03,
          "75%": 1.14
        },
        "36071": {
          "name": "Orange",
          "median": 1.11,
          "10%": 0.99,
          "90%": 1.31,
          "25%": 1.06,
          "75%": 1.22
        },
        "51137": {
          "name": "Orange",
          "median": 1.13,
          "10%": 0.98,
          "90%": 1.27,
          "25%": 1.06,
          "75%": 1.19
        },
        "36077": {
          "name": "Otsego",
          "median": 1.09,
          "10%": 0.99,
          "90%": 1.21,
          "25%": 1.03,
          "75%": 1.17
        },
        "51139": {
          "name": "Page",
          "median": 1.12,
          "10%": 1.01,
          "90%": 1.32,
          "25%": 1.06,
          "75%": 1.18
        },
        "51141": {
          "name": "Patrick",
          "median": 1.12,
          "10%": 0.98,
          "90%": 1.3,
          "25%": 1.06,
          "75%": 1.22
        },
        "54071": {
          "name": "Pendleton",
          "median": 1.12,
          "10%": 0.99,
          "90%": 1.31,
          "25%": 1.07,
          "75%": 1.23
        },
        "42099": {
          "name": "Perry",
          "median": 1.14,
          "10%": 1.04,
          "90%": 1.28,
          "25%": 1.08,
          "75%": 1.2
        },
        "51730": {
          "name": "Petersburg",
          "median": 1.08,
          "10%": 0.94,
          "90%": 1.25,
          "25%": 1.03,
          "75%": 1.14
        },
        "42101": {
          "name": "Philadelphia",
          "median": 1.11,
          "10%": 1.01,
          "90%": 1.22,
          "25%": 1.05,
          "75%": 1.16
        },
        "42103": {
          "name": "Pike",
          "median": 1.13,
          "10%": 0.97,
          "90%": 1.28,
          "25%": 1.04,
          "75%": 1.2
        },
        "51143": {
          "name": "Pittsylvania",
          "median": 1.15,
          "10%": 1.03,
          "90%": 1.31,
          "25%": 1.11,
          "75%": 1.23
        },
        "54073": {
          "name": "Pleasants",
          "median": 1.06,
          "10%": 1.0,
          "90%": 1.2,
          "25%": 1.02,
          "75%": 1.14
        },
        "54075": {
          "name": "Pocahontas",
          "median": 1.12,
          "10%": 1.02,
          "90%": 1.23,
          "25%": 1.05,
          "75%": 1.16
        },
        "51735": {
          "name": "Poquoson",
          "median": 1.1,
          "10%": 0.96,
          "90%": 1.2,
          "25%": 1.03,
          "75%": 1.17
        },
        "51740": {
          "name": "Portsmouth",
          "median": 1.09,
          "10%": 0.96,
          "90%": 1.29,
          "25%": 1.03,
          "75%": 1.2
        },
        "42105": {
          "name": "Potter",
          "median": 1.12,
          "10%": 1.0,
          "90%": 1.2,
          "25%": 1.05,
          "75%": 1.17
        },
        "51145": {
          "name": "Powhatan",
          "median": 1.09,
          "10%": 0.96,
          "90%": 1.28,
          "25%": 1.0,
          "75%": 1.16
        },
        "54077": {
          "name": "Preston",
          "median": 1.09,
          "10%": 1.0,
          "90%": 1.2,
          "25%": 1.03,
          "75%": 1.13
        },
        "51147": {
          "name": "Prince Edward",
          "median": 1.11,
          "10%": 0.97,
          "90%": 1.26,
          "25%": 1.05,
          "75%": 1.17
        },
        "51149": {
          "name": "Prince George",
          "median": 1.08,
          "10%": 0.96,
          "90%": 1.25,
          "25%": 1.01,
          "75%": 1.13
        },
        "24033": {
          "name": "Prince George's",
          "median": 1.08,
          "10%": 0.98,
          "90%": 1.22,
          "25%": 1.03,
          "75%": 1.16
        },
        "51153": {
          "name": "Prince William",
          "median": 1.09,
          "10%": 1.01,
          "90%": 1.21,
          "25%": 1.04,
          "75%": 1.16
        },
        "51155": {
          "name": "Pulaski",
          "median": 1.13,
          "10%": 1.01,
          "90%": 1.23,
          "25%": 1.08,
          "75%": 1.2
        },
        "54079": {
          "name": "Putnam",
          "median": 1.11,
          "10%": 1.0,
          "90%": 1.19,
          "25%": 1.04,
          "75%": 1.16
        },
        "24035": {
          "name": "Queen Anne's",
          "median": 1.08,
          "10%": 0.98,
          "90%": 1.2,
          "25%": 1.02,
          "75%": 1.16
        },
        "51750": {
          "name": "Radford",
          "median": 1.14,
          "10%": 1.01,
          "90%": 1.27,
          "25%": 1.09,
          "75%": 1.22
        },
        "54081": {
          "name": "Raleigh",
          "median": 1.11,
          "10%": 1.01,
          "90%": 1.26,
          "25%": 1.06,
          "75%": 1.17
        },
        "54083": {
          "name": "Randolph",
          "median": 1.09,
          "10%": 1.01,
          "90%": 1.19,
          "25%": 1.04,
          "75%": 1.15
        },
        "51157": {
          "name": "Rappahannock",
          "median": 1.14,
          "10%": 1.0,
          "90%": 1.23,
          "25%": 1.07,
          "75%": 1.19
        },
        "36085": {
          "name": "Richmond",
          "median": 1.09,
          "10%": 0.95,
          "90%": 1.27,
          "25%": 1.01,
          "75%": 1.15
        },
        "51159": {
          "name": "Richmond",
          "median": 1.12,
          "10%": 0.9,
          "90%": 1.26,
          "25%": 1.0,
          "75%": 1.19
        },
        "51760": {
          "name": "Richmond",
          "median": 1.1,
          "10%": 0.98,
          "90%": 1.23,
          "25%": 1.02,
          "75%": 1.18
        },
        "54085": {
          "name": "Ritchie",
          "median": 1.1,
          "10%": 1.02,
          "90%": 1.2,
          "25%": 1.05,
          "75%": 1.16
        },
        "54087": {
          "name": "Roane",
          "median": 1.1,
          "10%": 1.02,
          "90%": 1.2,
          "25%": 1.05,
          "75%": 1.16
        },
        "51161": {
          "name": "Roanoke",
          "median": 1.18,
          "10%": 1.0,
          "90%": 1.35,
          "25%": 1.1,
          "75%": 1.26
        },
        "51770": {
          "name": "Roanoke",
          "median": 1.19,
          "10%": 0.98,
          "90%": 1.35,
          "25%": 1.07,
          "75%": 1.26
        },
        "51163": {
          "name": "Rockbridge",
          "median": 1.15,
          "10%": 1.0,
          "90%": 1.29,
          "25%": 1.06,
          "75%": 1.22
        },
        "51165": {
          "name": "Rockingham",
          "median": 1.11,
          "10%": 1.02,
          "90%": 1.25,
          "25%": 1.05,
          "75%": 1.18
        },
        "51167": {
          "name": "Russell",
          "median": 1.11,
          "10%": 1.0,
          "90%": 1.2,
          "25%": 1.06,
          "75%": 1.14
        },
        "34033": {
          "name": "Salem",
          "median": 1.11,
          "10%": 1.03,
          "90%": 1.24,
          "25%": 1.07,
          "75%": 1.2
        },
        "51775": {
          "name": "Salem",
          "median": 1.2,
          "10%": 1.0,
          "90%": 1.38,
          "25%": 1.08,
          "75%": 1.28
        },
        "36095": {
          "name": "Schoharie",
          "median": 1.12,
          "10%": 1.01,
          "90%": 1.26,
          "25%": 1.07,
          "75%": 1.19
        },
        "36097": {
          "name": "Schuyler",
          "median": 1.12,
          "10%": 1.01,
          "90%": 1.25,
          "25%": 1.05,
          "75%": 1.17
        },
        "42107": {
          "name": "Schuylkill",
          "median": 1.13,
          "10%": 0.99,
          "90%": 1.26,
          "25%": 1.05,
          "75%": 1.2
        },
        "51169": {
          "name": "Scott",
          "median": 1.14,
          "10%": 1.04,
          "90%": 1.21,
          "25%": 1.07,
          "75%": 1.19
        },
        "51171": {
          "name": "Shenandoah",
          "median": 1.12,
          "10%": 1.02,
          "90%": 1.28,
          "25%": 1.06,
          "75%": 1.18
        },
        "51173": {
          "name": "Smyth",
          "median": 1.1,
          "10%": 1.05,
          "90%": 1.19,
          "25%": 1.07,
          "75%": 1.16
        },
        "42109": {
          "name": "Snyder",
          "median": 1.13,
          "10%": 1.04,
          "90%": 1.29,
          "25%": 1.07,
          "75%": 1.18
        },
        "24039": {
          "name": "Somerset",
          "median": 1.1,
          "10%": 1.0,
          "90%": 1.29,
          "25%": 1.06,
          "75%": 1.18
        },
        "42111": {
          "name": "Somerset",
          "median": 1.1,
          "10%": 1.03,
          "90%": 1.21,
          "25%": 1.05,
          "75%": 1.14
        },
        "51175": {
          "name": "Southampton",
          "median": 1.1,
          "10%": 0.97,
          "90%": 1.251,
          "25%": 1.04,
          "75%": 1.19
        },
        "51177": {
          "name": "Spotsylvania",
          "median": 1.11,
          "10%": 0.96,
          "90%": 1.27,
          "25%": 1.02,
          "75%": 1.17
        },
        "24037": {
          "name": "St. Mary's",
          "median": 1.08,
          "10%": 0.96,
          "90%": 1.23,
          "25%": 1.01,
          "75%": 1.18
        },
        "51179": {
          "name": "Stafford",
          "median": 1.12,
          "10%": 0.99,
          "90%": 1.28,
          "25%": 1.04,
          "75%": 1.18
        },
        "51790": {
          "name": "Staunton",
          "median": 1.14,
          "10%": 0.99,
          "90%": 1.4,
          "25%": 1.07,
          "75%": 1.21
        },
        "36101": {
          "name": "Steuben",
          "median": 1.11,
          "10%": 0.99,
          "90%": 1.22,
          "25%": 1.05,
          "75%": 1.15
        },
        "51800": {
          "name": "Suffolk",
          "median": 1.14,
          "10%": 0.969,
          "90%": 1.24,
          "25%": 1.05,
          "75%": 1.2
        },
        "36105": {
          "name": "Sullivan",
          "median": 1.14,
          "10%": 1.01,
          "90%": 1.26,
          "25%": 1.05,
          "75%": 1.22
        },
        "42113": {
          "name": "Sullivan",
          "median": 1.12,
          "10%": 0.98,
          "90%": 1.23,
          "25%": 1.04,
          "75%": 1.17
        },
        "54089": {
          "name": "Summers",
          "median": 1.1,
          "10%": 1.01,
          "90%": 1.22,
          "25%": 1.05,
          "75%": 1.15
        },
        "51181": {
          "name": "Surry",
          "median": 1.09,
          "10%": 0.98,
          "90%": 1.22,
          "25%": 1.04,
          "75%": 1.16
        },
        "42115": {
          "name": "Susquehanna",
          "median": 1.1,
          "10%": 1.0,
          "90%": 1.22,
          "25%": 1.03,
          "75%": 1.15
        },
        "10005": {
          "name": "Sussex",
          "median": 1.1,
          "10%": 1.01,
          "90%": 1.21,
          "25%": 1.03,
          "75%": 1.15
        },
        "34037": {
          "name": "Sussex",
          "median": 1.13,
          "10%": 1.0,
          "90%": 1.33,
          "25%": 1.06,
          "75%": 1.2
        },
        "51183": {
          "name": "Sussex",
          "median": 1.1,
          "10%": 0.96,
          "90%": 1.221,
          "25%": 1.02,
          "75%": 1.18
        },
        "24041": {
          "name": "Talbot",
          "median": 1.06,
          "10%": 0.96,
          "90%": 1.22,
          "25%": 1.01,
          "75%": 1.13
        },
        "54091": {
          "name": "Taylor",
          "median": 1.08,
          "10%": 1.0,
          "90%": 1.21,
          "25%": 1.04,
          "75%": 1.15
        },
        "51185": {
          "name": "Tazewell",
          "median": 1.09,
          "10%": 1.05,
          "90%": 1.2,
          "25%": 1.07,
          "75%": 1.14
        },
        "36107": {
          "name": "Tioga",
          "median": 1.09,
          "10%": 0.99,
          "90%": 1.22,
          "25%": 1.03,
          "75%": 1.15
        },
        "42117": {
          "name": "Tioga",
          "median": 1.11,
          "10%": 0.99,
          "90%": 1.22,
          "25%": 1.04,
          "75%": 1.15
        },
        "36109": {
          "name": "Tompkins",
          "median": 1.1,
          "10%": 1.01,
          "90%": 1.2,
          "25%": 1.05,
          "75%": 1.16
        },
        "54093": {
          "name": "Tucker",
          "median": 1.09,
          "10%": 0.99,
          "90%": 1.2,
          "25%": 1.02,
          "75%": 1.15
        },
        "54095": {
          "name": "Tyler",
          "median": 1.05,
          "10%": 0.96,
          "90%": 1.17,
          "25%": 1.0,
          "75%": 1.1
        },
        "36111": {
          "name": "Ulster",
          "median": 1.14,
          "10%": 1.04,
          "90%": 1.34,
          "25%": 1.07,
          "75%": 1.24
        },
        "42119": {
          "name": "Union",
          "median": 1.12,
          "10%": 1.03,
          "90%": 1.231,
          "25%": 1.08,
          "75%": 1.17
        },
        "54097": {
          "name": "Upshur",
          "median": 1.08,
          "10%": 1.0,
          "90%": 1.16,
          "25%": 1.04,
          "75%": 1.13
        },
        "42121": {
          "name": "Venango",
          "median": 1.12,
          "10%": 1.0,
          "90%": 1.23,
          "25%": 1.07,
          "75%": 1.17
        },
        "51810": {
          "name": "Virginia Beach",
          "median": 1.11,
          "10%": 0.97,
          "90%": 1.31,
          "25%": 1.06,
          "75%": 1.21
        },
        "34041": {
          "name": "Warren",
          "median": 1.12,
          "10%": 1.0,
          "90%": 1.31,
          "25%": 1.07,
          "75%": 1.23
        },
        "42123": {
          "name": "Warren",
          "median": 1.09,
          "10%": 1.01,
          "90%": 1.27,
          "25%": 1.05,
          "75%": 1.17
        },
        "51187": {
          "name": "Warren",
          "median": 1.14,
          "10%": 1.02,
          "90%": 1.26,
          "25%": 1.08,
          "75%": 1.21
        },
        "24043": {
          "name": "Washington",
          "median": 1.12,
          "10%": 1.02,
          "90%": 1.3,
          "25%": 1.08,
          "75%": 1.2
        },
        "42125": {
          "name": "Washington",
          "median": 1.1,
          "10%": 0.98,
          "90%": 1.21,
          "25%": 1.04,
          "75%": 1.15
        },
        "51191": {
          "name": "Washington",
          "median": 1.11,
          "10%": 1.01,
          "90%": 1.18,
          "25%": 1.06,
          "75%": 1.14
        },
        "42127": {
          "name": "Wayne",
          "median": 1.13,
          "10%": 0.99,
          "90%": 1.25,
          "25%": 1.02,
          "75%": 1.18
        },
        "54099": {
          "name": "Wayne",
          "median": 1.1,
          "10%": 1.03,
          "90%": 1.21,
          "25%": 1.05,
          "75%": 1.14
        },
        "51820": {
          "name": "Waynesboro",
          "median": 1.14,
          "10%": 0.97,
          "90%": 1.4,
          "25%": 1.07,
          "75%": 1.24
        },
        "54101": {
          "name": "Webster",
          "median": 1.07,
          "10%": 1.01,
          "90%": 1.16,
          "25%": 1.04,
          "75%": 1.13
        },
        "36119": {
          "name": "Westchester",
          "median": 1.11,
          "10%": 1.01,
          "90%": 1.24,
          "25%": 1.06,
          "75%": 1.2
        },
        "42129": {
          "name": "Westmoreland",
          "median": 1.08,
          "10%": 0.99,
          "90%": 1.17,
          "25%": 1.03,
          "75%": 1.13
        },
        "51193": {
          "name": "Westmoreland",
          "median": 1.1,
          "10%": 0.93,
          "90%": 1.25,
          "25%": 0.97,
          "75%": 1.2
        },
        "54103": {
          "name": "Wetzel",
          "median": 1.1,
          "10%": 1.01,
          "90%": 1.19,
          "25%": 1.05,
          "75%": 1.14
        },
        "24045": {
          "name": "Wicomico",
          "median": 1.09,
          "10%": 0.99,
          "90%": 1.24,
          "25%": 1.04,
          "75%": 1.18
        },
        "51830": {
          "name": "Williamsburg",
          "median": 1.07,
          "10%": 0.94,
          "90%": 1.21,
          "25%": 0.99,
          "75%": 1.15
        },
        "51840": {
          "name": "Winchester",
          "median": 1.13,
          "10%": 1.0,
          "90%": 1.3,
          "25%": 1.07,
          "75%": 1.2
        },
        "54105": {
          "name": "Wirt",
          "median": 1.15,
          "10%": 1.02,
          "90%": 1.25,
          "25%": 1.08,
          "75%": 1.2
        },
        "51195": {
          "name": "Wise",
          "median": 1.1,
          "10%": 1.0,
          "90%": 1.24,
          "25%": 1.05,
          "75%": 1.18
        },
        "54107": {
          "name": "Wood",
          "median": 1.11,
          "10%": 1.0,
          "90%": 1.22,
          "25%": 1.05,
          "75%": 1.18
        },
        "24047": {
          "name": "Worcester",
          "median": 1.11,
          "10%": 0.99,
          "90%": 1.26,
          "25%": 1.04,
          "75%": 1.2
        },
        "42131": {
          "name": "Wyoming",
          "median": 1.13,
          "10%": 0.99,
          "90%": 1.23,
          "25%": 1.06,
          "75%": 1.19
        },
        "54109": {
          "name": "Wyoming",
          "median": 1.11,
          "10%": 1.03,
          "90%": 1.26,
          "25%": 1.06,
          "75%": 1.15
        },
        "51197": {
          "name": "Wythe",
          "median": 1.11,
          "10%": 1.0,
          "90%": 1.2,
          "25%": 1.0475,
          "75%": 1.16
        },
        "36123": {
          "name": "Yates",
          "median": 1.1,
          "10%": 0.98,
          "90%": 1.22,
          "25%": 1.04,
          "75%": 1.15
        },
        "42133": {
          "name": "York",
          "median": 1.12,
          "10%": 0.99,
          "90%": 1.27,
          "25%": 1.05,
          "75%": 1.17
        },
        "51199": {
          "name": "York",
          "median": 1.09,
          "10%": 0.98,
          "90%": 1.22,
          "25%": 1.03,
          "75%": 1.14
        },
        "max": 1.2,
        "min": 1
      },
      "25": {
        "51001": {
          "name": "Accomack",
          "median": 1.12,
          "10%": 0.99,
          "90%": 1.27,
          "25%": 1.05,
          "75%": 1.19
        },
        "42001": {
          "name": "Adams",
          "median": 1.12,
          "10%": 0.94,
          "90%": 1.32,
          "25%": 1.0,
          "75%": 1.21
        },
        "51003": {
          "name": "Albemarle",
          "median": 1.14,
          "10%": 0.94,
          "90%": 1.38,
          "25%": 1.04,
          "75%": 1.22
        },
        "51510": {
          "name": "Alexandria",
          "median": 1.1,
          "10%": 0.9,
          "90%": 1.32,
          "25%": 0.97,
          "75%": 1.23
        },
        "24001": {
          "name": "Allegany",
          "median": 1.14,
          "10%": 1.0,
          "90%": 1.32,
          "25%": 1.06,
          "75%": 1.21
        },
        "36003": {
          "name": "Allegany",
          "median": 1.08,
          "10%": 0.95,
          "90%": 1.27,
          "25%": 1.01,
          "75%": 1.18
        },
        "51005": {
          "name": "Alleghany",
          "median": 1.14,
          "10%": 0.99,
          "90%": 1.35,
          "25%": 1.06,
          "75%": 1.21
        },
        "42003": {
          "name": "Allegheny",
          "median": 1.08,
          "10%": 0.97,
          "90%": 1.23,
          "25%": 1.01,
          "75%": 1.18
        },
        "51007": {
          "name": "Amelia",
          "median": 1.1,
          "10%": 0.93,
          "90%": 1.38,
          "25%": 1.0,
          "75%": 1.21
        },
        "51009": {
          "name": "Amherst",
          "median": 1.15,
          "10%": 0.97,
          "90%": 1.35,
          "25%": 1.05,
          "75%": 1.24
        },
        "24003": {
          "name": "Anne Arundel",
          "median": 1.09,
          "10%": 0.93,
          "90%": 1.27,
          "25%": 0.98,
          "75%": 1.18
        },
        "51011": {
          "name": "Appomattox",
          "median": 1.13,
          "10%": 0.97,
          "90%": 1.34,
          "25%": 1.05,
          "75%": 1.24
        },
        "51013": {
          "name": "Arlington",
          "median": 1.09,
          "10%": 0.93,
          "90%": 1.28,
          "25%": 0.98,
          "75%": 1.2
        },
        "42005": {
          "name": "Armstrong",
          "median": 1.12,
          "10%": 0.96,
          "90%": 1.31,
          "25%": 1.05,
          "75%": 1.19
        },
        "34001": {
          "name": "Atlantic",
          "median": 1.11,
          "10%": 0.98,
          "90%": 1.3,
          "25%": 1.06,
          "75%": 1.18
        },
        "51015": {
          "name": "Augusta",
          "median": 1.14,
          "10%": 0.95,
          "90%": 1.34,
          "25%": 1.05,
          "75%": 1.23
        },
        "24005": {
          "name": "Baltimore",
          "median": 1.1,
          "10%": 0.95,
          "90%": 1.28,
          "25%": 1.02,
          "75%": 1.17
        },
        "24510": {
          "name": "Baltimore",
          "median": 1.09,
          "10%": 0.92,
          "90%": 1.31,
          "25%": 1.0,
          "75%": 1.2
        },
        "54001": {
          "name": "Barbour",
          "median": 1.07,
          "10%": 0.98,
          "90%": 1.22,
          "25%": 1.01,
          "75%": 1.17
        },
        "51017": {
          "name": "Bath",
          "median": 1.14,
          "10%": 1.0,
          "90%": 1.38,
          "25%": 1.06,
          "75%": 1.23
        },
        "42007": {
          "name": "Beaver",
          "median": 1.09,
          "10%": 0.95,
          "90%": 1.26,
          "25%": 1.0,
          "75%": 1.17
        },
        "42009": {
          "name": "Bedford",
          "median": 1.14,
          "10%": 1.05,
          "90%": 1.28,
          "25%": 1.1,
          "75%": 1.21
        },
        "51019": {
          "name": "Bedford",
          "median": 1.15,
          "10%": 1.03,
          "90%": 1.34,
          "25%": 1.08,
          "75%": 1.25
        },
        "54003": {
          "name": "Berkeley",
          "median": 1.11,
          "10%": 0.99,
          "90%": 1.31,
          "25%": 1.05,
          "75%": 1.21
        },
        "42011": {
          "name": "Berks",
          "median": 1.13,
          "10%": 0.97,
          "90%": 1.34,
          "25%": 1.03,
          "75%": 1.26
        },
        "42013": {
          "name": "Blair",
          "median": 1.14,
          "10%": 1.029,
          "90%": 1.31,
          "25%": 1.08,
          "75%": 1.2
        },
        "51021": {
          "name": "Bland",
          "median": 1.13,
          "10%": 0.98,
          "90%": 1.24,
          "25%": 1.03,
          "75%": 1.18
        },
        "54005": {
          "name": "Boone",
          "median": 1.11,
          "10%": 0.99,
          "90%": 1.2,
          "25%": 1.05,
          "75%": 1.16
        },
        "51023": {
          "name": "Botetourt",
          "median": 1.15,
          "10%": 1.02,
          "90%": 1.36,
          "25%": 1.06,
          "75%": 1.27
        },
        "42015": {
          "name": "Bradford",
          "median": 1.1,
          "10%": 0.93,
          "90%": 1.27,
          "25%": 1.03,
          "75%": 1.21
        },
        "54007": {
          "name": "Braxton",
          "median": 1.07,
          "10%": 0.97,
          "90%": 1.21,
          "25%": 1.02,
          "75%": 1.14
        },
        "51520": {
          "name": "Bristol",
          "median": 1.12,
          "10%": 0.99,
          "90%": 1.22,
          "25%": 1.03,
          "75%": 1.19
        },
        "36005": {
          "name": "Bronx",
          "median": 1.09,
          "10%": 0.95,
          "90%": 1.27,
          "25%": 1.01,
          "75%": 1.18
        },
        "54009": {
          "name": "Brooke",
          "median": 1.12,
          "10%": 0.94,
          "90%": 1.28,
          "25%": 1.01,
          "75%": 1.18
        },
        "36007": {
          "name": "Broome",
          "median": 1.09,
          "10%": 1.0,
          "90%": 1.27,
          "25%": 1.04,
          "75%": 1.19
        },
        "51025": {
          "name": "Brunswick",
          "median": 1.1,
          "10%": 0.91,
          "90%": 1.32,
          "25%": 0.9875,
          "75%": 1.19
        },
        "51027": {
          "name": "Buchanan",
          "median": 1.09,
          "10%": 0.97,
          "90%": 1.24,
          "25%": 1.02,
          "75%": 1.17
        },
        "51029": {
          "name": "Buckingham",
          "median": 1.11,
          "10%": 0.97,
          "90%": 1.34,
          "25%": 1.04,
          "75%": 1.2
        },
        "42017": {
          "name": "Bucks",
          "median": 1.1,
          "10%": 0.98,
          "90%": 1.25,
          "25%": 1.03,
          "75%": 1.17
        },
        "51530": {
          "name": "Buena Vista",
          "median": 1.13,
          "10%": 0.96,
          "90%": 1.33,
          "25%": 1.04,
          "75%": 1.24
        },
        "34005": {
          "name": "Burlington",
          "median": 1.09,
          "10%": 0.99,
          "90%": 1.22,
          "25%": 1.02,
          "75%": 1.15
        },
        "42019": {
          "name": "Butler",
          "median": 1.11,
          "10%": 0.96,
          "90%": 1.25,
          "25%": 1.02,
          "75%": 1.18
        },
        "54011": {
          "name": "Cabell",
          "median": 1.11,
          "10%": 0.98,
          "90%": 1.25,
          "25%": 1.04,
          "75%": 1.18
        },
        "54013": {
          "name": "Calhoun",
          "median": 1.12,
          "10%": 0.97,
          "90%": 1.3,
          "25%": 1.06,
          "75%": 1.2
        },
        "24009": {
          "name": "Calvert",
          "median": 1.08,
          "10%": 0.95,
          "90%": 1.27,
          "25%": 1.01,
          "75%": 1.2
        },
        "42021": {
          "name": "Cambria",
          "median": 1.1,
          "10%": 0.99,
          "90%": 1.24,
          "25%": 1.05,
          "75%": 1.19
        },
        "34007": {
          "name": "Camden",
          "median": 1.09,
          "10%": 0.99,
          "90%": 1.26,
          "25%": 1.05,
          "75%": 1.18
        },
        "42023": {
          "name": "Cameron",
          "median": 1.11,
          "10%": 0.97,
          "90%": 1.25,
          "25%": 1.04,
          "75%": 1.17
        },
        "51031": {
          "name": "Campbell",
          "median": 1.14,
          "10%": 1.0,
          "90%": 1.31,
          "25%": 1.08,
          "75%": 1.23
        },
        "34009": {
          "name": "Cape May",
          "median": 1.11,
          "10%": 0.99,
          "90%": 1.26,
          "25%": 1.04,
          "75%": 1.19
        },
        "42025": {
          "name": "Carbon",
          "median": 1.14,
          "10%": 0.96,
          "90%": 1.32,
          "25%": 1.05,
          "75%": 1.23
        },
        "24011": {
          "name": "Caroline",
          "median": 1.1,
          "10%": 0.95,
          "90%": 1.28,
          "25%": 1.03,
          "75%": 1.18
        },
        "51033": {
          "name": "Caroline",
          "median": 1.11,
          "10%": 0.95,
          "90%": 1.28,
          "25%": 1.0,
          "75%": 1.2
        },
        "24013": {
          "name": "Carroll",
          "median": 1.12,
          "10%": 0.95,
          "90%": 1.27,
          "25%": 1.03,
          "75%": 1.18
        },
        "51035": {
          "name": "Carroll",
          "median": 1.11,
          "10%": 1.0,
          "90%": 1.25,
          "25%": 1.06,
          "75%": 1.19
        },
        "24015": {
          "name": "Cecil",
          "median": 1.1,
          "10%": 0.97,
          "90%": 1.27,
          "25%": 1.04,
          "75%": 1.2
        },
        "42027": {
          "name": "Centre",
          "median": 1.12,
          "10%": 0.98,
          "90%": 1.27,
          "25%": 1.07,
          "75%": 1.2
        },
        "24017": {
          "name": "Charles",
          "median": 1.12,
          "10%": 0.93,
          "90%": 1.28,
          "25%": 1.0,
          "75%": 1.23
        },
        "51036": {
          "name": "Charles City",
          "median": 1.06,
          "10%": 0.97,
          "90%": 1.24,
          "25%": 1.0,
          "75%": 1.16
        },
        "51037": {
          "name": "Charlotte",
          "median": 1.12,
          "10%": 1.01,
          "90%": 1.27,
          "25%": 1.05,
          "75%": 1.2
        },
        "51540": {
          "name": "Charlottesville",
          "median": 1.13,
          "10%": 0.94,
          "90%": 1.34,
          "25%": 1.04,
          "75%": 1.21
        },
        "36015": {
          "name": "Chemung",
          "median": 1.12,
          "10%": 0.98,
          "90%": 1.25,
          "25%": 1.05,
          "75%": 1.17
        },
        "36017": {
          "name": "Chenango",
          "median": 1.09,
          "10%": 0.96,
          "90%": 1.25,
          "25%": 1.02,
          "75%": 1.16
        },
        "51550": {
          "name": "Chesapeake",
          "median": 1.11,
          "10%": 0.92,
          "90%": 1.31,
          "25%": 1.04,
          "75%": 1.23
        },
        "42029": {
          "name": "Chester",
          "median": 1.11,
          "10%": 0.97,
          "90%": 1.35,
          "25%": 1.01,
          "75%": 1.23
        },
        "51041": {
          "name": "Chesterfield",
          "median": 1.11,
          "10%": 0.949,
          "90%": 1.3,
          "25%": 1.01,
          "75%": 1.2
        },
        "42031": {
          "name": "Clarion",
          "median": 1.12,
          "10%": 1.0,
          "90%": 1.25,
          "25%": 1.06,
          "75%": 1.19
        },
        "51043": {
          "name": "Clarke",
          "median": 1.09,
          "10%": 0.96,
          "90%": 1.27,
          "25%": 1.02,
          "75%": 1.19
        },
        "54015": {
          "name": "Clay",
          "median": 1.08,
          "10%": 0.97,
          "90%": 1.2,
          "25%": 1.01,
          "75%": 1.13
        },
        "42033": {
          "name": "Clearfield",
          "median": 1.1,
          "10%": 1.0,
          "90%": 1.24,
          "25%": 1.04,
          "75%": 1.18
        },
        "42035": {
          "name": "Clinton",
          "median": 1.11,
          "10%": 0.96,
          "90%": 1.26,
          "25%": 1.04,
          "75%": 1.2
        },
        "51570": {
          "name": "Colonial Heights",
          "median": 1.11,
          "10%": 0.93,
          "90%": 1.31,
          "25%": 1.01,
          "75%": 1.19
        },
        "42037": {
          "name": "Columbia",
          "median": 1.15,
          "10%": 0.97,
          "90%": 1.34,
          "25%": 1.07,
          "75%": 1.23
        },
        "36023": {
          "name": "Cortland",
          "median": 1.1,
          "10%": 0.98,
          "90%": 1.27,
          "25%": 1.04,
          "75%": 1.19
        },
        "51580": {
          "name": "Covington",
          "median": 1.13,
          "10%": 0.96,
          "90%": 1.38,
          "25%": 1.01,
          "75%": 1.23
        },
        "51045": {
          "name": "Craig",
          "median": 1.15,
          "10%": 1.01,
          "90%": 1.35,
          "25%": 1.08,
          "75%": 1.24
        },
        "42039": {
          "name": "Crawford",
          "median": 1.13,
          "10%": 0.99,
          "90%": 1.26,
          "25%": 1.04,
          "75%": 1.21
        },
        "51047": {
          "name": "Culpeper",
          "median": 1.12,
          "10%": 1.01,
          "90%": 1.25,
          "25%": 1.07,
          "75%": 1.18
        },
        "34011": {
          "name": "Cumberland",
          "median": 1.115,
          "10%": 0.97,
          "90%": 1.3,
          "25%": 1.03,
          "75%": 1.21
        },
        "42041": {
          "name": "Cumberland",
          "median": 1.13,
          "10%": 1.0,
          "90%": 1.35,
          "25%": 1.06,
          "75%": 1.18
        },
        "51049": {
          "name": "Cumberland",
          "median": 1.1,
          "10%": 0.95,
          "90%": 1.32,
          "25%": 1.03,
          "75%": 1.19
        },
        "51590": {
          "name": "Danville",
          "median": 1.12,
          "10%": 1.01,
          "90%": 1.3,
          "25%": 1.08,
          "75%": 1.2
        },
        "42043": {
          "name": "Dauphin",
          "median": 1.15,
          "10%": 0.98,
          "90%": 1.4,
          "25%": 1.08,
          "75%": 1.26
        },
        "36025": {
          "name": "Delaware",
          "median": 1.13,
          "10%": 1.02,
          "90%": 1.3,
          "25%": 1.06,
          "75%": 1.2
        },
        "42045": {
          "name": "Delaware",
          "median": 1.13,
          "10%": 0.98,
          "90%": 1.32,
          "25%": 1.05,
          "75%": 1.21
        },
        "51051": {
          "name": "Dickenson",
          "median": 1.09,
          "10%": 0.99,
          "90%": 1.23,
          "25%": 1.04,
          "75%": 1.16
        },
        "51053": {
          "name": "Dinwiddie",
          "median": 1.11,
          "10%": 0.96,
          "90%": 1.27,
          "25%": 1.01,
          "75%": 1.17
        },
        "11001": {
          "name": "District of Columbia",
          "median": 1.09,
          "10%": 0.92,
          "90%": 1.28,
          "25%": 0.98,
          "75%": 1.19
        },
        "54017": {
          "name": "Doddridge",
          "median": 1.06,
          "10%": 0.97,
          "90%": 1.18,
          "25%": 1.03,
          "75%": 1.12
        },
        "24019": {
          "name": "Dorchester",
          "median": 1.06,
          "10%": 0.93,
          "90%": 1.28,
          "25%": 1.0,
          "75%": 1.17
        },
        "42047": {
          "name": "Elk",
          "median": 1.12,
          "10%": 0.959,
          "90%": 1.21,
          "25%": 1.03,
          "75%": 1.18
        },
        "51595": {
          "name": "Emporia",
          "median": 1.08,
          "10%": 0.92,
          "90%": 1.27,
          "25%": 0.98,
          "75%": 1.17
        },
        "42049": {
          "name": "Erie",
          "median": 1.13,
          "10%": 1.0,
          "90%": 1.27,
          "25%": 1.03,
          "75%": 1.18
        },
        "51057": {
          "name": "Essex",
          "median": 1.11,
          "10%": 0.91,
          "90%": 1.25,
          "25%": 0.99,
          "75%": 1.21
        },
        "51059": {
          "name": "Fairfax",
          "median": 1.08,
          "10%": 0.97,
          "90%": 1.25,
          "25%": 1.03,
          "75%": 1.16
        },
        "51600": {
          "name": "Fairfax",
          "median": 1.07,
          "10%": 0.96,
          "90%": 1.25,
          "25%": 1.0,
          "75%": 1.15
        },
        "51610": {
          "name": "Falls Church",
          "median": 1.07,
          "10%": 0.94,
          "90%": 1.28,
          "25%": 1.0,
          "75%": 1.18
        },
        "51061": {
          "name": "Fauquier",
          "median": 1.12,
          "10%": 0.97,
          "90%": 1.31,
          "25%": 1.06,
          "75%": 1.21
        },
        "42051": {
          "name": "Fayette",
          "median": 1.08,
          "10%": 0.96,
          "90%": 1.24,
          "25%": 1.0,
          "75%": 1.16
        },
        "54019": {
          "name": "Fayette",
          "median": 1.1,
          "10%": 0.97,
          "90%": 1.22,
          "25%": 1.05,
          "75%": 1.14
        },
        "51063": {
          "name": "Floyd",
          "median": 1.12,
          "10%": 0.98,
          "90%": 1.32,
          "25%": 1.06,
          "75%": 1.2125
        },
        "51065": {
          "name": "Fluvanna",
          "median": 1.13,
          "10%": 0.95,
          "90%": 1.43,
          "25%": 1.01,
          "75%": 1.24
        },
        "42053": {
          "name": "Forest",
          "median": 1.12,
          "10%": 0.97,
          "90%": 1.29,
          "25%": 1.04,
          "75%": 1.19
        },
        "42055": {
          "name": "Franklin",
          "median": 1.11,
          "10%": 1.0,
          "90%": 1.33,
          "25%": 1.06,
          "75%": 1.21
        },
        "51067": {
          "name": "Franklin",
          "median": 1.15,
          "10%": 1.01,
          "90%": 1.32,
          "25%": 1.07,
          "75%": 1.25
        },
        "51620": {
          "name": "Franklin",
          "median": 1.12,
          "10%": 0.91,
          "90%": 1.3,
          "25%": 1.02,
          "75%": 1.23
        },
        "24021": {
          "name": "Frederick",
          "median": 1.1,
          "10%": 0.96,
          "90%": 1.32,
          "25%": 1.03,
          "75%": 1.19
        },
        "51069": {
          "name": "Frederick",
          "median": 1.12,
          "10%": 0.99,
          "90%": 1.34,
          "25%": 1.06,
          "75%": 1.19
        },
        "51630": {
          "name": "Fredericksburg",
          "median": 1.13,
          "10%": 0.939,
          "90%": 1.36,
          "25%": 1.0,
          "75%": 1.23
        },
        "42057": {
          "name": "Fulton",
          "median": 1.15,
          "10%": 1.02,
          "90%": 1.38,
          "25%": 1.0775,
          "75%": 1.25
        },
        "51640": {
          "name": "Galax",
          "median": 1.11,
          "10%": 0.92,
          "90%": 1.27,
          "25%": 1.0,
          "75%": 1.2
        },
        "24023": {
          "name": "Garrett",
          "median": 1.07,
          "10%": 0.98,
          "90%": 1.26,
          "25%": 1.03,
          "75%": 1.13
        },
        "51071": {
          "name": "Giles",
          "median": 1.14,
          "10%": 1.0,
          "90%": 1.26,
          "25%": 1.07,
          "75%": 1.19
        },
        "54021": {
          "name": "Gilmer",
          "median": 1.1,
          "10%": 0.96,
          "90%": 1.24,
          "25%": 1.03,
          "75%": 1.15
        },
        "34015": {
          "name": "Gloucester",
          "median": 1.11,
          "10%": 1.01,
          "90%": 1.24,
          "25%": 1.07,
          "75%": 1.19
        },
        "51073": {
          "name": "Gloucester",
          "median": 1.08,
          "10%": 0.96,
          "90%": 1.24,
          "25%": 1.0,
          "75%": 1.17
        },
        "51075": {
          "name": "Goochland",
          "median": 1.14,
          "10%": 0.91,
          "90%": 1.37,
          "25%": 0.98,
          "75%": 1.25
        },
        "54023": {
          "name": "Grant",
          "median": 1.08,
          "10%": 1.01,
          "90%": 1.29,
          "25%": 1.02,
          "75%": 1.17
        },
        "51077": {
          "name": "Grayson",
          "median": 1.11,
          "10%": 0.99,
          "90%": 1.24,
          "25%": 1.05,
          "75%": 1.17
        },
        "54025": {
          "name": "Greenbrier",
          "median": 1.13,
          "10%": 1.04,
          "90%": 1.26,
          "25%": 1.08,
          "75%": 1.19
        },
        "36039": {
          "name": "Greene",
          "median": 1.19,
          "10%": 1.0,
          "90%": 1.36,
          "25%": 1.08,
          "75%": 1.27
        },
        "42059": {
          "name": "Greene",
          "median": 1.12,
          "10%": 0.98,
          "90%": 1.22,
          "25%": 1.04,
          "75%": 1.18
        },
        "51079": {
          "name": "Greene",
          "median": 1.13,
          "10%": 0.95,
          "90%": 1.35,
          "25%": 1.03,
          "75%": 1.24
        },
        "51081": {
          "name": "Greensville",
          "median": 1.09,
          "10%": 0.93,
          "90%": 1.26,
          "25%": 0.98,
          "75%": 1.18
        },
        "51083": {
          "name": "Halifax",
          "median": 1.14,
          "10%": 1.0,
          "90%": 1.3,
          "25%": 1.07,
          "75%": 1.23
        },
        "54027": {
          "name": "Hampshire",
          "median": 1.14,
          "10%": 1.02,
          "90%": 1.34,
          "25%": 1.07,
          "75%": 1.23
        },
        "51650": {
          "name": "Hampton",
          "median": 1.1,
          "10%": 0.96,
          "90%": 1.28,
          "25%": 1.03,
          "75%": 1.18
        },
        "54029": {
          "name": "Hancock",
          "median": 1.1,
          "10%": 0.96,
          "90%": 1.25,
          "25%": 1.0,
          "75%": 1.18
        },
        "51085": {
          "name": "Hanover",
          "median": 1.1,
          "10%": 0.96,
          "90%": 1.29,
          "25%": 0.99,
          "75%": 1.17
        },
        "54031": {
          "name": "Hardy",
          "median": 1.12,
          "10%": 1.01,
          "90%": 1.32,
          "25%": 1.06,
          "75%": 1.2
        },
        "24025": {
          "name": "Harford",
          "median": 1.1,
          "10%": 0.94,
          "90%": 1.32,
          "25%": 1.03,
          "75%": 1.18
        },
        "54033": {
          "name": "Harrison",
          "median": 1.06,
          "10%": 0.97,
          "90%": 1.22,
          "25%": 1.03,
          "75%": 1.15
        },
        "51660": {
          "name": "Harrisonburg",
          "median": 1.1,
          "10%": 0.96,
          "90%": 1.351,
          "25%": 1.01,
          "75%": 1.19
        },
        "51087": {
          "name": "Henrico",
          "median": 1.11,
          "10%": 0.96,
          "90%": 1.27,
          "25%": 1.02,
          "75%": 1.2
        },
        "51089": {
          "name": "Henry",
          "median": 1.16,
          "10%": 1.0,
          "90%": 1.41,
          "25%": 1.09,
          "75%": 1.3
        },
        "36043": {
          "name": "Herkimer",
          "median": 1.05,
          "10%": 0.92,
          "90%": 1.2,
          "25%": 1.0,
          "75%": 1.12
        },
        "51091": {
          "name": "Highland",
          "median": 1.11,
          "10%": 0.99,
          "90%": 1.31,
          "25%": 1.03,
          "75%": 1.21
        },
        "51670": {
          "name": "Hopewell",
          "median": 1.07,
          "10%": 0.95,
          "90%": 1.29,
          "25%": 0.98,
          "75%": 1.16
        },
        "24027": {
          "name": "Howard",
          "median": 1.11,
          "10%": 0.96,
          "90%": 1.3,
          "25%": 1.03,
          "75%": 1.21
        },
        "34019": {
          "name": "Hunterdon",
          "median": 1.12,
          "10%": 0.98,
          "90%": 1.36,
          "25%": 1.03,
          "75%": 1.23
        },
        "42061": {
          "name": "Huntingdon",
          "median": 1.17,
          "10%": 0.99,
          "90%": 1.31,
          "25%": 1.06,
          "75%": 1.23
        },
        "42063": {
          "name": "Indiana",
          "median": 1.11,
          "10%": 0.98,
          "90%": 1.27,
          "25%": 1.04,
          "75%": 1.18
        },
        "51093": {
          "name": "Isle of Wight",
          "median": 1.13,
          "10%": 0.95,
          "90%": 1.28,
          "25%": 1.03,
          "75%": 1.22
        },
        "54035": {
          "name": "Jackson",
          "median": 1.13,
          "10%": 0.98,
          "90%": 1.25,
          "25%": 1.06,
          "75%": 1.2
        },
        "51095": {
          "name": "James City",
          "median": 1.06,
          "10%": 0.92,
          "90%": 1.26,
          "25%": 0.98,
          "75%": 1.18
        },
        "42065": {
          "name": "Jefferson",
          "median": 1.12,
          "10%": 1.0,
          "90%": 1.26,
          "25%": 1.05,
          "75%": 1.2
        },
        "54037": {
          "name": "Jefferson",
          "median": 1.1,
          "10%": 0.97,
          "90%": 1.26,
          "25%": 1.01,
          "75%": 1.18
        },
        "42067": {
          "name": "Juniata",
          "median": 1.13,
          "10%": 1.01,
          "90%": 1.3,
          "25%": 1.06,
          "75%": 1.2
        },
        "54039": {
          "name": "Kanawha",
          "median": 1.06,
          "10%": 0.96,
          "90%": 1.17,
          "25%": 1.01,
          "75%": 1.12
        },
        "10001": {
          "name": "Kent",
          "median": 1.09,
          "10%": 0.97,
          "90%": 1.24,
          "25%": 1.02,
          "75%": 1.17
        },
        "24029": {
          "name": "Kent",
          "median": 1.09,
          "10%": 0.95,
          "90%": 1.24,
          "25%": 0.99,
          "75%": 1.15
        },
        "51099": {
          "name": "King George",
          "median": 1.11,
          "10%": 0.94,
          "90%": 1.36,
          "25%": 0.98,
          "75%": 1.23
        },
        "51101": {
          "name": "King William",
          "median": 1.09,
          "10%": 0.96,
          "90%": 1.26,
          "25%": 1.0,
          "75%": 1.19
        },
        "51097": {
          "name": "King and Queen",
          "median": 1.1,
          "10%": 0.94,
          "90%": 1.23,
          "25%": 0.99,
          "75%": 1.16
        },
        "42069": {
          "name": "Lackawanna",
          "median": 1.15,
          "10%": 0.96,
          "90%": 1.32,
          "25%": 1.07,
          "75%": 1.26
        },
        "42071": {
          "name": "Lancaster",
          "median": 1.13,
          "10%": 0.96,
          "90%": 1.35,
          "25%": 1.04,
          "75%": 1.25
        },
        "51103": {
          "name": "Lancaster",
          "median": 1.09,
          "10%": 0.94,
          "90%": 1.21,
          "25%": 1.0,
          "75%": 1.15
        },
        "42073": {
          "name": "Lawrence",
          "median": 1.11,
          "10%": 0.97,
          "90%": 1.28,
          "25%": 1.02,
          "75%": 1.18
        },
        "42075": {
          "name": "Lebanon",
          "median": 1.12,
          "10%": 0.96,
          "90%": 1.33,
          "25%": 1.06,
          "75%": 1.24
        },
        "51105": {
          "name": "Lee",
          "median": 1.16,
          "10%": 1.02,
          "90%": 1.27,
          "25%": 1.08,
          "75%": 1.21
        },
        "42077": {
          "name": "Lehigh",
          "median": 1.12,
          "10%": 0.96,
          "90%": 1.35,
          "25%": 1.03,
          "75%": 1.26
        },
        "54041": {
          "name": "Lewis",
          "median": 1.09,
          "10%": 0.98,
          "90%": 1.19,
          "25%": 1.03,
          "75%": 1.15
        },
        "51678": {
          "name": "Lexington",
          "median": 1.09,
          "10%": 0.95,
          "90%": 1.29,
          "25%": 1.01,
          "75%": 1.2025
        },
        "54043": {
          "name": "Lincoln",
          "median": 1.1,
          "10%": 1.0,
          "90%": 1.23,
          "25%": 1.03,
          "75%": 1.17
        },
        "36051": {
          "name": "Livingston",
          "median": 1.1,
          "10%": 0.95,
          "90%": 1.28,
          "25%": 1.03,
          "75%": 1.17
        },
        "54045": {
          "name": "Logan",
          "median": 1.12,
          "10%": 1.01,
          "90%": 1.22,
          "25%": 1.06,
          "75%": 1.18
        },
        "51107": {
          "name": "Loudoun",
          "median": 1.09,
          "10%": 0.98,
          "90%": 1.33,
          "25%": 1.04,
          "75%": 1.21
        },
        "51109": {
          "name": "Louisa",
          "median": 1.13,
          "10%": 0.95,
          "90%": 1.35,
          "25%": 1.02,
          "75%": 1.21
        },
        "51111": {
          "name": "Lunenburg",
          "median": 1.12,
          "10%": 0.95,
          "90%": 1.31,
          "25%": 1.01,
          "75%": 1.22
        },
        "42079": {
          "name": "Luzerne",
          "median": 1.15,
          "10%": 0.97,
          "90%": 1.27,
          "25%": 1.06,
          "75%": 1.21
        },
        "42081": {
          "name": "Lycoming",
          "median": 1.11,
          "10%": 1.01,
          "90%": 1.23,
          "25%": 1.05,
          "75%": 1.18
        },
        "51680": {
          "name": "Lynchburg",
          "median": 1.14,
          "10%": 1.02,
          "90%": 1.28,
          "25%": 1.08,
          "75%": 1.21
        },
        "36053": {
          "name": "Madison",
          "median": 1.07,
          "10%": 0.94,
          "90%": 1.25,
          "25%": 1.02,
          "75%": 1.16
        },
        "51113": {
          "name": "Madison",
          "median": 1.12,
          "10%": 0.95,
          "90%": 1.33,
          "25%": 1.04,
          "75%": 1.22
        },
        "51683": {
          "name": "Manassas",
          "median": 1.08,
          "10%": 0.96,
          "90%": 1.22,
          "25%": 1.02,
          "75%": 1.15
        },
        "51685": {
          "name": "Manassas Park",
          "median": 1.07,
          "10%": 0.95,
          "90%": 1.23,
          "25%": 1.01,
          "75%": 1.14
        },
        "54049": {
          "name": "Marion",
          "median": 1.06,
          "10%": 0.96,
          "90%": 1.21,
          "25%": 1.01,
          "75%": 1.12
        },
        "54051": {
          "name": "Marshall",
          "median": 1.12,
          "10%": 0.97,
          "90%": 1.21,
          "25%": 1.05,
          "75%": 1.17
        },
        "51690": {
          "name": "Martinsville",
          "median": 1.18,
          "10%": 0.959,
          "90%": 1.45,
          "25%": 1.09,
          "75%": 1.34
        },
        "54053": {
          "name": "Mason",
          "median": 1.14,
          "10%": 1.01,
          "90%": 1.28,
          "25%": 1.08,
          "75%": 1.23
        },
        "51115": {
          "name": "Mathews",
          "median": 1.12,
          "10%": 0.96,
          "90%": 1.27,
          "25%": 1.02,
          "75%": 1.19
        },
        "54047": {
          "name": "McDowell",
          "median": 1.1,
          "10%": 1.01,
          "90%": 1.26,
          "25%": 1.04,
          "75%": 1.15
        },
        "42083": {
          "name": "McKean",
          "median": 1.11,
          "10%": 0.96,
          "90%": 1.22,
          "25%": 1.03,
          "75%": 1.16
        },
        "51117": {
          "name": "Mecklenburg",
          "median": 1.1,
          "10%": 0.96,
          "90%": 1.25,
          "25%": 1.04,
          "75%": 1.19
        },
        "34021": {
          "name": "Mercer",
          "median": 1.06,
          "10%": 0.93,
          "90%": 1.26,
          "25%": 0.99,
          "75%": 1.16
        },
        "42085": {
          "name": "Mercer",
          "median": 1.14,
          "10%": 0.98,
          "90%": 1.27,
          "25%": 1.03,
          "75%": 1.21
        },
        "54055": {
          "name": "Mercer",
          "median": 1.13,
          "10%": 1.04,
          "90%": 1.25,
          "25%": 1.08,
          "75%": 1.18
        },
        "51119": {
          "name": "Middlesex",
          "median": 1.08,
          "10%": 0.96,
          "90%": 1.19,
          "25%": 1.0,
          "75%": 1.14
        },
        "42087": {
          "name": "Mifflin",
          "median": 1.16,
          "10%": 0.98,
          "90%": 1.32,
          "25%": 1.06,
          "75%": 1.23
        },
        "54057": {
          "name": "Mineral",
          "median": 1.12,
          "10%": 1.0,
          "90%": 1.29,
          "25%": 1.07,
          "75%": 1.18
        },
        "54059": {
          "name": "Mingo",
          "median": 1.12,
          "10%": 1.01,
          "90%": 1.26,
          "25%": 1.07,
          "75%": 1.2
        },
        "34025": {
          "name": "Monmouth",
          "median": 1.09,
          "10%": 0.95,
          "90%": 1.26,
          "25%": 0.99,
          "75%": 1.16
        },
        "54061": {
          "name": "Monongalia",
          "median": 1.08,
          "10%": 0.96,
          "90%": 1.23,
          "25%": 1.01,
          "75%": 1.14
        },
        "42089": {
          "name": "Monroe",
          "median": 1.14,
          "10%": 0.95,
          "90%": 1.33,
          "25%": 1.05,
          "75%": 1.26
        },
        "54063": {
          "name": "Monroe",
          "median": 1.12,
          "10%": 1.01,
          "90%": 1.21,
          "25%": 1.06,
          "75%": 1.17
        },
        "24031": {
          "name": "Montgomery",
          "median": 1.09,
          "10%": 0.99,
          "90%": 1.26,
          "25%": 1.02,
          "75%": 1.17
        },
        "36057": {
          "name": "Montgomery",
          "median": 1.12,
          "10%": 0.96,
          "90%": 1.3,
          "25%": 1.03,
          "75%": 1.24
        },
        "42091": {
          "name": "Montgomery",
          "median": 1.08,
          "10%": 1.01,
          "90%": 1.31,
          "25%": 1.03,
          "75%": 1.2
        },
        "51121": {
          "name": "Montgomery",
          "median": 1.16,
          "10%": 1.0,
          "90%": 1.31,
          "25%": 1.1,
          "75%": 1.21
        },
        "42093": {
          "name": "Montour",
          "median": 1.16,
          "10%": 1.0,
          "90%": 1.37,
          "25%": 1.04,
          "75%": 1.25
        },
        "54065": {
          "name": "Morgan",
          "median": 1.13,
          "10%": 0.99,
          "90%": 1.39,
          "25%": 1.06,
          "75%": 1.23
        },
        "34027": {
          "name": "Morris",
          "median": 1.13,
          "10%": 0.97,
          "90%": 1.4,
          "25%": 1.03,
          "75%": 1.31
        },
        "36059": {
          "name": "Nassau",
          "median": 1.1,
          "10%": 0.97,
          "90%": 1.29,
          "25%": 1.04,
          "75%": 1.2
        },
        "51125": {
          "name": "Nelson",
          "median": 1.15,
          "10%": 0.91,
          "90%": 1.42,
          "25%": 1.05,
          "75%": 1.27
        },
        "10003": {
          "name": "New Castle",
          "median": 1.12,
          "10%": 0.98,
          "90%": 1.29,
          "25%": 1.05,
          "75%": 1.23
        },
        "51127": {
          "name": "New Kent",
          "median": 1.08,
          "10%": 0.97,
          "90%": 1.23,
          "25%": 1.01,
          "75%": 1.18
        },
        "36061": {
          "name": "New York",
          "median": 1.07,
          "10%": 0.93,
          "90%": 1.29,
          "25%": 1.01,
          "75%": 1.18
        },
        "51700": {
          "name": "Newport News",
          "median": 1.11,
          "10%": 0.98,
          "90%": 1.26,
          "25%": 1.02,
          "75%": 1.17
        },
        "54067": {
          "name": "Nicholas",
          "median": 1.08,
          "10%": 0.98,
          "90%": 1.22,
          "25%": 1.03,
          "75%": 1.14
        },
        "51710": {
          "name": "Norfolk",
          "median": 1.11,
          "10%": 0.94,
          "90%": 1.36,
          "25%": 1.01,
          "75%": 1.26
        },
        "42095": {
          "name": "Northampton",
          "median": 1.12,
          "10%": 0.97,
          "90%": 1.34,
          "25%": 1.04,
          "75%": 1.23
        },
        "51131": {
          "name": "Northampton",
          "median": 1.12,
          "10%": 0.96,
          "90%": 1.23,
          "25%": 1.04,
          "75%": 1.17
        },
        "42097": {
          "name": "Northumberland",
          "median": 1.16,
          "10%": 0.99,
          "90%": 1.36,
          "25%": 1.07,
          "75%": 1.24
        },
        "51133": {
          "name": "Northumberland",
          "median": 1.1,
          "10%": 0.91,
          "90%": 1.27,
          "25%": 1.0,
          "75%": 1.19
        },
        "51720": {
          "name": "Norton",
          "median": 1.14,
          "10%": 0.97,
          "90%": 1.29,
          "25%": 1.04,
          "75%": 1.23
        },
        "51135": {
          "name": "Nottoway",
          "median": 1.11,
          "10%": 0.94,
          "90%": 1.3,
          "25%": 1.01,
          "75%": 1.2
        },
        "34029": {
          "name": "Ocean",
          "median": 1.08,
          "10%": 0.99,
          "90%": 1.24,
          "25%": 1.02,
          "75%": 1.14
        },
        "54069": {
          "name": "Ohio",
          "median": 1.12,
          "10%": 0.97,
          "90%": 1.26,
          "25%": 1.03,
          "75%": 1.19
        },
        "36065": {
          "name": "Oneida",
          "median": 1.08,
          "10%": 0.97,
          "90%": 1.24,
          "25%": 1.03,
          "75%": 1.17
        },
        "36067": {
          "name": "Onondaga",
          "median": 1.11,
          "10%": 1.01,
          "90%": 1.29,
          "25%": 1.04,
          "75%": 1.18
        },
        "36069": {
          "name": "Ontario",
          "median": 1.08,
          "10%": 0.959,
          "90%": 1.24,
          "25%": 1.02,
          "75%": 1.16
        },
        "36071": {
          "name": "Orange",
          "median": 1.13,
          "10%": 0.96,
          "90%": 1.38,
          "25%": 1.06,
          "75%": 1.25
        },
        "51137": {
          "name": "Orange",
          "median": 1.14,
          "10%": 0.97,
          "90%": 1.29,
          "25%": 1.05,
          "75%": 1.2
        },
        "36077": {
          "name": "Otsego",
          "median": 1.08,
          "10%": 0.97,
          "90%": 1.25,
          "25%": 1.01,
          "75%": 1.18
        },
        "51139": {
          "name": "Page",
          "median": 1.11,
          "10%": 0.99,
          "90%": 1.43,
          "25%": 1.04,
          "75%": 1.22
        },
        "51141": {
          "name": "Patrick",
          "median": 1.13,
          "10%": 0.96,
          "90%": 1.36,
          "25%": 1.06,
          "75%": 1.24
        },
        "54071": {
          "name": "Pendleton",
          "median": 1.12,
          "10%": 0.96,
          "90%": 1.35,
          "25%": 1.03,
          "75%": 1.27
        },
        "42099": {
          "name": "Perry",
          "median": 1.14,
          "10%": 1.01,
          "90%": 1.33,
          "25%": 1.07,
          "75%": 1.21
        },
        "51730": {
          "name": "Petersburg",
          "median": 1.1,
          "10%": 0.94,
          "90%": 1.31,
          "25%": 1.01,
          "75%": 1.17
        },
        "42101": {
          "name": "Philadelphia",
          "median": 1.1,
          "10%": 0.99,
          "90%": 1.25,
          "25%": 1.05,
          "75%": 1.18
        },
        "42103": {
          "name": "Pike",
          "median": 1.14,
          "10%": 0.95,
          "90%": 1.35,
          "25%": 1.06,
          "75%": 1.22
        },
        "51143": {
          "name": "Pittsylvania",
          "median": 1.16,
          "10%": 1.02,
          "90%": 1.35,
          "25%": 1.1,
          "75%": 1.24
        },
        "54073": {
          "name": "Pleasants",
          "median": 1.06,
          "10%": 0.97,
          "90%": 1.19,
          "25%": 1.01,
          "75%": 1.14
        },
        "54075": {
          "name": "Pocahontas",
          "median": 1.12,
          "10%": 1.01,
          "90%": 1.3,
          "25%": 1.05,
          "75%": 1.18
        },
        "51735": {
          "name": "Poquoson",
          "median": 1.09,
          "10%": 0.95,
          "90%": 1.25,
          "25%": 1.02,
          "75%": 1.18
        },
        "51740": {
          "name": "Portsmouth",
          "median": 1.11,
          "10%": 0.93,
          "90%": 1.35,
          "25%": 1.01,
          "75%": 1.23
        },
        "42105": {
          "name": "Potter",
          "median": 1.11,
          "10%": 0.95,
          "90%": 1.23,
          "25%": 1.03,
          "75%": 1.18
        },
        "51145": {
          "name": "Powhatan",
          "median": 1.1,
          "10%": 0.94,
          "90%": 1.34,
          "25%": 0.99,
          "75%": 1.21
        },
        "54077": {
          "name": "Preston",
          "median": 1.09,
          "10%": 0.97,
          "90%": 1.22,
          "25%": 1.02,
          "75%": 1.16
        },
        "51147": {
          "name": "Prince Edward",
          "median": 1.1,
          "10%": 0.96,
          "90%": 1.31,
          "25%": 1.03,
          "75%": 1.18
        },
        "51149": {
          "name": "Prince George",
          "median": 1.08,
          "10%": 0.95,
          "90%": 1.28,
          "25%": 0.99,
          "75%": 1.14
        },
        "24033": {
          "name": "Prince George's",
          "median": 1.09,
          "10%": 0.94,
          "90%": 1.28,
          "25%": 1.02,
          "75%": 1.18
        },
        "51153": {
          "name": "Prince William",
          "median": 1.1,
          "10%": 1.01,
          "90%": 1.24,
          "25%": 1.04,
          "75%": 1.18
        },
        "51155": {
          "name": "Pulaski",
          "median": 1.14,
          "10%": 0.99,
          "90%": 1.26,
          "25%": 1.07,
          "75%": 1.21
        },
        "54079": {
          "name": "Putnam",
          "median": 1.11,
          "10%": 0.98,
          "90%": 1.23,
          "25%": 1.04,
          "75%": 1.18
        },
        "24035": {
          "name": "Queen Anne's",
          "median": 1.07,
          "10%": 0.95,
          "90%": 1.25,
          "25%": 1.0,
          "75%": 1.15
        },
        "51750": {
          "name": "Radford",
          "median": 1.16,
          "10%": 1.01,
          "90%": 1.29,
          "25%": 1.07,
          "75%": 1.25
        },
        "54081": {
          "name": "Raleigh",
          "median": 1.1,
          "10%": 1.0,
          "90%": 1.33,
          "25%": 1.06,
          "75%": 1.18
        },
        "54083": {
          "name": "Randolph",
          "median": 1.1,
          "10%": 0.98,
          "90%": 1.24,
          "25%": 1.04,
          "75%": 1.18
        },
        "51157": {
          "name": "Rappahannock",
          "median": 1.13,
          "10%": 0.97,
          "90%": 1.29,
          "25%": 1.05,
          "75%": 1.2
        },
        "36085": {
          "name": "Richmond",
          "median": 1.08,
          "10%": 0.9,
          "90%": 1.28,
          "25%": 0.99,
          "75%": 1.17
        },
        "51159": {
          "name": "Richmond",
          "median": 1.12,
          "10%": 0.88,
          "90%": 1.28,
          "25%": 0.99,
          "75%": 1.21
        },
        "51760": {
          "name": "Richmond",
          "median": 1.12,
          "10%": 0.96,
          "90%": 1.31,
          "25%": 1.02,
          "75%": 1.21
        },
        "54085": {
          "name": "Ritchie",
          "median": 1.1,
          "10%": 1.01,
          "90%": 1.23,
          "25%": 1.04,
          "75%": 1.17
        },
        "54087": {
          "name": "Roane",
          "median": 1.1,
          "10%": 0.98,
          "90%": 1.22,
          "25%": 1.04,
          "75%": 1.17
        },
        "51161": {
          "name": "Roanoke",
          "median": 1.17,
          "10%": 1.01,
          "90%": 1.41,
          "25%": 1.09,
          "75%": 1.3025
        },
        "51770": {
          "name": "Roanoke",
          "median": 1.19,
          "10%": 0.97,
          "90%": 1.42,
          "25%": 1.07,
          "75%": 1.32
        },
        "51163": {
          "name": "Rockbridge",
          "median": 1.14,
          "10%": 0.98,
          "90%": 1.33,
          "25%": 1.05,
          "75%": 1.23
        },
        "51165": {
          "name": "Rockingham",
          "median": 1.1,
          "10%": 1.0,
          "90%": 1.33,
          "25%": 1.03,
          "75%": 1.2
        },
        "51167": {
          "name": "Russell",
          "median": 1.12,
          "10%": 0.99,
          "90%": 1.22,
          "25%": 1.05,
          "75%": 1.17
        },
        "34033": {
          "name": "Salem",
          "median": 1.11,
          "10%": 1.01,
          "90%": 1.26,
          "25%": 1.06,
          "75%": 1.2
        },
        "51775": {
          "name": "Salem",
          "median": 1.19,
          "10%": 0.99,
          "90%": 1.46,
          "25%": 1.06,
          "75%": 1.32
        },
        "36095": {
          "name": "Schoharie",
          "median": 1.11,
          "10%": 0.98,
          "90%": 1.3,
          "25%": 1.05,
          "75%": 1.21
        },
        "36097": {
          "name": "Schuyler",
          "median": 1.11,
          "10%": 0.98,
          "90%": 1.29,
          "25%": 1.0475,
          "75%": 1.19
        },
        "42107": {
          "name": "Schuylkill",
          "median": 1.16,
          "10%": 0.96,
          "90%": 1.33,
          "25%": 1.04,
          "75%": 1.24
        },
        "51169": {
          "name": "Scott",
          "median": 1.16,
          "10%": 1.01,
          "90%": 1.24,
          "25%": 1.06,
          "75%": 1.21
        },
        "51171": {
          "name": "Shenandoah",
          "median": 1.1,
          "10%": 0.99,
          "90%": 1.32,
          "25%": 1.04,
          "75%": 1.2
        },
        "51173": {
          "name": "Smyth",
          "median": 1.1,
          "10%": 1.04,
          "90%": 1.22,
          "25%": 1.07,
          "75%": 1.17
        },
        "42109": {
          "name": "Snyder",
          "median": 1.14,
          "10%": 1.01,
          "90%": 1.34,
          "25%": 1.06,
          "75%": 1.22
        },
        "24039": {
          "name": "Somerset",
          "median": 1.1,
          "10%": 0.99,
          "90%": 1.3,
          "25%": 1.05,
          "75%": 1.19
        },
        "42111": {
          "name": "Somerset",
          "median": 1.1,
          "10%": 1.02,
          "90%": 1.23,
          "25%": 1.04,
          "75%": 1.15
        },
        "51175": {
          "name": "Southampton",
          "median": 1.1,
          "10%": 0.95,
          "90%": 1.29,
          "25%": 1.03,
          "75%": 1.22
        },
        "51177": {
          "name": "Spotsylvania",
          "median": 1.11,
          "10%": 0.95,
          "90%": 1.3,
          "25%": 1.01,
          "75%": 1.2
        },
        "24037": {
          "name": "St. Mary's",
          "median": 1.08,
          "10%": 0.93,
          "90%": 1.28,
          "25%": 0.99,
          "75%": 1.2
        },
        "51179": {
          "name": "Stafford",
          "median": 1.13,
          "10%": 0.96,
          "90%": 1.31,
          "25%": 1.02,
          "75%": 1.2
        },
        "51790": {
          "name": "Staunton",
          "median": 1.14,
          "10%": 0.91,
          "90%": 1.4,
          "25%": 1.0575,
          "75%": 1.23
        },
        "36101": {
          "name": "Steuben",
          "median": 1.1,
          "10%": 0.96,
          "90%": 1.29,
          "25%": 1.03,
          "75%": 1.15
        },
        "51800": {
          "name": "Suffolk",
          "median": 1.15,
          "10%": 0.93,
          "90%": 1.27,
          "25%": 1.03,
          "75%": 1.22
        },
        "36105": {
          "name": "Sullivan",
          "median": 1.15,
          "10%": 0.99,
          "90%": 1.32,
          "25%": 1.06,
          "75%": 1.23
        },
        "42113": {
          "name": "Sullivan",
          "median": 1.13,
          "10%": 0.96,
          "90%": 1.27,
          "25%": 1.04,
          "75%": 1.2
        },
        "54089": {
          "name": "Summers",
          "median": 1.11,
          "10%": 0.98,
          "90%": 1.26,
          "25%": 1.05,
          "75%": 1.18
        },
        "51181": {
          "name": "Surry",
          "median": 1.08,
          "10%": 0.96,
          "90%": 1.24,
          "25%": 1.01,
          "75%": 1.19
        },
        "42115": {
          "name": "Susquehanna",
          "median": 1.11,
          "10%": 0.99,
          "90%": 1.26,
          "25%": 1.03,
          "75%": 1.19
        },
        "10005": {
          "name": "Sussex",
          "median": 1.09,
          "10%": 0.98,
          "90%": 1.28,
          "25%": 1.02,
          "75%": 1.17
        },
        "34037": {
          "name": "Sussex",
          "median": 1.14,
          "10%": 1.0,
          "90%": 1.37,
          "25%": 1.06,
          "75%": 1.25
        },
        "51183": {
          "name": "Sussex",
          "median": 1.1,
          "10%": 0.93,
          "90%": 1.25,
          "25%": 1.0,
          "75%": 1.18
        },
        "24041": {
          "name": "Talbot",
          "median": 1.06,
          "10%": 0.92,
          "90%": 1.29,
          "25%": 0.98,
          "75%": 1.14
        },
        "54091": {
          "name": "Taylor",
          "median": 1.09,
          "10%": 0.97,
          "90%": 1.23,
          "25%": 1.02,
          "75%": 1.18
        },
        "51185": {
          "name": "Tazewell",
          "median": 1.1,
          "10%": 1.03,
          "90%": 1.23,
          "25%": 1.06,
          "75%": 1.17
        },
        "36107": {
          "name": "Tioga",
          "median": 1.1,
          "10%": 0.98,
          "90%": 1.29,
          "25%": 1.03,
          "75%": 1.2
        },
        "42117": {
          "name": "Tioga",
          "median": 1.11,
          "10%": 0.95,
          "90%": 1.23,
          "25%": 1.02,
          "75%": 1.18
        },
        "36109": {
          "name": "Tompkins",
          "median": 1.1,
          "10%": 0.98,
          "90%": 1.27,
          "25%": 1.04,
          "75%": 1.16
        },
        "54093": {
          "name": "Tucker",
          "median": 1.08,
          "10%": 0.98,
          "90%": 1.23,
          "25%": 1.01,
          "75%": 1.16
        },
        "54095": {
          "name": "Tyler",
          "median": 1.06,
          "10%": 0.94,
          "90%": 1.16,
          "25%": 0.99,
          "75%": 1.12
        },
        "36111": {
          "name": "Ulster",
          "median": 1.16,
          "10%": 1.01,
          "90%": 1.35,
          "25%": 1.06,
          "75%": 1.28
        },
        "42119": {
          "name": "Union",
          "median": 1.12,
          "10%": 1.01,
          "90%": 1.26,
          "25%": 1.06,
          "75%": 1.2
        },
        "54097": {
          "name": "Upshur",
          "median": 1.1,
          "10%": 0.98,
          "90%": 1.2,
          "25%": 1.03,
          "75%": 1.16
        },
        "42121": {
          "name": "Venango",
          "median": 1.13,
          "10%": 0.99,
          "90%": 1.27,
          "25%": 1.07,
          "75%": 1.18
        },
        "51810": {
          "name": "Virginia Beach",
          "median": 1.12,
          "10%": 0.94,
          "90%": 1.341,
          "25%": 1.05,
          "75%": 1.23
        },
        "34041": {
          "name": "Warren",
          "median": 1.13,
          "10%": 0.97,
          "90%": 1.37,
          "25%": 1.06,
          "75%": 1.27
        },
        "42123": {
          "name": "Warren",
          "median": 1.1,
          "10%": 1.02,
          "90%": 1.29,
          "25%": 1.05,
          "75%": 1.18
        },
        "51187": {
          "name": "Warren",
          "median": 1.13,
          "10%": 0.98,
          "90%": 1.3,
          "25%": 1.05,
          "75%": 1.21
        },
        "24043": {
          "name": "Washington",
          "median": 1.12,
          "10%": 0.99,
          "90%": 1.32,
          "25%": 1.06,
          "75%": 1.22
        },
        "42125": {
          "name": "Washington",
          "median": 1.09,
          "10%": 0.96,
          "90%": 1.24,
          "25%": 1.01,
          "75%": 1.16
        },
        "51191": {
          "name": "Washington",
          "median": 1.11,
          "10%": 0.99,
          "90%": 1.21,
          "25%": 1.05,
          "75%": 1.16
        },
        "42127": {
          "name": "Wayne",
          "median": 1.14,
          "10%": 0.96,
          "90%": 1.3,
          "25%": 1.02,
          "75%": 1.22
        },
        "54099": {
          "name": "Wayne",
          "median": 1.11,
          "10%": 1.02,
          "90%": 1.27,
          "25%": 1.05,
          "75%": 1.18
        },
        "51820": {
          "name": "Waynesboro",
          "median": 1.15,
          "10%": 0.929,
          "90%": 1.39,
          "25%": 1.04,
          "75%": 1.25
        },
        "54101": {
          "name": "Webster",
          "median": 1.08,
          "10%": 0.98,
          "90%": 1.2,
          "25%": 1.02,
          "75%": 1.14
        },
        "36119": {
          "name": "Westchester",
          "median": 1.11,
          "10%": 0.98,
          "90%": 1.28,
          "25%": 1.03,
          "75%": 1.2
        },
        "42129": {
          "name": "Westmoreland",
          "median": 1.08,
          "10%": 0.98,
          "90%": 1.22,
          "25%": 1.03,
          "75%": 1.15
        },
        "51193": {
          "name": "Westmoreland",
          "median": 1.1,
          "10%": 0.92,
          "90%": 1.3,
          "25%": 0.96,
          "75%": 1.21
        },
        "54103": {
          "name": "Wetzel",
          "median": 1.1,
          "10%": 0.98,
          "90%": 1.21,
          "25%": 1.03,
          "75%": 1.15
        },
        "24045": {
          "name": "Wicomico",
          "median": 1.09,
          "10%": 0.99,
          "90%": 1.28,
          "25%": 1.03,
          "75%": 1.18
        },
        "51830": {
          "name": "Williamsburg",
          "median": 1.05,
          "10%": 0.91,
          "90%": 1.27,
          "25%": 0.95,
          "75%": 1.18
        },
        "51840": {
          "name": "Winchester",
          "median": 1.11,
          "10%": 0.97,
          "90%": 1.32,
          "25%": 1.05,
          "75%": 1.21
        },
        "54105": {
          "name": "Wirt",
          "median": 1.15,
          "10%": 1.0,
          "90%": 1.28,
          "25%": 1.06,
          "75%": 1.22
        },
        "51195": {
          "name": "Wise",
          "median": 1.12,
          "10%": 0.98,
          "90%": 1.27,
          "25%": 1.05,
          "75%": 1.21
        },
        "54107": {
          "name": "Wood",
          "median": 1.11,
          "10%": 0.98,
          "90%": 1.25,
          "25%": 1.04,
          "75%": 1.18
        },
        "24047": {
          "name": "Worcester",
          "median": 1.1,
          "10%": 0.97,
          "90%": 1.31,
          "25%": 1.03,
          "75%": 1.24
        },
        "42131": {
          "name": "Wyoming",
          "median": 1.15,
          "10%": 0.98,
          "90%": 1.29,
          "25%": 1.05,
          "75%": 1.23
        },
        "54109": {
          "name": "Wyoming",
          "median": 1.1,
          "10%": 1.02,
          "90%": 1.26,
          "25%": 1.06,
          "75%": 1.15
        },
        "51197": {
          "name": "Wythe",
          "median": 1.12,
          "10%": 0.98,
          "90%": 1.22,
          "25%": 1.03,
          "75%": 1.18
        },
        "36123": {
          "name": "Yates",
          "median": 1.11,
          "10%": 0.94,
          "90%": 1.29,
          "25%": 1.01,
          "75%": 1.18
        },
        "42133": {
          "name": "York",
          "median": 1.11,
          "10%": 0.96,
          "90%": 1.31,
          "25%": 1.03,
          "75%": 1.21
        },
        "51199": {
          "name": "York",
          "median": 1.09,
          "10%": 0.94,
          "90%": 1.28,
          "25%": 1.0,
          "75%": 1.16
        },
        "max": 1.19,
        "min": 1
      },
      "50": {
        "51001": {
          "name": "Accomack",
          "median": 1.12,
          "10%": 0.97,
          "90%": 1.31,
          "25%": 1.05,
          "75%": 1.21
        },
        "42001": {
          "name": "Adams",
          "median": 1.11,
          "10%": 0.89,
          "90%": 1.361,
          "25%": 0.98,
          "75%": 1.21
        },
        "51003": {
          "name": "Albemarle",
          "median": 1.14,
          "10%": 0.91,
          "90%": 1.41,
          "25%": 1.04,
          "75%": 1.24
        },
        "51510": {
          "name": "Alexandria",
          "median": 1.12,
          "10%": 0.88,
          "90%": 1.39,
          "25%": 0.96,
          "75%": 1.27
        },
        "24001": {
          "name": "Allegany",
          "median": 1.13,
          "10%": 0.96,
          "90%": 1.39,
          "25%": 1.05,
          "75%": 1.23
        },
        "36003": {
          "name": "Allegany",
          "median": 1.07,
          "10%": 0.91,
          "90%": 1.31,
          "25%": 0.99,
          "75%": 1.19
        },
        "51005": {
          "name": "Alleghany",
          "median": 1.14,
          "10%": 0.97,
          "90%": 1.42,
          "25%": 1.05,
          "75%": 1.23
        },
        "42003": {
          "name": "Allegheny",
          "median": 1.07,
          "10%": 0.94,
          "90%": 1.28,
          "25%": 0.99,
          "75%": 1.19
        },
        "51007": {
          "name": "Amelia",
          "median": 1.1,
          "10%": 0.9,
          "90%": 1.46,
          "25%": 0.99,
          "75%": 1.26
        },
        "51009": {
          "name": "Amherst",
          "median": 1.15,
          "10%": 0.95,
          "90%": 1.39,
          "25%": 1.06,
          "75%": 1.25
        },
        "24003": {
          "name": "Anne Arundel",
          "median": 1.1,
          "10%": 0.9,
          "90%": 1.34,
          "25%": 0.97,
          "75%": 1.2
        },
        "51011": {
          "name": "Appomattox",
          "median": 1.13,
          "10%": 0.95,
          "90%": 1.41,
          "25%": 1.03,
          "75%": 1.25
        },
        "51013": {
          "name": "Arlington",
          "median": 1.11,
          "10%": 0.91,
          "90%": 1.36,
          "25%": 0.98,
          "75%": 1.23
        },
        "42005": {
          "name": "Armstrong",
          "median": 1.13,
          "10%": 0.94,
          "90%": 1.38,
          "25%": 1.04,
          "75%": 1.21
        },
        "34001": {
          "name": "Atlantic",
          "median": 1.12,
          "10%": 0.96,
          "90%": 1.35,
          "25%": 1.05,
          "75%": 1.19
        },
        "51015": {
          "name": "Augusta",
          "median": 1.14,
          "10%": 0.919,
          "90%": 1.33,
          "25%": 1.03,
          "75%": 1.23
        },
        "24005": {
          "name": "Baltimore",
          "median": 1.11,
          "10%": 0.92,
          "90%": 1.34,
          "25%": 0.99,
          "75%": 1.2
        },
        "24510": {
          "name": "Baltimore",
          "median": 1.11,
          "10%": 0.88,
          "90%": 1.37,
          "25%": 0.97,
          "75%": 1.24
        },
        "54001": {
          "name": "Barbour",
          "median": 1.07,
          "10%": 0.95,
          "90%": 1.25,
          "25%": 1.0,
          "75%": 1.19
        },
        "51017": {
          "name": "Bath",
          "median": 1.14,
          "10%": 0.97,
          "90%": 1.44,
          "25%": 1.03,
          "75%": 1.26
        },
        "42007": {
          "name": "Beaver",
          "median": 1.08,
          "10%": 0.91,
          "90%": 1.32,
          "25%": 0.98,
          "75%": 1.2
        },
        "42009": {
          "name": "Bedford",
          "median": 1.15,
          "10%": 1.02,
          "90%": 1.34,
          "25%": 1.09,
          "75%": 1.23
        },
        "51019": {
          "name": "Bedford",
          "median": 1.15,
          "10%": 1.03,
          "90%": 1.39,
          "25%": 1.08,
          "75%": 1.29
        },
        "54003": {
          "name": "Berkeley",
          "median": 1.1,
          "10%": 0.96,
          "90%": 1.32,
          "25%": 1.02,
          "75%": 1.23
        },
        "42011": {
          "name": "Berks",
          "median": 1.14,
          "10%": 0.94,
          "90%": 1.4,
          "25%": 1.01,
          "75%": 1.27
        },
        "42013": {
          "name": "Blair",
          "median": 1.15,
          "10%": 0.99,
          "90%": 1.37,
          "25%": 1.07,
          "75%": 1.22
        },
        "51021": {
          "name": "Bland",
          "median": 1.14,
          "10%": 0.95,
          "90%": 1.27,
          "25%": 1.02,
          "75%": 1.2
        },
        "54005": {
          "name": "Boone",
          "median": 1.11,
          "10%": 0.95,
          "90%": 1.23,
          "25%": 1.04,
          "75%": 1.18
        },
        "51023": {
          "name": "Botetourt",
          "median": 1.15,
          "10%": 1.0,
          "90%": 1.44,
          "25%": 1.06,
          "75%": 1.28
        },
        "42015": {
          "name": "Bradford",
          "median": 1.13,
          "10%": 0.91,
          "90%": 1.36,
          "25%": 1.01,
          "75%": 1.25
        },
        "54007": {
          "name": "Braxton",
          "median": 1.06,
          "10%": 0.95,
          "90%": 1.25,
          "25%": 1.01,
          "75%": 1.14
        },
        "51520": {
          "name": "Bristol",
          "median": 1.13,
          "10%": 0.96,
          "90%": 1.241,
          "25%": 1.02,
          "75%": 1.19
        },
        "36005": {
          "name": "Bronx",
          "median": 1.07,
          "10%": 0.91,
          "90%": 1.3,
          "25%": 1.0,
          "75%": 1.18
        },
        "54009": {
          "name": "Brooke",
          "median": 1.12,
          "10%": 0.92,
          "90%": 1.31,
          "25%": 1.0,
          "75%": 1.21
        },
        "36007": {
          "name": "Broome",
          "median": 1.1,
          "10%": 0.99,
          "90%": 1.32,
          "25%": 1.04,
          "75%": 1.21
        },
        "51025": {
          "name": "Brunswick",
          "median": 1.1,
          "10%": 0.9,
          "90%": 1.35,
          "25%": 0.97,
          "75%": 1.21
        },
        "51027": {
          "name": "Buchanan",
          "median": 1.08,
          "10%": 0.96,
          "90%": 1.26,
          "25%": 1.01,
          "75%": 1.19
        },
        "51029": {
          "name": "Buckingham",
          "median": 1.11,
          "10%": 0.94,
          "90%": 1.4,
          "25%": 1.03,
          "75%": 1.23
        },
        "42017": {
          "name": "Bucks",
          "median": 1.11,
          "10%": 0.96,
          "90%": 1.3,
          "25%": 1.02,
          "75%": 1.19
        },
        "51530": {
          "name": "Buena Vista",
          "median": 1.13,
          "10%": 0.91,
          "90%": 1.33,
          "25%": 1.02,
          "75%": 1.24
        },
        "34005": {
          "name": "Burlington",
          "median": 1.08,
          "10%": 0.95,
          "90%": 1.25,
          "25%": 1.01,
          "75%": 1.16
        },
        "42019": {
          "name": "Butler",
          "median": 1.12,
          "10%": 0.95,
          "90%": 1.28,
          "25%": 1.01,
          "75%": 1.2
        },
        "54011": {
          "name": "Cabell",
          "median": 1.12,
          "10%": 0.95,
          "90%": 1.31,
          "25%": 1.04,
          "75%": 1.21
        },
        "54013": {
          "name": "Calhoun",
          "median": 1.12,
          "10%": 0.93,
          "90%": 1.36,
          "25%": 1.03,
          "75%": 1.21
        },
        "24009": {
          "name": "Calvert",
          "median": 1.09,
          "10%": 0.93,
          "90%": 1.3,
          "25%": 1.0,
          "75%": 1.22
        },
        "42021": {
          "name": "Cambria",
          "median": 1.12,
          "10%": 0.97,
          "90%": 1.28,
          "25%": 1.05,
          "75%": 1.21
        },
        "34007": {
          "name": "Camden",
          "median": 1.09,
          "10%": 0.97,
          "90%": 1.28,
          "25%": 1.04,
          "75%": 1.19
        },
        "42023": {
          "name": "Cameron",
          "median": 1.11,
          "10%": 0.94,
          "90%": 1.27,
          "25%": 1.03,
          "75%": 1.19
        },
        "51031": {
          "name": "Campbell",
          "median": 1.13,
          "10%": 0.98,
          "90%": 1.34,
          "25%": 1.07,
          "75%": 1.24
        },
        "34009": {
          "name": "Cape May",
          "median": 1.12,
          "10%": 0.98,
          "90%": 1.29,
          "25%": 1.04,
          "75%": 1.22
        },
        "42025": {
          "name": "Carbon",
          "median": 1.15,
          "10%": 0.95,
          "90%": 1.39,
          "25%": 1.05,
          "75%": 1.26
        },
        "24011": {
          "name": "Caroline",
          "median": 1.1,
          "10%": 0.92,
          "90%": 1.35,
          "25%": 1.01,
          "75%": 1.21
        },
        "51033": {
          "name": "Caroline",
          "median": 1.11,
          "10%": 0.93,
          "90%": 1.36,
          "25%": 0.99,
          "75%": 1.22
        },
        "24013": {
          "name": "Carroll",
          "median": 1.11,
          "10%": 0.93,
          "90%": 1.34,
          "25%": 1.0,
          "75%": 1.21
        },
        "51035": {
          "name": "Carroll",
          "median": 1.11,
          "10%": 0.99,
          "90%": 1.27,
          "25%": 1.06,
          "75%": 1.2
        },
        "24015": {
          "name": "Cecil",
          "median": 1.1,
          "10%": 0.93,
          "90%": 1.32,
          "25%": 1.02,
          "75%": 1.19
        },
        "42027": {
          "name": "Centre",
          "median": 1.11,
          "10%": 0.97,
          "90%": 1.31,
          "25%": 1.05,
          "75%": 1.23
        },
        "24017": {
          "name": "Charles",
          "median": 1.14,
          "10%": 0.89,
          "90%": 1.35,
          "25%": 0.99,
          "75%": 1.27
        },
        "51036": {
          "name": "Charles City",
          "median": 1.06,
          "10%": 0.96,
          "90%": 1.27,
          "25%": 1.0,
          "75%": 1.19
        },
        "51037": {
          "name": "Charlotte",
          "median": 1.13,
          "10%": 0.99,
          "90%": 1.31,
          "25%": 1.04,
          "75%": 1.21
        },
        "51540": {
          "name": "Charlottesville",
          "median": 1.13,
          "10%": 0.9,
          "90%": 1.42,
          "25%": 1.03,
          "75%": 1.25
        },
        "36015": {
          "name": "Chemung",
          "median": 1.12,
          "10%": 0.96,
          "90%": 1.3,
          "25%": 1.05,
          "75%": 1.18
        },
        "36017": {
          "name": "Chenango",
          "median": 1.09,
          "10%": 0.94,
          "90%": 1.3,
          "25%": 1.0,
          "75%": 1.19
        },
        "51550": {
          "name": "Chesapeake",
          "median": 1.13,
          "10%": 0.89,
          "90%": 1.35,
          "25%": 1.03,
          "75%": 1.27
        },
        "42029": {
          "name": "Chester",
          "median": 1.11,
          "10%": 0.939,
          "90%": 1.41,
          "25%": 1.0,
          "75%": 1.27
        },
        "51041": {
          "name": "Chesterfield",
          "median": 1.11,
          "10%": 0.94,
          "90%": 1.34,
          "25%": 1.0,
          "75%": 1.24
        },
        "42031": {
          "name": "Clarion",
          "median": 1.12,
          "10%": 0.99,
          "90%": 1.3,
          "25%": 1.05,
          "75%": 1.21
        },
        "51043": {
          "name": "Clarke",
          "median": 1.07,
          "10%": 0.92,
          "90%": 1.28,
          "25%": 1.0,
          "75%": 1.18
        },
        "54015": {
          "name": "Clay",
          "median": 1.08,
          "10%": 0.94,
          "90%": 1.25,
          "25%": 0.99,
          "75%": 1.16
        },
        "42033": {
          "name": "Clearfield",
          "median": 1.1,
          "10%": 0.99,
          "90%": 1.28,
          "25%": 1.03,
          "75%": 1.19
        },
        "42035": {
          "name": "Clinton",
          "median": 1.11,
          "10%": 0.92,
          "90%": 1.3,
          "25%": 1.02,
          "75%": 1.21
        },
        "51570": {
          "name": "Colonial Heights",
          "median": 1.12,
          "10%": 0.93,
          "90%": 1.38,
          "25%": 1.0,
          "75%": 1.22
        },
        "42037": {
          "name": "Columbia",
          "median": 1.16,
          "10%": 0.97,
          "90%": 1.39,
          "25%": 1.06,
          "75%": 1.28
        },
        "36023": {
          "name": "Cortland",
          "median": 1.11,
          "10%": 0.95,
          "90%": 1.301,
          "25%": 1.03,
          "75%": 1.21
        },
        "51580": {
          "name": "Covington",
          "median": 1.13,
          "10%": 0.94,
          "90%": 1.451,
          "25%": 0.99,
          "75%": 1.26
        },
        "51045": {
          "name": "Craig",
          "median": 1.14,
          "10%": 1.0,
          "90%": 1.37,
          "25%": 1.07,
          "75%": 1.26
        },
        "42039": {
          "name": "Crawford",
          "median": 1.13,
          "10%": 0.99,
          "90%": 1.3,
          "25%": 1.04,
          "75%": 1.23
        },
        "51047": {
          "name": "Culpeper",
          "median": 1.11,
          "10%": 0.98,
          "90%": 1.3,
          "25%": 1.04,
          "75%": 1.19
        },
        "34011": {
          "name": "Cumberland",
          "median": 1.12,
          "10%": 0.94,
          "90%": 1.36,
          "25%": 1.02,
          "75%": 1.23
        },
        "42041": {
          "name": "Cumberland",
          "median": 1.13,
          "10%": 0.97,
          "90%": 1.41,
          "25%": 1.04,
          "75%": 1.2
        },
        "51049": {
          "name": "Cumberland",
          "median": 1.1,
          "10%": 0.91,
          "90%": 1.35,
          "25%": 1.02,
          "75%": 1.22
        },
        "51590": {
          "name": "Danville",
          "median": 1.14,
          "10%": 0.979,
          "90%": 1.32,
          "25%": 1.07,
          "75%": 1.23
        },
        "42043": {
          "name": "Dauphin",
          "median": 1.15,
          "10%": 0.95,
          "90%": 1.46,
          "25%": 1.06,
          "75%": 1.3
        },
        "36025": {
          "name": "Delaware",
          "median": 1.15,
          "10%": 1.02,
          "90%": 1.36,
          "25%": 1.06,
          "75%": 1.23
        },
        "42045": {
          "name": "Delaware",
          "median": 1.13,
          "10%": 0.96,
          "90%": 1.35,
          "25%": 1.03,
          "75%": 1.24
        },
        "51051": {
          "name": "Dickenson",
          "median": 1.09,
          "10%": 0.97,
          "90%": 1.26,
          "25%": 1.03,
          "75%": 1.17
        },
        "51053": {
          "name": "Dinwiddie",
          "median": 1.1,
          "10%": 0.95,
          "90%": 1.29,
          "25%": 1.0,
          "75%": 1.19
        },
        "11001": {
          "name": "District of Columbia",
          "median": 1.1,
          "10%": 0.9,
          "90%": 1.33,
          "25%": 0.98,
          "75%": 1.21
        },
        "54017": {
          "name": "Doddridge",
          "median": 1.07,
          "10%": 0.95,
          "90%": 1.23,
          "25%": 1.03,
          "75%": 1.14
        },
        "24019": {
          "name": "Dorchester",
          "median": 1.06,
          "10%": 0.9,
          "90%": 1.32,
          "25%": 0.99,
          "75%": 1.19
        },
        "42047": {
          "name": "Elk",
          "median": 1.12,
          "10%": 0.93,
          "90%": 1.24,
          "25%": 1.02,
          "75%": 1.19
        },
        "51595": {
          "name": "Emporia",
          "median": 1.09,
          "10%": 0.88,
          "90%": 1.33,
          "25%": 0.96,
          "75%": 1.21
        },
        "42049": {
          "name": "Erie",
          "median": 1.12,
          "10%": 0.99,
          "90%": 1.3,
          "25%": 1.03,
          "75%": 1.19
        },
        "51057": {
          "name": "Essex",
          "median": 1.09,
          "10%": 0.9,
          "90%": 1.28,
          "25%": 0.99,
          "75%": 1.22
        },
        "51059": {
          "name": "Fairfax",
          "median": 1.08,
          "10%": 0.96,
          "90%": 1.32,
          "25%": 1.02,
          "75%": 1.1925
        },
        "51600": {
          "name": "Fairfax",
          "median": 1.06,
          "10%": 0.94,
          "90%": 1.31,
          "25%": 1.0,
          "75%": 1.19
        },
        "51610": {
          "name": "Falls Church",
          "median": 1.06,
          "10%": 0.91,
          "90%": 1.34,
          "25%": 0.99,
          "75%": 1.22
        },
        "51061": {
          "name": "Fauquier",
          "median": 1.12,
          "10%": 0.93,
          "90%": 1.34,
          "25%": 1.04,
          "75%": 1.23
        },
        "42051": {
          "name": "Fayette",
          "median": 1.09,
          "10%": 0.92,
          "90%": 1.3,
          "25%": 0.99,
          "75%": 1.17
        },
        "54019": {
          "name": "Fayette",
          "median": 1.09,
          "10%": 0.95,
          "90%": 1.23,
          "25%": 1.04,
          "75%": 1.15
        },
        "51063": {
          "name": "Floyd",
          "median": 1.12,
          "10%": 0.96,
          "90%": 1.34,
          "25%": 1.04,
          "75%": 1.23
        },
        "51065": {
          "name": "Fluvanna",
          "median": 1.14,
          "10%": 0.9,
          "90%": 1.51,
          "25%": 1.0,
          "75%": 1.28
        },
        "42053": {
          "name": "Forest",
          "median": 1.12,
          "10%": 0.94,
          "90%": 1.321,
          "25%": 1.03,
          "75%": 1.21
        },
        "42055": {
          "name": "Franklin",
          "median": 1.12,
          "10%": 0.98,
          "90%": 1.37,
          "25%": 1.05,
          "75%": 1.22
        },
        "51067": {
          "name": "Franklin",
          "median": 1.17,
          "10%": 1.01,
          "90%": 1.39,
          "25%": 1.05,
          "75%": 1.28
        },
        "51620": {
          "name": "Franklin",
          "median": 1.13,
          "10%": 0.88,
          "90%": 1.34,
          "25%": 0.99,
          "75%": 1.25
        },
        "24021": {
          "name": "Frederick",
          "median": 1.09,
          "10%": 0.93,
          "90%": 1.33,
          "25%": 1.01,
          "75%": 1.19
        },
        "51069": {
          "name": "Frederick",
          "median": 1.11,
          "10%": 0.949,
          "90%": 1.35,
          "25%": 1.03,
          "75%": 1.2
        },
        "51630": {
          "name": "Fredericksburg",
          "median": 1.12,
          "10%": 0.89,
          "90%": 1.41,
          "25%": 0.99,
          "75%": 1.25
        },
        "42057": {
          "name": "Fulton",
          "median": 1.16,
          "10%": 0.99,
          "90%": 1.39,
          "25%": 1.06,
          "75%": 1.26
        },
        "51640": {
          "name": "Galax",
          "median": 1.1,
          "10%": 0.89,
          "90%": 1.28,
          "25%": 0.99,
          "75%": 1.2
        },
        "24023": {
          "name": "Garrett",
          "median": 1.07,
          "10%": 0.94,
          "90%": 1.29,
          "25%": 1.01,
          "75%": 1.15
        },
        "51071": {
          "name": "Giles",
          "median": 1.14,
          "10%": 0.98,
          "90%": 1.28,
          "25%": 1.06,
          "75%": 1.21
        },
        "54021": {
          "name": "Gilmer",
          "median": 1.09,
          "10%": 0.92,
          "90%": 1.26,
          "25%": 1.0,
          "75%": 1.16
        },
        "34015": {
          "name": "Gloucester",
          "median": 1.11,
          "10%": 0.96,
          "90%": 1.27,
          "25%": 1.07,
          "75%": 1.2
        },
        "51073": {
          "name": "Gloucester",
          "median": 1.08,
          "10%": 0.94,
          "90%": 1.29,
          "25%": 0.99,
          "75%": 1.18
        },
        "51075": {
          "name": "Goochland",
          "median": 1.15,
          "10%": 0.86,
          "90%": 1.43,
          "25%": 0.96,
          "75%": 1.28
        },
        "54023": {
          "name": "Grant",
          "median": 1.08,
          "10%": 0.98,
          "90%": 1.32,
          "25%": 1.02,
          "75%": 1.19
        },
        "51077": {
          "name": "Grayson",
          "median": 1.1,
          "10%": 0.99,
          "90%": 1.26,
          "25%": 1.04,
          "75%": 1.18
        },
        "54025": {
          "name": "Greenbrier",
          "median": 1.13,
          "10%": 0.99,
          "90%": 1.28,
          "25%": 1.08,
          "75%": 1.2
        },
        "36039": {
          "name": "Greene",
          "median": 1.19,
          "10%": 0.97,
          "90%": 1.38,
          "25%": 1.08,
          "75%": 1.29
        },
        "42059": {
          "name": "Greene",
          "median": 1.11,
          "10%": 0.96,
          "90%": 1.26,
          "25%": 1.03,
          "75%": 1.19
        },
        "51079": {
          "name": "Greene",
          "median": 1.13,
          "10%": 0.94,
          "90%": 1.39,
          "25%": 1.01,
          "75%": 1.24
        },
        "51081": {
          "name": "Greensville",
          "median": 1.09,
          "10%": 0.92,
          "90%": 1.31,
          "25%": 0.96,
          "75%": 1.2
        },
        "51083": {
          "name": "Halifax",
          "median": 1.15,
          "10%": 0.97,
          "90%": 1.36,
          "25%": 1.07,
          "75%": 1.27
        },
        "54027": {
          "name": "Hampshire",
          "median": 1.14,
          "10%": 1.01,
          "90%": 1.39,
          "25%": 1.06,
          "75%": 1.27
        },
        "51650": {
          "name": "Hampton",
          "median": 1.11,
          "10%": 0.95,
          "90%": 1.32,
          "25%": 1.02,
          "75%": 1.21
        },
        "54029": {
          "name": "Hancock",
          "median": 1.09,
          "10%": 0.9,
          "90%": 1.27,
          "25%": 0.99,
          "75%": 1.19
        },
        "51085": {
          "name": "Hanover",
          "median": 1.1,
          "10%": 0.94,
          "90%": 1.33,
          "25%": 0.99,
          "75%": 1.2
        },
        "54031": {
          "name": "Hardy",
          "median": 1.12,
          "10%": 0.99,
          "90%": 1.35,
          "25%": 1.05,
          "75%": 1.21
        },
        "24025": {
          "name": "Harford",
          "median": 1.1,
          "10%": 0.9,
          "90%": 1.4,
          "25%": 1.03,
          "75%": 1.19
        },
        "54033": {
          "name": "Harrison",
          "median": 1.06,
          "10%": 0.94,
          "90%": 1.24,
          "25%": 1.02,
          "75%": 1.17
        },
        "51660": {
          "name": "Harrisonburg",
          "median": 1.09,
          "10%": 0.92,
          "90%": 1.41,
          "25%": 1.0,
          "75%": 1.2
        },
        "51087": {
          "name": "Henrico",
          "median": 1.12,
          "10%": 0.94,
          "90%": 1.32,
          "25%": 1.02,
          "75%": 1.23
        },
        "51089": {
          "name": "Henry",
          "median": 1.18,
          "10%": 0.99,
          "90%": 1.47,
          "25%": 1.08,
          "75%": 1.34
        },
        "36043": {
          "name": "Herkimer",
          "median": 1.05,
          "10%": 0.91,
          "90%": 1.23,
          "25%": 0.99,
          "75%": 1.14
        },
        "51091": {
          "name": "Highland",
          "median": 1.12,
          "10%": 0.96,
          "90%": 1.35,
          "25%": 1.01,
          "75%": 1.23
        },
        "51670": {
          "name": "Hopewell",
          "median": 1.07,
          "10%": 0.94,
          "90%": 1.32,
          "25%": 0.99,
          "75%": 1.19
        },
        "24027": {
          "name": "Howard",
          "median": 1.13,
          "10%": 0.93,
          "90%": 1.33,
          "25%": 1.0075,
          "75%": 1.25
        },
        "34019": {
          "name": "Hunterdon",
          "median": 1.13,
          "10%": 0.96,
          "90%": 1.4,
          "25%": 1.03,
          "75%": 1.29
        },
        "42061": {
          "name": "Huntingdon",
          "median": 1.18,
          "10%": 0.96,
          "90%": 1.36,
          "25%": 1.05,
          "75%": 1.25
        },
        "42063": {
          "name": "Indiana",
          "median": 1.12,
          "10%": 0.96,
          "90%": 1.32,
          "25%": 1.03,
          "75%": 1.22
        },
        "51093": {
          "name": "Isle of Wight",
          "median": 1.135,
          "10%": 0.92,
          "90%": 1.31,
          "25%": 1.02,
          "75%": 1.24
        },
        "54035": {
          "name": "Jackson",
          "median": 1.14,
          "10%": 0.97,
          "90%": 1.3,
          "25%": 1.06,
          "75%": 1.23
        },
        "51095": {
          "name": "James City",
          "median": 1.06,
          "10%": 0.89,
          "90%": 1.32,
          "25%": 0.95,
          "75%": 1.19
        },
        "42065": {
          "name": "Jefferson",
          "median": 1.12,
          "10%": 0.98,
          "90%": 1.3,
          "25%": 1.05,
          "75%": 1.22
        },
        "54037": {
          "name": "Jefferson",
          "median": 1.07,
          "10%": 0.95,
          "90%": 1.25,
          "25%": 0.99,
          "75%": 1.18
        },
        "42067": {
          "name": "Juniata",
          "median": 1.14,
          "10%": 0.98,
          "90%": 1.34,
          "25%": 1.03,
          "75%": 1.21
        },
        "54039": {
          "name": "Kanawha",
          "median": 1.06,
          "10%": 0.94,
          "90%": 1.181,
          "25%": 1.0,
          "75%": 1.13
        },
        "10001": {
          "name": "Kent",
          "median": 1.09,
          "10%": 0.93,
          "90%": 1.27,
          "25%": 0.99,
          "75%": 1.19
        },
        "24029": {
          "name": "Kent",
          "median": 1.07,
          "10%": 0.92,
          "90%": 1.29,
          "25%": 0.97,
          "75%": 1.16
        },
        "51099": {
          "name": "King George",
          "median": 1.11,
          "10%": 0.91,
          "90%": 1.43,
          "25%": 0.96,
          "75%": 1.26
        },
        "51101": {
          "name": "King William",
          "median": 1.08,
          "10%": 0.95,
          "90%": 1.3,
          "25%": 1.0,
          "75%": 1.22
        },
        "51097": {
          "name": "King and Queen",
          "median": 1.09,
          "10%": 0.92,
          "90%": 1.27,
          "25%": 0.98,
          "75%": 1.18
        },
        "42069": {
          "name": "Lackawanna",
          "median": 1.16,
          "10%": 0.95,
          "90%": 1.35,
          "25%": 1.06,
          "75%": 1.28
        },
        "42071": {
          "name": "Lancaster",
          "median": 1.13,
          "10%": 0.94,
          "90%": 1.4,
          "25%": 1.02,
          "75%": 1.29
        },
        "51103": {
          "name": "Lancaster",
          "median": 1.09,
          "10%": 0.92,
          "90%": 1.24,
          "25%": 1.0,
          "75%": 1.17
        },
        "42073": {
          "name": "Lawrence",
          "median": 1.11,
          "10%": 0.92,
          "90%": 1.35,
          "25%": 1.01,
          "75%": 1.22
        },
        "42075": {
          "name": "Lebanon",
          "median": 1.13,
          "10%": 0.92,
          "90%": 1.41,
          "25%": 1.06,
          "75%": 1.28
        },
        "51105": {
          "name": "Lee",
          "median": 1.18,
          "10%": 1.0,
          "90%": 1.32,
          "25%": 1.08,
          "75%": 1.24
        },
        "42077": {
          "name": "Lehigh",
          "median": 1.13,
          "10%": 0.95,
          "90%": 1.41,
          "25%": 1.02,
          "75%": 1.27
        },
        "54041": {
          "name": "Lewis",
          "median": 1.1,
          "10%": 0.96,
          "90%": 1.22,
          "25%": 1.02,
          "75%": 1.16
        },
        "51678": {
          "name": "Lexington",
          "median": 1.1,
          "10%": 0.92,
          "90%": 1.33,
          "25%": 0.99,
          "75%": 1.22
        },
        "54043": {
          "name": "Lincoln",
          "median": 1.11,
          "10%": 0.97,
          "90%": 1.3,
          "25%": 1.03,
          "75%": 1.19
        },
        "36051": {
          "name": "Livingston",
          "median": 1.1,
          "10%": 0.91,
          "90%": 1.3,
          "25%": 1.02,
          "75%": 1.18
        },
        "54045": {
          "name": "Logan",
          "median": 1.12,
          "10%": 0.98,
          "90%": 1.27,
          "25%": 1.06,
          "75%": 1.2
        },
        "51107": {
          "name": "Loudoun",
          "median": 1.09,
          "10%": 0.96,
          "90%": 1.35,
          "25%": 1.02,
          "75%": 1.22
        },
        "51109": {
          "name": "Louisa",
          "median": 1.13,
          "10%": 0.92,
          "90%": 1.41,
          "25%": 0.99,
          "75%": 1.25
        },
        "51111": {
          "name": "Lunenburg",
          "median": 1.13,
          "10%": 0.92,
          "90%": 1.34,
          "25%": 0.99,
          "75%": 1.25
        },
        "42079": {
          "name": "Luzerne",
          "median": 1.17,
          "10%": 0.96,
          "90%": 1.32,
          "25%": 1.07,
          "75%": 1.23
        },
        "42081": {
          "name": "Lycoming",
          "median": 1.12,
          "10%": 0.98,
          "90%": 1.29,
          "25%": 1.0475,
          "75%": 1.21
        },
        "51680": {
          "name": "Lynchburg",
          "median": 1.15,
          "10%": 1.01,
          "90%": 1.36,
          "25%": 1.07,
          "75%": 1.2425
        },
        "36053": {
          "name": "Madison",
          "median": 1.08,
          "10%": 0.93,
          "90%": 1.3,
          "25%": 0.99,
          "75%": 1.18
        },
        "51113": {
          "name": "Madison",
          "median": 1.11,
          "10%": 0.93,
          "90%": 1.39,
          "25%": 1.02,
          "75%": 1.25
        },
        "51683": {
          "name": "Manassas",
          "median": 1.09,
          "10%": 0.96,
          "90%": 1.26,
          "25%": 1.03,
          "75%": 1.18
        },
        "51685": {
          "name": "Manassas Park",
          "median": 1.08,
          "10%": 0.94,
          "90%": 1.26,
          "25%": 1.01,
          "75%": 1.17
        },
        "54049": {
          "name": "Marion",
          "median": 1.06,
          "10%": 0.94,
          "90%": 1.22,
          "25%": 1.0,
          "75%": 1.14
        },
        "54051": {
          "name": "Marshall",
          "median": 1.11,
          "10%": 0.94,
          "90%": 1.27,
          "25%": 1.02,
          "75%": 1.19
        },
        "51690": {
          "name": "Martinsville",
          "median": 1.19,
          "10%": 0.95,
          "90%": 1.49,
          "25%": 1.07,
          "75%": 1.38
        },
        "54053": {
          "name": "Mason",
          "median": 1.15,
          "10%": 0.98,
          "90%": 1.321,
          "25%": 1.07,
          "75%": 1.25
        },
        "51115": {
          "name": "Mathews",
          "median": 1.13,
          "10%": 0.96,
          "90%": 1.32,
          "25%": 1.02,
          "75%": 1.21
        },
        "54047": {
          "name": "McDowell",
          "median": 1.09,
          "10%": 1.0,
          "90%": 1.3,
          "25%": 1.04,
          "75%": 1.16
        },
        "42083": {
          "name": "McKean",
          "median": 1.11,
          "10%": 0.94,
          "90%": 1.27,
          "25%": 1.02,
          "75%": 1.17
        },
        "51117": {
          "name": "Mecklenburg",
          "median": 1.11,
          "10%": 0.94,
          "90%": 1.26,
          "25%": 1.02,
          "75%": 1.21
        },
        "34021": {
          "name": "Mercer",
          "median": 1.06,
          "10%": 0.91,
          "90%": 1.35,
          "25%": 0.98,
          "75%": 1.1925
        },
        "42085": {
          "name": "Mercer",
          "median": 1.14,
          "10%": 0.97,
          "90%": 1.29,
          "25%": 1.03,
          "75%": 1.21
        },
        "54055": {
          "name": "Mercer",
          "median": 1.14,
          "10%": 1.01,
          "90%": 1.27,
          "25%": 1.07,
          "75%": 1.21
        },
        "51119": {
          "name": "Middlesex",
          "median": 1.06,
          "10%": 0.95,
          "90%": 1.231,
          "25%": 0.99,
          "75%": 1.15
        },
        "42087": {
          "name": "Mifflin",
          "median": 1.15,
          "10%": 0.95,
          "90%": 1.38,
          "25%": 1.03,
          "75%": 1.25
        },
        "54057": {
          "name": "Mineral",
          "median": 1.13,
          "10%": 1.0,
          "90%": 1.34,
          "25%": 1.06,
          "75%": 1.22
        },
        "54059": {
          "name": "Mingo",
          "median": 1.13,
          "10%": 0.99,
          "90%": 1.3,
          "25%": 1.06,
          "75%": 1.22
        },
        "34025": {
          "name": "Monmouth",
          "median": 1.09,
          "10%": 0.92,
          "90%": 1.291,
          "25%": 0.97,
          "75%": 1.19
        },
        "54061": {
          "name": "Monongalia",
          "median": 1.09,
          "10%": 0.92,
          "90%": 1.25,
          "25%": 1.01,
          "75%": 1.16
        },
        "42089": {
          "name": "Monroe",
          "median": 1.15,
          "10%": 0.93,
          "90%": 1.39,
          "25%": 1.05,
          "75%": 1.28
        },
        "54063": {
          "name": "Monroe",
          "median": 1.12,
          "10%": 1.0,
          "90%": 1.25,
          "25%": 1.05,
          "75%": 1.19
        },
        "24031": {
          "name": "Montgomery",
          "median": 1.1,
          "10%": 0.97,
          "90%": 1.3,
          "25%": 1.02,
          "75%": 1.19
        },
        "36057": {
          "name": "Montgomery",
          "median": 1.12,
          "10%": 0.93,
          "90%": 1.36,
          "25%": 1.02,
          "75%": 1.26
        },
        "42091": {
          "name": "Montgomery",
          "median": 1.08,
          "10%": 0.99,
          "90%": 1.34,
          "25%": 1.04,
          "75%": 1.21
        },
        "51121": {
          "name": "Montgomery",
          "median": 1.15,
          "10%": 0.98,
          "90%": 1.34,
          "25%": 1.07,
          "75%": 1.21
        },
        "42093": {
          "name": "Montour",
          "median": 1.16,
          "10%": 0.97,
          "90%": 1.4,
          "25%": 1.04,
          "75%": 1.27
        },
        "54065": {
          "name": "Morgan",
          "median": 1.13,
          "10%": 0.95,
          "90%": 1.44,
          "25%": 1.04,
          "75%": 1.24
        },
        "34027": {
          "name": "Morris",
          "median": 1.15,
          "10%": 0.94,
          "90%": 1.44,
          "25%": 1.01,
          "75%": 1.35
        },
        "36059": {
          "name": "Nassau",
          "median": 1.1,
          "10%": 0.93,
          "90%": 1.32,
          "25%": 1.03,
          "75%": 1.23
        },
        "51125": {
          "name": "Nelson",
          "median": 1.16,
          "10%": 0.87,
          "90%": 1.45,
          "25%": 1.05,
          "75%": 1.3
        },
        "10003": {
          "name": "New Castle",
          "median": 1.12,
          "10%": 0.95,
          "90%": 1.32,
          "25%": 1.03,
          "75%": 1.22
        },
        "51127": {
          "name": "New Kent",
          "median": 1.07,
          "10%": 0.96,
          "90%": 1.27,
          "25%": 0.99,
          "75%": 1.21
        },
        "36061": {
          "name": "New York",
          "median": 1.05,
          "10%": 0.89,
          "90%": 1.32,
          "25%": 0.97,
          "75%": 1.17
        },
        "51700": {
          "name": "Newport News",
          "median": 1.11,
          "10%": 0.93,
          "90%": 1.29,
          "25%": 1.01,
          "75%": 1.19
        },
        "54067": {
          "name": "Nicholas",
          "median": 1.08,
          "10%": 0.94,
          "90%": 1.24,
          "25%": 1.01,
          "75%": 1.15
        },
        "51710": {
          "name": "Norfolk",
          "median": 1.12,
          "10%": 0.9,
          "90%": 1.4,
          "25%": 1.0,
          "75%": 1.3
        },
        "42095": {
          "name": "Northampton",
          "median": 1.12,
          "10%": 0.94,
          "90%": 1.4,
          "25%": 1.02,
          "75%": 1.27
        },
        "51131": {
          "name": "Northampton",
          "median": 1.11,
          "10%": 0.93,
          "90%": 1.25,
          "25%": 1.02,
          "75%": 1.19
        },
        "42097": {
          "name": "Northumberland",
          "median": 1.17,
          "10%": 0.97,
          "90%": 1.42,
          "25%": 1.07,
          "75%": 1.29
        },
        "51133": {
          "name": "Northumberland",
          "median": 1.1,
          "10%": 0.9,
          "90%": 1.31,
          "25%": 1.0,
          "75%": 1.19
        },
        "51720": {
          "name": "Norton",
          "median": 1.16,
          "10%": 0.96,
          "90%": 1.34,
          "25%": 1.05,
          "75%": 1.24
        },
        "51135": {
          "name": "Nottoway",
          "median": 1.12,
          "10%": 0.92,
          "90%": 1.39,
          "25%": 1.0,
          "75%": 1.23
        },
        "34029": {
          "name": "Ocean",
          "median": 1.08,
          "10%": 0.97,
          "90%": 1.271,
          "25%": 1.01,
          "75%": 1.14
        },
        "54069": {
          "name": "Ohio",
          "median": 1.12,
          "10%": 0.93,
          "90%": 1.31,
          "25%": 1.02,
          "75%": 1.22
        },
        "36065": {
          "name": "Oneida",
          "median": 1.08,
          "10%": 0.94,
          "90%": 1.28,
          "25%": 1.02,
          "75%": 1.19
        },
        "36067": {
          "name": "Onondaga",
          "median": 1.1,
          "10%": 0.98,
          "90%": 1.34,
          "25%": 1.03,
          "75%": 1.22
        },
        "36069": {
          "name": "Ontario",
          "median": 1.09,
          "10%": 0.94,
          "90%": 1.301,
          "25%": 1.02,
          "75%": 1.19
        },
        "36071": {
          "name": "Orange",
          "median": 1.15,
          "10%": 0.95,
          "90%": 1.44,
          "25%": 1.07,
          "75%": 1.28
        },
        "51137": {
          "name": "Orange",
          "median": 1.14,
          "10%": 0.95,
          "90%": 1.34,
          "25%": 1.03,
          "75%": 1.22
        },
        "36077": {
          "name": "Otsego",
          "median": 1.09,
          "10%": 0.949,
          "90%": 1.3,
          "25%": 1.02,
          "75%": 1.2025
        },
        "51139": {
          "name": "Page",
          "median": 1.11,
          "10%": 0.96,
          "90%": 1.46,
          "25%": 1.02,
          "75%": 1.25
        },
        "51141": {
          "name": "Patrick",
          "median": 1.13,
          "10%": 0.95,
          "90%": 1.43,
          "25%": 1.05,
          "75%": 1.29
        },
        "54071": {
          "name": "Pendleton",
          "median": 1.11,
          "10%": 0.91,
          "90%": 1.421,
          "25%": 1.0,
          "75%": 1.28
        },
        "42099": {
          "name": "Perry",
          "median": 1.13,
          "10%": 0.97,
          "90%": 1.37,
          "25%": 1.05,
          "75%": 1.23
        },
        "51730": {
          "name": "Petersburg",
          "median": 1.11,
          "10%": 0.93,
          "90%": 1.38,
          "25%": 0.99,
          "75%": 1.21
        },
        "42101": {
          "name": "Philadelphia",
          "median": 1.1,
          "10%": 0.95,
          "90%": 1.28,
          "25%": 1.05,
          "75%": 1.2
        },
        "42103": {
          "name": "Pike",
          "median": 1.15,
          "10%": 0.91,
          "90%": 1.41,
          "25%": 1.06,
          "75%": 1.26
        },
        "51143": {
          "name": "Pittsylvania",
          "median": 1.17,
          "10%": 1.0,
          "90%": 1.38,
          "25%": 1.09,
          "75%": 1.26
        },
        "54073": {
          "name": "Pleasants",
          "median": 1.06,
          "10%": 0.94,
          "90%": 1.21,
          "25%": 1.0,
          "75%": 1.14
        },
        "54075": {
          "name": "Pocahontas",
          "median": 1.12,
          "10%": 1.0,
          "90%": 1.35,
          "25%": 1.05,
          "75%": 1.21
        },
        "51735": {
          "name": "Poquoson",
          "median": 1.1,
          "10%": 0.94,
          "90%": 1.29,
          "25%": 1.01,
          "75%": 1.21
        },
        "51740": {
          "name": "Portsmouth",
          "median": 1.13,
          "10%": 0.88,
          "90%": 1.41,
          "25%": 1.01,
          "75%": 1.27
        },
        "42105": {
          "name": "Potter",
          "median": 1.11,
          "10%": 0.9,
          "90%": 1.26,
          "25%": 1.02,
          "75%": 1.19
        },
        "51145": {
          "name": "Powhatan",
          "median": 1.1,
          "10%": 0.9,
          "90%": 1.41,
          "25%": 0.98,
          "75%": 1.24
        },
        "54077": {
          "name": "Preston",
          "median": 1.09,
          "10%": 0.93,
          "90%": 1.25,
          "25%": 1.01,
          "75%": 1.19
        },
        "51147": {
          "name": "Prince Edward",
          "median": 1.09,
          "10%": 0.95,
          "90%": 1.35,
          "25%": 1.01,
          "75%": 1.19
        },
        "51149": {
          "name": "Prince George",
          "median": 1.09,
          "10%": 0.95,
          "90%": 1.32,
          "25%": 0.99,
          "75%": 1.17
        },
        "24033": {
          "name": "Prince George's",
          "median": 1.1,
          "10%": 0.91,
          "90%": 1.34,
          "25%": 1.01,
          "75%": 1.2
        },
        "51153": {
          "name": "Prince William",
          "median": 1.1,
          "10%": 1.01,
          "90%": 1.31,
          "25%": 1.04,
          "75%": 1.2
        },
        "51155": {
          "name": "Pulaski",
          "median": 1.15,
          "10%": 0.97,
          "90%": 1.29,
          "25%": 1.05,
          "75%": 1.22
        },
        "54079": {
          "name": "Putnam",
          "median": 1.12,
          "10%": 0.96,
          "90%": 1.28,
          "25%": 1.03,
          "75%": 1.2
        },
        "24035": {
          "name": "Queen Anne's",
          "median": 1.06,
          "10%": 0.92,
          "90%": 1.29,
          "25%": 0.98,
          "75%": 1.16
        },
        "51750": {
          "name": "Radford",
          "median": 1.17,
          "10%": 0.98,
          "90%": 1.31,
          "25%": 1.06,
          "75%": 1.26
        },
        "54081": {
          "name": "Raleigh",
          "median": 1.11,
          "10%": 0.98,
          "90%": 1.38,
          "25%": 1.05,
          "75%": 1.21
        },
        "54083": {
          "name": "Randolph",
          "median": 1.11,
          "10%": 0.97,
          "90%": 1.29,
          "25%": 1.04,
          "75%": 1.2
        },
        "51157": {
          "name": "Rappahannock",
          "median": 1.12,
          "10%": 0.95,
          "90%": 1.34,
          "25%": 1.03,
          "75%": 1.21
        },
        "36085": {
          "name": "Richmond",
          "median": 1.06,
          "10%": 0.85,
          "90%": 1.3,
          "25%": 0.97,
          "75%": 1.17
        },
        "51159": {
          "name": "Richmond",
          "median": 1.12,
          "10%": 0.86,
          "90%": 1.29,
          "25%": 0.98,
          "75%": 1.21
        },
        "51760": {
          "name": "Richmond",
          "median": 1.14,
          "10%": 0.95,
          "90%": 1.38,
          "25%": 1.02,
          "75%": 1.24
        },
        "54085": {
          "name": "Ritchie",
          "median": 1.1,
          "10%": 1.0,
          "90%": 1.26,
          "25%": 1.04,
          "75%": 1.18
        },
        "54087": {
          "name": "Roane",
          "median": 1.1,
          "10%": 0.95,
          "90%": 1.26,
          "25%": 1.01,
          "75%": 1.19
        },
        "51161": {
          "name": "Roanoke",
          "median": 1.17,
          "10%": 1.0,
          "90%": 1.42,
          "25%": 1.07,
          "75%": 1.32
        },
        "51770": {
          "name": "Roanoke",
          "median": 1.2,
          "10%": 0.96,
          "90%": 1.51,
          "25%": 1.07,
          "75%": 1.35
        },
        "51163": {
          "name": "Rockbridge",
          "median": 1.14,
          "10%": 0.96,
          "90%": 1.36,
          "25%": 1.03,
          "75%": 1.23
        },
        "51165": {
          "name": "Rockingham",
          "median": 1.09,
          "10%": 0.98,
          "90%": 1.41,
          "25%": 1.01,
          "75%": 1.2
        },
        "51167": {
          "name": "Russell",
          "median": 1.13,
          "10%": 0.96,
          "90%": 1.24,
          "25%": 1.05,
          "75%": 1.19
        },
        "34033": {
          "name": "Salem",
          "median": 1.12,
          "10%": 0.98,
          "90%": 1.29,
          "25%": 1.05,
          "75%": 1.2
        },
        "51775": {
          "name": "Salem",
          "median": 1.19,
          "10%": 0.97,
          "90%": 1.49,
          "25%": 1.06,
          "75%": 1.35
        },
        "36095": {
          "name": "Schoharie",
          "median": 1.115,
          "10%": 0.95,
          "90%": 1.35,
          "25%": 1.03,
          "75%": 1.22
        },
        "36097": {
          "name": "Schuyler",
          "median": 1.11,
          "10%": 0.94,
          "90%": 1.31,
          "25%": 1.03,
          "75%": 1.2
        },
        "42107": {
          "name": "Schuylkill",
          "median": 1.18,
          "10%": 0.94,
          "90%": 1.38,
          "25%": 1.03,
          "75%": 1.28
        },
        "51169": {
          "name": "Scott",
          "median": 1.17,
          "10%": 0.97,
          "90%": 1.27,
          "25%": 1.06,
          "75%": 1.22
        },
        "51171": {
          "name": "Shenandoah",
          "median": 1.1,
          "10%": 0.97,
          "90%": 1.34,
          "25%": 1.01,
          "75%": 1.21
        },
        "51173": {
          "name": "Smyth",
          "median": 1.1,
          "10%": 1.02,
          "90%": 1.24,
          "25%": 1.06,
          "75%": 1.18
        },
        "42109": {
          "name": "Snyder",
          "median": 1.14,
          "10%": 0.99,
          "90%": 1.39,
          "25%": 1.05,
          "75%": 1.25
        },
        "24039": {
          "name": "Somerset",
          "median": 1.115,
          "10%": 0.97,
          "90%": 1.35,
          "25%": 1.05,
          "75%": 1.22
        },
        "42111": {
          "name": "Somerset",
          "median": 1.1,
          "10%": 0.99,
          "90%": 1.26,
          "25%": 1.03,
          "75%": 1.16
        },
        "51175": {
          "name": "Southampton",
          "median": 1.12,
          "10%": 0.92,
          "90%": 1.33,
          "25%": 1.01,
          "75%": 1.24
        },
        "51177": {
          "name": "Spotsylvania",
          "median": 1.11,
          "10%": 0.93,
          "90%": 1.31,
          "25%": 0.99,
          "75%": 1.22
        },
        "24037": {
          "name": "St. Mary's",
          "median": 1.08,
          "10%": 0.9,
          "90%": 1.31,
          "25%": 0.98,
          "75%": 1.21
        },
        "51179": {
          "name": "Stafford",
          "median": 1.13,
          "10%": 0.94,
          "90%": 1.38,
          "25%": 1.01,
          "75%": 1.22
        },
        "51790": {
          "name": "Staunton",
          "median": 1.14,
          "10%": 0.86,
          "90%": 1.41,
          "25%": 1.05,
          "75%": 1.24
        },
        "36101": {
          "name": "Steuben",
          "median": 1.09,
          "10%": 0.93,
          "90%": 1.35,
          "25%": 1.02,
          "75%": 1.1625
        },
        "51800": {
          "name": "Suffolk",
          "median": 1.17,
          "10%": 0.9,
          "90%": 1.31,
          "25%": 1.02,
          "75%": 1.23
        },
        "36105": {
          "name": "Sullivan",
          "median": 1.17,
          "10%": 0.96,
          "90%": 1.38,
          "25%": 1.06,
          "75%": 1.27
        },
        "42113": {
          "name": "Sullivan",
          "median": 1.13,
          "10%": 0.92,
          "90%": 1.32,
          "25%": 1.04,
          "75%": 1.23
        },
        "54089": {
          "name": "Summers",
          "median": 1.13,
          "10%": 0.95,
          "90%": 1.31,
          "25%": 1.04,
          "75%": 1.23
        },
        "51181": {
          "name": "Surry",
          "median": 1.07,
          "10%": 0.92,
          "90%": 1.27,
          "25%": 0.99,
          "75%": 1.19
        },
        "42115": {
          "name": "Susquehanna",
          "median": 1.12,
          "10%": 0.98,
          "90%": 1.32,
          "25%": 1.03,
          "75%": 1.22
        },
        "10005": {
          "name": "Sussex",
          "median": 1.08,
          "10%": 0.97,
          "90%": 1.37,
          "25%": 1.01,
          "75%": 1.2
        },
        "34037": {
          "name": "Sussex",
          "median": 1.16,
          "10%": 0.97,
          "90%": 1.47,
          "25%": 1.06,
          "75%": 1.29
        },
        "51183": {
          "name": "Sussex",
          "median": 1.1,
          "10%": 0.9,
          "90%": 1.31,
          "25%": 0.98,
          "75%": 1.2
        },
        "24041": {
          "name": "Talbot",
          "median": 1.05,
          "10%": 0.9,
          "90%": 1.33,
          "25%": 0.96,
          "75%": 1.17
        },
        "54091": {
          "name": "Taylor",
          "median": 1.1,
          "10%": 0.93,
          "90%": 1.25,
          "25%": 1.01,
          "75%": 1.19
        },
        "51185": {
          "name": "Tazewell",
          "median": 1.11,
          "10%": 1.01,
          "90%": 1.26,
          "25%": 1.05,
          "75%": 1.19
        },
        "36107": {
          "name": "Tioga",
          "median": 1.11,
          "10%": 0.96,
          "90%": 1.38,
          "25%": 1.03,
          "75%": 1.26
        },
        "42117": {
          "name": "Tioga",
          "median": 1.11,
          "10%": 0.92,
          "90%": 1.28,
          "25%": 1.01,
          "75%": 1.2
        },
        "36109": {
          "name": "Tompkins",
          "median": 1.11,
          "10%": 0.96,
          "90%": 1.34,
          "25%": 1.04,
          "75%": 1.19
        },
        "54093": {
          "name": "Tucker",
          "median": 1.07,
          "10%": 0.97,
          "90%": 1.27,
          "25%": 1.0,
          "75%": 1.18
        },
        "54095": {
          "name": "Tyler",
          "median": 1.07,
          "10%": 0.91,
          "90%": 1.18,
          "25%": 0.98,
          "75%": 1.13
        },
        "36111": {
          "name": "Ulster",
          "median": 1.17,
          "10%": 0.99,
          "90%": 1.36,
          "25%": 1.06,
          "75%": 1.3
        },
        "42119": {
          "name": "Union",
          "median": 1.13,
          "10%": 1.0,
          "90%": 1.31,
          "25%": 1.05,
          "75%": 1.22
        },
        "54097": {
          "name": "Upshur",
          "median": 1.1,
          "10%": 0.96,
          "90%": 1.26,
          "25%": 1.03,
          "75%": 1.19
        },
        "42121": {
          "name": "Venango",
          "median": 1.13,
          "10%": 0.979,
          "90%": 1.3,
          "25%": 1.06,
          "75%": 1.21
        },
        "51810": {
          "name": "Virginia Beach",
          "median": 1.12,
          "10%": 0.91,
          "90%": 1.35,
          "25%": 1.04,
          "75%": 1.24
        },
        "34041": {
          "name": "Warren",
          "median": 1.15,
          "10%": 0.95,
          "90%": 1.43,
          "25%": 1.04,
          "75%": 1.29
        },
        "42123": {
          "name": "Warren",
          "median": 1.11,
          "10%": 1.0,
          "90%": 1.3,
          "25%": 1.05,
          "75%": 1.2
        },
        "51187": {
          "name": "Warren",
          "median": 1.11,
          "10%": 0.94,
          "90%": 1.321,
          "25%": 1.02,
          "75%": 1.21
        },
        "24043": {
          "name": "Washington",
          "median": 1.11,
          "10%": 0.96,
          "90%": 1.35,
          "25%": 1.03,
          "75%": 1.23
        },
        "42125": {
          "name": "Washington",
          "median": 1.08,
          "10%": 0.93,
          "90%": 1.28,
          "25%": 0.99,
          "75%": 1.18
        },
        "51191": {
          "name": "Washington",
          "median": 1.11,
          "10%": 0.97,
          "90%": 1.24,
          "25%": 1.03,
          "75%": 1.17
        },
        "42127": {
          "name": "Wayne",
          "median": 1.15,
          "10%": 0.95,
          "90%": 1.35,
          "25%": 1.02,
          "75%": 1.26
        },
        "54099": {
          "name": "Wayne",
          "median": 1.12,
          "10%": 1.01,
          "90%": 1.33,
          "25%": 1.05,
          "75%": 1.21
        },
        "51820": {
          "name": "Waynesboro",
          "median": 1.16,
          "10%": 0.89,
          "90%": 1.4,
          "25%": 1.0,
          "75%": 1.26
        },
        "54101": {
          "name": "Webster",
          "median": 1.08,
          "10%": 0.95,
          "90%": 1.26,
          "25%": 1.01,
          "75%": 1.15
        },
        "36119": {
          "name": "Westchester",
          "median": 1.09,
          "10%": 0.94,
          "90%": 1.34,
          "25%": 1.0,
          "75%": 1.23
        },
        "42129": {
          "name": "Westmoreland",
          "median": 1.08,
          "10%": 0.94,
          "90%": 1.26,
          "25%": 1.03,
          "75%": 1.17
        },
        "51193": {
          "name": "Westmoreland",
          "median": 1.1,
          "10%": 0.9,
          "90%": 1.34,
          "25%": 0.96,
          "75%": 1.24
        },
        "54103": {
          "name": "Wetzel",
          "median": 1.09,
          "10%": 0.95,
          "90%": 1.24,
          "25%": 1.01,
          "75%": 1.17
        },
        "24045": {
          "name": "Wicomico",
          "median": 1.11,
          "10%": 0.96,
          "90%": 1.33,
          "25%": 1.03,
          "75%": 1.19
        },
        "51830": {
          "name": "Williamsburg",
          "median": 1.05,
          "10%": 0.86,
          "90%": 1.36,
          "25%": 0.94,
          "75%": 1.19
        },
        "51840": {
          "name": "Winchester",
          "median": 1.11,
          "10%": 0.93,
          "90%": 1.38,
          "25%": 1.02,
          "75%": 1.21
        },
        "54105": {
          "name": "Wirt",
          "median": 1.16,
          "10%": 0.97,
          "90%": 1.32,
          "25%": 1.05,
          "75%": 1.23
        },
        "51195": {
          "name": "Wise",
          "median": 1.13,
          "10%": 0.97,
          "90%": 1.3,
          "25%": 1.05,
          "75%": 1.23
        },
        "54107": {
          "name": "Wood",
          "median": 1.11,
          "10%": 0.97,
          "90%": 1.29,
          "25%": 1.03,
          "75%": 1.19
        },
        "24047": {
          "name": "Worcester",
          "median": 1.1,
          "10%": 0.95,
          "90%": 1.35,
          "25%": 1.02,
          "75%": 1.28
        },
        "42131": {
          "name": "Wyoming",
          "median": 1.17,
          "10%": 0.97,
          "90%": 1.33,
          "25%": 1.07,
          "75%": 1.26
        },
        "54109": {
          "name": "Wyoming",
          "median": 1.1,
          "10%": 1.0,
          "90%": 1.27,
          "25%": 1.06,
          "75%": 1.17
        },
        "51197": {
          "name": "Wythe",
          "median": 1.12,
          "10%": 0.95,
          "90%": 1.24,
          "25%": 1.0,
          "75%": 1.19
        },
        "36123": {
          "name": "Yates",
          "median": 1.11,
          "10%": 0.92,
          "90%": 1.34,
          "25%": 1.0,
          "75%": 1.21
        },
        "42133": {
          "name": "York",
          "median": 1.11,
          "10%": 0.94,
          "90%": 1.36,
          "25%": 1.02,
          "75%": 1.24
        },
        "51199": {
          "name": "York",
          "median": 1.08,
          "10%": 0.91,
          "90%": 1.31,
          "25%": 0.98,
          "75%": 1.18
        },
        "max": 1.2,
        "min": 1
      },
      "100": {
        "51001": {
          "name": "Accomack",
          "median": 1.12,
          "10%": 0.95,
          "90%": 1.39,
          "25%": 1.05,
          "75%": 1.25
        },
        "42001": {
          "name": "Adams",
          "median": 1.08,
          "10%": 0.84,
          "90%": 1.41,
          "25%": 0.97,
          "75%": 1.22
        },
        "51003": {
          "name": "Albemarle",
          "median": 1.15,
          "10%": 0.9,
          "90%": 1.45,
          "25%": 1.02,
          "75%": 1.26
        },
        "51510": {
          "name": "Alexandria",
          "median": 1.15,
          "10%": 0.85,
          "90%": 1.47,
          "25%": 0.94,
          "75%": 1.32
        },
        "24001": {
          "name": "Allegany",
          "median": 1.13,
          "10%": 0.94,
          "90%": 1.47,
          "25%": 1.04,
          "75%": 1.26
        },
        "36003": {
          "name": "Allegany",
          "median": 1.07,
          "10%": 0.86,
          "90%": 1.33,
          "25%": 0.96,
          "75%": 1.2
        },
        "51005": {
          "name": "Alleghany",
          "median": 1.14,
          "10%": 0.91,
          "90%": 1.52,
          "25%": 1.04,
          "75%": 1.29
        },
        "42003": {
          "name": "Allegheny",
          "median": 1.06,
          "10%": 0.92,
          "90%": 1.33,
          "25%": 0.98,
          "75%": 1.21
        },
        "51007": {
          "name": "Amelia",
          "median": 1.11,
          "10%": 0.86,
          "90%": 1.56,
          "25%": 0.97,
          "75%": 1.31
        },
        "51009": {
          "name": "Amherst",
          "median": 1.15,
          "10%": 0.92,
          "90%": 1.41,
          "25%": 1.06,
          "75%": 1.28
        },
        "24003": {
          "name": "Anne Arundel",
          "median": 1.11,
          "10%": 0.86,
          "90%": 1.43,
          "25%": 0.95,
          "75%": 1.2425
        },
        "51011": {
          "name": "Appomattox",
          "median": 1.13,
          "10%": 0.9,
          "90%": 1.46,
          "25%": 1.02,
          "75%": 1.29
        },
        "51013": {
          "name": "Arlington",
          "median": 1.13,
          "10%": 0.87,
          "90%": 1.43,
          "25%": 0.95,
          "75%": 1.29
        },
        "42005": {
          "name": "Armstrong",
          "median": 1.14,
          "10%": 0.92,
          "90%": 1.47,
          "25%": 1.02,
          "75%": 1.25
        },
        "34001": {
          "name": "Atlantic",
          "median": 1.11,
          "10%": 0.93,
          "90%": 1.39,
          "25%": 1.04,
          "75%": 1.22
        },
        "51015": {
          "name": "Augusta",
          "median": 1.15,
          "10%": 0.88,
          "90%": 1.32,
          "25%": 1.01,
          "75%": 1.23
        },
        "24005": {
          "name": "Baltimore",
          "median": 1.11,
          "10%": 0.89,
          "90%": 1.43,
          "25%": 0.98,
          "75%": 1.24
        },
        "24510": {
          "name": "Baltimore",
          "median": 1.13,
          "10%": 0.83,
          "90%": 1.49,
          "25%": 0.93,
          "75%": 1.3
        },
        "54001": {
          "name": "Barbour",
          "median": 1.05,
          "10%": 0.93,
          "90%": 1.3,
          "25%": 0.99,
          "75%": 1.22
        },
        "51017": {
          "name": "Bath",
          "median": 1.15,
          "10%": 0.94,
          "90%": 1.51,
          "25%": 1.02,
          "75%": 1.31
        },
        "42007": {
          "name": "Beaver",
          "median": 1.06,
          "10%": 0.859,
          "90%": 1.41,
          "25%": 0.94,
          "75%": 1.25
        },
        "42009": {
          "name": "Bedford",
          "median": 1.17,
          "10%": 0.98,
          "90%": 1.401,
          "25%": 1.09,
          "75%": 1.2525
        },
        "51019": {
          "name": "Bedford",
          "median": 1.16,
          "10%": 1.01,
          "90%": 1.44,
          "25%": 1.08,
          "75%": 1.32
        },
        "54003": {
          "name": "Berkeley",
          "median": 1.08,
          "10%": 0.93,
          "90%": 1.37,
          "25%": 1.0,
          "75%": 1.25
        },
        "42011": {
          "name": "Berks",
          "median": 1.16,
          "10%": 0.9,
          "90%": 1.49,
          "25%": 0.98,
          "75%": 1.3
        },
        "42013": {
          "name": "Blair",
          "median": 1.15,
          "10%": 0.94,
          "90%": 1.43,
          "25%": 1.04,
          "75%": 1.24
        },
        "51021": {
          "name": "Bland",
          "median": 1.14,
          "10%": 0.9,
          "90%": 1.31,
          "25%": 1.01,
          "75%": 1.23
        },
        "54005": {
          "name": "Boone",
          "median": 1.12,
          "10%": 0.93,
          "90%": 1.28,
          "25%": 1.03,
          "75%": 1.2
        },
        "51023": {
          "name": "Botetourt",
          "median": 1.15,
          "10%": 0.96,
          "90%": 1.52,
          "25%": 1.05,
          "75%": 1.3
        },
        "42015": {
          "name": "Bradford",
          "median": 1.17,
          "10%": 0.87,
          "90%": 1.46,
          "25%": 0.99,
          "75%": 1.3
        },
        "54007": {
          "name": "Braxton",
          "median": 1.04,
          "10%": 0.91,
          "90%": 1.28,
          "25%": 0.98,
          "75%": 1.13
        },
        "51520": {
          "name": "Bristol",
          "median": 1.13,
          "10%": 0.92,
          "90%": 1.3,
          "25%": 1.0,
          "75%": 1.21
        },
        "36005": {
          "name": "Bronx",
          "median": 1.05,
          "10%": 0.86,
          "90%": 1.33,
          "25%": 0.97,
          "75%": 1.17
        },
        "54009": {
          "name": "Brooke",
          "median": 1.12,
          "10%": 0.86,
          "90%": 1.38,
          "25%": 0.96,
          "75%": 1.22
        },
        "36007": {
          "name": "Broome",
          "median": 1.11,
          "10%": 0.98,
          "90%": 1.35,
          "25%": 1.03,
          "75%": 1.24
        },
        "51025": {
          "name": "Brunswick",
          "median": 1.09,
          "10%": 0.89,
          "90%": 1.4,
          "25%": 0.96,
          "75%": 1.23
        },
        "51027": {
          "name": "Buchanan",
          "median": 1.08,
          "10%": 0.93,
          "90%": 1.3,
          "25%": 0.99,
          "75%": 1.21
        },
        "51029": {
          "name": "Buckingham",
          "median": 1.11,
          "10%": 0.9,
          "90%": 1.45,
          "25%": 1.03,
          "75%": 1.25
        },
        "42017": {
          "name": "Bucks",
          "median": 1.11,
          "10%": 0.93,
          "90%": 1.37,
          "25%": 1.01,
          "75%": 1.23
        },
        "51530": {
          "name": "Buena Vista",
          "median": 1.12,
          "10%": 0.88,
          "90%": 1.34,
          "25%": 1.0,
          "75%": 1.22
        },
        "34005": {
          "name": "Burlington",
          "median": 1.07,
          "10%": 0.93,
          "90%": 1.28,
          "25%": 1.0,
          "75%": 1.19
        },
        "42019": {
          "name": "Butler",
          "median": 1.11,
          "10%": 0.92,
          "90%": 1.32,
          "25%": 1.0,
          "75%": 1.23
        },
        "54011": {
          "name": "Cabell",
          "median": 1.13,
          "10%": 0.91,
          "90%": 1.38,
          "25%": 1.03,
          "75%": 1.24
        },
        "54013": {
          "name": "Calhoun",
          "median": 1.09,
          "10%": 0.86,
          "90%": 1.41,
          "25%": 1.0,
          "75%": 1.22
        },
        "24009": {
          "name": "Calvert",
          "median": 1.11,
          "10%": 0.9,
          "90%": 1.39,
          "25%": 0.99,
          "75%": 1.24
        },
        "42021": {
          "name": "Cambria",
          "median": 1.15,
          "10%": 0.94,
          "90%": 1.32,
          "25%": 1.04,
          "75%": 1.24
        },
        "34007": {
          "name": "Camden",
          "median": 1.09,
          "10%": 0.94,
          "90%": 1.32,
          "25%": 1.02,
          "75%": 1.2
        },
        "42023": {
          "name": "Cameron",
          "median": 1.12,
          "10%": 0.89,
          "90%": 1.3,
          "25%": 1.03,
          "75%": 1.22
        },
        "51031": {
          "name": "Campbell",
          "median": 1.13,
          "10%": 0.97,
          "90%": 1.36,
          "25%": 1.05,
          "75%": 1.26
        },
        "34009": {
          "name": "Cape May",
          "median": 1.13,
          "10%": 0.95,
          "90%": 1.36,
          "25%": 1.04,
          "75%": 1.24
        },
        "42025": {
          "name": "Carbon",
          "median": 1.16,
          "10%": 0.95,
          "90%": 1.46,
          "25%": 1.0475,
          "75%": 1.3
        },
        "24011": {
          "name": "Caroline",
          "median": 1.1,
          "10%": 0.88,
          "90%": 1.46,
          "25%": 0.97,
          "75%": 1.24
        },
        "51033": {
          "name": "Caroline",
          "median": 1.11,
          "10%": 0.9,
          "90%": 1.46,
          "25%": 0.99,
          "75%": 1.24
        },
        "24013": {
          "name": "Carroll",
          "median": 1.1,
          "10%": 0.91,
          "90%": 1.38,
          "25%": 0.97,
          "75%": 1.24
        },
        "51035": {
          "name": "Carroll",
          "median": 1.11,
          "10%": 0.98,
          "90%": 1.32,
          "25%": 1.04,
          "75%": 1.2
        },
        "24015": {
          "name": "Cecil",
          "median": 1.1,
          "10%": 0.88,
          "90%": 1.36,
          "25%": 0.99,
          "75%": 1.21
        },
        "42027": {
          "name": "Centre",
          "median": 1.11,
          "10%": 0.93,
          "90%": 1.36,
          "25%": 1.02,
          "75%": 1.25
        },
        "24017": {
          "name": "Charles",
          "median": 1.15,
          "10%": 0.85,
          "90%": 1.44,
          "25%": 0.96,
          "75%": 1.31
        },
        "51036": {
          "name": "Charles City",
          "median": 1.05,
          "10%": 0.94,
          "90%": 1.31,
          "25%": 0.98,
          "75%": 1.22
        },
        "51037": {
          "name": "Charlotte",
          "median": 1.13,
          "10%": 0.95,
          "90%": 1.37,
          "25%": 1.04,
          "75%": 1.23
        },
        "51540": {
          "name": "Charlottesville",
          "median": 1.14,
          "10%": 0.869,
          "90%": 1.551,
          "25%": 1.0,
          "75%": 1.29
        },
        "36015": {
          "name": "Chemung",
          "median": 1.14,
          "10%": 0.9,
          "90%": 1.36,
          "25%": 1.04,
          "75%": 1.2
        },
        "36017": {
          "name": "Chenango",
          "median": 1.1,
          "10%": 0.91,
          "90%": 1.36,
          "25%": 0.98,
          "75%": 1.23
        },
        "51550": {
          "name": "Chesapeake",
          "median": 1.13,
          "10%": 0.87,
          "90%": 1.39,
          "25%": 1.02,
          "75%": 1.28
        },
        "42029": {
          "name": "Chester",
          "median": 1.1,
          "10%": 0.89,
          "90%": 1.48,
          "25%": 0.99,
          "75%": 1.32
        },
        "51041": {
          "name": "Chesterfield",
          "median": 1.13,
          "10%": 0.9,
          "90%": 1.41,
          "25%": 0.99,
          "75%": 1.28
        },
        "42031": {
          "name": "Clarion",
          "median": 1.13,
          "10%": 0.97,
          "90%": 1.35,
          "25%": 1.04,
          "75%": 1.25
        },
        "51043": {
          "name": "Clarke",
          "median": 1.05,
          "10%": 0.87,
          "90%": 1.3,
          "25%": 0.96,
          "75%": 1.18
        },
        "54015": {
          "name": "Clay",
          "median": 1.07,
          "10%": 0.9,
          "90%": 1.32,
          "25%": 0.97,
          "75%": 1.19
        },
        "42033": {
          "name": "Clearfield",
          "median": 1.1,
          "10%": 0.97,
          "90%": 1.32,
          "25%": 1.03,
          "75%": 1.21
        },
        "42035": {
          "name": "Clinton",
          "median": 1.11,
          "10%": 0.89,
          "90%": 1.34,
          "25%": 0.99,
          "75%": 1.22
        },
        "51570": {
          "name": "Colonial Heights",
          "median": 1.13,
          "10%": 0.93,
          "90%": 1.45,
          "25%": 1.0,
          "75%": 1.27
        },
        "42037": {
          "name": "Columbia",
          "median": 1.17,
          "10%": 0.95,
          "90%": 1.45,
          "25%": 1.06,
          "75%": 1.32
        },
        "36023": {
          "name": "Cortland",
          "median": 1.11,
          "10%": 0.91,
          "90%": 1.39,
          "25%": 1.02,
          "75%": 1.23
        },
        "51580": {
          "name": "Covington",
          "median": 1.16,
          "10%": 0.9,
          "90%": 1.55,
          "25%": 0.98,
          "75%": 1.34
        },
        "51045": {
          "name": "Craig",
          "median": 1.14,
          "10%": 0.98,
          "90%": 1.4,
          "25%": 1.05,
          "75%": 1.3
        },
        "42039": {
          "name": "Crawford",
          "median": 1.12,
          "10%": 0.98,
          "90%": 1.35,
          "25%": 1.02,
          "75%": 1.26
        },
        "51047": {
          "name": "Culpeper",
          "median": 1.11,
          "10%": 0.96,
          "90%": 1.33,
          "25%": 1.02,
          "75%": 1.21
        },
        "34011": {
          "name": "Cumberland",
          "median": 1.13,
          "10%": 0.91,
          "90%": 1.45,
          "25%": 0.99,
          "75%": 1.24
        },
        "42041": {
          "name": "Cumberland",
          "median": 1.12,
          "10%": 0.95,
          "90%": 1.45,
          "25%": 1.01,
          "75%": 1.21
        },
        "51049": {
          "name": "Cumberland",
          "median": 1.1,
          "10%": 0.87,
          "90%": 1.39,
          "25%": 1.02,
          "75%": 1.26
        },
        "51590": {
          "name": "Danville",
          "median": 1.17,
          "10%": 0.93,
          "90%": 1.37,
          "25%": 1.06,
          "75%": 1.26
        },
        "42043": {
          "name": "Dauphin",
          "median": 1.16,
          "10%": 0.93,
          "90%": 1.49,
          "25%": 1.04,
          "75%": 1.34
        },
        "36025": {
          "name": "Delaware",
          "median": 1.16,
          "10%": 1.0,
          "90%": 1.43,
          "25%": 1.06,
          "75%": 1.28
        },
        "42045": {
          "name": "Delaware",
          "median": 1.12,
          "10%": 0.92,
          "90%": 1.39,
          "25%": 1.02,
          "75%": 1.27
        },
        "51051": {
          "name": "Dickenson",
          "median": 1.1,
          "10%": 0.95,
          "90%": 1.3,
          "25%": 1.03,
          "75%": 1.2
        },
        "51053": {
          "name": "Dinwiddie",
          "median": 1.1,
          "10%": 0.94,
          "90%": 1.34,
          "25%": 1.0,
          "75%": 1.21
        },
        "11001": {
          "name": "District of Columbia",
          "median": 1.12,
          "10%": 0.87,
          "90%": 1.4,
          "25%": 0.97,
          "75%": 1.25
        },
        "54017": {
          "name": "Doddridge",
          "median": 1.09,
          "10%": 0.93,
          "90%": 1.28,
          "25%": 1.02,
          "75%": 1.17
        },
        "24019": {
          "name": "Dorchester",
          "median": 1.06,
          "10%": 0.88,
          "90%": 1.41,
          "25%": 0.96,
          "75%": 1.21
        },
        "42047": {
          "name": "Elk",
          "median": 1.12,
          "10%": 0.9,
          "90%": 1.29,
          "25%": 1.01,
          "75%": 1.21
        },
        "51595": {
          "name": "Emporia",
          "median": 1.11,
          "10%": 0.83,
          "90%": 1.42,
          "25%": 0.95,
          "75%": 1.25
        },
        "42049": {
          "name": "Erie",
          "median": 1.11,
          "10%": 0.96,
          "90%": 1.33,
          "25%": 1.03,
          "75%": 1.21
        },
        "51057": {
          "name": "Essex",
          "median": 1.1,
          "10%": 0.88,
          "90%": 1.33,
          "25%": 0.96,
          "75%": 1.24
        },
        "51059": {
          "name": "Fairfax",
          "median": 1.09,
          "10%": 0.94,
          "90%": 1.41,
          "25%": 1.02,
          "75%": 1.24
        },
        "51600": {
          "name": "Fairfax",
          "median": 1.08,
          "10%": 0.91,
          "90%": 1.4,
          "25%": 0.98,
          "75%": 1.23
        },
        "51610": {
          "name": "Falls Church",
          "median": 1.07,
          "10%": 0.88,
          "90%": 1.42,
          "25%": 0.97,
          "75%": 1.26
        },
        "51061": {
          "name": "Fauquier",
          "median": 1.12,
          "10%": 0.88,
          "90%": 1.4,
          "25%": 1.03,
          "75%": 1.25
        },
        "42051": {
          "name": "Fayette",
          "median": 1.08,
          "10%": 0.88,
          "90%": 1.37,
          "25%": 0.98,
          "75%": 1.18
        },
        "54019": {
          "name": "Fayette",
          "median": 1.08,
          "10%": 0.92,
          "90%": 1.25,
          "25%": 1.02,
          "75%": 1.16
        },
        "51063": {
          "name": "Floyd",
          "median": 1.12,
          "10%": 0.92,
          "90%": 1.36,
          "25%": 1.02,
          "75%": 1.25
        },
        "51065": {
          "name": "Fluvanna",
          "median": 1.15,
          "10%": 0.84,
          "90%": 1.58,
          "25%": 0.99,
          "75%": 1.32
        },
        "42053": {
          "name": "Forest",
          "median": 1.14,
          "10%": 0.92,
          "90%": 1.37,
          "25%": 1.02,
          "75%": 1.25
        },
        "42055": {
          "name": "Franklin",
          "median": 1.12,
          "10%": 0.95,
          "90%": 1.42,
          "25%": 1.02,
          "75%": 1.22
        },
        "51067": {
          "name": "Franklin",
          "median": 1.18,
          "10%": 0.99,
          "90%": 1.44,
          "25%": 1.04,
          "75%": 1.31
        },
        "51620": {
          "name": "Franklin",
          "median": 1.13,
          "10%": 0.86,
          "90%": 1.4,
          "25%": 0.96,
          "75%": 1.29
        },
        "24021": {
          "name": "Frederick",
          "median": 1.08,
          "10%": 0.89,
          "90%": 1.39,
          "25%": 0.99,
          "75%": 1.21
        },
        "51069": {
          "name": "Frederick",
          "median": 1.1,
          "10%": 0.9,
          "90%": 1.46,
          "25%": 1.0,
          "75%": 1.21
        },
        "51630": {
          "name": "Fredericksburg",
          "median": 1.12,
          "10%": 0.87,
          "90%": 1.48,
          "25%": 0.9875,
          "75%": 1.27
        },
        "42057": {
          "name": "Fulton",
          "median": 1.16,
          "10%": 0.95,
          "90%": 1.44,
          "25%": 1.04,
          "75%": 1.28
        },
        "51640": {
          "name": "Galax",
          "median": 1.1,
          "10%": 0.86,
          "90%": 1.331,
          "25%": 0.99,
          "75%": 1.21
        },
        "24023": {
          "name": "Garrett",
          "median": 1.07,
          "10%": 0.91,
          "90%": 1.31,
          "25%": 0.99,
          "75%": 1.17
        },
        "51071": {
          "name": "Giles",
          "median": 1.14,
          "10%": 0.97,
          "90%": 1.33,
          "25%": 1.05,
          "75%": 1.23
        },
        "54021": {
          "name": "Gilmer",
          "median": 1.07,
          "10%": 0.87,
          "90%": 1.31,
          "25%": 0.96,
          "75%": 1.15
        },
        "34015": {
          "name": "Gloucester",
          "median": 1.12,
          "10%": 0.91,
          "90%": 1.3,
          "25%": 1.04,
          "75%": 1.21
        },
        "51073": {
          "name": "Gloucester",
          "median": 1.08,
          "10%": 0.92,
          "90%": 1.33,
          "25%": 0.97,
          "75%": 1.2
        },
        "51075": {
          "name": "Goochland",
          "median": 1.15,
          "10%": 0.81,
          "90%": 1.53,
          "25%": 0.95,
          "75%": 1.32
        },
        "54023": {
          "name": "Grant",
          "median": 1.09,
          "10%": 0.96,
          "90%": 1.37,
          "25%": 1.01,
          "75%": 1.2
        },
        "51077": {
          "name": "Grayson",
          "median": 1.1,
          "10%": 0.96,
          "90%": 1.28,
          "25%": 1.02,
          "75%": 1.19
        },
        "54025": {
          "name": "Greenbrier",
          "median": 1.14,
          "10%": 0.94,
          "90%": 1.33,
          "25%": 1.06,
          "75%": 1.23
        },
        "36039": {
          "name": "Greene",
          "median": 1.2,
          "10%": 0.94,
          "90%": 1.42,
          "25%": 1.08,
          "75%": 1.3
        },
        "42059": {
          "name": "Greene",
          "median": 1.09,
          "10%": 0.93,
          "90%": 1.311,
          "25%": 1.01,
          "75%": 1.22
        },
        "51079": {
          "name": "Greene",
          "median": 1.14,
          "10%": 0.91,
          "90%": 1.44,
          "25%": 0.99,
          "75%": 1.27
        },
        "51081": {
          "name": "Greensville",
          "median": 1.11,
          "10%": 0.89,
          "90%": 1.38,
          "25%": 0.95,
          "75%": 1.24
        },
        "51083": {
          "name": "Halifax",
          "median": 1.18,
          "10%": 0.96,
          "90%": 1.42,
          "25%": 1.06,
          "75%": 1.3
        },
        "54027": {
          "name": "Hampshire",
          "median": 1.15,
          "10%": 1.01,
          "90%": 1.47,
          "25%": 1.06,
          "75%": 1.29
        },
        "51650": {
          "name": "Hampton",
          "median": 1.12,
          "10%": 0.91,
          "90%": 1.38,
          "25%": 1.01,
          "75%": 1.26
        },
        "54029": {
          "name": "Hancock",
          "median": 1.07,
          "10%": 0.87,
          "90%": 1.29,
          "25%": 0.96,
          "75%": 1.19
        },
        "51085": {
          "name": "Hanover",
          "median": 1.1,
          "10%": 0.91,
          "90%": 1.371,
          "25%": 0.97,
          "75%": 1.22
        },
        "54031": {
          "name": "Hardy",
          "median": 1.13,
          "10%": 0.96,
          "90%": 1.4,
          "25%": 1.05,
          "75%": 1.24
        },
        "24025": {
          "name": "Harford",
          "median": 1.09,
          "10%": 0.86,
          "90%": 1.49,
          "25%": 1.0,
          "75%": 1.2
        },
        "54033": {
          "name": "Harrison",
          "median": 1.06,
          "10%": 0.9,
          "90%": 1.28,
          "25%": 0.99,
          "75%": 1.17
        },
        "51660": {
          "name": "Harrisonburg",
          "median": 1.08,
          "10%": 0.87,
          "90%": 1.48,
          "25%": 0.98,
          "75%": 1.22
        },
        "51087": {
          "name": "Henrico",
          "median": 1.14,
          "10%": 0.93,
          "90%": 1.38,
          "25%": 1.01,
          "75%": 1.25
        },
        "51089": {
          "name": "Henry",
          "median": 1.2,
          "10%": 0.97,
          "90%": 1.54,
          "25%": 1.08,
          "75%": 1.38
        },
        "36043": {
          "name": "Herkimer",
          "median": 1.05,
          "10%": 0.92,
          "90%": 1.26,
          "25%": 0.98,
          "75%": 1.17
        },
        "51091": {
          "name": "Highland",
          "median": 1.12,
          "10%": 0.92,
          "90%": 1.4,
          "25%": 1.01,
          "75%": 1.24
        },
        "51670": {
          "name": "Hopewell",
          "median": 1.07,
          "10%": 0.93,
          "90%": 1.38,
          "25%": 0.98,
          "75%": 1.23
        },
        "24027": {
          "name": "Howard",
          "median": 1.14,
          "10%": 0.89,
          "90%": 1.42,
          "25%": 0.97,
          "75%": 1.29
        },
        "34019": {
          "name": "Hunterdon",
          "median": 1.13,
          "10%": 0.93,
          "90%": 1.45,
          "25%": 1.01,
          "75%": 1.34
        },
        "42061": {
          "name": "Huntingdon",
          "median": 1.18,
          "10%": 0.93,
          "90%": 1.42,
          "25%": 1.04,
          "75%": 1.27
        },
        "42063": {
          "name": "Indiana",
          "median": 1.14,
          "10%": 0.95,
          "90%": 1.39,
          "25%": 1.02,
          "75%": 1.27
        },
        "51093": {
          "name": "Isle of Wight",
          "median": 1.14,
          "10%": 0.87,
          "90%": 1.38,
          "25%": 1.0,
          "75%": 1.27
        },
        "54035": {
          "name": "Jackson",
          "median": 1.15,
          "10%": 0.96,
          "90%": 1.35,
          "25%": 1.06,
          "75%": 1.26
        },
        "51095": {
          "name": "James City",
          "median": 1.05,
          "10%": 0.86,
          "90%": 1.36,
          "25%": 0.93,
          "75%": 1.19
        },
        "42065": {
          "name": "Jefferson",
          "median": 1.14,
          "10%": 0.93,
          "90%": 1.36,
          "25%": 1.03,
          "75%": 1.26
        },
        "54037": {
          "name": "Jefferson",
          "median": 1.05,
          "10%": 0.91,
          "90%": 1.25,
          "25%": 0.97,
          "75%": 1.17
        },
        "42067": {
          "name": "Juniata",
          "median": 1.14,
          "10%": 0.94,
          "90%": 1.4,
          "25%": 1.02,
          "75%": 1.24
        },
        "54039": {
          "name": "Kanawha",
          "median": 1.06,
          "10%": 0.92,
          "90%": 1.21,
          "25%": 0.99,
          "75%": 1.15
        },
        "10001": {
          "name": "Kent",
          "median": 1.09,
          "10%": 0.89,
          "90%": 1.32,
          "25%": 0.97,
          "75%": 1.21
        },
        "24029": {
          "name": "Kent",
          "median": 1.06,
          "10%": 0.88,
          "90%": 1.34,
          "25%": 0.96,
          "75%": 1.2
        },
        "51099": {
          "name": "King George",
          "median": 1.12,
          "10%": 0.89,
          "90%": 1.5,
          "25%": 0.96,
          "75%": 1.28
        },
        "51101": {
          "name": "King William",
          "median": 1.09,
          "10%": 0.94,
          "90%": 1.36,
          "25%": 0.99,
          "75%": 1.25
        },
        "51097": {
          "name": "King and Queen",
          "median": 1.09,
          "10%": 0.89,
          "90%": 1.31,
          "25%": 0.95,
          "75%": 1.21
        },
        "42069": {
          "name": "Lackawanna",
          "median": 1.18,
          "10%": 0.94,
          "90%": 1.42,
          "25%": 1.07,
          "75%": 1.3
        },
        "42071": {
          "name": "Lancaster",
          "median": 1.13,
          "10%": 0.9,
          "90%": 1.49,
          "25%": 1.01,
          "75%": 1.32
        },
        "51103": {
          "name": "Lancaster",
          "median": 1.08,
          "10%": 0.9,
          "90%": 1.3,
          "25%": 0.99,
          "75%": 1.17
        },
        "42073": {
          "name": "Lawrence",
          "median": 1.12,
          "10%": 0.88,
          "90%": 1.44,
          "25%": 0.98,
          "75%": 1.28
        },
        "42075": {
          "name": "Lebanon",
          "median": 1.13,
          "10%": 0.88,
          "90%": 1.49,
          "25%": 1.03,
          "75%": 1.34
        },
        "51105": {
          "name": "Lee",
          "median": 1.19,
          "10%": 0.98,
          "90%": 1.39,
          "25%": 1.08,
          "75%": 1.27
        },
        "42077": {
          "name": "Lehigh",
          "median": 1.14,
          "10%": 0.93,
          "90%": 1.44,
          "25%": 1.01,
          "75%": 1.3
        },
        "54041": {
          "name": "Lewis",
          "median": 1.1,
          "10%": 0.93,
          "90%": 1.25,
          "25%": 1.0,
          "75%": 1.18
        },
        "51678": {
          "name": "Lexington",
          "median": 1.1,
          "10%": 0.879,
          "90%": 1.4,
          "25%": 0.98,
          "75%": 1.23
        },
        "54043": {
          "name": "Lincoln",
          "median": 1.12,
          "10%": 0.93,
          "90%": 1.37,
          "25%": 1.02,
          "75%": 1.23
        },
        "36051": {
          "name": "Livingston",
          "median": 1.11,
          "10%": 0.87,
          "90%": 1.371,
          "25%": 1.02,
          "75%": 1.2
        },
        "54045": {
          "name": "Logan",
          "median": 1.12,
          "10%": 0.96,
          "90%": 1.34,
          "25%": 1.04,
          "75%": 1.22
        },
        "51107": {
          "name": "Loudoun",
          "median": 1.09,
          "10%": 0.92,
          "90%": 1.36,
          "25%": 0.99,
          "75%": 1.22
        },
        "51109": {
          "name": "Louisa",
          "median": 1.13,
          "10%": 0.88,
          "90%": 1.51,
          "25%": 0.98,
          "75%": 1.29
        },
        "51111": {
          "name": "Lunenburg",
          "median": 1.12,
          "10%": 0.88,
          "90%": 1.4,
          "25%": 0.97,
          "75%": 1.3
        },
        "42079": {
          "name": "Luzerne",
          "median": 1.19,
          "10%": 0.93,
          "90%": 1.37,
          "25%": 1.07,
          "75%": 1.26
        },
        "42081": {
          "name": "Lycoming",
          "median": 1.13,
          "10%": 0.95,
          "90%": 1.38,
          "25%": 1.03,
          "75%": 1.24
        },
        "51680": {
          "name": "Lynchburg",
          "median": 1.17,
          "10%": 0.99,
          "90%": 1.41,
          "25%": 1.06,
          "75%": 1.28
        },
        "36053": {
          "name": "Madison",
          "median": 1.08,
          "10%": 0.89,
          "90%": 1.35,
          "25%": 0.97,
          "75%": 1.21
        },
        "51113": {
          "name": "Madison",
          "median": 1.11,
          "10%": 0.91,
          "90%": 1.46,
          "25%": 1.0,
          "75%": 1.27
        },
        "51683": {
          "name": "Manassas",
          "median": 1.11,
          "10%": 0.96,
          "90%": 1.32,
          "25%": 1.02,
          "75%": 1.21
        },
        "51685": {
          "name": "Manassas Park",
          "median": 1.11,
          "10%": 0.92,
          "90%": 1.31,
          "25%": 1.03,
          "75%": 1.2
        },
        "54049": {
          "name": "Marion",
          "median": 1.05,
          "10%": 0.9,
          "90%": 1.24,
          "25%": 0.99,
          "75%": 1.16
        },
        "54051": {
          "name": "Marshall",
          "median": 1.12,
          "10%": 0.88,
          "90%": 1.36,
          "25%": 0.98,
          "75%": 1.23
        },
        "51690": {
          "name": "Martinsville",
          "median": 1.21,
          "10%": 0.92,
          "90%": 1.56,
          "25%": 1.0675,
          "75%": 1.43
        },
        "54053": {
          "name": "Mason",
          "median": 1.16,
          "10%": 0.95,
          "90%": 1.38,
          "25%": 1.06,
          "75%": 1.26
        },
        "51115": {
          "name": "Mathews",
          "median": 1.13,
          "10%": 0.94,
          "90%": 1.32,
          "25%": 1.01,
          "75%": 1.24
        },
        "54047": {
          "name": "McDowell",
          "median": 1.09,
          "10%": 0.96,
          "90%": 1.34,
          "25%": 1.03,
          "75%": 1.17
        },
        "42083": {
          "name": "McKean",
          "median": 1.12,
          "10%": 0.92,
          "90%": 1.32,
          "25%": 1.01,
          "75%": 1.2
        },
        "51117": {
          "name": "Mecklenburg",
          "median": 1.11,
          "10%": 0.92,
          "90%": 1.29,
          "25%": 1.03,
          "75%": 1.22
        },
        "34021": {
          "name": "Mercer",
          "median": 1.05,
          "10%": 0.87,
          "90%": 1.46,
          "25%": 0.94,
          "75%": 1.23
        },
        "42085": {
          "name": "Mercer",
          "median": 1.14,
          "10%": 0.96,
          "90%": 1.37,
          "25%": 1.02,
          "75%": 1.23
        },
        "54055": {
          "name": "Mercer",
          "median": 1.13,
          "10%": 0.98,
          "90%": 1.31,
          "25%": 1.06,
          "75%": 1.23
        },
        "51119": {
          "name": "Middlesex",
          "median": 1.06,
          "10%": 0.91,
          "90%": 1.3,
          "25%": 0.98,
          "75%": 1.16
        },
        "42087": {
          "name": "Mifflin",
          "median": 1.13,
          "10%": 0.9,
          "90%": 1.44,
          "25%": 0.99,
          "75%": 1.28
        },
        "54057": {
          "name": "Mineral",
          "median": 1.14,
          "10%": 0.99,
          "90%": 1.42,
          "25%": 1.05,
          "75%": 1.26
        },
        "54059": {
          "name": "Mingo",
          "median": 1.14,
          "10%": 0.98,
          "90%": 1.35,
          "25%": 1.04,
          "75%": 1.26
        },
        "34025": {
          "name": "Monmouth",
          "median": 1.08,
          "10%": 0.88,
          "90%": 1.36,
          "25%": 0.94,
          "75%": 1.22
        },
        "54061": {
          "name": "Monongalia",
          "median": 1.1,
          "10%": 0.9,
          "90%": 1.29,
          "25%": 0.99,
          "75%": 1.19
        },
        "42089": {
          "name": "Monroe",
          "median": 1.16,
          "10%": 0.91,
          "90%": 1.46,
          "25%": 1.04,
          "75%": 1.29
        },
        "54063": {
          "name": "Monroe",
          "median": 1.13,
          "10%": 0.97,
          "90%": 1.31,
          "25%": 1.03,
          "75%": 1.23
        },
        "24031": {
          "name": "Montgomery",
          "median": 1.11,
          "10%": 0.94,
          "90%": 1.35,
          "25%": 1.02,
          "75%": 1.22
        },
        "36057": {
          "name": "Montgomery",
          "median": 1.13,
          "10%": 0.9,
          "90%": 1.41,
          "25%": 1.01,
          "75%": 1.29
        },
        "42091": {
          "name": "Montgomery",
          "median": 1.09,
          "10%": 0.96,
          "90%": 1.4,
          "25%": 1.03,
          "75%": 1.23
        },
        "51121": {
          "name": "Montgomery",
          "median": 1.15,
          "10%": 0.95,
          "90%": 1.38,
          "25%": 1.04,
          "75%": 1.24
        },
        "42093": {
          "name": "Montour",
          "median": 1.18,
          "10%": 0.94,
          "90%": 1.441,
          "25%": 1.04,
          "75%": 1.33
        },
        "54065": {
          "name": "Morgan",
          "median": 1.13,
          "10%": 0.91,
          "90%": 1.52,
          "25%": 1.01,
          "75%": 1.26
        },
        "34027": {
          "name": "Morris",
          "median": 1.16,
          "10%": 0.91,
          "90%": 1.49,
          "25%": 1.0,
          "75%": 1.38
        },
        "36059": {
          "name": "Nassau",
          "median": 1.13,
          "10%": 0.88,
          "90%": 1.35,
          "25%": 1.01,
          "75%": 1.24
        },
        "51125": {
          "name": "Nelson",
          "median": 1.16,
          "10%": 0.84,
          "90%": 1.47,
          "25%": 1.04,
          "75%": 1.32
        },
        "10003": {
          "name": "New Castle",
          "median": 1.13,
          "10%": 0.91,
          "90%": 1.351,
          "25%": 1.01,
          "75%": 1.22
        },
        "51127": {
          "name": "New Kent",
          "median": 1.08,
          "10%": 0.95,
          "90%": 1.31,
          "25%": 0.99,
          "75%": 1.24
        },
        "36061": {
          "name": "New York",
          "median": 1.03,
          "10%": 0.84,
          "90%": 1.38,
          "25%": 0.94,
          "75%": 1.2
        },
        "51700": {
          "name": "Newport News",
          "median": 1.11,
          "10%": 0.89,
          "90%": 1.33,
          "25%": 0.99,
          "75%": 1.22
        },
        "54067": {
          "name": "Nicholas",
          "median": 1.06,
          "10%": 0.91,
          "90%": 1.28,
          "25%": 0.97,
          "75%": 1.16
        },
        "51710": {
          "name": "Norfolk",
          "median": 1.12,
          "10%": 0.85,
          "90%": 1.48,
          "25%": 0.99,
          "75%": 1.33
        },
        "42095": {
          "name": "Northampton",
          "median": 1.11,
          "10%": 0.91,
          "90%": 1.47,
          "25%": 1.0,
          "75%": 1.31
        },
        "51131": {
          "name": "Northampton",
          "median": 1.13,
          "10%": 0.93,
          "90%": 1.31,
          "25%": 1.01,
          "75%": 1.23
        },
        "42097": {
          "name": "Northumberland",
          "median": 1.17,
          "10%": 0.94,
          "90%": 1.48,
          "25%": 1.05,
          "75%": 1.34
        },
        "51133": {
          "name": "Northumberland",
          "median": 1.09,
          "10%": 0.88,
          "90%": 1.381,
          "25%": 0.98,
          "75%": 1.19
        },
        "51720": {
          "name": "Norton",
          "median": 1.17,
          "10%": 0.92,
          "90%": 1.41,
          "25%": 1.05,
          "75%": 1.27
        },
        "51135": {
          "name": "Nottoway",
          "median": 1.13,
          "10%": 0.89,
          "90%": 1.48,
          "25%": 0.97,
          "75%": 1.27
        },
        "34029": {
          "name": "Ocean",
          "median": 1.08,
          "10%": 0.94,
          "90%": 1.31,
          "25%": 1.0,
          "75%": 1.15
        },
        "54069": {
          "name": "Ohio",
          "median": 1.11,
          "10%": 0.86,
          "90%": 1.38,
          "25%": 0.99,
          "75%": 1.27
        },
        "36065": {
          "name": "Oneida",
          "median": 1.08,
          "10%": 0.91,
          "90%": 1.32,
          "25%": 1.01,
          "75%": 1.21
        },
        "36067": {
          "name": "Onondaga",
          "median": 1.1,
          "10%": 0.95,
          "90%": 1.4,
          "25%": 1.01,
          "75%": 1.24
        },
        "36069": {
          "name": "Ontario",
          "median": 1.1,
          "10%": 0.94,
          "90%": 1.4,
          "25%": 1.01,
          "75%": 1.22
        },
        "36071": {
          "name": "Orange",
          "median": 1.19,
          "10%": 0.94,
          "90%": 1.521,
          "25%": 1.07,
          "75%": 1.31
        },
        "51137": {
          "name": "Orange",
          "median": 1.15,
          "10%": 0.95,
          "90%": 1.36,
          "25%": 1.01,
          "75%": 1.23
        },
        "36077": {
          "name": "Otsego",
          "median": 1.1,
          "10%": 0.92,
          "90%": 1.36,
          "25%": 1.01,
          "75%": 1.23
        },
        "51139": {
          "name": "Page",
          "median": 1.11,
          "10%": 0.94,
          "90%": 1.5,
          "25%": 1.0,
          "75%": 1.29
        },
        "51141": {
          "name": "Patrick",
          "median": 1.14,
          "10%": 0.94,
          "90%": 1.48,
          "25%": 1.03,
          "75%": 1.34
        },
        "54071": {
          "name": "Pendleton",
          "median": 1.1,
          "10%": 0.87,
          "90%": 1.51,
          "25%": 0.99,
          "75%": 1.29
        },
        "42099": {
          "name": "Perry",
          "median": 1.11,
          "10%": 0.93,
          "90%": 1.37,
          "25%": 1.02,
          "75%": 1.26
        },
        "51730": {
          "name": "Petersburg",
          "median": 1.12,
          "10%": 0.9,
          "90%": 1.45,
          "25%": 0.98,
          "75%": 1.27
        },
        "42101": {
          "name": "Philadelphia",
          "median": 1.11,
          "10%": 0.92,
          "90%": 1.34,
          "25%": 1.04,
          "75%": 1.21
        },
        "42103": {
          "name": "Pike",
          "median": 1.16,
          "10%": 0.91,
          "90%": 1.5,
          "25%": 1.05,
          "75%": 1.3
        },
        "51143": {
          "name": "Pittsylvania",
          "median": 1.17,
          "10%": 0.97,
          "90%": 1.39,
          "25%": 1.08,
          "75%": 1.27
        },
        "54073": {
          "name": "Pleasants",
          "median": 1.06,
          "10%": 0.92,
          "90%": 1.23,
          "25%": 0.99,
          "75%": 1.14
        },
        "54075": {
          "name": "Pocahontas",
          "median": 1.13,
          "10%": 0.98,
          "90%": 1.4,
          "25%": 1.05,
          "75%": 1.23
        },
        "51735": {
          "name": "Poquoson",
          "median": 1.11,
          "10%": 0.9,
          "90%": 1.37,
          "25%": 1.0,
          "75%": 1.25
        },
        "51740": {
          "name": "Portsmouth",
          "median": 1.14,
          "10%": 0.84,
          "90%": 1.45,
          "25%": 1.0,
          "75%": 1.3
        },
        "42105": {
          "name": "Potter",
          "median": 1.11,
          "10%": 0.88,
          "90%": 1.31,
          "25%": 1.01,
          "75%": 1.2
        },
        "51145": {
          "name": "Powhatan",
          "median": 1.1,
          "10%": 0.86,
          "90%": 1.47,
          "25%": 0.97,
          "75%": 1.28
        },
        "54077": {
          "name": "Preston",
          "median": 1.09,
          "10%": 0.89,
          "90%": 1.31,
          "25%": 0.99,
          "75%": 1.21
        },
        "51147": {
          "name": "Prince Edward",
          "median": 1.09,
          "10%": 0.91,
          "90%": 1.39,
          "25%": 0.99,
          "75%": 1.22
        },
        "51149": {
          "name": "Prince George",
          "median": 1.09,
          "10%": 0.94,
          "90%": 1.37,
          "25%": 0.99,
          "75%": 1.2
        },
        "24033": {
          "name": "Prince George's",
          "median": 1.11,
          "10%": 0.899,
          "90%": 1.44,
          "25%": 1.0,
          "75%": 1.27
        },
        "51153": {
          "name": "Prince William",
          "median": 1.1,
          "10%": 1.0,
          "90%": 1.38,
          "25%": 1.05,
          "75%": 1.22
        },
        "51155": {
          "name": "Pulaski",
          "median": 1.15,
          "10%": 0.96,
          "90%": 1.31,
          "25%": 1.04,
          "75%": 1.24
        },
        "54079": {
          "name": "Putnam",
          "median": 1.14,
          "10%": 0.93,
          "90%": 1.35,
          "25%": 1.02,
          "75%": 1.24
        },
        "24035": {
          "name": "Queen Anne's",
          "median": 1.05,
          "10%": 0.89,
          "90%": 1.33,
          "25%": 0.96,
          "75%": 1.19
        },
        "51750": {
          "name": "Radford",
          "median": 1.17,
          "10%": 0.94,
          "90%": 1.35,
          "25%": 1.05,
          "75%": 1.27
        },
        "54081": {
          "name": "Raleigh",
          "median": 1.105,
          "10%": 0.95,
          "90%": 1.44,
          "25%": 1.01,
          "75%": 1.24
        },
        "54083": {
          "name": "Randolph",
          "median": 1.13,
          "10%": 0.94,
          "90%": 1.37,
          "25%": 1.02,
          "75%": 1.24
        },
        "51157": {
          "name": "Rappahannock",
          "median": 1.12,
          "10%": 0.91,
          "90%": 1.38,
          "25%": 1.0,
          "75%": 1.24
        },
        "36085": {
          "name": "Richmond",
          "median": 1.06,
          "10%": 0.81,
          "90%": 1.38,
          "25%": 0.93,
          "75%": 1.19
        },
        "51159": {
          "name": "Richmond",
          "median": 1.11,
          "10%": 0.83,
          "90%": 1.33,
          "25%": 0.98,
          "75%": 1.22
        },
        "51760": {
          "name": "Richmond",
          "median": 1.16,
          "10%": 0.92,
          "90%": 1.45,
          "25%": 1.01,
          "75%": 1.3
        },
        "54085": {
          "name": "Ritchie",
          "median": 1.11,
          "10%": 0.98,
          "90%": 1.29,
          "25%": 1.03,
          "75%": 1.19
        },
        "54087": {
          "name": "Roane",
          "median": 1.09,
          "10%": 0.93,
          "90%": 1.31,
          "25%": 1.01,
          "75%": 1.19
        },
        "51161": {
          "name": "Roanoke",
          "median": 1.17,
          "10%": 0.98,
          "90%": 1.48,
          "25%": 1.05,
          "75%": 1.33
        },
        "51770": {
          "name": "Roanoke",
          "median": 1.21,
          "10%": 0.93,
          "90%": 1.55,
          "25%": 1.05,
          "75%": 1.37
        },
        "51163": {
          "name": "Rockbridge",
          "median": 1.14,
          "10%": 0.93,
          "90%": 1.4,
          "25%": 1.01,
          "75%": 1.24
        },
        "51165": {
          "name": "Rockingham",
          "median": 1.08,
          "10%": 0.949,
          "90%": 1.48,
          "25%": 1.0,
          "75%": 1.2
        },
        "51167": {
          "name": "Russell",
          "median": 1.13,
          "10%": 0.94,
          "90%": 1.28,
          "25%": 1.04,
          "75%": 1.22
        },
        "34033": {
          "name": "Salem",
          "median": 1.13,
          "10%": 0.95,
          "90%": 1.32,
          "25%": 1.03,
          "75%": 1.21
        },
        "51775": {
          "name": "Salem",
          "median": 1.19,
          "10%": 0.93,
          "90%": 1.52,
          "25%": 1.03,
          "75%": 1.33
        },
        "36095": {
          "name": "Schoharie",
          "median": 1.12,
          "10%": 0.92,
          "90%": 1.42,
          "25%": 1.02,
          "75%": 1.25
        },
        "36097": {
          "name": "Schuyler",
          "median": 1.11,
          "10%": 0.89,
          "90%": 1.34,
          "25%": 1.02,
          "75%": 1.21
        },
        "42107": {
          "name": "Schuylkill",
          "median": 1.21,
          "10%": 0.91,
          "90%": 1.42,
          "25%": 1.04,
          "75%": 1.32
        },
        "51169": {
          "name": "Scott",
          "median": 1.18,
          "10%": 0.95,
          "90%": 1.32,
          "25%": 1.06,
          "75%": 1.24
        },
        "51171": {
          "name": "Shenandoah",
          "median": 1.1,
          "10%": 0.949,
          "90%": 1.38,
          "25%": 0.99,
          "75%": 1.22
        },
        "51173": {
          "name": "Smyth",
          "median": 1.11,
          "10%": 0.98,
          "90%": 1.27,
          "25%": 1.05,
          "75%": 1.19
        },
        "42109": {
          "name": "Snyder",
          "median": 1.14,
          "10%": 0.96,
          "90%": 1.46,
          "25%": 1.06,
          "75%": 1.28
        },
        "24039": {
          "name": "Somerset",
          "median": 1.12,
          "10%": 0.92,
          "90%": 1.41,
          "25%": 1.03,
          "75%": 1.26
        },
        "42111": {
          "name": "Somerset",
          "median": 1.1,
          "10%": 0.97,
          "90%": 1.31,
          "25%": 1.02,
          "75%": 1.17
        },
        "51175": {
          "name": "Southampton",
          "median": 1.14,
          "10%": 0.89,
          "90%": 1.38,
          "25%": 0.98,
          "75%": 1.27
        },
        "51177": {
          "name": "Spotsylvania",
          "median": 1.12,
          "10%": 0.9,
          "90%": 1.36,
          "25%": 0.98,
          "75%": 1.24
        },
        "24037": {
          "name": "St. Mary's",
          "median": 1.08,
          "10%": 0.86,
          "90%": 1.35,
          "25%": 0.97,
          "75%": 1.22
        },
        "51179": {
          "name": "Stafford",
          "median": 1.14,
          "10%": 0.9,
          "90%": 1.46,
          "25%": 1.0,
          "75%": 1.21
        },
        "51790": {
          "name": "Staunton",
          "median": 1.15,
          "10%": 0.85,
          "90%": 1.42,
          "25%": 1.01,
          "75%": 1.26
        },
        "36101": {
          "name": "Steuben",
          "median": 1.08,
          "10%": 0.91,
          "90%": 1.4,
          "25%": 1.0,
          "75%": 1.19
        },
        "51800": {
          "name": "Suffolk",
          "median": 1.18,
          "10%": 0.89,
          "90%": 1.35,
          "25%": 1.02,
          "75%": 1.26
        },
        "36105": {
          "name": "Sullivan",
          "median": 1.18,
          "10%": 0.93,
          "90%": 1.44,
          "25%": 1.07,
          "75%": 1.31
        },
        "42113": {
          "name": "Sullivan",
          "median": 1.15,
          "10%": 0.88,
          "90%": 1.4,
          "25%": 1.03,
          "75%": 1.28
        },
        "54089": {
          "name": "Summers",
          "median": 1.15,
          "10%": 0.92,
          "90%": 1.38,
          "25%": 1.02,
          "75%": 1.27
        },
        "51181": {
          "name": "Surry",
          "median": 1.08,
          "10%": 0.88,
          "90%": 1.32,
          "25%": 0.96,
          "75%": 1.2
        },
        "42115": {
          "name": "Susquehanna",
          "median": 1.13,
          "10%": 0.97,
          "90%": 1.41,
          "25%": 1.03,
          "75%": 1.27
        },
        "10005": {
          "name": "Sussex",
          "median": 1.08,
          "10%": 0.94,
          "90%": 1.46,
          "25%": 1.0,
          "75%": 1.23
        },
        "34037": {
          "name": "Sussex",
          "median": 1.17,
          "10%": 0.91,
          "90%": 1.58,
          "25%": 1.08,
          "75%": 1.33
        },
        "51183": {
          "name": "Sussex",
          "median": 1.09,
          "10%": 0.88,
          "90%": 1.37,
          "25%": 0.97,
          "75%": 1.22
        },
        "24041": {
          "name": "Talbot",
          "median": 1.04,
          "10%": 0.87,
          "90%": 1.44,
          "25%": 0.95,
          "75%": 1.21
        },
        "54091": {
          "name": "Taylor",
          "median": 1.1,
          "10%": 0.9,
          "90%": 1.3,
          "25%": 0.98,
          "75%": 1.2025
        },
        "51185": {
          "name": "Tazewell",
          "median": 1.12,
          "10%": 0.99,
          "90%": 1.3,
          "25%": 1.05,
          "75%": 1.22
        },
        "36107": {
          "name": "Tioga",
          "median": 1.14,
          "10%": 0.92,
          "90%": 1.48,
          "25%": 1.01,
          "75%": 1.31
        },
        "42117": {
          "name": "Tioga",
          "median": 1.1,
          "10%": 0.89,
          "90%": 1.32,
          "25%": 1.0,
          "75%": 1.22
        },
        "36109": {
          "name": "Tompkins",
          "median": 1.11,
          "10%": 0.92,
          "90%": 1.42,
          "25%": 1.03,
          "75%": 1.24
        },
        "54093": {
          "name": "Tucker",
          "median": 1.07,
          "10%": 0.93,
          "90%": 1.34,
          "25%": 0.99,
          "75%": 1.2
        },
        "54095": {
          "name": "Tyler",
          "median": 1.07,
          "10%": 0.87,
          "90%": 1.22,
          "25%": 0.98,
          "75%": 1.15
        },
        "36111": {
          "name": "Ulster",
          "median": 1.19,
          "10%": 0.98,
          "90%": 1.39,
          "25%": 1.06,
          "75%": 1.32
        },
        "42119": {
          "name": "Union",
          "median": 1.13,
          "10%": 0.98,
          "90%": 1.36,
          "25%": 1.04,
          "75%": 1.25
        },
        "54097": {
          "name": "Upshur",
          "median": 1.11,
          "10%": 0.93,
          "90%": 1.35,
          "25%": 1.02,
          "75%": 1.23
        },
        "42121": {
          "name": "Venango",
          "median": 1.15,
          "10%": 0.95,
          "90%": 1.34,
          "25%": 1.05,
          "75%": 1.24
        },
        "51810": {
          "name": "Virginia Beach",
          "median": 1.12,
          "10%": 0.89,
          "90%": 1.37,
          "25%": 1.0,
          "75%": 1.25
        },
        "34041": {
          "name": "Warren",
          "median": 1.16,
          "10%": 0.93,
          "90%": 1.49,
          "25%": 1.02,
          "75%": 1.33
        },
        "42123": {
          "name": "Warren",
          "median": 1.13,
          "10%": 0.96,
          "90%": 1.32,
          "25%": 1.05,
          "75%": 1.23
        },
        "51187": {
          "name": "Warren",
          "median": 1.1,
          "10%": 0.88,
          "90%": 1.38,
          "25%": 0.99,
          "75%": 1.22
        },
        "24043": {
          "name": "Washington",
          "median": 1.1,
          "10%": 0.94,
          "90%": 1.4,
          "25%": 1.01,
          "75%": 1.26
        },
        "42125": {
          "name": "Washington",
          "median": 1.07,
          "10%": 0.9,
          "90%": 1.32,
          "25%": 0.97,
          "75%": 1.21
        },
        "51191": {
          "name": "Washington",
          "median": 1.12,
          "10%": 0.94,
          "90%": 1.29,
          "25%": 1.01,
          "75%": 1.19
        },
        "42127": {
          "name": "Wayne",
          "median": 1.16,
          "10%": 0.91,
          "90%": 1.39,
          "25%": 1.02,
          "75%": 1.29
        },
        "54099": {
          "name": "Wayne",
          "median": 1.13,
          "10%": 0.99,
          "90%": 1.4,
          "25%": 1.05,
          "75%": 1.26
        },
        "51820": {
          "name": "Waynesboro",
          "median": 1.16,
          "10%": 0.85,
          "90%": 1.44,
          "25%": 0.97,
          "75%": 1.28
        },
        "54101": {
          "name": "Webster",
          "median": 1.07,
          "10%": 0.92,
          "90%": 1.31,
          "25%": 1.0,
          "75%": 1.17
        },
        "36119": {
          "name": "Westchester",
          "median": 1.08,
          "10%": 0.88,
          "90%": 1.39,
          "25%": 0.97,
          "75%": 1.22
        },
        "42129": {
          "name": "Westmoreland",
          "median": 1.09,
          "10%": 0.92,
          "90%": 1.31,
          "25%": 1.02,
          "75%": 1.19
        },
        "51193": {
          "name": "Westmoreland",
          "median": 1.08,
          "10%": 0.9,
          "90%": 1.38,
          "25%": 0.97,
          "75%": 1.27
        },
        "54103": {
          "name": "Wetzel",
          "median": 1.08,
          "10%": 0.91,
          "90%": 1.3,
          "25%": 0.99,
          "75%": 1.19
        },
        "24045": {
          "name": "Wicomico",
          "median": 1.11,
          "10%": 0.93,
          "90%": 1.4,
          "25%": 1.04,
          "75%": 1.21
        },
        "51830": {
          "name": "Williamsburg",
          "median": 1.04,
          "10%": 0.83,
          "90%": 1.44,
          "25%": 0.92,
          "75%": 1.21
        },
        "51840": {
          "name": "Winchester",
          "median": 1.09,
          "10%": 0.89,
          "90%": 1.48,
          "25%": 0.98,
          "75%": 1.23
        },
        "54105": {
          "name": "Wirt",
          "median": 1.14,
          "10%": 0.93,
          "90%": 1.36,
          "25%": 1.04,
          "75%": 1.24
        },
        "51195": {
          "name": "Wise",
          "median": 1.14,
          "10%": 0.96,
          "90%": 1.34,
          "25%": 1.06,
          "75%": 1.25
        },
        "54107": {
          "name": "Wood",
          "median": 1.11,
          "10%": 0.96,
          "90%": 1.35,
          "25%": 1.02,
          "75%": 1.22
        },
        "24047": {
          "name": "Worcester",
          "median": 1.1,
          "10%": 0.94,
          "90%": 1.42,
          "25%": 1.0,
          "75%": 1.32
        },
        "42131": {
          "name": "Wyoming",
          "median": 1.19,
          "10%": 0.96,
          "90%": 1.4,
          "25%": 1.07,
          "75%": 1.3
        },
        "54109": {
          "name": "Wyoming",
          "median": 1.1,
          "10%": 0.96,
          "90%": 1.3,
          "25%": 1.05,
          "75%": 1.18
        },
        "51197": {
          "name": "Wythe",
          "median": 1.12,
          "10%": 0.92,
          "90%": 1.29,
          "25%": 0.99,
          "75%": 1.2
        },
        "36123": {
          "name": "Yates",
          "median": 1.1,
          "10%": 0.91,
          "90%": 1.42,
          "25%": 0.99,
          "75%": 1.24
        },
        "42133": {
          "name": "York",
          "median": 1.11,
          "10%": 0.91,
          "90%": 1.42,
          "25%": 1.01,
          "75%": 1.27
        },
        "51199": {
          "name": "York",
          "median": 1.07,
          "10%": 0.89,
          "90%": 1.37,
          "25%": 0.96,
          "75%": 1.21
        },
        "max": 1.21,
        "min": 1
      }
    },
    "2050-2100": {
      "2": {
        "51001": {
          "name": "Accomack",
          "median": 1.17,
          "10%": 1.05,
          "90%": 1.31,
          "25%": 1.1,
          "75%": 1.24
        },
        "42001": {
          "name": "Adams",
          "median": 1.21,
          "10%": 1.09,
          "90%": 1.34,
          "25%": 1.13,
          "75%": 1.27
        },
        "51003": {
          "name": "Albemarle",
          "median": 1.19,
          "10%": 1.11,
          "90%": 1.33,
          "25%": 1.15,
          "75%": 1.28
        },
        "51510": {
          "name": "Alexandria",
          "median": 1.14,
          "10%": 1.03,
          "90%": 1.25,
          "25%": 1.09,
          "75%": 1.21
        },
        "24001": {
          "name": "Allegany",
          "median": 1.19,
          "10%": 1.11,
          "90%": 1.28,
          "25%": 1.17,
          "75%": 1.24
        },
        "36003": {
          "name": "Allegany",
          "median": 1.2,
          "10%": 1.1,
          "90%": 1.3,
          "25%": 1.13,
          "75%": 1.25
        },
        "51005": {
          "name": "Alleghany",
          "median": 1.19,
          "10%": 1.07,
          "90%": 1.31,
          "25%": 1.12,
          "75%": 1.25
        },
        "42003": {
          "name": "Allegheny",
          "median": 1.18,
          "10%": 1.05,
          "90%": 1.27,
          "25%": 1.12,
          "75%": 1.24
        },
        "51007": {
          "name": "Amelia",
          "median": 1.18,
          "10%": 1.04,
          "90%": 1.32,
          "25%": 1.1,
          "75%": 1.23
        },
        "51009": {
          "name": "Amherst",
          "median": 1.19,
          "10%": 1.09,
          "90%": 1.36,
          "25%": 1.14,
          "75%": 1.31
        },
        "24003": {
          "name": "Anne Arundel",
          "median": 1.15,
          "10%": 1.06,
          "90%": 1.26,
          "25%": 1.09,
          "75%": 1.2
        },
        "51011": {
          "name": "Appomattox",
          "median": 1.22,
          "10%": 1.08,
          "90%": 1.38,
          "25%": 1.14,
          "75%": 1.32
        },
        "51013": {
          "name": "Arlington",
          "median": 1.13,
          "10%": 1.05,
          "90%": 1.24,
          "25%": 1.1,
          "75%": 1.19
        },
        "42005": {
          "name": "Armstrong",
          "median": 1.17,
          "10%": 1.08,
          "90%": 1.27,
          "25%": 1.12,
          "75%": 1.22
        },
        "34001": {
          "name": "Atlantic",
          "median": 1.19,
          "10%": 1.1,
          "90%": 1.3,
          "25%": 1.15,
          "75%": 1.23
        },
        "51015": {
          "name": "Augusta",
          "median": 1.21,
          "10%": 1.09,
          "90%": 1.33,
          "25%": 1.15,
          "75%": 1.3
        },
        "24005": {
          "name": "Baltimore",
          "median": 1.15,
          "10%": 1.05,
          "90%": 1.26,
          "25%": 1.11,
          "75%": 1.21
        },
        "24510": {
          "name": "Baltimore",
          "median": 1.15,
          "10%": 1.04,
          "90%": 1.27,
          "25%": 1.1,
          "75%": 1.2
        },
        "54001": {
          "name": "Barbour",
          "median": 1.14,
          "10%": 1.05,
          "90%": 1.25,
          "25%": 1.1,
          "75%": 1.19
        },
        "51017": {
          "name": "Bath",
          "median": 1.2,
          "10%": 1.11,
          "90%": 1.34,
          "25%": 1.16,
          "75%": 1.28
        },
        "42007": {
          "name": "Beaver",
          "median": 1.18,
          "10%": 1.09,
          "90%": 1.27,
          "25%": 1.13,
          "75%": 1.22
        },
        "42009": {
          "name": "Bedford",
          "median": 1.2,
          "10%": 1.12,
          "90%": 1.28,
          "25%": 1.16,
          "75%": 1.24
        },
        "51019": {
          "name": "Bedford",
          "median": 1.2,
          "10%": 1.08,
          "90%": 1.31,
          "25%": 1.12,
          "75%": 1.27
        },
        "54003": {
          "name": "Berkeley",
          "median": 1.22,
          "10%": 1.11,
          "90%": 1.31,
          "25%": 1.15,
          "75%": 1.28
        },
        "42011": {
          "name": "Berks",
          "median": 1.2,
          "10%": 1.06,
          "90%": 1.29,
          "25%": 1.14,
          "75%": 1.24
        },
        "42013": {
          "name": "Blair",
          "median": 1.2,
          "10%": 1.12,
          "90%": 1.28,
          "25%": 1.16,
          "75%": 1.25
        },
        "51021": {
          "name": "Bland",
          "median": 1.16,
          "10%": 1.07,
          "90%": 1.29,
          "25%": 1.11,
          "75%": 1.2
        },
        "54005": {
          "name": "Boone",
          "median": 1.17,
          "10%": 1.09,
          "90%": 1.26,
          "25%": 1.12,
          "75%": 1.22
        },
        "51023": {
          "name": "Botetourt",
          "median": 1.2,
          "10%": 1.09,
          "90%": 1.33,
          "25%": 1.14,
          "75%": 1.28
        },
        "42015": {
          "name": "Bradford",
          "median": 1.14,
          "10%": 1.07,
          "90%": 1.23,
          "25%": 1.11,
          "75%": 1.18
        },
        "54007": {
          "name": "Braxton",
          "median": 1.16,
          "10%": 1.07,
          "90%": 1.25,
          "25%": 1.11,
          "75%": 1.2
        },
        "51520": {
          "name": "Bristol",
          "median": 1.15,
          "10%": 1.09,
          "90%": 1.29,
          "25%": 1.11,
          "75%": 1.21
        },
        "36005": {
          "name": "Bronx",
          "median": 1.21,
          "10%": 1.08,
          "90%": 1.33,
          "25%": 1.15,
          "75%": 1.27
        },
        "54009": {
          "name": "Brooke",
          "median": 1.2,
          "10%": 1.07,
          "90%": 1.31,
          "25%": 1.14,
          "75%": 1.25
        },
        "36007": {
          "name": "Broome",
          "median": 1.15,
          "10%": 1.06,
          "90%": 1.26,
          "25%": 1.12,
          "75%": 1.22
        },
        "51025": {
          "name": "Brunswick",
          "median": 1.18,
          "10%": 1.08,
          "90%": 1.28,
          "25%": 1.13,
          "75%": 1.23
        },
        "51027": {
          "name": "Buchanan",
          "median": 1.16,
          "10%": 1.08,
          "90%": 1.3,
          "25%": 1.12,
          "75%": 1.22
        },
        "51029": {
          "name": "Buckingham",
          "median": 1.19,
          "10%": 1.06,
          "90%": 1.33,
          "25%": 1.11,
          "75%": 1.23
        },
        "42017": {
          "name": "Bucks",
          "median": 1.16,
          "10%": 1.06,
          "90%": 1.26,
          "25%": 1.11,
          "75%": 1.2
        },
        "51530": {
          "name": "Buena Vista",
          "median": 1.2,
          "10%": 1.08,
          "90%": 1.43,
          "25%": 1.14,
          "75%": 1.34
        },
        "34005": {
          "name": "Burlington",
          "median": 1.16,
          "10%": 1.06,
          "90%": 1.24,
          "25%": 1.11,
          "75%": 1.2
        },
        "42019": {
          "name": "Butler",
          "median": 1.19,
          "10%": 1.08,
          "90%": 1.27,
          "25%": 1.12,
          "75%": 1.23
        },
        "54011": {
          "name": "Cabell",
          "median": 1.15,
          "10%": 1.06,
          "90%": 1.28,
          "25%": 1.11,
          "75%": 1.2325
        },
        "54013": {
          "name": "Calhoun",
          "median": 1.2,
          "10%": 1.09,
          "90%": 1.32,
          "25%": 1.16,
          "75%": 1.27
        },
        "24009": {
          "name": "Calvert",
          "median": 1.17,
          "10%": 1.05,
          "90%": 1.28,
          "25%": 1.09,
          "75%": 1.22
        },
        "42021": {
          "name": "Cambria",
          "median": 1.14,
          "10%": 1.09,
          "90%": 1.24,
          "25%": 1.12,
          "75%": 1.19
        },
        "34007": {
          "name": "Camden",
          "median": 1.17,
          "10%": 1.06,
          "90%": 1.25,
          "25%": 1.11,
          "75%": 1.2
        },
        "42023": {
          "name": "Cameron",
          "median": 1.18,
          "10%": 1.07,
          "90%": 1.29,
          "25%": 1.14,
          "75%": 1.23
        },
        "51031": {
          "name": "Campbell",
          "median": 1.22,
          "10%": 1.08,
          "90%": 1.34,
          "25%": 1.13,
          "75%": 1.27
        },
        "34009": {
          "name": "Cape May",
          "median": 1.18,
          "10%": 1.08,
          "90%": 1.31,
          "25%": 1.13,
          "75%": 1.23
        },
        "42025": {
          "name": "Carbon",
          "median": 1.18,
          "10%": 1.1,
          "90%": 1.27,
          "25%": 1.13,
          "75%": 1.23
        },
        "24011": {
          "name": "Caroline",
          "median": 1.18,
          "10%": 1.05,
          "90%": 1.32,
          "25%": 1.1,
          "75%": 1.22
        },
        "51033": {
          "name": "Caroline",
          "median": 1.18,
          "10%": 1.07,
          "90%": 1.27,
          "25%": 1.13,
          "75%": 1.24
        },
        "24013": {
          "name": "Carroll",
          "median": 1.21,
          "10%": 1.08,
          "90%": 1.34,
          "25%": 1.12,
          "75%": 1.27
        },
        "51035": {
          "name": "Carroll",
          "median": 1.18,
          "10%": 1.11,
          "90%": 1.3,
          "25%": 1.13,
          "75%": 1.25
        },
        "24015": {
          "name": "Cecil",
          "median": 1.2,
          "10%": 1.09,
          "90%": 1.31,
          "25%": 1.12,
          "75%": 1.25
        },
        "42027": {
          "name": "Centre",
          "median": 1.22,
          "10%": 1.11,
          "90%": 1.3,
          "25%": 1.16,
          "75%": 1.26
        },
        "24017": {
          "name": "Charles",
          "median": 1.16,
          "10%": 1.05,
          "90%": 1.26,
          "25%": 1.11,
          "75%": 1.23
        },
        "51036": {
          "name": "Charles City",
          "median": 1.17,
          "10%": 1.07,
          "90%": 1.27,
          "25%": 1.12,
          "75%": 1.22
        },
        "51037": {
          "name": "Charlotte",
          "median": 1.19,
          "10%": 1.07,
          "90%": 1.32,
          "25%": 1.13,
          "75%": 1.26
        },
        "51540": {
          "name": "Charlottesville",
          "median": 1.18,
          "10%": 1.09,
          "90%": 1.31,
          "25%": 1.13,
          "75%": 1.27
        },
        "36015": {
          "name": "Chemung",
          "median": 1.17,
          "10%": 1.08,
          "90%": 1.25,
          "25%": 1.12,
          "75%": 1.21
        },
        "36017": {
          "name": "Chenango",
          "median": 1.155,
          "10%": 1.08,
          "90%": 1.26,
          "25%": 1.11,
          "75%": 1.23
        },
        "51550": {
          "name": "Chesapeake",
          "median": 1.17,
          "10%": 1.05,
          "90%": 1.32,
          "25%": 1.1,
          "75%": 1.25
        },
        "42029": {
          "name": "Chester",
          "median": 1.17,
          "10%": 1.07,
          "90%": 1.28,
          "25%": 1.13,
          "75%": 1.24
        },
        "51041": {
          "name": "Chesterfield",
          "median": 1.18,
          "10%": 1.05,
          "90%": 1.31,
          "25%": 1.0975,
          "75%": 1.25
        },
        "42031": {
          "name": "Clarion",
          "median": 1.21,
          "10%": 1.07,
          "90%": 1.3,
          "25%": 1.16,
          "75%": 1.25
        },
        "51043": {
          "name": "Clarke",
          "median": 1.23,
          "10%": 1.11,
          "90%": 1.36,
          "25%": 1.17,
          "75%": 1.3
        },
        "54015": {
          "name": "Clay",
          "median": 1.13,
          "10%": 1.05,
          "90%": 1.23,
          "25%": 1.08,
          "75%": 1.17
        },
        "42033": {
          "name": "Clearfield",
          "median": 1.21,
          "10%": 1.1,
          "90%": 1.3,
          "25%": 1.16,
          "75%": 1.24
        },
        "42035": {
          "name": "Clinton",
          "median": 1.2,
          "10%": 1.11,
          "90%": 1.27,
          "25%": 1.15,
          "75%": 1.25
        },
        "51570": {
          "name": "Colonial Heights",
          "median": 1.17,
          "10%": 1.05,
          "90%": 1.281,
          "25%": 1.11,
          "75%": 1.24
        },
        "42037": {
          "name": "Columbia",
          "median": 1.2,
          "10%": 1.11,
          "90%": 1.3,
          "25%": 1.15,
          "75%": 1.25
        },
        "36023": {
          "name": "Cortland",
          "median": 1.19,
          "10%": 1.08,
          "90%": 1.27,
          "25%": 1.13,
          "75%": 1.23
        },
        "51580": {
          "name": "Covington",
          "median": 1.17,
          "10%": 1.05,
          "90%": 1.26,
          "25%": 1.1,
          "75%": 1.22
        },
        "51045": {
          "name": "Craig",
          "median": 1.18,
          "10%": 1.09,
          "90%": 1.35,
          "25%": 1.14,
          "75%": 1.26
        },
        "42039": {
          "name": "Crawford",
          "median": 1.18,
          "10%": 1.05,
          "90%": 1.28,
          "25%": 1.1,
          "75%": 1.24
        },
        "51047": {
          "name": "Culpeper",
          "median": 1.22,
          "10%": 1.1,
          "90%": 1.32,
          "25%": 1.16,
          "75%": 1.26
        },
        "34011": {
          "name": "Cumberland",
          "median": 1.16,
          "10%": 1.08,
          "90%": 1.28,
          "25%": 1.13,
          "75%": 1.22
        },
        "42041": {
          "name": "Cumberland",
          "median": 1.21,
          "10%": 1.13,
          "90%": 1.35,
          "25%": 1.15,
          "75%": 1.26
        },
        "51049": {
          "name": "Cumberland",
          "median": 1.18,
          "10%": 1.06,
          "90%": 1.32,
          "25%": 1.09,
          "75%": 1.25
        },
        "51590": {
          "name": "Danville",
          "median": 1.18,
          "10%": 1.09,
          "90%": 1.31,
          "25%": 1.13,
          "75%": 1.27
        },
        "42043": {
          "name": "Dauphin",
          "median": 1.21,
          "10%": 1.11,
          "90%": 1.32,
          "25%": 1.15,
          "75%": 1.27
        },
        "36025": {
          "name": "Delaware",
          "median": 1.21,
          "10%": 1.1,
          "90%": 1.28,
          "25%": 1.14,
          "75%": 1.23
        },
        "42045": {
          "name": "Delaware",
          "median": 1.18,
          "10%": 1.06,
          "90%": 1.31,
          "25%": 1.12,
          "75%": 1.24
        },
        "51051": {
          "name": "Dickenson",
          "median": 1.16,
          "10%": 1.06,
          "90%": 1.27,
          "25%": 1.1,
          "75%": 1.21
        },
        "51053": {
          "name": "Dinwiddie",
          "median": 1.18,
          "10%": 1.06,
          "90%": 1.3,
          "25%": 1.11,
          "75%": 1.23
        },
        "11001": {
          "name": "District of Columbia",
          "median": 1.14,
          "10%": 1.04,
          "90%": 1.25,
          "25%": 1.1,
          "75%": 1.22
        },
        "54017": {
          "name": "Doddridge",
          "median": 1.14,
          "10%": 1.05,
          "90%": 1.24,
          "25%": 1.1,
          "75%": 1.19
        },
        "24019": {
          "name": "Dorchester",
          "median": 1.14,
          "10%": 1.05,
          "90%": 1.28,
          "25%": 1.09,
          "75%": 1.22
        },
        "42047": {
          "name": "Elk",
          "median": 1.19,
          "10%": 1.02,
          "90%": 1.29,
          "25%": 1.14,
          "75%": 1.25
        },
        "51595": {
          "name": "Emporia",
          "median": 1.1,
          "10%": 1.0,
          "90%": 1.2,
          "25%": 1.04,
          "75%": 1.15
        },
        "42049": {
          "name": "Erie",
          "median": 1.19,
          "10%": 1.06,
          "90%": 1.31,
          "25%": 1.1,
          "75%": 1.25
        },
        "51057": {
          "name": "Essex",
          "median": 1.16,
          "10%": 1.05,
          "90%": 1.34,
          "25%": 1.1,
          "75%": 1.23
        },
        "51059": {
          "name": "Fairfax",
          "median": 1.13,
          "10%": 1.06,
          "90%": 1.24,
          "25%": 1.09,
          "75%": 1.19
        },
        "51600": {
          "name": "Fairfax",
          "median": 1.13,
          "10%": 1.03,
          "90%": 1.25,
          "25%": 1.08,
          "75%": 1.2
        },
        "51610": {
          "name": "Falls Church",
          "median": 1.13,
          "10%": 1.05,
          "90%": 1.24,
          "25%": 1.09,
          "75%": 1.2
        },
        "51061": {
          "name": "Fauquier",
          "median": 1.21,
          "10%": 1.1,
          "90%": 1.33,
          "25%": 1.15,
          "75%": 1.26
        },
        "42051": {
          "name": "Fayette",
          "median": 1.16,
          "10%": 1.07,
          "90%": 1.24,
          "25%": 1.11,
          "75%": 1.19
        },
        "54019": {
          "name": "Fayette",
          "median": 1.13,
          "10%": 1.08,
          "90%": 1.27,
          "25%": 1.11,
          "75%": 1.2
        },
        "51063": {
          "name": "Floyd",
          "median": 1.19,
          "10%": 1.09,
          "90%": 1.35,
          "25%": 1.15,
          "75%": 1.26
        },
        "51065": {
          "name": "Fluvanna",
          "median": 1.19,
          "10%": 1.06,
          "90%": 1.36,
          "25%": 1.11,
          "75%": 1.2625
        },
        "42053": {
          "name": "Forest",
          "median": 1.21,
          "10%": 1.04,
          "90%": 1.32,
          "25%": 1.13,
          "75%": 1.26
        },
        "42055": {
          "name": "Franklin",
          "median": 1.19,
          "10%": 1.12,
          "90%": 1.27,
          "25%": 1.15,
          "75%": 1.24
        },
        "51067": {
          "name": "Franklin",
          "median": 1.19,
          "10%": 1.08,
          "90%": 1.36,
          "25%": 1.11,
          "75%": 1.29
        },
        "51620": {
          "name": "Franklin",
          "median": 1.14,
          "10%": 1.07,
          "90%": 1.32,
          "25%": 1.11,
          "75%": 1.24
        },
        "24021": {
          "name": "Frederick",
          "median": 1.2,
          "10%": 1.09,
          "90%": 1.3,
          "25%": 1.13,
          "75%": 1.26
        },
        "51069": {
          "name": "Frederick",
          "median": 1.21,
          "10%": 1.12,
          "90%": 1.35,
          "25%": 1.16,
          "75%": 1.29
        },
        "51630": {
          "name": "Fredericksburg",
          "median": 1.17,
          "10%": 1.03,
          "90%": 1.27,
          "25%": 1.11,
          "75%": 1.24
        },
        "42057": {
          "name": "Fulton",
          "median": 1.22,
          "10%": 1.12,
          "90%": 1.34,
          "25%": 1.15,
          "75%": 1.28
        },
        "51640": {
          "name": "Galax",
          "median": 1.17,
          "10%": 1.05,
          "90%": 1.32,
          "25%": 1.13,
          "75%": 1.26
        },
        "24023": {
          "name": "Garrett",
          "median": 1.15,
          "10%": 1.08,
          "90%": 1.27,
          "25%": 1.1,
          "75%": 1.19
        },
        "51071": {
          "name": "Giles",
          "median": 1.18,
          "10%": 1.1,
          "90%": 1.32,
          "25%": 1.13,
          "75%": 1.25
        },
        "54021": {
          "name": "Gilmer",
          "median": 1.18,
          "10%": 1.11,
          "90%": 1.29,
          "25%": 1.14,
          "75%": 1.27
        },
        "34015": {
          "name": "Gloucester",
          "median": 1.17,
          "10%": 1.06,
          "90%": 1.3,
          "25%": 1.13,
          "75%": 1.24
        },
        "51073": {
          "name": "Gloucester",
          "median": 1.17,
          "10%": 1.06,
          "90%": 1.26,
          "25%": 1.11,
          "75%": 1.21
        },
        "51075": {
          "name": "Goochland",
          "median": 1.19,
          "10%": 1.04,
          "90%": 1.34,
          "25%": 1.07,
          "75%": 1.27
        },
        "54023": {
          "name": "Grant",
          "median": 1.16,
          "10%": 1.07,
          "90%": 1.27,
          "25%": 1.09,
          "75%": 1.2
        },
        "51077": {
          "name": "Grayson",
          "median": 1.17,
          "10%": 1.11,
          "90%": 1.32,
          "25%": 1.13,
          "75%": 1.25
        },
        "54025": {
          "name": "Greenbrier",
          "median": 1.16,
          "10%": 1.09,
          "90%": 1.28,
          "25%": 1.12,
          "75%": 1.23
        },
        "36039": {
          "name": "Greene",
          "median": 1.23,
          "10%": 1.11,
          "90%": 1.35,
          "25%": 1.16,
          "75%": 1.32
        },
        "42059": {
          "name": "Greene",
          "median": 1.22,
          "10%": 1.1,
          "90%": 1.31,
          "25%": 1.17,
          "75%": 1.27
        },
        "51079": {
          "name": "Greene",
          "median": 1.19,
          "10%": 1.12,
          "90%": 1.33,
          "25%": 1.15,
          "75%": 1.27
        },
        "51081": {
          "name": "Greensville",
          "median": 1.14,
          "10%": 1.02,
          "90%": 1.26,
          "25%": 1.07,
          "75%": 1.17
        },
        "51083": {
          "name": "Halifax",
          "median": 1.2,
          "10%": 1.07,
          "90%": 1.32,
          "25%": 1.13,
          "75%": 1.25
        },
        "54027": {
          "name": "Hampshire",
          "median": 1.2,
          "10%": 1.129,
          "90%": 1.29,
          "25%": 1.16,
          "75%": 1.26
        },
        "51650": {
          "name": "Hampton",
          "median": 1.16,
          "10%": 1.07,
          "90%": 1.27,
          "25%": 1.1,
          "75%": 1.22
        },
        "54029": {
          "name": "Hancock",
          "median": 1.21,
          "10%": 1.08,
          "90%": 1.31,
          "25%": 1.15,
          "75%": 1.25
        },
        "51085": {
          "name": "Hanover",
          "median": 1.17,
          "10%": 1.07,
          "90%": 1.28,
          "25%": 1.12,
          "75%": 1.24
        },
        "54031": {
          "name": "Hardy",
          "median": 1.19,
          "10%": 1.11,
          "90%": 1.27,
          "25%": 1.14,
          "75%": 1.24
        },
        "24025": {
          "name": "Harford",
          "median": 1.17,
          "10%": 1.06,
          "90%": 1.27,
          "25%": 1.12,
          "75%": 1.24
        },
        "54033": {
          "name": "Harrison",
          "median": 1.16,
          "10%": 1.09,
          "90%": 1.27,
          "25%": 1.11,
          "75%": 1.22
        },
        "51660": {
          "name": "Harrisonburg",
          "median": 1.16,
          "10%": 1.06,
          "90%": 1.29,
          "25%": 1.12,
          "75%": 1.23
        },
        "51087": {
          "name": "Henrico",
          "median": 1.17,
          "10%": 1.08,
          "90%": 1.26,
          "25%": 1.11,
          "75%": 1.23
        },
        "51089": {
          "name": "Henry",
          "median": 1.19,
          "10%": 1.04,
          "90%": 1.33,
          "25%": 1.12,
          "75%": 1.28
        },
        "36043": {
          "name": "Herkimer",
          "median": 1.13,
          "10%": 1.04,
          "90%": 1.22,
          "25%": 1.09,
          "75%": 1.18
        },
        "51091": {
          "name": "Highland",
          "median": 1.2,
          "10%": 1.1,
          "90%": 1.31,
          "25%": 1.14,
          "75%": 1.23
        },
        "51670": {
          "name": "Hopewell",
          "median": 1.16,
          "10%": 1.01,
          "90%": 1.27,
          "25%": 1.08,
          "75%": 1.2
        },
        "24027": {
          "name": "Howard",
          "median": 1.17,
          "10%": 1.05,
          "90%": 1.28,
          "25%": 1.11,
          "75%": 1.22
        },
        "34019": {
          "name": "Hunterdon",
          "median": 1.18,
          "10%": 1.09,
          "90%": 1.29,
          "25%": 1.13,
          "75%": 1.23
        },
        "42061": {
          "name": "Huntingdon",
          "median": 1.21,
          "10%": 1.13,
          "90%": 1.29,
          "25%": 1.16,
          "75%": 1.25
        },
        "42063": {
          "name": "Indiana",
          "median": 1.15,
          "10%": 1.05,
          "90%": 1.23,
          "25%": 1.13,
          "75%": 1.18
        },
        "51093": {
          "name": "Isle of Wight",
          "median": 1.16,
          "10%": 1.08,
          "90%": 1.29,
          "25%": 1.12,
          "75%": 1.24
        },
        "54035": {
          "name": "Jackson",
          "median": 1.18,
          "10%": 1.07,
          "90%": 1.28,
          "25%": 1.12,
          "75%": 1.23
        },
        "51095": {
          "name": "James City",
          "median": 1.15,
          "10%": 1.03,
          "90%": 1.24,
          "25%": 1.1,
          "75%": 1.2
        },
        "42065": {
          "name": "Jefferson",
          "median": 1.19,
          "10%": 1.06,
          "90%": 1.27,
          "25%": 1.14,
          "75%": 1.24
        },
        "54037": {
          "name": "Jefferson",
          "median": 1.22,
          "10%": 1.1,
          "90%": 1.35,
          "25%": 1.17,
          "75%": 1.27
        },
        "42067": {
          "name": "Juniata",
          "median": 1.21,
          "10%": 1.13,
          "90%": 1.31,
          "25%": 1.16,
          "75%": 1.25
        },
        "54039": {
          "name": "Kanawha",
          "median": 1.12,
          "10%": 1.03,
          "90%": 1.231,
          "25%": 1.09,
          "75%": 1.17
        },
        "10001": {
          "name": "Kent",
          "median": 1.15,
          "10%": 1.07,
          "90%": 1.28,
          "25%": 1.12,
          "75%": 1.23
        },
        "24029": {
          "name": "Kent",
          "median": 1.18,
          "10%": 1.06,
          "90%": 1.27,
          "25%": 1.11,
          "75%": 1.24
        },
        "51099": {
          "name": "King George",
          "median": 1.17,
          "10%": 1.03,
          "90%": 1.29,
          "25%": 1.11,
          "75%": 1.25
        },
        "51101": {
          "name": "King William",
          "median": 1.15,
          "10%": 1.06,
          "90%": 1.26,
          "25%": 1.1,
          "75%": 1.19
        },
        "51097": {
          "name": "King and Queen",
          "median": 1.15,
          "10%": 1.07,
          "90%": 1.28,
          "25%": 1.1,
          "75%": 1.2
        },
        "42069": {
          "name": "Lackawanna",
          "median": 1.18,
          "10%": 1.11,
          "90%": 1.29,
          "25%": 1.14,
          "75%": 1.24
        },
        "42071": {
          "name": "Lancaster",
          "median": 1.17,
          "10%": 1.09,
          "90%": 1.29,
          "25%": 1.13,
          "75%": 1.24
        },
        "51103": {
          "name": "Lancaster",
          "median": 1.16,
          "10%": 1.05,
          "90%": 1.29,
          "25%": 1.11,
          "75%": 1.24
        },
        "42073": {
          "name": "Lawrence",
          "median": 1.18,
          "10%": 1.07,
          "90%": 1.27,
          "25%": 1.11,
          "75%": 1.23
        },
        "42075": {
          "name": "Lebanon",
          "median": 1.15,
          "10%": 1.06,
          "90%": 1.26,
          "25%": 1.11,
          "75%": 1.22
        },
        "51105": {
          "name": "Lee",
          "median": 1.19,
          "10%": 1.11,
          "90%": 1.3,
          "25%": 1.14,
          "75%": 1.24
        },
        "42077": {
          "name": "Lehigh",
          "median": 1.19,
          "10%": 1.09,
          "90%": 1.31,
          "25%": 1.14,
          "75%": 1.2425
        },
        "54041": {
          "name": "Lewis",
          "median": 1.15,
          "10%": 1.07,
          "90%": 1.24,
          "25%": 1.1,
          "75%": 1.19
        },
        "51678": {
          "name": "Lexington",
          "median": 1.16,
          "10%": 1.09,
          "90%": 1.32,
          "25%": 1.13,
          "75%": 1.22
        },
        "54043": {
          "name": "Lincoln",
          "median": 1.15,
          "10%": 1.07,
          "90%": 1.27,
          "25%": 1.1,
          "75%": 1.22
        },
        "36051": {
          "name": "Livingston",
          "median": 1.17,
          "10%": 1.09,
          "90%": 1.32,
          "25%": 1.13,
          "75%": 1.27
        },
        "54045": {
          "name": "Logan",
          "median": 1.17,
          "10%": 1.08,
          "90%": 1.26,
          "25%": 1.12,
          "75%": 1.22
        },
        "51107": {
          "name": "Loudoun",
          "median": 1.18,
          "10%": 1.09,
          "90%": 1.3,
          "25%": 1.13,
          "75%": 1.25
        },
        "51109": {
          "name": "Louisa",
          "median": 1.19,
          "10%": 1.08,
          "90%": 1.32,
          "25%": 1.12,
          "75%": 1.26
        },
        "51111": {
          "name": "Lunenburg",
          "median": 1.2,
          "10%": 1.09,
          "90%": 1.32,
          "25%": 1.12,
          "75%": 1.28
        },
        "42079": {
          "name": "Luzerne",
          "median": 1.18,
          "10%": 1.12,
          "90%": 1.27,
          "25%": 1.14,
          "75%": 1.23
        },
        "42081": {
          "name": "Lycoming",
          "median": 1.2,
          "10%": 1.11,
          "90%": 1.26,
          "25%": 1.15,
          "75%": 1.23
        },
        "51680": {
          "name": "Lynchburg",
          "median": 1.18,
          "10%": 1.06,
          "90%": 1.28,
          "25%": 1.12,
          "75%": 1.22
        },
        "36053": {
          "name": "Madison",
          "median": 1.18,
          "10%": 1.06,
          "90%": 1.27,
          "25%": 1.11,
          "75%": 1.22
        },
        "51113": {
          "name": "Madison",
          "median": 1.19,
          "10%": 1.1,
          "90%": 1.3,
          "25%": 1.14,
          "75%": 1.24
        },
        "51683": {
          "name": "Manassas",
          "median": 1.14,
          "10%": 1.02,
          "90%": 1.25,
          "25%": 1.09,
          "75%": 1.21
        },
        "51685": {
          "name": "Manassas Park",
          "median": 1.14,
          "10%": 1.02,
          "90%": 1.25,
          "25%": 1.07,
          "75%": 1.21
        },
        "54049": {
          "name": "Marion",
          "median": 1.15,
          "10%": 1.08,
          "90%": 1.26,
          "25%": 1.1,
          "75%": 1.19
        },
        "54051": {
          "name": "Marshall",
          "median": 1.19,
          "10%": 1.11,
          "90%": 1.28,
          "25%": 1.14,
          "75%": 1.26
        },
        "51690": {
          "name": "Martinsville",
          "median": 1.18,
          "10%": 1.06,
          "90%": 1.34,
          "25%": 1.11,
          "75%": 1.28
        },
        "54053": {
          "name": "Mason",
          "median": 1.21,
          "10%": 1.1,
          "90%": 1.3,
          "25%": 1.13,
          "75%": 1.24
        },
        "51115": {
          "name": "Mathews",
          "median": 1.16,
          "10%": 1.07,
          "90%": 1.28,
          "25%": 1.09,
          "75%": 1.21
        },
        "54047": {
          "name": "McDowell",
          "median": 1.17,
          "10%": 1.1,
          "90%": 1.29,
          "25%": 1.13,
          "75%": 1.24
        },
        "42083": {
          "name": "McKean",
          "median": 1.2,
          "10%": 1.06,
          "90%": 1.3,
          "25%": 1.13,
          "75%": 1.25
        },
        "51117": {
          "name": "Mecklenburg",
          "median": 1.17,
          "10%": 1.06,
          "90%": 1.27,
          "25%": 1.11,
          "75%": 1.23
        },
        "34021": {
          "name": "Mercer",
          "median": 1.15,
          "10%": 1.04,
          "90%": 1.25,
          "25%": 1.11,
          "75%": 1.2
        },
        "42085": {
          "name": "Mercer",
          "median": 1.19,
          "10%": 1.07,
          "90%": 1.33,
          "25%": 1.13,
          "75%": 1.27
        },
        "54055": {
          "name": "Mercer",
          "median": 1.15,
          "10%": 1.08,
          "90%": 1.29,
          "25%": 1.11,
          "75%": 1.22
        },
        "51119": {
          "name": "Middlesex",
          "median": 1.15,
          "10%": 1.05,
          "90%": 1.27,
          "25%": 1.11,
          "75%": 1.21
        },
        "42087": {
          "name": "Mifflin",
          "median": 1.23,
          "10%": 1.11,
          "90%": 1.31,
          "25%": 1.17,
          "75%": 1.27
        },
        "54057": {
          "name": "Mineral",
          "median": 1.17,
          "10%": 1.09,
          "90%": 1.3,
          "25%": 1.13,
          "75%": 1.24
        },
        "54059": {
          "name": "Mingo",
          "median": 1.18,
          "10%": 1.09,
          "90%": 1.31,
          "25%": 1.12,
          "75%": 1.23
        },
        "34025": {
          "name": "Monmouth",
          "median": 1.17,
          "10%": 1.06,
          "90%": 1.27,
          "25%": 1.13,
          "75%": 1.2
        },
        "54061": {
          "name": "Monongalia",
          "median": 1.16,
          "10%": 1.08,
          "90%": 1.25,
          "25%": 1.11,
          "75%": 1.21
        },
        "42089": {
          "name": "Monroe",
          "median": 1.2,
          "10%": 1.11,
          "90%": 1.31,
          "25%": 1.14,
          "75%": 1.28
        },
        "54063": {
          "name": "Monroe",
          "median": 1.15,
          "10%": 1.08,
          "90%": 1.27,
          "25%": 1.11,
          "75%": 1.2
        },
        "24031": {
          "name": "Montgomery",
          "median": 1.15,
          "10%": 1.08,
          "90%": 1.26,
          "25%": 1.11,
          "75%": 1.2
        },
        "36057": {
          "name": "Montgomery",
          "median": 1.18,
          "10%": 1.08,
          "90%": 1.29,
          "25%": 1.14,
          "75%": 1.24
        },
        "42091": {
          "name": "Montgomery",
          "median": 1.17,
          "10%": 1.07,
          "90%": 1.27,
          "25%": 1.12,
          "75%": 1.22
        },
        "51121": {
          "name": "Montgomery",
          "median": 1.19,
          "10%": 1.1,
          "90%": 1.36,
          "25%": 1.15,
          "75%": 1.29
        },
        "42093": {
          "name": "Montour",
          "median": 1.21,
          "10%": 1.13,
          "90%": 1.29,
          "25%": 1.17,
          "75%": 1.25
        },
        "54065": {
          "name": "Morgan",
          "median": 1.24,
          "10%": 1.11,
          "90%": 1.32,
          "25%": 1.16,
          "75%": 1.29
        },
        "34027": {
          "name": "Morris",
          "median": 1.2,
          "10%": 1.12,
          "90%": 1.35,
          "25%": 1.15,
          "75%": 1.28
        },
        "36059": {
          "name": "Nassau",
          "median": 1.19,
          "10%": 1.09,
          "90%": 1.27,
          "25%": 1.13,
          "75%": 1.24
        },
        "51125": {
          "name": "Nelson",
          "median": 1.2,
          "10%": 1.08,
          "90%": 1.37,
          "25%": 1.14,
          "75%": 1.29
        },
        "10003": {
          "name": "New Castle",
          "median": 1.19,
          "10%": 1.08,
          "90%": 1.33,
          "25%": 1.13,
          "75%": 1.28
        },
        "51127": {
          "name": "New Kent",
          "median": 1.16,
          "10%": 1.07,
          "90%": 1.24,
          "25%": 1.11,
          "75%": 1.2
        },
        "36061": {
          "name": "New York",
          "median": 1.17,
          "10%": 1.08,
          "90%": 1.27,
          "25%": 1.14,
          "75%": 1.23
        },
        "51700": {
          "name": "Newport News",
          "median": 1.17,
          "10%": 1.08,
          "90%": 1.27,
          "25%": 1.11,
          "75%": 1.24
        },
        "54067": {
          "name": "Nicholas",
          "median": 1.15,
          "10%": 1.06,
          "90%": 1.26,
          "25%": 1.09,
          "75%": 1.2
        },
        "51710": {
          "name": "Norfolk",
          "median": 1.18,
          "10%": 1.04,
          "90%": 1.31,
          "25%": 1.1,
          "75%": 1.25
        },
        "42095": {
          "name": "Northampton",
          "median": 1.16,
          "10%": 1.09,
          "90%": 1.27,
          "25%": 1.13,
          "75%": 1.24
        },
        "51131": {
          "name": "Northampton",
          "median": 1.18,
          "10%": 1.05,
          "90%": 1.3,
          "25%": 1.1,
          "75%": 1.25
        },
        "42097": {
          "name": "Northumberland",
          "median": 1.2,
          "10%": 1.11,
          "90%": 1.31,
          "25%": 1.18,
          "75%": 1.25
        },
        "51133": {
          "name": "Northumberland",
          "median": 1.16,
          "10%": 1.05,
          "90%": 1.3,
          "25%": 1.1,
          "75%": 1.24
        },
        "51720": {
          "name": "Norton",
          "median": 1.17,
          "10%": 1.07,
          "90%": 1.28,
          "25%": 1.13,
          "75%": 1.25
        },
        "51135": {
          "name": "Nottoway",
          "median": 1.17,
          "10%": 1.07,
          "90%": 1.28,
          "25%": 1.11,
          "75%": 1.23
        },
        "34029": {
          "name": "Ocean",
          "median": 1.16,
          "10%": 1.08,
          "90%": 1.27,
          "25%": 1.11,
          "75%": 1.2
        },
        "54069": {
          "name": "Ohio",
          "median": 1.18,
          "10%": 1.1,
          "90%": 1.31,
          "25%": 1.15,
          "75%": 1.25
        },
        "36065": {
          "name": "Oneida",
          "median": 1.19,
          "10%": 1.06,
          "90%": 1.28,
          "25%": 1.13,
          "75%": 1.22
        },
        "36067": {
          "name": "Onondaga",
          "median": 1.18,
          "10%": 1.08,
          "90%": 1.28,
          "25%": 1.14,
          "75%": 1.23
        },
        "36069": {
          "name": "Ontario",
          "median": 1.16,
          "10%": 1.06,
          "90%": 1.27,
          "25%": 1.12,
          "75%": 1.23
        },
        "36071": {
          "name": "Orange",
          "median": 1.19,
          "10%": 1.09,
          "90%": 1.28,
          "25%": 1.14,
          "75%": 1.24
        },
        "51137": {
          "name": "Orange",
          "median": 1.2,
          "10%": 1.1,
          "90%": 1.32,
          "25%": 1.17,
          "75%": 1.26
        },
        "36077": {
          "name": "Otsego",
          "median": 1.18,
          "10%": 1.09,
          "90%": 1.31,
          "25%": 1.13,
          "75%": 1.24
        },
        "51139": {
          "name": "Page",
          "median": 1.21,
          "10%": 1.11,
          "90%": 1.33,
          "25%": 1.15,
          "75%": 1.26
        },
        "51141": {
          "name": "Patrick",
          "median": 1.17,
          "10%": 1.05,
          "90%": 1.33,
          "25%": 1.12,
          "75%": 1.24
        },
        "54071": {
          "name": "Pendleton",
          "median": 1.21,
          "10%": 1.09,
          "90%": 1.35,
          "25%": 1.15,
          "75%": 1.25
        },
        "42099": {
          "name": "Perry",
          "median": 1.21,
          "10%": 1.14,
          "90%": 1.35,
          "25%": 1.17,
          "75%": 1.28
        },
        "51730": {
          "name": "Petersburg",
          "median": 1.16,
          "10%": 1.05,
          "90%": 1.27,
          "25%": 1.1,
          "75%": 1.22
        },
        "42101": {
          "name": "Philadelphia",
          "median": 1.18,
          "10%": 1.06,
          "90%": 1.28,
          "25%": 1.11,
          "75%": 1.21
        },
        "42103": {
          "name": "Pike",
          "median": 1.18,
          "10%": 1.09,
          "90%": 1.29,
          "25%": 1.12,
          "75%": 1.25
        },
        "51143": {
          "name": "Pittsylvania",
          "median": 1.23,
          "10%": 1.1,
          "90%": 1.33,
          "25%": 1.15,
          "75%": 1.3
        },
        "54073": {
          "name": "Pleasants",
          "median": 1.17,
          "10%": 1.08,
          "90%": 1.27,
          "25%": 1.12,
          "75%": 1.23
        },
        "54075": {
          "name": "Pocahontas",
          "median": 1.16,
          "10%": 1.08,
          "90%": 1.27,
          "25%": 1.12,
          "75%": 1.22
        },
        "51735": {
          "name": "Poquoson",
          "median": 1.16,
          "10%": 1.06,
          "90%": 1.28,
          "25%": 1.1,
          "75%": 1.21
        },
        "51740": {
          "name": "Portsmouth",
          "median": 1.17,
          "10%": 1.05,
          "90%": 1.311,
          "25%": 1.09,
          "75%": 1.24
        },
        "42105": {
          "name": "Potter",
          "median": 1.19,
          "10%": 1.11,
          "90%": 1.3,
          "25%": 1.15,
          "75%": 1.26
        },
        "51145": {
          "name": "Powhatan",
          "median": 1.17,
          "10%": 1.01,
          "90%": 1.3,
          "25%": 1.06,
          "75%": 1.24
        },
        "54077": {
          "name": "Preston",
          "median": 1.15,
          "10%": 1.08,
          "90%": 1.26,
          "25%": 1.11,
          "75%": 1.21
        },
        "51147": {
          "name": "Prince Edward",
          "median": 1.17,
          "10%": 1.06,
          "90%": 1.31,
          "25%": 1.13,
          "75%": 1.25
        },
        "51149": {
          "name": "Prince George",
          "median": 1.18,
          "10%": 1.04,
          "90%": 1.27,
          "25%": 1.1,
          "75%": 1.21
        },
        "24033": {
          "name": "Prince George's",
          "median": 1.15,
          "10%": 1.06,
          "90%": 1.27,
          "25%": 1.09,
          "75%": 1.22
        },
        "51153": {
          "name": "Prince William",
          "median": 1.16,
          "10%": 1.08,
          "90%": 1.26,
          "25%": 1.11,
          "75%": 1.22
        },
        "51155": {
          "name": "Pulaski",
          "median": 1.18,
          "10%": 1.11,
          "90%": 1.33,
          "25%": 1.14,
          "75%": 1.26
        },
        "54079": {
          "name": "Putnam",
          "median": 1.18,
          "10%": 1.07,
          "90%": 1.27,
          "25%": 1.1,
          "75%": 1.22
        },
        "24035": {
          "name": "Queen Anne's",
          "median": 1.19,
          "10%": 1.07,
          "90%": 1.28,
          "25%": 1.12,
          "75%": 1.24
        },
        "51750": {
          "name": "Radford",
          "median": 1.2,
          "10%": 1.1,
          "90%": 1.37,
          "25%": 1.16,
          "75%": 1.29
        },
        "54081": {
          "name": "Raleigh",
          "median": 1.18,
          "10%": 1.09,
          "90%": 1.28,
          "25%": 1.12,
          "75%": 1.22
        },
        "54083": {
          "name": "Randolph",
          "median": 1.14,
          "10%": 1.08,
          "90%": 1.23,
          "25%": 1.11,
          "75%": 1.21
        },
        "51157": {
          "name": "Rappahannock",
          "median": 1.2,
          "10%": 1.09,
          "90%": 1.34,
          "25%": 1.15,
          "75%": 1.27
        },
        "36085": {
          "name": "Richmond",
          "median": 1.15,
          "10%": 1.08,
          "90%": 1.28,
          "25%": 1.12,
          "75%": 1.23
        },
        "51159": {
          "name": "Richmond",
          "median": 1.15,
          "10%": 1.02,
          "90%": 1.33,
          "25%": 1.07,
          "75%": 1.23
        },
        "51760": {
          "name": "Richmond",
          "median": 1.17,
          "10%": 1.05,
          "90%": 1.27,
          "25%": 1.11,
          "75%": 1.24
        },
        "54085": {
          "name": "Ritchie",
          "median": 1.17,
          "10%": 1.09,
          "90%": 1.3,
          "25%": 1.13,
          "75%": 1.24
        },
        "54087": {
          "name": "Roane",
          "median": 1.19,
          "10%": 1.07,
          "90%": 1.26,
          "25%": 1.12,
          "75%": 1.23
        },
        "51161": {
          "name": "Roanoke",
          "median": 1.2,
          "10%": 1.08,
          "90%": 1.37,
          "25%": 1.14,
          "75%": 1.29
        },
        "51770": {
          "name": "Roanoke",
          "median": 1.2,
          "10%": 1.05,
          "90%": 1.34,
          "25%": 1.12,
          "75%": 1.28
        },
        "51163": {
          "name": "Rockbridge",
          "median": 1.19,
          "10%": 1.1,
          "90%": 1.34,
          "25%": 1.15,
          "75%": 1.31
        },
        "51165": {
          "name": "Rockingham",
          "median": 1.18,
          "10%": 1.1,
          "90%": 1.31,
          "25%": 1.15,
          "75%": 1.25
        },
        "51167": {
          "name": "Russell",
          "median": 1.16,
          "10%": 1.05,
          "90%": 1.28,
          "25%": 1.1,
          "75%": 1.2
        },
        "34033": {
          "name": "Salem",
          "median": 1.18,
          "10%": 1.07,
          "90%": 1.32,
          "25%": 1.12,
          "75%": 1.28
        },
        "51775": {
          "name": "Salem",
          "median": 1.2,
          "10%": 1.09,
          "90%": 1.39,
          "25%": 1.13,
          "75%": 1.3
        },
        "36095": {
          "name": "Schoharie",
          "median": 1.2,
          "10%": 1.11,
          "90%": 1.32,
          "25%": 1.16,
          "75%": 1.27
        },
        "36097": {
          "name": "Schuyler",
          "median": 1.2,
          "10%": 1.08,
          "90%": 1.33,
          "25%": 1.14,
          "75%": 1.24
        },
        "42107": {
          "name": "Schuylkill",
          "median": 1.18,
          "10%": 1.1,
          "90%": 1.31,
          "25%": 1.15,
          "75%": 1.24
        },
        "51169": {
          "name": "Scott",
          "median": 1.19,
          "10%": 1.1,
          "90%": 1.3,
          "25%": 1.15,
          "75%": 1.25
        },
        "51171": {
          "name": "Shenandoah",
          "median": 1.2,
          "10%": 1.12,
          "90%": 1.32,
          "25%": 1.16,
          "75%": 1.27
        },
        "51173": {
          "name": "Smyth",
          "median": 1.16,
          "10%": 1.1,
          "90%": 1.29,
          "25%": 1.13,
          "75%": 1.21
        },
        "42109": {
          "name": "Snyder",
          "median": 1.21,
          "10%": 1.09,
          "90%": 1.29,
          "25%": 1.15,
          "75%": 1.24
        },
        "24039": {
          "name": "Somerset",
          "median": 1.17,
          "10%": 1.06,
          "90%": 1.3,
          "25%": 1.12,
          "75%": 1.23
        },
        "42111": {
          "name": "Somerset",
          "median": 1.16,
          "10%": 1.1,
          "90%": 1.27,
          "25%": 1.12,
          "75%": 1.2
        },
        "51175": {
          "name": "Southampton",
          "median": 1.14,
          "10%": 1.03,
          "90%": 1.3,
          "25%": 1.09,
          "75%": 1.21
        },
        "51177": {
          "name": "Spotsylvania",
          "median": 1.19,
          "10%": 1.08,
          "90%": 1.29,
          "25%": 1.12,
          "75%": 1.24
        },
        "24037": {
          "name": "St. Mary's",
          "median": 1.19,
          "10%": 1.06,
          "90%": 1.28,
          "25%": 1.1,
          "75%": 1.24
        },
        "51179": {
          "name": "Stafford",
          "median": 1.17,
          "10%": 1.08,
          "90%": 1.3,
          "25%": 1.12,
          "75%": 1.27
        },
        "51790": {
          "name": "Staunton",
          "median": 1.21,
          "10%": 1.06,
          "90%": 1.35,
          "25%": 1.15,
          "75%": 1.29
        },
        "36101": {
          "name": "Steuben",
          "median": 1.19,
          "10%": 1.1,
          "90%": 1.3,
          "25%": 1.14,
          "75%": 1.25
        },
        "51800": {
          "name": "Suffolk",
          "median": 1.15,
          "10%": 1.07,
          "90%": 1.32,
          "25%": 1.11,
          "75%": 1.23
        },
        "36105": {
          "name": "Sullivan",
          "median": 1.2,
          "10%": 1.09,
          "90%": 1.3,
          "25%": 1.15,
          "75%": 1.25
        },
        "42113": {
          "name": "Sullivan",
          "median": 1.16,
          "10%": 1.09,
          "90%": 1.26,
          "25%": 1.13,
          "75%": 1.2
        },
        "54089": {
          "name": "Summers",
          "median": 1.14,
          "10%": 1.08,
          "90%": 1.29,
          "25%": 1.1,
          "75%": 1.19
        },
        "51181": {
          "name": "Surry",
          "median": 1.17,
          "10%": 1.04,
          "90%": 1.27,
          "25%": 1.13,
          "75%": 1.22
        },
        "42115": {
          "name": "Susquehanna",
          "median": 1.16,
          "10%": 1.08,
          "90%": 1.24,
          "25%": 1.12,
          "75%": 1.2
        },
        "10005": {
          "name": "Sussex",
          "median": 1.16,
          "10%": 1.06,
          "90%": 1.26,
          "25%": 1.11,
          "75%": 1.21
        },
        "34037": {
          "name": "Sussex",
          "median": 1.21,
          "10%": 1.07,
          "90%": 1.3,
          "25%": 1.14,
          "75%": 1.25
        },
        "51183": {
          "name": "Sussex",
          "median": 1.17,
          "10%": 1.03,
          "90%": 1.27,
          "25%": 1.12,
          "75%": 1.22
        },
        "24041": {
          "name": "Talbot",
          "median": 1.18,
          "10%": 1.04,
          "90%": 1.25,
          "25%": 1.0875,
          "75%": 1.22
        },
        "54091": {
          "name": "Taylor",
          "median": 1.16,
          "10%": 1.07,
          "90%": 1.28,
          "25%": 1.12,
          "75%": 1.21
        },
        "51185": {
          "name": "Tazewell",
          "median": 1.15,
          "10%": 1.09,
          "90%": 1.24,
          "25%": 1.11,
          "75%": 1.21
        },
        "36107": {
          "name": "Tioga",
          "median": 1.12,
          "10%": 1.07,
          "90%": 1.22,
          "25%": 1.1,
          "75%": 1.19
        },
        "42117": {
          "name": "Tioga",
          "median": 1.18,
          "10%": 1.11,
          "90%": 1.28,
          "25%": 1.14,
          "75%": 1.23
        },
        "36109": {
          "name": "Tompkins",
          "median": 1.18,
          "10%": 1.09,
          "90%": 1.26,
          "25%": 1.15,
          "75%": 1.21
        },
        "54093": {
          "name": "Tucker",
          "median": 1.14,
          "10%": 1.07,
          "90%": 1.26,
          "25%": 1.1,
          "75%": 1.2
        },
        "54095": {
          "name": "Tyler",
          "median": 1.14,
          "10%": 1.06,
          "90%": 1.25,
          "25%": 1.1,
          "75%": 1.19
        },
        "36111": {
          "name": "Ulster",
          "median": 1.22,
          "10%": 1.1,
          "90%": 1.34,
          "25%": 1.17,
          "75%": 1.29
        },
        "42119": {
          "name": "Union",
          "median": 1.2,
          "10%": 1.1,
          "90%": 1.27,
          "25%": 1.15,
          "75%": 1.23
        },
        "54097": {
          "name": "Upshur",
          "median": 1.14,
          "10%": 1.05,
          "90%": 1.22,
          "25%": 1.09,
          "75%": 1.2
        },
        "42121": {
          "name": "Venango",
          "median": 1.2,
          "10%": 1.07,
          "90%": 1.33,
          "25%": 1.15,
          "75%": 1.27
        },
        "51810": {
          "name": "Virginia Beach",
          "median": 1.18,
          "10%": 1.04,
          "90%": 1.33,
          "25%": 1.1,
          "75%": 1.27
        },
        "34041": {
          "name": "Warren",
          "median": 1.19,
          "10%": 1.09,
          "90%": 1.3,
          "25%": 1.13,
          "75%": 1.25
        },
        "42123": {
          "name": "Warren",
          "median": 1.19,
          "10%": 1.04,
          "90%": 1.35,
          "25%": 1.11,
          "75%": 1.27
        },
        "51187": {
          "name": "Warren",
          "median": 1.22,
          "10%": 1.1,
          "90%": 1.39,
          "25%": 1.17,
          "75%": 1.3
        },
        "24043": {
          "name": "Washington",
          "median": 1.21,
          "10%": 1.11,
          "90%": 1.29,
          "25%": 1.15,
          "75%": 1.25
        },
        "42125": {
          "name": "Washington",
          "median": 1.19,
          "10%": 1.07,
          "90%": 1.3,
          "25%": 1.14,
          "75%": 1.25
        },
        "51191": {
          "name": "Washington",
          "median": 1.15,
          "10%": 1.08,
          "90%": 1.28,
          "25%": 1.11,
          "75%": 1.18
        },
        "42127": {
          "name": "Wayne",
          "median": 1.18,
          "10%": 1.07,
          "90%": 1.27,
          "25%": 1.13,
          "75%": 1.22
        },
        "54099": {
          "name": "Wayne",
          "median": 1.14,
          "10%": 1.06,
          "90%": 1.27,
          "25%": 1.11,
          "75%": 1.22
        },
        "51820": {
          "name": "Waynesboro",
          "median": 1.21,
          "10%": 1.1,
          "90%": 1.37,
          "25%": 1.16,
          "75%": 1.32
        },
        "54101": {
          "name": "Webster",
          "median": 1.15,
          "10%": 1.05,
          "90%": 1.23,
          "25%": 1.09,
          "75%": 1.19
        },
        "36119": {
          "name": "Westchester",
          "median": 1.2,
          "10%": 1.1,
          "90%": 1.28,
          "25%": 1.16,
          "75%": 1.24
        },
        "42129": {
          "name": "Westmoreland",
          "median": 1.16,
          "10%": 1.08,
          "90%": 1.27,
          "25%": 1.12,
          "75%": 1.21
        },
        "51193": {
          "name": "Westmoreland",
          "median": 1.15,
          "10%": 1.05,
          "90%": 1.31,
          "25%": 1.09,
          "75%": 1.23
        },
        "54103": {
          "name": "Wetzel",
          "median": 1.18,
          "10%": 1.12,
          "90%": 1.26,
          "25%": 1.14,
          "75%": 1.24
        },
        "24045": {
          "name": "Wicomico",
          "median": 1.16,
          "10%": 1.06,
          "90%": 1.28,
          "25%": 1.1,
          "75%": 1.23
        },
        "51830": {
          "name": "Williamsburg",
          "median": 1.13,
          "10%": 1.01,
          "90%": 1.24,
          "25%": 1.08,
          "75%": 1.18
        },
        "51840": {
          "name": "Winchester",
          "median": 1.21,
          "10%": 1.12,
          "90%": 1.34,
          "25%": 1.15,
          "75%": 1.27
        },
        "54105": {
          "name": "Wirt",
          "median": 1.21,
          "10%": 1.13,
          "90%": 1.34,
          "25%": 1.15,
          "75%": 1.28
        },
        "51195": {
          "name": "Wise",
          "median": 1.18,
          "10%": 1.08,
          "90%": 1.27,
          "25%": 1.13,
          "75%": 1.25
        },
        "54107": {
          "name": "Wood",
          "median": 1.18,
          "10%": 1.09,
          "90%": 1.31,
          "25%": 1.14,
          "75%": 1.25
        },
        "24047": {
          "name": "Worcester",
          "median": 1.17,
          "10%": 1.06,
          "90%": 1.29,
          "25%": 1.09,
          "75%": 1.22
        },
        "42131": {
          "name": "Wyoming",
          "median": 1.17,
          "10%": 1.1,
          "90%": 1.27,
          "25%": 1.15,
          "75%": 1.21
        },
        "54109": {
          "name": "Wyoming",
          "median": 1.18,
          "10%": 1.09,
          "90%": 1.31,
          "25%": 1.14,
          "75%": 1.24
        },
        "51197": {
          "name": "Wythe",
          "median": 1.15,
          "10%": 1.09,
          "90%": 1.27,
          "25%": 1.11,
          "75%": 1.2
        },
        "36123": {
          "name": "Yates",
          "median": 1.17,
          "10%": 1.09,
          "90%": 1.29,
          "25%": 1.13,
          "75%": 1.26
        },
        "42133": {
          "name": "York",
          "median": 1.17,
          "10%": 1.06,
          "90%": 1.27,
          "25%": 1.1,
          "75%": 1.25
        },
        "51199": {
          "name": "York",
          "median": 1.16,
          "10%": 1.04,
          "90%": 1.25,
          "25%": 1.1,
          "75%": 1.2
        },
        "max": 1.24,
        "min": 1
      },
      "5": {
        "51001": {
          "name": "Accomack",
          "median": 1.18,
          "10%": 1.05,
          "90%": 1.29,
          "25%": 1.1,
          "75%": 1.25
        },
        "42001": {
          "name": "Adams",
          "median": 1.19,
          "10%": 1.06,
          "90%": 1.36,
          "25%": 1.13,
          "75%": 1.28
        },
        "51003": {
          "name": "Albemarle",
          "median": 1.18,
          "10%": 1.04,
          "90%": 1.36,
          "25%": 1.13,
          "75%": 1.29
        },
        "51510": {
          "name": "Alexandria",
          "median": 1.13,
          "10%": 1.01,
          "90%": 1.28,
          "25%": 1.06,
          "75%": 1.21
        },
        "24001": {
          "name": "Allegany",
          "median": 1.21,
          "10%": 1.1,
          "90%": 1.32,
          "25%": 1.17,
          "75%": 1.27
        },
        "36003": {
          "name": "Allegany",
          "median": 1.19,
          "10%": 1.06,
          "90%": 1.31,
          "25%": 1.13,
          "75%": 1.25
        },
        "51005": {
          "name": "Alleghany",
          "median": 1.2,
          "10%": 1.07,
          "90%": 1.35,
          "25%": 1.12,
          "75%": 1.28
        },
        "42003": {
          "name": "Allegheny",
          "median": 1.17,
          "10%": 1.04,
          "90%": 1.29,
          "25%": 1.1,
          "75%": 1.25
        },
        "51007": {
          "name": "Amelia",
          "median": 1.17,
          "10%": 1.01,
          "90%": 1.361,
          "25%": 1.1,
          "75%": 1.26
        },
        "51009": {
          "name": "Amherst",
          "median": 1.21,
          "10%": 1.07,
          "90%": 1.37,
          "25%": 1.14,
          "75%": 1.33
        },
        "24003": {
          "name": "Anne Arundel",
          "median": 1.14,
          "10%": 1.04,
          "90%": 1.29,
          "25%": 1.07,
          "75%": 1.22
        },
        "51011": {
          "name": "Appomattox",
          "median": 1.19,
          "10%": 1.05,
          "90%": 1.41,
          "25%": 1.13,
          "75%": 1.32
        },
        "51013": {
          "name": "Arlington",
          "median": 1.13,
          "10%": 1.02,
          "90%": 1.27,
          "25%": 1.06,
          "75%": 1.18
        },
        "42005": {
          "name": "Armstrong",
          "median": 1.17,
          "10%": 1.07,
          "90%": 1.32,
          "25%": 1.12,
          "75%": 1.23
        },
        "34001": {
          "name": "Atlantic",
          "median": 1.19,
          "10%": 1.09,
          "90%": 1.35,
          "25%": 1.15,
          "75%": 1.26
        },
        "51015": {
          "name": "Augusta",
          "median": 1.2,
          "10%": 1.06,
          "90%": 1.37,
          "25%": 1.16,
          "75%": 1.31
        },
        "24005": {
          "name": "Baltimore",
          "median": 1.14,
          "10%": 1.04,
          "90%": 1.29,
          "25%": 1.09,
          "75%": 1.21
        },
        "24510": {
          "name": "Baltimore",
          "median": 1.14,
          "10%": 1.04,
          "90%": 1.31,
          "25%": 1.08,
          "75%": 1.21
        },
        "54001": {
          "name": "Barbour",
          "median": 1.16,
          "10%": 1.06,
          "90%": 1.28,
          "25%": 1.1,
          "75%": 1.21
        },
        "51017": {
          "name": "Bath",
          "median": 1.22,
          "10%": 1.08,
          "90%": 1.41,
          "25%": 1.15,
          "75%": 1.29
        },
        "42007": {
          "name": "Beaver",
          "median": 1.15,
          "10%": 1.08,
          "90%": 1.28,
          "25%": 1.1,
          "75%": 1.21
        },
        "42009": {
          "name": "Bedford",
          "median": 1.21,
          "10%": 1.13,
          "90%": 1.3,
          "25%": 1.16,
          "75%": 1.27
        },
        "51019": {
          "name": "Bedford",
          "median": 1.21,
          "10%": 1.09,
          "90%": 1.34,
          "25%": 1.13,
          "75%": 1.27
        },
        "54003": {
          "name": "Berkeley",
          "median": 1.22,
          "10%": 1.09,
          "90%": 1.31,
          "25%": 1.14,
          "75%": 1.27
        },
        "42011": {
          "name": "Berks",
          "median": 1.2,
          "10%": 1.05,
          "90%": 1.34,
          "25%": 1.15,
          "75%": 1.25
        },
        "42013": {
          "name": "Blair",
          "median": 1.22,
          "10%": 1.11,
          "90%": 1.31,
          "25%": 1.15,
          "75%": 1.25
        },
        "51021": {
          "name": "Bland",
          "median": 1.15,
          "10%": 1.05,
          "90%": 1.31,
          "25%": 1.1,
          "75%": 1.2
        },
        "54005": {
          "name": "Boone",
          "median": 1.19,
          "10%": 1.08,
          "90%": 1.26,
          "25%": 1.11,
          "75%": 1.24
        },
        "51023": {
          "name": "Botetourt",
          "median": 1.22,
          "10%": 1.08,
          "90%": 1.38,
          "25%": 1.15,
          "75%": 1.31
        },
        "42015": {
          "name": "Bradford",
          "median": 1.14,
          "10%": 1.06,
          "90%": 1.26,
          "25%": 1.1,
          "75%": 1.21
        },
        "54007": {
          "name": "Braxton",
          "median": 1.15,
          "10%": 1.06,
          "90%": 1.26,
          "25%": 1.1,
          "75%": 1.2
        },
        "51520": {
          "name": "Bristol",
          "median": 1.14,
          "10%": 1.09,
          "90%": 1.31,
          "25%": 1.12,
          "75%": 1.23
        },
        "36005": {
          "name": "Bronx",
          "median": 1.19,
          "10%": 1.08,
          "90%": 1.35,
          "25%": 1.15,
          "75%": 1.26
        },
        "54009": {
          "name": "Brooke",
          "median": 1.2,
          "10%": 1.06,
          "90%": 1.36,
          "25%": 1.11,
          "75%": 1.28
        },
        "36007": {
          "name": "Broome",
          "median": 1.16,
          "10%": 1.05,
          "90%": 1.26,
          "25%": 1.09,
          "75%": 1.21
        },
        "51025": {
          "name": "Brunswick",
          "median": 1.18,
          "10%": 1.06,
          "90%": 1.3,
          "25%": 1.12,
          "75%": 1.25
        },
        "51027": {
          "name": "Buchanan",
          "median": 1.16,
          "10%": 1.06,
          "90%": 1.29,
          "25%": 1.1,
          "75%": 1.22
        },
        "51029": {
          "name": "Buckingham",
          "median": 1.19,
          "10%": 1.05,
          "90%": 1.37,
          "25%": 1.1,
          "75%": 1.25
        },
        "42017": {
          "name": "Bucks",
          "median": 1.14,
          "10%": 1.06,
          "90%": 1.27,
          "25%": 1.11,
          "75%": 1.22
        },
        "51530": {
          "name": "Buena Vista",
          "median": 1.2,
          "10%": 1.06,
          "90%": 1.49,
          "25%": 1.13,
          "75%": 1.36
        },
        "34005": {
          "name": "Burlington",
          "median": 1.16,
          "10%": 1.05,
          "90%": 1.26,
          "25%": 1.11,
          "75%": 1.21
        },
        "42019": {
          "name": "Butler",
          "median": 1.18,
          "10%": 1.06,
          "90%": 1.29,
          "25%": 1.1,
          "75%": 1.22
        },
        "54011": {
          "name": "Cabell",
          "median": 1.16,
          "10%": 1.06,
          "90%": 1.3,
          "25%": 1.1,
          "75%": 1.24
        },
        "54013": {
          "name": "Calhoun",
          "median": 1.21,
          "10%": 1.09,
          "90%": 1.36,
          "25%": 1.15,
          "75%": 1.3
        },
        "24009": {
          "name": "Calvert",
          "median": 1.17,
          "10%": 1.04,
          "90%": 1.32,
          "25%": 1.1,
          "75%": 1.21
        },
        "42021": {
          "name": "Cambria",
          "median": 1.15,
          "10%": 1.08,
          "90%": 1.27,
          "25%": 1.11,
          "75%": 1.2
        },
        "34007": {
          "name": "Camden",
          "median": 1.17,
          "10%": 1.05,
          "90%": 1.26,
          "25%": 1.11,
          "75%": 1.22
        },
        "42023": {
          "name": "Cameron",
          "median": 1.18,
          "10%": 1.05,
          "90%": 1.3,
          "25%": 1.12,
          "75%": 1.25
        },
        "51031": {
          "name": "Campbell",
          "median": 1.22,
          "10%": 1.07,
          "90%": 1.33,
          "25%": 1.13,
          "75%": 1.27
        },
        "34009": {
          "name": "Cape May",
          "median": 1.2,
          "10%": 1.08,
          "90%": 1.35,
          "25%": 1.15,
          "75%": 1.24
        },
        "42025": {
          "name": "Carbon",
          "median": 1.19,
          "10%": 1.08,
          "90%": 1.29,
          "25%": 1.14,
          "75%": 1.23
        },
        "24011": {
          "name": "Caroline",
          "median": 1.18,
          "10%": 1.069,
          "90%": 1.31,
          "25%": 1.12,
          "75%": 1.23
        },
        "51033": {
          "name": "Caroline",
          "median": 1.18,
          "10%": 1.04,
          "90%": 1.32,
          "25%": 1.09,
          "75%": 1.26
        },
        "24013": {
          "name": "Carroll",
          "median": 1.18,
          "10%": 1.06,
          "90%": 1.32,
          "25%": 1.1,
          "75%": 1.27
        },
        "51035": {
          "name": "Carroll",
          "median": 1.17,
          "10%": 1.09,
          "90%": 1.3,
          "25%": 1.13,
          "75%": 1.24
        },
        "24015": {
          "name": "Cecil",
          "median": 1.18,
          "10%": 1.07,
          "90%": 1.32,
          "25%": 1.12,
          "75%": 1.26
        },
        "42027": {
          "name": "Centre",
          "median": 1.23,
          "10%": 1.08,
          "90%": 1.33,
          "25%": 1.16,
          "75%": 1.28
        },
        "24017": {
          "name": "Charles",
          "median": 1.18,
          "10%": 1.03,
          "90%": 1.33,
          "25%": 1.1,
          "75%": 1.25
        },
        "51036": {
          "name": "Charles City",
          "median": 1.15,
          "10%": 1.04,
          "90%": 1.27,
          "25%": 1.11,
          "75%": 1.22
        },
        "51037": {
          "name": "Charlotte",
          "median": 1.19,
          "10%": 1.07,
          "90%": 1.31,
          "25%": 1.12,
          "75%": 1.27
        },
        "51540": {
          "name": "Charlottesville",
          "median": 1.17,
          "10%": 1.03,
          "90%": 1.32,
          "25%": 1.11,
          "75%": 1.25
        },
        "36015": {
          "name": "Chemung",
          "median": 1.18,
          "10%": 1.08,
          "90%": 1.28,
          "25%": 1.11,
          "75%": 1.21
        },
        "36017": {
          "name": "Chenango",
          "median": 1.16,
          "10%": 1.06,
          "90%": 1.28,
          "25%": 1.1,
          "75%": 1.23
        },
        "51550": {
          "name": "Chesapeake",
          "median": 1.19,
          "10%": 1.06,
          "90%": 1.37,
          "25%": 1.08,
          "75%": 1.28
        },
        "42029": {
          "name": "Chester",
          "median": 1.2,
          "10%": 1.07,
          "90%": 1.32,
          "25%": 1.11,
          "75%": 1.27
        },
        "51041": {
          "name": "Chesterfield",
          "median": 1.16,
          "10%": 1.02,
          "90%": 1.35,
          "25%": 1.1,
          "75%": 1.27
        },
        "42031": {
          "name": "Clarion",
          "median": 1.2,
          "10%": 1.06,
          "90%": 1.33,
          "25%": 1.14,
          "75%": 1.27
        },
        "51043": {
          "name": "Clarke",
          "median": 1.22,
          "10%": 1.1,
          "90%": 1.34,
          "25%": 1.15,
          "75%": 1.28
        },
        "54015": {
          "name": "Clay",
          "median": 1.12,
          "10%": 1.04,
          "90%": 1.23,
          "25%": 1.07,
          "75%": 1.17
        },
        "42033": {
          "name": "Clearfield",
          "median": 1.2,
          "10%": 1.09,
          "90%": 1.31,
          "25%": 1.13,
          "75%": 1.25
        },
        "42035": {
          "name": "Clinton",
          "median": 1.2,
          "10%": 1.07,
          "90%": 1.3,
          "25%": 1.15,
          "75%": 1.26
        },
        "51570": {
          "name": "Colonial Heights",
          "median": 1.17,
          "10%": 1.05,
          "90%": 1.33,
          "25%": 1.09,
          "75%": 1.24
        },
        "42037": {
          "name": "Columbia",
          "median": 1.22,
          "10%": 1.09,
          "90%": 1.31,
          "25%": 1.15,
          "75%": 1.26
        },
        "36023": {
          "name": "Cortland",
          "median": 1.18,
          "10%": 1.08,
          "90%": 1.3,
          "25%": 1.12,
          "75%": 1.25
        },
        "51580": {
          "name": "Covington",
          "median": 1.18,
          "10%": 1.05,
          "90%": 1.34,
          "25%": 1.09,
          "75%": 1.24
        },
        "51045": {
          "name": "Craig",
          "median": 1.2,
          "10%": 1.1,
          "90%": 1.38,
          "25%": 1.14,
          "75%": 1.2725
        },
        "42039": {
          "name": "Crawford",
          "median": 1.18,
          "10%": 1.04,
          "90%": 1.29,
          "25%": 1.09,
          "75%": 1.25
        },
        "51047": {
          "name": "Culpeper",
          "median": 1.2,
          "10%": 1.07,
          "90%": 1.32,
          "25%": 1.15,
          "75%": 1.26
        },
        "34011": {
          "name": "Cumberland",
          "median": 1.16,
          "10%": 1.09,
          "90%": 1.31,
          "25%": 1.12,
          "75%": 1.22
        },
        "42041": {
          "name": "Cumberland",
          "median": 1.2,
          "10%": 1.12,
          "90%": 1.38,
          "25%": 1.15,
          "75%": 1.28
        },
        "51049": {
          "name": "Cumberland",
          "median": 1.16,
          "10%": 1.05,
          "90%": 1.37,
          "25%": 1.1,
          "75%": 1.26
        },
        "51590": {
          "name": "Danville",
          "median": 1.17,
          "10%": 1.04,
          "90%": 1.32,
          "25%": 1.12,
          "75%": 1.28
        },
        "42043": {
          "name": "Dauphin",
          "median": 1.24,
          "10%": 1.07,
          "90%": 1.35,
          "25%": 1.14,
          "75%": 1.3
        },
        "36025": {
          "name": "Delaware",
          "median": 1.18,
          "10%": 1.1,
          "90%": 1.29,
          "25%": 1.14,
          "75%": 1.25
        },
        "42045": {
          "name": "Delaware",
          "median": 1.18,
          "10%": 1.05,
          "90%": 1.351,
          "25%": 1.13,
          "75%": 1.28
        },
        "51051": {
          "name": "Dickenson",
          "median": 1.16,
          "10%": 1.04,
          "90%": 1.27,
          "25%": 1.09,
          "75%": 1.21
        },
        "51053": {
          "name": "Dinwiddie",
          "median": 1.18,
          "10%": 1.07,
          "90%": 1.29,
          "25%": 1.11,
          "75%": 1.24
        },
        "11001": {
          "name": "District of Columbia",
          "median": 1.12,
          "10%": 1.01,
          "90%": 1.29,
          "25%": 1.07,
          "75%": 1.21
        },
        "54017": {
          "name": "Doddridge",
          "median": 1.14,
          "10%": 1.05,
          "90%": 1.25,
          "25%": 1.07,
          "75%": 1.19
        },
        "24019": {
          "name": "Dorchester",
          "median": 1.14,
          "10%": 1.01,
          "90%": 1.27,
          "25%": 1.08,
          "75%": 1.2
        },
        "42047": {
          "name": "Elk",
          "median": 1.19,
          "10%": 0.98,
          "90%": 1.3,
          "25%": 1.1,
          "75%": 1.25
        },
        "51595": {
          "name": "Emporia",
          "median": 1.12,
          "10%": 0.99,
          "90%": 1.23,
          "25%": 1.04,
          "75%": 1.16
        },
        "42049": {
          "name": "Erie",
          "median": 1.19,
          "10%": 1.04,
          "90%": 1.34,
          "25%": 1.09,
          "75%": 1.26
        },
        "51057": {
          "name": "Essex",
          "median": 1.15,
          "10%": 1.03,
          "90%": 1.36,
          "25%": 1.06,
          "75%": 1.26
        },
        "51059": {
          "name": "Fairfax",
          "median": 1.13,
          "10%": 1.03,
          "90%": 1.27,
          "25%": 1.07,
          "75%": 1.19
        },
        "51600": {
          "name": "Fairfax",
          "median": 1.12,
          "10%": 1.02,
          "90%": 1.27,
          "25%": 1.06,
          "75%": 1.2
        },
        "51610": {
          "name": "Falls Church",
          "median": 1.13,
          "10%": 1.02,
          "90%": 1.27,
          "25%": 1.07,
          "75%": 1.19
        },
        "51061": {
          "name": "Fauquier",
          "median": 1.19,
          "10%": 1.08,
          "90%": 1.36,
          "25%": 1.14,
          "75%": 1.28
        },
        "42051": {
          "name": "Fayette",
          "median": 1.16,
          "10%": 1.06,
          "90%": 1.29,
          "25%": 1.11,
          "75%": 1.22
        },
        "54019": {
          "name": "Fayette",
          "median": 1.13,
          "10%": 1.07,
          "90%": 1.27,
          "25%": 1.1,
          "75%": 1.21
        },
        "51063": {
          "name": "Floyd",
          "median": 1.18,
          "10%": 1.04,
          "90%": 1.34,
          "25%": 1.12,
          "75%": 1.25
        },
        "51065": {
          "name": "Fluvanna",
          "median": 1.18,
          "10%": 1.06,
          "90%": 1.47,
          "25%": 1.12,
          "75%": 1.28
        },
        "42053": {
          "name": "Forest",
          "median": 1.2,
          "10%": 1.0,
          "90%": 1.35,
          "25%": 1.09,
          "75%": 1.27
        },
        "42055": {
          "name": "Franklin",
          "median": 1.18,
          "10%": 1.1,
          "90%": 1.33,
          "25%": 1.14,
          "75%": 1.25
        },
        "51067": {
          "name": "Franklin",
          "median": 1.19,
          "10%": 1.04,
          "90%": 1.39,
          "25%": 1.11,
          "75%": 1.31
        },
        "51620": {
          "name": "Franklin",
          "median": 1.16,
          "10%": 1.07,
          "90%": 1.36,
          "25%": 1.1,
          "75%": 1.28
        },
        "24021": {
          "name": "Frederick",
          "median": 1.2,
          "10%": 1.08,
          "90%": 1.33,
          "25%": 1.12,
          "75%": 1.28
        },
        "51069": {
          "name": "Frederick",
          "median": 1.23,
          "10%": 1.12,
          "90%": 1.39,
          "25%": 1.15,
          "75%": 1.28
        },
        "51630": {
          "name": "Fredericksburg",
          "median": 1.16,
          "10%": 1.04,
          "90%": 1.33,
          "25%": 1.1,
          "75%": 1.26
        },
        "42057": {
          "name": "Fulton",
          "median": 1.23,
          "10%": 1.12,
          "90%": 1.37,
          "25%": 1.16,
          "75%": 1.3
        },
        "51640": {
          "name": "Galax",
          "median": 1.17,
          "10%": 1.0,
          "90%": 1.32,
          "25%": 1.09,
          "75%": 1.26
        },
        "24023": {
          "name": "Garrett",
          "median": 1.15,
          "10%": 1.08,
          "90%": 1.3,
          "25%": 1.11,
          "75%": 1.21
        },
        "51071": {
          "name": "Giles",
          "median": 1.19,
          "10%": 1.1,
          "90%": 1.31,
          "25%": 1.13,
          "75%": 1.25
        },
        "54021": {
          "name": "Gilmer",
          "median": 1.19,
          "10%": 1.09,
          "90%": 1.31,
          "25%": 1.13,
          "75%": 1.25
        },
        "34015": {
          "name": "Gloucester",
          "median": 1.17,
          "10%": 1.05,
          "90%": 1.32,
          "25%": 1.13,
          "75%": 1.25
        },
        "51073": {
          "name": "Gloucester",
          "median": 1.17,
          "10%": 1.02,
          "90%": 1.26,
          "25%": 1.12,
          "75%": 1.21
        },
        "51075": {
          "name": "Goochland",
          "median": 1.18,
          "10%": 1.02,
          "90%": 1.43,
          "25%": 1.07,
          "75%": 1.25
        },
        "54023": {
          "name": "Grant",
          "median": 1.16,
          "10%": 1.05,
          "90%": 1.3,
          "25%": 1.1,
          "75%": 1.23
        },
        "51077": {
          "name": "Grayson",
          "median": 1.16,
          "10%": 1.08,
          "90%": 1.33,
          "25%": 1.12,
          "75%": 1.24
        },
        "54025": {
          "name": "Greenbrier",
          "median": 1.18,
          "10%": 1.09,
          "90%": 1.29,
          "25%": 1.12,
          "75%": 1.24
        },
        "36039": {
          "name": "Greene",
          "median": 1.24,
          "10%": 1.11,
          "90%": 1.41,
          "25%": 1.17,
          "75%": 1.34
        },
        "42059": {
          "name": "Greene",
          "median": 1.21,
          "10%": 1.1,
          "90%": 1.31,
          "25%": 1.16,
          "75%": 1.27
        },
        "51079": {
          "name": "Greene",
          "median": 1.19,
          "10%": 1.1,
          "90%": 1.36,
          "25%": 1.14,
          "75%": 1.28
        },
        "51081": {
          "name": "Greensville",
          "median": 1.13,
          "10%": 1.01,
          "90%": 1.25,
          "25%": 1.08,
          "75%": 1.18
        },
        "51083": {
          "name": "Halifax",
          "median": 1.21,
          "10%": 1.08,
          "90%": 1.34,
          "25%": 1.14,
          "75%": 1.27
        },
        "54027": {
          "name": "Hampshire",
          "median": 1.2,
          "10%": 1.12,
          "90%": 1.34,
          "25%": 1.16,
          "75%": 1.29
        },
        "51650": {
          "name": "Hampton",
          "median": 1.17,
          "10%": 1.06,
          "90%": 1.26,
          "25%": 1.09,
          "75%": 1.23
        },
        "54029": {
          "name": "Hancock",
          "median": 1.2,
          "10%": 1.07,
          "90%": 1.31,
          "25%": 1.12,
          "75%": 1.25
        },
        "51085": {
          "name": "Hanover",
          "median": 1.17,
          "10%": 1.04,
          "90%": 1.32,
          "25%": 1.12,
          "75%": 1.24
        },
        "54031": {
          "name": "Hardy",
          "median": 1.2,
          "10%": 1.09,
          "90%": 1.34,
          "25%": 1.15,
          "75%": 1.25
        },
        "24025": {
          "name": "Harford",
          "median": 1.16,
          "10%": 1.06,
          "90%": 1.28,
          "25%": 1.11,
          "75%": 1.25
        },
        "54033": {
          "name": "Harrison",
          "median": 1.16,
          "10%": 1.07,
          "90%": 1.27,
          "25%": 1.1,
          "75%": 1.21
        },
        "51660": {
          "name": "Harrisonburg",
          "median": 1.16,
          "10%": 1.03,
          "90%": 1.35,
          "25%": 1.11,
          "75%": 1.27
        },
        "51087": {
          "name": "Henrico",
          "median": 1.17,
          "10%": 1.06,
          "90%": 1.31,
          "25%": 1.11,
          "75%": 1.25
        },
        "51089": {
          "name": "Henry",
          "median": 1.2,
          "10%": 1.03,
          "90%": 1.4,
          "25%": 1.12,
          "75%": 1.31
        },
        "36043": {
          "name": "Herkimer",
          "median": 1.13,
          "10%": 1.03,
          "90%": 1.25,
          "25%": 1.08,
          "75%": 1.2
        },
        "51091": {
          "name": "Highland",
          "median": 1.19,
          "10%": 1.08,
          "90%": 1.3,
          "25%": 1.12,
          "75%": 1.24
        },
        "51670": {
          "name": "Hopewell",
          "median": 1.15,
          "10%": 1.01,
          "90%": 1.3,
          "25%": 1.08,
          "75%": 1.2
        },
        "24027": {
          "name": "Howard",
          "median": 1.16,
          "10%": 1.04,
          "90%": 1.31,
          "25%": 1.09,
          "75%": 1.21
        },
        "34019": {
          "name": "Hunterdon",
          "median": 1.18,
          "10%": 1.06,
          "90%": 1.33,
          "25%": 1.13,
          "75%": 1.24
        },
        "42061": {
          "name": "Huntingdon",
          "median": 1.21,
          "10%": 1.13,
          "90%": 1.32,
          "25%": 1.17,
          "75%": 1.28
        },
        "42063": {
          "name": "Indiana",
          "median": 1.15,
          "10%": 1.05,
          "90%": 1.28,
          "25%": 1.12,
          "75%": 1.21
        },
        "51093": {
          "name": "Isle of Wight",
          "median": 1.18,
          "10%": 1.07,
          "90%": 1.35,
          "25%": 1.11,
          "75%": 1.25
        },
        "54035": {
          "name": "Jackson",
          "median": 1.19,
          "10%": 1.08,
          "90%": 1.3,
          "25%": 1.12,
          "75%": 1.24
        },
        "51095": {
          "name": "James City",
          "median": 1.15,
          "10%": 1.01,
          "90%": 1.23,
          "25%": 1.09,
          "75%": 1.2
        },
        "42065": {
          "name": "Jefferson",
          "median": 1.2,
          "10%": 1.06,
          "90%": 1.3,
          "25%": 1.13,
          "75%": 1.24
        },
        "54037": {
          "name": "Jefferson",
          "median": 1.2,
          "10%": 1.07,
          "90%": 1.34,
          "25%": 1.13,
          "75%": 1.27
        },
        "42067": {
          "name": "Juniata",
          "median": 1.2,
          "10%": 1.11,
          "90%": 1.3,
          "25%": 1.16,
          "75%": 1.26
        },
        "54039": {
          "name": "Kanawha",
          "median": 1.11,
          "10%": 1.01,
          "90%": 1.23,
          "25%": 1.08,
          "75%": 1.16
        },
        "10001": {
          "name": "Kent",
          "median": 1.16,
          "10%": 1.06,
          "90%": 1.3,
          "25%": 1.11,
          "75%": 1.23
        },
        "24029": {
          "name": "Kent",
          "median": 1.18,
          "10%": 1.03,
          "90%": 1.28,
          "25%": 1.09,
          "75%": 1.25
        },
        "51099": {
          "name": "King George",
          "median": 1.18,
          "10%": 1.0,
          "90%": 1.33,
          "25%": 1.08,
          "75%": 1.26
        },
        "51101": {
          "name": "King William",
          "median": 1.14,
          "10%": 1.05,
          "90%": 1.28,
          "25%": 1.08,
          "75%": 1.21
        },
        "51097": {
          "name": "King and Queen",
          "median": 1.14,
          "10%": 1.02,
          "90%": 1.27,
          "25%": 1.08,
          "75%": 1.22
        },
        "42069": {
          "name": "Lackawanna",
          "median": 1.2,
          "10%": 1.1,
          "90%": 1.34,
          "25%": 1.15,
          "75%": 1.28
        },
        "42071": {
          "name": "Lancaster",
          "median": 1.19,
          "10%": 1.05,
          "90%": 1.33,
          "25%": 1.12,
          "75%": 1.26
        },
        "51103": {
          "name": "Lancaster",
          "median": 1.15,
          "10%": 1.03,
          "90%": 1.28,
          "25%": 1.08,
          "75%": 1.23
        },
        "42073": {
          "name": "Lawrence",
          "median": 1.17,
          "10%": 1.04,
          "90%": 1.28,
          "25%": 1.09,
          "75%": 1.23
        },
        "42075": {
          "name": "Lebanon",
          "median": 1.16,
          "10%": 1.05,
          "90%": 1.28,
          "25%": 1.1,
          "75%": 1.23
        },
        "51105": {
          "name": "Lee",
          "median": 1.21,
          "10%": 1.13,
          "90%": 1.35,
          "25%": 1.16,
          "75%": 1.28
        },
        "42077": {
          "name": "Lehigh",
          "median": 1.2,
          "10%": 1.08,
          "90%": 1.33,
          "25%": 1.13,
          "75%": 1.27
        },
        "54041": {
          "name": "Lewis",
          "median": 1.16,
          "10%": 1.07,
          "90%": 1.26,
          "25%": 1.1,
          "75%": 1.2
        },
        "51678": {
          "name": "Lexington",
          "median": 1.15,
          "10%": 1.069,
          "90%": 1.32,
          "25%": 1.1,
          "75%": 1.24
        },
        "54043": {
          "name": "Lincoln",
          "median": 1.16,
          "10%": 1.06,
          "90%": 1.3,
          "25%": 1.09,
          "75%": 1.23
        },
        "36051": {
          "name": "Livingston",
          "median": 1.18,
          "10%": 1.06,
          "90%": 1.32,
          "25%": 1.12,
          "75%": 1.26
        },
        "54045": {
          "name": "Logan",
          "median": 1.17,
          "10%": 1.08,
          "90%": 1.29,
          "25%": 1.13,
          "75%": 1.24
        },
        "51107": {
          "name": "Loudoun",
          "median": 1.18,
          "10%": 1.09,
          "90%": 1.32,
          "25%": 1.12,
          "75%": 1.27
        },
        "51109": {
          "name": "Louisa",
          "median": 1.19,
          "10%": 1.08,
          "90%": 1.39,
          "25%": 1.12,
          "75%": 1.26
        },
        "51111": {
          "name": "Lunenburg",
          "median": 1.2,
          "10%": 1.07,
          "90%": 1.33,
          "25%": 1.11,
          "75%": 1.27
        },
        "42079": {
          "name": "Luzerne",
          "median": 1.2,
          "10%": 1.11,
          "90%": 1.28,
          "25%": 1.14,
          "75%": 1.25
        },
        "42081": {
          "name": "Lycoming",
          "median": 1.19,
          "10%": 1.09,
          "90%": 1.27,
          "25%": 1.14,
          "75%": 1.24
        },
        "51680": {
          "name": "Lynchburg",
          "median": 1.17,
          "10%": 1.07,
          "90%": 1.29,
          "25%": 1.13,
          "75%": 1.25
        },
        "36053": {
          "name": "Madison",
          "median": 1.16,
          "10%": 1.05,
          "90%": 1.29,
          "25%": 1.11,
          "75%": 1.24
        },
        "51113": {
          "name": "Madison",
          "median": 1.19,
          "10%": 1.09,
          "90%": 1.32,
          "25%": 1.13,
          "75%": 1.25
        },
        "51683": {
          "name": "Manassas",
          "median": 1.12,
          "10%": 1.0,
          "90%": 1.27,
          "25%": 1.05,
          "75%": 1.2
        },
        "51685": {
          "name": "Manassas Park",
          "median": 1.12,
          "10%": 0.99,
          "90%": 1.28,
          "25%": 1.04,
          "75%": 1.2
        },
        "54049": {
          "name": "Marion",
          "median": 1.14,
          "10%": 1.06,
          "90%": 1.24,
          "25%": 1.09,
          "75%": 1.2
        },
        "54051": {
          "name": "Marshall",
          "median": 1.19,
          "10%": 1.08,
          "90%": 1.3,
          "25%": 1.13,
          "75%": 1.25
        },
        "51690": {
          "name": "Martinsville",
          "median": 1.2,
          "10%": 1.02,
          "90%": 1.45,
          "25%": 1.1,
          "75%": 1.32
        },
        "54053": {
          "name": "Mason",
          "median": 1.22,
          "10%": 1.08,
          "90%": 1.3,
          "25%": 1.13,
          "75%": 1.26
        },
        "51115": {
          "name": "Mathews",
          "median": 1.18,
          "10%": 1.03,
          "90%": 1.29,
          "25%": 1.1,
          "75%": 1.24
        },
        "54047": {
          "name": "McDowell",
          "median": 1.17,
          "10%": 1.09,
          "90%": 1.29,
          "25%": 1.12,
          "75%": 1.23
        },
        "42083": {
          "name": "McKean",
          "median": 1.2,
          "10%": 1.03,
          "90%": 1.3,
          "25%": 1.13,
          "75%": 1.23
        },
        "51117": {
          "name": "Mecklenburg",
          "median": 1.18,
          "10%": 1.07,
          "90%": 1.31,
          "25%": 1.13,
          "75%": 1.24
        },
        "34021": {
          "name": "Mercer",
          "median": 1.13,
          "10%": 1.03,
          "90%": 1.25,
          "25%": 1.08,
          "75%": 1.2
        },
        "42085": {
          "name": "Mercer",
          "median": 1.19,
          "10%": 1.03,
          "90%": 1.31,
          "25%": 1.1,
          "75%": 1.28
        },
        "54055": {
          "name": "Mercer",
          "median": 1.15,
          "10%": 1.07,
          "90%": 1.3,
          "25%": 1.11,
          "75%": 1.22
        },
        "51119": {
          "name": "Middlesex",
          "median": 1.15,
          "10%": 1.03,
          "90%": 1.27,
          "25%": 1.09,
          "75%": 1.22
        },
        "42087": {
          "name": "Mifflin",
          "median": 1.23,
          "10%": 1.12,
          "90%": 1.33,
          "25%": 1.16,
          "75%": 1.29
        },
        "54057": {
          "name": "Mineral",
          "median": 1.19,
          "10%": 1.1,
          "90%": 1.31,
          "25%": 1.13,
          "75%": 1.26
        },
        "54059": {
          "name": "Mingo",
          "median": 1.2,
          "10%": 1.1,
          "90%": 1.31,
          "25%": 1.13,
          "75%": 1.25
        },
        "34025": {
          "name": "Monmouth",
          "median": 1.16,
          "10%": 1.06,
          "90%": 1.27,
          "25%": 1.11,
          "75%": 1.2
        },
        "54061": {
          "name": "Monongalia",
          "median": 1.14,
          "10%": 1.06,
          "90%": 1.25,
          "25%": 1.11,
          "75%": 1.21
        },
        "42089": {
          "name": "Monroe",
          "median": 1.21,
          "10%": 1.11,
          "90%": 1.35,
          "25%": 1.15,
          "75%": 1.3
        },
        "54063": {
          "name": "Monroe",
          "median": 1.16,
          "10%": 1.07,
          "90%": 1.3,
          "25%": 1.11,
          "75%": 1.21
        },
        "24031": {
          "name": "Montgomery",
          "median": 1.15,
          "10%": 1.06,
          "90%": 1.31,
          "25%": 1.09,
          "75%": 1.2
        },
        "36057": {
          "name": "Montgomery",
          "median": 1.17,
          "10%": 1.07,
          "90%": 1.32,
          "25%": 1.13,
          "75%": 1.27
        },
        "42091": {
          "name": "Montgomery",
          "median": 1.17,
          "10%": 1.08,
          "90%": 1.32,
          "25%": 1.13,
          "75%": 1.23
        },
        "51121": {
          "name": "Montgomery",
          "median": 1.2,
          "10%": 1.1,
          "90%": 1.38,
          "25%": 1.15,
          "75%": 1.28
        },
        "42093": {
          "name": "Montour",
          "median": 1.23,
          "10%": 1.1,
          "90%": 1.34,
          "25%": 1.16,
          "75%": 1.29
        },
        "54065": {
          "name": "Morgan",
          "median": 1.24,
          "10%": 1.1,
          "90%": 1.36,
          "25%": 1.17,
          "75%": 1.31
        },
        "34027": {
          "name": "Morris",
          "median": 1.21,
          "10%": 1.09,
          "90%": 1.4,
          "25%": 1.14,
          "75%": 1.32
        },
        "36059": {
          "name": "Nassau",
          "median": 1.2,
          "10%": 1.07,
          "90%": 1.3,
          "25%": 1.13,
          "75%": 1.25
        },
        "51125": {
          "name": "Nelson",
          "median": 1.2,
          "10%": 1.05,
          "90%": 1.42,
          "25%": 1.13,
          "75%": 1.33
        },
        "10003": {
          "name": "New Castle",
          "median": 1.19,
          "10%": 1.08,
          "90%": 1.38,
          "25%": 1.13,
          "75%": 1.29
        },
        "51127": {
          "name": "New Kent",
          "median": 1.16,
          "10%": 1.06,
          "90%": 1.26,
          "25%": 1.1,
          "75%": 1.22
        },
        "36061": {
          "name": "New York",
          "median": 1.18,
          "10%": 1.07,
          "90%": 1.29,
          "25%": 1.13,
          "75%": 1.25
        },
        "51700": {
          "name": "Newport News",
          "median": 1.16,
          "10%": 1.06,
          "90%": 1.28,
          "25%": 1.11,
          "75%": 1.22
        },
        "54067": {
          "name": "Nicholas",
          "median": 1.15,
          "10%": 1.05,
          "90%": 1.25,
          "25%": 1.08,
          "75%": 1.21
        },
        "51710": {
          "name": "Norfolk",
          "median": 1.18,
          "10%": 1.02,
          "90%": 1.38,
          "25%": 1.09,
          "75%": 1.3
        },
        "42095": {
          "name": "Northampton",
          "median": 1.17,
          "10%": 1.08,
          "90%": 1.3,
          "25%": 1.12,
          "75%": 1.25
        },
        "51131": {
          "name": "Northampton",
          "median": 1.17,
          "10%": 1.04,
          "90%": 1.3,
          "25%": 1.08,
          "75%": 1.25
        },
        "42097": {
          "name": "Northumberland",
          "median": 1.23,
          "10%": 1.11,
          "90%": 1.33,
          "25%": 1.17,
          "75%": 1.28
        },
        "51133": {
          "name": "Northumberland",
          "median": 1.15,
          "10%": 1.0,
          "90%": 1.32,
          "25%": 1.08,
          "75%": 1.26
        },
        "51720": {
          "name": "Norton",
          "median": 1.18,
          "10%": 1.06,
          "90%": 1.32,
          "25%": 1.13,
          "75%": 1.28
        },
        "51135": {
          "name": "Nottoway",
          "median": 1.17,
          "10%": 1.04,
          "90%": 1.3,
          "25%": 1.11,
          "75%": 1.26
        },
        "34029": {
          "name": "Ocean",
          "median": 1.14,
          "10%": 1.07,
          "90%": 1.28,
          "25%": 1.11,
          "75%": 1.21
        },
        "54069": {
          "name": "Ohio",
          "median": 1.2,
          "10%": 1.08,
          "90%": 1.36,
          "25%": 1.13,
          "75%": 1.28
        },
        "36065": {
          "name": "Oneida",
          "median": 1.18,
          "10%": 1.05,
          "90%": 1.29,
          "25%": 1.12,
          "75%": 1.23
        },
        "36067": {
          "name": "Onondaga",
          "median": 1.19,
          "10%": 1.08,
          "90%": 1.34,
          "25%": 1.14,
          "75%": 1.27
        },
        "36069": {
          "name": "Ontario",
          "median": 1.16,
          "10%": 1.05,
          "90%": 1.26,
          "25%": 1.1,
          "75%": 1.24
        },
        "36071": {
          "name": "Orange",
          "median": 1.21,
          "10%": 1.11,
          "90%": 1.35,
          "25%": 1.14,
          "75%": 1.27
        },
        "51137": {
          "name": "Orange",
          "median": 1.21,
          "10%": 1.08,
          "90%": 1.35,
          "25%": 1.16,
          "75%": 1.27
        },
        "36077": {
          "name": "Otsego",
          "median": 1.16,
          "10%": 1.06,
          "90%": 1.3,
          "25%": 1.1,
          "75%": 1.25
        },
        "51139": {
          "name": "Page",
          "median": 1.21,
          "10%": 1.08,
          "90%": 1.36,
          "25%": 1.14,
          "75%": 1.27
        },
        "51141": {
          "name": "Patrick",
          "median": 1.18,
          "10%": 1.02,
          "90%": 1.33,
          "25%": 1.1,
          "75%": 1.25
        },
        "54071": {
          "name": "Pendleton",
          "median": 1.21,
          "10%": 1.08,
          "90%": 1.37,
          "25%": 1.14,
          "75%": 1.27
        },
        "42099": {
          "name": "Perry",
          "median": 1.22,
          "10%": 1.12,
          "90%": 1.36,
          "25%": 1.15,
          "75%": 1.29
        },
        "51730": {
          "name": "Petersburg",
          "median": 1.17,
          "10%": 1.06,
          "90%": 1.33,
          "25%": 1.09,
          "75%": 1.23
        },
        "42101": {
          "name": "Philadelphia",
          "median": 1.17,
          "10%": 1.059,
          "90%": 1.28,
          "25%": 1.12,
          "75%": 1.22
        },
        "42103": {
          "name": "Pike",
          "median": 1.19,
          "10%": 1.05,
          "90%": 1.321,
          "25%": 1.13,
          "75%": 1.27
        },
        "51143": {
          "name": "Pittsylvania",
          "median": 1.22,
          "10%": 1.079,
          "90%": 1.36,
          "25%": 1.16,
          "75%": 1.31
        },
        "54073": {
          "name": "Pleasants",
          "median": 1.17,
          "10%": 1.04,
          "90%": 1.29,
          "25%": 1.1,
          "75%": 1.24
        },
        "54075": {
          "name": "Pocahontas",
          "median": 1.17,
          "10%": 1.07,
          "90%": 1.28,
          "25%": 1.11,
          "75%": 1.24
        },
        "51735": {
          "name": "Poquoson",
          "median": 1.15,
          "10%": 1.06,
          "90%": 1.27,
          "25%": 1.09,
          "75%": 1.23
        },
        "51740": {
          "name": "Portsmouth",
          "median": 1.17,
          "10%": 1.03,
          "90%": 1.36,
          "25%": 1.08,
          "75%": 1.28
        },
        "42105": {
          "name": "Potter",
          "median": 1.2,
          "10%": 1.08,
          "90%": 1.32,
          "25%": 1.13,
          "75%": 1.26
        },
        "51145": {
          "name": "Powhatan",
          "median": 1.17,
          "10%": 0.98,
          "90%": 1.37,
          "25%": 1.07,
          "75%": 1.23
        },
        "54077": {
          "name": "Preston",
          "median": 1.16,
          "10%": 1.07,
          "90%": 1.28,
          "25%": 1.11,
          "75%": 1.22
        },
        "51147": {
          "name": "Prince Edward",
          "median": 1.18,
          "10%": 1.07,
          "90%": 1.34,
          "25%": 1.12,
          "75%": 1.28
        },
        "51149": {
          "name": "Prince George",
          "median": 1.16,
          "10%": 1.05,
          "90%": 1.28,
          "25%": 1.1,
          "75%": 1.23
        },
        "24033": {
          "name": "Prince George's",
          "median": 1.15,
          "10%": 1.04,
          "90%": 1.29,
          "25%": 1.08,
          "75%": 1.21
        },
        "51153": {
          "name": "Prince William",
          "median": 1.16,
          "10%": 1.04,
          "90%": 1.28,
          "25%": 1.09,
          "75%": 1.22
        },
        "51155": {
          "name": "Pulaski",
          "median": 1.19,
          "10%": 1.1,
          "90%": 1.31,
          "25%": 1.14,
          "75%": 1.27
        },
        "54079": {
          "name": "Putnam",
          "median": 1.16,
          "10%": 1.06,
          "90%": 1.28,
          "25%": 1.09,
          "75%": 1.23
        },
        "24035": {
          "name": "Queen Anne's",
          "median": 1.18,
          "10%": 1.06,
          "90%": 1.3,
          "25%": 1.11,
          "75%": 1.25
        },
        "51750": {
          "name": "Radford",
          "median": 1.21,
          "10%": 1.1,
          "90%": 1.38,
          "25%": 1.16,
          "75%": 1.3
        },
        "54081": {
          "name": "Raleigh",
          "median": 1.18,
          "10%": 1.08,
          "90%": 1.3,
          "25%": 1.11,
          "75%": 1.22
        },
        "54083": {
          "name": "Randolph",
          "median": 1.15,
          "10%": 1.09,
          "90%": 1.26,
          "25%": 1.11,
          "75%": 1.22
        },
        "51157": {
          "name": "Rappahannock",
          "median": 1.19,
          "10%": 1.07,
          "90%": 1.35,
          "25%": 1.16,
          "75%": 1.27
        },
        "36085": {
          "name": "Richmond",
          "median": 1.16,
          "10%": 1.06,
          "90%": 1.3,
          "25%": 1.1,
          "75%": 1.25
        },
        "51159": {
          "name": "Richmond",
          "median": 1.15,
          "10%": 0.99,
          "90%": 1.39,
          "25%": 1.05,
          "75%": 1.27
        },
        "51760": {
          "name": "Richmond",
          "median": 1.18,
          "10%": 1.04,
          "90%": 1.32,
          "25%": 1.11,
          "75%": 1.26
        },
        "54085": {
          "name": "Ritchie",
          "median": 1.18,
          "10%": 1.09,
          "90%": 1.31,
          "25%": 1.13,
          "75%": 1.25
        },
        "54087": {
          "name": "Roane",
          "median": 1.19,
          "10%": 1.05,
          "90%": 1.28,
          "25%": 1.11,
          "75%": 1.23
        },
        "51161": {
          "name": "Roanoke",
          "median": 1.22,
          "10%": 1.09,
          "90%": 1.41,
          "25%": 1.14,
          "75%": 1.35
        },
        "51770": {
          "name": "Roanoke",
          "median": 1.21,
          "10%": 1.05,
          "90%": 1.44,
          "25%": 1.12,
          "75%": 1.32
        },
        "51163": {
          "name": "Rockbridge",
          "median": 1.21,
          "10%": 1.07,
          "90%": 1.41,
          "25%": 1.13,
          "75%": 1.33
        },
        "51165": {
          "name": "Rockingham",
          "median": 1.2,
          "10%": 1.09,
          "90%": 1.34,
          "25%": 1.13,
          "75%": 1.27
        },
        "51167": {
          "name": "Russell",
          "median": 1.14,
          "10%": 1.05,
          "90%": 1.27,
          "25%": 1.1,
          "75%": 1.22
        },
        "34033": {
          "name": "Salem",
          "median": 1.19,
          "10%": 1.07,
          "90%": 1.37,
          "25%": 1.12,
          "75%": 1.3
        },
        "51775": {
          "name": "Salem",
          "median": 1.23,
          "10%": 1.07,
          "90%": 1.45,
          "25%": 1.12,
          "75%": 1.37
        },
        "36095": {
          "name": "Schoharie",
          "median": 1.21,
          "10%": 1.09,
          "90%": 1.36,
          "25%": 1.15,
          "75%": 1.3
        },
        "36097": {
          "name": "Schuyler",
          "median": 1.21,
          "10%": 1.08,
          "90%": 1.34,
          "25%": 1.14,
          "75%": 1.26
        },
        "42107": {
          "name": "Schuylkill",
          "median": 1.2,
          "10%": 1.09,
          "90%": 1.33,
          "25%": 1.1375,
          "75%": 1.26
        },
        "51169": {
          "name": "Scott",
          "median": 1.2,
          "10%": 1.1,
          "90%": 1.32,
          "25%": 1.15,
          "75%": 1.26
        },
        "51171": {
          "name": "Shenandoah",
          "median": 1.21,
          "10%": 1.09,
          "90%": 1.34,
          "25%": 1.17,
          "75%": 1.26
        },
        "51173": {
          "name": "Smyth",
          "median": 1.16,
          "10%": 1.08,
          "90%": 1.28,
          "25%": 1.11,
          "75%": 1.22
        },
        "42109": {
          "name": "Snyder",
          "median": 1.21,
          "10%": 1.11,
          "90%": 1.29,
          "25%": 1.15,
          "75%": 1.26
        },
        "24039": {
          "name": "Somerset",
          "median": 1.17,
          "10%": 1.05,
          "90%": 1.33,
          "25%": 1.11,
          "75%": 1.23
        },
        "42111": {
          "name": "Somerset",
          "median": 1.16,
          "10%": 1.1,
          "90%": 1.27,
          "25%": 1.11,
          "75%": 1.21
        },
        "51175": {
          "name": "Southampton",
          "median": 1.16,
          "10%": 1.03,
          "90%": 1.34,
          "25%": 1.08,
          "75%": 1.23
        },
        "51177": {
          "name": "Spotsylvania",
          "median": 1.17,
          "10%": 1.05,
          "90%": 1.3,
          "25%": 1.11,
          "75%": 1.26
        },
        "24037": {
          "name": "St. Mary's",
          "median": 1.18,
          "10%": 1.04,
          "90%": 1.3,
          "25%": 1.08,
          "75%": 1.25
        },
        "51179": {
          "name": "Stafford",
          "median": 1.16,
          "10%": 1.04,
          "90%": 1.34,
          "25%": 1.11,
          "75%": 1.29
        },
        "51790": {
          "name": "Staunton",
          "median": 1.22,
          "10%": 1.04,
          "90%": 1.41,
          "25%": 1.15,
          "75%": 1.32
        },
        "36101": {
          "name": "Steuben",
          "median": 1.2,
          "10%": 1.08,
          "90%": 1.3,
          "25%": 1.14,
          "75%": 1.24
        },
        "51800": {
          "name": "Suffolk",
          "median": 1.16,
          "10%": 1.07,
          "90%": 1.35,
          "25%": 1.11,
          "75%": 1.27
        },
        "36105": {
          "name": "Sullivan",
          "median": 1.21,
          "10%": 1.1,
          "90%": 1.33,
          "25%": 1.14,
          "75%": 1.27
        },
        "42113": {
          "name": "Sullivan",
          "median": 1.16,
          "10%": 1.07,
          "90%": 1.28,
          "25%": 1.13,
          "75%": 1.22
        },
        "54089": {
          "name": "Summers",
          "median": 1.15,
          "10%": 1.08,
          "90%": 1.31,
          "25%": 1.1,
          "75%": 1.2
        },
        "51181": {
          "name": "Surry",
          "median": 1.16,
          "10%": 1.04,
          "90%": 1.27,
          "25%": 1.12,
          "75%": 1.21
        },
        "42115": {
          "name": "Susquehanna",
          "median": 1.17,
          "10%": 1.06,
          "90%": 1.25,
          "25%": 1.12,
          "75%": 1.2
        },
        "10005": {
          "name": "Sussex",
          "median": 1.16,
          "10%": 1.06,
          "90%": 1.28,
          "25%": 1.1,
          "75%": 1.23
        },
        "34037": {
          "name": "Sussex",
          "median": 1.21,
          "10%": 1.08,
          "90%": 1.36,
          "25%": 1.12,
          "75%": 1.28
        },
        "51183": {
          "name": "Sussex",
          "median": 1.18,
          "10%": 1.04,
          "90%": 1.28,
          "25%": 1.11,
          "75%": 1.22
        },
        "24041": {
          "name": "Talbot",
          "median": 1.16,
          "10%": 1.01,
          "90%": 1.26,
          "25%": 1.07,
          "75%": 1.22
        },
        "54091": {
          "name": "Taylor",
          "median": 1.16,
          "10%": 1.08,
          "90%": 1.29,
          "25%": 1.12,
          "75%": 1.23
        },
        "51185": {
          "name": "Tazewell",
          "median": 1.15,
          "10%": 1.07,
          "90%": 1.24,
          "25%": 1.1,
          "75%": 1.21
        },
        "36107": {
          "name": "Tioga",
          "median": 1.14,
          "10%": 1.05,
          "90%": 1.23,
          "25%": 1.08,
          "75%": 1.18
        },
        "42117": {
          "name": "Tioga",
          "median": 1.18,
          "10%": 1.09,
          "90%": 1.29,
          "25%": 1.13,
          "75%": 1.23
        },
        "36109": {
          "name": "Tompkins",
          "median": 1.17,
          "10%": 1.08,
          "90%": 1.29,
          "25%": 1.13,
          "75%": 1.21
        },
        "54093": {
          "name": "Tucker",
          "median": 1.15,
          "10%": 1.08,
          "90%": 1.29,
          "25%": 1.11,
          "75%": 1.2
        },
        "54095": {
          "name": "Tyler",
          "median": 1.13,
          "10%": 1.02,
          "90%": 1.26,
          "25%": 1.07,
          "75%": 1.18
        },
        "36111": {
          "name": "Ulster",
          "median": 1.23,
          "10%": 1.11,
          "90%": 1.38,
          "25%": 1.17,
          "75%": 1.32
        },
        "42119": {
          "name": "Union",
          "median": 1.19,
          "10%": 1.11,
          "90%": 1.28,
          "25%": 1.14,
          "75%": 1.24
        },
        "54097": {
          "name": "Upshur",
          "median": 1.15,
          "10%": 1.06,
          "90%": 1.25,
          "25%": 1.09,
          "75%": 1.21
        },
        "42121": {
          "name": "Venango",
          "median": 1.19,
          "10%": 1.05,
          "90%": 1.35,
          "25%": 1.14,
          "75%": 1.26
        },
        "51810": {
          "name": "Virginia Beach",
          "median": 1.19,
          "10%": 1.03,
          "90%": 1.401,
          "25%": 1.09,
          "75%": 1.3
        },
        "34041": {
          "name": "Warren",
          "median": 1.2,
          "10%": 1.09,
          "90%": 1.36,
          "25%": 1.13,
          "75%": 1.27
        },
        "42123": {
          "name": "Warren",
          "median": 1.18,
          "10%": 1.01,
          "90%": 1.33,
          "25%": 1.09,
          "75%": 1.27
        },
        "51187": {
          "name": "Warren",
          "median": 1.24,
          "10%": 1.08,
          "90%": 1.38,
          "25%": 1.17,
          "75%": 1.3
        },
        "24043": {
          "name": "Washington",
          "median": 1.2,
          "10%": 1.08,
          "90%": 1.33,
          "25%": 1.15,
          "75%": 1.26
        },
        "42125": {
          "name": "Washington",
          "median": 1.18,
          "10%": 1.07,
          "90%": 1.32,
          "25%": 1.12,
          "75%": 1.27
        },
        "51191": {
          "name": "Washington",
          "median": 1.14,
          "10%": 1.06,
          "90%": 1.29,
          "25%": 1.1,
          "75%": 1.19
        },
        "42127": {
          "name": "Wayne",
          "median": 1.2,
          "10%": 1.06,
          "90%": 1.29,
          "25%": 1.14,
          "75%": 1.24
        },
        "54099": {
          "name": "Wayne",
          "median": 1.15,
          "10%": 1.06,
          "90%": 1.29,
          "25%": 1.12,
          "75%": 1.23
        },
        "51820": {
          "name": "Waynesboro",
          "median": 1.21,
          "10%": 1.07,
          "90%": 1.41,
          "25%": 1.15,
          "75%": 1.34
        },
        "54101": {
          "name": "Webster",
          "median": 1.14,
          "10%": 1.03,
          "90%": 1.24,
          "25%": 1.08,
          "75%": 1.19
        },
        "36119": {
          "name": "Westchester",
          "median": 1.2,
          "10%": 1.07,
          "90%": 1.29,
          "25%": 1.15,
          "75%": 1.25
        },
        "42129": {
          "name": "Westmoreland",
          "median": 1.17,
          "10%": 1.06,
          "90%": 1.28,
          "25%": 1.11,
          "75%": 1.21
        },
        "51193": {
          "name": "Westmoreland",
          "median": 1.16,
          "10%": 1.02,
          "90%": 1.35,
          "25%": 1.06,
          "75%": 1.25
        },
        "54103": {
          "name": "Wetzel",
          "median": 1.17,
          "10%": 1.09,
          "90%": 1.3,
          "25%": 1.12,
          "75%": 1.22
        },
        "24045": {
          "name": "Wicomico",
          "median": 1.15,
          "10%": 1.04,
          "90%": 1.31,
          "25%": 1.11,
          "75%": 1.22
        },
        "51830": {
          "name": "Williamsburg",
          "median": 1.13,
          "10%": 0.99,
          "90%": 1.22,
          "25%": 1.08,
          "75%": 1.18
        },
        "51840": {
          "name": "Winchester",
          "median": 1.22,
          "10%": 1.1,
          "90%": 1.35,
          "25%": 1.15,
          "75%": 1.28
        },
        "54105": {
          "name": "Wirt",
          "median": 1.22,
          "10%": 1.12,
          "90%": 1.38,
          "25%": 1.17,
          "75%": 1.33
        },
        "51195": {
          "name": "Wise",
          "median": 1.18,
          "10%": 1.08,
          "90%": 1.31,
          "25%": 1.13,
          "75%": 1.27
        },
        "54107": {
          "name": "Wood",
          "median": 1.2,
          "10%": 1.06,
          "90%": 1.33,
          "25%": 1.12,
          "75%": 1.25
        },
        "24047": {
          "name": "Worcester",
          "median": 1.15,
          "10%": 1.04,
          "90%": 1.33,
          "25%": 1.1,
          "75%": 1.24
        },
        "42131": {
          "name": "Wyoming",
          "median": 1.18,
          "10%": 1.11,
          "90%": 1.29,
          "25%": 1.15,
          "75%": 1.22
        },
        "54109": {
          "name": "Wyoming",
          "median": 1.18,
          "10%": 1.1,
          "90%": 1.33,
          "25%": 1.13,
          "75%": 1.25
        },
        "51197": {
          "name": "Wythe",
          "median": 1.16,
          "10%": 1.07,
          "90%": 1.3,
          "25%": 1.1,
          "75%": 1.22
        },
        "36123": {
          "name": "Yates",
          "median": 1.19,
          "10%": 1.05,
          "90%": 1.33,
          "25%": 1.1,
          "75%": 1.26
        },
        "42133": {
          "name": "York",
          "median": 1.18,
          "10%": 1.06,
          "90%": 1.31,
          "25%": 1.09,
          "75%": 1.26
        },
        "51199": {
          "name": "York",
          "median": 1.16,
          "10%": 1.02,
          "90%": 1.25,
          "25%": 1.11,
          "75%": 1.19
        },
        "max": 1.24,
        "min": 1
      },
      "10": {
        "51001": {
          "name": "Accomack",
          "median": 1.18,
          "10%": 1.03,
          "90%": 1.29,
          "25%": 1.09,
          "75%": 1.25
        },
        "42001": {
          "name": "Adams",
          "median": 1.17,
          "10%": 1.04,
          "90%": 1.4,
          "25%": 1.1,
          "75%": 1.27
        },
        "51003": {
          "name": "Albemarle",
          "median": 1.18,
          "10%": 1.01,
          "90%": 1.39,
          "25%": 1.13,
          "75%": 1.3
        },
        "51510": {
          "name": "Alexandria",
          "median": 1.13,
          "10%": 0.96,
          "90%": 1.31,
          "25%": 1.03,
          "75%": 1.22
        },
        "24001": {
          "name": "Allegany",
          "median": 1.21,
          "10%": 1.1,
          "90%": 1.36,
          "25%": 1.16,
          "75%": 1.29
        },
        "36003": {
          "name": "Allegany",
          "median": 1.185,
          "10%": 1.04,
          "90%": 1.32,
          "25%": 1.12,
          "75%": 1.26
        },
        "51005": {
          "name": "Alleghany",
          "median": 1.21,
          "10%": 1.07,
          "90%": 1.38,
          "25%": 1.12,
          "75%": 1.3
        },
        "42003": {
          "name": "Allegheny",
          "median": 1.17,
          "10%": 1.04,
          "90%": 1.31,
          "25%": 1.09,
          "75%": 1.25
        },
        "51007": {
          "name": "Amelia",
          "median": 1.17,
          "10%": 1.0,
          "90%": 1.39,
          "25%": 1.1,
          "75%": 1.26
        },
        "51009": {
          "name": "Amherst",
          "median": 1.22,
          "10%": 1.05,
          "90%": 1.4,
          "25%": 1.14,
          "75%": 1.33
        },
        "24003": {
          "name": "Anne Arundel",
          "median": 1.14,
          "10%": 1.01,
          "90%": 1.32,
          "25%": 1.06,
          "75%": 1.24
        },
        "51011": {
          "name": "Appomattox",
          "median": 1.19,
          "10%": 1.05,
          "90%": 1.4,
          "25%": 1.11,
          "75%": 1.31
        },
        "51013": {
          "name": "Arlington",
          "median": 1.13,
          "10%": 1.0,
          "90%": 1.29,
          "25%": 1.04,
          "75%": 1.19
        },
        "42005": {
          "name": "Armstrong",
          "median": 1.18,
          "10%": 1.07,
          "90%": 1.36,
          "25%": 1.1,
          "75%": 1.27
        },
        "34001": {
          "name": "Atlantic",
          "median": 1.2,
          "10%": 1.08,
          "90%": 1.39,
          "25%": 1.12,
          "75%": 1.26
        },
        "51015": {
          "name": "Augusta",
          "median": 1.22,
          "10%": 1.04,
          "90%": 1.36,
          "25%": 1.12,
          "75%": 1.32
        },
        "24005": {
          "name": "Baltimore",
          "median": 1.14,
          "10%": 1.03,
          "90%": 1.31,
          "25%": 1.09,
          "75%": 1.22
        },
        "24510": {
          "name": "Baltimore",
          "median": 1.13,
          "10%": 1.01,
          "90%": 1.33,
          "25%": 1.05,
          "75%": 1.25
        },
        "54001": {
          "name": "Barbour",
          "median": 1.15,
          "10%": 1.05,
          "90%": 1.3,
          "25%": 1.1,
          "75%": 1.22
        },
        "51017": {
          "name": "Bath",
          "median": 1.23,
          "10%": 1.06,
          "90%": 1.43,
          "25%": 1.13,
          "75%": 1.34
        },
        "42007": {
          "name": "Beaver",
          "median": 1.13,
          "10%": 1.06,
          "90%": 1.28,
          "25%": 1.09,
          "75%": 1.23
        },
        "42009": {
          "name": "Bedford",
          "median": 1.22,
          "10%": 1.12,
          "90%": 1.34,
          "25%": 1.16,
          "75%": 1.29
        },
        "51019": {
          "name": "Bedford",
          "median": 1.22,
          "10%": 1.09,
          "90%": 1.35,
          "25%": 1.14,
          "75%": 1.29
        },
        "54003": {
          "name": "Berkeley",
          "median": 1.21,
          "10%": 1.08,
          "90%": 1.34,
          "25%": 1.13,
          "75%": 1.26
        },
        "42011": {
          "name": "Berks",
          "median": 1.21,
          "10%": 1.03,
          "90%": 1.361,
          "25%": 1.13,
          "75%": 1.26
        },
        "42013": {
          "name": "Blair",
          "median": 1.22,
          "10%": 1.08,
          "90%": 1.34,
          "25%": 1.14,
          "75%": 1.28
        },
        "51021": {
          "name": "Bland",
          "median": 1.14,
          "10%": 1.04,
          "90%": 1.29,
          "25%": 1.09,
          "75%": 1.21
        },
        "54005": {
          "name": "Boone",
          "median": 1.19,
          "10%": 1.07,
          "90%": 1.27,
          "25%": 1.11,
          "75%": 1.24
        },
        "51023": {
          "name": "Botetourt",
          "median": 1.22,
          "10%": 1.08,
          "90%": 1.39,
          "25%": 1.16,
          "75%": 1.32
        },
        "42015": {
          "name": "Bradford",
          "median": 1.16,
          "10%": 1.06,
          "90%": 1.29,
          "25%": 1.11,
          "75%": 1.23
        },
        "54007": {
          "name": "Braxton",
          "median": 1.15,
          "10%": 1.05,
          "90%": 1.27,
          "25%": 1.08,
          "75%": 1.2
        },
        "51520": {
          "name": "Bristol",
          "median": 1.16,
          "10%": 1.08,
          "90%": 1.32,
          "25%": 1.11,
          "75%": 1.23
        },
        "36005": {
          "name": "Bronx",
          "median": 1.18,
          "10%": 1.07,
          "90%": 1.34,
          "25%": 1.13,
          "75%": 1.26
        },
        "54009": {
          "name": "Brooke",
          "median": 1.2,
          "10%": 1.05,
          "90%": 1.38,
          "25%": 1.11,
          "75%": 1.28
        },
        "36007": {
          "name": "Broome",
          "median": 1.17,
          "10%": 1.03,
          "90%": 1.27,
          "25%": 1.09,
          "75%": 1.21
        },
        "51025": {
          "name": "Brunswick",
          "median": 1.19,
          "10%": 1.04,
          "90%": 1.33,
          "25%": 1.12,
          "75%": 1.25
        },
        "51027": {
          "name": "Buchanan",
          "median": 1.15,
          "10%": 1.05,
          "90%": 1.29,
          "25%": 1.09,
          "75%": 1.23
        },
        "51029": {
          "name": "Buckingham",
          "median": 1.19,
          "10%": 1.04,
          "90%": 1.38,
          "25%": 1.1,
          "75%": 1.26
        },
        "42017": {
          "name": "Bucks",
          "median": 1.15,
          "10%": 1.05,
          "90%": 1.29,
          "25%": 1.11,
          "75%": 1.23
        },
        "51530": {
          "name": "Buena Vista",
          "median": 1.21,
          "10%": 1.03,
          "90%": 1.5,
          "25%": 1.12,
          "75%": 1.34
        },
        "34005": {
          "name": "Burlington",
          "median": 1.15,
          "10%": 1.04,
          "90%": 1.28,
          "25%": 1.09,
          "75%": 1.22
        },
        "42019": {
          "name": "Butler",
          "median": 1.17,
          "10%": 1.06,
          "90%": 1.3,
          "25%": 1.1,
          "75%": 1.23
        },
        "54011": {
          "name": "Cabell",
          "median": 1.16,
          "10%": 1.05,
          "90%": 1.34,
          "25%": 1.1,
          "75%": 1.24
        },
        "54013": {
          "name": "Calhoun",
          "median": 1.22,
          "10%": 1.07,
          "90%": 1.4,
          "25%": 1.14,
          "75%": 1.31
        },
        "24009": {
          "name": "Calvert",
          "median": 1.17,
          "10%": 1.03,
          "90%": 1.32,
          "25%": 1.09,
          "75%": 1.23
        },
        "42021": {
          "name": "Cambria",
          "median": 1.16,
          "10%": 1.05,
          "90%": 1.3,
          "25%": 1.11,
          "75%": 1.22
        },
        "34007": {
          "name": "Camden",
          "median": 1.18,
          "10%": 1.04,
          "90%": 1.29,
          "25%": 1.11,
          "75%": 1.24
        },
        "42023": {
          "name": "Cameron",
          "median": 1.19,
          "10%": 1.049,
          "90%": 1.32,
          "25%": 1.12,
          "75%": 1.26
        },
        "51031": {
          "name": "Campbell",
          "median": 1.21,
          "10%": 1.06,
          "90%": 1.33,
          "25%": 1.14,
          "75%": 1.27
        },
        "34009": {
          "name": "Cape May",
          "median": 1.21,
          "10%": 1.07,
          "90%": 1.36,
          "25%": 1.16,
          "75%": 1.27
        },
        "42025": {
          "name": "Carbon",
          "median": 1.19,
          "10%": 1.06,
          "90%": 1.31,
          "25%": 1.16,
          "75%": 1.25
        },
        "24011": {
          "name": "Caroline",
          "median": 1.19,
          "10%": 1.04,
          "90%": 1.35,
          "25%": 1.12,
          "75%": 1.25
        },
        "51033": {
          "name": "Caroline",
          "median": 1.18,
          "10%": 1.01,
          "90%": 1.35,
          "25%": 1.08,
          "75%": 1.26
        },
        "24013": {
          "name": "Carroll",
          "median": 1.17,
          "10%": 1.06,
          "90%": 1.37,
          "25%": 1.1,
          "75%": 1.27
        },
        "51035": {
          "name": "Carroll",
          "median": 1.17,
          "10%": 1.07,
          "90%": 1.31,
          "25%": 1.12,
          "75%": 1.26
        },
        "24015": {
          "name": "Cecil",
          "median": 1.17,
          "10%": 1.05,
          "90%": 1.32,
          "25%": 1.11,
          "75%": 1.26
        },
        "42027": {
          "name": "Centre",
          "median": 1.22,
          "10%": 1.07,
          "90%": 1.36,
          "25%": 1.16,
          "75%": 1.29
        },
        "24017": {
          "name": "Charles",
          "median": 1.18,
          "10%": 1.0,
          "90%": 1.37,
          "25%": 1.08,
          "75%": 1.27
        },
        "51036": {
          "name": "Charles City",
          "median": 1.15,
          "10%": 1.04,
          "90%": 1.28,
          "25%": 1.09,
          "75%": 1.22
        },
        "51037": {
          "name": "Charlotte",
          "median": 1.19,
          "10%": 1.07,
          "90%": 1.33,
          "25%": 1.12,
          "75%": 1.26
        },
        "51540": {
          "name": "Charlottesville",
          "median": 1.17,
          "10%": 1.01,
          "90%": 1.37,
          "25%": 1.11,
          "75%": 1.27
        },
        "36015": {
          "name": "Chemung",
          "median": 1.17,
          "10%": 1.07,
          "90%": 1.3,
          "25%": 1.12,
          "75%": 1.22
        },
        "36017": {
          "name": "Chenango",
          "median": 1.17,
          "10%": 1.05,
          "90%": 1.31,
          "25%": 1.1,
          "75%": 1.23
        },
        "51550": {
          "name": "Chesapeake",
          "median": 1.19,
          "10%": 1.05,
          "90%": 1.39,
          "25%": 1.09,
          "75%": 1.32
        },
        "42029": {
          "name": "Chester",
          "median": 1.21,
          "10%": 1.04,
          "90%": 1.34,
          "25%": 1.11,
          "75%": 1.3
        },
        "51041": {
          "name": "Chesterfield",
          "median": 1.16,
          "10%": 1.01,
          "90%": 1.39,
          "25%": 1.09,
          "75%": 1.27
        },
        "42031": {
          "name": "Clarion",
          "median": 1.19,
          "10%": 1.06,
          "90%": 1.36,
          "25%": 1.13,
          "75%": 1.29
        },
        "51043": {
          "name": "Clarke",
          "median": 1.19,
          "10%": 1.08,
          "90%": 1.36,
          "25%": 1.12,
          "75%": 1.28
        },
        "54015": {
          "name": "Clay",
          "median": 1.12,
          "10%": 1.03,
          "90%": 1.23,
          "25%": 1.06,
          "75%": 1.18
        },
        "42033": {
          "name": "Clearfield",
          "median": 1.19,
          "10%": 1.08,
          "90%": 1.32,
          "25%": 1.13,
          "75%": 1.27
        },
        "42035": {
          "name": "Clinton",
          "median": 1.2,
          "10%": 1.06,
          "90%": 1.34,
          "25%": 1.16,
          "75%": 1.29
        },
        "51570": {
          "name": "Colonial Heights",
          "median": 1.17,
          "10%": 1.05,
          "90%": 1.37,
          "25%": 1.08,
          "75%": 1.26
        },
        "42037": {
          "name": "Columbia",
          "median": 1.23,
          "10%": 1.08,
          "90%": 1.33,
          "25%": 1.17,
          "75%": 1.29
        },
        "36023": {
          "name": "Cortland",
          "median": 1.18,
          "10%": 1.08,
          "90%": 1.32,
          "25%": 1.11,
          "75%": 1.26
        },
        "51580": {
          "name": "Covington",
          "median": 1.18,
          "10%": 1.04,
          "90%": 1.36,
          "25%": 1.08,
          "75%": 1.26
        },
        "51045": {
          "name": "Craig",
          "median": 1.22,
          "10%": 1.1,
          "90%": 1.38,
          "25%": 1.14,
          "75%": 1.29
        },
        "42039": {
          "name": "Crawford",
          "median": 1.17,
          "10%": 1.01,
          "90%": 1.3,
          "25%": 1.09,
          "75%": 1.25
        },
        "51047": {
          "name": "Culpeper",
          "median": 1.19,
          "10%": 1.06,
          "90%": 1.341,
          "25%": 1.14,
          "75%": 1.26
        },
        "34011": {
          "name": "Cumberland",
          "median": 1.17,
          "10%": 1.07,
          "90%": 1.32,
          "25%": 1.11,
          "75%": 1.23
        },
        "42041": {
          "name": "Cumberland",
          "median": 1.19,
          "10%": 1.09,
          "90%": 1.39,
          "25%": 1.13,
          "75%": 1.28
        },
        "51049": {
          "name": "Cumberland",
          "median": 1.16,
          "10%": 1.05,
          "90%": 1.39,
          "25%": 1.09,
          "75%": 1.27
        },
        "51590": {
          "name": "Danville",
          "median": 1.17,
          "10%": 1.02,
          "90%": 1.35,
          "25%": 1.1,
          "75%": 1.28
        },
        "42043": {
          "name": "Dauphin",
          "median": 1.24,
          "10%": 1.06,
          "90%": 1.37,
          "25%": 1.14,
          "75%": 1.31
        },
        "36025": {
          "name": "Delaware",
          "median": 1.18,
          "10%": 1.1,
          "90%": 1.32,
          "25%": 1.14,
          "75%": 1.26
        },
        "42045": {
          "name": "Delaware",
          "median": 1.2,
          "10%": 1.02,
          "90%": 1.4,
          "25%": 1.12,
          "75%": 1.29
        },
        "51051": {
          "name": "Dickenson",
          "median": 1.16,
          "10%": 1.02,
          "90%": 1.28,
          "25%": 1.1,
          "75%": 1.23
        },
        "51053": {
          "name": "Dinwiddie",
          "median": 1.18,
          "10%": 1.06,
          "90%": 1.3,
          "25%": 1.1,
          "75%": 1.24
        },
        "11001": {
          "name": "District of Columbia",
          "median": 1.12,
          "10%": 1.0,
          "90%": 1.31,
          "25%": 1.07,
          "75%": 1.23
        },
        "54017": {
          "name": "Doddridge",
          "median": 1.14,
          "10%": 1.04,
          "90%": 1.26,
          "25%": 1.07,
          "75%": 1.2
        },
        "24019": {
          "name": "Dorchester",
          "median": 1.15,
          "10%": 0.99,
          "90%": 1.28,
          "25%": 1.06,
          "75%": 1.19
        },
        "42047": {
          "name": "Elk",
          "median": 1.19,
          "10%": 0.97,
          "90%": 1.3,
          "25%": 1.08,
          "75%": 1.26
        },
        "51595": {
          "name": "Emporia",
          "median": 1.12,
          "10%": 0.98,
          "90%": 1.25,
          "25%": 1.04,
          "75%": 1.18
        },
        "42049": {
          "name": "Erie",
          "median": 1.19,
          "10%": 1.03,
          "90%": 1.35,
          "25%": 1.08,
          "75%": 1.26
        },
        "51057": {
          "name": "Essex",
          "median": 1.16,
          "10%": 1.0,
          "90%": 1.34,
          "25%": 1.04,
          "75%": 1.26
        },
        "51059": {
          "name": "Fairfax",
          "median": 1.14,
          "10%": 1.02,
          "90%": 1.29,
          "25%": 1.06,
          "75%": 1.2
        },
        "51600": {
          "name": "Fairfax",
          "median": 1.13,
          "10%": 1.02,
          "90%": 1.29,
          "25%": 1.04,
          "75%": 1.21
        },
        "51610": {
          "name": "Falls Church",
          "median": 1.13,
          "10%": 1.01,
          "90%": 1.29,
          "25%": 1.05,
          "75%": 1.2
        },
        "51061": {
          "name": "Fauquier",
          "median": 1.19,
          "10%": 1.06,
          "90%": 1.37,
          "25%": 1.13,
          "75%": 1.28
        },
        "42051": {
          "name": "Fayette",
          "median": 1.17,
          "10%": 1.06,
          "90%": 1.32,
          "25%": 1.11,
          "75%": 1.24
        },
        "54019": {
          "name": "Fayette",
          "median": 1.13,
          "10%": 1.06,
          "90%": 1.27,
          "25%": 1.09,
          "75%": 1.2
        },
        "51063": {
          "name": "Floyd",
          "median": 1.18,
          "10%": 1.01,
          "90%": 1.34,
          "25%": 1.11,
          "75%": 1.25
        },
        "51065": {
          "name": "Fluvanna",
          "median": 1.18,
          "10%": 1.01,
          "90%": 1.54,
          "25%": 1.11,
          "75%": 1.31
        },
        "42053": {
          "name": "Forest",
          "median": 1.18,
          "10%": 0.98,
          "90%": 1.38,
          "25%": 1.06,
          "75%": 1.27
        },
        "42055": {
          "name": "Franklin",
          "median": 1.18,
          "10%": 1.09,
          "90%": 1.36,
          "25%": 1.12,
          "75%": 1.28
        },
        "51067": {
          "name": "Franklin",
          "median": 1.2,
          "10%": 1.03,
          "90%": 1.39,
          "25%": 1.11,
          "75%": 1.32
        },
        "51620": {
          "name": "Franklin",
          "median": 1.2,
          "10%": 1.06,
          "90%": 1.38,
          "25%": 1.09,
          "75%": 1.3
        },
        "24021": {
          "name": "Frederick",
          "median": 1.18,
          "10%": 1.07,
          "90%": 1.37,
          "25%": 1.11,
          "75%": 1.28
        },
        "51069": {
          "name": "Frederick",
          "median": 1.22,
          "10%": 1.1,
          "90%": 1.4,
          "25%": 1.13,
          "75%": 1.27
        },
        "51630": {
          "name": "Fredericksburg",
          "median": 1.16,
          "10%": 1.03,
          "90%": 1.38,
          "25%": 1.08,
          "75%": 1.28
        },
        "42057": {
          "name": "Fulton",
          "median": 1.25,
          "10%": 1.1,
          "90%": 1.4,
          "25%": 1.16,
          "75%": 1.32
        },
        "51640": {
          "name": "Galax",
          "median": 1.16,
          "10%": 0.96,
          "90%": 1.33,
          "25%": 1.06,
          "75%": 1.27
        },
        "24023": {
          "name": "Garrett",
          "median": 1.15,
          "10%": 1.07,
          "90%": 1.31,
          "25%": 1.1,
          "75%": 1.22
        },
        "51071": {
          "name": "Giles",
          "median": 1.19,
          "10%": 1.09,
          "90%": 1.3,
          "25%": 1.14,
          "75%": 1.25
        },
        "54021": {
          "name": "Gilmer",
          "median": 1.18,
          "10%": 1.07,
          "90%": 1.33,
          "25%": 1.12,
          "75%": 1.26
        },
        "34015": {
          "name": "Gloucester",
          "median": 1.19,
          "10%": 1.04,
          "90%": 1.36,
          "25%": 1.13,
          "75%": 1.25
        },
        "51073": {
          "name": "Gloucester",
          "median": 1.17,
          "10%": 1.0,
          "90%": 1.26,
          "25%": 1.11,
          "75%": 1.21
        },
        "51075": {
          "name": "Goochland",
          "median": 1.18,
          "10%": 0.97,
          "90%": 1.47,
          "25%": 1.07,
          "75%": 1.26
        },
        "54023": {
          "name": "Grant",
          "median": 1.16,
          "10%": 1.05,
          "90%": 1.32,
          "25%": 1.1,
          "75%": 1.24
        },
        "51077": {
          "name": "Grayson",
          "median": 1.17,
          "10%": 1.05,
          "90%": 1.32,
          "25%": 1.1,
          "75%": 1.25
        },
        "54025": {
          "name": "Greenbrier",
          "median": 1.18,
          "10%": 1.07,
          "90%": 1.29,
          "25%": 1.12,
          "75%": 1.25
        },
        "36039": {
          "name": "Greene",
          "median": 1.26,
          "10%": 1.09,
          "90%": 1.43,
          "25%": 1.16,
          "75%": 1.37
        },
        "42059": {
          "name": "Greene",
          "median": 1.21,
          "10%": 1.08,
          "90%": 1.311,
          "25%": 1.15,
          "75%": 1.27
        },
        "51079": {
          "name": "Greene",
          "median": 1.18,
          "10%": 1.06,
          "90%": 1.36,
          "25%": 1.13,
          "75%": 1.3
        },
        "51081": {
          "name": "Greensville",
          "median": 1.14,
          "10%": 0.99,
          "90%": 1.26,
          "25%": 1.07,
          "75%": 1.21
        },
        "51083": {
          "name": "Halifax",
          "median": 1.21,
          "10%": 1.08,
          "90%": 1.36,
          "25%": 1.14,
          "75%": 1.29
        },
        "54027": {
          "name": "Hampshire",
          "median": 1.21,
          "10%": 1.12,
          "90%": 1.39,
          "25%": 1.16,
          "75%": 1.32
        },
        "51650": {
          "name": "Hampton",
          "median": 1.17,
          "10%": 1.04,
          "90%": 1.28,
          "25%": 1.08,
          "75%": 1.24
        },
        "54029": {
          "name": "Hancock",
          "median": 1.2,
          "10%": 1.05,
          "90%": 1.32,
          "25%": 1.09,
          "75%": 1.25
        },
        "51085": {
          "name": "Hanover",
          "median": 1.15,
          "10%": 1.02,
          "90%": 1.35,
          "25%": 1.0975,
          "75%": 1.27
        },
        "54031": {
          "name": "Hardy",
          "median": 1.19,
          "10%": 1.07,
          "90%": 1.37,
          "25%": 1.14,
          "75%": 1.27
        },
        "24025": {
          "name": "Harford",
          "median": 1.16,
          "10%": 1.02,
          "90%": 1.32,
          "25%": 1.1,
          "75%": 1.25
        },
        "54033": {
          "name": "Harrison",
          "median": 1.15,
          "10%": 1.04,
          "90%": 1.28,
          "25%": 1.1,
          "75%": 1.21
        },
        "51660": {
          "name": "Harrisonburg",
          "median": 1.16,
          "10%": 1.0,
          "90%": 1.38,
          "25%": 1.09,
          "75%": 1.27
        },
        "51087": {
          "name": "Henrico",
          "median": 1.18,
          "10%": 1.04,
          "90%": 1.34,
          "25%": 1.09,
          "75%": 1.28
        },
        "51089": {
          "name": "Henry",
          "median": 1.21,
          "10%": 1.03,
          "90%": 1.45,
          "25%": 1.12,
          "75%": 1.33
        },
        "36043": {
          "name": "Herkimer",
          "median": 1.13,
          "10%": 1.02,
          "90%": 1.28,
          "25%": 1.07,
          "75%": 1.22
        },
        "51091": {
          "name": "Highland",
          "median": 1.19,
          "10%": 1.07,
          "90%": 1.35,
          "25%": 1.11,
          "75%": 1.26
        },
        "51670": {
          "name": "Hopewell",
          "median": 1.13,
          "10%": 0.99,
          "90%": 1.3,
          "25%": 1.06,
          "75%": 1.22
        },
        "24027": {
          "name": "Howard",
          "median": 1.15,
          "10%": 1.03,
          "90%": 1.35,
          "25%": 1.08,
          "75%": 1.22
        },
        "34019": {
          "name": "Hunterdon",
          "median": 1.18,
          "10%": 1.04,
          "90%": 1.35,
          "25%": 1.13,
          "75%": 1.25
        },
        "42061": {
          "name": "Huntingdon",
          "median": 1.21,
          "10%": 1.11,
          "90%": 1.35,
          "25%": 1.16,
          "75%": 1.31
        },
        "42063": {
          "name": "Indiana",
          "median": 1.16,
          "10%": 1.06,
          "90%": 1.34,
          "25%": 1.12,
          "75%": 1.24
        },
        "51093": {
          "name": "Isle of Wight",
          "median": 1.19,
          "10%": 1.05,
          "90%": 1.37,
          "25%": 1.11,
          "75%": 1.27
        },
        "54035": {
          "name": "Jackson",
          "median": 1.19,
          "10%": 1.06,
          "90%": 1.31,
          "25%": 1.12,
          "75%": 1.25
        },
        "51095": {
          "name": "James City",
          "median": 1.15,
          "10%": 0.99,
          "90%": 1.26,
          "25%": 1.07,
          "75%": 1.21
        },
        "42065": {
          "name": "Jefferson",
          "median": 1.2,
          "10%": 1.06,
          "90%": 1.32,
          "25%": 1.11,
          "75%": 1.27
        },
        "54037": {
          "name": "Jefferson",
          "median": 1.18,
          "10%": 1.06,
          "90%": 1.37,
          "25%": 1.1,
          "75%": 1.25
        },
        "42067": {
          "name": "Juniata",
          "median": 1.19,
          "10%": 1.09,
          "90%": 1.33,
          "25%": 1.14,
          "75%": 1.26
        },
        "54039": {
          "name": "Kanawha",
          "median": 1.11,
          "10%": 1.01,
          "90%": 1.22,
          "25%": 1.06,
          "75%": 1.16
        },
        "10001": {
          "name": "Kent",
          "median": 1.17,
          "10%": 1.05,
          "90%": 1.31,
          "25%": 1.11,
          "75%": 1.24
        },
        "24029": {
          "name": "Kent",
          "median": 1.18,
          "10%": 1.01,
          "90%": 1.3,
          "25%": 1.1,
          "75%": 1.25
        },
        "51099": {
          "name": "King George",
          "median": 1.17,
          "10%": 0.98,
          "90%": 1.36,
          "25%": 1.06,
          "75%": 1.29
        },
        "51101": {
          "name": "King William",
          "median": 1.13,
          "10%": 1.03,
          "90%": 1.28,
          "25%": 1.06,
          "75%": 1.22
        },
        "51097": {
          "name": "King and Queen",
          "median": 1.14,
          "10%": 1.0,
          "90%": 1.29,
          "25%": 1.06,
          "75%": 1.2
        },
        "42069": {
          "name": "Lackawanna",
          "median": 1.21,
          "10%": 1.08,
          "90%": 1.37,
          "25%": 1.16,
          "75%": 1.31
        },
        "42071": {
          "name": "Lancaster",
          "median": 1.2,
          "10%": 1.06,
          "90%": 1.37,
          "25%": 1.11,
          "75%": 1.29
        },
        "51103": {
          "name": "Lancaster",
          "median": 1.15,
          "10%": 1.01,
          "90%": 1.27,
          "25%": 1.06,
          "75%": 1.23
        },
        "42073": {
          "name": "Lawrence",
          "median": 1.16,
          "10%": 1.02,
          "90%": 1.28,
          "25%": 1.09,
          "75%": 1.23
        },
        "42075": {
          "name": "Lebanon",
          "median": 1.18,
          "10%": 1.02,
          "90%": 1.31,
          "25%": 1.11,
          "75%": 1.25
        },
        "51105": {
          "name": "Lee",
          "median": 1.21,
          "10%": 1.11,
          "90%": 1.39,
          "25%": 1.17,
          "75%": 1.31
        },
        "42077": {
          "name": "Lehigh",
          "median": 1.19,
          "10%": 1.06,
          "90%": 1.36,
          "25%": 1.14,
          "75%": 1.28
        },
        "54041": {
          "name": "Lewis",
          "median": 1.16,
          "10%": 1.06,
          "90%": 1.28,
          "25%": 1.1,
          "75%": 1.21
        },
        "51678": {
          "name": "Lexington",
          "median": 1.14,
          "10%": 1.05,
          "90%": 1.32,
          "25%": 1.08,
          "75%": 1.25
        },
        "54043": {
          "name": "Lincoln",
          "median": 1.17,
          "10%": 1.05,
          "90%": 1.33,
          "25%": 1.09,
          "75%": 1.24
        },
        "36051": {
          "name": "Livingston",
          "median": 1.19,
          "10%": 1.04,
          "90%": 1.32,
          "25%": 1.11,
          "75%": 1.27
        },
        "54045": {
          "name": "Logan",
          "median": 1.18,
          "10%": 1.07,
          "90%": 1.32,
          "25%": 1.13,
          "75%": 1.25
        },
        "51107": {
          "name": "Loudoun",
          "median": 1.17,
          "10%": 1.08,
          "90%": 1.35,
          "25%": 1.1,
          "75%": 1.28
        },
        "51109": {
          "name": "Louisa",
          "median": 1.19,
          "10%": 1.05,
          "90%": 1.4,
          "25%": 1.12,
          "75%": 1.3
        },
        "51111": {
          "name": "Lunenburg",
          "median": 1.21,
          "10%": 1.07,
          "90%": 1.34,
          "25%": 1.1,
          "75%": 1.28
        },
        "42079": {
          "name": "Luzerne",
          "median": 1.2,
          "10%": 1.1,
          "90%": 1.3,
          "25%": 1.15,
          "75%": 1.26
        },
        "42081": {
          "name": "Lycoming",
          "median": 1.19,
          "10%": 1.08,
          "90%": 1.31,
          "25%": 1.14,
          "75%": 1.26
        },
        "51680": {
          "name": "Lynchburg",
          "median": 1.18,
          "10%": 1.06,
          "90%": 1.3,
          "25%": 1.12,
          "75%": 1.26
        },
        "36053": {
          "name": "Madison",
          "median": 1.16,
          "10%": 1.02,
          "90%": 1.3,
          "25%": 1.1,
          "75%": 1.24
        },
        "51113": {
          "name": "Madison",
          "median": 1.18,
          "10%": 1.05,
          "90%": 1.33,
          "25%": 1.13,
          "75%": 1.27
        },
        "51683": {
          "name": "Manassas",
          "median": 1.12,
          "10%": 1.0,
          "90%": 1.29,
          "25%": 1.04,
          "75%": 1.2
        },
        "51685": {
          "name": "Manassas Park",
          "median": 1.115,
          "10%": 0.99,
          "90%": 1.3,
          "25%": 1.03,
          "75%": 1.2
        },
        "54049": {
          "name": "Marion",
          "median": 1.14,
          "10%": 1.04,
          "90%": 1.24,
          "25%": 1.08,
          "75%": 1.2
        },
        "54051": {
          "name": "Marshall",
          "median": 1.18,
          "10%": 1.06,
          "90%": 1.32,
          "25%": 1.12,
          "75%": 1.27
        },
        "51690": {
          "name": "Martinsville",
          "median": 1.22,
          "10%": 1.0,
          "90%": 1.51,
          "25%": 1.13,
          "75%": 1.35
        },
        "54053": {
          "name": "Mason",
          "median": 1.23,
          "10%": 1.07,
          "90%": 1.33,
          "25%": 1.14,
          "75%": 1.28
        },
        "51115": {
          "name": "Mathews",
          "median": 1.18,
          "10%": 1.01,
          "90%": 1.33,
          "25%": 1.1,
          "75%": 1.25
        },
        "54047": {
          "name": "McDowell",
          "median": 1.16,
          "10%": 1.07,
          "90%": 1.3,
          "25%": 1.11,
          "75%": 1.22
        },
        "42083": {
          "name": "McKean",
          "median": 1.19,
          "10%": 1.0,
          "90%": 1.28,
          "25%": 1.12,
          "75%": 1.24
        },
        "51117": {
          "name": "Mecklenburg",
          "median": 1.19,
          "10%": 1.07,
          "90%": 1.32,
          "25%": 1.13,
          "75%": 1.25
        },
        "34021": {
          "name": "Mercer",
          "median": 1.12,
          "10%": 1.01,
          "90%": 1.25,
          "25%": 1.06,
          "75%": 1.19
        },
        "42085": {
          "name": "Mercer",
          "median": 1.18,
          "10%": 1.03,
          "90%": 1.32,
          "25%": 1.1,
          "75%": 1.27
        },
        "54055": {
          "name": "Mercer",
          "median": 1.16,
          "10%": 1.07,
          "90%": 1.3,
          "25%": 1.11,
          "75%": 1.22
        },
        "51119": {
          "name": "Middlesex",
          "median": 1.15,
          "10%": 1.0,
          "90%": 1.26,
          "25%": 1.07,
          "75%": 1.21
        },
        "42087": {
          "name": "Mifflin",
          "median": 1.22,
          "10%": 1.12,
          "90%": 1.35,
          "25%": 1.16,
          "75%": 1.29
        },
        "54057": {
          "name": "Mineral",
          "median": 1.2,
          "10%": 1.09,
          "90%": 1.34,
          "25%": 1.13,
          "75%": 1.28
        },
        "54059": {
          "name": "Mingo",
          "median": 1.22,
          "10%": 1.09,
          "90%": 1.34,
          "25%": 1.14,
          "75%": 1.27
        },
        "34025": {
          "name": "Monmouth",
          "median": 1.15,
          "10%": 1.03,
          "90%": 1.28,
          "25%": 1.09,
          "75%": 1.2
        },
        "54061": {
          "name": "Monongalia",
          "median": 1.15,
          "10%": 1.06,
          "90%": 1.27,
          "25%": 1.09,
          "75%": 1.22
        },
        "42089": {
          "name": "Monroe",
          "median": 1.22,
          "10%": 1.1,
          "90%": 1.38,
          "25%": 1.16,
          "75%": 1.31
        },
        "54063": {
          "name": "Monroe",
          "median": 1.16,
          "10%": 1.07,
          "90%": 1.3,
          "25%": 1.11,
          "75%": 1.21
        },
        "24031": {
          "name": "Montgomery",
          "median": 1.15,
          "10%": 1.04,
          "90%": 1.36,
          "25%": 1.09,
          "75%": 1.2
        },
        "36057": {
          "name": "Montgomery",
          "median": 1.18,
          "10%": 1.06,
          "90%": 1.36,
          "25%": 1.12,
          "75%": 1.29
        },
        "42091": {
          "name": "Montgomery",
          "median": 1.18,
          "10%": 1.08,
          "90%": 1.34,
          "25%": 1.13,
          "75%": 1.25
        },
        "51121": {
          "name": "Montgomery",
          "median": 1.21,
          "10%": 1.1,
          "90%": 1.37,
          "25%": 1.14,
          "75%": 1.28
        },
        "42093": {
          "name": "Montour",
          "median": 1.26,
          "10%": 1.06,
          "90%": 1.38,
          "25%": 1.15,
          "75%": 1.31
        },
        "54065": {
          "name": "Morgan",
          "median": 1.24,
          "10%": 1.09,
          "90%": 1.4,
          "25%": 1.16,
          "75%": 1.32
        },
        "34027": {
          "name": "Morris",
          "median": 1.22,
          "10%": 1.07,
          "90%": 1.44,
          "25%": 1.14,
          "75%": 1.34
        },
        "36059": {
          "name": "Nassau",
          "median": 1.2,
          "10%": 1.08,
          "90%": 1.32,
          "25%": 1.13,
          "75%": 1.26
        },
        "51125": {
          "name": "Nelson",
          "median": 1.22,
          "10%": 1.03,
          "90%": 1.48,
          "25%": 1.13,
          "75%": 1.35
        },
        "10003": {
          "name": "New Castle",
          "median": 1.2,
          "10%": 1.06,
          "90%": 1.38,
          "25%": 1.11,
          "75%": 1.32
        },
        "51127": {
          "name": "New Kent",
          "median": 1.16,
          "10%": 1.03,
          "90%": 1.29,
          "25%": 1.09,
          "75%": 1.2
        },
        "36061": {
          "name": "New York",
          "median": 1.18,
          "10%": 1.06,
          "90%": 1.31,
          "25%": 1.1,
          "75%": 1.24
        },
        "51700": {
          "name": "Newport News",
          "median": 1.16,
          "10%": 1.04,
          "90%": 1.31,
          "25%": 1.1,
          "75%": 1.22
        },
        "54067": {
          "name": "Nicholas",
          "median": 1.15,
          "10%": 1.03,
          "90%": 1.24,
          "25%": 1.08,
          "75%": 1.21
        },
        "51710": {
          "name": "Norfolk",
          "median": 1.18,
          "10%": 1.01,
          "90%": 1.41,
          "25%": 1.09,
          "75%": 1.34
        },
        "42095": {
          "name": "Northampton",
          "median": 1.18,
          "10%": 1.05,
          "90%": 1.33,
          "25%": 1.11,
          "75%": 1.26
        },
        "51131": {
          "name": "Northampton",
          "median": 1.17,
          "10%": 1.01,
          "90%": 1.32,
          "25%": 1.08,
          "75%": 1.25
        },
        "42097": {
          "name": "Northumberland",
          "median": 1.26,
          "10%": 1.07,
          "90%": 1.38,
          "25%": 1.17,
          "75%": 1.3
        },
        "51133": {
          "name": "Northumberland",
          "median": 1.15,
          "10%": 0.97,
          "90%": 1.33,
          "25%": 1.08,
          "75%": 1.26
        },
        "51720": {
          "name": "Norton",
          "median": 1.2,
          "10%": 1.06,
          "90%": 1.351,
          "25%": 1.12,
          "75%": 1.3
        },
        "51135": {
          "name": "Nottoway",
          "median": 1.18,
          "10%": 1.04,
          "90%": 1.32,
          "25%": 1.11,
          "75%": 1.26
        },
        "34029": {
          "name": "Ocean",
          "median": 1.14,
          "10%": 1.06,
          "90%": 1.28,
          "25%": 1.1,
          "75%": 1.22
        },
        "54069": {
          "name": "Ohio",
          "median": 1.2,
          "10%": 1.06,
          "90%": 1.39,
          "25%": 1.12,
          "75%": 1.3
        },
        "36065": {
          "name": "Oneida",
          "median": 1.17,
          "10%": 1.05,
          "90%": 1.29,
          "25%": 1.11,
          "75%": 1.24
        },
        "36067": {
          "name": "Onondaga",
          "median": 1.18,
          "10%": 1.08,
          "90%": 1.36,
          "25%": 1.14,
          "75%": 1.27
        },
        "36069": {
          "name": "Ontario",
          "median": 1.18,
          "10%": 1.04,
          "90%": 1.27,
          "25%": 1.08,
          "75%": 1.23
        },
        "36071": {
          "name": "Orange",
          "median": 1.21,
          "10%": 1.09,
          "90%": 1.39,
          "25%": 1.16,
          "75%": 1.3
        },
        "51137": {
          "name": "Orange",
          "median": 1.2,
          "10%": 1.06,
          "90%": 1.37,
          "25%": 1.15,
          "75%": 1.28
        },
        "36077": {
          "name": "Otsego",
          "median": 1.16,
          "10%": 1.06,
          "90%": 1.32,
          "25%": 1.09,
          "75%": 1.24
        },
        "51139": {
          "name": "Page",
          "median": 1.21,
          "10%": 1.05,
          "90%": 1.4,
          "25%": 1.14,
          "75%": 1.3
        },
        "51141": {
          "name": "Patrick",
          "median": 1.18,
          "10%": 1.02,
          "90%": 1.38,
          "25%": 1.09,
          "75%": 1.26
        },
        "54071": {
          "name": "Pendleton",
          "median": 1.2,
          "10%": 1.05,
          "90%": 1.37,
          "25%": 1.11,
          "75%": 1.3
        },
        "42099": {
          "name": "Perry",
          "median": 1.2,
          "10%": 1.1,
          "90%": 1.36,
          "25%": 1.13,
          "75%": 1.31
        },
        "51730": {
          "name": "Petersburg",
          "median": 1.15,
          "10%": 1.05,
          "90%": 1.33,
          "25%": 1.08,
          "75%": 1.25
        },
        "42101": {
          "name": "Philadelphia",
          "median": 1.18,
          "10%": 1.05,
          "90%": 1.32,
          "25%": 1.1,
          "75%": 1.24
        },
        "42103": {
          "name": "Pike",
          "median": 1.22,
          "10%": 1.03,
          "90%": 1.39,
          "25%": 1.14,
          "75%": 1.28
        },
        "51143": {
          "name": "Pittsylvania",
          "median": 1.23,
          "10%": 1.05,
          "90%": 1.38,
          "25%": 1.16,
          "75%": 1.32
        },
        "54073": {
          "name": "Pleasants",
          "median": 1.16,
          "10%": 1.01,
          "90%": 1.3,
          "25%": 1.08,
          "75%": 1.24
        },
        "54075": {
          "name": "Pocahontas",
          "median": 1.17,
          "10%": 1.07,
          "90%": 1.3,
          "25%": 1.11,
          "75%": 1.24
        },
        "51735": {
          "name": "Poquoson",
          "median": 1.15,
          "10%": 1.05,
          "90%": 1.29,
          "25%": 1.08,
          "75%": 1.24
        },
        "51740": {
          "name": "Portsmouth",
          "median": 1.17,
          "10%": 1.02,
          "90%": 1.39,
          "25%": 1.09,
          "75%": 1.33
        },
        "42105": {
          "name": "Potter",
          "median": 1.21,
          "10%": 1.06,
          "90%": 1.33,
          "25%": 1.13,
          "75%": 1.26
        },
        "51145": {
          "name": "Powhatan",
          "median": 1.17,
          "10%": 0.99,
          "90%": 1.4,
          "25%": 1.08,
          "75%": 1.24
        },
        "54077": {
          "name": "Preston",
          "median": 1.17,
          "10%": 1.05,
          "90%": 1.31,
          "25%": 1.11,
          "75%": 1.25
        },
        "51147": {
          "name": "Prince Edward",
          "median": 1.18,
          "10%": 1.07,
          "90%": 1.32,
          "25%": 1.11,
          "75%": 1.28
        },
        "51149": {
          "name": "Prince George",
          "median": 1.15,
          "10%": 1.05,
          "90%": 1.29,
          "25%": 1.09,
          "75%": 1.24
        },
        "24033": {
          "name": "Prince George's",
          "median": 1.16,
          "10%": 1.02,
          "90%": 1.32,
          "25%": 1.07,
          "75%": 1.24
        },
        "51153": {
          "name": "Prince William",
          "median": 1.16,
          "10%": 1.03,
          "90%": 1.3,
          "25%": 1.09,
          "75%": 1.23
        },
        "51155": {
          "name": "Pulaski",
          "median": 1.19,
          "10%": 1.08,
          "90%": 1.31,
          "25%": 1.13,
          "75%": 1.28
        },
        "54079": {
          "name": "Putnam",
          "median": 1.15,
          "10%": 1.05,
          "90%": 1.3,
          "25%": 1.08,
          "75%": 1.24
        },
        "24035": {
          "name": "Queen Anne's",
          "median": 1.18,
          "10%": 1.04,
          "90%": 1.32,
          "25%": 1.09,
          "75%": 1.26
        },
        "51750": {
          "name": "Radford",
          "median": 1.22,
          "10%": 1.08,
          "90%": 1.37,
          "25%": 1.15,
          "75%": 1.29
        },
        "54081": {
          "name": "Raleigh",
          "median": 1.18,
          "10%": 1.07,
          "90%": 1.29,
          "25%": 1.11,
          "75%": 1.24
        },
        "54083": {
          "name": "Randolph",
          "median": 1.16,
          "10%": 1.06,
          "90%": 1.29,
          "25%": 1.11,
          "75%": 1.22
        },
        "51157": {
          "name": "Rappahannock",
          "median": 1.19,
          "10%": 1.08,
          "90%": 1.36,
          "25%": 1.14,
          "75%": 1.29
        },
        "36085": {
          "name": "Richmond",
          "median": 1.15,
          "10%": 1.03,
          "90%": 1.31,
          "25%": 1.08,
          "75%": 1.24
        },
        "51159": {
          "name": "Richmond",
          "median": 1.14,
          "10%": 0.97,
          "90%": 1.4,
          "25%": 1.0375,
          "75%": 1.29
        },
        "51760": {
          "name": "Richmond",
          "median": 1.18,
          "10%": 1.01,
          "90%": 1.37,
          "25%": 1.1,
          "75%": 1.29
        },
        "54085": {
          "name": "Ritchie",
          "median": 1.17,
          "10%": 1.09,
          "90%": 1.31,
          "25%": 1.13,
          "75%": 1.26
        },
        "54087": {
          "name": "Roane",
          "median": 1.19,
          "10%": 1.04,
          "90%": 1.28,
          "25%": 1.1,
          "75%": 1.24
        },
        "51161": {
          "name": "Roanoke",
          "median": 1.25,
          "10%": 1.09,
          "90%": 1.43,
          "25%": 1.15,
          "75%": 1.35
        },
        "51770": {
          "name": "Roanoke",
          "median": 1.23,
          "10%": 1.06,
          "90%": 1.47,
          "25%": 1.13,
          "75%": 1.34
        },
        "51163": {
          "name": "Rockbridge",
          "median": 1.21,
          "10%": 1.06,
          "90%": 1.41,
          "25%": 1.12,
          "75%": 1.33
        },
        "51165": {
          "name": "Rockingham",
          "median": 1.2,
          "10%": 1.05,
          "90%": 1.34,
          "25%": 1.11,
          "75%": 1.29
        },
        "51167": {
          "name": "Russell",
          "median": 1.15,
          "10%": 1.06,
          "90%": 1.29,
          "25%": 1.1,
          "75%": 1.23
        },
        "34033": {
          "name": "Salem",
          "median": 1.2,
          "10%": 1.06,
          "90%": 1.39,
          "25%": 1.12,
          "75%": 1.29
        },
        "51775": {
          "name": "Salem",
          "median": 1.25,
          "10%": 1.07,
          "90%": 1.47,
          "25%": 1.14,
          "75%": 1.39
        },
        "36095": {
          "name": "Schoharie",
          "median": 1.21,
          "10%": 1.07,
          "90%": 1.37,
          "25%": 1.15,
          "75%": 1.3
        },
        "36097": {
          "name": "Schuyler",
          "median": 1.21,
          "10%": 1.06,
          "90%": 1.36,
          "25%": 1.14,
          "75%": 1.28
        },
        "42107": {
          "name": "Schuylkill",
          "median": 1.22,
          "10%": 1.07,
          "90%": 1.34,
          "25%": 1.14,
          "75%": 1.29
        },
        "51169": {
          "name": "Scott",
          "median": 1.2,
          "10%": 1.1,
          "90%": 1.33,
          "25%": 1.14,
          "75%": 1.28
        },
        "51171": {
          "name": "Shenandoah",
          "median": 1.21,
          "10%": 1.05,
          "90%": 1.36,
          "25%": 1.15,
          "75%": 1.28
        },
        "51173": {
          "name": "Smyth",
          "median": 1.17,
          "10%": 1.08,
          "90%": 1.28,
          "25%": 1.1,
          "75%": 1.23
        },
        "42109": {
          "name": "Snyder",
          "median": 1.21,
          "10%": 1.09,
          "90%": 1.32,
          "25%": 1.14,
          "75%": 1.27
        },
        "24039": {
          "name": "Somerset",
          "median": 1.17,
          "10%": 1.05,
          "90%": 1.37,
          "25%": 1.11,
          "75%": 1.24
        },
        "42111": {
          "name": "Somerset",
          "median": 1.16,
          "10%": 1.08,
          "90%": 1.3,
          "25%": 1.11,
          "75%": 1.22
        },
        "51175": {
          "name": "Southampton",
          "median": 1.18,
          "10%": 1.03,
          "90%": 1.33,
          "25%": 1.08,
          "75%": 1.25
        },
        "51177": {
          "name": "Spotsylvania",
          "median": 1.15,
          "10%": 1.03,
          "90%": 1.33,
          "25%": 1.1,
          "75%": 1.27
        },
        "24037": {
          "name": "St. Mary's",
          "median": 1.17,
          "10%": 1.01,
          "90%": 1.32,
          "25%": 1.07,
          "75%": 1.26
        },
        "51179": {
          "name": "Stafford",
          "median": 1.16,
          "10%": 1.03,
          "90%": 1.38,
          "25%": 1.1,
          "75%": 1.29
        },
        "51790": {
          "name": "Staunton",
          "median": 1.23,
          "10%": 1.01,
          "90%": 1.42,
          "25%": 1.13,
          "75%": 1.33
        },
        "36101": {
          "name": "Steuben",
          "median": 1.21,
          "10%": 1.06,
          "90%": 1.31,
          "25%": 1.13,
          "75%": 1.25
        },
        "51800": {
          "name": "Suffolk",
          "median": 1.18,
          "10%": 1.04,
          "90%": 1.36,
          "25%": 1.11,
          "75%": 1.29
        },
        "36105": {
          "name": "Sullivan",
          "median": 1.23,
          "10%": 1.08,
          "90%": 1.35,
          "25%": 1.14,
          "75%": 1.29
        },
        "42113": {
          "name": "Sullivan",
          "median": 1.18,
          "10%": 1.06,
          "90%": 1.32,
          "25%": 1.12,
          "75%": 1.25
        },
        "54089": {
          "name": "Summers",
          "median": 1.16,
          "10%": 1.08,
          "90%": 1.3,
          "25%": 1.1,
          "75%": 1.2
        },
        "51181": {
          "name": "Surry",
          "median": 1.15,
          "10%": 1.02,
          "90%": 1.29,
          "25%": 1.1,
          "75%": 1.22
        },
        "42115": {
          "name": "Susquehanna",
          "median": 1.18,
          "10%": 1.07,
          "90%": 1.27,
          "25%": 1.12,
          "75%": 1.22
        },
        "10005": {
          "name": "Sussex",
          "median": 1.16,
          "10%": 1.05,
          "90%": 1.32,
          "25%": 1.1,
          "75%": 1.23
        },
        "34037": {
          "name": "Sussex",
          "median": 1.23,
          "10%": 1.06,
          "90%": 1.42,
          "25%": 1.13,
          "75%": 1.31
        },
        "51183": {
          "name": "Sussex",
          "median": 1.17,
          "10%": 1.04,
          "90%": 1.3,
          "25%": 1.1,
          "75%": 1.23
        },
        "24041": {
          "name": "Talbot",
          "median": 1.15,
          "10%": 0.99,
          "90%": 1.28,
          "25%": 1.06,
          "75%": 1.22
        },
        "54091": {
          "name": "Taylor",
          "median": 1.17,
          "10%": 1.06,
          "90%": 1.29,
          "25%": 1.11,
          "75%": 1.25
        },
        "51185": {
          "name": "Tazewell",
          "median": 1.15,
          "10%": 1.06,
          "90%": 1.24,
          "25%": 1.1,
          "75%": 1.21
        },
        "36107": {
          "name": "Tioga",
          "median": 1.15,
          "10%": 1.04,
          "90%": 1.24,
          "25%": 1.09,
          "75%": 1.2
        },
        "42117": {
          "name": "Tioga",
          "median": 1.18,
          "10%": 1.08,
          "90%": 1.31,
          "25%": 1.12,
          "75%": 1.25
        },
        "36109": {
          "name": "Tompkins",
          "median": 1.17,
          "10%": 1.09,
          "90%": 1.29,
          "25%": 1.12,
          "75%": 1.22
        },
        "54093": {
          "name": "Tucker",
          "median": 1.15,
          "10%": 1.06,
          "90%": 1.31,
          "25%": 1.11,
          "75%": 1.22
        },
        "54095": {
          "name": "Tyler",
          "median": 1.13,
          "10%": 0.99,
          "90%": 1.24,
          "25%": 1.04,
          "75%": 1.18
        },
        "36111": {
          "name": "Ulster",
          "median": 1.23,
          "10%": 1.09,
          "90%": 1.4,
          "25%": 1.16,
          "75%": 1.34
        },
        "42119": {
          "name": "Union",
          "median": 1.19,
          "10%": 1.1,
          "90%": 1.33,
          "25%": 1.13,
          "75%": 1.25
        },
        "54097": {
          "name": "Upshur",
          "median": 1.17,
          "10%": 1.06,
          "90%": 1.29,
          "25%": 1.1,
          "75%": 1.22
        },
        "42121": {
          "name": "Venango",
          "median": 1.19,
          "10%": 1.03,
          "90%": 1.35,
          "25%": 1.12,
          "75%": 1.27
        },
        "51810": {
          "name": "Virginia Beach",
          "median": 1.2,
          "10%": 1.02,
          "90%": 1.44,
          "25%": 1.08,
          "75%": 1.32
        },
        "34041": {
          "name": "Warren",
          "median": 1.2,
          "10%": 1.08,
          "90%": 1.41,
          "25%": 1.14,
          "75%": 1.28
        },
        "42123": {
          "name": "Warren",
          "median": 1.17,
          "10%": 1.0,
          "90%": 1.36,
          "25%": 1.07,
          "75%": 1.27
        },
        "51187": {
          "name": "Warren",
          "median": 1.24,
          "10%": 1.09,
          "90%": 1.37,
          "25%": 1.17,
          "75%": 1.3
        },
        "24043": {
          "name": "Washington",
          "median": 1.19,
          "10%": 1.06,
          "90%": 1.36,
          "25%": 1.13,
          "75%": 1.27
        },
        "42125": {
          "name": "Washington",
          "median": 1.175,
          "10%": 1.07,
          "90%": 1.34,
          "25%": 1.12,
          "75%": 1.26
        },
        "51191": {
          "name": "Washington",
          "median": 1.15,
          "10%": 1.04,
          "90%": 1.31,
          "25%": 1.09,
          "75%": 1.2
        },
        "42127": {
          "name": "Wayne",
          "median": 1.22,
          "10%": 1.05,
          "90%": 1.33,
          "25%": 1.15,
          "75%": 1.27
        },
        "54099": {
          "name": "Wayne",
          "median": 1.17,
          "10%": 1.06,
          "90%": 1.33,
          "25%": 1.12,
          "75%": 1.25
        },
        "51820": {
          "name": "Waynesboro",
          "median": 1.21,
          "10%": 1.04,
          "90%": 1.43,
          "25%": 1.13,
          "75%": 1.34
        },
        "54101": {
          "name": "Webster",
          "median": 1.13,
          "10%": 1.01,
          "90%": 1.24,
          "25%": 1.07,
          "75%": 1.19
        },
        "36119": {
          "name": "Westchester",
          "median": 1.2,
          "10%": 1.06,
          "90%": 1.32,
          "25%": 1.13,
          "75%": 1.26
        },
        "42129": {
          "name": "Westmoreland",
          "median": 1.17,
          "10%": 1.06,
          "90%": 1.32,
          "25%": 1.11,
          "75%": 1.23
        },
        "51193": {
          "name": "Westmoreland",
          "median": 1.14,
          "10%": 0.98,
          "90%": 1.36,
          "25%": 1.06,
          "75%": 1.27
        },
        "54103": {
          "name": "Wetzel",
          "median": 1.16,
          "10%": 1.07,
          "90%": 1.3,
          "25%": 1.1,
          "75%": 1.24
        },
        "24045": {
          "name": "Wicomico",
          "median": 1.14,
          "10%": 1.05,
          "90%": 1.3,
          "25%": 1.11,
          "75%": 1.22
        },
        "51830": {
          "name": "Williamsburg",
          "median": 1.12,
          "10%": 0.96,
          "90%": 1.26,
          "25%": 1.05,
          "75%": 1.19
        },
        "51840": {
          "name": "Winchester",
          "median": 1.21,
          "10%": 1.08,
          "90%": 1.39,
          "25%": 1.13,
          "75%": 1.29
        },
        "54105": {
          "name": "Wirt",
          "median": 1.23,
          "10%": 1.11,
          "90%": 1.4,
          "25%": 1.17,
          "75%": 1.34
        },
        "51195": {
          "name": "Wise",
          "median": 1.18,
          "10%": 1.08,
          "90%": 1.34,
          "25%": 1.12,
          "75%": 1.28
        },
        "54107": {
          "name": "Wood",
          "median": 1.205,
          "10%": 1.03,
          "90%": 1.35,
          "25%": 1.11,
          "75%": 1.27
        },
        "24047": {
          "name": "Worcester",
          "median": 1.16,
          "10%": 1.05,
          "90%": 1.37,
          "25%": 1.09,
          "75%": 1.25
        },
        "42131": {
          "name": "Wyoming",
          "median": 1.19,
          "10%": 1.1,
          "90%": 1.32,
          "25%": 1.15,
          "75%": 1.26
        },
        "54109": {
          "name": "Wyoming",
          "median": 1.18,
          "10%": 1.08,
          "90%": 1.34,
          "25%": 1.12,
          "75%": 1.23
        },
        "51197": {
          "name": "Wythe",
          "median": 1.16,
          "10%": 1.05,
          "90%": 1.3,
          "25%": 1.08,
          "75%": 1.23
        },
        "36123": {
          "name": "Yates",
          "median": 1.21,
          "10%": 1.03,
          "90%": 1.35,
          "25%": 1.09,
          "75%": 1.27
        },
        "42133": {
          "name": "York",
          "median": 1.2,
          "10%": 1.05,
          "90%": 1.35,
          "25%": 1.09,
          "75%": 1.28
        },
        "51199": {
          "name": "York",
          "median": 1.16,
          "10%": 1.01,
          "90%": 1.29,
          "25%": 1.1,
          "75%": 1.19
        },
        "max": 1.26,
        "min": 1
      },
      "25": {
        "51001": {
          "name": "Accomack",
          "median": 1.18,
          "10%": 1.02,
          "90%": 1.31,
          "25%": 1.09,
          "75%": 1.26
        },
        "42001": {
          "name": "Adams",
          "median": 1.15,
          "10%": 0.97,
          "90%": 1.44,
          "25%": 1.07,
          "75%": 1.3
        },
        "51003": {
          "name": "Albemarle",
          "median": 1.18,
          "10%": 0.97,
          "90%": 1.42,
          "25%": 1.12,
          "75%": 1.32
        },
        "51510": {
          "name": "Alexandria",
          "median": 1.13,
          "10%": 0.91,
          "90%": 1.39,
          "25%": 1.02,
          "75%": 1.25
        },
        "24001": {
          "name": "Allegany",
          "median": 1.22,
          "10%": 1.06,
          "90%": 1.42,
          "25%": 1.13,
          "75%": 1.31
        },
        "36003": {
          "name": "Allegany",
          "median": 1.18,
          "10%": 1.01,
          "90%": 1.33,
          "25%": 1.09,
          "75%": 1.26
        },
        "51005": {
          "name": "Alleghany",
          "median": 1.22,
          "10%": 1.04,
          "90%": 1.44,
          "25%": 1.12,
          "75%": 1.32
        },
        "42003": {
          "name": "Allegheny",
          "median": 1.16,
          "10%": 1.03,
          "90%": 1.36,
          "25%": 1.08,
          "75%": 1.25
        },
        "51007": {
          "name": "Amelia",
          "median": 1.18,
          "10%": 1.0,
          "90%": 1.48,
          "25%": 1.09,
          "75%": 1.3
        },
        "51009": {
          "name": "Amherst",
          "median": 1.22,
          "10%": 1.03,
          "90%": 1.42,
          "25%": 1.12,
          "75%": 1.33
        },
        "24003": {
          "name": "Anne Arundel",
          "median": 1.15,
          "10%": 0.98,
          "90%": 1.36,
          "25%": 1.03,
          "75%": 1.28
        },
        "51011": {
          "name": "Appomattox",
          "median": 1.19,
          "10%": 1.04,
          "90%": 1.43,
          "25%": 1.09,
          "75%": 1.33
        },
        "51013": {
          "name": "Arlington",
          "median": 1.13,
          "10%": 0.95,
          "90%": 1.33,
          "25%": 1.04,
          "75%": 1.22
        },
        "42005": {
          "name": "Armstrong",
          "median": 1.18,
          "10%": 1.05,
          "90%": 1.4,
          "25%": 1.09,
          "75%": 1.33
        },
        "34001": {
          "name": "Atlantic",
          "median": 1.21,
          "10%": 1.05,
          "90%": 1.44,
          "25%": 1.11,
          "75%": 1.28
        },
        "51015": {
          "name": "Augusta",
          "median": 1.21,
          "10%": 1.0,
          "90%": 1.37,
          "25%": 1.08,
          "75%": 1.3
        },
        "24005": {
          "name": "Baltimore",
          "median": 1.15,
          "10%": 1.01,
          "90%": 1.37,
          "25%": 1.08,
          "75%": 1.24
        },
        "24510": {
          "name": "Baltimore",
          "median": 1.13,
          "10%": 0.98,
          "90%": 1.38,
          "25%": 1.02,
          "75%": 1.26
        },
        "54001": {
          "name": "Barbour",
          "median": 1.15,
          "10%": 1.01,
          "90%": 1.34,
          "25%": 1.09,
          "75%": 1.24
        },
        "51017": {
          "name": "Bath",
          "median": 1.23,
          "10%": 1.04,
          "90%": 1.48,
          "25%": 1.1,
          "75%": 1.38
        },
        "42007": {
          "name": "Beaver",
          "median": 1.14,
          "10%": 1.0,
          "90%": 1.31,
          "25%": 1.06,
          "75%": 1.24
        },
        "42009": {
          "name": "Bedford",
          "median": 1.23,
          "10%": 1.09,
          "90%": 1.39,
          "25%": 1.16,
          "75%": 1.31
        },
        "51019": {
          "name": "Bedford",
          "median": 1.23,
          "10%": 1.08,
          "90%": 1.38,
          "25%": 1.15,
          "75%": 1.3
        },
        "54003": {
          "name": "Berkeley",
          "median": 1.18,
          "10%": 1.05,
          "90%": 1.37,
          "25%": 1.11,
          "75%": 1.27
        },
        "42011": {
          "name": "Berks",
          "median": 1.21,
          "10%": 1.01,
          "90%": 1.43,
          "25%": 1.12,
          "75%": 1.3
        },
        "42013": {
          "name": "Blair",
          "median": 1.22,
          "10%": 1.06,
          "90%": 1.37,
          "25%": 1.14,
          "75%": 1.31
        },
        "51021": {
          "name": "Bland",
          "median": 1.14,
          "10%": 1.02,
          "90%": 1.29,
          "25%": 1.07,
          "75%": 1.21
        },
        "54005": {
          "name": "Boone",
          "median": 1.19,
          "10%": 1.04,
          "90%": 1.31,
          "25%": 1.09,
          "75%": 1.26
        },
        "51023": {
          "name": "Botetourt",
          "median": 1.24,
          "10%": 1.08,
          "90%": 1.41,
          "25%": 1.16,
          "75%": 1.34
        },
        "42015": {
          "name": "Bradford",
          "median": 1.2,
          "10%": 1.04,
          "90%": 1.38,
          "25%": 1.11,
          "75%": 1.28
        },
        "54007": {
          "name": "Braxton",
          "median": 1.13,
          "10%": 1.01,
          "90%": 1.29,
          "25%": 1.05,
          "75%": 1.2
        },
        "51520": {
          "name": "Bristol",
          "median": 1.16,
          "10%": 1.07,
          "90%": 1.32,
          "25%": 1.11,
          "75%": 1.25
        },
        "36005": {
          "name": "Bronx",
          "median": 1.16,
          "10%": 1.03,
          "90%": 1.33,
          "25%": 1.08,
          "75%": 1.26
        },
        "54009": {
          "name": "Brooke",
          "median": 1.2,
          "10%": 1.0,
          "90%": 1.39,
          "25%": 1.1,
          "75%": 1.29
        },
        "36007": {
          "name": "Broome",
          "median": 1.17,
          "10%": 1.02,
          "90%": 1.31,
          "25%": 1.09,
          "75%": 1.24
        },
        "51025": {
          "name": "Brunswick",
          "median": 1.17,
          "10%": 1.02,
          "90%": 1.37,
          "25%": 1.1,
          "75%": 1.28
        },
        "51027": {
          "name": "Buchanan",
          "median": 1.14,
          "10%": 1.01,
          "90%": 1.3,
          "25%": 1.08,
          "75%": 1.25
        },
        "51029": {
          "name": "Buckingham",
          "median": 1.18,
          "10%": 1.03,
          "90%": 1.411,
          "25%": 1.1,
          "75%": 1.27
        },
        "42017": {
          "name": "Bucks",
          "median": 1.15,
          "10%": 1.02,
          "90%": 1.34,
          "25%": 1.1,
          "75%": 1.24
        },
        "51530": {
          "name": "Buena Vista",
          "median": 1.19,
          "10%": 1.0,
          "90%": 1.47,
          "25%": 1.11,
          "75%": 1.32
        },
        "34005": {
          "name": "Burlington",
          "median": 1.15,
          "10%": 1.03,
          "90%": 1.29,
          "25%": 1.07,
          "75%": 1.22
        },
        "42019": {
          "name": "Butler",
          "median": 1.15,
          "10%": 1.05,
          "90%": 1.32,
          "25%": 1.09,
          "75%": 1.26
        },
        "54011": {
          "name": "Cabell",
          "median": 1.18,
          "10%": 1.02,
          "90%": 1.39,
          "25%": 1.11,
          "75%": 1.26
        },
        "54013": {
          "name": "Calhoun",
          "median": 1.21,
          "10%": 1.02,
          "90%": 1.44,
          "25%": 1.11,
          "75%": 1.32
        },
        "24009": {
          "name": "Calvert",
          "median": 1.18,
          "10%": 0.98,
          "90%": 1.36,
          "25%": 1.07,
          "75%": 1.28
        },
        "42021": {
          "name": "Cambria",
          "median": 1.17,
          "10%": 1.03,
          "90%": 1.37,
          "25%": 1.1,
          "75%": 1.26
        },
        "34007": {
          "name": "Camden",
          "median": 1.18,
          "10%": 1.01,
          "90%": 1.34,
          "25%": 1.08,
          "75%": 1.25
        },
        "42023": {
          "name": "Cameron",
          "median": 1.19,
          "10%": 1.04,
          "90%": 1.34,
          "25%": 1.11,
          "75%": 1.27
        },
        "51031": {
          "name": "Campbell",
          "median": 1.2,
          "10%": 1.05,
          "90%": 1.35,
          "25%": 1.12,
          "75%": 1.29
        },
        "34009": {
          "name": "Cape May",
          "median": 1.22,
          "10%": 1.04,
          "90%": 1.38,
          "25%": 1.14,
          "75%": 1.3
        },
        "42025": {
          "name": "Carbon",
          "median": 1.21,
          "10%": 1.02,
          "90%": 1.37,
          "25%": 1.16,
          "75%": 1.27
        },
        "24011": {
          "name": "Caroline",
          "median": 1.19,
          "10%": 1.03,
          "90%": 1.38,
          "25%": 1.1,
          "75%": 1.27
        },
        "51033": {
          "name": "Caroline",
          "median": 1.16,
          "10%": 0.99,
          "90%": 1.43,
          "25%": 1.0575,
          "75%": 1.27
        },
        "24013": {
          "name": "Carroll",
          "median": 1.16,
          "10%": 1.02,
          "90%": 1.46,
          "25%": 1.08,
          "75%": 1.29
        },
        "51035": {
          "name": "Carroll",
          "median": 1.16,
          "10%": 1.06,
          "90%": 1.35,
          "25%": 1.11,
          "75%": 1.26
        },
        "24015": {
          "name": "Cecil",
          "median": 1.17,
          "10%": 1.0,
          "90%": 1.33,
          "25%": 1.1,
          "75%": 1.26
        },
        "42027": {
          "name": "Centre",
          "median": 1.22,
          "10%": 1.06,
          "90%": 1.39,
          "25%": 1.15,
          "75%": 1.3
        },
        "24017": {
          "name": "Charles",
          "median": 1.19,
          "10%": 0.97,
          "90%": 1.431,
          "25%": 1.06,
          "75%": 1.33
        },
        "51036": {
          "name": "Charles City",
          "median": 1.15,
          "10%": 1.0,
          "90%": 1.31,
          "25%": 1.06,
          "75%": 1.21
        },
        "51037": {
          "name": "Charlotte",
          "median": 1.19,
          "10%": 1.06,
          "90%": 1.36,
          "25%": 1.11,
          "75%": 1.27
        },
        "51540": {
          "name": "Charlottesville",
          "median": 1.16,
          "10%": 0.96,
          "90%": 1.42,
          "25%": 1.09,
          "75%": 1.31
        },
        "36015": {
          "name": "Chemung",
          "median": 1.17,
          "10%": 1.05,
          "90%": 1.36,
          "25%": 1.11,
          "75%": 1.24
        },
        "36017": {
          "name": "Chenango",
          "median": 1.17,
          "10%": 1.03,
          "90%": 1.33,
          "25%": 1.08,
          "75%": 1.25
        },
        "51550": {
          "name": "Chesapeake",
          "median": 1.21,
          "10%": 1.03,
          "90%": 1.43,
          "25%": 1.1,
          "75%": 1.36
        },
        "42029": {
          "name": "Chester",
          "median": 1.2,
          "10%": 1.01,
          "90%": 1.4,
          "25%": 1.11,
          "75%": 1.32
        },
        "51041": {
          "name": "Chesterfield",
          "median": 1.17,
          "10%": 1.0,
          "90%": 1.42,
          "25%": 1.08,
          "75%": 1.29
        },
        "42031": {
          "name": "Clarion",
          "median": 1.17,
          "10%": 1.05,
          "90%": 1.39,
          "25%": 1.1,
          "75%": 1.31
        },
        "51043": {
          "name": "Clarke",
          "median": 1.15,
          "10%": 1.02,
          "90%": 1.39,
          "25%": 1.09,
          "75%": 1.25
        },
        "54015": {
          "name": "Clay",
          "median": 1.12,
          "10%": 0.99,
          "90%": 1.28,
          "25%": 1.05,
          "75%": 1.2
        },
        "42033": {
          "name": "Clearfield",
          "median": 1.18,
          "10%": 1.05,
          "90%": 1.36,
          "25%": 1.12,
          "75%": 1.28
        },
        "42035": {
          "name": "Clinton",
          "median": 1.21,
          "10%": 1.05,
          "90%": 1.39,
          "25%": 1.14,
          "75%": 1.29
        },
        "51570": {
          "name": "Colonial Heights",
          "median": 1.16,
          "10%": 1.01,
          "90%": 1.41,
          "25%": 1.08,
          "75%": 1.2725
        },
        "42037": {
          "name": "Columbia",
          "median": 1.24,
          "10%": 1.05,
          "90%": 1.39,
          "25%": 1.1575,
          "75%": 1.32
        },
        "36023": {
          "name": "Cortland",
          "median": 1.2,
          "10%": 1.05,
          "90%": 1.36,
          "25%": 1.11,
          "75%": 1.26
        },
        "51580": {
          "name": "Covington",
          "median": 1.175,
          "10%": 1.01,
          "90%": 1.45,
          "25%": 1.07,
          "75%": 1.32
        },
        "51045": {
          "name": "Craig",
          "median": 1.23,
          "10%": 1.08,
          "90%": 1.4,
          "25%": 1.14,
          "75%": 1.31
        },
        "42039": {
          "name": "Crawford",
          "median": 1.15,
          "10%": 1.0,
          "90%": 1.34,
          "25%": 1.07,
          "75%": 1.25
        },
        "51047": {
          "name": "Culpeper",
          "median": 1.18,
          "10%": 1.05,
          "90%": 1.36,
          "25%": 1.11,
          "75%": 1.26
        },
        "34011": {
          "name": "Cumberland",
          "median": 1.18,
          "10%": 1.04,
          "90%": 1.39,
          "25%": 1.1,
          "75%": 1.28
        },
        "42041": {
          "name": "Cumberland",
          "median": 1.18,
          "10%": 1.05,
          "90%": 1.39,
          "25%": 1.1,
          "75%": 1.29
        },
        "51049": {
          "name": "Cumberland",
          "median": 1.15,
          "10%": 1.04,
          "90%": 1.41,
          "25%": 1.07,
          "75%": 1.29
        },
        "51590": {
          "name": "Danville",
          "median": 1.19,
          "10%": 0.99,
          "90%": 1.41,
          "25%": 1.08,
          "75%": 1.31
        },
        "42043": {
          "name": "Dauphin",
          "median": 1.24,
          "10%": 1.02,
          "90%": 1.42,
          "25%": 1.13,
          "75%": 1.34
        },
        "36025": {
          "name": "Delaware",
          "median": 1.2,
          "10%": 1.08,
          "90%": 1.38,
          "25%": 1.14,
          "75%": 1.28
        },
        "42045": {
          "name": "Delaware",
          "median": 1.22,
          "10%": 0.99,
          "90%": 1.45,
          "25%": 1.12,
          "75%": 1.32
        },
        "51051": {
          "name": "Dickenson",
          "median": 1.16,
          "10%": 1.02,
          "90%": 1.31,
          "25%": 1.1,
          "75%": 1.24
        },
        "51053": {
          "name": "Dinwiddie",
          "median": 1.17,
          "10%": 1.03,
          "90%": 1.31,
          "25%": 1.08,
          "75%": 1.25
        },
        "11001": {
          "name": "District of Columbia",
          "median": 1.13,
          "10%": 0.97,
          "90%": 1.34,
          "25%": 1.05,
          "75%": 1.27
        },
        "54017": {
          "name": "Doddridge",
          "median": 1.15,
          "10%": 0.99,
          "90%": 1.27,
          "25%": 1.08,
          "75%": 1.22
        },
        "24019": {
          "name": "Dorchester",
          "median": 1.14,
          "10%": 0.95,
          "90%": 1.33,
          "25%": 1.05,
          "75%": 1.22
        },
        "42047": {
          "name": "Elk",
          "median": 1.15,
          "10%": 0.96,
          "90%": 1.32,
          "25%": 1.05,
          "75%": 1.27
        },
        "51595": {
          "name": "Emporia",
          "median": 1.13,
          "10%": 0.96,
          "90%": 1.28,
          "25%": 1.05,
          "75%": 1.21
        },
        "42049": {
          "name": "Erie",
          "median": 1.18,
          "10%": 1.02,
          "90%": 1.37,
          "25%": 1.07,
          "75%": 1.26
        },
        "51057": {
          "name": "Essex",
          "median": 1.14,
          "10%": 0.96,
          "90%": 1.35,
          "25%": 1.02,
          "75%": 1.28
        },
        "51059": {
          "name": "Fairfax",
          "median": 1.15,
          "10%": 1.0,
          "90%": 1.32,
          "25%": 1.05,
          "75%": 1.22
        },
        "51600": {
          "name": "Fairfax",
          "median": 1.14,
          "10%": 1.0,
          "90%": 1.301,
          "25%": 1.0575,
          "75%": 1.22
        },
        "51610": {
          "name": "Falls Church",
          "median": 1.13,
          "10%": 0.99,
          "90%": 1.33,
          "25%": 1.03,
          "75%": 1.23
        },
        "51061": {
          "name": "Fauquier",
          "median": 1.18,
          "10%": 1.01,
          "90%": 1.4,
          "25%": 1.1,
          "75%": 1.27
        },
        "42051": {
          "name": "Fayette",
          "median": 1.19,
          "10%": 1.05,
          "90%": 1.37,
          "25%": 1.11,
          "75%": 1.3
        },
        "54019": {
          "name": "Fayette",
          "median": 1.13,
          "10%": 1.05,
          "90%": 1.3,
          "25%": 1.08,
          "75%": 1.18
        },
        "51063": {
          "name": "Floyd",
          "median": 1.19,
          "10%": 0.98,
          "90%": 1.37,
          "25%": 1.09,
          "75%": 1.25
        },
        "51065": {
          "name": "Fluvanna",
          "median": 1.18,
          "10%": 0.97,
          "90%": 1.6,
          "25%": 1.09,
          "75%": 1.34
        },
        "42053": {
          "name": "Forest",
          "median": 1.16,
          "10%": 0.96,
          "90%": 1.4,
          "25%": 1.04,
          "75%": 1.29
        },
        "42055": {
          "name": "Franklin",
          "median": 1.18,
          "10%": 1.06,
          "90%": 1.42,
          "25%": 1.1,
          "75%": 1.31
        },
        "51067": {
          "name": "Franklin",
          "median": 1.22,
          "10%": 1.02,
          "90%": 1.42,
          "25%": 1.12,
          "75%": 1.35
        },
        "51620": {
          "name": "Franklin",
          "median": 1.22,
          "10%": 1.03,
          "90%": 1.44,
          "25%": 1.09,
          "75%": 1.32
        },
        "24021": {
          "name": "Frederick",
          "median": 1.16,
          "10%": 1.03,
          "90%": 1.42,
          "25%": 1.1,
          "75%": 1.28
        },
        "51069": {
          "name": "Frederick",
          "median": 1.21,
          "10%": 1.07,
          "90%": 1.39,
          "25%": 1.11,
          "75%": 1.3
        },
        "51630": {
          "name": "Fredericksburg",
          "median": 1.16,
          "10%": 0.96,
          "90%": 1.45,
          "25%": 1.05,
          "75%": 1.32
        },
        "42057": {
          "name": "Fulton",
          "median": 1.25,
          "10%": 1.04,
          "90%": 1.45,
          "25%": 1.17,
          "75%": 1.35
        },
        "51640": {
          "name": "Galax",
          "median": 1.14,
          "10%": 0.92,
          "90%": 1.37,
          "25%": 1.03,
          "75%": 1.28
        },
        "24023": {
          "name": "Garrett",
          "median": 1.14,
          "10%": 1.04,
          "90%": 1.35,
          "25%": 1.1,
          "75%": 1.23
        },
        "51071": {
          "name": "Giles",
          "median": 1.2,
          "10%": 1.06,
          "90%": 1.31,
          "25%": 1.13,
          "75%": 1.25
        },
        "54021": {
          "name": "Gilmer",
          "median": 1.15,
          "10%": 1.03,
          "90%": 1.36,
          "25%": 1.08,
          "75%": 1.26
        },
        "34015": {
          "name": "Gloucester",
          "median": 1.19,
          "10%": 1.01,
          "90%": 1.41,
          "25%": 1.12,
          "75%": 1.27
        },
        "51073": {
          "name": "Gloucester",
          "median": 1.17,
          "10%": 0.98,
          "90%": 1.29,
          "25%": 1.08,
          "75%": 1.22
        },
        "51075": {
          "name": "Goochland",
          "median": 1.19,
          "10%": 0.91,
          "90%": 1.54,
          "25%": 1.06,
          "75%": 1.31
        },
        "54023": {
          "name": "Grant",
          "median": 1.14,
          "10%": 1.04,
          "90%": 1.36,
          "25%": 1.09,
          "75%": 1.24
        },
        "51077": {
          "name": "Grayson",
          "median": 1.15,
          "10%": 1.04,
          "90%": 1.33,
          "25%": 1.09,
          "75%": 1.25
        },
        "54025": {
          "name": "Greenbrier",
          "median": 1.17,
          "10%": 1.03,
          "90%": 1.3,
          "25%": 1.12,
          "75%": 1.26
        },
        "36039": {
          "name": "Greene",
          "median": 1.28,
          "10%": 1.06,
          "90%": 1.47,
          "25%": 1.16,
          "75%": 1.39
        },
        "42059": {
          "name": "Greene",
          "median": 1.21,
          "10%": 1.05,
          "90%": 1.35,
          "25%": 1.12,
          "75%": 1.28
        },
        "51079": {
          "name": "Greene",
          "median": 1.18,
          "10%": 1.02,
          "90%": 1.43,
          "25%": 1.11,
          "75%": 1.31
        },
        "51081": {
          "name": "Greensville",
          "median": 1.15,
          "10%": 0.98,
          "90%": 1.3,
          "25%": 1.07,
          "75%": 1.24
        },
        "51083": {
          "name": "Halifax",
          "median": 1.21,
          "10%": 1.07,
          "90%": 1.42,
          "25%": 1.13,
          "75%": 1.31
        },
        "54027": {
          "name": "Hampshire",
          "median": 1.22,
          "10%": 1.1,
          "90%": 1.46,
          "25%": 1.13,
          "75%": 1.35
        },
        "51650": {
          "name": "Hampton",
          "median": 1.19,
          "10%": 1.02,
          "90%": 1.35,
          "25%": 1.07,
          "75%": 1.26
        },
        "54029": {
          "name": "Hancock",
          "median": 1.16,
          "10%": 1.01,
          "90%": 1.32,
          "25%": 1.06,
          "75%": 1.25
        },
        "51085": {
          "name": "Hanover",
          "median": 1.13,
          "10%": 1.01,
          "90%": 1.38,
          "25%": 1.07,
          "75%": 1.28
        },
        "54031": {
          "name": "Hardy",
          "median": 1.2,
          "10%": 1.04,
          "90%": 1.361,
          "25%": 1.13,
          "75%": 1.3
        },
        "24025": {
          "name": "Harford",
          "median": 1.17,
          "10%": 0.99,
          "90%": 1.39,
          "25%": 1.08,
          "75%": 1.26
        },
        "54033": {
          "name": "Harrison",
          "median": 1.13,
          "10%": 1.01,
          "90%": 1.3,
          "25%": 1.09,
          "75%": 1.23
        },
        "51660": {
          "name": "Harrisonburg",
          "median": 1.14,
          "10%": 0.98,
          "90%": 1.42,
          "25%": 1.05,
          "75%": 1.3
        },
        "51087": {
          "name": "Henrico",
          "median": 1.2,
          "10%": 0.99,
          "90%": 1.39,
          "25%": 1.05,
          "75%": 1.29
        },
        "51089": {
          "name": "Henry",
          "median": 1.24,
          "10%": 1.02,
          "90%": 1.5,
          "25%": 1.13,
          "75%": 1.3825
        },
        "36043": {
          "name": "Herkimer",
          "median": 1.12,
          "10%": 1.0,
          "90%": 1.32,
          "25%": 1.05,
          "75%": 1.23
        },
        "51091": {
          "name": "Highland",
          "median": 1.18,
          "10%": 1.04,
          "90%": 1.38,
          "25%": 1.09,
          "75%": 1.29
        },
        "51670": {
          "name": "Hopewell",
          "median": 1.14,
          "10%": 0.96,
          "90%": 1.33,
          "25%": 1.04,
          "75%": 1.2325
        },
        "24027": {
          "name": "Howard",
          "median": 1.14,
          "10%": 1.01,
          "90%": 1.39,
          "25%": 1.07,
          "75%": 1.24
        },
        "34019": {
          "name": "Hunterdon",
          "median": 1.18,
          "10%": 1.01,
          "90%": 1.401,
          "25%": 1.12,
          "75%": 1.27
        },
        "42061": {
          "name": "Huntingdon",
          "median": 1.23,
          "10%": 1.07,
          "90%": 1.39,
          "25%": 1.16,
          "75%": 1.34
        },
        "42063": {
          "name": "Indiana",
          "median": 1.18,
          "10%": 1.05,
          "90%": 1.4,
          "25%": 1.11,
          "75%": 1.29
        },
        "51093": {
          "name": "Isle of Wight",
          "median": 1.21,
          "10%": 1.03,
          "90%": 1.4,
          "25%": 1.11,
          "75%": 1.32
        },
        "54035": {
          "name": "Jackson",
          "median": 1.2,
          "10%": 1.03,
          "90%": 1.35,
          "25%": 1.11,
          "75%": 1.27
        },
        "51095": {
          "name": "James City",
          "median": 1.13,
          "10%": 0.96,
          "90%": 1.32,
          "25%": 1.03,
          "75%": 1.24
        },
        "42065": {
          "name": "Jefferson",
          "median": 1.19,
          "10%": 1.04,
          "90%": 1.36,
          "25%": 1.1,
          "75%": 1.3
        },
        "54037": {
          "name": "Jefferson",
          "median": 1.14,
          "10%": 1.02,
          "90%": 1.41,
          "25%": 1.07,
          "75%": 1.22
        },
        "42067": {
          "name": "Juniata",
          "median": 1.19,
          "10%": 1.07,
          "90%": 1.35,
          "25%": 1.11,
          "75%": 1.28
        },
        "54039": {
          "name": "Kanawha",
          "median": 1.1,
          "10%": 1.0,
          "90%": 1.23,
          "25%": 1.05,
          "75%": 1.16
        },
        "10001": {
          "name": "Kent",
          "median": 1.16,
          "10%": 1.03,
          "90%": 1.33,
          "25%": 1.09,
          "75%": 1.26
        },
        "24029": {
          "name": "Kent",
          "median": 1.18,
          "10%": 0.97,
          "90%": 1.34,
          "25%": 1.07,
          "75%": 1.28
        },
        "51099": {
          "name": "King George",
          "median": 1.13,
          "10%": 0.95,
          "90%": 1.41,
          "25%": 1.03,
          "75%": 1.32
        },
        "51101": {
          "name": "King William",
          "median": 1.12,
          "10%": 0.99,
          "90%": 1.32,
          "25%": 1.05,
          "75%": 1.22
        },
        "51097": {
          "name": "King and Queen",
          "median": 1.11,
          "10%": 0.96,
          "90%": 1.33,
          "25%": 1.04,
          "75%": 1.21
        },
        "42069": {
          "name": "Lackawanna",
          "median": 1.24,
          "10%": 1.05,
          "90%": 1.41,
          "25%": 1.16,
          "75%": 1.34
        },
        "42071": {
          "name": "Lancaster",
          "median": 1.22,
          "10%": 1.04,
          "90%": 1.46,
          "25%": 1.09,
          "75%": 1.31
        },
        "51103": {
          "name": "Lancaster",
          "median": 1.14,
          "10%": 0.97,
          "90%": 1.31,
          "25%": 1.03,
          "75%": 1.22
        },
        "42073": {
          "name": "Lawrence",
          "median": 1.16,
          "10%": 0.99,
          "90%": 1.3,
          "25%": 1.06,
          "75%": 1.24
        },
        "42075": {
          "name": "Lebanon",
          "median": 1.205,
          "10%": 0.98,
          "90%": 1.37,
          "25%": 1.1,
          "75%": 1.29
        },
        "51105": {
          "name": "Lee",
          "median": 1.24,
          "10%": 1.11,
          "90%": 1.46,
          "25%": 1.17,
          "75%": 1.34
        },
        "42077": {
          "name": "Lehigh",
          "median": 1.2,
          "10%": 1.039,
          "90%": 1.41,
          "25%": 1.11,
          "75%": 1.29
        },
        "54041": {
          "name": "Lewis",
          "median": 1.16,
          "10%": 1.05,
          "90%": 1.29,
          "25%": 1.09,
          "75%": 1.22
        },
        "51678": {
          "name": "Lexington",
          "median": 1.15,
          "10%": 1.02,
          "90%": 1.33,
          "25%": 1.06,
          "75%": 1.26
        },
        "54043": {
          "name": "Lincoln",
          "median": 1.16,
          "10%": 1.04,
          "90%": 1.38,
          "25%": 1.08,
          "75%": 1.27
        },
        "36051": {
          "name": "Livingston",
          "median": 1.18,
          "10%": 1.01,
          "90%": 1.36,
          "25%": 1.11,
          "75%": 1.29
        },
        "54045": {
          "name": "Logan",
          "median": 1.19,
          "10%": 1.06,
          "90%": 1.37,
          "25%": 1.11,
          "75%": 1.28
        },
        "51107": {
          "name": "Loudoun",
          "median": 1.15,
          "10%": 1.05,
          "90%": 1.37,
          "25%": 1.09,
          "75%": 1.26
        },
        "51109": {
          "name": "Louisa",
          "median": 1.19,
          "10%": 1.0,
          "90%": 1.48,
          "25%": 1.1,
          "75%": 1.3
        },
        "51111": {
          "name": "Lunenburg",
          "median": 1.22,
          "10%": 1.04,
          "90%": 1.36,
          "25%": 1.1,
          "75%": 1.3
        },
        "42079": {
          "name": "Luzerne",
          "median": 1.22,
          "10%": 1.07,
          "90%": 1.31,
          "25%": 1.16,
          "75%": 1.27
        },
        "42081": {
          "name": "Lycoming",
          "median": 1.21,
          "10%": 1.06,
          "90%": 1.39,
          "25%": 1.13,
          "75%": 1.29
        },
        "51680": {
          "name": "Lynchburg",
          "median": 1.18,
          "10%": 1.04,
          "90%": 1.34,
          "25%": 1.11,
          "75%": 1.27
        },
        "36053": {
          "name": "Madison",
          "median": 1.16,
          "10%": 0.99,
          "90%": 1.341,
          "25%": 1.1,
          "75%": 1.24
        },
        "51113": {
          "name": "Madison",
          "median": 1.18,
          "10%": 1.01,
          "90%": 1.39,
          "25%": 1.12,
          "75%": 1.3
        },
        "51683": {
          "name": "Manassas",
          "median": 1.11,
          "10%": 0.99,
          "90%": 1.32,
          "25%": 1.05,
          "75%": 1.21
        },
        "51685": {
          "name": "Manassas Park",
          "median": 1.1,
          "10%": 0.98,
          "90%": 1.34,
          "25%": 1.03,
          "75%": 1.22
        },
        "54049": {
          "name": "Marion",
          "median": 1.14,
          "10%": 1.01,
          "90%": 1.27,
          "25%": 1.06,
          "75%": 1.21
        },
        "54051": {
          "name": "Marshall",
          "median": 1.18,
          "10%": 1.01,
          "90%": 1.38,
          "25%": 1.09,
          "75%": 1.28
        },
        "51690": {
          "name": "Martinsville",
          "median": 1.24,
          "10%": 0.99,
          "90%": 1.56,
          "25%": 1.14,
          "75%": 1.41
        },
        "54053": {
          "name": "Mason",
          "median": 1.22,
          "10%": 1.03,
          "90%": 1.39,
          "25%": 1.14,
          "75%": 1.31
        },
        "51115": {
          "name": "Mathews",
          "median": 1.17,
          "10%": 0.99,
          "90%": 1.35,
          "25%": 1.1,
          "75%": 1.27
        },
        "54047": {
          "name": "McDowell",
          "median": 1.15,
          "10%": 1.04,
          "90%": 1.31,
          "25%": 1.1,
          "75%": 1.22
        },
        "42083": {
          "name": "McKean",
          "median": 1.16,
          "10%": 0.97,
          "90%": 1.3,
          "25%": 1.08,
          "75%": 1.25
        },
        "51117": {
          "name": "Mecklenburg",
          "median": 1.2,
          "10%": 1.05,
          "90%": 1.33,
          "25%": 1.12,
          "75%": 1.28
        },
        "34021": {
          "name": "Mercer",
          "median": 1.14,
          "10%": 0.98,
          "90%": 1.27,
          "25%": 1.04,
          "75%": 1.22
        },
        "42085": {
          "name": "Mercer",
          "median": 1.15,
          "10%": 1.02,
          "90%": 1.34,
          "25%": 1.08,
          "75%": 1.26
        },
        "54055": {
          "name": "Mercer",
          "median": 1.16,
          "10%": 1.04,
          "90%": 1.29,
          "25%": 1.1,
          "75%": 1.22
        },
        "51119": {
          "name": "Middlesex",
          "median": 1.13,
          "10%": 0.97,
          "90%": 1.28,
          "25%": 1.04,
          "75%": 1.2
        },
        "42087": {
          "name": "Mifflin",
          "median": 1.21,
          "10%": 1.09,
          "90%": 1.38,
          "25%": 1.14,
          "75%": 1.3
        },
        "54057": {
          "name": "Mineral",
          "median": 1.21,
          "10%": 1.06,
          "90%": 1.38,
          "25%": 1.11,
          "75%": 1.29
        },
        "54059": {
          "name": "Mingo",
          "median": 1.23,
          "10%": 1.07,
          "90%": 1.4,
          "25%": 1.13,
          "75%": 1.32
        },
        "34025": {
          "name": "Monmouth",
          "median": 1.15,
          "10%": 1.01,
          "90%": 1.29,
          "25%": 1.06,
          "75%": 1.22
        },
        "54061": {
          "name": "Monongalia",
          "median": 1.16,
          "10%": 1.03,
          "90%": 1.31,
          "25%": 1.07,
          "75%": 1.24
        },
        "42089": {
          "name": "Monroe",
          "median": 1.25,
          "10%": 1.06,
          "90%": 1.42,
          "25%": 1.15,
          "75%": 1.33
        },
        "54063": {
          "name": "Monroe",
          "median": 1.16,
          "10%": 1.05,
          "90%": 1.29,
          "25%": 1.11,
          "75%": 1.22
        },
        "24031": {
          "name": "Montgomery",
          "median": 1.15,
          "10%": 1.01,
          "90%": 1.371,
          "25%": 1.09,
          "75%": 1.23
        },
        "36057": {
          "name": "Montgomery",
          "median": 1.19,
          "10%": 1.03,
          "90%": 1.4,
          "25%": 1.1,
          "75%": 1.3
        },
        "42091": {
          "name": "Montgomery",
          "median": 1.18,
          "10%": 1.05,
          "90%": 1.37,
          "25%": 1.12,
          "75%": 1.28
        },
        "51121": {
          "name": "Montgomery",
          "median": 1.21,
          "10%": 1.09,
          "90%": 1.36,
          "25%": 1.14,
          "75%": 1.28
        },
        "42093": {
          "name": "Montour",
          "median": 1.26,
          "10%": 1.02,
          "90%": 1.44,
          "25%": 1.14,
          "75%": 1.36
        },
        "54065": {
          "name": "Morgan",
          "median": 1.22,
          "10%": 1.07,
          "90%": 1.45,
          "25%": 1.11,
          "75%": 1.34
        },
        "34027": {
          "name": "Morris",
          "median": 1.22,
          "10%": 1.04,
          "90%": 1.49,
          "25%": 1.12,
          "75%": 1.36
        },
        "36059": {
          "name": "Nassau",
          "median": 1.2,
          "10%": 1.07,
          "90%": 1.36,
          "25%": 1.12,
          "75%": 1.28
        },
        "51125": {
          "name": "Nelson",
          "median": 1.23,
          "10%": 0.98,
          "90%": 1.53,
          "25%": 1.12,
          "75%": 1.36
        },
        "10003": {
          "name": "New Castle",
          "median": 1.2,
          "10%": 1.03,
          "90%": 1.41,
          "25%": 1.1,
          "75%": 1.32
        },
        "51127": {
          "name": "New Kent",
          "median": 1.15,
          "10%": 1.0,
          "90%": 1.331,
          "25%": 1.06,
          "75%": 1.2
        },
        "36061": {
          "name": "New York",
          "median": 1.15,
          "10%": 0.99,
          "90%": 1.33,
          "25%": 1.06,
          "75%": 1.24
        },
        "51700": {
          "name": "Newport News",
          "median": 1.16,
          "10%": 1.01,
          "90%": 1.32,
          "25%": 1.08,
          "75%": 1.24
        },
        "54067": {
          "name": "Nicholas",
          "median": 1.13,
          "10%": 0.99,
          "90%": 1.26,
          "25%": 1.05,
          "75%": 1.2
        },
        "51710": {
          "name": "Norfolk",
          "median": 1.2,
          "10%": 1.0,
          "90%": 1.51,
          "25%": 1.09,
          "75%": 1.37
        },
        "42095": {
          "name": "Northampton",
          "median": 1.17,
          "10%": 1.02,
          "90%": 1.39,
          "25%": 1.08,
          "75%": 1.28
        },
        "51131": {
          "name": "Northampton",
          "median": 1.16,
          "10%": 0.97,
          "90%": 1.34,
          "25%": 1.07,
          "75%": 1.26
        },
        "42097": {
          "name": "Northumberland",
          "median": 1.25,
          "10%": 1.02,
          "90%": 1.43,
          "25%": 1.16,
          "75%": 1.35
        },
        "51133": {
          "name": "Northumberland",
          "median": 1.15,
          "10%": 0.95,
          "90%": 1.36,
          "25%": 1.04,
          "75%": 1.24
        },
        "51720": {
          "name": "Norton",
          "median": 1.22,
          "10%": 1.05,
          "90%": 1.4,
          "25%": 1.12,
          "75%": 1.31
        },
        "51135": {
          "name": "Nottoway",
          "median": 1.22,
          "10%": 1.03,
          "90%": 1.36,
          "25%": 1.08,
          "75%": 1.3
        },
        "34029": {
          "name": "Ocean",
          "median": 1.13,
          "10%": 1.04,
          "90%": 1.28,
          "25%": 1.08,
          "75%": 1.21
        },
        "54069": {
          "name": "Ohio",
          "median": 1.21,
          "10%": 1.02,
          "90%": 1.44,
          "25%": 1.09,
          "75%": 1.33
        },
        "36065": {
          "name": "Oneida",
          "median": 1.16,
          "10%": 1.0,
          "90%": 1.35,
          "25%": 1.09,
          "75%": 1.25
        },
        "36067": {
          "name": "Onondaga",
          "median": 1.19,
          "10%": 1.05,
          "90%": 1.37,
          "25%": 1.13,
          "75%": 1.26
        },
        "36069": {
          "name": "Ontario",
          "median": 1.19,
          "10%": 1.02,
          "90%": 1.33,
          "25%": 1.08,
          "75%": 1.25
        },
        "36071": {
          "name": "Orange",
          "median": 1.24,
          "10%": 1.04,
          "90%": 1.49,
          "25%": 1.17,
          "75%": 1.34
        },
        "51137": {
          "name": "Orange",
          "median": 1.2,
          "10%": 1.05,
          "90%": 1.43,
          "25%": 1.13,
          "75%": 1.29
        },
        "36077": {
          "name": "Otsego",
          "median": 1.16,
          "10%": 1.04,
          "90%": 1.37,
          "25%": 1.08,
          "75%": 1.23
        },
        "51139": {
          "name": "Page",
          "median": 1.22,
          "10%": 1.01,
          "90%": 1.5,
          "25%": 1.12,
          "75%": 1.32
        },
        "51141": {
          "name": "Patrick",
          "median": 1.2,
          "10%": 1.0,
          "90%": 1.44,
          "25%": 1.08,
          "75%": 1.29
        },
        "54071": {
          "name": "Pendleton",
          "median": 1.19,
          "10%": 1.0,
          "90%": 1.38,
          "25%": 1.07,
          "75%": 1.33
        },
        "42099": {
          "name": "Perry",
          "median": 1.17,
          "10%": 1.05,
          "90%": 1.37,
          "25%": 1.1,
          "75%": 1.31
        },
        "51730": {
          "name": "Petersburg",
          "median": 1.16,
          "10%": 1.0,
          "90%": 1.38,
          "25%": 1.08,
          "75%": 1.26
        },
        "42101": {
          "name": "Philadelphia",
          "median": 1.18,
          "10%": 1.02,
          "90%": 1.35,
          "25%": 1.1,
          "75%": 1.26
        },
        "42103": {
          "name": "Pike",
          "median": 1.25,
          "10%": 1.0,
          "90%": 1.46,
          "25%": 1.15,
          "75%": 1.34
        },
        "51143": {
          "name": "Pittsylvania",
          "median": 1.23,
          "10%": 1.04,
          "90%": 1.41,
          "25%": 1.11,
          "75%": 1.33
        },
        "54073": {
          "name": "Pleasants",
          "median": 1.15,
          "10%": 0.99,
          "90%": 1.33,
          "25%": 1.05,
          "75%": 1.24
        },
        "54075": {
          "name": "Pocahontas",
          "median": 1.17,
          "10%": 1.06,
          "90%": 1.34,
          "25%": 1.1,
          "75%": 1.25
        },
        "51735": {
          "name": "Poquoson",
          "median": 1.17,
          "10%": 1.02,
          "90%": 1.35,
          "25%": 1.08,
          "75%": 1.25
        },
        "51740": {
          "name": "Portsmouth",
          "median": 1.17,
          "10%": 1.0,
          "90%": 1.46,
          "25%": 1.09,
          "75%": 1.36
        },
        "42105": {
          "name": "Potter",
          "median": 1.21,
          "10%": 1.03,
          "90%": 1.34,
          "25%": 1.12,
          "75%": 1.26
        },
        "51145": {
          "name": "Powhatan",
          "median": 1.17,
          "10%": 0.93,
          "90%": 1.47,
          "25%": 1.05,
          "75%": 1.28
        },
        "54077": {
          "name": "Preston",
          "median": 1.19,
          "10%": 1.03,
          "90%": 1.35,
          "25%": 1.1,
          "75%": 1.27
        },
        "51147": {
          "name": "Prince Edward",
          "median": 1.19,
          "10%": 1.05,
          "90%": 1.34,
          "25%": 1.1,
          "75%": 1.27
        },
        "51149": {
          "name": "Prince George",
          "median": 1.16,
          "10%": 1.0,
          "90%": 1.31,
          "25%": 1.07,
          "75%": 1.23
        },
        "24033": {
          "name": "Prince George's",
          "median": 1.17,
          "10%": 1.0,
          "90%": 1.37,
          "25%": 1.05,
          "75%": 1.27
        },
        "51153": {
          "name": "Prince William",
          "median": 1.14,
          "10%": 1.02,
          "90%": 1.34,
          "25%": 1.07,
          "75%": 1.24
        },
        "51155": {
          "name": "Pulaski",
          "median": 1.2,
          "10%": 1.09,
          "90%": 1.32,
          "25%": 1.13,
          "75%": 1.26
        },
        "54079": {
          "name": "Putnam",
          "median": 1.165,
          "10%": 1.03,
          "90%": 1.35,
          "25%": 1.07,
          "75%": 1.25
        },
        "24035": {
          "name": "Queen Anne's",
          "median": 1.18,
          "10%": 1.0,
          "90%": 1.34,
          "25%": 1.06,
          "75%": 1.26
        },
        "51750": {
          "name": "Radford",
          "median": 1.21,
          "10%": 1.07,
          "90%": 1.37,
          "25%": 1.15,
          "75%": 1.28
        },
        "54081": {
          "name": "Raleigh",
          "median": 1.17,
          "10%": 1.04,
          "90%": 1.31,
          "25%": 1.09,
          "75%": 1.25
        },
        "54083": {
          "name": "Randolph",
          "median": 1.18,
          "10%": 1.05,
          "90%": 1.35,
          "25%": 1.09,
          "75%": 1.24
        },
        "51157": {
          "name": "Rappahannock",
          "median": 1.2,
          "10%": 1.05,
          "90%": 1.37,
          "25%": 1.1,
          "75%": 1.29
        },
        "36085": {
          "name": "Richmond",
          "median": 1.14,
          "10%": 0.99,
          "90%": 1.32,
          "25%": 1.05,
          "75%": 1.24
        },
        "51159": {
          "name": "Richmond",
          "median": 1.12,
          "10%": 0.92,
          "90%": 1.39,
          "25%": 1.01,
          "75%": 1.29
        },
        "51760": {
          "name": "Richmond",
          "median": 1.2,
          "10%": 0.97,
          "90%": 1.46,
          "25%": 1.06,
          "75%": 1.33
        },
        "54085": {
          "name": "Ritchie",
          "median": 1.18,
          "10%": 1.08,
          "90%": 1.34,
          "25%": 1.12,
          "75%": 1.29
        },
        "54087": {
          "name": "Roane",
          "median": 1.18,
          "10%": 1.02,
          "90%": 1.31,
          "25%": 1.09,
          "75%": 1.25
        },
        "51161": {
          "name": "Roanoke",
          "median": 1.26,
          "10%": 1.06,
          "90%": 1.46,
          "25%": 1.15,
          "75%": 1.37
        },
        "51770": {
          "name": "Roanoke",
          "median": 1.25,
          "10%": 1.05,
          "90%": 1.51,
          "25%": 1.15,
          "75%": 1.42
        },
        "51163": {
          "name": "Rockbridge",
          "median": 1.21,
          "10%": 1.05,
          "90%": 1.42,
          "25%": 1.12,
          "75%": 1.32
        },
        "51165": {
          "name": "Rockingham",
          "median": 1.2,
          "10%": 0.99,
          "90%": 1.39,
          "25%": 1.08,
          "75%": 1.3
        },
        "51167": {
          "name": "Russell",
          "median": 1.16,
          "10%": 1.05,
          "90%": 1.3,
          "25%": 1.1,
          "75%": 1.23
        },
        "34033": {
          "name": "Salem",
          "median": 1.19,
          "10%": 1.02,
          "90%": 1.41,
          "25%": 1.11,
          "75%": 1.3
        },
        "51775": {
          "name": "Salem",
          "median": 1.26,
          "10%": 1.06,
          "90%": 1.54,
          "25%": 1.16,
          "75%": 1.39
        },
        "36095": {
          "name": "Schoharie",
          "median": 1.22,
          "10%": 1.04,
          "90%": 1.41,
          "25%": 1.12,
          "75%": 1.31
        },
        "36097": {
          "name": "Schuyler",
          "median": 1.2,
          "10%": 1.04,
          "90%": 1.41,
          "25%": 1.13,
          "75%": 1.3
        },
        "42107": {
          "name": "Schuylkill",
          "median": 1.23,
          "10%": 1.02,
          "90%": 1.4,
          "25%": 1.12,
          "75%": 1.32
        },
        "51169": {
          "name": "Scott",
          "median": 1.21,
          "10%": 1.08,
          "90%": 1.36,
          "25%": 1.14,
          "75%": 1.31
        },
        "51171": {
          "name": "Shenandoah",
          "median": 1.21,
          "10%": 1.0,
          "90%": 1.4,
          "25%": 1.13,
          "75%": 1.3
        },
        "51173": {
          "name": "Smyth",
          "median": 1.17,
          "10%": 1.06,
          "90%": 1.31,
          "25%": 1.09,
          "75%": 1.23
        },
        "42109": {
          "name": "Snyder",
          "median": 1.23,
          "10%": 1.04,
          "90%": 1.4,
          "25%": 1.13,
          "75%": 1.29
        },
        "24039": {
          "name": "Somerset",
          "median": 1.15,
          "10%": 1.01,
          "90%": 1.42,
          "25%": 1.1,
          "75%": 1.24
        },
        "42111": {
          "name": "Somerset",
          "median": 1.17,
          "10%": 1.08,
          "90%": 1.34,
          "25%": 1.11,
          "75%": 1.23
        },
        "51175": {
          "name": "Southampton",
          "median": 1.19,
          "10%": 1.02,
          "90%": 1.39,
          "25%": 1.08,
          "75%": 1.28
        },
        "51177": {
          "name": "Spotsylvania",
          "median": 1.13,
          "10%": 0.98,
          "90%": 1.39,
          "25%": 1.07,
          "75%": 1.29
        },
        "24037": {
          "name": "St. Mary's",
          "median": 1.16,
          "10%": 0.98,
          "90%": 1.34,
          "25%": 1.05,
          "75%": 1.28
        },
        "51179": {
          "name": "Stafford",
          "median": 1.15,
          "10%": 0.98,
          "90%": 1.41,
          "25%": 1.07,
          "75%": 1.29
        },
        "51790": {
          "name": "Staunton",
          "median": 1.21,
          "10%": 0.97,
          "90%": 1.42,
          "25%": 1.08,
          "75%": 1.34
        },
        "36101": {
          "name": "Steuben",
          "median": 1.21,
          "10%": 1.04,
          "90%": 1.34,
          "25%": 1.11,
          "75%": 1.27
        },
        "51800": {
          "name": "Suffolk",
          "median": 1.22,
          "10%": 1.04,
          "90%": 1.41,
          "25%": 1.12,
          "75%": 1.33
        },
        "36105": {
          "name": "Sullivan",
          "median": 1.26,
          "10%": 1.06,
          "90%": 1.42,
          "25%": 1.15,
          "75%": 1.32
        },
        "42113": {
          "name": "Sullivan",
          "median": 1.21,
          "10%": 1.03,
          "90%": 1.39,
          "25%": 1.1,
          "75%": 1.28
        },
        "54089": {
          "name": "Summers",
          "median": 1.17,
          "10%": 1.06,
          "90%": 1.31,
          "25%": 1.09,
          "75%": 1.21
        },
        "51181": {
          "name": "Surry",
          "median": 1.15,
          "10%": 1.0,
          "90%": 1.32,
          "25%": 1.06,
          "75%": 1.24
        },
        "42115": {
          "name": "Susquehanna",
          "median": 1.2,
          "10%": 1.06,
          "90%": 1.351,
          "25%": 1.13,
          "75%": 1.27
        },
        "10005": {
          "name": "Sussex",
          "median": 1.16,
          "10%": 1.02,
          "90%": 1.35,
          "25%": 1.09,
          "75%": 1.23
        },
        "34037": {
          "name": "Sussex",
          "median": 1.25,
          "10%": 1.03,
          "90%": 1.52,
          "25%": 1.15,
          "75%": 1.35
        },
        "51183": {
          "name": "Sussex",
          "median": 1.15,
          "10%": 1.02,
          "90%": 1.36,
          "25%": 1.07,
          "75%": 1.24
        },
        "24041": {
          "name": "Talbot",
          "median": 1.14,
          "10%": 0.96,
          "90%": 1.34,
          "25%": 1.04,
          "75%": 1.23
        },
        "54091": {
          "name": "Taylor",
          "median": 1.19,
          "10%": 1.02,
          "90%": 1.33,
          "25%": 1.11,
          "75%": 1.27
        },
        "51185": {
          "name": "Tazewell",
          "median": 1.15,
          "10%": 1.05,
          "90%": 1.27,
          "25%": 1.1,
          "75%": 1.2
        },
        "36107": {
          "name": "Tioga",
          "median": 1.17,
          "10%": 1.02,
          "90%": 1.33,
          "25%": 1.1,
          "75%": 1.25
        },
        "42117": {
          "name": "Tioga",
          "median": 1.19,
          "10%": 1.06,
          "90%": 1.35,
          "25%": 1.1,
          "75%": 1.28
        },
        "36109": {
          "name": "Tompkins",
          "median": 1.18,
          "10%": 1.06,
          "90%": 1.33,
          "25%": 1.12,
          "75%": 1.26
        },
        "54093": {
          "name": "Tucker",
          "median": 1.15,
          "10%": 1.02,
          "90%": 1.35,
          "25%": 1.09,
          "75%": 1.25
        },
        "54095": {
          "name": "Tyler",
          "median": 1.11,
          "10%": 0.96,
          "90%": 1.26,
          "25%": 1.02,
          "75%": 1.19
        },
        "36111": {
          "name": "Ulster",
          "median": 1.24,
          "10%": 1.07,
          "90%": 1.45,
          "25%": 1.15,
          "75%": 1.38
        },
        "42119": {
          "name": "Union",
          "median": 1.19,
          "10%": 1.06,
          "90%": 1.35,
          "25%": 1.13,
          "75%": 1.28
        },
        "54097": {
          "name": "Upshur",
          "median": 1.18,
          "10%": 1.04,
          "90%": 1.34,
          "25%": 1.09,
          "75%": 1.25
        },
        "42121": {
          "name": "Venango",
          "median": 1.16,
          "10%": 1.02,
          "90%": 1.38,
          "25%": 1.07,
          "75%": 1.27
        },
        "51810": {
          "name": "Virginia Beach",
          "median": 1.19,
          "10%": 1.019,
          "90%": 1.47,
          "25%": 1.08,
          "75%": 1.33
        },
        "34041": {
          "name": "Warren",
          "median": 1.21,
          "10%": 1.05,
          "90%": 1.48,
          "25%": 1.14,
          "75%": 1.29
        },
        "42123": {
          "name": "Warren",
          "median": 1.16,
          "10%": 0.98,
          "90%": 1.37,
          "25%": 1.06,
          "75%": 1.25
        },
        "51187": {
          "name": "Warren",
          "median": 1.21,
          "10%": 1.06,
          "90%": 1.38,
          "25%": 1.14,
          "75%": 1.29
        },
        "24043": {
          "name": "Washington",
          "median": 1.17,
          "10%": 1.03,
          "90%": 1.41,
          "25%": 1.1,
          "75%": 1.29
        },
        "42125": {
          "name": "Washington",
          "median": 1.17,
          "10%": 1.03,
          "90%": 1.41,
          "25%": 1.1,
          "75%": 1.26
        },
        "51191": {
          "name": "Washington",
          "median": 1.15,
          "10%": 1.03,
          "90%": 1.3,
          "25%": 1.08,
          "75%": 1.2125
        },
        "42127": {
          "name": "Wayne",
          "median": 1.23,
          "10%": 1.01,
          "90%": 1.41,
          "25%": 1.15,
          "75%": 1.31
        },
        "54099": {
          "name": "Wayne",
          "median": 1.19,
          "10%": 1.06,
          "90%": 1.4,
          "25%": 1.13,
          "75%": 1.29
        },
        "51820": {
          "name": "Waynesboro",
          "median": 1.2,
          "10%": 0.99,
          "90%": 1.44,
          "25%": 1.09,
          "75%": 1.33
        },
        "54101": {
          "name": "Webster",
          "median": 1.12,
          "10%": 0.99,
          "90%": 1.26,
          "25%": 1.05,
          "75%": 1.2
        },
        "36119": {
          "name": "Westchester",
          "median": 1.19,
          "10%": 1.04,
          "90%": 1.39,
          "25%": 1.1,
          "75%": 1.28
        },
        "42129": {
          "name": "Westmoreland",
          "median": 1.19,
          "10%": 1.04,
          "90%": 1.39,
          "25%": 1.11,
          "75%": 1.27
        },
        "51193": {
          "name": "Westmoreland",
          "median": 1.13,
          "10%": 0.95,
          "90%": 1.36,
          "25%": 1.04,
          "75%": 1.29
        },
        "54103": {
          "name": "Wetzel",
          "median": 1.14,
          "10%": 1.03,
          "90%": 1.33,
          "25%": 1.07,
          "75%": 1.26
        },
        "24045": {
          "name": "Wicomico",
          "median": 1.15,
          "10%": 1.04,
          "90%": 1.3,
          "25%": 1.09,
          "75%": 1.22
        },
        "51830": {
          "name": "Williamsburg",
          "median": 1.11,
          "10%": 0.93,
          "90%": 1.33,
          "25%": 1.01,
          "75%": 1.23
        },
        "51840": {
          "name": "Winchester",
          "median": 1.2,
          "10%": 1.05,
          "90%": 1.4,
          "25%": 1.1,
          "75%": 1.33
        },
        "54105": {
          "name": "Wirt",
          "median": 1.25,
          "10%": 1.09,
          "90%": 1.4,
          "25%": 1.16,
          "75%": 1.33
        },
        "51195": {
          "name": "Wise",
          "median": 1.2,
          "10%": 1.08,
          "90%": 1.38,
          "25%": 1.12,
          "75%": 1.3
        },
        "54107": {
          "name": "Wood",
          "median": 1.21,
          "10%": 1.0,
          "90%": 1.36,
          "25%": 1.08,
          "75%": 1.29
        },
        "24047": {
          "name": "Worcester",
          "median": 1.17,
          "10%": 1.02,
          "90%": 1.44,
          "25%": 1.08,
          "75%": 1.27
        },
        "42131": {
          "name": "Wyoming",
          "median": 1.22,
          "10%": 1.09,
          "90%": 1.36,
          "25%": 1.16,
          "75%": 1.29
        },
        "54109": {
          "name": "Wyoming",
          "median": 1.17,
          "10%": 1.04,
          "90%": 1.32,
          "25%": 1.1,
          "75%": 1.24
        },
        "51197": {
          "name": "Wythe",
          "median": 1.15,
          "10%": 1.03,
          "90%": 1.3,
          "25%": 1.07,
          "75%": 1.24
        },
        "36123": {
          "name": "Yates",
          "median": 1.22,
          "10%": 1.01,
          "90%": 1.39,
          "25%": 1.09,
          "75%": 1.32
        },
        "42133": {
          "name": "York",
          "median": 1.21,
          "10%": 1.02,
          "90%": 1.45,
          "25%": 1.09,
          "75%": 1.32
        },
        "51199": {
          "name": "York",
          "median": 1.15,
          "10%": 0.98,
          "90%": 1.3,
          "25%": 1.07,
          "75%": 1.22
        },
        "max": 1.28,
        "min": 1
      },
      "50": {
        "51001": {
          "name": "Accomack",
          "median": 1.19,
          "10%": 0.99,
          "90%": 1.35,
          "25%": 1.09,
          "75%": 1.26
        },
        "42001": {
          "name": "Adams",
          "median": 1.13,
          "10%": 0.91,
          "90%": 1.5,
          "25%": 1.02,
          "75%": 1.29
        },
        "51003": {
          "name": "Albemarle",
          "median": 1.18,
          "10%": 0.95,
          "90%": 1.48,
          "25%": 1.1,
          "75%": 1.34
        },
        "51510": {
          "name": "Alexandria",
          "median": 1.14,
          "10%": 0.89,
          "90%": 1.47,
          "25%": 0.99,
          "75%": 1.3
        },
        "24001": {
          "name": "Allegany",
          "median": 1.22,
          "10%": 1.03,
          "90%": 1.46,
          "25%": 1.11,
          "75%": 1.33
        },
        "36003": {
          "name": "Allegany",
          "median": 1.18,
          "10%": 0.99,
          "90%": 1.37,
          "25%": 1.07,
          "75%": 1.27
        },
        "51005": {
          "name": "Alleghany",
          "median": 1.22,
          "10%": 1.01,
          "90%": 1.51,
          "25%": 1.11,
          "75%": 1.34
        },
        "42003": {
          "name": "Allegheny",
          "median": 1.17,
          "10%": 1.01,
          "90%": 1.42,
          "25%": 1.06,
          "75%": 1.28
        },
        "51007": {
          "name": "Amelia",
          "median": 1.19,
          "10%": 1.0,
          "90%": 1.54,
          "25%": 1.07,
          "75%": 1.34
        },
        "51009": {
          "name": "Amherst",
          "median": 1.21,
          "10%": 1.02,
          "90%": 1.42,
          "25%": 1.1,
          "75%": 1.32
        },
        "24003": {
          "name": "Anne Arundel",
          "median": 1.18,
          "10%": 0.94,
          "90%": 1.41,
          "25%": 1.01,
          "75%": 1.31
        },
        "51011": {
          "name": "Appomattox",
          "median": 1.19,
          "10%": 1.0,
          "90%": 1.51,
          "25%": 1.07,
          "75%": 1.35
        },
        "51013": {
          "name": "Arlington",
          "median": 1.14,
          "10%": 0.92,
          "90%": 1.39,
          "25%": 1.04,
          "75%": 1.25
        },
        "42005": {
          "name": "Armstrong",
          "median": 1.19,
          "10%": 1.02,
          "90%": 1.48,
          "25%": 1.08,
          "75%": 1.38
        },
        "34001": {
          "name": "Atlantic",
          "median": 1.2,
          "10%": 1.01,
          "90%": 1.47,
          "25%": 1.1,
          "75%": 1.32
        },
        "51015": {
          "name": "Augusta",
          "median": 1.2,
          "10%": 0.96,
          "90%": 1.36,
          "25%": 1.06,
          "75%": 1.3
        },
        "24005": {
          "name": "Baltimore",
          "median": 1.17,
          "10%": 0.99,
          "90%": 1.47,
          "25%": 1.08,
          "75%": 1.28
        },
        "24510": {
          "name": "Baltimore",
          "median": 1.12,
          "10%": 0.95,
          "90%": 1.43,
          "25%": 1.01,
          "75%": 1.28
        },
        "54001": {
          "name": "Barbour",
          "median": 1.16,
          "10%": 0.97,
          "90%": 1.38,
          "25%": 1.08,
          "75%": 1.27
        },
        "51017": {
          "name": "Bath",
          "median": 1.22,
          "10%": 1.01,
          "90%": 1.54,
          "25%": 1.07,
          "75%": 1.4
        },
        "42007": {
          "name": "Beaver",
          "median": 1.14,
          "10%": 0.95,
          "90%": 1.38,
          "25%": 1.04,
          "75%": 1.25
        },
        "42009": {
          "name": "Bedford",
          "median": 1.24,
          "10%": 1.06,
          "90%": 1.44,
          "25%": 1.16,
          "75%": 1.32
        },
        "51019": {
          "name": "Bedford",
          "median": 1.25,
          "10%": 1.07,
          "90%": 1.4,
          "25%": 1.15,
          "75%": 1.33
        },
        "54003": {
          "name": "Berkeley",
          "median": 1.16,
          "10%": 1.03,
          "90%": 1.44,
          "25%": 1.08,
          "75%": 1.26
        },
        "42011": {
          "name": "Berks",
          "median": 1.2,
          "10%": 0.98,
          "90%": 1.46,
          "25%": 1.1,
          "75%": 1.33
        },
        "42013": {
          "name": "Blair",
          "median": 1.22,
          "10%": 1.03,
          "90%": 1.42,
          "25%": 1.13,
          "75%": 1.33
        },
        "51021": {
          "name": "Bland",
          "median": 1.13,
          "10%": 0.99,
          "90%": 1.3,
          "25%": 1.04,
          "75%": 1.21
        },
        "54005": {
          "name": "Boone",
          "median": 1.18,
          "10%": 1.01,
          "90%": 1.33,
          "25%": 1.07,
          "75%": 1.28
        },
        "51023": {
          "name": "Botetourt",
          "median": 1.25,
          "10%": 1.08,
          "90%": 1.44,
          "25%": 1.15,
          "75%": 1.37
        },
        "42015": {
          "name": "Bradford",
          "median": 1.24,
          "10%": 1.01,
          "90%": 1.49,
          "25%": 1.13,
          "75%": 1.34
        },
        "54007": {
          "name": "Braxton",
          "median": 1.11,
          "10%": 0.97,
          "90%": 1.32,
          "25%": 1.03,
          "75%": 1.2
        },
        "51520": {
          "name": "Bristol",
          "median": 1.17,
          "10%": 1.04,
          "90%": 1.35,
          "25%": 1.1,
          "75%": 1.27
        },
        "36005": {
          "name": "Bronx",
          "median": 1.14,
          "10%": 0.98,
          "90%": 1.34,
          "25%": 1.05,
          "75%": 1.24
        },
        "54009": {
          "name": "Brooke",
          "median": 1.2,
          "10%": 0.96,
          "90%": 1.46,
          "25%": 1.08,
          "75%": 1.31
        },
        "36007": {
          "name": "Broome",
          "median": 1.18,
          "10%": 1.01,
          "90%": 1.35,
          "25%": 1.08,
          "75%": 1.28
        },
        "51025": {
          "name": "Brunswick",
          "median": 1.17,
          "10%": 1.01,
          "90%": 1.4,
          "25%": 1.09,
          "75%": 1.31
        },
        "51027": {
          "name": "Buchanan",
          "median": 1.14,
          "10%": 0.99,
          "90%": 1.31,
          "25%": 1.06,
          "75%": 1.25
        },
        "51029": {
          "name": "Buckingham",
          "median": 1.17,
          "10%": 1.0,
          "90%": 1.46,
          "25%": 1.09,
          "75%": 1.3
        },
        "42017": {
          "name": "Bucks",
          "median": 1.15,
          "10%": 1.0,
          "90%": 1.4,
          "25%": 1.1,
          "75%": 1.26
        },
        "51530": {
          "name": "Buena Vista",
          "median": 1.19,
          "10%": 0.96,
          "90%": 1.45,
          "25%": 1.07,
          "75%": 1.31
        },
        "34005": {
          "name": "Burlington",
          "median": 1.15,
          "10%": 1.009,
          "90%": 1.32,
          "25%": 1.0575,
          "75%": 1.23
        },
        "42019": {
          "name": "Butler",
          "median": 1.15,
          "10%": 1.0,
          "90%": 1.35,
          "25%": 1.08,
          "75%": 1.29
        },
        "54011": {
          "name": "Cabell",
          "median": 1.18,
          "10%": 1.0,
          "90%": 1.44,
          "25%": 1.11,
          "75%": 1.29
        },
        "54013": {
          "name": "Calhoun",
          "median": 1.19,
          "10%": 0.98,
          "90%": 1.46,
          "25%": 1.08,
          "75%": 1.33
        },
        "24009": {
          "name": "Calvert",
          "median": 1.19,
          "10%": 0.95,
          "90%": 1.39,
          "25%": 1.04,
          "75%": 1.31
        },
        "42021": {
          "name": "Cambria",
          "median": 1.18,
          "10%": 0.99,
          "90%": 1.41,
          "25%": 1.09,
          "75%": 1.3
        },
        "34007": {
          "name": "Camden",
          "median": 1.17,
          "10%": 0.99,
          "90%": 1.4,
          "25%": 1.07,
          "75%": 1.28
        },
        "42023": {
          "name": "Cameron",
          "median": 1.2,
          "10%": 1.02,
          "90%": 1.37,
          "25%": 1.11,
          "75%": 1.29
        },
        "51031": {
          "name": "Campbell",
          "median": 1.19,
          "10%": 1.03,
          "90%": 1.39,
          "25%": 1.11,
          "75%": 1.31
        },
        "34009": {
          "name": "Cape May",
          "median": 1.21,
          "10%": 1.03,
          "90%": 1.44,
          "25%": 1.13,
          "75%": 1.33
        },
        "42025": {
          "name": "Carbon",
          "median": 1.22,
          "10%": 0.99,
          "90%": 1.43,
          "25%": 1.14,
          "75%": 1.3
        },
        "24011": {
          "name": "Caroline",
          "median": 1.19,
          "10%": 0.99,
          "90%": 1.46,
          "25%": 1.07,
          "75%": 1.3
        },
        "51033": {
          "name": "Caroline",
          "median": 1.15,
          "10%": 0.95,
          "90%": 1.47,
          "25%": 1.03,
          "75%": 1.3
        },
        "24013": {
          "name": "Carroll",
          "median": 1.17,
          "10%": 0.98,
          "90%": 1.5,
          "25%": 1.06,
          "75%": 1.32
        },
        "51035": {
          "name": "Carroll",
          "median": 1.15,
          "10%": 1.04,
          "90%": 1.39,
          "25%": 1.1,
          "75%": 1.27
        },
        "24015": {
          "name": "Cecil",
          "median": 1.18,
          "10%": 0.95,
          "90%": 1.37,
          "25%": 1.08,
          "75%": 1.26
        },
        "42027": {
          "name": "Centre",
          "median": 1.21,
          "10%": 1.03,
          "90%": 1.41,
          "25%": 1.13,
          "75%": 1.32
        },
        "24017": {
          "name": "Charles",
          "median": 1.2,
          "10%": 0.93,
          "90%": 1.521,
          "25%": 1.04,
          "75%": 1.36
        },
        "51036": {
          "name": "Charles City",
          "median": 1.15,
          "10%": 0.96,
          "90%": 1.35,
          "25%": 1.03,
          "75%": 1.23
        },
        "51037": {
          "name": "Charlotte",
          "median": 1.19,
          "10%": 1.04,
          "90%": 1.39,
          "25%": 1.1,
          "75%": 1.28
        },
        "51540": {
          "name": "Charlottesville",
          "median": 1.16,
          "10%": 0.94,
          "90%": 1.481,
          "25%": 1.05,
          "75%": 1.34
        },
        "36015": {
          "name": "Chemung",
          "median": 1.17,
          "10%": 1.04,
          "90%": 1.39,
          "25%": 1.1,
          "75%": 1.26
        },
        "36017": {
          "name": "Chenango",
          "median": 1.17,
          "10%": 1.01,
          "90%": 1.38,
          "25%": 1.0675,
          "75%": 1.28
        },
        "51550": {
          "name": "Chesapeake",
          "median": 1.22,
          "10%": 1.03,
          "90%": 1.49,
          "25%": 1.11,
          "75%": 1.38
        },
        "42029": {
          "name": "Chester",
          "median": 1.19,
          "10%": 0.97,
          "90%": 1.46,
          "25%": 1.1,
          "75%": 1.33
        },
        "51041": {
          "name": "Chesterfield",
          "median": 1.18,
          "10%": 0.97,
          "90%": 1.45,
          "25%": 1.07,
          "75%": 1.31
        },
        "42031": {
          "name": "Clarion",
          "median": 1.16,
          "10%": 1.04,
          "90%": 1.43,
          "25%": 1.08,
          "75%": 1.31
        },
        "51043": {
          "name": "Clarke",
          "median": 1.14,
          "10%": 0.97,
          "90%": 1.41,
          "25%": 1.05,
          "75%": 1.23
        },
        "54015": {
          "name": "Clay",
          "median": 1.11,
          "10%": 0.95,
          "90%": 1.34,
          "25%": 1.04,
          "75%": 1.2225
        },
        "42033": {
          "name": "Clearfield",
          "median": 1.17,
          "10%": 1.02,
          "90%": 1.42,
          "25%": 1.11,
          "75%": 1.28
        },
        "42035": {
          "name": "Clinton",
          "median": 1.22,
          "10%": 1.03,
          "90%": 1.44,
          "25%": 1.11,
          "75%": 1.32
        },
        "51570": {
          "name": "Colonial Heights",
          "median": 1.16,
          "10%": 0.98,
          "90%": 1.45,
          "25%": 1.07,
          "75%": 1.2725
        },
        "42037": {
          "name": "Columbia",
          "median": 1.22,
          "10%": 1.03,
          "90%": 1.47,
          "25%": 1.14,
          "75%": 1.36
        },
        "36023": {
          "name": "Cortland",
          "median": 1.21,
          "10%": 1.02,
          "90%": 1.39,
          "25%": 1.11,
          "75%": 1.31
        },
        "51580": {
          "name": "Covington",
          "median": 1.17,
          "10%": 0.98,
          "90%": 1.54,
          "25%": 1.06,
          "75%": 1.37
        },
        "51045": {
          "name": "Craig",
          "median": 1.24,
          "10%": 1.06,
          "90%": 1.43,
          "25%": 1.14,
          "75%": 1.32
        },
        "42039": {
          "name": "Crawford",
          "median": 1.14,
          "10%": 1.0,
          "90%": 1.38,
          "25%": 1.05,
          "75%": 1.26
        },
        "51047": {
          "name": "Culpeper",
          "median": 1.16,
          "10%": 1.0,
          "90%": 1.37,
          "25%": 1.09,
          "75%": 1.27
        },
        "34011": {
          "name": "Cumberland",
          "median": 1.17,
          "10%": 1.01,
          "90%": 1.47,
          "25%": 1.1,
          "75%": 1.3
        },
        "42041": {
          "name": "Cumberland",
          "median": 1.16,
          "10%": 1.02,
          "90%": 1.41,
          "25%": 1.08,
          "75%": 1.29
        },
        "51049": {
          "name": "Cumberland",
          "median": 1.16,
          "10%": 1.01,
          "90%": 1.43,
          "25%": 1.05,
          "75%": 1.3
        },
        "51590": {
          "name": "Danville",
          "median": 1.19,
          "10%": 0.97,
          "90%": 1.45,
          "25%": 1.06,
          "75%": 1.32
        },
        "42043": {
          "name": "Dauphin",
          "median": 1.25,
          "10%": 1.0,
          "90%": 1.48,
          "25%": 1.1,
          "75%": 1.37
        },
        "36025": {
          "name": "Delaware",
          "median": 1.23,
          "10%": 1.06,
          "90%": 1.44,
          "25%": 1.14,
          "75%": 1.3
        },
        "42045": {
          "name": "Delaware",
          "median": 1.21,
          "10%": 0.97,
          "90%": 1.48,
          "25%": 1.11,
          "75%": 1.34
        },
        "51051": {
          "name": "Dickenson",
          "median": 1.17,
          "10%": 1.0,
          "90%": 1.35,
          "25%": 1.08,
          "75%": 1.26
        },
        "51053": {
          "name": "Dinwiddie",
          "median": 1.17,
          "10%": 1.01,
          "90%": 1.33,
          "25%": 1.07,
          "75%": 1.27
        },
        "11001": {
          "name": "District of Columbia",
          "median": 1.15,
          "10%": 0.95,
          "90%": 1.39,
          "25%": 1.04,
          "75%": 1.28
        },
        "54017": {
          "name": "Doddridge",
          "median": 1.155,
          "10%": 0.96,
          "90%": 1.32,
          "25%": 1.07,
          "75%": 1.24
        },
        "24019": {
          "name": "Dorchester",
          "median": 1.14,
          "10%": 0.92,
          "90%": 1.36,
          "25%": 1.02,
          "75%": 1.24
        },
        "42047": {
          "name": "Elk",
          "median": 1.12,
          "10%": 0.95,
          "90%": 1.38,
          "25%": 1.03,
          "75%": 1.28
        },
        "51595": {
          "name": "Emporia",
          "median": 1.13,
          "10%": 0.94,
          "90%": 1.36,
          "25%": 1.04,
          "75%": 1.24
        },
        "42049": {
          "name": "Erie",
          "median": 1.17,
          "10%": 1.0,
          "90%": 1.38,
          "25%": 1.05,
          "75%": 1.27
        },
        "51057": {
          "name": "Essex",
          "median": 1.13,
          "10%": 0.93,
          "90%": 1.37,
          "25%": 1.0,
          "75%": 1.28
        },
        "51059": {
          "name": "Fairfax",
          "median": 1.16,
          "10%": 0.99,
          "90%": 1.38,
          "25%": 1.05,
          "75%": 1.24
        },
        "51600": {
          "name": "Fairfax",
          "median": 1.15,
          "10%": 0.96,
          "90%": 1.36,
          "25%": 1.06,
          "75%": 1.24
        },
        "51610": {
          "name": "Falls Church",
          "median": 1.13,
          "10%": 0.96,
          "90%": 1.41,
          "25%": 1.03,
          "75%": 1.25
        },
        "51061": {
          "name": "Fauquier",
          "median": 1.17,
          "10%": 0.96,
          "90%": 1.4,
          "25%": 1.07,
          "75%": 1.28
        },
        "42051": {
          "name": "Fayette",
          "median": 1.2,
          "10%": 1.04,
          "90%": 1.43,
          "25%": 1.11,
          "75%": 1.34
        },
        "54019": {
          "name": "Fayette",
          "median": 1.12,
          "10%": 1.029,
          "90%": 1.29,
          "25%": 1.07,
          "75%": 1.19
        },
        "51063": {
          "name": "Floyd",
          "median": 1.19,
          "10%": 0.96,
          "90%": 1.4,
          "25%": 1.09,
          "75%": 1.27
        },
        "51065": {
          "name": "Fluvanna",
          "median": 1.18,
          "10%": 0.92,
          "90%": 1.69,
          "25%": 1.07,
          "75%": 1.4
        },
        "42053": {
          "name": "Forest",
          "median": 1.14,
          "10%": 0.95,
          "90%": 1.42,
          "25%": 1.01,
          "75%": 1.28
        },
        "42055": {
          "name": "Franklin",
          "median": 1.18,
          "10%": 1.03,
          "90%": 1.48,
          "25%": 1.08,
          "75%": 1.32
        },
        "51067": {
          "name": "Franklin",
          "median": 1.23,
          "10%": 1.01,
          "90%": 1.47,
          "25%": 1.1,
          "75%": 1.37
        },
        "51620": {
          "name": "Franklin",
          "median": 1.24,
          "10%": 1.01,
          "90%": 1.51,
          "25%": 1.1,
          "75%": 1.33
        },
        "24021": {
          "name": "Frederick",
          "median": 1.16,
          "10%": 0.98,
          "90%": 1.46,
          "25%": 1.07,
          "75%": 1.28
        },
        "51069": {
          "name": "Frederick",
          "median": 1.2,
          "10%": 1.03,
          "90%": 1.42,
          "25%": 1.1,
          "75%": 1.31
        },
        "51630": {
          "name": "Fredericksburg",
          "median": 1.16,
          "10%": 0.91,
          "90%": 1.5,
          "25%": 1.02,
          "75%": 1.33
        },
        "42057": {
          "name": "Fulton",
          "median": 1.255,
          "10%": 1.02,
          "90%": 1.49,
          "25%": 1.17,
          "75%": 1.35
        },
        "51640": {
          "name": "Galax",
          "median": 1.12,
          "10%": 0.89,
          "90%": 1.43,
          "25%": 1.0,
          "75%": 1.29
        },
        "24023": {
          "name": "Garrett",
          "median": 1.13,
          "10%": 1.01,
          "90%": 1.4,
          "25%": 1.09,
          "75%": 1.24
        },
        "51071": {
          "name": "Giles",
          "median": 1.2,
          "10%": 1.04,
          "90%": 1.32,
          "25%": 1.13,
          "75%": 1.25
        },
        "54021": {
          "name": "Gilmer",
          "median": 1.13,
          "10%": 0.99,
          "90%": 1.39,
          "25%": 1.05,
          "75%": 1.27
        },
        "34015": {
          "name": "Gloucester",
          "median": 1.18,
          "10%": 0.99,
          "90%": 1.46,
          "25%": 1.1,
          "75%": 1.3
        },
        "51073": {
          "name": "Gloucester",
          "median": 1.16,
          "10%": 0.95,
          "90%": 1.33,
          "25%": 1.0575,
          "75%": 1.24
        },
        "51075": {
          "name": "Goochland",
          "median": 1.18,
          "10%": 0.88,
          "90%": 1.61,
          "25%": 1.02,
          "75%": 1.36
        },
        "54023": {
          "name": "Grant",
          "median": 1.13,
          "10%": 1.01,
          "90%": 1.38,
          "25%": 1.08,
          "75%": 1.24
        },
        "51077": {
          "name": "Grayson",
          "median": 1.14,
          "10%": 1.03,
          "90%": 1.34,
          "25%": 1.08,
          "75%": 1.26
        },
        "54025": {
          "name": "Greenbrier",
          "median": 1.17,
          "10%": 1.02,
          "90%": 1.33,
          "25%": 1.1,
          "75%": 1.27
        },
        "36039": {
          "name": "Greene",
          "median": 1.3,
          "10%": 1.02,
          "90%": 1.49,
          "25%": 1.16,
          "75%": 1.39
        },
        "42059": {
          "name": "Greene",
          "median": 1.2,
          "10%": 1.03,
          "90%": 1.39,
          "25%": 1.1,
          "75%": 1.31
        },
        "51079": {
          "name": "Greene",
          "median": 1.19,
          "10%": 0.98,
          "90%": 1.52,
          "25%": 1.08,
          "75%": 1.31
        },
        "51081": {
          "name": "Greensville",
          "median": 1.15,
          "10%": 0.96,
          "90%": 1.37,
          "25%": 1.04,
          "75%": 1.26
        },
        "51083": {
          "name": "Halifax",
          "median": 1.21,
          "10%": 1.06,
          "90%": 1.49,
          "25%": 1.13,
          "75%": 1.33
        },
        "54027": {
          "name": "Hampshire",
          "median": 1.22,
          "10%": 1.06,
          "90%": 1.54,
          "25%": 1.12,
          "75%": 1.37
        },
        "51650": {
          "name": "Hampton",
          "median": 1.2,
          "10%": 0.99,
          "90%": 1.42,
          "25%": 1.06,
          "75%": 1.29
        },
        "54029": {
          "name": "Hancock",
          "median": 1.14,
          "10%": 0.95,
          "90%": 1.35,
          "25%": 1.02,
          "75%": 1.25
        },
        "51085": {
          "name": "Hanover",
          "median": 1.11,
          "10%": 0.98,
          "90%": 1.43,
          "25%": 1.04,
          "75%": 1.29
        },
        "54031": {
          "name": "Hardy",
          "median": 1.2,
          "10%": 1.01,
          "90%": 1.41,
          "25%": 1.11,
          "75%": 1.31
        },
        "24025": {
          "name": "Harford",
          "median": 1.17,
          "10%": 0.95,
          "90%": 1.46,
          "25%": 1.05,
          "75%": 1.28
        },
        "54033": {
          "name": "Harrison",
          "median": 1.13,
          "10%": 1.0,
          "90%": 1.34,
          "25%": 1.07,
          "75%": 1.24
        },
        "51660": {
          "name": "Harrisonburg",
          "median": 1.14,
          "10%": 0.92,
          "90%": 1.47,
          "25%": 1.02,
          "75%": 1.33
        },
        "51087": {
          "name": "Henrico",
          "median": 1.21,
          "10%": 0.96,
          "90%": 1.44,
          "25%": 1.03,
          "75%": 1.31
        },
        "51089": {
          "name": "Henry",
          "median": 1.25,
          "10%": 0.99,
          "90%": 1.59,
          "25%": 1.1375,
          "75%": 1.44
        },
        "36043": {
          "name": "Herkimer",
          "median": 1.12,
          "10%": 0.97,
          "90%": 1.36,
          "25%": 1.04,
          "75%": 1.25
        },
        "51091": {
          "name": "Highland",
          "median": 1.18,
          "10%": 1.01,
          "90%": 1.42,
          "25%": 1.08,
          "75%": 1.3
        },
        "51670": {
          "name": "Hopewell",
          "median": 1.15,
          "10%": 0.93,
          "90%": 1.36,
          "25%": 1.02,
          "75%": 1.26
        },
        "24027": {
          "name": "Howard",
          "median": 1.14,
          "10%": 0.97,
          "90%": 1.42,
          "25%": 1.05,
          "75%": 1.27
        },
        "34019": {
          "name": "Hunterdon",
          "median": 1.19,
          "10%": 0.97,
          "90%": 1.47,
          "25%": 1.1,
          "75%": 1.33
        },
        "42061": {
          "name": "Huntingdon",
          "median": 1.24,
          "10%": 1.04,
          "90%": 1.43,
          "25%": 1.15,
          "75%": 1.36
        },
        "42063": {
          "name": "Indiana",
          "median": 1.21,
          "10%": 1.04,
          "90%": 1.451,
          "25%": 1.11,
          "75%": 1.34
        },
        "51093": {
          "name": "Isle of Wight",
          "median": 1.23,
          "10%": 1.02,
          "90%": 1.45,
          "25%": 1.12,
          "75%": 1.34
        },
        "54035": {
          "name": "Jackson",
          "median": 1.2,
          "10%": 1.01,
          "90%": 1.41,
          "25%": 1.1,
          "75%": 1.29
        },
        "51095": {
          "name": "James City",
          "median": 1.12,
          "10%": 0.91,
          "90%": 1.36,
          "25%": 1.0,
          "75%": 1.27
        },
        "42065": {
          "name": "Jefferson",
          "median": 1.2,
          "10%": 1.03,
          "90%": 1.41,
          "25%": 1.09,
          "75%": 1.33
        },
        "54037": {
          "name": "Jefferson",
          "median": 1.11,
          "10%": 0.98,
          "90%": 1.42,
          "25%": 1.05,
          "75%": 1.22
        },
        "42067": {
          "name": "Juniata",
          "median": 1.19,
          "10%": 1.03,
          "90%": 1.38,
          "25%": 1.09,
          "75%": 1.28
        },
        "54039": {
          "name": "Kanawha",
          "median": 1.1,
          "10%": 0.99,
          "90%": 1.25,
          "25%": 1.03,
          "75%": 1.16
        },
        "10001": {
          "name": "Kent",
          "median": 1.15,
          "10%": 1.0,
          "90%": 1.37,
          "25%": 1.08,
          "75%": 1.28
        },
        "24029": {
          "name": "Kent",
          "median": 1.19,
          "10%": 0.94,
          "90%": 1.37,
          "25%": 1.05,
          "75%": 1.31
        },
        "51099": {
          "name": "King George",
          "median": 1.12,
          "10%": 0.93,
          "90%": 1.45,
          "25%": 1.01,
          "75%": 1.35
        },
        "51101": {
          "name": "King William",
          "median": 1.12,
          "10%": 0.96,
          "90%": 1.37,
          "25%": 1.04,
          "75%": 1.24
        },
        "51097": {
          "name": "King and Queen",
          "median": 1.1,
          "10%": 0.94,
          "90%": 1.36,
          "25%": 1.02,
          "75%": 1.22
        },
        "42069": {
          "name": "Lackawanna",
          "median": 1.27,
          "10%": 1.02,
          "90%": 1.46,
          "25%": 1.15,
          "75%": 1.37
        },
        "42071": {
          "name": "Lancaster",
          "median": 1.22,
          "10%": 0.99,
          "90%": 1.51,
          "25%": 1.08,
          "75%": 1.36
        },
        "51103": {
          "name": "Lancaster",
          "median": 1.12,
          "10%": 0.93,
          "90%": 1.34,
          "25%": 1.01,
          "75%": 1.23
        },
        "42073": {
          "name": "Lawrence",
          "median": 1.17,
          "10%": 0.95,
          "90%": 1.37,
          "25%": 1.05,
          "75%": 1.25
        },
        "42075": {
          "name": "Lebanon",
          "median": 1.22,
          "10%": 0.95,
          "90%": 1.46,
          "25%": 1.1,
          "75%": 1.33
        },
        "51105": {
          "name": "Lee",
          "median": 1.24,
          "10%": 1.09,
          "90%": 1.54,
          "25%": 1.17,
          "75%": 1.36
        },
        "42077": {
          "name": "Lehigh",
          "median": 1.2,
          "10%": 1.009,
          "90%": 1.42,
          "25%": 1.07,
          "75%": 1.31
        },
        "54041": {
          "name": "Lewis",
          "median": 1.16,
          "10%": 1.03,
          "90%": 1.32,
          "25%": 1.08,
          "75%": 1.2325
        },
        "51678": {
          "name": "Lexington",
          "median": 1.15,
          "10%": 0.99,
          "90%": 1.37,
          "25%": 1.04,
          "75%": 1.28
        },
        "54043": {
          "name": "Lincoln",
          "median": 1.17,
          "10%": 1.03,
          "90%": 1.451,
          "25%": 1.07,
          "75%": 1.31
        },
        "36051": {
          "name": "Livingston",
          "median": 1.18,
          "10%": 0.98,
          "90%": 1.39,
          "25%": 1.1,
          "75%": 1.3
        },
        "54045": {
          "name": "Logan",
          "median": 1.21,
          "10%": 1.02,
          "90%": 1.41,
          "25%": 1.09,
          "75%": 1.3
        },
        "51107": {
          "name": "Loudoun",
          "median": 1.14,
          "10%": 1.029,
          "90%": 1.42,
          "25%": 1.07,
          "75%": 1.25
        },
        "51109": {
          "name": "Louisa",
          "median": 1.2,
          "10%": 0.95,
          "90%": 1.56,
          "25%": 1.07,
          "75%": 1.31
        },
        "51111": {
          "name": "Lunenburg",
          "median": 1.22,
          "10%": 1.01,
          "90%": 1.39,
          "25%": 1.09,
          "75%": 1.32
        },
        "42079": {
          "name": "Luzerne",
          "median": 1.24,
          "10%": 1.05,
          "90%": 1.35,
          "25%": 1.17,
          "75%": 1.29
        },
        "42081": {
          "name": "Lycoming",
          "median": 1.22,
          "10%": 1.04,
          "90%": 1.49,
          "25%": 1.13,
          "75%": 1.34
        },
        "51680": {
          "name": "Lynchburg",
          "median": 1.2,
          "10%": 1.0,
          "90%": 1.41,
          "25%": 1.11,
          "75%": 1.3
        },
        "36053": {
          "name": "Madison",
          "median": 1.17,
          "10%": 0.96,
          "90%": 1.39,
          "25%": 1.08,
          "75%": 1.25
        },
        "51113": {
          "name": "Madison",
          "median": 1.19,
          "10%": 0.979,
          "90%": 1.49,
          "25%": 1.1,
          "75%": 1.33
        },
        "51683": {
          "name": "Manassas",
          "median": 1.12,
          "10%": 0.99,
          "90%": 1.381,
          "25%": 1.05,
          "75%": 1.23
        },
        "51685": {
          "name": "Manassas Park",
          "median": 1.11,
          "10%": 0.97,
          "90%": 1.41,
          "25%": 1.02,
          "75%": 1.22
        },
        "54049": {
          "name": "Marion",
          "median": 1.12,
          "10%": 1.0,
          "90%": 1.31,
          "25%": 1.04,
          "75%": 1.23
        },
        "54051": {
          "name": "Marshall",
          "median": 1.17,
          "10%": 0.96,
          "90%": 1.46,
          "25%": 1.06,
          "75%": 1.31
        },
        "51690": {
          "name": "Martinsville",
          "median": 1.25,
          "10%": 0.98,
          "90%": 1.59,
          "25%": 1.14,
          "75%": 1.45
        },
        "54053": {
          "name": "Mason",
          "median": 1.21,
          "10%": 1.02,
          "90%": 1.44,
          "25%": 1.11,
          "75%": 1.32
        },
        "51115": {
          "name": "Mathews",
          "median": 1.17,
          "10%": 0.96,
          "90%": 1.4,
          "25%": 1.08,
          "75%": 1.28
        },
        "54047": {
          "name": "McDowell",
          "median": 1.15,
          "10%": 1.01,
          "90%": 1.32,
          "25%": 1.08,
          "75%": 1.21
        },
        "42083": {
          "name": "McKean",
          "median": 1.15,
          "10%": 0.94,
          "90%": 1.34,
          "25%": 1.05,
          "75%": 1.26
        },
        "51117": {
          "name": "Mecklenburg",
          "median": 1.21,
          "10%": 1.03,
          "90%": 1.34,
          "25%": 1.11,
          "75%": 1.3
        },
        "34021": {
          "name": "Mercer",
          "median": 1.15,
          "10%": 0.94,
          "90%": 1.34,
          "25%": 1.03,
          "75%": 1.24
        },
        "42085": {
          "name": "Mercer",
          "median": 1.12,
          "10%": 0.99,
          "90%": 1.37,
          "25%": 1.05,
          "75%": 1.26
        },
        "54055": {
          "name": "Mercer",
          "median": 1.16,
          "10%": 1.01,
          "90%": 1.3,
          "25%": 1.09,
          "75%": 1.22
        },
        "51119": {
          "name": "Middlesex",
          "median": 1.1,
          "10%": 0.94,
          "90%": 1.33,
          "25%": 1.02,
          "75%": 1.21
        },
        "42087": {
          "name": "Mifflin",
          "median": 1.21,
          "10%": 1.04,
          "90%": 1.4,
          "25%": 1.13,
          "75%": 1.3
        },
        "54057": {
          "name": "Mineral",
          "median": 1.21,
          "10%": 1.03,
          "90%": 1.45,
          "25%": 1.08,
          "75%": 1.31
        },
        "54059": {
          "name": "Mingo",
          "median": 1.24,
          "10%": 1.05,
          "90%": 1.45,
          "25%": 1.13,
          "75%": 1.36
        },
        "34025": {
          "name": "Monmouth",
          "median": 1.14,
          "10%": 0.97,
          "90%": 1.31,
          "25%": 1.04,
          "75%": 1.23
        },
        "54061": {
          "name": "Monongalia",
          "median": 1.17,
          "10%": 1.01,
          "90%": 1.34,
          "25%": 1.06,
          "75%": 1.26
        },
        "42089": {
          "name": "Monroe",
          "median": 1.25,
          "10%": 1.03,
          "90%": 1.47,
          "25%": 1.15,
          "75%": 1.36
        },
        "54063": {
          "name": "Monroe",
          "median": 1.16,
          "10%": 1.04,
          "90%": 1.32,
          "25%": 1.1,
          "75%": 1.23
        },
        "24031": {
          "name": "Montgomery",
          "median": 1.17,
          "10%": 0.99,
          "90%": 1.43,
          "25%": 1.08,
          "75%": 1.27
        },
        "36057": {
          "name": "Montgomery",
          "median": 1.2,
          "10%": 1.02,
          "90%": 1.45,
          "25%": 1.09,
          "75%": 1.31
        },
        "42091": {
          "name": "Montgomery",
          "median": 1.18,
          "10%": 1.01,
          "90%": 1.42,
          "25%": 1.12,
          "75%": 1.31
        },
        "51121": {
          "name": "Montgomery",
          "median": 1.22,
          "10%": 1.07,
          "90%": 1.37,
          "25%": 1.13,
          "75%": 1.28
        },
        "42093": {
          "name": "Montour",
          "median": 1.26,
          "10%": 1.0,
          "90%": 1.51,
          "25%": 1.13,
          "75%": 1.38
        },
        "54065": {
          "name": "Morgan",
          "median": 1.2,
          "10%": 1.02,
          "90%": 1.49,
          "25%": 1.1,
          "75%": 1.35
        },
        "34027": {
          "name": "Morris",
          "median": 1.23,
          "10%": 1.0,
          "90%": 1.51,
          "25%": 1.11,
          "75%": 1.39
        },
        "36059": {
          "name": "Nassau",
          "median": 1.2,
          "10%": 1.04,
          "90%": 1.4,
          "25%": 1.11,
          "75%": 1.3
        },
        "51125": {
          "name": "Nelson",
          "median": 1.21,
          "10%": 0.95,
          "90%": 1.55,
          "25%": 1.11,
          "75%": 1.39
        },
        "10003": {
          "name": "New Castle",
          "median": 1.19,
          "10%": 0.98,
          "90%": 1.42,
          "25%": 1.08,
          "75%": 1.33
        },
        "51127": {
          "name": "New Kent",
          "median": 1.13,
          "10%": 0.96,
          "90%": 1.36,
          "25%": 1.04,
          "75%": 1.23
        },
        "36061": {
          "name": "New York",
          "median": 1.11,
          "10%": 0.93,
          "90%": 1.35,
          "25%": 1.02,
          "75%": 1.26
        },
        "51700": {
          "name": "Newport News",
          "median": 1.17,
          "10%": 0.97,
          "90%": 1.36,
          "25%": 1.07,
          "75%": 1.26
        },
        "54067": {
          "name": "Nicholas",
          "median": 1.11,
          "10%": 0.95,
          "90%": 1.29,
          "25%": 1.03,
          "75%": 1.2
        },
        "51710": {
          "name": "Norfolk",
          "median": 1.2,
          "10%": 0.99,
          "90%": 1.59,
          "25%": 1.08,
          "75%": 1.41
        },
        "42095": {
          "name": "Northampton",
          "median": 1.16,
          "10%": 0.98,
          "90%": 1.45,
          "25%": 1.06,
          "75%": 1.3
        },
        "51131": {
          "name": "Northampton",
          "median": 1.17,
          "10%": 0.95,
          "90%": 1.4,
          "25%": 1.05,
          "75%": 1.28
        },
        "42097": {
          "name": "Northumberland",
          "median": 1.25,
          "10%": 1.0,
          "90%": 1.51,
          "25%": 1.13,
          "75%": 1.39
        },
        "51133": {
          "name": "Northumberland",
          "median": 1.13,
          "10%": 0.92,
          "90%": 1.4,
          "25%": 0.99,
          "75%": 1.23
        },
        "51720": {
          "name": "Norton",
          "median": 1.23,
          "10%": 1.02,
          "90%": 1.43,
          "25%": 1.12,
          "75%": 1.3425
        },
        "51135": {
          "name": "Nottoway",
          "median": 1.23,
          "10%": 1.02,
          "90%": 1.43,
          "25%": 1.06,
          "75%": 1.33
        },
        "34029": {
          "name": "Ocean",
          "median": 1.12,
          "10%": 1.02,
          "90%": 1.28,
          "25%": 1.06,
          "75%": 1.21
        },
        "54069": {
          "name": "Ohio",
          "median": 1.2,
          "10%": 0.97,
          "90%": 1.52,
          "25%": 1.06,
          "75%": 1.36
        },
        "36065": {
          "name": "Oneida",
          "median": 1.15,
          "10%": 0.98,
          "90%": 1.42,
          "25%": 1.07,
          "75%": 1.26
        },
        "36067": {
          "name": "Onondaga",
          "median": 1.2,
          "10%": 1.01,
          "90%": 1.38,
          "25%": 1.13,
          "75%": 1.26
        },
        "36069": {
          "name": "Ontario",
          "median": 1.2,
          "10%": 1.0,
          "90%": 1.4,
          "25%": 1.09,
          "75%": 1.29
        },
        "36071": {
          "name": "Orange",
          "median": 1.25,
          "10%": 1.01,
          "90%": 1.61,
          "25%": 1.16,
          "75%": 1.4
        },
        "51137": {
          "name": "Orange",
          "median": 1.19,
          "10%": 1.04,
          "90%": 1.47,
          "25%": 1.11,
          "75%": 1.31
        },
        "36077": {
          "name": "Otsego",
          "median": 1.16,
          "10%": 1.01,
          "90%": 1.41,
          "25%": 1.07,
          "75%": 1.24
        },
        "51139": {
          "name": "Page",
          "median": 1.22,
          "10%": 0.98,
          "90%": 1.56,
          "25%": 1.11,
          "75%": 1.34
        },
        "51141": {
          "name": "Patrick",
          "median": 1.21,
          "10%": 0.98,
          "90%": 1.53,
          "25%": 1.09,
          "75%": 1.33
        },
        "54071": {
          "name": "Pendleton",
          "median": 1.17,
          "10%": 0.96,
          "90%": 1.44,
          "25%": 1.04,
          "75%": 1.33
        },
        "42099": {
          "name": "Perry",
          "median": 1.15,
          "10%": 1.01,
          "90%": 1.39,
          "25%": 1.06,
          "75%": 1.3
        },
        "51730": {
          "name": "Petersburg",
          "median": 1.16,
          "10%": 0.97,
          "90%": 1.43,
          "25%": 1.06,
          "75%": 1.27
        },
        "42101": {
          "name": "Philadelphia",
          "median": 1.17,
          "10%": 1.0,
          "90%": 1.37,
          "25%": 1.09,
          "75%": 1.27
        },
        "42103": {
          "name": "Pike",
          "median": 1.29,
          "10%": 0.97,
          "90%": 1.54,
          "25%": 1.14,
          "75%": 1.38
        },
        "51143": {
          "name": "Pittsylvania",
          "median": 1.22,
          "10%": 1.03,
          "90%": 1.441,
          "25%": 1.11,
          "75%": 1.35
        },
        "54073": {
          "name": "Pleasants",
          "median": 1.13,
          "10%": 0.95,
          "90%": 1.34,
          "25%": 1.02,
          "75%": 1.24
        },
        "54075": {
          "name": "Pocahontas",
          "median": 1.16,
          "10%": 1.03,
          "90%": 1.42,
          "25%": 1.09,
          "75%": 1.28
        },
        "51735": {
          "name": "Poquoson",
          "median": 1.18,
          "10%": 1.0,
          "90%": 1.43,
          "25%": 1.07,
          "75%": 1.26
        },
        "51740": {
          "name": "Portsmouth",
          "median": 1.2,
          "10%": 0.98,
          "90%": 1.54,
          "25%": 1.1,
          "75%": 1.4
        },
        "42105": {
          "name": "Potter",
          "median": 1.2,
          "10%": 1.01,
          "90%": 1.35,
          "25%": 1.12,
          "75%": 1.27
        },
        "51145": {
          "name": "Powhatan",
          "median": 1.18,
          "10%": 0.91,
          "90%": 1.55,
          "25%": 1.03,
          "75%": 1.31
        },
        "54077": {
          "name": "Preston",
          "median": 1.2,
          "10%": 1.01,
          "90%": 1.41,
          "25%": 1.08,
          "75%": 1.29
        },
        "51147": {
          "name": "Prince Edward",
          "median": 1.18,
          "10%": 1.03,
          "90%": 1.37,
          "25%": 1.09,
          "75%": 1.27
        },
        "51149": {
          "name": "Prince George",
          "median": 1.16,
          "10%": 0.96,
          "90%": 1.32,
          "25%": 1.06,
          "75%": 1.24
        },
        "24033": {
          "name": "Prince George's",
          "median": 1.18,
          "10%": 0.97,
          "90%": 1.4,
          "25%": 1.03,
          "75%": 1.31
        },
        "51153": {
          "name": "Prince William",
          "median": 1.15,
          "10%": 1.01,
          "90%": 1.37,
          "25%": 1.0675,
          "75%": 1.26
        },
        "51155": {
          "name": "Pulaski",
          "median": 1.2,
          "10%": 1.08,
          "90%": 1.36,
          "25%": 1.13,
          "75%": 1.27
        },
        "54079": {
          "name": "Putnam",
          "median": 1.17,
          "10%": 1.0,
          "90%": 1.38,
          "25%": 1.07,
          "75%": 1.27
        },
        "24035": {
          "name": "Queen Anne's",
          "median": 1.18,
          "10%": 0.97,
          "90%": 1.37,
          "25%": 1.05,
          "75%": 1.28
        },
        "51750": {
          "name": "Radford",
          "median": 1.2,
          "10%": 1.05,
          "90%": 1.36,
          "25%": 1.12,
          "75%": 1.28
        },
        "54081": {
          "name": "Raleigh",
          "median": 1.16,
          "10%": 1.02,
          "90%": 1.35,
          "25%": 1.08,
          "75%": 1.26
        },
        "54083": {
          "name": "Randolph",
          "median": 1.18,
          "10%": 1.02,
          "90%": 1.42,
          "25%": 1.09,
          "75%": 1.3
        },
        "51157": {
          "name": "Rappahannock",
          "median": 1.19,
          "10%": 1.03,
          "90%": 1.38,
          "25%": 1.09,
          "75%": 1.29
        },
        "36085": {
          "name": "Richmond",
          "median": 1.12,
          "10%": 0.93,
          "90%": 1.34,
          "25%": 1.02,
          "75%": 1.24
        },
        "51159": {
          "name": "Richmond",
          "median": 1.11,
          "10%": 0.879,
          "90%": 1.39,
          "25%": 1.0,
          "75%": 1.28
        },
        "51760": {
          "name": "Richmond",
          "median": 1.21,
          "10%": 0.95,
          "90%": 1.53,
          "25%": 1.03,
          "75%": 1.36
        },
        "54085": {
          "name": "Ritchie",
          "median": 1.18,
          "10%": 1.05,
          "90%": 1.35,
          "25%": 1.11,
          "75%": 1.3
        },
        "54087": {
          "name": "Roane",
          "median": 1.18,
          "10%": 1.0,
          "90%": 1.35,
          "25%": 1.07,
          "75%": 1.26
        },
        "51161": {
          "name": "Roanoke",
          "median": 1.27,
          "10%": 1.04,
          "90%": 1.47,
          "25%": 1.15,
          "75%": 1.38
        },
        "51770": {
          "name": "Roanoke",
          "median": 1.27,
          "10%": 1.04,
          "90%": 1.59,
          "25%": 1.14,
          "75%": 1.45
        },
        "51163": {
          "name": "Rockbridge",
          "median": 1.2,
          "10%": 1.01,
          "90%": 1.41,
          "25%": 1.1,
          "75%": 1.33
        },
        "51165": {
          "name": "Rockingham",
          "median": 1.19,
          "10%": 0.95,
          "90%": 1.42,
          "25%": 1.06,
          "75%": 1.31
        },
        "51167": {
          "name": "Russell",
          "median": 1.16,
          "10%": 1.04,
          "90%": 1.32,
          "25%": 1.1,
          "75%": 1.23
        },
        "34033": {
          "name": "Salem",
          "median": 1.17,
          "10%": 0.99,
          "90%": 1.42,
          "25%": 1.11,
          "75%": 1.33
        },
        "51775": {
          "name": "Salem",
          "median": 1.26,
          "10%": 1.04,
          "90%": 1.58,
          "25%": 1.14,
          "75%": 1.42
        },
        "36095": {
          "name": "Schoharie",
          "median": 1.22,
          "10%": 1.02,
          "90%": 1.46,
          "25%": 1.1,
          "75%": 1.33
        },
        "36097": {
          "name": "Schuyler",
          "median": 1.2,
          "10%": 1.03,
          "90%": 1.44,
          "25%": 1.11,
          "75%": 1.33
        },
        "42107": {
          "name": "Schuylkill",
          "median": 1.23,
          "10%": 0.98,
          "90%": 1.45,
          "25%": 1.09,
          "75%": 1.34
        },
        "51169": {
          "name": "Scott",
          "median": 1.21,
          "10%": 1.04,
          "90%": 1.4,
          "25%": 1.14,
          "75%": 1.32
        },
        "51171": {
          "name": "Shenandoah",
          "median": 1.21,
          "10%": 0.98,
          "90%": 1.42,
          "25%": 1.12,
          "75%": 1.31
        },
        "51173": {
          "name": "Smyth",
          "median": 1.18,
          "10%": 1.05,
          "90%": 1.33,
          "25%": 1.09,
          "75%": 1.25
        },
        "42109": {
          "name": "Snyder",
          "median": 1.23,
          "10%": 1.0,
          "90%": 1.46,
          "25%": 1.11,
          "75%": 1.31
        },
        "24039": {
          "name": "Somerset",
          "median": 1.15,
          "10%": 0.97,
          "90%": 1.45,
          "25%": 1.07,
          "75%": 1.25
        },
        "42111": {
          "name": "Somerset",
          "median": 1.18,
          "10%": 1.06,
          "90%": 1.39,
          "25%": 1.1,
          "75%": 1.24
        },
        "51175": {
          "name": "Southampton",
          "median": 1.19,
          "10%": 1.0,
          "90%": 1.43,
          "25%": 1.08,
          "75%": 1.3
        },
        "51177": {
          "name": "Spotsylvania",
          "median": 1.13,
          "10%": 0.94,
          "90%": 1.42,
          "25%": 1.04,
          "75%": 1.3
        },
        "24037": {
          "name": "St. Mary's",
          "median": 1.15,
          "10%": 0.94,
          "90%": 1.38,
          "25%": 1.02,
          "75%": 1.31
        },
        "51179": {
          "name": "Stafford",
          "median": 1.14,
          "10%": 0.95,
          "90%": 1.45,
          "25%": 1.04,
          "75%": 1.3
        },
        "51790": {
          "name": "Staunton",
          "median": 1.18,
          "10%": 0.94,
          "90%": 1.42,
          "25%": 1.06,
          "75%": 1.34
        },
        "36101": {
          "name": "Steuben",
          "median": 1.21,
          "10%": 1.02,
          "90%": 1.38,
          "25%": 1.09,
          "75%": 1.28
        },
        "51800": {
          "name": "Suffolk",
          "median": 1.24,
          "10%": 1.04,
          "90%": 1.47,
          "25%": 1.13,
          "75%": 1.35
        },
        "36105": {
          "name": "Sullivan",
          "median": 1.28,
          "10%": 1.05,
          "90%": 1.52,
          "25%": 1.15,
          "75%": 1.36
        },
        "42113": {
          "name": "Sullivan",
          "median": 1.22,
          "10%": 1.01,
          "90%": 1.47,
          "25%": 1.1,
          "75%": 1.32
        },
        "54089": {
          "name": "Summers",
          "median": 1.17,
          "10%": 1.03,
          "90%": 1.37,
          "25%": 1.09,
          "75%": 1.25
        },
        "51181": {
          "name": "Surry",
          "median": 1.15,
          "10%": 0.96,
          "90%": 1.36,
          "25%": 1.03,
          "75%": 1.26
        },
        "42115": {
          "name": "Susquehanna",
          "median": 1.22,
          "10%": 1.05,
          "90%": 1.43,
          "25%": 1.14,
          "75%": 1.32
        },
        "10005": {
          "name": "Sussex",
          "median": 1.16,
          "10%": 1.0,
          "90%": 1.4,
          "25%": 1.08,
          "75%": 1.24
        },
        "34037": {
          "name": "Sussex",
          "median": 1.27,
          "10%": 1.0,
          "90%": 1.6,
          "25%": 1.15,
          "75%": 1.4
        },
        "51183": {
          "name": "Sussex",
          "median": 1.15,
          "10%": 0.99,
          "90%": 1.41,
          "25%": 1.06,
          "75%": 1.25
        },
        "24041": {
          "name": "Talbot",
          "median": 1.14,
          "10%": 0.93,
          "90%": 1.401,
          "25%": 1.02,
          "75%": 1.25
        },
        "54091": {
          "name": "Taylor",
          "median": 1.2,
          "10%": 0.98,
          "90%": 1.37,
          "25%": 1.09,
          "75%": 1.28
        },
        "51185": {
          "name": "Tazewell",
          "median": 1.16,
          "10%": 1.02,
          "90%": 1.28,
          "25%": 1.1,
          "75%": 1.2
        },
        "36107": {
          "name": "Tioga",
          "median": 1.19,
          "10%": 1.0,
          "90%": 1.43,
          "25%": 1.1,
          "75%": 1.3
        },
        "42117": {
          "name": "Tioga",
          "median": 1.21,
          "10%": 1.03,
          "90%": 1.41,
          "25%": 1.09,
          "75%": 1.31
        },
        "36109": {
          "name": "Tompkins",
          "median": 1.2,
          "10%": 1.03,
          "90%": 1.39,
          "25%": 1.1275,
          "75%": 1.28
        },
        "54093": {
          "name": "Tucker",
          "median": 1.15,
          "10%": 0.98,
          "90%": 1.38,
          "25%": 1.07,
          "75%": 1.29
        },
        "54095": {
          "name": "Tyler",
          "median": 1.11,
          "10%": 0.92,
          "90%": 1.3,
          "25%": 1.02,
          "75%": 1.21
        },
        "36111": {
          "name": "Ulster",
          "median": 1.25,
          "10%": 1.05,
          "90%": 1.49,
          "25%": 1.16,
          "75%": 1.4
        },
        "42119": {
          "name": "Union",
          "median": 1.19,
          "10%": 1.04,
          "90%": 1.41,
          "25%": 1.12,
          "75%": 1.3
        },
        "54097": {
          "name": "Upshur",
          "median": 1.19,
          "10%": 1.02,
          "90%": 1.41,
          "25%": 1.08,
          "75%": 1.28
        },
        "42121": {
          "name": "Venango",
          "median": 1.16,
          "10%": 0.99,
          "90%": 1.41,
          "25%": 1.05,
          "75%": 1.27
        },
        "51810": {
          "name": "Virginia Beach",
          "median": 1.19,
          "10%": 0.98,
          "90%": 1.52,
          "25%": 1.08,
          "75%": 1.36
        },
        "34041": {
          "name": "Warren",
          "median": 1.22,
          "10%": 1.0,
          "90%": 1.54,
          "25%": 1.13,
          "75%": 1.33
        },
        "42123": {
          "name": "Warren",
          "median": 1.15,
          "10%": 0.97,
          "90%": 1.38,
          "25%": 1.04,
          "75%": 1.24
        },
        "51187": {
          "name": "Warren",
          "median": 1.19,
          "10%": 1.02,
          "90%": 1.38,
          "25%": 1.11,
          "75%": 1.28
        },
        "24043": {
          "name": "Washington",
          "median": 1.15,
          "10%": 1.0,
          "90%": 1.47,
          "25%": 1.06,
          "75%": 1.3
        },
        "42125": {
          "name": "Washington",
          "median": 1.17,
          "10%": 1.01,
          "90%": 1.451,
          "25%": 1.08,
          "75%": 1.29
        },
        "51191": {
          "name": "Washington",
          "median": 1.16,
          "10%": 1.02,
          "90%": 1.34,
          "25%": 1.07,
          "75%": 1.23
        },
        "42127": {
          "name": "Wayne",
          "median": 1.26,
          "10%": 0.999,
          "90%": 1.49,
          "25%": 1.15,
          "75%": 1.35
        },
        "54099": {
          "name": "Wayne",
          "median": 1.2,
          "10%": 1.05,
          "90%": 1.47,
          "25%": 1.14,
          "75%": 1.34
        },
        "51820": {
          "name": "Waynesboro",
          "median": 1.2,
          "10%": 0.95,
          "90%": 1.46,
          "25%": 1.06,
          "75%": 1.32
        },
        "54101": {
          "name": "Webster",
          "median": 1.11,
          "10%": 0.97,
          "90%": 1.28,
          "25%": 1.03,
          "75%": 1.2
        },
        "36119": {
          "name": "Westchester",
          "median": 1.17,
          "10%": 1.0,
          "90%": 1.46,
          "25%": 1.07,
          "75%": 1.3
        },
        "42129": {
          "name": "Westmoreland",
          "median": 1.22,
          "10%": 1.02,
          "90%": 1.43,
          "25%": 1.12,
          "75%": 1.32
        },
        "51193": {
          "name": "Westmoreland",
          "median": 1.13,
          "10%": 0.92,
          "90%": 1.38,
          "25%": 1.02,
          "75%": 1.29
        },
        "54103": {
          "name": "Wetzel",
          "median": 1.13,
          "10%": 0.99,
          "90%": 1.37,
          "25%": 1.05,
          "75%": 1.27
        },
        "24045": {
          "name": "Wicomico",
          "median": 1.15,
          "10%": 1.02,
          "90%": 1.37,
          "25%": 1.07,
          "75%": 1.22
        },
        "51830": {
          "name": "Williamsburg",
          "median": 1.1,
          "10%": 0.87,
          "90%": 1.38,
          "25%": 0.98,
          "75%": 1.26
        },
        "51840": {
          "name": "Winchester",
          "median": 1.2,
          "10%": 1.02,
          "90%": 1.43,
          "25%": 1.09,
          "75%": 1.33
        },
        "54105": {
          "name": "Wirt",
          "median": 1.24,
          "10%": 1.06,
          "90%": 1.41,
          "25%": 1.16,
          "75%": 1.34
        },
        "51195": {
          "name": "Wise",
          "median": 1.2,
          "10%": 1.05,
          "90%": 1.41,
          "25%": 1.12,
          "75%": 1.31
        },
        "54107": {
          "name": "Wood",
          "median": 1.22,
          "10%": 0.97,
          "90%": 1.39,
          "25%": 1.06,
          "75%": 1.32
        },
        "24047": {
          "name": "Worcester",
          "median": 1.17,
          "10%": 1.0,
          "90%": 1.49,
          "25%": 1.07,
          "75%": 1.27
        },
        "42131": {
          "name": "Wyoming",
          "median": 1.24,
          "10%": 1.09,
          "90%": 1.43,
          "25%": 1.17,
          "75%": 1.33
        },
        "54109": {
          "name": "Wyoming",
          "median": 1.16,
          "10%": 1.02,
          "90%": 1.33,
          "25%": 1.09,
          "75%": 1.25
        },
        "51197": {
          "name": "Wythe",
          "median": 1.13,
          "10%": 1.02,
          "90%": 1.31,
          "25%": 1.07,
          "75%": 1.24
        },
        "36123": {
          "name": "Yates",
          "median": 1.23,
          "10%": 1.0,
          "90%": 1.441,
          "25%": 1.09,
          "75%": 1.34
        },
        "42133": {
          "name": "York",
          "median": 1.22,
          "10%": 0.99,
          "90%": 1.56,
          "25%": 1.08,
          "75%": 1.3625
        },
        "51199": {
          "name": "York",
          "median": 1.16,
          "10%": 0.94,
          "90%": 1.35,
          "25%": 1.04,
          "75%": 1.25
        },
        "max": 1.3,
        "min": 1
      },
      "100": {
        "51001": {
          "name": "Accomack",
          "median": 1.2,
          "10%": 0.96,
          "90%": 1.43,
          "25%": 1.09,
          "75%": 1.28
        },
        "42001": {
          "name": "Adams",
          "median": 1.12,
          "10%": 0.86,
          "90%": 1.59,
          "25%": 0.98,
          "75%": 1.28
        },
        "51003": {
          "name": "Albemarle",
          "median": 1.16,
          "10%": 0.93,
          "90%": 1.54,
          "25%": 1.06,
          "75%": 1.36
        },
        "51510": {
          "name": "Alexandria",
          "median": 1.13,
          "10%": 0.86,
          "90%": 1.57,
          "25%": 0.95,
          "75%": 1.35
        },
        "24001": {
          "name": "Allegany",
          "median": 1.21,
          "10%": 0.979,
          "90%": 1.51,
          "25%": 1.09,
          "75%": 1.36
        },
        "36003": {
          "name": "Allegany",
          "median": 1.19,
          "10%": 0.96,
          "90%": 1.39,
          "25%": 1.06,
          "75%": 1.28
        },
        "51005": {
          "name": "Alleghany",
          "median": 1.22,
          "10%": 0.96,
          "90%": 1.62,
          "25%": 1.09,
          "75%": 1.36
        },
        "42003": {
          "name": "Allegheny",
          "median": 1.17,
          "10%": 0.99,
          "90%": 1.48,
          "25%": 1.05,
          "75%": 1.33
        },
        "51007": {
          "name": "Amelia",
          "median": 1.18,
          "10%": 0.98,
          "90%": 1.641,
          "25%": 1.06,
          "75%": 1.4
        },
        "51009": {
          "name": "Amherst",
          "median": 1.22,
          "10%": 0.99,
          "90%": 1.46,
          "25%": 1.08,
          "75%": 1.33
        },
        "24003": {
          "name": "Anne Arundel",
          "median": 1.19,
          "10%": 0.91,
          "90%": 1.46,
          "25%": 1.0,
          "75%": 1.34
        },
        "51011": {
          "name": "Appomattox",
          "median": 1.18,
          "10%": 0.97,
          "90%": 1.57,
          "25%": 1.06,
          "75%": 1.36
        },
        "51013": {
          "name": "Arlington",
          "median": 1.15,
          "10%": 0.89,
          "90%": 1.47,
          "25%": 1.02,
          "75%": 1.3
        },
        "42005": {
          "name": "Armstrong",
          "median": 1.21,
          "10%": 1.0,
          "90%": 1.58,
          "25%": 1.08,
          "75%": 1.43
        },
        "34001": {
          "name": "Atlantic",
          "median": 1.21,
          "10%": 0.97,
          "90%": 1.52,
          "25%": 1.07,
          "75%": 1.37
        },
        "51015": {
          "name": "Augusta",
          "median": 1.17,
          "10%": 0.9,
          "90%": 1.381,
          "25%": 1.04,
          "75%": 1.31
        },
        "24005": {
          "name": "Baltimore",
          "median": 1.19,
          "10%": 0.96,
          "90%": 1.58,
          "25%": 1.07,
          "75%": 1.3
        },
        "24510": {
          "name": "Baltimore",
          "median": 1.11,
          "10%": 0.9,
          "90%": 1.51,
          "25%": 1.0,
          "75%": 1.3
        },
        "54001": {
          "name": "Barbour",
          "median": 1.16,
          "10%": 0.94,
          "90%": 1.45,
          "25%": 1.04,
          "75%": 1.31
        },
        "51017": {
          "name": "Bath",
          "median": 1.2,
          "10%": 0.98,
          "90%": 1.59,
          "25%": 1.05,
          "75%": 1.4
        },
        "42007": {
          "name": "Beaver",
          "median": 1.14,
          "10%": 0.91,
          "90%": 1.47,
          "25%": 1.0,
          "75%": 1.28
        },
        "42009": {
          "name": "Bedford",
          "median": 1.24,
          "10%": 1.01,
          "90%": 1.5,
          "25%": 1.14,
          "75%": 1.3325
        },
        "51019": {
          "name": "Bedford",
          "median": 1.27,
          "10%": 1.04,
          "90%": 1.47,
          "25%": 1.14,
          "75%": 1.35
        },
        "54003": {
          "name": "Berkeley",
          "median": 1.15,
          "10%": 0.99,
          "90%": 1.49,
          "25%": 1.06,
          "75%": 1.27
        },
        "42011": {
          "name": "Berks",
          "median": 1.18,
          "10%": 0.93,
          "90%": 1.54,
          "25%": 1.09,
          "75%": 1.38
        },
        "42013": {
          "name": "Blair",
          "median": 1.23,
          "10%": 1.0,
          "90%": 1.46,
          "25%": 1.13,
          "75%": 1.35
        },
        "51021": {
          "name": "Bland",
          "median": 1.12,
          "10%": 0.97,
          "90%": 1.32,
          "25%": 1.03,
          "75%": 1.22
        },
        "54005": {
          "name": "Boone",
          "median": 1.17,
          "10%": 0.98,
          "90%": 1.38,
          "25%": 1.06,
          "75%": 1.3
        },
        "51023": {
          "name": "Botetourt",
          "median": 1.25,
          "10%": 1.06,
          "90%": 1.5,
          "25%": 1.12,
          "75%": 1.39
        },
        "42015": {
          "name": "Bradford",
          "median": 1.27,
          "10%": 0.98,
          "90%": 1.65,
          "25%": 1.13,
          "75%": 1.4325
        },
        "54007": {
          "name": "Braxton",
          "median": 1.09,
          "10%": 0.93,
          "90%": 1.34,
          "25%": 1.01,
          "75%": 1.18
        },
        "51520": {
          "name": "Bristol",
          "median": 1.17,
          "10%": 1.01,
          "90%": 1.44,
          "25%": 1.09,
          "75%": 1.29
        },
        "36005": {
          "name": "Bronx",
          "median": 1.12,
          "10%": 0.91,
          "90%": 1.35,
          "25%": 1.02,
          "75%": 1.22
        },
        "54009": {
          "name": "Brooke",
          "median": 1.22,
          "10%": 0.909,
          "90%": 1.47,
          "25%": 1.05,
          "75%": 1.33
        },
        "36007": {
          "name": "Broome",
          "median": 1.19,
          "10%": 1.0,
          "90%": 1.38,
          "25%": 1.08,
          "75%": 1.31
        },
        "51025": {
          "name": "Brunswick",
          "median": 1.18,
          "10%": 0.97,
          "90%": 1.43,
          "25%": 1.08,
          "75%": 1.34
        },
        "51027": {
          "name": "Buchanan",
          "median": 1.15,
          "10%": 0.95,
          "90%": 1.33,
          "25%": 1.05,
          "75%": 1.25
        },
        "51029": {
          "name": "Buckingham",
          "median": 1.18,
          "10%": 0.99,
          "90%": 1.51,
          "25%": 1.09,
          "75%": 1.32
        },
        "42017": {
          "name": "Bucks",
          "median": 1.15,
          "10%": 0.98,
          "90%": 1.46,
          "25%": 1.08,
          "75%": 1.3125
        },
        "51530": {
          "name": "Buena Vista",
          "median": 1.18,
          "10%": 0.92,
          "90%": 1.441,
          "25%": 1.03,
          "75%": 1.31
        },
        "34005": {
          "name": "Burlington",
          "median": 1.16,
          "10%": 0.98,
          "90%": 1.4,
          "25%": 1.04,
          "75%": 1.25
        },
        "42019": {
          "name": "Butler",
          "median": 1.17,
          "10%": 0.95,
          "90%": 1.42,
          "25%": 1.06,
          "75%": 1.31
        },
        "54011": {
          "name": "Cabell",
          "median": 1.17,
          "10%": 0.97,
          "90%": 1.51,
          "25%": 1.09,
          "75%": 1.34
        },
        "54013": {
          "name": "Calhoun",
          "median": 1.18,
          "10%": 0.94,
          "90%": 1.51,
          "25%": 1.04,
          "75%": 1.34
        },
        "24009": {
          "name": "Calvert",
          "median": 1.205,
          "10%": 0.92,
          "90%": 1.47,
          "25%": 1.01,
          "75%": 1.34
        },
        "42021": {
          "name": "Cambria",
          "median": 1.19,
          "10%": 0.97,
          "90%": 1.49,
          "25%": 1.08,
          "75%": 1.34
        },
        "34007": {
          "name": "Camden",
          "median": 1.16,
          "10%": 0.97,
          "90%": 1.48,
          "25%": 1.06,
          "75%": 1.31
        },
        "42023": {
          "name": "Cameron",
          "median": 1.2,
          "10%": 1.0,
          "90%": 1.42,
          "25%": 1.12,
          "75%": 1.31
        },
        "51031": {
          "name": "Campbell",
          "median": 1.18,
          "10%": 1.01,
          "90%": 1.42,
          "25%": 1.09,
          "75%": 1.33
        },
        "34009": {
          "name": "Cape May",
          "median": 1.2,
          "10%": 0.99,
          "90%": 1.5,
          "25%": 1.11,
          "75%": 1.34
        },
        "42025": {
          "name": "Carbon",
          "median": 1.23,
          "10%": 0.96,
          "90%": 1.49,
          "25%": 1.1,
          "75%": 1.34
        },
        "24011": {
          "name": "Caroline",
          "median": 1.18,
          "10%": 0.95,
          "90%": 1.5,
          "25%": 1.05,
          "75%": 1.34
        },
        "51033": {
          "name": "Caroline",
          "median": 1.13,
          "10%": 0.91,
          "90%": 1.55,
          "25%": 1.01,
          "75%": 1.32
        },
        "24013": {
          "name": "Carroll",
          "median": 1.18,
          "10%": 0.94,
          "90%": 1.6,
          "25%": 1.04,
          "75%": 1.38
        },
        "51035": {
          "name": "Carroll",
          "median": 1.16,
          "10%": 1.03,
          "90%": 1.45,
          "25%": 1.09,
          "75%": 1.29
        },
        "24015": {
          "name": "Cecil",
          "median": 1.16,
          "10%": 0.91,
          "90%": 1.42,
          "25%": 1.06,
          "75%": 1.27
        },
        "42027": {
          "name": "Centre",
          "median": 1.2,
          "10%": 1.0,
          "90%": 1.45,
          "25%": 1.11,
          "75%": 1.33
        },
        "24017": {
          "name": "Charles",
          "median": 1.21,
          "10%": 0.87,
          "90%": 1.64,
          "25%": 1.02,
          "75%": 1.4
        },
        "51036": {
          "name": "Charles City",
          "median": 1.13,
          "10%": 0.91,
          "90%": 1.38,
          "25%": 0.99,
          "75%": 1.25
        },
        "51037": {
          "name": "Charlotte",
          "median": 1.18,
          "10%": 1.02,
          "90%": 1.48,
          "25%": 1.1,
          "75%": 1.3
        },
        "51540": {
          "name": "Charlottesville",
          "median": 1.16,
          "10%": 0.92,
          "90%": 1.52,
          "25%": 1.03,
          "75%": 1.36
        },
        "36015": {
          "name": "Chemung",
          "median": 1.18,
          "10%": 1.01,
          "90%": 1.46,
          "25%": 1.09,
          "75%": 1.31
        },
        "36017": {
          "name": "Chenango",
          "median": 1.18,
          "10%": 0.98,
          "90%": 1.42,
          "25%": 1.05,
          "75%": 1.3
        },
        "51550": {
          "name": "Chesapeake",
          "median": 1.23,
          "10%": 1.02,
          "90%": 1.53,
          "25%": 1.12,
          "75%": 1.41
        },
        "42029": {
          "name": "Chester",
          "median": 1.19,
          "10%": 0.95,
          "90%": 1.54,
          "25%": 1.07,
          "75%": 1.33
        },
        "51041": {
          "name": "Chesterfield",
          "median": 1.19,
          "10%": 0.94,
          "90%": 1.52,
          "25%": 1.05,
          "75%": 1.37
        },
        "42031": {
          "name": "Clarion",
          "median": 1.16,
          "10%": 1.0,
          "90%": 1.49,
          "25%": 1.07,
          "75%": 1.33
        },
        "51043": {
          "name": "Clarke",
          "median": 1.12,
          "10%": 0.91,
          "90%": 1.42,
          "25%": 1.0,
          "75%": 1.25
        },
        "54015": {
          "name": "Clay",
          "median": 1.11,
          "10%": 0.9,
          "90%": 1.43,
          "25%": 1.01,
          "75%": 1.25
        },
        "42033": {
          "name": "Clearfield",
          "median": 1.17,
          "10%": 1.01,
          "90%": 1.47,
          "25%": 1.1,
          "75%": 1.29
        },
        "42035": {
          "name": "Clinton",
          "median": 1.22,
          "10%": 0.98,
          "90%": 1.5,
          "25%": 1.09,
          "75%": 1.36
        },
        "51570": {
          "name": "Colonial Heights",
          "median": 1.17,
          "10%": 0.93,
          "90%": 1.48,
          "25%": 1.03,
          "75%": 1.31
        },
        "42037": {
          "name": "Columbia",
          "median": 1.23,
          "10%": 1.03,
          "90%": 1.56,
          "25%": 1.11,
          "75%": 1.4
        },
        "36023": {
          "name": "Cortland",
          "median": 1.22,
          "10%": 0.99,
          "90%": 1.43,
          "25%": 1.1,
          "75%": 1.34
        },
        "51580": {
          "name": "Covington",
          "median": 1.17,
          "10%": 0.98,
          "90%": 1.72,
          "25%": 1.06,
          "75%": 1.42
        },
        "51045": {
          "name": "Craig",
          "median": 1.24,
          "10%": 1.04,
          "90%": 1.45,
          "25%": 1.12,
          "75%": 1.34
        },
        "42039": {
          "name": "Crawford",
          "median": 1.14,
          "10%": 0.98,
          "90%": 1.43,
          "25%": 1.03,
          "75%": 1.28
        },
        "51047": {
          "name": "Culpeper",
          "median": 1.17,
          "10%": 0.96,
          "90%": 1.4,
          "25%": 1.06,
          "75%": 1.27
        },
        "34011": {
          "name": "Cumberland",
          "median": 1.16,
          "10%": 0.95,
          "90%": 1.55,
          "25%": 1.08,
          "75%": 1.34
        },
        "42041": {
          "name": "Cumberland",
          "median": 1.15,
          "10%": 0.97,
          "90%": 1.49,
          "25%": 1.06,
          "75%": 1.29
        },
        "51049": {
          "name": "Cumberland",
          "median": 1.18,
          "10%": 0.99,
          "90%": 1.47,
          "25%": 1.04,
          "75%": 1.33
        },
        "51590": {
          "name": "Danville",
          "median": 1.19,
          "10%": 0.95,
          "90%": 1.521,
          "25%": 1.06,
          "75%": 1.34
        },
        "42043": {
          "name": "Dauphin",
          "median": 1.25,
          "10%": 0.98,
          "90%": 1.57,
          "25%": 1.08,
          "75%": 1.4
        },
        "36025": {
          "name": "Delaware",
          "median": 1.26,
          "10%": 1.03,
          "90%": 1.52,
          "25%": 1.14,
          "75%": 1.35
        },
        "42045": {
          "name": "Delaware",
          "median": 1.21,
          "10%": 0.95,
          "90%": 1.49,
          "25%": 1.07,
          "75%": 1.38
        },
        "51051": {
          "name": "Dickenson",
          "median": 1.18,
          "10%": 0.99,
          "90%": 1.38,
          "25%": 1.06,
          "75%": 1.28
        },
        "51053": {
          "name": "Dinwiddie",
          "median": 1.16,
          "10%": 0.97,
          "90%": 1.39,
          "25%": 1.06,
          "75%": 1.3
        },
        "11001": {
          "name": "District of Columbia",
          "median": 1.17,
          "10%": 0.93,
          "90%": 1.46,
          "25%": 1.04,
          "75%": 1.32
        },
        "54017": {
          "name": "Doddridge",
          "median": 1.17,
          "10%": 0.92,
          "90%": 1.39,
          "25%": 1.07,
          "75%": 1.28
        },
        "24019": {
          "name": "Dorchester",
          "median": 1.13,
          "10%": 0.89,
          "90%": 1.42,
          "25%": 1.0,
          "75%": 1.29
        },
        "42047": {
          "name": "Elk",
          "median": 1.12,
          "10%": 0.92,
          "90%": 1.44,
          "25%": 1.02,
          "75%": 1.31
        },
        "51595": {
          "name": "Emporia",
          "median": 1.12,
          "10%": 0.89,
          "90%": 1.46,
          "25%": 1.02,
          "75%": 1.29
        },
        "42049": {
          "name": "Erie",
          "median": 1.18,
          "10%": 0.99,
          "90%": 1.43,
          "25%": 1.05,
          "75%": 1.28
        },
        "51057": {
          "name": "Essex",
          "median": 1.12,
          "10%": 0.9,
          "90%": 1.42,
          "25%": 0.98,
          "75%": 1.25
        },
        "51059": {
          "name": "Fairfax",
          "median": 1.17,
          "10%": 0.97,
          "90%": 1.46,
          "25%": 1.04,
          "75%": 1.27
        },
        "51600": {
          "name": "Fairfax",
          "median": 1.16,
          "10%": 0.92,
          "90%": 1.431,
          "25%": 1.06,
          "75%": 1.26
        },
        "51610": {
          "name": "Falls Church",
          "median": 1.16,
          "10%": 0.94,
          "90%": 1.49,
          "25%": 1.01,
          "75%": 1.28
        },
        "51061": {
          "name": "Fauquier",
          "median": 1.17,
          "10%": 0.9,
          "90%": 1.42,
          "25%": 1.02,
          "75%": 1.31
        },
        "42051": {
          "name": "Fayette",
          "median": 1.22,
          "10%": 1.0,
          "90%": 1.5,
          "25%": 1.1,
          "75%": 1.37
        },
        "54019": {
          "name": "Fayette",
          "median": 1.11,
          "10%": 0.97,
          "90%": 1.29,
          "25%": 1.06,
          "75%": 1.18
        },
        "51063": {
          "name": "Floyd",
          "median": 1.195,
          "10%": 0.96,
          "90%": 1.43,
          "25%": 1.08,
          "75%": 1.29
        },
        "51065": {
          "name": "Fluvanna",
          "median": 1.19,
          "10%": 0.87,
          "90%": 1.79,
          "25%": 1.05,
          "75%": 1.44
        },
        "42053": {
          "name": "Forest",
          "median": 1.12,
          "10%": 0.919,
          "90%": 1.43,
          "25%": 1.0,
          "75%": 1.29
        },
        "42055": {
          "name": "Franklin",
          "median": 1.18,
          "10%": 1.0,
          "90%": 1.55,
          "25%": 1.07,
          "75%": 1.33
        },
        "51067": {
          "name": "Franklin",
          "median": 1.24,
          "10%": 1.0,
          "90%": 1.53,
          "25%": 1.1,
          "75%": 1.39
        },
        "51620": {
          "name": "Franklin",
          "median": 1.23,
          "10%": 1.02,
          "90%": 1.53,
          "25%": 1.11,
          "75%": 1.35
        },
        "24021": {
          "name": "Frederick",
          "median": 1.15,
          "10%": 0.94,
          "90%": 1.53,
          "25%": 1.04,
          "75%": 1.28
        },
        "51069": {
          "name": "Frederick",
          "median": 1.19,
          "10%": 0.97,
          "90%": 1.45,
          "25%": 1.08,
          "75%": 1.33
        },
        "51630": {
          "name": "Fredericksburg",
          "median": 1.15,
          "10%": 0.85,
          "90%": 1.62,
          "25%": 0.99,
          "75%": 1.36
        },
        "42057": {
          "name": "Fulton",
          "median": 1.25,
          "10%": 0.99,
          "90%": 1.54,
          "25%": 1.15,
          "75%": 1.37
        },
        "51640": {
          "name": "Galax",
          "median": 1.15,
          "10%": 0.88,
          "90%": 1.49,
          "25%": 0.98,
          "75%": 1.32
        },
        "24023": {
          "name": "Garrett",
          "median": 1.13,
          "10%": 0.98,
          "90%": 1.43,
          "25%": 1.06,
          "75%": 1.2325
        },
        "51071": {
          "name": "Giles",
          "median": 1.2,
          "10%": 1.01,
          "90%": 1.35,
          "25%": 1.12,
          "75%": 1.26
        },
        "54021": {
          "name": "Gilmer",
          "median": 1.12,
          "10%": 0.93,
          "90%": 1.42,
          "25%": 1.01,
          "75%": 1.25
        },
        "34015": {
          "name": "Gloucester",
          "median": 1.18,
          "10%": 0.95,
          "90%": 1.51,
          "25%": 1.07,
          "75%": 1.33
        },
        "51073": {
          "name": "Gloucester",
          "median": 1.15,
          "10%": 0.9,
          "90%": 1.42,
          "25%": 1.04,
          "75%": 1.25
        },
        "51075": {
          "name": "Goochland",
          "median": 1.21,
          "10%": 0.85,
          "90%": 1.72,
          "25%": 0.99,
          "75%": 1.46
        },
        "54023": {
          "name": "Grant",
          "median": 1.13,
          "10%": 0.99,
          "90%": 1.38,
          "25%": 1.06,
          "75%": 1.25
        },
        "51077": {
          "name": "Grayson",
          "median": 1.14,
          "10%": 1.0,
          "90%": 1.37,
          "25%": 1.07,
          "75%": 1.28
        },
        "54025": {
          "name": "Greenbrier",
          "median": 1.18,
          "10%": 0.99,
          "90%": 1.37,
          "25%": 1.07,
          "75%": 1.29
        },
        "36039": {
          "name": "Greene",
          "median": 1.31,
          "10%": 0.98,
          "90%": 1.53,
          "25%": 1.15,
          "75%": 1.42
        },
        "42059": {
          "name": "Greene",
          "median": 1.19,
          "10%": 1.0,
          "90%": 1.49,
          "25%": 1.08,
          "75%": 1.33
        },
        "51079": {
          "name": "Greene",
          "median": 1.18,
          "10%": 0.95,
          "90%": 1.59,
          "25%": 1.07,
          "75%": 1.35
        },
        "51081": {
          "name": "Greensville",
          "median": 1.17,
          "10%": 0.93,
          "90%": 1.46,
          "25%": 1.03,
          "75%": 1.3
        },
        "51083": {
          "name": "Halifax",
          "median": 1.24,
          "10%": 1.04,
          "90%": 1.57,
          "25%": 1.12,
          "75%": 1.37
        },
        "54027": {
          "name": "Hampshire",
          "median": 1.23,
          "10%": 1.02,
          "90%": 1.64,
          "25%": 1.09,
          "75%": 1.41
        },
        "51650": {
          "name": "Hampton",
          "median": 1.22,
          "10%": 0.94,
          "90%": 1.5,
          "25%": 1.06,
          "75%": 1.32
        },
        "54029": {
          "name": "Hancock",
          "median": 1.11,
          "10%": 0.9,
          "90%": 1.39,
          "25%": 0.99,
          "75%": 1.2525
        },
        "51085": {
          "name": "Hanover",
          "median": 1.11,
          "10%": 0.95,
          "90%": 1.48,
          "25%": 1.02,
          "75%": 1.29
        },
        "54031": {
          "name": "Hardy",
          "median": 1.2,
          "10%": 1.0,
          "90%": 1.48,
          "25%": 1.1,
          "75%": 1.33
        },
        "24025": {
          "name": "Harford",
          "median": 1.18,
          "10%": 0.9,
          "90%": 1.55,
          "25%": 1.03,
          "75%": 1.33
        },
        "54033": {
          "name": "Harrison",
          "median": 1.12,
          "10%": 0.94,
          "90%": 1.38,
          "25%": 1.04,
          "75%": 1.25
        },
        "51660": {
          "name": "Harrisonburg",
          "median": 1.15,
          "10%": 0.86,
          "90%": 1.52,
          "25%": 0.98,
          "75%": 1.38
        },
        "51087": {
          "name": "Henrico",
          "median": 1.22,
          "10%": 0.93,
          "90%": 1.49,
          "25%": 1.01,
          "75%": 1.34
        },
        "51089": {
          "name": "Henry",
          "median": 1.26,
          "10%": 0.99,
          "90%": 1.68,
          "25%": 1.12,
          "75%": 1.49
        },
        "36043": {
          "name": "Herkimer",
          "median": 1.13,
          "10%": 0.95,
          "90%": 1.4,
          "25%": 1.03,
          "75%": 1.28
        },
        "51091": {
          "name": "Highland",
          "median": 1.17,
          "10%": 1.0,
          "90%": 1.49,
          "25%": 1.04,
          "75%": 1.33
        },
        "51670": {
          "name": "Hopewell",
          "median": 1.14,
          "10%": 0.89,
          "90%": 1.42,
          "25%": 0.97,
          "75%": 1.3
        },
        "24027": {
          "name": "Howard",
          "median": 1.13,
          "10%": 0.93,
          "90%": 1.47,
          "25%": 1.02,
          "75%": 1.2925
        },
        "34019": {
          "name": "Hunterdon",
          "median": 1.18,
          "10%": 0.94,
          "90%": 1.53,
          "25%": 1.07,
          "75%": 1.38
        },
        "42061": {
          "name": "Huntingdon",
          "median": 1.25,
          "10%": 1.0,
          "90%": 1.47,
          "25%": 1.14,
          "75%": 1.38
        },
        "42063": {
          "name": "Indiana",
          "median": 1.24,
          "10%": 1.03,
          "90%": 1.57,
          "25%": 1.11,
          "75%": 1.38
        },
        "51093": {
          "name": "Isle of Wight",
          "median": 1.23,
          "10%": 1.0,
          "90%": 1.5,
          "25%": 1.1275,
          "75%": 1.38
        },
        "54035": {
          "name": "Jackson",
          "median": 1.21,
          "10%": 0.98,
          "90%": 1.46,
          "25%": 1.08,
          "75%": 1.33
        },
        "51095": {
          "name": "James City",
          "median": 1.13,
          "10%": 0.84,
          "90%": 1.44,
          "25%": 0.97,
          "75%": 1.29
        },
        "42065": {
          "name": "Jefferson",
          "median": 1.22,
          "10%": 1.02,
          "90%": 1.46,
          "25%": 1.09,
          "75%": 1.36
        },
        "54037": {
          "name": "Jefferson",
          "median": 1.1,
          "10%": 0.94,
          "90%": 1.44,
          "25%": 1.0,
          "75%": 1.19
        },
        "42067": {
          "name": "Juniata",
          "median": 1.2,
          "10%": 0.98,
          "90%": 1.42,
          "25%": 1.07,
          "75%": 1.29
        },
        "54039": {
          "name": "Kanawha",
          "median": 1.09,
          "10%": 0.96,
          "90%": 1.26,
          "25%": 1.02,
          "75%": 1.17
        },
        "10001": {
          "name": "Kent",
          "median": 1.14,
          "10%": 0.95,
          "90%": 1.4,
          "25%": 1.06,
          "75%": 1.31
        },
        "24029": {
          "name": "Kent",
          "median": 1.18,
          "10%": 0.9,
          "90%": 1.42,
          "25%": 1.01,
          "75%": 1.33
        },
        "51099": {
          "name": "King George",
          "median": 1.09,
          "10%": 0.89,
          "90%": 1.53,
          "25%": 0.99,
          "75%": 1.35
        },
        "51101": {
          "name": "King William",
          "median": 1.13,
          "10%": 0.94,
          "90%": 1.43,
          "25%": 1.01,
          "75%": 1.27
        },
        "51097": {
          "name": "King and Queen",
          "median": 1.09,
          "10%": 0.9,
          "90%": 1.43,
          "25%": 1.0,
          "75%": 1.24
        },
        "42069": {
          "name": "Lackawanna",
          "median": 1.29,
          "10%": 1.0,
          "90%": 1.54,
          "25%": 1.15,
          "75%": 1.4
        },
        "42071": {
          "name": "Lancaster",
          "median": 1.21,
          "10%": 0.94,
          "90%": 1.59,
          "25%": 1.06,
          "75%": 1.41
        },
        "51103": {
          "name": "Lancaster",
          "median": 1.09,
          "10%": 0.9,
          "90%": 1.42,
          "25%": 0.98,
          "75%": 1.26
        },
        "42073": {
          "name": "Lawrence",
          "median": 1.18,
          "10%": 0.91,
          "90%": 1.451,
          "25%": 1.02,
          "75%": 1.27
        },
        "42075": {
          "name": "Lebanon",
          "median": 1.24,
          "10%": 0.9,
          "90%": 1.55,
          "25%": 1.08,
          "75%": 1.38
        },
        "51105": {
          "name": "Lee",
          "median": 1.25,
          "10%": 1.08,
          "90%": 1.61,
          "25%": 1.16,
          "75%": 1.39
        },
        "42077": {
          "name": "Lehigh",
          "median": 1.19,
          "10%": 0.969,
          "90%": 1.45,
          "25%": 1.05,
          "75%": 1.33
        },
        "54041": {
          "name": "Lewis",
          "median": 1.16,
          "10%": 0.99,
          "90%": 1.36,
          "25%": 1.07,
          "75%": 1.25
        },
        "51678": {
          "name": "Lexington",
          "median": 1.16,
          "10%": 0.93,
          "90%": 1.44,
          "25%": 1.02,
          "75%": 1.3
        },
        "54043": {
          "name": "Lincoln",
          "median": 1.18,
          "10%": 0.98,
          "90%": 1.53,
          "25%": 1.06,
          "75%": 1.33
        },
        "36051": {
          "name": "Livingston",
          "median": 1.19,
          "10%": 0.97,
          "90%": 1.49,
          "25%": 1.07,
          "75%": 1.32
        },
        "54045": {
          "name": "Logan",
          "median": 1.22,
          "10%": 0.99,
          "90%": 1.48,
          "25%": 1.07,
          "75%": 1.34
        },
        "51107": {
          "name": "Loudoun",
          "median": 1.14,
          "10%": 0.98,
          "90%": 1.481,
          "25%": 1.05,
          "75%": 1.26
        },
        "51109": {
          "name": "Louisa",
          "median": 1.2,
          "10%": 0.91,
          "90%": 1.62,
          "25%": 1.05,
          "75%": 1.37
        },
        "51111": {
          "name": "Lunenburg",
          "median": 1.22,
          "10%": 0.96,
          "90%": 1.47,
          "25%": 1.07,
          "75%": 1.36
        },
        "42079": {
          "name": "Luzerne",
          "median": 1.25,
          "10%": 1.02,
          "90%": 1.41,
          "25%": 1.17,
          "75%": 1.31
        },
        "42081": {
          "name": "Lycoming",
          "median": 1.26,
          "10%": 1.03,
          "90%": 1.61,
          "25%": 1.12,
          "75%": 1.41
        },
        "51680": {
          "name": "Lynchburg",
          "median": 1.21,
          "10%": 0.98,
          "90%": 1.49,
          "25%": 1.08,
          "75%": 1.31
        },
        "36053": {
          "name": "Madison",
          "median": 1.17,
          "10%": 0.91,
          "90%": 1.42,
          "25%": 1.06,
          "75%": 1.27
        },
        "51113": {
          "name": "Madison",
          "median": 1.19,
          "10%": 0.94,
          "90%": 1.54,
          "25%": 1.1,
          "75%": 1.37
        },
        "51683": {
          "name": "Manassas",
          "median": 1.13,
          "10%": 0.97,
          "90%": 1.46,
          "25%": 1.05,
          "75%": 1.25
        },
        "51685": {
          "name": "Manassas Park",
          "median": 1.12,
          "10%": 0.96,
          "90%": 1.49,
          "25%": 1.03,
          "75%": 1.24
        },
        "54049": {
          "name": "Marion",
          "median": 1.1,
          "10%": 0.97,
          "90%": 1.371,
          "25%": 1.02,
          "75%": 1.26
        },
        "54051": {
          "name": "Marshall",
          "median": 1.16,
          "10%": 0.9,
          "90%": 1.54,
          "25%": 1.02,
          "75%": 1.34
        },
        "51690": {
          "name": "Martinsville",
          "median": 1.27,
          "10%": 0.96,
          "90%": 1.68,
          "25%": 1.13,
          "75%": 1.53
        },
        "54053": {
          "name": "Mason",
          "median": 1.21,
          "10%": 0.97,
          "90%": 1.49,
          "25%": 1.1,
          "75%": 1.33
        },
        "51115": {
          "name": "Mathews",
          "median": 1.18,
          "10%": 0.94,
          "90%": 1.47,
          "25%": 1.05,
          "75%": 1.29
        },
        "54047": {
          "name": "McDowell",
          "median": 1.13,
          "10%": 0.979,
          "90%": 1.33,
          "25%": 1.05,
          "75%": 1.22
        },
        "42083": {
          "name": "McKean",
          "median": 1.14,
          "10%": 0.92,
          "90%": 1.37,
          "25%": 1.03,
          "75%": 1.27
        },
        "51117": {
          "name": "Mecklenburg",
          "median": 1.23,
          "10%": 1.01,
          "90%": 1.39,
          "25%": 1.12,
          "75%": 1.32
        },
        "34021": {
          "name": "Mercer",
          "median": 1.15,
          "10%": 0.9,
          "90%": 1.46,
          "25%": 1.01,
          "75%": 1.27
        },
        "42085": {
          "name": "Mercer",
          "median": 1.12,
          "10%": 0.95,
          "90%": 1.43,
          "25%": 1.02,
          "75%": 1.27
        },
        "54055": {
          "name": "Mercer",
          "median": 1.16,
          "10%": 0.98,
          "90%": 1.34,
          "25%": 1.07,
          "75%": 1.23
        },
        "51119": {
          "name": "Middlesex",
          "median": 1.07,
          "10%": 0.91,
          "90%": 1.39,
          "25%": 1.0,
          "75%": 1.23
        },
        "42087": {
          "name": "Mifflin",
          "median": 1.21,
          "10%": 1.0,
          "90%": 1.42,
          "25%": 1.11,
          "75%": 1.31
        },
        "54057": {
          "name": "Mineral",
          "median": 1.21,
          "10%": 0.98,
          "90%": 1.47,
          "25%": 1.06,
          "75%": 1.32
        },
        "54059": {
          "name": "Mingo",
          "median": 1.26,
          "10%": 1.04,
          "90%": 1.5,
          "25%": 1.12,
          "75%": 1.4
        },
        "34025": {
          "name": "Monmouth",
          "median": 1.14,
          "10%": 0.93,
          "90%": 1.38,
          "25%": 1.02,
          "75%": 1.26
        },
        "54061": {
          "name": "Monongalia",
          "median": 1.19,
          "10%": 0.97,
          "90%": 1.4,
          "25%": 1.05,
          "75%": 1.3
        },
        "42089": {
          "name": "Monroe",
          "median": 1.25,
          "10%": 1.0,
          "90%": 1.57,
          "25%": 1.14,
          "75%": 1.39
        },
        "54063": {
          "name": "Monroe",
          "median": 1.17,
          "10%": 1.01,
          "90%": 1.38,
          "25%": 1.08,
          "75%": 1.25
        },
        "24031": {
          "name": "Montgomery",
          "median": 1.17,
          "10%": 0.97,
          "90%": 1.54,
          "25%": 1.05,
          "75%": 1.32
        },
        "36057": {
          "name": "Montgomery",
          "median": 1.2,
          "10%": 1.0,
          "90%": 1.51,
          "25%": 1.09,
          "75%": 1.32
        },
        "42091": {
          "name": "Montgomery",
          "median": 1.18,
          "10%": 0.99,
          "90%": 1.47,
          "25%": 1.09,
          "75%": 1.34
        },
        "51121": {
          "name": "Montgomery",
          "median": 1.21,
          "10%": 1.02,
          "90%": 1.4,
          "25%": 1.11,
          "75%": 1.31
        },
        "42093": {
          "name": "Montour",
          "median": 1.26,
          "10%": 0.99,
          "90%": 1.58,
          "25%": 1.1,
          "75%": 1.4
        },
        "54065": {
          "name": "Morgan",
          "median": 1.2,
          "10%": 0.97,
          "90%": 1.55,
          "25%": 1.08,
          "75%": 1.34
        },
        "34027": {
          "name": "Morris",
          "median": 1.23,
          "10%": 0.96,
          "90%": 1.54,
          "25%": 1.09,
          "75%": 1.42
        },
        "36059": {
          "name": "Nassau",
          "median": 1.2,
          "10%": 0.97,
          "90%": 1.49,
          "25%": 1.08,
          "75%": 1.33
        },
        "51125": {
          "name": "Nelson",
          "median": 1.2,
          "10%": 0.91,
          "90%": 1.56,
          "25%": 1.1,
          "75%": 1.42
        },
        "10003": {
          "name": "New Castle",
          "median": 1.17,
          "10%": 0.94,
          "90%": 1.43,
          "25%": 1.07,
          "75%": 1.34
        },
        "51127": {
          "name": "New Kent",
          "median": 1.13,
          "10%": 0.939,
          "90%": 1.41,
          "25%": 1.02,
          "75%": 1.24
        },
        "36061": {
          "name": "New York",
          "median": 1.08,
          "10%": 0.86,
          "90%": 1.38,
          "25%": 0.97,
          "75%": 1.27
        },
        "51700": {
          "name": "Newport News",
          "median": 1.18,
          "10%": 0.93,
          "90%": 1.41,
          "25%": 1.05,
          "75%": 1.28
        },
        "54067": {
          "name": "Nicholas",
          "median": 1.09,
          "10%": 0.92,
          "90%": 1.32,
          "25%": 1.0,
          "75%": 1.2
        },
        "51710": {
          "name": "Norfolk",
          "median": 1.2,
          "10%": 0.95,
          "90%": 1.7,
          "25%": 1.07,
          "75%": 1.47
        },
        "42095": {
          "name": "Northampton",
          "median": 1.16,
          "10%": 0.94,
          "90%": 1.53,
          "25%": 1.04,
          "75%": 1.35
        },
        "51131": {
          "name": "Northampton",
          "median": 1.18,
          "10%": 0.93,
          "90%": 1.46,
          "25%": 1.04,
          "75%": 1.3
        },
        "42097": {
          "name": "Northumberland",
          "median": 1.26,
          "10%": 0.98,
          "90%": 1.58,
          "25%": 1.11,
          "75%": 1.41
        },
        "51133": {
          "name": "Northumberland",
          "median": 1.11,
          "10%": 0.89,
          "90%": 1.44,
          "25%": 0.98,
          "75%": 1.24
        },
        "51720": {
          "name": "Norton",
          "median": 1.25,
          "10%": 0.98,
          "90%": 1.5,
          "25%": 1.12,
          "75%": 1.36
        },
        "51135": {
          "name": "Nottoway",
          "median": 1.24,
          "10%": 1.01,
          "90%": 1.52,
          "25%": 1.05,
          "75%": 1.37
        },
        "34029": {
          "name": "Ocean",
          "median": 1.11,
          "10%": 0.99,
          "90%": 1.34,
          "25%": 1.05,
          "75%": 1.22
        },
        "54069": {
          "name": "Ohio",
          "median": 1.22,
          "10%": 0.9,
          "90%": 1.57,
          "25%": 1.04,
          "75%": 1.39
        },
        "36065": {
          "name": "Oneida",
          "median": 1.16,
          "10%": 0.93,
          "90%": 1.45,
          "25%": 1.04,
          "75%": 1.29
        },
        "36067": {
          "name": "Onondaga",
          "median": 1.2,
          "10%": 0.97,
          "90%": 1.4,
          "25%": 1.12,
          "75%": 1.29
        },
        "36069": {
          "name": "Ontario",
          "median": 1.21,
          "10%": 0.98,
          "90%": 1.49,
          "25%": 1.1,
          "75%": 1.34
        },
        "36071": {
          "name": "Orange",
          "median": 1.28,
          "10%": 0.98,
          "90%": 1.74,
          "25%": 1.15,
          "75%": 1.48
        },
        "51137": {
          "name": "Orange",
          "median": 1.19,
          "10%": 1.02,
          "90%": 1.51,
          "25%": 1.09,
          "75%": 1.31
        },
        "36077": {
          "name": "Otsego",
          "median": 1.17,
          "10%": 0.98,
          "90%": 1.45,
          "25%": 1.07,
          "75%": 1.26
        },
        "51139": {
          "name": "Page",
          "median": 1.23,
          "10%": 0.94,
          "90%": 1.65,
          "25%": 1.09,
          "75%": 1.38
        },
        "51141": {
          "name": "Patrick",
          "median": 1.23,
          "10%": 0.95,
          "90%": 1.63,
          "25%": 1.0875,
          "75%": 1.39
        },
        "54071": {
          "name": "Pendleton",
          "median": 1.16,
          "10%": 0.92,
          "90%": 1.52,
          "25%": 1.0,
          "75%": 1.33
        },
        "42099": {
          "name": "Perry",
          "median": 1.13,
          "10%": 0.94,
          "90%": 1.43,
          "25%": 1.02,
          "75%": 1.31
        },
        "51730": {
          "name": "Petersburg",
          "median": 1.17,
          "10%": 0.94,
          "90%": 1.47,
          "25%": 1.03,
          "75%": 1.31
        },
        "42101": {
          "name": "Philadelphia",
          "median": 1.17,
          "10%": 0.97,
          "90%": 1.4,
          "25%": 1.05,
          "75%": 1.29
        },
        "42103": {
          "name": "Pike",
          "median": 1.31,
          "10%": 0.97,
          "90%": 1.68,
          "25%": 1.14,
          "75%": 1.44
        },
        "51143": {
          "name": "Pittsylvania",
          "median": 1.2,
          "10%": 0.99,
          "90%": 1.52,
          "25%": 1.09,
          "75%": 1.36
        },
        "54073": {
          "name": "Pleasants",
          "median": 1.12,
          "10%": 0.92,
          "90%": 1.35,
          "25%": 1.0,
          "75%": 1.27
        },
        "54075": {
          "name": "Pocahontas",
          "median": 1.17,
          "10%": 1.02,
          "90%": 1.46,
          "25%": 1.08,
          "75%": 1.31
        },
        "51735": {
          "name": "Poquoson",
          "median": 1.19,
          "10%": 0.95,
          "90%": 1.48,
          "25%": 1.07,
          "75%": 1.31
        },
        "51740": {
          "name": "Portsmouth",
          "median": 1.2,
          "10%": 0.97,
          "90%": 1.6,
          "25%": 1.09,
          "75%": 1.44
        },
        "42105": {
          "name": "Potter",
          "median": 1.21,
          "10%": 0.96,
          "90%": 1.36,
          "25%": 1.12,
          "75%": 1.29
        },
        "51145": {
          "name": "Powhatan",
          "median": 1.19,
          "10%": 0.88,
          "90%": 1.65,
          "25%": 1.0,
          "75%": 1.37
        },
        "54077": {
          "name": "Preston",
          "median": 1.2,
          "10%": 0.97,
          "90%": 1.49,
          "25%": 1.06,
          "75%": 1.3
        },
        "51147": {
          "name": "Prince Edward",
          "median": 1.18,
          "10%": 0.99,
          "90%": 1.45,
          "25%": 1.09,
          "75%": 1.29
        },
        "51149": {
          "name": "Prince George",
          "median": 1.16,
          "10%": 0.91,
          "90%": 1.37,
          "25%": 1.02,
          "75%": 1.27
        },
        "24033": {
          "name": "Prince George's",
          "median": 1.19,
          "10%": 0.95,
          "90%": 1.471,
          "25%": 1.02,
          "75%": 1.36
        },
        "51153": {
          "name": "Prince William",
          "median": 1.16,
          "10%": 0.99,
          "90%": 1.42,
          "25%": 1.06,
          "75%": 1.28
        },
        "51155": {
          "name": "Pulaski",
          "median": 1.2,
          "10%": 1.06,
          "90%": 1.38,
          "25%": 1.12,
          "75%": 1.27
        },
        "54079": {
          "name": "Putnam",
          "median": 1.18,
          "10%": 0.96,
          "90%": 1.44,
          "25%": 1.07,
          "75%": 1.3
        },
        "24035": {
          "name": "Queen Anne's",
          "median": 1.17,
          "10%": 0.91,
          "90%": 1.42,
          "25%": 1.02,
          "75%": 1.3
        },
        "51750": {
          "name": "Radford",
          "median": 1.18,
          "10%": 1.02,
          "90%": 1.4,
          "25%": 1.1,
          "75%": 1.29
        },
        "54081": {
          "name": "Raleigh",
          "median": 1.16,
          "10%": 1.0,
          "90%": 1.41,
          "25%": 1.07,
          "75%": 1.29
        },
        "54083": {
          "name": "Randolph",
          "median": 1.19,
          "10%": 1.0,
          "90%": 1.52,
          "25%": 1.08,
          "75%": 1.36
        },
        "51157": {
          "name": "Rappahannock",
          "median": 1.17,
          "10%": 1.0,
          "90%": 1.481,
          "25%": 1.06,
          "75%": 1.31
        },
        "36085": {
          "name": "Richmond",
          "median": 1.12,
          "10%": 0.87,
          "90%": 1.35,
          "25%": 0.96,
          "75%": 1.25
        },
        "51159": {
          "name": "Richmond",
          "median": 1.1,
          "10%": 0.84,
          "90%": 1.4,
          "25%": 0.97,
          "75%": 1.26
        },
        "51760": {
          "name": "Richmond",
          "median": 1.21,
          "10%": 0.9,
          "90%": 1.59,
          "25%": 0.99,
          "75%": 1.4
        },
        "54085": {
          "name": "Ritchie",
          "median": 1.19,
          "10%": 1.03,
          "90%": 1.38,
          "25%": 1.1,
          "75%": 1.32
        },
        "54087": {
          "name": "Roane",
          "median": 1.18,
          "10%": 0.96,
          "90%": 1.4,
          "25%": 1.07,
          "75%": 1.27
        },
        "51161": {
          "name": "Roanoke",
          "median": 1.28,
          "10%": 1.01,
          "90%": 1.48,
          "25%": 1.14,
          "75%": 1.4125
        },
        "51770": {
          "name": "Roanoke",
          "median": 1.31,
          "10%": 1.0,
          "90%": 1.7,
          "25%": 1.12,
          "75%": 1.48
        },
        "51163": {
          "name": "Rockbridge",
          "median": 1.2,
          "10%": 0.98,
          "90%": 1.42,
          "25%": 1.07,
          "75%": 1.33
        },
        "51165": {
          "name": "Rockingham",
          "median": 1.18,
          "10%": 0.91,
          "90%": 1.47,
          "25%": 1.03,
          "75%": 1.32
        },
        "51167": {
          "name": "Russell",
          "median": 1.17,
          "10%": 1.02,
          "90%": 1.35,
          "25%": 1.1,
          "75%": 1.25
        },
        "34033": {
          "name": "Salem",
          "median": 1.17,
          "10%": 0.97,
          "90%": 1.46,
          "25%": 1.07,
          "75%": 1.35
        },
        "51775": {
          "name": "Salem",
          "median": 1.26,
          "10%": 1.01,
          "90%": 1.6,
          "25%": 1.12,
          "75%": 1.46
        },
        "36095": {
          "name": "Schoharie",
          "median": 1.21,
          "10%": 1.019,
          "90%": 1.5,
          "25%": 1.09,
          "75%": 1.35
        },
        "36097": {
          "name": "Schuyler",
          "median": 1.2,
          "10%": 0.99,
          "90%": 1.48,
          "25%": 1.09,
          "75%": 1.36
        },
        "42107": {
          "name": "Schuylkill",
          "median": 1.23,
          "10%": 0.94,
          "90%": 1.49,
          "25%": 1.08,
          "75%": 1.38
        },
        "51169": {
          "name": "Scott",
          "median": 1.22,
          "10%": 1.01,
          "90%": 1.44,
          "25%": 1.13,
          "75%": 1.32
        },
        "51171": {
          "name": "Shenandoah",
          "median": 1.2,
          "10%": 0.95,
          "90%": 1.48,
          "25%": 1.1,
          "75%": 1.32
        },
        "51173": {
          "name": "Smyth",
          "median": 1.18,
          "10%": 1.01,
          "90%": 1.39,
          "25%": 1.07,
          "75%": 1.27
        },
        "42109": {
          "name": "Snyder",
          "median": 1.24,
          "10%": 0.97,
          "90%": 1.53,
          "25%": 1.09,
          "75%": 1.34
        },
        "24039": {
          "name": "Somerset",
          "median": 1.14,
          "10%": 0.92,
          "90%": 1.44,
          "25%": 1.03,
          "75%": 1.28
        },
        "42111": {
          "name": "Somerset",
          "median": 1.17,
          "10%": 1.03,
          "90%": 1.43,
          "25%": 1.09,
          "75%": 1.25
        },
        "51175": {
          "name": "Southampton",
          "median": 1.2,
          "10%": 0.99,
          "90%": 1.48,
          "25%": 1.09,
          "75%": 1.32
        },
        "51177": {
          "name": "Spotsylvania",
          "median": 1.13,
          "10%": 0.92,
          "90%": 1.45,
          "25%": 1.02,
          "75%": 1.32
        },
        "24037": {
          "name": "St. Mary's",
          "median": 1.15,
          "10%": 0.9,
          "90%": 1.43,
          "25%": 1.0,
          "75%": 1.32
        },
        "51179": {
          "name": "Stafford",
          "median": 1.12,
          "10%": 0.91,
          "90%": 1.56,
          "25%": 1.02,
          "75%": 1.3
        },
        "51790": {
          "name": "Staunton",
          "median": 1.17,
          "10%": 0.89,
          "90%": 1.46,
          "25%": 1.0,
          "75%": 1.31
        },
        "36101": {
          "name": "Steuben",
          "median": 1.2,
          "10%": 0.98,
          "90%": 1.41,
          "25%": 1.08,
          "75%": 1.31
        },
        "51800": {
          "name": "Suffolk",
          "median": 1.24,
          "10%": 1.04,
          "90%": 1.52,
          "25%": 1.14,
          "75%": 1.37
        },
        "36105": {
          "name": "Sullivan",
          "median": 1.29,
          "10%": 1.04,
          "90%": 1.65,
          "25%": 1.18,
          "75%": 1.4
        },
        "42113": {
          "name": "Sullivan",
          "median": 1.24,
          "10%": 0.98,
          "90%": 1.58,
          "25%": 1.08,
          "75%": 1.4
        },
        "54089": {
          "name": "Summers",
          "median": 1.18,
          "10%": 1.0,
          "90%": 1.44,
          "25%": 1.08,
          "75%": 1.28
        },
        "51181": {
          "name": "Surry",
          "median": 1.16,
          "10%": 0.899,
          "90%": 1.41,
          "25%": 1.01,
          "75%": 1.26
        },
        "42115": {
          "name": "Susquehanna",
          "median": 1.25,
          "10%": 1.04,
          "90%": 1.55,
          "25%": 1.14,
          "75%": 1.41
        },
        "10005": {
          "name": "Sussex",
          "median": 1.16,
          "10%": 0.98,
          "90%": 1.44,
          "25%": 1.07,
          "75%": 1.28
        },
        "34037": {
          "name": "Sussex",
          "median": 1.3,
          "10%": 0.97,
          "90%": 1.74,
          "25%": 1.1375,
          "75%": 1.49
        },
        "51183": {
          "name": "Sussex",
          "median": 1.14,
          "10%": 0.95,
          "90%": 1.49,
          "25%": 1.04,
          "75%": 1.29
        },
        "24041": {
          "name": "Talbot",
          "median": 1.14,
          "10%": 0.89,
          "90%": 1.5,
          "25%": 1.02,
          "75%": 1.31
        },
        "54091": {
          "name": "Taylor",
          "median": 1.21,
          "10%": 0.92,
          "90%": 1.43,
          "25%": 1.07,
          "75%": 1.3
        },
        "51185": {
          "name": "Tazewell",
          "median": 1.16,
          "10%": 1.0,
          "90%": 1.32,
          "25%": 1.09,
          "75%": 1.21
        },
        "36107": {
          "name": "Tioga",
          "median": 1.23,
          "10%": 0.97,
          "90%": 1.531,
          "25%": 1.09,
          "75%": 1.39
        },
        "42117": {
          "name": "Tioga",
          "median": 1.21,
          "10%": 1.01,
          "90%": 1.5,
          "25%": 1.08,
          "75%": 1.35
        },
        "36109": {
          "name": "Tompkins",
          "median": 1.22,
          "10%": 1.02,
          "90%": 1.48,
          "25%": 1.11,
          "75%": 1.3325
        },
        "54093": {
          "name": "Tucker",
          "median": 1.15,
          "10%": 0.96,
          "90%": 1.44,
          "25%": 1.05,
          "75%": 1.31
        },
        "54095": {
          "name": "Tyler",
          "median": 1.11,
          "10%": 0.9,
          "90%": 1.35,
          "25%": 1.0,
          "75%": 1.22
        },
        "36111": {
          "name": "Ulster",
          "median": 1.28,
          "10%": 1.03,
          "90%": 1.561,
          "25%": 1.16,
          "75%": 1.42
        },
        "42119": {
          "name": "Union",
          "median": 1.2,
          "10%": 1.03,
          "90%": 1.49,
          "25%": 1.11,
          "75%": 1.32
        },
        "54097": {
          "name": "Upshur",
          "median": 1.21,
          "10%": 1.01,
          "90%": 1.5,
          "25%": 1.07,
          "75%": 1.33
        },
        "42121": {
          "name": "Venango",
          "median": 1.15,
          "10%": 0.97,
          "90%": 1.43,
          "25%": 1.03,
          "75%": 1.27
        },
        "51810": {
          "name": "Virginia Beach",
          "median": 1.18,
          "10%": 0.97,
          "90%": 1.591,
          "25%": 1.07,
          "75%": 1.39
        },
        "34041": {
          "name": "Warren",
          "median": 1.22,
          "10%": 0.93,
          "90%": 1.58,
          "25%": 1.11,
          "75%": 1.39
        },
        "42123": {
          "name": "Warren",
          "median": 1.13,
          "10%": 0.95,
          "90%": 1.4,
          "25%": 1.02,
          "75%": 1.24
        },
        "51187": {
          "name": "Warren",
          "median": 1.17,
          "10%": 0.96,
          "90%": 1.46,
          "25%": 1.06,
          "75%": 1.29
        },
        "24043": {
          "name": "Washington",
          "median": 1.13,
          "10%": 0.969,
          "90%": 1.49,
          "25%": 1.04,
          "75%": 1.3
        },
        "42125": {
          "name": "Washington",
          "median": 1.17,
          "10%": 0.99,
          "90%": 1.5,
          "25%": 1.07,
          "75%": 1.31
        },
        "51191": {
          "name": "Washington",
          "median": 1.16,
          "10%": 1.0,
          "90%": 1.39,
          "25%": 1.06,
          "75%": 1.27
        },
        "42127": {
          "name": "Wayne",
          "median": 1.27,
          "10%": 1.0,
          "90%": 1.54,
          "25%": 1.15,
          "75%": 1.41
        },
        "54099": {
          "name": "Wayne",
          "median": 1.22,
          "10%": 1.04,
          "90%": 1.53,
          "25%": 1.13,
          "75%": 1.4
        },
        "51820": {
          "name": "Waynesboro",
          "median": 1.2,
          "10%": 0.87,
          "90%": 1.49,
          "25%": 1.02,
          "75%": 1.33
        },
        "54101": {
          "name": "Webster",
          "median": 1.1,
          "10%": 0.95,
          "90%": 1.32,
          "25%": 1.01,
          "75%": 1.22
        },
        "36119": {
          "name": "Westchester",
          "median": 1.15,
          "10%": 0.97,
          "90%": 1.47,
          "25%": 1.04,
          "75%": 1.29
        },
        "42129": {
          "name": "Westmoreland",
          "median": 1.26,
          "10%": 1.0,
          "90%": 1.5,
          "25%": 1.12,
          "75%": 1.38
        },
        "51193": {
          "name": "Westmoreland",
          "median": 1.13,
          "10%": 0.89,
          "90%": 1.45,
          "25%": 1.0,
          "75%": 1.26
        },
        "54103": {
          "name": "Wetzel",
          "median": 1.12,
          "10%": 0.95,
          "90%": 1.42,
          "25%": 1.03,
          "75%": 1.3
        },
        "24045": {
          "name": "Wicomico",
          "median": 1.15,
          "10%": 0.97,
          "90%": 1.4,
          "25%": 1.06,
          "75%": 1.24
        },
        "51830": {
          "name": "Williamsburg",
          "median": 1.11,
          "10%": 0.82,
          "90%": 1.54,
          "25%": 0.95,
          "75%": 1.28
        },
        "51840": {
          "name": "Winchester",
          "median": 1.2,
          "10%": 0.95,
          "90%": 1.51,
          "25%": 1.07,
          "75%": 1.34
        },
        "54105": {
          "name": "Wirt",
          "median": 1.24,
          "10%": 1.02,
          "90%": 1.45,
          "25%": 1.12,
          "75%": 1.35
        },
        "51195": {
          "name": "Wise",
          "median": 1.21,
          "10%": 1.02,
          "90%": 1.43,
          "25%": 1.11,
          "75%": 1.34
        },
        "54107": {
          "name": "Wood",
          "median": 1.23,
          "10%": 0.95,
          "90%": 1.44,
          "25%": 1.05,
          "75%": 1.33
        },
        "24047": {
          "name": "Worcester",
          "median": 1.18,
          "10%": 0.96,
          "90%": 1.53,
          "25%": 1.06,
          "75%": 1.32
        },
        "42131": {
          "name": "Wyoming",
          "median": 1.26,
          "10%": 1.09,
          "90%": 1.53,
          "25%": 1.17,
          "75%": 1.39
        },
        "54109": {
          "name": "Wyoming",
          "median": 1.16,
          "10%": 0.99,
          "90%": 1.37,
          "25%": 1.06,
          "75%": 1.25
        },
        "51197": {
          "name": "Wythe",
          "median": 1.13,
          "10%": 0.99,
          "90%": 1.35,
          "25%": 1.05,
          "75%": 1.25
        },
        "36123": {
          "name": "Yates",
          "median": 1.25,
          "10%": 0.97,
          "90%": 1.48,
          "25%": 1.08,
          "75%": 1.38
        },
        "42133": {
          "name": "York",
          "median": 1.22,
          "10%": 0.96,
          "90%": 1.7,
          "25%": 1.0775,
          "75%": 1.42
        },
        "51199": {
          "name": "York",
          "median": 1.16,
          "10%": 0.9,
          "90%": 1.44,
          "25%": 1.02,
          "75%": 1.28
        },
        "max": 1.31,
        "min": 1
      }
    }
  }
};

export const stations = {
  "USW00014736 6": {
    "fips": "42013",
    "station_name": "ALTOONA BLAIR COUNTY AP",
    "state": "PA",
    "latitude": "40.2963",
    "longitude": "-78.3202",
    "5min": {
      "2-mid": "0.37",
      "2-bound": [0.33, 0.41],
      "5-mid": "0.45",
      "5-bound": [0.4, 0.5],
      "10-mid": "0.51",
      "10-bound": [0.45, 0.57],
      "25-mid": "0.59",
      "25-bound": [0.53, 0.66],
      "50-mid": "0.66",
      "50-bound": [0.58, 0.73],
      "100-mid": "0.73",
      "100-bound": [0.64, 0.8]
    },
    "10min": {
      "2-mid": "0.57",
      "2-bound": [0.51, 0.64],
      "5-mid": "0.69",
      "5-bound": [0.62, 0.77],
      "10-mid": "0.79",
      "10-bound": [0.7, 0.88],
      "25-mid": "0.91",
      "25-bound": [0.8, 1.01],
      "50-mid": "1.0",
      "50-bound": [0.88, 1.11],
      "100-mid": "1.09",
      "100-bound": [0.96, 1.21]
    },
    "15min": {
      "2-mid": "0.7",
      "2-bound": [0.63, 0.78],
      "5-mid": "0.85",
      "5-bound": [0.76, 0.95],
      "10-mid": "0.97",
      "10-bound": [0.86, 1.08],
      "25-mid": "1.12",
      "25-bound": [0.99, 1.25],
      "50-mid": "1.24",
      "50-bound": [1.09, 1.37],
      "100-mid": "1.36",
      "100-bound": [1.19, 1.5]
    },
    "30min": {
      "2-mid": "0.94",
      "2-bound": [0.84, 1.05],
      "5-mid": "1.17",
      "5-bound": [1.04, 1.3],
      "10-mid": "1.34",
      "10-bound": [1.2, 1.5],
      "25-mid": "1.58",
      "25-bound": [1.4, 1.76],
      "50-mid": "1.77",
      "50-bound": [1.56, 1.96],
      "100-mid": "1.96",
      "100-bound": [1.72, 2.17]
    },
    "60min": {
      "2-mid": "1.15",
      "2-bound": [1.03, 1.28],
      "5-mid": "1.46",
      "5-bound": [1.31, 1.63],
      "10-mid": "1.71",
      "10-bound": [1.52, 1.9],
      "25-mid": "2.06",
      "25-bound": [1.82, 2.28],
      "50-mid": "2.33",
      "50-bound": [2.05, 2.58],
      "100-mid": "2.62",
      "100-bound": [2.3, 2.9]
    },
    "2hr": {
      "2-mid": "1.31",
      "2-bound": [1.17, 1.48],
      "5-mid": "1.68",
      "5-bound": [1.49, 1.89],
      "10-mid": "1.97",
      "10-bound": [1.74, 2.21],
      "25-mid": "2.39",
      "25-bound": [2.09, 2.67],
      "50-mid": "2.73",
      "50-bound": [2.38, 3.04],
      "100-mid": "3.09",
      "100-bound": [2.68, 3.44]
    },
    "3hr": {
      "2-mid": "1.41",
      "2-bound": [1.27, 1.59],
      "5-mid": "1.79",
      "5-bound": [1.6, 2.01],
      "10-mid": "2.1",
      "10-bound": [1.87, 2.34],
      "25-mid": "2.54",
      "25-bound": [2.24, 2.83],
      "50-mid": "2.9",
      "50-bound": [2.55, 3.21],
      "100-mid": "3.3",
      "100-bound": [2.87, 3.65]
    },
    "6hr": {
      "2-mid": "1.77",
      "2-bound": [1.6, 1.98],
      "5-mid": "2.21",
      "5-bound": [1.99, 2.47],
      "10-mid": "2.58",
      "10-bound": [2.31, 2.87],
      "25-mid": "3.1",
      "25-bound": [2.76, 3.44],
      "50-mid": "3.54",
      "50-bound": [3.13, 3.92],
      "100-mid": "4.01",
      "100-bound": [3.51, 4.42]
    },
    "12hr": {
      "2-mid": "2.16",
      "2-bound": [1.94, 2.43],
      "5-mid": "2.69",
      "5-bound": [2.41, 3.02],
      "10-mid": "3.13",
      "10-bound": [2.8, 3.5],
      "25-mid": "3.78",
      "25-bound": [3.35, 4.21],
      "50-mid": "4.32",
      "50-bound": [3.81, 4.81],
      "100-mid": "4.92",
      "100-bound": [4.3, 5.44]
    },
    "24hr": {
      "2-mid": "2.62",
      "2-bound": [2.41, 2.86],
      "5-mid": "3.26",
      "5-bound": [3.0, 3.56],
      "10-mid": "3.79",
      "10-bound": [3.47, 4.13],
      "25-mid": "4.55",
      "25-bound": [4.15, 4.95],
      "50-mid": "5.18",
      "50-bound": [4.7, 5.63],
      "100-mid": "5.86",
      "100-bound": [5.28, 6.35]
    },
    "2day": {
      "2-mid": "2.99",
      "2-bound": [2.75, 3.29],
      "5-mid": "3.71",
      "5-bound": [3.41, 4.08],
      "10-mid": "4.31",
      "10-bound": [3.95, 4.73],
      "25-mid": "5.18",
      "25-bound": [4.72, 5.66],
      "50-mid": "5.9",
      "50-bound": [5.36, 6.45],
      "100-mid": "6.68",
      "100-bound": [6.02, 7.29]
    },
    "3day": {
      "2-mid": "3.22",
      "2-bound": [2.97, 3.52],
      "5-mid": "3.98",
      "5-bound": [3.67, 4.35],
      "10-mid": "4.61",
      "10-bound": [4.24, 5.03],
      "25-mid": "5.52",
      "25-bound": [5.05, 6.02],
      "50-mid": "6.28",
      "50-bound": [5.72, 6.84],
      "100-mid": "7.09",
      "100-bound": [6.41, 7.72]
    },
    "4day": {
      "2-mid": "3.44",
      "2-bound": [3.18, 3.74],
      "5-mid": "4.25",
      "5-bound": [3.92, 4.63],
      "10-mid": "4.91",
      "10-bound": [4.52, 5.34],
      "25-mid": "5.87",
      "25-bound": [5.38, 6.38],
      "50-mid": "6.67",
      "50-bound": [6.08, 7.23],
      "100-mid": "7.51",
      "100-bound": [6.81, 8.15]
    },
    "7day": {
      "2-mid": "4.03",
      "2-bound": [3.75, 4.35],
      "5-mid": "4.92",
      "5-bound": [4.58, 5.31],
      "10-mid": "5.63",
      "10-bound": [5.22, 6.08],
      "25-mid": "6.62",
      "25-bound": [6.12, 7.14],
      "50-mid": "7.41",
      "50-bound": [6.81, 7.98],
      "100-mid": "8.22",
      "100-bound": [7.53, 8.88]
    }
  },
  "USC00302454 6": {
    "fips": "36025",
    "station_name": "EAST SIDNEY",
    "state": "NY",
    "latitude": "42.3327",
    "longitude": "-75.2298",
    "5min": {
      "2-mid": "0.39",
      "2-bound": [0.3, 0.49],
      "5-mid": "0.5",
      "5-bound": [0.39, 0.64],
      "10-mid": "0.6",
      "10-bound": [0.46, 0.77],
      "25-mid": "0.73",
      "25-bound": [0.55, 0.99],
      "50-mid": "0.82",
      "50-bound": [0.61, 1.15],
      "100-mid": "0.93",
      "100-bound": [0.67, 1.35]
    },
    "10min": {
      "2-mid": "0.55",
      "2-bound": [0.43, 0.7],
      "5-mid": "0.71",
      "5-bound": [0.55, 0.91],
      "10-mid": "0.84",
      "10-bound": [0.65, 1.09],
      "25-mid": "1.03",
      "25-bound": [0.77, 1.4],
      "50-mid": "1.17",
      "50-bound": [0.86, 1.63],
      "100-mid": "1.32",
      "100-bound": [0.94, 1.91]
    },
    "15min": {
      "2-mid": "0.65",
      "2-bound": [0.5, 0.82],
      "5-mid": "0.84",
      "5-bound": [0.65, 1.07],
      "10-mid": "0.99",
      "10-bound": [0.77, 1.28],
      "25-mid": "1.21",
      "25-bound": [0.91, 1.64],
      "50-mid": "1.37",
      "50-bound": [1.01, 1.91],
      "100-mid": "1.55",
      "100-bound": [1.11, 2.25]
    },
    "30min": {
      "2-mid": "0.84",
      "2-bound": [0.65, 1.07],
      "5-mid": "1.09",
      "5-bound": [0.85, 1.4],
      "10-mid": "1.3",
      "10-bound": [1.01, 1.68],
      "25-mid": "1.59",
      "25-bound": [1.19, 2.16],
      "50-mid": "1.81",
      "50-bound": [1.33, 2.52],
      "100-mid": "2.04",
      "100-bound": [1.46, 2.96]
    },
    "60min": {
      "2-mid": "1.03",
      "2-bound": [0.8, 1.31],
      "5-mid": "1.34",
      "5-bound": [1.04, 1.72],
      "10-mid": "1.61",
      "10-bound": [1.24, 2.07],
      "25-mid": "1.97",
      "25-bound": [1.48, 2.68],
      "50-mid": "2.24",
      "50-bound": [1.65, 3.12],
      "100-mid": "2.53",
      "100-bound": [1.81, 3.68]
    },
    "2hr": {
      "2-mid": "1.28",
      "2-bound": [1.01, 1.63],
      "5-mid": "1.62",
      "5-bound": [1.27, 2.07],
      "10-mid": "1.91",
      "10-bound": [1.49, 2.44],
      "25-mid": "2.3",
      "25-bound": [1.74, 3.11],
      "50-mid": "2.59",
      "50-bound": [1.92, 3.6],
      "100-mid": "2.9",
      "100-bound": [2.11, 4.23]
    },
    "3hr": {
      "2-mid": "1.46",
      "2-bound": [1.15, 1.84],
      "5-mid": "1.82",
      "5-bound": [1.43, 2.31],
      "10-mid": "2.13",
      "10-bound": [1.66, 2.72],
      "25-mid": "2.55",
      "25-bound": [1.94, 3.43],
      "50-mid": "2.85",
      "50-bound": [2.13, 3.95],
      "100-mid": "3.19",
      "100-bound": [2.33, 4.65]
    },
    "6hr": {
      "2-mid": "1.8",
      "2-bound": [1.43, 2.26],
      "5-mid": "2.26",
      "5-bound": [1.78, 2.84],
      "10-mid": "2.63",
      "10-bound": [2.07, 3.33],
      "25-mid": "3.15",
      "25-bound": [2.41, 4.21],
      "50-mid": "3.52",
      "50-bound": [2.65, 4.85],
      "100-mid": "3.94",
      "100-bound": [2.9, 5.7]
    },
    "12hr": {
      "2-mid": "2.2",
      "2-bound": [1.76, 2.75],
      "5-mid": "2.81",
      "5-bound": [2.24, 3.51],
      "10-mid": "3.31",
      "10-bound": [2.62, 4.17],
      "25-mid": "4.0",
      "25-bound": [3.08, 5.32],
      "50-mid": "4.51",
      "50-bound": [3.4, 6.16],
      "100-mid": "5.07",
      "100-bound": [3.73, 7.25]
    },
    "24hr": {
      "2-mid": "2.62",
      "2-bound": [2.11, 3.25],
      "5-mid": "3.39",
      "5-bound": [2.72, 4.21],
      "10-mid": "4.02",
      "10-bound": [3.2, 5.03],
      "25-mid": "4.9",
      "25-bound": [3.78, 6.45],
      "50-mid": "5.54",
      "50-bound": [4.19, 7.48],
      "100-mid": "6.24",
      "100-bound": [4.59, 8.81]
    },
    "2day": {
      "2-mid": "3.05",
      "2-bound": [2.47, 3.75],
      "5-mid": "3.91",
      "5-bound": [3.16, 4.83],
      "10-mid": "4.63",
      "10-bound": [3.71, 5.74],
      "25-mid": "5.61",
      "25-bound": [4.35, 7.32],
      "50-mid": "6.34",
      "50-bound": [4.81, 8.47],
      "100-mid": "7.12",
      "100-bound": [5.25, 9.93]
    },
    "3day": {
      "2-mid": "3.35",
      "2-bound": [2.72, 4.1],
      "5-mid": "4.24",
      "5-bound": [3.43, 5.2],
      "10-mid": "4.97",
      "10-bound": [4.0, 6.14],
      "25-mid": "5.99",
      "25-bound": [4.66, 7.76],
      "50-mid": "6.74",
      "50-bound": [5.13, 8.96],
      "100-mid": "7.55",
      "100-bound": [5.57, 10.5]
    },
    "4day": {
      "2-mid": "3.6",
      "2-bound": [2.93, 4.39],
      "5-mid": "4.5",
      "5-bound": [3.65, 5.5],
      "10-mid": "5.24",
      "10-bound": [4.23, 6.46],
      "25-mid": "6.27",
      "25-bound": [4.88, 8.1],
      "50-mid": "7.03",
      "50-bound": [5.36, 9.3],
      "100-mid": "7.85",
      "100-bound": [5.8, 10.8]
    },
    "7day": {
      "2-mid": "4.22",
      "2-bound": [3.46, 5.12],
      "5-mid": "5.14",
      "5-bound": [4.2, 6.26],
      "10-mid": "5.9",
      "10-bound": [4.79, 7.23],
      "25-mid": "6.95",
      "25-bound": [5.44, 8.91],
      "50-mid": "7.73",
      "50-bound": [5.92, 10.1],
      "100-mid": "8.57",
      "100-bound": [6.35, 11.7]
    }
  },
  "USW00013743 6": {
    "fips": "51013",
    "station_name": "WASHINGTON REAGAN NATIONAL AIRPORT",
    "state": "VA",
    "latitude": "38.8470",
    "longitude": "-77.0345",
    "5min": {
      "2-mid": "0.43",
      "2-bound": [0.39, 0.47],
      "5-mid": "0.51",
      "5-bound": [0.46, 0.56],
      "10-mid": "0.57",
      "10-bound": [0.51, 0.62],
      "25-mid": "0.64",
      "25-bound": [0.58, 0.71],
      "50-mid": "0.7",
      "50-bound": [0.62, 0.77],
      "100-mid": "0.75",
      "100-bound": [0.67, 0.83]
    },
    "10min": {
      "2-mid": "0.68",
      "2-bound": [0.62, 0.75],
      "5-mid": "0.81",
      "5-bound": [0.74, 0.9],
      "10-mid": "0.91",
      "10-bound": [0.82, 1.0],
      "25-mid": "1.02",
      "25-bound": [0.92, 1.13],
      "50-mid": "1.11",
      "50-bound": [0.99, 1.23],
      "100-mid": "1.2",
      "100-bound": [1.06, 1.33]
    },
    "15min": {
      "2-mid": "0.86",
      "2-bound": [0.78, 0.94],
      "5-mid": "1.03",
      "5-bound": [0.93, 1.14],
      "10-mid": "1.15",
      "10-bound": [1.04, 1.26],
      "25-mid": "1.3",
      "25-bound": [1.17, 1.43],
      "50-mid": "1.41",
      "50-bound": [1.26, 1.56],
      "100-mid": "1.52",
      "100-bound": [1.34, 1.68]
    },
    "30min": {
      "2-mid": "1.19",
      "2-bound": [1.08, 1.3],
      "5-mid": "1.46",
      "5-bound": [1.32, 1.61],
      "10-mid": "1.66",
      "10-bound": [1.5, 1.83],
      "25-mid": "1.92",
      "25-bound": [1.73, 2.12],
      "50-mid": "2.12",
      "50-bound": [1.9, 2.34],
      "100-mid": "2.32",
      "100-bound": [2.06, 2.57]
    },
    "60min": {
      "2-mid": "1.49",
      "2-bound": [1.35, 1.64],
      "5-mid": "1.88",
      "5-bound": [1.7, 2.07],
      "10-mid": "2.17",
      "10-bound": [1.96, 2.39],
      "25-mid": "2.56",
      "25-bound": [2.3, 2.83],
      "50-mid": "2.88",
      "50-bound": [2.57, 3.18],
      "100-mid": "3.2",
      "100-bound": [2.83, 3.54]
    },
    "2hr": {
      "2-mid": "1.71",
      "2-bound": [1.56, 1.89],
      "5-mid": "2.17",
      "5-bound": [1.97, 2.39],
      "10-mid": "2.52",
      "10-bound": [2.28, 2.78],
      "25-mid": "3.02",
      "25-bound": [2.72, 3.33],
      "50-mid": "3.43",
      "50-bound": [3.06, 3.78],
      "100-mid": "3.86",
      "100-bound": [3.42, 4.26]
    },
    "3hr": {
      "2-mid": "1.83",
      "2-bound": [1.66, 2.02],
      "5-mid": "2.32",
      "5-bound": [2.09, 2.56],
      "10-mid": "2.71",
      "10-bound": [2.44, 2.98],
      "25-mid": "3.26",
      "25-bound": [2.92, 3.6],
      "50-mid": "3.72",
      "50-bound": [3.31, 4.1],
      "100-mid": "4.2",
      "100-bound": [3.71, 4.65]
    },
    "6hr": {
      "2-mid": "2.22",
      "2-bound": [2.02, 2.46],
      "5-mid": "2.81",
      "5-bound": [2.54, 3.1],
      "10-mid": "3.29",
      "10-bound": [2.96, 3.63],
      "25-mid": "4.0",
      "25-bound": [3.57, 4.42],
      "50-mid": "4.6",
      "50-bound": [4.07, 5.09],
      "100-mid": "5.26",
      "100-bound": [4.6, 5.82]
    },
    "12hr": {
      "2-mid": "2.67",
      "2-bound": [2.4, 2.99],
      "5-mid": "3.39",
      "5-bound": [3.05, 3.79],
      "10-mid": "4.01",
      "10-bound": [3.58, 4.48],
      "25-mid": "4.96",
      "25-bound": [4.38, 5.53],
      "50-mid": "5.78",
      "50-bound": [5.06, 6.46],
      "100-mid": "6.7",
      "100-bound": [5.79, 7.51]
    },
    "24hr": {
      "2-mid": "3.1",
      "2-bound": [2.82, 3.46],
      "5-mid": "3.99",
      "5-bound": [3.62, 4.44],
      "10-mid": "4.76",
      "10-bound": [4.31, 5.28],
      "25-mid": "5.96",
      "25-bound": [5.34, 6.57],
      "50-mid": "7.02",
      "50-bound": [6.25, 7.7],
      "100-mid": "8.22",
      "100-bound": [7.25, 8.98]
    },
    "2day": {
      "2-mid": "3.61",
      "2-bound": [3.28, 4.0],
      "5-mid": "4.62",
      "5-bound": [4.2, 5.12],
      "10-mid": "5.49",
      "10-bound": [4.98, 6.08],
      "25-mid": "6.81",
      "25-bound": [6.13, 7.51],
      "50-mid": "7.96",
      "50-bound": [7.11, 8.75],
      "100-mid": "9.23",
      "100-bound": [8.18, 10.1]
    },
    "3day": {
      "2-mid": "3.81",
      "2-bound": [3.47, 4.23],
      "5-mid": "4.88",
      "5-bound": [4.43, 5.4],
      "10-mid": "5.79",
      "10-bound": [5.25, 6.4],
      "25-mid": "7.17",
      "25-bound": [6.46, 7.9],
      "50-mid": "8.37",
      "50-bound": [7.49, 9.2],
      "100-mid": "9.7",
      "100-bound": [8.61, 10.7]
    },
    "4day": {
      "2-mid": "4.01",
      "2-bound": [3.66, 4.46],
      "5-mid": "5.13",
      "5-bound": [4.67, 5.68],
      "10-mid": "6.09",
      "10-bound": [5.53, 6.73],
      "25-mid": "7.53",
      "25-bound": [6.79, 8.3],
      "50-mid": "8.78",
      "50-bound": [7.87, 9.66],
      "100-mid": "10.2",
      "100-bound": [9.03, 11.2]
    },
    "7day": {
      "2-mid": "4.63",
      "2-bound": [4.24, 5.1],
      "5-mid": "5.85",
      "5-bound": [5.35, 6.44],
      "10-mid": "6.9",
      "10-bound": [6.3, 7.58],
      "25-mid": "8.46",
      "25-bound": [7.67, 9.27],
      "50-mid": "9.8",
      "50-bound": [8.84, 10.7],
      "100-mid": "11.3",
      "100-bound": [10.1, 12.3]
    }
  },
  "USC00305512 6": {
    "fips": "36053",
    "station_name": "MORRISVILLE 6 SW",
    "state": "NY",
    "latitude": "42.8410",
    "longitude": "-75.7260",
    "5min": {
      "2-mid": "0.34",
      "2-bound": [0.27, 0.41],
      "5-mid": "0.43",
      "5-bound": [0.35, 0.53],
      "10-mid": "0.51",
      "10-bound": [0.41, 0.63],
      "25-mid": "0.62",
      "25-bound": [0.48, 0.79],
      "50-mid": "0.71",
      "50-bound": [0.53, 0.91],
      "100-mid": "0.79",
      "100-bound": [0.57, 1.05]
    },
    "10min": {
      "2-mid": "0.48",
      "2-bound": [0.39, 0.58],
      "5-mid": "0.61",
      "5-bound": [0.49, 0.75],
      "10-mid": "0.73",
      "10-bound": [0.58, 0.89],
      "25-mid": "0.88",
      "25-bound": [0.68, 1.12],
      "50-mid": "1.0",
      "50-bound": [0.75, 1.29],
      "100-mid": "1.12",
      "100-bound": [0.81, 1.49]
    },
    "15min": {
      "2-mid": "0.56",
      "2-bound": [0.45, 0.69],
      "5-mid": "0.72",
      "5-bound": [0.58, 0.88],
      "10-mid": "0.85",
      "10-bound": [0.68, 1.05],
      "25-mid": "1.04",
      "25-bound": [0.8, 1.32],
      "50-mid": "1.18",
      "50-bound": [0.88, 1.52],
      "100-mid": "1.32",
      "100-bound": [0.95, 1.76]
    },
    "30min": {
      "2-mid": "0.76",
      "2-bound": [0.61, 0.93],
      "5-mid": "0.98",
      "5-bound": [0.78, 1.2],
      "10-mid": "1.16",
      "10-bound": [0.92, 1.42],
      "25-mid": "1.41",
      "25-bound": [1.08, 1.79],
      "50-mid": "1.59",
      "50-bound": [1.19, 2.06],
      "100-mid": "1.79",
      "100-bound": [1.29, 2.38]
    },
    "60min": {
      "2-mid": "0.96",
      "2-bound": [0.78, 1.17],
      "5-mid": "1.24",
      "5-bound": [0.99, 1.51],
      "10-mid": "1.46",
      "10-bound": [1.16, 1.8],
      "25-mid": "1.78",
      "25-bound": [1.36, 2.26],
      "50-mid": "2.01",
      "50-bound": [1.51, 2.6],
      "100-mid": "2.26",
      "100-bound": [1.64, 3.01]
    },
    "2hr": {
      "2-mid": "1.21",
      "2-bound": [0.98, 1.46],
      "5-mid": "1.51",
      "5-bound": [1.22, 1.84],
      "10-mid": "1.77",
      "10-bound": [1.42, 2.16],
      "25-mid": "2.12",
      "25-bound": [1.64, 2.67],
      "50-mid": "2.38",
      "50-bound": [1.8, 3.06],
      "100-mid": "2.66",
      "100-bound": [1.94, 3.51]
    },
    "3hr": {
      "2-mid": "1.37",
      "2-bound": [1.12, 1.65],
      "5-mid": "1.7",
      "5-bound": [1.38, 2.06],
      "10-mid": "1.98",
      "10-bound": [1.6, 2.4],
      "25-mid": "2.36",
      "25-bound": [1.83, 2.96],
      "50-mid": "2.64",
      "50-bound": [2.0, 3.38],
      "100-mid": "2.94",
      "100-bound": [2.15, 3.87]
    },
    "6hr": {
      "2-mid": "1.7",
      "2-bound": [1.39, 2.03],
      "5-mid": "2.1",
      "5-bound": [1.72, 2.52],
      "10-mid": "2.43",
      "10-bound": [1.98, 2.93],
      "25-mid": "2.9",
      "25-bound": [2.26, 3.61],
      "50-mid": "3.24",
      "50-bound": [2.47, 4.11],
      "100-mid": "3.6",
      "100-bound": [2.66, 4.7]
    },
    "12hr": {
      "2-mid": "2.07",
      "2-bound": [1.72, 2.47],
      "5-mid": "2.59",
      "5-bound": [2.14, 3.09],
      "10-mid": "3.02",
      "10-bound": [2.47, 3.62],
      "25-mid": "3.61",
      "25-bound": [2.84, 4.47],
      "50-mid": "4.05",
      "50-bound": [3.12, 5.1],
      "100-mid": "4.52",
      "100-bound": [3.36, 5.85]
    },
    "24hr": {
      "2-mid": "2.47",
      "2-bound": [2.06, 2.91],
      "5-mid": "3.09",
      "5-bound": [2.57, 3.66],
      "10-mid": "3.61",
      "10-bound": [2.98, 4.29],
      "25-mid": "4.32",
      "25-bound": [3.43, 5.31],
      "50-mid": "4.86",
      "50-bound": [3.76, 6.07],
      "100-mid": "5.42",
      "100-bound": [4.06, 6.96]
    },
    "2day": {
      "2-mid": "2.86",
      "2-bound": [2.4, 3.36],
      "5-mid": "3.55",
      "5-bound": [2.97, 4.18],
      "10-mid": "4.12",
      "10-bound": [3.43, 4.87],
      "25-mid": "4.91",
      "25-bound": [3.93, 5.99],
      "50-mid": "5.5",
      "50-bound": [4.3, 6.81],
      "100-mid": "6.13",
      "100-bound": [4.61, 7.79]
    },
    "3day": {
      "2-mid": "3.15",
      "2-bound": [2.66, 3.68],
      "5-mid": "3.87",
      "5-bound": [3.26, 4.54],
      "10-mid": "4.48",
      "10-bound": [3.74, 5.26],
      "25-mid": "5.31",
      "25-bound": [4.26, 6.44],
      "50-mid": "5.93",
      "50-bound": [4.65, 7.3],
      "100-mid": "6.58",
      "100-bound": [4.98, 8.33]
    },
    "4day": {
      "2-mid": "3.4",
      "2-bound": [2.88, 3.96],
      "5-mid": "4.15",
      "5-bound": [3.5, 4.85],
      "10-mid": "4.77",
      "10-bound": [4.0, 5.6],
      "25-mid": "5.63",
      "25-bound": [4.54, 6.81],
      "50-mid": "6.28",
      "50-bound": [4.94, 7.7],
      "100-mid": "6.96",
      "100-bound": [5.27, 8.76]
    },
    "7day": {
      "2-mid": "4.05",
      "2-bound": [3.45, 4.7],
      "5-mid": "4.86",
      "5-bound": [4.12, 5.65],
      "10-mid": "5.53",
      "10-bound": [4.66, 6.45],
      "25-mid": "6.45",
      "25-bound": [5.23, 7.74],
      "50-mid": "7.15",
      "50-bound": [5.65, 8.7],
      "100-mid": "7.87",
      "100-bound": [5.99, 9.82]
    }
  },
  "USC00187806 6": {
    "fips": "24041",
    "station_name": "ROYAL OAK 2 SSW",
    "state": "MD",
    "latitude": "38.7150",
    "longitude": "-76.1900",
    "5min": {
      "2-mid": "0.43",
      "2-bound": [0.39, 0.47],
      "5-mid": "0.51",
      "5-bound": [0.46, 0.56],
      "10-mid": "0.56",
      "10-bound": [0.51, 0.62],
      "25-mid": "0.64",
      "25-bound": [0.57, 0.71],
      "50-mid": "0.69",
      "50-bound": [0.62, 0.77],
      "100-mid": "0.75",
      "100-bound": [0.67, 0.83]
    },
    "10min": {
      "2-mid": "0.68",
      "2-bound": [0.62, 0.75],
      "5-mid": "0.81",
      "5-bound": [0.73, 0.9],
      "10-mid": "0.9",
      "10-bound": [0.82, 1.0],
      "25-mid": "1.02",
      "25-bound": [0.92, 1.13],
      "50-mid": "1.11",
      "50-bound": [0.99, 1.23],
      "100-mid": "1.19",
      "100-bound": [1.06, 1.32]
    },
    "15min": {
      "2-mid": "0.86",
      "2-bound": [0.77, 0.94],
      "5-mid": "1.03",
      "5-bound": [0.93, 1.13],
      "10-mid": "1.14",
      "10-bound": [1.03, 1.26],
      "25-mid": "1.29",
      "25-bound": [1.16, 1.43],
      "50-mid": "1.4",
      "50-bound": [1.25, 1.55],
      "100-mid": "1.51",
      "100-bound": [1.34, 1.67]
    },
    "30min": {
      "2-mid": "1.18",
      "2-bound": [1.07, 1.3],
      "5-mid": "1.46",
      "5-bound": [1.32, 1.61],
      "10-mid": "1.66",
      "10-bound": [1.5, 1.83],
      "25-mid": "1.92",
      "25-bound": [1.72, 2.12],
      "50-mid": "2.11",
      "50-bound": [1.88, 2.34],
      "100-mid": "2.31",
      "100-bound": [2.05, 2.56]
    },
    "60min": {
      "2-mid": "1.48",
      "2-bound": [1.34, 1.64],
      "5-mid": "1.87",
      "5-bound": [1.69, 2.07],
      "10-mid": "2.16",
      "10-bound": [1.95, 2.38],
      "25-mid": "2.55",
      "25-bound": [2.29, 2.82],
      "50-mid": "2.86",
      "50-bound": [2.55, 3.17],
      "100-mid": "3.18",
      "100-bound": [2.82, 3.53]
    },
    "2hr": {
      "2-mid": "1.77",
      "2-bound": [1.61, 1.96],
      "5-mid": "2.25",
      "5-bound": [2.03, 2.48],
      "10-mid": "2.61",
      "10-bound": [2.35, 2.88],
      "25-mid": "3.12",
      "25-bound": [2.8, 3.44],
      "50-mid": "3.53",
      "50-bound": [3.15, 3.9],
      "100-mid": "3.97",
      "100-bound": [3.51, 4.4]
    },
    "3hr": {
      "2-mid": "1.94",
      "2-bound": [1.75, 2.14],
      "5-mid": "2.46",
      "5-bound": [2.22, 2.71],
      "10-mid": "2.87",
      "10-bound": [2.58, 3.16],
      "25-mid": "3.45",
      "25-bound": [3.08, 3.8],
      "50-mid": "3.93",
      "50-bound": [3.49, 4.34],
      "100-mid": "4.44",
      "100-bound": [3.91, 4.91]
    },
    "6hr": {
      "2-mid": "2.4",
      "2-bound": [2.18, 2.66],
      "5-mid": "3.04",
      "5-bound": [2.74, 3.36],
      "10-mid": "3.56",
      "10-bound": [3.2, 3.93],
      "25-mid": "4.33",
      "25-bound": [3.86, 4.78],
      "50-mid": "4.98",
      "50-bound": [4.4, 5.51],
      "100-mid": "5.69",
      "100-bound": [4.98, 6.32]
    },
    "12hr": {
      "2-mid": "2.9",
      "2-bound": [2.6, 3.25],
      "5-mid": "3.68",
      "5-bound": [3.3, 4.14],
      "10-mid": "4.36",
      "10-bound": [3.88, 4.9],
      "25-mid": "5.4",
      "25-bound": [4.75, 6.06],
      "50-mid": "6.3",
      "50-bound": [5.5, 7.08],
      "100-mid": "7.32",
      "100-bound": [6.29, 8.24]
    },
    "24hr": {
      "2-mid": "3.36",
      "2-bound": [3.05, 3.73],
      "5-mid": "4.37",
      "5-bound": [3.96, 4.85],
      "10-mid": "5.24",
      "10-bound": [4.74, 5.81],
      "25-mid": "6.57",
      "25-bound": [5.9, 7.26],
      "50-mid": "7.74",
      "50-bound": [6.89, 8.51],
      "100-mid": "9.05",
      "100-bound": [7.99, 9.93]
    },
    "2day": {
      "2-mid": "3.86",
      "2-bound": [3.5, 4.28],
      "5-mid": "5.01",
      "5-bound": [4.55, 5.56],
      "10-mid": "6.01",
      "10-bound": [5.42, 6.64],
      "25-mid": "7.51",
      "25-bound": [6.74, 8.28],
      "50-mid": "8.82",
      "50-bound": [7.86, 9.7],
      "100-mid": "10.3",
      "100-bound": [9.1, 11.3]
    },
    "3day": {
      "2-mid": "4.08",
      "2-bound": [3.72, 4.53],
      "5-mid": "5.28",
      "5-bound": [4.81, 5.85],
      "10-mid": "6.3",
      "10-bound": [5.72, 6.96],
      "25-mid": "7.84",
      "25-bound": [7.07, 8.64],
      "50-mid": "9.18",
      "50-bound": [8.22, 10.1],
      "100-mid": "10.7",
      "100-bound": [9.49, 11.7]
    },
    "4day": {
      "2-mid": "4.31",
      "2-bound": [3.95, 4.77],
      "5-mid": "5.55",
      "5-bound": [5.08, 6.13],
      "10-mid": "6.6",
      "10-bound": [6.02, 7.28],
      "25-mid": "8.18",
      "25-bound": [7.4, 9.02],
      "50-mid": "9.54",
      "50-bound": [8.59, 10.5],
      "100-mid": "11.0",
      "100-bound": [9.88, 12.1]
    },
    "7day": {
      "2-mid": "4.97",
      "2-bound": [4.58, 5.43],
      "5-mid": "6.29",
      "5-bound": [5.79, 6.88],
      "10-mid": "7.41",
      "10-bound": [6.8, 8.1],
      "25-mid": "9.07",
      "25-bound": [8.28, 9.88],
      "50-mid": "10.5",
      "50-bound": [9.52, 11.4],
      "100-mid": "12.1",
      "100-bound": [10.9, 13.1]
    }
  },
  "USC00360457 6": {
    "fips": "42097",
    "station_name": "BEAR GAP",
    "state": "PA",
    "latitude": "40.8208",
    "longitude": "-76.4983",
    "5min": {
      "2-mid": "0.41",
      "2-bound": [0.37, 0.45],
      "5-mid": "0.48",
      "5-bound": [0.43, 0.53],
      "10-mid": "0.53",
      "10-bound": [0.48, 0.58],
      "25-mid": "0.59",
      "25-bound": [0.53, 0.65],
      "50-mid": "0.63",
      "50-bound": [0.57, 0.7],
      "100-mid": "0.68",
      "100-bound": [0.61, 0.75]
    },
    "10min": {
      "2-mid": "0.64",
      "2-bound": [0.58, 0.71],
      "5-mid": "0.74",
      "5-bound": [0.67, 0.82],
      "10-mid": "0.81",
      "10-bound": [0.74, 0.9],
      "25-mid": "0.9",
      "25-bound": [0.81, 0.99],
      "50-mid": "0.96",
      "50-bound": [0.86, 1.06],
      "100-mid": "1.02",
      "100-bound": [0.92, 1.13]
    },
    "15min": {
      "2-mid": "0.79",
      "2-bound": [0.71, 0.86],
      "5-mid": "0.91",
      "5-bound": [0.83, 1.01],
      "10-mid": "1.0",
      "10-bound": [0.91, 1.1],
      "25-mid": "1.11",
      "25-bound": [1.0, 1.22],
      "50-mid": "1.19",
      "50-bound": [1.07, 1.31],
      "100-mid": "1.27",
      "100-bound": [1.14, 1.4]
    },
    "30min": {
      "2-mid": "1.05",
      "2-bound": [0.95, 1.16],
      "5-mid": "1.25",
      "5-bound": [1.13, 1.38],
      "10-mid": "1.39",
      "10-bound": [1.26, 1.53],
      "25-mid": "1.57",
      "25-bound": [1.41, 1.73],
      "50-mid": "1.7",
      "50-bound": [1.53, 1.87],
      "100-mid": "1.83",
      "100-bound": [1.64, 2.02]
    },
    "60min": {
      "2-mid": "1.29",
      "2-bound": [1.17, 1.42],
      "5-mid": "1.57",
      "5-bound": [1.42, 1.73],
      "10-mid": "1.77",
      "10-bound": [1.6, 1.95],
      "25-mid": "2.03",
      "25-bound": [1.84, 2.24],
      "50-mid": "2.24",
      "50-bound": [2.02, 2.47],
      "100-mid": "2.46",
      "100-bound": [2.2, 2.71]
    },
    "2hr": {
      "2-mid": "1.51",
      "2-bound": [1.37, 1.67],
      "5-mid": "1.86",
      "5-bound": [1.67, 2.04],
      "10-mid": "2.13",
      "10-bound": [1.92, 2.35],
      "25-mid": "2.54",
      "25-bound": [2.27, 2.8],
      "50-mid": "2.87",
      "50-bound": [2.56, 3.17],
      "100-mid": "3.25",
      "100-bound": [2.88, 3.59]
    },
    "3hr": {
      "2-mid": "1.64",
      "2-bound": [1.48, 1.83],
      "5-mid": "2.02",
      "5-bound": [1.82, 2.25],
      "10-mid": "2.33",
      "10-bound": [2.1, 2.6],
      "25-mid": "2.8",
      "25-bound": [2.5, 3.12],
      "50-mid": "3.2",
      "50-bound": [2.84, 3.56],
      "100-mid": "3.66",
      "100-bound": [3.22, 4.08]
    },
    "6hr": {
      "2-mid": "2.04",
      "2-bound": [1.84, 2.3],
      "5-mid": "2.51",
      "5-bound": [2.25, 2.82],
      "10-mid": "2.91",
      "10-bound": [2.6, 3.26],
      "25-mid": "3.49",
      "25-bound": [3.1, 3.9],
      "50-mid": "3.99",
      "50-bound": [3.52, 4.46],
      "100-mid": "4.57",
      "100-bound": [4.0, 5.1]
    },
    "12hr": {
      "2-mid": "2.52",
      "2-bound": [2.26, 2.84],
      "5-mid": "3.11",
      "5-bound": [2.79, 3.5],
      "10-mid": "3.61",
      "10-bound": [3.22, 4.05],
      "25-mid": "4.36",
      "25-bound": [3.86, 4.88],
      "50-mid": "5.03",
      "50-bound": [4.42, 5.63],
      "100-mid": "5.79",
      "100-bound": [5.05, 6.49]
    },
    "24hr": {
      "2-mid": "2.96",
      "2-bound": [2.71, 3.27],
      "5-mid": "3.66",
      "5-bound": [3.35, 4.05],
      "10-mid": "4.28",
      "10-bound": [3.9, 4.72],
      "25-mid": "5.26",
      "25-bound": [4.76, 5.77],
      "50-mid": "6.17",
      "50-bound": [5.53, 6.74],
      "100-mid": "7.24",
      "100-bound": [6.42, 7.87]
    },
    "2day": {
      "2-mid": "3.45",
      "2-bound": [3.12, 3.84],
      "5-mid": "4.27",
      "5-bound": [3.86, 4.74],
      "10-mid": "4.99",
      "10-bound": [4.49, 5.52],
      "25-mid": "6.13",
      "25-bound": [5.48, 6.76],
      "50-mid": "7.18",
      "50-bound": [6.37, 7.91],
      "100-mid": "8.43",
      "100-bound": [7.4, 9.25]
    },
    "3day": {
      "2-mid": "3.65",
      "2-bound": [3.32, 4.08],
      "5-mid": "4.5",
      "5-bound": [4.08, 5.03],
      "10-mid": "5.25",
      "10-bound": [4.74, 5.84],
      "25-mid": "6.43",
      "25-bound": [5.77, 7.13],
      "50-mid": "7.52",
      "50-bound": [6.69, 8.32],
      "100-mid": "8.81",
      "100-bound": [7.78, 9.71]
    },
    "4day": {
      "2-mid": "3.86",
      "2-bound": [3.52, 4.33],
      "5-mid": "4.73",
      "5-bound": [4.3, 5.31],
      "10-mid": "5.5",
      "10-bound": [4.99, 6.16],
      "25-mid": "6.72",
      "25-bound": [6.05, 7.5],
      "50-mid": "7.86",
      "50-bound": [7.02, 8.72],
      "100-mid": "9.19",
      "100-bound": [8.15, 10.2]
    },
    "7day": {
      "2-mid": "4.53",
      "2-bound": [4.15, 5.01],
      "5-mid": "5.52",
      "5-bound": [5.03, 6.09],
      "10-mid": "6.38",
      "10-bound": [5.8, 7.02],
      "25-mid": "7.74",
      "25-bound": [7.0, 8.49],
      "50-mid": "8.99",
      "50-bound": [8.06, 9.82],
      "100-mid": "10.4",
      "100-bound": [9.31, 11.4]
    }
  },
  "USC00444101 6": {
    "fips": "51670",
    "station_name": "HOPEWELL",
    "state": "VA",
    "latitude": "37.2990",
    "longitude": "-77.2770",
    "5min": {
      "2-mid": "0.45",
      "2-bound": [0.41, 0.5],
      "5-mid": "0.53",
      "5-bound": [0.48, 0.58],
      "10-mid": "0.59",
      "10-bound": [0.53, 0.66],
      "25-mid": "0.67",
      "25-bound": [0.6, 0.74],
      "50-mid": "0.72",
      "50-bound": [0.65, 0.8],
      "100-mid": "0.78",
      "100-bound": [0.69, 0.86]
    },
    "10min": {
      "2-mid": "0.72",
      "2-bound": [0.66, 0.8],
      "5-mid": "0.84",
      "5-bound": [0.76, 0.94],
      "10-mid": "0.95",
      "10-bound": [0.85, 1.05],
      "25-mid": "1.06",
      "25-bound": [0.95, 1.18],
      "50-mid": "1.15",
      "50-bound": [1.03, 1.28],
      "100-mid": "1.24",
      "100-bound": [1.1, 1.37]
    },
    "15min": {
      "2-mid": "0.91",
      "2-bound": [0.82, 1.01],
      "5-mid": "1.07",
      "5-bound": [0.96, 1.18],
      "10-mid": "1.2",
      "10-bound": [1.08, 1.33],
      "25-mid": "1.35",
      "25-bound": [1.21, 1.49],
      "50-mid": "1.46",
      "50-bound": [1.3, 1.62],
      "100-mid": "1.56",
      "100-bound": [1.39, 1.73]
    },
    "30min": {
      "2-mid": "1.26",
      "2-bound": [1.14, 1.39],
      "5-mid": "1.52",
      "5-bound": [1.37, 1.68],
      "10-mid": "1.74",
      "10-bound": [1.56, 1.93],
      "25-mid": "1.99",
      "25-bound": [1.79, 2.21],
      "50-mid": "2.2",
      "50-bound": [1.96, 2.43],
      "100-mid": "2.39",
      "100-bound": [2.13, 2.65]
    },
    "60min": {
      "2-mid": "1.58",
      "2-bound": [1.43, 1.75],
      "5-mid": "1.94",
      "5-bound": [1.76, 2.15],
      "10-mid": "2.26",
      "10-bound": [2.04, 2.51],
      "25-mid": "2.66",
      "25-bound": [2.38, 2.94],
      "50-mid": "2.98",
      "50-bound": [2.66, 3.3],
      "100-mid": "3.3",
      "100-bound": [2.93, 3.65]
    },
    "2hr": {
      "2-mid": "1.87",
      "2-bound": [1.69, 2.08],
      "5-mid": "2.33",
      "5-bound": [2.1, 2.59],
      "10-mid": "2.75",
      "10-bound": [2.47, 3.05],
      "25-mid": "3.28",
      "25-bound": [2.93, 3.64],
      "50-mid": "3.74",
      "50-bound": [3.32, 4.14],
      "100-mid": "4.2",
      "100-bound": [3.7, 4.64]
    },
    "3hr": {
      "2-mid": "2.02",
      "2-bound": [1.81, 2.25],
      "5-mid": "2.52",
      "5-bound": [2.26, 2.81],
      "10-mid": "2.97",
      "10-bound": [2.66, 3.32],
      "25-mid": "3.57",
      "25-bound": [3.17, 3.97],
      "50-mid": "4.07",
      "50-bound": [3.6, 4.53],
      "100-mid": "4.6",
      "100-bound": [4.04, 5.11]
    },
    "6hr": {
      "2-mid": "2.43",
      "2-bound": [2.17, 2.74],
      "5-mid": "3.03",
      "5-bound": [2.7, 3.41],
      "10-mid": "3.59",
      "10-bound": [3.19, 4.04],
      "25-mid": "4.34",
      "25-bound": [3.83, 4.87],
      "50-mid": "5.0",
      "50-bound": [4.39, 5.59],
      "100-mid": "5.69",
      "100-bound": [4.95, 6.36]
    },
    "12hr": {
      "2-mid": "2.9",
      "2-bound": [2.59, 3.28],
      "5-mid": "3.63",
      "5-bound": [3.24, 4.11],
      "10-mid": "4.34",
      "10-bound": [3.85, 4.9],
      "25-mid": "5.31",
      "25-bound": [4.66, 5.97],
      "50-mid": "6.17",
      "50-bound": [5.38, 6.93],
      "100-mid": "7.1",
      "100-bound": [6.12, 7.94]
    },
    "24hr": {
      "2-mid": "3.38",
      "2-bound": [3.12, 3.71],
      "5-mid": "4.33",
      "5-bound": [3.98, 4.75],
      "10-mid": "5.14",
      "10-bound": [4.7, 5.63],
      "25-mid": "6.33",
      "25-bound": [5.75, 6.92],
      "50-mid": "7.36",
      "50-bound": [6.64, 8.03],
      "100-mid": "8.48",
      "100-bound": [7.59, 9.25]
    },
    "2day": {
      "2-mid": "3.94",
      "2-bound": [3.63, 4.3],
      "5-mid": "5.02",
      "5-bound": [4.62, 5.48],
      "10-mid": "5.92",
      "10-bound": [5.44, 6.46],
      "25-mid": "7.22",
      "25-bound": [6.59, 7.87],
      "50-mid": "8.33",
      "50-bound": [7.55, 9.08],
      "100-mid": "9.52",
      "100-bound": [8.57, 10.4]
    },
    "3day": {
      "2-mid": "4.17",
      "2-bound": [3.85, 4.54],
      "5-mid": "5.3",
      "5-bound": [4.9, 5.78],
      "10-mid": "6.25",
      "10-bound": [5.75, 6.8],
      "25-mid": "7.61",
      "25-bound": [6.96, 8.28],
      "50-mid": "8.77",
      "50-bound": [7.97, 9.54],
      "100-mid": "10.0",
      "100-bound": [9.03, 10.9]
    },
    "4day": {
      "2-mid": "4.4",
      "2-bound": [4.07, 4.78],
      "5-mid": "5.59",
      "5-bound": [5.17, 6.08],
      "10-mid": "6.58",
      "10-bound": [6.07, 7.14],
      "25-mid": "8.0",
      "25-bound": [7.33, 8.69],
      "50-mid": "9.2",
      "50-bound": [8.39, 10.0],
      "100-mid": "10.5",
      "100-bound": [9.5, 11.4]
    },
    "7day": {
      "2-mid": "5.05",
      "2-bound": [4.68, 5.49],
      "5-mid": "6.32",
      "5-bound": [5.85, 6.87],
      "10-mid": "7.37",
      "10-bound": [6.81, 8.0],
      "25-mid": "8.87",
      "25-bound": [8.15, 9.63],
      "50-mid": "10.1",
      "50-bound": [9.25, 11.0],
      "100-mid": "11.5",
      "100-bound": [10.4, 12.5]
    }
  },
  "USC00368905 6": {
    "fips": "42015",
    "station_name": "TOWANDA 1 S",
    "state": "PA",
    "latitude": "41.7510",
    "longitude": "-76.4400",
    "5min": {
      "2-mid": "0.33",
      "2-bound": [0.31, 0.37],
      "5-mid": "0.4",
      "5-bound": [0.36, 0.44],
      "10-mid": "0.45",
      "10-bound": [0.41, 0.49],
      "25-mid": "0.5",
      "25-bound": [0.46, 0.55],
      "50-mid": "0.55",
      "50-bound": [0.49, 0.6],
      "100-mid": "0.59",
      "100-bound": [0.53, 0.64]
    },
    "10min": {
      "2-mid": "0.52",
      "2-bound": [0.48, 0.58],
      "5-mid": "0.62",
      "5-bound": [0.57, 0.68],
      "10-mid": "0.69",
      "10-bound": [0.63, 0.75],
      "25-mid": "0.77",
      "25-bound": [0.7, 0.84],
      "50-mid": "0.83",
      "50-bound": [0.75, 0.91],
      "100-mid": "0.88",
      "100-bound": [0.79, 0.96]
    },
    "15min": {
      "2-mid": "0.64",
      "2-bound": [0.59, 0.7],
      "5-mid": "0.76",
      "5-bound": [0.7, 0.84],
      "10-mid": "0.85",
      "10-bound": [0.77, 0.93],
      "25-mid": "0.95",
      "25-bound": [0.86, 1.04],
      "50-mid": "1.03",
      "50-bound": [0.93, 1.12],
      "100-mid": "1.1",
      "100-bound": [0.98, 1.2]
    },
    "30min": {
      "2-mid": "0.85",
      "2-bound": [0.79, 0.94],
      "5-mid": "1.04",
      "5-bound": [0.95, 1.14],
      "10-mid": "1.17",
      "10-bound": [1.08, 1.29],
      "25-mid": "1.34",
      "25-bound": [1.22, 1.47],
      "50-mid": "1.47",
      "50-bound": [1.32, 1.6],
      "100-mid": "1.58",
      "100-bound": [1.42, 1.73]
    },
    "60min": {
      "2-mid": "1.05",
      "2-bound": [0.96, 1.16],
      "5-mid": "1.31",
      "5-bound": [1.2, 1.44],
      "10-mid": "1.49",
      "10-bound": [1.37, 1.64],
      "25-mid": "1.74",
      "25-bound": [1.58, 1.9],
      "50-mid": "1.93",
      "50-bound": [1.75, 2.11],
      "100-mid": "2.12",
      "100-bound": [1.9, 2.31]
    },
    "2hr": {
      "2-mid": "1.2",
      "2-bound": [1.11, 1.32],
      "5-mid": "1.51",
      "5-bound": [1.38, 1.66],
      "10-mid": "1.73",
      "10-bound": [1.58, 1.9],
      "25-mid": "2.04",
      "25-bound": [1.86, 2.23],
      "50-mid": "2.29",
      "50-bound": [2.06, 2.48],
      "100-mid": "2.54",
      "100-bound": [2.27, 2.75]
    },
    "3hr": {
      "2-mid": "1.29",
      "2-bound": [1.2, 1.41],
      "5-mid": "1.61",
      "5-bound": [1.49, 1.76],
      "10-mid": "1.85",
      "10-bound": [1.7, 2.02],
      "25-mid": "2.18",
      "25-bound": [1.99, 2.37],
      "50-mid": "2.44",
      "50-bound": [2.22, 2.65],
      "100-mid": "2.72",
      "100-bound": [2.45, 2.94]
    },
    "6hr": {
      "2-mid": "1.64",
      "2-bound": [1.51, 1.8],
      "5-mid": "2.01",
      "5-bound": [1.85, 2.21],
      "10-mid": "2.31",
      "10-bound": [2.12, 2.52],
      "25-mid": "2.71",
      "25-bound": [2.46, 2.95],
      "50-mid": "3.03",
      "50-bound": [2.74, 3.29],
      "100-mid": "3.36",
      "100-bound": [3.01, 3.64]
    },
    "12hr": {
      "2-mid": "2.04",
      "2-bound": [1.88, 2.23],
      "5-mid": "2.5",
      "5-bound": [2.3, 2.72],
      "10-mid": "2.85",
      "10-bound": [2.62, 3.11],
      "25-mid": "3.37",
      "25-bound": [3.06, 3.65],
      "50-mid": "3.78",
      "50-bound": [3.42, 4.09],
      "100-mid": "4.21",
      "100-bound": [3.77, 4.55]
    },
    "24hr": {
      "2-mid": "2.44",
      "2-bound": [2.3, 2.61],
      "5-mid": "2.98",
      "5-bound": [2.8, 3.18],
      "10-mid": "3.41",
      "10-bound": [3.19, 3.63],
      "25-mid": "3.99",
      "25-bound": [3.73, 4.25],
      "50-mid": "4.45",
      "50-bound": [4.15, 4.73],
      "100-mid": "4.93",
      "100-bound": [4.58, 5.23]
    },
    "2day": {
      "2-mid": "2.84",
      "2-bound": [2.64, 3.06],
      "5-mid": "3.45",
      "5-bound": [3.21, 3.72],
      "10-mid": "3.94",
      "10-bound": [3.66, 4.24],
      "25-mid": "4.62",
      "25-bound": [4.28, 4.96],
      "50-mid": "5.16",
      "50-bound": [4.77, 5.55],
      "100-mid": "5.72",
      "100-bound": [5.27, 6.14]
    },
    "3day": {
      "2-mid": "3.0",
      "2-bound": [2.8, 3.23],
      "5-mid": "3.63",
      "5-bound": [3.39, 3.91],
      "10-mid": "4.14",
      "10-bound": [3.85, 4.45],
      "25-mid": "4.83",
      "25-bound": [4.48, 5.19],
      "50-mid": "5.38",
      "50-bound": [4.98, 5.78],
      "100-mid": "5.95",
      "100-bound": [5.49, 6.38]
    },
    "4day": {
      "2-mid": "3.16",
      "2-bound": [2.96, 3.41],
      "5-mid": "3.81",
      "5-bound": [3.56, 4.11],
      "10-mid": "4.33",
      "10-bound": [4.04, 4.66],
      "25-mid": "5.04",
      "25-bound": [4.68, 5.42],
      "50-mid": "5.59",
      "50-bound": [5.19, 6.01],
      "100-mid": "6.17",
      "100-bound": [5.71, 6.62]
    },
    "7day": {
      "2-mid": "3.71",
      "2-bound": [3.49, 3.96],
      "5-mid": "4.37",
      "5-bound": [4.12, 4.66],
      "10-mid": "4.88",
      "10-bound": [4.6, 5.2],
      "25-mid": "5.56",
      "25-bound": [5.22, 5.92],
      "50-mid": "6.09",
      "50-bound": [5.71, 6.47],
      "100-mid": "6.61",
      "100-bound": [6.18, 7.02]
    }
  },
  "USC00448062 6": {
    "fips": "51790",
    "station_name": "STAUNTON WATER TREATMENT PLANT",
    "state": "VA",
    "latitude": "38.1690",
    "longitude": "-79.0840",
    "5min": {
      "2-mid": "0.34",
      "2-bound": [0.31, 0.38],
      "5-mid": "0.41",
      "5-bound": [0.37, 0.46],
      "10-mid": "0.47",
      "10-bound": [0.42, 0.52],
      "25-mid": "0.53",
      "25-bound": [0.47, 0.59],
      "50-mid": "0.58",
      "50-bound": [0.51, 0.64],
      "100-mid": "0.63",
      "100-bound": [0.55, 0.7]
    },
    "10min": {
      "2-mid": "0.55",
      "2-bound": [0.49, 0.61],
      "5-mid": "0.66",
      "5-bound": [0.59, 0.74],
      "10-mid": "0.75",
      "10-bound": [0.67, 0.83],
      "25-mid": "0.85",
      "25-bound": [0.76, 0.94],
      "50-mid": "0.93",
      "50-bound": [0.82, 1.03],
      "100-mid": "1.0",
      "100-bound": [0.88, 1.11]
    },
    "15min": {
      "2-mid": "0.69",
      "2-bound": [0.62, 0.77],
      "5-mid": "0.84",
      "5-bound": [0.75, 0.93],
      "10-mid": "0.95",
      "10-bound": [0.85, 1.05],
      "25-mid": "1.08",
      "25-bound": [0.96, 1.19],
      "50-mid": "1.17",
      "50-bound": [1.04, 1.3],
      "100-mid": "1.26",
      "100-bound": [1.11, 1.4]
    },
    "30min": {
      "2-mid": "0.95",
      "2-bound": [0.86, 1.06],
      "5-mid": "1.19",
      "5-bound": [1.07, 1.32],
      "10-mid": "1.37",
      "10-bound": [1.23, 1.52],
      "25-mid": "1.59",
      "25-bound": [1.42, 1.77],
      "50-mid": "1.76",
      "50-bound": [1.56, 1.96],
      "100-mid": "1.93",
      "100-bound": [1.69, 2.14]
    },
    "60min": {
      "2-mid": "1.19",
      "2-bound": [1.08, 1.33],
      "5-mid": "1.53",
      "5-bound": [1.37, 1.7],
      "10-mid": "1.78",
      "10-bound": [1.6, 1.98],
      "25-mid": "2.12",
      "25-bound": [1.89, 2.35],
      "50-mid": "2.39",
      "50-bound": [2.11, 2.65],
      "100-mid": "2.66",
      "100-bound": [2.33, 2.96]
    },
    "2hr": {
      "2-mid": "1.42",
      "2-bound": [1.28, 1.57],
      "5-mid": "1.81",
      "5-bound": [1.63, 2.0],
      "10-mid": "2.12",
      "10-bound": [1.91, 2.35],
      "25-mid": "2.53",
      "25-bound": [2.26, 2.8],
      "50-mid": "2.87",
      "50-bound": [2.55, 3.18],
      "100-mid": "3.21",
      "100-bound": [2.83, 3.56]
    },
    "3hr": {
      "2-mid": "1.52",
      "2-bound": [1.37, 1.69],
      "5-mid": "1.92",
      "5-bound": [1.74, 2.14],
      "10-mid": "2.25",
      "10-bound": [2.03, 2.51],
      "25-mid": "2.7",
      "25-bound": [2.41, 3.0],
      "50-mid": "3.06",
      "50-bound": [2.72, 3.4],
      "100-mid": "3.44",
      "100-bound": [3.03, 3.82]
    },
    "6hr": {
      "2-mid": "1.89",
      "2-bound": [1.71, 2.11],
      "5-mid": "2.36",
      "5-bound": [2.13, 2.63],
      "10-mid": "2.77",
      "10-bound": [2.49, 3.08],
      "25-mid": "3.33",
      "25-bound": [2.97, 3.7],
      "50-mid": "3.8",
      "50-bound": [3.37, 4.22],
      "100-mid": "4.29",
      "100-bound": [3.76, 4.78]
    },
    "12hr": {
      "2-mid": "2.33",
      "2-bound": [2.1, 2.63],
      "5-mid": "2.9",
      "5-bound": [2.6, 3.28],
      "10-mid": "3.41",
      "10-bound": [3.05, 3.86],
      "25-mid": "4.14",
      "25-bound": [3.66, 4.67],
      "50-mid": "4.77",
      "50-bound": [4.17, 5.39],
      "100-mid": "5.46",
      "100-bound": [4.7, 6.18]
    },
    "24hr": {
      "2-mid": "2.87",
      "2-bound": [2.64, 3.14],
      "5-mid": "3.63",
      "5-bound": [3.33, 3.96],
      "10-mid": "4.26",
      "10-bound": [3.89, 4.64],
      "25-mid": "5.16",
      "25-bound": [4.69, 5.61],
      "50-mid": "5.92",
      "50-bound": [5.35, 6.43],
      "100-mid": "6.72",
      "100-bound": [6.03, 7.31]
    },
    "2day": {
      "2-mid": "3.34",
      "2-bound": [3.07, 3.64],
      "5-mid": "4.2",
      "5-bound": [3.86, 4.59],
      "10-mid": "4.91",
      "10-bound": [4.5, 5.35],
      "25-mid": "5.9",
      "25-bound": [5.37, 6.42],
      "50-mid": "6.72",
      "50-bound": [6.09, 7.31],
      "100-mid": "7.59",
      "100-bound": [6.82, 8.24]
    },
    "3day": {
      "2-mid": "3.56",
      "2-bound": [3.29, 3.87],
      "5-mid": "4.48",
      "5-bound": [4.12, 4.87],
      "10-mid": "5.22",
      "10-bound": [4.79, 5.67],
      "25-mid": "6.27",
      "25-bound": [5.73, 6.81],
      "50-mid": "7.13",
      "50-bound": [6.48, 7.74],
      "100-mid": "8.04",
      "100-bound": [7.26, 8.72]
    },
    "4day": {
      "2-mid": "3.78",
      "2-bound": [3.5, 4.1],
      "5-mid": "4.75",
      "5-bound": [4.38, 5.15],
      "10-mid": "5.53",
      "10-bound": [5.09, 5.99],
      "25-mid": "6.64",
      "25-bound": [6.08, 7.2],
      "50-mid": "7.54",
      "50-bound": [6.88, 8.17],
      "100-mid": "8.5",
      "100-bound": [7.7, 9.2]
    },
    "7day": {
      "2-mid": "4.35",
      "2-bound": [4.04, 4.69],
      "5-mid": "5.39",
      "5-bound": [5.0, 5.82],
      "10-mid": "6.23",
      "10-bound": [5.76, 6.71],
      "25-mid": "7.38",
      "25-bound": [6.8, 7.96],
      "50-mid": "8.32",
      "50-bound": [7.62, 8.97],
      "100-mid": "9.27",
      "100-bound": [8.46, 10.0]
    }
  },
  "USC00368379 6": {
    "fips": "42133",
    "station_name": "SPRING GROVE",
    "state": "PA",
    "latitude": "39.8695",
    "longitude": "-76.8632",
    "5min": {
      "2-mid": "0.39",
      "2-bound": [0.34, 0.43],
      "5-mid": "0.45",
      "5-bound": [0.41, 0.51],
      "10-mid": "0.5",
      "10-bound": [0.45, 0.56],
      "25-mid": "0.57",
      "25-bound": [0.51, 0.63],
      "50-mid": "0.61",
      "50-bound": [0.54, 0.68],
      "100-mid": "0.66",
      "100-bound": [0.58, 0.73]
    },
    "10min": {
      "2-mid": "0.61",
      "2-bound": [0.55, 0.69],
      "5-mid": "0.73",
      "5-bound": [0.65, 0.81],
      "10-mid": "0.81",
      "10-bound": [0.72, 0.9],
      "25-mid": "0.9",
      "25-bound": [0.8, 1.0],
      "50-mid": "0.98",
      "50-bound": [0.86, 1.08],
      "100-mid": "1.04",
      "100-bound": [0.92, 1.16]
    },
    "15min": {
      "2-mid": "0.77",
      "2-bound": [0.69, 0.86],
      "5-mid": "0.92",
      "5-bound": [0.82, 1.02],
      "10-mid": "1.02",
      "10-bound": [0.91, 1.13],
      "25-mid": "1.15",
      "25-bound": [1.02, 1.27],
      "50-mid": "1.24",
      "50-bound": [1.09, 1.37],
      "100-mid": "1.32",
      "100-bound": [1.16, 1.46]
    },
    "30min": {
      "2-mid": "1.07",
      "2-bound": [0.96, 1.19],
      "5-mid": "1.31",
      "5-bound": [1.17, 1.46],
      "10-mid": "1.48",
      "10-bound": [1.32, 1.64],
      "25-mid": "1.7",
      "25-bound": [1.51, 1.88],
      "50-mid": "1.86",
      "50-bound": [1.65, 2.06],
      "100-mid": "2.02",
      "100-bound": [1.78, 2.24]
    },
    "60min": {
      "2-mid": "1.34",
      "2-bound": [1.2, 1.49],
      "5-mid": "1.68",
      "5-bound": [1.5, 1.87],
      "10-mid": "1.92",
      "10-bound": [1.72, 2.14],
      "25-mid": "2.26",
      "25-bound": [2.01, 2.51],
      "50-mid": "2.52",
      "50-bound": [2.23, 2.8],
      "100-mid": "2.78",
      "100-bound": [2.46, 3.08]
    },
    "2hr": {
      "2-mid": "1.56",
      "2-bound": [1.4, 1.74],
      "5-mid": "1.98",
      "5-bound": [1.77, 2.21],
      "10-mid": "2.32",
      "10-bound": [2.06, 2.57],
      "25-mid": "2.79",
      "25-bound": [2.47, 3.09],
      "50-mid": "3.18",
      "50-bound": [2.8, 3.52],
      "100-mid": "3.61",
      "100-bound": [3.16, 3.99]
    },
    "3hr": {
      "2-mid": "1.69",
      "2-bound": [1.52, 1.9],
      "5-mid": "2.15",
      "5-bound": [1.93, 2.4],
      "10-mid": "2.51",
      "10-bound": [2.24, 2.8],
      "25-mid": "3.02",
      "25-bound": [2.68, 3.36],
      "50-mid": "3.44",
      "50-bound": [3.04, 3.83],
      "100-mid": "3.9",
      "100-bound": [3.41, 4.32]
    },
    "6hr": {
      "2-mid": "2.07",
      "2-bound": [1.85, 2.34],
      "5-mid": "2.61",
      "5-bound": [2.33, 2.95],
      "10-mid": "3.06",
      "10-bound": [2.72, 3.46],
      "25-mid": "3.73",
      "25-bound": [3.29, 4.19],
      "50-mid": "4.3",
      "50-bound": [3.76, 4.82],
      "100-mid": "4.92",
      "100-bound": [4.27, 5.5]
    },
    "12hr": {
      "2-mid": "2.5",
      "2-bound": [2.21, 2.9],
      "5-mid": "3.17",
      "5-bound": [2.8, 3.67],
      "10-mid": "3.76",
      "10-bound": [3.29, 4.34],
      "25-mid": "4.63",
      "25-bound": [4.02, 5.32],
      "50-mid": "5.4",
      "50-bound": [4.66, 6.18],
      "100-mid": "6.25",
      "100-bound": [5.34, 7.14]
    },
    "24hr": {
      "2-mid": "2.91",
      "2-bound": [2.7, 3.19],
      "5-mid": "3.72",
      "5-bound": [3.44, 4.07],
      "10-mid": "4.43",
      "10-bound": [4.07, 4.84],
      "25-mid": "5.53",
      "25-bound": [5.03, 6.0],
      "50-mid": "6.5",
      "50-bound": [5.88, 7.03],
      "100-mid": "7.6",
      "100-bound": [6.8, 8.19]
    },
    "2day": {
      "2-mid": "3.39",
      "2-bound": [3.13, 3.73],
      "5-mid": "4.33",
      "5-bound": [3.99, 4.76],
      "10-mid": "5.13",
      "10-bound": [4.7, 5.62],
      "25-mid": "6.34",
      "25-bound": [5.78, 6.93],
      "50-mid": "7.4",
      "50-bound": [6.69, 8.07],
      "100-mid": "8.59",
      "100-bound": [7.7, 9.36]
    },
    "3day": {
      "2-mid": "3.6",
      "2-bound": [3.32, 3.95],
      "5-mid": "4.58",
      "5-bound": [4.22, 5.02],
      "10-mid": "5.42",
      "10-bound": [4.98, 5.94],
      "25-mid": "6.7",
      "25-bound": [6.11, 7.31],
      "50-mid": "7.82",
      "50-bound": [7.07, 8.52],
      "100-mid": "9.07",
      "100-bound": [8.14, 9.87]
    },
    "4day": {
      "2-mid": "3.8",
      "2-bound": [3.52, 4.16],
      "5-mid": "4.83",
      "5-bound": [4.46, 5.28],
      "10-mid": "5.71",
      "10-bound": [5.26, 6.25],
      "25-mid": "7.06",
      "25-bound": [6.44, 7.69],
      "50-mid": "8.23",
      "50-bound": [7.46, 8.96],
      "100-mid": "9.55",
      "100-bound": [8.58, 10.4]
    },
    "7day": {
      "2-mid": "4.43",
      "2-bound": [4.09, 4.86],
      "5-mid": "5.57",
      "5-bound": [5.14, 6.1],
      "10-mid": "6.55",
      "10-bound": [6.02, 7.17],
      "25-mid": "8.02",
      "25-bound": [7.33, 8.77],
      "50-mid": "9.3",
      "50-bound": [8.44, 10.2],
      "100-mid": "10.7",
      "100-bound": [9.66, 11.7]
    }
  },
  "USW00013769 6": {
    "fips": "51810",
    "station_name": "OCEANA NAS",
    "state": "VA",
    "latitude": "36.8166",
    "longitude": "-76.0333",
    "5min": {
      "2-mid": "0.48",
      "2-bound": [0.44, 0.54],
      "5-mid": "0.54",
      "5-bound": [0.49, 0.6],
      "10-mid": "0.63",
      "10-bound": [0.57, 0.69],
      "25-mid": "0.71",
      "25-bound": [0.64, 0.78],
      "50-mid": "0.78",
      "50-bound": [0.7, 0.86],
      "100-mid": "0.85",
      "100-bound": [0.76, 0.94]
    },
    "10min": {
      "2-mid": "0.77",
      "2-bound": [0.7, 0.86],
      "5-mid": "0.87",
      "5-bound": [0.79, 0.96],
      "10-mid": "1.0",
      "10-bound": [0.91, 1.11],
      "25-mid": "1.13",
      "25-bound": [1.01, 1.24],
      "50-mid": "1.24",
      "50-bound": [1.12, 1.37],
      "100-mid": "1.34",
      "100-bound": [1.2, 1.48]
    },
    "15min": {
      "2-mid": "0.97",
      "2-bound": [0.88, 1.08],
      "5-mid": "1.1",
      "5-bound": [0.99, 1.22],
      "10-mid": "1.27",
      "10-bound": [1.14, 1.4],
      "25-mid": "1.43",
      "25-bound": [1.28, 1.58],
      "50-mid": "1.57",
      "50-bound": [1.41, 1.74],
      "100-mid": "1.7",
      "100-bound": [1.52, 1.88]
    },
    "30min": {
      "2-mid": "1.34",
      "2-bound": [1.22, 1.49],
      "5-mid": "1.56",
      "5-bound": [1.41, 1.73],
      "10-mid": "1.84",
      "10-bound": [1.66, 2.04],
      "25-mid": "2.11",
      "25-bound": [1.9, 2.33],
      "50-mid": "2.37",
      "50-bound": [2.12, 2.62],
      "100-mid": "2.6",
      "100-bound": [2.32, 2.88]
    },
    "60min": {
      "2-mid": "1.69",
      "2-bound": [1.53, 1.87],
      "5-mid": "2.0",
      "5-bound": [1.81, 2.21],
      "10-mid": "2.4",
      "10-bound": [2.16, 2.65],
      "25-mid": "2.81",
      "25-bound": [2.53, 3.11],
      "50-mid": "3.21",
      "50-bound": [2.88, 3.55],
      "100-mid": "3.58",
      "100-bound": [3.2, 3.96]
    },
    "2hr": {
      "2-mid": "2.01",
      "2-bound": [1.81, 2.23],
      "5-mid": "2.42",
      "5-bound": [2.19, 2.69],
      "10-mid": "2.95",
      "10-bound": [2.66, 3.27],
      "25-mid": "3.54",
      "25-bound": [3.16, 3.9],
      "50-mid": "4.11",
      "50-bound": [3.66, 4.54],
      "100-mid": "4.65",
      "100-bound": [4.12, 5.14]
    },
    "3hr": {
      "2-mid": "2.17",
      "2-bound": [1.95, 2.43],
      "5-mid": "2.63",
      "5-bound": [2.36, 2.93],
      "10-mid": "3.22",
      "10-bound": [2.88, 3.59],
      "25-mid": "3.89",
      "25-bound": [3.46, 4.33],
      "50-mid": "4.56",
      "50-bound": [4.04, 5.07],
      "100-mid": "5.22",
      "100-bound": [4.59, 5.8]
    },
    "6hr": {
      "2-mid": "2.65",
      "2-bound": [2.37, 2.98],
      "5-mid": "3.21",
      "5-bound": [2.87, 3.61],
      "10-mid": "3.94",
      "10-bound": [3.5, 4.42],
      "25-mid": "4.78",
      "25-bound": [4.23, 5.35],
      "50-mid": "5.64",
      "50-bound": [4.95, 6.28],
      "100-mid": "6.48",
      "100-bound": [5.65, 7.22]
    },
    "12hr": {
      "2-mid": "3.14",
      "2-bound": [2.8, 3.55],
      "5-mid": "3.82",
      "5-bound": [3.4, 4.32],
      "10-mid": "4.71",
      "10-bound": [4.17, 5.31],
      "25-mid": "5.77",
      "25-bound": [5.07, 6.49],
      "50-mid": "6.86",
      "50-bound": [5.97, 7.69],
      "100-mid": "7.95",
      "100-bound": [6.87, 8.91]
    },
    "24hr": {
      "2-mid": "3.65",
      "2-bound": [3.35, 4.01],
      "5-mid": "4.72",
      "5-bound": [4.33, 5.19],
      "10-mid": "5.64",
      "10-bound": [5.14, 6.17],
      "25-mid": "6.98",
      "25-bound": [6.34, 7.63],
      "50-mid": "8.15",
      "50-bound": [7.33, 8.9],
      "100-mid": "9.44",
      "100-bound": [8.41, 10.3]
    },
    "2day": {
      "2-mid": "4.2",
      "2-bound": [3.85, 4.63],
      "5-mid": "5.4",
      "5-bound": [4.95, 5.95],
      "10-mid": "6.44",
      "10-bound": [5.87, 7.08],
      "25-mid": "7.99",
      "25-bound": [7.23, 8.78],
      "50-mid": "9.35",
      "50-bound": [8.39, 10.2],
      "100-mid": "10.9",
      "100-bound": [9.65, 11.9]
    },
    "3day": {
      "2-mid": "4.44",
      "2-bound": [4.08, 4.87],
      "5-mid": "5.68",
      "5-bound": [5.22, 6.23],
      "10-mid": "6.74",
      "10-bound": [6.16, 7.38],
      "25-mid": "8.3",
      "25-bound": [7.53, 9.08],
      "50-mid": "9.64",
      "50-bound": [8.68, 10.5],
      "100-mid": "11.1",
      "100-bound": [9.92, 12.2]
    },
    "4day": {
      "2-mid": "4.68",
      "2-bound": [4.31, 5.12],
      "5-mid": "5.97",
      "5-bound": [5.49, 6.51],
      "10-mid": "7.04",
      "10-bound": [6.45, 7.68],
      "25-mid": "8.61",
      "25-bound": [7.84, 9.38],
      "50-mid": "9.94",
      "50-bound": [8.98, 10.8],
      "100-mid": "11.4",
      "100-bound": [10.2, 12.4]
    },
    "7day": {
      "2-mid": "5.44",
      "2-bound": [5.04, 5.92],
      "5-mid": "6.85",
      "5-bound": [6.33, 7.44],
      "10-mid": "8.02",
      "10-bound": [7.38, 8.69],
      "25-mid": "9.71",
      "25-bound": [8.88, 10.5],
      "50-mid": "11.1",
      "50-bound": [10.1, 12.0],
      "100-mid": "12.6",
      "100-bound": [11.4, 13.7]
    }
  },
  "USC00076410 6": {
    "fips": "10003",
    "station_name": "NEWARK AG FARM",
    "state": "DE",
    "latitude": "39.6680",
    "longitude": "-75.7456",
    "5min": {
      "2-mid": "0.41",
      "2-bound": [0.37, 0.46],
      "5-mid": "0.48",
      "5-bound": [0.44, 0.54],
      "10-mid": "0.54",
      "10-bound": [0.48, 0.59],
      "25-mid": "0.6",
      "25-bound": [0.53, 0.66],
      "50-mid": "0.64",
      "50-bound": [0.57, 0.71],
      "100-mid": "0.68",
      "100-bound": [0.6, 0.76]
    },
    "10min": {
      "2-mid": "0.66",
      "2-bound": [0.6, 0.73],
      "5-mid": "0.78",
      "5-bound": [0.7, 0.86],
      "10-mid": "0.86",
      "10-bound": [0.77, 0.95],
      "25-mid": "0.95",
      "25-bound": [0.85, 1.05],
      "50-mid": "1.02",
      "50-bound": [0.91, 1.13],
      "100-mid": "1.08",
      "100-bound": [0.96, 1.2]
    },
    "15min": {
      "2-mid": "0.83",
      "2-bound": [0.75, 0.92],
      "5-mid": "0.98",
      "5-bound": [0.89, 1.09],
      "10-mid": "1.08",
      "10-bound": [0.97, 1.2],
      "25-mid": "1.2",
      "25-bound": [1.08, 1.34],
      "50-mid": "1.28",
      "50-bound": [1.15, 1.43],
      "100-mid": "1.36",
      "100-bound": [1.21, 1.52]
    },
    "30min": {
      "2-mid": "1.15",
      "2-bound": [1.04, 1.27],
      "5-mid": "1.4",
      "5-bound": [1.26, 1.55],
      "10-mid": "1.57",
      "10-bound": [1.41, 1.74],
      "25-mid": "1.78",
      "25-bound": [1.6, 1.98],
      "50-mid": "1.94",
      "50-bound": [1.72, 2.15],
      "100-mid": "2.09",
      "100-bound": [1.85, 2.32]
    },
    "60min": {
      "2-mid": "1.44",
      "2-bound": [1.3, 1.6],
      "5-mid": "1.79",
      "5-bound": [1.61, 1.98],
      "10-mid": "2.04",
      "10-bound": [1.84, 2.26],
      "25-mid": "2.37",
      "25-bound": [2.13, 2.64],
      "50-mid": "2.62",
      "50-bound": [2.34, 2.91],
      "100-mid": "2.87",
      "100-bound": [2.55, 3.2]
    },
    "2hr": {
      "2-mid": "1.72",
      "2-bound": [1.55, 1.91],
      "5-mid": "2.15",
      "5-bound": [1.93, 2.39],
      "10-mid": "2.48",
      "10-bound": [2.22, 2.75],
      "25-mid": "2.92",
      "25-bound": [2.6, 3.23],
      "50-mid": "3.26",
      "50-bound": [2.89, 3.62],
      "100-mid": "3.61",
      "100-bound": [3.19, 4.01]
    },
    "3hr": {
      "2-mid": "1.86",
      "2-bound": [1.68, 2.06],
      "5-mid": "2.33",
      "5-bound": [2.1, 2.58],
      "10-mid": "2.69",
      "10-bound": [2.42, 2.98],
      "25-mid": "3.18",
      "25-bound": [2.84, 3.51],
      "50-mid": "3.57",
      "50-bound": [3.17, 3.94],
      "100-mid": "3.97",
      "100-bound": [3.5, 4.39]
    },
    "6hr": {
      "2-mid": "2.29",
      "2-bound": [2.08, 2.55],
      "5-mid": "2.86",
      "5-bound": [2.59, 3.18],
      "10-mid": "3.32",
      "10-bound": [3.0, 3.69],
      "25-mid": "3.97",
      "25-bound": [3.56, 4.41],
      "50-mid": "4.5",
      "50-bound": [4.0, 4.99],
      "100-mid": "5.07",
      "100-bound": [4.46, 5.63]
    },
    "12hr": {
      "2-mid": "2.79",
      "2-bound": [2.5, 3.14],
      "5-mid": "3.5",
      "5-bound": [3.13, 3.94],
      "10-mid": "4.1",
      "10-bound": [3.65, 4.6],
      "25-mid": "4.97",
      "25-bound": [4.39, 5.59],
      "50-mid": "5.71",
      "50-bound": [4.99, 6.41],
      "100-mid": "6.52",
      "100-bound": [5.63, 7.34]
    },
    "24hr": {
      "2-mid": "3.24",
      "2-bound": [2.97, 3.54],
      "5-mid": "4.08",
      "5-bound": [3.74, 4.47],
      "10-mid": "4.79",
      "10-bound": [4.38, 5.24],
      "25-mid": "5.82",
      "25-bound": [5.3, 6.36],
      "50-mid": "6.7",
      "50-bound": [6.06, 7.29],
      "100-mid": "7.65",
      "100-bound": [6.88, 8.32]
    },
    "2day": {
      "2-mid": "3.73",
      "2-bound": [3.43, 4.09],
      "5-mid": "4.71",
      "5-bound": [4.32, 5.16],
      "10-mid": "5.52",
      "10-bound": [5.05, 6.04],
      "25-mid": "6.67",
      "25-bound": [6.08, 7.29],
      "50-mid": "7.64",
      "50-bound": [6.92, 8.33],
      "100-mid": "8.67",
      "100-bound": [7.82, 9.45]
    },
    "3day": {
      "2-mid": "3.93",
      "2-bound": [3.62, 4.29],
      "5-mid": "4.95",
      "5-bound": [4.55, 5.4],
      "10-mid": "5.78",
      "10-bound": [5.3, 6.3],
      "25-mid": "6.98",
      "25-bound": [6.37, 7.6],
      "50-mid": "7.98",
      "50-bound": [7.24, 8.68],
      "100-mid": "9.05",
      "100-bound": [8.17, 9.83]
    },
    "4day": {
      "2-mid": "4.13",
      "2-bound": [3.8, 4.49],
      "5-mid": "5.19",
      "5-bound": [4.77, 5.64],
      "10-mid": "6.05",
      "10-bound": [5.55, 6.57],
      "25-mid": "7.29",
      "25-bound": [6.66, 7.91],
      "50-mid": "8.32",
      "50-bound": [7.56, 9.02],
      "100-mid": "9.42",
      "100-bound": [8.52, 10.2]
    },
    "7day": {
      "2-mid": "4.77",
      "2-bound": [4.42, 5.18],
      "5-mid": "5.92",
      "5-bound": [5.47, 6.42],
      "10-mid": "6.87",
      "10-bound": [6.35, 7.44],
      "25-mid": "8.24",
      "25-bound": [7.57, 8.91],
      "50-mid": "9.38",
      "50-bound": [8.58, 10.1],
      "100-mid": "10.6",
      "100-bound": [9.64, 11.4]
    }
  },
  "USW00014711 6": {
    "fips": "42043",
    "station_name": "MIDDLETOWN HARRISBURG INT'L AP",
    "state": "PA",
    "latitude": "40.1960",
    "longitude": "-76.7720",
    "5min": {
      "2-mid": "0.38",
      "2-bound": [0.34, 0.42],
      "5-mid": "0.45",
      "5-bound": [0.4, 0.5],
      "10-mid": "0.5",
      "10-bound": [0.45, 0.55],
      "25-mid": "0.56",
      "25-bound": [0.5, 0.62],
      "50-mid": "0.6",
      "50-bound": [0.54, 0.67],
      "100-mid": "0.65",
      "100-bound": [0.57, 0.71]
    },
    "10min": {
      "2-mid": "0.61",
      "2-bound": [0.55, 0.68],
      "5-mid": "0.72",
      "5-bound": [0.64, 0.8],
      "10-mid": "0.8",
      "10-bound": [0.71, 0.88],
      "25-mid": "0.89",
      "25-bound": [0.79, 0.98],
      "50-mid": "0.96",
      "50-bound": [0.85, 1.06],
      "100-mid": "1.02",
      "100-bound": [0.91, 1.13]
    },
    "15min": {
      "2-mid": "0.76",
      "2-bound": [0.69, 0.85],
      "5-mid": "0.91",
      "5-bound": [0.81, 1.01],
      "10-mid": "1.01",
      "10-bound": [0.9, 1.12],
      "25-mid": "1.13",
      "25-bound": [1.0, 1.25],
      "50-mid": "1.21",
      "50-bound": [1.08, 1.34],
      "100-mid": "1.29",
      "100-bound": [1.15, 1.43]
    },
    "30min": {
      "2-mid": "1.05",
      "2-bound": [0.94, 1.17],
      "5-mid": "1.29",
      "5-bound": [1.15, 1.43],
      "10-mid": "1.46",
      "10-bound": [1.3, 1.61],
      "25-mid": "1.67",
      "25-bound": [1.48, 1.84],
      "50-mid": "1.82",
      "50-bound": [1.62, 2.02],
      "100-mid": "1.98",
      "100-bound": [1.76, 2.19]
    },
    "60min": {
      "2-mid": "1.32",
      "2-bound": [1.19, 1.47],
      "5-mid": "1.65",
      "5-bound": [1.48, 1.83],
      "10-mid": "1.89",
      "10-bound": [1.7, 2.1],
      "25-mid": "2.22",
      "25-bound": [1.98, 2.46],
      "50-mid": "2.47",
      "50-bound": [2.2, 2.73],
      "100-mid": "2.72",
      "100-bound": [2.41, 3.02]
    },
    "2hr": {
      "2-mid": "1.54",
      "2-bound": [1.38, 1.71],
      "5-mid": "1.94",
      "5-bound": [1.75, 2.16],
      "10-mid": "2.27",
      "10-bound": [2.03, 2.51],
      "25-mid": "2.73",
      "25-bound": [2.44, 3.02],
      "50-mid": "3.12",
      "50-bound": [2.76, 3.44],
      "100-mid": "3.54",
      "100-bound": [3.11, 3.89]
    },
    "3hr": {
      "2-mid": "1.68",
      "2-bound": [1.52, 1.87],
      "5-mid": "2.13",
      "5-bound": [1.92, 2.37],
      "10-mid": "2.48",
      "10-bound": [2.23, 2.76],
      "25-mid": "2.99",
      "25-bound": [2.67, 3.3],
      "50-mid": "3.41",
      "50-bound": [3.03, 3.77],
      "100-mid": "3.87",
      "100-bound": [3.41, 4.27]
    },
    "6hr": {
      "2-mid": "2.07",
      "2-bound": [1.86, 2.32],
      "5-mid": "2.6",
      "5-bound": [2.34, 2.91],
      "10-mid": "3.05",
      "10-bound": [2.73, 3.4],
      "25-mid": "3.71",
      "25-bound": [3.3, 4.12],
      "50-mid": "4.27",
      "50-bound": [3.77, 4.74],
      "100-mid": "4.9",
      "100-bound": [4.28, 5.42]
    },
    "12hr": {
      "2-mid": "2.5",
      "2-bound": [2.23, 2.85],
      "5-mid": "3.17",
      "5-bound": [2.82, 3.61],
      "10-mid": "3.75",
      "10-bound": [3.31, 4.25],
      "25-mid": "4.61",
      "25-bound": [4.05, 5.21],
      "50-mid": "5.37",
      "50-bound": [4.67, 6.05],
      "100-mid": "6.22",
      "100-bound": [5.36, 7.0]
    },
    "24hr": {
      "2-mid": "2.89",
      "2-bound": [2.66, 3.18],
      "5-mid": "3.68",
      "5-bound": [3.38, 4.05],
      "10-mid": "4.37",
      "10-bound": [4.0, 4.8],
      "25-mid": "5.44",
      "25-bound": [4.93, 5.95],
      "50-mid": "6.39",
      "50-bound": [5.75, 6.96],
      "100-mid": "7.48",
      "100-bound": [6.66, 8.11]
    },
    "2day": {
      "2-mid": "3.34",
      "2-bound": [3.06, 3.71],
      "5-mid": "4.25",
      "5-bound": [3.88, 4.72],
      "10-mid": "5.03",
      "10-bound": [4.58, 5.58],
      "25-mid": "6.22",
      "25-bound": [5.62, 6.86],
      "50-mid": "7.25",
      "50-bound": [6.5, 7.99],
      "100-mid": "8.42",
      "100-bound": [7.49, 9.26]
    },
    "3day": {
      "2-mid": "3.56",
      "2-bound": [3.27, 3.93],
      "5-mid": "4.51",
      "5-bound": [4.14, 4.99],
      "10-mid": "5.33",
      "10-bound": [4.87, 5.89],
      "25-mid": "6.58",
      "25-bound": [5.97, 7.24],
      "50-mid": "7.68",
      "50-bound": [6.91, 8.43],
      "100-mid": "8.91",
      "100-bound": [7.95, 9.76]
    },
    "4day": {
      "2-mid": "3.77",
      "2-bound": [3.47, 4.15],
      "5-mid": "4.77",
      "5-bound": [4.39, 5.26],
      "10-mid": "5.64",
      "10-bound": [5.16, 6.2],
      "25-mid": "6.95",
      "25-bound": [6.32, 7.62],
      "50-mid": "8.1",
      "50-bound": [7.32, 8.87],
      "100-mid": "9.39",
      "100-bound": [8.41, 10.3]
    },
    "7day": {
      "2-mid": "4.4",
      "2-bound": [4.07, 4.83],
      "5-mid": "5.52",
      "5-bound": [5.1, 6.04],
      "10-mid": "6.48",
      "10-bound": [5.96, 7.08],
      "25-mid": "7.92",
      "25-bound": [7.24, 8.64],
      "50-mid": "9.18",
      "50-bound": [8.34, 10.0],
      "100-mid": "10.6",
      "100-bound": [9.55, 11.5]
    }
  },
  "USC00303444 6": {
    "fips": "36017",
    "station_name": "GREENE",
    "state": "NY",
    "latitude": "42.3230",
    "longitude": "-75.7710",
    "5min": {
      "2-mid": "0.37",
      "2-bound": [0.28, 0.47],
      "5-mid": "0.48",
      "5-bound": [0.36, 0.61],
      "10-mid": "0.57",
      "10-bound": [0.43, 0.73],
      "25-mid": "0.69",
      "25-bound": [0.51, 0.94],
      "50-mid": "0.79",
      "50-bound": [0.57, 1.09],
      "100-mid": "0.89",
      "100-bound": [0.62, 1.27]
    },
    "10min": {
      "2-mid": "0.53",
      "2-bound": [0.4, 0.67],
      "5-mid": "0.68",
      "5-bound": [0.52, 0.87],
      "10-mid": "0.81",
      "10-bound": [0.61, 1.04],
      "25-mid": "0.98",
      "25-bound": [0.72, 1.33],
      "50-mid": "1.12",
      "50-bound": [0.81, 1.54],
      "100-mid": "1.26",
      "100-bound": [0.89, 1.8]
    },
    "15min": {
      "2-mid": "0.62",
      "2-bound": [0.47, 0.79],
      "5-mid": "0.8",
      "5-bound": [0.61, 1.02],
      "10-mid": "0.95",
      "10-bound": [0.72, 1.22],
      "25-mid": "1.16",
      "25-bound": [0.85, 1.56],
      "50-mid": "1.31",
      "50-bound": [0.95, 1.81],
      "100-mid": "1.48",
      "100-bound": [1.04, 2.12]
    },
    "30min": {
      "2-mid": "0.82",
      "2-bound": [0.63, 1.05],
      "5-mid": "1.07",
      "5-bound": [0.81, 1.36],
      "10-mid": "1.27",
      "10-bound": [0.96, 1.63],
      "25-mid": "1.54",
      "25-bound": [1.14, 2.08],
      "50-mid": "1.75",
      "50-bound": [1.27, 2.42],
      "100-mid": "1.97",
      "100-bound": [1.39, 2.83]
    },
    "60min": {
      "2-mid": "1.03",
      "2-bound": [0.79, 1.31],
      "5-mid": "1.33",
      "5-bound": [1.02, 1.7],
      "10-mid": "1.58",
      "10-bound": [1.2, 2.04],
      "25-mid": "1.93",
      "25-bound": [1.42, 2.6],
      "50-mid": "2.19",
      "50-bound": [1.58, 3.02],
      "100-mid": "2.46",
      "100-bound": [1.74, 3.53]
    },
    "2hr": {
      "2-mid": "1.28",
      "2-bound": [0.98, 1.61],
      "5-mid": "1.6",
      "5-bound": [1.22, 2.03],
      "10-mid": "1.87",
      "10-bound": [1.42, 2.38],
      "25-mid": "2.24",
      "25-bound": [1.67, 3.02],
      "50-mid": "2.5",
      "50-bound": [1.84, 3.48],
      "100-mid": "2.8",
      "100-bound": [2.03, 4.11]
    },
    "3hr": {
      "2-mid": "1.44",
      "2-bound": [1.11, 1.82],
      "5-mid": "1.79",
      "5-bound": [1.38, 2.26],
      "10-mid": "2.08",
      "10-bound": [1.59, 2.64],
      "25-mid": "2.48",
      "25-bound": [1.86, 3.34],
      "50-mid": "2.76",
      "50-bound": [2.05, 3.85],
      "100-mid": "3.09",
      "100-bound": [2.26, 4.55]
    },
    "6hr": {
      "2-mid": "1.79",
      "2-bound": [1.39, 2.23],
      "5-mid": "2.22",
      "5-bound": [1.72, 2.79],
      "10-mid": "2.59",
      "10-bound": [1.99, 3.27],
      "25-mid": "3.09",
      "25-bound": [2.34, 4.16],
      "50-mid": "3.45",
      "50-bound": [2.58, 4.78],
      "100-mid": "3.86",
      "100-bound": [2.85, 5.67]
    },
    "12hr": {
      "2-mid": "2.21",
      "2-bound": [1.73, 2.74],
      "5-mid": "2.82",
      "5-bound": [2.19, 3.51],
      "10-mid": "3.32",
      "10-bound": [2.57, 4.16],
      "25-mid": "4.01",
      "25-bound": [3.04, 5.33],
      "50-mid": "4.52",
      "50-bound": [3.37, 6.17],
      "100-mid": "5.08",
      "100-bound": [3.72, 7.3]
    },
    "24hr": {
      "2-mid": "2.64",
      "2-bound": [2.08, 3.26],
      "5-mid": "3.41",
      "5-bound": [2.67, 4.23],
      "10-mid": "4.05",
      "10-bound": [3.16, 5.05],
      "25-mid": "4.93",
      "25-bound": [3.74, 6.48],
      "50-mid": "5.59",
      "50-bound": [4.16, 7.52],
      "100-mid": "6.29",
      "100-bound": [4.58, 8.87]
    },
    "2day": {
      "2-mid": "3.03",
      "2-bound": [2.4, 3.72],
      "5-mid": "3.89",
      "5-bound": [3.07, 4.79],
      "10-mid": "4.61",
      "10-bound": [3.62, 5.7],
      "25-mid": "5.59",
      "25-bound": [4.26, 7.28],
      "50-mid": "6.32",
      "50-bound": [4.72, 8.44],
      "100-mid": "7.1",
      "100-bound": [5.18, 9.92]
    },
    "3day": {
      "2-mid": "3.29",
      "2-bound": [2.62, 4.02],
      "5-mid": "4.18",
      "5-bound": [3.32, 5.13],
      "10-mid": "4.92",
      "10-bound": [3.88, 6.07],
      "25-mid": "5.94",
      "25-bound": [4.54, 7.71],
      "50-mid": "6.7",
      "50-bound": [5.03, 8.91],
      "100-mid": "7.52",
      "100-bound": [5.49, 10.4]
    },
    "4day": {
      "2-mid": "3.51",
      "2-bound": [2.8, 4.27],
      "5-mid": "4.42",
      "5-bound": [3.51, 5.4],
      "10-mid": "5.17",
      "10-bound": [4.08, 6.36],
      "25-mid": "6.21",
      "25-bound": [4.76, 8.02],
      "50-mid": "6.98",
      "50-bound": [5.24, 9.24],
      "100-mid": "7.81",
      "100-bound": [5.72, 10.8]
    },
    "7day": {
      "2-mid": "4.08",
      "2-bound": [3.27, 4.94],
      "5-mid": "5.01",
      "5-bound": [4.0, 6.09],
      "10-mid": "5.79",
      "10-bound": [4.59, 7.07],
      "25-mid": "6.85",
      "25-bound": [5.27, 8.79],
      "50-mid": "7.64",
      "50-bound": [5.76, 10.0],
      "100-mid": "8.49",
      "100-bound": [6.23, 11.7]
    }
  },
  "USC00300668 6": {
    "fips": "36043",
    "station_name": "BIG MOOSE 3 SE",
    "state": "NY",
    "latitude": "43.0000",
    "longitude": "-74.8660",
    "5min": {
      "2-mid": "0.33",
      "2-bound": [0.26, 0.41],
      "5-mid": "0.41",
      "5-bound": [0.33, 0.51],
      "10-mid": "0.49",
      "10-bound": [0.38, 0.61],
      "25-mid": "0.59",
      "25-bound": [0.45, 0.74],
      "50-mid": "0.66",
      "50-bound": [0.5, 0.85],
      "100-mid": "0.74",
      "100-bound": [0.54, 0.96]
    },
    "10min": {
      "2-mid": "0.46",
      "2-bound": [0.37, 0.57],
      "5-mid": "0.59",
      "5-bound": [0.47, 0.73],
      "10-mid": "0.69",
      "10-bound": [0.54, 0.86],
      "25-mid": "0.83",
      "25-bound": [0.64, 1.05],
      "50-mid": "0.94",
      "50-bound": [0.7, 1.2],
      "100-mid": "1.05",
      "100-bound": [0.76, 1.36]
    },
    "15min": {
      "2-mid": "0.55",
      "2-bound": [0.43, 0.68],
      "5-mid": "0.69",
      "5-bound": [0.55, 0.86],
      "10-mid": "0.81",
      "10-bound": [0.64, 1.01],
      "25-mid": "0.98",
      "25-bound": [0.75, 1.24],
      "50-mid": "1.1",
      "50-bound": [0.83, 1.42],
      "100-mid": "1.23",
      "100-bound": [0.9, 1.61]
    },
    "30min": {
      "2-mid": "0.74",
      "2-bound": [0.59, 0.91],
      "5-mid": "0.94",
      "5-bound": [0.74, 1.16],
      "10-mid": "1.1",
      "10-bound": [0.87, 1.38],
      "25-mid": "1.34",
      "25-bound": [1.02, 1.7],
      "50-mid": "1.51",
      "50-bound": [1.13, 1.94],
      "100-mid": "1.69",
      "100-bound": [1.23, 2.2]
    },
    "60min": {
      "2-mid": "0.93",
      "2-bound": [0.74, 1.15],
      "5-mid": "1.19",
      "5-bound": [0.94, 1.47],
      "10-mid": "1.4",
      "10-bound": [1.11, 1.74],
      "25-mid": "1.69",
      "25-bound": [1.3, 2.15],
      "50-mid": "1.92",
      "50-bound": [1.44, 2.46],
      "100-mid": "2.15",
      "100-bound": [1.56, 2.8]
    },
    "2hr": {
      "2-mid": "1.17",
      "2-bound": [0.94, 1.44],
      "5-mid": "1.46",
      "5-bound": [1.17, 1.8],
      "10-mid": "1.7",
      "10-bound": [1.35, 2.1],
      "25-mid": "2.03",
      "25-bound": [1.56, 2.56],
      "50-mid": "2.28",
      "50-bound": [1.72, 2.9],
      "100-mid": "2.53",
      "100-bound": [1.86, 3.29]
    },
    "3hr": {
      "2-mid": "1.33",
      "2-bound": [1.07, 1.63],
      "5-mid": "1.64",
      "5-bound": [1.32, 2.02],
      "10-mid": "1.9",
      "10-bound": [1.52, 2.34],
      "25-mid": "2.25",
      "25-bound": [1.74, 2.83],
      "50-mid": "2.52",
      "50-bound": [1.92, 3.2],
      "100-mid": "2.8",
      "100-bound": [2.07, 3.62]
    },
    "6hr": {
      "2-mid": "1.65",
      "2-bound": [1.33, 2.0],
      "5-mid": "2.02",
      "5-bound": [1.63, 2.46],
      "10-mid": "2.32",
      "10-bound": [1.86, 2.84],
      "25-mid": "2.74",
      "25-bound": [2.14, 3.43],
      "50-mid": "3.06",
      "50-bound": [2.34, 3.87],
      "100-mid": "3.39",
      "100-bound": [2.53, 4.37]
    },
    "12hr": {
      "2-mid": "2.01",
      "2-bound": [1.64, 2.43],
      "5-mid": "2.47",
      "5-bound": [2.0, 2.99],
      "10-mid": "2.85",
      "10-bound": [2.3, 3.46],
      "25-mid": "3.38",
      "25-bound": [2.66, 4.2],
      "50-mid": "3.77",
      "50-bound": [2.91, 4.74],
      "100-mid": "4.19",
      "100-bound": [3.15, 5.38]
    },
    "24hr": {
      "2-mid": "2.4",
      "2-bound": [1.97, 2.88],
      "5-mid": "2.95",
      "5-bound": [2.41, 3.54],
      "10-mid": "3.4",
      "10-bound": [2.77, 4.1],
      "25-mid": "4.03",
      "25-bound": [3.19, 4.97],
      "50-mid": "4.5",
      "50-bound": [3.5, 5.61],
      "100-mid": "5.0",
      "100-bound": [3.78, 6.35]
    },
    "2day": {
      "2-mid": "2.81",
      "2-bound": [2.32, 3.35],
      "5-mid": "3.41",
      "5-bound": [2.8, 4.07],
      "10-mid": "3.9",
      "10-bound": [3.2, 4.68],
      "25-mid": "4.59",
      "25-bound": [3.65, 5.61],
      "50-mid": "5.11",
      "50-bound": [3.98, 6.3],
      "100-mid": "5.64",
      "100-bound": [4.28, 7.09]
    },
    "3day": {
      "2-mid": "3.09",
      "2-bound": [2.56, 3.68],
      "5-mid": "3.72",
      "5-bound": [3.07, 4.42],
      "10-mid": "4.23",
      "10-bound": [3.48, 5.05],
      "25-mid": "4.94",
      "25-bound": [3.94, 6.01],
      "50-mid": "5.49",
      "50-bound": [4.29, 6.73],
      "100-mid": "6.04",
      "100-bound": [4.6, 7.54]
    },
    "4day": {
      "2-mid": "3.33",
      "2-bound": [2.77, 3.95],
      "5-mid": "3.98",
      "5-bound": [3.29, 4.72],
      "10-mid": "4.51",
      "10-bound": [3.71, 5.36],
      "25-mid": "5.24",
      "25-bound": [4.19, 6.35],
      "50-mid": "5.8",
      "50-bound": [4.55, 7.09],
      "100-mid": "6.37",
      "100-bound": [4.85, 7.91]
    },
    "7day": {
      "2-mid": "3.98",
      "2-bound": [3.32, 4.69],
      "5-mid": "4.67",
      "5-bound": [3.88, 5.51],
      "10-mid": "5.23",
      "10-bound": [4.33, 6.19],
      "25-mid": "6.02",
      "25-bound": [4.84, 7.24],
      "50-mid": "6.62",
      "50-bound": [5.21, 8.03],
      "100-mid": "7.22",
      "100-bound": [5.52, 8.89]
    }
  },
  "USC00448894 6": {
    "fips": "51159",
    "station_name": "WARSAW 2 NW",
    "state": "VA",
    "latitude": "37.9880",
    "longitude": "-76.7760",
    "5min": {
      "2-mid": "0.45",
      "2-bound": [0.4, 0.49],
      "5-mid": "0.52",
      "5-bound": [0.47, 0.58],
      "10-mid": "0.59",
      "10-bound": [0.53, 0.65],
      "25-mid": "0.66",
      "25-bound": [0.6, 0.73],
      "50-mid": "0.72",
      "50-bound": [0.65, 0.8],
      "100-mid": "0.78",
      "100-bound": [0.69, 0.86]
    },
    "10min": {
      "2-mid": "0.71",
      "2-bound": [0.65, 0.79],
      "5-mid": "0.84",
      "5-bound": [0.76, 0.92],
      "10-mid": "0.94",
      "10-bound": [0.85, 1.04],
      "25-mid": "1.06",
      "25-bound": [0.95, 1.16],
      "50-mid": "1.15",
      "50-bound": [1.03, 1.27],
      "100-mid": "1.24",
      "100-bound": [1.1, 1.37]
    },
    "15min": {
      "2-mid": "0.9",
      "2-bound": [0.81, 0.99],
      "5-mid": "1.06",
      "5-bound": [0.96, 1.17],
      "10-mid": "1.19",
      "10-bound": [1.07, 1.31],
      "25-mid": "1.34",
      "25-bound": [1.2, 1.48],
      "50-mid": "1.46",
      "50-bound": [1.3, 1.61],
      "100-mid": "1.56",
      "100-bound": [1.39, 1.73]
    },
    "30min": {
      "2-mid": "1.24",
      "2-bound": [1.12, 1.36],
      "5-mid": "1.5",
      "5-bound": [1.36, 1.66],
      "10-mid": "1.72",
      "10-bound": [1.55, 1.9],
      "25-mid": "1.98",
      "25-bound": [1.78, 2.19],
      "50-mid": "2.19",
      "50-bound": [1.96, 2.42],
      "100-mid": "2.4",
      "100-bound": [2.13, 2.65]
    },
    "60min": {
      "2-mid": "1.55",
      "2-bound": [1.41, 1.71],
      "5-mid": "1.93",
      "5-bound": [1.75, 2.12],
      "10-mid": "2.24",
      "10-bound": [2.02, 2.47],
      "25-mid": "2.64",
      "25-bound": [2.37, 2.91],
      "50-mid": "2.97",
      "50-bound": [2.66, 3.28],
      "100-mid": "3.3",
      "100-bound": [2.94, 3.65]
    },
    "2hr": {
      "2-mid": "1.85",
      "2-bound": [1.67, 2.04],
      "5-mid": "2.32",
      "5-bound": [2.09, 2.56],
      "10-mid": "2.72",
      "10-bound": [2.44, 3.0],
      "25-mid": "3.24",
      "25-bound": [2.9, 3.58],
      "50-mid": "3.69",
      "50-bound": [3.28, 4.07],
      "100-mid": "4.14",
      "100-bound": [3.66, 4.58]
    },
    "3hr": {
      "2-mid": "2.0",
      "2-bound": [1.8, 2.23],
      "5-mid": "2.52",
      "5-bound": [2.25, 2.8],
      "10-mid": "2.96",
      "10-bound": [2.65, 3.3],
      "25-mid": "3.56",
      "25-bound": [3.15, 3.96],
      "50-mid": "4.07",
      "50-bound": [3.58, 4.52],
      "100-mid": "4.6",
      "100-bound": [4.02, 5.11]
    },
    "6hr": {
      "2-mid": "2.42",
      "2-bound": [2.17, 2.71],
      "5-mid": "3.03",
      "5-bound": [2.71, 3.4],
      "10-mid": "3.58",
      "10-bound": [3.19, 4.01],
      "25-mid": "4.34",
      "25-bound": [3.84, 4.86],
      "50-mid": "5.01",
      "50-bound": [4.39, 5.61],
      "100-mid": "5.71",
      "100-bound": [4.96, 6.41]
    },
    "12hr": {
      "2-mid": "2.88",
      "2-bound": [2.56, 3.28],
      "5-mid": "3.63",
      "5-bound": [3.22, 4.13],
      "10-mid": "4.34",
      "10-bound": [3.83, 4.92],
      "25-mid": "5.34",
      "25-bound": [4.67, 6.04],
      "50-mid": "6.24",
      "50-bound": [5.4, 7.06],
      "100-mid": "7.22",
      "100-bound": [6.17, 8.17]
    },
    "24hr": {
      "2-mid": "3.28",
      "2-bound": [2.98, 3.64],
      "5-mid": "4.25",
      "5-bound": [3.86, 4.72],
      "10-mid": "5.09",
      "10-bound": [4.61, 5.65],
      "25-mid": "6.38",
      "25-bound": [5.74, 7.05],
      "50-mid": "7.51",
      "50-bound": [6.71, 8.27],
      "100-mid": "8.79",
      "100-bound": [7.78, 9.65]
    },
    "2day": {
      "2-mid": "3.79",
      "2-bound": [3.49, 4.19],
      "5-mid": "4.93",
      "5-bound": [4.52, 5.43],
      "10-mid": "5.9",
      "10-bound": [5.38, 6.49],
      "25-mid": "7.36",
      "25-bound": [6.68, 8.08],
      "50-mid": "8.64",
      "50-bound": [7.78, 9.46],
      "100-mid": "10.1",
      "100-bound": [9.0, 11.0]
    },
    "3day": {
      "2-mid": "4.02",
      "2-bound": [3.7, 4.42],
      "5-mid": "5.2",
      "5-bound": [4.77, 5.7],
      "10-mid": "6.2",
      "10-bound": [5.67, 6.79],
      "25-mid": "7.71",
      "25-bound": [7.0, 8.42],
      "50-mid": "9.01",
      "50-bound": [8.14, 9.84],
      "100-mid": "10.5",
      "100-bound": [9.39, 11.4]
    },
    "4day": {
      "2-mid": "4.25",
      "2-bound": [3.91, 4.65],
      "5-mid": "5.47",
      "5-bound": [5.02, 5.98],
      "10-mid": "6.5",
      "10-bound": [5.95, 7.1],
      "25-mid": "8.05",
      "25-bound": [7.33, 8.77],
      "50-mid": "9.39",
      "50-bound": [8.49, 10.2],
      "100-mid": "10.9",
      "100-bound": [9.77, 11.8]
    },
    "7day": {
      "2-mid": "4.88",
      "2-bound": [4.53, 5.31],
      "5-mid": "6.18",
      "5-bound": [5.73, 6.71],
      "10-mid": "7.28",
      "10-bound": [6.73, 7.9],
      "25-mid": "8.91",
      "25-bound": [8.19, 9.66],
      "50-mid": "10.3",
      "50-bound": [9.42, 11.2],
      "100-mid": "11.8",
      "100-bound": [10.7, 12.8]
    }
  },
  "USC00361920 6": {
    "fips": "42041",
    "station_name": "CARLISLE WATER PLANT",
    "state": "PA",
    "latitude": "40.2250",
    "longitude": "-77.1890",
    "5min": {
      "2-mid": "0.38",
      "2-bound": [0.34, 0.43],
      "5-mid": "0.46",
      "5-bound": [0.41, 0.52],
      "10-mid": "0.52",
      "10-bound": [0.46, 0.58],
      "25-mid": "0.59",
      "25-bound": [0.52, 0.67],
      "50-mid": "0.65",
      "50-bound": [0.57, 0.73],
      "100-mid": "0.71",
      "100-bound": [0.62, 0.8]
    },
    "10min": {
      "2-mid": "0.6",
      "2-bound": [0.53, 0.68],
      "5-mid": "0.72",
      "5-bound": [0.64, 0.81],
      "10-mid": "0.81",
      "10-bound": [0.71, 0.91],
      "25-mid": "0.93",
      "25-bound": [0.81, 1.04],
      "50-mid": "1.01",
      "50-bound": [0.89, 1.14],
      "100-mid": "1.11",
      "100-bound": [0.97, 1.24]
    },
    "15min": {
      "2-mid": "0.75",
      "2-bound": [0.66, 0.84],
      "5-mid": "0.9",
      "5-bound": [0.8, 1.01],
      "10-mid": "1.01",
      "10-bound": [0.89, 1.14],
      "25-mid": "1.16",
      "25-bound": [1.02, 1.3],
      "50-mid": "1.27",
      "50-bound": [1.11, 1.42],
      "100-mid": "1.39",
      "100-bound": [1.21, 1.55]
    },
    "30min": {
      "2-mid": "1.02",
      "2-bound": [0.9, 1.15],
      "5-mid": "1.25",
      "5-bound": [1.11, 1.42],
      "10-mid": "1.43",
      "10-bound": [1.27, 1.61],
      "25-mid": "1.67",
      "25-bound": [1.47, 1.88],
      "50-mid": "1.86",
      "50-bound": [1.63, 2.09],
      "100-mid": "2.06",
      "100-bound": [1.8, 2.31]
    },
    "60min": {
      "2-mid": "1.26",
      "2-bound": [1.12, 1.43],
      "5-mid": "1.59",
      "5-bound": [1.41, 1.8],
      "10-mid": "1.85",
      "10-bound": [1.63, 2.08],
      "25-mid": "2.2",
      "25-bound": [1.94, 2.47],
      "50-mid": "2.49",
      "50-bound": [2.18, 2.8],
      "100-mid": "2.8",
      "100-bound": [2.45, 3.14]
    },
    "2hr": {
      "2-mid": "1.44",
      "2-bound": [1.28, 1.63],
      "5-mid": "1.83",
      "5-bound": [1.62, 2.06],
      "10-mid": "2.14",
      "10-bound": [1.89, 2.41],
      "25-mid": "2.62",
      "25-bound": [2.3, 2.93],
      "50-mid": "3.03",
      "50-bound": [2.64, 3.39],
      "100-mid": "3.49",
      "100-bound": [3.03, 3.9]
    },
    "3hr": {
      "2-mid": "1.56",
      "2-bound": [1.38, 1.78],
      "5-mid": "1.97",
      "5-bound": [1.75, 2.24],
      "10-mid": "2.31",
      "10-bound": [2.04, 2.62],
      "25-mid": "2.82",
      "25-bound": [2.47, 3.18],
      "50-mid": "3.26",
      "50-bound": [2.84, 3.68],
      "100-mid": "3.76",
      "100-bound": [3.26, 4.23]
    },
    "6hr": {
      "2-mid": "1.93",
      "2-bound": [1.72, 2.19],
      "5-mid": "2.41",
      "5-bound": [2.14, 2.74],
      "10-mid": "2.82",
      "10-bound": [2.5, 3.19],
      "25-mid": "3.44",
      "25-bound": [3.03, 3.88],
      "50-mid": "3.99",
      "50-bound": [3.48, 4.48],
      "100-mid": "4.61",
      "100-bound": [4.0, 5.16]
    },
    "12hr": {
      "2-mid": "2.37",
      "2-bound": [2.1, 2.7],
      "5-mid": "2.96",
      "5-bound": [2.61, 3.36],
      "10-mid": "3.47",
      "10-bound": [3.05, 3.93],
      "25-mid": "4.25",
      "25-bound": [3.71, 4.8],
      "50-mid": "4.96",
      "50-bound": [4.3, 5.57],
      "100-mid": "5.77",
      "100-bound": [4.96, 6.47]
    },
    "24hr": {
      "2-mid": "2.83",
      "2-bound": [2.6, 3.12],
      "5-mid": "3.52",
      "5-bound": [3.23, 3.87],
      "10-mid": "4.13",
      "10-bound": [3.77, 4.53],
      "25-mid": "5.1",
      "25-bound": [4.61, 5.56],
      "50-mid": "5.99",
      "50-bound": [5.37, 6.5],
      "100-mid": "7.04",
      "100-bound": [6.26, 7.6]
    },
    "2day": {
      "2-mid": "3.27",
      "2-bound": [2.98, 3.64],
      "5-mid": "4.06",
      "5-bound": [3.69, 4.51],
      "10-mid": "4.76",
      "10-bound": [4.31, 5.27],
      "25-mid": "5.86",
      "25-bound": [5.28, 6.47],
      "50-mid": "6.89",
      "50-bound": [6.15, 7.57],
      "100-mid": "8.1",
      "100-bound": [7.17, 8.87]
    },
    "3day": {
      "2-mid": "3.47",
      "2-bound": [3.18, 3.85],
      "5-mid": "4.29",
      "5-bound": [3.92, 4.75],
      "10-mid": "5.02",
      "10-bound": [4.56, 5.54],
      "25-mid": "6.16",
      "25-bound": [5.57, 6.77],
      "50-mid": "7.22",
      "50-bound": [6.48, 7.91],
      "100-mid": "8.46",
      "100-bound": [7.53, 9.24]
    },
    "4day": {
      "2-mid": "3.68",
      "2-bound": [3.38, 4.06],
      "5-mid": "4.53",
      "5-bound": [4.15, 4.99],
      "10-mid": "5.28",
      "10-bound": [4.82, 5.8],
      "25-mid": "6.46",
      "25-bound": [5.87, 7.07],
      "50-mid": "7.55",
      "50-bound": [6.8, 8.24],
      "100-mid": "8.82",
      "100-bound": [7.89, 9.61]
    },
    "7day": {
      "2-mid": "4.29",
      "2-bound": [3.96, 4.72],
      "5-mid": "5.24",
      "5-bound": [4.83, 5.75],
      "10-mid": "6.07",
      "10-bound": [5.58, 6.66],
      "25-mid": "7.37",
      "25-bound": [6.73, 8.06],
      "50-mid": "8.56",
      "50-bound": [7.75, 9.33],
      "100-mid": "9.93",
      "100-bound": [8.93, 10.8]
    }
  },
  "USC00300343 6": {
    "fips": "36051",
    "station_name": "AVON",
    "state": "NY",
    "latitude": "42.9200",
    "longitude": "-77.7550",
    "5min": {
      "2-mid": "0.32",
      "2-bound": [0.25, 0.4],
      "5-mid": "0.41",
      "5-bound": [0.32, 0.52],
      "10-mid": "0.49",
      "10-bound": [0.38, 0.62],
      "25-mid": "0.59",
      "25-bound": [0.45, 0.78],
      "50-mid": "0.67",
      "50-bound": [0.5, 0.91],
      "100-mid": "0.76",
      "100-bound": [0.55, 1.05]
    },
    "10min": {
      "2-mid": "0.45",
      "2-bound": [0.35, 0.56],
      "5-mid": "0.58",
      "5-bound": [0.46, 0.73],
      "10-mid": "0.69",
      "10-bound": [0.54, 0.88],
      "25-mid": "0.84",
      "25-bound": [0.64, 1.11],
      "50-mid": "0.95",
      "50-bound": [0.71, 1.28],
      "100-mid": "1.07",
      "100-bound": [0.77, 1.49]
    },
    "15min": {
      "2-mid": "0.52",
      "2-bound": [0.41, 0.66],
      "5-mid": "0.68",
      "5-bound": [0.54, 0.86],
      "10-mid": "0.81",
      "10-bound": [0.63, 1.03],
      "25-mid": "0.99",
      "25-bound": [0.75, 1.31],
      "50-mid": "1.12",
      "50-bound": [0.83, 1.51],
      "100-mid": "1.26",
      "100-bound": [0.91, 1.76]
    },
    "30min": {
      "2-mid": "0.74",
      "2-bound": [0.59, 0.94],
      "5-mid": "0.96",
      "5-bound": [0.76, 1.22],
      "10-mid": "1.14",
      "10-bound": [0.89, 1.46],
      "25-mid": "1.39",
      "25-bound": [1.05, 1.84],
      "50-mid": "1.58",
      "50-bound": [1.17, 2.12],
      "100-mid": "1.77",
      "100-bound": [1.28, 2.46]
    },
    "60min": {
      "2-mid": "0.96",
      "2-bound": [0.76, 1.22],
      "5-mid": "1.24",
      "5-bound": [0.98, 1.58],
      "10-mid": "1.47",
      "10-bound": [1.15, 1.88],
      "25-mid": "1.79",
      "25-bound": [1.36, 2.37],
      "50-mid": "2.03",
      "50-bound": [1.51, 2.73],
      "100-mid": "2.28",
      "100-bound": [1.65, 3.18]
    },
    "2hr": {
      "2-mid": "1.18",
      "2-bound": [0.94, 1.48],
      "5-mid": "1.51",
      "5-bound": [1.2, 1.89],
      "10-mid": "1.78",
      "10-bound": [1.41, 2.24],
      "25-mid": "2.15",
      "25-bound": [1.65, 2.81],
      "50-mid": "2.43",
      "50-bound": [1.82, 3.23],
      "100-mid": "2.73",
      "100-bound": [1.99, 3.74]
    },
    "3hr": {
      "2-mid": "1.31",
      "2-bound": [1.06, 1.64],
      "5-mid": "1.67",
      "5-bound": [1.34, 2.08],
      "10-mid": "1.96",
      "10-bound": [1.56, 2.46],
      "25-mid": "2.37",
      "25-bound": [1.82, 3.07],
      "50-mid": "2.67",
      "50-bound": [2.01, 3.52],
      "100-mid": "2.99",
      "100-bound": [2.19, 4.06]
    },
    "6hr": {
      "2-mid": "1.56",
      "2-bound": [1.26, 1.92],
      "5-mid": "1.96",
      "5-bound": [1.58, 2.42],
      "10-mid": "2.29",
      "10-bound": [1.84, 2.84],
      "25-mid": "2.75",
      "25-bound": [2.14, 3.52],
      "50-mid": "3.09",
      "50-bound": [2.36, 4.03],
      "100-mid": "3.45",
      "100-bound": [2.56, 4.64]
    },
    "12hr": {
      "2-mid": "1.83",
      "2-bound": [1.5, 2.23],
      "5-mid": "2.28",
      "5-bound": [1.87, 2.79],
      "10-mid": "2.66",
      "10-bound": [2.16, 3.26],
      "25-mid": "3.18",
      "25-bound": [2.5, 4.02],
      "50-mid": "3.56",
      "50-bound": [2.75, 4.59],
      "100-mid": "3.97",
      "100-bound": [2.98, 5.27]
    },
    "24hr": {
      "2-mid": "2.15",
      "2-bound": [1.78, 2.59],
      "5-mid": "2.66",
      "5-bound": [2.2, 3.21],
      "10-mid": "3.08",
      "10-bound": [2.53, 3.74],
      "25-mid": "3.67",
      "25-bound": [2.92, 4.59],
      "50-mid": "4.11",
      "50-bound": [3.2, 5.22],
      "100-mid": "4.57",
      "100-bound": [3.47, 5.97]
    },
    "2day": {
      "2-mid": "2.51",
      "2-bound": [2.1, 3.0],
      "5-mid": "3.09",
      "5-bound": [2.58, 3.69],
      "10-mid": "3.57",
      "10-bound": [2.96, 4.28],
      "25-mid": "4.23",
      "25-bound": [3.4, 5.22],
      "50-mid": "4.72",
      "50-bound": [3.72, 5.91],
      "100-mid": "5.24",
      "100-bound": [4.01, 6.73]
    },
    "3day": {
      "2-mid": "2.76",
      "2-bound": [2.33, 3.27],
      "5-mid": "3.37",
      "5-bound": [2.83, 4.0],
      "10-mid": "3.88",
      "10-bound": [3.24, 4.62],
      "25-mid": "4.57",
      "25-bound": [3.7, 5.59],
      "50-mid": "5.09",
      "50-bound": [4.04, 6.32],
      "100-mid": "5.64",
      "100-bound": [4.34, 7.17]
    },
    "4day": {
      "2-mid": "2.97",
      "2-bound": [2.51, 3.5],
      "5-mid": "3.6",
      "5-bound": [3.04, 4.26],
      "10-mid": "4.13",
      "10-bound": [3.46, 4.9],
      "25-mid": "4.85",
      "25-bound": [3.94, 5.9],
      "50-mid": "5.4",
      "50-bound": [4.3, 6.66],
      "100-mid": "5.96",
      "100-bound": [4.61, 7.53]
    },
    "7day": {
      "2-mid": "3.5",
      "2-bound": [2.99, 4.1],
      "5-mid": "4.21",
      "5-bound": [3.58, 4.93],
      "10-mid": "4.79",
      "10-bound": [4.06, 5.63],
      "25-mid": "5.59",
      "25-bound": [4.58, 6.73],
      "50-mid": "6.2",
      "50-bound": [4.98, 7.56],
      "100-mid": "6.83",
      "100-bound": [5.32, 8.5]
    }
  },
  "USW00014751 6": {
    "fips": "42133",
    "station_name": "HARRISBURG CAPITAL CITY AP",
    "state": "PA",
    "latitude": "40.2172",
    "longitude": "-76.8513",
    "5min": {
      "2-mid": "0.38",
      "2-bound": [0.34, 0.43],
      "5-mid": "0.45",
      "5-bound": [0.41, 0.5],
      "10-mid": "0.5",
      "10-bound": [0.45, 0.56],
      "25-mid": "0.56",
      "25-bound": [0.5, 0.62],
      "50-mid": "0.61",
      "50-bound": [0.54, 0.67],
      "100-mid": "0.65",
      "100-bound": [0.58, 0.72]
    },
    "10min": {
      "2-mid": "0.61",
      "2-bound": [0.55, 0.68],
      "5-mid": "0.72",
      "5-bound": [0.65, 0.8],
      "10-mid": "0.8",
      "10-bound": [0.71, 0.89],
      "25-mid": "0.9",
      "25-bound": [0.8, 0.99],
      "50-mid": "0.97",
      "50-bound": [0.86, 1.07],
      "100-mid": "1.04",
      "100-bound": [0.92, 1.15]
    },
    "15min": {
      "2-mid": "0.77",
      "2-bound": [0.69, 0.85],
      "5-mid": "0.91",
      "5-bound": [0.82, 1.01],
      "10-mid": "1.01",
      "10-bound": [0.9, 1.12],
      "25-mid": "1.13",
      "25-bound": [1.01, 1.26],
      "50-mid": "1.22",
      "50-bound": [1.09, 1.35],
      "100-mid": "1.31",
      "100-bound": [1.16, 1.45]
    },
    "30min": {
      "2-mid": "1.06",
      "2-bound": [0.95, 1.18],
      "5-mid": "1.29",
      "5-bound": [1.16, 1.44],
      "10-mid": "1.46",
      "10-bound": [1.31, 1.62],
      "25-mid": "1.68",
      "25-bound": [1.49, 1.86],
      "50-mid": "1.84",
      "50-bound": [1.63, 2.03],
      "100-mid": "2.0",
      "100-bound": [1.77, 2.21]
    },
    "60min": {
      "2-mid": "1.32",
      "2-bound": [1.19, 1.47],
      "5-mid": "1.65",
      "5-bound": [1.48, 1.84],
      "10-mid": "1.9",
      "10-bound": [1.7, 2.11],
      "25-mid": "2.23",
      "25-bound": [1.98, 2.47],
      "50-mid": "2.48",
      "50-bound": [2.21, 2.75],
      "100-mid": "2.75",
      "100-bound": [2.43, 3.04]
    },
    "2hr": {
      "2-mid": "1.53",
      "2-bound": [1.38, 1.71],
      "5-mid": "1.94",
      "5-bound": [1.74, 2.15],
      "10-mid": "2.26",
      "10-bound": [2.03, 2.51],
      "25-mid": "2.73",
      "25-bound": [2.43, 3.02],
      "50-mid": "3.12",
      "50-bound": [2.77, 3.44],
      "100-mid": "3.55",
      "100-bound": [3.12, 3.91]
    },
    "3hr": {
      "2-mid": "1.67",
      "2-bound": [1.51, 1.87],
      "5-mid": "2.12",
      "5-bound": [1.91, 2.36],
      "10-mid": "2.48",
      "10-bound": [2.22, 2.75],
      "25-mid": "2.99",
      "25-bound": [2.66, 3.31],
      "50-mid": "3.42",
      "50-bound": [3.03, 3.78],
      "100-mid": "3.88",
      "100-bound": [3.42, 4.29]
    },
    "6hr": {
      "2-mid": "2.06",
      "2-bound": [1.85, 2.32],
      "5-mid": "2.6",
      "5-bound": [2.33, 2.91],
      "10-mid": "3.04",
      "10-bound": [2.72, 3.4],
      "25-mid": "3.7",
      "25-bound": [3.28, 4.12],
      "50-mid": "4.27",
      "50-bound": [3.76, 4.74],
      "100-mid": "4.9",
      "100-bound": [4.28, 5.43]
    },
    "12hr": {
      "2-mid": "2.5",
      "2-bound": [2.22, 2.86],
      "5-mid": "3.17",
      "5-bound": [2.8, 3.62],
      "10-mid": "3.74",
      "10-bound": [3.3, 4.25],
      "25-mid": "4.6",
      "25-bound": [4.03, 5.21],
      "50-mid": "5.36",
      "50-bound": [4.65, 6.06],
      "100-mid": "6.22",
      "100-bound": [5.34, 7.02]
    },
    "24hr": {
      "2-mid": "2.9",
      "2-bound": [2.67, 3.19],
      "5-mid": "3.67",
      "5-bound": [3.38, 4.05],
      "10-mid": "4.36",
      "10-bound": [3.99, 4.79],
      "25-mid": "5.43",
      "25-bound": [4.92, 5.94],
      "50-mid": "6.38",
      "50-bound": [5.74, 6.96],
      "100-mid": "7.48",
      "100-bound": [6.67, 8.13]
    },
    "2day": {
      "2-mid": "3.35",
      "2-bound": [3.06, 3.74],
      "5-mid": "4.24",
      "5-bound": [3.87, 4.74],
      "10-mid": "5.02",
      "10-bound": [4.56, 5.59],
      "25-mid": "6.21",
      "25-bound": [5.59, 6.88],
      "50-mid": "7.26",
      "50-bound": [6.48, 8.04],
      "100-mid": "8.45",
      "100-bound": [7.49, 9.34]
    },
    "3day": {
      "2-mid": "3.56",
      "2-bound": [3.26, 3.96],
      "5-mid": "4.5",
      "5-bound": [4.11, 5.0],
      "10-mid": "5.32",
      "10-bound": [4.84, 5.9],
      "25-mid": "6.56",
      "25-bound": [5.93, 7.25],
      "50-mid": "7.67",
      "50-bound": [6.88, 8.46],
      "100-mid": "8.92",
      "100-bound": [7.93, 9.82]
    },
    "4day": {
      "2-mid": "3.78",
      "2-bound": [3.46, 4.18],
      "5-mid": "4.76",
      "5-bound": [4.36, 5.27],
      "10-mid": "5.62",
      "10-bound": [5.12, 6.2],
      "25-mid": "6.92",
      "25-bound": [6.27, 7.62],
      "50-mid": "8.08",
      "50-bound": [7.27, 8.88],
      "100-mid": "9.39",
      "100-bound": [8.38, 10.3]
    },
    "7day": {
      "2-mid": "4.41",
      "2-bound": [4.07, 4.85],
      "5-mid": "5.5",
      "5-bound": [5.07, 6.04],
      "10-mid": "6.45",
      "10-bound": [5.92, 7.07],
      "25-mid": "7.88",
      "25-bound": [7.19, 8.63],
      "50-mid": "9.15",
      "50-bound": [8.29, 9.99],
      "100-mid": "10.6",
      "100-bound": [9.5, 11.5]
    }
  },
  "USW00013752 6": {
    "fips": "24003",
    "station_name": "ANNAPOLIS UNITED STATES NAVAL ACADEMY ASOS",
    "state": "MD",
    "latitude": "38.9910",
    "longitude": "-76.4890",
    "5min": {
      "2-mid": "0.42",
      "2-bound": [0.38, 0.46],
      "5-mid": "0.5",
      "5-bound": [0.45, 0.55],
      "10-mid": "0.55",
      "10-bound": [0.5, 0.61],
      "25-mid": "0.62",
      "25-bound": [0.56, 0.69],
      "50-mid": "0.68",
      "50-bound": [0.6, 0.75],
      "100-mid": "0.73",
      "100-bound": [0.65, 0.81]
    },
    "10min": {
      "2-mid": "0.67",
      "2-bound": [0.6, 0.73],
      "5-mid": "0.79",
      "5-bound": [0.72, 0.88],
      "10-mid": "0.88",
      "10-bound": [0.8, 0.98],
      "25-mid": "1.0",
      "25-bound": [0.89, 1.1],
      "50-mid": "1.08",
      "50-bound": [0.96, 1.2],
      "100-mid": "1.16",
      "100-bound": [1.03, 1.29]
    },
    "15min": {
      "2-mid": "0.84",
      "2-bound": [0.76, 0.92],
      "5-mid": "1.0",
      "5-bound": [0.91, 1.11],
      "10-mid": "1.12",
      "10-bound": [1.01, 1.24],
      "25-mid": "1.26",
      "25-bound": [1.13, 1.4],
      "50-mid": "1.37",
      "50-bound": [1.22, 1.51],
      "100-mid": "1.47",
      "100-bound": [1.3, 1.63]
    },
    "30min": {
      "2-mid": "1.16",
      "2-bound": [1.05, 1.28],
      "5-mid": "1.43",
      "5-bound": [1.29, 1.58],
      "10-mid": "1.62",
      "10-bound": [1.46, 1.79],
      "25-mid": "1.87",
      "25-bound": [1.67, 2.07],
      "50-mid": "2.06",
      "50-bound": [1.84, 2.28],
      "100-mid": "2.25",
      "100-bound": [2.0, 2.5]
    },
    "60min": {
      "2-mid": "1.45",
      "2-bound": [1.31, 1.6],
      "5-mid": "1.83",
      "5-bound": [1.65, 2.02],
      "10-mid": "2.11",
      "10-bound": [1.9, 2.33],
      "25-mid": "2.49",
      "25-bound": [2.23, 2.75],
      "50-mid": "2.79",
      "50-bound": [2.49, 3.09],
      "100-mid": "3.1",
      "100-bound": [2.75, 3.44]
    },
    "2hr": {
      "2-mid": "1.72",
      "2-bound": [1.56, 1.9],
      "5-mid": "2.17",
      "5-bound": [1.96, 2.4],
      "10-mid": "2.53",
      "10-bound": [2.28, 2.79],
      "25-mid": "3.02",
      "25-bound": [2.71, 3.33],
      "50-mid": "3.43",
      "50-bound": [3.05, 3.78],
      "100-mid": "3.85",
      "100-bound": [3.4, 4.26]
    },
    "3hr": {
      "2-mid": "1.86",
      "2-bound": [1.68, 2.06],
      "5-mid": "2.36",
      "5-bound": [2.13, 2.6],
      "10-mid": "2.75",
      "10-bound": [2.47, 3.04],
      "25-mid": "3.31",
      "25-bound": [2.96, 3.65],
      "50-mid": "3.77",
      "50-bound": [3.35, 4.17],
      "100-mid": "4.26",
      "100-bound": [3.75, 4.72]
    },
    "6hr": {
      "2-mid": "2.29",
      "2-bound": [2.08, 2.53],
      "5-mid": "2.89",
      "5-bound": [2.62, 3.2],
      "10-mid": "3.39",
      "10-bound": [3.05, 3.75],
      "25-mid": "4.12",
      "25-bound": [3.68, 4.56],
      "50-mid": "4.74",
      "50-bound": [4.2, 5.25],
      "100-mid": "5.42",
      "100-bound": [4.75, 6.02]
    },
    "12hr": {
      "2-mid": "2.76",
      "2-bound": [2.48, 3.11],
      "5-mid": "3.51",
      "5-bound": [3.14, 3.95],
      "10-mid": "4.16",
      "10-bound": [3.7, 4.67],
      "25-mid": "5.14",
      "25-bound": [4.53, 5.77],
      "50-mid": "6.0",
      "50-bound": [5.24, 6.74],
      "100-mid": "6.97",
      "100-bound": [6.0, 7.84]
    },
    "24hr": {
      "2-mid": "3.23",
      "2-bound": [2.92, 3.65],
      "5-mid": "4.19",
      "5-bound": [3.77, 4.72],
      "10-mid": "5.02",
      "10-bound": [4.5, 5.64],
      "25-mid": "6.28",
      "25-bound": [5.6, 7.03],
      "50-mid": "7.4",
      "50-bound": [6.54, 8.25],
      "100-mid": "8.66",
      "100-bound": [7.59, 9.62]
    },
    "2day": {
      "2-mid": "3.74",
      "2-bound": [3.38, 4.19],
      "5-mid": "4.84",
      "5-bound": [4.37, 5.42],
      "10-mid": "5.79",
      "10-bound": [5.2, 6.46],
      "25-mid": "7.21",
      "25-bound": [6.45, 8.03],
      "50-mid": "8.46",
      "50-bound": [7.51, 9.39],
      "100-mid": "9.85",
      "100-bound": [8.68, 10.9]
    },
    "3day": {
      "2-mid": "3.94",
      "2-bound": [3.58, 4.4],
      "5-mid": "5.08",
      "5-bound": [4.61, 5.67],
      "10-mid": "6.06",
      "10-bound": [5.48, 6.74],
      "25-mid": "7.53",
      "25-bound": [6.76, 8.35],
      "50-mid": "8.8",
      "50-bound": [7.86, 9.74],
      "100-mid": "10.2",
      "100-bound": [9.06, 11.3]
    },
    "4day": {
      "2-mid": "4.15",
      "2-bound": [3.79, 4.61],
      "5-mid": "5.32",
      "5-bound": [4.85, 5.92],
      "10-mid": "6.33",
      "10-bound": [5.75, 7.02],
      "25-mid": "7.84",
      "25-bound": [7.08, 8.67],
      "50-mid": "9.15",
      "50-bound": [8.21, 10.1],
      "100-mid": "10.6",
      "100-bound": [9.43, 11.7]
    },
    "7day": {
      "2-mid": "4.79",
      "2-bound": [4.37, 5.29],
      "5-mid": "6.06",
      "5-bound": [5.52, 6.69],
      "10-mid": "7.15",
      "10-bound": [6.49, 7.88],
      "25-mid": "8.75",
      "25-bound": [7.89, 9.61],
      "50-mid": "10.1",
      "50-bound": [9.09, 11.1],
      "100-mid": "11.6",
      "100-bound": [10.4, 12.8]
    }
  },
  "USC00304174 6": {
    "fips": "36109",
    "station_name": "ITHACA CORNELL UNIV",
    "state": "NY",
    "latitude": "42.4491",
    "longitude": "-76.4490",
    "5min": {
      "2-mid": "0.36",
      "2-bound": [0.29, 0.44],
      "5-mid": "0.47",
      "5-bound": [0.38, 0.57],
      "10-mid": "0.56",
      "10-bound": [0.45, 0.69],
      "25-mid": "0.68",
      "25-bound": [0.53, 0.88],
      "50-mid": "0.77",
      "50-bound": [0.58, 1.03],
      "100-mid": "0.87",
      "100-bound": [0.63, 1.21]
    },
    "10min": {
      "2-mid": "0.51",
      "2-bound": [0.41, 0.62],
      "5-mid": "0.66",
      "5-bound": [0.54, 0.81],
      "10-mid": "0.79",
      "10-bound": [0.63, 0.97],
      "25-mid": "0.96",
      "25-bound": [0.74, 1.25],
      "50-mid": "1.09",
      "50-bound": [0.82, 1.45],
      "100-mid": "1.23",
      "100-bound": [0.9, 1.71]
    },
    "15min": {
      "2-mid": "0.6",
      "2-bound": [0.49, 0.73],
      "5-mid": "0.78",
      "5-bound": [0.63, 0.95],
      "10-mid": "0.93",
      "10-bound": [0.75, 1.14],
      "25-mid": "1.13",
      "25-bound": [0.88, 1.47],
      "50-mid": "1.29",
      "50-bound": [0.97, 1.71],
      "100-mid": "1.45",
      "100-bound": [1.06, 2.01]
    },
    "30min": {
      "2-mid": "0.82",
      "2-bound": [0.66, 1.0],
      "5-mid": "1.06",
      "5-bound": [0.86, 1.3],
      "10-mid": "1.26",
      "10-bound": [1.01, 1.56],
      "25-mid": "1.54",
      "25-bound": [1.19, 2.0],
      "50-mid": "1.75",
      "50-bound": [1.32, 2.33],
      "100-mid": "1.97",
      "100-bound": [1.44, 2.74]
    },
    "60min": {
      "2-mid": "1.04",
      "2-bound": [0.84, 1.26],
      "5-mid": "1.34",
      "5-bound": [1.09, 1.64],
      "10-mid": "1.6",
      "10-bound": [1.28, 1.97],
      "25-mid": "1.95",
      "25-bound": [1.51, 2.53],
      "50-mid": "2.22",
      "50-bound": [1.67, 2.94],
      "100-mid": "2.49",
      "100-bound": [1.82, 3.46]
    },
    "2hr": {
      "2-mid": "1.27",
      "2-bound": [1.03, 1.53],
      "5-mid": "1.61",
      "5-bound": [1.31, 1.95],
      "10-mid": "1.89",
      "10-bound": [1.52, 2.31],
      "25-mid": "2.28",
      "25-bound": [1.77, 2.94],
      "50-mid": "2.57",
      "50-bound": [1.95, 3.4],
      "100-mid": "2.88",
      "100-bound": [2.11, 3.98]
    },
    "3hr": {
      "2-mid": "1.42",
      "2-bound": [1.16, 1.71],
      "5-mid": "1.79",
      "5-bound": [1.46, 2.16],
      "10-mid": "2.09",
      "10-bound": [1.69, 2.55],
      "25-mid": "2.51",
      "25-bound": [1.96, 3.23],
      "50-mid": "2.82",
      "50-bound": [2.15, 3.73],
      "100-mid": "3.16",
      "100-bound": [2.33, 4.37]
    },
    "6hr": {
      "2-mid": "1.72",
      "2-bound": [1.42, 2.06],
      "5-mid": "2.18",
      "5-bound": [1.79, 2.62],
      "10-mid": "2.56",
      "10-bound": [2.08, 3.09],
      "25-mid": "3.08",
      "25-bound": [2.41, 3.93],
      "50-mid": "3.46",
      "50-bound": [2.65, 4.54],
      "100-mid": "3.88",
      "100-bound": [2.88, 5.34]
    },
    "12hr": {
      "2-mid": "2.08",
      "2-bound": [1.73, 2.48],
      "5-mid": "2.69",
      "5-bound": [2.22, 3.21],
      "10-mid": "3.19",
      "10-bound": [2.62, 3.83],
      "25-mid": "3.88",
      "25-bound": [3.06, 4.93],
      "50-mid": "4.39",
      "50-bound": [3.38, 5.73],
      "100-mid": "4.94",
      "100-bound": [3.69, 6.76]
    },
    "24hr": {
      "2-mid": "2.47",
      "2-bound": [2.06, 2.91],
      "5-mid": "3.22",
      "5-bound": [2.67, 3.81],
      "10-mid": "3.84",
      "10-bound": [3.17, 4.58],
      "25-mid": "4.69",
      "25-bound": [3.72, 5.92],
      "50-mid": "5.32",
      "50-bound": [4.12, 6.9],
      "100-mid": "6.01",
      "100-bound": [4.5, 8.17]
    },
    "2day": {
      "2-mid": "2.84",
      "2-bound": [2.38, 3.33],
      "5-mid": "3.68",
      "5-bound": [3.08, 4.33],
      "10-mid": "4.38",
      "10-bound": [3.64, 5.19],
      "25-mid": "5.34",
      "25-bound": [4.26, 6.69],
      "50-mid": "6.05",
      "50-bound": [4.71, 7.79],
      "100-mid": "6.82",
      "100-bound": [5.14, 9.21]
    },
    "3day": {
      "2-mid": "3.09",
      "2-bound": [2.6, 3.61],
      "5-mid": "3.98",
      "5-bound": [3.34, 4.67],
      "10-mid": "4.72",
      "10-bound": [3.94, 5.57],
      "25-mid": "5.74",
      "25-bound": [4.6, 7.17],
      "50-mid": "6.49",
      "50-bound": [5.08, 8.33],
      "100-mid": "7.31",
      "100-bound": [5.52, 9.83]
    },
    "4day": {
      "2-mid": "3.3",
      "2-bound": [2.79, 3.85],
      "5-mid": "4.23",
      "5-bound": [3.56, 4.95],
      "10-mid": "5.0",
      "10-bound": [4.18, 5.88],
      "25-mid": "6.06",
      "25-bound": [4.86, 7.54],
      "50-mid": "6.84",
      "50-bound": [5.36, 8.74],
      "100-mid": "7.69",
      "100-bound": [5.82, 10.3]
    },
    "7day": {
      "2-mid": "3.87",
      "2-bound": [3.29, 4.48],
      "5-mid": "4.86",
      "5-bound": [4.11, 5.65],
      "10-mid": "5.67",
      "10-bound": [4.76, 6.64],
      "25-mid": "6.79",
      "25-bound": [5.48, 8.39],
      "50-mid": "7.63",
      "50-bound": [5.99, 9.67],
      "100-mid": "8.53",
      "100-bound": [6.46, 11.3]
    }
  },
  "USC00466867 6": {
    "fips": "54093",
    "station_name": "PARSONS 3 SE",
    "state": "WV",
    "latitude": "39.0730",
    "longitude": "-79.6300",
    "5min": {
      "2-mid": "0.36",
      "2-bound": [0.32, 0.4],
      "5-mid": "0.42",
      "5-bound": [0.38, 0.47],
      "10-mid": "0.48",
      "10-bound": [0.43, 0.54],
      "25-mid": "0.56",
      "25-bound": [0.49, 0.62],
      "50-mid": "0.62",
      "50-bound": [0.54, 0.69],
      "100-mid": "0.68",
      "100-bound": [0.59, 0.75]
    },
    "10min": {
      "2-mid": "0.56",
      "2-bound": [0.5, 0.63],
      "5-mid": "0.67",
      "5-bound": [0.6, 0.75],
      "10-mid": "0.76",
      "10-bound": [0.67, 0.84],
      "25-mid": "0.86",
      "25-bound": [0.77, 0.96],
      "50-mid": "0.95",
      "50-bound": [0.84, 1.06],
      "100-mid": "1.04",
      "100-bound": [0.91, 1.15]
    },
    "15min": {
      "2-mid": "0.69",
      "2-bound": [0.62, 0.78],
      "5-mid": "0.83",
      "5-bound": [0.74, 0.93],
      "10-mid": "0.94",
      "10-bound": [0.83, 1.05],
      "25-mid": "1.08",
      "25-bound": [0.95, 1.2],
      "50-mid": "1.19",
      "50-bound": [1.05, 1.32],
      "100-mid": "1.3",
      "100-bound": [1.14, 1.44]
    },
    "30min": {
      "2-mid": "0.94",
      "2-bound": [0.84, 1.05],
      "5-mid": "1.15",
      "5-bound": [1.03, 1.29],
      "10-mid": "1.32",
      "10-bound": [1.18, 1.48],
      "25-mid": "1.55",
      "25-bound": [1.37, 1.73],
      "50-mid": "1.73",
      "50-bound": [1.52, 1.93],
      "100-mid": "1.92",
      "100-bound": [1.68, 2.13]
    },
    "60min": {
      "2-mid": "1.16",
      "2-bound": [1.04, 1.3],
      "5-mid": "1.45",
      "5-bound": [1.3, 1.63],
      "10-mid": "1.7",
      "10-bound": [1.51, 1.9],
      "25-mid": "2.03",
      "25-bound": [1.8, 2.26],
      "50-mid": "2.31",
      "50-bound": [2.03, 2.56],
      "100-mid": "2.59",
      "100-bound": [2.27, 2.88]
    },
    "2hr": {
      "2-mid": "1.37",
      "2-bound": [1.23, 1.54],
      "5-mid": "1.72",
      "5-bound": [1.53, 1.92],
      "10-mid": "2.03",
      "10-bound": [1.81, 2.26],
      "25-mid": "2.45",
      "25-bound": [2.17, 2.73],
      "50-mid": "2.82",
      "50-bound": [2.48, 3.14],
      "100-mid": "3.21",
      "100-bound": [2.81, 3.57]
    },
    "3hr": {
      "2-mid": "1.48",
      "2-bound": [1.33, 1.67],
      "5-mid": "1.85",
      "5-bound": [1.65, 2.09],
      "10-mid": "2.18",
      "10-bound": [1.94, 2.45],
      "25-mid": "2.63",
      "25-bound": [2.33, 2.96],
      "50-mid": "3.03",
      "50-bound": [2.66, 3.4],
      "100-mid": "3.46",
      "100-bound": [3.02, 3.87]
    },
    "6hr": {
      "2-mid": "1.81",
      "2-bound": [1.62, 2.04],
      "5-mid": "2.23",
      "5-bound": [2.0, 2.51],
      "10-mid": "2.62",
      "10-bound": [2.34, 2.94],
      "25-mid": "3.16",
      "25-bound": [2.8, 3.53],
      "50-mid": "3.64",
      "50-bound": [3.2, 4.06],
      "100-mid": "4.15",
      "100-bound": [3.63, 4.62]
    },
    "12hr": {
      "2-mid": "2.2",
      "2-bound": [1.98, 2.48],
      "5-mid": "2.7",
      "5-bound": [2.43, 3.04],
      "10-mid": "3.17",
      "10-bound": [2.84, 3.55],
      "25-mid": "3.83",
      "25-bound": [3.4, 4.28],
      "50-mid": "4.42",
      "50-bound": [3.9, 4.93],
      "100-mid": "5.06",
      "100-bound": [4.42, 5.63]
    },
    "24hr": {
      "2-mid": "2.6",
      "2-bound": [2.42, 2.81],
      "5-mid": "3.18",
      "5-bound": [2.96, 3.45],
      "10-mid": "3.69",
      "10-bound": [3.41, 3.99],
      "25-mid": "4.42",
      "25-bound": [4.05, 4.78],
      "50-mid": "5.04",
      "50-bound": [4.58, 5.47],
      "100-mid": "5.71",
      "100-bound": [5.12, 6.23]
    },
    "2day": {
      "2-mid": "3.07",
      "2-bound": [2.87, 3.31],
      "5-mid": "3.74",
      "5-bound": [3.48, 4.02],
      "10-mid": "4.29",
      "10-bound": [3.98, 4.62],
      "25-mid": "5.09",
      "25-bound": [4.69, 5.5],
      "50-mid": "5.75",
      "50-bound": [5.25, 6.24],
      "100-mid": "6.45",
      "100-bound": [5.83, 7.05]
    },
    "3day": {
      "2-mid": "3.35",
      "2-bound": [3.15, 3.58],
      "5-mid": "4.04",
      "5-bound": [3.79, 4.31],
      "10-mid": "4.6",
      "10-bound": [4.3, 4.91],
      "25-mid": "5.39",
      "25-bound": [5.01, 5.78],
      "50-mid": "6.03",
      "50-bound": [5.56, 6.49],
      "100-mid": "6.7",
      "100-bound": [6.12, 7.26]
    },
    "4day": {
      "2-mid": "3.63",
      "2-bound": [3.43, 3.85],
      "5-mid": "4.34",
      "5-bound": [4.1, 4.6],
      "10-mid": "4.9",
      "10-bound": [4.62, 5.21],
      "25-mid": "5.69",
      "25-bound": [5.33, 6.06],
      "50-mid": "6.32",
      "50-bound": [5.87, 6.75],
      "100-mid": "6.95",
      "100-bound": [6.41, 7.47]
    },
    "7day": {
      "2-mid": "4.44",
      "2-bound": [4.21, 4.71],
      "5-mid": "5.24",
      "5-bound": [4.97, 5.56],
      "10-mid": "5.88",
      "10-bound": [5.55, 6.23],
      "25-mid": "6.72",
      "25-bound": [6.31, 7.14],
      "50-mid": "7.38",
      "50-bound": [6.89, 7.87],
      "100-mid": "8.04",
      "100-bound": [7.45, 8.62]
    }
  },
  "USC00309047 6": {
    "fips": "36107",
    "station_name": "WAVERLY",
    "state": "NY",
    "latitude": "42.0010",
    "longitude": "-76.5200",
    "5min": {
      "2-mid": "0.37",
      "2-bound": [0.28, 0.49],
      "5-mid": "0.47",
      "5-bound": [0.36, 0.62],
      "10-mid": "0.56",
      "10-bound": [0.42, 0.74],
      "25-mid": "0.68",
      "25-bound": [0.49, 0.93],
      "50-mid": "0.76",
      "50-bound": [0.55, 1.08],
      "100-mid": "0.85",
      "100-bound": [0.6, 1.25]
    },
    "10min": {
      "2-mid": "0.53",
      "2-bound": [0.4, 0.69],
      "5-mid": "0.67",
      "5-bound": [0.51, 0.89],
      "10-mid": "0.79",
      "10-bound": [0.59, 1.05],
      "25-mid": "0.96",
      "25-bound": [0.7, 1.32],
      "50-mid": "1.08",
      "50-bound": [0.78, 1.53],
      "100-mid": "1.21",
      "100-bound": [0.85, 1.78]
    },
    "15min": {
      "2-mid": "0.62",
      "2-bound": [0.47, 0.81],
      "5-mid": "0.79",
      "5-bound": [0.59, 1.04],
      "10-mid": "0.93",
      "10-bound": [0.7, 1.23],
      "25-mid": "1.12",
      "25-bound": [0.82, 1.56],
      "50-mid": "1.27",
      "50-bound": [0.91, 1.8],
      "100-mid": "1.42",
      "100-bound": [1.0, 2.09]
    },
    "30min": {
      "2-mid": "0.81",
      "2-bound": [0.61, 1.06],
      "5-mid": "1.03",
      "5-bound": [0.78, 1.36],
      "10-mid": "1.21",
      "10-bound": [0.91, 1.61],
      "25-mid": "1.47",
      "25-bound": [1.07, 2.03],
      "50-mid": "1.66",
      "50-bound": [1.19, 2.35],
      "100-mid": "1.86",
      "100-bound": [1.3, 2.73]
    },
    "60min": {
      "2-mid": "1.0",
      "2-bound": [0.76, 1.31],
      "5-mid": "1.27",
      "5-bound": [0.96, 1.68],
      "10-mid": "1.5",
      "10-bound": [1.13, 1.99],
      "25-mid": "1.81",
      "25-bound": [1.33, 2.51],
      "50-mid": "2.05",
      "50-bound": [1.47, 2.89],
      "100-mid": "2.3",
      "100-bound": [1.61, 3.36]
    },
    "2hr": {
      "2-mid": "1.23",
      "2-bound": [0.93, 1.6],
      "5-mid": "1.54",
      "5-bound": [1.17, 2.02],
      "10-mid": "1.81",
      "10-bound": [1.36, 2.38],
      "25-mid": "2.17",
      "25-bound": [1.59, 2.98],
      "50-mid": "2.44",
      "50-bound": [1.76, 3.43],
      "100-mid": "2.73",
      "100-bound": [1.92, 3.97]
    },
    "3hr": {
      "2-mid": "1.38",
      "2-bound": [1.05, 1.8],
      "5-mid": "1.73",
      "5-bound": [1.32, 2.26],
      "10-mid": "2.02",
      "10-bound": [1.53, 2.65],
      "25-mid": "2.42",
      "25-bound": [1.78, 3.32],
      "50-mid": "2.72",
      "50-bound": [1.97, 3.81],
      "100-mid": "3.04",
      "100-bound": [2.14, 4.41]
    },
    "6hr": {
      "2-mid": "1.69",
      "2-bound": [1.29, 2.18],
      "5-mid": "2.12",
      "5-bound": [1.62, 2.75],
      "10-mid": "2.48",
      "10-bound": [1.88, 3.23],
      "25-mid": "2.97",
      "25-bound": [2.2, 4.05],
      "50-mid": "3.34",
      "50-bound": [2.43, 4.65],
      "100-mid": "3.73",
      "100-bound": [2.65, 5.4]
    },
    "12hr": {
      "2-mid": "2.04",
      "2-bound": [1.57, 2.62],
      "5-mid": "2.6",
      "5-bound": [1.99, 3.34],
      "10-mid": "3.06",
      "10-bound": [2.33, 3.96],
      "25-mid": "3.69",
      "25-bound": [2.74, 5.01],
      "50-mid": "4.16",
      "50-bound": [3.04, 5.78],
      "100-mid": "4.67",
      "100-bound": [3.34, 6.75]
    },
    "24hr": {
      "2-mid": "2.41",
      "2-bound": [1.86, 3.07],
      "5-mid": "3.11",
      "5-bound": [2.39, 3.98],
      "10-mid": "3.69",
      "10-bound": [2.82, 4.75],
      "25-mid": "4.49",
      "25-bound": [3.36, 6.07],
      "50-mid": "5.08",
      "50-bound": [3.74, 7.04],
      "100-mid": "5.72",
      "100-bound": [4.13, 8.28]
    },
    "2day": {
      "2-mid": "2.78",
      "2-bound": [2.15, 3.52],
      "5-mid": "3.62",
      "5-bound": [2.79, 4.6],
      "10-mid": "4.31",
      "10-bound": [3.31, 5.51],
      "25-mid": "5.27",
      "25-bound": [3.96, 7.1],
      "50-mid": "5.97",
      "50-bound": [4.42, 8.26],
      "100-mid": "6.75",
      "100-bound": [4.91, 9.76]
    },
    "3day": {
      "2-mid": "3.04",
      "2-bound": [2.36, 3.83],
      "5-mid": "3.94",
      "5-bound": [3.05, 4.99],
      "10-mid": "4.69",
      "10-bound": [3.62, 5.98],
      "25-mid": "5.72",
      "25-bound": [4.31, 7.69],
      "50-mid": "6.48",
      "50-bound": [4.81, 8.93],
      "100-mid": "7.32",
      "100-bound": [5.34, 10.6]
    },
    "4day": {
      "2-mid": "3.26",
      "2-bound": [2.54, 4.1],
      "5-mid": "4.2",
      "5-bound": [3.26, 5.3],
      "10-mid": "4.98",
      "10-bound": [3.84, 6.32],
      "25-mid": "6.05",
      "25-bound": [4.57, 8.11],
      "50-mid": "6.84",
      "50-bound": [5.09, 9.4],
      "100-mid": "7.71",
      "100-bound": [5.64, 11.1]
    },
    "7day": {
      "2-mid": "3.84",
      "2-bound": [3.0, 4.8],
      "5-mid": "4.83",
      "5-bound": [3.76, 6.06],
      "10-mid": "5.65",
      "10-bound": [4.38, 7.14],
      "25-mid": "6.79",
      "25-bound": [5.13, 9.02],
      "50-mid": "7.62",
      "50-bound": [5.68, 10.4],
      "100-mid": "8.53",
      "100-bound": [6.24, 12.2]
    }
  },
  "USC00449301 6": {
    "fips": "51197",
    "station_name": "WYTHEVILLE",
    "state": "VA",
    "latitude": "36.9610",
    "longitude": "-81.0800",
    "5min": {
      "2-mid": "0.33",
      "2-bound": [0.3, 0.37],
      "5-mid": "0.4",
      "5-bound": [0.35, 0.44],
      "10-mid": "0.45",
      "10-bound": [0.4, 0.5],
      "25-mid": "0.52",
      "25-bound": [0.46, 0.59],
      "50-mid": "0.58",
      "50-bound": [0.5, 0.66],
      "100-mid": "0.64",
      "100-bound": [0.55, 0.73]
    },
    "10min": {
      "2-mid": "0.53",
      "2-bound": [0.47, 0.59],
      "5-mid": "0.63",
      "5-bound": [0.57, 0.7],
      "10-mid": "0.72",
      "10-bound": [0.64, 0.8],
      "25-mid": "0.83",
      "25-bound": [0.73, 0.93],
      "50-mid": "0.92",
      "50-bound": [0.8, 1.04],
      "100-mid": "1.02",
      "100-bound": [0.87, 1.16]
    },
    "15min": {
      "2-mid": "0.66",
      "2-bound": [0.59, 0.74],
      "5-mid": "0.8",
      "5-bound": [0.72, 0.89],
      "10-mid": "0.91",
      "10-bound": [0.81, 1.02],
      "25-mid": "1.05",
      "25-bound": [0.93, 1.18],
      "50-mid": "1.17",
      "50-bound": [1.01, 1.32],
      "100-mid": "1.28",
      "100-bound": [1.09, 1.47]
    },
    "30min": {
      "2-mid": "0.91",
      "2-bound": [0.82, 1.02],
      "5-mid": "1.14",
      "5-bound": [1.02, 1.27],
      "10-mid": "1.32",
      "10-bound": [1.18, 1.47],
      "25-mid": "1.56",
      "25-bound": [1.38, 1.75],
      "50-mid": "1.76",
      "50-bound": [1.52, 1.99],
      "100-mid": "1.96",
      "100-bound": [1.68, 2.25]
    },
    "60min": {
      "2-mid": "1.15",
      "2-bound": [1.03, 1.28],
      "5-mid": "1.46",
      "5-bound": [1.31, 1.62],
      "10-mid": "1.71",
      "10-bound": [1.53, 1.92],
      "25-mid": "2.08",
      "25-bound": [1.83, 2.33],
      "50-mid": "2.38",
      "50-bound": [2.07, 2.69],
      "100-mid": "2.71",
      "100-bound": [2.31, 3.09]
    },
    "2hr": {
      "2-mid": "1.31",
      "2-bound": [1.18, 1.45],
      "5-mid": "1.69",
      "5-bound": [1.52, 1.89],
      "10-mid": "2.01",
      "10-bound": [1.8, 2.24],
      "25-mid": "2.48",
      "25-bound": [2.18, 2.79],
      "50-mid": "2.87",
      "50-bound": [2.48, 3.25],
      "100-mid": "3.29",
      "100-bound": [2.8, 3.76]
    },
    "3hr": {
      "2-mid": "1.38",
      "2-bound": [1.25, 1.54],
      "5-mid": "1.78",
      "5-bound": [1.61, 1.98],
      "10-mid": "2.11",
      "10-bound": [1.9, 2.35],
      "25-mid": "2.59",
      "25-bound": [2.29, 2.9],
      "50-mid": "3.0",
      "50-bound": [2.61, 3.39],
      "100-mid": "3.44",
      "100-bound": [2.94, 3.93]
    },
    "6hr": {
      "2-mid": "1.63",
      "2-bound": [1.49, 1.79],
      "5-mid": "2.07",
      "5-bound": [1.88, 2.28],
      "10-mid": "2.44",
      "10-bound": [2.2, 2.68],
      "25-mid": "2.96",
      "25-bound": [2.64, 3.27],
      "50-mid": "3.39",
      "50-bound": [2.99, 3.77],
      "100-mid": "3.85",
      "100-bound": [3.34, 4.33]
    },
    "12hr": {
      "2-mid": "1.95",
      "2-bound": [1.8, 2.12],
      "5-mid": "2.43",
      "5-bound": [2.24, 2.64],
      "10-mid": "2.82",
      "10-bound": [2.59, 3.06],
      "25-mid": "3.35",
      "25-bound": [3.04, 3.65],
      "50-mid": "3.77",
      "50-bound": [3.4, 4.13],
      "100-mid": "4.2",
      "100-bound": [3.74, 4.64]
    },
    "24hr": {
      "2-mid": "2.41",
      "2-bound": [2.25, 2.59],
      "5-mid": "3.0",
      "5-bound": [2.8, 3.21],
      "10-mid": "3.45",
      "10-bound": [3.22, 3.7],
      "25-mid": "4.09",
      "25-bound": [3.8, 4.38],
      "50-mid": "4.59",
      "50-bound": [4.25, 4.91],
      "100-mid": "5.11",
      "100-bound": [4.71, 5.47]
    },
    "2day": {
      "2-mid": "2.87",
      "2-bound": [2.69, 3.08],
      "5-mid": "3.54",
      "5-bound": [3.31, 3.79],
      "10-mid": "4.06",
      "10-bound": [3.79, 4.33],
      "25-mid": "4.76",
      "25-bound": [4.43, 5.08],
      "50-mid": "5.32",
      "50-bound": [4.93, 5.67],
      "100-mid": "5.88",
      "100-bound": [5.43, 6.28]
    },
    "3day": {
      "2-mid": "3.06",
      "2-bound": [2.88, 3.27],
      "5-mid": "3.75",
      "5-bound": [3.53, 4.0],
      "10-mid": "4.29",
      "10-bound": [4.02, 4.56],
      "25-mid": "5.02",
      "25-bound": [4.69, 5.34],
      "50-mid": "5.6",
      "50-bound": [5.21, 5.95],
      "100-mid": "6.17",
      "100-bound": [5.73, 6.57]
    },
    "4day": {
      "2-mid": "3.26",
      "2-bound": [3.07, 3.46],
      "5-mid": "3.97",
      "5-bound": [3.75, 4.21],
      "10-mid": "4.52",
      "10-bound": [4.26, 4.79],
      "25-mid": "5.28",
      "25-bound": [4.95, 5.59],
      "50-mid": "5.87",
      "50-bound": [5.49, 6.22],
      "100-mid": "6.46",
      "100-bound": [6.02, 6.85]
    },
    "7day": {
      "2-mid": "3.82",
      "2-bound": [3.62, 4.04],
      "5-mid": "4.59",
      "5-bound": [4.35, 4.86],
      "10-mid": "5.19",
      "10-bound": [4.91, 5.49],
      "25-mid": "5.99",
      "25-bound": [5.64, 6.33],
      "50-mid": "6.61",
      "50-bound": [6.21, 6.99],
      "100-mid": "7.22",
      "100-bound": [6.76, 7.64]
    }
  },
  "USC00444876 6": {
    "fips": "51678",
    "station_name": "LEXINGTON",
    "state": "VA",
    "latitude": "37.7760",
    "longitude": "-79.4380",
    "5min": {
      "2-mid": "0.35",
      "2-bound": [0.31, 0.39],
      "5-mid": "0.42",
      "5-bound": [0.38, 0.47],
      "10-mid": "0.47",
      "10-bound": [0.43, 0.53],
      "25-mid": "0.54",
      "25-bound": [0.48, 0.6],
      "50-mid": "0.59",
      "50-bound": [0.52, 0.65],
      "100-mid": "0.63",
      "100-bound": [0.56, 0.7]
    },
    "10min": {
      "2-mid": "0.56",
      "2-bound": [0.5, 0.62],
      "5-mid": "0.68",
      "5-bound": [0.61, 0.75],
      "10-mid": "0.76",
      "10-bound": [0.68, 0.84],
      "25-mid": "0.86",
      "25-bound": [0.77, 0.95],
      "50-mid": "0.94",
      "50-bound": [0.83, 1.04],
      "100-mid": "1.0",
      "100-bound": [0.88, 1.12]
    },
    "15min": {
      "2-mid": "0.7",
      "2-bound": [0.63, 0.78],
      "5-mid": "0.85",
      "5-bound": [0.77, 0.95],
      "10-mid": "0.96",
      "10-bound": [0.86, 1.07],
      "25-mid": "1.09",
      "25-bound": [0.97, 1.21],
      "50-mid": "1.18",
      "50-bound": [1.05, 1.31],
      "100-mid": "1.27",
      "100-bound": [1.11, 1.41]
    },
    "30min": {
      "2-mid": "0.97",
      "2-bound": [0.87, 1.08],
      "5-mid": "1.22",
      "5-bound": [1.09, 1.35],
      "10-mid": "1.39",
      "10-bound": [1.25, 1.54],
      "25-mid": "1.62",
      "25-bound": [1.44, 1.79],
      "50-mid": "1.78",
      "50-bound": [1.58, 1.98],
      "100-mid": "1.94",
      "100-bound": [1.71, 2.16]
    },
    "60min": {
      "2-mid": "1.21",
      "2-bound": [1.09, 1.35],
      "5-mid": "1.56",
      "5-bound": [1.4, 1.73],
      "10-mid": "1.81",
      "10-bound": [1.62, 2.01],
      "25-mid": "2.15",
      "25-bound": [1.92, 2.39],
      "50-mid": "2.42",
      "50-bound": [2.14, 2.68],
      "100-mid": "2.68",
      "100-bound": [2.35, 2.98]
    },
    "2hr": {
      "2-mid": "1.41",
      "2-bound": [1.27, 1.56],
      "5-mid": "1.81",
      "5-bound": [1.64, 2.01],
      "10-mid": "2.12",
      "10-bound": [1.91, 2.36],
      "25-mid": "2.54",
      "25-bound": [2.27, 2.81],
      "50-mid": "2.86",
      "50-bound": [2.54, 3.17],
      "100-mid": "3.19",
      "100-bound": [2.81, 3.54]
    },
    "3hr": {
      "2-mid": "1.51",
      "2-bound": [1.37, 1.68],
      "5-mid": "1.93",
      "5-bound": [1.75, 2.15],
      "10-mid": "2.26",
      "10-bound": [2.04, 2.51],
      "25-mid": "2.7",
      "25-bound": [2.42, 2.99],
      "50-mid": "3.04",
      "50-bound": [2.71, 3.38],
      "100-mid": "3.4",
      "100-bound": [3.0, 3.78]
    },
    "6hr": {
      "2-mid": "1.87",
      "2-bound": [1.7, 2.1],
      "5-mid": "2.37",
      "5-bound": [2.14, 2.65],
      "10-mid": "2.77",
      "10-bound": [2.49, 3.09],
      "25-mid": "3.32",
      "25-bound": [2.97, 3.7],
      "50-mid": "3.78",
      "50-bound": [3.35, 4.21],
      "100-mid": "4.26",
      "100-bound": [3.73, 4.75]
    },
    "12hr": {
      "2-mid": "2.29",
      "2-bound": [2.06, 2.59],
      "5-mid": "2.88",
      "5-bound": [2.59, 3.26],
      "10-mid": "3.38",
      "10-bound": [3.02, 3.82],
      "25-mid": "4.11",
      "25-bound": [3.63, 4.63],
      "50-mid": "4.71",
      "50-bound": [4.12, 5.31],
      "100-mid": "5.37",
      "100-bound": [4.63, 6.08]
    },
    "24hr": {
      "2-mid": "2.87",
      "2-bound": [2.67, 3.11],
      "5-mid": "3.64",
      "5-bound": [3.38, 3.94],
      "10-mid": "4.27",
      "10-bound": [3.96, 4.62],
      "25-mid": "5.19",
      "25-bound": [4.78, 5.6],
      "50-mid": "5.96",
      "50-bound": [5.46, 6.42],
      "100-mid": "6.78",
      "100-bound": [6.17, 7.3]
    },
    "2day": {
      "2-mid": "3.36",
      "2-bound": [3.13, 3.63],
      "5-mid": "4.24",
      "5-bound": [3.94, 4.57],
      "10-mid": "4.96",
      "10-bound": [4.59, 5.33],
      "25-mid": "5.98",
      "25-bound": [5.51, 6.43],
      "50-mid": "6.82",
      "50-bound": [6.25, 7.33],
      "100-mid": "7.7",
      "100-bound": [7.02, 8.28]
    },
    "3day": {
      "2-mid": "3.59",
      "2-bound": [3.33, 3.88],
      "5-mid": "4.52",
      "5-bound": [4.19, 4.88],
      "10-mid": "5.28",
      "10-bound": [4.88, 5.68],
      "25-mid": "6.34",
      "25-bound": [5.84, 6.83],
      "50-mid": "7.22",
      "50-bound": [6.61, 7.77],
      "100-mid": "8.14",
      "100-bound": [7.41, 8.77]
    },
    "4day": {
      "2-mid": "3.82",
      "2-bound": [3.54, 4.13],
      "5-mid": "4.8",
      "5-bound": [4.44, 5.19],
      "10-mid": "5.59",
      "10-bound": [5.16, 6.03],
      "25-mid": "6.71",
      "25-bound": [6.16, 7.23],
      "50-mid": "7.62",
      "50-bound": [6.97, 8.21],
      "100-mid": "8.58",
      "100-bound": [7.8, 9.26]
    },
    "7day": {
      "2-mid": "4.41",
      "2-bound": [4.1, 4.73],
      "5-mid": "5.48",
      "5-bound": [5.09, 5.88],
      "10-mid": "6.33",
      "10-bound": [5.87, 6.78],
      "25-mid": "7.5",
      "25-bound": [6.93, 8.04],
      "50-mid": "8.44",
      "50-bound": [7.76, 9.04],
      "100-mid": "9.42",
      "100-bound": [8.62, 10.1]
    }
  },
  "USC00446626 6": {
    "fips": "51105",
    "station_name": "PENNINGTON GAP",
    "state": "VA",
    "latitude": "36.7580",
    "longitude": "-83.0100",
    "5min": {
      "2-mid": "0.36",
      "2-bound": [0.33, 0.41],
      "5-mid": "0.43",
      "5-bound": [0.39, 0.48],
      "10-mid": "0.48",
      "10-bound": [0.44, 0.54],
      "25-mid": "0.56",
      "25-bound": [0.5, 0.62],
      "50-mid": "0.62",
      "50-bound": [0.55, 0.69],
      "100-mid": "0.69",
      "100-bound": [0.6, 0.76]
    },
    "10min": {
      "2-mid": "0.58",
      "2-bound": [0.53, 0.65],
      "5-mid": "0.69",
      "5-bound": [0.62, 0.77],
      "10-mid": "0.78",
      "10-bound": [0.7, 0.86],
      "25-mid": "0.89",
      "25-bound": [0.8, 0.99],
      "50-mid": "0.99",
      "50-bound": [0.88, 1.1],
      "100-mid": "1.09",
      "100-bound": [0.96, 1.21]
    },
    "15min": {
      "2-mid": "0.73",
      "2-bound": [0.66, 0.82],
      "5-mid": "0.87",
      "5-bound": [0.79, 0.97],
      "10-mid": "0.98",
      "10-bound": [0.88, 1.09],
      "25-mid": "1.13",
      "25-bound": [1.01, 1.26],
      "50-mid": "1.25",
      "50-bound": [1.11, 1.39],
      "100-mid": "1.38",
      "100-bound": [1.21, 1.52]
    },
    "30min": {
      "2-mid": "1.01",
      "2-bound": [0.91, 1.13],
      "5-mid": "1.24",
      "5-bound": [1.12, 1.38],
      "10-mid": "1.42",
      "10-bound": [1.28, 1.58],
      "25-mid": "1.68",
      "25-bound": [1.5, 1.86],
      "50-mid": "1.89",
      "50-bound": [1.67, 2.09],
      "100-mid": "2.11",
      "100-bound": [1.86, 2.34]
    },
    "60min": {
      "2-mid": "1.27",
      "2-bound": [1.14, 1.42],
      "5-mid": "1.58",
      "5-bound": [1.43, 1.77],
      "10-mid": "1.85",
      "10-bound": [1.66, 2.06],
      "25-mid": "2.23",
      "25-bound": [1.99, 2.48],
      "50-mid": "2.56",
      "50-bound": [2.27, 2.83],
      "100-mid": "2.91",
      "100-bound": [2.56, 3.22]
    },
    "2hr": {
      "2-mid": "1.5",
      "2-bound": [1.36, 1.67],
      "5-mid": "1.87",
      "5-bound": [1.69, 2.08],
      "10-mid": "2.19",
      "10-bound": [1.98, 2.44],
      "25-mid": "2.68",
      "25-bound": [2.4, 2.96],
      "50-mid": "3.1",
      "50-bound": [2.76, 3.42],
      "100-mid": "3.57",
      "100-bound": [3.15, 3.94]
    },
    "3hr": {
      "2-mid": "1.62",
      "2-bound": [1.48, 1.8],
      "5-mid": "2.01",
      "5-bound": [1.82, 2.23],
      "10-mid": "2.34",
      "10-bound": [2.12, 2.6],
      "25-mid": "2.85",
      "25-bound": [2.56, 3.15],
      "50-mid": "3.28",
      "50-bound": [2.93, 3.62],
      "100-mid": "3.77",
      "100-bound": [3.33, 4.16]
    },
    "6hr": {
      "2-mid": "2.0",
      "2-bound": [1.83, 2.2],
      "5-mid": "2.44",
      "5-bound": [2.23, 2.69],
      "10-mid": "2.83",
      "10-bound": [2.58, 3.11],
      "25-mid": "3.4",
      "25-bound": [3.07, 3.72],
      "50-mid": "3.88",
      "50-bound": [3.49, 4.26],
      "100-mid": "4.42",
      "100-bound": [3.94, 4.84]
    },
    "12hr": {
      "2-mid": "2.48",
      "2-bound": [2.28, 2.72],
      "5-mid": "3.02",
      "5-bound": [2.77, 3.31],
      "10-mid": "3.48",
      "10-bound": [3.19, 3.81],
      "25-mid": "4.15",
      "25-bound": [3.78, 4.54],
      "50-mid": "4.72",
      "50-bound": [4.27, 5.16],
      "100-mid": "5.34",
      "100-bound": [4.8, 5.83]
    },
    "24hr": {
      "2-mid": "3.04",
      "2-bound": [2.83, 3.29],
      "5-mid": "3.71",
      "5-bound": [3.44, 4.02],
      "10-mid": "4.27",
      "10-bound": [3.95, 4.62],
      "25-mid": "5.07",
      "25-bound": [4.66, 5.49],
      "50-mid": "5.75",
      "50-bound": [5.24, 6.22],
      "100-mid": "6.47",
      "100-bound": [5.85, 7.02]
    },
    "2day": {
      "2-mid": "3.7",
      "2-bound": [3.45, 3.98],
      "5-mid": "4.48",
      "5-bound": [4.18, 4.83],
      "10-mid": "5.13",
      "10-bound": [4.77, 5.53],
      "25-mid": "6.06",
      "25-bound": [5.6, 6.54],
      "50-mid": "6.83",
      "50-bound": [6.26, 7.38],
      "100-mid": "7.65",
      "100-bound": [6.94, 8.31]
    },
    "3day": {
      "2-mid": "3.94",
      "2-bound": [3.68, 4.23],
      "5-mid": "4.76",
      "5-bound": [4.44, 5.11],
      "10-mid": "5.42",
      "10-bound": [5.05, 5.83],
      "25-mid": "6.37",
      "25-bound": [5.9, 6.86],
      "50-mid": "7.14",
      "50-bound": [6.57, 7.71],
      "100-mid": "7.96",
      "100-bound": [7.26, 8.62]
    },
    "4day": {
      "2-mid": "4.18",
      "2-bound": [3.91, 4.48],
      "5-mid": "5.03",
      "5-bound": [4.7, 5.39],
      "10-mid": "5.72",
      "10-bound": [5.34, 6.13],
      "25-mid": "6.68",
      "25-bound": [6.2, 7.18],
      "50-mid": "7.46",
      "50-bound": [6.88, 8.04],
      "100-mid": "8.27",
      "100-bound": [7.57, 8.93]
    },
    "7day": {
      "2-mid": "5.18",
      "2-bound": [4.86, 5.51],
      "5-mid": "6.16",
      "5-bound": [5.77, 6.55],
      "10-mid": "6.91",
      "10-bound": [6.47, 7.35],
      "25-mid": "7.89",
      "25-bound": [7.37, 8.4],
      "50-mid": "8.64",
      "50-bound": [8.04, 9.22],
      "100-mid": "9.4",
      "100-bound": [8.7, 10.1]
    }
  },
  "USC00302610 6": {
    "fips": "36015",
    "station_name": "ELMIRA",
    "state": "NY",
    "latitude": "42.0990",
    "longitude": "-76.8350",
    "5min": {
      "2-mid": "0.37",
      "2-bound": [0.28, 0.49],
      "5-mid": "0.47",
      "5-bound": [0.36, 0.63],
      "10-mid": "0.56",
      "10-bound": [0.42, 0.75],
      "25-mid": "0.68",
      "25-bound": [0.5, 0.94],
      "50-mid": "0.77",
      "50-bound": [0.55, 1.09],
      "100-mid": "0.86",
      "100-bound": [0.61, 1.26]
    },
    "10min": {
      "2-mid": "0.53",
      "2-bound": [0.4, 0.69],
      "5-mid": "0.67",
      "5-bound": [0.51, 0.89],
      "10-mid": "0.79",
      "10-bound": [0.59, 1.06],
      "25-mid": "0.96",
      "25-bound": [0.7, 1.34],
      "50-mid": "1.09",
      "50-bound": [0.78, 1.54],
      "100-mid": "1.22",
      "100-bound": [0.86, 1.79]
    },
    "15min": {
      "2-mid": "0.62",
      "2-bound": [0.47, 0.82],
      "5-mid": "0.79",
      "5-bound": [0.6, 1.05],
      "10-mid": "0.93",
      "10-bound": [0.7, 1.24],
      "25-mid": "1.13",
      "25-bound": [0.83, 1.57],
      "50-mid": "1.28",
      "50-bound": [0.92, 1.81],
      "100-mid": "1.43",
      "100-bound": [1.01, 2.11]
    },
    "30min": {
      "2-mid": "0.82",
      "2-bound": [0.62, 1.08],
      "5-mid": "1.04",
      "5-bound": [0.79, 1.38],
      "10-mid": "1.23",
      "10-bound": [0.93, 1.64],
      "25-mid": "1.49",
      "25-bound": [1.09, 2.07],
      "50-mid": "1.69",
      "50-bound": [1.21, 2.39],
      "100-mid": "1.89",
      "100-bound": [1.33, 2.78]
    },
    "60min": {
      "2-mid": "1.01",
      "2-bound": [0.77, 1.34],
      "5-mid": "1.3",
      "5-bound": [0.98, 1.72],
      "10-mid": "1.53",
      "10-bound": [1.15, 2.04],
      "25-mid": "1.85",
      "25-bound": [1.36, 2.58],
      "50-mid": "2.09",
      "50-bound": [1.51, 2.97],
      "100-mid": "2.35",
      "100-bound": [1.65, 3.46]
    },
    "2hr": {
      "2-mid": "1.24",
      "2-bound": [0.95, 1.62],
      "5-mid": "1.58",
      "5-bound": [1.21, 2.07],
      "10-mid": "1.86",
      "10-bound": [1.41, 2.45],
      "25-mid": "2.25",
      "25-bound": [1.67, 3.1],
      "50-mid": "2.53",
      "50-bound": [1.85, 3.57],
      "100-mid": "2.84",
      "100-bound": [2.03, 4.18]
    },
    "3hr": {
      "2-mid": "1.4",
      "2-bound": [1.08, 1.81],
      "5-mid": "1.77",
      "5-bound": [1.36, 2.3],
      "10-mid": "2.09",
      "10-bound": [1.6, 2.72],
      "25-mid": "2.52",
      "25-bound": [1.88, 3.45],
      "50-mid": "2.83",
      "50-bound": [2.08, 3.98],
      "100-mid": "3.18",
      "100-bound": [2.29, 4.66]
    },
    "6hr": {
      "2-mid": "1.71",
      "2-bound": [1.33, 2.18],
      "5-mid": "2.17",
      "5-bound": [1.69, 2.78],
      "10-mid": "2.55",
      "10-bound": [1.97, 3.29],
      "25-mid": "3.08",
      "25-bound": [2.32, 4.17],
      "50-mid": "3.46",
      "50-bound": [2.57, 4.81],
      "100-mid": "3.89",
      "100-bound": [2.82, 5.65]
    },
    "12hr": {
      "2-mid": "2.07",
      "2-bound": [1.64, 2.62],
      "5-mid": "2.65",
      "5-bound": [2.09, 3.35],
      "10-mid": "3.13",
      "10-bound": [2.45, 3.98],
      "25-mid": "3.78",
      "25-bound": [2.88, 5.06],
      "50-mid": "4.27",
      "50-bound": [3.19, 5.84],
      "100-mid": "4.8",
      "100-bound": [3.5, 6.86]
    },
    "24hr": {
      "2-mid": "2.46",
      "2-bound": [1.97, 3.06],
      "5-mid": "3.16",
      "5-bound": [2.52, 3.95],
      "10-mid": "3.75",
      "10-bound": [2.97, 4.71],
      "25-mid": "4.56",
      "25-bound": [3.5, 6.01],
      "50-mid": "5.15",
      "50-bound": [3.88, 6.96],
      "100-mid": "5.8",
      "100-bound": [4.24, 8.17]
    },
    "2day": {
      "2-mid": "2.83",
      "2-bound": [2.3, 3.47],
      "5-mid": "3.66",
      "5-bound": [2.96, 4.51],
      "10-mid": "4.36",
      "10-bound": [3.5, 5.4],
      "25-mid": "5.31",
      "25-bound": [4.12, 6.91],
      "50-mid": "6.02",
      "50-bound": [4.57, 8.03],
      "100-mid": "6.78",
      "100-bound": [4.99, 9.43]
    },
    "3day": {
      "2-mid": "3.09",
      "2-bound": [2.53, 3.76],
      "5-mid": "3.98",
      "5-bound": [3.24, 4.86],
      "10-mid": "4.72",
      "10-bound": [3.82, 5.8],
      "25-mid": "5.74",
      "25-bound": [4.48, 7.42],
      "50-mid": "6.49",
      "50-bound": [4.96, 8.61],
      "100-mid": "7.31",
      "100-bound": [5.41, 10.1]
    },
    "4day": {
      "2-mid": "3.31",
      "2-bound": [2.72, 4.0],
      "5-mid": "4.23",
      "5-bound": [3.47, 5.14],
      "10-mid": "5.0",
      "10-bound": [4.07, 6.1],
      "25-mid": "6.05",
      "25-bound": [4.75, 7.78],
      "50-mid": "6.83",
      "50-bound": [5.24, 9.01],
      "100-mid": "7.67",
      "100-bound": [5.7, 10.6]
    },
    "7day": {
      "2-mid": "3.89",
      "2-bound": [3.23, 4.65],
      "5-mid": "4.85",
      "5-bound": [4.02, 5.82],
      "10-mid": "5.65",
      "10-bound": [4.65, 6.83],
      "25-mid": "6.75",
      "25-bound": [5.35, 8.58],
      "50-mid": "7.57",
      "50-bound": [5.85, 9.87],
      "100-mid": "8.44",
      "100-bound": [6.31, 11.5]
    }
  },
  "USC00303983 6": {
    "fips": "36101",
    "station_name": "HORNELL ALMOND DAM",
    "state": "NY",
    "latitude": "42.3480",
    "longitude": "-77.7040",
    "5min": {
      "2-mid": "0.32",
      "2-bound": [0.25, 0.4],
      "5-mid": "0.41",
      "5-bound": [0.32, 0.51],
      "10-mid": "0.48",
      "10-bound": [0.37, 0.6],
      "25-mid": "0.58",
      "25-bound": [0.43, 0.76],
      "50-mid": "0.66",
      "50-bound": [0.48, 0.88],
      "100-mid": "0.73",
      "100-bound": [0.52, 1.02]
    },
    "10min": {
      "2-mid": "0.45",
      "2-bound": [0.35, 0.56],
      "5-mid": "0.58",
      "5-bound": [0.45, 0.72],
      "10-mid": "0.68",
      "10-bound": [0.52, 0.85],
      "25-mid": "0.82",
      "25-bound": [0.61, 1.08],
      "50-mid": "0.93",
      "50-bound": [0.68, 1.24],
      "100-mid": "1.04",
      "100-bound": [0.74, 1.44]
    },
    "15min": {
      "2-mid": "0.53",
      "2-bound": [0.41, 0.66],
      "5-mid": "0.68",
      "5-bound": [0.52, 0.84],
      "10-mid": "0.8",
      "10-bound": [0.61, 1.0],
      "25-mid": "0.96",
      "25-bound": [0.72, 1.26],
      "50-mid": "1.09",
      "50-bound": [0.8, 1.46],
      "100-mid": "1.22",
      "100-bound": [0.87, 1.7]
    },
    "30min": {
      "2-mid": "0.76",
      "2-bound": [0.59, 0.95],
      "5-mid": "0.96",
      "5-bound": [0.74, 1.2],
      "10-mid": "1.13",
      "10-bound": [0.87, 1.42],
      "25-mid": "1.36",
      "25-bound": [1.01, 1.78],
      "50-mid": "1.53",
      "50-bound": [1.12, 2.05],
      "100-mid": "1.71",
      "100-bound": [1.22, 2.38]
    },
    "60min": {
      "2-mid": "0.99",
      "2-bound": [0.77, 1.23],
      "5-mid": "1.25",
      "5-bound": [0.96, 1.56],
      "10-mid": "1.46",
      "10-bound": [1.12, 1.83],
      "25-mid": "1.75",
      "25-bound": [1.31, 2.3],
      "50-mid": "1.97",
      "50-bound": [1.44, 2.64],
      "100-mid": "2.2",
      "100-bound": [1.56, 3.06]
    },
    "2hr": {
      "2-mid": "1.23",
      "2-bound": [0.96, 1.52],
      "5-mid": "1.58",
      "5-bound": [1.23, 1.95],
      "10-mid": "1.86",
      "10-bound": [1.44, 2.32],
      "25-mid": "2.25",
      "25-bound": [1.69, 2.93],
      "50-mid": "2.55",
      "50-bound": [1.87, 3.38],
      "100-mid": "2.85",
      "100-bound": [2.04, 3.93]
    },
    "3hr": {
      "2-mid": "1.39",
      "2-bound": [1.09, 1.71],
      "5-mid": "1.78",
      "5-bound": [1.39, 2.2],
      "10-mid": "2.11",
      "10-bound": [1.64, 2.62],
      "25-mid": "2.56",
      "25-bound": [1.92, 3.32],
      "50-mid": "2.89",
      "50-bound": [2.13, 3.83],
      "100-mid": "3.24",
      "100-bound": [2.33, 4.47]
    },
    "6hr": {
      "2-mid": "1.69",
      "2-bound": [1.34, 2.06],
      "5-mid": "2.15",
      "5-bound": [1.7, 2.64],
      "10-mid": "2.54",
      "10-bound": [1.99, 3.13],
      "25-mid": "3.07",
      "25-bound": [2.33, 3.97],
      "50-mid": "3.46",
      "50-bound": [2.58, 4.58],
      "100-mid": "3.89",
      "100-bound": [2.82, 5.36]
    },
    "12hr": {
      "2-mid": "2.03",
      "2-bound": [1.62, 2.46],
      "5-mid": "2.55",
      "5-bound": [2.02, 3.11],
      "10-mid": "2.98",
      "10-bound": [2.35, 3.65],
      "25-mid": "3.58",
      "25-bound": [2.74, 4.61],
      "50-mid": "4.01",
      "50-bound": [3.02, 5.31],
      "100-mid": "4.49",
      "100-bound": [3.32, 6.23]
    },
    "24hr": {
      "2-mid": "2.39",
      "2-bound": [1.92, 2.88],
      "5-mid": "3.0",
      "5-bound": [2.4, 3.63],
      "10-mid": "3.51",
      "10-bound": [2.78, 4.26],
      "25-mid": "4.2",
      "25-bound": [3.25, 5.39],
      "50-mid": "4.71",
      "50-bound": [3.58, 6.2],
      "100-mid": "5.28",
      "100-bound": [3.93, 7.3]
    },
    "2day": {
      "2-mid": "2.74",
      "2-bound": [2.22, 3.28],
      "5-mid": "3.51",
      "5-bound": [2.82, 4.21],
      "10-mid": "4.15",
      "10-bound": [3.32, 5.0],
      "25-mid": "5.02",
      "25-bound": [3.9, 6.38],
      "50-mid": "5.66",
      "50-bound": [4.31, 7.37],
      "100-mid": "6.37",
      "100-bound": [4.73, 8.68]
    },
    "3day": {
      "2-mid": "2.99",
      "2-bound": [2.43, 3.56],
      "5-mid": "3.84",
      "5-bound": [3.1, 4.59],
      "10-mid": "4.54",
      "10-bound": [3.64, 5.46],
      "25-mid": "5.5",
      "25-bound": [4.28, 6.96],
      "50-mid": "6.22",
      "50-bound": [4.74, 8.05],
      "100-mid": "6.99",
      "100-bound": [5.2, 9.46]
    },
    "4day": {
      "2-mid": "3.2",
      "2-bound": [2.6, 3.8],
      "5-mid": "4.1",
      "5-bound": [3.32, 4.88],
      "10-mid": "4.83",
      "10-bound": [3.89, 5.79],
      "25-mid": "5.85",
      "25-bound": [4.56, 7.37],
      "50-mid": "6.6",
      "50-bound": [5.04, 8.51],
      "100-mid": "7.42",
      "100-bound": [5.52, 9.99]
    },
    "7day": {
      "2-mid": "3.76",
      "2-bound": [3.08, 4.44],
      "5-mid": "4.72",
      "5-bound": [3.85, 5.59],
      "10-mid": "5.52",
      "10-bound": [4.47, 6.57],
      "25-mid": "6.62",
      "25-bound": [5.18, 8.26],
      "50-mid": "7.43",
      "50-bound": [5.69, 9.5],
      "100-mid": "8.31",
      "100-bound": [6.18, 11.1]
    }
  },
  "USC00306184 6": {
    "fips": "36043",
    "station_name": "OLD FORGE",
    "state": "NY",
    "latitude": "43.7020",
    "longitude": "-74.9830",
    "5min": {
      "2-mid": "0.34",
      "2-bound": [0.28, 0.42],
      "5-mid": "0.43",
      "5-bound": [0.35, 0.54],
      "10-mid": "0.51",
      "10-bound": [0.41, 0.63],
      "25-mid": "0.61",
      "25-bound": [0.47, 0.79],
      "50-mid": "0.69",
      "50-bound": [0.52, 0.91],
      "100-mid": "0.77",
      "100-bound": [0.56, 1.04]
    },
    "10min": {
      "2-mid": "0.49",
      "2-bound": [0.39, 0.6],
      "5-mid": "0.62",
      "5-bound": [0.49, 0.76],
      "10-mid": "0.72",
      "10-bound": [0.58, 0.9],
      "25-mid": "0.87",
      "25-bound": [0.67, 1.12],
      "50-mid": "0.98",
      "50-bound": [0.73, 1.28],
      "100-mid": "1.09",
      "100-bound": [0.79, 1.48]
    },
    "15min": {
      "2-mid": "0.57",
      "2-bound": [0.46, 0.71],
      "5-mid": "0.72",
      "5-bound": [0.58, 0.9],
      "10-mid": "0.85",
      "10-bound": [0.68, 1.06],
      "25-mid": "1.02",
      "25-bound": [0.78, 1.32],
      "50-mid": "1.15",
      "50-bound": [0.86, 1.51],
      "100-mid": "1.28",
      "100-bound": [0.93, 1.74]
    },
    "30min": {
      "2-mid": "0.76",
      "2-bound": [0.62, 0.94],
      "5-mid": "0.96",
      "5-bound": [0.78, 1.19],
      "10-mid": "1.13",
      "10-bound": [0.9, 1.4],
      "25-mid": "1.36",
      "25-bound": [1.04, 1.75],
      "50-mid": "1.53",
      "50-bound": [1.15, 2.01],
      "100-mid": "1.71",
      "100-bound": [1.23, 2.31]
    },
    "60min": {
      "2-mid": "0.95",
      "2-bound": [0.77, 1.18],
      "5-mid": "1.2",
      "5-bound": [0.97, 1.49],
      "10-mid": "1.41",
      "10-bound": [1.13, 1.75],
      "25-mid": "1.7",
      "25-bound": [1.3, 2.18],
      "50-mid": "1.91",
      "50-bound": [1.43, 2.51],
      "100-mid": "2.13",
      "100-bound": [1.54, 2.88]
    },
    "2hr": {
      "2-mid": "1.2",
      "2-bound": [0.98, 1.47],
      "5-mid": "1.49",
      "5-bound": [1.2, 1.83],
      "10-mid": "1.72",
      "10-bound": [1.38, 2.13],
      "25-mid": "2.05",
      "25-bound": [1.58, 2.63],
      "50-mid": "2.29",
      "50-bound": [1.73, 3.0],
      "100-mid": "2.55",
      "100-bound": [1.86, 3.45]
    },
    "3hr": {
      "2-mid": "1.38",
      "2-bound": [1.12, 1.68],
      "5-mid": "1.69",
      "5-bound": [1.37, 2.07],
      "10-mid": "1.95",
      "10-bound": [1.57, 2.4],
      "25-mid": "2.31",
      "25-bound": [1.79, 2.95],
      "50-mid": "2.57",
      "50-bound": [1.95, 3.35],
      "100-mid": "2.86",
      "100-bound": [2.1, 3.86]
    },
    "6hr": {
      "2-mid": "1.73",
      "2-bound": [1.42, 2.1],
      "5-mid": "2.13",
      "5-bound": [1.74, 2.59],
      "10-mid": "2.45",
      "10-bound": [1.99, 3.0],
      "25-mid": "2.9",
      "25-bound": [2.27, 3.68],
      "50-mid": "3.23",
      "50-bound": [2.47, 4.18],
      "100-mid": "3.59",
      "100-bound": [2.64, 4.79]
    },
    "12hr": {
      "2-mid": "2.18",
      "2-bound": [1.8, 2.62],
      "5-mid": "2.69",
      "5-bound": [2.21, 3.25],
      "10-mid": "3.11",
      "10-bound": [2.54, 3.78],
      "25-mid": "3.7",
      "25-bound": [2.9, 4.64],
      "50-mid": "4.14",
      "50-bound": [3.16, 5.28],
      "100-mid": "4.6",
      "100-bound": [3.38, 6.04]
    },
    "24hr": {
      "2-mid": "2.66",
      "2-bound": [2.21, 3.18],
      "5-mid": "3.27",
      "5-bound": [2.71, 3.93],
      "10-mid": "3.78",
      "10-bound": [3.11, 4.56],
      "25-mid": "4.48",
      "25-bound": [3.53, 5.57],
      "50-mid": "5.02",
      "50-bound": [3.85, 6.33],
      "100-mid": "5.56",
      "100-bound": [4.09, 7.21]
    },
    "2day": {
      "2-mid": "3.15",
      "2-bound": [2.64, 3.75],
      "5-mid": "3.8",
      "5-bound": [3.17, 4.53],
      "10-mid": "4.34",
      "10-bound": [3.59, 5.2],
      "25-mid": "5.09",
      "25-bound": [4.04, 6.28],
      "50-mid": "5.66",
      "50-bound": [4.37, 7.09],
      "100-mid": "6.24",
      "100-bound": [4.62, 8.02]
    },
    "3day": {
      "2-mid": "3.48",
      "2-bound": [2.92, 4.12],
      "5-mid": "4.15",
      "5-bound": [3.47, 4.92],
      "10-mid": "4.7",
      "10-bound": [3.9, 5.61],
      "25-mid": "5.47",
      "25-bound": [4.36, 6.72],
      "50-mid": "6.05",
      "50-bound": [4.69, 7.55],
      "100-mid": "6.64",
      "100-bound": [4.95, 8.52]
    },
    "4day": {
      "2-mid": "3.75",
      "2-bound": [3.16, 4.43],
      "5-mid": "4.44",
      "5-bound": [3.72, 5.25],
      "10-mid": "5.0",
      "10-bound": [4.17, 5.95],
      "25-mid": "5.79",
      "25-bound": [4.62, 7.09],
      "50-mid": "6.38",
      "50-bound": [4.96, 7.94],
      "100-mid": "6.99",
      "100-bound": [5.22, 8.94]
    },
    "7day": {
      "2-mid": "4.49",
      "2-bound": [3.8, 5.27],
      "5-mid": "5.22",
      "5-bound": [4.4, 6.14],
      "10-mid": "5.82",
      "10-bound": [4.87, 6.88],
      "25-mid": "6.65",
      "25-bound": [5.35, 8.1],
      "50-mid": "7.28",
      "50-bound": [5.7, 9.01],
      "100-mid": "7.94",
      "100-bound": [5.96, 10.1]
    }
  },
  "USW00013701 6": {
    "fips": "24025",
    "station_name": "ABERDEEN PHILLIPS FLD",
    "state": "MD",
    "latitude": "39.4710",
    "longitude": "-76.1690",
    "5min": {
      "2-mid": "0.41",
      "2-bound": [0.36, 0.47],
      "5-mid": "0.49",
      "5-bound": [0.43, 0.55],
      "10-mid": "0.55",
      "10-bound": [0.48, 0.62],
      "25-mid": "0.61",
      "25-bound": [0.54, 0.69],
      "50-mid": "0.67",
      "50-bound": [0.58, 0.75],
      "100-mid": "0.71",
      "100-bound": [0.62, 0.81]
    },
    "10min": {
      "2-mid": "0.66",
      "2-bound": [0.58, 0.75],
      "5-mid": "0.79",
      "5-bound": [0.69, 0.89],
      "10-mid": "0.87",
      "10-bound": [0.77, 0.98],
      "25-mid": "0.98",
      "25-bound": [0.86, 1.11],
      "50-mid": "1.06",
      "50-bound": [0.93, 1.2],
      "100-mid": "1.14",
      "100-bound": [0.99, 1.29]
    },
    "15min": {
      "2-mid": "0.83",
      "2-bound": [0.73, 0.94],
      "5-mid": "0.99",
      "5-bound": [0.88, 1.12],
      "10-mid": "1.1",
      "10-bound": [0.97, 1.25],
      "25-mid": "1.24",
      "25-bound": [1.09, 1.4],
      "50-mid": "1.34",
      "50-bound": [1.18, 1.51],
      "100-mid": "1.44",
      "100-bound": [1.25, 1.63]
    },
    "30min": {
      "2-mid": "1.14",
      "2-bound": [1.02, 1.3],
      "5-mid": "1.41",
      "5-bound": [1.25, 1.59],
      "10-mid": "1.6",
      "10-bound": [1.41, 1.81],
      "25-mid": "1.84",
      "25-bound": [1.62, 2.08],
      "50-mid": "2.02",
      "50-bound": [1.77, 2.28],
      "100-mid": "2.2",
      "100-bound": [1.92, 2.49]
    },
    "60min": {
      "2-mid": "1.44",
      "2-bound": [1.27, 1.63],
      "5-mid": "1.81",
      "5-bound": [1.6, 2.04],
      "10-mid": "2.08",
      "10-bound": [1.84, 2.35],
      "25-mid": "2.45",
      "25-bound": [2.16, 2.77],
      "50-mid": "2.74",
      "50-bound": [2.4, 3.09],
      "100-mid": "3.03",
      "100-bound": [2.65, 3.43]
    },
    "2hr": {
      "2-mid": "1.74",
      "2-bound": [1.54, 1.95],
      "5-mid": "2.19",
      "5-bound": [1.94, 2.45],
      "10-mid": "2.55",
      "10-bound": [2.25, 2.84],
      "25-mid": "3.04",
      "25-bound": [2.68, 3.39],
      "50-mid": "3.44",
      "50-bound": [3.02, 3.83],
      "100-mid": "3.86",
      "100-bound": [3.37, 4.31]
    },
    "3hr": {
      "2-mid": "1.87",
      "2-bound": [1.69, 2.08],
      "5-mid": "2.37",
      "5-bound": [2.13, 2.63],
      "10-mid": "2.76",
      "10-bound": [2.47, 3.06],
      "25-mid": "3.3",
      "25-bound": [2.95, 3.66],
      "50-mid": "3.76",
      "50-bound": [3.33, 4.16],
      "100-mid": "4.24",
      "100-bound": [3.72, 4.69]
    },
    "6hr": {
      "2-mid": "2.3",
      "2-bound": [2.09, 2.57],
      "5-mid": "2.9",
      "5-bound": [2.62, 3.24],
      "10-mid": "3.4",
      "10-bound": [3.05, 3.79],
      "25-mid": "4.12",
      "25-bound": [3.68, 4.59],
      "50-mid": "4.73",
      "50-bound": [4.19, 5.26],
      "100-mid": "5.4",
      "100-bound": [4.73, 6.02]
    },
    "12hr": {
      "2-mid": "2.81",
      "2-bound": [2.5, 3.22],
      "5-mid": "3.57",
      "5-bound": [3.15, 4.08],
      "10-mid": "4.22",
      "10-bound": [3.71, 4.82],
      "25-mid": "5.2",
      "25-bound": [4.53, 5.94],
      "50-mid": "6.06",
      "50-bound": [5.23, 6.9],
      "100-mid": "7.01",
      "100-bound": [5.98, 7.98]
    },
    "24hr": {
      "2-mid": "3.23",
      "2-bound": [2.97, 3.55],
      "5-mid": "4.15",
      "5-bound": [3.82, 4.56],
      "10-mid": "4.96",
      "10-bound": [4.54, 5.44],
      "25-mid": "6.2",
      "25-bound": [5.63, 6.76],
      "50-mid": "7.29",
      "50-bound": [6.56, 7.93],
      "100-mid": "8.52",
      "100-bound": [7.6, 9.25]
    },
    "2day": {
      "2-mid": "3.73",
      "2-bound": [3.43, 4.1],
      "5-mid": "4.79",
      "5-bound": [4.39, 5.26],
      "10-mid": "5.69",
      "10-bound": [5.21, 6.25],
      "25-mid": "7.06",
      "25-bound": [6.41, 7.72],
      "50-mid": "8.24",
      "50-bound": [7.44, 8.99],
      "100-mid": "9.56",
      "100-bound": [8.56, 10.4]
    },
    "3day": {
      "2-mid": "3.93",
      "2-bound": [3.62, 4.31],
      "5-mid": "5.03",
      "5-bound": [4.62, 5.51],
      "10-mid": "5.97",
      "10-bound": [5.48, 6.54],
      "25-mid": "7.39",
      "25-bound": [6.73, 8.07],
      "50-mid": "8.62",
      "50-bound": [7.8, 9.39],
      "100-mid": "9.98",
      "100-bound": [8.96, 10.8]
    },
    "4day": {
      "2-mid": "4.12",
      "2-bound": [3.8, 4.51],
      "5-mid": "5.28",
      "5-bound": [4.86, 5.77],
      "10-mid": "6.26",
      "10-bound": [5.75, 6.83],
      "25-mid": "7.73",
      "25-bound": [7.05, 8.42],
      "50-mid": "9.0",
      "50-bound": [8.15, 9.78],
      "100-mid": "10.4",
      "100-bound": [9.36, 11.3]
    },
    "7day": {
      "2-mid": "4.78",
      "2-bound": [4.42, 5.2],
      "5-mid": "6.04",
      "5-bound": [5.58, 6.56],
      "10-mid": "7.11",
      "10-bound": [6.55, 7.72],
      "25-mid": "8.7",
      "25-bound": [7.97, 9.43],
      "50-mid": "10.1",
      "50-bound": [9.16, 10.9],
      "100-mid": "11.6",
      "100-bound": [10.5, 12.5]
    }
  },
  "USC00362323 6": {
    "fips": "42113",
    "station_name": "DUSHORE",
    "state": "PA",
    "latitude": "41.5210",
    "longitude": "-76.4040",
    "5min": {
      "2-mid": "0.37",
      "2-bound": [0.34, 0.41],
      "5-mid": "0.43",
      "5-bound": [0.4, 0.47],
      "10-mid": "0.47",
      "10-bound": [0.43, 0.52],
      "25-mid": "0.52",
      "25-bound": [0.47, 0.57],
      "50-mid": "0.55",
      "50-bound": [0.5, 0.61],
      "100-mid": "0.58",
      "100-bound": [0.53, 0.64]
    },
    "10min": {
      "2-mid": "0.58",
      "2-bound": [0.53, 0.64],
      "5-mid": "0.67",
      "5-bound": [0.61, 0.74],
      "10-mid": "0.73",
      "10-bound": [0.67, 0.8],
      "25-mid": "0.8",
      "25-bound": [0.72, 0.87],
      "50-mid": "0.84",
      "50-bound": [0.76, 0.92],
      "100-mid": "0.88",
      "100-bound": [0.79, 0.96]
    },
    "15min": {
      "2-mid": "0.71",
      "2-bound": [0.65, 0.78],
      "5-mid": "0.83",
      "5-bound": [0.75, 0.91],
      "10-mid": "0.9",
      "10-bound": [0.82, 0.99],
      "25-mid": "0.99",
      "25-bound": [0.89, 1.08],
      "50-mid": "1.04",
      "50-bound": [0.94, 1.14],
      "100-mid": "1.09",
      "100-bound": [0.98, 1.2]
    },
    "30min": {
      "2-mid": "0.95",
      "2-bound": [0.87, 1.05],
      "5-mid": "1.13",
      "5-bound": [1.03, 1.24],
      "10-mid": "1.25",
      "10-bound": [1.14, 1.37],
      "25-mid": "1.39",
      "25-bound": [1.26, 1.52],
      "50-mid": "1.49",
      "50-bound": [1.35, 1.63],
      "100-mid": "1.58",
      "100-bound": [1.42, 1.73]
    },
    "60min": {
      "2-mid": "1.17",
      "2-bound": [1.07, 1.28],
      "5-mid": "1.42",
      "5-bound": [1.3, 1.56],
      "10-mid": "1.59",
      "10-bound": [1.45, 1.74],
      "25-mid": "1.8",
      "25-bound": [1.64, 1.97],
      "50-mid": "1.96",
      "50-bound": [1.77, 2.15],
      "100-mid": "2.11",
      "100-bound": [1.9, 2.31]
    },
    "2hr": {
      "2-mid": "1.34",
      "2-bound": [1.22, 1.47],
      "5-mid": "1.64",
      "5-bound": [1.49, 1.8],
      "10-mid": "1.86",
      "10-bound": [1.69, 2.04],
      "25-mid": "2.16",
      "25-bound": [1.96, 2.37],
      "50-mid": "2.4",
      "50-bound": [2.16, 2.63],
      "100-mid": "2.64",
      "100-bound": [2.36, 2.9]
    },
    "3hr": {
      "2-mid": "1.43",
      "2-bound": [1.31, 1.57],
      "5-mid": "1.75",
      "5-bound": [1.6, 1.93],
      "10-mid": "2.0",
      "10-bound": [1.82, 2.2],
      "25-mid": "2.35",
      "25-bound": [2.12, 2.58],
      "50-mid": "2.63",
      "50-bound": [2.36, 2.88],
      "100-mid": "2.92",
      "100-bound": [2.6, 3.2]
    },
    "6hr": {
      "2-mid": "1.8",
      "2-bound": [1.64, 1.99],
      "5-mid": "2.18",
      "5-bound": [1.98, 2.42],
      "10-mid": "2.49",
      "10-bound": [2.26, 2.75],
      "25-mid": "2.92",
      "25-bound": [2.63, 3.22],
      "50-mid": "3.26",
      "50-bound": [2.92, 3.6],
      "100-mid": "3.62",
      "100-bound": [3.2, 3.98]
    },
    "12hr": {
      "2-mid": "2.21",
      "2-bound": [2.02, 2.44],
      "5-mid": "2.7",
      "5-bound": [2.46, 2.98],
      "10-mid": "3.09",
      "10-bound": [2.8, 3.41],
      "25-mid": "3.64",
      "25-bound": [3.27, 4.0],
      "50-mid": "4.09",
      "50-bound": [3.65, 4.5],
      "100-mid": "4.57",
      "100-bound": [4.04, 5.01]
    },
    "24hr": {
      "2-mid": "2.62",
      "2-bound": [2.42, 2.85],
      "5-mid": "3.2",
      "5-bound": [2.96, 3.47],
      "10-mid": "3.67",
      "10-bound": [3.38, 3.97],
      "25-mid": "4.32",
      "25-bound": [3.97, 4.67],
      "50-mid": "4.86",
      "50-bound": [4.43, 5.24],
      "100-mid": "5.41",
      "100-bound": [4.92, 5.83]
    },
    "2day": {
      "2-mid": "3.08",
      "2-bound": [2.83, 3.39],
      "5-mid": "3.75",
      "5-bound": [3.44, 4.13],
      "10-mid": "4.3",
      "10-bound": [3.93, 4.72],
      "25-mid": "5.07",
      "25-bound": [4.62, 5.56],
      "50-mid": "5.7",
      "50-bound": [5.18, 6.25],
      "100-mid": "6.37",
      "100-bound": [5.75, 6.97]
    },
    "3day": {
      "2-mid": "3.26",
      "2-bound": [3.0, 3.58],
      "5-mid": "3.95",
      "5-bound": [3.63, 4.34],
      "10-mid": "4.52",
      "10-bound": [4.14, 4.95],
      "25-mid": "5.3",
      "25-bound": [4.84, 5.81],
      "50-mid": "5.94",
      "50-bound": [5.41, 6.5],
      "100-mid": "6.61",
      "100-bound": [6.0, 7.22]
    },
    "4day": {
      "2-mid": "3.44",
      "2-bound": [3.17, 3.78],
      "5-mid": "4.16",
      "5-bound": [3.83, 4.56],
      "10-mid": "4.73",
      "10-bound": [4.35, 5.18],
      "25-mid": "5.53",
      "25-bound": [5.07, 6.05],
      "50-mid": "6.18",
      "50-bound": [5.65, 6.75],
      "100-mid": "6.86",
      "100-bound": [6.24, 7.48]
    },
    "7day": {
      "2-mid": "4.06",
      "2-bound": [3.77, 4.42],
      "5-mid": "4.79",
      "5-bound": [4.44, 5.22],
      "10-mid": "5.38",
      "10-bound": [4.98, 5.85],
      "25-mid": "6.18",
      "25-bound": [5.7, 6.71],
      "50-mid": "6.8",
      "50-bound": [6.26, 7.39],
      "100-mid": "7.44",
      "100-bound": [6.83, 8.09]
    }
  },
  "USC00449151 6": {
    "fips": "51199",
    "station_name": "WILLIAMSBURG 2 N",
    "state": "VA",
    "latitude": "37.3010",
    "longitude": "-76.7030",
    "5min": {
      "2-mid": "0.48",
      "2-bound": [0.43, 0.53],
      "5-mid": "0.56",
      "5-bound": [0.5, 0.62],
      "10-mid": "0.62",
      "10-bound": [0.56, 0.7],
      "25-mid": "0.7",
      "25-bound": [0.63, 0.78],
      "50-mid": "0.77",
      "50-bound": [0.69, 0.86],
      "100-mid": "0.83",
      "100-bound": [0.74, 0.93]
    },
    "10min": {
      "2-mid": "0.77",
      "2-bound": [0.69, 0.85],
      "5-mid": "0.89",
      "5-bound": [0.8, 0.99],
      "10-mid": "1.0",
      "10-bound": [0.9, 1.11],
      "25-mid": "1.12",
      "25-bound": [1.01, 1.25],
      "50-mid": "1.22",
      "50-bound": [1.1, 1.36],
      "100-mid": "1.32",
      "100-bound": [1.18, 1.47]
    },
    "15min": {
      "2-mid": "0.96",
      "2-bound": [0.87, 1.07],
      "5-mid": "1.12",
      "5-bound": [1.02, 1.25],
      "10-mid": "1.26",
      "10-bound": [1.14, 1.41],
      "25-mid": "1.42",
      "25-bound": [1.28, 1.58],
      "50-mid": "1.55",
      "50-bound": [1.39, 1.72],
      "100-mid": "1.67",
      "100-bound": [1.49, 1.86]
    },
    "30min": {
      "2-mid": "1.33",
      "2-bound": [1.2, 1.48],
      "5-mid": "1.6",
      "5-bound": [1.44, 1.78],
      "10-mid": "1.83",
      "10-bound": [1.65, 2.04],
      "25-mid": "2.11",
      "25-bound": [1.89, 2.35],
      "50-mid": "2.34",
      "50-bound": [2.09, 2.6],
      "100-mid": "2.56",
      "100-bound": [2.28, 2.85]
    },
    "60min": {
      "2-mid": "1.67",
      "2-bound": [1.51, 1.86],
      "5-mid": "2.05",
      "5-bound": [1.85, 2.28],
      "10-mid": "2.38",
      "10-bound": [2.15, 2.66],
      "25-mid": "2.81",
      "25-bound": [2.52, 3.12],
      "50-mid": "3.16",
      "50-bound": [2.83, 3.52],
      "100-mid": "3.52",
      "100-bound": [3.13, 3.92]
    },
    "2hr": {
      "2-mid": "2.0",
      "2-bound": [1.82, 2.22],
      "5-mid": "2.51",
      "5-bound": [2.27, 2.78],
      "10-mid": "2.97",
      "10-bound": [2.68, 3.28],
      "25-mid": "3.57",
      "25-bound": [3.21, 3.94],
      "50-mid": "4.09",
      "50-bound": [3.65, 4.51],
      "100-mid": "4.62",
      "100-bound": [4.11, 5.1]
    },
    "3hr": {
      "2-mid": "2.14",
      "2-bound": [1.94, 2.38],
      "5-mid": "2.69",
      "5-bound": [2.42, 2.99],
      "10-mid": "3.2",
      "10-bound": [2.89, 3.56],
      "25-mid": "3.89",
      "25-bound": [3.47, 4.31],
      "50-mid": "4.49",
      "50-bound": [3.99, 4.97],
      "100-mid": "5.12",
      "100-bound": [4.52, 5.66]
    },
    "6hr": {
      "2-mid": "2.58",
      "2-bound": [2.33, 2.9],
      "5-mid": "3.24",
      "5-bound": [2.91, 3.64],
      "10-mid": "3.87",
      "10-bound": [3.46, 4.34],
      "25-mid": "4.72",
      "25-bound": [4.2, 5.29],
      "50-mid": "5.49",
      "50-bound": [4.85, 6.12],
      "100-mid": "6.29",
      "100-bound": [5.52, 7.01]
    },
    "12hr": {
      "2-mid": "3.06",
      "2-bound": [2.7, 3.57],
      "5-mid": "3.88",
      "5-bound": [3.4, 4.52],
      "10-mid": "4.66",
      "10-bound": [4.06, 5.41],
      "25-mid": "5.73",
      "25-bound": [4.96, 6.65],
      "50-mid": "6.71",
      "50-bound": [5.77, 7.76],
      "100-mid": "7.76",
      "100-bound": [6.61, 8.96]
    },
    "24hr": {
      "2-mid": "3.57",
      "2-bound": [3.24, 4.0],
      "5-mid": "4.62",
      "5-bound": [4.18, 5.18],
      "10-mid": "5.51",
      "10-bound": [4.97, 6.18],
      "25-mid": "6.83",
      "25-bound": [6.11, 7.67],
      "50-mid": "7.97",
      "50-bound": [7.09, 8.95],
      "100-mid": "9.24",
      "100-bound": [8.12, 10.4]
    },
    "2day": {
      "2-mid": "4.16",
      "2-bound": [3.71, 4.73],
      "5-mid": "5.35",
      "5-bound": [4.77, 6.09],
      "10-mid": "6.37",
      "10-bound": [5.66, 7.24],
      "25-mid": "7.91",
      "25-bound": [6.96, 8.98],
      "50-mid": "9.24",
      "50-bound": [8.07, 10.5],
      "100-mid": "10.7",
      "100-bound": [9.27, 12.2]
    },
    "3day": {
      "2-mid": "4.39",
      "2-bound": [3.92, 5.0],
      "5-mid": "5.62",
      "5-bound": [5.02, 6.4],
      "10-mid": "6.66",
      "10-bound": [5.93, 7.57],
      "25-mid": "8.21",
      "25-bound": [7.25, 9.31],
      "50-mid": "9.54",
      "50-bound": [8.36, 10.8],
      "100-mid": "11.0",
      "100-bound": [9.56, 12.5]
    },
    "4day": {
      "2-mid": "4.62",
      "2-bound": [4.14, 5.26],
      "5-mid": "5.89",
      "5-bound": [5.27, 6.7],
      "10-mid": "6.96",
      "10-bound": [6.2, 7.89],
      "25-mid": "8.51",
      "25-bound": [7.54, 9.64],
      "50-mid": "9.83",
      "50-bound": [8.66, 11.1],
      "100-mid": "11.3",
      "100-bound": [9.85, 12.7]
    },
    "7day": {
      "2-mid": "5.38",
      "2-bound": [4.87, 6.02],
      "5-mid": "6.77",
      "5-bound": [6.13, 7.56],
      "10-mid": "7.93",
      "10-bound": [7.14, 8.85],
      "25-mid": "9.61",
      "25-bound": [8.6, 10.7],
      "50-mid": "11.0",
      "50-bound": [9.8, 12.3],
      "100-mid": "12.5",
      "100-bound": [11.1, 14.0]
    }
  },
  "USC00365109 6": {
    "fips": "42035",
    "station_name": "LOCK HAVEN SEWAGE PLANT",
    "state": "PA",
    "latitude": "41.1300",
    "longitude": "-77.4330",
    "5min": {
      "2-mid": "0.37",
      "2-bound": [0.34, 0.41],
      "5-mid": "0.44",
      "5-bound": [0.4, 0.48],
      "10-mid": "0.49",
      "10-bound": [0.44, 0.54],
      "25-mid": "0.54",
      "25-bound": [0.48, 0.6],
      "50-mid": "0.58",
      "50-bound": [0.52, 0.64],
      "100-mid": "0.61",
      "100-bound": [0.55, 0.68]
    },
    "10min": {
      "2-mid": "0.58",
      "2-bound": [0.53, 0.64],
      "5-mid": "0.68",
      "5-bound": [0.62, 0.75],
      "10-mid": "0.75",
      "10-bound": [0.68, 0.83],
      "25-mid": "0.83",
      "25-bound": [0.74, 0.91],
      "50-mid": "0.88",
      "50-bound": [0.79, 0.97],
      "100-mid": "0.93",
      "100-bound": [0.82, 1.02]
    },
    "15min": {
      "2-mid": "0.71",
      "2-bound": [0.64, 0.79],
      "5-mid": "0.84",
      "5-bound": [0.76, 0.93],
      "10-mid": "0.92",
      "10-bound": [0.83, 1.02],
      "25-mid": "1.02",
      "25-bound": [0.91, 1.13],
      "50-mid": "1.09",
      "50-bound": [0.97, 1.2],
      "100-mid": "1.15",
      "100-bound": [1.02, 1.27]
    },
    "30min": {
      "2-mid": "0.96",
      "2-bound": [0.86, 1.05],
      "5-mid": "1.15",
      "5-bound": [1.04, 1.27],
      "10-mid": "1.28",
      "10-bound": [1.15, 1.42],
      "25-mid": "1.44",
      "25-bound": [1.29, 1.59],
      "50-mid": "1.56",
      "50-bound": [1.39, 1.72],
      "100-mid": "1.66",
      "100-bound": [1.47, 1.83]
    },
    "60min": {
      "2-mid": "1.17",
      "2-bound": [1.05, 1.29],
      "5-mid": "1.44",
      "5-bound": [1.3, 1.59],
      "10-mid": "1.63",
      "10-bound": [1.47, 1.8],
      "25-mid": "1.87",
      "25-bound": [1.67, 2.06],
      "50-mid": "2.05",
      "50-bound": [1.83, 2.26],
      "100-mid": "2.22",
      "100-bound": [1.97, 2.45]
    },
    "2hr": {
      "2-mid": "1.34",
      "2-bound": [1.19, 1.51],
      "5-mid": "1.65",
      "5-bound": [1.46, 1.86],
      "10-mid": "1.89",
      "10-bound": [1.67, 2.12],
      "25-mid": "2.22",
      "25-bound": [1.94, 2.48],
      "50-mid": "2.48",
      "50-bound": [2.17, 2.77],
      "100-mid": "2.75",
      "100-bound": [2.38, 3.05]
    },
    "3hr": {
      "2-mid": "1.44",
      "2-bound": [1.28, 1.61],
      "5-mid": "1.77",
      "5-bound": [1.58, 1.98],
      "10-mid": "2.04",
      "10-bound": [1.81, 2.28],
      "25-mid": "2.4",
      "25-bound": [2.13, 2.68],
      "50-mid": "2.7",
      "50-bound": [2.38, 3.0],
      "100-mid": "3.01",
      "100-bound": [2.63, 3.34]
    },
    "6hr": {
      "2-mid": "1.8",
      "2-bound": [1.61, 2.04],
      "5-mid": "2.2",
      "5-bound": [1.96, 2.5],
      "10-mid": "2.52",
      "10-bound": [2.25, 2.85],
      "25-mid": "2.97",
      "25-bound": [2.63, 3.36],
      "50-mid": "3.34",
      "50-bound": [2.93, 3.77],
      "100-mid": "3.72",
      "100-bound": [3.24, 4.2]
    },
    "12hr": {
      "2-mid": "2.24",
      "2-bound": [2.02, 2.52],
      "5-mid": "2.74",
      "5-bound": [2.46, 3.09],
      "10-mid": "3.15",
      "10-bound": [2.81, 3.54],
      "25-mid": "3.73",
      "25-bound": [3.31, 4.18],
      "50-mid": "4.21",
      "50-bound": [3.7, 4.72],
      "100-mid": "4.72",
      "100-bound": [4.12, 5.29]
    },
    "24hr": {
      "2-mid": "2.68",
      "2-bound": [2.48, 2.93],
      "5-mid": "3.29",
      "5-bound": [3.03, 3.59],
      "10-mid": "3.78",
      "10-bound": [3.48, 4.12],
      "25-mid": "4.47",
      "25-bound": [4.1, 4.85],
      "50-mid": "5.04",
      "50-bound": [4.6, 5.46],
      "100-mid": "5.64",
      "100-bound": [5.12, 6.1]
    },
    "2day": {
      "2-mid": "3.11",
      "2-bound": [2.87, 3.39],
      "5-mid": "3.8",
      "5-bound": [3.5, 4.13],
      "10-mid": "4.36",
      "10-bound": [4.01, 4.73],
      "25-mid": "5.16",
      "25-bound": [4.73, 5.59],
      "50-mid": "5.82",
      "50-bound": [5.32, 6.3],
      "100-mid": "6.52",
      "100-bound": [5.94, 7.06]
    },
    "3day": {
      "2-mid": "3.3",
      "2-bound": [3.06, 3.58],
      "5-mid": "4.01",
      "5-bound": [3.72, 4.35],
      "10-mid": "4.59",
      "10-bound": [4.24, 4.97],
      "25-mid": "5.41",
      "25-bound": [4.98, 5.84],
      "50-mid": "6.09",
      "50-bound": [5.59, 6.57],
      "100-mid": "6.8",
      "100-bound": [6.22, 7.33]
    },
    "4day": {
      "2-mid": "3.48",
      "2-bound": [3.24, 3.77],
      "5-mid": "4.22",
      "5-bound": [3.92, 4.56],
      "10-mid": "4.82",
      "10-bound": [4.47, 5.2],
      "25-mid": "5.66",
      "25-bound": [5.24, 6.1],
      "50-mid": "6.36",
      "50-bound": [5.86, 6.84],
      "100-mid": "7.08",
      "100-bound": [6.5, 7.6]
    },
    "7day": {
      "2-mid": "4.1",
      "2-bound": [3.85, 4.38],
      "5-mid": "4.87",
      "5-bound": [4.57, 5.2],
      "10-mid": "5.49",
      "10-bound": [5.13, 5.84],
      "25-mid": "6.34",
      "25-bound": [5.91, 6.74],
      "50-mid": "7.01",
      "50-bound": [6.53, 7.47],
      "100-mid": "7.71",
      "100-bound": [7.15, 8.2]
    }
  },
  "USC00443640 6": {
    "fips": "51027",
    "station_name": "GRUNDY",
    "state": "VA",
    "latitude": "37.2821",
    "longitude": "-82.0884",
    "5min": {
      "2-mid": "0.36",
      "2-bound": [0.32, 0.4],
      "5-mid": "0.43",
      "5-bound": [0.38, 0.48],
      "10-mid": "0.48",
      "10-bound": [0.43, 0.54],
      "25-mid": "0.56",
      "25-bound": [0.49, 0.62],
      "50-mid": "0.62",
      "50-bound": [0.55, 0.69],
      "100-mid": "0.68",
      "100-bound": [0.6, 0.76]
    },
    "10min": {
      "2-mid": "0.57",
      "2-bound": [0.51, 0.64],
      "5-mid": "0.68",
      "5-bound": [0.61, 0.76],
      "10-mid": "0.77",
      "10-bound": [0.68, 0.86],
      "25-mid": "0.89",
      "25-bound": [0.78, 0.99],
      "50-mid": "0.98",
      "50-bound": [0.86, 1.09],
      "100-mid": "1.08",
      "100-bound": [0.94, 1.2]
    },
    "15min": {
      "2-mid": "0.72",
      "2-bound": [0.64, 0.8],
      "5-mid": "0.86",
      "5-bound": [0.77, 0.96],
      "10-mid": "0.97",
      "10-bound": [0.86, 1.08],
      "25-mid": "1.12",
      "25-bound": [0.99, 1.25],
      "50-mid": "1.24",
      "50-bound": [1.09, 1.38],
      "100-mid": "1.36",
      "100-bound": [1.19, 1.52]
    },
    "30min": {
      "2-mid": "0.99",
      "2-bound": [0.88, 1.1],
      "5-mid": "1.21",
      "5-bound": [1.08, 1.36],
      "10-mid": "1.4",
      "10-bound": [1.24, 1.56],
      "25-mid": "1.65",
      "25-bound": [1.46, 1.84],
      "50-mid": "1.86",
      "50-bound": [1.63, 2.07],
      "100-mid": "2.07",
      "100-bound": [1.8, 2.3]
    },
    "60min": {
      "2-mid": "1.23",
      "2-bound": [1.1, 1.38],
      "5-mid": "1.55",
      "5-bound": [1.39, 1.74],
      "10-mid": "1.81",
      "10-bound": [1.61, 2.03],
      "25-mid": "2.19",
      "25-bound": [1.94, 2.44],
      "50-mid": "2.5",
      "50-bound": [2.2, 2.79],
      "100-mid": "2.84",
      "100-bound": [2.48, 3.16]
    },
    "2hr": {
      "2-mid": "1.41",
      "2-bound": [1.26, 1.58],
      "5-mid": "1.77",
      "5-bound": [1.57, 1.99],
      "10-mid": "2.08",
      "10-bound": [1.84, 2.33],
      "25-mid": "2.54",
      "25-bound": [2.24, 2.84],
      "50-mid": "2.94",
      "50-bound": [2.57, 3.29],
      "100-mid": "3.37",
      "100-bound": [2.93, 3.78]
    },
    "3hr": {
      "2-mid": "1.5",
      "2-bound": [1.34, 1.7],
      "5-mid": "1.88",
      "5-bound": [1.67, 2.12],
      "10-mid": "2.2",
      "10-bound": [1.95, 2.48],
      "25-mid": "2.68",
      "25-bound": [2.36, 3.01],
      "50-mid": "3.08",
      "50-bound": [2.7, 3.47],
      "100-mid": "3.54",
      "100-bound": [3.07, 3.97]
    },
    "6hr": {
      "2-mid": "1.79",
      "2-bound": [1.61, 2.02],
      "5-mid": "2.21",
      "5-bound": [1.98, 2.49],
      "10-mid": "2.57",
      "10-bound": [2.29, 2.89],
      "25-mid": "3.1",
      "25-bound": [2.75, 3.48],
      "50-mid": "3.55",
      "50-bound": [3.13, 3.98],
      "100-mid": "4.05",
      "100-bound": [3.54, 4.54]
    },
    "12hr": {
      "2-mid": "2.12",
      "2-bound": [1.92, 2.36],
      "5-mid": "2.59",
      "5-bound": [2.35, 2.88],
      "10-mid": "3.0",
      "10-bound": [2.71, 3.34],
      "25-mid": "3.59",
      "25-bound": [3.23, 3.98],
      "50-mid": "4.09",
      "50-bound": [3.66, 4.54],
      "100-mid": "4.62",
      "100-bound": [4.1, 5.13]
    },
    "24hr": {
      "2-mid": "2.59",
      "2-bound": [2.39, 2.82],
      "5-mid": "3.16",
      "5-bound": [2.92, 3.45],
      "10-mid": "3.65",
      "10-bound": [3.36, 3.98],
      "25-mid": "4.34",
      "25-bound": [3.98, 4.72],
      "50-mid": "4.92",
      "50-bound": [4.48, 5.34],
      "100-mid": "5.53",
      "100-bound": [5.0, 6.02]
    },
    "2day": {
      "2-mid": "3.14",
      "2-bound": [2.91, 3.4],
      "5-mid": "3.82",
      "5-bound": [3.53, 4.13],
      "10-mid": "4.38",
      "10-bound": [4.04, 4.74],
      "25-mid": "5.17",
      "25-bound": [4.75, 5.59],
      "50-mid": "5.82",
      "50-bound": [5.32, 6.3],
      "100-mid": "6.51",
      "100-bound": [5.9, 7.06]
    },
    "3day": {
      "2-mid": "3.4",
      "2-bound": [3.16, 3.67],
      "5-mid": "4.12",
      "5-bound": [3.82, 4.44],
      "10-mid": "4.7",
      "10-bound": [4.35, 5.07],
      "25-mid": "5.53",
      "25-bound": [5.09, 5.96],
      "50-mid": "6.19",
      "50-bound": [5.68, 6.69],
      "100-mid": "6.89",
      "100-bound": [6.28, 7.46]
    },
    "4day": {
      "2-mid": "3.66",
      "2-bound": [3.41, 3.93],
      "5-mid": "4.42",
      "5-bound": [4.11, 4.75],
      "10-mid": "5.03",
      "10-bound": [4.67, 5.41],
      "25-mid": "5.88",
      "25-bound": [5.44, 6.33],
      "50-mid": "6.56",
      "50-bound": [6.04, 7.07],
      "100-mid": "7.28",
      "100-bound": [6.65, 7.86]
    },
    "7day": {
      "2-mid": "4.44",
      "2-bound": [4.16, 4.75],
      "5-mid": "5.28",
      "5-bound": [4.94, 5.65],
      "10-mid": "5.92",
      "10-bound": [5.53, 6.33],
      "25-mid": "6.74",
      "25-bound": [6.29, 7.22],
      "50-mid": "7.38",
      "50-bound": [6.86, 7.91],
      "100-mid": "8.0",
      "100-bound": [7.39, 8.58]
    }
  },
  "USC00441955 6": {
    "fips": "51031",
    "station_name": "CONCORD 4 SSW",
    "state": "VA",
    "latitude": "37.2810",
    "longitude": "-78.9590",
    "5min": {
      "2-mid": "0.4",
      "2-bound": [0.37, 0.45],
      "5-mid": "0.48",
      "5-bound": [0.43, 0.53],
      "10-mid": "0.54",
      "10-bound": [0.48, 0.59],
      "25-mid": "0.6",
      "25-bound": [0.54, 0.66],
      "50-mid": "0.65",
      "50-bound": [0.58, 0.72],
      "100-mid": "0.7",
      "100-bound": [0.62, 0.77]
    },
    "10min": {
      "2-mid": "0.65",
      "2-bound": [0.59, 0.71],
      "5-mid": "0.77",
      "5-bound": [0.69, 0.84],
      "10-mid": "0.86",
      "10-bound": [0.77, 0.94],
      "25-mid": "0.96",
      "25-bound": [0.86, 1.06],
      "50-mid": "1.04",
      "50-bound": [0.93, 1.14],
      "100-mid": "1.11",
      "100-bound": [0.99, 1.22]
    },
    "15min": {
      "2-mid": "0.81",
      "2-bound": [0.74, 0.9],
      "5-mid": "0.97",
      "5-bound": [0.87, 1.07],
      "10-mid": "1.08",
      "10-bound": [0.98, 1.19],
      "25-mid": "1.22",
      "25-bound": [1.1, 1.34],
      "50-mid": "1.31",
      "50-bound": [1.18, 1.44],
      "100-mid": "1.4",
      "100-bound": [1.25, 1.54]
    },
    "30min": {
      "2-mid": "1.12",
      "2-bound": [1.02, 1.24],
      "5-mid": "1.37",
      "5-bound": [1.24, 1.52],
      "10-mid": "1.57",
      "10-bound": [1.42, 1.73],
      "25-mid": "1.8",
      "25-bound": [1.62, 1.98],
      "50-mid": "1.98",
      "50-bound": [1.77, 2.17],
      "100-mid": "2.15",
      "100-bound": [1.91, 2.36]
    },
    "60min": {
      "2-mid": "1.41",
      "2-bound": [1.28, 1.56],
      "5-mid": "1.76",
      "5-bound": [1.59, 1.94],
      "10-mid": "2.05",
      "10-bound": [1.85, 2.25],
      "25-mid": "2.4",
      "25-bound": [2.16, 2.64],
      "50-mid": "2.68",
      "50-bound": [2.4, 2.95],
      "100-mid": "2.96",
      "100-bound": [2.64, 3.25]
    },
    "2hr": {
      "2-mid": "1.67",
      "2-bound": [1.5, 1.85],
      "5-mid": "2.1",
      "5-bound": [1.89, 2.33],
      "10-mid": "2.46",
      "10-bound": [2.21, 2.73],
      "25-mid": "2.93",
      "25-bound": [2.61, 3.24],
      "50-mid": "3.31",
      "50-bound": [2.94, 3.66],
      "100-mid": "3.7",
      "100-bound": [3.26, 4.08]
    },
    "3hr": {
      "2-mid": "1.8",
      "2-bound": [1.62, 2.0],
      "5-mid": "2.26",
      "5-bound": [2.03, 2.52],
      "10-mid": "2.64",
      "10-bound": [2.37, 2.94],
      "25-mid": "3.15",
      "25-bound": [2.81, 3.5],
      "50-mid": "3.56",
      "50-bound": [3.16, 3.95],
      "100-mid": "3.98",
      "100-bound": [3.51, 4.4]
    },
    "6hr": {
      "2-mid": "2.24",
      "2-bound": [2.02, 2.51],
      "5-mid": "2.81",
      "5-bound": [2.52, 3.14],
      "10-mid": "3.31",
      "10-bound": [2.96, 3.69],
      "25-mid": "3.97",
      "25-bound": [3.53, 4.42],
      "50-mid": "4.54",
      "50-bound": [4.01, 5.04],
      "100-mid": "5.13",
      "100-bound": [4.49, 5.69]
    },
    "12hr": {
      "2-mid": "2.76",
      "2-bound": [2.49, 3.09],
      "5-mid": "3.46",
      "5-bound": [3.12, 3.87],
      "10-mid": "4.11",
      "10-bound": [3.68, 4.58],
      "25-mid": "5.0",
      "25-bound": [4.44, 5.56],
      "50-mid": "5.78",
      "50-bound": [5.08, 6.4],
      "100-mid": "6.62",
      "100-bound": [5.75, 7.31]
    },
    "24hr": {
      "2-mid": "3.4",
      "2-bound": [3.12, 3.74],
      "5-mid": "4.34",
      "5-bound": [3.98, 4.78],
      "10-mid": "5.14",
      "10-bound": [4.69, 5.65],
      "25-mid": "6.32",
      "25-bound": [5.73, 6.92],
      "50-mid": "7.33",
      "50-bound": [6.61, 8.02],
      "100-mid": "8.44",
      "100-bound": [7.54, 9.22]
    },
    "2day": {
      "2-mid": "4.02",
      "2-bound": [3.69, 4.41],
      "5-mid": "5.11",
      "5-bound": [4.68, 5.6],
      "10-mid": "6.01",
      "10-bound": [5.48, 6.58],
      "25-mid": "7.31",
      "25-bound": [6.62, 8.0],
      "50-mid": "8.4",
      "50-bound": [7.58, 9.19],
      "100-mid": "9.57",
      "100-bound": [8.58, 10.5]
    },
    "3day": {
      "2-mid": "4.26",
      "2-bound": [3.9, 4.67],
      "5-mid": "5.41",
      "5-bound": [4.94, 5.93],
      "10-mid": "6.35",
      "10-bound": [5.78, 6.97],
      "25-mid": "7.72",
      "25-bound": [6.98, 8.45],
      "50-mid": "8.87",
      "50-bound": [7.98, 9.7],
      "100-mid": "10.1",
      "100-bound": [9.04, 11.0]
    },
    "4day": {
      "2-mid": "4.49",
      "2-bound": [4.1, 4.94],
      "5-mid": "5.7",
      "5-bound": [5.2, 6.26],
      "10-mid": "6.7",
      "10-bound": [6.08, 7.35],
      "25-mid": "8.13",
      "25-bound": [7.35, 8.9],
      "50-mid": "9.34",
      "50-bound": [8.39, 10.2],
      "100-mid": "10.6",
      "100-bound": [9.49, 11.6]
    },
    "7day": {
      "2-mid": "5.16",
      "2-bound": [4.74, 5.61],
      "5-mid": "6.44",
      "5-bound": [5.91, 7.01],
      "10-mid": "7.49",
      "10-bound": [6.86, 8.16],
      "25-mid": "9.01",
      "25-bound": [8.2, 9.79],
      "50-mid": "10.3",
      "50-bound": [9.29, 11.1],
      "100-mid": "11.6",
      "100-bound": [10.4, 12.6]
    }
  },
  "USC00188380 6": {
    "fips": "24047",
    "station_name": "SNOW HILL 4 N",
    "state": "MD",
    "latitude": "38.2317",
    "longitude": "-75.3760",
    "5min": {
      "2-mid": "0.43",
      "2-bound": [0.39, 0.48],
      "5-mid": "0.5",
      "5-bound": [0.45, 0.56],
      "10-mid": "0.57",
      "10-bound": [0.51, 0.63],
      "25-mid": "0.65",
      "25-bound": [0.57, 0.72],
      "50-mid": "0.71",
      "50-bound": [0.63, 0.79],
      "100-mid": "0.76",
      "100-bound": [0.68, 0.85]
    },
    "10min": {
      "2-mid": "0.69",
      "2-bound": [0.62, 0.77],
      "5-mid": "0.81",
      "5-bound": [0.72, 0.89],
      "10-mid": "0.91",
      "10-bound": [0.82, 1.01],
      "25-mid": "1.03",
      "25-bound": [0.92, 1.14],
      "50-mid": "1.12",
      "50-bound": [1.0, 1.25],
      "100-mid": "1.21",
      "100-bound": [1.07, 1.35]
    },
    "15min": {
      "2-mid": "0.87",
      "2-bound": [0.78, 0.96],
      "5-mid": "1.02",
      "5-bound": [0.92, 1.13],
      "10-mid": "1.15",
      "10-bound": [1.03, 1.28],
      "25-mid": "1.3",
      "25-bound": [1.16, 1.45],
      "50-mid": "1.42",
      "50-bound": [1.26, 1.58],
      "100-mid": "1.53",
      "100-bound": [1.36, 1.71]
    },
    "30min": {
      "2-mid": "1.2",
      "2-bound": [1.07, 1.33],
      "5-mid": "1.45",
      "5-bound": [1.3, 1.61],
      "10-mid": "1.67",
      "10-bound": [1.5, 1.85],
      "25-mid": "1.93",
      "25-bound": [1.72, 2.14],
      "50-mid": "2.14",
      "50-bound": [1.9, 2.38],
      "100-mid": "2.35",
      "100-bound": [2.08, 2.62]
    },
    "60min": {
      "2-mid": "1.5",
      "2-bound": [1.35, 1.67],
      "5-mid": "1.86",
      "5-bound": [1.67, 2.06],
      "10-mid": "2.18",
      "10-bound": [1.95, 2.41],
      "25-mid": "2.57",
      "25-bound": [2.29, 2.85],
      "50-mid": "2.9",
      "50-bound": [2.58, 3.23],
      "100-mid": "3.23",
      "100-bound": [2.86, 3.61]
    },
    "2hr": {
      "2-mid": "1.86",
      "2-bound": [1.65, 2.08],
      "5-mid": "2.32",
      "5-bound": [2.06, 2.6],
      "10-mid": "2.74",
      "10-bound": [2.43, 3.07],
      "25-mid": "3.27",
      "25-bound": [2.89, 3.66],
      "50-mid": "3.73",
      "50-bound": [3.27, 4.18],
      "100-mid": "4.19",
      "100-bound": [3.66, 4.71]
    },
    "3hr": {
      "2-mid": "2.02",
      "2-bound": [1.8, 2.28],
      "5-mid": "2.53",
      "5-bound": [2.25, 2.85],
      "10-mid": "3.01",
      "10-bound": [2.66, 3.38],
      "25-mid": "3.62",
      "25-bound": [3.18, 4.05],
      "50-mid": "4.15",
      "50-bound": [3.62, 4.65],
      "100-mid": "4.7",
      "100-bound": [4.07, 5.28]
    },
    "6hr": {
      "2-mid": "2.47",
      "2-bound": [2.19, 2.79],
      "5-mid": "3.08",
      "5-bound": [2.73, 3.48],
      "10-mid": "3.67",
      "10-bound": [3.24, 4.13],
      "25-mid": "4.46",
      "25-bound": [3.9, 5.02],
      "50-mid": "5.16",
      "50-bound": [4.48, 5.82],
      "100-mid": "5.9",
      "100-bound": [5.08, 6.67]
    },
    "12hr": {
      "2-mid": "2.92",
      "2-bound": [2.59, 3.32],
      "5-mid": "3.66",
      "5-bound": [3.23, 4.15],
      "10-mid": "4.41",
      "10-bound": [3.88, 4.99],
      "25-mid": "5.44",
      "25-bound": [4.74, 6.15],
      "50-mid": "6.39",
      "50-bound": [5.52, 7.23],
      "100-mid": "7.42",
      "100-bound": [6.34, 8.42]
    },
    "24hr": {
      "2-mid": "3.49",
      "2-bound": [3.21, 3.82],
      "5-mid": "4.54",
      "5-bound": [4.17, 4.97],
      "10-mid": "5.45",
      "10-bound": [4.99, 5.96],
      "25-mid": "6.83",
      "25-bound": [6.2, 7.44],
      "50-mid": "8.05",
      "50-bound": [7.26, 8.73],
      "100-mid": "9.42",
      "100-bound": [8.42, 10.2]
    },
    "2day": {
      "2-mid": "4.01",
      "2-bound": [3.7, 4.38],
      "5-mid": "5.22",
      "5-bound": [4.8, 5.7],
      "10-mid": "6.25",
      "10-bound": [5.73, 6.81],
      "25-mid": "7.82",
      "25-bound": [7.12, 8.5],
      "50-mid": "9.19",
      "50-bound": [8.31, 9.97],
      "100-mid": "10.7",
      "100-bound": [9.64, 11.6]
    },
    "3day": {
      "2-mid": "4.26",
      "2-bound": [3.93, 4.65],
      "5-mid": "5.51",
      "5-bound": [5.08, 6.01],
      "10-mid": "6.58",
      "10-bound": [6.05, 7.16],
      "25-mid": "8.19",
      "25-bound": [7.48, 8.89],
      "50-mid": "9.58",
      "50-bound": [8.7, 10.4],
      "100-mid": "11.1",
      "100-bound": [10.0, 12.1]
    },
    "4day": {
      "2-mid": "4.51",
      "2-bound": [4.17, 4.91],
      "5-mid": "5.8",
      "5-bound": [5.36, 6.32],
      "10-mid": "6.91",
      "10-bound": [6.36, 7.51],
      "25-mid": "8.56",
      "25-bound": [7.83, 9.28],
      "50-mid": "9.98",
      "50-bound": [9.08, 10.8],
      "100-mid": "11.6",
      "100-bound": [10.4, 12.5]
    },
    "7day": {
      "2-mid": "5.13",
      "2-bound": [4.76, 5.57],
      "5-mid": "6.5",
      "5-bound": [6.02, 7.05],
      "10-mid": "7.66",
      "10-bound": [7.08, 8.3],
      "25-mid": "9.38",
      "25-bound": [8.62, 10.1],
      "50-mid": "10.9",
      "50-bound": [9.92, 11.7],
      "100-mid": "12.5",
      "100-bound": [11.3, 13.4]
    }
  },
  "USC00365790 6": {
    "fips": "42027",
    "station_name": "MILLHEIM",
    "state": "PA",
    "latitude": "40.8840",
    "longitude": "-77.4700",
    "5min": {
      "2-mid": "0.41",
      "2-bound": [0.36, 0.47],
      "5-mid": "0.5",
      "5-bound": [0.44, 0.56],
      "10-mid": "0.56",
      "10-bound": [0.49, 0.63],
      "25-mid": "0.65",
      "25-bound": [0.57, 0.73],
      "50-mid": "0.72",
      "50-bound": [0.63, 0.81],
      "100-mid": "0.79",
      "100-bound": [0.69, 0.88]
    },
    "10min": {
      "2-mid": "0.64",
      "2-bound": [0.57, 0.73],
      "5-mid": "0.77",
      "5-bound": [0.68, 0.87],
      "10-mid": "0.86",
      "10-bound": [0.77, 0.97],
      "25-mid": "0.99",
      "25-bound": [0.87, 1.11],
      "50-mid": "1.09",
      "50-bound": [0.95, 1.22],
      "100-mid": "1.19",
      "100-bound": [1.03, 1.33]
    },
    "15min": {
      "2-mid": "0.79",
      "2-bound": [0.7, 0.89],
      "5-mid": "0.95",
      "5-bound": [0.84, 1.07],
      "10-mid": "1.06",
      "10-bound": [0.94, 1.2],
      "25-mid": "1.22",
      "25-bound": [1.08, 1.37],
      "50-mid": "1.35",
      "50-bound": [1.18, 1.51],
      "100-mid": "1.47",
      "100-bound": [1.28, 1.65]
    },
    "30min": {
      "2-mid": "1.05",
      "2-bound": [0.93, 1.19],
      "5-mid": "1.3",
      "5-bound": [1.15, 1.46],
      "10-mid": "1.48",
      "10-bound": [1.31, 1.66],
      "25-mid": "1.73",
      "25-bound": [1.52, 1.94],
      "50-mid": "1.92",
      "50-bound": [1.69, 2.16],
      "100-mid": "2.13",
      "100-bound": [1.86, 2.38]
    },
    "60min": {
      "2-mid": "1.29",
      "2-bound": [1.14, 1.46],
      "5-mid": "1.62",
      "5-bound": [1.44, 1.83],
      "10-mid": "1.88",
      "10-bound": [1.66, 2.11],
      "25-mid": "2.24",
      "25-bound": [1.98, 2.52],
      "50-mid": "2.54",
      "50-bound": [2.22, 2.85],
      "100-mid": "2.84",
      "100-bound": [2.48, 3.19]
    },
    "2hr": {
      "2-mid": "1.46",
      "2-bound": [1.28, 1.67],
      "5-mid": "1.84",
      "5-bound": [1.61, 2.1],
      "10-mid": "2.16",
      "10-bound": [1.88, 2.46],
      "25-mid": "2.63",
      "25-bound": [2.28, 2.98],
      "50-mid": "3.04",
      "50-bound": [2.62, 3.44],
      "100-mid": "3.52",
      "100-bound": [3.0, 3.96]
    },
    "3hr": {
      "2-mid": "1.56",
      "2-bound": [1.37, 1.77],
      "5-mid": "1.95",
      "5-bound": [1.72, 2.22],
      "10-mid": "2.29",
      "10-bound": [2.01, 2.6],
      "25-mid": "2.79",
      "25-bound": [2.44, 3.16],
      "50-mid": "3.24",
      "50-bound": [2.81, 3.65],
      "100-mid": "3.75",
      "100-bound": [3.23, 4.22]
    },
    "6hr": {
      "2-mid": "1.92",
      "2-bound": [1.7, 2.18],
      "5-mid": "2.39",
      "5-bound": [2.11, 2.72],
      "10-mid": "2.78",
      "10-bound": [2.46, 3.16],
      "25-mid": "3.38",
      "25-bound": [2.97, 3.82],
      "50-mid": "3.91",
      "50-bound": [3.4, 4.41],
      "100-mid": "4.52",
      "100-bound": [3.91, 5.08]
    },
    "12hr": {
      "2-mid": "2.37",
      "2-bound": [2.14, 2.65],
      "5-mid": "2.94",
      "5-bound": [2.64, 3.28],
      "10-mid": "3.43",
      "10-bound": [3.07, 3.82],
      "25-mid": "4.18",
      "25-bound": [3.72, 4.64],
      "50-mid": "4.86",
      "50-bound": [4.28, 5.37],
      "100-mid": "5.63",
      "100-bound": [4.93, 6.22]
    },
    "24hr": {
      "2-mid": "2.86",
      "2-bound": [2.63, 3.13],
      "5-mid": "3.55",
      "5-bound": [3.26, 3.88],
      "10-mid": "4.14",
      "10-bound": [3.79, 4.51],
      "25-mid": "5.04",
      "25-bound": [4.59, 5.47],
      "50-mid": "5.86",
      "50-bound": [5.3, 6.34],
      "100-mid": "6.79",
      "100-bound": [6.09, 7.32]
    },
    "2day": {
      "2-mid": "3.34",
      "2-bound": [3.06, 3.67],
      "5-mid": "4.13",
      "5-bound": [3.77, 4.54],
      "10-mid": "4.81",
      "10-bound": [4.38, 5.28],
      "25-mid": "5.86",
      "25-bound": [5.31, 6.42],
      "50-mid": "6.81",
      "50-bound": [6.12, 7.41],
      "100-mid": "7.89",
      "100-bound": [7.02, 8.58]
    },
    "3day": {
      "2-mid": "3.54",
      "2-bound": [3.24, 3.88],
      "5-mid": "4.35",
      "5-bound": [3.98, 4.78],
      "10-mid": "5.06",
      "10-bound": [4.62, 5.54],
      "25-mid": "6.14",
      "25-bound": [5.56, 6.71],
      "50-mid": "7.1",
      "50-bound": [6.4, 7.74],
      "100-mid": "8.2",
      "100-bound": [7.33, 8.93]
    },
    "4day": {
      "2-mid": "3.73",
      "2-bound": [3.43, 4.09],
      "5-mid": "4.57",
      "5-bound": [4.2, 5.01],
      "10-mid": "5.3",
      "10-bound": [4.85, 5.8],
      "25-mid": "6.41",
      "25-bound": [5.82, 7.0],
      "50-mid": "7.39",
      "50-bound": [6.67, 8.07],
      "100-mid": "8.51",
      "100-bound": [7.63, 9.28]
    },
    "7day": {
      "2-mid": "4.33",
      "2-bound": [4.01, 4.72],
      "5-mid": "5.25",
      "5-bound": [4.86, 5.72],
      "10-mid": "6.03",
      "10-bound": [5.56, 6.55],
      "25-mid": "7.21",
      "25-bound": [6.6, 7.84],
      "50-mid": "8.24",
      "50-bound": [7.51, 8.94],
      "100-mid": "9.39",
      "100-bound": [8.5, 10.2]
    }
  },
  "USC00079605 6": {
    "fips": "10003",
    "station_name": "WILMINGTON PORTER RES",
    "state": "DE",
    "latitude": "39.7730",
    "longitude": "-75.5410",
    "5min": {
      "2-mid": "0.42",
      "2-bound": [0.38, 0.46],
      "5-mid": "0.49",
      "5-bound": [0.45, 0.54],
      "10-mid": "0.54",
      "10-bound": [0.49, 0.6],
      "25-mid": "0.6",
      "25-bound": [0.54, 0.66],
      "50-mid": "0.64",
      "50-bound": [0.58, 0.71],
      "100-mid": "0.68",
      "100-bound": [0.61, 0.76]
    },
    "10min": {
      "2-mid": "0.67",
      "2-bound": [0.61, 0.74],
      "5-mid": "0.79",
      "5-bound": [0.71, 0.86],
      "10-mid": "0.87",
      "10-bound": [0.78, 0.95],
      "25-mid": "0.96",
      "25-bound": [0.86, 1.06],
      "50-mid": "1.02",
      "50-bound": [0.92, 1.13],
      "100-mid": "1.09",
      "100-bound": [0.97, 1.2]
    },
    "15min": {
      "2-mid": "0.84",
      "2-bound": [0.77, 0.93],
      "5-mid": "0.99",
      "5-bound": [0.9, 1.09],
      "10-mid": "1.1",
      "10-bound": [0.99, 1.2],
      "25-mid": "1.22",
      "25-bound": [1.1, 1.34],
      "50-mid": "1.3",
      "50-bound": [1.16, 1.43],
      "100-mid": "1.37",
      "100-bound": [1.23, 1.52]
    },
    "30min": {
      "2-mid": "1.16",
      "2-bound": [1.06, 1.28],
      "5-mid": "1.41",
      "5-bound": [1.28, 1.55],
      "10-mid": "1.59",
      "10-bound": [1.44, 1.75],
      "25-mid": "1.8",
      "25-bound": [1.62, 1.98],
      "50-mid": "1.95",
      "50-bound": [1.75, 2.15],
      "100-mid": "2.1",
      "100-bound": [1.88, 2.32]
    },
    "60min": {
      "2-mid": "1.46",
      "2-bound": [1.33, 1.6],
      "5-mid": "1.81",
      "5-bound": [1.64, 1.99],
      "10-mid": "2.07",
      "10-bound": [1.87, 2.27],
      "25-mid": "2.4",
      "25-bound": [2.16, 2.64],
      "50-mid": "2.65",
      "50-bound": [2.37, 2.91],
      "100-mid": "2.9",
      "100-bound": [2.59, 3.2]
    },
    "2hr": {
      "2-mid": "1.75",
      "2-bound": [1.58, 1.94],
      "5-mid": "2.18",
      "5-bound": [1.97, 2.41],
      "10-mid": "2.51",
      "10-bound": [2.26, 2.77],
      "25-mid": "2.94",
      "25-bound": [2.63, 3.25],
      "50-mid": "3.28",
      "50-bound": [2.92, 3.62],
      "100-mid": "3.62",
      "100-bound": [3.2, 4.01]
    },
    "3hr": {
      "2-mid": "1.89",
      "2-bound": [1.72, 2.09],
      "5-mid": "2.37",
      "5-bound": [2.14, 2.61],
      "10-mid": "2.73",
      "10-bound": [2.46, 3.01],
      "25-mid": "3.22",
      "25-bound": [2.88, 3.55],
      "50-mid": "3.6",
      "50-bound": [3.21, 3.97],
      "100-mid": "4.0",
      "100-bound": [3.53, 4.41]
    },
    "6hr": {
      "2-mid": "2.33",
      "2-bound": [2.11, 2.58],
      "5-mid": "2.9",
      "5-bound": [2.62, 3.22],
      "10-mid": "3.36",
      "10-bound": [3.03, 3.72],
      "25-mid": "4.0",
      "25-bound": [3.58, 4.44],
      "50-mid": "4.52",
      "50-bound": [4.02, 5.01],
      "100-mid": "5.08",
      "100-bound": [4.46, 5.63]
    },
    "12hr": {
      "2-mid": "2.83",
      "2-bound": [2.55, 3.17],
      "5-mid": "3.54",
      "5-bound": [3.19, 3.97],
      "10-mid": "4.14",
      "10-bound": [3.71, 4.63],
      "25-mid": "5.01",
      "25-bound": [4.44, 5.6],
      "50-mid": "5.74",
      "50-bound": [5.04, 6.42],
      "100-mid": "6.54",
      "100-bound": [5.66, 7.32]
    },
    "24hr": {
      "2-mid": "3.28",
      "2-bound": [3.02, 3.58],
      "5-mid": "4.13",
      "5-bound": [3.79, 4.52],
      "10-mid": "4.84",
      "10-bound": [4.43, 5.28],
      "25-mid": "5.87",
      "25-bound": [5.35, 6.4],
      "50-mid": "6.74",
      "50-bound": [6.1, 7.34],
      "100-mid": "7.69",
      "100-bound": [6.92, 8.36]
    },
    "2day": {
      "2-mid": "3.79",
      "2-bound": [3.48, 4.14],
      "5-mid": "4.78",
      "5-bound": [4.39, 5.22],
      "10-mid": "5.59",
      "10-bound": [5.12, 6.11],
      "25-mid": "6.75",
      "25-bound": [6.15, 7.37],
      "50-mid": "7.71",
      "50-bound": [7.0, 8.42],
      "100-mid": "8.75",
      "100-bound": [7.9, 9.54]
    },
    "3day": {
      "2-mid": "3.99",
      "2-bound": [3.67, 4.36],
      "5-mid": "5.02",
      "5-bound": [4.61, 5.48],
      "10-mid": "5.86",
      "10-bound": [5.37, 6.4],
      "25-mid": "7.06",
      "25-bound": [6.44, 7.7],
      "50-mid": "8.06",
      "50-bound": [7.32, 8.78],
      "100-mid": "9.13",
      "100-bound": [8.24, 9.93]
    },
    "4day": {
      "2-mid": "4.2",
      "2-bound": [3.86, 4.58],
      "5-mid": "5.26",
      "5-bound": [4.84, 5.74],
      "10-mid": "6.13",
      "10-bound": [5.62, 6.68],
      "25-mid": "7.38",
      "25-bound": [6.73, 8.03],
      "50-mid": "8.41",
      "50-bound": [7.63, 9.14],
      "100-mid": "9.51",
      "100-bound": [8.58, 10.3]
    },
    "7day": {
      "2-mid": "4.87",
      "2-bound": [4.52, 5.27],
      "5-mid": "6.03",
      "5-bound": [5.6, 6.53],
      "10-mid": "7.0",
      "10-bound": [6.48, 7.56],
      "25-mid": "8.38",
      "25-bound": [7.72, 9.05],
      "50-mid": "9.52",
      "50-bound": [8.73, 10.3],
      "100-mid": "10.7",
      "100-bound": [9.8, 11.6]
    }
  },
  "USW00014778 6": {
    "fips": "42081",
    "station_name": "WILLIAMSPORT REGIONAL AP",
    "state": "PA",
    "latitude": "41.2429",
    "longitude": "-76.9210",
    "5min": {
      "2-mid": "0.4",
      "2-bound": [0.36, 0.44],
      "5-mid": "0.47",
      "5-bound": [0.42, 0.51],
      "10-mid": "0.51",
      "10-bound": [0.46, 0.56],
      "25-mid": "0.56",
      "25-bound": [0.51, 0.62],
      "50-mid": "0.61",
      "50-bound": [0.55, 0.67],
      "100-mid": "0.65",
      "100-bound": [0.58, 0.71]
    },
    "10min": {
      "2-mid": "0.62",
      "2-bound": [0.57, 0.68],
      "5-mid": "0.72",
      "5-bound": [0.66, 0.79],
      "10-mid": "0.79",
      "10-bound": [0.71, 0.86],
      "25-mid": "0.86",
      "25-bound": [0.78, 0.94],
      "50-mid": "0.92",
      "50-bound": [0.83, 1.01],
      "100-mid": "0.97",
      "100-bound": [0.87, 1.07]
    },
    "15min": {
      "2-mid": "0.76",
      "2-bound": [0.69, 0.84],
      "5-mid": "0.89",
      "5-bound": [0.81, 0.97],
      "10-mid": "0.97",
      "10-bound": [0.88, 1.06],
      "25-mid": "1.07",
      "25-bound": [0.97, 1.17],
      "50-mid": "1.14",
      "50-bound": [1.03, 1.25],
      "100-mid": "1.21",
      "100-bound": [1.09, 1.32]
    },
    "30min": {
      "2-mid": "1.02",
      "2-bound": [0.93, 1.12],
      "5-mid": "1.22",
      "5-bound": [1.1, 1.33],
      "10-mid": "1.34",
      "10-bound": [1.22, 1.47],
      "25-mid": "1.51",
      "25-bound": [1.36, 1.65],
      "50-mid": "1.63",
      "50-bound": [1.47, 1.78],
      "100-mid": "1.74",
      "100-bound": [1.57, 1.91]
    },
    "60min": {
      "2-mid": "1.26",
      "2-bound": [1.14, 1.37],
      "5-mid": "1.52",
      "5-bound": [1.38, 1.67],
      "10-mid": "1.71",
      "10-bound": [1.55, 1.87],
      "25-mid": "1.95",
      "25-bound": [1.77, 2.14],
      "50-mid": "2.14",
      "50-bound": [1.94, 2.35],
      "100-mid": "2.33",
      "100-bound": [2.1, 2.56]
    },
    "2hr": {
      "2-mid": "1.42",
      "2-bound": [1.29, 1.56],
      "5-mid": "1.73",
      "5-bound": [1.58, 1.91],
      "10-mid": "2.0",
      "10-bound": [1.81, 2.19],
      "25-mid": "2.37",
      "25-bound": [2.13, 2.6],
      "50-mid": "2.69",
      "50-bound": [2.42, 2.95],
      "100-mid": "3.06",
      "100-bound": [2.72, 3.35]
    },
    "3hr": {
      "2-mid": "1.52",
      "2-bound": [1.38, 1.67],
      "5-mid": "1.87",
      "5-bound": [1.7, 2.06],
      "10-mid": "2.16",
      "10-bound": [1.96, 2.38],
      "25-mid": "2.6",
      "25-bound": [2.34, 2.86],
      "50-mid": "2.98",
      "50-bound": [2.67, 3.28],
      "100-mid": "3.42",
      "100-bound": [3.04, 3.76]
    },
    "6hr": {
      "2-mid": "1.9",
      "2-bound": [1.73, 2.1],
      "5-mid": "2.32",
      "5-bound": [2.11, 2.57],
      "10-mid": "2.69",
      "10-bound": [2.44, 2.97],
      "25-mid": "3.23",
      "25-bound": [2.9, 3.55],
      "50-mid": "3.71",
      "50-bound": [3.31, 4.08],
      "100-mid": "4.25",
      "100-bound": [3.76, 4.68]
    },
    "12hr": {
      "2-mid": "2.36",
      "2-bound": [2.14, 2.63],
      "5-mid": "2.9",
      "5-bound": [2.63, 3.23],
      "10-mid": "3.36",
      "10-bound": [3.04, 3.73],
      "25-mid": "4.07",
      "25-bound": [3.64, 4.51],
      "50-mid": "4.7",
      "50-bound": [4.17, 5.2],
      "100-mid": "5.42",
      "100-bound": [4.76, 6.02]
    },
    "24hr": {
      "2-mid": "2.85",
      "2-bound": [2.62, 3.15],
      "5-mid": "3.53",
      "5-bound": [3.24, 3.89],
      "10-mid": "4.12",
      "10-bound": [3.76, 4.52],
      "25-mid": "5.03",
      "25-bound": [4.57, 5.5],
      "50-mid": "5.87",
      "50-bound": [5.29, 6.39],
      "100-mid": "6.84",
      "100-bound": [6.12, 7.43]
    },
    "2day": {
      "2-mid": "3.34",
      "2-bound": [3.05, 3.68],
      "5-mid": "4.12",
      "5-bound": [3.75, 4.54],
      "10-mid": "4.8",
      "10-bound": [4.36, 5.28],
      "25-mid": "5.87",
      "25-bound": [5.29, 6.42],
      "50-mid": "6.84",
      "50-bound": [6.12, 7.46],
      "100-mid": "7.98",
      "100-bound": [7.08, 8.68]
    },
    "3day": {
      "2-mid": "3.54",
      "2-bound": [3.24, 3.92],
      "5-mid": "4.35",
      "5-bound": [3.97, 4.81],
      "10-mid": "5.05",
      "10-bound": [4.59, 5.57],
      "25-mid": "6.14",
      "25-bound": [5.54, 6.74],
      "50-mid": "7.12",
      "50-bound": [6.4, 7.81],
      "100-mid": "8.28",
      "100-bound": [7.38, 9.05]
    },
    "4day": {
      "2-mid": "3.74",
      "2-bound": [3.43, 4.16],
      "5-mid": "4.58",
      "5-bound": [4.19, 5.08],
      "10-mid": "5.29",
      "10-bound": [4.82, 5.86],
      "25-mid": "6.4",
      "25-bound": [5.8, 7.06],
      "50-mid": "7.41",
      "50-bound": [6.67, 8.15],
      "100-mid": "8.58",
      "100-bound": [7.67, 9.41]
    },
    "7day": {
      "2-mid": "4.34",
      "2-bound": [4.02, 4.73],
      "5-mid": "5.25",
      "5-bound": [4.85, 5.71],
      "10-mid": "6.03",
      "10-bound": [5.56, 6.55],
      "25-mid": "7.22",
      "25-bound": [6.61, 7.83],
      "50-mid": "8.29",
      "50-bound": [7.55, 8.98],
      "100-mid": "9.51",
      "100-bound": [8.59, 10.3]
    }
  },
  "USC00367931 6": {
    "fips": "42109",
    "station_name": "SELINSGROVE 2 S",
    "state": "PA",
    "latitude": "40.7830",
    "longitude": "-76.8610",
    "5min": {
      "2-mid": "0.41",
      "2-bound": [0.37, 0.45],
      "5-mid": "0.47",
      "5-bound": [0.43, 0.52],
      "10-mid": "0.52",
      "10-bound": [0.47, 0.58],
      "25-mid": "0.58",
      "25-bound": [0.53, 0.65],
      "50-mid": "0.63",
      "50-bound": [0.57, 0.7],
      "100-mid": "0.68",
      "100-bound": [0.61, 0.75]
    },
    "10min": {
      "2-mid": "0.63",
      "2-bound": [0.57, 0.7],
      "5-mid": "0.74",
      "5-bound": [0.67, 0.81],
      "10-mid": "0.81",
      "10-bound": [0.73, 0.89],
      "25-mid": "0.9",
      "25-bound": [0.81, 0.99],
      "50-mid": "0.96",
      "50-bound": [0.86, 1.06],
      "100-mid": "1.03",
      "100-bound": [0.92, 1.14]
    },
    "15min": {
      "2-mid": "0.78",
      "2-bound": [0.7, 0.86],
      "5-mid": "0.91",
      "5-bound": [0.82, 1.0],
      "10-mid": "1.0",
      "10-bound": [0.9, 1.1],
      "25-mid": "1.11",
      "25-bound": [1.0, 1.22],
      "50-mid": "1.19",
      "50-bound": [1.07, 1.32],
      "100-mid": "1.27",
      "100-bound": [1.14, 1.41]
    },
    "30min": {
      "2-mid": "1.04",
      "2-bound": [0.94, 1.15],
      "5-mid": "1.24",
      "5-bound": [1.12, 1.37],
      "10-mid": "1.39",
      "10-bound": [1.25, 1.53],
      "25-mid": "1.57",
      "25-bound": [1.42, 1.73],
      "50-mid": "1.71",
      "50-bound": [1.53, 1.89],
      "100-mid": "1.85",
      "100-bound": [1.65, 2.04]
    },
    "60min": {
      "2-mid": "1.28",
      "2-bound": [1.16, 1.41],
      "5-mid": "1.56",
      "5-bound": [1.41, 1.72],
      "10-mid": "1.77",
      "10-bound": [1.6, 1.95],
      "25-mid": "2.04",
      "25-bound": [1.84, 2.25],
      "50-mid": "2.25",
      "50-bound": [2.02, 2.49],
      "100-mid": "2.47",
      "100-bound": [2.21, 2.74]
    },
    "2hr": {
      "2-mid": "1.47",
      "2-bound": [1.33, 1.63],
      "5-mid": "1.82",
      "5-bound": [1.64, 2.01],
      "10-mid": "2.1",
      "10-bound": [1.89, 2.32],
      "25-mid": "2.51",
      "25-bound": [2.25, 2.78],
      "50-mid": "2.87",
      "50-bound": [2.55, 3.18],
      "100-mid": "3.27",
      "100-bound": [2.89, 3.62]
    },
    "3hr": {
      "2-mid": "1.59",
      "2-bound": [1.43, 1.77],
      "5-mid": "1.96",
      "5-bound": [1.77, 2.19],
      "10-mid": "2.28",
      "10-bound": [2.05, 2.55],
      "25-mid": "2.76",
      "25-bound": [2.46, 3.07],
      "50-mid": "3.17",
      "50-bound": [2.81, 3.53],
      "100-mid": "3.65",
      "100-bound": [3.21, 4.07]
    },
    "6hr": {
      "2-mid": "1.97",
      "2-bound": [1.78, 2.2],
      "5-mid": "2.43",
      "5-bound": [2.19, 2.72],
      "10-mid": "2.82",
      "10-bound": [2.54, 3.16],
      "25-mid": "3.41",
      "25-bound": [3.04, 3.81],
      "50-mid": "3.92",
      "50-bound": [3.48, 4.38],
      "100-mid": "4.52",
      "100-bound": [3.97, 5.05]
    },
    "12hr": {
      "2-mid": "2.41",
      "2-bound": [2.18, 2.68],
      "5-mid": "2.98",
      "5-bound": [2.69, 3.31],
      "10-mid": "3.47",
      "10-bound": [3.12, 3.85],
      "25-mid": "4.22",
      "25-bound": [3.77, 4.67],
      "50-mid": "4.89",
      "50-bound": [4.33, 5.41],
      "100-mid": "5.67",
      "100-bound": [4.98, 6.28]
    },
    "24hr": {
      "2-mid": "2.83",
      "2-bound": [2.62, 3.1],
      "5-mid": "3.51",
      "5-bound": [3.24, 3.83],
      "10-mid": "4.11",
      "10-bound": [3.78, 4.48],
      "25-mid": "5.06",
      "25-bound": [4.62, 5.48],
      "50-mid": "5.94",
      "50-bound": [5.38, 6.41],
      "100-mid": "6.99",
      "100-bound": [6.26, 7.5]
    },
    "2day": {
      "2-mid": "3.29",
      "2-bound": [3.02, 3.63],
      "5-mid": "4.07",
      "5-bound": [3.73, 4.48],
      "10-mid": "4.76",
      "10-bound": [4.35, 5.22],
      "25-mid": "5.86",
      "25-bound": [5.31, 6.4],
      "50-mid": "6.88",
      "50-bound": [6.19, 7.49],
      "100-mid": "8.08",
      "100-bound": [7.21, 8.78]
    },
    "3day": {
      "2-mid": "3.5",
      "2-bound": [3.23, 3.85],
      "5-mid": "4.31",
      "5-bound": [3.96, 4.73],
      "10-mid": "5.02",
      "10-bound": [4.6, 5.5],
      "25-mid": "6.16",
      "25-bound": [5.61, 6.72],
      "50-mid": "7.22",
      "50-bound": [6.52, 7.84],
      "100-mid": "8.46",
      "100-bound": [7.57, 9.17]
    },
    "4day": {
      "2-mid": "3.71",
      "2-bound": [3.43, 4.07],
      "5-mid": "4.55",
      "5-bound": [4.2, 4.98],
      "10-mid": "5.29",
      "10-bound": [4.86, 5.78],
      "25-mid": "6.46",
      "25-bound": [5.9, 7.04],
      "50-mid": "7.56",
      "50-bound": [6.84, 8.2],
      "100-mid": "8.84",
      "100-bound": [7.94, 9.56]
    },
    "7day": {
      "2-mid": "4.34",
      "2-bound": [4.04, 4.71],
      "5-mid": "5.28",
      "5-bound": [4.9, 5.71],
      "10-mid": "6.1",
      "10-bound": [5.65, 6.59],
      "25-mid": "7.4",
      "25-bound": [6.82, 7.97],
      "50-mid": "8.59",
      "50-bound": [7.85, 9.23],
      "100-mid": "9.98",
      "100-bound": [9.05, 10.7]
    }
  },
  "USW00013721 6": {
    "fips": "24037",
    "station_name": "PATUXENT RIVER NAS",
    "state": "MD",
    "latitude": "38.0000",
    "longitude": "-76.4166",
    "5min": {
      "2-mid": "0.45",
      "2-bound": [0.41, 0.49],
      "5-mid": "0.53",
      "5-bound": [0.48, 0.58],
      "10-mid": "0.59",
      "10-bound": [0.53, 0.65],
      "25-mid": "0.67",
      "25-bound": [0.6, 0.74],
      "50-mid": "0.73",
      "50-bound": [0.65, 0.81],
      "100-mid": "0.79",
      "100-bound": [0.7, 0.87]
    },
    "10min": {
      "2-mid": "0.72",
      "2-bound": [0.65, 0.79],
      "5-mid": "0.84",
      "5-bound": [0.76, 0.93],
      "10-mid": "0.95",
      "10-bound": [0.85, 1.04],
      "25-mid": "1.07",
      "25-bound": [0.96, 1.17],
      "50-mid": "1.16",
      "50-bound": [1.04, 1.28],
      "100-mid": "1.25",
      "100-bound": [1.12, 1.39]
    },
    "15min": {
      "2-mid": "0.9",
      "2-bound": [0.82, 0.99],
      "5-mid": "1.06",
      "5-bound": [0.96, 1.17],
      "10-mid": "1.2",
      "10-bound": [1.08, 1.32],
      "25-mid": "1.35",
      "25-bound": [1.21, 1.49],
      "50-mid": "1.47",
      "50-bound": [1.32, 1.62],
      "100-mid": "1.58",
      "100-bound": [1.41, 1.75]
    },
    "30min": {
      "2-mid": "1.25",
      "2-bound": [1.13, 1.37],
      "5-mid": "1.51",
      "5-bound": [1.37, 1.66],
      "10-mid": "1.74",
      "10-bound": [1.57, 1.91],
      "25-mid": "2.0",
      "25-bound": [1.8, 2.2],
      "50-mid": "2.22",
      "50-bound": [1.98, 2.45],
      "100-mid": "2.42",
      "100-bound": [2.16, 2.68]
    },
    "60min": {
      "2-mid": "1.56",
      "2-bound": [1.42, 1.72],
      "5-mid": "1.94",
      "5-bound": [1.76, 2.13],
      "10-mid": "2.26",
      "10-bound": [2.04, 2.48],
      "25-mid": "2.66",
      "25-bound": [2.4, 2.94],
      "50-mid": "3.0",
      "50-bound": [2.69, 3.32],
      "100-mid": "3.34",
      "100-bound": [2.97, 3.7]
    },
    "2hr": {
      "2-mid": "1.86",
      "2-bound": [1.69, 2.06],
      "5-mid": "2.33",
      "5-bound": [2.11, 2.58],
      "10-mid": "2.74",
      "10-bound": [2.47, 3.03],
      "25-mid": "3.28",
      "25-bound": [2.94, 3.62],
      "50-mid": "3.73",
      "50-bound": [3.33, 4.12],
      "100-mid": "4.2",
      "100-bound": [3.72, 4.65]
    },
    "3hr": {
      "2-mid": "2.02",
      "2-bound": [1.82, 2.25],
      "5-mid": "2.54",
      "5-bound": [2.28, 2.83],
      "10-mid": "3.0",
      "10-bound": [2.69, 3.33],
      "25-mid": "3.62",
      "25-bound": [3.21, 4.01],
      "50-mid": "4.14",
      "50-bound": [3.66, 4.59],
      "100-mid": "4.69",
      "100-bound": [4.11, 5.2]
    },
    "6hr": {
      "2-mid": "2.45",
      "2-bound": [2.21, 2.74],
      "5-mid": "3.07",
      "5-bound": [2.76, 3.43],
      "10-mid": "3.64",
      "10-bound": [3.26, 4.06],
      "25-mid": "4.42",
      "25-bound": [3.93, 4.92],
      "50-mid": "5.12",
      "50-bound": [4.5, 5.7],
      "100-mid": "5.85",
      "100-bound": [5.1, 6.52]
    },
    "12hr": {
      "2-mid": "2.92",
      "2-bound": [2.61, 3.3],
      "5-mid": "3.68",
      "5-bound": [3.28, 4.16],
      "10-mid": "4.4",
      "10-bound": [3.9, 4.97],
      "25-mid": "5.43",
      "25-bound": [4.76, 6.12],
      "50-mid": "6.36",
      "50-bound": [5.53, 7.17],
      "100-mid": "7.37",
      "100-bound": [6.33, 8.33]
    },
    "24hr": {
      "2-mid": "3.28",
      "2-bound": [2.94, 3.72],
      "5-mid": "4.26",
      "5-bound": [3.81, 4.82],
      "10-mid": "5.11",
      "10-bound": [4.55, 5.77],
      "25-mid": "6.4",
      "25-bound": [5.65, 7.21],
      "50-mid": "7.53",
      "50-bound": [6.61, 8.46],
      "100-mid": "8.81",
      "100-bound": [7.66, 9.87]
    },
    "2day": {
      "2-mid": "3.79",
      "2-bound": [3.41, 4.25],
      "5-mid": "4.93",
      "5-bound": [4.43, 5.52],
      "10-mid": "5.9",
      "10-bound": [5.28, 6.59],
      "25-mid": "7.37",
      "25-bound": [6.56, 8.21],
      "50-mid": "8.66",
      "50-bound": [7.65, 9.62],
      "100-mid": "10.1",
      "100-bound": [8.86, 11.2]
    },
    "3day": {
      "2-mid": "4.02",
      "2-bound": [3.63, 4.48],
      "5-mid": "5.19",
      "5-bound": [4.68, 5.79],
      "10-mid": "6.2",
      "10-bound": [5.57, 6.9],
      "25-mid": "7.71",
      "25-bound": [6.89, 8.56],
      "50-mid": "9.02",
      "50-bound": [8.02, 10.0],
      "100-mid": "10.5",
      "100-bound": [9.25, 11.6]
    },
    "4day": {
      "2-mid": "4.24",
      "2-bound": [3.84, 4.72],
      "5-mid": "5.46",
      "5-bound": [4.94, 6.07],
      "10-mid": "6.5",
      "10-bound": [5.87, 7.22],
      "25-mid": "8.05",
      "25-bound": [7.23, 8.91],
      "50-mid": "9.39",
      "50-bound": [8.38, 10.4],
      "100-mid": "10.9",
      "100-bound": [9.64, 12.0]
    },
    "7day": {
      "2-mid": "4.87",
      "2-bound": [4.45, 5.38],
      "5-mid": "6.17",
      "5-bound": [5.62, 6.81],
      "10-mid": "7.27",
      "10-bound": [6.61, 8.02],
      "25-mid": "8.9",
      "25-bound": [8.05, 9.8],
      "50-mid": "10.3",
      "50-bound": [9.27, 11.3],
      "100-mid": "11.8",
      "100-bound": [10.6, 13.0]
    }
  },
  "USC00188315 6": {
    "fips": "24023",
    "station_name": "SINES DEEP CREEK",
    "state": "MD",
    "latitude": "39.5220",
    "longitude": "-79.4130",
    "5min": {
      "2-mid": "0.36",
      "2-bound": [0.33, 0.41],
      "5-mid": "0.43",
      "5-bound": [0.38, 0.48],
      "10-mid": "0.49",
      "10-bound": [0.43, 0.55],
      "25-mid": "0.56",
      "25-bound": [0.49, 0.62],
      "50-mid": "0.62",
      "50-bound": [0.54, 0.69],
      "100-mid": "0.67",
      "100-bound": [0.59, 0.74]
    },
    "10min": {
      "2-mid": "0.57",
      "2-bound": [0.51, 0.64],
      "5-mid": "0.67",
      "5-bound": [0.6, 0.75],
      "10-mid": "0.75",
      "10-bound": [0.67, 0.84],
      "25-mid": "0.85",
      "25-bound": [0.75, 0.95],
      "50-mid": "0.94",
      "50-bound": [0.82, 1.04],
      "100-mid": "1.01",
      "100-bound": [0.89, 1.12]
    },
    "15min": {
      "2-mid": "0.69",
      "2-bound": [0.62, 0.78],
      "5-mid": "0.82",
      "5-bound": [0.73, 0.92],
      "10-mid": "0.93",
      "10-bound": [0.82, 1.04],
      "25-mid": "1.06",
      "25-bound": [0.93, 1.18],
      "50-mid": "1.16",
      "50-bound": [1.02, 1.29],
      "100-mid": "1.25",
      "100-bound": [1.1, 1.39]
    },
    "30min": {
      "2-mid": "0.93",
      "2-bound": [0.83, 1.04],
      "5-mid": "1.12",
      "5-bound": [1.0, 1.26],
      "10-mid": "1.29",
      "10-bound": [1.14, 1.44],
      "25-mid": "1.49",
      "25-bound": [1.32, 1.66],
      "50-mid": "1.65",
      "50-bound": [1.45, 1.84],
      "100-mid": "1.81",
      "100-bound": [1.59, 2.01]
    },
    "60min": {
      "2-mid": "1.14",
      "2-bound": [1.02, 1.28],
      "5-mid": "1.41",
      "5-bound": [1.26, 1.58],
      "10-mid": "1.64",
      "10-bound": [1.46, 1.83],
      "25-mid": "1.93",
      "25-bound": [1.71, 2.16],
      "50-mid": "2.18",
      "50-bound": [1.92, 2.42],
      "100-mid": "2.42",
      "100-bound": [2.12, 2.68]
    },
    "2hr": {
      "2-mid": "1.36",
      "2-bound": [1.22, 1.54],
      "5-mid": "1.68",
      "5-bound": [1.5, 1.89],
      "10-mid": "1.97",
      "10-bound": [1.75, 2.2],
      "25-mid": "2.34",
      "25-bound": [2.08, 2.62],
      "50-mid": "2.67",
      "50-bound": [2.35, 2.97],
      "100-mid": "2.99",
      "100-bound": [2.61, 3.32]
    },
    "3hr": {
      "2-mid": "1.46",
      "2-bound": [1.32, 1.64],
      "5-mid": "1.8",
      "5-bound": [1.62, 2.01],
      "10-mid": "2.1",
      "10-bound": [1.88, 2.34],
      "25-mid": "2.5",
      "25-bound": [2.22, 2.77],
      "50-mid": "2.84",
      "50-bound": [2.52, 3.15],
      "100-mid": "3.2",
      "100-bound": [2.82, 3.53]
    },
    "6hr": {
      "2-mid": "1.79",
      "2-bound": [1.61, 2.01],
      "5-mid": "2.18",
      "5-bound": [1.95, 2.44],
      "10-mid": "2.53",
      "10-bound": [2.26, 2.82],
      "25-mid": "3.0",
      "25-bound": [2.66, 3.34],
      "50-mid": "3.41",
      "50-bound": [3.02, 3.79],
      "100-mid": "3.82",
      "100-bound": [3.36, 4.24]
    },
    "12hr": {
      "2-mid": "2.18",
      "2-bound": [1.94, 2.51],
      "5-mid": "2.64",
      "5-bound": [2.34, 3.04],
      "10-mid": "3.06",
      "10-bound": [2.71, 3.51],
      "25-mid": "3.65",
      "25-bound": [3.21, 4.14],
      "50-mid": "4.15",
      "50-bound": [3.62, 4.7],
      "100-mid": "4.68",
      "100-bound": [4.05, 5.28]
    },
    "24hr": {
      "2-mid": "2.55",
      "2-bound": [2.35, 2.82],
      "5-mid": "3.12",
      "5-bound": [2.87, 3.44],
      "10-mid": "3.6",
      "10-bound": [3.3, 3.97],
      "25-mid": "4.28",
      "25-bound": [3.91, 4.72],
      "50-mid": "4.86",
      "50-bound": [4.41, 5.34],
      "100-mid": "5.47",
      "100-bound": [4.93, 6.01]
    },
    "2day": {
      "2-mid": "3.02",
      "2-bound": [2.79, 3.29],
      "5-mid": "3.65",
      "5-bound": [3.37, 3.98],
      "10-mid": "4.18",
      "10-bound": [3.84, 4.55],
      "25-mid": "4.92",
      "25-bound": [4.51, 5.36],
      "50-mid": "5.54",
      "50-bound": [5.05, 6.03],
      "100-mid": "6.19",
      "100-bound": [5.61, 6.73]
    },
    "3day": {
      "2-mid": "3.27",
      "2-bound": [3.04, 3.53],
      "5-mid": "3.94",
      "5-bound": [3.66, 4.25],
      "10-mid": "4.48",
      "10-bound": [4.16, 4.83],
      "25-mid": "5.25",
      "25-bound": [4.84, 5.65],
      "50-mid": "5.87",
      "50-bound": [5.39, 6.33],
      "100-mid": "6.52",
      "100-bound": [5.96, 7.03]
    },
    "4day": {
      "2-mid": "3.52",
      "2-bound": [3.29, 3.77],
      "5-mid": "4.22",
      "5-bound": [3.95, 4.52],
      "10-mid": "4.79",
      "10-bound": [4.47, 5.11],
      "25-mid": "5.57",
      "25-bound": [5.18, 5.94],
      "50-mid": "6.2",
      "50-bound": [5.73, 6.62],
      "100-mid": "6.85",
      "100-bound": [6.31, 7.32]
    },
    "7day": {
      "2-mid": "4.28",
      "2-bound": [4.01, 4.56],
      "5-mid": "5.06",
      "5-bound": [4.75, 5.39],
      "10-mid": "5.67",
      "10-bound": [5.32, 6.05],
      "25-mid": "6.5",
      "25-bound": [6.08, 6.93],
      "50-mid": "7.15",
      "50-bound": [6.66, 7.63],
      "100-mid": "7.79",
      "100-bound": [7.23, 8.33]
    }
  },
  "USC00443272 6": {
    "fips": "51640",
    "station_name": "GALAX WATER PLANT",
    "state": "VA",
    "latitude": "36.6545",
    "longitude": "-80.9173",
    "5min": {
      "2-mid": "0.37",
      "2-bound": [0.34, 0.41],
      "5-mid": "0.44",
      "5-bound": [0.4, 0.48],
      "10-mid": "0.5",
      "10-bound": [0.45, 0.55],
      "25-mid": "0.58",
      "25-bound": [0.52, 0.64],
      "50-mid": "0.64",
      "50-bound": [0.57, 0.71],
      "100-mid": "0.71",
      "100-bound": [0.61, 0.79]
    },
    "10min": {
      "2-mid": "0.59",
      "2-bound": [0.54, 0.65],
      "5-mid": "0.7",
      "5-bound": [0.64, 0.78],
      "10-mid": "0.8",
      "10-bound": [0.72, 0.88],
      "25-mid": "0.92",
      "25-bound": [0.82, 1.02],
      "50-mid": "1.02",
      "50-bound": [0.9, 1.14],
      "100-mid": "1.12",
      "100-bound": [0.97, 1.26]
    },
    "15min": {
      "2-mid": "0.74",
      "2-bound": [0.67, 0.81],
      "5-mid": "0.89",
      "5-bound": [0.81, 0.98],
      "10-mid": "1.01",
      "10-bound": [0.91, 1.11],
      "25-mid": "1.17",
      "25-bound": [1.05, 1.29],
      "50-mid": "1.3",
      "50-bound": [1.14, 1.44],
      "100-mid": "1.42",
      "100-bound": [1.23, 1.59]
    },
    "30min": {
      "2-mid": "1.02",
      "2-bound": [0.93, 1.12],
      "5-mid": "1.27",
      "5-bound": [1.15, 1.4],
      "10-mid": "1.46",
      "10-bound": [1.32, 1.61],
      "25-mid": "1.73",
      "25-bound": [1.55, 1.91],
      "50-mid": "1.95",
      "50-bound": [1.72, 2.17],
      "100-mid": "2.18",
      "100-bound": [1.89, 2.44]
    },
    "60min": {
      "2-mid": "1.28",
      "2-bound": [1.17, 1.41],
      "5-mid": "1.62",
      "5-bound": [1.48, 1.79],
      "10-mid": "1.9",
      "10-bound": [1.72, 2.1],
      "25-mid": "2.31",
      "25-bound": [2.06, 2.55],
      "50-mid": "2.64",
      "50-bound": [2.33, 2.94],
      "100-mid": "3.0",
      "100-bound": [2.6, 3.36]
    },
    "2hr": {
      "2-mid": "1.5",
      "2-bound": [1.37, 1.65],
      "5-mid": "1.91",
      "5-bound": [1.74, 2.09],
      "10-mid": "2.26",
      "10-bound": [2.04, 2.46],
      "25-mid": "2.76",
      "25-bound": [2.46, 3.03],
      "50-mid": "3.18",
      "50-bound": [2.79, 3.52],
      "100-mid": "3.64",
      "100-bound": [3.14, 4.06]
    },
    "3hr": {
      "2-mid": "1.62",
      "2-bound": [1.48, 1.79],
      "5-mid": "2.05",
      "5-bound": [1.88, 2.26],
      "10-mid": "2.41",
      "10-bound": [2.19, 2.66],
      "25-mid": "2.94",
      "25-bound": [2.63, 3.25],
      "50-mid": "3.4",
      "50-bound": [2.99, 3.78],
      "100-mid": "3.89",
      "100-bound": [3.36, 4.37]
    },
    "6hr": {
      "2-mid": "2.0",
      "2-bound": [1.82, 2.2],
      "5-mid": "2.52",
      "5-bound": [2.28, 2.77],
      "10-mid": "2.94",
      "10-bound": [2.65, 3.24],
      "25-mid": "3.54",
      "25-bound": [3.16, 3.94],
      "50-mid": "4.05",
      "50-bound": [3.57, 4.52],
      "100-mid": "4.6",
      "100-bound": [4.0, 5.18]
    },
    "12hr": {
      "2-mid": "2.47",
      "2-bound": [2.27, 2.7],
      "5-mid": "3.06",
      "5-bound": [2.8, 3.35],
      "10-mid": "3.52",
      "10-bound": [3.2, 3.86],
      "25-mid": "4.17",
      "25-bound": [3.76, 4.59],
      "50-mid": "4.68",
      "50-bound": [4.18, 5.16],
      "100-mid": "5.21",
      "100-bound": [4.6, 5.8]
    },
    "24hr": {
      "2-mid": "3.01",
      "2-bound": [2.75, 3.29],
      "5-mid": "3.78",
      "5-bound": [3.45, 4.13],
      "10-mid": "4.39",
      "10-bound": [4.0, 4.8],
      "25-mid": "5.24",
      "25-bound": [4.74, 5.73],
      "50-mid": "5.93",
      "50-bound": [5.32, 6.5],
      "100-mid": "6.64",
      "100-bound": [5.93, 7.3]
    },
    "2day": {
      "2-mid": "3.57",
      "2-bound": [3.26, 3.93],
      "5-mid": "4.47",
      "5-bound": [4.06, 4.92],
      "10-mid": "5.18",
      "10-bound": [4.69, 5.69],
      "25-mid": "6.18",
      "25-bound": [5.56, 6.8],
      "50-mid": "6.99",
      "50-bound": [6.24, 7.72],
      "100-mid": "7.84",
      "100-bound": [6.94, 8.69]
    },
    "3day": {
      "2-mid": "3.8",
      "2-bound": [3.5, 4.14],
      "5-mid": "4.74",
      "5-bound": [4.35, 5.16],
      "10-mid": "5.47",
      "10-bound": [5.01, 5.95],
      "25-mid": "6.49",
      "25-bound": [5.91, 7.07],
      "50-mid": "7.32",
      "50-bound": [6.63, 7.98],
      "100-mid": "8.17",
      "100-bound": [7.34, 8.94]
    },
    "4day": {
      "2-mid": "4.03",
      "2-bound": [3.74, 4.35],
      "5-mid": "5.0",
      "5-bound": [4.64, 5.39],
      "10-mid": "5.76",
      "10-bound": [5.33, 6.21],
      "25-mid": "6.81",
      "25-bound": [6.27, 7.34],
      "50-mid": "7.64",
      "50-bound": [7.01, 8.25],
      "100-mid": "8.5",
      "100-bound": [7.75, 9.19]
    },
    "7day": {
      "2-mid": "4.64",
      "2-bound": [4.34, 4.99],
      "5-mid": "5.66",
      "5-bound": [5.28, 6.07],
      "10-mid": "6.46",
      "10-bound": [6.01, 6.92],
      "25-mid": "7.53",
      "25-bound": [6.99, 8.08],
      "50-mid": "8.38",
      "50-bound": [7.74, 8.99],
      "100-mid": "9.24",
      "100-bound": [8.49, 9.94]
    }
  },
  "USC00300870 6": {
    "fips": "36067",
    "station_name": "BREWERTON LOCK 23",
    "state": "NY",
    "latitude": "43.2380",
    "longitude": "-76.1960",
    "5min": {
      "2-mid": "0.34",
      "2-bound": [0.28, 0.42],
      "5-mid": "0.43",
      "5-bound": [0.35, 0.53],
      "10-mid": "0.51",
      "10-bound": [0.41, 0.63],
      "25-mid": "0.61",
      "25-bound": [0.47, 0.78],
      "50-mid": "0.69",
      "50-bound": [0.52, 0.9],
      "100-mid": "0.77",
      "100-bound": [0.56, 1.04]
    },
    "10min": {
      "2-mid": "0.48",
      "2-bound": [0.39, 0.59],
      "5-mid": "0.61",
      "5-bound": [0.49, 0.75],
      "10-mid": "0.72",
      "10-bound": [0.58, 0.89],
      "25-mid": "0.87",
      "25-bound": [0.67, 1.11],
      "50-mid": "0.98",
      "50-bound": [0.74, 1.27],
      "100-mid": "1.1",
      "100-bound": [0.8, 1.47]
    },
    "15min": {
      "2-mid": "0.57",
      "2-bound": [0.46, 0.69],
      "5-mid": "0.72",
      "5-bound": [0.58, 0.88],
      "10-mid": "0.84",
      "10-bound": [0.68, 1.04],
      "25-mid": "1.02",
      "25-bound": [0.79, 1.3],
      "50-mid": "1.15",
      "50-bound": [0.87, 1.49],
      "100-mid": "1.29",
      "100-bound": [0.94, 1.72]
    },
    "30min": {
      "2-mid": "0.8",
      "2-bound": [0.66, 0.98],
      "5-mid": "1.02",
      "5-bound": [0.83, 1.25],
      "10-mid": "1.2",
      "10-bound": [0.97, 1.48],
      "25-mid": "1.45",
      "25-bound": [1.12, 1.85],
      "50-mid": "1.64",
      "50-bound": [1.23, 2.12],
      "100-mid": "1.83",
      "100-bound": [1.33, 2.45]
    },
    "60min": {
      "2-mid": "1.04",
      "2-bound": [0.85, 1.28],
      "5-mid": "1.32",
      "5-bound": [1.07, 1.62],
      "10-mid": "1.56",
      "10-bound": [1.25, 1.92],
      "25-mid": "1.88",
      "25-bound": [1.45, 2.4],
      "50-mid": "2.12",
      "50-bound": [1.6, 2.75],
      "100-mid": "2.37",
      "100-bound": [1.73, 3.18]
    },
    "2hr": {
      "2-mid": "1.32",
      "2-bound": [1.08, 1.61],
      "5-mid": "1.65",
      "5-bound": [1.35, 2.01],
      "10-mid": "1.92",
      "10-bound": [1.56, 2.36],
      "25-mid": "2.3",
      "25-bound": [1.8, 2.92],
      "50-mid": "2.59",
      "50-bound": [1.97, 3.33],
      "100-mid": "2.88",
      "100-bound": [2.12, 3.83]
    },
    "3hr": {
      "2-mid": "1.49",
      "2-bound": [1.23, 1.81],
      "5-mid": "1.85",
      "5-bound": [1.52, 2.25],
      "10-mid": "2.15",
      "10-bound": [1.75, 2.63],
      "25-mid": "2.56",
      "25-bound": [2.01, 3.24],
      "50-mid": "2.88",
      "50-bound": [2.2, 3.69],
      "100-mid": "3.2",
      "100-bound": [2.36, 4.23]
    },
    "6hr": {
      "2-mid": "1.79",
      "2-bound": [1.48, 2.16],
      "5-mid": "2.22",
      "5-bound": [1.83, 2.68],
      "10-mid": "2.57",
      "10-bound": [2.11, 3.12],
      "25-mid": "3.06",
      "25-bound": [2.41, 3.83],
      "50-mid": "3.42",
      "50-bound": [2.64, 4.36],
      "100-mid": "3.81",
      "100-bound": [2.84, 4.99]
    },
    "12hr": {
      "2-mid": "2.1",
      "2-bound": [1.76, 2.52],
      "5-mid": "2.61",
      "5-bound": [2.17, 3.13],
      "10-mid": "3.03",
      "10-bound": [2.5, 3.65],
      "25-mid": "3.61",
      "25-bound": [2.87, 4.49],
      "50-mid": "4.05",
      "50-bound": [3.14, 5.11],
      "100-mid": "4.5",
      "100-bound": [3.38, 5.84]
    },
    "24hr": {
      "2-mid": "2.44",
      "2-bound": [2.04, 2.89],
      "5-mid": "3.01",
      "5-bound": [2.52, 3.59],
      "10-mid": "3.49",
      "10-bound": [2.9, 4.18],
      "25-mid": "4.16",
      "25-bound": [3.33, 5.12],
      "50-mid": "4.66",
      "50-bound": [3.64, 5.82],
      "100-mid": "5.17",
      "100-bound": [3.91, 6.64]
    },
    "2day": {
      "2-mid": "2.81",
      "2-bound": [2.37, 3.32],
      "5-mid": "3.43",
      "5-bound": [2.89, 4.06],
      "10-mid": "3.95",
      "10-bound": [3.3, 4.69],
      "25-mid": "4.66",
      "25-bound": [3.76, 5.69],
      "50-mid": "5.2",
      "50-bound": [4.1, 6.44],
      "100-mid": "5.75",
      "100-bound": [4.38, 7.3]
    },
    "3day": {
      "2-mid": "3.1",
      "2-bound": [2.62, 3.64],
      "5-mid": "3.74",
      "5-bound": [3.16, 4.4],
      "10-mid": "4.27",
      "10-bound": [3.59, 5.05],
      "25-mid": "5.0",
      "25-bound": [4.06, 6.08],
      "50-mid": "5.56",
      "50-bound": [4.41, 6.85],
      "100-mid": "6.13",
      "100-bound": [4.69, 7.73]
    },
    "4day": {
      "2-mid": "3.35",
      "2-bound": [2.85, 3.92],
      "5-mid": "4.0",
      "5-bound": [3.39, 4.7],
      "10-mid": "4.55",
      "10-bound": [3.83, 5.36],
      "25-mid": "5.3",
      "25-bound": [4.31, 6.41],
      "50-mid": "5.87",
      "50-bound": [4.66, 7.2],
      "100-mid": "6.45",
      "100-bound": [4.95, 8.09]
    },
    "7day": {
      "2-mid": "4.01",
      "2-bound": [3.43, 4.68],
      "5-mid": "4.7",
      "5-bound": [4.01, 5.5],
      "10-mid": "5.28",
      "10-bound": [4.47, 6.19],
      "25-mid": "6.06",
      "25-bound": [4.96, 7.28],
      "50-mid": "6.68",
      "50-bound": [5.34, 8.12],
      "100-mid": "7.28",
      "100-bound": [5.61, 9.03]
    }
  },
  "USC00364896 6": {
    "fips": "42075",
    "station_name": "LEBANON 2 W",
    "state": "PA",
    "latitude": "40.3330",
    "longitude": "-76.4660",
    "5min": {
      "2-mid": "0.39",
      "2-bound": [0.36, 0.43],
      "5-mid": "0.46",
      "5-bound": [0.42, 0.51],
      "10-mid": "0.51",
      "10-bound": [0.46, 0.56],
      "25-mid": "0.57",
      "25-bound": [0.51, 0.63],
      "50-mid": "0.61",
      "50-bound": [0.55, 0.68],
      "100-mid": "0.66",
      "100-bound": [0.59, 0.72]
    },
    "10min": {
      "2-mid": "0.63",
      "2-bound": [0.57, 0.69],
      "5-mid": "0.74",
      "5-bound": [0.67, 0.81],
      "10-mid": "0.81",
      "10-bound": [0.74, 0.9],
      "25-mid": "0.9",
      "25-bound": [0.81, 0.99],
      "50-mid": "0.97",
      "50-bound": [0.87, 1.07],
      "100-mid": "1.03",
      "100-bound": [0.93, 1.14]
    },
    "15min": {
      "2-mid": "0.78",
      "2-bound": [0.71, 0.86],
      "5-mid": "0.93",
      "5-bound": [0.84, 1.02],
      "10-mid": "1.02",
      "10-bound": [0.93, 1.13],
      "25-mid": "1.14",
      "25-bound": [1.03, 1.26],
      "50-mid": "1.22",
      "50-bound": [1.1, 1.34],
      "100-mid": "1.3",
      "100-bound": [1.16, 1.43]
    },
    "30min": {
      "2-mid": "1.08",
      "2-bound": [0.98, 1.19],
      "5-mid": "1.31",
      "5-bound": [1.19, 1.44],
      "10-mid": "1.47",
      "10-bound": [1.33, 1.62],
      "25-mid": "1.67",
      "25-bound": [1.51, 1.84],
      "50-mid": "1.82",
      "50-bound": [1.64, 2.01],
      "100-mid": "1.97",
      "100-bound": [1.77, 2.17]
    },
    "60min": {
      "2-mid": "1.34",
      "2-bound": [1.22, 1.49],
      "5-mid": "1.67",
      "5-bound": [1.52, 1.84],
      "10-mid": "1.91",
      "10-bound": [1.73, 2.1],
      "25-mid": "2.22",
      "25-bound": [2.0, 2.44],
      "50-mid": "2.46",
      "50-bound": [2.21, 2.7],
      "100-mid": "2.7",
      "100-bound": [2.42, 2.97]
    },
    "2hr": {
      "2-mid": "1.59",
      "2-bound": [1.44, 1.75],
      "5-mid": "1.99",
      "5-bound": [1.81, 2.2],
      "10-mid": "2.32",
      "10-bound": [2.1, 2.55],
      "25-mid": "2.77",
      "25-bound": [2.5, 3.05],
      "50-mid": "3.15",
      "50-bound": [2.82, 3.46],
      "100-mid": "3.55",
      "100-bound": [3.17, 3.9]
    },
    "3hr": {
      "2-mid": "1.73",
      "2-bound": [1.58, 1.93],
      "5-mid": "2.18",
      "5-bound": [1.98, 2.42],
      "10-mid": "2.54",
      "10-bound": [2.3, 2.81],
      "25-mid": "3.05",
      "25-bound": [2.74, 3.36],
      "50-mid": "3.46",
      "50-bound": [3.09, 3.82],
      "100-mid": "3.92",
      "100-bound": [3.48, 4.32]
    },
    "6hr": {
      "2-mid": "2.15",
      "2-bound": [1.94, 2.4],
      "5-mid": "2.7",
      "5-bound": [2.43, 3.01],
      "10-mid": "3.15",
      "10-bound": [2.82, 3.51],
      "25-mid": "3.82",
      "25-bound": [3.4, 4.23],
      "50-mid": "4.38",
      "50-bound": [3.88, 4.85],
      "100-mid": "5.0",
      "100-bound": [4.39, 5.53]
    },
    "12hr": {
      "2-mid": "2.63",
      "2-bound": [2.37, 2.96],
      "5-mid": "3.33",
      "5-bound": [2.99, 3.73],
      "10-mid": "3.92",
      "10-bound": [3.5, 4.38],
      "25-mid": "4.8",
      "25-bound": [4.26, 5.35],
      "50-mid": "5.57",
      "50-bound": [4.9, 6.18],
      "100-mid": "6.43",
      "100-bound": [5.6, 7.13]
    },
    "24hr": {
      "2-mid": "3.02",
      "2-bound": [2.76, 3.35],
      "5-mid": "3.84",
      "5-bound": [3.51, 4.26],
      "10-mid": "4.55",
      "10-bound": [4.14, 5.04],
      "25-mid": "5.64",
      "25-bound": [5.08, 6.22],
      "50-mid": "6.6",
      "50-bound": [5.9, 7.26],
      "100-mid": "7.68",
      "100-bound": [6.81, 8.42]
    },
    "2day": {
      "2-mid": "3.52",
      "2-bound": [3.22, 3.9],
      "5-mid": "4.47",
      "5-bound": [4.08, 4.95],
      "10-mid": "5.28",
      "10-bound": [4.8, 5.84],
      "25-mid": "6.49",
      "25-bound": [5.86, 7.16],
      "50-mid": "7.54",
      "50-bound": [6.76, 8.32],
      "100-mid": "8.7",
      "100-bound": [7.74, 9.58]
    },
    "3day": {
      "2-mid": "3.72",
      "2-bound": [3.41, 4.11],
      "5-mid": "4.72",
      "5-bound": [4.32, 5.21],
      "10-mid": "5.57",
      "10-bound": [5.08, 6.14],
      "25-mid": "6.84",
      "25-bound": [6.2, 7.51],
      "50-mid": "7.94",
      "50-bound": [7.14, 8.71],
      "100-mid": "9.16",
      "100-bound": [8.18, 10.0]
    },
    "4day": {
      "2-mid": "3.92",
      "2-bound": [3.61, 4.32],
      "5-mid": "4.97",
      "5-bound": [4.56, 5.46],
      "10-mid": "5.86",
      "10-bound": [5.36, 6.43],
      "25-mid": "7.19",
      "25-bound": [6.53, 7.86],
      "50-mid": "8.34",
      "50-bound": [7.53, 9.11],
      "100-mid": "9.62",
      "100-bound": [8.61, 10.5]
    },
    "7day": {
      "2-mid": "4.61",
      "2-bound": [4.26, 5.05],
      "5-mid": "5.77",
      "5-bound": [5.32, 6.32],
      "10-mid": "6.76",
      "10-bound": [6.23, 7.38],
      "25-mid": "8.24",
      "25-bound": [7.54, 8.97],
      "50-mid": "9.52",
      "50-bound": [8.65, 10.3],
      "100-mid": "10.9",
      "100-bound": [9.86, 11.9]
    }
  },
  "USC00368449 6": {
    "fips": "42027",
    "station_name": "STATE COLLEGE",
    "state": "PA",
    "latitude": "40.7930",
    "longitude": "-77.8670",
    "5min": {
      "2-mid": "0.37",
      "2-bound": [0.33, 0.41],
      "5-mid": "0.45",
      "5-bound": [0.41, 0.5],
      "10-mid": "0.51",
      "10-bound": [0.46, 0.57],
      "25-mid": "0.6",
      "25-bound": [0.54, 0.66],
      "50-mid": "0.66",
      "50-bound": [0.59, 0.72],
      "100-mid": "0.72",
      "100-bound": [0.64, 0.79]
    },
    "10min": {
      "2-mid": "0.57",
      "2-bound": [0.52, 0.64],
      "5-mid": "0.7",
      "5-bound": [0.63, 0.77],
      "10-mid": "0.79",
      "10-bound": [0.71, 0.87],
      "25-mid": "0.91",
      "25-bound": [0.82, 1.0],
      "50-mid": "1.0",
      "50-bound": [0.89, 1.1],
      "100-mid": "1.09",
      "100-bound": [0.97, 1.19]
    },
    "15min": {
      "2-mid": "0.7",
      "2-bound": [0.64, 0.78],
      "5-mid": "0.86",
      "5-bound": [0.78, 0.95],
      "10-mid": "0.97",
      "10-bound": [0.88, 1.08],
      "25-mid": "1.13",
      "25-bound": [1.01, 1.24],
      "50-mid": "1.24",
      "50-bound": [1.1, 1.36],
      "100-mid": "1.36",
      "100-bound": [1.2, 1.48]
    },
    "30min": {
      "2-mid": "0.94",
      "2-bound": [0.85, 1.04],
      "5-mid": "1.18",
      "5-bound": [1.07, 1.3],
      "10-mid": "1.35",
      "10-bound": [1.22, 1.49],
      "25-mid": "1.59",
      "25-bound": [1.43, 1.75],
      "50-mid": "1.77",
      "50-bound": [1.58, 1.94],
      "100-mid": "1.96",
      "100-bound": [1.73, 2.14]
    },
    "60min": {
      "2-mid": "1.16",
      "2-bound": [1.04, 1.28],
      "5-mid": "1.48",
      "5-bound": [1.34, 1.63],
      "10-mid": "1.72",
      "10-bound": [1.56, 1.9],
      "25-mid": "2.07",
      "25-bound": [1.85, 2.27],
      "50-mid": "2.33",
      "50-bound": [2.08, 2.55],
      "100-mid": "2.62",
      "100-bound": [2.32, 2.86]
    },
    "2hr": {
      "2-mid": "1.33",
      "2-bound": [1.19, 1.48],
      "5-mid": "1.7",
      "5-bound": [1.52, 1.9],
      "10-mid": "1.99",
      "10-bound": [1.77, 2.22],
      "25-mid": "2.4",
      "25-bound": [2.13, 2.66],
      "50-mid": "2.74",
      "50-bound": [2.41, 3.03],
      "100-mid": "3.09",
      "100-bound": [2.71, 3.41]
    },
    "3hr": {
      "2-mid": "1.43",
      "2-bound": [1.29, 1.59],
      "5-mid": "1.81",
      "5-bound": [1.63, 2.01],
      "10-mid": "2.12",
      "10-bound": [1.9, 2.34],
      "25-mid": "2.56",
      "25-bound": [2.28, 2.81],
      "50-mid": "2.91",
      "50-bound": [2.58, 3.2],
      "100-mid": "3.3",
      "100-bound": [2.9, 3.61]
    },
    "6hr": {
      "2-mid": "1.77",
      "2-bound": [1.61, 1.95],
      "5-mid": "2.21",
      "5-bound": [2.0, 2.44],
      "10-mid": "2.57",
      "10-bound": [2.33, 2.82],
      "25-mid": "3.09",
      "25-bound": [2.78, 3.38],
      "50-mid": "3.52",
      "50-bound": [3.14, 3.84],
      "100-mid": "3.97",
      "100-bound": [3.51, 4.32]
    },
    "12hr": {
      "2-mid": "2.19",
      "2-bound": [2.0, 2.44],
      "5-mid": "2.73",
      "5-bound": [2.47, 3.02],
      "10-mid": "3.17",
      "10-bound": [2.87, 3.5],
      "25-mid": "3.82",
      "25-bound": [3.42, 4.2],
      "50-mid": "4.36",
      "50-bound": [3.88, 4.77],
      "100-mid": "4.94",
      "100-bound": [4.36, 5.39]
    },
    "24hr": {
      "2-mid": "2.64",
      "2-bound": [2.48, 2.83],
      "5-mid": "3.29",
      "5-bound": [3.07, 3.52],
      "10-mid": "3.82",
      "10-bound": [3.56, 4.08],
      "25-mid": "4.58",
      "25-bound": [4.25, 4.89],
      "50-mid": "5.23",
      "50-bound": [4.82, 5.58],
      "100-mid": "5.92",
      "100-bound": [5.42, 6.31]
    },
    "2day": {
      "2-mid": "3.05",
      "2-bound": [2.87, 3.28],
      "5-mid": "3.79",
      "5-bound": [3.55, 4.06],
      "10-mid": "4.4",
      "10-bound": [4.1, 4.7],
      "25-mid": "5.29",
      "25-bound": [4.9, 5.64],
      "50-mid": "6.03",
      "50-bound": [5.55, 6.42],
      "100-mid": "6.82",
      "100-bound": [6.24, 7.28]
    },
    "3day": {
      "2-mid": "3.24",
      "2-bound": [3.04, 3.48],
      "5-mid": "4.01",
      "5-bound": [3.76, 4.3],
      "10-mid": "4.65",
      "10-bound": [4.34, 4.97],
      "25-mid": "5.57",
      "25-bound": [5.17, 5.95],
      "50-mid": "6.34",
      "50-bound": [5.85, 6.76],
      "100-mid": "7.16",
      "100-bound": [6.57, 7.64]
    },
    "4day": {
      "2-mid": "3.43",
      "2-bound": [3.22, 3.67],
      "5-mid": "4.23",
      "5-bound": [3.97, 4.53],
      "10-mid": "4.9",
      "10-bound": [4.58, 5.24],
      "25-mid": "5.86",
      "25-bound": [5.44, 6.25],
      "50-mid": "6.65",
      "50-bound": [6.15, 7.1],
      "100-mid": "7.5",
      "100-bound": [6.9, 8.0]
    },
    "7day": {
      "2-mid": "4.03",
      "2-bound": [3.8, 4.28],
      "5-mid": "4.91",
      "5-bound": [4.62, 5.22],
      "10-mid": "5.62",
      "10-bound": [5.28, 5.97],
      "25-mid": "6.6",
      "25-bound": [6.17, 7.02],
      "50-mid": "7.4",
      "50-bound": [6.89, 7.87],
      "100-mid": "8.23",
      "100-bound": [7.62, 8.76]
    }
  },
  "USC00442941 6": {
    "fips": "51049",
    "station_name": "FARMVILLE 2 N",
    "state": "VA",
    "latitude": "37.3260",
    "longitude": "-78.3860",
    "5min": {
      "2-mid": "0.42",
      "2-bound": [0.38, 0.47],
      "5-mid": "0.49",
      "5-bound": [0.44, 0.55],
      "10-mid": "0.56",
      "10-bound": [0.5, 0.62],
      "25-mid": "0.62",
      "25-bound": [0.56, 0.69],
      "50-mid": "0.68",
      "50-bound": [0.6, 0.75],
      "100-mid": "0.72",
      "100-bound": [0.64, 0.8]
    },
    "10min": {
      "2-mid": "0.67",
      "2-bound": [0.61, 0.75],
      "5-mid": "0.79",
      "5-bound": [0.71, 0.88],
      "10-mid": "0.89",
      "10-bound": [0.8, 0.98],
      "25-mid": "0.99",
      "25-bound": [0.89, 1.1],
      "50-mid": "1.08",
      "50-bound": [0.96, 1.19],
      "100-mid": "1.15",
      "100-bound": [1.02, 1.27]
    },
    "15min": {
      "2-mid": "0.85",
      "2-bound": [0.76, 0.94],
      "5-mid": "0.99",
      "5-bound": [0.89, 1.11],
      "10-mid": "1.12",
      "10-bound": [1.01, 1.25],
      "25-mid": "1.26",
      "25-bound": [1.12, 1.39],
      "50-mid": "1.36",
      "50-bound": [1.21, 1.51],
      "100-mid": "1.45",
      "100-bound": [1.28, 1.6]
    },
    "30min": {
      "2-mid": "1.17",
      "2-bound": [1.05, 1.3],
      "5-mid": "1.41",
      "5-bound": [1.27, 1.57],
      "10-mid": "1.63",
      "10-bound": [1.46, 1.81],
      "25-mid": "1.86",
      "25-bound": [1.66, 2.06],
      "50-mid": "2.05",
      "50-bound": [1.82, 2.27],
      "100-mid": "2.22",
      "100-bound": [1.97, 2.46]
    },
    "60min": {
      "2-mid": "1.47",
      "2-bound": [1.32, 1.63],
      "5-mid": "1.81",
      "5-bound": [1.63, 2.02],
      "10-mid": "2.12",
      "10-bound": [1.9, 2.35],
      "25-mid": "2.48",
      "25-bound": [2.22, 2.75],
      "50-mid": "2.78",
      "50-bound": [2.47, 3.07],
      "100-mid": "3.06",
      "100-bound": [2.71, 3.39]
    },
    "2hr": {
      "2-mid": "1.74",
      "2-bound": [1.55, 1.95],
      "5-mid": "2.16",
      "5-bound": [1.93, 2.43],
      "10-mid": "2.55",
      "10-bound": [2.27, 2.86],
      "25-mid": "3.03",
      "25-bound": [2.68, 3.38],
      "50-mid": "3.44",
      "50-bound": [3.02, 3.84],
      "100-mid": "3.84",
      "100-bound": [3.35, 4.28]
    },
    "3hr": {
      "2-mid": "1.87",
      "2-bound": [1.67, 2.11],
      "5-mid": "2.33",
      "5-bound": [2.07, 2.62],
      "10-mid": "2.74",
      "10-bound": [2.44, 3.08],
      "25-mid": "3.26",
      "25-bound": [2.88, 3.65],
      "50-mid": "3.7",
      "50-bound": [3.24, 4.14],
      "100-mid": "4.13",
      "100-bound": [3.6, 4.62]
    },
    "6hr": {
      "2-mid": "2.29",
      "2-bound": [2.04, 2.6],
      "5-mid": "2.84",
      "5-bound": [2.52, 3.22],
      "10-mid": "3.36",
      "10-bound": [2.97, 3.8],
      "25-mid": "4.03",
      "25-bound": [3.54, 4.55],
      "50-mid": "4.62",
      "50-bound": [4.03, 5.2],
      "100-mid": "5.23",
      "100-bound": [4.52, 5.88]
    },
    "12hr": {
      "2-mid": "2.78",
      "2-bound": [2.49, 3.15],
      "5-mid": "3.46",
      "5-bound": [3.09, 3.92],
      "10-mid": "4.13",
      "10-bound": [3.67, 4.66],
      "25-mid": "5.02",
      "25-bound": [4.42, 5.64],
      "50-mid": "5.82",
      "50-bound": [5.08, 6.51],
      "100-mid": "6.66",
      "100-bound": [5.75, 7.43]
    },
    "24hr": {
      "2-mid": "3.32",
      "2-bound": [3.07, 3.64],
      "5-mid": "4.24",
      "5-bound": [3.91, 4.65],
      "10-mid": "5.02",
      "10-bound": [4.61, 5.49],
      "25-mid": "6.18",
      "25-bound": [5.63, 6.73],
      "50-mid": "7.16",
      "50-bound": [6.48, 7.8],
      "100-mid": "8.25",
      "100-bound": [7.4, 8.96]
    },
    "2day": {
      "2-mid": "3.89",
      "2-bound": [3.6, 4.25],
      "5-mid": "4.95",
      "5-bound": [4.56, 5.4],
      "10-mid": "5.82",
      "10-bound": [5.35, 6.34],
      "25-mid": "7.08",
      "25-bound": [6.47, 7.7],
      "50-mid": "8.14",
      "50-bound": [7.4, 8.84],
      "100-mid": "9.28",
      "100-bound": [8.38, 10.1]
    },
    "3day": {
      "2-mid": "4.13",
      "2-bound": [3.82, 4.5],
      "5-mid": "5.25",
      "5-bound": [4.84, 5.71],
      "10-mid": "6.17",
      "10-bound": [5.67, 6.71],
      "25-mid": "7.5",
      "25-bound": [6.85, 8.14],
      "50-mid": "8.61",
      "50-bound": [7.83, 9.34],
      "100-mid": "9.81",
      "100-bound": [8.86, 10.6]
    },
    "4day": {
      "2-mid": "4.36",
      "2-bound": [4.03, 4.75],
      "5-mid": "5.54",
      "5-bound": [5.11, 6.03],
      "10-mid": "6.51",
      "10-bound": [5.98, 7.07],
      "25-mid": "7.91",
      "25-bound": [7.24, 8.58],
      "50-mid": "9.08",
      "50-bound": [8.26, 9.84],
      "100-mid": "10.3",
      "100-bound": [9.33, 11.2]
    },
    "7day": {
      "2-mid": "4.98",
      "2-bound": [4.62, 5.41],
      "5-mid": "6.23",
      "5-bound": [5.76, 6.76],
      "10-mid": "7.25",
      "10-bound": [6.69, 7.86],
      "25-mid": "8.72",
      "25-bound": [8.01, 9.44],
      "50-mid": "9.93",
      "50-bound": [9.09, 10.8],
      "100-mid": "11.2",
      "100-bound": [10.2, 12.2]
    }
  },
  "USC00444148 6": {
    "fips": "51019",
    "station_name": "HUDDLESTON 4 SW",
    "state": "VA",
    "latitude": "37.1258",
    "longitude": "-79.5250",
    "5min": {
      "2-mid": "0.4",
      "2-bound": [0.36, 0.44],
      "5-mid": "0.47",
      "5-bound": [0.43, 0.52],
      "10-mid": "0.53",
      "10-bound": [0.48, 0.58],
      "25-mid": "0.6",
      "25-bound": [0.54, 0.66],
      "50-mid": "0.64",
      "50-bound": [0.58, 0.71],
      "100-mid": "0.69",
      "100-bound": [0.61, 0.76]
    },
    "10min": {
      "2-mid": "0.63",
      "2-bound": [0.57, 0.7],
      "5-mid": "0.76",
      "5-bound": [0.69, 0.84],
      "10-mid": "0.85",
      "10-bound": [0.77, 0.93],
      "25-mid": "0.95",
      "25-bound": [0.86, 1.04],
      "50-mid": "1.03",
      "50-bound": [0.92, 1.13],
      "100-mid": "1.1",
      "100-bound": [0.98, 1.2]
    },
    "15min": {
      "2-mid": "0.8",
      "2-bound": [0.72, 0.88],
      "5-mid": "0.96",
      "5-bound": [0.87, 1.06],
      "10-mid": "1.07",
      "10-bound": [0.97, 1.18],
      "25-mid": "1.21",
      "25-bound": [1.08, 1.32],
      "50-mid": "1.3",
      "50-bound": [1.16, 1.42],
      "100-mid": "1.39",
      "100-bound": [1.23, 1.52]
    },
    "30min": {
      "2-mid": "1.1",
      "2-bound": [1.0, 1.21],
      "5-mid": "1.36",
      "5-bound": [1.23, 1.5],
      "10-mid": "1.55",
      "10-bound": [1.4, 1.7],
      "25-mid": "1.79",
      "25-bound": [1.61, 1.96],
      "50-mid": "1.96",
      "50-bound": [1.75, 2.15],
      "100-mid": "2.12",
      "100-bound": [1.89, 2.33]
    },
    "60min": {
      "2-mid": "1.38",
      "2-bound": [1.25, 1.52],
      "5-mid": "1.75",
      "5-bound": [1.58, 1.93],
      "10-mid": "2.02",
      "10-bound": [1.83, 2.22],
      "25-mid": "2.38",
      "25-bound": [2.14, 2.61],
      "50-mid": "2.65",
      "50-bound": [2.37, 2.91],
      "100-mid": "2.92",
      "100-bound": [2.6, 3.21]
    },
    "2hr": {
      "2-mid": "1.62",
      "2-bound": [1.47, 1.8],
      "5-mid": "2.07",
      "5-bound": [1.88, 2.28],
      "10-mid": "2.42",
      "10-bound": [2.18, 2.66],
      "25-mid": "2.88",
      "25-bound": [2.59, 3.17],
      "50-mid": "3.25",
      "50-bound": [2.9, 3.56],
      "100-mid": "3.63",
      "100-bound": [3.21, 3.98]
    },
    "3hr": {
      "2-mid": "1.75",
      "2-bound": [1.59, 1.94],
      "5-mid": "2.23",
      "5-bound": [2.02, 2.46],
      "10-mid": "2.59",
      "10-bound": [2.34, 2.86],
      "25-mid": "3.1",
      "25-bound": [2.78, 3.41],
      "50-mid": "3.49",
      "50-bound": [3.11, 3.84],
      "100-mid": "3.9",
      "100-bound": [3.46, 4.28]
    },
    "6hr": {
      "2-mid": "2.17",
      "2-bound": [1.97, 2.41],
      "5-mid": "2.74",
      "5-bound": [2.49, 3.05],
      "10-mid": "3.21",
      "10-bound": [2.9, 3.56],
      "25-mid": "3.86",
      "25-bound": [3.46, 4.27],
      "50-mid": "4.4",
      "50-bound": [3.91, 4.85],
      "100-mid": "4.97",
      "100-bound": [4.38, 5.48]
    },
    "12hr": {
      "2-mid": "2.64",
      "2-bound": [2.39, 2.95],
      "5-mid": "3.35",
      "5-bound": [3.03, 3.73],
      "10-mid": "3.95",
      "10-bound": [3.55, 4.38],
      "25-mid": "4.82",
      "25-bound": [4.29, 5.32],
      "50-mid": "5.54",
      "50-bound": [4.89, 6.11],
      "100-mid": "6.34",
      "100-bound": [5.53, 6.98]
    },
    "24hr": {
      "2-mid": "3.29",
      "2-bound": [3.05, 3.59],
      "5-mid": "4.2",
      "5-bound": [3.88, 4.58],
      "10-mid": "4.96",
      "10-bound": [4.56, 5.4],
      "25-mid": "6.09",
      "25-bound": [5.57, 6.61],
      "50-mid": "7.06",
      "50-bound": [6.4, 7.64],
      "100-mid": "8.12",
      "100-bound": [7.3, 8.76]
    },
    "2day": {
      "2-mid": "3.9",
      "2-bound": [3.6, 4.22],
      "5-mid": "4.94",
      "5-bound": [4.57, 5.36],
      "10-mid": "5.81",
      "10-bound": [5.35, 6.28],
      "25-mid": "7.05",
      "25-bound": [6.46, 7.62],
      "50-mid": "8.1",
      "50-bound": [7.38, 8.74],
      "100-mid": "9.22",
      "100-bound": [8.35, 9.97]
    },
    "3day": {
      "2-mid": "4.12",
      "2-bound": [3.81, 4.47],
      "5-mid": "5.23",
      "5-bound": [4.83, 5.67],
      "10-mid": "6.14",
      "10-bound": [5.65, 6.65],
      "25-mid": "7.45",
      "25-bound": [6.81, 8.06],
      "50-mid": "8.54",
      "50-bound": [7.78, 9.23],
      "100-mid": "9.72",
      "100-bound": [8.79, 10.5]
    },
    "4day": {
      "2-mid": "4.35",
      "2-bound": [4.02, 4.72],
      "5-mid": "5.51",
      "5-bound": [5.08, 5.99],
      "10-mid": "6.47",
      "10-bound": [5.95, 7.02],
      "25-mid": "7.84",
      "25-bound": [7.16, 8.5],
      "50-mid": "8.99",
      "50-bound": [8.18, 9.73],
      "100-mid": "10.2",
      "100-bound": [9.23, 11.1]
    },
    "7day": {
      "2-mid": "4.99",
      "2-bound": [4.63, 5.42],
      "5-mid": "6.23",
      "5-bound": [5.76, 6.76],
      "10-mid": "7.24",
      "10-bound": [6.68, 7.85],
      "25-mid": "8.69",
      "25-bound": [7.98, 9.39],
      "50-mid": "9.88",
      "50-bound": [9.02, 10.7],
      "100-mid": "11.1",
      "100-bound": [10.1, 12.0]
    }
  },
  "USC00301752 6": {
    "fips": "36077",
    "station_name": "COOPERSTOWN",
    "state": "NY",
    "latitude": "42.7160",
    "longitude": "-74.9260",
    "5min": {
      "2-mid": "0.33",
      "2-bound": [0.27, 0.4],
      "5-mid": "0.42",
      "5-bound": [0.34, 0.51],
      "10-mid": "0.49",
      "10-bound": [0.4, 0.61],
      "25-mid": "0.6",
      "25-bound": [0.47, 0.77],
      "50-mid": "0.68",
      "50-bound": [0.51, 0.89],
      "100-mid": "0.76",
      "100-bound": [0.56, 1.04]
    },
    "10min": {
      "2-mid": "0.46",
      "2-bound": [0.38, 0.56],
      "5-mid": "0.59",
      "5-bound": [0.48, 0.72],
      "10-mid": "0.7",
      "10-bound": [0.57, 0.86],
      "25-mid": "0.85",
      "25-bound": [0.66, 1.09],
      "50-mid": "0.96",
      "50-bound": [0.73, 1.26],
      "100-mid": "1.07",
      "100-bound": [0.79, 1.48]
    },
    "15min": {
      "2-mid": "0.54",
      "2-bound": [0.45, 0.66],
      "5-mid": "0.7",
      "5-bound": [0.57, 0.85],
      "10-mid": "0.82",
      "10-bound": [0.67, 1.01],
      "25-mid": "1.0",
      "25-bound": [0.78, 1.28],
      "50-mid": "1.13",
      "50-bound": [0.86, 1.48],
      "100-mid": "1.26",
      "100-bound": [0.93, 1.74]
    },
    "30min": {
      "2-mid": "0.73",
      "2-bound": [0.6, 0.89],
      "5-mid": "0.94",
      "5-bound": [0.77, 1.15],
      "10-mid": "1.11",
      "10-bound": [0.9, 1.36],
      "25-mid": "1.35",
      "25-bound": [1.05, 1.74],
      "50-mid": "1.52",
      "50-bound": [1.16, 2.01],
      "100-mid": "1.71",
      "100-bound": [1.25, 2.35]
    },
    "60min": {
      "2-mid": "0.93",
      "2-bound": [0.76, 1.13],
      "5-mid": "1.19",
      "5-bound": [0.97, 1.45],
      "10-mid": "1.4",
      "10-bound": [1.14, 1.72],
      "25-mid": "1.7",
      "25-bound": [1.32, 2.19],
      "50-mid": "1.92",
      "50-bound": [1.46, 2.53],
      "100-mid": "2.15",
      "100-bound": [1.58, 2.96]
    },
    "2hr": {
      "2-mid": "1.16",
      "2-bound": [0.96, 1.41],
      "5-mid": "1.46",
      "5-bound": [1.21, 1.78],
      "10-mid": "1.71",
      "10-bound": [1.4, 2.09],
      "25-mid": "2.06",
      "25-bound": [1.61, 2.63],
      "50-mid": "2.32",
      "50-bound": [1.77, 3.02],
      "100-mid": "2.59",
      "100-bound": [1.9, 3.51]
    },
    "3hr": {
      "2-mid": "1.32",
      "2-bound": [1.1, 1.59],
      "5-mid": "1.66",
      "5-bound": [1.37, 2.0],
      "10-mid": "1.93",
      "10-bound": [1.58, 2.35],
      "25-mid": "2.31",
      "25-bound": [1.82, 2.94],
      "50-mid": "2.6",
      "50-bound": [1.99, 3.37],
      "100-mid": "2.9",
      "100-bound": [2.14, 3.91]
    },
    "6hr": {
      "2-mid": "1.64",
      "2-bound": [1.37, 1.96],
      "5-mid": "2.05",
      "5-bound": [1.71, 2.46],
      "10-mid": "2.39",
      "10-bound": [1.98, 2.89],
      "25-mid": "2.86",
      "25-bound": [2.27, 3.61],
      "50-mid": "3.21",
      "50-bound": [2.48, 4.14],
      "100-mid": "3.58",
      "100-bound": [2.66, 4.8]
    },
    "12hr": {
      "2-mid": "2.02",
      "2-bound": [1.7, 2.39],
      "5-mid": "2.54",
      "5-bound": [2.13, 3.03],
      "10-mid": "2.98",
      "10-bound": [2.47, 3.57],
      "25-mid": "3.58",
      "25-bound": [2.85, 4.48],
      "50-mid": "4.02",
      "50-bound": [3.12, 5.15],
      "100-mid": "4.5",
      "100-bound": [3.37, 6.0]
    },
    "24hr": {
      "2-mid": "2.42",
      "2-bound": [2.05, 2.85],
      "5-mid": "3.05",
      "5-bound": [2.57, 3.61],
      "10-mid": "3.58",
      "10-bound": [2.99, 4.25],
      "25-mid": "4.3",
      "25-bound": [3.45, 5.35],
      "50-mid": "4.84",
      "50-bound": [3.78, 6.15],
      "100-mid": "5.42",
      "100-bound": [4.07, 7.16]
    },
    "2day": {
      "2-mid": "2.83",
      "2-bound": [2.42, 3.32],
      "5-mid": "3.53",
      "5-bound": [3.0, 4.15],
      "10-mid": "4.11",
      "10-bound": [3.46, 4.86],
      "25-mid": "4.91",
      "25-bound": [3.96, 6.04],
      "50-mid": "5.51",
      "50-bound": [4.32, 6.92],
      "100-mid": "6.14",
      "100-bound": [4.63, 8.0]
    },
    "3day": {
      "2-mid": "3.13",
      "2-bound": [2.68, 3.65],
      "5-mid": "3.85",
      "5-bound": [3.28, 4.51],
      "10-mid": "4.45",
      "10-bound": [3.76, 5.24],
      "25-mid": "5.28",
      "25-bound": [4.26, 6.45],
      "50-mid": "5.9",
      "50-bound": [4.63, 7.35],
      "100-mid": "6.55",
      "100-bound": [4.93, 8.45]
    },
    "4day": {
      "2-mid": "3.38",
      "2-bound": [2.9, 3.93],
      "5-mid": "4.12",
      "5-bound": [3.52, 4.8],
      "10-mid": "4.73",
      "10-bound": [4.0, 5.54],
      "25-mid": "5.57",
      "25-bound": [4.51, 6.78],
      "50-mid": "6.2",
      "50-bound": [4.88, 7.69],
      "100-mid": "6.86",
      "100-bound": [5.17, 8.79]
    },
    "7day": {
      "2-mid": "4.03",
      "2-bound": [3.48, 4.66],
      "5-mid": "4.8",
      "5-bound": [4.12, 5.57],
      "10-mid": "5.43",
      "10-bound": [4.62, 6.33],
      "25-mid": "6.31",
      "25-bound": [5.13, 7.6],
      "50-mid": "6.97",
      "50-bound": [5.5, 8.55],
      "100-mid": "7.65",
      "100-bound": [5.76, 9.66]
    }
  },
  "USC00367029 6": {
    "fips": "42127",
    "station_name": "PLEASANT MOUNT 1 W",
    "state": "PA",
    "latitude": "41.7390",
    "longitude": "-75.4460",
    "5min": {
      "2-mid": "0.38",
      "2-bound": [0.34, 0.42],
      "5-mid": "0.44",
      "5-bound": [0.4, 0.49],
      "10-mid": "0.48",
      "10-bound": [0.44, 0.54],
      "25-mid": "0.54",
      "25-bound": [0.49, 0.6],
      "50-mid": "0.59",
      "50-bound": [0.53, 0.66],
      "100-mid": "0.64",
      "100-bound": [0.57, 0.71]
    },
    "10min": {
      "2-mid": "0.59",
      "2-bound": [0.53, 0.65],
      "5-mid": "0.68",
      "5-bound": [0.61, 0.76],
      "10-mid": "0.75",
      "10-bound": [0.67, 0.83],
      "25-mid": "0.83",
      "25-bound": [0.75, 0.92],
      "50-mid": "0.9",
      "50-bound": [0.8, 1.0],
      "100-mid": "0.96",
      "100-bound": [0.86, 1.07]
    },
    "15min": {
      "2-mid": "0.72",
      "2-bound": [0.65, 0.79],
      "5-mid": "0.84",
      "5-bound": [0.75, 0.93],
      "10-mid": "0.92",
      "10-bound": [0.83, 1.02],
      "25-mid": "1.03",
      "25-bound": [0.92, 1.14],
      "50-mid": "1.11",
      "50-bound": [0.99, 1.23],
      "100-mid": "1.19",
      "100-bound": [1.06, 1.33]
    },
    "30min": {
      "2-mid": "0.96",
      "2-bound": [0.87, 1.06],
      "5-mid": "1.15",
      "5-bound": [1.03, 1.27],
      "10-mid": "1.28",
      "10-bound": [1.15, 1.42],
      "25-mid": "1.45",
      "25-bound": [1.3, 1.61],
      "50-mid": "1.59",
      "50-bound": [1.42, 1.76],
      "100-mid": "1.72",
      "100-bound": [1.54, 1.92]
    },
    "60min": {
      "2-mid": "1.18",
      "2-bound": [1.07, 1.3],
      "5-mid": "1.44",
      "5-bound": [1.3, 1.59],
      "10-mid": "1.63",
      "10-bound": [1.46, 1.8],
      "25-mid": "1.88",
      "25-bound": [1.69, 2.09],
      "50-mid": "2.09",
      "50-bound": [1.87, 2.32],
      "100-mid": "2.3",
      "100-bound": [2.05, 2.56]
    },
    "2hr": {
      "2-mid": "1.38",
      "2-bound": [1.26, 1.52],
      "5-mid": "1.7",
      "5-bound": [1.55, 1.87],
      "10-mid": "1.96",
      "10-bound": [1.78, 2.15],
      "25-mid": "2.35",
      "25-bound": [2.12, 2.57],
      "50-mid": "2.68",
      "50-bound": [2.4, 2.94],
      "100-mid": "3.06",
      "100-bound": [2.72, 3.36]
    },
    "3hr": {
      "2-mid": "1.5",
      "2-bound": [1.38, 1.64],
      "5-mid": "1.85",
      "5-bound": [1.7, 2.02],
      "10-mid": "2.14",
      "10-bound": [1.96, 2.34],
      "25-mid": "2.58",
      "25-bound": [2.35, 2.82],
      "50-mid": "2.97",
      "50-bound": [2.68, 3.26],
      "100-mid": "3.42",
      "100-bound": [3.06, 3.77]
    },
    "6hr": {
      "2-mid": "1.91",
      "2-bound": [1.76, 2.09],
      "5-mid": "2.35",
      "5-bound": [2.16, 2.56],
      "10-mid": "2.72",
      "10-bound": [2.5, 2.97],
      "25-mid": "3.27",
      "25-bound": [2.98, 3.57],
      "50-mid": "3.77",
      "50-bound": [3.4, 4.12],
      "100-mid": "4.34",
      "100-bound": [3.88, 4.75]
    },
    "12hr": {
      "2-mid": "2.4",
      "2-bound": [2.2, 2.65],
      "5-mid": "2.96",
      "5-bound": [2.7, 3.27],
      "10-mid": "3.44",
      "10-bound": [3.13, 3.79],
      "25-mid": "4.17",
      "25-bound": [3.77, 4.6],
      "50-mid": "4.83",
      "50-bound": [4.32, 5.34],
      "100-mid": "5.59",
      "100-bound": [4.95, 6.19]
    },
    "24hr": {
      "2-mid": "3.0",
      "2-bound": [2.74, 3.33],
      "5-mid": "3.71",
      "5-bound": [3.38, 4.12],
      "10-mid": "4.33",
      "10-bound": [3.93, 4.8],
      "25-mid": "5.29",
      "25-bound": [4.76, 5.85],
      "50-mid": "6.18",
      "50-bound": [5.51, 6.8],
      "100-mid": "7.21",
      "100-bound": [6.36, 7.91]
    },
    "2day": {
      "2-mid": "3.53",
      "2-bound": [3.24, 3.88],
      "5-mid": "4.36",
      "5-bound": [4.0, 4.79],
      "10-mid": "5.09",
      "10-bound": [4.65, 5.58],
      "25-mid": "6.22",
      "25-bound": [5.64, 6.8],
      "50-mid": "7.26",
      "50-bound": [6.52, 7.91],
      "100-mid": "8.48",
      "100-bound": [7.54, 9.22]
    },
    "3day": {
      "2-mid": "3.72",
      "2-bound": [3.44, 4.07],
      "5-mid": "4.57",
      "5-bound": [4.22, 5.0],
      "10-mid": "5.32",
      "10-bound": [4.89, 5.8],
      "25-mid": "6.48",
      "25-bound": [5.91, 7.06],
      "50-mid": "7.55",
      "50-bound": [6.84, 8.2],
      "100-mid": "8.81",
      "100-bound": [7.9, 9.54]
    },
    "4day": {
      "2-mid": "3.9",
      "2-bound": [3.63, 4.26],
      "5-mid": "4.78",
      "5-bound": [4.44, 5.21],
      "10-mid": "5.54",
      "10-bound": [5.12, 6.02],
      "25-mid": "6.74",
      "25-bound": [6.19, 7.31],
      "50-mid": "7.84",
      "50-bound": [7.15, 8.48],
      "100-mid": "9.14",
      "100-bound": [8.25, 9.86]
    },
    "7day": {
      "2-mid": "4.65",
      "2-bound": [4.3, 5.05],
      "5-mid": "5.65",
      "5-bound": [5.21, 6.12],
      "10-mid": "6.51",
      "10-bound": [5.99, 7.05],
      "25-mid": "7.85",
      "25-bound": [7.18, 8.47],
      "50-mid": "9.06",
      "50-bound": [8.24, 9.77],
      "100-mid": "10.5",
      "100-bound": [9.45, 11.3]
    }
  },
  "USW00013728 6": {
    "fips": "51143",
    "station_name": "DANVILLE REGIONAL AIRPORT",
    "state": "VA",
    "latitude": "36.5720",
    "longitude": "-79.3350",
    "5min": {
      "2-mid": "0.44",
      "2-bound": [0.4, 0.48],
      "5-mid": "0.52",
      "5-bound": [0.47, 0.57],
      "10-mid": "0.57",
      "10-bound": [0.52, 0.63],
      "25-mid": "0.64",
      "25-bound": [0.58, 0.69],
      "50-mid": "0.68",
      "50-bound": [0.61, 0.74],
      "100-mid": "0.72",
      "100-bound": [0.65, 0.79]
    },
    "10min": {
      "2-mid": "0.7",
      "2-bound": [0.64, 0.77],
      "5-mid": "0.83",
      "5-bound": [0.76, 0.91],
      "10-mid": "0.92",
      "10-bound": [0.83, 1.0],
      "25-mid": "1.02",
      "25-bound": [0.92, 1.11],
      "50-mid": "1.08",
      "50-bound": [0.98, 1.18],
      "100-mid": "1.15",
      "100-bound": [1.03, 1.25]
    },
    "15min": {
      "2-mid": "0.88",
      "2-bound": [0.81, 0.97],
      "5-mid": "1.05",
      "5-bound": [0.96, 1.15],
      "10-mid": "1.16",
      "10-bound": [1.05, 1.27],
      "25-mid": "1.29",
      "25-bound": [1.17, 1.4],
      "50-mid": "1.37",
      "50-bound": [1.24, 1.5],
      "100-mid": "1.45",
      "100-bound": [1.3, 1.58]
    },
    "30min": {
      "2-mid": "1.22",
      "2-bound": [1.11, 1.34],
      "5-mid": "1.49",
      "5-bound": [1.36, 1.63],
      "10-mid": "1.68",
      "10-bound": [1.53, 1.84],
      "25-mid": "1.91",
      "25-bound": [1.73, 2.08],
      "50-mid": "2.06",
      "50-bound": [1.86, 2.25],
      "100-mid": "2.22",
      "100-bound": [1.99, 2.42]
    },
    "60min": {
      "2-mid": "1.53",
      "2-bound": [1.4, 1.68],
      "5-mid": "1.91",
      "5-bound": [1.74, 2.1],
      "10-mid": "2.19",
      "10-bound": [1.99, 2.39],
      "25-mid": "2.54",
      "25-bound": [2.3, 2.77],
      "50-mid": "2.8",
      "50-bound": [2.52, 3.05],
      "100-mid": "3.06",
      "100-bound": [2.74, 3.33]
    },
    "2hr": {
      "2-mid": "1.8",
      "2-bound": [1.64, 1.98],
      "5-mid": "2.27",
      "5-bound": [2.06, 2.49],
      "10-mid": "2.62",
      "10-bound": [2.37, 2.87],
      "25-mid": "3.09",
      "25-bound": [2.78, 3.37],
      "50-mid": "3.45",
      "50-bound": [3.09, 3.76],
      "100-mid": "3.82",
      "100-bound": [3.39, 4.17]
    },
    "3hr": {
      "2-mid": "1.93",
      "2-bound": [1.76, 2.13],
      "5-mid": "2.43",
      "5-bound": [2.21, 2.67],
      "10-mid": "2.81",
      "10-bound": [2.55, 3.08],
      "25-mid": "3.32",
      "25-bound": [2.99, 3.62],
      "50-mid": "3.7",
      "50-bound": [3.32, 4.04],
      "100-mid": "4.1",
      "100-bound": [3.66, 4.47]
    },
    "6hr": {
      "2-mid": "2.36",
      "2-bound": [2.15, 2.6],
      "5-mid": "2.96",
      "5-bound": [2.69, 3.26],
      "10-mid": "3.44",
      "10-bound": [3.12, 3.78],
      "25-mid": "4.1",
      "25-bound": [3.69, 4.5],
      "50-mid": "4.63",
      "50-bound": [4.14, 5.07],
      "100-mid": "5.19",
      "100-bound": [4.6, 5.67]
    },
    "12hr": {
      "2-mid": "2.83",
      "2-bound": [2.58, 3.12],
      "5-mid": "3.57",
      "5-bound": [3.25, 3.94],
      "10-mid": "4.18",
      "10-bound": [3.79, 4.6],
      "25-mid": "5.06",
      "25-bound": [4.54, 5.52],
      "50-mid": "5.77",
      "50-bound": [5.15, 6.29],
      "100-mid": "6.55",
      "100-bound": [5.78, 7.11]
    },
    "24hr": {
      "2-mid": "3.33",
      "2-bound": [3.09, 3.6],
      "5-mid": "4.21",
      "5-bound": [3.91, 4.55],
      "10-mid": "4.94",
      "10-bound": [4.58, 5.33],
      "25-mid": "5.99",
      "25-bound": [5.51, 6.44],
      "50-mid": "6.86",
      "50-bound": [6.28, 7.39],
      "100-mid": "7.81",
      "100-bound": [7.09, 8.4]
    },
    "2day": {
      "2-mid": "3.92",
      "2-bound": [3.64, 4.21],
      "5-mid": "4.92",
      "5-bound": [4.57, 5.28],
      "10-mid": "5.73",
      "10-bound": [5.31, 6.14],
      "25-mid": "6.87",
      "25-bound": [6.35, 7.36],
      "50-mid": "7.81",
      "50-bound": [7.18, 8.37],
      "100-mid": "8.8",
      "100-bound": [8.04, 9.44]
    },
    "3day": {
      "2-mid": "4.13",
      "2-bound": [3.85, 4.45],
      "5-mid": "5.18",
      "5-bound": [4.82, 5.57],
      "10-mid": "6.04",
      "10-bound": [5.6, 6.48],
      "25-mid": "7.24",
      "25-bound": [6.69, 7.77],
      "50-mid": "8.22",
      "50-bound": [7.56, 8.83],
      "100-mid": "9.27",
      "100-bound": [8.47, 9.97]
    },
    "4day": {
      "2-mid": "4.35",
      "2-bound": [4.05, 4.68],
      "5-mid": "5.45",
      "5-bound": [5.07, 5.86],
      "10-mid": "6.34",
      "10-bound": [5.89, 6.83],
      "25-mid": "7.61",
      "25-bound": [7.03, 8.18],
      "50-mid": "8.64",
      "50-bound": [7.94, 9.29],
      "100-mid": "9.74",
      "100-bound": [8.9, 10.5]
    },
    "7day": {
      "2-mid": "4.95",
      "2-bound": [4.64, 5.3],
      "5-mid": "6.12",
      "5-bound": [5.73, 6.54],
      "10-mid": "7.06",
      "10-bound": [6.6, 7.55],
      "25-mid": "8.4",
      "25-bound": [7.82, 8.98],
      "50-mid": "9.49",
      "50-bound": [8.78, 10.1],
      "100-mid": "10.6",
      "100-bound": [9.79, 11.4]
    }
  },
  "USC00448737 6": {
    "fips": "51059",
    "station_name": "VIENNA",
    "state": "VA",
    "latitude": "38.8920",
    "longitude": "-77.2890",
    "5min": {
      "2-mid": "0.42",
      "2-bound": [0.38, 0.47],
      "5-mid": "0.51",
      "5-bound": [0.46, 0.56],
      "10-mid": "0.56",
      "10-bound": [0.51, 0.62],
      "25-mid": "0.64",
      "25-bound": [0.57, 0.71],
      "50-mid": "0.7",
      "50-bound": [0.62, 0.77],
      "100-mid": "0.75",
      "100-bound": [0.67, 0.83]
    },
    "10min": {
      "2-mid": "0.68",
      "2-bound": [0.61, 0.75],
      "5-mid": "0.81",
      "5-bound": [0.73, 0.89],
      "10-mid": "0.9",
      "10-bound": [0.81, 1.0],
      "25-mid": "1.02",
      "25-bound": [0.91, 1.12],
      "50-mid": "1.11",
      "50-bound": [0.99, 1.22],
      "100-mid": "1.2",
      "100-bound": [1.06, 1.32]
    },
    "15min": {
      "2-mid": "0.85",
      "2-bound": [0.77, 0.94],
      "5-mid": "1.02",
      "5-bound": [0.92, 1.13],
      "10-mid": "1.14",
      "10-bound": [1.03, 1.26],
      "25-mid": "1.29",
      "25-bound": [1.16, 1.43],
      "50-mid": "1.4",
      "50-bound": [1.25, 1.55],
      "100-mid": "1.51",
      "100-bound": [1.34, 1.67]
    },
    "30min": {
      "2-mid": "1.18",
      "2-bound": [1.07, 1.3],
      "5-mid": "1.45",
      "5-bound": [1.31, 1.6],
      "10-mid": "1.65",
      "10-bound": [1.49, 1.82],
      "25-mid": "1.92",
      "25-bound": [1.71, 2.11],
      "50-mid": "2.12",
      "50-bound": [1.88, 2.34],
      "100-mid": "2.32",
      "100-bound": [2.05, 2.56]
    },
    "60min": {
      "2-mid": "1.48",
      "2-bound": [1.34, 1.63],
      "5-mid": "1.86",
      "5-bound": [1.68, 2.06],
      "10-mid": "2.15",
      "10-bound": [1.94, 2.38],
      "25-mid": "2.55",
      "25-bound": [2.28, 2.81],
      "50-mid": "2.87",
      "50-bound": [2.55, 3.16],
      "100-mid": "3.19",
      "100-bound": [2.82, 3.53]
    },
    "2hr": {
      "2-mid": "1.73",
      "2-bound": [1.57, 1.91],
      "5-mid": "2.2",
      "5-bound": [1.99, 2.42],
      "10-mid": "2.56",
      "10-bound": [2.3, 2.82],
      "25-mid": "3.07",
      "25-bound": [2.75, 3.39],
      "50-mid": "3.5",
      "50-bound": [3.11, 3.85],
      "100-mid": "3.94",
      "100-bound": [3.48, 4.35]
    },
    "3hr": {
      "2-mid": "1.85",
      "2-bound": [1.67, 2.05],
      "5-mid": "2.35",
      "5-bound": [2.11, 2.6],
      "10-mid": "2.74",
      "10-bound": [2.46, 3.04],
      "25-mid": "3.31",
      "25-bound": [2.95, 3.66],
      "50-mid": "3.78",
      "50-bound": [3.35, 4.18],
      "100-mid": "4.28",
      "100-bound": [3.76, 4.74]
    },
    "6hr": {
      "2-mid": "2.26",
      "2-bound": [2.05, 2.52],
      "5-mid": "2.86",
      "5-bound": [2.58, 3.18],
      "10-mid": "3.35",
      "10-bound": [3.01, 3.72],
      "25-mid": "4.07",
      "25-bound": [3.63, 4.52],
      "50-mid": "4.69",
      "50-bound": [4.14, 5.2],
      "100-mid": "5.36",
      "100-bound": [4.69, 5.95]
    },
    "12hr": {
      "2-mid": "2.74",
      "2-bound": [2.47, 3.08],
      "5-mid": "3.48",
      "5-bound": [3.12, 3.9],
      "10-mid": "4.11",
      "10-bound": [3.67, 4.6],
      "25-mid": "5.06",
      "25-bound": [4.47, 5.66],
      "50-mid": "5.9",
      "50-bound": [5.16, 6.59],
      "100-mid": "6.83",
      "100-bound": [5.9, 7.64]
    },
    "24hr": {
      "2-mid": "3.16",
      "2-bound": [2.87, 3.53],
      "5-mid": "4.06",
      "5-bound": [3.68, 4.53],
      "10-mid": "4.85",
      "10-bound": [4.38, 5.4],
      "25-mid": "6.08",
      "25-bound": [5.44, 6.72],
      "50-mid": "7.16",
      "50-bound": [6.36, 7.89],
      "100-mid": "8.39",
      "100-bound": [7.39, 9.21]
    },
    "2day": {
      "2-mid": "3.66",
      "2-bound": [3.33, 4.08],
      "5-mid": "4.69",
      "5-bound": [4.26, 5.22],
      "10-mid": "5.57",
      "10-bound": [5.04, 6.19],
      "25-mid": "6.91",
      "25-bound": [6.2, 7.65],
      "50-mid": "8.07",
      "50-bound": [7.2, 8.91],
      "100-mid": "9.37",
      "100-bound": [8.28, 10.3]
    },
    "3day": {
      "2-mid": "3.87",
      "2-bound": [3.52, 4.31],
      "5-mid": "4.95",
      "5-bound": [4.5, 5.5],
      "10-mid": "5.88",
      "10-bound": [5.33, 6.52],
      "25-mid": "7.28",
      "25-bound": [6.55, 8.05],
      "50-mid": "8.5",
      "50-bound": [7.59, 9.37],
      "100-mid": "9.86",
      "100-bound": [8.73, 10.8]
    },
    "4day": {
      "2-mid": "4.08",
      "2-bound": [3.72, 4.53],
      "5-mid": "5.21",
      "5-bound": [4.74, 5.78],
      "10-mid": "6.19",
      "10-bound": [5.61, 6.85],
      "25-mid": "7.66",
      "25-bound": [6.89, 8.44],
      "50-mid": "8.93",
      "50-bound": [7.99, 9.84],
      "100-mid": "10.3",
      "100-bound": [9.18, 11.4]
    },
    "7day": {
      "2-mid": "4.71",
      "2-bound": [4.31, 5.2],
      "5-mid": "5.96",
      "5-bound": [5.44, 6.57],
      "10-mid": "7.02",
      "10-bound": [6.4, 7.73],
      "25-mid": "8.62",
      "25-bound": [7.8, 9.46],
      "50-mid": "9.99",
      "50-bound": [8.99, 11.0],
      "100-mid": "11.5",
      "100-bound": [10.3, 12.6]
    }
  },
  "USC00368308 6": {
    "fips": "42055",
    "station_name": "SOUTH MOUNTAIN",
    "state": "PA",
    "latitude": "39.8507",
    "longitude": "-77.5030",
    "5min": {
      "2-mid": "0.44",
      "2-bound": [0.39, 0.49],
      "5-mid": "0.53",
      "5-bound": [0.47, 0.59],
      "10-mid": "0.59",
      "10-bound": [0.53, 0.66],
      "25-mid": "0.69",
      "25-bound": [0.61, 0.77],
      "50-mid": "0.77",
      "50-bound": [0.68, 0.85],
      "100-mid": "0.85",
      "100-bound": [0.74, 0.94]
    },
    "10min": {
      "2-mid": "0.68",
      "2-bound": [0.61, 0.76],
      "5-mid": "0.82",
      "5-bound": [0.73, 0.91],
      "10-mid": "0.92",
      "10-bound": [0.82, 1.02],
      "25-mid": "1.06",
      "25-bound": [0.94, 1.18],
      "50-mid": "1.17",
      "50-bound": [1.03, 1.3],
      "100-mid": "1.28",
      "100-bound": [1.12, 1.42]
    },
    "15min": {
      "2-mid": "0.83",
      "2-bound": [0.75, 0.93],
      "5-mid": "1.0",
      "5-bound": [0.9, 1.12],
      "10-mid": "1.13",
      "10-bound": [1.01, 1.26],
      "25-mid": "1.31",
      "25-bound": [1.16, 1.46],
      "50-mid": "1.44",
      "50-bound": [1.27, 1.61],
      "100-mid": "1.59",
      "100-bound": [1.39, 1.76]
    },
    "30min": {
      "2-mid": "1.12",
      "2-bound": [1.0, 1.25],
      "5-mid": "1.38",
      "5-bound": [1.23, 1.54],
      "10-mid": "1.58",
      "10-bound": [1.41, 1.76],
      "25-mid": "1.85",
      "25-bound": [1.64, 2.06],
      "50-mid": "2.07",
      "50-bound": [1.83, 2.3],
      "100-mid": "2.3",
      "100-bound": [2.02, 2.56]
    },
    "60min": {
      "2-mid": "1.38",
      "2-bound": [1.23, 1.54],
      "5-mid": "1.73",
      "5-bound": [1.55, 1.94],
      "10-mid": "2.01",
      "10-bound": [1.79, 2.24],
      "25-mid": "2.41",
      "25-bound": [2.13, 2.67],
      "50-mid": "2.73",
      "50-bound": [2.41, 3.04],
      "100-mid": "3.08",
      "100-bound": [2.7, 3.42]
    },
    "2hr": {
      "2-mid": "1.6",
      "2-bound": [1.43, 1.8],
      "5-mid": "2.02",
      "5-bound": [1.8, 2.27],
      "10-mid": "2.37",
      "10-bound": [2.11, 2.66],
      "25-mid": "2.89",
      "25-bound": [2.55, 3.22],
      "50-mid": "3.33",
      "50-bound": [2.92, 3.72],
      "100-mid": "3.84",
      "100-bound": [3.34, 4.27]
    },
    "3hr": {
      "2-mid": "1.79",
      "2-bound": [1.6, 2.03],
      "5-mid": "2.25",
      "5-bound": [2.01, 2.56],
      "10-mid": "2.63",
      "10-bound": [2.34, 2.98],
      "25-mid": "3.2",
      "25-bound": [2.82, 3.62],
      "50-mid": "3.7",
      "50-bound": [3.24, 4.17],
      "100-mid": "4.27",
      "100-bound": [3.71, 4.8]
    },
    "6hr": {
      "2-mid": "2.3",
      "2-bound": [2.06, 2.62],
      "5-mid": "2.87",
      "5-bound": [2.56, 3.27],
      "10-mid": "3.34",
      "10-bound": [2.96, 3.8],
      "25-mid": "4.06",
      "25-bound": [3.58, 4.61],
      "50-mid": "4.7",
      "50-bound": [4.1, 5.31],
      "100-mid": "5.42",
      "100-bound": [4.7, 6.12]
    },
    "12hr": {
      "2-mid": "2.87",
      "2-bound": [2.54, 3.26],
      "5-mid": "3.57",
      "5-bound": [3.15, 4.06],
      "10-mid": "4.17",
      "10-bound": [3.67, 4.73],
      "25-mid": "5.09",
      "25-bound": [4.44, 5.75],
      "50-mid": "5.91",
      "50-bound": [5.12, 6.67],
      "100-mid": "6.86",
      "100-bound": [5.89, 7.72]
    },
    "24hr": {
      "2-mid": "3.33",
      "2-bound": [3.05, 3.67],
      "5-mid": "4.14",
      "5-bound": [3.78, 4.56],
      "10-mid": "4.86",
      "10-bound": [4.42, 5.33],
      "25-mid": "5.98",
      "25-bound": [5.39, 6.53],
      "50-mid": "7.01",
      "50-bound": [6.27, 7.62],
      "100-mid": "8.22",
      "100-bound": [7.28, 8.91]
    },
    "2day": {
      "2-mid": "3.87",
      "2-bound": [3.53, 4.3],
      "5-mid": "4.8",
      "5-bound": [4.37, 5.33],
      "10-mid": "5.62",
      "10-bound": [5.09, 6.22],
      "25-mid": "6.92",
      "25-bound": [6.22, 7.64],
      "50-mid": "8.11",
      "50-bound": [7.24, 8.93],
      "100-mid": "9.51",
      "100-bound": [8.42, 10.4]
    },
    "3day": {
      "2-mid": "4.12",
      "2-bound": [3.77, 4.57],
      "5-mid": "5.09",
      "5-bound": [4.64, 5.64],
      "10-mid": "5.94",
      "10-bound": [5.39, 6.57],
      "25-mid": "7.28",
      "25-bound": [6.56, 8.03],
      "50-mid": "8.51",
      "50-bound": [7.61, 9.35],
      "100-mid": "9.94",
      "100-bound": [8.82, 10.9]
    },
    "4day": {
      "2-mid": "4.38",
      "2-bound": [4.01, 4.84],
      "5-mid": "5.38",
      "5-bound": [4.92, 5.96],
      "10-mid": "6.27",
      "10-bound": [5.7, 6.92],
      "25-mid": "7.64",
      "25-bound": [6.9, 8.41],
      "50-mid": "8.9",
      "50-bound": [7.99, 9.78],
      "100-mid": "10.4",
      "100-bound": [9.22, 11.4]
    },
    "7day": {
      "2-mid": "5.07",
      "2-bound": [4.66, 5.58],
      "5-mid": "6.19",
      "5-bound": [5.68, 6.81],
      "10-mid": "7.16",
      "10-bound": [6.54, 7.86],
      "25-mid": "8.66",
      "25-bound": [7.86, 9.48],
      "50-mid": "10.0",
      "50-bound": [9.04, 10.9],
      "100-mid": "11.6",
      "100-bound": [10.4, 12.6]
    }
  },
  "USW00013734 6": {
    "fips": "54003",
    "station_name": "MARTINSBURG EASTERN WEST VIRGINIA REGIONAL AIRPORT",
    "state": "WV",
    "latitude": "39.4030",
    "longitude": "-77.9400",
    "5min": {
      "2-mid": "0.39",
      "2-bound": [0.35, 0.44],
      "5-mid": "0.48",
      "5-bound": [0.42, 0.54],
      "10-mid": "0.54",
      "10-bound": [0.48, 0.61],
      "25-mid": "0.63",
      "25-bound": [0.55, 0.71],
      "50-mid": "0.7",
      "50-bound": [0.61, 0.78],
      "100-mid": "0.78",
      "100-bound": [0.67, 0.86]
    },
    "10min": {
      "2-mid": "0.61",
      "2-bound": [0.54, 0.69],
      "5-mid": "0.74",
      "5-bound": [0.66, 0.84],
      "10-mid": "0.84",
      "10-bound": [0.74, 0.94],
      "25-mid": "0.97",
      "25-bound": [0.85, 1.08],
      "50-mid": "1.07",
      "50-bound": [0.93, 1.19],
      "100-mid": "1.17",
      "100-bound": [1.02, 1.3]
    },
    "15min": {
      "2-mid": "0.75",
      "2-bound": [0.67, 0.85],
      "5-mid": "0.91",
      "5-bound": [0.81, 1.03],
      "10-mid": "1.03",
      "10-bound": [0.91, 1.16],
      "25-mid": "1.2",
      "25-bound": [1.05, 1.34],
      "50-mid": "1.32",
      "50-bound": [1.16, 1.48],
      "100-mid": "1.46",
      "100-bound": [1.27, 1.62]
    },
    "30min": {
      "2-mid": "1.01",
      "2-bound": [0.89, 1.14],
      "5-mid": "1.25",
      "5-bound": [1.11, 1.41],
      "10-mid": "1.44",
      "10-bound": [1.28, 1.62],
      "25-mid": "1.7",
      "25-bound": [1.49, 1.9],
      "50-mid": "1.9",
      "50-bound": [1.66, 2.12],
      "100-mid": "2.11",
      "100-bound": [1.83, 2.35]
    },
    "60min": {
      "2-mid": "1.24",
      "2-bound": [1.1, 1.4],
      "5-mid": "1.58",
      "5-bound": [1.4, 1.78],
      "10-mid": "1.84",
      "10-bound": [1.62, 2.07],
      "25-mid": "2.21",
      "25-bound": [1.94, 2.47],
      "50-mid": "2.51",
      "50-bound": [2.19, 2.8],
      "100-mid": "2.83",
      "100-bound": [2.46, 3.15]
    },
    "2hr": {
      "2-mid": "1.46",
      "2-bound": [1.3, 1.65],
      "5-mid": "1.87",
      "5-bound": [1.66, 2.1],
      "10-mid": "2.19",
      "10-bound": [1.93, 2.46],
      "25-mid": "2.66",
      "25-bound": [2.34, 2.97],
      "50-mid": "3.05",
      "50-bound": [2.66, 3.4],
      "100-mid": "3.47",
      "100-bound": [3.01, 3.86]
    },
    "3hr": {
      "2-mid": "1.58",
      "2-bound": [1.41, 1.78],
      "5-mid": "2.0",
      "5-bound": [1.78, 2.25],
      "10-mid": "2.34",
      "10-bound": [2.08, 2.63],
      "25-mid": "2.84",
      "25-bound": [2.5, 3.18],
      "50-mid": "3.26",
      "50-bound": [2.86, 3.63],
      "100-mid": "3.71",
      "100-bound": [3.23, 4.13]
    },
    "6hr": {
      "2-mid": "1.98",
      "2-bound": [1.77, 2.23],
      "5-mid": "2.48",
      "5-bound": [2.2, 2.78],
      "10-mid": "2.89",
      "10-bound": [2.56, 3.23],
      "25-mid": "3.48",
      "25-bound": [3.07, 3.89],
      "50-mid": "3.99",
      "50-bound": [3.5, 4.44],
      "100-mid": "4.54",
      "100-bound": [3.95, 5.03]
    },
    "12hr": {
      "2-mid": "2.43",
      "2-bound": [2.2, 2.71],
      "5-mid": "3.03",
      "5-bound": [2.74, 3.37],
      "10-mid": "3.54",
      "10-bound": [3.18, 3.92],
      "25-mid": "4.28",
      "25-bound": [3.82, 4.72],
      "50-mid": "4.92",
      "50-bound": [4.35, 5.4],
      "100-mid": "5.63",
      "100-bound": [4.93, 6.16]
    },
    "24hr": {
      "2-mid": "2.86",
      "2-bound": [2.64, 3.1],
      "5-mid": "3.56",
      "5-bound": [3.28, 3.85],
      "10-mid": "4.14",
      "10-bound": [3.81, 4.46],
      "25-mid": "4.98",
      "25-bound": [4.56, 5.36],
      "50-mid": "5.69",
      "50-bound": [5.18, 6.11],
      "100-mid": "6.45",
      "100-bound": [5.84, 6.92]
    },
    "2day": {
      "2-mid": "3.3",
      "2-bound": [3.06, 3.58],
      "5-mid": "4.11",
      "5-bound": [3.8, 4.44],
      "10-mid": "4.78",
      "10-bound": [4.41, 5.16],
      "25-mid": "5.76",
      "25-bound": [5.28, 6.2],
      "50-mid": "6.6",
      "50-bound": [6.0, 7.08],
      "100-mid": "7.49",
      "100-bound": [6.78, 8.05]
    },
    "3day": {
      "2-mid": "3.52",
      "2-bound": [3.27, 3.81],
      "5-mid": "4.37",
      "5-bound": [4.05, 4.71],
      "10-mid": "5.07",
      "10-bound": [4.69, 5.46],
      "25-mid": "6.09",
      "25-bound": [5.6, 6.55],
      "50-mid": "6.94",
      "50-bound": [6.34, 7.46],
      "100-mid": "7.86",
      "100-bound": [7.14, 8.44]
    },
    "4day": {
      "2-mid": "3.74",
      "2-bound": [3.48, 4.04],
      "5-mid": "4.62",
      "5-bound": [4.3, 4.99],
      "10-mid": "5.36",
      "10-bound": [4.96, 5.77],
      "25-mid": "6.41",
      "25-bound": [5.92, 6.9],
      "50-mid": "7.29",
      "50-bound": [6.69, 7.84],
      "100-mid": "8.22",
      "100-bound": [7.5, 8.83]
    },
    "7day": {
      "2-mid": "4.35",
      "2-bound": [4.05, 4.67],
      "5-mid": "5.31",
      "5-bound": [4.95, 5.7],
      "10-mid": "6.09",
      "10-bound": [5.66, 6.53],
      "25-mid": "7.17",
      "25-bound": [6.63, 7.68],
      "50-mid": "8.04",
      "50-bound": [7.41, 8.61],
      "100-mid": "8.94",
      "100-bound": [8.2, 9.59]
    }
  },
  "USC00368073 6": {
    "fips": "42041",
    "station_name": "SHIPPENSBURG",
    "state": "PA",
    "latitude": "40.0590",
    "longitude": "-77.5212",
    "5min": {
      "2-mid": "0.4",
      "2-bound": [0.35, 0.45],
      "5-mid": "0.48",
      "5-bound": [0.43, 0.55],
      "10-mid": "0.55",
      "10-bound": [0.49, 0.62],
      "25-mid": "0.64",
      "25-bound": [0.57, 0.72],
      "50-mid": "0.72",
      "50-bound": [0.63, 0.8],
      "100-mid": "0.79",
      "100-bound": [0.69, 0.89]
    },
    "10min": {
      "2-mid": "0.62",
      "2-bound": [0.56, 0.7],
      "5-mid": "0.75",
      "5-bound": [0.67, 0.85],
      "10-mid": "0.85",
      "10-bound": [0.76, 0.96],
      "25-mid": "0.98",
      "25-bound": [0.87, 1.1],
      "50-mid": "1.09",
      "50-bound": [0.95, 1.22],
      "100-mid": "1.2",
      "100-bound": [1.04, 1.34]
    },
    "15min": {
      "2-mid": "0.76",
      "2-bound": [0.68, 0.86],
      "5-mid": "0.93",
      "5-bound": [0.82, 1.04],
      "10-mid": "1.05",
      "10-bound": [0.93, 1.18],
      "25-mid": "1.22",
      "25-bound": [1.07, 1.36],
      "50-mid": "1.35",
      "50-bound": [1.18, 1.51],
      "100-mid": "1.48",
      "100-bound": [1.29, 1.66]
    },
    "30min": {
      "2-mid": "1.02",
      "2-bound": [0.91, 1.15],
      "5-mid": "1.27",
      "5-bound": [1.12, 1.43],
      "10-mid": "1.46",
      "10-bound": [1.29, 1.64],
      "25-mid": "1.72",
      "25-bound": [1.52, 1.92],
      "50-mid": "1.93",
      "50-bound": [1.69, 2.16],
      "100-mid": "2.15",
      "100-bound": [1.87, 2.4]
    },
    "60min": {
      "2-mid": "1.26",
      "2-bound": [1.12, 1.41],
      "5-mid": "1.59",
      "5-bound": [1.41, 1.79],
      "10-mid": "1.86",
      "10-bound": [1.64, 2.08],
      "25-mid": "2.23",
      "25-bound": [1.97, 2.5],
      "50-mid": "2.54",
      "50-bound": [2.23, 2.84],
      "100-mid": "2.88",
      "100-bound": [2.51, 3.21]
    },
    "2hr": {
      "2-mid": "1.42",
      "2-bound": [1.27, 1.61],
      "5-mid": "1.81",
      "5-bound": [1.61, 2.04],
      "10-mid": "2.13",
      "10-bound": [1.88, 2.4],
      "25-mid": "2.6",
      "25-bound": [2.29, 2.92],
      "50-mid": "3.01",
      "50-bound": [2.63, 3.37],
      "100-mid": "3.47",
      "100-bound": [3.01, 3.87]
    },
    "3hr": {
      "2-mid": "1.54",
      "2-bound": [1.37, 1.77],
      "5-mid": "1.95",
      "5-bound": [1.73, 2.23],
      "10-mid": "2.28",
      "10-bound": [2.02, 2.6],
      "25-mid": "2.79",
      "25-bound": [2.45, 3.17],
      "50-mid": "3.22",
      "50-bound": [2.81, 3.65],
      "100-mid": "3.72",
      "100-bound": [3.22, 4.2]
    },
    "6hr": {
      "2-mid": "1.93",
      "2-bound": [1.72, 2.21],
      "5-mid": "2.41",
      "5-bound": [2.14, 2.75],
      "10-mid": "2.81",
      "10-bound": [2.49, 3.2],
      "25-mid": "3.42",
      "25-bound": [3.0, 3.88],
      "50-mid": "3.94",
      "50-bound": [3.44, 4.46],
      "100-mid": "4.54",
      "100-bound": [3.94, 5.12]
    },
    "12hr": {
      "2-mid": "2.38",
      "2-bound": [2.11, 2.71],
      "5-mid": "2.96",
      "5-bound": [2.62, 3.36],
      "10-mid": "3.46",
      "10-bound": [3.05, 3.91],
      "25-mid": "4.22",
      "25-bound": [3.69, 4.74],
      "50-mid": "4.89",
      "50-bound": [4.24, 5.48],
      "100-mid": "5.66",
      "100-bound": [4.87, 6.32]
    },
    "24hr": {
      "2-mid": "2.83",
      "2-bound": [2.59, 3.12],
      "5-mid": "3.51",
      "5-bound": [3.21, 3.87],
      "10-mid": "4.11",
      "10-bound": [3.73, 4.51],
      "25-mid": "5.04",
      "25-bound": [4.55, 5.5],
      "50-mid": "5.89",
      "50-bound": [5.28, 6.4],
      "100-mid": "6.87",
      "100-bound": [6.12, 7.44]
    },
    "2day": {
      "2-mid": "3.28",
      "2-bound": [2.99, 3.63],
      "5-mid": "4.06",
      "5-bound": [3.69, 4.49],
      "10-mid": "4.74",
      "10-bound": [4.3, 5.23],
      "25-mid": "5.82",
      "25-bound": [5.24, 6.4],
      "50-mid": "6.81",
      "50-bound": [6.08, 7.46],
      "100-mid": "7.96",
      "100-bound": [7.04, 8.69]
    },
    "3day": {
      "2-mid": "3.49",
      "2-bound": [3.2, 3.86],
      "5-mid": "4.3",
      "5-bound": [3.93, 4.75],
      "10-mid": "5.01",
      "10-bound": [4.56, 5.52],
      "25-mid": "6.12",
      "25-bound": [5.54, 6.72],
      "50-mid": "7.14",
      "50-bound": [6.41, 7.82],
      "100-mid": "8.33",
      "100-bound": [7.41, 9.1]
    },
    "4day": {
      "2-mid": "3.7",
      "2-bound": [3.4, 4.09],
      "5-mid": "4.54",
      "5-bound": [4.17, 5.01],
      "10-mid": "5.28",
      "10-bound": [4.82, 5.81],
      "25-mid": "6.43",
      "25-bound": [5.83, 7.05],
      "50-mid": "7.48",
      "50-bound": [6.74, 8.18],
      "100-mid": "8.69",
      "100-bound": [7.78, 9.5]
    },
    "7day": {
      "2-mid": "4.32",
      "2-bound": [4.01, 4.71],
      "5-mid": "5.26",
      "5-bound": [4.87, 5.72],
      "10-mid": "6.07",
      "10-bound": [5.6, 6.59],
      "25-mid": "7.32",
      "25-bound": [6.7, 7.93],
      "50-mid": "8.45",
      "50-bound": [7.69, 9.14],
      "100-mid": "9.75",
      "100-bound": [8.8, 10.5]
    }
  },
  "USC00442790 6": {
    "fips": "51595",
    "station_name": "EMPORIA 1 WNW",
    "state": "VA",
    "latitude": "36.6980",
    "longitude": "-77.5590",
    "5min": {
      "2-mid": "0.45",
      "2-bound": [0.4, 0.51],
      "5-mid": "0.52",
      "5-bound": [0.46, 0.59],
      "10-mid": "0.59",
      "10-bound": [0.52, 0.66],
      "25-mid": "0.66",
      "25-bound": [0.59, 0.74],
      "50-mid": "0.72",
      "50-bound": [0.64, 0.81],
      "100-mid": "0.78",
      "100-bound": [0.68, 0.87]
    },
    "10min": {
      "2-mid": "0.72",
      "2-bound": [0.64, 0.81],
      "5-mid": "0.84",
      "5-bound": [0.74, 0.94],
      "10-mid": "0.94",
      "10-bound": [0.84, 1.06],
      "25-mid": "1.06",
      "25-bound": [0.93, 1.19],
      "50-mid": "1.15",
      "50-bound": [1.01, 1.29],
      "100-mid": "1.24",
      "100-bound": [1.08, 1.38]
    },
    "15min": {
      "2-mid": "0.91",
      "2-bound": [0.81, 1.02],
      "5-mid": "1.06",
      "5-bound": [0.94, 1.19],
      "10-mid": "1.19",
      "10-bound": [1.06, 1.34],
      "25-mid": "1.34",
      "25-bound": [1.18, 1.5],
      "50-mid": "1.46",
      "50-bound": [1.28, 1.63],
      "100-mid": "1.56",
      "100-bound": [1.37, 1.75]
    },
    "30min": {
      "2-mid": "1.25",
      "2-bound": [1.12, 1.41],
      "5-mid": "1.5",
      "5-bound": [1.34, 1.69],
      "10-mid": "1.73",
      "10-bound": [1.53, 1.94],
      "25-mid": "1.99",
      "25-bound": [1.75, 2.23],
      "50-mid": "2.19",
      "50-bound": [1.93, 2.46],
      "100-mid": "2.39",
      "100-bound": [2.09, 2.68]
    },
    "60min": {
      "2-mid": "1.57",
      "2-bound": [1.4, 1.77],
      "5-mid": "1.93",
      "5-bound": [1.71, 2.17],
      "10-mid": "2.25",
      "10-bound": [2.0, 2.53],
      "25-mid": "2.64",
      "25-bound": [2.34, 2.97],
      "50-mid": "2.97",
      "50-bound": [2.62, 3.33],
      "100-mid": "3.3",
      "100-bound": [2.88, 3.69]
    },
    "2hr": {
      "2-mid": "1.85",
      "2-bound": [1.64, 2.1],
      "5-mid": "2.29",
      "5-bound": [2.02, 2.6],
      "10-mid": "2.72",
      "10-bound": [2.39, 3.07],
      "25-mid": "3.25",
      "25-bound": [2.84, 3.66],
      "50-mid": "3.71",
      "50-bound": [3.23, 4.18],
      "100-mid": "4.18",
      "100-bound": [3.62, 4.7]
    },
    "3hr": {
      "2-mid": "1.98",
      "2-bound": [1.74, 2.26],
      "5-mid": "2.46",
      "5-bound": [2.16, 2.8],
      "10-mid": "2.92",
      "10-bound": [2.56, 3.32],
      "25-mid": "3.52",
      "25-bound": [3.06, 3.99],
      "50-mid": "4.04",
      "50-bound": [3.5, 4.59],
      "100-mid": "4.59",
      "100-bound": [3.95, 5.2]
    },
    "6hr": {
      "2-mid": "2.37",
      "2-bound": [2.09, 2.71],
      "5-mid": "2.94",
      "5-bound": [2.59, 3.35],
      "10-mid": "3.51",
      "10-bound": [3.08, 3.99],
      "25-mid": "4.25",
      "25-bound": [3.71, 4.82],
      "50-mid": "4.93",
      "50-bound": [4.27, 5.57],
      "100-mid": "5.63",
      "100-bound": [4.84, 6.34]
    },
    "12hr": {
      "2-mid": "2.83",
      "2-bound": [2.52, 3.2],
      "5-mid": "3.52",
      "5-bound": [3.12, 3.98],
      "10-mid": "4.23",
      "10-bound": [3.73, 4.77],
      "25-mid": "5.17",
      "25-bound": [4.54, 5.81],
      "50-mid": "6.04",
      "50-bound": [5.26, 6.76],
      "100-mid": "6.95",
      "100-bound": [6.0, 7.77]
    },
    "24hr": {
      "2-mid": "3.27",
      "2-bound": [3.02, 3.57],
      "5-mid": "4.21",
      "5-bound": [3.87, 4.59],
      "10-mid": "4.99",
      "10-bound": [4.58, 5.42],
      "25-mid": "6.12",
      "25-bound": [5.58, 6.64],
      "50-mid": "7.07",
      "50-bound": [6.41, 7.66],
      "100-mid": "8.08",
      "100-bound": [7.28, 8.77]
    },
    "2day": {
      "2-mid": "3.78",
      "2-bound": [3.5, 4.13],
      "5-mid": "4.84",
      "5-bound": [4.46, 5.27],
      "10-mid": "5.71",
      "10-bound": [5.25, 6.21],
      "25-mid": "6.96",
      "25-bound": [6.36, 7.56],
      "50-mid": "7.99",
      "50-bound": [7.27, 8.68],
      "100-mid": "9.1",
      "100-bound": [8.23, 9.89]
    },
    "3day": {
      "2-mid": "4.04",
      "2-bound": [3.74, 4.4],
      "5-mid": "5.13",
      "5-bound": [4.74, 5.58],
      "10-mid": "6.03",
      "10-bound": [5.56, 6.54],
      "25-mid": "7.31",
      "25-bound": [6.7, 7.93],
      "50-mid": "8.37",
      "50-bound": [7.64, 9.07],
      "100-mid": "9.49",
      "100-bound": [8.6, 10.3]
    },
    "4day": {
      "2-mid": "4.29",
      "2-bound": [3.98, 4.67],
      "5-mid": "5.43",
      "5-bound": [5.02, 5.89],
      "10-mid": "6.35",
      "10-bound": [5.86, 6.88],
      "25-mid": "7.67",
      "25-bound": [7.04, 8.3],
      "50-mid": "8.75",
      "50-bound": [8.0, 9.47],
      "100-mid": "9.89",
      "100-bound": [8.98, 10.7]
    },
    "7day": {
      "2-mid": "4.97",
      "2-bound": [4.61, 5.39],
      "5-mid": "6.21",
      "5-bound": [5.76, 6.73],
      "10-mid": "7.21",
      "10-bound": [6.67, 7.79],
      "25-mid": "8.62",
      "25-bound": [7.93, 9.31],
      "50-mid": "9.75",
      "50-bound": [8.93, 10.5],
      "100-mid": "10.9",
      "100-bound": [9.97, 11.8]
    }
  },
  "USC00467730 6": {
    "fips": "54027",
    "station_name": "ROMNEY 1 SW",
    "state": "WV",
    "latitude": "39.3389",
    "longitude": "-78.7710",
    "5min": {
      "2-mid": "0.35",
      "2-bound": [0.32, 0.4],
      "5-mid": "0.43",
      "5-bound": [0.38, 0.48],
      "10-mid": "0.49",
      "10-bound": [0.43, 0.55],
      "25-mid": "0.57",
      "25-bound": [0.5, 0.64],
      "50-mid": "0.64",
      "50-bound": [0.56, 0.71],
      "100-mid": "0.7",
      "100-bound": [0.61, 0.78]
    },
    "10min": {
      "2-mid": "0.55",
      "2-bound": [0.49, 0.62],
      "5-mid": "0.67",
      "5-bound": [0.59, 0.75],
      "10-mid": "0.76",
      "10-bound": [0.67, 0.85],
      "25-mid": "0.87",
      "25-bound": [0.77, 0.98],
      "50-mid": "0.96",
      "50-bound": [0.84, 1.08],
      "100-mid": "1.06",
      "100-bound": [0.92, 1.18]
    },
    "15min": {
      "2-mid": "0.68",
      "2-bound": [0.6, 0.76],
      "5-mid": "0.82",
      "5-bound": [0.72, 0.92],
      "10-mid": "0.93",
      "10-bound": [0.82, 1.05],
      "25-mid": "1.08",
      "25-bound": [0.95, 1.21],
      "50-mid": "1.19",
      "50-bound": [1.04, 1.33],
      "100-mid": "1.31",
      "100-bound": [1.14, 1.46]
    },
    "30min": {
      "2-mid": "0.9",
      "2-bound": [0.8, 1.02],
      "5-mid": "1.12",
      "5-bound": [0.99, 1.26],
      "10-mid": "1.29",
      "10-bound": [1.14, 1.45],
      "25-mid": "1.52",
      "25-bound": [1.34, 1.71],
      "50-mid": "1.7",
      "50-bound": [1.49, 1.9],
      "100-mid": "1.89",
      "100-bound": [1.65, 2.12]
    },
    "60min": {
      "2-mid": "1.11",
      "2-bound": [0.99, 1.25],
      "5-mid": "1.4",
      "5-bound": [1.24, 1.58],
      "10-mid": "1.64",
      "10-bound": [1.46, 1.85],
      "25-mid": "1.97",
      "25-bound": [1.74, 2.21],
      "50-mid": "2.24",
      "50-bound": [1.96, 2.51],
      "100-mid": "2.53",
      "100-bound": [2.2, 2.83]
    },
    "2hr": {
      "2-mid": "1.29",
      "2-bound": [1.16, 1.43],
      "5-mid": "1.64",
      "5-bound": [1.48, 1.82],
      "10-mid": "1.94",
      "10-bound": [1.74, 2.14],
      "25-mid": "2.36",
      "25-bound": [2.1, 2.59],
      "50-mid": "2.71",
      "50-bound": [2.4, 2.97],
      "100-mid": "3.1",
      "100-bound": [2.72, 3.39]
    },
    "3hr": {
      "2-mid": "1.38",
      "2-bound": [1.25, 1.53],
      "5-mid": "1.74",
      "5-bound": [1.58, 1.93],
      "10-mid": "2.05",
      "10-bound": [1.85, 2.26],
      "25-mid": "2.5",
      "25-bound": [2.23, 2.74],
      "50-mid": "2.88",
      "50-bound": [2.55, 3.14],
      "100-mid": "3.28",
      "100-bound": [2.9, 3.58]
    },
    "6hr": {
      "2-mid": "1.7",
      "2-bound": [1.54, 1.88],
      "5-mid": "2.12",
      "5-bound": [1.91, 2.34],
      "10-mid": "2.48",
      "10-bound": [2.23, 2.73],
      "25-mid": "2.99",
      "25-bound": [2.68, 3.29],
      "50-mid": "3.44",
      "50-bound": [3.06, 3.77],
      "100-mid": "3.92",
      "100-bound": [3.46, 4.28]
    },
    "12hr": {
      "2-mid": "2.05",
      "2-bound": [1.86, 2.27],
      "5-mid": "2.54",
      "5-bound": [2.31, 2.8],
      "10-mid": "2.97",
      "10-bound": [2.69, 3.28],
      "25-mid": "3.6",
      "25-bound": [3.24, 3.96],
      "50-mid": "4.15",
      "50-bound": [3.71, 4.54],
      "100-mid": "4.75",
      "100-bound": [4.21, 5.19]
    },
    "24hr": {
      "2-mid": "2.46",
      "2-bound": [2.3, 2.66],
      "5-mid": "3.06",
      "5-bound": [2.85, 3.31],
      "10-mid": "3.58",
      "10-bound": [3.32, 3.86],
      "25-mid": "4.34",
      "25-bound": [4.0, 4.67],
      "50-mid": "4.99",
      "50-bound": [4.56, 5.36],
      "100-mid": "5.7",
      "100-bound": [5.17, 6.11]
    },
    "2day": {
      "2-mid": "2.86",
      "2-bound": [2.67, 3.08],
      "5-mid": "3.55",
      "5-bound": [3.31, 3.82],
      "10-mid": "4.13",
      "10-bound": [3.84, 4.45],
      "25-mid": "5.0",
      "25-bound": [4.6, 5.37],
      "50-mid": "5.73",
      "50-bound": [5.24, 6.15],
      "100-mid": "6.52",
      "100-bound": [5.92, 7.0]
    },
    "3day": {
      "2-mid": "3.12",
      "2-bound": [2.92, 3.35],
      "5-mid": "3.86",
      "5-bound": [3.6, 4.13],
      "10-mid": "4.47",
      "10-bound": [4.16, 4.8],
      "25-mid": "5.38",
      "25-bound": [4.97, 5.76],
      "50-mid": "6.14",
      "50-bound": [5.64, 6.58],
      "100-mid": "6.96",
      "100-bound": [6.35, 7.47]
    },
    "4day": {
      "2-mid": "3.37",
      "2-bound": [3.16, 3.61],
      "5-mid": "4.16",
      "5-bound": [3.89, 4.44],
      "10-mid": "4.81",
      "10-bound": [4.49, 5.14],
      "25-mid": "5.76",
      "25-bound": [5.35, 6.15],
      "50-mid": "6.56",
      "50-bound": [6.04, 7.0],
      "100-mid": "7.41",
      "100-bound": [6.77, 7.93]
    },
    "7day": {
      "2-mid": "3.92",
      "2-bound": [3.68, 4.18],
      "5-mid": "4.77",
      "5-bound": [4.46, 5.09],
      "10-mid": "5.46",
      "10-bound": [5.1, 5.82],
      "25-mid": "6.42",
      "25-bound": [5.97, 6.85],
      "50-mid": "7.21",
      "50-bound": [6.66, 7.7],
      "100-mid": "8.02",
      "100-bound": [7.37, 8.58]
    }
  },
  "USC00465224 6": {
    "fips": "54025",
    "station_name": "LEWISBURG 3 N",
    "state": "WV",
    "latitude": "37.8560",
    "longitude": "-80.4040",
    "5min": {
      "2-mid": "0.34",
      "2-bound": [0.3, 0.38],
      "5-mid": "0.41",
      "5-bound": [0.36, 0.46],
      "10-mid": "0.45",
      "10-bound": [0.41, 0.51],
      "25-mid": "0.51",
      "25-bound": [0.45, 0.57],
      "50-mid": "0.55",
      "50-bound": [0.48, 0.62],
      "100-mid": "0.59",
      "100-bound": [0.51, 0.66]
    },
    "10min": {
      "2-mid": "0.54",
      "2-bound": [0.49, 0.61],
      "5-mid": "0.65",
      "5-bound": [0.58, 0.73],
      "10-mid": "0.72",
      "10-bound": [0.65, 0.81],
      "25-mid": "0.81",
      "25-bound": [0.72, 0.91],
      "50-mid": "0.88",
      "50-bound": [0.77, 0.98],
      "100-mid": "0.93",
      "100-bound": [0.82, 1.05]
    },
    "15min": {
      "2-mid": "0.68",
      "2-bound": [0.61, 0.77],
      "5-mid": "0.82",
      "5-bound": [0.74, 0.92],
      "10-mid": "0.92",
      "10-bound": [0.82, 1.02],
      "25-mid": "1.03",
      "25-bound": [0.92, 1.15],
      "50-mid": "1.11",
      "50-bound": [0.98, 1.24],
      "100-mid": "1.18",
      "100-bound": [1.03, 1.32]
    },
    "30min": {
      "2-mid": "0.94",
      "2-bound": [0.85, 1.06],
      "5-mid": "1.17",
      "5-bound": [1.05, 1.31],
      "10-mid": "1.33",
      "10-bound": [1.19, 1.48],
      "25-mid": "1.53",
      "25-bound": [1.36, 1.71],
      "50-mid": "1.67",
      "50-bound": [1.47, 1.87],
      "100-mid": "1.81",
      "100-bound": [1.58, 2.03]
    },
    "60min": {
      "2-mid": "1.18",
      "2-bound": [1.06, 1.33],
      "5-mid": "1.5",
      "5-bound": [1.34, 1.68],
      "10-mid": "1.73",
      "10-bound": [1.54, 1.93],
      "25-mid": "2.04",
      "25-bound": [1.8, 2.27],
      "50-mid": "2.26",
      "50-bound": [1.99, 2.53],
      "100-mid": "2.49",
      "100-bound": [2.18, 2.8]
    },
    "2hr": {
      "2-mid": "1.37",
      "2-bound": [1.24, 1.51],
      "5-mid": "1.73",
      "5-bound": [1.57, 1.91],
      "10-mid": "2.0",
      "10-bound": [1.8, 2.2],
      "25-mid": "2.35",
      "25-bound": [2.1, 2.59],
      "50-mid": "2.62",
      "50-bound": [2.33, 2.89],
      "100-mid": "2.88",
      "100-bound": [2.54, 3.2]
    },
    "3hr": {
      "2-mid": "1.46",
      "2-bound": [1.33, 1.62],
      "5-mid": "1.83",
      "5-bound": [1.67, 2.02],
      "10-mid": "2.11",
      "10-bound": [1.92, 2.34],
      "25-mid": "2.48",
      "25-bound": [2.24, 2.75],
      "50-mid": "2.77",
      "50-bound": [2.48, 3.07],
      "100-mid": "3.06",
      "100-bound": [2.71, 3.4]
    },
    "6hr": {
      "2-mid": "1.77",
      "2-bound": [1.62, 1.98],
      "5-mid": "2.19",
      "5-bound": [2.0, 2.45],
      "10-mid": "2.53",
      "10-bound": [2.29, 2.82],
      "25-mid": "2.99",
      "25-bound": [2.68, 3.33],
      "50-mid": "3.36",
      "50-bound": [2.98, 3.74],
      "100-mid": "3.73",
      "100-bound": [3.28, 4.17]
    },
    "12hr": {
      "2-mid": "2.13",
      "2-bound": [1.94, 2.38],
      "5-mid": "2.62",
      "5-bound": [2.38, 2.93],
      "10-mid": "3.02",
      "10-bound": [2.74, 3.38],
      "25-mid": "3.6",
      "25-bound": [3.22, 4.03],
      "50-mid": "4.08",
      "50-bound": [3.61, 4.58],
      "100-mid": "4.59",
      "100-bound": [4.0, 5.16]
    },
    "24hr": {
      "2-mid": "2.69",
      "2-bound": [2.52, 2.88],
      "5-mid": "3.24",
      "5-bound": [3.04, 3.48],
      "10-mid": "3.69",
      "10-bound": [3.45, 3.95],
      "25-mid": "4.3",
      "25-bound": [4.0, 4.61],
      "50-mid": "4.8",
      "50-bound": [4.44, 5.14],
      "100-mid": "5.3",
      "100-bound": [4.88, 5.69]
    },
    "2day": {
      "2-mid": "3.17",
      "2-bound": [2.98, 3.39],
      "5-mid": "3.79",
      "5-bound": [3.55, 4.05],
      "10-mid": "4.28",
      "10-bound": [4.0, 4.58],
      "25-mid": "4.94",
      "25-bound": [4.61, 5.29],
      "50-mid": "5.46",
      "50-bound": [5.07, 5.85],
      "100-mid": "5.98",
      "100-bound": [5.53, 6.42]
    },
    "3day": {
      "2-mid": "3.39",
      "2-bound": [3.2, 3.61],
      "5-mid": "4.03",
      "5-bound": [3.8, 4.29],
      "10-mid": "4.53",
      "10-bound": [4.26, 4.82],
      "25-mid": "5.19",
      "25-bound": [4.87, 5.53],
      "50-mid": "5.7",
      "50-bound": [5.33, 6.09],
      "100-mid": "6.22",
      "100-bound": [5.78, 6.65]
    },
    "4day": {
      "2-mid": "3.61",
      "2-bound": [3.42, 3.82],
      "5-mid": "4.27",
      "5-bound": [4.04, 4.53],
      "10-mid": "4.78",
      "10-bound": [4.51, 5.06],
      "25-mid": "5.45",
      "25-bound": [5.13, 5.78],
      "50-mid": "5.95",
      "50-bound": [5.59, 6.32],
      "100-mid": "6.46",
      "100-bound": [6.02, 6.87]
    },
    "7day": {
      "2-mid": "4.22",
      "2-bound": [4.0, 4.46],
      "5-mid": "4.94",
      "5-bound": [4.68, 5.23],
      "10-mid": "5.49",
      "10-bound": [5.19, 5.81],
      "25-mid": "6.2",
      "25-bound": [5.85, 6.56],
      "50-mid": "6.73",
      "50-bound": [6.34, 7.14],
      "100-mid": "7.24",
      "100-bound": [6.79, 7.69]
    }
  },
  "USC00368692 6": {
    "fips": "42115",
    "station_name": "SUSQUEHANNA",
    "state": "PA",
    "latitude": "41.9470",
    "longitude": "-75.6040",
    "5min": {
      "2-mid": "0.35",
      "2-bound": [0.32, 0.38],
      "5-mid": "0.41",
      "5-bound": [0.37, 0.45],
      "10-mid": "0.45",
      "10-bound": [0.41, 0.5],
      "25-mid": "0.51",
      "25-bound": [0.46, 0.56],
      "50-mid": "0.55",
      "50-bound": [0.49, 0.6],
      "100-mid": "0.59",
      "100-bound": [0.52, 0.65]
    },
    "10min": {
      "2-mid": "0.54",
      "2-bound": [0.49, 0.6],
      "5-mid": "0.63",
      "5-bound": [0.57, 0.7],
      "10-mid": "0.7",
      "10-bound": [0.63, 0.77],
      "25-mid": "0.77",
      "25-bound": [0.7, 0.85],
      "50-mid": "0.83",
      "50-bound": [0.74, 0.91],
      "100-mid": "0.88",
      "100-bound": [0.79, 0.97]
    },
    "15min": {
      "2-mid": "0.66",
      "2-bound": [0.6, 0.73],
      "5-mid": "0.78",
      "5-bound": [0.7, 0.86],
      "10-mid": "0.86",
      "10-bound": [0.77, 0.95],
      "25-mid": "0.96",
      "25-bound": [0.86, 1.05],
      "50-mid": "1.03",
      "50-bound": [0.92, 1.13],
      "100-mid": "1.1",
      "100-bound": [0.98, 1.21]
    },
    "30min": {
      "2-mid": "0.89",
      "2-bound": [0.8, 0.98],
      "5-mid": "1.06",
      "5-bound": [0.96, 1.18],
      "10-mid": "1.19",
      "10-bound": [1.08, 1.31],
      "25-mid": "1.35",
      "25-bound": [1.21, 1.49],
      "50-mid": "1.47",
      "50-bound": [1.31, 1.62],
      "100-mid": "1.58",
      "100-bound": [1.41, 1.74]
    },
    "60min": {
      "2-mid": "1.09",
      "2-bound": [0.99, 1.2],
      "5-mid": "1.34",
      "5-bound": [1.21, 1.47],
      "10-mid": "1.51",
      "10-bound": [1.37, 1.67],
      "25-mid": "1.75",
      "25-bound": [1.57, 1.93],
      "50-mid": "1.93",
      "50-bound": [1.73, 2.13],
      "100-mid": "2.12",
      "100-bound": [1.89, 2.33]
    },
    "2hr": {
      "2-mid": "1.27",
      "2-bound": [1.16, 1.4],
      "5-mid": "1.57",
      "5-bound": [1.43, 1.72],
      "10-mid": "1.8",
      "10-bound": [1.63, 1.98],
      "25-mid": "2.13",
      "25-bound": [1.92, 2.34],
      "50-mid": "2.39",
      "50-bound": [2.15, 2.63],
      "100-mid": "2.68",
      "100-bound": [2.38, 2.94]
    },
    "3hr": {
      "2-mid": "1.37",
      "2-bound": [1.26, 1.51],
      "5-mid": "1.69",
      "5-bound": [1.55, 1.86],
      "10-mid": "1.95",
      "10-bound": [1.78, 2.14],
      "25-mid": "2.32",
      "25-bound": [2.1, 2.54],
      "50-mid": "2.63",
      "50-bound": [2.36, 2.88],
      "100-mid": "2.96",
      "100-bound": [2.64, 3.25]
    },
    "6hr": {
      "2-mid": "1.73",
      "2-bound": [1.58, 1.9],
      "5-mid": "2.12",
      "5-bound": [1.94, 2.32],
      "10-mid": "2.44",
      "10-bound": [2.22, 2.67],
      "25-mid": "2.89",
      "25-bound": [2.62, 3.16],
      "50-mid": "3.27",
      "50-bound": [2.94, 3.57],
      "100-mid": "3.68",
      "100-bound": [3.28, 4.02]
    },
    "12hr": {
      "2-mid": "2.15",
      "2-bound": [1.97, 2.37],
      "5-mid": "2.64",
      "5-bound": [2.41, 2.89],
      "10-mid": "3.04",
      "10-bound": [2.78, 3.33],
      "25-mid": "3.63",
      "25-bound": [3.28, 3.96],
      "50-mid": "4.13",
      "50-bound": [3.71, 4.51],
      "100-mid": "4.68",
      "100-bound": [4.16, 5.12]
    },
    "24hr": {
      "2-mid": "2.63",
      "2-bound": [2.43, 2.86],
      "5-mid": "3.21",
      "5-bound": [2.97, 3.49],
      "10-mid": "3.7",
      "10-bound": [3.41, 4.01],
      "25-mid": "4.39",
      "25-bound": [4.02, 4.75],
      "50-mid": "4.96",
      "50-bound": [4.52, 5.35],
      "100-mid": "5.58",
      "100-bound": [5.06, 6.0]
    },
    "2day": {
      "2-mid": "3.06",
      "2-bound": [2.83, 3.32],
      "5-mid": "3.74",
      "5-bound": [3.45, 4.05],
      "10-mid": "4.3",
      "10-bound": [3.97, 4.66],
      "25-mid": "5.1",
      "25-bound": [4.68, 5.51],
      "50-mid": "5.77",
      "50-bound": [5.27, 6.22],
      "100-mid": "6.5",
      "100-bound": [5.9, 7.01]
    },
    "3day": {
      "2-mid": "3.25",
      "2-bound": [3.02, 3.51],
      "5-mid": "3.95",
      "5-bound": [3.67, 4.25],
      "10-mid": "4.52",
      "10-bound": [4.2, 4.87],
      "25-mid": "5.34",
      "25-bound": [4.93, 5.74],
      "50-mid": "6.02",
      "50-bound": [5.54, 6.46],
      "100-mid": "6.74",
      "100-bound": [6.17, 7.23]
    },
    "4day": {
      "2-mid": "3.44",
      "2-bound": [3.22, 3.69],
      "5-mid": "4.16",
      "5-bound": [3.89, 4.46],
      "10-mid": "4.74",
      "10-bound": [4.43, 5.08],
      "25-mid": "5.57",
      "25-bound": [5.18, 5.97],
      "50-mid": "6.26",
      "50-bound": [5.8, 6.69],
      "100-mid": "6.98",
      "100-bound": [6.44, 7.46]
    },
    "7day": {
      "2-mid": "4.08",
      "2-bound": [3.83, 4.35],
      "5-mid": "4.83",
      "5-bound": [4.54, 5.15],
      "10-mid": "5.44",
      "10-bound": [5.1, 5.79],
      "25-mid": "6.28",
      "25-bound": [5.87, 6.68],
      "50-mid": "6.96",
      "50-bound": [6.49, 7.4],
      "100-mid": "7.66",
      "100-bound": [7.12, 8.15]
    }
  },
  "USC00369823 6": {
    "fips": "42009",
    "station_name": "WOLFSBURG",
    "state": "PA",
    "latitude": "40.0394",
    "longitude": "-78.5238",
    "5min": {
      "2-mid": "0.37",
      "2-bound": [0.33, 0.41],
      "5-mid": "0.45",
      "5-bound": [0.4, 0.5],
      "10-mid": "0.51",
      "10-bound": [0.45, 0.57],
      "25-mid": "0.6",
      "25-bound": [0.53, 0.66],
      "50-mid": "0.66",
      "50-bound": [0.58, 0.74],
      "100-mid": "0.73",
      "100-bound": [0.64, 0.81]
    },
    "10min": {
      "2-mid": "0.57",
      "2-bound": [0.51, 0.64],
      "5-mid": "0.69",
      "5-bound": [0.62, 0.78],
      "10-mid": "0.79",
      "10-bound": [0.7, 0.88],
      "25-mid": "0.91",
      "25-bound": [0.81, 1.02],
      "50-mid": "1.01",
      "50-bound": [0.89, 1.12],
      "100-mid": "1.1",
      "100-bound": [0.96, 1.22]
    },
    "15min": {
      "2-mid": "0.7",
      "2-bound": [0.63, 0.79],
      "5-mid": "0.85",
      "5-bound": [0.76, 0.95],
      "10-mid": "0.97",
      "10-bound": [0.86, 1.08],
      "25-mid": "1.13",
      "25-bound": [1.0, 1.26],
      "50-mid": "1.25",
      "50-bound": [1.1, 1.38],
      "100-mid": "1.37",
      "100-bound": [1.2, 1.52]
    },
    "30min": {
      "2-mid": "0.94",
      "2-bound": [0.84, 1.05],
      "5-mid": "1.17",
      "5-bound": [1.04, 1.31],
      "10-mid": "1.35",
      "10-bound": [1.2, 1.5],
      "25-mid": "1.59",
      "25-bound": [1.41, 1.77],
      "50-mid": "1.78",
      "50-bound": [1.57, 1.98],
      "100-mid": "1.98",
      "100-bound": [1.73, 2.2]
    },
    "60min": {
      "2-mid": "1.15",
      "2-bound": [1.03, 1.29],
      "5-mid": "1.47",
      "5-bound": [1.31, 1.64],
      "10-mid": "1.72",
      "10-bound": [1.52, 1.92],
      "25-mid": "2.07",
      "25-bound": [1.82, 2.3],
      "50-mid": "2.35",
      "50-bound": [2.06, 2.61],
      "100-mid": "2.65",
      "100-bound": [2.31, 2.94]
    },
    "2hr": {
      "2-mid": "1.32",
      "2-bound": [1.18, 1.48],
      "5-mid": "1.7",
      "5-bound": [1.51, 1.89],
      "10-mid": "1.99",
      "10-bound": [1.77, 2.22],
      "25-mid": "2.43",
      "25-bound": [2.14, 2.69],
      "50-mid": "2.78",
      "50-bound": [2.44, 3.08],
      "100-mid": "3.18",
      "100-bound": [2.77, 3.51]
    },
    "3hr": {
      "2-mid": "1.42",
      "2-bound": [1.28, 1.59],
      "5-mid": "1.81",
      "5-bound": [1.62, 2.02],
      "10-mid": "2.12",
      "10-bound": [1.9, 2.36],
      "25-mid": "2.58",
      "25-bound": [2.29, 2.86],
      "50-mid": "2.96",
      "50-bound": [2.61, 3.27],
      "100-mid": "3.38",
      "100-bound": [2.97, 3.73]
    },
    "6hr": {
      "2-mid": "1.78",
      "2-bound": [1.61, 1.99],
      "5-mid": "2.23",
      "5-bound": [2.02, 2.49],
      "10-mid": "2.6",
      "10-bound": [2.34, 2.9],
      "25-mid": "3.15",
      "25-bound": [2.81, 3.49],
      "50-mid": "3.61",
      "50-bound": [3.2, 3.99],
      "100-mid": "4.11",
      "100-bound": [3.61, 4.53]
    },
    "12hr": {
      "2-mid": "2.18",
      "2-bound": [1.98, 2.44],
      "5-mid": "2.72",
      "5-bound": [2.45, 3.03],
      "10-mid": "3.17",
      "10-bound": [2.85, 3.52],
      "25-mid": "3.84",
      "25-bound": [3.43, 4.25],
      "50-mid": "4.41",
      "50-bound": [3.92, 4.87],
      "100-mid": "5.05",
      "100-bound": [4.44, 5.56]
    },
    "24hr": {
      "2-mid": "2.63",
      "2-bound": [2.41, 2.88],
      "5-mid": "3.27",
      "5-bound": [2.99, 3.58],
      "10-mid": "3.82",
      "10-bound": [3.48, 4.17],
      "25-mid": "4.61",
      "25-bound": [4.18, 5.02],
      "50-mid": "5.29",
      "50-bound": [4.76, 5.75],
      "100-mid": "6.01",
      "100-bound": [5.36, 6.54]
    },
    "2day": {
      "2-mid": "3.0",
      "2-bound": [2.76, 3.27],
      "5-mid": "3.72",
      "5-bound": [3.42, 4.06],
      "10-mid": "4.34",
      "10-bound": [3.97, 4.72],
      "25-mid": "5.23",
      "25-bound": [4.77, 5.68],
      "50-mid": "5.99",
      "50-bound": [5.43, 6.5],
      "100-mid": "6.82",
      "100-bound": [6.12, 7.39]
    },
    "3day": {
      "2-mid": "3.21",
      "2-bound": [2.97, 3.49],
      "5-mid": "3.97",
      "5-bound": [3.66, 4.31],
      "10-mid": "4.62",
      "10-bound": [4.25, 5.01],
      "25-mid": "5.55",
      "25-bound": [5.07, 6.0],
      "50-mid": "6.33",
      "50-bound": [5.75, 6.84],
      "100-mid": "7.17",
      "100-bound": [6.47, 7.75]
    },
    "4day": {
      "2-mid": "3.42",
      "2-bound": [3.18, 3.71],
      "5-mid": "4.22",
      "5-bound": [3.91, 4.57],
      "10-mid": "4.89",
      "10-bound": [4.52, 5.29],
      "25-mid": "5.86",
      "25-bound": [5.38, 6.32],
      "50-mid": "6.66",
      "50-bound": [6.08, 7.18],
      "100-mid": "7.52",
      "100-bound": [6.82, 8.11]
    },
    "7day": {
      "2-mid": "4.04",
      "2-bound": [3.77, 4.32],
      "5-mid": "4.92",
      "5-bound": [4.59, 5.27],
      "10-mid": "5.63",
      "10-bound": [5.24, 6.03],
      "25-mid": "6.63",
      "25-bound": [6.15, 7.11],
      "50-mid": "7.43",
      "50-bound": [6.85, 7.96],
      "100-mid": "8.27",
      "100-bound": [7.58, 8.87]
    }
  },
  "USC00307780 6": {
    "fips": "36067",
    "station_name": "SKANEATELES",
    "state": "NY",
    "latitude": "42.9460",
    "longitude": "-76.4310",
    "5min": {
      "2-mid": "0.34",
      "2-bound": [0.26, 0.44],
      "5-mid": "0.44",
      "5-bound": [0.33, 0.58],
      "10-mid": "0.52",
      "10-bound": [0.4, 0.69],
      "25-mid": "0.64",
      "25-bound": [0.47, 0.87],
      "50-mid": "0.73",
      "50-bound": [0.53, 1.0],
      "100-mid": "0.82",
      "100-bound": [0.58, 1.17]
    },
    "10min": {
      "2-mid": "0.48",
      "2-bound": [0.36, 0.63],
      "5-mid": "0.62",
      "5-bound": [0.47, 0.82],
      "10-mid": "0.74",
      "10-bound": [0.56, 0.97],
      "25-mid": "0.91",
      "25-bound": [0.67, 1.23],
      "50-mid": "1.03",
      "50-bound": [0.74, 1.42],
      "100-mid": "1.16",
      "100-bound": [0.82, 1.65]
    },
    "15min": {
      "2-mid": "0.56",
      "2-bound": [0.43, 0.74],
      "5-mid": "0.73",
      "5-bound": [0.56, 0.96],
      "10-mid": "0.87",
      "10-bound": [0.66, 1.15],
      "25-mid": "1.07",
      "25-bound": [0.79, 1.45],
      "50-mid": "1.21",
      "50-bound": [0.88, 1.67],
      "100-mid": "1.36",
      "100-bound": [0.96, 1.94]
    },
    "30min": {
      "2-mid": "0.77",
      "2-bound": [0.58, 1.0],
      "5-mid": "1.0",
      "5-bound": [0.76, 1.31],
      "10-mid": "1.19",
      "10-bound": [0.9, 1.57],
      "25-mid": "1.46",
      "25-bound": [1.07, 1.98],
      "50-mid": "1.65",
      "50-bound": [1.2, 2.29],
      "100-mid": "1.86",
      "100-bound": [1.32, 2.65]
    },
    "60min": {
      "2-mid": "0.97",
      "2-bound": [0.74, 1.27],
      "5-mid": "1.27",
      "5-bound": [0.96, 1.66],
      "10-mid": "1.51",
      "10-bound": [1.14, 1.99],
      "25-mid": "1.84",
      "25-bound": [1.36, 2.51],
      "50-mid": "2.1",
      "50-bound": [1.52, 2.9],
      "100-mid": "2.36",
      "100-bound": [1.67, 3.36]
    },
    "2hr": {
      "2-mid": "1.21",
      "2-bound": [0.94, 1.57],
      "5-mid": "1.55",
      "5-bound": [1.2, 2.01],
      "10-mid": "1.83",
      "10-bound": [1.41, 2.38],
      "25-mid": "2.22",
      "25-bound": [1.66, 2.99],
      "50-mid": "2.51",
      "50-bound": [1.84, 3.43],
      "100-mid": "2.82",
      "100-bound": [2.02, 3.97]
    },
    "3hr": {
      "2-mid": "1.37",
      "2-bound": [1.07, 1.75],
      "5-mid": "1.74",
      "5-bound": [1.35, 2.23],
      "10-mid": "2.05",
      "10-bound": [1.58, 2.64],
      "25-mid": "2.47",
      "25-bound": [1.85, 3.29],
      "50-mid": "2.78",
      "50-bound": [2.05, 3.77],
      "100-mid": "3.12",
      "100-bound": [2.24, 4.35]
    },
    "6hr": {
      "2-mid": "1.67",
      "2-bound": [1.32, 2.11],
      "5-mid": "2.11",
      "5-bound": [1.66, 2.67],
      "10-mid": "2.47",
      "10-bound": [1.93, 3.14],
      "25-mid": "2.97",
      "25-bound": [2.26, 3.9],
      "50-mid": "3.34",
      "50-bound": [2.49, 4.47],
      "100-mid": "3.74",
      "100-bound": [2.72, 5.14]
    },
    "12hr": {
      "2-mid": "2.01",
      "2-bound": [1.61, 2.51],
      "5-mid": "2.54",
      "5-bound": [2.03, 3.18],
      "10-mid": "2.98",
      "10-bound": [2.36, 3.74],
      "25-mid": "3.58",
      "25-bound": [2.76, 4.65],
      "50-mid": "4.03",
      "50-bound": [3.04, 5.32],
      "100-mid": "4.51",
      "100-bound": [3.31, 6.12]
    },
    "24hr": {
      "2-mid": "2.38",
      "2-bound": [1.93, 2.93],
      "5-mid": "3.0",
      "5-bound": [2.42, 3.69],
      "10-mid": "3.51",
      "10-bound": [2.82, 4.34],
      "25-mid": "4.21",
      "25-bound": [3.28, 5.38],
      "50-mid": "4.73",
      "50-bound": [3.61, 6.16],
      "100-mid": "5.29",
      "100-bound": [3.92, 7.08]
    },
    "2day": {
      "2-mid": "2.77",
      "2-bound": [2.28, 3.36],
      "5-mid": "3.44",
      "5-bound": [2.82, 4.19],
      "10-mid": "4.0",
      "10-bound": [3.26, 4.89],
      "25-mid": "4.77",
      "25-bound": [3.76, 6.02],
      "50-mid": "5.35",
      "50-bound": [4.13, 6.85],
      "100-mid": "5.96",
      "100-bound": [4.46, 7.84]
    },
    "3day": {
      "2-mid": "3.05",
      "2-bound": [2.53, 3.66],
      "5-mid": "3.75",
      "5-bound": [3.1, 4.52],
      "10-mid": "4.33",
      "10-bound": [3.56, 5.24],
      "25-mid": "5.13",
      "25-bound": [4.08, 6.41],
      "50-mid": "5.74",
      "50-bound": [4.46, 7.28],
      "100-mid": "6.36",
      "100-bound": [4.79, 8.3]
    },
    "4day": {
      "2-mid": "3.28",
      "2-bound": [2.74, 3.92],
      "5-mid": "4.0",
      "5-bound": [3.33, 4.8],
      "10-mid": "4.6",
      "10-bound": [3.8, 5.54],
      "25-mid": "5.42",
      "25-bound": [4.33, 6.73],
      "50-mid": "6.05",
      "50-bound": [4.72, 7.63],
      "100-mid": "6.69",
      "100-bound": [5.05, 8.67]
    },
    "7day": {
      "2-mid": "3.9",
      "2-bound": [3.29, 4.61],
      "5-mid": "4.67",
      "5-bound": [3.93, 5.53],
      "10-mid": "5.3",
      "10-bound": [4.44, 6.31],
      "25-mid": "6.18",
      "25-bound": [4.99, 7.58],
      "50-mid": "6.85",
      "50-bound": [5.4, 8.53],
      "100-mid": "7.53",
      "100-bound": [5.73, 9.62]
    }
  },
  "USW00014712 6": {
    "fips": "42011",
    "station_name": "READING REGIONAL AIRPORT",
    "state": "PA",
    "latitude": "40.3733",
    "longitude": "-75.9592",
    "5min": {
      "2-mid": "0.4",
      "2-bound": [0.36, 0.44],
      "5-mid": "0.47",
      "5-bound": [0.42, 0.52],
      "10-mid": "0.52",
      "10-bound": [0.47, 0.57],
      "25-mid": "0.57",
      "25-bound": [0.52, 0.63],
      "50-mid": "0.61",
      "50-bound": [0.55, 0.67],
      "100-mid": "0.65",
      "100-bound": [0.58, 0.72]
    },
    "10min": {
      "2-mid": "0.63",
      "2-bound": [0.57, 0.7],
      "5-mid": "0.74",
      "5-bound": [0.67, 0.82],
      "10-mid": "0.82",
      "10-bound": [0.74, 0.9],
      "25-mid": "0.91",
      "25-bound": [0.81, 0.99],
      "50-mid": "0.97",
      "50-bound": [0.86, 1.06],
      "100-mid": "1.02",
      "100-bound": [0.92, 1.13]
    },
    "15min": {
      "2-mid": "0.79",
      "2-bound": [0.72, 0.87],
      "5-mid": "0.93",
      "5-bound": [0.84, 1.03],
      "10-mid": "1.03",
      "10-bound": [0.93, 1.14],
      "25-mid": "1.14",
      "25-bound": [1.03, 1.26],
      "50-mid": "1.22",
      "50-bound": [1.09, 1.34],
      "100-mid": "1.29",
      "100-bound": [1.16, 1.42]
    },
    "30min": {
      "2-mid": "1.09",
      "2-bound": [0.98, 1.2],
      "5-mid": "1.32",
      "5-bound": [1.19, 1.45],
      "10-mid": "1.48",
      "10-bound": [1.34, 1.63],
      "25-mid": "1.68",
      "25-bound": [1.5, 1.84],
      "50-mid": "1.81",
      "50-bound": [1.62, 1.99],
      "100-mid": "1.95",
      "100-bound": [1.74, 2.15]
    },
    "60min": {
      "2-mid": "1.36",
      "2-bound": [1.23, 1.5],
      "5-mid": "1.68",
      "5-bound": [1.52, 1.85],
      "10-mid": "1.92",
      "10-bound": [1.74, 2.11],
      "25-mid": "2.22",
      "25-bound": [1.99, 2.44],
      "50-mid": "2.44",
      "50-bound": [2.19, 2.68],
      "100-mid": "2.68",
      "100-bound": [2.39, 2.94]
    },
    "2hr": {
      "2-mid": "1.64",
      "2-bound": [1.47, 1.86],
      "5-mid": "2.04",
      "5-bound": [1.82, 2.31],
      "10-mid": "2.36",
      "10-bound": [2.1, 2.67],
      "25-mid": "2.8",
      "25-bound": [2.47, 3.15],
      "50-mid": "3.14",
      "50-bound": [2.77, 3.54],
      "100-mid": "3.51",
      "100-bound": [3.07, 3.95]
    },
    "3hr": {
      "2-mid": "1.8",
      "2-bound": [1.6, 2.06],
      "5-mid": "2.25",
      "5-bound": [1.99, 2.57],
      "10-mid": "2.6",
      "10-bound": [2.29, 2.96],
      "25-mid": "3.09",
      "25-bound": [2.7, 3.5],
      "50-mid": "3.47",
      "50-bound": [3.03, 3.93],
      "100-mid": "3.88",
      "100-bound": [3.36, 4.38]
    },
    "6hr": {
      "2-mid": "2.25",
      "2-bound": [1.98, 2.58],
      "5-mid": "2.8",
      "5-bound": [2.46, 3.21],
      "10-mid": "3.25",
      "10-bound": [2.85, 3.72],
      "25-mid": "3.89",
      "25-bound": [3.39, 4.43],
      "50-mid": "4.42",
      "50-bound": [3.82, 5.02],
      "100-mid": "4.99",
      "100-bound": [4.29, 5.66]
    },
    "12hr": {
      "2-mid": "2.76",
      "2-bound": [2.43, 3.18],
      "5-mid": "3.46",
      "5-bound": [3.04, 3.97],
      "10-mid": "4.04",
      "10-bound": [3.54, 4.63],
      "25-mid": "4.89",
      "25-bound": [4.24, 5.57],
      "50-mid": "5.62",
      "50-bound": [4.83, 6.37],
      "100-mid": "6.42",
      "100-bound": [5.47, 7.27]
    },
    "24hr": {
      "2-mid": "3.18",
      "2-bound": [2.89, 3.52],
      "5-mid": "3.99",
      "5-bound": [3.62, 4.42],
      "10-mid": "4.67",
      "10-bound": [4.22, 5.16],
      "25-mid": "5.67",
      "25-bound": [5.09, 6.25],
      "50-mid": "6.52",
      "50-bound": [5.82, 7.17],
      "100-mid": "7.45",
      "100-bound": [6.6, 8.16]
    },
    "2day": {
      "2-mid": "3.71",
      "2-bound": [3.37, 4.1],
      "5-mid": "4.67",
      "5-bound": [4.24, 5.15],
      "10-mid": "5.45",
      "10-bound": [4.93, 6.0],
      "25-mid": "6.58",
      "25-bound": [5.92, 7.22],
      "50-mid": "7.52",
      "50-bound": [6.72, 8.24],
      "100-mid": "8.53",
      "100-bound": [7.58, 9.33]
    },
    "3day": {
      "2-mid": "3.92",
      "2-bound": [3.59, 4.3],
      "5-mid": "4.9",
      "5-bound": [4.48, 5.37],
      "10-mid": "5.7",
      "10-bound": [5.2, 6.24],
      "25-mid": "6.86",
      "25-bound": [6.23, 7.49],
      "50-mid": "7.82",
      "50-bound": [7.07, 8.52],
      "100-mid": "8.85",
      "100-bound": [7.96, 9.64]
    },
    "4day": {
      "2-mid": "4.12",
      "2-bound": [3.8, 4.49],
      "5-mid": "5.13",
      "5-bound": [4.73, 5.59],
      "10-mid": "5.96",
      "10-bound": [5.48, 6.48],
      "25-mid": "7.14",
      "25-bound": [6.54, 7.75],
      "50-mid": "8.13",
      "50-bound": [7.41, 8.81],
      "100-mid": "9.18",
      "100-bound": [8.33, 9.94]
    },
    "7day": {
      "2-mid": "4.83",
      "2-bound": [4.46, 5.27],
      "5-mid": "5.95",
      "5-bound": [5.49, 6.49],
      "10-mid": "6.88",
      "10-bound": [6.34, 7.49],
      "25-mid": "8.22",
      "25-bound": [7.54, 8.94],
      "50-mid": "9.33",
      "50-bound": [8.52, 10.1],
      "100-mid": "10.5",
      "100-bound": [9.56, 11.4]
    }
  },
  "USC00441606 6": {
    "fips": "51117",
    "station_name": "CHASE CITY",
    "state": "VA",
    "latitude": "36.7770",
    "longitude": "-78.4750",
    "5min": {
      "2-mid": "0.44",
      "2-bound": [0.39, 0.49],
      "5-mid": "0.51",
      "5-bound": [0.46, 0.57],
      "10-mid": "0.57",
      "10-bound": [0.51, 0.64],
      "25-mid": "0.64",
      "25-bound": [0.57, 0.71],
      "50-mid": "0.69",
      "50-bound": [0.61, 0.77],
      "100-mid": "0.74",
      "100-bound": [0.66, 0.82]
    },
    "10min": {
      "2-mid": "0.7",
      "2-bound": [0.63, 0.78],
      "5-mid": "0.81",
      "5-bound": [0.73, 0.91],
      "10-mid": "0.92",
      "10-bound": [0.82, 1.02],
      "25-mid": "1.02",
      "25-bound": [0.91, 1.14],
      "50-mid": "1.1",
      "50-bound": [0.98, 1.23],
      "100-mid": "1.18",
      "100-bound": [1.04, 1.31]
    },
    "15min": {
      "2-mid": "0.88",
      "2-bound": [0.79, 0.98],
      "5-mid": "1.03",
      "5-bound": [0.92, 1.15],
      "10-mid": "1.16",
      "10-bound": [1.04, 1.29],
      "25-mid": "1.3",
      "25-bound": [1.15, 1.44],
      "50-mid": "1.4",
      "50-bound": [1.24, 1.55],
      "100-mid": "1.49",
      "100-bound": [1.32, 1.66]
    },
    "30min": {
      "2-mid": "1.21",
      "2-bound": [1.09, 1.36],
      "5-mid": "1.46",
      "5-bound": [1.31, 1.63],
      "10-mid": "1.68",
      "10-bound": [1.5, 1.87],
      "25-mid": "1.92",
      "25-bound": [1.71, 2.13],
      "50-mid": "2.11",
      "50-bound": [1.87, 2.34],
      "100-mid": "2.28",
      "100-bound": [2.01, 2.54]
    },
    "60min": {
      "2-mid": "1.52",
      "2-bound": [1.37, 1.7],
      "5-mid": "1.88",
      "5-bound": [1.68, 2.1],
      "10-mid": "2.18",
      "10-bound": [1.95, 2.43],
      "25-mid": "2.56",
      "25-bound": [2.27, 2.84],
      "50-mid": "2.86",
      "50-bound": [2.53, 3.17],
      "100-mid": "3.15",
      "100-bound": [2.77, 3.49]
    },
    "2hr": {
      "2-mid": "1.8",
      "2-bound": [1.6, 2.02],
      "5-mid": "2.23",
      "5-bound": [1.98, 2.5],
      "10-mid": "2.62",
      "10-bound": [2.33, 2.94],
      "25-mid": "3.12",
      "25-bound": [2.75, 3.48],
      "50-mid": "3.54",
      "50-bound": [3.1, 3.94],
      "100-mid": "3.96",
      "100-bound": [3.44, 4.41]
    },
    "3hr": {
      "2-mid": "1.93",
      "2-bound": [1.72, 2.17],
      "5-mid": "2.39",
      "5-bound": [2.13, 2.69],
      "10-mid": "2.82",
      "10-bound": [2.5, 3.17],
      "25-mid": "3.36",
      "25-bound": [2.96, 3.77],
      "50-mid": "3.82",
      "50-bound": [3.34, 4.28],
      "100-mid": "4.29",
      "100-bound": [3.73, 4.79]
    },
    "6hr": {
      "2-mid": "2.32",
      "2-bound": [2.07, 2.61],
      "5-mid": "2.88",
      "5-bound": [2.56, 3.24],
      "10-mid": "3.4",
      "10-bound": [3.02, 3.82],
      "25-mid": "4.09",
      "25-bound": [3.6, 4.58],
      "50-mid": "4.69",
      "50-bound": [4.11, 5.24],
      "100-mid": "5.32",
      "100-bound": [4.62, 5.92]
    },
    "12hr": {
      "2-mid": "2.76",
      "2-bound": [2.49, 3.1],
      "5-mid": "3.45",
      "5-bound": [3.1, 3.85],
      "10-mid": "4.11",
      "10-bound": [3.68, 4.58],
      "25-mid": "5.0",
      "25-bound": [4.44, 5.54],
      "50-mid": "5.79",
      "50-bound": [5.1, 6.4],
      "100-mid": "6.62",
      "100-bound": [5.79, 7.3]
    },
    "24hr": {
      "2-mid": "3.26",
      "2-bound": [3.02, 3.54],
      "5-mid": "4.16",
      "5-bound": [3.85, 4.5],
      "10-mid": "4.91",
      "10-bound": [4.53, 5.31],
      "25-mid": "6.01",
      "25-bound": [5.5, 6.48],
      "50-mid": "6.95",
      "50-bound": [6.32, 7.48],
      "100-mid": "7.97",
      "100-bound": [7.2, 8.58]
    },
    "2day": {
      "2-mid": "3.83",
      "2-bound": [3.57, 4.14],
      "5-mid": "4.85",
      "5-bound": [4.51, 5.24],
      "10-mid": "5.69",
      "10-bound": [5.28, 6.13],
      "25-mid": "6.89",
      "25-bound": [6.36, 7.42],
      "50-mid": "7.89",
      "50-bound": [7.24, 8.49],
      "100-mid": "8.96",
      "100-bound": [8.17, 9.66]
    },
    "3day": {
      "2-mid": "4.05",
      "2-bound": [3.76, 4.38],
      "5-mid": "5.12",
      "5-bound": [4.76, 5.53],
      "10-mid": "6.01",
      "10-bound": [5.56, 6.48],
      "25-mid": "7.27",
      "25-bound": [6.7, 7.84],
      "50-mid": "8.32",
      "50-bound": [7.63, 8.97],
      "100-mid": "9.45",
      "100-bound": [8.6, 10.2]
    },
    "4day": {
      "2-mid": "4.27",
      "2-bound": [3.96, 4.62],
      "5-mid": "5.4",
      "5-bound": [5.01, 5.83],
      "10-mid": "6.33",
      "10-bound": [5.85, 6.83],
      "25-mid": "7.65",
      "25-bound": [7.05, 8.26],
      "50-mid": "8.75",
      "50-bound": [8.02, 9.44],
      "100-mid": "9.93",
      "100-bound": [9.04, 10.7]
    },
    "7day": {
      "2-mid": "4.9",
      "2-bound": [4.56, 5.29],
      "5-mid": "6.1",
      "5-bound": [5.67, 6.58],
      "10-mid": "7.08",
      "10-bound": [6.57, 7.63],
      "25-mid": "8.48",
      "25-bound": [7.83, 9.12],
      "50-mid": "9.63",
      "50-bound": [8.86, 10.4],
      "100-mid": "10.9",
      "100-bound": [9.92, 11.7]
    }
  },
  "USW00013737 6": {
    "fips": "51710",
    "station_name": "NORFOLK INTL AP",
    "state": "VA",
    "latitude": "36.9030",
    "longitude": "-76.1920",
    "5min": {
      "2-mid": "0.48",
      "2-bound": [0.44, 0.53],
      "5-mid": "0.55",
      "5-bound": [0.5, 0.61],
      "10-mid": "0.63",
      "10-bound": [0.57, 0.69],
      "25-mid": "0.71",
      "25-bound": [0.64, 0.78],
      "50-mid": "0.78",
      "50-bound": [0.7, 0.85],
      "100-mid": "0.84",
      "100-bound": [0.75, 0.92]
    },
    "10min": {
      "2-mid": "0.77",
      "2-bound": [0.7, 0.85],
      "5-mid": "0.88",
      "5-bound": [0.8, 0.97],
      "10-mid": "1.0",
      "10-bound": [0.91, 1.1],
      "25-mid": "1.13",
      "25-bound": [1.02, 1.24],
      "50-mid": "1.24",
      "50-bound": [1.11, 1.36],
      "100-mid": "1.34",
      "100-bound": [1.2, 1.47]
    },
    "15min": {
      "2-mid": "0.97",
      "2-bound": [0.88, 1.07],
      "5-mid": "1.12",
      "5-bound": [1.02, 1.23],
      "10-mid": "1.27",
      "10-bound": [1.15, 1.4],
      "25-mid": "1.43",
      "25-bound": [1.29, 1.57],
      "50-mid": "1.57",
      "50-bound": [1.41, 1.72],
      "100-mid": "1.69",
      "100-bound": [1.51, 1.85]
    },
    "30min": {
      "2-mid": "1.34",
      "2-bound": [1.22, 1.47],
      "5-mid": "1.59",
      "5-bound": [1.44, 1.75],
      "10-mid": "1.84",
      "10-bound": [1.67, 2.02],
      "25-mid": "2.12",
      "25-bound": [1.91, 2.33],
      "50-mid": "2.36",
      "50-bound": [2.12, 2.6],
      "100-mid": "2.58",
      "100-bound": [2.32, 2.84]
    },
    "60min": {
      "2-mid": "1.68",
      "2-bound": [1.53, 1.85],
      "5-mid": "2.04",
      "5-bound": [1.85, 2.24],
      "10-mid": "2.4",
      "10-bound": [2.17, 2.64],
      "25-mid": "2.82",
      "25-bound": [2.55, 3.1],
      "50-mid": "3.2",
      "50-bound": [2.88, 3.52],
      "100-mid": "3.56",
      "100-bound": [3.19, 3.91]
    },
    "2hr": {
      "2-mid": "1.99",
      "2-bound": [1.81, 2.2],
      "5-mid": "2.47",
      "5-bound": [2.24, 2.72],
      "10-mid": "2.96",
      "10-bound": [2.67, 3.25],
      "25-mid": "3.55",
      "25-bound": [3.19, 3.9],
      "50-mid": "4.09",
      "50-bound": [3.66, 4.5],
      "100-mid": "4.64",
      "100-bound": [4.12, 5.08]
    },
    "3hr": {
      "2-mid": "2.15",
      "2-bound": [1.94, 2.39],
      "5-mid": "2.66",
      "5-bound": [2.4, 2.96],
      "10-mid": "3.21",
      "10-bound": [2.89, 3.56],
      "25-mid": "3.9",
      "25-bound": [3.48, 4.32],
      "50-mid": "4.54",
      "50-bound": [4.03, 5.01],
      "100-mid": "5.2",
      "100-bound": [4.58, 5.73]
    },
    "6hr": {
      "2-mid": "2.6",
      "2-bound": [2.34, 2.93],
      "5-mid": "3.24",
      "5-bound": [2.9, 3.64],
      "10-mid": "3.9",
      "10-bound": [3.48, 4.37],
      "25-mid": "4.77",
      "25-bound": [4.22, 5.32],
      "50-mid": "5.57",
      "50-bound": [4.91, 6.19],
      "100-mid": "6.4",
      "100-bound": [5.58, 7.11]
    },
    "12hr": {
      "2-mid": "3.08",
      "2-bound": [2.75, 3.48],
      "5-mid": "3.85",
      "5-bound": [3.43, 4.34],
      "10-mid": "4.66",
      "10-bound": [4.13, 5.24],
      "25-mid": "5.74",
      "25-bound": [5.05, 6.44],
      "50-mid": "6.76",
      "50-bound": [5.89, 7.56],
      "100-mid": "7.83",
      "100-bound": [6.77, 8.74]
    },
    "24hr": {
      "2-mid": "3.57",
      "2-bound": [3.32, 3.88],
      "5-mid": "4.62",
      "5-bound": [4.28, 5.02],
      "10-mid": "5.5",
      "10-bound": [5.08, 5.97],
      "25-mid": "6.82",
      "25-bound": [6.24, 7.39],
      "50-mid": "7.95",
      "50-bound": [7.22, 8.6],
      "100-mid": "9.2",
      "100-bound": [8.27, 9.95]
    },
    "2day": {
      "2-mid": "4.1",
      "2-bound": [3.77, 4.52],
      "5-mid": "5.28",
      "5-bound": [4.84, 5.81],
      "10-mid": "6.29",
      "10-bound": [5.74, 6.91],
      "25-mid": "7.81",
      "25-bound": [7.06, 8.57],
      "50-mid": "9.13",
      "50-bound": [8.19, 10.0],
      "100-mid": "10.6",
      "100-bound": [9.41, 11.6]
    },
    "3day": {
      "2-mid": "4.34",
      "2-bound": [3.99, 4.76],
      "5-mid": "5.55",
      "5-bound": [5.1, 6.08],
      "10-mid": "6.58",
      "10-bound": [6.02, 7.19],
      "25-mid": "8.1",
      "25-bound": [7.36, 8.84],
      "50-mid": "9.41",
      "50-bound": [8.47, 10.3],
      "100-mid": "10.8",
      "100-bound": [9.67, 11.8]
    },
    "4day": {
      "2-mid": "4.57",
      "2-bound": [4.22, 4.99],
      "5-mid": "5.82",
      "5-bound": [5.36, 6.35],
      "10-mid": "6.86",
      "10-bound": [6.3, 7.47],
      "25-mid": "8.39",
      "25-bound": [7.65, 9.12],
      "50-mid": "9.68",
      "50-bound": [8.76, 10.5],
      "100-mid": "11.1",
      "100-bound": [9.93, 12.1]
    },
    "7day": {
      "2-mid": "5.3",
      "2-bound": [4.91, 5.74],
      "5-mid": "6.66",
      "5-bound": [6.16, 7.21],
      "10-mid": "7.79",
      "10-bound": [7.18, 8.44],
      "25-mid": "9.42",
      "25-bound": [8.64, 10.2],
      "50-mid": "10.8",
      "50-bound": [9.82, 11.7],
      "100-mid": "12.3",
      "100-bound": [11.1, 13.3]
    }
  },
  "USW00014771 6": {
    "fips": "36067",
    "station_name": "SYRACUSE HANCOCK INTL AP",
    "state": "NY",
    "latitude": "43.1110",
    "longitude": "-76.1030",
    "5min": {
      "2-mid": "0.34",
      "2-bound": [0.28, 0.41],
      "5-mid": "0.43",
      "5-bound": [0.35, 0.52],
      "10-mid": "0.51",
      "10-bound": [0.41, 0.62],
      "25-mid": "0.61",
      "25-bound": [0.48, 0.78],
      "50-mid": "0.69",
      "50-bound": [0.53, 0.9],
      "100-mid": "0.78",
      "100-bound": [0.57, 1.04]
    },
    "10min": {
      "2-mid": "0.48",
      "2-bound": [0.4, 0.58],
      "5-mid": "0.61",
      "5-bound": [0.5, 0.74],
      "10-mid": "0.72",
      "10-bound": [0.59, 0.88],
      "25-mid": "0.87",
      "25-bound": [0.68, 1.11],
      "50-mid": "0.98",
      "50-bound": [0.75, 1.27],
      "100-mid": "1.1",
      "100-bound": [0.81, 1.47]
    },
    "15min": {
      "2-mid": "0.56",
      "2-bound": [0.47, 0.69],
      "5-mid": "0.72",
      "5-bound": [0.59, 0.88],
      "10-mid": "0.85",
      "10-bound": [0.69, 1.04],
      "25-mid": "1.02",
      "25-bound": [0.8, 1.3],
      "50-mid": "1.16",
      "50-bound": [0.88, 1.5],
      "100-mid": "1.3",
      "100-bound": [0.95, 1.73]
    },
    "30min": {
      "2-mid": "0.8",
      "2-bound": [0.66, 0.97],
      "5-mid": "1.02",
      "5-bound": [0.84, 1.24],
      "10-mid": "1.2",
      "10-bound": [0.98, 1.47],
      "25-mid": "1.45",
      "25-bound": [1.14, 1.84],
      "50-mid": "1.64",
      "50-bound": [1.25, 2.12],
      "100-mid": "1.84",
      "100-bound": [1.35, 2.46]
    },
    "60min": {
      "2-mid": "1.04",
      "2-bound": [0.85, 1.26],
      "5-mid": "1.32",
      "5-bound": [1.08, 1.61],
      "10-mid": "1.56",
      "10-bound": [1.27, 1.9],
      "25-mid": "1.88",
      "25-bound": [1.47, 2.39],
      "50-mid": "2.12",
      "50-bound": [1.62, 2.75],
      "100-mid": "2.38",
      "100-bound": [1.74, 3.18]
    },
    "2hr": {
      "2-mid": "1.32",
      "2-bound": [1.09, 1.59],
      "5-mid": "1.65",
      "5-bound": [1.37, 2.0],
      "10-mid": "1.93",
      "10-bound": [1.59, 2.34],
      "25-mid": "2.32",
      "25-bound": [1.82, 2.91],
      "50-mid": "2.61",
      "50-bound": [2.0, 3.34],
      "100-mid": "2.91",
      "100-bound": [2.15, 3.84]
    },
    "3hr": {
      "2-mid": "1.49",
      "2-bound": [1.24, 1.79],
      "5-mid": "1.86",
      "5-bound": [1.54, 2.23],
      "10-mid": "2.16",
      "10-bound": [1.78, 2.61],
      "25-mid": "2.58",
      "25-bound": [2.04, 3.23],
      "50-mid": "2.9",
      "50-bound": [2.24, 3.69],
      "100-mid": "3.23",
      "100-bound": [2.4, 4.24]
    },
    "6hr": {
      "2-mid": "1.79",
      "2-bound": [1.5, 2.13],
      "5-mid": "2.22",
      "5-bound": [1.85, 2.65],
      "10-mid": "2.58",
      "10-bound": [2.14, 3.09],
      "25-mid": "3.07",
      "25-bound": [2.45, 3.81],
      "50-mid": "3.45",
      "50-bound": [2.68, 4.35],
      "100-mid": "3.83",
      "100-bound": [2.88, 4.98]
    },
    "12hr": {
      "2-mid": "2.08",
      "2-bound": [1.76, 2.47],
      "5-mid": "2.6",
      "5-bound": [2.18, 3.08],
      "10-mid": "3.02",
      "10-bound": [2.52, 3.6],
      "25-mid": "3.6",
      "25-bound": [2.9, 4.44],
      "50-mid": "4.04",
      "50-bound": [3.18, 5.06],
      "100-mid": "4.5",
      "100-bound": [3.42, 5.8]
    },
    "24hr": {
      "2-mid": "2.39",
      "2-bound": [2.03, 2.81],
      "5-mid": "2.97",
      "5-bound": [2.51, 3.5],
      "10-mid": "3.45",
      "10-bound": [2.9, 4.08],
      "25-mid": "4.11",
      "25-bound": [3.34, 5.02],
      "50-mid": "4.61",
      "50-bound": [3.66, 5.72],
      "100-mid": "5.13",
      "100-bound": [3.94, 6.55]
    },
    "2day": {
      "2-mid": "2.73",
      "2-bound": [2.34, 3.19],
      "5-mid": "3.36",
      "5-bound": [2.86, 3.93],
      "10-mid": "3.87",
      "10-bound": [3.28, 4.55],
      "25-mid": "4.58",
      "25-bound": [3.75, 5.55],
      "50-mid": "5.13",
      "50-bound": [4.1, 6.29],
      "100-mid": "5.68",
      "100-bound": [4.4, 7.16]
    },
    "3day": {
      "2-mid": "3.0",
      "2-bound": [2.57, 3.48],
      "5-mid": "3.64",
      "5-bound": [3.12, 4.25],
      "10-mid": "4.18",
      "10-bound": [3.56, 4.89],
      "25-mid": "4.92",
      "25-bound": [4.04, 5.92],
      "50-mid": "5.48",
      "50-bound": [4.4, 6.69],
      "100-mid": "6.05",
      "100-bound": [4.71, 7.58]
    },
    "4day": {
      "2-mid": "3.23",
      "2-bound": [2.78, 3.74],
      "5-mid": "3.89",
      "5-bound": [3.34, 4.52],
      "10-mid": "4.44",
      "10-bound": [3.79, 5.18],
      "25-mid": "5.19",
      "25-bound": [4.28, 6.23],
      "50-mid": "5.76",
      "50-bound": [4.66, 7.01],
      "100-mid": "6.35",
      "100-bound": [4.97, 7.92]
    },
    "7day": {
      "2-mid": "3.83",
      "2-bound": [3.32, 4.42],
      "5-mid": "4.53",
      "5-bound": [3.91, 5.23],
      "10-mid": "5.1",
      "10-bound": [4.38, 5.92],
      "25-mid": "5.9",
      "25-bound": [4.9, 7.02],
      "50-mid": "6.5",
      "50-bound": [5.29, 7.85],
      "100-mid": "7.12",
      "100-bound": [5.63, 8.81]
    }
  },
  "USC00182325 6": {
    "fips": "11001",
    "station_name": "DALECARLIA RESERVOIR",
    "state": "DC",
    "latitude": "38.9380",
    "longitude": "-77.1130",
    "5min": {
      "2-mid": "0.43",
      "2-bound": [0.39, 0.47],
      "5-mid": "0.51",
      "5-bound": [0.46, 0.56],
      "10-mid": "0.57",
      "10-bound": [0.51, 0.62],
      "25-mid": "0.64",
      "25-bound": [0.57, 0.71],
      "50-mid": "0.7",
      "50-bound": [0.62, 0.77],
      "100-mid": "0.75",
      "100-bound": [0.67, 0.83]
    },
    "10min": {
      "2-mid": "0.68",
      "2-bound": [0.62, 0.75],
      "5-mid": "0.81",
      "5-bound": [0.73, 0.89],
      "10-mid": "0.91",
      "10-bound": [0.82, 1.0],
      "25-mid": "1.02",
      "25-bound": [0.92, 1.13],
      "50-mid": "1.11",
      "50-bound": [0.99, 1.23],
      "100-mid": "1.2",
      "100-bound": [1.06, 1.32]
    },
    "15min": {
      "2-mid": "0.86",
      "2-bound": [0.78, 0.94],
      "5-mid": "1.03",
      "5-bound": [0.93, 1.13],
      "10-mid": "1.14",
      "10-bound": [1.03, 1.26],
      "25-mid": "1.3",
      "25-bound": [1.16, 1.43],
      "50-mid": "1.41",
      "50-bound": [1.25, 1.55],
      "100-mid": "1.51",
      "100-bound": [1.34, 1.67]
    },
    "30min": {
      "2-mid": "1.18",
      "2-bound": [1.07, 1.3],
      "5-mid": "1.46",
      "5-bound": [1.32, 1.61],
      "10-mid": "1.66",
      "10-bound": [1.5, 1.83],
      "25-mid": "1.92",
      "25-bound": [1.72, 2.12],
      "50-mid": "2.12",
      "50-bound": [1.89, 2.34],
      "100-mid": "2.32",
      "100-bound": [2.05, 2.56]
    },
    "60min": {
      "2-mid": "1.48",
      "2-bound": [1.35, 1.63],
      "5-mid": "1.87",
      "5-bound": [1.69, 2.06],
      "10-mid": "2.16",
      "10-bound": [1.95, 2.38],
      "25-mid": "2.56",
      "25-bound": [2.29, 2.82],
      "50-mid": "2.87",
      "50-bound": [2.56, 3.17],
      "100-mid": "3.19",
      "100-bound": [2.83, 3.53]
    },
    "2hr": {
      "2-mid": "1.73",
      "2-bound": [1.57, 1.91],
      "5-mid": "2.19",
      "5-bound": [1.99, 2.41],
      "10-mid": "2.55",
      "10-bound": [2.3, 2.8],
      "25-mid": "3.06",
      "25-bound": [2.75, 3.36],
      "50-mid": "3.47",
      "50-bound": [3.1, 3.82],
      "100-mid": "3.91",
      "100-bound": [3.46, 4.31]
    },
    "3hr": {
      "2-mid": "1.85",
      "2-bound": [1.68, 2.04],
      "5-mid": "2.34",
      "5-bound": [2.12, 2.59],
      "10-mid": "2.74",
      "10-bound": [2.47, 3.02],
      "25-mid": "3.3",
      "25-bound": [2.95, 3.64],
      "50-mid": "3.77",
      "50-bound": [3.35, 4.16],
      "100-mid": "4.26",
      "100-bound": [3.76, 4.71]
    },
    "6hr": {
      "2-mid": "2.26",
      "2-bound": [2.05, 2.5],
      "5-mid": "2.86",
      "5-bound": [2.58, 3.16],
      "10-mid": "3.34",
      "10-bound": [3.01, 3.69],
      "25-mid": "4.07",
      "25-bound": [3.63, 4.49],
      "50-mid": "4.68",
      "50-bound": [4.14, 5.18],
      "100-mid": "5.35",
      "100-bound": [4.69, 5.93]
    },
    "12hr": {
      "2-mid": "2.73",
      "2-bound": [2.46, 3.06],
      "5-mid": "3.47",
      "5-bound": [3.12, 3.89],
      "10-mid": "4.1",
      "10-bound": [3.67, 4.59],
      "25-mid": "5.07",
      "25-bound": [4.48, 5.66],
      "50-mid": "5.92",
      "50-bound": [5.17, 6.61],
      "100-mid": "6.86",
      "100-bound": [5.92, 7.68]
    },
    "24hr": {
      "2-mid": "3.18",
      "2-bound": [2.89, 3.53],
      "5-mid": "4.08",
      "5-bound": [3.71, 4.53],
      "10-mid": "4.88",
      "10-bound": [4.42, 5.4],
      "25-mid": "6.1",
      "25-bound": [5.48, 6.72],
      "50-mid": "7.19",
      "50-bound": [6.41, 7.88],
      "100-mid": "8.42",
      "100-bound": [7.44, 9.2]
    },
    "2day": {
      "2-mid": "3.68",
      "2-bound": [3.35, 4.08],
      "5-mid": "4.71",
      "5-bound": [4.29, 5.22],
      "10-mid": "5.6",
      "10-bound": [5.08, 6.19],
      "25-mid": "6.94",
      "25-bound": [6.25, 7.64],
      "50-mid": "8.11",
      "50-bound": [7.26, 8.9],
      "100-mid": "9.41",
      "100-bound": [8.35, 10.3]
    },
    "3day": {
      "2-mid": "3.89",
      "2-bound": [3.55, 4.31],
      "5-mid": "4.97",
      "5-bound": [4.53, 5.5],
      "10-mid": "5.91",
      "10-bound": [5.36, 6.52],
      "25-mid": "7.31",
      "25-bound": [6.6, 8.05],
      "50-mid": "8.54",
      "50-bound": [7.65, 9.38],
      "100-mid": "9.9",
      "100-bound": [8.79, 10.9]
    },
    "4day": {
      "2-mid": "4.1",
      "2-bound": [3.74, 4.54],
      "5-mid": "5.23",
      "5-bound": [4.77, 5.79],
      "10-mid": "6.21",
      "10-bound": [5.65, 6.86],
      "25-mid": "7.69",
      "25-bound": [6.94, 8.46],
      "50-mid": "8.96",
      "50-bound": [8.05, 9.85],
      "100-mid": "10.4",
      "100-bound": [9.24, 11.4]
    },
    "7day": {
      "2-mid": "4.73",
      "2-bound": [4.35, 5.21],
      "5-mid": "5.98",
      "5-bound": [5.48, 6.58],
      "10-mid": "7.05",
      "10-bound": [6.45, 7.75],
      "25-mid": "8.65",
      "25-bound": [7.86, 9.48],
      "50-mid": "10.0",
      "50-bound": [9.06, 11.0],
      "100-mid": "11.6",
      "100-bound": [10.3, 12.6]
    }
  },
  "USC00448054 6": {
    "fips": "51075",
    "station_name": "CROZIER",
    "state": "VA",
    "latitude": "37.6660",
    "longitude": "-77.8760",
    "5min": {
      "2-mid": "0.42",
      "2-bound": [0.38, 0.47],
      "5-mid": "0.49",
      "5-bound": [0.44, 0.55],
      "10-mid": "0.56",
      "10-bound": [0.5, 0.62],
      "25-mid": "0.63",
      "25-bound": [0.56, 0.69],
      "50-mid": "0.68",
      "50-bound": [0.61, 0.76],
      "100-mid": "0.73",
      "100-bound": [0.65, 0.81]
    },
    "10min": {
      "2-mid": "0.68",
      "2-bound": [0.61, 0.76],
      "5-mid": "0.79",
      "5-bound": [0.71, 0.88],
      "10-mid": "0.9",
      "10-bound": [0.8, 0.99],
      "25-mid": "1.0",
      "25-bound": [0.9, 1.11],
      "50-mid": "1.09",
      "50-bound": [0.97, 1.2],
      "100-mid": "1.16",
      "100-bound": [1.03, 1.29]
    },
    "15min": {
      "2-mid": "0.85",
      "2-bound": [0.77, 0.95],
      "5-mid": "1.0",
      "5-bound": [0.9, 1.11],
      "10-mid": "1.13",
      "10-bound": [1.02, 1.26],
      "25-mid": "1.27",
      "25-bound": [1.14, 1.4],
      "50-mid": "1.38",
      "50-bound": [1.22, 1.52],
      "100-mid": "1.47",
      "100-bound": [1.3, 1.62]
    },
    "30min": {
      "2-mid": "1.18",
      "2-bound": [1.06, 1.31],
      "5-mid": "1.42",
      "5-bound": [1.28, 1.58],
      "10-mid": "1.64",
      "10-bound": [1.47, 1.82],
      "25-mid": "1.88",
      "25-bound": [1.68, 2.08],
      "50-mid": "2.07",
      "50-bound": [1.84, 2.29],
      "100-mid": "2.25",
      "100-bound": [1.99, 2.49]
    },
    "60min": {
      "2-mid": "1.48",
      "2-bound": [1.33, 1.64],
      "5-mid": "1.82",
      "5-bound": [1.64, 2.02],
      "10-mid": "2.14",
      "10-bound": [1.92, 2.37],
      "25-mid": "2.5",
      "25-bound": [2.24, 2.77],
      "50-mid": "2.81",
      "50-bound": [2.5, 3.1],
      "100-mid": "3.1",
      "100-bound": [2.75, 3.43]
    },
    "2hr": {
      "2-mid": "1.74",
      "2-bound": [1.55, 1.95],
      "5-mid": "2.16",
      "5-bound": [1.93, 2.42],
      "10-mid": "2.55",
      "10-bound": [2.28, 2.86],
      "25-mid": "3.04",
      "25-bound": [2.69, 3.38],
      "50-mid": "3.45",
      "50-bound": [3.04, 3.84],
      "100-mid": "3.86",
      "100-bound": [3.38, 4.29]
    },
    "3hr": {
      "2-mid": "1.88",
      "2-bound": [1.68, 2.12],
      "5-mid": "2.33",
      "5-bound": [2.08, 2.63],
      "10-mid": "2.76",
      "10-bound": [2.45, 3.11],
      "25-mid": "3.28",
      "25-bound": [2.9, 3.68],
      "50-mid": "3.73",
      "50-bound": [3.27, 4.18],
      "100-mid": "4.18",
      "100-bound": [3.64, 4.68]
    },
    "6hr": {
      "2-mid": "2.28",
      "2-bound": [2.02, 2.61],
      "5-mid": "2.82",
      "5-bound": [2.49, 3.22],
      "10-mid": "3.35",
      "10-bound": [2.95, 3.82],
      "25-mid": "4.02",
      "25-bound": [3.51, 4.57],
      "50-mid": "4.61",
      "50-bound": [4.01, 5.23],
      "100-mid": "5.22",
      "100-bound": [4.5, 5.92]
    },
    "12hr": {
      "2-mid": "2.76",
      "2-bound": [2.45, 3.16],
      "5-mid": "3.42",
      "5-bound": [3.03, 3.92],
      "10-mid": "4.1",
      "10-bound": [3.61, 4.68],
      "25-mid": "4.98",
      "25-bound": [4.34, 5.66],
      "50-mid": "5.78",
      "50-bound": [5.0, 6.55],
      "100-mid": "6.62",
      "100-bound": [5.66, 7.48]
    },
    "24hr": {
      "2-mid": "3.28",
      "2-bound": [2.98, 3.64],
      "5-mid": "4.2",
      "5-bound": [3.8, 4.65],
      "10-mid": "4.97",
      "10-bound": [4.49, 5.5],
      "25-mid": "6.12",
      "25-bound": [5.48, 6.76],
      "50-mid": "7.11",
      "50-bound": [6.32, 7.84],
      "100-mid": "8.19",
      "100-bound": [7.22, 9.02]
    },
    "2day": {
      "2-mid": "3.85",
      "2-bound": [3.49, 4.28],
      "5-mid": "4.89",
      "5-bound": [4.42, 5.43],
      "10-mid": "5.75",
      "10-bound": [5.19, 6.39],
      "25-mid": "7.0",
      "25-bound": [6.29, 7.76],
      "50-mid": "8.05",
      "50-bound": [7.19, 8.92],
      "100-mid": "9.18",
      "100-bound": [8.15, 10.2]
    },
    "3day": {
      "2-mid": "4.06",
      "2-bound": [3.7, 4.49],
      "5-mid": "5.16",
      "5-bound": [4.69, 5.7],
      "10-mid": "6.07",
      "10-bound": [5.5, 6.7],
      "25-mid": "7.38",
      "25-bound": [6.66, 8.14],
      "50-mid": "8.49",
      "50-bound": [7.62, 9.35],
      "100-mid": "9.68",
      "100-bound": [8.63, 10.6]
    },
    "4day": {
      "2-mid": "4.28",
      "2-bound": [3.9, 4.7],
      "5-mid": "5.44",
      "5-bound": [4.95, 5.97],
      "10-mid": "6.39",
      "10-bound": [5.81, 7.01],
      "25-mid": "7.77",
      "25-bound": [7.03, 8.52],
      "50-mid": "8.93",
      "50-bound": [8.04, 9.78],
      "100-mid": "10.2",
      "100-bound": [9.1, 11.1]
    },
    "7day": {
      "2-mid": "4.89",
      "2-bound": [4.51, 5.34],
      "5-mid": "6.12",
      "5-bound": [5.63, 6.67],
      "10-mid": "7.13",
      "10-bound": [6.54, 7.77],
      "25-mid": "8.58",
      "25-bound": [7.83, 9.33],
      "50-mid": "9.78",
      "50-bound": [8.89, 10.6],
      "100-mid": "11.1",
      "100-bound": [10.0, 12.0]
    }
  },
  "USC00308578 6": {
    "fips": "36065",
    "station_name": "TRENTON FALLS",
    "state": "NY",
    "latitude": "43.2760",
    "longitude": "-75.1560",
    "5min": {
      "2-mid": "0.36",
      "2-bound": [0.29, 0.45],
      "5-mid": "0.45",
      "5-bound": [0.35, 0.56],
      "10-mid": "0.52",
      "10-bound": [0.41, 0.65],
      "25-mid": "0.62",
      "25-bound": [0.47, 0.79],
      "50-mid": "0.69",
      "50-bound": [0.52, 0.89],
      "100-mid": "0.77",
      "100-bound": [0.56, 1.01]
    },
    "10min": {
      "2-mid": "0.51",
      "2-bound": [0.41, 0.63],
      "5-mid": "0.64",
      "5-bound": [0.5, 0.79],
      "10-mid": "0.74",
      "10-bound": [0.58, 0.91],
      "25-mid": "0.88",
      "25-bound": [0.67, 1.12],
      "50-mid": "0.98",
      "50-bound": [0.73, 1.27],
      "100-mid": "1.09",
      "100-bound": [0.79, 1.43]
    },
    "15min": {
      "2-mid": "0.6",
      "2-bound": [0.48, 0.75],
      "5-mid": "0.75",
      "5-bound": [0.59, 0.93],
      "10-mid": "0.87",
      "10-bound": [0.68, 1.08],
      "25-mid": "1.03",
      "25-bound": [0.79, 1.31],
      "50-mid": "1.16",
      "50-bound": [0.86, 1.49],
      "100-mid": "1.28",
      "100-bound": [0.93, 1.69]
    },
    "30min": {
      "2-mid": "0.82",
      "2-bound": [0.65, 1.02],
      "5-mid": "1.02",
      "5-bound": [0.81, 1.26],
      "10-mid": "1.18",
      "10-bound": [0.93, 1.47],
      "25-mid": "1.4",
      "25-bound": [1.07, 1.79],
      "50-mid": "1.58",
      "50-bound": [1.18, 2.03],
      "100-mid": "1.75",
      "100-bound": [1.26, 2.3]
    },
    "60min": {
      "2-mid": "1.04",
      "2-bound": [0.83, 1.29],
      "5-mid": "1.29",
      "5-bound": [1.02, 1.6],
      "10-mid": "1.5",
      "10-bound": [1.18, 1.86],
      "25-mid": "1.78",
      "25-bound": [1.35, 2.26],
      "50-mid": "1.99",
      "50-bound": [1.49, 2.57],
      "100-mid": "2.21",
      "100-bound": [1.6, 2.91]
    },
    "2hr": {
      "2-mid": "1.32",
      "2-bound": [1.06, 1.61],
      "5-mid": "1.64",
      "5-bound": [1.3, 2.01],
      "10-mid": "1.9",
      "10-bound": [1.51, 2.34],
      "25-mid": "2.26",
      "25-bound": [1.74, 2.86],
      "50-mid": "2.54",
      "50-bound": [1.92, 3.26],
      "100-mid": "2.82",
      "100-bound": [2.07, 3.71]
    },
    "3hr": {
      "2-mid": "1.5",
      "2-bound": [1.21, 1.83],
      "5-mid": "1.87",
      "5-bound": [1.5, 2.28],
      "10-mid": "2.17",
      "10-bound": [1.73, 2.66],
      "25-mid": "2.58",
      "25-bound": [2.0, 3.26],
      "50-mid": "2.9",
      "50-bound": [2.2, 3.71],
      "100-mid": "3.22",
      "100-bound": [2.38, 4.24]
    },
    "6hr": {
      "2-mid": "1.87",
      "2-bound": [1.52, 2.27],
      "5-mid": "2.33",
      "5-bound": [1.88, 2.82],
      "10-mid": "2.7",
      "10-bound": [2.17, 3.28],
      "25-mid": "3.22",
      "25-bound": [2.51, 4.03],
      "50-mid": "3.6",
      "50-bound": [2.76, 4.59],
      "100-mid": "4.01",
      "100-bound": [2.99, 5.24]
    },
    "12hr": {
      "2-mid": "2.31",
      "2-bound": [1.9, 2.78],
      "5-mid": "2.86",
      "5-bound": [2.33, 3.44],
      "10-mid": "3.31",
      "10-bound": [2.68, 3.99],
      "25-mid": "3.93",
      "25-bound": [3.09, 4.89],
      "50-mid": "4.4",
      "50-bound": [3.39, 5.55],
      "100-mid": "4.88",
      "100-bound": [3.66, 6.33]
    },
    "24hr": {
      "2-mid": "2.77",
      "2-bound": [2.29, 3.3],
      "5-mid": "3.39",
      "5-bound": [2.79, 4.04],
      "10-mid": "3.9",
      "10-bound": [3.2, 4.67],
      "25-mid": "4.6",
      "25-bound": [3.65, 5.68],
      "50-mid": "5.14",
      "50-bound": [4.0, 6.42],
      "100-mid": "5.69",
      "100-bound": [4.29, 7.29]
    },
    "2day": {
      "2-mid": "3.23",
      "2-bound": [2.69, 3.81],
      "5-mid": "3.88",
      "5-bound": [3.23, 4.6],
      "10-mid": "4.43",
      "10-bound": [3.66, 5.26],
      "25-mid": "5.18",
      "25-bound": [4.14, 6.32],
      "50-mid": "5.75",
      "50-bound": [4.5, 7.12],
      "100-mid": "6.34",
      "100-bound": [4.8, 8.02]
    },
    "3day": {
      "2-mid": "3.55",
      "2-bound": [2.98, 4.18],
      "5-mid": "4.23",
      "5-bound": [3.54, 4.98],
      "10-mid": "4.79",
      "10-bound": [3.98, 5.67],
      "25-mid": "5.56",
      "25-bound": [4.47, 6.75],
      "50-mid": "6.16",
      "50-bound": [4.84, 7.57],
      "100-mid": "6.75",
      "100-bound": [5.13, 8.5]
    },
    "4day": {
      "2-mid": "3.84",
      "2-bound": [3.23, 4.49],
      "5-mid": "4.52",
      "5-bound": [3.8, 5.32],
      "10-mid": "5.1",
      "10-bound": [4.25, 6.01],
      "25-mid": "5.88",
      "25-bound": [4.74, 7.12],
      "50-mid": "6.49",
      "50-bound": [5.12, 7.95],
      "100-mid": "7.1",
      "100-bound": [5.41, 8.89]
    },
    "7day": {
      "2-mid": "4.59",
      "2-bound": [3.89, 5.34],
      "5-mid": "5.31",
      "5-bound": [4.49, 6.2],
      "10-mid": "5.91",
      "10-bound": [4.97, 6.93],
      "25-mid": "6.74",
      "25-bound": [5.48, 8.09],
      "50-mid": "7.39",
      "50-bound": [5.86, 8.98],
      "100-mid": "8.02",
      "100-bound": [6.14, 9.95]
    }
  },
  "USC00441180 6": {
    "fips": "51117",
    "station_name": "JOHN H KERR DAM",
    "state": "VA",
    "latitude": "36.6002",
    "longitude": "-78.3011",
    "5min": {
      "2-mid": "0.44",
      "2-bound": [0.39, 0.48],
      "5-mid": "0.51",
      "5-bound": [0.46, 0.56],
      "10-mid": "0.57",
      "10-bound": [0.51, 0.63],
      "25-mid": "0.64",
      "25-bound": [0.57, 0.71],
      "50-mid": "0.69",
      "50-bound": [0.62, 0.77],
      "100-mid": "0.74",
      "100-bound": [0.66, 0.82]
    },
    "10min": {
      "2-mid": "0.7",
      "2-bound": [0.63, 0.78],
      "5-mid": "0.81",
      "5-bound": [0.73, 0.9],
      "10-mid": "0.91",
      "10-bound": [0.82, 1.01],
      "25-mid": "1.02",
      "25-bound": [0.91, 1.13],
      "50-mid": "1.1",
      "50-bound": [0.98, 1.22],
      "100-mid": "1.18",
      "100-bound": [1.04, 1.3]
    },
    "15min": {
      "2-mid": "0.88",
      "2-bound": [0.79, 0.98],
      "5-mid": "1.03",
      "5-bound": [0.93, 1.14],
      "10-mid": "1.16",
      "10-bound": [1.04, 1.28],
      "25-mid": "1.29",
      "25-bound": [1.16, 1.43],
      "50-mid": "1.4",
      "50-bound": [1.24, 1.55],
      "100-mid": "1.49",
      "100-bound": [1.32, 1.65]
    },
    "30min": {
      "2-mid": "1.21",
      "2-bound": [1.1, 1.35],
      "5-mid": "1.46",
      "5-bound": [1.32, 1.62],
      "10-mid": "1.68",
      "10-bound": [1.5, 1.86],
      "25-mid": "1.92",
      "25-bound": [1.71, 2.12],
      "50-mid": "2.1",
      "50-bound": [1.88, 2.33],
      "100-mid": "2.28",
      "100-bound": [2.02, 2.52]
    },
    "60min": {
      "2-mid": "1.52",
      "2-bound": [1.37, 1.69],
      "5-mid": "1.88",
      "5-bound": [1.69, 2.08],
      "10-mid": "2.18",
      "10-bound": [1.96, 2.42],
      "25-mid": "2.55",
      "25-bound": [2.28, 2.83],
      "50-mid": "2.85",
      "50-bound": [2.54, 3.16],
      "100-mid": "3.14",
      "100-bound": [2.78, 3.47]
    },
    "2hr": {
      "2-mid": "1.79",
      "2-bound": [1.61, 1.99],
      "5-mid": "2.22",
      "5-bound": [1.99, 2.47],
      "10-mid": "2.62",
      "10-bound": [2.33, 2.9],
      "25-mid": "3.1",
      "25-bound": [2.75, 3.44],
      "50-mid": "3.52",
      "50-bound": [3.1, 3.9],
      "100-mid": "3.93",
      "100-bound": [3.44, 4.36]
    },
    "3hr": {
      "2-mid": "1.92",
      "2-bound": [1.72, 2.14],
      "5-mid": "2.38",
      "5-bound": [2.14, 2.66],
      "10-mid": "2.8",
      "10-bound": [2.51, 3.13],
      "25-mid": "3.34",
      "25-bound": [2.97, 3.72],
      "50-mid": "3.8",
      "50-bound": [3.36, 4.22],
      "100-mid": "4.26",
      "100-bound": [3.74, 4.73]
    },
    "6hr": {
      "2-mid": "2.31",
      "2-bound": [2.09, 2.57],
      "5-mid": "2.87",
      "5-bound": [2.58, 3.18],
      "10-mid": "3.39",
      "10-bound": [3.05, 3.75],
      "25-mid": "4.07",
      "25-bound": [3.64, 4.49],
      "50-mid": "4.67",
      "50-bound": [4.15, 5.14],
      "100-mid": "5.29",
      "100-bound": [4.66, 5.8]
    },
    "12hr": {
      "2-mid": "2.76",
      "2-bound": [2.53, 3.05],
      "5-mid": "3.45",
      "5-bound": [3.14, 3.8],
      "10-mid": "4.1",
      "10-bound": [3.73, 4.51],
      "25-mid": "4.99",
      "25-bound": [4.5, 5.46],
      "50-mid": "5.78",
      "50-bound": [5.17, 6.29],
      "100-mid": "6.61",
      "100-bound": [5.85, 7.18]
    },
    "24hr": {
      "2-mid": "3.23",
      "2-bound": [3.02, 3.49],
      "5-mid": "4.12",
      "5-bound": [3.83, 4.44],
      "10-mid": "4.85",
      "10-bound": [4.5, 5.22],
      "25-mid": "5.92",
      "25-bound": [5.45, 6.35],
      "50-mid": "6.82",
      "50-bound": [6.24, 7.3],
      "100-mid": "7.79",
      "100-bound": [7.08, 8.33]
    },
    "2day": {
      "2-mid": "3.79",
      "2-bound": [3.54, 4.06],
      "5-mid": "4.79",
      "5-bound": [4.47, 5.13],
      "10-mid": "5.62",
      "10-bound": [5.23, 6.0],
      "25-mid": "6.78",
      "25-bound": [6.28, 7.24],
      "50-mid": "7.74",
      "50-bound": [7.14, 8.27],
      "100-mid": "8.77",
      "100-bound": [8.02, 9.38]
    },
    "3day": {
      "2-mid": "4.02",
      "2-bound": [3.75, 4.32],
      "5-mid": "5.07",
      "5-bound": [4.73, 5.44],
      "10-mid": "5.93",
      "10-bound": [5.52, 6.36],
      "25-mid": "7.15",
      "25-bound": [6.62, 7.66],
      "50-mid": "8.16",
      "50-bound": [7.52, 8.74],
      "100-mid": "9.24",
      "100-bound": [8.45, 9.9]
    },
    "4day": {
      "2-mid": "4.24",
      "2-bound": [3.96, 4.57],
      "5-mid": "5.35",
      "5-bound": [4.99, 5.75],
      "10-mid": "6.25",
      "10-bound": [5.81, 6.72],
      "25-mid": "7.52",
      "25-bound": [6.96, 8.08],
      "50-mid": "8.58",
      "50-bound": [7.91, 9.21],
      "100-mid": "9.7",
      "100-bound": [8.88, 10.4]
    },
    "7day": {
      "2-mid": "4.9",
      "2-bound": [4.58, 5.29],
      "5-mid": "6.09",
      "5-bound": [5.68, 6.57],
      "10-mid": "7.05",
      "10-bound": [6.55, 7.61],
      "25-mid": "8.42",
      "25-bound": [7.78, 9.07],
      "50-mid": "9.54",
      "50-bound": [8.78, 10.3],
      "100-mid": "10.7",
      "100-bound": [9.82, 11.5]
    }
  },
  "USC00305597 6": {
    "fips": "36051",
    "station_name": "MOUNT MORRIS 2 W",
    "state": "NY",
    "latitude": "42.7310",
    "longitude": "-77.9050",
    "5min": {
      "2-mid": "0.32",
      "2-bound": [0.26, 0.4],
      "5-mid": "0.42",
      "5-bound": [0.34, 0.52],
      "10-mid": "0.5",
      "10-bound": [0.4, 0.62],
      "25-mid": "0.61",
      "25-bound": [0.47, 0.79],
      "50-mid": "0.69",
      "50-bound": [0.52, 0.91],
      "100-mid": "0.78",
      "100-bound": [0.57, 1.06]
    },
    "10min": {
      "2-mid": "0.46",
      "2-bound": [0.37, 0.56],
      "5-mid": "0.59",
      "5-bound": [0.48, 0.73],
      "10-mid": "0.71",
      "10-bound": [0.56, 0.88],
      "25-mid": "0.86",
      "25-bound": [0.66, 1.11],
      "50-mid": "0.98",
      "50-bound": [0.74, 1.29],
      "100-mid": "1.11",
      "100-bound": [0.81, 1.5]
    },
    "15min": {
      "2-mid": "0.54",
      "2-bound": [0.43, 0.66],
      "5-mid": "0.7",
      "5-bound": [0.56, 0.86],
      "10-mid": "0.83",
      "10-bound": [0.66, 1.03],
      "25-mid": "1.02",
      "25-bound": [0.78, 1.31],
      "50-mid": "1.15",
      "50-bound": [0.87, 1.52],
      "100-mid": "1.3",
      "100-bound": [0.95, 1.77]
    },
    "30min": {
      "2-mid": "0.73",
      "2-bound": [0.59, 0.9],
      "5-mid": "0.95",
      "5-bound": [0.76, 1.18],
      "10-mid": "1.13",
      "10-bound": [0.9, 1.4],
      "25-mid": "1.38",
      "25-bound": [1.06, 1.78],
      "50-mid": "1.57",
      "50-bound": [1.18, 2.06],
      "100-mid": "1.77",
      "100-bound": [1.29, 2.41]
    },
    "60min": {
      "2-mid": "0.93",
      "2-bound": [0.75, 1.14],
      "5-mid": "1.21",
      "5-bound": [0.97, 1.49],
      "10-mid": "1.44",
      "10-bound": [1.14, 1.78],
      "25-mid": "1.75",
      "25-bound": [1.35, 2.26],
      "50-mid": "1.99",
      "50-bound": [1.49, 2.61],
      "100-mid": "2.24",
      "100-bound": [1.63, 3.05]
    },
    "2hr": {
      "2-mid": "1.14",
      "2-bound": [0.92, 1.39],
      "5-mid": "1.47",
      "5-bound": [1.18, 1.8],
      "10-mid": "1.74",
      "10-bound": [1.39, 2.14],
      "25-mid": "2.12",
      "25-bound": [1.64, 2.7],
      "50-mid": "2.4",
      "50-bound": [1.81, 3.12],
      "100-mid": "2.7",
      "100-bound": [1.98, 3.62]
    },
    "3hr": {
      "2-mid": "1.27",
      "2-bound": [1.04, 1.55],
      "5-mid": "1.63",
      "5-bound": [1.32, 1.99],
      "10-mid": "1.93",
      "10-bound": [1.55, 2.37],
      "25-mid": "2.34",
      "25-bound": [1.82, 2.98],
      "50-mid": "2.65",
      "50-bound": [2.01, 3.43],
      "100-mid": "2.97",
      "100-bound": [2.19, 3.98]
    },
    "6hr": {
      "2-mid": "1.54",
      "2-bound": [1.26, 1.87],
      "5-mid": "1.96",
      "5-bound": [1.6, 2.37],
      "10-mid": "2.3",
      "10-bound": [1.86, 2.8],
      "25-mid": "2.77",
      "25-bound": [2.17, 3.49],
      "50-mid": "3.12",
      "50-bound": [2.39, 4.0],
      "100-mid": "3.49",
      "100-bound": [2.6, 4.63]
    },
    "12hr": {
      "2-mid": "1.87",
      "2-bound": [1.54, 2.25],
      "5-mid": "2.34",
      "5-bound": [1.92, 2.81],
      "10-mid": "2.73",
      "10-bound": [2.22, 3.3],
      "25-mid": "3.26",
      "25-bound": [2.57, 4.09],
      "50-mid": "3.66",
      "50-bound": [2.83, 4.67],
      "100-mid": "4.08",
      "100-bound": [3.07, 5.39]
    },
    "24hr": {
      "2-mid": "2.22",
      "2-bound": [1.84, 2.64],
      "5-mid": "2.75",
      "5-bound": [2.27, 3.29],
      "10-mid": "3.19",
      "10-bound": [2.62, 3.83],
      "25-mid": "3.8",
      "25-bound": [3.02, 4.73],
      "50-mid": "4.26",
      "50-bound": [3.31, 5.38],
      "100-mid": "4.74",
      "100-bound": [3.59, 6.2]
    },
    "2day": {
      "2-mid": "2.57",
      "2-bound": [2.14, 3.04],
      "5-mid": "3.17",
      "5-bound": [2.64, 3.76],
      "10-mid": "3.68",
      "10-bound": [3.04, 4.38],
      "25-mid": "4.37",
      "25-bound": [3.49, 5.37],
      "50-mid": "4.88",
      "50-bound": [3.82, 6.11],
      "100-mid": "5.43",
      "100-bound": [4.13, 6.99]
    },
    "3day": {
      "2-mid": "2.81",
      "2-bound": [2.35, 3.31],
      "5-mid": "3.44",
      "5-bound": [2.88, 4.07],
      "10-mid": "3.97",
      "10-bound": [3.3, 4.71],
      "25-mid": "4.7",
      "25-bound": [3.77, 5.75],
      "50-mid": "5.25",
      "50-bound": [4.12, 6.52],
      "100-mid": "5.82",
      "100-bound": [4.44, 7.44]
    },
    "4day": {
      "2-mid": "3.0",
      "2-bound": [2.52, 3.53],
      "5-mid": "3.66",
      "5-bound": [3.07, 4.32],
      "10-mid": "4.21",
      "10-bound": [3.51, 4.98],
      "25-mid": "4.97",
      "25-bound": [4.0, 6.06],
      "50-mid": "5.54",
      "50-bound": [4.36, 6.86],
      "100-mid": "6.13",
      "100-bound": [4.68, 7.8]
    },
    "7day": {
      "2-mid": "3.5",
      "2-bound": [2.96, 4.1],
      "5-mid": "4.23",
      "5-bound": [3.56, 4.96],
      "10-mid": "4.83",
      "10-bound": [4.04, 5.68],
      "25-mid": "5.66",
      "25-bound": [4.58, 6.85],
      "50-mid": "6.29",
      "50-bound": [4.98, 7.72],
      "100-mid": "6.93",
      "100-bound": [5.32, 8.73]
    }
  },
  "USW00013750 6": {
    "fips": "51710",
    "station_name": "NORFOLK NAS",
    "state": "VA",
    "latitude": "36.9374",
    "longitude": "-76.2892",
    "5min": {
      "2-mid": "0.48",
      "2-bound": [0.44, 0.54],
      "5-mid": "0.56",
      "5-bound": [0.51, 0.61],
      "10-mid": "0.63",
      "10-bound": [0.57, 0.7],
      "25-mid": "0.71",
      "25-bound": [0.64, 0.78],
      "50-mid": "0.78",
      "50-bound": [0.7, 0.86],
      "100-mid": "0.85",
      "100-bound": [0.76, 0.93]
    },
    "10min": {
      "2-mid": "0.78",
      "2-bound": [0.71, 0.86],
      "5-mid": "0.89",
      "5-bound": [0.81, 0.98],
      "10-mid": "1.01",
      "10-bound": [0.92, 1.11],
      "25-mid": "1.14",
      "25-bound": [1.03, 1.25],
      "50-mid": "1.24",
      "50-bound": [1.12, 1.37],
      "100-mid": "1.34",
      "100-bound": [1.2, 1.48]
    },
    "15min": {
      "2-mid": "0.98",
      "2-bound": [0.89, 1.08],
      "5-mid": "1.13",
      "5-bound": [1.02, 1.24],
      "10-mid": "1.28",
      "10-bound": [1.16, 1.41],
      "25-mid": "1.44",
      "25-bound": [1.3, 1.58],
      "50-mid": "1.58",
      "50-bound": [1.42, 1.74],
      "100-mid": "1.7",
      "100-bound": [1.52, 1.87]
    },
    "30min": {
      "2-mid": "1.35",
      "2-bound": [1.23, 1.49],
      "5-mid": "1.6",
      "5-bound": [1.45, 1.76],
      "10-mid": "1.85",
      "10-bound": [1.68, 2.04],
      "25-mid": "2.13",
      "25-bound": [1.93, 2.34],
      "50-mid": "2.38",
      "50-bound": [2.14, 2.62],
      "100-mid": "2.6",
      "100-bound": [2.33, 2.86]
    },
    "60min": {
      "2-mid": "1.69",
      "2-bound": [1.54, 1.86],
      "5-mid": "2.05",
      "5-bound": [1.86, 2.26],
      "10-mid": "2.41",
      "10-bound": [2.18, 2.66],
      "25-mid": "2.84",
      "25-bound": [2.56, 3.12],
      "50-mid": "3.22",
      "50-bound": [2.9, 3.54],
      "100-mid": "3.59",
      "100-bound": [3.21, 3.94]
    },
    "2hr": {
      "2-mid": "2.01",
      "2-bound": [1.82, 2.22],
      "5-mid": "2.48",
      "5-bound": [2.25, 2.74],
      "10-mid": "2.97",
      "10-bound": [2.68, 3.27],
      "25-mid": "3.57",
      "25-bound": [3.2, 3.92],
      "50-mid": "4.11",
      "50-bound": [3.67, 4.52],
      "100-mid": "4.66",
      "100-bound": [4.13, 5.12]
    },
    "3hr": {
      "2-mid": "2.16",
      "2-bound": [1.95, 2.41],
      "5-mid": "2.68",
      "5-bound": [2.41, 2.98],
      "10-mid": "3.22",
      "10-bound": [2.9, 3.58],
      "25-mid": "3.92",
      "25-bound": [3.49, 4.34],
      "50-mid": "4.56",
      "50-bound": [4.04, 5.04],
      "100-mid": "5.22",
      "100-bound": [4.59, 5.76]
    },
    "6hr": {
      "2-mid": "2.61",
      "2-bound": [2.34, 2.93],
      "5-mid": "3.24",
      "5-bound": [2.9, 3.64],
      "10-mid": "3.9",
      "10-bound": [3.48, 4.37],
      "25-mid": "4.76",
      "25-bound": [4.22, 5.32],
      "50-mid": "5.56",
      "50-bound": [4.9, 6.19],
      "100-mid": "6.39",
      "100-bound": [5.58, 7.1]
    },
    "12hr": {
      "2-mid": "3.08",
      "2-bound": [2.74, 3.48],
      "5-mid": "3.84",
      "5-bound": [3.42, 4.33],
      "10-mid": "4.65",
      "10-bound": [4.12, 5.24],
      "25-mid": "5.72",
      "25-bound": [5.03, 6.43],
      "50-mid": "6.74",
      "50-bound": [5.88, 7.56],
      "100-mid": "7.81",
      "100-bound": [6.75, 8.73]
    },
    "24hr": {
      "2-mid": "3.56",
      "2-bound": [3.29, 3.89],
      "5-mid": "4.6",
      "5-bound": [4.25, 5.03],
      "10-mid": "5.49",
      "10-bound": [5.04, 5.98],
      "25-mid": "6.8",
      "25-bound": [6.21, 7.4],
      "50-mid": "7.94",
      "50-bound": [7.18, 8.62],
      "100-mid": "9.19",
      "100-bound": [8.23, 9.97]
    },
    "2day": {
      "2-mid": "4.1",
      "2-bound": [3.77, 4.51],
      "5-mid": "5.27",
      "5-bound": [4.84, 5.8],
      "10-mid": "6.28",
      "10-bound": [5.75, 6.9],
      "25-mid": "7.8",
      "25-bound": [7.07, 8.55],
      "50-mid": "9.12",
      "50-bound": [8.2, 9.98],
      "100-mid": "10.6",
      "100-bound": [9.43, 11.6]
    },
    "3day": {
      "2-mid": "4.33",
      "2-bound": [3.99, 4.75],
      "5-mid": "5.55",
      "5-bound": [5.1, 6.08],
      "10-mid": "6.58",
      "10-bound": [6.03, 7.19],
      "25-mid": "8.1",
      "25-bound": [7.37, 8.85],
      "50-mid": "9.41",
      "50-bound": [8.5, 10.3],
      "100-mid": "10.9",
      "100-bound": [9.7, 11.8]
    },
    "4day": {
      "2-mid": "4.57",
      "2-bound": [4.22, 4.99],
      "5-mid": "5.82",
      "5-bound": [5.37, 6.35],
      "10-mid": "6.87",
      "10-bound": [6.31, 7.48],
      "25-mid": "8.41",
      "25-bound": [7.67, 9.14],
      "50-mid": "9.71",
      "50-bound": [8.79, 10.6],
      "100-mid": "11.1",
      "100-bound": [9.98, 12.1]
    },
    "7day": {
      "2-mid": "5.3",
      "2-bound": [4.92, 5.74],
      "5-mid": "6.67",
      "5-bound": [6.17, 7.21],
      "10-mid": "7.8",
      "10-bound": [7.2, 8.43],
      "25-mid": "9.45",
      "25-bound": [8.66, 10.2],
      "50-mid": "10.8",
      "50-bound": [9.86, 11.7],
      "100-mid": "12.3",
      "100-bound": [11.1, 13.3]
    }
  },
  "USC00444909 6": {
    "fips": "51107",
    "station_name": "PURCELLVILLE",
    "state": "VA",
    "latitude": "39.1421",
    "longitude": "-77.7093",
    "5min": {
      "2-mid": "0.41",
      "2-bound": [0.37, 0.46],
      "5-mid": "0.5",
      "5-bound": [0.45, 0.55],
      "10-mid": "0.56",
      "10-bound": [0.5, 0.62],
      "25-mid": "0.65",
      "25-bound": [0.57, 0.71],
      "50-mid": "0.71",
      "50-bound": [0.63, 0.79],
      "100-mid": "0.78",
      "100-bound": [0.68, 0.86]
    },
    "10min": {
      "2-mid": "0.66",
      "2-bound": [0.59, 0.73],
      "5-mid": "0.79",
      "5-bound": [0.71, 0.88],
      "10-mid": "0.89",
      "10-bound": [0.79, 0.98],
      "25-mid": "1.01",
      "25-bound": [0.9, 1.12],
      "50-mid": "1.11",
      "50-bound": [0.98, 1.22],
      "100-mid": "1.21",
      "100-bound": [1.06, 1.33]
    },
    "15min": {
      "2-mid": "0.82",
      "2-bound": [0.73, 0.91],
      "5-mid": "0.98",
      "5-bound": [0.88, 1.1],
      "10-mid": "1.11",
      "10-bound": [0.99, 1.23],
      "25-mid": "1.27",
      "25-bound": [1.12, 1.4],
      "50-mid": "1.39",
      "50-bound": [1.23, 1.54],
      "100-mid": "1.52",
      "100-bound": [1.33, 1.67]
    },
    "30min": {
      "2-mid": "1.12",
      "2-bound": [1.0, 1.24],
      "5-mid": "1.38",
      "5-bound": [1.24, 1.54],
      "10-mid": "1.58",
      "10-bound": [1.41, 1.75],
      "25-mid": "1.84",
      "25-bound": [1.64, 2.04],
      "50-mid": "2.06",
      "50-bound": [1.82, 2.27],
      "100-mid": "2.27",
      "100-bound": [1.99, 2.51]
    },
    "60min": {
      "2-mid": "1.39",
      "2-bound": [1.25, 1.55],
      "5-mid": "1.76",
      "5-bound": [1.57, 1.95],
      "10-mid": "2.04",
      "10-bound": [1.82, 2.26],
      "25-mid": "2.43",
      "25-bound": [2.16, 2.69],
      "50-mid": "2.76",
      "50-bound": [2.43, 3.05],
      "100-mid": "3.09",
      "100-bound": [2.72, 3.42]
    },
    "2hr": {
      "2-mid": "1.64",
      "2-bound": [1.47, 1.83],
      "5-mid": "2.09",
      "5-bound": [1.87, 2.33],
      "10-mid": "2.45",
      "10-bound": [2.19, 2.73],
      "25-mid": "2.97",
      "25-bound": [2.64, 3.3],
      "50-mid": "3.4",
      "50-bound": [3.0, 3.78],
      "100-mid": "3.88",
      "100-bound": [3.4, 4.29]
    },
    "3hr": {
      "2-mid": "1.77",
      "2-bound": [1.59, 1.99],
      "5-mid": "2.25",
      "5-bound": [2.02, 2.52],
      "10-mid": "2.64",
      "10-bound": [2.35, 2.94],
      "25-mid": "3.2",
      "25-bound": [2.83, 3.56],
      "50-mid": "3.67",
      "50-bound": [3.23, 4.08],
      "100-mid": "4.18",
      "100-bound": [3.66, 4.64]
    },
    "6hr": {
      "2-mid": "2.19",
      "2-bound": [1.98, 2.46],
      "5-mid": "2.76",
      "5-bound": [2.48, 3.09],
      "10-mid": "3.23",
      "10-bound": [2.89, 3.6],
      "25-mid": "3.92",
      "25-bound": [3.48, 4.37],
      "50-mid": "4.51",
      "50-bound": [3.98, 5.01],
      "100-mid": "5.16",
      "100-bound": [4.51, 5.71]
    },
    "12hr": {
      "2-mid": "2.68",
      "2-bound": [2.41, 3.01],
      "5-mid": "3.38",
      "5-bound": [3.03, 3.78],
      "10-mid": "3.97",
      "10-bound": [3.54, 4.43],
      "25-mid": "4.85",
      "25-bound": [4.29, 5.39],
      "50-mid": "5.61",
      "50-bound": [4.92, 6.23],
      "100-mid": "6.46",
      "100-bound": [5.62, 7.16]
    },
    "24hr": {
      "2-mid": "3.1",
      "2-bound": [2.86, 3.39],
      "5-mid": "3.93",
      "5-bound": [3.62, 4.3],
      "10-mid": "4.64",
      "10-bound": [4.26, 5.07],
      "25-mid": "5.71",
      "25-bound": [5.2, 6.21],
      "50-mid": "6.63",
      "50-bound": [6.0, 7.2],
      "100-mid": "7.66",
      "100-bound": [6.88, 8.31]
    },
    "2day": {
      "2-mid": "3.59",
      "2-bound": [3.33, 3.91],
      "5-mid": "4.54",
      "5-bound": [4.2, 4.94],
      "10-mid": "5.35",
      "10-bound": [4.93, 5.81],
      "25-mid": "6.55",
      "25-bound": [5.98, 7.09],
      "50-mid": "7.57",
      "50-bound": [6.88, 8.2],
      "100-mid": "8.7",
      "100-bound": [7.84, 9.42]
    },
    "3day": {
      "2-mid": "3.81",
      "2-bound": [3.53, 4.14],
      "5-mid": "4.82",
      "5-bound": [4.45, 5.23],
      "10-mid": "5.66",
      "10-bound": [5.22, 6.14],
      "25-mid": "6.92",
      "25-bound": [6.33, 7.48],
      "50-mid": "7.99",
      "50-bound": [7.27, 8.63],
      "100-mid": "9.17",
      "100-bound": [8.28, 9.89]
    },
    "4day": {
      "2-mid": "4.03",
      "2-bound": [3.74, 4.37],
      "5-mid": "5.09",
      "5-bound": [4.7, 5.51],
      "10-mid": "5.98",
      "10-bound": [5.51, 6.46],
      "25-mid": "7.29",
      "25-bound": [6.68, 7.86],
      "50-mid": "8.41",
      "50-bound": [7.67, 9.06],
      "100-mid": "9.64",
      "100-bound": [8.72, 10.4]
    },
    "7day": {
      "2-mid": "4.67",
      "2-bound": [4.34, 5.02],
      "5-mid": "5.82",
      "5-bound": [5.4, 6.27],
      "10-mid": "6.78",
      "10-bound": [6.28, 7.3],
      "25-mid": "8.18",
      "25-bound": [7.54, 8.79],
      "50-mid": "9.36",
      "50-bound": [8.58, 10.0],
      "100-mid": "10.6",
      "100-bound": [9.68, 11.4]
    }
  },
  "USC00441746 6": {
    "fips": "51117",
    "station_name": "CLARKSVILLE",
    "state": "VA",
    "latitude": "36.6210",
    "longitude": "-78.5500",
    "5min": {
      "2-mid": "0.44",
      "2-bound": [0.39, 0.48],
      "5-mid": "0.51",
      "5-bound": [0.46, 0.56],
      "10-mid": "0.57",
      "10-bound": [0.51, 0.63],
      "25-mid": "0.64",
      "25-bound": [0.57, 0.7],
      "50-mid": "0.69",
      "50-bound": [0.61, 0.76],
      "100-mid": "0.73",
      "100-bound": [0.65, 0.81]
    },
    "10min": {
      "2-mid": "0.7",
      "2-bound": [0.63, 0.77],
      "5-mid": "0.81",
      "5-bound": [0.73, 0.9],
      "10-mid": "0.91",
      "10-bound": [0.82, 1.01],
      "25-mid": "1.01",
      "25-bound": [0.91, 1.12],
      "50-mid": "1.09",
      "50-bound": [0.97, 1.21],
      "100-mid": "1.16",
      "100-bound": [1.03, 1.29]
    },
    "15min": {
      "2-mid": "0.88",
      "2-bound": [0.79, 0.97],
      "5-mid": "1.02",
      "5-bound": [0.92, 1.14],
      "10-mid": "1.15",
      "10-bound": [1.03, 1.27],
      "25-mid": "1.28",
      "25-bound": [1.15, 1.42],
      "50-mid": "1.38",
      "50-bound": [1.23, 1.53],
      "100-mid": "1.47",
      "100-bound": [1.3, 1.63]
    },
    "30min": {
      "2-mid": "1.21",
      "2-bound": [1.09, 1.34],
      "5-mid": "1.46",
      "5-bound": [1.31, 1.62],
      "10-mid": "1.67",
      "10-bound": [1.5, 1.84],
      "25-mid": "1.9",
      "25-bound": [1.7, 2.1],
      "50-mid": "2.08",
      "50-bound": [1.86, 2.3],
      "100-mid": "2.25",
      "100-bound": [2.0, 2.49]
    },
    "60min": {
      "2-mid": "1.52",
      "2-bound": [1.37, 1.68],
      "5-mid": "1.87",
      "5-bound": [1.68, 2.07],
      "10-mid": "2.17",
      "10-bound": [1.95, 2.4],
      "25-mid": "2.53",
      "25-bound": [2.26, 2.8],
      "50-mid": "2.82",
      "50-bound": [2.52, 3.12],
      "100-mid": "3.1",
      "100-bound": [2.75, 3.43]
    },
    "2hr": {
      "2-mid": "1.77",
      "2-bound": [1.58, 1.97],
      "5-mid": "2.2",
      "5-bound": [1.96, 2.44],
      "10-mid": "2.58",
      "10-bound": [2.3, 2.87],
      "25-mid": "3.05",
      "25-bound": [2.7, 3.39],
      "50-mid": "3.46",
      "50-bound": [3.04, 3.83],
      "100-mid": "3.85",
      "100-bound": [3.37, 4.27]
    },
    "3hr": {
      "2-mid": "1.88",
      "2-bound": [1.69, 2.11],
      "5-mid": "2.34",
      "5-bound": [2.09, 2.62],
      "10-mid": "2.75",
      "10-bound": [2.45, 3.07],
      "25-mid": "3.27",
      "25-bound": [2.9, 3.64],
      "50-mid": "3.71",
      "50-bound": [3.27, 4.13],
      "100-mid": "4.16",
      "100-bound": [3.64, 4.62]
    },
    "6hr": {
      "2-mid": "2.27",
      "2-bound": [2.04, 2.54],
      "5-mid": "2.82",
      "5-bound": [2.52, 3.15],
      "10-mid": "3.33",
      "10-bound": [2.97, 3.71],
      "25-mid": "3.98",
      "25-bound": [3.54, 4.43],
      "50-mid": "4.56",
      "50-bound": [4.02, 5.06],
      "100-mid": "5.16",
      "100-bound": [4.51, 5.71]
    },
    "12hr": {
      "2-mid": "2.71",
      "2-bound": [2.46, 3.02],
      "5-mid": "3.38",
      "5-bound": [3.06, 3.75],
      "10-mid": "4.02",
      "10-bound": [3.62, 4.46],
      "25-mid": "4.87",
      "25-bound": [4.36, 5.37],
      "50-mid": "5.63",
      "50-bound": [5.0, 6.18],
      "100-mid": "6.42",
      "100-bound": [5.64, 7.03]
    },
    "24hr": {
      "2-mid": "3.16",
      "2-bound": [2.96, 3.39],
      "5-mid": "4.01",
      "5-bound": [3.75, 4.29],
      "10-mid": "4.71",
      "10-bound": [4.39, 5.04],
      "25-mid": "5.72",
      "25-bound": [5.29, 6.11],
      "50-mid": "6.58",
      "50-bound": [6.05, 7.02],
      "100-mid": "7.5",
      "100-bound": [6.85, 8.0]
    },
    "2day": {
      "2-mid": "3.72",
      "2-bound": [3.49, 3.98],
      "5-mid": "4.68",
      "5-bound": [4.38, 5.0],
      "10-mid": "5.46",
      "10-bound": [5.1, 5.83],
      "25-mid": "6.57",
      "25-bound": [6.1, 7.0],
      "50-mid": "7.48",
      "50-bound": [6.92, 7.98],
      "100-mid": "8.45",
      "100-bound": [7.76, 9.03]
    },
    "3day": {
      "2-mid": "3.93",
      "2-bound": [3.69, 4.22],
      "5-mid": "4.95",
      "5-bound": [4.63, 5.3],
      "10-mid": "5.77",
      "10-bound": [5.39, 6.18],
      "25-mid": "6.94",
      "25-bound": [6.45, 7.42],
      "50-mid": "7.9",
      "50-bound": [7.3, 8.44],
      "100-mid": "8.92",
      "100-bound": [8.19, 9.55]
    },
    "4day": {
      "2-mid": "4.15",
      "2-bound": [3.88, 4.45],
      "5-mid": "5.22",
      "5-bound": [4.88, 5.6],
      "10-mid": "6.08",
      "10-bound": [5.68, 6.52],
      "25-mid": "7.31",
      "25-bound": [6.79, 7.84],
      "50-mid": "8.32",
      "50-bound": [7.68, 8.91],
      "100-mid": "9.4",
      "100-bound": [8.63, 10.1]
    },
    "7day": {
      "2-mid": "4.76",
      "2-bound": [4.46, 5.11],
      "5-mid": "5.89",
      "5-bound": [5.5, 6.32],
      "10-mid": "6.81",
      "10-bound": [6.34, 7.3],
      "25-mid": "8.11",
      "25-bound": [7.52, 8.69],
      "50-mid": "9.18",
      "50-bound": [8.48, 9.84],
      "100-mid": "10.3",
      "100-bound": [9.46, 11.0]
    }
  },
  "USC00363632 6": {
    "fips": "42011",
    "station_name": "HAMBURG",
    "state": "PA",
    "latitude": "40.5515",
    "longitude": "-75.9910",
    "5min": {
      "2-mid": "0.42",
      "2-bound": [0.38, 0.47],
      "5-mid": "0.49",
      "5-bound": [0.44, 0.54],
      "10-mid": "0.54",
      "10-bound": [0.49, 0.6],
      "25-mid": "0.61",
      "25-bound": [0.54, 0.67],
      "50-mid": "0.66",
      "50-bound": [0.58, 0.72],
      "100-mid": "0.7",
      "100-bound": [0.63, 0.78]
    },
    "10min": {
      "2-mid": "0.66",
      "2-bound": [0.6, 0.73],
      "5-mid": "0.77",
      "5-bound": [0.69, 0.85],
      "10-mid": "0.85",
      "10-bound": [0.77, 0.94],
      "25-mid": "0.95",
      "25-bound": [0.85, 1.05],
      "50-mid": "1.02",
      "50-bound": [0.9, 1.12],
      "100-mid": "1.09",
      "100-bound": [0.96, 1.2]
    },
    "15min": {
      "2-mid": "0.82",
      "2-bound": [0.74, 0.91],
      "5-mid": "0.96",
      "5-bound": [0.86, 1.06],
      "10-mid": "1.06",
      "10-bound": [0.95, 1.17],
      "25-mid": "1.18",
      "25-bound": [1.06, 1.3],
      "50-mid": "1.27",
      "50-bound": [1.13, 1.4],
      "100-mid": "1.36",
      "100-bound": [1.21, 1.5]
    },
    "30min": {
      "2-mid": "1.11",
      "2-bound": [1.0, 1.23],
      "5-mid": "1.34",
      "5-bound": [1.2, 1.48],
      "10-mid": "1.5",
      "10-bound": [1.35, 1.66],
      "25-mid": "1.7",
      "25-bound": [1.52, 1.88],
      "50-mid": "1.85",
      "50-bound": [1.65, 2.05],
      "100-mid": "2.01",
      "100-bound": [1.78, 2.22]
    },
    "60min": {
      "2-mid": "1.38",
      "2-bound": [1.24, 1.53],
      "5-mid": "1.7",
      "5-bound": [1.52, 1.87],
      "10-mid": "1.93",
      "10-bound": [1.73, 2.13],
      "25-mid": "2.23",
      "25-bound": [2.0, 2.47],
      "50-mid": "2.47",
      "50-bound": [2.2, 2.73],
      "100-mid": "2.72",
      "100-bound": [2.42, 3.01]
    },
    "2hr": {
      "2-mid": "1.66",
      "2-bound": [1.5, 1.86],
      "5-mid": "2.06",
      "5-bound": [1.85, 2.3],
      "10-mid": "2.39",
      "10-bound": [2.14, 2.67],
      "25-mid": "2.85",
      "25-bound": [2.54, 3.18],
      "50-mid": "3.25",
      "50-bound": [2.87, 3.62],
      "100-mid": "3.69",
      "100-bound": [3.25, 4.12]
    },
    "3hr": {
      "2-mid": "1.83",
      "2-bound": [1.63, 2.07],
      "5-mid": "2.28",
      "5-bound": [2.02, 2.57],
      "10-mid": "2.64",
      "10-bound": [2.34, 2.97],
      "25-mid": "3.17",
      "25-bound": [2.79, 3.57],
      "50-mid": "3.63",
      "50-bound": [3.18, 4.08],
      "100-mid": "4.14",
      "100-bound": [3.6, 4.66]
    },
    "6hr": {
      "2-mid": "2.27",
      "2-bound": [2.03, 2.56],
      "5-mid": "2.81",
      "5-bound": [2.51, 3.18],
      "10-mid": "3.27",
      "10-bound": [2.9, 3.68],
      "25-mid": "3.94",
      "25-bound": [3.48, 4.44],
      "50-mid": "4.53",
      "50-bound": [3.97, 5.09],
      "100-mid": "5.2",
      "100-bound": [4.52, 5.84]
    },
    "12hr": {
      "2-mid": "2.82",
      "2-bound": [2.53, 3.18],
      "5-mid": "3.5",
      "5-bound": [3.14, 3.94],
      "10-mid": "4.09",
      "10-bound": [3.64, 4.59],
      "25-mid": "4.98",
      "25-bound": [4.4, 5.57],
      "50-mid": "5.77",
      "50-bound": [5.06, 6.44],
      "100-mid": "6.68",
      "100-bound": [5.8, 7.46]
    },
    "24hr": {
      "2-mid": "3.3",
      "2-bound": [3.04, 3.59],
      "5-mid": "4.12",
      "5-bound": [3.79, 4.48],
      "10-mid": "4.82",
      "10-bound": [4.42, 5.23],
      "25-mid": "5.89",
      "25-bound": [5.36, 6.37],
      "50-mid": "6.83",
      "50-bound": [6.18, 7.37],
      "100-mid": "7.91",
      "100-bound": [7.09, 8.5]
    },
    "2day": {
      "2-mid": "3.88",
      "2-bound": [3.6, 4.2],
      "5-mid": "4.85",
      "5-bound": [4.49, 5.24],
      "10-mid": "5.66",
      "10-bound": [5.23, 6.11],
      "25-mid": "6.89",
      "25-bound": [6.32, 7.41],
      "50-mid": "7.96",
      "50-bound": [7.25, 8.54],
      "100-mid": "9.16",
      "100-bound": [8.29, 9.81]
    },
    "3day": {
      "2-mid": "4.07",
      "2-bound": [3.79, 4.39],
      "5-mid": "5.06",
      "5-bound": [4.7, 5.45],
      "10-mid": "5.9",
      "10-bound": [5.46, 6.34],
      "25-mid": "7.15",
      "25-bound": [6.58, 7.66],
      "50-mid": "8.24",
      "50-bound": [7.54, 8.82],
      "100-mid": "9.46",
      "100-bound": [8.6, 10.1]
    },
    "4day": {
      "2-mid": "4.26",
      "2-bound": [3.98, 4.58],
      "5-mid": "5.27",
      "5-bound": [4.92, 5.66],
      "10-mid": "6.13",
      "10-bound": [5.7, 6.57],
      "25-mid": "7.4",
      "25-bound": [6.85, 7.92],
      "50-mid": "8.52",
      "50-bound": [7.83, 9.09],
      "100-mid": "9.76",
      "100-bound": [8.92, 10.4]
    },
    "7day": {
      "2-mid": "5.04",
      "2-bound": [4.71, 5.45],
      "5-mid": "6.19",
      "5-bound": [5.76, 6.67],
      "10-mid": "7.15",
      "10-bound": [6.64, 7.7],
      "25-mid": "8.6",
      "25-bound": [7.94, 9.24],
      "50-mid": "9.86",
      "50-bound": [9.06, 10.6],
      "100-mid": "11.3",
      "100-bound": [10.3, 12.1]
    }
  },
  "USC00187330 6": {
    "fips": "24039",
    "station_name": "PRINCESS ANNE",
    "state": "MD",
    "latitude": "38.2120",
    "longitude": "-75.6820",
    "5min": {
      "2-mid": "0.43",
      "2-bound": [0.39, 0.47],
      "5-mid": "0.5",
      "5-bound": [0.45, 0.55],
      "10-mid": "0.57",
      "10-bound": [0.51, 0.62],
      "25-mid": "0.64",
      "25-bound": [0.57, 0.71],
      "50-mid": "0.7",
      "50-bound": [0.63, 0.78],
      "100-mid": "0.76",
      "100-bound": [0.67, 0.84]
    },
    "10min": {
      "2-mid": "0.69",
      "2-bound": [0.62, 0.76],
      "5-mid": "0.8",
      "5-bound": [0.72, 0.89],
      "10-mid": "0.91",
      "10-bound": [0.82, 1.0],
      "25-mid": "1.02",
      "25-bound": [0.92, 1.13],
      "50-mid": "1.12",
      "50-bound": [1.0, 1.24],
      "100-mid": "1.2",
      "100-bound": [1.07, 1.34]
    },
    "15min": {
      "2-mid": "0.86",
      "2-bound": [0.78, 0.95],
      "5-mid": "1.02",
      "5-bound": [0.92, 1.12],
      "10-mid": "1.15",
      "10-bound": [1.03, 1.26],
      "25-mid": "1.3",
      "25-bound": [1.16, 1.43],
      "50-mid": "1.42",
      "50-bound": [1.26, 1.57],
      "100-mid": "1.52",
      "100-bound": [1.35, 1.69]
    },
    "30min": {
      "2-mid": "1.19",
      "2-bound": [1.07, 1.31],
      "5-mid": "1.44",
      "5-bound": [1.3, 1.59],
      "10-mid": "1.66",
      "10-bound": [1.5, 1.83],
      "25-mid": "1.92",
      "25-bound": [1.72, 2.12],
      "50-mid": "2.13",
      "50-bound": [1.9, 2.36],
      "100-mid": "2.33",
      "100-bound": [2.07, 2.59]
    },
    "60min": {
      "2-mid": "1.49",
      "2-bound": [1.35, 1.65],
      "5-mid": "1.85",
      "5-bound": [1.67, 2.04],
      "10-mid": "2.16",
      "10-bound": [1.95, 2.39],
      "25-mid": "2.56",
      "25-bound": [2.29, 2.83],
      "50-mid": "2.89",
      "50-bound": [2.58, 3.2],
      "100-mid": "3.21",
      "100-bound": [2.85, 3.57]
    },
    "2hr": {
      "2-mid": "1.8",
      "2-bound": [1.62, 2.0],
      "5-mid": "2.25",
      "5-bound": [2.02, 2.5],
      "10-mid": "2.66",
      "10-bound": [2.38, 2.95],
      "25-mid": "3.18",
      "25-bound": [2.83, 3.53],
      "50-mid": "3.63",
      "50-bound": [3.21, 4.03],
      "100-mid": "4.08",
      "100-bound": [3.58, 4.54]
    },
    "3hr": {
      "2-mid": "1.98",
      "2-bound": [1.77, 2.21],
      "5-mid": "2.48",
      "5-bound": [2.22, 2.76],
      "10-mid": "2.94",
      "10-bound": [2.62, 3.27],
      "25-mid": "3.54",
      "25-bound": [3.13, 3.93],
      "50-mid": "4.06",
      "50-bound": [3.57, 4.51],
      "100-mid": "4.59",
      "100-bound": [4.01, 5.11]
    },
    "6hr": {
      "2-mid": "2.4",
      "2-bound": [2.15, 2.68],
      "5-mid": "3.0",
      "5-bound": [2.68, 3.35],
      "10-mid": "3.57",
      "10-bound": [3.17, 3.98],
      "25-mid": "4.34",
      "25-bound": [3.83, 4.83],
      "50-mid": "5.02",
      "50-bound": [4.4, 5.6],
      "100-mid": "5.74",
      "100-bound": [4.98, 6.43]
    },
    "12hr": {
      "2-mid": "2.82",
      "2-bound": [2.52, 3.18],
      "5-mid": "3.54",
      "5-bound": [3.15, 3.99],
      "10-mid": "4.26",
      "10-bound": [3.77, 4.79],
      "25-mid": "5.26",
      "25-bound": [4.62, 5.9],
      "50-mid": "6.18",
      "50-bound": [5.37, 6.94],
      "100-mid": "7.17",
      "100-bound": [6.16, 8.08]
    },
    "24hr": {
      "2-mid": "3.32",
      "2-bound": [3.05, 3.65],
      "5-mid": "4.32",
      "5-bound": [3.96, 4.74],
      "10-mid": "5.18",
      "10-bound": [4.73, 5.68],
      "25-mid": "6.49",
      "25-bound": [5.89, 7.09],
      "50-mid": "7.64",
      "50-bound": [6.89, 8.33],
      "100-mid": "8.94",
      "100-bound": [7.99, 9.72]
    },
    "2day": {
      "2-mid": "3.86",
      "2-bound": [3.56, 4.22],
      "5-mid": "5.02",
      "5-bound": [4.62, 5.49],
      "10-mid": "6.01",
      "10-bound": [5.52, 6.57],
      "25-mid": "7.52",
      "25-bound": [6.85, 8.19],
      "50-mid": "8.83",
      "50-bound": [7.99, 9.59],
      "100-mid": "10.3",
      "100-bound": [9.25, 11.2]
    },
    "3day": {
      "2-mid": "4.08",
      "2-bound": [3.76, 4.45],
      "5-mid": "5.28",
      "5-bound": [4.86, 5.75],
      "10-mid": "6.3",
      "10-bound": [5.78, 6.85],
      "25-mid": "7.84",
      "25-bound": [7.15, 8.51],
      "50-mid": "9.17",
      "50-bound": [8.32, 9.93],
      "100-mid": "10.7",
      "100-bound": [9.6, 11.5]
    },
    "4day": {
      "2-mid": "4.3",
      "2-bound": [3.97, 4.68],
      "5-mid": "5.54",
      "5-bound": [5.1, 6.01],
      "10-mid": "6.59",
      "10-bound": [6.06, 7.14],
      "25-mid": "8.16",
      "25-bound": [7.45, 8.83],
      "50-mid": "9.51",
      "50-bound": [8.65, 10.3],
      "100-mid": "11.0",
      "100-bound": [9.94, 11.9]
    },
    "7day": {
      "2-mid": "4.91",
      "2-bound": [4.56, 5.31],
      "5-mid": "6.21",
      "5-bound": [5.76, 6.72],
      "10-mid": "7.32",
      "10-bound": [6.78, 7.91],
      "25-mid": "8.96",
      "25-bound": [8.25, 9.66],
      "50-mid": "10.4",
      "50-bound": [9.49, 11.2],
      "100-mid": "11.9",
      "100-bound": [10.8, 12.8]
    }
  },
  "USC00367103 6": {
    "fips": "42083",
    "station_name": "PORT ALLEGANY",
    "state": "PA",
    "latitude": "41.8156",
    "longitude": "-78.2873",
    "5min": {
      "2-mid": "0.34",
      "2-bound": [0.31, 0.38],
      "5-mid": "0.41",
      "5-bound": [0.37, 0.46],
      "10-mid": "0.47",
      "10-bound": [0.42, 0.52],
      "25-mid": "0.55",
      "25-bound": [0.49, 0.6],
      "50-mid": "0.6",
      "50-bound": [0.54, 0.66],
      "100-mid": "0.66",
      "100-bound": [0.59, 0.72]
    },
    "10min": {
      "2-mid": "0.53",
      "2-bound": [0.48, 0.59],
      "5-mid": "0.65",
      "5-bound": [0.58, 0.71],
      "10-mid": "0.73",
      "10-bound": [0.66, 0.8],
      "25-mid": "0.83",
      "25-bound": [0.75, 0.92],
      "50-mid": "0.91",
      "50-bound": [0.81, 1.0],
      "100-mid": "0.99",
      "100-bound": [0.88, 1.09]
    },
    "15min": {
      "2-mid": "0.65",
      "2-bound": [0.59, 0.72],
      "5-mid": "0.79",
      "5-bound": [0.71, 0.88],
      "10-mid": "0.9",
      "10-bound": [0.81, 0.99],
      "25-mid": "1.03",
      "25-bound": [0.92, 1.14],
      "50-mid": "1.13",
      "50-bound": [1.01, 1.24],
      "100-mid": "1.24",
      "100-bound": [1.1, 1.36]
    },
    "30min": {
      "2-mid": "0.87",
      "2-bound": [0.79, 0.97],
      "5-mid": "1.08",
      "5-bound": [0.98, 1.2],
      "10-mid": "1.24",
      "10-bound": [1.12, 1.37],
      "25-mid": "1.46",
      "25-bound": [1.3, 1.6],
      "50-mid": "1.62",
      "50-bound": [1.44, 1.78],
      "100-mid": "1.78",
      "100-bound": [1.58, 1.96]
    },
    "60min": {
      "2-mid": "1.07",
      "2-bound": [0.97, 1.19],
      "5-mid": "1.36",
      "5-bound": [1.23, 1.5],
      "10-mid": "1.58",
      "10-bound": [1.42, 1.74],
      "25-mid": "1.89",
      "25-bound": [1.69, 2.08],
      "50-mid": "2.13",
      "50-bound": [1.9, 2.34],
      "100-mid": "2.38",
      "100-bound": [2.12, 2.62]
    },
    "2hr": {
      "2-mid": "1.26",
      "2-bound": [1.13, 1.4],
      "5-mid": "1.59",
      "5-bound": [1.43, 1.76],
      "10-mid": "1.85",
      "10-bound": [1.66, 2.05],
      "25-mid": "2.23",
      "25-bound": [1.99, 2.46],
      "50-mid": "2.54",
      "50-bound": [2.25, 2.79],
      "100-mid": "2.87",
      "100-bound": [2.54, 3.15]
    },
    "3hr": {
      "2-mid": "1.37",
      "2-bound": [1.24, 1.53],
      "5-mid": "1.72",
      "5-bound": [1.55, 1.92],
      "10-mid": "2.01",
      "10-bound": [1.81, 2.24],
      "25-mid": "2.42",
      "25-bound": [2.16, 2.68],
      "50-mid": "2.76",
      "50-bound": [2.45, 3.05],
      "100-mid": "3.13",
      "100-bound": [2.76, 3.44]
    },
    "6hr": {
      "2-mid": "1.69",
      "2-bound": [1.53, 1.9],
      "5-mid": "2.1",
      "5-bound": [1.9, 2.36],
      "10-mid": "2.44",
      "10-bound": [2.2, 2.73],
      "25-mid": "2.93",
      "25-bound": [2.63, 3.26],
      "50-mid": "3.34",
      "50-bound": [2.98, 3.71],
      "100-mid": "3.79",
      "100-bound": [3.36, 4.2]
    },
    "12hr": {
      "2-mid": "2.07",
      "2-bound": [1.88, 2.31],
      "5-mid": "2.55",
      "5-bound": [2.31, 2.85],
      "10-mid": "2.95",
      "10-bound": [2.67, 3.29],
      "25-mid": "3.55",
      "25-bound": [3.18, 3.95],
      "50-mid": "4.06",
      "50-bound": [3.62, 4.5],
      "100-mid": "4.62",
      "100-bound": [4.08, 5.1]
    },
    "24hr": {
      "2-mid": "2.43",
      "2-bound": [2.23, 2.68],
      "5-mid": "2.98",
      "5-bound": [2.72, 3.28],
      "10-mid": "3.43",
      "10-bound": [3.13, 3.77],
      "25-mid": "4.09",
      "25-bound": [3.71, 4.48],
      "50-mid": "4.64",
      "50-bound": [4.2, 5.07],
      "100-mid": "5.24",
      "100-bound": [4.71, 5.71]
    },
    "2day": {
      "2-mid": "2.83",
      "2-bound": [2.57, 3.16],
      "5-mid": "3.44",
      "5-bound": [3.13, 3.83],
      "10-mid": "3.95",
      "10-bound": [3.58, 4.39],
      "25-mid": "4.68",
      "25-bound": [4.22, 5.19],
      "50-mid": "5.29",
      "50-bound": [4.75, 5.85],
      "100-mid": "5.95",
      "100-bound": [5.31, 6.58]
    },
    "3day": {
      "2-mid": "3.04",
      "2-bound": [2.76, 3.41],
      "5-mid": "3.67",
      "5-bound": [3.34, 4.12],
      "10-mid": "4.2",
      "10-bound": [3.8, 4.71],
      "25-mid": "4.96",
      "25-bound": [4.47, 5.55],
      "50-mid": "5.59",
      "50-bound": [5.02, 6.25],
      "100-mid": "6.28",
      "100-bound": [5.61, 7.01]
    },
    "4day": {
      "2-mid": "3.24",
      "2-bound": [2.95, 3.66],
      "5-mid": "3.9",
      "5-bound": [3.54, 4.41],
      "10-mid": "4.45",
      "10-bound": [4.03, 5.02],
      "25-mid": "5.24",
      "25-bound": [4.72, 5.91],
      "50-mid": "5.9",
      "50-bound": [5.3, 6.64],
      "100-mid": "6.61",
      "100-bound": [5.9, 7.44]
    },
    "7day": {
      "2-mid": "3.86",
      "2-bound": [3.53, 4.28],
      "5-mid": "4.57",
      "5-bound": [4.18, 5.06],
      "10-mid": "5.15",
      "10-bound": [4.71, 5.7],
      "25-mid": "5.98",
      "25-bound": [5.44, 6.61],
      "50-mid": "6.66",
      "50-bound": [6.04, 7.36],
      "100-mid": "7.38",
      "100-bound": [6.66, 8.14]
    }
  },
  "USC00188557 6": {
    "fips": "24035",
    "station_name": "STEVENSVILLE 2SW",
    "state": "MD",
    "latitude": "38.9700",
    "longitude": "-76.3300",
    "5min": {
      "2-mid": "0.42",
      "2-bound": [0.38, 0.46],
      "5-mid": "0.5",
      "5-bound": [0.45, 0.55],
      "10-mid": "0.55",
      "10-bound": [0.5, 0.61],
      "25-mid": "0.63",
      "25-bound": [0.56, 0.69],
      "50-mid": "0.68",
      "50-bound": [0.61, 0.75],
      "100-mid": "0.73",
      "100-bound": [0.65, 0.81]
    },
    "10min": {
      "2-mid": "0.67",
      "2-bound": [0.6, 0.74],
      "5-mid": "0.8",
      "5-bound": [0.72, 0.88],
      "10-mid": "0.89",
      "10-bound": [0.8, 0.98],
      "25-mid": "1.0",
      "25-bound": [0.89, 1.1],
      "50-mid": "1.08",
      "50-bound": [0.96, 1.2],
      "100-mid": "1.16",
      "100-bound": [1.03, 1.29]
    },
    "15min": {
      "2-mid": "0.84",
      "2-bound": [0.76, 0.93],
      "5-mid": "1.0",
      "5-bound": [0.91, 1.11],
      "10-mid": "1.12",
      "10-bound": [1.01, 1.24],
      "25-mid": "1.26",
      "25-bound": [1.13, 1.4],
      "50-mid": "1.37",
      "50-bound": [1.22, 1.52],
      "100-mid": "1.47",
      "100-bound": [1.3, 1.63]
    },
    "30min": {
      "2-mid": "1.16",
      "2-bound": [1.05, 1.28],
      "5-mid": "1.43",
      "5-bound": [1.29, 1.58],
      "10-mid": "1.62",
      "10-bound": [1.46, 1.79],
      "25-mid": "1.87",
      "25-bound": [1.68, 2.07],
      "50-mid": "2.06",
      "50-bound": [1.84, 2.28],
      "100-mid": "2.25",
      "100-bound": [2.0, 2.5]
    },
    "60min": {
      "2-mid": "1.45",
      "2-bound": [1.31, 1.6],
      "5-mid": "1.83",
      "5-bound": [1.65, 2.02],
      "10-mid": "2.11",
      "10-bound": [1.9, 2.34],
      "25-mid": "2.49",
      "25-bound": [2.23, 2.76],
      "50-mid": "2.8",
      "50-bound": [2.49, 3.1],
      "100-mid": "3.1",
      "100-bound": [2.75, 3.44]
    },
    "2hr": {
      "2-mid": "1.73",
      "2-bound": [1.57, 1.91],
      "5-mid": "2.19",
      "5-bound": [1.98, 2.42],
      "10-mid": "2.55",
      "10-bound": [2.29, 2.81],
      "25-mid": "3.05",
      "25-bound": [2.73, 3.36],
      "50-mid": "3.45",
      "50-bound": [3.08, 3.81],
      "100-mid": "3.88",
      "100-bound": [3.43, 4.29]
    },
    "3hr": {
      "2-mid": "1.87",
      "2-bound": [1.7, 2.07],
      "5-mid": "2.38",
      "5-bound": [2.15, 2.62],
      "10-mid": "2.78",
      "10-bound": [2.5, 3.06],
      "25-mid": "3.34",
      "25-bound": [2.99, 3.68],
      "50-mid": "3.81",
      "50-bound": [3.38, 4.2],
      "100-mid": "4.3",
      "100-bound": [3.79, 4.75]
    },
    "6hr": {
      "2-mid": "2.3",
      "2-bound": [2.09, 2.55],
      "5-mid": "2.91",
      "5-bound": [2.64, 3.22],
      "10-mid": "3.41",
      "10-bound": [3.08, 3.77],
      "25-mid": "4.15",
      "25-bound": [3.71, 4.58],
      "50-mid": "4.78",
      "50-bound": [4.23, 5.28],
      "100-mid": "5.46",
      "100-bound": [4.79, 6.05]
    },
    "12hr": {
      "2-mid": "2.77",
      "2-bound": [2.49, 3.12],
      "5-mid": "3.53",
      "5-bound": [3.16, 3.97],
      "10-mid": "4.18",
      "10-bound": [3.72, 4.7],
      "25-mid": "5.17",
      "25-bound": [4.55, 5.8],
      "50-mid": "6.04",
      "50-bound": [5.26, 6.78],
      "100-mid": "7.0",
      "100-bound": [6.02, 7.89]
    },
    "24hr": {
      "2-mid": "3.24",
      "2-bound": [2.94, 3.62],
      "5-mid": "4.21",
      "5-bound": [3.81, 4.7],
      "10-mid": "5.04",
      "10-bound": [4.55, 5.62],
      "25-mid": "6.32",
      "25-bound": [5.65, 7.0],
      "50-mid": "7.44",
      "50-bound": [6.61, 8.21],
      "100-mid": "8.71",
      "100-bound": [7.67, 9.58]
    },
    "2day": {
      "2-mid": "3.75",
      "2-bound": [3.4, 4.18],
      "5-mid": "4.86",
      "5-bound": [4.4, 5.41],
      "10-mid": "5.82",
      "10-bound": [5.25, 6.45],
      "25-mid": "7.26",
      "25-bound": [6.51, 8.02],
      "50-mid": "8.52",
      "50-bound": [7.59, 9.38],
      "100-mid": "9.92",
      "100-bound": [8.77, 10.9]
    },
    "3day": {
      "2-mid": "3.96",
      "2-bound": [3.6, 4.39],
      "5-mid": "5.1",
      "5-bound": [4.64, 5.66],
      "10-mid": "6.09",
      "10-bound": [5.52, 6.73],
      "25-mid": "7.56",
      "25-bound": [6.81, 8.34],
      "50-mid": "8.85",
      "50-bound": [7.92, 9.73],
      "100-mid": "10.3",
      "100-bound": [9.13, 11.3]
    },
    "4day": {
      "2-mid": "4.16",
      "2-bound": [3.8, 4.6],
      "5-mid": "5.35",
      "5-bound": [4.88, 5.91],
      "10-mid": "6.36",
      "10-bound": [5.79, 7.02],
      "25-mid": "7.87",
      "25-bound": [7.12, 8.66],
      "50-mid": "9.18",
      "50-bound": [8.26, 10.1],
      "100-mid": "10.6",
      "100-bound": [9.49, 11.7]
    },
    "7day": {
      "2-mid": "4.79",
      "2-bound": [4.39, 5.28],
      "5-mid": "6.07",
      "5-bound": [5.54, 6.68],
      "10-mid": "7.15",
      "10-bound": [6.51, 7.85],
      "25-mid": "8.76",
      "25-bound": [7.93, 9.59],
      "50-mid": "10.1",
      "50-bound": [9.13, 11.1],
      "100-mid": "11.6",
      "100-bound": [10.4, 12.7]
    }
  },
  "USC00366289 6": {
    "fips": "42133",
    "station_name": "NEW PARK",
    "state": "PA",
    "latitude": "39.7340",
    "longitude": "-76.5000",
    "5min": {
      "2-mid": "0.4",
      "2-bound": [0.36, 0.45],
      "5-mid": "0.47",
      "5-bound": [0.42, 0.53],
      "10-mid": "0.52",
      "10-bound": [0.47, 0.59],
      "25-mid": "0.59",
      "25-bound": [0.52, 0.66],
      "50-mid": "0.63",
      "50-bound": [0.56, 0.71],
      "100-mid": "0.68",
      "100-bound": [0.6, 0.76]
    },
    "10min": {
      "2-mid": "0.64",
      "2-bound": [0.57, 0.72],
      "5-mid": "0.76",
      "5-bound": [0.68, 0.85],
      "10-mid": "0.84",
      "10-bound": [0.75, 0.94],
      "25-mid": "0.94",
      "25-bound": [0.83, 1.05],
      "50-mid": "1.01",
      "50-bound": [0.89, 1.13],
      "100-mid": "1.08",
      "100-bound": [0.95, 1.2]
    },
    "15min": {
      "2-mid": "0.8",
      "2-bound": [0.72, 0.9],
      "5-mid": "0.96",
      "5-bound": [0.85, 1.07],
      "10-mid": "1.06",
      "10-bound": [0.94, 1.19],
      "25-mid": "1.19",
      "25-bound": [1.05, 1.33],
      "50-mid": "1.28",
      "50-bound": [1.13, 1.43],
      "100-mid": "1.36",
      "100-bound": [1.2, 1.52]
    },
    "30min": {
      "2-mid": "1.11",
      "2-bound": [0.99, 1.24],
      "5-mid": "1.36",
      "5-bound": [1.21, 1.52],
      "10-mid": "1.54",
      "10-bound": [1.37, 1.72],
      "25-mid": "1.76",
      "25-bound": [1.56, 1.97],
      "50-mid": "1.92",
      "50-bound": [1.7, 2.15],
      "100-mid": "2.09",
      "100-bound": [1.84, 2.33]
    },
    "60min": {
      "2-mid": "1.39",
      "2-bound": [1.24, 1.56],
      "5-mid": "1.74",
      "5-bound": [1.56, 1.95],
      "10-mid": "2.0",
      "10-bound": [1.78, 2.24],
      "25-mid": "2.35",
      "25-bound": [2.08, 2.62],
      "50-mid": "2.61",
      "50-bound": [2.3, 2.92],
      "100-mid": "2.88",
      "100-bound": [2.53, 3.21]
    },
    "2hr": {
      "2-mid": "1.68",
      "2-bound": [1.5, 1.88],
      "5-mid": "2.13",
      "5-bound": [1.9, 2.38],
      "10-mid": "2.48",
      "10-bound": [2.2, 2.77],
      "25-mid": "2.97",
      "25-bound": [2.63, 3.31],
      "50-mid": "3.37",
      "50-bound": [2.96, 3.75],
      "100-mid": "3.8",
      "100-bound": [3.32, 4.23]
    },
    "3hr": {
      "2-mid": "1.82",
      "2-bound": [1.63, 2.04],
      "5-mid": "2.31",
      "5-bound": [2.07, 2.58],
      "10-mid": "2.69",
      "10-bound": [2.4, 3.01],
      "25-mid": "3.23",
      "25-bound": [2.86, 3.59],
      "50-mid": "3.67",
      "50-bound": [3.23, 4.09],
      "100-mid": "4.14",
      "100-bound": [3.62, 4.61]
    },
    "6hr": {
      "2-mid": "2.26",
      "2-bound": [2.03, 2.54],
      "5-mid": "2.85",
      "5-bound": [2.55, 3.2],
      "10-mid": "3.34",
      "10-bound": [2.98, 3.75],
      "25-mid": "4.06",
      "25-bound": [3.59, 4.54],
      "50-mid": "4.66",
      "50-bound": [4.1, 5.21],
      "100-mid": "5.32",
      "100-bound": [4.64, 5.94]
    },
    "12hr": {
      "2-mid": "2.74",
      "2-bound": [2.44, 3.12],
      "5-mid": "3.48",
      "5-bound": [3.1, 3.97],
      "10-mid": "4.12",
      "10-bound": [3.64, 4.68],
      "25-mid": "5.07",
      "25-bound": [4.45, 5.75],
      "50-mid": "5.91",
      "50-bound": [5.14, 6.68],
      "100-mid": "6.84",
      "100-bound": [5.88, 7.72]
    },
    "24hr": {
      "2-mid": "3.15",
      "2-bound": [2.9, 3.46],
      "5-mid": "4.04",
      "5-bound": [3.71, 4.44],
      "10-mid": "4.82",
      "10-bound": [4.41, 5.28],
      "25-mid": "6.02",
      "25-bound": [5.45, 6.57],
      "50-mid": "7.08",
      "50-bound": [6.36, 7.7],
      "100-mid": "8.27",
      "100-bound": [7.35, 8.97]
    },
    "2day": {
      "2-mid": "3.64",
      "2-bound": [3.36, 4.0],
      "5-mid": "4.66",
      "5-bound": [4.29, 5.11],
      "10-mid": "5.54",
      "10-bound": [5.08, 6.06],
      "25-mid": "6.85",
      "25-bound": [6.23, 7.47],
      "50-mid": "7.98",
      "50-bound": [7.2, 8.69],
      "100-mid": "9.25",
      "100-bound": [8.26, 10.0]
    },
    "3day": {
      "2-mid": "3.84",
      "2-bound": [3.54, 4.2],
      "5-mid": "4.91",
      "5-bound": [4.52, 5.37],
      "10-mid": "5.83",
      "10-bound": [5.34, 6.36],
      "25-mid": "7.21",
      "25-bound": [6.56, 7.85],
      "50-mid": "8.41",
      "50-bound": [7.6, 9.14],
      "100-mid": "9.74",
      "100-bound": [8.72, 10.6]
    },
    "4day": {
      "2-mid": "4.03",
      "2-bound": [3.72, 4.4],
      "5-mid": "5.15",
      "5-bound": [4.75, 5.62],
      "10-mid": "6.12",
      "10-bound": [5.61, 6.67],
      "25-mid": "7.57",
      "25-bound": [6.9, 8.23],
      "50-mid": "8.83",
      "50-bound": [7.99, 9.58],
      "100-mid": "10.2",
      "100-bound": [9.18, 11.1]
    },
    "7day": {
      "2-mid": "4.69",
      "2-bound": [4.34, 5.1],
      "5-mid": "5.93",
      "5-bound": [5.47, 6.45],
      "10-mid": "6.99",
      "10-bound": [6.43, 7.6],
      "25-mid": "8.58",
      "25-bound": [7.84, 9.32],
      "50-mid": "9.95",
      "50-bound": [9.03, 10.8],
      "100-mid": "11.5",
      "100-bound": [10.3, 12.4]
    }
  },
  "USC00369408 6": {
    "fips": "42117",
    "station_name": "WELLSBORO 4 SW",
    "state": "PA",
    "latitude": "41.7000",
    "longitude": "-77.3870",
    "5min": {
      "2-mid": "0.32",
      "2-bound": [0.29, 0.36],
      "5-mid": "0.39",
      "5-bound": [0.35, 0.43],
      "10-mid": "0.44",
      "10-bound": [0.39, 0.5],
      "25-mid": "0.51",
      "25-bound": [0.46, 0.57],
      "50-mid": "0.57",
      "50-bound": [0.51, 0.64],
      "100-mid": "0.63",
      "100-bound": [0.55, 0.7]
    },
    "10min": {
      "2-mid": "0.5",
      "2-bound": [0.45, 0.56],
      "5-mid": "0.6",
      "5-bound": [0.54, 0.68],
      "10-mid": "0.68",
      "10-bound": [0.61, 0.77],
      "25-mid": "0.79",
      "25-bound": [0.7, 0.88],
      "50-mid": "0.87",
      "50-bound": [0.77, 0.97],
      "100-mid": "0.95",
      "100-bound": [0.83, 1.06]
    },
    "15min": {
      "2-mid": "0.61",
      "2-bound": [0.55, 0.69],
      "5-mid": "0.74",
      "5-bound": [0.66, 0.83],
      "10-mid": "0.84",
      "10-bound": [0.75, 0.94],
      "25-mid": "0.97",
      "25-bound": [0.86, 1.08],
      "50-mid": "1.07",
      "50-bound": [0.95, 1.2],
      "100-mid": "1.18",
      "100-bound": [1.04, 1.32]
    },
    "30min": {
      "2-mid": "0.82",
      "2-bound": [0.73, 0.92],
      "5-mid": "1.01",
      "5-bound": [0.91, 1.13],
      "10-mid": "1.17",
      "10-bound": [1.04, 1.31],
      "25-mid": "1.37",
      "25-bound": [1.21, 1.53],
      "50-mid": "1.54",
      "50-bound": [1.35, 1.71],
      "100-mid": "1.71",
      "100-bound": [1.5, 1.9]
    },
    "60min": {
      "2-mid": "1.01",
      "2-bound": [0.9, 1.13],
      "5-mid": "1.27",
      "5-bound": [1.14, 1.42],
      "10-mid": "1.48",
      "10-bound": [1.32, 1.66],
      "25-mid": "1.78",
      "25-bound": [1.58, 1.99],
      "50-mid": "2.02",
      "50-bound": [1.78, 2.25],
      "100-mid": "2.28",
      "100-bound": [2.0, 2.55]
    },
    "2hr": {
      "2-mid": "1.15",
      "2-bound": [1.03, 1.28],
      "5-mid": "1.45",
      "5-bound": [1.31, 1.61],
      "10-mid": "1.7",
      "10-bound": [1.52, 1.88],
      "25-mid": "2.08",
      "25-bound": [1.85, 2.29],
      "50-mid": "2.41",
      "50-bound": [2.14, 2.65],
      "100-mid": "2.79",
      "100-bound": [2.46, 3.07]
    },
    "3hr": {
      "2-mid": "1.27",
      "2-bound": [1.14, 1.42],
      "5-mid": "1.59",
      "5-bound": [1.43, 1.77],
      "10-mid": "1.86",
      "10-bound": [1.67, 2.06],
      "25-mid": "2.27",
      "25-bound": [2.02, 2.51],
      "50-mid": "2.63",
      "50-bound": [2.33, 2.9],
      "100-mid": "3.06",
      "100-bound": [2.69, 3.36]
    },
    "6hr": {
      "2-mid": "1.59",
      "2-bound": [1.43, 1.78],
      "5-mid": "1.96",
      "5-bound": [1.76, 2.2],
      "10-mid": "2.28",
      "10-bound": [2.05, 2.55],
      "25-mid": "2.77",
      "25-bound": [2.48, 3.08],
      "50-mid": "3.21",
      "50-bound": [2.85, 3.57],
      "100-mid": "3.72",
      "100-bound": [3.28, 4.12]
    },
    "12hr": {
      "2-mid": "1.95",
      "2-bound": [1.76, 2.19],
      "5-mid": "2.4",
      "5-bound": [2.16, 2.7],
      "10-mid": "2.79",
      "10-bound": [2.5, 3.12],
      "25-mid": "3.4",
      "25-bound": [3.03, 3.79],
      "50-mid": "3.95",
      "50-bound": [3.5, 4.39],
      "100-mid": "4.6",
      "100-bound": [4.03, 5.09]
    },
    "24hr": {
      "2-mid": "2.34",
      "2-bound": [2.15, 2.58],
      "5-mid": "2.88",
      "5-bound": [2.64, 3.17],
      "10-mid": "3.34",
      "10-bound": [3.05, 3.67],
      "25-mid": "4.07",
      "25-bound": [3.68, 4.46],
      "50-mid": "4.73",
      "50-bound": [4.26, 5.17],
      "100-mid": "5.49",
      "100-bound": [4.9, 5.99]
    },
    "2day": {
      "2-mid": "2.7",
      "2-bound": [2.47, 3.02],
      "5-mid": "3.32",
      "5-bound": [3.02, 3.7],
      "10-mid": "3.87",
      "10-bound": [3.5, 4.3],
      "25-mid": "4.73",
      "25-bound": [4.24, 5.24],
      "50-mid": "5.53",
      "50-bound": [4.92, 6.11],
      "100-mid": "6.46",
      "100-bound": [5.69, 7.12]
    },
    "3day": {
      "2-mid": "2.86",
      "2-bound": [2.62, 3.16],
      "5-mid": "3.5",
      "5-bound": [3.2, 3.86],
      "10-mid": "4.06",
      "10-bound": [3.7, 4.48],
      "25-mid": "4.95",
      "25-bound": [4.47, 5.45],
      "50-mid": "5.77",
      "50-bound": [5.17, 6.34],
      "100-mid": "6.74",
      "100-bound": [5.97, 7.38]
    },
    "4day": {
      "2-mid": "3.01",
      "2-bound": [2.76, 3.31],
      "5-mid": "3.67",
      "5-bound": [3.37, 4.02],
      "10-mid": "4.25",
      "10-bound": [3.89, 4.66],
      "25-mid": "5.17",
      "25-bound": [4.69, 5.66],
      "50-mid": "6.02",
      "50-bound": [5.42, 6.58],
      "100-mid": "7.02",
      "100-bound": [6.26, 7.64]
    },
    "7day": {
      "2-mid": "3.54",
      "2-bound": [3.28, 3.87],
      "5-mid": "4.22",
      "5-bound": [3.9, 4.59],
      "10-mid": "4.8",
      "10-bound": [4.42, 5.23],
      "25-mid": "5.72",
      "25-bound": [5.24, 6.22],
      "50-mid": "6.55",
      "50-bound": [5.95, 7.11],
      "100-mid": "7.5",
      "100-bound": [6.77, 8.13]
    }
  },
  "USC00368763 6": {
    "fips": "42107",
    "station_name": "TAMAQUA 4 N DAM",
    "state": "PA",
    "latitude": "40.8480",
    "longitude": "-75.9990",
    "5min": {
      "2-mid": "0.45",
      "2-bound": [0.41, 0.5],
      "5-mid": "0.53",
      "5-bound": [0.48, 0.59],
      "10-mid": "0.59",
      "10-bound": [0.54, 0.65],
      "25-mid": "0.66",
      "25-bound": [0.6, 0.73],
      "50-mid": "0.72",
      "50-bound": [0.65, 0.8],
      "100-mid": "0.79",
      "100-bound": [0.7, 0.87]
    },
    "10min": {
      "2-mid": "0.71",
      "2-bound": [0.64, 0.78],
      "5-mid": "0.83",
      "5-bound": [0.75, 0.91],
      "10-mid": "0.91",
      "10-bound": [0.83, 1.01],
      "25-mid": "1.02",
      "25-bound": [0.92, 1.12],
      "50-mid": "1.1",
      "50-bound": [0.99, 1.21],
      "100-mid": "1.19",
      "100-bound": [1.06, 1.31]
    },
    "15min": {
      "2-mid": "0.87",
      "2-bound": [0.79, 0.96],
      "5-mid": "1.02",
      "5-bound": [0.92, 1.12],
      "10-mid": "1.12",
      "10-bound": [1.02, 1.24],
      "25-mid": "1.26",
      "25-bound": [1.14, 1.39],
      "50-mid": "1.36",
      "50-bound": [1.22, 1.5],
      "100-mid": "1.47",
      "100-bound": [1.32, 1.63]
    },
    "30min": {
      "2-mid": "1.17",
      "2-bound": [1.06, 1.29],
      "5-mid": "1.4",
      "5-bound": [1.26, 1.54],
      "10-mid": "1.57",
      "10-bound": [1.42, 1.72],
      "25-mid": "1.78",
      "25-bound": [1.61, 1.96],
      "50-mid": "1.95",
      "50-bound": [1.75, 2.15],
      "100-mid": "2.13",
      "100-bound": [1.91, 2.36]
    },
    "60min": {
      "2-mid": "1.43",
      "2-bound": [1.3, 1.58],
      "5-mid": "1.76",
      "5-bound": [1.59, 1.94],
      "10-mid": "2.0",
      "10-bound": [1.81, 2.2],
      "25-mid": "2.32",
      "25-bound": [2.09, 2.55],
      "50-mid": "2.58",
      "50-bound": [2.31, 2.84],
      "100-mid": "2.86",
      "100-bound": [2.55, 3.15]
    },
    "2hr": {
      "2-mid": "1.7",
      "2-bound": [1.54, 1.89],
      "5-mid": "2.11",
      "5-bound": [1.9, 2.33],
      "10-mid": "2.44",
      "10-bound": [2.2, 2.71],
      "25-mid": "2.95",
      "25-bound": [2.64, 3.27],
      "50-mid": "3.4",
      "50-bound": [3.03, 3.77],
      "100-mid": "3.93",
      "100-bound": [3.47, 4.36]
    },
    "3hr": {
      "2-mid": "1.88",
      "2-bound": [1.7, 2.12],
      "5-mid": "2.33",
      "5-bound": [2.09, 2.62],
      "10-mid": "2.71",
      "10-bound": [2.42, 3.04],
      "25-mid": "3.3",
      "25-bound": [2.93, 3.7],
      "50-mid": "3.83",
      "50-bound": [3.38, 4.3],
      "100-mid": "4.46",
      "100-bound": [3.9, 5.02]
    },
    "6hr": {
      "2-mid": "2.34",
      "2-bound": [2.11, 2.63],
      "5-mid": "2.88",
      "5-bound": [2.59, 3.24],
      "10-mid": "3.36",
      "10-bound": [3.0, 3.77],
      "25-mid": "4.08",
      "25-bound": [3.63, 4.58],
      "50-mid": "4.75",
      "50-bound": [4.18, 5.32],
      "100-mid": "5.53",
      "100-bound": [4.83, 6.2]
    },
    "12hr": {
      "2-mid": "2.94",
      "2-bound": [2.66, 3.28],
      "5-mid": "3.64",
      "5-bound": [3.29, 4.06],
      "10-mid": "4.25",
      "10-bound": [3.82, 4.73],
      "25-mid": "5.21",
      "25-bound": [4.65, 5.78],
      "50-mid": "6.09",
      "50-bound": [5.39, 6.76],
      "100-mid": "7.13",
      "100-bound": [6.24, 7.92]
    },
    "24hr": {
      "2-mid": "3.52",
      "2-bound": [3.22, 3.86],
      "5-mid": "4.37",
      "5-bound": [4.0, 4.78],
      "10-mid": "5.12",
      "10-bound": [4.67, 5.6],
      "25-mid": "6.34",
      "25-bound": [5.73, 6.88],
      "50-mid": "7.47",
      "50-bound": [6.7, 8.07],
      "100-mid": "8.82",
      "100-bound": [7.84, 9.48]
    },
    "2day": {
      "2-mid": "4.12",
      "2-bound": [3.81, 4.51],
      "5-mid": "5.11",
      "5-bound": [4.71, 5.58],
      "10-mid": "5.99",
      "10-bound": [5.5, 6.52],
      "25-mid": "7.4",
      "25-bound": [6.74, 8.03],
      "50-mid": "8.71",
      "50-bound": [7.88, 9.4],
      "100-mid": "10.3",
      "100-bound": [9.2, 11.1]
    },
    "3day": {
      "2-mid": "4.31",
      "2-bound": [3.99, 4.7],
      "5-mid": "5.32",
      "5-bound": [4.91, 5.79],
      "10-mid": "6.21",
      "10-bound": [5.71, 6.74],
      "25-mid": "7.63",
      "25-bound": [6.97, 8.25],
      "50-mid": "8.95",
      "50-bound": [8.12, 9.64],
      "100-mid": "10.5",
      "100-bound": [9.45, 11.3]
    },
    "4day": {
      "2-mid": "4.5",
      "2-bound": [4.18, 4.89],
      "5-mid": "5.52",
      "5-bound": [5.11, 6.0],
      "10-mid": "6.43",
      "10-bound": [5.92, 6.97],
      "25-mid": "7.86",
      "25-bound": [7.2, 8.48],
      "50-mid": "9.19",
      "50-bound": [8.36, 9.88],
      "100-mid": "10.8",
      "100-bound": [9.7, 11.5]
    },
    "7day": {
      "2-mid": "5.38",
      "2-bound": [4.98, 5.85],
      "5-mid": "6.55",
      "5-bound": [6.05, 7.13],
      "10-mid": "7.58",
      "10-bound": [6.97, 8.23],
      "25-mid": "9.2",
      "25-bound": [8.41, 9.96],
      "50-mid": "10.7",
      "50-bound": [9.7, 11.5],
      "100-mid": "12.4",
      "100-bound": [11.2, 13.4]
    }
  },
  "USC00188405 6": {
    "fips": "24009",
    "station_name": "SOLOMONS",
    "state": "MD",
    "latitude": "38.3190",
    "longitude": "-76.4520",
    "5min": {
      "2-mid": "0.44",
      "2-bound": [0.4, 0.48],
      "5-mid": "0.52",
      "5-bound": [0.47, 0.57],
      "10-mid": "0.58",
      "10-bound": [0.53, 0.64],
      "25-mid": "0.66",
      "25-bound": [0.59, 0.73],
      "50-mid": "0.72",
      "50-bound": [0.64, 0.79],
      "100-mid": "0.77",
      "100-bound": [0.69, 0.86]
    },
    "10min": {
      "2-mid": "0.7",
      "2-bound": [0.64, 0.78],
      "5-mid": "0.83",
      "5-bound": [0.76, 0.92],
      "10-mid": "0.93",
      "10-bound": [0.84, 1.03],
      "25-mid": "1.05",
      "25-bound": [0.94, 1.16],
      "50-mid": "1.14",
      "50-bound": [1.02, 1.26],
      "100-mid": "1.23",
      "100-bound": [1.09, 1.36]
    },
    "15min": {
      "2-mid": "0.88",
      "2-bound": [0.8, 0.97],
      "5-mid": "1.06",
      "5-bound": [0.95, 1.16],
      "10-mid": "1.18",
      "10-bound": [1.06, 1.3],
      "25-mid": "1.33",
      "25-bound": [1.2, 1.47],
      "50-mid": "1.44",
      "50-bound": [1.29, 1.6],
      "100-mid": "1.55",
      "100-bound": [1.38, 1.72]
    },
    "30min": {
      "2-mid": "1.22",
      "2-bound": [1.1, 1.34],
      "5-mid": "1.5",
      "5-bound": [1.36, 1.65],
      "10-mid": "1.71",
      "10-bound": [1.54, 1.88],
      "25-mid": "1.97",
      "25-bound": [1.77, 2.18],
      "50-mid": "2.18",
      "50-bound": [1.95, 2.41],
      "100-mid": "2.38",
      "100-bound": [2.12, 2.64]
    },
    "60min": {
      "2-mid": "1.53",
      "2-bound": [1.38, 1.69],
      "5-mid": "1.92",
      "5-bound": [1.74, 2.12],
      "10-mid": "2.22",
      "10-bound": [2.0, 2.45],
      "25-mid": "2.62",
      "25-bound": [2.36, 2.9],
      "50-mid": "2.95",
      "50-bound": [2.64, 3.27],
      "100-mid": "3.28",
      "100-bound": [2.91, 3.64]
    },
    "2hr": {
      "2-mid": "1.85",
      "2-bound": [1.67, 2.05],
      "5-mid": "2.34",
      "5-bound": [2.11, 2.59],
      "10-mid": "2.72",
      "10-bound": [2.45, 3.01],
      "25-mid": "3.25",
      "25-bound": [2.91, 3.6],
      "50-mid": "3.68",
      "50-bound": [3.28, 4.08],
      "100-mid": "4.13",
      "100-bound": [3.65, 4.6]
    },
    "3hr": {
      "2-mid": "2.01",
      "2-bound": [1.8, 2.24],
      "5-mid": "2.55",
      "5-bound": [2.28, 2.83],
      "10-mid": "2.98",
      "10-bound": [2.66, 3.31],
      "25-mid": "3.58",
      "25-bound": [3.17, 3.98],
      "50-mid": "4.08",
      "50-bound": [3.59, 4.54],
      "100-mid": "4.61",
      "100-bound": [4.03, 5.14]
    },
    "6hr": {
      "2-mid": "2.45",
      "2-bound": [2.2, 2.73],
      "5-mid": "3.09",
      "5-bound": [2.78, 3.44],
      "10-mid": "3.63",
      "10-bound": [3.24, 4.04],
      "25-mid": "4.41",
      "25-bound": [3.91, 4.9],
      "50-mid": "5.07",
      "50-bound": [4.46, 5.65],
      "100-mid": "5.79",
      "100-bound": [5.04, 6.48]
    },
    "12hr": {
      "2-mid": "2.91",
      "2-bound": [2.6, 3.29],
      "5-mid": "3.7",
      "5-bound": [3.3, 4.18],
      "10-mid": "4.4",
      "10-bound": [3.9, 4.96],
      "25-mid": "5.43",
      "25-bound": [4.77, 6.11],
      "50-mid": "6.34",
      "50-bound": [5.51, 7.15],
      "100-mid": "7.35",
      "100-bound": [6.3, 8.3]
    },
    "24hr": {
      "2-mid": "3.36",
      "2-bound": [3.04, 3.77],
      "5-mid": "4.37",
      "5-bound": [3.95, 4.9],
      "10-mid": "5.24",
      "10-bound": [4.71, 5.85],
      "25-mid": "6.56",
      "25-bound": [5.85, 7.3],
      "50-mid": "7.72",
      "50-bound": [6.84, 8.58],
      "100-mid": "9.03",
      "100-bound": [7.92, 10.0]
    },
    "2day": {
      "2-mid": "3.85",
      "2-bound": [3.48, 4.29],
      "5-mid": "5.01",
      "5-bound": [4.52, 5.58],
      "10-mid": "6.0",
      "10-bound": [5.38, 6.66],
      "25-mid": "7.5",
      "25-bound": [6.69, 8.31],
      "50-mid": "8.8",
      "50-bound": [7.81, 9.74],
      "100-mid": "10.3",
      "100-bound": [9.04, 11.3]
    },
    "3day": {
      "2-mid": "4.09",
      "2-bound": [3.71, 4.54],
      "5-mid": "5.29",
      "5-bound": [4.79, 5.87],
      "10-mid": "6.31",
      "10-bound": [5.7, 6.99],
      "25-mid": "7.85",
      "25-bound": [7.04, 8.68],
      "50-mid": "9.18",
      "50-bound": [8.2, 10.1],
      "100-mid": "10.7",
      "100-bound": [9.45, 11.8]
    },
    "4day": {
      "2-mid": "4.32",
      "2-bound": [3.94, 4.79],
      "5-mid": "5.56",
      "5-bound": [5.06, 6.17],
      "10-mid": "6.62",
      "10-bound": [6.01, 7.33],
      "25-mid": "8.2",
      "25-bound": [7.4, 9.05],
      "50-mid": "9.57",
      "50-bound": [8.58, 10.5],
      "100-mid": "11.1",
      "100-bound": [9.87, 12.2]
    },
    "7day": {
      "2-mid": "4.97",
      "2-bound": [4.57, 5.44],
      "5-mid": "6.29",
      "5-bound": [5.78, 6.89],
      "10-mid": "7.41",
      "10-bound": [6.8, 8.11],
      "25-mid": "9.08",
      "25-bound": [8.29, 9.92],
      "50-mid": "10.5",
      "50-bound": [9.54, 11.4],
      "100-mid": "12.1",
      "100-bound": [10.9, 13.1]
    }
  },
  "USC00361705 6": {
    "fips": "42111",
    "station_name": "CONFLUENCE 1 SW DAM",
    "state": "PA",
    "latitude": "39.7994",
    "longitude": "-79.3663",
    "5min": {
      "2-mid": "0.37",
      "2-bound": [0.34, 0.4],
      "5-mid": "0.44",
      "5-bound": [0.4, 0.48],
      "10-mid": "0.5",
      "10-bound": [0.45, 0.54],
      "25-mid": "0.57",
      "25-bound": [0.52, 0.62],
      "50-mid": "0.63",
      "50-bound": [0.57, 0.68],
      "100-mid": "0.68",
      "100-bound": [0.61, 0.74]
    },
    "10min": {
      "2-mid": "0.57",
      "2-bound": [0.52, 0.62],
      "5-mid": "0.68",
      "5-bound": [0.62, 0.74],
      "10-mid": "0.77",
      "10-bound": [0.7, 0.83],
      "25-mid": "0.87",
      "25-bound": [0.79, 0.95],
      "50-mid": "0.95",
      "50-bound": [0.86, 1.03],
      "100-mid": "1.03",
      "100-bound": [0.92, 1.11]
    },
    "15min": {
      "2-mid": "0.7",
      "2-bound": [0.64, 0.77],
      "5-mid": "0.83",
      "5-bound": [0.76, 0.91],
      "10-mid": "0.94",
      "10-bound": [0.86, 1.03],
      "25-mid": "1.08",
      "25-bound": [0.98, 1.17],
      "50-mid": "1.18",
      "50-bound": [1.06, 1.28],
      "100-mid": "1.28",
      "100-bound": [1.15, 1.38]
    },
    "30min": {
      "2-mid": "0.93",
      "2-bound": [0.86, 1.02],
      "5-mid": "1.14",
      "5-bound": [1.04, 1.25],
      "10-mid": "1.31",
      "10-bound": [1.19, 1.43],
      "25-mid": "1.52",
      "25-bound": [1.38, 1.66],
      "50-mid": "1.68",
      "50-bound": [1.52, 1.83],
      "100-mid": "1.84",
      "100-bound": [1.66, 2.0]
    },
    "60min": {
      "2-mid": "1.15",
      "2-bound": [1.05, 1.26],
      "5-mid": "1.44",
      "5-bound": [1.31, 1.57],
      "10-mid": "1.67",
      "10-bound": [1.51, 1.82],
      "25-mid": "1.97",
      "25-bound": [1.79, 2.15],
      "50-mid": "2.22",
      "50-bound": [2.0, 2.41],
      "100-mid": "2.46",
      "100-bound": [2.21, 2.67]
    },
    "2hr": {
      "2-mid": "1.36",
      "2-bound": [1.24, 1.48],
      "5-mid": "1.71",
      "5-bound": [1.55, 1.85],
      "10-mid": "1.99",
      "10-bound": [1.81, 2.16],
      "25-mid": "2.38",
      "25-bound": [2.15, 2.57],
      "50-mid": "2.7",
      "50-bound": [2.43, 2.91],
      "100-mid": "3.04",
      "100-bound": [2.71, 3.28]
    },
    "3hr": {
      "2-mid": "1.47",
      "2-bound": [1.34, 1.62],
      "5-mid": "1.83",
      "5-bound": [1.67, 2.01],
      "10-mid": "2.13",
      "10-bound": [1.94, 2.34],
      "25-mid": "2.55",
      "25-bound": [2.31, 2.79],
      "50-mid": "2.9",
      "50-bound": [2.61, 3.17],
      "100-mid": "3.27",
      "100-bound": [2.93, 3.57]
    },
    "6hr": {
      "2-mid": "1.79",
      "2-bound": [1.62, 1.99],
      "5-mid": "2.21",
      "5-bound": [1.99, 2.45],
      "10-mid": "2.57",
      "10-bound": [2.31, 2.85],
      "25-mid": "3.07",
      "25-bound": [2.75, 3.4],
      "50-mid": "3.49",
      "50-bound": [3.11, 3.86],
      "100-mid": "3.94",
      "100-bound": [3.49, 4.34]
    },
    "12hr": {
      "2-mid": "2.18",
      "2-bound": [1.97, 2.45],
      "5-mid": "2.67",
      "5-bound": [2.41, 3.0],
      "10-mid": "3.1",
      "10-bound": [2.79, 3.47],
      "25-mid": "3.71",
      "25-bound": [3.32, 4.13],
      "50-mid": "4.23",
      "50-bound": [3.76, 4.7],
      "100-mid": "4.78",
      "100-bound": [4.21, 5.29]
    },
    "24hr": {
      "2-mid": "2.52",
      "2-bound": [2.34, 2.74],
      "5-mid": "3.08",
      "5-bound": [2.86, 3.34],
      "10-mid": "3.55",
      "10-bound": [3.28, 3.84],
      "25-mid": "4.21",
      "25-bound": [3.88, 4.54],
      "50-mid": "4.76",
      "50-bound": [4.37, 5.13],
      "100-mid": "5.34",
      "100-bound": [4.88, 5.75]
    },
    "2day": {
      "2-mid": "2.97",
      "2-bound": [2.78, 3.2],
      "5-mid": "3.6",
      "5-bound": [3.36, 3.87],
      "10-mid": "4.1",
      "10-bound": [3.82, 4.41],
      "25-mid": "4.83",
      "25-bound": [4.48, 5.18],
      "50-mid": "5.42",
      "50-bound": [5.0, 5.82],
      "100-mid": "6.04",
      "100-bound": [5.54, 6.48]
    },
    "3day": {
      "2-mid": "3.21",
      "2-bound": [3.01, 3.45],
      "5-mid": "3.86",
      "5-bound": [3.62, 4.14],
      "10-mid": "4.39",
      "10-bound": [4.1, 4.7],
      "25-mid": "5.13",
      "25-bound": [4.78, 5.49],
      "50-mid": "5.72",
      "50-bound": [5.31, 6.12],
      "100-mid": "6.34",
      "100-bound": [5.85, 6.78]
    },
    "4day": {
      "2-mid": "3.45",
      "2-bound": [3.24, 3.69],
      "5-mid": "4.14",
      "5-bound": [3.88, 4.42],
      "10-mid": "4.68",
      "10-bound": [4.38, 4.99],
      "25-mid": "5.43",
      "25-bound": [5.08, 5.79],
      "50-mid": "6.03",
      "50-bound": [5.61, 6.42],
      "100-mid": "6.64",
      "100-bound": [6.16, 7.08]
    },
    "7day": {
      "2-mid": "4.14",
      "2-bound": [3.91, 4.41],
      "5-mid": "4.89",
      "5-bound": [4.61, 5.21],
      "10-mid": "5.49",
      "10-bound": [5.16, 5.84],
      "25-mid": "6.28",
      "25-bound": [5.89, 6.67],
      "50-mid": "6.89",
      "50-bound": [6.44, 7.31],
      "100-mid": "7.5",
      "100-bound": [7.0, 7.96]
    }
  },
  "USC00363130 6": {
    "fips": "42105",
    "station_name": "GALETON",
    "state": "PA",
    "latitude": "41.7350",
    "longitude": "-77.6510",
    "5min": {
      "2-mid": "0.34",
      "2-bound": [0.31, 0.38],
      "5-mid": "0.41",
      "5-bound": [0.37, 0.46],
      "10-mid": "0.47",
      "10-bound": [0.42, 0.52],
      "25-mid": "0.55",
      "25-bound": [0.49, 0.61],
      "50-mid": "0.61",
      "50-bound": [0.54, 0.67],
      "100-mid": "0.67",
      "100-bound": [0.59, 0.74]
    },
    "10min": {
      "2-mid": "0.53",
      "2-bound": [0.48, 0.59],
      "5-mid": "0.64",
      "5-bound": [0.57, 0.71],
      "10-mid": "0.72",
      "10-bound": [0.65, 0.81],
      "25-mid": "0.83",
      "25-bound": [0.74, 0.93],
      "50-mid": "0.92",
      "50-bound": [0.81, 1.02],
      "100-mid": "1.01",
      "100-bound": [0.89, 1.12]
    },
    "15min": {
      "2-mid": "0.65",
      "2-bound": [0.59, 0.73],
      "5-mid": "0.79",
      "5-bound": [0.71, 0.88],
      "10-mid": "0.89",
      "10-bound": [0.8, 0.99],
      "25-mid": "1.03",
      "25-bound": [0.92, 1.15],
      "50-mid": "1.14",
      "50-bound": [1.01, 1.26],
      "100-mid": "1.26",
      "100-bound": [1.1, 1.39]
    },
    "30min": {
      "2-mid": "0.87",
      "2-bound": [0.79, 0.97],
      "5-mid": "1.08",
      "5-bound": [0.97, 1.2],
      "10-mid": "1.24",
      "10-bound": [1.11, 1.38],
      "25-mid": "1.46",
      "25-bound": [1.3, 1.62],
      "50-mid": "1.63",
      "50-bound": [1.44, 1.81],
      "100-mid": "1.81",
      "100-bound": [1.6, 2.01]
    },
    "60min": {
      "2-mid": "1.07",
      "2-bound": [0.96, 1.2],
      "5-mid": "1.35",
      "5-bound": [1.21, 1.51],
      "10-mid": "1.57",
      "10-bound": [1.41, 1.75],
      "25-mid": "1.89",
      "25-bound": [1.68, 2.1],
      "50-mid": "2.14",
      "50-bound": [1.9, 2.38],
      "100-mid": "2.42",
      "100-bound": [2.13, 2.69]
    },
    "2hr": {
      "2-mid": "1.23",
      "2-bound": [1.11, 1.37],
      "5-mid": "1.55",
      "5-bound": [1.4, 1.72],
      "10-mid": "1.82",
      "10-bound": [1.63, 2.01],
      "25-mid": "2.21",
      "25-bound": [1.97, 2.44],
      "50-mid": "2.56",
      "50-bound": [2.28, 2.82],
      "100-mid": "2.96",
      "100-bound": [2.61, 3.25]
    },
    "3hr": {
      "2-mid": "1.33",
      "2-bound": [1.21, 1.48],
      "5-mid": "1.67",
      "5-bound": [1.51, 1.85],
      "10-mid": "1.95",
      "10-bound": [1.76, 2.16],
      "25-mid": "2.38",
      "25-bound": [2.13, 2.62],
      "50-mid": "2.76",
      "50-bound": [2.45, 3.03],
      "100-mid": "3.19",
      "100-bound": [2.82, 3.5]
    },
    "6hr": {
      "2-mid": "1.69",
      "2-bound": [1.54, 1.88],
      "5-mid": "2.09",
      "5-bound": [1.9, 2.32],
      "10-mid": "2.43",
      "10-bound": [2.2, 2.69],
      "25-mid": "2.94",
      "25-bound": [2.64, 3.24],
      "50-mid": "3.41",
      "50-bound": [3.04, 3.74],
      "100-mid": "3.93",
      "100-bound": [3.48, 4.31]
    },
    "12hr": {
      "2-mid": "2.1",
      "2-bound": [1.9, 2.36],
      "5-mid": "2.58",
      "5-bound": [2.33, 2.91],
      "10-mid": "3.01",
      "10-bound": [2.7, 3.37],
      "25-mid": "3.65",
      "25-bound": [3.26, 4.08],
      "50-mid": "4.24",
      "50-bound": [3.75, 4.72],
      "100-mid": "4.91",
      "100-bound": [4.31, 5.46]
    },
    "24hr": {
      "2-mid": "2.52",
      "2-bound": [2.32, 2.79],
      "5-mid": "3.11",
      "5-bound": [2.85, 3.43],
      "10-mid": "3.62",
      "10-bound": [3.3, 3.98],
      "25-mid": "4.42",
      "25-bound": [4.0, 4.84],
      "50-mid": "5.16",
      "50-bound": [4.63, 5.64],
      "100-mid": "6.02",
      "100-bound": [5.36, 6.57]
    },
    "2day": {
      "2-mid": "2.91",
      "2-bound": [2.68, 3.21],
      "5-mid": "3.58",
      "5-bound": [3.29, 3.94],
      "10-mid": "4.17",
      "10-bound": [3.82, 4.59],
      "25-mid": "5.12",
      "25-bound": [4.64, 5.61],
      "50-mid": "6.0",
      "50-bound": [5.39, 6.56],
      "100-mid": "7.04",
      "100-bound": [6.26, 7.69]
    },
    "3day": {
      "2-mid": "3.08",
      "2-bound": [2.84, 3.39],
      "5-mid": "3.77",
      "5-bound": [3.48, 4.15],
      "10-mid": "4.39",
      "10-bound": [4.02, 4.82],
      "25-mid": "5.37",
      "25-bound": [4.88, 5.88],
      "50-mid": "6.29",
      "50-bound": [5.66, 6.87],
      "100-mid": "7.37",
      "100-bound": [6.56, 8.04]
    },
    "4day": {
      "2-mid": "3.25",
      "2-bound": [3.0, 3.58],
      "5-mid": "3.97",
      "5-bound": [3.66, 4.36],
      "10-mid": "4.61",
      "10-bound": [4.23, 5.05],
      "25-mid": "5.62",
      "25-bound": [5.12, 6.16],
      "50-mid": "6.58",
      "50-bound": [5.93, 7.19],
      "100-mid": "7.7",
      "100-bound": [6.87, 8.4]
    },
    "7day": {
      "2-mid": "3.86",
      "2-bound": [3.59, 4.21],
      "5-mid": "4.6",
      "5-bound": [4.27, 5.01],
      "10-mid": "5.26",
      "10-bound": [4.86, 5.72],
      "25-mid": "6.29",
      "25-bound": [5.78, 6.82],
      "50-mid": "7.23",
      "50-bound": [6.59, 7.83],
      "100-mid": "8.33",
      "100-bound": [7.53, 9.02]
    }
  },
  "USC00446593 6": {
    "fips": "51009",
    "station_name": "PEDLAR DAM",
    "state": "VA",
    "latitude": "37.6690",
    "longitude": "-79.2770",
    "5min": {
      "2-mid": "0.36",
      "2-bound": [0.33, 0.41],
      "5-mid": "0.44",
      "5-bound": [0.4, 0.49],
      "10-mid": "0.5",
      "10-bound": [0.45, 0.55],
      "25-mid": "0.56",
      "25-bound": [0.51, 0.62],
      "50-mid": "0.61",
      "50-bound": [0.55, 0.68],
      "100-mid": "0.66",
      "100-bound": [0.58, 0.73]
    },
    "10min": {
      "2-mid": "0.58",
      "2-bound": [0.53, 0.65],
      "5-mid": "0.7",
      "5-bound": [0.64, 0.78],
      "10-mid": "0.79",
      "10-bound": [0.71, 0.88],
      "25-mid": "0.9",
      "25-bound": [0.81, 0.99],
      "50-mid": "0.98",
      "50-bound": [0.87, 1.08],
      "100-mid": "1.05",
      "100-bound": [0.93, 1.16]
    },
    "15min": {
      "2-mid": "0.73",
      "2-bound": [0.67, 0.81],
      "5-mid": "0.89",
      "5-bound": [0.8, 0.98],
      "10-mid": "1.0",
      "10-bound": [0.9, 1.11],
      "25-mid": "1.14",
      "25-bound": [1.02, 1.26],
      "50-mid": "1.24",
      "50-bound": [1.1, 1.37],
      "100-mid": "1.33",
      "100-bound": [1.17, 1.47]
    },
    "30min": {
      "2-mid": "1.02",
      "2-bound": [0.92, 1.12],
      "5-mid": "1.26",
      "5-bound": [1.14, 1.4],
      "10-mid": "1.45",
      "10-bound": [1.31, 1.6],
      "25-mid": "1.68",
      "25-bound": [1.51, 1.86],
      "50-mid": "1.86",
      "50-bound": [1.66, 2.06],
      "100-mid": "2.03",
      "100-bound": [1.8, 2.25]
    },
    "60min": {
      "2-mid": "1.27",
      "2-bound": [1.15, 1.41],
      "5-mid": "1.62",
      "5-bound": [1.46, 1.8],
      "10-mid": "1.89",
      "10-bound": [1.7, 2.09],
      "25-mid": "2.24",
      "25-bound": [2.01, 2.48],
      "50-mid": "2.52",
      "50-bound": [2.24, 2.79],
      "100-mid": "2.8",
      "100-bound": [2.47, 3.1]
    },
    "2hr": {
      "2-mid": "1.49",
      "2-bound": [1.35, 1.65],
      "5-mid": "1.91",
      "5-bound": [1.73, 2.12],
      "10-mid": "2.25",
      "10-bound": [2.03, 2.49],
      "25-mid": "2.69",
      "25-bound": [2.41, 2.96],
      "50-mid": "3.04",
      "50-bound": [2.71, 3.36],
      "100-mid": "3.4",
      "100-bound": [3.0, 3.76]
    },
    "3hr": {
      "2-mid": "1.61",
      "2-bound": [1.46, 1.79],
      "5-mid": "2.05",
      "5-bound": [1.85, 2.27],
      "10-mid": "2.4",
      "10-bound": [2.17, 2.67],
      "25-mid": "2.88",
      "25-bound": [2.58, 3.19],
      "50-mid": "3.26",
      "50-bound": [2.9, 3.61],
      "100-mid": "3.65",
      "100-bound": [3.22, 4.05]
    },
    "6hr": {
      "2-mid": "2.0",
      "2-bound": [1.81, 2.23],
      "5-mid": "2.52",
      "5-bound": [2.28, 2.81],
      "10-mid": "2.96",
      "10-bound": [2.66, 3.3],
      "25-mid": "3.56",
      "25-bound": [3.18, 3.96],
      "50-mid": "4.07",
      "50-bound": [3.6, 4.53],
      "100-mid": "4.6",
      "100-bound": [4.02, 5.12]
    },
    "12hr": {
      "2-mid": "2.45",
      "2-bound": [2.21, 2.78],
      "5-mid": "3.08",
      "5-bound": [2.77, 3.49],
      "10-mid": "3.64",
      "10-bound": [3.26, 4.11],
      "25-mid": "4.43",
      "25-bound": [3.92, 4.99],
      "50-mid": "5.11",
      "50-bound": [4.47, 5.74],
      "100-mid": "5.84",
      "100-bound": [5.04, 6.59]
    },
    "24hr": {
      "2-mid": "3.12",
      "2-bound": [2.89, 3.39],
      "5-mid": "3.96",
      "5-bound": [3.66, 4.31],
      "10-mid": "4.66",
      "10-bound": [4.3, 5.06],
      "25-mid": "5.67",
      "25-bound": [5.21, 6.14],
      "50-mid": "6.52",
      "50-bound": [5.95, 7.06],
      "100-mid": "7.43",
      "100-bound": [6.74, 8.04]
    },
    "2day": {
      "2-mid": "3.66",
      "2-bound": [3.4, 3.96],
      "5-mid": "4.63",
      "5-bound": [4.29, 5.0],
      "10-mid": "5.41",
      "10-bound": [5.0, 5.84],
      "25-mid": "6.53",
      "25-bound": [6.01, 7.05],
      "50-mid": "7.46",
      "50-bound": [6.82, 8.04],
      "100-mid": "8.45",
      "100-bound": [7.67, 9.1]
    },
    "3day": {
      "2-mid": "3.91",
      "2-bound": [3.62, 4.23],
      "5-mid": "4.93",
      "5-bound": [4.56, 5.33],
      "10-mid": "5.76",
      "10-bound": [5.3, 6.21],
      "25-mid": "6.93",
      "25-bound": [6.36, 7.47],
      "50-mid": "7.9",
      "50-bound": [7.21, 8.51],
      "100-mid": "8.92",
      "100-bound": [8.09, 9.62]
    },
    "4day": {
      "2-mid": "4.15",
      "2-bound": [3.84, 4.49],
      "5-mid": "5.23",
      "5-bound": [4.82, 5.65],
      "10-mid": "6.1",
      "10-bound": [5.61, 6.58],
      "25-mid": "7.32",
      "25-bound": [6.71, 7.89],
      "50-mid": "8.33",
      "50-bound": [7.59, 8.98],
      "100-mid": "9.4",
      "100-bound": [8.5, 10.1]
    },
    "7day": {
      "2-mid": "4.77",
      "2-bound": [4.42, 5.14],
      "5-mid": "5.94",
      "5-bound": [5.5, 6.4],
      "10-mid": "6.87",
      "10-bound": [6.34, 7.38],
      "25-mid": "8.16",
      "25-bound": [7.51, 8.76],
      "50-mid": "9.2",
      "50-bound": [8.43, 9.88],
      "100-mid": "10.3",
      "100-bound": [9.37, 11.0]
    }
  },
  "USC00301168 6": {
    "fips": "36107",
    "station_name": "CANDOR 2SE",
    "state": "NY",
    "latitude": "42.1940",
    "longitude": "-76.3120",
    "5min": {
      "2-mid": "0.36",
      "2-bound": [0.28, 0.47],
      "5-mid": "0.47",
      "5-bound": [0.36, 0.6],
      "10-mid": "0.56",
      "10-bound": [0.43, 0.72],
      "25-mid": "0.68",
      "25-bound": [0.51, 0.92],
      "50-mid": "0.77",
      "50-bound": [0.56, 1.07],
      "100-mid": "0.86",
      "100-bound": [0.61, 1.25]
    },
    "10min": {
      "2-mid": "0.52",
      "2-bound": [0.4, 0.66],
      "5-mid": "0.67",
      "5-bound": [0.52, 0.86],
      "10-mid": "0.79",
      "10-bound": [0.61, 1.02],
      "25-mid": "0.96",
      "25-bound": [0.72, 1.3],
      "50-mid": "1.09",
      "50-bound": [0.8, 1.51],
      "100-mid": "1.22",
      "100-bound": [0.87, 1.77]
    },
    "15min": {
      "2-mid": "0.61",
      "2-bound": [0.47, 0.78],
      "5-mid": "0.78",
      "5-bound": [0.61, 1.01],
      "10-mid": "0.93",
      "10-bound": [0.72, 1.2],
      "25-mid": "1.13",
      "25-bound": [0.84, 1.54],
      "50-mid": "1.28",
      "50-bound": [0.94, 1.78],
      "100-mid": "1.44",
      "100-bound": [1.02, 2.09]
    },
    "30min": {
      "2-mid": "0.81",
      "2-bound": [0.63, 1.04],
      "5-mid": "1.04",
      "5-bound": [0.81, 1.34],
      "10-mid": "1.24",
      "10-bound": [0.95, 1.6],
      "25-mid": "1.5",
      "25-bound": [1.12, 2.04],
      "50-mid": "1.7",
      "50-bound": [1.24, 2.37],
      "100-mid": "1.91",
      "100-bound": [1.36, 2.77]
    },
    "60min": {
      "2-mid": "1.01",
      "2-bound": [0.79, 1.3],
      "5-mid": "1.3",
      "5-bound": [1.01, 1.68],
      "10-mid": "1.54",
      "10-bound": [1.19, 2.0],
      "25-mid": "1.87",
      "25-bound": [1.4, 2.55],
      "50-mid": "2.12",
      "50-bound": [1.55, 2.95],
      "100-mid": "2.38",
      "100-bound": [1.69, 3.46]
    },
    "2hr": {
      "2-mid": "1.24",
      "2-bound": [0.97, 1.57],
      "5-mid": "1.55",
      "5-bound": [1.21, 1.98],
      "10-mid": "1.81",
      "10-bound": [1.4, 2.33],
      "25-mid": "2.17",
      "25-bound": [1.64, 2.96],
      "50-mid": "2.43",
      "50-bound": [1.81, 3.41],
      "100-mid": "2.73",
      "100-bound": [1.99, 4.02]
    },
    "3hr": {
      "2-mid": "1.38",
      "2-bound": [1.09, 1.76],
      "5-mid": "1.73",
      "5-bound": [1.35, 2.2],
      "10-mid": "2.01",
      "10-bound": [1.56, 2.58],
      "25-mid": "2.4",
      "25-bound": [1.82, 3.27],
      "50-mid": "2.68",
      "50-bound": [2.01, 3.77],
      "100-mid": "3.0",
      "100-bound": [2.21, 4.45]
    },
    "6hr": {
      "2-mid": "1.69",
      "2-bound": [1.34, 2.13],
      "5-mid": "2.12",
      "5-bound": [1.67, 2.68],
      "10-mid": "2.48",
      "10-bound": [1.94, 3.16],
      "25-mid": "2.96",
      "25-bound": [2.27, 4.02],
      "50-mid": "3.32",
      "50-bound": [2.5, 4.64],
      "100-mid": "3.72",
      "100-bound": [2.75, 5.51]
    },
    "12hr": {
      "2-mid": "2.07",
      "2-bound": [1.65, 2.59],
      "5-mid": "2.65",
      "5-bound": [2.1, 3.33],
      "10-mid": "3.13",
      "10-bound": [2.47, 3.97],
      "25-mid": "3.79",
      "25-bound": [2.91, 5.1],
      "50-mid": "4.28",
      "50-bound": [3.22, 5.93],
      "100-mid": "4.82",
      "100-bound": [3.55, 7.03]
    },
    "24hr": {
      "2-mid": "2.46",
      "2-bound": [1.97, 3.07],
      "5-mid": "3.2",
      "5-bound": [2.56, 4.0],
      "10-mid": "3.82",
      "10-bound": [3.03, 4.8],
      "25-mid": "4.66",
      "25-bound": [3.59, 6.22],
      "50-mid": "5.28",
      "50-bound": [3.99, 7.25],
      "100-mid": "5.96",
      "100-bound": [4.4, 8.61]
    },
    "2day": {
      "2-mid": "2.85",
      "2-bound": [2.29, 3.52],
      "5-mid": "3.7",
      "5-bound": [2.97, 4.6],
      "10-mid": "4.41",
      "10-bound": [3.52, 5.51],
      "25-mid": "5.39",
      "25-bound": [4.17, 7.15],
      "50-mid": "6.1",
      "50-bound": [4.64, 8.34],
      "100-mid": "6.89",
      "100-bound": [5.1, 9.91]
    },
    "3day": {
      "2-mid": "3.11",
      "2-bound": [2.52, 3.83],
      "5-mid": "4.03",
      "5-bound": [3.25, 4.98],
      "10-mid": "4.79",
      "10-bound": [3.84, 5.96],
      "25-mid": "5.84",
      "25-bound": [4.54, 7.72],
      "50-mid": "6.6",
      "50-bound": [5.03, 9.0],
      "100-mid": "7.45",
      "100-bound": [5.54, 10.7]
    },
    "4day": {
      "2-mid": "3.34",
      "2-bound": [2.71, 4.11],
      "5-mid": "4.3",
      "5-bound": [3.48, 5.3],
      "10-mid": "5.09",
      "10-bound": [4.09, 6.32],
      "25-mid": "6.18",
      "25-bound": [4.82, 8.16],
      "50-mid": "6.98",
      "50-bound": [5.33, 9.49],
      "100-mid": "7.86",
      "100-bound": [5.86, 11.3]
    },
    "7day": {
      "2-mid": "3.96",
      "2-bound": [3.23, 4.84],
      "5-mid": "4.97",
      "5-bound": [4.04, 6.1],
      "10-mid": "5.81",
      "10-bound": [4.69, 7.18],
      "25-mid": "6.97",
      "25-bound": [5.45, 9.13],
      "50-mid": "7.82",
      "50-bound": [5.99, 10.6],
      "100-mid": "8.76",
      "100-bound": [6.53, 12.4]
    }
  },
  "USC00446012 6": {
    "fips": "51045",
    "station_name": "NEW CASTLE",
    "state": "VA",
    "latitude": "37.5090",
    "longitude": "-80.0981",
    "5min": {
      "2-mid": "0.35",
      "2-bound": [0.31, 0.39],
      "5-mid": "0.42",
      "5-bound": [0.38, 0.47],
      "10-mid": "0.47",
      "10-bound": [0.42, 0.53],
      "25-mid": "0.53",
      "25-bound": [0.47, 0.59],
      "50-mid": "0.58",
      "50-bound": [0.51, 0.65],
      "100-mid": "0.62",
      "100-bound": [0.54, 0.69]
    },
    "10min": {
      "2-mid": "0.56",
      "2-bound": [0.5, 0.62],
      "5-mid": "0.67",
      "5-bound": [0.6, 0.75],
      "10-mid": "0.75",
      "10-bound": [0.67, 0.84],
      "25-mid": "0.85",
      "25-bound": [0.75, 0.95],
      "50-mid": "0.92",
      "50-bound": [0.81, 1.03],
      "100-mid": "0.99",
      "100-bound": [0.86, 1.1]
    },
    "15min": {
      "2-mid": "0.7",
      "2-bound": [0.63, 0.78],
      "5-mid": "0.85",
      "5-bound": [0.76, 0.95],
      "10-mid": "0.95",
      "10-bound": [0.85, 1.06],
      "25-mid": "1.08",
      "25-bound": [0.96, 1.2],
      "50-mid": "1.17",
      "50-bound": [1.03, 1.3],
      "100-mid": "1.25",
      "100-bound": [1.09, 1.4]
    },
    "30min": {
      "2-mid": "0.97",
      "2-bound": [0.87, 1.08],
      "5-mid": "1.21",
      "5-bound": [1.08, 1.35],
      "10-mid": "1.38",
      "10-bound": [1.23, 1.54],
      "25-mid": "1.6",
      "25-bound": [1.42, 1.78],
      "50-mid": "1.76",
      "50-bound": [1.54, 1.96],
      "100-mid": "1.91",
      "100-bound": [1.67, 2.14]
    },
    "60min": {
      "2-mid": "1.22",
      "2-bound": [1.09, 1.36],
      "5-mid": "1.55",
      "5-bound": [1.39, 1.73],
      "10-mid": "1.8",
      "10-bound": [1.6, 2.0],
      "25-mid": "2.13",
      "25-bound": [1.88, 2.37],
      "50-mid": "2.38",
      "50-bound": [2.09, 2.65],
      "100-mid": "2.63",
      "100-bound": [2.3, 2.94]
    },
    "2hr": {
      "2-mid": "1.39",
      "2-bound": [1.26, 1.54],
      "5-mid": "1.78",
      "5-bound": [1.6, 1.97],
      "10-mid": "2.07",
      "10-bound": [1.86, 2.29],
      "25-mid": "2.46",
      "25-bound": [2.19, 2.72],
      "50-mid": "2.75",
      "50-bound": [2.44, 3.06],
      "100-mid": "3.06",
      "100-bound": [2.69, 3.4]
    },
    "3hr": {
      "2-mid": "1.48",
      "2-bound": [1.34, 1.64],
      "5-mid": "1.88",
      "5-bound": [1.7, 2.08],
      "10-mid": "2.19",
      "10-bound": [1.98, 2.43],
      "25-mid": "2.6",
      "25-bound": [2.33, 2.88],
      "50-mid": "2.92",
      "50-bound": [2.6, 3.24],
      "100-mid": "3.25",
      "100-bound": [2.86, 3.62]
    },
    "6hr": {
      "2-mid": "1.82",
      "2-bound": [1.66, 2.03],
      "5-mid": "2.28",
      "5-bound": [2.07, 2.55],
      "10-mid": "2.65",
      "10-bound": [2.4, 2.96],
      "25-mid": "3.17",
      "25-bound": [2.84, 3.53],
      "50-mid": "3.59",
      "50-bound": [3.18, 4.0],
      "100-mid": "4.02",
      "100-bound": [3.52, 4.51]
    },
    "12hr": {
      "2-mid": "2.2",
      "2-bound": [2.0, 2.47],
      "5-mid": "2.75",
      "5-bound": [2.49, 3.08],
      "10-mid": "3.21",
      "10-bound": [2.89, 3.59],
      "25-mid": "3.87",
      "25-bound": [3.44, 4.33],
      "50-mid": "4.42",
      "50-bound": [3.89, 4.96],
      "100-mid": "5.02",
      "100-bound": [4.36, 5.66]
    },
    "24hr": {
      "2-mid": "2.82",
      "2-bound": [2.6, 3.08],
      "5-mid": "3.55",
      "5-bound": [3.27, 3.87],
      "10-mid": "4.16",
      "10-bound": [3.82, 4.53],
      "25-mid": "5.02",
      "25-bound": [4.58, 5.46],
      "50-mid": "5.75",
      "50-bound": [5.21, 6.25],
      "100-mid": "6.52",
      "100-bound": [5.88, 7.09]
    },
    "2day": {
      "2-mid": "3.33",
      "2-bound": [3.08, 3.6],
      "5-mid": "4.17",
      "5-bound": [3.86, 4.52],
      "10-mid": "4.86",
      "10-bound": [4.48, 5.25],
      "25-mid": "5.83",
      "25-bound": [5.35, 6.29],
      "50-mid": "6.63",
      "50-bound": [6.05, 7.15],
      "100-mid": "7.47",
      "100-bound": [6.78, 8.07]
    },
    "3day": {
      "2-mid": "3.54",
      "2-bound": [3.3, 3.84],
      "5-mid": "4.43",
      "5-bound": [4.12, 4.8],
      "10-mid": "5.15",
      "10-bound": [4.77, 5.56],
      "25-mid": "6.16",
      "25-bound": [5.68, 6.65],
      "50-mid": "6.99",
      "50-bound": [6.41, 7.56],
      "100-mid": "7.87",
      "100-bound": [7.16, 8.51]
    },
    "4day": {
      "2-mid": "3.76",
      "2-bound": [3.51, 4.07],
      "5-mid": "4.69",
      "5-bound": [4.37, 5.08],
      "10-mid": "5.44",
      "10-bound": [5.05, 5.88],
      "25-mid": "6.5",
      "25-bound": [6.01, 7.02],
      "50-mid": "7.36",
      "50-bound": [6.77, 7.96],
      "100-mid": "8.26",
      "100-bound": [7.55, 8.94]
    },
    "7day": {
      "2-mid": "4.36",
      "2-bound": [4.07, 4.7],
      "5-mid": "5.39",
      "5-bound": [5.02, 5.81],
      "10-mid": "6.2",
      "10-bound": [5.76, 6.68],
      "25-mid": "7.32",
      "25-bound": [6.78, 7.88],
      "50-mid": "8.22",
      "50-bound": [7.58, 8.86],
      "100-mid": "9.14",
      "100-bound": [8.38, 9.87]
    }
  },
  "USW00013729 6": {
    "fips": "54083",
    "station_name": "ELKINS- RANDOLPH COUNTY AIRPORT",
    "state": "WV",
    "latitude": "38.8898",
    "longitude": "-79.8554",
    "5min": {
      "2-mid": "0.35",
      "2-bound": [0.32, 0.38],
      "5-mid": "0.41",
      "5-bound": [0.38, 0.45],
      "10-mid": "0.46",
      "10-bound": [0.42, 0.51],
      "25-mid": "0.53",
      "25-bound": [0.48, 0.58],
      "50-mid": "0.57",
      "50-bound": [0.52, 0.62],
      "100-mid": "0.61",
      "100-bound": [0.55, 0.67]
    },
    "10min": {
      "2-mid": "0.55",
      "2-bound": [0.5, 0.61],
      "5-mid": "0.66",
      "5-bound": [0.6, 0.72],
      "10-mid": "0.73",
      "10-bound": [0.67, 0.8],
      "25-mid": "0.83",
      "25-bound": [0.75, 0.91],
      "50-mid": "0.9",
      "50-bound": [0.81, 0.98],
      "100-mid": "0.96",
      "100-bound": [0.86, 1.05]
    },
    "15min": {
      "2-mid": "0.69",
      "2-bound": [0.63, 0.76],
      "5-mid": "0.82",
      "5-bound": [0.75, 0.9],
      "10-mid": "0.92",
      "10-bound": [0.84, 1.01],
      "25-mid": "1.04",
      "25-bound": [0.94, 1.14],
      "50-mid": "1.13",
      "50-bound": [1.02, 1.23],
      "100-mid": "1.21",
      "100-bound": [1.09, 1.32]
    },
    "30min": {
      "2-mid": "0.94",
      "2-bound": [0.86, 1.04],
      "5-mid": "1.16",
      "5-bound": [1.06, 1.27],
      "10-mid": "1.32",
      "10-bound": [1.2, 1.45],
      "25-mid": "1.52",
      "25-bound": [1.38, 1.67],
      "50-mid": "1.68",
      "50-bound": [1.51, 1.83],
      "100-mid": "1.83",
      "100-bound": [1.64, 1.99]
    },
    "60min": {
      "2-mid": "1.18",
      "2-bound": [1.07, 1.29],
      "5-mid": "1.48",
      "5-bound": [1.35, 1.62],
      "10-mid": "1.71",
      "10-bound": [1.56, 1.87],
      "25-mid": "2.02",
      "25-bound": [1.82, 2.2],
      "50-mid": "2.26",
      "50-bound": [2.04, 2.46],
      "100-mid": "2.5",
      "100-bound": [2.24, 2.72]
    },
    "2hr": {
      "2-mid": "1.38",
      "2-bound": [1.27, 1.5],
      "5-mid": "1.72",
      "5-bound": [1.58, 1.88],
      "10-mid": "2.0",
      "10-bound": [1.84, 2.17],
      "25-mid": "2.38",
      "25-bound": [2.17, 2.58],
      "50-mid": "2.68",
      "50-bound": [2.44, 2.91],
      "100-mid": "3.0",
      "100-bound": [2.71, 3.24]
    },
    "3hr": {
      "2-mid": "1.48",
      "2-bound": [1.36, 1.62],
      "5-mid": "1.85",
      "5-bound": [1.7, 2.03],
      "10-mid": "2.15",
      "10-bound": [1.96, 2.35],
      "25-mid": "2.56",
      "25-bound": [2.33, 2.79],
      "50-mid": "2.9",
      "50-bound": [2.63, 3.15],
      "100-mid": "3.24",
      "100-bound": [2.93, 3.52]
    },
    "6hr": {
      "2-mid": "1.79",
      "2-bound": [1.65, 1.96],
      "5-mid": "2.21",
      "5-bound": [2.04, 2.42],
      "10-mid": "2.56",
      "10-bound": [2.35, 2.8],
      "25-mid": "3.06",
      "25-bound": [2.79, 3.34],
      "50-mid": "3.47",
      "50-bound": [3.15, 3.77],
      "100-mid": "3.9",
      "100-bound": [3.51, 4.23]
    },
    "12hr": {
      "2-mid": "2.14",
      "2-bound": [1.97, 2.35],
      "5-mid": "2.63",
      "5-bound": [2.42, 2.88],
      "10-mid": "3.04",
      "10-bound": [2.78, 3.32],
      "25-mid": "3.63",
      "25-bound": [3.3, 3.95],
      "50-mid": "4.12",
      "50-bound": [3.72, 4.48],
      "100-mid": "4.64",
      "100-bound": [4.16, 5.03]
    },
    "24hr": {
      "2-mid": "2.58",
      "2-bound": [2.39, 2.79],
      "5-mid": "3.14",
      "5-bound": [2.91, 3.4],
      "10-mid": "3.6",
      "10-bound": [3.33, 3.9],
      "25-mid": "4.26",
      "25-bound": [3.92, 4.61],
      "50-mid": "4.81",
      "50-bound": [4.39, 5.19],
      "100-mid": "5.38",
      "100-bound": [4.88, 5.82]
    },
    "2day": {
      "2-mid": "3.05",
      "2-bound": [2.85, 3.27],
      "5-mid": "3.67",
      "5-bound": [3.43, 3.94],
      "10-mid": "4.18",
      "10-bound": [3.89, 4.48],
      "25-mid": "4.89",
      "25-bound": [4.53, 5.24],
      "50-mid": "5.46",
      "50-bound": [5.05, 5.86],
      "100-mid": "6.06",
      "100-bound": [5.57, 6.51]
    },
    "3day": {
      "2-mid": "3.3",
      "2-bound": [3.1, 3.52],
      "5-mid": "3.94",
      "5-bound": [3.7, 4.21],
      "10-mid": "4.47",
      "10-bound": [4.19, 4.77],
      "25-mid": "5.18",
      "25-bound": [4.84, 5.54],
      "50-mid": "5.76",
      "50-bound": [5.35, 6.15],
      "100-mid": "6.34",
      "100-bound": [5.86, 6.78]
    },
    "4day": {
      "2-mid": "3.55",
      "2-bound": [3.35, 3.78],
      "5-mid": "4.22",
      "5-bound": [3.98, 4.49],
      "10-mid": "4.76",
      "10-bound": [4.48, 5.06],
      "25-mid": "5.48",
      "25-bound": [5.15, 5.84],
      "50-mid": "6.05",
      "50-bound": [5.66, 6.44],
      "100-mid": "6.62",
      "100-bound": [6.16, 7.06]
    },
    "7day": {
      "2-mid": "4.3",
      "2-bound": [4.08, 4.54],
      "5-mid": "5.04",
      "5-bound": [4.8, 5.32],
      "10-mid": "5.62",
      "10-bound": [5.34, 5.94],
      "25-mid": "6.39",
      "25-bound": [6.04, 6.75],
      "50-mid": "6.98",
      "50-bound": [6.57, 7.38],
      "100-mid": "7.55",
      "100-bound": [7.08, 8.0]
    }
  },
  "USC00367732 6": {
    "fips": "42071",
    "station_name": "SAFE HARBOR DAM",
    "state": "PA",
    "latitude": "39.9253",
    "longitude": "-76.3890",
    "5min": {
      "2-mid": "0.38",
      "2-bound": [0.34, 0.43],
      "5-mid": "0.45",
      "5-bound": [0.41, 0.51],
      "10-mid": "0.5",
      "10-bound": [0.45, 0.56],
      "25-mid": "0.56",
      "25-bound": [0.5, 0.63],
      "50-mid": "0.61",
      "50-bound": [0.54, 0.68],
      "100-mid": "0.65",
      "100-bound": [0.57, 0.72]
    },
    "10min": {
      "2-mid": "0.61",
      "2-bound": [0.55, 0.69],
      "5-mid": "0.73",
      "5-bound": [0.65, 0.82],
      "10-mid": "0.81",
      "10-bound": [0.72, 0.9],
      "25-mid": "0.9",
      "25-bound": [0.8, 1.0],
      "50-mid": "0.96",
      "50-bound": [0.85, 1.08],
      "100-mid": "1.03",
      "100-bound": [0.91, 1.15]
    },
    "15min": {
      "2-mid": "0.77",
      "2-bound": [0.69, 0.87],
      "5-mid": "0.92",
      "5-bound": [0.82, 1.03],
      "10-mid": "1.02",
      "10-bound": [0.91, 1.14],
      "25-mid": "1.14",
      "25-bound": [1.01, 1.27],
      "50-mid": "1.22",
      "50-bound": [1.08, 1.37],
      "100-mid": "1.3",
      "100-bound": [1.14, 1.45]
    },
    "30min": {
      "2-mid": "1.07",
      "2-bound": [0.95, 1.2],
      "5-mid": "1.31",
      "5-bound": [1.17, 1.47],
      "10-mid": "1.48",
      "10-bound": [1.32, 1.65],
      "25-mid": "1.69",
      "25-bound": [1.5, 1.89],
      "50-mid": "1.84",
      "50-bound": [1.63, 2.06],
      "100-mid": "1.99",
      "100-bound": [1.75, 2.22]
    },
    "60min": {
      "2-mid": "1.34",
      "2-bound": [1.2, 1.5],
      "5-mid": "1.67",
      "5-bound": [1.5, 1.88],
      "10-mid": "1.92",
      "10-bound": [1.71, 2.15],
      "25-mid": "2.25",
      "25-bound": [1.99, 2.51],
      "50-mid": "2.49",
      "50-bound": [2.21, 2.79],
      "100-mid": "2.74",
      "100-bound": [2.41, 3.06]
    },
    "2hr": {
      "2-mid": "1.6",
      "2-bound": [1.44, 1.79],
      "5-mid": "2.02",
      "5-bound": [1.81, 2.27],
      "10-mid": "2.36",
      "10-bound": [2.1, 2.64],
      "25-mid": "2.82",
      "25-bound": [2.51, 3.15],
      "50-mid": "3.2",
      "50-bound": [2.83, 3.56],
      "100-mid": "3.6",
      "100-bound": [3.16, 4.0]
    },
    "3hr": {
      "2-mid": "1.74",
      "2-bound": [1.56, 1.95],
      "5-mid": "2.2",
      "5-bound": [1.98, 2.46],
      "10-mid": "2.56",
      "10-bound": [2.3, 2.86],
      "25-mid": "3.07",
      "25-bound": [2.73, 3.41],
      "50-mid": "3.48",
      "50-bound": [3.08, 3.87],
      "100-mid": "3.91",
      "100-bound": [3.44, 4.35]
    },
    "6hr": {
      "2-mid": "2.14",
      "2-bound": [1.93, 2.39],
      "5-mid": "2.7",
      "5-bound": [2.43, 3.02],
      "10-mid": "3.16",
      "10-bound": [2.84, 3.53],
      "25-mid": "3.83",
      "25-bound": [3.42, 4.26],
      "50-mid": "4.39",
      "50-bound": [3.89, 4.87],
      "100-mid": "5.0",
      "100-bound": [4.39, 5.53]
    },
    "12hr": {
      "2-mid": "2.56",
      "2-bound": [2.31, 2.89],
      "5-mid": "3.26",
      "5-bound": [2.93, 3.66],
      "10-mid": "3.85",
      "10-bound": [3.44, 4.32],
      "25-mid": "4.73",
      "25-bound": [4.19, 5.28],
      "50-mid": "5.49",
      "50-bound": [4.82, 6.11],
      "100-mid": "6.33",
      "100-bound": [5.5, 7.03]
    },
    "24hr": {
      "2-mid": "2.95",
      "2-bound": [2.71, 3.25],
      "5-mid": "3.76",
      "5-bound": [3.45, 4.14],
      "10-mid": "4.47",
      "10-bound": [4.08, 4.9],
      "25-mid": "5.54",
      "25-bound": [5.0, 6.05],
      "50-mid": "6.47",
      "50-bound": [5.8, 7.04],
      "100-mid": "7.51",
      "100-bound": [6.65, 8.14]
    },
    "2day": {
      "2-mid": "3.4",
      "2-bound": [3.13, 3.74],
      "5-mid": "4.34",
      "5-bound": [3.99, 4.77],
      "10-mid": "5.14",
      "10-bound": [4.7, 5.62],
      "25-mid": "6.31",
      "25-bound": [5.73, 6.87],
      "50-mid": "7.31",
      "50-bound": [6.59, 7.94],
      "100-mid": "8.41",
      "100-bound": [7.51, 9.12]
    },
    "3day": {
      "2-mid": "3.6",
      "2-bound": [3.32, 3.93],
      "5-mid": "4.59",
      "5-bound": [4.23, 5.01],
      "10-mid": "5.43",
      "10-bound": [4.99, 5.91],
      "25-mid": "6.68",
      "25-bound": [6.09, 7.24],
      "50-mid": "7.75",
      "50-bound": [7.02, 8.39],
      "100-mid": "8.93",
      "100-bound": [8.02, 9.65]
    },
    "4day": {
      "2-mid": "3.8",
      "2-bound": [3.52, 4.12],
      "5-mid": "4.83",
      "5-bound": [4.47, 5.25],
      "10-mid": "5.72",
      "10-bound": [5.27, 6.2],
      "25-mid": "7.04",
      "25-bound": [6.45, 7.61],
      "50-mid": "8.19",
      "50-bound": [7.44, 8.83],
      "100-mid": "9.45",
      "100-bound": [8.53, 10.2]
    },
    "7day": {
      "2-mid": "4.42",
      "2-bound": [4.1, 4.79],
      "5-mid": "5.57",
      "5-bound": [5.16, 6.03],
      "10-mid": "6.54",
      "10-bound": [6.04, 7.08],
      "25-mid": "8.0",
      "25-bound": [7.35, 8.64],
      "50-mid": "9.25",
      "50-bound": [8.44, 9.98],
      "100-mid": "10.6",
      "100-bound": [9.62, 11.4]
    }
  },
  "USC00300183 6": {
    "fips": "36003",
    "station_name": "ANGELICA",
    "state": "NY",
    "latitude": "42.3100",
    "longitude": "-78.0200",
    "5min": {
      "2-mid": "0.34",
      "2-bound": [0.28, 0.41],
      "5-mid": "0.43",
      "5-bound": [0.35, 0.52],
      "10-mid": "0.51",
      "10-bound": [0.41, 0.62],
      "25-mid": "0.61",
      "25-bound": [0.48, 0.79],
      "50-mid": "0.69",
      "50-bound": [0.53, 0.91],
      "100-mid": "0.78",
      "100-bound": [0.57, 1.06]
    },
    "10min": {
      "2-mid": "0.48",
      "2-bound": [0.39, 0.58],
      "5-mid": "0.61",
      "5-bound": [0.5, 0.74],
      "10-mid": "0.72",
      "10-bound": [0.58, 0.88],
      "25-mid": "0.87",
      "25-bound": [0.68, 1.11],
      "50-mid": "0.98",
      "50-bound": [0.75, 1.29],
      "100-mid": "1.1",
      "100-bound": [0.8, 1.5]
    },
    "15min": {
      "2-mid": "0.56",
      "2-bound": [0.46, 0.68],
      "5-mid": "0.72",
      "5-bound": [0.59, 0.87],
      "10-mid": "0.84",
      "10-bound": [0.69, 1.03],
      "25-mid": "1.02",
      "25-bound": [0.8, 1.31],
      "50-mid": "1.16",
      "50-bound": [0.88, 1.52],
      "100-mid": "1.3",
      "100-bound": [0.94, 1.76]
    },
    "30min": {
      "2-mid": "0.77",
      "2-bound": [0.64, 0.94],
      "5-mid": "0.98",
      "5-bound": [0.81, 1.2],
      "10-mid": "1.16",
      "10-bound": [0.94, 1.41],
      "25-mid": "1.39",
      "25-bound": [1.09, 1.78],
      "50-mid": "1.57",
      "50-bound": [1.19, 2.06],
      "100-mid": "1.76",
      "100-bound": [1.28, 2.4]
    },
    "60min": {
      "2-mid": "0.99",
      "2-bound": [0.81, 1.2],
      "5-mid": "1.25",
      "5-bound": [1.02, 1.52],
      "10-mid": "1.46",
      "10-bound": [1.19, 1.79],
      "25-mid": "1.76",
      "25-bound": [1.38, 2.26],
      "50-mid": "1.99",
      "50-bound": [1.51, 2.61],
      "100-mid": "2.22",
      "100-bound": [1.62, 3.03]
    },
    "2hr": {
      "2-mid": "1.21",
      "2-bound": [1.0, 1.46],
      "5-mid": "1.56",
      "5-bound": [1.28, 1.88],
      "10-mid": "1.84",
      "10-bound": [1.51, 2.24],
      "25-mid": "2.23",
      "25-bound": [1.75, 2.84],
      "50-mid": "2.53",
      "50-bound": [1.93, 3.29],
      "100-mid": "2.84",
      "100-bound": [2.08, 3.84]
    },
    "3hr": {
      "2-mid": "1.35",
      "2-bound": [1.12, 1.62],
      "5-mid": "1.75",
      "5-bound": [1.45, 2.1],
      "10-mid": "2.08",
      "10-bound": [1.7, 2.51],
      "25-mid": "2.53",
      "25-bound": [1.99, 3.21],
      "50-mid": "2.87",
      "50-bound": [2.19, 3.72],
      "100-mid": "3.22",
      "100-bound": [2.37, 4.34]
    },
    "6hr": {
      "2-mid": "1.63",
      "2-bound": [1.37, 1.95],
      "5-mid": "2.11",
      "5-bound": [1.76, 2.52],
      "10-mid": "2.5",
      "10-bound": [2.07, 3.01],
      "25-mid": "3.04",
      "25-bound": [2.41, 3.85],
      "50-mid": "3.44",
      "50-bound": [2.66, 4.47],
      "100-mid": "3.87",
      "100-bound": [2.89, 5.26]
    },
    "12hr": {
      "2-mid": "1.97",
      "2-bound": [1.66, 2.33],
      "5-mid": "2.5",
      "5-bound": [2.1, 2.98],
      "10-mid": "2.95",
      "10-bound": [2.46, 3.53],
      "25-mid": "3.57",
      "25-bound": [2.86, 4.52],
      "50-mid": "4.01",
      "50-bound": [3.15, 5.24],
      "100-mid": "4.51",
      "100-bound": [3.45, 6.21]
    },
    "24hr": {
      "2-mid": "2.32",
      "2-bound": [1.96, 2.72],
      "5-mid": "2.95",
      "5-bound": [2.49, 3.48],
      "10-mid": "3.47",
      "10-bound": [2.91, 4.12],
      "25-mid": "4.19",
      "25-bound": [3.39, 5.3],
      "50-mid": "4.71",
      "50-bound": [3.73, 6.13],
      "100-mid": "5.3",
      "100-bound": [4.1, 7.3]
    },
    "2day": {
      "2-mid": "2.68",
      "2-bound": [2.29, 3.13],
      "5-mid": "3.45",
      "5-bound": [2.93, 4.04],
      "10-mid": "4.09",
      "10-bound": [3.44, 4.82],
      "25-mid": "4.97",
      "25-bound": [4.03, 6.21],
      "50-mid": "5.6",
      "50-bound": [4.44, 7.2],
      "100-mid": "6.32",
      "100-bound": [4.87, 8.56]
    },
    "3day": {
      "2-mid": "2.95",
      "2-bound": [2.52, 3.43],
      "5-mid": "3.79",
      "5-bound": [3.23, 4.42],
      "10-mid": "4.48",
      "10-bound": [3.79, 5.27],
      "25-mid": "5.44",
      "25-bound": [4.43, 6.76],
      "50-mid": "6.14",
      "50-bound": [4.88, 7.84],
      "100-mid": "6.92",
      "100-bound": [5.32, 9.28]
    },
    "4day": {
      "2-mid": "3.18",
      "2-bound": [2.73, 3.68],
      "5-mid": "4.06",
      "5-bound": [3.47, 4.72],
      "10-mid": "4.79",
      "10-bound": [4.06, 5.61],
      "25-mid": "5.8",
      "25-bound": [4.72, 7.16],
      "50-mid": "6.53",
      "50-bound": [5.19, 8.29],
      "100-mid": "7.35",
      "100-bound": [5.64, 9.78]
    },
    "7day": {
      "2-mid": "3.78",
      "2-bound": [3.26, 4.36],
      "5-mid": "4.73",
      "5-bound": [4.06, 5.48],
      "10-mid": "5.52",
      "10-bound": [4.71, 6.43],
      "25-mid": "6.61",
      "25-bound": [5.4, 8.09],
      "50-mid": "7.42",
      "50-bound": [5.9, 9.3],
      "100-mid": "8.29",
      "100-bound": [6.35, 10.9]
    }
  },
  "USC00305751 6": {
    "fips": "36065",
    "station_name": "NEW LONDON LOCK NO 22",
    "state": "NY",
    "latitude": "43.2090",
    "longitude": "-75.6450",
    "5min": {
      "2-mid": "0.35",
      "2-bound": [0.28, 0.42],
      "5-mid": "0.44",
      "5-bound": [0.35, 0.53],
      "10-mid": "0.51",
      "10-bound": [0.41, 0.62],
      "25-mid": "0.61",
      "25-bound": [0.48, 0.77],
      "50-mid": "0.69",
      "50-bound": [0.53, 0.88],
      "100-mid": "0.77",
      "100-bound": [0.57, 1.0]
    },
    "10min": {
      "2-mid": "0.49",
      "2-bound": [0.4, 0.6],
      "5-mid": "0.62",
      "5-bound": [0.5, 0.75],
      "10-mid": "0.72",
      "10-bound": [0.58, 0.88],
      "25-mid": "0.86",
      "25-bound": [0.68, 1.09],
      "50-mid": "0.97",
      "50-bound": [0.74, 1.24],
      "100-mid": "1.09",
      "100-bound": [0.8, 1.42]
    },
    "15min": {
      "2-mid": "0.58",
      "2-bound": [0.47, 0.7],
      "5-mid": "0.73",
      "5-bound": [0.59, 0.89],
      "10-mid": "0.85",
      "10-bound": [0.69, 1.04],
      "25-mid": "1.02",
      "25-bound": [0.79, 1.28],
      "50-mid": "1.15",
      "50-bound": [0.88, 1.46],
      "100-mid": "1.28",
      "100-bound": [0.94, 1.67]
    },
    "30min": {
      "2-mid": "0.79",
      "2-bound": [0.65, 0.97],
      "5-mid": "1.0",
      "5-bound": [0.81, 1.22],
      "10-mid": "1.17",
      "10-bound": [0.94, 1.43],
      "25-mid": "1.4",
      "25-bound": [1.09, 1.76],
      "50-mid": "1.58",
      "50-bound": [1.2, 2.01],
      "100-mid": "1.76",
      "100-bound": [1.3, 2.29]
    },
    "60min": {
      "2-mid": "1.01",
      "2-bound": [0.82, 1.23],
      "5-mid": "1.27",
      "5-bound": [1.03, 1.55],
      "10-mid": "1.48",
      "10-bound": [1.2, 1.82],
      "25-mid": "1.78",
      "25-bound": [1.39, 2.24],
      "50-mid": "2.0",
      "50-bound": [1.53, 2.56],
      "100-mid": "2.24",
      "100-bound": [1.65, 2.92]
    },
    "2hr": {
      "2-mid": "1.29",
      "2-bound": [1.06, 1.56],
      "5-mid": "1.61",
      "5-bound": [1.31, 1.95],
      "10-mid": "1.87",
      "10-bound": [1.52, 2.28],
      "25-mid": "2.24",
      "25-bound": [1.76, 2.8],
      "50-mid": "2.52",
      "50-bound": [1.94, 3.19],
      "100-mid": "2.8",
      "100-bound": [2.09, 3.64]
    },
    "3hr": {
      "2-mid": "1.47",
      "2-bound": [1.21, 1.77],
      "5-mid": "1.83",
      "5-bound": [1.5, 2.21],
      "10-mid": "2.12",
      "10-bound": [1.73, 2.58],
      "25-mid": "2.54",
      "25-bound": [2.0, 3.17],
      "50-mid": "2.85",
      "50-bound": [2.2, 3.6],
      "100-mid": "3.17",
      "100-bound": [2.38, 4.11]
    },
    "6hr": {
      "2-mid": "1.8",
      "2-bound": [1.5, 2.16],
      "5-mid": "2.24",
      "5-bound": [1.85, 2.69],
      "10-mid": "2.61",
      "10-bound": [2.14, 3.14],
      "25-mid": "3.11",
      "25-bound": [2.47, 3.85],
      "50-mid": "3.48",
      "50-bound": [2.72, 4.38],
      "100-mid": "3.88",
      "100-bound": [2.93, 5.0]
    },
    "12hr": {
      "2-mid": "2.18",
      "2-bound": [1.82, 2.59],
      "5-mid": "2.7",
      "5-bound": [2.25, 3.22],
      "10-mid": "3.14",
      "10-bound": [2.6, 3.76],
      "25-mid": "3.74",
      "25-bound": [3.0, 4.6],
      "50-mid": "4.19",
      "50-bound": [3.29, 5.23],
      "100-mid": "4.66",
      "100-bound": [3.55, 5.97]
    },
    "24hr": {
      "2-mid": "2.56",
      "2-bound": [2.15, 3.03],
      "5-mid": "3.16",
      "5-bound": [2.64, 3.74],
      "10-mid": "3.65",
      "10-bound": [3.04, 4.34],
      "25-mid": "4.33",
      "25-bound": [3.49, 5.29],
      "50-mid": "4.84",
      "50-bound": [3.83, 6.0],
      "100-mid": "5.38",
      "100-bound": [4.12, 6.82]
    },
    "2day": {
      "2-mid": "2.97",
      "2-bound": [2.51, 3.49],
      "5-mid": "3.6",
      "5-bound": [3.03, 4.24],
      "10-mid": "4.12",
      "10-bound": [3.46, 4.87],
      "25-mid": "4.84",
      "25-bound": [3.93, 5.87],
      "50-mid": "5.39",
      "50-bound": [4.28, 6.62],
      "100-mid": "5.95",
      "100-bound": [4.58, 7.47]
    },
    "3day": {
      "2-mid": "3.26",
      "2-bound": [2.77, 3.82],
      "5-mid": "3.92",
      "5-bound": [3.31, 4.59],
      "10-mid": "4.46",
      "10-bound": [3.75, 5.24],
      "25-mid": "5.2",
      "25-bound": [4.24, 6.27],
      "50-mid": "5.77",
      "50-bound": [4.6, 7.04],
      "100-mid": "6.35",
      "100-bound": [4.9, 7.92]
    },
    "4day": {
      "2-mid": "3.52",
      "2-bound": [2.99, 4.1],
      "5-mid": "4.18",
      "5-bound": [3.55, 4.89],
      "10-mid": "4.74",
      "10-bound": [4.0, 5.56],
      "25-mid": "5.5",
      "25-bound": [4.49, 6.61],
      "50-mid": "6.09",
      "50-bound": [4.86, 7.4],
      "100-mid": "6.68",
      "100-bound": [5.17, 8.28]
    },
    "7day": {
      "2-mid": "4.18",
      "2-bound": [3.58, 4.85],
      "5-mid": "4.88",
      "5-bound": [4.17, 5.68],
      "10-mid": "5.46",
      "10-bound": [4.64, 6.37],
      "25-mid": "6.26",
      "25-bound": [5.14, 7.47],
      "50-mid": "6.89",
      "50-bound": [5.53, 8.3],
      "100-mid": "7.5",
      "100-bound": [5.82, 9.21]
    }
  },
  "USC00445096 6": {
    "fips": "51139",
    "station_name": "LURAY 5 E",
    "state": "VA",
    "latitude": "38.6660",
    "longitude": "-78.3720",
    "5min": {
      "2-mid": "0.4",
      "2-bound": [0.36, 0.44],
      "5-mid": "0.48",
      "5-bound": [0.43, 0.53],
      "10-mid": "0.54",
      "10-bound": [0.49, 0.6],
      "25-mid": "0.62",
      "25-bound": [0.56, 0.69],
      "50-mid": "0.69",
      "50-bound": [0.61, 0.76],
      "100-mid": "0.75",
      "100-bound": [0.66, 0.83]
    },
    "10min": {
      "2-mid": "0.62",
      "2-bound": [0.56, 0.69],
      "5-mid": "0.75",
      "5-bound": [0.67, 0.83],
      "10-mid": "0.84",
      "10-bound": [0.76, 0.94],
      "25-mid": "0.97",
      "25-bound": [0.86, 1.07],
      "50-mid": "1.06",
      "50-bound": [0.94, 1.17],
      "100-mid": "1.16",
      "100-bound": [1.02, 1.27]
    },
    "15min": {
      "2-mid": "0.77",
      "2-bound": [0.69, 0.85],
      "5-mid": "0.93",
      "5-bound": [0.84, 1.03],
      "10-mid": "1.05",
      "10-bound": [0.94, 1.16],
      "25-mid": "1.2",
      "25-bound": [1.07, 1.33],
      "50-mid": "1.32",
      "50-bound": [1.17, 1.46],
      "100-mid": "1.44",
      "100-bound": [1.27, 1.59]
    },
    "30min": {
      "2-mid": "1.04",
      "2-bound": [0.94, 1.15],
      "5-mid": "1.29",
      "5-bound": [1.16, 1.43],
      "10-mid": "1.48",
      "10-bound": [1.32, 1.64],
      "25-mid": "1.73",
      "25-bound": [1.54, 1.9],
      "50-mid": "1.92",
      "50-bound": [1.7, 2.12],
      "100-mid": "2.12",
      "100-bound": [1.87, 2.33]
    },
    "60min": {
      "2-mid": "1.28",
      "2-bound": [1.16, 1.43],
      "5-mid": "1.63",
      "5-bound": [1.46, 1.81],
      "10-mid": "1.9",
      "10-bound": [1.7, 2.1],
      "25-mid": "2.26",
      "25-bound": [2.01, 2.49],
      "50-mid": "2.56",
      "50-bound": [2.26, 2.82],
      "100-mid": "2.86",
      "100-bound": [2.52, 3.15]
    },
    "2hr": {
      "2-mid": "1.52",
      "2-bound": [1.37, 1.69],
      "5-mid": "1.94",
      "5-bound": [1.74, 2.16],
      "10-mid": "2.28",
      "10-bound": [2.04, 2.53],
      "25-mid": "2.76",
      "25-bound": [2.46, 3.06],
      "50-mid": "3.16",
      "50-bound": [2.8, 3.5],
      "100-mid": "3.6",
      "100-bound": [3.16, 3.98]
    },
    "3hr": {
      "2-mid": "1.64",
      "2-bound": [1.47, 1.84],
      "5-mid": "2.08",
      "5-bound": [1.86, 2.33],
      "10-mid": "2.44",
      "10-bound": [2.18, 2.72],
      "25-mid": "2.96",
      "25-bound": [2.62, 3.29],
      "50-mid": "3.4",
      "50-bound": [2.99, 3.77],
      "100-mid": "3.87",
      "100-bound": [3.38, 4.29]
    },
    "6hr": {
      "2-mid": "2.04",
      "2-bound": [1.84, 2.28],
      "5-mid": "2.56",
      "5-bound": [2.3, 2.87],
      "10-mid": "3.0",
      "10-bound": [2.68, 3.36],
      "25-mid": "3.64",
      "25-bound": [3.23, 4.06],
      "50-mid": "4.18",
      "50-bound": [3.69, 4.66],
      "100-mid": "4.78",
      "100-bound": [4.18, 5.32]
    },
    "12hr": {
      "2-mid": "2.52",
      "2-bound": [2.26, 2.83],
      "5-mid": "3.17",
      "5-bound": [2.84, 3.55],
      "10-mid": "3.72",
      "10-bound": [3.32, 4.16],
      "25-mid": "4.54",
      "25-bound": [4.02, 5.07],
      "50-mid": "5.25",
      "50-bound": [4.61, 5.86],
      "100-mid": "6.06",
      "100-bound": [5.25, 6.75]
    },
    "24hr": {
      "2-mid": "3.15",
      "2-bound": [2.84, 3.52],
      "5-mid": "3.99",
      "5-bound": [3.6, 4.46],
      "10-mid": "4.69",
      "10-bound": [4.21, 5.24],
      "25-mid": "5.71",
      "25-bound": [5.1, 6.36],
      "50-mid": "6.57",
      "50-bound": [5.84, 7.32],
      "100-mid": "7.5",
      "100-bound": [6.61, 8.36]
    },
    "2day": {
      "2-mid": "3.67",
      "2-bound": [3.33, 4.04],
      "5-mid": "4.63",
      "5-bound": [4.2, 5.11],
      "10-mid": "5.42",
      "10-bound": [4.9, 5.97],
      "25-mid": "6.55",
      "25-bound": [5.88, 7.22],
      "50-mid": "7.5",
      "50-bound": [6.7, 8.24],
      "100-mid": "8.51",
      "100-bound": [7.55, 9.35]
    },
    "3day": {
      "2-mid": "3.92",
      "2-bound": [3.56, 4.33],
      "5-mid": "4.94",
      "5-bound": [4.48, 5.46],
      "10-mid": "5.76",
      "10-bound": [5.21, 6.37],
      "25-mid": "6.96",
      "25-bound": [6.26, 7.69],
      "50-mid": "7.94",
      "50-bound": [7.1, 8.76],
      "100-mid": "9.0",
      "100-bound": [7.99, 9.93]
    },
    "4day": {
      "2-mid": "4.17",
      "2-bound": [3.79, 4.62],
      "5-mid": "5.24",
      "5-bound": [4.76, 5.82],
      "10-mid": "6.11",
      "10-bound": [5.53, 6.77],
      "25-mid": "7.36",
      "25-bound": [6.63, 8.15],
      "50-mid": "8.39",
      "50-bound": [7.52, 9.28],
      "100-mid": "9.49",
      "100-bound": [8.44, 10.5]
    },
    "7day": {
      "2-mid": "4.82",
      "2-bound": [4.39, 5.36],
      "5-mid": "6.0",
      "5-bound": [5.44, 6.66],
      "10-mid": "6.94",
      "10-bound": [6.29, 7.72],
      "25-mid": "8.25",
      "25-bound": [7.43, 9.16],
      "50-mid": "9.32",
      "50-bound": [8.35, 10.4],
      "100-mid": "10.4",
      "100-bound": [9.3, 11.6]
    }
  },
  "USC00440327 6": {
    "fips": "51085",
    "station_name": "ASHLAND",
    "state": "VA",
    "latitude": "37.7000",
    "longitude": "-77.4830",
    "5min": {
      "2-mid": "0.44",
      "2-bound": [0.39, 0.48],
      "5-mid": "0.51",
      "5-bound": [0.46, 0.56],
      "10-mid": "0.57",
      "10-bound": [0.52, 0.64],
      "25-mid": "0.64",
      "25-bound": [0.58, 0.71],
      "50-mid": "0.7",
      "50-bound": [0.62, 0.77],
      "100-mid": "0.75",
      "100-bound": [0.67, 0.83]
    },
    "10min": {
      "2-mid": "0.7",
      "2-bound": [0.63, 0.77],
      "5-mid": "0.82",
      "5-bound": [0.74, 0.9],
      "10-mid": "0.92",
      "10-bound": [0.82, 1.02],
      "25-mid": "1.03",
      "25-bound": [0.92, 1.13],
      "50-mid": "1.11",
      "50-bound": [0.99, 1.23],
      "100-mid": "1.19",
      "100-bound": [1.06, 1.31]
    },
    "15min": {
      "2-mid": "0.88",
      "2-bound": [0.79, 0.97],
      "5-mid": "1.03",
      "5-bound": [0.93, 1.14],
      "10-mid": "1.16",
      "10-bound": [1.04, 1.28],
      "25-mid": "1.3",
      "25-bound": [1.17, 1.44],
      "50-mid": "1.41",
      "50-bound": [1.26, 1.56],
      "100-mid": "1.5",
      "100-bound": [1.34, 1.66]
    },
    "30min": {
      "2-mid": "1.21",
      "2-bound": [1.1, 1.34],
      "5-mid": "1.47",
      "5-bound": [1.32, 1.63],
      "10-mid": "1.68",
      "10-bound": [1.51, 1.86],
      "25-mid": "1.93",
      "25-bound": [1.73, 2.13],
      "50-mid": "2.12",
      "50-bound": [1.89, 2.34],
      "100-mid": "2.3",
      "100-bound": [2.05, 2.54]
    },
    "60min": {
      "2-mid": "1.52",
      "2-bound": [1.37, 1.69],
      "5-mid": "1.88",
      "5-bound": [1.7, 2.08],
      "10-mid": "2.19",
      "10-bound": [1.97, 2.42],
      "25-mid": "2.57",
      "25-bound": [2.3, 2.84],
      "50-mid": "2.88",
      "50-bound": [2.57, 3.17],
      "100-mid": "3.18",
      "100-bound": [2.82, 3.5]
    },
    "2hr": {
      "2-mid": "1.82",
      "2-bound": [1.63, 2.03],
      "5-mid": "2.26",
      "5-bound": [2.03, 2.53],
      "10-mid": "2.66",
      "10-bound": [2.38, 2.97],
      "25-mid": "3.17",
      "25-bound": [2.82, 3.53],
      "50-mid": "3.59",
      "50-bound": [3.18, 4.0],
      "100-mid": "4.02",
      "100-bound": [3.54, 4.47]
    },
    "3hr": {
      "2-mid": "1.96",
      "2-bound": [1.75, 2.21],
      "5-mid": "2.45",
      "5-bound": [2.18, 2.76],
      "10-mid": "2.88",
      "10-bound": [2.56, 3.24],
      "25-mid": "3.44",
      "25-bound": [3.04, 3.85],
      "50-mid": "3.91",
      "50-bound": [3.43, 4.37],
      "100-mid": "4.38",
      "100-bound": [3.82, 4.9]
    },
    "6hr": {
      "2-mid": "2.38",
      "2-bound": [2.11, 2.7],
      "5-mid": "2.96",
      "5-bound": [2.62, 3.36],
      "10-mid": "3.5",
      "10-bound": [3.08, 3.96],
      "25-mid": "4.21",
      "25-bound": [3.69, 4.76],
      "50-mid": "4.83",
      "50-bound": [4.2, 5.45],
      "100-mid": "5.47",
      "100-bound": [4.72, 6.18]
    },
    "12hr": {
      "2-mid": "2.85",
      "2-bound": [2.54, 3.25],
      "5-mid": "3.57",
      "5-bound": [3.17, 4.07],
      "10-mid": "4.25",
      "10-bound": [3.76, 4.83],
      "25-mid": "5.19",
      "25-bound": [4.54, 5.87],
      "50-mid": "6.02",
      "50-bound": [5.21, 6.8],
      "100-mid": "6.91",
      "100-bound": [5.92, 7.78]
    },
    "24hr": {
      "2-mid": "3.29",
      "2-bound": [3.04, 3.6],
      "5-mid": "4.22",
      "5-bound": [3.88, 4.61],
      "10-mid": "5.02",
      "10-bound": [4.6, 5.48],
      "25-mid": "6.24",
      "25-bound": [5.67, 6.79],
      "50-mid": "7.3",
      "50-bound": [6.58, 7.91],
      "100-mid": "8.48",
      "100-bound": [7.58, 9.18]
    },
    "2day": {
      "2-mid": "3.84",
      "2-bound": [3.56, 4.19],
      "5-mid": "4.91",
      "5-bound": [4.53, 5.35],
      "10-mid": "5.81",
      "10-bound": [5.35, 6.33],
      "25-mid": "7.14",
      "25-bound": [6.53, 7.77],
      "50-mid": "8.29",
      "50-bound": [7.52, 9.01],
      "100-mid": "9.54",
      "100-bound": [8.6, 10.4]
    },
    "3day": {
      "2-mid": "4.07",
      "2-bound": [3.76, 4.42],
      "5-mid": "5.19",
      "5-bound": [4.79, 5.64],
      "10-mid": "6.14",
      "10-bound": [5.66, 6.65],
      "25-mid": "7.54",
      "25-bound": [6.9, 8.16],
      "50-mid": "8.73",
      "50-bound": [7.94, 9.46],
      "100-mid": "10.0",
      "100-bound": [9.08, 10.9]
    },
    "4day": {
      "2-mid": "4.29",
      "2-bound": [3.98, 4.64],
      "5-mid": "5.47",
      "5-bound": [5.06, 5.92],
      "10-mid": "6.46",
      "10-bound": [5.96, 6.98],
      "25-mid": "7.93",
      "25-bound": [7.28, 8.56],
      "50-mid": "9.17",
      "50-bound": [8.37, 9.9],
      "100-mid": "10.5",
      "100-bound": [9.56, 11.4]
    },
    "7day": {
      "2-mid": "4.92",
      "2-bound": [4.58, 5.31],
      "5-mid": "6.19",
      "5-bound": [5.75, 6.67],
      "10-mid": "7.25",
      "10-bound": [6.73, 7.81],
      "25-mid": "8.81",
      "25-bound": [8.13, 9.48],
      "50-mid": "10.1",
      "50-bound": [9.29, 10.9],
      "100-mid": "11.6",
      "100-bound": [10.5, 12.4]
    }
  },
  "USC00449186 6": {
    "fips": "51069",
    "station_name": "WINCHESTER 7 SE",
    "state": "VA",
    "latitude": "39.1830",
    "longitude": "-78.1160",
    "5min": {
      "2-mid": "0.39",
      "2-bound": [0.35, 0.44],
      "5-mid": "0.47",
      "5-bound": [0.42, 0.53],
      "10-mid": "0.54",
      "10-bound": [0.48, 0.6],
      "25-mid": "0.63",
      "25-bound": [0.56, 0.7],
      "50-mid": "0.7",
      "50-bound": [0.62, 0.78],
      "100-mid": "0.77",
      "100-bound": [0.68, 0.85]
    },
    "10min": {
      "2-mid": "0.61",
      "2-bound": [0.55, 0.69],
      "5-mid": "0.74",
      "5-bound": [0.66, 0.83],
      "10-mid": "0.84",
      "10-bound": [0.74, 0.94],
      "25-mid": "0.97",
      "25-bound": [0.85, 1.07],
      "50-mid": "1.07",
      "50-bound": [0.94, 1.18],
      "100-mid": "1.17",
      "100-bound": [1.02, 1.29]
    },
    "15min": {
      "2-mid": "0.75",
      "2-bound": [0.67, 0.84],
      "5-mid": "0.91",
      "5-bound": [0.81, 1.02],
      "10-mid": "1.04",
      "10-bound": [0.92, 1.16],
      "25-mid": "1.2",
      "25-bound": [1.06, 1.33],
      "50-mid": "1.32",
      "50-bound": [1.17, 1.47],
      "100-mid": "1.46",
      "100-bound": [1.28, 1.61]
    },
    "30min": {
      "2-mid": "1.01",
      "2-bound": [0.9, 1.13],
      "5-mid": "1.26",
      "5-bound": [1.12, 1.4],
      "10-mid": "1.44",
      "10-bound": [1.28, 1.61],
      "25-mid": "1.7",
      "25-bound": [1.5, 1.89],
      "50-mid": "1.91",
      "50-bound": [1.68, 2.11],
      "100-mid": "2.12",
      "100-bound": [1.85, 2.34]
    },
    "60min": {
      "2-mid": "1.24",
      "2-bound": [1.11, 1.39],
      "5-mid": "1.58",
      "5-bound": [1.41, 1.76],
      "10-mid": "1.84",
      "10-bound": [1.64, 2.06],
      "25-mid": "2.21",
      "25-bound": [1.96, 2.46],
      "50-mid": "2.52",
      "50-bound": [2.22, 2.79],
      "100-mid": "2.84",
      "100-bound": [2.49, 3.14]
    },
    "2hr": {
      "2-mid": "1.47",
      "2-bound": [1.32, 1.65],
      "5-mid": "1.88",
      "5-bound": [1.68, 2.11],
      "10-mid": "2.22",
      "10-bound": [1.97, 2.47],
      "25-mid": "2.7",
      "25-bound": [2.39, 3.0],
      "50-mid": "3.1",
      "50-bound": [2.73, 3.44],
      "100-mid": "3.54",
      "100-bound": [3.1, 3.91]
    },
    "3hr": {
      "2-mid": "1.59",
      "2-bound": [1.42, 1.78],
      "5-mid": "2.02",
      "5-bound": [1.8, 2.25],
      "10-mid": "2.36",
      "10-bound": [2.11, 2.64],
      "25-mid": "2.87",
      "25-bound": [2.55, 3.19],
      "50-mid": "3.3",
      "50-bound": [2.91, 3.66],
      "100-mid": "3.77",
      "100-bound": [3.3, 4.17]
    },
    "6hr": {
      "2-mid": "1.97",
      "2-bound": [1.78, 2.2],
      "5-mid": "2.48",
      "5-bound": [2.23, 2.76],
      "10-mid": "2.89",
      "10-bound": [2.59, 3.21],
      "25-mid": "3.5",
      "25-bound": [3.12, 3.88],
      "50-mid": "4.02",
      "50-bound": [3.56, 4.44],
      "100-mid": "4.58",
      "100-bound": [4.03, 5.04]
    },
    "12hr": {
      "2-mid": "2.41",
      "2-bound": [2.18, 2.69],
      "5-mid": "3.02",
      "5-bound": [2.72, 3.35],
      "10-mid": "3.52",
      "10-bound": [3.16, 3.9],
      "25-mid": "4.28",
      "25-bound": [3.82, 4.72],
      "50-mid": "4.93",
      "50-bound": [4.36, 5.42],
      "100-mid": "5.66",
      "100-bound": [4.96, 6.2]
    },
    "24hr": {
      "2-mid": "2.86",
      "2-bound": [2.66, 3.1],
      "5-mid": "3.57",
      "5-bound": [3.31, 3.86],
      "10-mid": "4.16",
      "10-bound": [3.84, 4.48],
      "25-mid": "5.02",
      "25-bound": [4.62, 5.39],
      "50-mid": "5.74",
      "50-bound": [5.25, 6.16],
      "100-mid": "6.52",
      "100-bound": [5.92, 6.99]
    },
    "2day": {
      "2-mid": "3.3",
      "2-bound": [3.07, 3.57],
      "5-mid": "4.12",
      "5-bound": [3.82, 4.45],
      "10-mid": "4.8",
      "10-bound": [4.44, 5.18],
      "25-mid": "5.79",
      "25-bound": [5.32, 6.23],
      "50-mid": "6.63",
      "50-bound": [6.05, 7.12],
      "100-mid": "7.54",
      "100-bound": [6.83, 8.09]
    },
    "3day": {
      "2-mid": "3.52",
      "2-bound": [3.28, 3.8],
      "5-mid": "4.38",
      "5-bound": [4.08, 4.73],
      "10-mid": "5.1",
      "10-bound": [4.73, 5.49],
      "25-mid": "6.13",
      "25-bound": [5.66, 6.6],
      "50-mid": "7.0",
      "50-bound": [6.42, 7.52],
      "100-mid": "7.93",
      "100-bound": [7.22, 8.52]
    },
    "4day": {
      "2-mid": "3.74",
      "2-bound": [3.49, 4.04],
      "5-mid": "4.65",
      "5-bound": [4.33, 5.01],
      "10-mid": "5.4",
      "10-bound": [5.02, 5.81],
      "25-mid": "6.47",
      "25-bound": [5.99, 6.96],
      "50-mid": "7.37",
      "50-bound": [6.78, 7.92],
      "100-mid": "8.32",
      "100-bound": [7.61, 8.95]
    },
    "7day": {
      "2-mid": "4.34",
      "2-bound": [4.06, 4.66],
      "5-mid": "5.33",
      "5-bound": [4.97, 5.72],
      "10-mid": "6.12",
      "10-bound": [5.7, 6.56],
      "25-mid": "7.22",
      "25-bound": [6.7, 7.75],
      "50-mid": "8.12",
      "50-bound": [7.5, 8.71],
      "100-mid": "9.05",
      "100-bound": [8.31, 9.72]
    }
  },
  "USC00448169 6": {
    "fips": "51141",
    "station_name": "STUART",
    "state": "VA",
    "latitude": "36.6360",
    "longitude": "-80.2540",
    "5min": {
      "2-mid": "0.46",
      "2-bound": [0.42, 0.5],
      "5-mid": "0.54",
      "5-bound": [0.5, 0.59],
      "10-mid": "0.6",
      "10-bound": [0.55, 0.66],
      "25-mid": "0.68",
      "25-bound": [0.62, 0.74],
      "50-mid": "0.73",
      "50-bound": [0.66, 0.8],
      "100-mid": "0.78",
      "100-bound": [0.7, 0.86]
    },
    "10min": {
      "2-mid": "0.73",
      "2-bound": [0.68, 0.8],
      "5-mid": "0.87",
      "5-bound": [0.8, 0.95],
      "10-mid": "0.96",
      "10-bound": [0.88, 1.05],
      "25-mid": "1.08",
      "25-bound": [0.98, 1.18],
      "50-mid": "1.16",
      "50-bound": [1.05, 1.27],
      "100-mid": "1.24",
      "100-bound": [1.12, 1.36]
    },
    "15min": {
      "2-mid": "0.92",
      "2-bound": [0.85, 1.01],
      "5-mid": "1.1",
      "5-bound": [1.01, 1.2],
      "10-mid": "1.22",
      "10-bound": [1.12, 1.33],
      "25-mid": "1.37",
      "25-bound": [1.25, 1.49],
      "50-mid": "1.47",
      "50-bound": [1.33, 1.61],
      "100-mid": "1.57",
      "100-bound": [1.41, 1.72]
    },
    "30min": {
      "2-mid": "1.27",
      "2-bound": [1.17, 1.39],
      "5-mid": "1.56",
      "5-bound": [1.44, 1.71],
      "10-mid": "1.77",
      "10-bound": [1.62, 1.93],
      "25-mid": "2.03",
      "25-bound": [1.85, 2.21],
      "50-mid": "2.22",
      "50-bound": [2.01, 2.43],
      "100-mid": "2.41",
      "100-bound": [2.16, 2.64]
    },
    "60min": {
      "2-mid": "1.6",
      "2-bound": [1.47, 1.75],
      "5-mid": "2.0",
      "5-bound": [1.84, 2.19],
      "10-mid": "2.3",
      "10-bound": [2.11, 2.51],
      "25-mid": "2.7",
      "25-bound": [2.46, 2.95],
      "50-mid": "3.01",
      "50-bound": [2.72, 3.29],
      "100-mid": "3.32",
      "100-bound": [2.97, 3.64]
    },
    "2hr": {
      "2-mid": "1.98",
      "2-bound": [1.81, 2.17],
      "5-mid": "2.51",
      "5-bound": [2.29, 2.74],
      "10-mid": "2.9",
      "10-bound": [2.64, 3.18],
      "25-mid": "3.45",
      "25-bound": [3.12, 3.78],
      "50-mid": "3.89",
      "50-bound": [3.5, 4.26],
      "100-mid": "4.35",
      "100-bound": [3.87, 4.77]
    },
    "3hr": {
      "2-mid": "2.18",
      "2-bound": [2.0, 2.39],
      "5-mid": "2.75",
      "5-bound": [2.52, 3.01],
      "10-mid": "3.19",
      "10-bound": [2.91, 3.5],
      "25-mid": "3.8",
      "25-bound": [3.44, 4.16],
      "50-mid": "4.28",
      "50-bound": [3.85, 4.7],
      "100-mid": "4.79",
      "100-bound": [4.27, 5.27]
    },
    "6hr": {
      "2-mid": "2.74",
      "2-bound": [2.52, 3.0],
      "5-mid": "3.45",
      "5-bound": [3.17, 3.78],
      "10-mid": "4.02",
      "10-bound": [3.67, 4.4],
      "25-mid": "4.82",
      "25-bound": [4.37, 5.28],
      "50-mid": "5.48",
      "50-bound": [4.92, 6.0],
      "100-mid": "6.18",
      "100-bound": [5.49, 6.78]
    },
    "12hr": {
      "2-mid": "3.44",
      "2-bound": [3.16, 3.76],
      "5-mid": "4.35",
      "5-bound": [3.99, 4.76],
      "10-mid": "5.1",
      "10-bound": [4.64, 5.56],
      "25-mid": "6.16",
      "25-bound": [5.56, 6.71],
      "50-mid": "7.05",
      "50-bound": [6.31, 7.68],
      "100-mid": "8.03",
      "100-bound": [7.1, 8.76]
    },
    "24hr": {
      "2-mid": "3.93",
      "2-bound": [3.63, 4.28],
      "5-mid": "5.02",
      "5-bound": [4.64, 5.47],
      "10-mid": "5.94",
      "10-bound": [5.47, 6.45],
      "25-mid": "7.3",
      "25-bound": [6.68, 7.9],
      "50-mid": "8.47",
      "50-bound": [7.69, 9.15],
      "100-mid": "9.75",
      "100-bound": [8.78, 10.5]
    },
    "2day": {
      "2-mid": "4.67",
      "2-bound": [4.32, 5.06],
      "5-mid": "5.94",
      "5-bound": [5.49, 6.42],
      "10-mid": "6.98",
      "10-bound": [6.43, 7.54],
      "25-mid": "8.49",
      "25-bound": [7.78, 9.17],
      "50-mid": "9.75",
      "50-bound": [8.89, 10.5],
      "100-mid": "11.1",
      "100-bound": [10.1, 12.0]
    },
    "3day": {
      "2-mid": "4.94",
      "2-bound": [4.58, 5.33],
      "5-mid": "6.27",
      "5-bound": [5.8, 6.77],
      "10-mid": "7.37",
      "10-bound": [6.8, 7.94],
      "25-mid": "8.95",
      "25-bound": [8.22, 9.64],
      "50-mid": "10.3",
      "50-bound": [9.39, 11.1],
      "100-mid": "11.7",
      "100-bound": [10.6, 12.6]
    },
    "4day": {
      "2-mid": "5.2",
      "2-bound": [4.83, 5.6],
      "5-mid": "6.61",
      "5-bound": [6.12, 7.11],
      "10-mid": "7.76",
      "10-bound": [7.17, 8.34],
      "25-mid": "9.41",
      "25-bound": [8.66, 10.1],
      "50-mid": "10.8",
      "50-bound": [9.88, 11.6],
      "100-mid": "12.3",
      "100-bound": [11.2, 13.2]
    },
    "7day": {
      "2-mid": "5.86",
      "2-bound": [5.49, 6.27],
      "5-mid": "7.33",
      "5-bound": [6.87, 7.82],
      "10-mid": "8.52",
      "10-bound": [7.96, 9.08],
      "25-mid": "10.2",
      "25-bound": [9.51, 10.9],
      "50-mid": "11.7",
      "50-bound": [10.8, 12.4],
      "100-mid": "13.2",
      "100-bound": [12.1, 14.0]
    }
  },
  "USC00369714 6": {
    "fips": "42061",
    "station_name": "WILLIAMSBURG",
    "state": "PA",
    "latitude": "40.4660",
    "longitude": "-78.0000",
    "5min": {
      "2-mid": "0.37",
      "2-bound": [0.33, 0.42],
      "5-mid": "0.45",
      "5-bound": [0.4, 0.51],
      "10-mid": "0.52",
      "10-bound": [0.46, 0.58],
      "25-mid": "0.6",
      "25-bound": [0.53, 0.67],
      "50-mid": "0.67",
      "50-bound": [0.59, 0.74],
      "100-mid": "0.74",
      "100-bound": [0.64, 0.82]
    },
    "10min": {
      "2-mid": "0.58",
      "2-bound": [0.52, 0.65],
      "5-mid": "0.7",
      "5-bound": [0.63, 0.79],
      "10-mid": "0.8",
      "10-bound": [0.71, 0.89],
      "25-mid": "0.92",
      "25-bound": [0.81, 1.03],
      "50-mid": "1.01",
      "50-bound": [0.89, 1.13],
      "100-mid": "1.11",
      "100-bound": [0.97, 1.23]
    },
    "15min": {
      "2-mid": "0.71",
      "2-bound": [0.63, 0.8],
      "5-mid": "0.86",
      "5-bound": [0.77, 0.97],
      "10-mid": "0.98",
      "10-bound": [0.87, 1.1],
      "25-mid": "1.14",
      "25-bound": [1.0, 1.27],
      "50-mid": "1.26",
      "50-bound": [1.1, 1.4],
      "100-mid": "1.38",
      "100-bound": [1.2, 1.53]
    },
    "30min": {
      "2-mid": "0.95",
      "2-bound": [0.85, 1.06],
      "5-mid": "1.18",
      "5-bound": [1.05, 1.33],
      "10-mid": "1.36",
      "10-bound": [1.21, 1.52],
      "25-mid": "1.61",
      "25-bound": [1.42, 1.79],
      "50-mid": "1.79",
      "50-bound": [1.58, 2.0],
      "100-mid": "1.99",
      "100-bound": [1.74, 2.21]
    },
    "60min": {
      "2-mid": "1.16",
      "2-bound": [1.04, 1.3],
      "5-mid": "1.48",
      "5-bound": [1.32, 1.66],
      "10-mid": "1.73",
      "10-bound": [1.54, 1.94],
      "25-mid": "2.08",
      "25-bound": [1.84, 2.32],
      "50-mid": "2.36",
      "50-bound": [2.08, 2.63],
      "100-mid": "2.66",
      "100-bound": [2.32, 2.95]
    },
    "2hr": {
      "2-mid": "1.32",
      "2-bound": [1.17, 1.51],
      "5-mid": "1.69",
      "5-bound": [1.48, 1.92],
      "10-mid": "1.98",
      "10-bound": [1.74, 2.26],
      "25-mid": "2.4",
      "25-bound": [2.09, 2.72],
      "50-mid": "2.74",
      "50-bound": [2.37, 3.1],
      "100-mid": "3.11",
      "100-bound": [2.67, 3.5]
    },
    "3hr": {
      "2-mid": "1.42",
      "2-bound": [1.26, 1.63],
      "5-mid": "1.8",
      "5-bound": [1.59, 2.05],
      "10-mid": "2.1",
      "10-bound": [1.86, 2.4],
      "25-mid": "2.54",
      "25-bound": [2.23, 2.89],
      "50-mid": "2.9",
      "50-bound": [2.53, 3.28],
      "100-mid": "3.3",
      "100-bound": [2.86, 3.72]
    },
    "6hr": {
      "2-mid": "1.77",
      "2-bound": [1.59, 1.99],
      "5-mid": "2.21",
      "5-bound": [1.98, 2.49],
      "10-mid": "2.57",
      "10-bound": [2.3, 2.89],
      "25-mid": "3.1",
      "25-bound": [2.74, 3.46],
      "50-mid": "3.53",
      "50-bound": [3.11, 3.94],
      "100-mid": "3.99",
      "100-bound": [3.49, 4.45]
    },
    "12hr": {
      "2-mid": "2.2",
      "2-bound": [1.97, 2.48],
      "5-mid": "2.73",
      "5-bound": [2.44, 3.06],
      "10-mid": "3.18",
      "10-bound": [2.83, 3.56],
      "25-mid": "3.84",
      "25-bound": [3.39, 4.29],
      "50-mid": "4.38",
      "50-bound": [3.85, 4.88],
      "100-mid": "4.98",
      "100-bound": [4.34, 5.54]
    },
    "24hr": {
      "2-mid": "2.65",
      "2-bound": [2.44, 2.91],
      "5-mid": "3.3",
      "5-bound": [3.03, 3.62],
      "10-mid": "3.83",
      "10-bound": [3.51, 4.2],
      "25-mid": "4.61",
      "25-bound": [4.2, 5.03],
      "50-mid": "5.26",
      "50-bound": [4.76, 5.74],
      "100-mid": "5.95",
      "100-bound": [5.36, 6.49]
    },
    "2day": {
      "2-mid": "3.06",
      "2-bound": [2.83, 3.33],
      "5-mid": "3.8",
      "5-bound": [3.51, 4.14],
      "10-mid": "4.42",
      "10-bound": [4.07, 4.8],
      "25-mid": "5.32",
      "25-bound": [4.87, 5.76],
      "50-mid": "6.08",
      "50-bound": [5.53, 6.58],
      "100-mid": "6.9",
      "100-bound": [6.23, 7.45]
    },
    "3day": {
      "2-mid": "3.26",
      "2-bound": [3.03, 3.53],
      "5-mid": "4.04",
      "5-bound": [3.74, 4.37],
      "10-mid": "4.69",
      "10-bound": [4.34, 5.07],
      "25-mid": "5.62",
      "25-bound": [5.17, 6.06],
      "50-mid": "6.41",
      "50-bound": [5.86, 6.9],
      "100-mid": "7.25",
      "100-bound": [6.58, 7.8]
    },
    "4day": {
      "2-mid": "3.46",
      "2-bound": [3.23, 3.74],
      "5-mid": "4.28",
      "5-bound": [3.98, 4.61],
      "10-mid": "4.95",
      "10-bound": [4.6, 5.33],
      "25-mid": "5.92",
      "25-bound": [5.47, 6.36],
      "50-mid": "6.73",
      "50-bound": [6.18, 7.22],
      "100-mid": "7.59",
      "100-bound": [6.93, 8.14]
    },
    "7day": {
      "2-mid": "4.03",
      "2-bound": [3.77, 4.33],
      "5-mid": "4.92",
      "5-bound": [4.6, 5.28],
      "10-mid": "5.64",
      "10-bound": [5.26, 6.03],
      "25-mid": "6.63",
      "25-bound": [6.16, 7.09],
      "50-mid": "7.43",
      "50-bound": [6.87, 7.94],
      "100-mid": "8.26",
      "100-bound": [7.6, 8.84]
    }
  },
  "USC00365738 6": {
    "fips": "42127",
    "station_name": "MILANVILLE",
    "state": "PA",
    "latitude": "41.6720",
    "longitude": "-75.0640",
    "5min": {
      "2-mid": "0.4",
      "2-bound": [0.31, 0.51],
      "5-mid": "0.5",
      "5-bound": [0.39, 0.65],
      "10-mid": "0.59",
      "10-bound": [0.45, 0.76],
      "25-mid": "0.71",
      "25-bound": [0.52, 0.96],
      "50-mid": "0.8",
      "50-bound": [0.58, 1.11],
      "100-mid": "0.89",
      "100-bound": [0.63, 1.28]
    },
    "10min": {
      "2-mid": "0.56",
      "2-bound": [0.43, 0.72],
      "5-mid": "0.71",
      "5-bound": [0.55, 0.92],
      "10-mid": "0.83",
      "10-bound": [0.64, 1.08],
      "25-mid": "1.0",
      "25-bound": [0.74, 1.36],
      "50-mid": "1.13",
      "50-bound": [0.82, 1.57],
      "100-mid": "1.27",
      "100-bound": [0.89, 1.82]
    },
    "15min": {
      "2-mid": "0.66",
      "2-bound": [0.51, 0.85],
      "5-mid": "0.84",
      "5-bound": [0.64, 1.08],
      "10-mid": "0.98",
      "10-bound": [0.75, 1.27],
      "25-mid": "1.18",
      "25-bound": [0.87, 1.6],
      "50-mid": "1.33",
      "50-bound": [0.97, 1.85],
      "100-mid": "1.49",
      "100-bound": [1.05, 2.14]
    },
    "30min": {
      "2-mid": "0.89",
      "2-bound": [0.69, 1.14],
      "5-mid": "1.12",
      "5-bound": [0.86, 1.45],
      "10-mid": "1.32",
      "10-bound": [1.01, 1.71],
      "25-mid": "1.59",
      "25-bound": [1.17, 2.15],
      "50-mid": "1.79",
      "50-bound": [1.3, 2.48],
      "100-mid": "2.0",
      "100-bound": [1.41, 2.88]
    },
    "60min": {
      "2-mid": "1.12",
      "2-bound": [0.86, 1.43],
      "5-mid": "1.41",
      "5-bound": [1.08, 1.82],
      "10-mid": "1.66",
      "10-bound": [1.26, 2.15],
      "25-mid": "2.0",
      "25-bound": [1.48, 2.7],
      "50-mid": "2.25",
      "50-bound": [1.63, 3.12],
      "100-mid": "2.52",
      "100-bound": [1.77, 3.62]
    },
    "2hr": {
      "2-mid": "1.39",
      "2-bound": [1.08, 1.77],
      "5-mid": "1.73",
      "5-bound": [1.34, 2.21],
      "10-mid": "2.01",
      "10-bound": [1.55, 2.59],
      "25-mid": "2.4",
      "25-bound": [1.78, 3.22],
      "50-mid": "2.7",
      "50-bound": [1.96, 3.7],
      "100-mid": "3.0",
      "100-bound": [2.11, 4.26]
    },
    "3hr": {
      "2-mid": "1.58",
      "2-bound": [1.23, 2.0],
      "5-mid": "1.96",
      "5-bound": [1.52, 2.5],
      "10-mid": "2.28",
      "10-bound": [1.75, 2.92],
      "25-mid": "2.71",
      "25-bound": [2.02, 3.63],
      "50-mid": "3.05",
      "50-bound": [2.22, 4.17],
      "100-mid": "3.39",
      "100-bound": [2.39, 4.8]
    },
    "6hr": {
      "2-mid": "1.95",
      "2-bound": [1.52, 2.45],
      "5-mid": "2.46",
      "5-bound": [1.92, 3.11],
      "10-mid": "2.88",
      "10-bound": [2.23, 3.67],
      "25-mid": "3.46",
      "25-bound": [2.6, 4.63],
      "50-mid": "3.9",
      "50-bound": [2.87, 5.34],
      "100-mid": "4.36",
      "100-bound": [3.11, 6.22]
    },
    "12hr": {
      "2-mid": "2.39",
      "2-bound": [1.88, 2.99],
      "5-mid": "3.11",
      "5-bound": [2.44, 3.9],
      "10-mid": "3.7",
      "10-bound": [2.89, 4.68],
      "25-mid": "4.52",
      "25-bound": [3.42, 6.04],
      "50-mid": "5.12",
      "50-bound": [3.81, 7.04],
      "100-mid": "5.78",
      "100-bound": [4.19, 8.32]
    },
    "24hr": {
      "2-mid": "2.89",
      "2-bound": [2.29, 3.59],
      "5-mid": "3.8",
      "5-bound": [3.0, 4.74],
      "10-mid": "4.55",
      "10-bound": [3.57, 5.72],
      "25-mid": "5.59",
      "25-bound": [4.26, 7.45],
      "50-mid": "6.35",
      "50-bound": [4.76, 8.71],
      "100-mid": "7.18",
      "100-bound": [5.27, 10.4]
    },
    "2day": {
      "2-mid": "3.42",
      "2-bound": [2.72, 4.22],
      "5-mid": "4.42",
      "5-bound": [3.52, 5.49],
      "10-mid": "5.26",
      "10-bound": [4.15, 6.57],
      "25-mid": "6.41",
      "25-bound": [4.92, 8.49],
      "50-mid": "7.25",
      "50-bound": [5.46, 9.89],
      "100-mid": "8.18",
      "100-bound": [6.01, 11.7]
    },
    "3day": {
      "2-mid": "3.75",
      "2-bound": [3.0, 4.61],
      "5-mid": "4.79",
      "5-bound": [3.82, 5.92],
      "10-mid": "5.66",
      "10-bound": [4.49, 7.04],
      "25-mid": "6.85",
      "25-bound": [5.27, 9.03],
      "50-mid": "7.73",
      "50-bound": [5.84, 10.5],
      "100-mid": "8.69",
      "100-bound": [6.4, 12.4]
    },
    "4day": {
      "2-mid": "4.02",
      "2-bound": [3.22, 4.93],
      "5-mid": "5.09",
      "5-bound": [4.07, 6.27],
      "10-mid": "5.98",
      "10-bound": [4.76, 7.42],
      "25-mid": "7.21",
      "25-bound": [5.56, 9.47],
      "50-mid": "8.12",
      "50-bound": [6.14, 11.0],
      "100-mid": "9.1",
      "100-bound": [6.7, 12.9]
    },
    "7day": {
      "2-mid": "4.71",
      "2-bound": [3.8, 5.75],
      "5-mid": "5.86",
      "5-bound": [4.71, 7.18],
      "10-mid": "6.82",
      "10-bound": [5.45, 8.41],
      "25-mid": "8.14",
      "25-bound": [6.29, 10.6],
      "50-mid": "9.12",
      "50-bound": [6.9, 12.2],
      "100-mid": "10.2",
      "100-bound": [7.48, 14.3]
    }
  },
  "USC00189570 6": {
    "fips": "24043",
    "station_name": "WILLIAMSPORT",
    "state": "MD",
    "latitude": "39.6100",
    "longitude": "-77.8470",
    "5min": {
      "2-mid": "0.39",
      "2-bound": [0.35, 0.44],
      "5-mid": "0.47",
      "5-bound": [0.42, 0.53],
      "10-mid": "0.54",
      "10-bound": [0.48, 0.6],
      "25-mid": "0.63",
      "25-bound": [0.55, 0.7],
      "50-mid": "0.7",
      "50-bound": [0.61, 0.78],
      "100-mid": "0.77",
      "100-bound": [0.67, 0.86]
    },
    "10min": {
      "2-mid": "0.61",
      "2-bound": [0.55, 0.69],
      "5-mid": "0.74",
      "5-bound": [0.66, 0.83],
      "10-mid": "0.83",
      "10-bound": [0.74, 0.93],
      "25-mid": "0.96",
      "25-bound": [0.85, 1.07],
      "50-mid": "1.06",
      "50-bound": [0.93, 1.18],
      "100-mid": "1.16",
      "100-bound": [1.02, 1.29]
    },
    "15min": {
      "2-mid": "0.75",
      "2-bound": [0.67, 0.84],
      "5-mid": "0.91",
      "5-bound": [0.81, 1.02],
      "10-mid": "1.03",
      "10-bound": [0.91, 1.15],
      "25-mid": "1.19",
      "25-bound": [1.05, 1.33],
      "50-mid": "1.32",
      "50-bound": [1.16, 1.46],
      "100-mid": "1.45",
      "100-bound": [1.26, 1.61]
    },
    "30min": {
      "2-mid": "1.0",
      "2-bound": [0.9, 1.13],
      "5-mid": "1.25",
      "5-bound": [1.11, 1.4],
      "10-mid": "1.43",
      "10-bound": [1.27, 1.6],
      "25-mid": "1.69",
      "25-bound": [1.49, 1.88],
      "50-mid": "1.89",
      "50-bound": [1.66, 2.1],
      "100-mid": "2.1",
      "100-bound": [1.83, 2.33]
    },
    "60min": {
      "2-mid": "1.23",
      "2-bound": [1.1, 1.39],
      "5-mid": "1.57",
      "5-bound": [1.4, 1.76],
      "10-mid": "1.83",
      "10-bound": [1.62, 2.04],
      "25-mid": "2.2",
      "25-bound": [1.94, 2.45],
      "50-mid": "2.49",
      "50-bound": [2.19, 2.77],
      "100-mid": "2.81",
      "100-bound": [2.46, 3.12]
    },
    "2hr": {
      "2-mid": "1.45",
      "2-bound": [1.29, 1.63],
      "5-mid": "1.84",
      "5-bound": [1.63, 2.08],
      "10-mid": "2.16",
      "10-bound": [1.91, 2.43],
      "25-mid": "2.62",
      "25-bound": [2.31, 2.94],
      "50-mid": "3.01",
      "50-bound": [2.63, 3.36],
      "100-mid": "3.44",
      "100-bound": [2.98, 3.83]
    },
    "3hr": {
      "2-mid": "1.56",
      "2-bound": [1.39, 1.76],
      "5-mid": "1.97",
      "5-bound": [1.75, 2.23],
      "10-mid": "2.3",
      "10-bound": [2.04, 2.6],
      "25-mid": "2.8",
      "25-bound": [2.46, 3.14],
      "50-mid": "3.21",
      "50-bound": [2.81, 3.6],
      "100-mid": "3.67",
      "100-bound": [3.18, 4.1]
    },
    "6hr": {
      "2-mid": "1.94",
      "2-bound": [1.73, 2.2],
      "5-mid": "2.43",
      "5-bound": [2.16, 2.75],
      "10-mid": "2.83",
      "10-bound": [2.51, 3.2],
      "25-mid": "3.42",
      "25-bound": [3.02, 3.85],
      "50-mid": "3.92",
      "50-bound": [3.44, 4.4],
      "100-mid": "4.47",
      "100-bound": [3.89, 5.0]
    },
    "12hr": {
      "2-mid": "2.38",
      "2-bound": [2.13, 2.68],
      "5-mid": "2.96",
      "5-bound": [2.65, 3.32],
      "10-mid": "3.46",
      "10-bound": [3.08, 3.87],
      "25-mid": "4.2",
      "25-bound": [3.71, 4.66],
      "50-mid": "4.83",
      "50-bound": [4.24, 5.35],
      "100-mid": "5.54",
      "100-bound": [4.82, 6.12]
    },
    "24hr": {
      "2-mid": "2.8",
      "2-bound": [2.55, 3.07],
      "5-mid": "3.48",
      "5-bound": [3.16, 3.81],
      "10-mid": "4.04",
      "10-bound": [3.67, 4.42],
      "25-mid": "4.87",
      "25-bound": [4.4, 5.3],
      "50-mid": "5.56",
      "50-bound": [5.0, 6.05],
      "100-mid": "6.31",
      "100-bound": [5.64, 6.84]
    },
    "2day": {
      "2-mid": "3.23",
      "2-bound": [2.94, 3.55],
      "5-mid": "4.01",
      "5-bound": [3.64, 4.4],
      "10-mid": "4.66",
      "10-bound": [4.22, 5.11],
      "25-mid": "5.62",
      "25-bound": [5.06, 6.14],
      "50-mid": "6.42",
      "50-bound": [5.75, 7.01],
      "100-mid": "7.29",
      "100-bound": [6.49, 7.96]
    },
    "3day": {
      "2-mid": "3.44",
      "2-bound": [3.13, 3.79],
      "5-mid": "4.26",
      "5-bound": [3.86, 4.68],
      "10-mid": "4.94",
      "10-bound": [4.47, 5.43],
      "25-mid": "5.93",
      "25-bound": [5.35, 6.5],
      "50-mid": "6.77",
      "50-bound": [6.06, 7.41],
      "100-mid": "7.66",
      "100-bound": [6.83, 8.39]
    },
    "4day": {
      "2-mid": "3.65",
      "2-bound": [3.33, 4.03],
      "5-mid": "4.5",
      "5-bound": [4.09, 4.96],
      "10-mid": "5.22",
      "10-bound": [4.73, 5.74],
      "25-mid": "6.25",
      "25-bound": [5.64, 6.87],
      "50-mid": "7.11",
      "50-bound": [6.38, 7.81],
      "100-mid": "8.04",
      "100-bound": [7.17, 8.82]
    },
    "7day": {
      "2-mid": "4.24",
      "2-bound": [3.9, 4.63],
      "5-mid": "5.18",
      "5-bound": [4.75, 5.65],
      "10-mid": "5.93",
      "10-bound": [5.43, 6.46],
      "25-mid": "6.98",
      "25-bound": [6.37, 7.62],
      "50-mid": "7.85",
      "50-bound": [7.13, 8.55],
      "100-mid": "8.74",
      "100-bound": [7.9, 9.53]
    }
  },
  "USC00366927 6": {
    "fips": "42029",
    "station_name": "PHOENIXVILLE 1 E",
    "state": "PA",
    "latitude": "40.1211",
    "longitude": "-75.4941",
    "5min": {
      "2-mid": "0.41",
      "2-bound": [0.38, 0.45],
      "5-mid": "0.48",
      "5-bound": [0.44, 0.52],
      "10-mid": "0.53",
      "10-bound": [0.48, 0.57],
      "25-mid": "0.58",
      "25-bound": [0.53, 0.64],
      "50-mid": "0.62",
      "50-bound": [0.56, 0.68],
      "100-mid": "0.66",
      "100-bound": [0.59, 0.71]
    },
    "10min": {
      "2-mid": "0.66",
      "2-bound": [0.61, 0.72],
      "5-mid": "0.77",
      "5-bound": [0.71, 0.84],
      "10-mid": "0.85",
      "10-bound": [0.78, 0.92],
      "25-mid": "0.93",
      "25-bound": [0.85, 1.01],
      "50-mid": "0.99",
      "50-bound": [0.9, 1.08],
      "100-mid": "1.04",
      "100-bound": [0.94, 1.14]
    },
    "15min": {
      "2-mid": "0.83",
      "2-bound": [0.76, 0.9],
      "5-mid": "0.97",
      "5-bound": [0.89, 1.06],
      "10-mid": "1.07",
      "10-bound": [0.98, 1.16],
      "25-mid": "1.18",
      "25-bound": [1.08, 1.28],
      "50-mid": "1.25",
      "50-bound": [1.14, 1.36],
      "100-mid": "1.32",
      "100-bound": [1.19, 1.44]
    },
    "30min": {
      "2-mid": "1.14",
      "2-bound": [1.05, 1.24],
      "5-mid": "1.38",
      "5-bound": [1.27, 1.5],
      "10-mid": "1.55",
      "10-bound": [1.42, 1.69],
      "25-mid": "1.75",
      "25-bound": [1.59, 1.9],
      "50-mid": "1.89",
      "50-bound": [1.71, 2.05],
      "100-mid": "2.02",
      "100-bound": [1.83, 2.2]
    },
    "60min": {
      "2-mid": "1.43",
      "2-bound": [1.32, 1.56],
      "5-mid": "1.77",
      "5-bound": [1.63, 1.93],
      "10-mid": "2.02",
      "10-bound": [1.85, 2.2],
      "25-mid": "2.33",
      "25-bound": [2.12, 2.53],
      "50-mid": "2.56",
      "50-bound": [2.32, 2.78],
      "100-mid": "2.79",
      "100-bound": [2.52, 3.03]
    },
    "2hr": {
      "2-mid": "1.71",
      "2-bound": [1.56, 1.87],
      "5-mid": "2.12",
      "5-bound": [1.93, 2.32],
      "10-mid": "2.44",
      "10-bound": [2.22, 2.67],
      "25-mid": "2.85",
      "25-bound": [2.58, 3.12],
      "50-mid": "3.18",
      "50-bound": [2.86, 3.47],
      "100-mid": "3.5",
      "100-bound": [3.13, 3.83]
    },
    "3hr": {
      "2-mid": "1.85",
      "2-bound": [1.69, 2.04],
      "5-mid": "2.31",
      "5-bound": [2.1, 2.53],
      "10-mid": "2.66",
      "10-bound": [2.41, 2.91],
      "25-mid": "3.11",
      "25-bound": [2.81, 3.41],
      "50-mid": "3.47",
      "50-bound": [3.11, 3.79],
      "100-mid": "3.83",
      "100-bound": [3.41, 4.18]
    },
    "6hr": {
      "2-mid": "2.29",
      "2-bound": [2.1, 2.53],
      "5-mid": "2.84",
      "5-bound": [2.59, 3.13],
      "10-mid": "3.29",
      "10-bound": [2.99, 3.62],
      "25-mid": "3.91",
      "25-bound": [3.53, 4.28],
      "50-mid": "4.4",
      "50-bound": [3.94, 4.82],
      "100-mid": "4.92",
      "100-bound": [4.36, 5.38]
    },
    "12hr": {
      "2-mid": "2.78",
      "2-bound": [2.53, 3.1],
      "5-mid": "3.46",
      "5-bound": [3.15, 3.85],
      "10-mid": "4.04",
      "10-bound": [3.65, 4.48],
      "25-mid": "4.86",
      "25-bound": [4.35, 5.37],
      "50-mid": "5.54",
      "50-bound": [4.92, 6.11],
      "100-mid": "6.28",
      "100-bound": [5.51, 6.93]
    },
    "24hr": {
      "2-mid": "3.21",
      "2-bound": [2.94, 3.52],
      "5-mid": "4.03",
      "5-bound": [3.68, 4.41],
      "10-mid": "4.7",
      "10-bound": [4.29, 5.14],
      "25-mid": "5.68",
      "25-bound": [5.15, 6.19],
      "50-mid": "6.5",
      "50-bound": [5.87, 7.08],
      "100-mid": "7.38",
      "100-bound": [6.62, 8.02]
    },
    "2day": {
      "2-mid": "3.72",
      "2-bound": [3.4, 4.09],
      "5-mid": "4.67",
      "5-bound": [4.26, 5.13],
      "10-mid": "5.44",
      "10-bound": [4.95, 5.97],
      "25-mid": "6.53",
      "25-bound": [5.92, 7.15],
      "50-mid": "7.43",
      "50-bound": [6.71, 8.13],
      "100-mid": "8.38",
      "100-bound": [7.52, 9.18]
    },
    "3day": {
      "2-mid": "3.92",
      "2-bound": [3.59, 4.32],
      "5-mid": "4.91",
      "5-bound": [4.49, 5.4],
      "10-mid": "5.71",
      "10-bound": [5.21, 6.27],
      "25-mid": "6.84",
      "25-bound": [6.21, 7.5],
      "50-mid": "7.77",
      "50-bound": [7.03, 8.51],
      "100-mid": "8.76",
      "100-bound": [7.88, 9.59]
    },
    "4day": {
      "2-mid": "4.13",
      "2-bound": [3.78, 4.54],
      "5-mid": "5.15",
      "5-bound": [4.71, 5.66],
      "10-mid": "5.98",
      "10-bound": [5.46, 6.57],
      "25-mid": "7.16",
      "25-bound": [6.51, 7.84],
      "50-mid": "8.12",
      "50-bound": [7.36, 8.89],
      "100-mid": "9.14",
      "100-bound": [8.24, 10.0]
    },
    "7day": {
      "2-mid": "4.78",
      "2-bound": [4.41, 5.21],
      "5-mid": "5.9",
      "5-bound": [5.44, 6.44],
      "10-mid": "6.82",
      "10-bound": [6.28, 7.43],
      "25-mid": "8.13",
      "25-bound": [7.45, 8.85],
      "50-mid": "9.21",
      "50-bound": [8.4, 10.0],
      "100-mid": "10.4",
      "100-bound": [9.4, 11.2]
    }
  },
  "USW00013781 6": {
    "fips": "10003",
    "station_name": "WILMINGTON NEW CASTLE CO AP",
    "state": "DE",
    "latitude": "39.6740",
    "longitude": "-75.6056",
    "5min": {
      "2-mid": "0.41",
      "2-bound": [0.38, 0.46],
      "5-mid": "0.49",
      "5-bound": [0.44, 0.54],
      "10-mid": "0.54",
      "10-bound": [0.48, 0.59],
      "25-mid": "0.6",
      "25-bound": [0.54, 0.66],
      "50-mid": "0.64",
      "50-bound": [0.57, 0.7],
      "100-mid": "0.68",
      "100-bound": [0.6, 0.75]
    },
    "10min": {
      "2-mid": "0.66",
      "2-bound": [0.6, 0.73],
      "5-mid": "0.78",
      "5-bound": [0.7, 0.86],
      "10-mid": "0.86",
      "10-bound": [0.77, 0.95],
      "25-mid": "0.95",
      "25-bound": [0.85, 1.05],
      "50-mid": "1.01",
      "50-bound": [0.91, 1.12],
      "100-mid": "1.07",
      "100-bound": [0.95, 1.19]
    },
    "15min": {
      "2-mid": "0.83",
      "2-bound": [0.75, 0.92],
      "5-mid": "0.98",
      "5-bound": [0.89, 1.09],
      "10-mid": "1.08",
      "10-bound": [0.98, 1.2],
      "25-mid": "1.2",
      "25-bound": [1.08, 1.33],
      "50-mid": "1.28",
      "50-bound": [1.15, 1.42],
      "100-mid": "1.36",
      "100-bound": [1.21, 1.51]
    },
    "30min": {
      "2-mid": "1.15",
      "2-bound": [1.04, 1.27],
      "5-mid": "1.4",
      "5-bound": [1.26, 1.54],
      "10-mid": "1.57",
      "10-bound": [1.42, 1.74],
      "25-mid": "1.78",
      "25-bound": [1.6, 1.97],
      "50-mid": "1.93",
      "50-bound": [1.73, 2.14],
      "100-mid": "2.08",
      "100-bound": [1.85, 2.31]
    },
    "60min": {
      "2-mid": "1.44",
      "2-bound": [1.31, 1.6],
      "5-mid": "1.79",
      "5-bound": [1.62, 1.98],
      "10-mid": "2.04",
      "10-bound": [1.85, 2.26],
      "25-mid": "2.37",
      "25-bound": [2.13, 2.62],
      "50-mid": "2.62",
      "50-bound": [2.34, 2.9],
      "100-mid": "2.86",
      "100-bound": [2.55, 3.18]
    },
    "2hr": {
      "2-mid": "1.73",
      "2-bound": [1.56, 1.92],
      "5-mid": "2.16",
      "5-bound": [1.94, 2.39],
      "10-mid": "2.48",
      "10-bound": [2.23, 2.75],
      "25-mid": "2.91",
      "25-bound": [2.6, 3.22],
      "50-mid": "3.24",
      "50-bound": [2.88, 3.58],
      "100-mid": "3.57",
      "100-bound": [3.16, 3.96]
    },
    "3hr": {
      "2-mid": "1.87",
      "2-bound": [1.7, 2.07],
      "5-mid": "2.34",
      "5-bound": [2.11, 2.58],
      "10-mid": "2.7",
      "10-bound": [2.43, 2.98],
      "25-mid": "3.18",
      "25-bound": [2.84, 3.51],
      "50-mid": "3.56",
      "50-bound": [3.16, 3.93],
      "100-mid": "3.94",
      "100-bound": [3.48, 4.36]
    },
    "6hr": {
      "2-mid": "2.3",
      "2-bound": [2.09, 2.56],
      "5-mid": "2.87",
      "5-bound": [2.59, 3.19],
      "10-mid": "3.32",
      "10-bound": [3.0, 3.7],
      "25-mid": "3.96",
      "25-bound": [3.54, 4.4],
      "50-mid": "4.47",
      "50-bound": [3.97, 4.97],
      "100-mid": "5.02",
      "100-bound": [4.4, 5.58]
    },
    "12hr": {
      "2-mid": "2.8",
      "2-bound": [2.51, 3.15],
      "5-mid": "3.5",
      "5-bound": [3.13, 3.94],
      "10-mid": "4.09",
      "10-bound": [3.64, 4.6],
      "25-mid": "4.95",
      "25-bound": [4.36, 5.56],
      "50-mid": "5.66",
      "50-bound": [4.94, 6.37],
      "100-mid": "6.45",
      "100-bound": [5.56, 7.28]
    },
    "24hr": {
      "2-mid": "3.25",
      "2-bound": [2.97, 3.57],
      "5-mid": "4.1",
      "5-bound": [3.75, 4.52],
      "10-mid": "4.82",
      "10-bound": [4.39, 5.3],
      "25-mid": "5.88",
      "25-bound": [5.33, 6.44],
      "50-mid": "6.77",
      "50-bound": [6.1, 7.4],
      "100-mid": "7.74",
      "100-bound": [6.94, 8.44]
    },
    "2day": {
      "2-mid": "3.74",
      "2-bound": [3.42, 4.12],
      "5-mid": "4.73",
      "5-bound": [4.33, 5.21],
      "10-mid": "5.55",
      "10-bound": [5.07, 6.12],
      "25-mid": "6.73",
      "25-bound": [6.11, 7.4],
      "50-mid": "7.71",
      "50-bound": [6.97, 8.48],
      "100-mid": "8.78",
      "100-bound": [7.89, 9.63]
    },
    "3day": {
      "2-mid": "3.94",
      "2-bound": [3.61, 4.32],
      "5-mid": "4.96",
      "5-bound": [4.55, 5.45],
      "10-mid": "5.81",
      "10-bound": [5.31, 6.37],
      "25-mid": "7.03",
      "25-bound": [6.39, 7.7],
      "50-mid": "8.05",
      "50-bound": [7.28, 8.8],
      "100-mid": "9.14",
      "100-bound": [8.22, 9.99]
    },
    "4day": {
      "2-mid": "4.14",
      "2-bound": [3.79, 4.52],
      "5-mid": "5.2",
      "5-bound": [4.76, 5.68],
      "10-mid": "6.07",
      "10-bound": [5.55, 6.63],
      "25-mid": "7.33",
      "25-bound": [6.67, 7.99],
      "50-mid": "8.38",
      "50-bound": [7.58, 9.13],
      "100-mid": "9.5",
      "100-bound": [8.55, 10.3]
    },
    "7day": {
      "2-mid": "4.77",
      "2-bound": [4.4, 5.2],
      "5-mid": "5.92",
      "5-bound": [5.46, 6.45],
      "10-mid": "6.88",
      "10-bound": [6.33, 7.48],
      "25-mid": "8.25",
      "25-bound": [7.56, 8.97],
      "50-mid": "9.4",
      "50-bound": [8.58, 10.2],
      "100-mid": "10.6",
      "100-bound": [9.64, 11.5]
    }
  },
  "USC00300023 6": {
    "fips": "36101",
    "station_name": "ADDISON",
    "state": "NY",
    "latitude": "42.1010",
    "longitude": "-77.2340",
    "5min": {
      "2-mid": "0.35",
      "2-bound": [0.28, 0.44],
      "5-mid": "0.45",
      "5-bound": [0.36, 0.56],
      "10-mid": "0.54",
      "10-bound": [0.42, 0.67],
      "25-mid": "0.65",
      "25-bound": [0.49, 0.85],
      "50-mid": "0.73",
      "50-bound": [0.54, 0.98],
      "100-mid": "0.82",
      "100-bound": [0.59, 1.14]
    },
    "10min": {
      "2-mid": "0.5",
      "2-bound": [0.4, 0.62],
      "5-mid": "0.64",
      "5-bound": [0.51, 0.8],
      "10-mid": "0.76",
      "10-bound": [0.59, 0.95],
      "25-mid": "0.92",
      "25-bound": [0.69, 1.2],
      "50-mid": "1.04",
      "50-bound": [0.77, 1.38],
      "100-mid": "1.17",
      "100-bound": [0.84, 1.62]
    },
    "15min": {
      "2-mid": "0.59",
      "2-bound": [0.47, 0.73],
      "5-mid": "0.76",
      "5-bound": [0.59, 0.94],
      "10-mid": "0.89",
      "10-bound": [0.7, 1.11],
      "25-mid": "1.08",
      "25-bound": [0.82, 1.41],
      "50-mid": "1.22",
      "50-bound": [0.9, 1.63],
      "100-mid": "1.37",
      "100-bound": [0.98, 1.9]
    },
    "30min": {
      "2-mid": "0.8",
      "2-bound": [0.63, 0.99],
      "5-mid": "1.02",
      "5-bound": [0.81, 1.27],
      "10-mid": "1.21",
      "10-bound": [0.95, 1.51],
      "25-mid": "1.47",
      "25-bound": [1.11, 1.91],
      "50-mid": "1.66",
      "50-bound": [1.22, 2.21],
      "100-mid": "1.86",
      "100-bound": [1.33, 2.58]
    },
    "60min": {
      "2-mid": "1.01",
      "2-bound": [0.8, 1.25],
      "5-mid": "1.3",
      "5-bound": [1.02, 1.61],
      "10-mid": "1.53",
      "10-bound": [1.19, 1.91],
      "25-mid": "1.85",
      "25-bound": [1.4, 2.42],
      "50-mid": "2.1",
      "50-bound": [1.55, 2.79],
      "100-mid": "2.35",
      "100-bound": [1.68, 3.25]
    },
    "2hr": {
      "2-mid": "1.22",
      "2-bound": [0.97, 1.5],
      "5-mid": "1.57",
      "5-bound": [1.25, 1.94],
      "10-mid": "1.86",
      "10-bound": [1.47, 2.31],
      "25-mid": "2.26",
      "25-bound": [1.72, 2.93],
      "50-mid": "2.56",
      "50-bound": [1.9, 3.39],
      "100-mid": "2.87",
      "100-bound": [2.07, 3.96]
    },
    "3hr": {
      "2-mid": "1.37",
      "2-bound": [1.09, 1.68],
      "5-mid": "1.76",
      "5-bound": [1.4, 2.16],
      "10-mid": "2.08",
      "10-bound": [1.65, 2.57],
      "25-mid": "2.53",
      "25-bound": [1.93, 3.26],
      "50-mid": "2.86",
      "50-bound": [2.14, 3.78],
      "100-mid": "3.21",
      "100-bound": [2.33, 4.41]
    },
    "6hr": {
      "2-mid": "1.67",
      "2-bound": [1.34, 2.03],
      "5-mid": "2.13",
      "5-bound": [1.71, 2.6],
      "10-mid": "2.52",
      "10-bound": [2.01, 3.09],
      "25-mid": "3.05",
      "25-bound": [2.34, 3.91],
      "50-mid": "3.44",
      "50-bound": [2.59, 4.52],
      "100-mid": "3.86",
      "100-bound": [2.82, 5.27]
    },
    "12hr": {
      "2-mid": "2.04",
      "2-bound": [1.66, 2.46],
      "5-mid": "2.59",
      "5-bound": [2.1, 3.14],
      "10-mid": "3.04",
      "10-bound": [2.45, 3.71],
      "25-mid": "3.67",
      "25-bound": [2.85, 4.68],
      "50-mid": "4.14",
      "50-bound": [3.14, 5.4],
      "100-mid": "4.64",
      "100-bound": [3.4, 6.29]
    },
    "24hr": {
      "2-mid": "2.43",
      "2-bound": [1.99, 2.91],
      "5-mid": "3.09",
      "5-bound": [2.52, 3.72],
      "10-mid": "3.64",
      "10-bound": [2.95, 4.4],
      "25-mid": "4.4",
      "25-bound": [3.44, 5.57],
      "50-mid": "4.96",
      "50-bound": [3.78, 6.42],
      "100-mid": "5.56",
      "100-bound": [4.11, 7.49]
    },
    "2day": {
      "2-mid": "2.8",
      "2-bound": [2.32, 3.33],
      "5-mid": "3.6",
      "5-bound": [2.97, 4.3],
      "10-mid": "4.27",
      "10-bound": [3.49, 5.13],
      "25-mid": "5.19",
      "25-bound": [4.08, 6.53],
      "50-mid": "5.87",
      "50-bound": [4.51, 7.56],
      "100-mid": "6.6",
      "100-bound": [4.91, 8.84]
    },
    "3day": {
      "2-mid": "3.06",
      "2-bound": [2.55, 3.64],
      "5-mid": "3.94",
      "5-bound": [3.26, 4.69],
      "10-mid": "4.66",
      "10-bound": [3.83, 5.58],
      "25-mid": "5.66",
      "25-bound": [4.47, 7.09],
      "50-mid": "6.4",
      "50-bound": [4.94, 8.2],
      "100-mid": "7.2",
      "100-bound": [5.36, 9.58]
    },
    "4day": {
      "2-mid": "3.29",
      "2-bound": [2.75, 3.89],
      "5-mid": "4.2",
      "5-bound": [3.49, 4.98],
      "10-mid": "4.96",
      "10-bound": [4.09, 5.91],
      "25-mid": "6.0",
      "25-bound": [4.75, 7.48],
      "50-mid": "6.77",
      "50-bound": [5.24, 8.64],
      "100-mid": "7.6",
      "100-bound": [5.67, 10.1]
    },
    "7day": {
      "2-mid": "3.89",
      "2-bound": [3.27, 4.57],
      "5-mid": "4.84",
      "5-bound": [4.05, 5.71],
      "10-mid": "5.63",
      "10-bound": [4.68, 6.68],
      "25-mid": "6.72",
      "25-bound": [5.36, 8.32],
      "50-mid": "7.54",
      "50-bound": [5.86, 9.54],
      "100-mid": "8.4",
      "100-bound": [6.28, 11.0]
    }
  },
  "USC00449263 6": {
    "fips": "51171",
    "station_name": "WOODSTOCK 2 NE",
    "state": "VA",
    "latitude": "38.8960",
    "longitude": "-78.4670",
    "5min": {
      "2-mid": "0.38",
      "2-bound": [0.35, 0.43],
      "5-mid": "0.47",
      "5-bound": [0.42, 0.52],
      "10-mid": "0.53",
      "10-bound": [0.48, 0.59],
      "25-mid": "0.62",
      "25-bound": [0.55, 0.68],
      "50-mid": "0.69",
      "50-bound": [0.61, 0.76],
      "100-mid": "0.76",
      "100-bound": [0.67, 0.84]
    },
    "10min": {
      "2-mid": "0.6",
      "2-bound": [0.54, 0.67],
      "5-mid": "0.73",
      "5-bound": [0.65, 0.81],
      "10-mid": "0.82",
      "10-bound": [0.74, 0.91],
      "25-mid": "0.95",
      "25-bound": [0.84, 1.05],
      "50-mid": "1.05",
      "50-bound": [0.93, 1.16],
      "100-mid": "1.15",
      "100-bound": [1.01, 1.26]
    },
    "15min": {
      "2-mid": "0.73",
      "2-bound": [0.66, 0.82],
      "5-mid": "0.89",
      "5-bound": [0.8, 0.99],
      "10-mid": "1.01",
      "10-bound": [0.91, 1.12],
      "25-mid": "1.17",
      "25-bound": [1.04, 1.3],
      "50-mid": "1.3",
      "50-bound": [1.15, 1.43],
      "100-mid": "1.42",
      "100-bound": [1.25, 1.57]
    },
    "30min": {
      "2-mid": "0.98",
      "2-bound": [0.89, 1.1],
      "5-mid": "1.23",
      "5-bound": [1.1, 1.36],
      "10-mid": "1.41",
      "10-bound": [1.26, 1.56],
      "25-mid": "1.66",
      "25-bound": [1.48, 1.84],
      "50-mid": "1.86",
      "50-bound": [1.65, 2.05],
      "100-mid": "2.07",
      "100-bound": [1.82, 2.28]
    },
    "60min": {
      "2-mid": "1.21",
      "2-bound": [1.09, 1.35],
      "5-mid": "1.54",
      "5-bound": [1.38, 1.71],
      "10-mid": "1.8",
      "10-bound": [1.61, 1.99],
      "25-mid": "2.16",
      "25-bound": [1.92, 2.38],
      "50-mid": "2.45",
      "50-bound": [2.17, 2.71],
      "100-mid": "2.77",
      "100-bound": [2.44, 3.05]
    },
    "2hr": {
      "2-mid": "1.45",
      "2-bound": [1.31, 1.61],
      "5-mid": "1.86",
      "5-bound": [1.68, 2.06],
      "10-mid": "2.19",
      "10-bound": [1.97, 2.42],
      "25-mid": "2.67",
      "25-bound": [2.39, 2.94],
      "50-mid": "3.07",
      "50-bound": [2.73, 3.39],
      "100-mid": "3.52",
      "100-bound": [3.1, 3.86]
    },
    "3hr": {
      "2-mid": "1.56",
      "2-bound": [1.41, 1.74],
      "5-mid": "1.98",
      "5-bound": [1.79, 2.2],
      "10-mid": "2.32",
      "10-bound": [2.09, 2.57],
      "25-mid": "2.83",
      "25-bound": [2.54, 3.13],
      "50-mid": "3.27",
      "50-bound": [2.9, 3.6],
      "100-mid": "3.74",
      "100-bound": [3.3, 4.11]
    },
    "6hr": {
      "2-mid": "1.93",
      "2-bound": [1.75, 2.14],
      "5-mid": "2.42",
      "5-bound": [2.19, 2.68],
      "10-mid": "2.83",
      "10-bound": [2.55, 3.14],
      "25-mid": "3.44",
      "25-bound": [3.08, 3.8],
      "50-mid": "3.96",
      "50-bound": [3.53, 4.36],
      "100-mid": "4.54",
      "100-bound": [4.0, 4.99]
    },
    "12hr": {
      "2-mid": "2.33",
      "2-bound": [2.11, 2.6],
      "5-mid": "2.92",
      "5-bound": [2.64, 3.25],
      "10-mid": "3.42",
      "10-bound": [3.08, 3.8],
      "25-mid": "4.18",
      "25-bound": [3.73, 4.62],
      "50-mid": "4.83",
      "50-bound": [4.28, 5.33],
      "100-mid": "5.57",
      "100-bound": [4.88, 6.13]
    },
    "24hr": {
      "2-mid": "2.78",
      "2-bound": [2.59, 3.01],
      "5-mid": "3.48",
      "5-bound": [3.23, 3.77],
      "10-mid": "4.06",
      "10-bound": [3.76, 4.39],
      "25-mid": "4.9",
      "25-bound": [4.51, 5.29],
      "50-mid": "5.62",
      "50-bound": [5.14, 6.05],
      "100-mid": "6.39",
      "100-bound": [5.8, 6.87]
    },
    "2day": {
      "2-mid": "3.22",
      "2-bound": [3.0, 3.46],
      "5-mid": "4.01",
      "5-bound": [3.73, 4.32],
      "10-mid": "4.68",
      "10-bound": [4.33, 5.03],
      "25-mid": "5.64",
      "25-bound": [5.2, 6.06],
      "50-mid": "6.44",
      "50-bound": [5.91, 6.91],
      "100-mid": "7.32",
      "100-bound": [6.66, 7.84]
    },
    "3day": {
      "2-mid": "3.43",
      "2-bound": [3.2, 3.7],
      "5-mid": "4.27",
      "5-bound": [3.97, 4.6],
      "10-mid": "4.96",
      "10-bound": [4.61, 5.34],
      "25-mid": "5.97",
      "25-bound": [5.51, 6.41],
      "50-mid": "6.8",
      "50-bound": [6.25, 7.29],
      "100-mid": "7.7",
      "100-bound": [7.02, 8.25]
    },
    "4day": {
      "2-mid": "3.65",
      "2-bound": [3.4, 3.93],
      "5-mid": "4.53",
      "5-bound": [4.21, 4.87],
      "10-mid": "5.26",
      "10-bound": [4.88, 5.64],
      "25-mid": "6.3",
      "25-bound": [5.83, 6.76],
      "50-mid": "7.16",
      "50-bound": [6.59, 7.68],
      "100-mid": "8.08",
      "100-bound": [7.38, 8.65]
    },
    "7day": {
      "2-mid": "4.23",
      "2-bound": [3.95, 4.55],
      "5-mid": "5.18",
      "5-bound": [4.84, 5.57],
      "10-mid": "5.94",
      "10-bound": [5.54, 6.39],
      "25-mid": "7.02",
      "25-bound": [6.5, 7.54],
      "50-mid": "7.88",
      "50-bound": [7.27, 8.46],
      "100-mid": "8.77",
      "100-bound": [8.06, 9.44]
    }
  },
  "USW00013733 6": {
    "fips": "51031",
    "station_name": "LYNCHBURG REGIONAL AIRPORT",
    "state": "VA",
    "latitude": "37.3212",
    "longitude": "-79.2065",
    "5min": {
      "2-mid": "0.39",
      "2-bound": [0.36, 0.43],
      "5-mid": "0.47",
      "5-bound": [0.42, 0.51],
      "10-mid": "0.52",
      "10-bound": [0.47, 0.57],
      "25-mid": "0.59",
      "25-bound": [0.53, 0.64],
      "50-mid": "0.63",
      "50-bound": [0.57, 0.69],
      "100-mid": "0.68",
      "100-bound": [0.61, 0.74]
    },
    "10min": {
      "2-mid": "0.62",
      "2-bound": [0.57, 0.69],
      "5-mid": "0.74",
      "5-bound": [0.68, 0.82],
      "10-mid": "0.83",
      "10-bound": [0.76, 0.91],
      "25-mid": "0.93",
      "25-bound": [0.84, 1.02],
      "50-mid": "1.01",
      "50-bound": [0.91, 1.1],
      "100-mid": "1.08",
      "100-bound": [0.97, 1.18]
    },
    "15min": {
      "2-mid": "0.79",
      "2-bound": [0.72, 0.86],
      "5-mid": "0.94",
      "5-bound": [0.86, 1.04],
      "10-mid": "1.05",
      "10-bound": [0.96, 1.15],
      "25-mid": "1.18",
      "25-bound": [1.07, 1.3],
      "50-mid": "1.28",
      "50-bound": [1.15, 1.4],
      "100-mid": "1.36",
      "100-bound": [1.22, 1.49]
    },
    "30min": {
      "2-mid": "1.08",
      "2-bound": [0.99, 1.2],
      "5-mid": "1.34",
      "5-bound": [1.22, 1.47],
      "10-mid": "1.52",
      "10-bound": [1.38, 1.67],
      "25-mid": "1.75",
      "25-bound": [1.59, 1.92],
      "50-mid": "1.92",
      "50-bound": [1.73, 2.11],
      "100-mid": "2.09",
      "100-bound": [1.87, 2.28]
    },
    "60min": {
      "2-mid": "1.36",
      "2-bound": [1.24, 1.5],
      "5-mid": "1.72",
      "5-bound": [1.56, 1.89],
      "10-mid": "1.98",
      "10-bound": [1.8, 2.18],
      "25-mid": "2.33",
      "25-bound": [2.11, 2.56],
      "50-mid": "2.6",
      "50-bound": [2.35, 2.85],
      "100-mid": "2.87",
      "100-bound": [2.58, 3.15]
    },
    "2hr": {
      "2-mid": "1.6",
      "2-bound": [1.46, 1.78],
      "5-mid": "2.04",
      "5-bound": [1.85, 2.25],
      "10-mid": "2.38",
      "10-bound": [2.15, 2.63],
      "25-mid": "2.83",
      "25-bound": [2.55, 3.11],
      "50-mid": "3.2",
      "50-bound": [2.86, 3.51],
      "100-mid": "3.57",
      "100-bound": [3.17, 3.92]
    },
    "3hr": {
      "2-mid": "1.73",
      "2-bound": [1.57, 1.92],
      "5-mid": "2.19",
      "5-bound": [1.98, 2.43],
      "10-mid": "2.56",
      "10-bound": [2.31, 2.83],
      "25-mid": "3.05",
      "25-bound": [2.74, 3.36],
      "50-mid": "3.44",
      "50-bound": [3.08, 3.8],
      "100-mid": "3.84",
      "100-bound": [3.41, 4.23]
    },
    "6hr": {
      "2-mid": "2.15",
      "2-bound": [1.96, 2.38],
      "5-mid": "2.71",
      "5-bound": [2.46, 3.0],
      "10-mid": "3.18",
      "10-bound": [2.87, 3.52],
      "25-mid": "3.82",
      "25-bound": [3.43, 4.22],
      "50-mid": "4.36",
      "50-bound": [3.88, 4.81],
      "100-mid": "4.92",
      "100-bound": [4.35, 5.43]
    },
    "12hr": {
      "2-mid": "2.63",
      "2-bound": [2.4, 2.93],
      "5-mid": "3.33",
      "5-bound": [3.02, 3.7],
      "10-mid": "3.93",
      "10-bound": [3.55, 4.36],
      "25-mid": "4.79",
      "25-bound": [4.28, 5.3],
      "50-mid": "5.52",
      "50-bound": [4.89, 6.08],
      "100-mid": "6.32",
      "100-bound": [5.53, 6.96]
    },
    "24hr": {
      "2-mid": "3.29",
      "2-bound": [3.05, 3.59],
      "5-mid": "4.2",
      "5-bound": [3.88, 4.59],
      "10-mid": "4.97",
      "10-bound": [4.57, 5.41],
      "25-mid": "6.1",
      "25-bound": [5.58, 6.63],
      "50-mid": "7.07",
      "50-bound": [6.42, 7.66],
      "100-mid": "8.13",
      "100-bound": [7.32, 8.8]
    },
    "2day": {
      "2-mid": "3.9",
      "2-bound": [3.6, 4.23],
      "5-mid": "4.94",
      "5-bound": [4.56, 5.36],
      "10-mid": "5.81",
      "10-bound": [5.34, 6.3],
      "25-mid": "7.06",
      "25-bound": [6.45, 7.64],
      "50-mid": "8.1",
      "50-bound": [7.37, 8.76],
      "100-mid": "9.22",
      "100-bound": [8.34, 9.98]
    },
    "3day": {
      "2-mid": "4.12",
      "2-bound": [3.81, 4.48],
      "5-mid": "5.23",
      "5-bound": [4.82, 5.67],
      "10-mid": "6.14",
      "10-bound": [5.64, 6.65],
      "25-mid": "7.45",
      "25-bound": [6.81, 8.07],
      "50-mid": "8.54",
      "50-bound": [7.77, 9.25],
      "100-mid": "9.72",
      "100-bound": [8.78, 10.5]
    },
    "4day": {
      "2-mid": "4.35",
      "2-bound": [4.02, 4.72],
      "5-mid": "5.51",
      "5-bound": [5.08, 5.98],
      "10-mid": "6.47",
      "10-bound": [5.94, 7.01],
      "25-mid": "7.84",
      "25-bound": [7.16, 8.5],
      "50-mid": "8.99",
      "50-bound": [8.17, 9.74],
      "100-mid": "10.2",
      "100-bound": [9.22, 11.1]
    },
    "7day": {
      "2-mid": "5.0",
      "2-bound": [4.63, 5.41],
      "5-mid": "6.24",
      "5-bound": [5.77, 6.74],
      "10-mid": "7.25",
      "10-bound": [6.69, 7.83],
      "25-mid": "8.7",
      "25-bound": [7.99, 9.38],
      "50-mid": "9.9",
      "50-bound": [9.05, 10.7],
      "100-mid": "11.2",
      "100-bound": [10.2, 12.0]
    }
  },
  "USC00302036 6": {
    "fips": "36025",
    "station_name": "DELHI 2 SE",
    "state": "NY",
    "latitude": "42.2530",
    "longitude": "-74.9000",
    "5min": {
      "2-mid": "0.36",
      "2-bound": [0.29, 0.46],
      "5-mid": "0.48",
      "5-bound": [0.38, 0.62],
      "10-mid": "0.59",
      "10-bound": [0.46, 0.75],
      "25-mid": "0.72",
      "25-bound": [0.55, 0.98],
      "50-mid": "0.83",
      "50-bound": [0.61, 1.15],
      "100-mid": "0.94",
      "100-bound": [0.67, 1.36]
    },
    "10min": {
      "2-mid": "0.52",
      "2-bound": [0.41, 0.66],
      "5-mid": "0.69",
      "5-bound": [0.54, 0.88],
      "10-mid": "0.83",
      "10-bound": [0.65, 1.07],
      "25-mid": "1.02",
      "25-bound": [0.77, 1.39],
      "50-mid": "1.17",
      "50-bound": [0.86, 1.63],
      "100-mid": "1.33",
      "100-bound": [0.95, 1.93]
    },
    "15min": {
      "2-mid": "0.61",
      "2-bound": [0.48, 0.77],
      "5-mid": "0.81",
      "5-bound": [0.63, 1.03],
      "10-mid": "0.98",
      "10-bound": [0.76, 1.25],
      "25-mid": "1.21",
      "25-bound": [0.91, 1.63],
      "50-mid": "1.38",
      "50-bound": [1.02, 1.92],
      "100-mid": "1.56",
      "100-bound": [1.12, 2.27]
    },
    "30min": {
      "2-mid": "0.81",
      "2-bound": [0.64, 1.03],
      "5-mid": "1.08",
      "5-bound": [0.84, 1.38],
      "10-mid": "1.3",
      "10-bound": [1.01, 1.67],
      "25-mid": "1.61",
      "25-bound": [1.21, 2.18],
      "50-mid": "1.84",
      "50-bound": [1.36, 2.56],
      "100-mid": "2.08",
      "100-bound": [1.5, 3.03]
    },
    "60min": {
      "2-mid": "1.01",
      "2-bound": [0.79, 1.28],
      "5-mid": "1.35",
      "5-bound": [1.05, 1.72],
      "10-mid": "1.63",
      "10-bound": [1.27, 2.09],
      "25-mid": "2.01",
      "25-bound": [1.52, 2.73],
      "50-mid": "2.3",
      "50-bound": [1.7, 3.2],
      "100-mid": "2.61",
      "100-bound": [1.87, 3.79]
    },
    "2hr": {
      "2-mid": "1.29",
      "2-bound": [1.02, 1.63],
      "5-mid": "1.69",
      "5-bound": [1.33, 2.14],
      "10-mid": "2.02",
      "10-bound": [1.58, 2.57],
      "25-mid": "2.46",
      "25-bound": [1.88, 3.33],
      "50-mid": "2.8",
      "50-bound": [2.09, 3.88],
      "100-mid": "3.16",
      "100-bound": [2.3, 4.61]
    },
    "3hr": {
      "2-mid": "1.49",
      "2-bound": [1.19, 1.87],
      "5-mid": "1.93",
      "5-bound": [1.53, 2.43],
      "10-mid": "2.29",
      "10-bound": [1.8, 2.9],
      "25-mid": "2.79",
      "25-bound": [2.13, 3.75],
      "50-mid": "3.15",
      "50-bound": [2.37, 4.36],
      "100-mid": "3.55",
      "100-bound": [2.61, 5.18]
    },
    "6hr": {
      "2-mid": "1.88",
      "2-bound": [1.51, 2.34],
      "5-mid": "2.42",
      "5-bound": [1.93, 3.02],
      "10-mid": "2.87",
      "10-bound": [2.28, 3.61],
      "25-mid": "3.49",
      "25-bound": [2.69, 4.66],
      "50-mid": "3.94",
      "50-bound": [2.98, 5.42],
      "100-mid": "4.44",
      "100-bound": [3.29, 6.45]
    },
    "12hr": {
      "2-mid": "2.33",
      "2-bound": [1.88, 2.88],
      "5-mid": "3.02",
      "5-bound": [2.44, 3.75],
      "10-mid": "3.6",
      "10-bound": [2.88, 4.49],
      "25-mid": "4.39",
      "25-bound": [3.41, 5.82],
      "50-mid": "4.97",
      "50-bound": [3.79, 6.78],
      "100-mid": "5.62",
      "100-bound": [4.18, 8.07]
    },
    "24hr": {
      "2-mid": "2.81",
      "2-bound": [2.29, 3.44],
      "5-mid": "3.65",
      "5-bound": [2.97, 4.49],
      "10-mid": "4.35",
      "10-bound": [3.51, 5.39],
      "25-mid": "5.32",
      "25-bound": [4.15, 6.97],
      "50-mid": "6.02",
      "50-bound": [4.61, 8.12],
      "100-mid": "6.8",
      "100-bound": [5.07, 9.64]
    },
    "2day": {
      "2-mid": "3.31",
      "2-bound": [2.72, 4.02],
      "5-mid": "4.24",
      "5-bound": [3.48, 5.18],
      "10-mid": "5.02",
      "10-bound": [4.09, 6.16],
      "25-mid": "6.09",
      "25-bound": [4.79, 7.9],
      "50-mid": "6.88",
      "50-bound": [5.29, 9.17],
      "100-mid": "7.74",
      "100-bound": [5.78, 10.8]
    },
    "3day": {
      "2-mid": "3.65",
      "2-bound": [3.01, 4.41],
      "5-mid": "4.62",
      "5-bound": [3.8, 5.6],
      "10-mid": "5.42",
      "10-bound": [4.43, 6.62],
      "25-mid": "6.53",
      "25-bound": [5.15, 8.42],
      "50-mid": "7.35",
      "50-bound": [5.67, 9.73],
      "100-mid": "8.24",
      "100-bound": [6.16, 11.4]
    },
    "4day": {
      "2-mid": "3.92",
      "2-bound": [3.26, 4.73],
      "5-mid": "4.92",
      "5-bound": [4.06, 5.94],
      "10-mid": "5.74",
      "10-bound": [4.71, 6.98],
      "25-mid": "6.87",
      "25-bound": [5.43, 8.81],
      "50-mid": "7.71",
      "50-bound": [5.96, 10.2],
      "100-mid": "8.62",
      "100-bound": [6.44, 11.9]
    },
    "7day": {
      "2-mid": "4.62",
      "2-bound": [3.86, 5.52],
      "5-mid": "5.66",
      "5-bound": [4.7, 6.79],
      "10-mid": "6.52",
      "10-bound": [5.38, 7.88],
      "25-mid": "7.7",
      "25-bound": [6.12, 9.78],
      "50-mid": "8.59",
      "50-bound": [6.65, 11.2],
      "100-mid": "9.53",
      "100-bound": [7.12, 12.9]
    }
  },
  "USC00309442 6": {
    "fips": "36007",
    "station_name": "WHITNEY POINT DAM",
    "state": "NY",
    "latitude": "42.3410",
    "longitude": "-75.9650",
    "5min": {
      "2-mid": "0.36",
      "2-bound": [0.28, 0.46],
      "5-mid": "0.47",
      "5-bound": [0.37, 0.6],
      "10-mid": "0.56",
      "10-bound": [0.43, 0.72],
      "25-mid": "0.68",
      "25-bound": [0.51, 0.92],
      "50-mid": "0.78",
      "50-bound": [0.57, 1.07],
      "100-mid": "0.87",
      "100-bound": [0.63, 1.26]
    },
    "10min": {
      "2-mid": "0.51",
      "2-bound": [0.4, 0.65],
      "5-mid": "0.67",
      "5-bound": [0.52, 0.85],
      "10-mid": "0.79",
      "10-bound": [0.61, 1.02],
      "25-mid": "0.97",
      "25-bound": [0.73, 1.31],
      "50-mid": "1.1",
      "50-bound": [0.81, 1.52],
      "100-mid": "1.24",
      "100-bound": [0.89, 1.78]
    },
    "15min": {
      "2-mid": "0.6",
      "2-bound": [0.47, 0.77],
      "5-mid": "0.78",
      "5-bound": [0.61, 1.0],
      "10-mid": "0.93",
      "10-bound": [0.72, 1.2],
      "25-mid": "1.14",
      "25-bound": [0.85, 1.54],
      "50-mid": "1.29",
      "50-bound": [0.95, 1.79],
      "100-mid": "1.46",
      "100-bound": [1.04, 2.1]
    },
    "30min": {
      "2-mid": "0.8",
      "2-bound": [0.62, 1.02],
      "5-mid": "1.04",
      "5-bound": [0.81, 1.32],
      "10-mid": "1.23",
      "10-bound": [0.96, 1.59],
      "25-mid": "1.5",
      "25-bound": [1.13, 2.03],
      "50-mid": "1.71",
      "50-bound": [1.26, 2.36],
      "100-mid": "1.92",
      "100-bound": [1.38, 2.77]
    },
    "60min": {
      "2-mid": "0.99",
      "2-bound": [0.78, 1.27],
      "5-mid": "1.29",
      "5-bound": [1.0, 1.65],
      "10-mid": "1.53",
      "10-bound": [1.19, 1.97],
      "25-mid": "1.87",
      "25-bound": [1.4, 2.53],
      "50-mid": "2.12",
      "50-bound": [1.56, 2.94],
      "100-mid": "2.39",
      "100-bound": [1.71, 3.45]
    },
    "2hr": {
      "2-mid": "1.21",
      "2-bound": [0.95, 1.53],
      "5-mid": "1.54",
      "5-bound": [1.21, 1.96],
      "10-mid": "1.82",
      "10-bound": [1.42, 2.32],
      "25-mid": "2.2",
      "25-bound": [1.66, 2.96],
      "50-mid": "2.48",
      "50-bound": [1.84, 3.42],
      "100-mid": "2.78",
      "100-bound": [2.01, 4.01]
    },
    "3hr": {
      "2-mid": "1.37",
      "2-bound": [1.08, 1.72],
      "5-mid": "1.73",
      "5-bound": [1.36, 2.19],
      "10-mid": "2.03",
      "10-bound": [1.59, 2.58],
      "25-mid": "2.45",
      "25-bound": [1.86, 3.28],
      "50-mid": "2.75",
      "50-bound": [2.05, 3.78],
      "100-mid": "3.08",
      "100-bound": [2.24, 4.44]
    },
    "6hr": {
      "2-mid": "1.7",
      "2-bound": [1.35, 2.12],
      "5-mid": "2.16",
      "5-bound": [1.71, 2.71],
      "10-mid": "2.54",
      "10-bound": [1.99, 3.2],
      "25-mid": "3.06",
      "25-bound": [2.33, 4.07],
      "50-mid": "3.44",
      "50-bound": [2.58, 4.7],
      "100-mid": "3.86",
      "100-bound": [2.82, 5.51]
    },
    "12hr": {
      "2-mid": "2.12",
      "2-bound": [1.69, 2.64],
      "5-mid": "2.73",
      "5-bound": [2.18, 3.41],
      "10-mid": "3.24",
      "10-bound": [2.56, 4.06],
      "25-mid": "3.94",
      "25-bound": [3.01, 5.19],
      "50-mid": "4.46",
      "50-bound": [3.34, 6.01],
      "100-mid": "5.01",
      "100-bound": [3.64, 7.04]
    },
    "24hr": {
      "2-mid": "2.55",
      "2-bound": [2.05, 3.15],
      "5-mid": "3.31",
      "5-bound": [2.65, 4.1],
      "10-mid": "3.94",
      "10-bound": [3.14, 4.91],
      "25-mid": "4.81",
      "25-bound": [3.7, 6.29],
      "50-mid": "5.46",
      "50-bound": [4.11, 7.31],
      "100-mid": "6.14",
      "100-bound": [4.48, 8.56]
    },
    "2day": {
      "2-mid": "2.94",
      "2-bound": [2.38, 3.61],
      "5-mid": "3.79",
      "5-bound": [3.06, 4.66],
      "10-mid": "4.49",
      "10-bound": [3.6, 5.56],
      "25-mid": "5.46",
      "25-bound": [4.23, 7.1],
      "50-mid": "6.18",
      "50-bound": [4.68, 8.24],
      "100-mid": "6.95",
      "100-bound": [5.12, 9.67]
    },
    "3day": {
      "2-mid": "3.2",
      "2-bound": [2.6, 3.91],
      "5-mid": "4.09",
      "5-bound": [3.31, 5.01],
      "10-mid": "4.82",
      "10-bound": [3.88, 5.95],
      "25-mid": "5.84",
      "25-bound": [4.54, 7.57],
      "50-mid": "6.59",
      "50-bound": [5.02, 8.76],
      "100-mid": "7.4",
      "100-bound": [5.47, 10.3]
    },
    "4day": {
      "2-mid": "3.41",
      "2-bound": [2.78, 4.16],
      "5-mid": "4.32",
      "5-bound": [3.51, 5.29],
      "10-mid": "5.08",
      "10-bound": [4.1, 6.25],
      "25-mid": "6.12",
      "25-bound": [4.78, 7.92],
      "50-mid": "6.89",
      "50-bound": [5.26, 9.14],
      "100-mid": "7.73",
      "100-bound": [5.73, 10.7]
    },
    "7day": {
      "2-mid": "3.98",
      "2-bound": [3.26, 4.82],
      "5-mid": "4.92",
      "5-bound": [4.02, 5.99],
      "10-mid": "5.71",
      "10-bound": [4.63, 6.98],
      "25-mid": "6.79",
      "25-bound": [5.32, 8.72],
      "50-mid": "7.59",
      "50-bound": [5.82, 9.99],
      "100-mid": "8.46",
      "100-bound": [6.29, 11.6]
    }
  },
  "USC00469522 6": {
    "fips": "54025",
    "station_name": "WHITE SULPHUR SPRINGS",
    "state": "WV",
    "latitude": "37.7883",
    "longitude": "-80.3083",
    "5min": {
      "2-mid": "0.35",
      "2-bound": [0.31, 0.39],
      "5-mid": "0.41",
      "5-bound": [0.37, 0.47],
      "10-mid": "0.46",
      "10-bound": [0.41, 0.52],
      "25-mid": "0.52",
      "25-bound": [0.46, 0.58],
      "50-mid": "0.56",
      "50-bound": [0.5, 0.63],
      "100-mid": "0.6",
      "100-bound": [0.53, 0.68]
    },
    "10min": {
      "2-mid": "0.56",
      "2-bound": [0.5, 0.62],
      "5-mid": "0.67",
      "5-bound": [0.59, 0.74],
      "10-mid": "0.74",
      "10-bound": [0.66, 0.83],
      "25-mid": "0.83",
      "25-bound": [0.74, 0.93],
      "50-mid": "0.9",
      "50-bound": [0.79, 1.01],
      "100-mid": "0.96",
      "100-bound": [0.84, 1.08]
    },
    "15min": {
      "2-mid": "0.7",
      "2-bound": [0.62, 0.78],
      "5-mid": "0.84",
      "5-bound": [0.75, 0.94],
      "10-mid": "0.94",
      "10-bound": [0.84, 1.05],
      "25-mid": "1.06",
      "25-bound": [0.94, 1.18],
      "50-mid": "1.14",
      "50-bound": [1.0, 1.28],
      "100-mid": "1.21",
      "100-bound": [1.06, 1.36]
    },
    "30min": {
      "2-mid": "0.96",
      "2-bound": [0.86, 1.08],
      "5-mid": "1.2",
      "5-bound": [1.07, 1.34],
      "10-mid": "1.36",
      "10-bound": [1.21, 1.52],
      "25-mid": "1.57",
      "25-bound": [1.39, 1.75],
      "50-mid": "1.72",
      "50-bound": [1.51, 1.92],
      "100-mid": "1.86",
      "100-bound": [1.62, 2.09]
    },
    "60min": {
      "2-mid": "1.21",
      "2-bound": [1.08, 1.36],
      "5-mid": "1.53",
      "5-bound": [1.37, 1.72],
      "10-mid": "1.77",
      "10-bound": [1.58, 1.98],
      "25-mid": "2.09",
      "25-bound": [1.85, 2.33],
      "50-mid": "2.33",
      "50-bound": [2.04, 2.6],
      "100-mid": "2.56",
      "100-bound": [2.23, 2.88]
    },
    "2hr": {
      "2-mid": "1.39",
      "2-bound": [1.26, 1.54],
      "5-mid": "1.76",
      "5-bound": [1.59, 1.95],
      "10-mid": "2.04",
      "10-bound": [1.83, 2.25],
      "25-mid": "2.4",
      "25-bound": [2.15, 2.65],
      "50-mid": "2.68",
      "50-bound": [2.38, 2.97],
      "100-mid": "2.96",
      "100-bound": [2.6, 3.29]
    },
    "3hr": {
      "2-mid": "1.48",
      "2-bound": [1.35, 1.64],
      "5-mid": "1.86",
      "5-bound": [1.69, 2.06],
      "10-mid": "2.15",
      "10-bound": [1.95, 2.38],
      "25-mid": "2.54",
      "25-bound": [2.28, 2.81],
      "50-mid": "2.84",
      "50-bound": [2.53, 3.15],
      "100-mid": "3.14",
      "100-bound": [2.78, 3.5]
    },
    "6hr": {
      "2-mid": "1.8",
      "2-bound": [1.63, 2.0],
      "5-mid": "2.23",
      "5-bound": [2.02, 2.49],
      "10-mid": "2.57",
      "10-bound": [2.32, 2.87],
      "25-mid": "3.05",
      "25-bound": [2.72, 3.4],
      "50-mid": "3.43",
      "50-bound": [3.04, 3.84],
      "100-mid": "3.82",
      "100-bound": [3.34, 4.29]
    },
    "12hr": {
      "2-mid": "2.16",
      "2-bound": [1.96, 2.43],
      "5-mid": "2.67",
      "5-bound": [2.42, 3.0],
      "10-mid": "3.09",
      "10-bound": [2.79, 3.47],
      "25-mid": "3.69",
      "25-bound": [3.29, 4.15],
      "50-mid": "4.2",
      "50-bound": [3.69, 4.72],
      "100-mid": "4.74",
      "100-bound": [4.11, 5.35]
    },
    "24hr": {
      "2-mid": "2.81",
      "2-bound": [2.63, 3.03],
      "5-mid": "3.42",
      "5-bound": [3.19, 3.68],
      "10-mid": "3.91",
      "10-bound": [3.63, 4.21],
      "25-mid": "4.58",
      "25-bound": [4.24, 4.94],
      "50-mid": "5.13",
      "50-bound": [4.72, 5.53],
      "100-mid": "5.7",
      "100-bound": [5.2, 6.16]
    },
    "2day": {
      "2-mid": "3.31",
      "2-bound": [3.1, 3.56],
      "5-mid": "3.99",
      "5-bound": [3.73, 4.29],
      "10-mid": "4.53",
      "10-bound": [4.23, 4.87],
      "25-mid": "5.27",
      "25-bound": [4.89, 5.67],
      "50-mid": "5.85",
      "50-bound": [5.4, 6.3],
      "100-mid": "6.44",
      "100-bound": [5.92, 6.96]
    },
    "3day": {
      "2-mid": "3.54",
      "2-bound": [3.32, 3.78],
      "5-mid": "4.23",
      "5-bound": [3.98, 4.53],
      "10-mid": "4.78",
      "10-bound": [4.48, 5.11],
      "25-mid": "5.52",
      "25-bound": [5.15, 5.9],
      "50-mid": "6.09",
      "50-bound": [5.66, 6.52],
      "100-mid": "6.68",
      "100-bound": [6.16, 7.17]
    },
    "4day": {
      "2-mid": "3.76",
      "2-bound": [3.54, 4.0],
      "5-mid": "4.48",
      "5-bound": [4.22, 4.76],
      "10-mid": "5.03",
      "10-bound": [4.73, 5.35],
      "25-mid": "5.77",
      "25-bound": [5.41, 6.14],
      "50-mid": "6.34",
      "50-bound": [5.92, 6.75],
      "100-mid": "6.91",
      "100-bound": [6.41, 7.38]
    },
    "7day": {
      "2-mid": "4.36",
      "2-bound": [4.13, 4.62],
      "5-mid": "5.15",
      "5-bound": [4.86, 5.45],
      "10-mid": "5.74",
      "10-bound": [5.42, 6.08],
      "25-mid": "6.52",
      "25-bound": [6.15, 6.9],
      "50-mid": "7.12",
      "50-bound": [6.69, 7.55],
      "100-mid": "7.7",
      "100-bound": [7.2, 8.18]
    }
  },
  "USC00361354 6": {
    "fips": "42055",
    "station_name": "CHAMBERSBURG 1 ESE",
    "state": "PA",
    "latitude": "39.9350",
    "longitude": "-77.6390",
    "5min": {
      "2-mid": "0.41",
      "2-bound": [0.37, 0.46],
      "5-mid": "0.5",
      "5-bound": [0.44, 0.56],
      "10-mid": "0.57",
      "10-bound": [0.51, 0.63],
      "25-mid": "0.66",
      "25-bound": [0.58, 0.73],
      "50-mid": "0.73",
      "50-bound": [0.65, 0.82],
      "100-mid": "0.81",
      "100-bound": [0.71, 0.9]
    },
    "10min": {
      "2-mid": "0.64",
      "2-bound": [0.57, 0.72],
      "5-mid": "0.77",
      "5-bound": [0.69, 0.87],
      "10-mid": "0.87",
      "10-bound": [0.78, 0.97],
      "25-mid": "1.01",
      "25-bound": [0.9, 1.12],
      "50-mid": "1.11",
      "50-bound": [0.98, 1.24],
      "100-mid": "1.22",
      "100-bound": [1.07, 1.36]
    },
    "15min": {
      "2-mid": "0.78",
      "2-bound": [0.7, 0.88],
      "5-mid": "0.95",
      "5-bound": [0.85, 1.06],
      "10-mid": "1.08",
      "10-bound": [0.96, 1.2],
      "25-mid": "1.25",
      "25-bound": [1.11, 1.39],
      "50-mid": "1.38",
      "50-bound": [1.22, 1.53],
      "100-mid": "1.52",
      "100-bound": [1.33, 1.68]
    },
    "30min": {
      "2-mid": "1.05",
      "2-bound": [0.94, 1.17],
      "5-mid": "1.3",
      "5-bound": [1.16, 1.46],
      "10-mid": "1.49",
      "10-bound": [1.33, 1.66],
      "25-mid": "1.76",
      "25-bound": [1.56, 1.96],
      "50-mid": "1.97",
      "50-bound": [1.74, 2.19],
      "100-mid": "2.19",
      "100-bound": [1.92, 2.43]
    },
    "60min": {
      "2-mid": "1.29",
      "2-bound": [1.15, 1.44],
      "5-mid": "1.63",
      "5-bound": [1.46, 1.83],
      "10-mid": "1.9",
      "10-bound": [1.69, 2.12],
      "25-mid": "2.29",
      "25-bound": [2.02, 2.54],
      "50-mid": "2.6",
      "50-bound": [2.29, 2.88],
      "100-mid": "2.93",
      "100-bound": [2.57, 3.25]
    },
    "2hr": {
      "2-mid": "1.49",
      "2-bound": [1.33, 1.68],
      "5-mid": "1.89",
      "5-bound": [1.68, 2.12],
      "10-mid": "2.22",
      "10-bound": [1.97, 2.49],
      "25-mid": "2.7",
      "25-bound": [2.38, 3.02],
      "50-mid": "3.11",
      "50-bound": [2.72, 3.47],
      "100-mid": "3.56",
      "100-bound": [3.1, 3.97]
    },
    "3hr": {
      "2-mid": "1.62",
      "2-bound": [1.45, 1.84],
      "5-mid": "2.05",
      "5-bound": [1.83, 2.33],
      "10-mid": "2.4",
      "10-bound": [2.13, 2.71],
      "25-mid": "2.92",
      "25-bound": [2.57, 3.29],
      "50-mid": "3.36",
      "50-bound": [2.94, 3.78],
      "100-mid": "3.85",
      "100-bound": [3.36, 4.33]
    },
    "6hr": {
      "2-mid": "2.05",
      "2-bound": [1.84, 2.32],
      "5-mid": "2.56",
      "5-bound": [2.3, 2.89],
      "10-mid": "2.99",
      "10-bound": [2.67, 3.37],
      "25-mid": "3.62",
      "25-bound": [3.2, 4.06],
      "50-mid": "4.16",
      "50-bound": [3.66, 4.66],
      "100-mid": "4.76",
      "100-bound": [4.16, 5.33]
    },
    "12hr": {
      "2-mid": "2.53",
      "2-bound": [2.26, 2.85],
      "5-mid": "3.15",
      "5-bound": [2.8, 3.53],
      "10-mid": "3.67",
      "10-bound": [3.26, 4.11],
      "25-mid": "4.46",
      "25-bound": [3.93, 4.97],
      "50-mid": "5.14",
      "50-bound": [4.5, 5.72],
      "100-mid": "5.92",
      "100-bound": [5.14, 6.57]
    },
    "24hr": {
      "2-mid": "2.94",
      "2-bound": [2.71, 3.22],
      "5-mid": "3.66",
      "5-bound": [3.36, 3.99],
      "10-mid": "4.27",
      "10-bound": [3.91, 4.64],
      "25-mid": "5.18",
      "25-bound": [4.72, 5.62],
      "50-mid": "5.98",
      "50-bound": [5.41, 6.46],
      "100-mid": "6.88",
      "100-bound": [6.17, 7.41]
    },
    "2day": {
      "2-mid": "3.42",
      "2-bound": [3.15, 3.74],
      "5-mid": "4.24",
      "5-bound": [3.89, 4.63],
      "10-mid": "4.94",
      "10-bound": [4.52, 5.39],
      "25-mid": "6.0",
      "25-bound": [5.46, 6.53],
      "50-mid": "6.93",
      "50-bound": [6.26, 7.53],
      "100-mid": "7.97",
      "100-bound": [7.15, 8.65]
    },
    "3day": {
      "2-mid": "3.64",
      "2-bound": [3.36, 3.98],
      "5-mid": "4.49",
      "5-bound": [4.14, 4.91],
      "10-mid": "5.22",
      "10-bound": [4.8, 5.69],
      "25-mid": "6.32",
      "25-bound": [5.77, 6.88],
      "50-mid": "7.28",
      "50-bound": [6.61, 7.91],
      "100-mid": "8.36",
      "100-bound": [7.53, 9.07]
    },
    "4day": {
      "2-mid": "3.86",
      "2-bound": [3.57, 4.22],
      "5-mid": "4.75",
      "5-bound": [4.38, 5.18],
      "10-mid": "5.51",
      "10-bound": [5.07, 6.0],
      "25-mid": "6.64",
      "25-bound": [6.08, 7.23],
      "50-mid": "7.64",
      "50-bound": [6.96, 8.3],
      "100-mid": "8.75",
      "100-bound": [7.91, 9.5]
    },
    "7day": {
      "2-mid": "4.5",
      "2-bound": [4.19, 4.87],
      "5-mid": "5.49",
      "5-bound": [5.09, 5.93],
      "10-mid": "6.31",
      "10-bound": [5.84, 6.8],
      "25-mid": "7.51",
      "25-bound": [6.92, 8.1],
      "50-mid": "8.54",
      "50-bound": [7.83, 9.2],
      "100-mid": "9.68",
      "100-bound": [8.81, 10.4]
    }
  },
  "USC00441209 6": {
    "fips": "51185",
    "station_name": "BURKES GARDEN",
    "state": "VA",
    "latitude": "37.0900",
    "longitude": "-81.3363",
    "5min": {
      "2-mid": "0.35",
      "2-bound": [0.31, 0.39],
      "5-mid": "0.41",
      "5-bound": [0.37, 0.46],
      "10-mid": "0.47",
      "10-bound": [0.42, 0.52],
      "25-mid": "0.54",
      "25-bound": [0.47, 0.6],
      "50-mid": "0.59",
      "50-bound": [0.52, 0.67],
      "100-mid": "0.65",
      "100-bound": [0.56, 0.74]
    },
    "10min": {
      "2-mid": "0.56",
      "2-bound": [0.5, 0.62],
      "5-mid": "0.66",
      "5-bound": [0.59, 0.74],
      "10-mid": "0.75",
      "10-bound": [0.67, 0.83],
      "25-mid": "0.86",
      "25-bound": [0.76, 0.96],
      "50-mid": "0.94",
      "50-bound": [0.82, 1.07],
      "100-mid": "1.04",
      "100-bound": [0.89, 1.18]
    },
    "15min": {
      "2-mid": "0.7",
      "2-bound": [0.63, 0.78],
      "5-mid": "0.84",
      "5-bound": [0.75, 0.94],
      "10-mid": "0.94",
      "10-bound": [0.84, 1.06],
      "25-mid": "1.09",
      "25-bound": [0.96, 1.22],
      "50-mid": "1.2",
      "50-bound": [1.04, 1.35],
      "100-mid": "1.31",
      "100-bound": [1.12, 1.49]
    },
    "30min": {
      "2-mid": "0.97",
      "2-bound": [0.87, 1.08],
      "5-mid": "1.19",
      "5-bound": [1.07, 1.33],
      "10-mid": "1.37",
      "10-bound": [1.22, 1.53],
      "25-mid": "1.61",
      "25-bound": [1.42, 1.81],
      "50-mid": "1.8",
      "50-bound": [1.57, 2.04],
      "100-mid": "2.01",
      "100-bound": [1.72, 2.29]
    },
    "60min": {
      "2-mid": "1.21",
      "2-bound": [1.09, 1.36],
      "5-mid": "1.52",
      "5-bound": [1.37, 1.7],
      "10-mid": "1.78",
      "10-bound": [1.59, 1.99],
      "25-mid": "2.14",
      "25-bound": [1.89, 2.4],
      "50-mid": "2.44",
      "50-bound": [2.12, 2.76],
      "100-mid": "2.76",
      "100-bound": [2.36, 3.15]
    },
    "2hr": {
      "2-mid": "1.39",
      "2-bound": [1.26, 1.55],
      "5-mid": "1.76",
      "5-bound": [1.58, 1.96],
      "10-mid": "2.06",
      "10-bound": [1.85, 2.3],
      "25-mid": "2.52",
      "25-bound": [2.22, 2.82],
      "50-mid": "2.9",
      "50-bound": [2.53, 3.27],
      "100-mid": "3.32",
      "100-bound": [2.84, 3.77]
    },
    "3hr": {
      "2-mid": "1.5",
      "2-bound": [1.36, 1.66],
      "5-mid": "1.89",
      "5-bound": [1.71, 2.09],
      "10-mid": "2.21",
      "10-bound": [1.99, 2.45],
      "25-mid": "2.69",
      "25-bound": [2.38, 3.0],
      "50-mid": "3.1",
      "50-bound": [2.71, 3.48],
      "100-mid": "3.55",
      "100-bound": [3.05, 4.02]
    },
    "6hr": {
      "2-mid": "1.82",
      "2-bound": [1.66, 2.0],
      "5-mid": "2.26",
      "5-bound": [2.06, 2.48],
      "10-mid": "2.63",
      "10-bound": [2.38, 2.9],
      "25-mid": "3.17",
      "25-bound": [2.84, 3.5],
      "50-mid": "3.62",
      "50-bound": [3.2, 4.03],
      "100-mid": "4.11",
      "100-bound": [3.58, 4.62]
    },
    "12hr": {
      "2-mid": "2.27",
      "2-bound": [2.1, 2.48],
      "5-mid": "2.78",
      "5-bound": [2.56, 3.04],
      "10-mid": "3.19",
      "10-bound": [2.92, 3.5],
      "25-mid": "3.77",
      "25-bound": [3.41, 4.15],
      "50-mid": "4.24",
      "50-bound": [3.8, 4.7],
      "100-mid": "4.74",
      "100-bound": [4.19, 5.3]
    },
    "24hr": {
      "2-mid": "2.87",
      "2-bound": [2.71, 3.06],
      "5-mid": "3.44",
      "5-bound": [3.25, 3.67],
      "10-mid": "3.9",
      "10-bound": [3.67, 4.15],
      "25-mid": "4.53",
      "25-bound": [4.24, 4.82],
      "50-mid": "5.03",
      "50-bound": [4.69, 5.36],
      "100-mid": "5.55",
      "100-bound": [5.15, 5.93]
    },
    "2day": {
      "2-mid": "3.46",
      "2-bound": [3.27, 3.67],
      "5-mid": "4.12",
      "5-bound": [3.89, 4.37],
      "10-mid": "4.63",
      "10-bound": [4.38, 4.92],
      "25-mid": "5.32",
      "25-bound": [5.01, 5.65],
      "50-mid": "5.87",
      "50-bound": [5.5, 6.24],
      "100-mid": "6.42",
      "100-bound": [5.99, 6.85]
    },
    "3day": {
      "2-mid": "3.72",
      "2-bound": [3.53, 3.94],
      "5-mid": "4.41",
      "5-bound": [4.18, 4.67],
      "10-mid": "4.94",
      "10-bound": [4.68, 5.23],
      "25-mid": "5.65",
      "25-bound": [5.33, 5.99],
      "50-mid": "6.2",
      "50-bound": [5.82, 6.58],
      "100-mid": "6.75",
      "100-bound": [6.31, 7.19]
    },
    "4day": {
      "2-mid": "3.99",
      "2-bound": [3.78, 4.21],
      "5-mid": "4.71",
      "5-bound": [4.47, 4.96],
      "10-mid": "5.26",
      "10-bound": [4.98, 5.54],
      "25-mid": "5.98",
      "25-bound": [5.64, 6.32],
      "50-mid": "6.54",
      "50-bound": [6.14, 6.92],
      "100-mid": "7.09",
      "100-bound": [6.62, 7.53]
    },
    "7day": {
      "2-mid": "4.63",
      "2-bound": [4.4, 4.87],
      "5-mid": "5.43",
      "5-bound": [5.16, 5.71],
      "10-mid": "6.02",
      "10-bound": [5.72, 6.34],
      "25-mid": "6.8",
      "25-bound": [6.44, 7.17],
      "50-mid": "7.38",
      "50-bound": [6.96, 7.79],
      "100-mid": "7.95",
      "100-bound": [7.47, 8.42]
    }
  },
  "USC00300379 6": {
    "fips": "36067",
    "station_name": "BALDWINSVILLE",
    "state": "NY",
    "latitude": "43.1000",
    "longitude": "-76.3330",
    "5min": {
      "2-mid": "0.33",
      "2-bound": [0.27, 0.41],
      "5-mid": "0.43",
      "5-bound": [0.35, 0.53],
      "10-mid": "0.51",
      "10-bound": [0.41, 0.63],
      "25-mid": "0.62",
      "25-bound": [0.48, 0.8],
      "50-mid": "0.7",
      "50-bound": [0.53, 0.92],
      "100-mid": "0.78",
      "100-bound": [0.57, 1.07]
    },
    "10min": {
      "2-mid": "0.47",
      "2-bound": [0.39, 0.58],
      "5-mid": "0.61",
      "5-bound": [0.49, 0.75],
      "10-mid": "0.72",
      "10-bound": [0.58, 0.89],
      "25-mid": "0.87",
      "25-bound": [0.68, 1.13],
      "50-mid": "0.99",
      "50-bound": [0.75, 1.3],
      "100-mid": "1.11",
      "100-bound": [0.81, 1.52]
    },
    "15min": {
      "2-mid": "0.56",
      "2-bound": [0.45, 0.68],
      "5-mid": "0.72",
      "5-bound": [0.58, 0.88],
      "10-mid": "0.85",
      "10-bound": [0.68, 1.05],
      "25-mid": "1.03",
      "25-bound": [0.8, 1.33],
      "50-mid": "1.16",
      "50-bound": [0.88, 1.53],
      "100-mid": "1.31",
      "100-bound": [0.95, 1.78]
    },
    "30min": {
      "2-mid": "0.77",
      "2-bound": [0.63, 0.95],
      "5-mid": "0.99",
      "5-bound": [0.81, 1.23],
      "10-mid": "1.18",
      "10-bound": [0.95, 1.46],
      "25-mid": "1.43",
      "25-bound": [1.1, 1.85],
      "50-mid": "1.62",
      "50-bound": [1.22, 2.13],
      "100-mid": "1.82",
      "100-bound": [1.32, 2.48]
    },
    "60min": {
      "2-mid": "0.99",
      "2-bound": [0.81, 1.22],
      "5-mid": "1.27",
      "5-bound": [1.03, 1.57],
      "10-mid": "1.51",
      "10-bound": [1.21, 1.87],
      "25-mid": "1.83",
      "25-bound": [1.42, 2.36],
      "50-mid": "2.07",
      "50-bound": [1.56, 2.73],
      "100-mid": "2.33",
      "100-bound": [1.7, 3.18]
    },
    "2hr": {
      "2-mid": "1.24",
      "2-bound": [1.02, 1.52],
      "5-mid": "1.57",
      "5-bound": [1.28, 1.92],
      "10-mid": "1.84",
      "10-bound": [1.5, 2.27],
      "25-mid": "2.22",
      "25-bound": [1.73, 2.84],
      "50-mid": "2.5",
      "50-bound": [1.9, 3.26],
      "100-mid": "2.8",
      "100-bound": [2.05, 3.77]
    },
    "3hr": {
      "2-mid": "1.41",
      "2-bound": [1.16, 1.71],
      "5-mid": "1.76",
      "5-bound": [1.45, 2.15],
      "10-mid": "2.06",
      "10-bound": [1.68, 2.52],
      "25-mid": "2.46",
      "25-bound": [1.93, 3.14],
      "50-mid": "2.77",
      "50-bound": [2.12, 3.6],
      "100-mid": "3.09",
      "100-bound": [2.28, 4.15]
    },
    "6hr": {
      "2-mid": "1.7",
      "2-bound": [1.41, 2.05],
      "5-mid": "2.12",
      "5-bound": [1.75, 2.56],
      "10-mid": "2.47",
      "10-bound": [2.03, 3.0],
      "25-mid": "2.95",
      "25-bound": [2.33, 3.72],
      "50-mid": "3.31",
      "50-bound": [2.55, 4.26],
      "100-mid": "3.69",
      "100-bound": [2.74, 4.9]
    },
    "12hr": {
      "2-mid": "2.01",
      "2-bound": [1.68, 2.41],
      "5-mid": "2.52",
      "5-bound": [2.1, 3.02],
      "10-mid": "2.94",
      "10-bound": [2.43, 3.54],
      "25-mid": "3.52",
      "25-bound": [2.8, 4.4],
      "50-mid": "3.95",
      "50-bound": [3.07, 5.04],
      "100-mid": "4.41",
      "100-bound": [3.31, 5.81]
    },
    "24hr": {
      "2-mid": "2.35",
      "2-bound": [1.98, 2.79],
      "5-mid": "2.94",
      "5-bound": [2.47, 3.49],
      "10-mid": "3.42",
      "10-bound": [2.86, 4.09],
      "25-mid": "4.09",
      "25-bound": [3.29, 5.08],
      "50-mid": "4.6",
      "50-bound": [3.61, 5.81],
      "100-mid": "5.12",
      "100-bound": [3.88, 6.69]
    },
    "2day": {
      "2-mid": "2.74",
      "2-bound": [2.33, 3.22],
      "5-mid": "3.37",
      "5-bound": [2.86, 3.98],
      "10-mid": "3.9",
      "10-bound": [3.28, 4.62],
      "25-mid": "4.62",
      "25-bound": [3.74, 5.68],
      "50-mid": "5.17",
      "50-bound": [4.09, 6.47],
      "100-mid": "5.74",
      "100-bound": [4.38, 7.4]
    },
    "3day": {
      "2-mid": "3.02",
      "2-bound": [2.58, 3.53],
      "5-mid": "3.68",
      "5-bound": [3.13, 4.32],
      "10-mid": "4.23",
      "10-bound": [3.57, 4.98],
      "25-mid": "4.98",
      "25-bound": [4.05, 6.08],
      "50-mid": "5.55",
      "50-bound": [4.41, 6.9],
      "100-mid": "6.14",
      "100-bound": [4.7, 7.86]
    },
    "4day": {
      "2-mid": "3.26",
      "2-bound": [2.8, 3.81],
      "5-mid": "3.94",
      "5-bound": [3.36, 4.61],
      "10-mid": "4.5",
      "10-bound": [3.82, 5.29],
      "25-mid": "5.27",
      "25-bound": [4.31, 6.41],
      "50-mid": "5.86",
      "50-bound": [4.67, 7.25],
      "100-mid": "6.46",
      "100-bound": [4.97, 8.24]
    },
    "7day": {
      "2-mid": "3.9",
      "2-bound": [3.37, 4.52],
      "5-mid": "4.62",
      "5-bound": [3.97, 5.37],
      "10-mid": "5.22",
      "10-bound": [4.46, 6.09],
      "25-mid": "6.04",
      "25-bound": [4.96, 7.28],
      "50-mid": "6.66",
      "50-bound": [5.35, 8.17],
      "100-mid": "7.3",
      "100-bound": [5.64, 9.2]
    }
  },
  "USC00460102 6": {
    "fips": "54063",
    "station_name": "ALDERSON",
    "state": "WV",
    "latitude": "37.7271",
    "longitude": "-80.6583",
    "5min": {
      "2-mid": "0.34",
      "2-bound": [0.31, 0.38],
      "5-mid": "0.41",
      "5-bound": [0.37, 0.45],
      "10-mid": "0.45",
      "10-bound": [0.41, 0.5],
      "25-mid": "0.51",
      "25-bound": [0.45, 0.56],
      "50-mid": "0.55",
      "50-bound": [0.48, 0.61],
      "100-mid": "0.58",
      "100-bound": [0.51, 0.65]
    },
    "10min": {
      "2-mid": "0.55",
      "2-bound": [0.49, 0.61],
      "5-mid": "0.65",
      "5-bound": [0.59, 0.72],
      "10-mid": "0.72",
      "10-bound": [0.65, 0.8],
      "25-mid": "0.81",
      "25-bound": [0.72, 0.9],
      "50-mid": "0.87",
      "50-bound": [0.77, 0.96],
      "100-mid": "0.92",
      "100-bound": [0.81, 1.03]
    },
    "15min": {
      "2-mid": "0.69",
      "2-bound": [0.62, 0.77],
      "5-mid": "0.82",
      "5-bound": [0.74, 0.92],
      "10-mid": "0.92",
      "10-bound": [0.82, 1.02],
      "25-mid": "1.02",
      "25-bound": [0.91, 1.14],
      "50-mid": "1.1",
      "50-bound": [0.97, 1.22],
      "100-mid": "1.16",
      "100-bound": [1.02, 1.3]
    },
    "30min": {
      "2-mid": "0.95",
      "2-bound": [0.85, 1.06],
      "5-mid": "1.17",
      "5-bound": [1.05, 1.3],
      "10-mid": "1.32",
      "10-bound": [1.18, 1.47],
      "25-mid": "1.51",
      "25-bound": [1.34, 1.68],
      "50-mid": "1.65",
      "50-bound": [1.46, 1.83],
      "100-mid": "1.78",
      "100-bound": [1.55, 1.98]
    },
    "60min": {
      "2-mid": "1.19",
      "2-bound": [1.07, 1.32],
      "5-mid": "1.5",
      "5-bound": [1.35, 1.67],
      "10-mid": "1.72",
      "10-bound": [1.54, 1.91],
      "25-mid": "2.02",
      "25-bound": [1.79, 2.24],
      "50-mid": "2.23",
      "50-bound": [1.97, 2.48],
      "100-mid": "2.44",
      "100-bound": [2.14, 2.73]
    },
    "2hr": {
      "2-mid": "1.37",
      "2-bound": [1.25, 1.51],
      "5-mid": "1.72",
      "5-bound": [1.56, 1.89],
      "10-mid": "1.98",
      "10-bound": [1.78, 2.17],
      "25-mid": "2.31",
      "25-bound": [2.07, 2.54],
      "50-mid": "2.56",
      "50-bound": [2.28, 2.83],
      "100-mid": "2.81",
      "100-bound": [2.48, 3.11]
    },
    "3hr": {
      "2-mid": "1.46",
      "2-bound": [1.34, 1.61],
      "5-mid": "1.82",
      "5-bound": [1.66, 2.0],
      "10-mid": "2.09",
      "10-bound": [1.9, 2.29],
      "25-mid": "2.44",
      "25-bound": [2.21, 2.68],
      "50-mid": "2.71",
      "50-bound": [2.43, 2.99],
      "100-mid": "2.98",
      "100-bound": [2.65, 3.3]
    },
    "6hr": {
      "2-mid": "1.76",
      "2-bound": [1.62, 1.94],
      "5-mid": "2.16",
      "5-bound": [1.99, 2.38],
      "10-mid": "2.48",
      "10-bound": [2.27, 2.73],
      "25-mid": "2.91",
      "25-bound": [2.64, 3.21],
      "50-mid": "3.26",
      "50-bound": [2.92, 3.6],
      "100-mid": "3.61",
      "100-bound": [3.19, 3.99]
    },
    "12hr": {
      "2-mid": "2.09",
      "2-bound": [1.93, 2.3],
      "5-mid": "2.56",
      "5-bound": [2.35, 2.81],
      "10-mid": "2.94",
      "10-bound": [2.69, 3.23],
      "25-mid": "3.48",
      "25-bound": [3.15, 3.82],
      "50-mid": "3.92",
      "50-bound": [3.51, 4.32],
      "100-mid": "4.39",
      "100-bound": [3.87, 4.86]
    },
    "24hr": {
      "2-mid": "2.56",
      "2-bound": [2.39, 2.76],
      "5-mid": "3.07",
      "5-bound": [2.86, 3.3],
      "10-mid": "3.48",
      "10-bound": [3.23, 3.73],
      "25-mid": "4.03",
      "25-bound": [3.73, 4.33],
      "50-mid": "4.47",
      "50-bound": [4.13, 4.81],
      "100-mid": "4.91",
      "100-bound": [4.52, 5.31]
    },
    "2day": {
      "2-mid": "3.05",
      "2-bound": [2.89, 3.24],
      "5-mid": "3.62",
      "5-bound": [3.41, 3.84],
      "10-mid": "4.06",
      "10-bound": [3.83, 4.31],
      "25-mid": "4.66",
      "25-bound": [4.37, 4.96],
      "50-mid": "5.12",
      "50-bound": [4.79, 5.45],
      "100-mid": "5.58",
      "100-bound": [5.2, 5.95]
    },
    "3day": {
      "2-mid": "3.26",
      "2-bound": [3.08, 3.46],
      "5-mid": "3.85",
      "5-bound": [3.63, 4.07],
      "10-mid": "4.3",
      "10-bound": [4.06, 4.56],
      "25-mid": "4.9",
      "25-bound": [4.6, 5.2],
      "50-mid": "5.36",
      "50-bound": [5.02, 5.69],
      "100-mid": "5.81",
      "100-bound": [5.42, 6.18]
    },
    "4day": {
      "2-mid": "3.47",
      "2-bound": [3.28, 3.66],
      "5-mid": "4.08",
      "5-bound": [3.85, 4.31],
      "10-mid": "4.54",
      "10-bound": [4.28, 4.8],
      "25-mid": "5.14",
      "25-bound": [4.84, 5.44],
      "50-mid": "5.6",
      "50-bound": [5.25, 5.93],
      "100-mid": "6.05",
      "100-bound": [5.64, 6.41]
    },
    "7day": {
      "2-mid": "4.04",
      "2-bound": [3.83, 4.27],
      "5-mid": "4.71",
      "5-bound": [4.46, 4.97],
      "10-mid": "5.21",
      "10-bound": [4.93, 5.5],
      "25-mid": "5.85",
      "25-bound": [5.52, 6.16],
      "50-mid": "6.32",
      "50-bound": [5.95, 6.68],
      "100-mid": "6.78",
      "100-bound": [6.35, 7.17]
    }
  },
  "USC00448192 6": {
    "fips": "51800",
    "station_name": "SUFFOLK LAKE KILBY",
    "state": "VA",
    "latitude": "36.7290",
    "longitude": "-76.6010",
    "5min": {
      "2-mid": "0.52",
      "2-bound": [0.47, 0.57],
      "5-mid": "0.59",
      "5-bound": [0.54, 0.66],
      "10-mid": "0.67",
      "10-bound": [0.61, 0.74],
      "25-mid": "0.76",
      "25-bound": [0.68, 0.83],
      "50-mid": "0.83",
      "50-bound": [0.74, 0.92],
      "100-mid": "0.9",
      "100-bound": [0.8, 0.99]
    },
    "10min": {
      "2-mid": "0.83",
      "2-bound": [0.75, 0.92],
      "5-mid": "0.95",
      "5-bound": [0.86, 1.05],
      "10-mid": "1.08",
      "10-bound": [0.97, 1.19],
      "25-mid": "1.21",
      "25-bound": [1.09, 1.33],
      "50-mid": "1.32",
      "50-bound": [1.18, 1.46],
      "100-mid": "1.43",
      "100-bound": [1.27, 1.58]
    },
    "15min": {
      "2-mid": "1.04",
      "2-bound": [0.95, 1.15],
      "5-mid": "1.2",
      "5-bound": [1.09, 1.33],
      "10-mid": "1.36",
      "10-bound": [1.23, 1.5],
      "25-mid": "1.53",
      "25-bound": [1.38, 1.69],
      "50-mid": "1.67",
      "50-bound": [1.5, 1.85],
      "100-mid": "1.8",
      "100-bound": [1.61, 1.99]
    },
    "30min": {
      "2-mid": "1.44",
      "2-bound": [1.31, 1.59],
      "5-mid": "1.71",
      "5-bound": [1.55, 1.88],
      "10-mid": "1.97",
      "10-bound": [1.78, 2.18],
      "25-mid": "2.27",
      "25-bound": [2.04, 2.5],
      "50-mid": "2.52",
      "50-bound": [2.26, 2.78],
      "100-mid": "2.76",
      "100-bound": [2.46, 3.05]
    },
    "60min": {
      "2-mid": "1.81",
      "2-bound": [1.64, 2.0],
      "5-mid": "2.19",
      "5-bound": [1.98, 2.42],
      "10-mid": "2.57",
      "10-bound": [2.32, 2.84],
      "25-mid": "3.02",
      "25-bound": [2.72, 3.33],
      "50-mid": "3.41",
      "50-bound": [3.06, 3.77],
      "100-mid": "3.8",
      "100-bound": [3.39, 4.2]
    },
    "2hr": {
      "2-mid": "2.1",
      "2-bound": [1.89, 2.33],
      "5-mid": "2.59",
      "5-bound": [2.33, 2.87],
      "10-mid": "3.08",
      "10-bound": [2.77, 3.42],
      "25-mid": "3.7",
      "25-bound": [3.31, 4.09],
      "50-mid": "4.25",
      "50-bound": [3.78, 4.7],
      "100-mid": "4.81",
      "100-bound": [4.25, 5.31]
    },
    "3hr": {
      "2-mid": "2.25",
      "2-bound": [2.02, 2.52],
      "5-mid": "2.78",
      "5-bound": [2.49, 3.11],
      "10-mid": "3.33",
      "10-bound": [2.98, 3.73],
      "25-mid": "4.04",
      "25-bound": [3.58, 4.5],
      "50-mid": "4.68",
      "50-bound": [4.14, 5.22],
      "100-mid": "5.35",
      "100-bound": [4.7, 5.95]
    },
    "6hr": {
      "2-mid": "2.68",
      "2-bound": [2.4, 3.01],
      "5-mid": "3.32",
      "5-bound": [2.96, 3.73],
      "10-mid": "3.99",
      "10-bound": [3.55, 4.48],
      "25-mid": "4.85",
      "25-bound": [4.29, 5.43],
      "50-mid": "5.66",
      "50-bound": [4.98, 6.31],
      "100-mid": "6.49",
      "100-bound": [5.66, 7.23]
    },
    "12hr": {
      "2-mid": "3.14",
      "2-bound": [2.8, 3.56],
      "5-mid": "3.91",
      "5-bound": [3.48, 4.42],
      "10-mid": "4.73",
      "10-bound": [4.18, 5.33],
      "25-mid": "5.8",
      "25-bound": [5.09, 6.52],
      "50-mid": "6.82",
      "50-bound": [5.94, 7.65],
      "100-mid": "7.88",
      "100-bound": [6.81, 8.83]
    },
    "24hr": {
      "2-mid": "3.64",
      "2-bound": [3.34, 3.99],
      "5-mid": "4.69",
      "5-bound": [4.31, 5.16],
      "10-mid": "5.59",
      "10-bound": [5.11, 6.12],
      "25-mid": "6.9",
      "25-bound": [6.26, 7.55],
      "50-mid": "8.04",
      "50-bound": [7.23, 8.78],
      "100-mid": "9.28",
      "100-bound": [8.27, 10.1]
    },
    "2day": {
      "2-mid": "4.21",
      "2-bound": [3.88, 4.62],
      "5-mid": "5.4",
      "5-bound": [4.96, 5.92],
      "10-mid": "6.42",
      "10-bound": [5.87, 7.03],
      "25-mid": "7.96",
      "25-bound": [7.22, 8.7],
      "50-mid": "9.3",
      "50-bound": [8.37, 10.2],
      "100-mid": "10.8",
      "100-bound": [9.59, 11.8]
    },
    "3day": {
      "2-mid": "4.48",
      "2-bound": [4.13, 4.9],
      "5-mid": "5.72",
      "5-bound": [5.27, 6.25],
      "10-mid": "6.78",
      "10-bound": [6.21, 7.39],
      "25-mid": "8.33",
      "25-bound": [7.57, 9.07],
      "50-mid": "9.65",
      "50-bound": [8.71, 10.5],
      "100-mid": "11.1",
      "100-bound": [9.92, 12.1]
    },
    "4day": {
      "2-mid": "4.75",
      "2-bound": [4.39, 5.18],
      "5-mid": "6.05",
      "5-bound": [5.57, 6.59],
      "10-mid": "7.13",
      "10-bound": [6.54, 7.75],
      "25-mid": "8.69",
      "25-bound": [7.93, 9.44],
      "50-mid": "10.0",
      "50-bound": [9.06, 10.9],
      "100-mid": "11.4",
      "100-bound": [10.3, 12.4]
    },
    "7day": {
      "2-mid": "5.56",
      "2-bound": [5.15, 6.03],
      "5-mid": "6.99",
      "5-bound": [6.46, 7.57],
      "10-mid": "8.16",
      "10-bound": [7.51, 8.83],
      "25-mid": "9.86",
      "25-bound": [9.02, 10.7],
      "50-mid": "11.3",
      "50-bound": [10.2, 12.2],
      "100-mid": "12.8",
      "100-bound": [11.5, 13.8]
    }
  },
  "USC00307705 6": {
    "fips": "36017",
    "station_name": "SHERBURNE",
    "state": "NY",
    "latitude": "42.6770",
    "longitude": "-75.5060",
    "5min": {
      "2-mid": "0.33",
      "2-bound": [0.27, 0.41],
      "5-mid": "0.43",
      "5-bound": [0.34, 0.53],
      "10-mid": "0.51",
      "10-bound": [0.4, 0.63],
      "25-mid": "0.62",
      "25-bound": [0.47, 0.8],
      "50-mid": "0.7",
      "50-bound": [0.53, 0.93],
      "100-mid": "0.79",
      "100-bound": [0.57, 1.09]
    },
    "10min": {
      "2-mid": "0.47",
      "2-bound": [0.38, 0.58],
      "5-mid": "0.6",
      "5-bound": [0.48, 0.75],
      "10-mid": "0.72",
      "10-bound": [0.57, 0.89],
      "25-mid": "0.88",
      "25-bound": [0.67, 1.14],
      "50-mid": "0.99",
      "50-bound": [0.74, 1.32],
      "100-mid": "1.12",
      "100-bound": [0.81, 1.54]
    },
    "15min": {
      "2-mid": "0.55",
      "2-bound": [0.44, 0.68],
      "5-mid": "0.71",
      "5-bound": [0.57, 0.88],
      "10-mid": "0.84",
      "10-bound": [0.67, 1.05],
      "25-mid": "1.03",
      "25-bound": [0.79, 1.34],
      "50-mid": "1.17",
      "50-bound": [0.88, 1.55],
      "100-mid": "1.31",
      "100-bound": [0.95, 1.81]
    },
    "30min": {
      "2-mid": "0.74",
      "2-bound": [0.59, 0.91],
      "5-mid": "0.96",
      "5-bound": [0.77, 1.19],
      "10-mid": "1.14",
      "10-bound": [0.91, 1.42],
      "25-mid": "1.39",
      "25-bound": [1.06, 1.8],
      "50-mid": "1.57",
      "50-bound": [1.18, 2.09],
      "100-mid": "1.77",
      "100-bound": [1.28, 2.44]
    },
    "60min": {
      "2-mid": "0.93",
      "2-bound": [0.75, 1.15],
      "5-mid": "1.2",
      "5-bound": [0.96, 1.49],
      "10-mid": "1.43",
      "10-bound": [1.14, 1.78],
      "25-mid": "1.74",
      "25-bound": [1.34, 2.27],
      "50-mid": "1.97",
      "50-bound": [1.48, 2.62],
      "100-mid": "2.22",
      "100-bound": [1.61, 3.07]
    },
    "2hr": {
      "2-mid": "1.16",
      "2-bound": [0.94, 1.43],
      "5-mid": "1.48",
      "5-bound": [1.19, 1.82],
      "10-mid": "1.74",
      "10-bound": [1.39, 2.14],
      "25-mid": "2.09",
      "25-bound": [1.62, 2.71],
      "50-mid": "2.35",
      "50-bound": [1.79, 3.12],
      "100-mid": "2.64",
      "100-bound": [1.95, 3.65]
    },
    "3hr": {
      "2-mid": "1.32",
      "2-bound": [1.07, 1.61],
      "5-mid": "1.66",
      "5-bound": [1.35, 2.03],
      "10-mid": "1.94",
      "10-bound": [1.56, 2.39],
      "25-mid": "2.33",
      "25-bound": [1.82, 3.01],
      "50-mid": "2.62",
      "50-bound": [2.0, 3.46],
      "100-mid": "2.93",
      "100-bound": [2.18, 4.05]
    },
    "6hr": {
      "2-mid": "1.62",
      "2-bound": [1.33, 1.97],
      "5-mid": "2.04",
      "5-bound": [1.66, 2.48],
      "10-mid": "2.38",
      "10-bound": [1.93, 2.91],
      "25-mid": "2.86",
      "25-bound": [2.24, 3.66],
      "50-mid": "3.2",
      "50-bound": [2.46, 4.2],
      "100-mid": "3.59",
      "100-bound": [2.68, 4.92]
    },
    "12hr": {
      "2-mid": "1.97",
      "2-bound": [1.63, 2.38],
      "5-mid": "2.5",
      "5-bound": [2.06, 3.02],
      "10-mid": "2.94",
      "10-bound": [2.4, 3.56],
      "25-mid": "3.54",
      "25-bound": [2.79, 4.49],
      "50-mid": "3.98",
      "50-bound": [3.07, 5.16],
      "100-mid": "4.47",
      "100-bound": [3.35, 6.03]
    },
    "24hr": {
      "2-mid": "2.36",
      "2-bound": [1.96, 2.81],
      "5-mid": "2.99",
      "5-bound": [2.48, 3.59],
      "10-mid": "3.52",
      "10-bound": [2.9, 4.24],
      "25-mid": "4.25",
      "25-bound": [3.37, 5.34],
      "50-mid": "4.79",
      "50-bound": [3.71, 6.14],
      "100-mid": "5.37",
      "100-bound": [4.03, 7.14]
    },
    "2day": {
      "2-mid": "2.76",
      "2-bound": [2.32, 3.28],
      "5-mid": "3.47",
      "5-bound": [2.9, 4.13],
      "10-mid": "4.06",
      "10-bound": [3.37, 4.86],
      "25-mid": "4.87",
      "25-bound": [3.89, 6.06],
      "50-mid": "5.48",
      "50-bound": [4.27, 6.94],
      "100-mid": "6.12",
      "100-bound": [4.61, 8.03]
    },
    "3day": {
      "2-mid": "3.04",
      "2-bound": [2.56, 3.59],
      "5-mid": "3.78",
      "5-bound": [3.17, 4.48],
      "10-mid": "4.39",
      "10-bound": [3.66, 5.23],
      "25-mid": "5.24",
      "25-bound": [4.2, 6.47],
      "50-mid": "5.87",
      "50-bound": [4.59, 7.39],
      "100-mid": "6.54",
      "100-bound": [4.93, 8.5]
    },
    "4day": {
      "2-mid": "3.27",
      "2-bound": [2.77, 3.85],
      "5-mid": "4.03",
      "5-bound": [3.39, 4.76],
      "10-mid": "4.66",
      "10-bound": [3.9, 5.53],
      "25-mid": "5.52",
      "25-bound": [4.44, 6.79],
      "50-mid": "6.18",
      "50-bound": [4.84, 7.73],
      "100-mid": "6.86",
      "100-bound": [5.17, 8.86]
    },
    "7day": {
      "2-mid": "3.89",
      "2-bound": [3.31, 4.56],
      "5-mid": "4.69",
      "5-bound": [3.98, 5.51],
      "10-mid": "5.35",
      "10-bound": [4.5, 6.31],
      "25-mid": "6.26",
      "25-bound": [5.06, 7.63],
      "50-mid": "6.96",
      "50-bound": [5.47, 8.61],
      "100-mid": "7.67",
      "100-bound": [5.79, 9.76]
    }
  },
  "USC00445300 6": {
    "fips": "51690",
    "station_name": "MARTINSVILLE FILTER PLANT",
    "state": "VA",
    "latitude": "36.7047",
    "longitude": "-79.8652",
    "5min": {
      "2-mid": "0.43",
      "2-bound": [0.4, 0.47],
      "5-mid": "0.51",
      "5-bound": [0.47, 0.56],
      "10-mid": "0.57",
      "10-bound": [0.52, 0.62],
      "25-mid": "0.64",
      "25-bound": [0.58, 0.69],
      "50-mid": "0.68",
      "50-bound": [0.62, 0.74],
      "100-mid": "0.72",
      "100-bound": [0.65, 0.79]
    },
    "10min": {
      "2-mid": "0.69",
      "2-bound": [0.63, 0.75],
      "5-mid": "0.82",
      "5-bound": [0.75, 0.9],
      "10-mid": "0.91",
      "10-bound": [0.83, 0.99],
      "25-mid": "1.01",
      "25-bound": [0.92, 1.1],
      "50-mid": "1.08",
      "50-bound": [0.98, 1.18],
      "100-mid": "1.15",
      "100-bound": [1.04, 1.26]
    },
    "15min": {
      "2-mid": "0.87",
      "2-bound": [0.79, 0.95],
      "5-mid": "1.04",
      "5-bound": [0.95, 1.13],
      "10-mid": "1.15",
      "10-bound": [1.05, 1.25],
      "25-mid": "1.28",
      "25-bound": [1.17, 1.4],
      "50-mid": "1.37",
      "50-bound": [1.24, 1.5],
      "100-mid": "1.46",
      "100-bound": [1.31, 1.59]
    },
    "30min": {
      "2-mid": "1.2",
      "2-bound": [1.1, 1.31],
      "5-mid": "1.47",
      "5-bound": [1.35, 1.61],
      "10-mid": "1.67",
      "10-bound": [1.52, 1.82],
      "25-mid": "1.9",
      "25-bound": [1.73, 2.07],
      "50-mid": "2.07",
      "50-bound": [1.87, 2.25],
      "100-mid": "2.23",
      "100-bound": [2.01, 2.43]
    },
    "60min": {
      "2-mid": "1.5",
      "2-bound": [1.38, 1.64],
      "5-mid": "1.89",
      "5-bound": [1.72, 2.06],
      "10-mid": "2.17",
      "10-bound": [1.98, 2.37],
      "25-mid": "2.53",
      "25-bound": [2.3, 2.76],
      "50-mid": "2.8",
      "50-bound": [2.54, 3.05],
      "100-mid": "3.07",
      "100-bound": [2.76, 3.35]
    },
    "2hr": {
      "2-mid": "1.81",
      "2-bound": [1.65, 1.99],
      "5-mid": "2.29",
      "5-bound": [2.09, 2.51],
      "10-mid": "2.66",
      "10-bound": [2.42, 2.91],
      "25-mid": "3.15",
      "25-bound": [2.85, 3.44],
      "50-mid": "3.53",
      "50-bound": [3.18, 3.86],
      "100-mid": "3.93",
      "100-bound": [3.5, 4.29]
    },
    "3hr": {
      "2-mid": "1.97",
      "2-bound": [1.8, 2.16],
      "5-mid": "2.49",
      "5-bound": [2.27, 2.72],
      "10-mid": "2.88",
      "10-bound": [2.63, 3.15],
      "25-mid": "3.42",
      "25-bound": [3.09, 3.73],
      "50-mid": "3.83",
      "50-bound": [3.45, 4.17],
      "100-mid": "4.26",
      "100-bound": [3.81, 4.64]
    },
    "6hr": {
      "2-mid": "2.43",
      "2-bound": [2.23, 2.68],
      "5-mid": "3.06",
      "5-bound": [2.81, 3.37],
      "10-mid": "3.57",
      "10-bound": [3.25, 3.92],
      "25-mid": "4.28",
      "25-bound": [3.86, 4.68],
      "50-mid": "4.85",
      "50-bound": [4.35, 5.3],
      "100-mid": "5.45",
      "100-bound": [4.85, 5.95]
    },
    "12hr": {
      "2-mid": "2.96",
      "2-bound": [2.71, 3.27],
      "5-mid": "3.75",
      "5-bound": [3.42, 4.13],
      "10-mid": "4.41",
      "10-bound": [4.0, 4.83],
      "25-mid": "5.35",
      "25-bound": [4.81, 5.84],
      "50-mid": "6.13",
      "50-bound": [5.47, 6.68],
      "100-mid": "6.98",
      "100-bound": [6.16, 7.6]
    },
    "24hr": {
      "2-mid": "3.47",
      "2-bound": [3.22, 3.75],
      "5-mid": "4.43",
      "5-bound": [4.11, 4.78],
      "10-mid": "5.24",
      "10-bound": [4.84, 5.65],
      "25-mid": "6.44",
      "25-bound": [5.91, 6.92],
      "50-mid": "7.46",
      "50-bound": [6.8, 8.01],
      "100-mid": "8.58",
      "100-bound": [7.76, 9.2]
    },
    "2day": {
      "2-mid": "4.09",
      "2-bound": [3.81, 4.42],
      "5-mid": "5.19",
      "5-bound": [4.83, 5.61],
      "10-mid": "6.1",
      "10-bound": [5.65, 6.57],
      "25-mid": "7.42",
      "25-bound": [6.84, 7.98],
      "50-mid": "8.52",
      "50-bound": [7.82, 9.16],
      "100-mid": "9.7",
      "100-bound": [8.84, 10.4]
    },
    "3day": {
      "2-mid": "4.32",
      "2-bound": [4.03, 4.67],
      "5-mid": "5.49",
      "5-bound": [5.11, 5.92],
      "10-mid": "6.45",
      "10-bound": [5.98, 6.94],
      "25-mid": "7.83",
      "25-bound": [7.23, 8.42],
      "50-mid": "8.98",
      "50-bound": [8.25, 9.67],
      "100-mid": "10.2",
      "100-bound": [9.33, 11.0]
    },
    "4day": {
      "2-mid": "4.56",
      "2-bound": [4.25, 4.91],
      "5-mid": "5.78",
      "5-bound": [5.39, 6.23],
      "10-mid": "6.79",
      "10-bound": [6.31, 7.31],
      "25-mid": "8.24",
      "25-bound": [7.61, 8.87],
      "50-mid": "9.45",
      "50-bound": [8.68, 10.2],
      "100-mid": "10.8",
      "100-bound": [9.82, 11.6]
    },
    "7day": {
      "2-mid": "5.18",
      "2-bound": [4.87, 5.54],
      "5-mid": "6.47",
      "5-bound": [6.07, 6.91],
      "10-mid": "7.53",
      "10-bound": [7.04, 8.03],
      "25-mid": "9.04",
      "25-bound": [8.41, 9.62],
      "50-mid": "10.3",
      "50-bound": [9.53, 11.0],
      "100-mid": "11.6",
      "100-bound": [10.7, 12.4]
    }
  },
  "USC00447338 6": {
    "fips": "51067",
    "station_name": "ROCKY MOUNT",
    "state": "VA",
    "latitude": "36.9760",
    "longitude": "-79.8960",
    "5min": {
      "2-mid": "0.42",
      "2-bound": [0.38, 0.46],
      "5-mid": "0.5",
      "5-bound": [0.45, 0.55],
      "10-mid": "0.56",
      "10-bound": [0.5, 0.61],
      "25-mid": "0.63",
      "25-bound": [0.56, 0.69],
      "50-mid": "0.68",
      "50-bound": [0.6, 0.74],
      "100-mid": "0.72",
      "100-bound": [0.64, 0.79]
    },
    "10min": {
      "2-mid": "0.67",
      "2-bound": [0.61, 0.74],
      "5-mid": "0.8",
      "5-bound": [0.72, 0.88],
      "10-mid": "0.89",
      "10-bound": [0.8, 0.98],
      "25-mid": "1.0",
      "25-bound": [0.9, 1.1],
      "50-mid": "1.08",
      "50-bound": [0.96, 1.18],
      "100-mid": "1.15",
      "100-bound": [1.02, 1.26]
    },
    "15min": {
      "2-mid": "0.84",
      "2-bound": [0.77, 0.93],
      "5-mid": "1.01",
      "5-bound": [0.92, 1.12],
      "10-mid": "1.13",
      "10-bound": [1.02, 1.24],
      "25-mid": "1.27",
      "25-bound": [1.14, 1.39],
      "50-mid": "1.36",
      "50-bound": [1.22, 1.5],
      "100-mid": "1.45",
      "100-bound": [1.29, 1.6]
    },
    "30min": {
      "2-mid": "1.16",
      "2-bound": [1.06, 1.29],
      "5-mid": "1.44",
      "5-bound": [1.3, 1.59],
      "10-mid": "1.63",
      "10-bound": [1.48, 1.8],
      "25-mid": "1.88",
      "25-bound": [1.69, 2.06],
      "50-mid": "2.05",
      "50-bound": [1.84, 2.25],
      "100-mid": "2.22",
      "100-bound": [1.98, 2.44]
    },
    "60min": {
      "2-mid": "1.46",
      "2-bound": [1.32, 1.62],
      "5-mid": "1.84",
      "5-bound": [1.67, 2.04],
      "10-mid": "2.13",
      "10-bound": [1.92, 2.34],
      "25-mid": "2.5",
      "25-bound": [2.25, 2.74],
      "50-mid": "2.78",
      "50-bound": [2.49, 3.05],
      "100-mid": "3.06",
      "100-bound": [2.72, 3.37]
    },
    "2hr": {
      "2-mid": "1.76",
      "2-bound": [1.6, 1.95],
      "5-mid": "2.24",
      "5-bound": [2.02, 2.47],
      "10-mid": "2.6",
      "10-bound": [2.35, 2.87],
      "25-mid": "3.09",
      "25-bound": [2.78, 3.41],
      "50-mid": "3.49",
      "50-bound": [3.12, 3.84],
      "100-mid": "3.89",
      "100-bound": [3.45, 4.28]
    },
    "3hr": {
      "2-mid": "1.91",
      "2-bound": [1.74, 2.12],
      "5-mid": "2.43",
      "5-bound": [2.2, 2.68],
      "10-mid": "2.82",
      "10-bound": [2.55, 3.12],
      "25-mid": "3.36",
      "25-bound": [3.02, 3.71],
      "50-mid": "3.78",
      "50-bound": [3.38, 4.17],
      "100-mid": "4.22",
      "100-bound": [3.75, 4.66]
    },
    "6hr": {
      "2-mid": "2.36",
      "2-bound": [2.17, 2.61],
      "5-mid": "2.99",
      "5-bound": [2.73, 3.29],
      "10-mid": "3.49",
      "10-bound": [3.17, 3.84],
      "25-mid": "4.19",
      "25-bound": [3.78, 4.61],
      "50-mid": "4.77",
      "50-bound": [4.27, 5.24],
      "100-mid": "5.39",
      "100-bound": [4.77, 5.93]
    },
    "12hr": {
      "2-mid": "2.88",
      "2-bound": [2.62, 3.22],
      "5-mid": "3.66",
      "5-bound": [3.31, 4.07],
      "10-mid": "4.31",
      "10-bound": [3.87, 4.78],
      "25-mid": "5.25",
      "25-bound": [4.68, 5.81],
      "50-mid": "6.04",
      "50-bound": [5.33, 6.67],
      "100-mid": "6.91",
      "100-bound": [6.03, 7.62]
    },
    "24hr": {
      "2-mid": "3.46",
      "2-bound": [3.21, 3.75],
      "5-mid": "4.42",
      "5-bound": [4.1, 4.78],
      "10-mid": "5.22",
      "10-bound": [4.82, 5.64],
      "25-mid": "6.4",
      "25-bound": [5.86, 6.9],
      "50-mid": "7.4",
      "50-bound": [6.73, 7.98],
      "100-mid": "8.5",
      "100-bound": [7.66, 9.15]
    },
    "2day": {
      "2-mid": "4.1",
      "2-bound": [3.8, 4.43],
      "5-mid": "5.2",
      "5-bound": [4.82, 5.62],
      "10-mid": "6.1",
      "10-bound": [5.64, 6.59],
      "25-mid": "7.41",
      "25-bound": [6.8, 7.99],
      "50-mid": "8.5",
      "50-bound": [7.75, 9.16],
      "100-mid": "9.67",
      "100-bound": [8.76, 10.4]
    },
    "3day": {
      "2-mid": "4.33",
      "2-bound": [4.02, 4.69],
      "5-mid": "5.49",
      "5-bound": [5.09, 5.94],
      "10-mid": "6.44",
      "10-bound": [5.95, 6.95],
      "25-mid": "7.81",
      "25-bound": [7.18, 8.42],
      "50-mid": "8.94",
      "50-bound": [8.17, 9.65],
      "100-mid": "10.2",
      "100-bound": [9.23, 11.0]
    },
    "4day": {
      "2-mid": "4.57",
      "2-bound": [4.24, 4.94],
      "5-mid": "5.78",
      "5-bound": [5.36, 6.25],
      "10-mid": "6.78",
      "10-bound": [6.27, 7.32],
      "25-mid": "8.2",
      "25-bound": [7.55, 8.86],
      "50-mid": "9.39",
      "50-bound": [8.6, 10.1],
      "100-mid": "10.7",
      "100-bound": [9.7, 11.5]
    },
    "7day": {
      "2-mid": "5.21",
      "2-bound": [4.88, 5.59],
      "5-mid": "6.5",
      "5-bound": [6.07, 6.97],
      "10-mid": "7.54",
      "10-bound": [7.03, 8.08],
      "25-mid": "9.04",
      "25-bound": [8.38, 9.66],
      "50-mid": "10.3",
      "50-bound": [9.48, 11.0],
      "100-mid": "11.6",
      "100-bound": [10.6, 12.4]
    }
  },
  "USC00188065 6": {
    "fips": "24023",
    "station_name": "SAVAGE RIVER DAM",
    "state": "MD",
    "latitude": "39.5090",
    "longitude": "-79.1400",
    "5min": {
      "2-mid": "0.35",
      "2-bound": [0.32, 0.39],
      "5-mid": "0.42",
      "5-bound": [0.38, 0.46],
      "10-mid": "0.48",
      "10-bound": [0.43, 0.53],
      "25-mid": "0.56",
      "25-bound": [0.5, 0.62],
      "50-mid": "0.62",
      "50-bound": [0.56, 0.69],
      "100-mid": "0.69",
      "100-bound": [0.61, 0.76]
    },
    "10min": {
      "2-mid": "0.54",
      "2-bound": [0.49, 0.6],
      "5-mid": "0.65",
      "5-bound": [0.59, 0.72],
      "10-mid": "0.74",
      "10-bound": [0.67, 0.82],
      "25-mid": "0.86",
      "25-bound": [0.77, 0.94],
      "50-mid": "0.95",
      "50-bound": [0.84, 1.04],
      "100-mid": "1.04",
      "100-bound": [0.93, 1.14]
    },
    "15min": {
      "2-mid": "0.67",
      "2-bound": [0.6, 0.74],
      "5-mid": "0.8",
      "5-bound": [0.72, 0.89],
      "10-mid": "0.91",
      "10-bound": [0.82, 1.0],
      "25-mid": "1.06",
      "25-bound": [0.95, 1.16],
      "50-mid": "1.17",
      "50-bound": [1.05, 1.29],
      "100-mid": "1.3",
      "100-bound": [1.15, 1.42]
    },
    "30min": {
      "2-mid": "0.89",
      "2-bound": [0.81, 0.98],
      "5-mid": "1.1",
      "5-bound": [0.99, 1.21],
      "10-mid": "1.26",
      "10-bound": [1.14, 1.4],
      "25-mid": "1.49",
      "25-bound": [1.34, 1.64],
      "50-mid": "1.68",
      "50-bound": [1.49, 1.84],
      "100-mid": "1.87",
      "100-bound": [1.66, 2.05]
    },
    "60min": {
      "2-mid": "1.09",
      "2-bound": [0.99, 1.21],
      "5-mid": "1.38",
      "5-bound": [1.24, 1.52],
      "10-mid": "1.61",
      "10-bound": [1.45, 1.78],
      "25-mid": "1.94",
      "25-bound": [1.73, 2.13],
      "50-mid": "2.21",
      "50-bound": [1.97, 2.42],
      "100-mid": "2.5",
      "100-bound": [2.22, 2.74]
    },
    "2hr": {
      "2-mid": "1.25",
      "2-bound": [1.12, 1.38],
      "5-mid": "1.59",
      "5-bound": [1.43, 1.76],
      "10-mid": "1.9",
      "10-bound": [1.7, 2.09],
      "25-mid": "2.34",
      "25-bound": [2.08, 2.58],
      "50-mid": "2.73",
      "50-bound": [2.41, 3.0],
      "100-mid": "3.15",
      "100-bound": [2.76, 3.45]
    },
    "3hr": {
      "2-mid": "1.34",
      "2-bound": [1.21, 1.5],
      "5-mid": "1.69",
      "5-bound": [1.53, 1.88],
      "10-mid": "2.02",
      "10-bound": [1.8, 2.23],
      "25-mid": "2.48",
      "25-bound": [2.21, 2.74],
      "50-mid": "2.9",
      "50-bound": [2.57, 3.19],
      "100-mid": "3.35",
      "100-bound": [2.95, 3.69]
    },
    "6hr": {
      "2-mid": "1.66",
      "2-bound": [1.48, 1.88],
      "5-mid": "2.07",
      "5-bound": [1.84, 2.34],
      "10-mid": "2.44",
      "10-bound": [2.16, 2.76],
      "25-mid": "2.99",
      "25-bound": [2.63, 3.36],
      "50-mid": "3.48",
      "50-bound": [3.04, 3.9],
      "100-mid": "4.02",
      "100-bound": [3.49, 4.5]
    },
    "12hr": {
      "2-mid": "2.03",
      "2-bound": [1.82, 2.29],
      "5-mid": "2.51",
      "5-bound": [2.26, 2.84],
      "10-mid": "2.97",
      "10-bound": [2.66, 3.35],
      "25-mid": "3.65",
      "25-bound": [3.24, 4.09],
      "50-mid": "4.26",
      "50-bound": [3.76, 4.76],
      "100-mid": "4.94",
      "100-bound": [4.31, 5.5]
    },
    "24hr": {
      "2-mid": "2.48",
      "2-bound": [2.26, 2.75],
      "5-mid": "3.1",
      "5-bound": [2.82, 3.45],
      "10-mid": "3.67",
      "10-bound": [3.32, 4.07],
      "25-mid": "4.54",
      "25-bound": [4.07, 5.02],
      "50-mid": "5.31",
      "50-bound": [4.71, 5.87],
      "100-mid": "6.2",
      "100-bound": [5.43, 6.84]
    },
    "2day": {
      "2-mid": "2.91",
      "2-bound": [2.68, 3.2],
      "5-mid": "3.62",
      "5-bound": [3.32, 3.98],
      "10-mid": "4.24",
      "10-bound": [3.87, 4.65],
      "25-mid": "5.18",
      "25-bound": [4.68, 5.68],
      "50-mid": "6.0",
      "50-bound": [5.37, 6.59],
      "100-mid": "6.93",
      "100-bound": [6.12, 7.61]
    },
    "3day": {
      "2-mid": "3.16",
      "2-bound": [2.92, 3.44],
      "5-mid": "3.89",
      "5-bound": [3.59, 4.25],
      "10-mid": "4.53",
      "10-bound": [4.16, 4.94],
      "25-mid": "5.48",
      "25-bound": [4.98, 5.98],
      "50-mid": "6.3",
      "50-bound": [5.67, 6.87],
      "100-mid": "7.2",
      "100-bound": [6.41, 7.87]
    },
    "4day": {
      "2-mid": "3.4",
      "2-bound": [3.15, 3.69],
      "5-mid": "4.17",
      "5-bound": [3.86, 4.52],
      "10-mid": "4.82",
      "10-bound": [4.45, 5.23],
      "25-mid": "5.78",
      "25-bound": [5.29, 6.27],
      "50-mid": "6.59",
      "50-bound": [5.98, 7.16],
      "100-mid": "7.46",
      "100-bound": [6.7, 8.13]
    },
    "7day": {
      "2-mid": "3.98",
      "2-bound": [3.72, 4.29],
      "5-mid": "4.82",
      "5-bound": [4.49, 5.18],
      "10-mid": "5.51",
      "10-bound": [5.12, 5.93],
      "25-mid": "6.49",
      "25-bound": [5.99, 7.0],
      "50-mid": "7.3",
      "50-bound": [6.7, 7.88],
      "100-mid": "8.14",
      "100-bound": [7.4, 8.82]
    }
  },
  "USW00094704 6": {
    "fips": "36051",
    "station_name": "DANSVILLE MUNICIPAL AP",
    "state": "NY",
    "latitude": "42.5708",
    "longitude": "-77.7133",
    "5min": {
      "2-mid": "0.32",
      "2-bound": [0.24, 0.4],
      "5-mid": "0.41",
      "5-bound": [0.31, 0.52],
      "10-mid": "0.48",
      "10-bound": [0.36, 0.62],
      "25-mid": "0.58",
      "25-bound": [0.43, 0.78],
      "50-mid": "0.66",
      "50-bound": [0.47, 0.91],
      "100-mid": "0.74",
      "100-bound": [0.52, 1.06]
    },
    "10min": {
      "2-mid": "0.45",
      "2-bound": [0.34, 0.57],
      "5-mid": "0.57",
      "5-bound": [0.43, 0.73],
      "10-mid": "0.68",
      "10-bound": [0.51, 0.87],
      "25-mid": "0.82",
      "25-bound": [0.6, 1.11],
      "50-mid": "0.93",
      "50-bound": [0.67, 1.28],
      "100-mid": "1.04",
      "100-bound": [0.74, 1.5]
    },
    "15min": {
      "2-mid": "0.53",
      "2-bound": [0.4, 0.67],
      "5-mid": "0.68",
      "5-bound": [0.51, 0.86],
      "10-mid": "0.8",
      "10-bound": [0.6, 1.03],
      "25-mid": "0.97",
      "25-bound": [0.71, 1.3],
      "50-mid": "1.09",
      "50-bound": [0.79, 1.51],
      "100-mid": "1.23",
      "100-bound": [0.87, 1.76]
    },
    "30min": {
      "2-mid": "0.73",
      "2-bound": [0.56, 0.94],
      "5-mid": "0.93",
      "5-bound": [0.71, 1.19],
      "10-mid": "1.1",
      "10-bound": [0.83, 1.41],
      "25-mid": "1.32",
      "25-bound": [0.97, 1.78],
      "50-mid": "1.49",
      "50-bound": [1.08, 2.05],
      "100-mid": "1.67",
      "100-bound": [1.18, 2.39]
    },
    "60min": {
      "2-mid": "0.94",
      "2-bound": [0.72, 1.2],
      "5-mid": "1.19",
      "5-bound": [0.9, 1.52],
      "10-mid": "1.39",
      "10-bound": [1.05, 1.79],
      "25-mid": "1.67",
      "25-bound": [1.23, 2.26],
      "50-mid": "1.88",
      "50-bound": [1.36, 2.6],
      "100-mid": "2.11",
      "100-bound": [1.49, 3.02]
    },
    "2hr": {
      "2-mid": "1.15",
      "2-bound": [0.88, 1.44],
      "5-mid": "1.46",
      "5-bound": [1.12, 1.84],
      "10-mid": "1.72",
      "10-bound": [1.31, 2.18],
      "25-mid": "2.07",
      "25-bound": [1.54, 2.76],
      "50-mid": "2.34",
      "50-bound": [1.7, 3.18],
      "100-mid": "2.62",
      "100-bound": [1.86, 3.7]
    },
    "3hr": {
      "2-mid": "1.28",
      "2-bound": [0.99, 1.6],
      "5-mid": "1.62",
      "5-bound": [1.26, 2.04],
      "10-mid": "1.92",
      "10-bound": [1.47, 2.42],
      "25-mid": "2.32",
      "25-bound": [1.73, 3.06],
      "50-mid": "2.61",
      "50-bound": [1.92, 3.53],
      "100-mid": "2.93",
      "100-bound": [2.1, 4.12]
    },
    "6hr": {
      "2-mid": "1.53",
      "2-bound": [1.2, 1.9],
      "5-mid": "1.94",
      "5-bound": [1.52, 2.41],
      "10-mid": "2.28",
      "10-bound": [1.77, 2.85],
      "25-mid": "2.74",
      "25-bound": [2.08, 3.6],
      "50-mid": "3.09",
      "50-bound": [2.3, 4.15],
      "100-mid": "3.46",
      "100-bound": [2.52, 4.84]
    },
    "12hr": {
      "2-mid": "1.84",
      "2-bound": [1.46, 2.25],
      "5-mid": "2.3",
      "5-bound": [1.82, 2.82],
      "10-mid": "2.68",
      "10-bound": [2.12, 3.31],
      "25-mid": "3.21",
      "25-bound": [2.47, 4.17],
      "50-mid": "3.59",
      "50-bound": [2.72, 4.79],
      "100-mid": "4.02",
      "100-bound": [2.98, 5.61]
    },
    "24hr": {
      "2-mid": "2.18",
      "2-bound": [1.76, 2.64],
      "5-mid": "2.72",
      "5-bound": [2.19, 3.31],
      "10-mid": "3.17",
      "10-bound": [2.54, 3.88],
      "25-mid": "3.79",
      "25-bound": [2.96, 4.88],
      "50-mid": "4.24",
      "50-bound": [3.25, 5.6],
      "100-mid": "4.75",
      "100-bound": [3.57, 6.56]
    },
    "2day": {
      "2-mid": "2.53",
      "2-bound": [2.07, 3.03],
      "5-mid": "3.21",
      "5-bound": [2.61, 3.85],
      "10-mid": "3.77",
      "10-bound": [3.05, 4.55],
      "25-mid": "4.54",
      "25-bound": [3.57, 5.75],
      "50-mid": "5.11",
      "50-bound": [3.95, 6.63],
      "100-mid": "5.73",
      "100-bound": [4.32, 7.75]
    },
    "3day": {
      "2-mid": "2.78",
      "2-bound": [2.29, 3.31],
      "5-mid": "3.52",
      "5-bound": [2.89, 4.2],
      "10-mid": "4.14",
      "10-bound": [3.38, 4.96],
      "25-mid": "4.99",
      "25-bound": [3.95, 6.27],
      "50-mid": "5.62",
      "50-bound": [4.36, 7.22],
      "100-mid": "6.3",
      "100-bound": [4.76, 8.42]
    },
    "4day": {
      "2-mid": "2.99",
      "2-bound": [2.48, 3.54],
      "5-mid": "3.78",
      "5-bound": [3.12, 4.48],
      "10-mid": "4.42",
      "10-bound": [3.63, 5.28],
      "25-mid": "5.32",
      "25-bound": [4.23, 6.64],
      "50-mid": "5.99",
      "50-bound": [4.67, 7.65],
      "100-mid": "6.7",
      "100-bound": [5.08, 8.9]
    },
    "7day": {
      "2-mid": "3.53",
      "2-bound": [2.96, 4.14],
      "5-mid": "4.39",
      "5-bound": [3.67, 5.16],
      "10-mid": "5.1",
      "10-bound": [4.24, 6.04],
      "25-mid": "6.09",
      "25-bound": [4.89, 7.51],
      "50-mid": "6.82",
      "50-bound": [5.36, 8.6],
      "100-mid": "7.6",
      "100-bound": [5.8, 9.95]
    }
  },
  "USC00363311 6": {
    "fips": "42047",
    "station_name": "GLEN HAZEL 2 NE DAM",
    "state": "PA",
    "latitude": "41.5606",
    "longitude": "-78.5994",
    "5min": {
      "2-mid": "0.36",
      "2-bound": [0.33, 0.41],
      "5-mid": "0.44",
      "5-bound": [0.39, 0.49],
      "10-mid": "0.5",
      "10-bound": [0.44, 0.55],
      "25-mid": "0.57",
      "25-bound": [0.51, 0.64],
      "50-mid": "0.63",
      "50-bound": [0.56, 0.7],
      "100-mid": "0.69",
      "100-bound": [0.61, 0.76]
    },
    "10min": {
      "2-mid": "0.57",
      "2-bound": [0.51, 0.63],
      "5-mid": "0.68",
      "5-bound": [0.61, 0.76],
      "10-mid": "0.77",
      "10-bound": [0.69, 0.86],
      "25-mid": "0.88",
      "25-bound": [0.78, 0.97],
      "50-mid": "0.96",
      "50-bound": [0.85, 1.06],
      "100-mid": "1.04",
      "100-bound": [0.92, 1.15]
    },
    "15min": {
      "2-mid": "0.69",
      "2-bound": [0.62, 0.77],
      "5-mid": "0.84",
      "5-bound": [0.75, 0.94],
      "10-mid": "0.95",
      "10-bound": [0.84, 1.05],
      "25-mid": "1.08",
      "25-bound": [0.96, 1.2],
      "50-mid": "1.18",
      "50-bound": [1.05, 1.31],
      "100-mid": "1.29",
      "100-bound": [1.14, 1.42]
    },
    "30min": {
      "2-mid": "0.93",
      "2-bound": [0.83, 1.04],
      "5-mid": "1.15",
      "5-bound": [1.03, 1.28],
      "10-mid": "1.31",
      "10-bound": [1.17, 1.46],
      "25-mid": "1.53",
      "25-bound": [1.36, 1.7],
      "50-mid": "1.69",
      "50-bound": [1.5, 1.88],
      "100-mid": "1.86",
      "100-bound": [1.64, 2.06]
    },
    "60min": {
      "2-mid": "1.14",
      "2-bound": [1.02, 1.27],
      "5-mid": "1.44",
      "5-bound": [1.29, 1.61],
      "10-mid": "1.67",
      "10-bound": [1.49, 1.86],
      "25-mid": "1.98",
      "25-bound": [1.76, 2.2],
      "50-mid": "2.23",
      "50-bound": [1.97, 2.47],
      "100-mid": "2.49",
      "100-bound": [2.2, 2.75]
    },
    "2hr": {
      "2-mid": "1.33",
      "2-bound": [1.19, 1.49],
      "5-mid": "1.68",
      "5-bound": [1.5, 1.87],
      "10-mid": "1.95",
      "10-bound": [1.74, 2.16],
      "25-mid": "2.33",
      "25-bound": [2.07, 2.58],
      "50-mid": "2.63",
      "50-bound": [2.33, 2.9],
      "100-mid": "2.94",
      "100-bound": [2.59, 3.25]
    },
    "3hr": {
      "2-mid": "1.45",
      "2-bound": [1.31, 1.63],
      "5-mid": "1.83",
      "5-bound": [1.64, 2.04],
      "10-mid": "2.12",
      "10-bound": [1.9, 2.37],
      "25-mid": "2.54",
      "25-bound": [2.26, 2.82],
      "50-mid": "2.87",
      "50-bound": [2.55, 3.19],
      "100-mid": "3.23",
      "100-bound": [2.85, 3.58]
    },
    "6hr": {
      "2-mid": "1.75",
      "2-bound": [1.58, 1.96],
      "5-mid": "2.18",
      "5-bound": [1.97, 2.44],
      "10-mid": "2.53",
      "10-bound": [2.28, 2.83],
      "25-mid": "3.02",
      "25-bound": [2.71, 3.37],
      "50-mid": "3.43",
      "50-bound": [3.06, 3.81],
      "100-mid": "3.86",
      "100-bound": [3.42, 4.27]
    },
    "12hr": {
      "2-mid": "2.14",
      "2-bound": [1.96, 2.37],
      "5-mid": "2.64",
      "5-bound": [2.42, 2.92],
      "10-mid": "3.06",
      "10-bound": [2.78, 3.37],
      "25-mid": "3.66",
      "25-bound": [3.31, 4.02],
      "50-mid": "4.15",
      "50-bound": [3.74, 4.55],
      "100-mid": "4.68",
      "100-bound": [4.18, 5.12]
    },
    "24hr": {
      "2-mid": "2.51",
      "2-bound": [2.32, 2.72],
      "5-mid": "3.06",
      "5-bound": [2.84, 3.32],
      "10-mid": "3.52",
      "10-bound": [3.26, 3.82],
      "25-mid": "4.19",
      "25-bound": [3.86, 4.52],
      "50-mid": "4.74",
      "50-bound": [4.35, 5.1],
      "100-mid": "5.32",
      "100-bound": [4.86, 5.72]
    },
    "2day": {
      "2-mid": "2.94",
      "2-bound": [2.73, 3.18],
      "5-mid": "3.57",
      "5-bound": [3.31, 3.86],
      "10-mid": "4.08",
      "10-bound": [3.78, 4.41],
      "25-mid": "4.81",
      "25-bound": [4.44, 5.19],
      "50-mid": "5.42",
      "50-bound": [4.98, 5.84],
      "100-mid": "6.06",
      "100-bound": [5.55, 6.51]
    },
    "3day": {
      "2-mid": "3.14",
      "2-bound": [2.92, 3.39],
      "5-mid": "3.79",
      "5-bound": [3.52, 4.09],
      "10-mid": "4.32",
      "10-bound": [4.01, 4.66],
      "25-mid": "5.06",
      "25-bound": [4.68, 5.45],
      "50-mid": "5.68",
      "50-bound": [5.24, 6.11],
      "100-mid": "6.33",
      "100-bound": [5.81, 6.79]
    },
    "4day": {
      "2-mid": "3.34",
      "2-bound": [3.12, 3.6],
      "5-mid": "4.01",
      "5-bound": [3.73, 4.32],
      "10-mid": "4.55",
      "10-bound": [4.23, 4.9],
      "25-mid": "5.32",
      "25-bound": [4.92, 5.71],
      "50-mid": "5.94",
      "50-bound": [5.49, 6.38],
      "100-mid": "6.6",
      "100-bound": [6.07, 7.07]
    },
    "7day": {
      "2-mid": "4.01",
      "2-bound": [3.75, 4.31],
      "5-mid": "4.73",
      "5-bound": [4.43, 5.09],
      "10-mid": "5.32",
      "10-bound": [4.97, 5.72],
      "25-mid": "6.13",
      "25-bound": [5.7, 6.58],
      "50-mid": "6.78",
      "50-bound": [6.29, 7.27],
      "100-mid": "7.46",
      "100-bound": [6.9, 7.99]
    }
  },
  "USC00301787 6": {
    "fips": "36101",
    "station_name": "CORNING",
    "state": "NY",
    "latitude": "42.1340",
    "longitude": "-77.0690",
    "5min": {
      "2-mid": "0.36",
      "2-bound": [0.28, 0.47],
      "5-mid": "0.47",
      "5-bound": [0.35, 0.6],
      "10-mid": "0.55",
      "10-bound": [0.41, 0.71],
      "25-mid": "0.67",
      "25-bound": [0.49, 0.9],
      "50-mid": "0.75",
      "50-bound": [0.54, 1.05],
      "100-mid": "0.84",
      "100-bound": [0.59, 1.22]
    },
    "10min": {
      "2-mid": "0.52",
      "2-bound": [0.39, 0.67],
      "5-mid": "0.66",
      "5-bound": [0.5, 0.85],
      "10-mid": "0.78",
      "10-bound": [0.59, 1.01],
      "25-mid": "0.94",
      "25-bound": [0.69, 1.28],
      "50-mid": "1.06",
      "50-bound": [0.77, 1.48],
      "100-mid": "1.19",
      "100-bound": [0.84, 1.72]
    },
    "15min": {
      "2-mid": "0.61",
      "2-bound": [0.46, 0.78],
      "5-mid": "0.78",
      "5-bound": [0.59, 1.0],
      "10-mid": "0.92",
      "10-bound": [0.69, 1.19],
      "25-mid": "1.11",
      "25-bound": [0.81, 1.51],
      "50-mid": "1.25",
      "50-bound": [0.9, 1.74],
      "100-mid": "1.4",
      "100-bound": [0.98, 2.03]
    },
    "30min": {
      "2-mid": "0.82",
      "2-bound": [0.62, 1.05],
      "5-mid": "1.04",
      "5-bound": [0.79, 1.34],
      "10-mid": "1.23",
      "10-bound": [0.92, 1.6],
      "25-mid": "1.49",
      "25-bound": [1.09, 2.02],
      "50-mid": "1.68",
      "50-bound": [1.21, 2.34],
      "100-mid": "1.88",
      "100-bound": [1.32, 2.72]
    },
    "60min": {
      "2-mid": "1.02",
      "2-bound": [0.78, 1.32],
      "5-mid": "1.31",
      "5-bound": [0.99, 1.69],
      "10-mid": "1.54",
      "10-bound": [1.16, 2.0],
      "25-mid": "1.86",
      "25-bound": [1.36, 2.54],
      "50-mid": "2.11",
      "50-bound": [1.52, 2.93],
      "100-mid": "2.36",
      "100-bound": [1.66, 3.42]
    },
    "2hr": {
      "2-mid": "1.25",
      "2-bound": [0.95, 1.59],
      "5-mid": "1.6",
      "5-bound": [1.22, 2.05],
      "10-mid": "1.89",
      "10-bound": [1.43, 2.44],
      "25-mid": "2.29",
      "25-bound": [1.69, 3.1],
      "50-mid": "2.59",
      "50-bound": [1.88, 3.59],
      "100-mid": "2.91",
      "100-bound": [2.06, 4.2]
    },
    "3hr": {
      "2-mid": "1.4",
      "2-bound": [1.07, 1.78],
      "5-mid": "1.79",
      "5-bound": [1.37, 2.29],
      "10-mid": "2.12",
      "10-bound": [1.62, 2.72],
      "25-mid": "2.57",
      "25-bound": [1.91, 3.47],
      "50-mid": "2.91",
      "50-bound": [2.12, 4.01],
      "100-mid": "3.27",
      "100-bound": [2.33, 4.7]
    },
    "6hr": {
      "2-mid": "1.71",
      "2-bound": [1.32, 2.15],
      "5-mid": "2.18",
      "5-bound": [1.69, 2.77],
      "10-mid": "2.58",
      "10-bound": [1.99, 3.29],
      "25-mid": "3.13",
      "25-bound": [2.34, 4.18],
      "50-mid": "3.53",
      "50-bound": [2.6, 4.84],
      "100-mid": "3.97",
      "100-bound": [2.85, 5.67]
    },
    "12hr": {
      "2-mid": "2.09",
      "2-bound": [1.63, 2.61],
      "5-mid": "2.66",
      "5-bound": [2.08, 3.34],
      "10-mid": "3.14",
      "10-bound": [2.44, 3.97],
      "25-mid": "3.79",
      "25-bound": [2.86, 5.03],
      "50-mid": "4.28",
      "50-bound": [3.17, 5.81],
      "100-mid": "4.81",
      "100-bound": [3.47, 6.79]
    },
    "24hr": {
      "2-mid": "2.48",
      "2-bound": [1.96, 3.09],
      "5-mid": "3.17",
      "5-bound": [2.5, 3.96],
      "10-mid": "3.75",
      "10-bound": [2.94, 4.7],
      "25-mid": "4.54",
      "25-bound": [3.45, 5.97],
      "50-mid": "5.12",
      "50-bound": [3.82, 6.9],
      "100-mid": "5.75",
      "100-bound": [4.17, 8.06]
    },
    "2day": {
      "2-mid": "2.86",
      "2-bound": [2.29, 3.54],
      "5-mid": "3.69",
      "5-bound": [2.94, 4.57],
      "10-mid": "4.37",
      "10-bound": [3.46, 5.45],
      "25-mid": "5.31",
      "25-bound": [4.07, 6.94],
      "50-mid": "6.01",
      "50-bound": [4.52, 8.04],
      "100-mid": "6.76",
      "100-bound": [4.95, 9.42]
    },
    "3day": {
      "2-mid": "3.14",
      "2-bound": [2.52, 3.86],
      "5-mid": "4.03",
      "5-bound": [3.22, 4.97],
      "10-mid": "4.77",
      "10-bound": [3.79, 5.91],
      "25-mid": "5.78",
      "25-bound": [4.45, 7.52],
      "50-mid": "6.54",
      "50-bound": [4.93, 8.7],
      "100-mid": "7.35",
      "100-bound": [5.39, 10.2]
    },
    "4day": {
      "2-mid": "3.37",
      "2-bound": [2.72, 4.13],
      "5-mid": "4.3",
      "5-bound": [3.45, 5.28],
      "10-mid": "5.06",
      "10-bound": [4.04, 6.26],
      "25-mid": "6.12",
      "25-bound": [4.73, 7.93],
      "50-mid": "6.91",
      "50-bound": [5.23, 9.15],
      "100-mid": "7.75",
      "100-bound": [5.7, 10.7]
    },
    "7day": {
      "2-mid": "3.96",
      "2-bound": [3.22, 4.82],
      "5-mid": "4.93",
      "5-bound": [3.99, 6.02],
      "10-mid": "5.74",
      "10-bound": [4.61, 7.05],
      "25-mid": "6.84",
      "25-bound": [5.32, 8.79],
      "50-mid": "7.67",
      "50-bound": [5.84, 10.1],
      "100-mid": "8.55",
      "100-bound": [6.31, 11.7]
    }
  },
  "USC00075320 6": {
    "fips": "10005",
    "station_name": "LEWES",
    "state": "DE",
    "latitude": "38.7840",
    "longitude": "-75.1580",
    "5min": {
      "2-mid": "0.42",
      "2-bound": [0.38, 0.46],
      "5-mid": "0.49",
      "5-bound": [0.44, 0.54],
      "10-mid": "0.55",
      "10-bound": [0.49, 0.61],
      "25-mid": "0.62",
      "25-bound": [0.56, 0.69],
      "50-mid": "0.68",
      "50-bound": [0.6, 0.75],
      "100-mid": "0.73",
      "100-bound": [0.65, 0.81]
    },
    "10min": {
      "2-mid": "0.67",
      "2-bound": [0.6, 0.74],
      "5-mid": "0.78",
      "5-bound": [0.7, 0.87],
      "10-mid": "0.88",
      "10-bound": [0.79, 0.97],
      "25-mid": "0.99",
      "25-bound": [0.89, 1.1],
      "50-mid": "1.08",
      "50-bound": [0.96, 1.2],
      "100-mid": "1.16",
      "100-bound": [1.03, 1.29]
    },
    "15min": {
      "2-mid": "0.84",
      "2-bound": [0.76, 0.93],
      "5-mid": "0.99",
      "5-bound": [0.89, 1.1],
      "10-mid": "1.12",
      "10-bound": [1.0, 1.23],
      "25-mid": "1.26",
      "25-bound": [1.12, 1.39],
      "50-mid": "1.37",
      "50-bound": [1.22, 1.52],
      "100-mid": "1.47",
      "100-bound": [1.3, 1.63]
    },
    "30min": {
      "2-mid": "1.16",
      "2-bound": [1.04, 1.28],
      "5-mid": "1.41",
      "5-bound": [1.26, 1.56],
      "10-mid": "1.62",
      "10-bound": [1.45, 1.79],
      "25-mid": "1.86",
      "25-bound": [1.66, 2.06],
      "50-mid": "2.06",
      "50-bound": [1.83, 2.28],
      "100-mid": "2.25",
      "100-bound": [1.99, 2.5]
    },
    "60min": {
      "2-mid": "1.46",
      "2-bound": [1.31, 1.61],
      "5-mid": "1.81",
      "5-bound": [1.62, 2.0],
      "10-mid": "2.1",
      "10-bound": [1.89, 2.33],
      "25-mid": "2.48",
      "25-bound": [2.22, 2.75],
      "50-mid": "2.79",
      "50-bound": [2.48, 3.1],
      "100-mid": "3.1",
      "100-bound": [2.74, 3.44]
    },
    "2hr": {
      "2-mid": "1.79",
      "2-bound": [1.6, 2.0],
      "5-mid": "2.24",
      "5-bound": [1.99, 2.5],
      "10-mid": "2.64",
      "10-bound": [2.34, 2.94],
      "25-mid": "3.14",
      "25-bound": [2.78, 3.5],
      "50-mid": "3.56",
      "50-bound": [3.13, 3.98],
      "100-mid": "3.98",
      "100-bound": [3.48, 4.47]
    },
    "3hr": {
      "2-mid": "1.96",
      "2-bound": [1.76, 2.19],
      "5-mid": "2.46",
      "5-bound": [2.2, 2.74],
      "10-mid": "2.9",
      "10-bound": [2.58, 3.23],
      "25-mid": "3.47",
      "25-bound": [3.07, 3.87],
      "50-mid": "3.96",
      "50-bound": [3.48, 4.42],
      "100-mid": "4.46",
      "100-bound": [3.9, 4.99]
    },
    "6hr": {
      "2-mid": "2.39",
      "2-bound": [2.15, 2.68],
      "5-mid": "2.99",
      "5-bound": [2.67, 3.35],
      "10-mid": "3.54",
      "10-bound": [3.15, 3.96],
      "25-mid": "4.28",
      "25-bound": [3.79, 4.79],
      "50-mid": "4.94",
      "50-bound": [4.33, 5.53],
      "100-mid": "5.62",
      "100-bound": [4.89, 6.32]
    },
    "12hr": {
      "2-mid": "2.84",
      "2-bound": [2.54, 3.2],
      "5-mid": "3.56",
      "5-bound": [3.18, 4.01],
      "10-mid": "4.26",
      "10-bound": [3.79, 4.8],
      "25-mid": "5.24",
      "25-bound": [4.62, 5.9],
      "50-mid": "6.13",
      "50-bound": [5.35, 6.91],
      "100-mid": "7.1",
      "100-bound": [6.12, 8.03]
    },
    "24hr": {
      "2-mid": "3.42",
      "2-bound": [3.17, 3.7],
      "5-mid": "4.45",
      "5-bound": [4.11, 4.81],
      "10-mid": "5.34",
      "10-bound": [4.92, 5.75],
      "25-mid": "6.69",
      "25-bound": [6.13, 7.19],
      "50-mid": "7.88",
      "50-bound": [7.16, 8.43],
      "100-mid": "9.22",
      "100-bound": [8.3, 9.84]
    },
    "2day": {
      "2-mid": "3.94",
      "2-bound": [3.64, 4.29],
      "5-mid": "5.13",
      "5-bound": [4.72, 5.57],
      "10-mid": "6.15",
      "10-bound": [5.65, 6.66],
      "25-mid": "7.69",
      "25-bound": [7.02, 8.32],
      "50-mid": "9.03",
      "50-bound": [8.18, 9.76],
      "100-mid": "10.5",
      "100-bound": [9.46, 11.4]
    },
    "3day": {
      "2-mid": "4.18",
      "2-bound": [3.87, 4.54],
      "5-mid": "5.4",
      "5-bound": [5.0, 5.86],
      "10-mid": "6.45",
      "10-bound": [5.95, 6.99],
      "25-mid": "8.03",
      "25-bound": [7.36, 8.68],
      "50-mid": "9.4",
      "50-bound": [8.56, 10.1],
      "100-mid": "10.9",
      "100-bound": [9.86, 11.8]
    },
    "4day": {
      "2-mid": "4.41",
      "2-bound": [4.1, 4.78],
      "5-mid": "5.68",
      "5-bound": [5.27, 6.15],
      "10-mid": "6.76",
      "10-bound": [6.25, 7.31],
      "25-mid": "8.38",
      "25-bound": [7.7, 9.05],
      "50-mid": "9.77",
      "50-bound": [8.93, 10.5],
      "100-mid": "11.3",
      "100-bound": [10.3, 12.2]
    },
    "7day": {
      "2-mid": "5.04",
      "2-bound": [4.7, 5.46],
      "5-mid": "6.38",
      "5-bound": [5.94, 6.9],
      "10-mid": "7.51",
      "10-bound": [7.0, 8.12],
      "25-mid": "9.2",
      "25-bound": [8.52, 9.92],
      "50-mid": "10.6",
      "50-bound": [9.8, 11.5],
      "100-mid": "12.2",
      "100-bound": [11.2, 13.2]
    }
  },
  "USC00368254 6": {
    "fips": "42111",
    "station_name": "SOMERSET",
    "state": "PA",
    "latitude": "39.9900",
    "longitude": "-79.0833",
    "5min": {
      "2-mid": "0.36",
      "2-bound": [0.33, 0.41],
      "5-mid": "0.44",
      "5-bound": [0.4, 0.49],
      "10-mid": "0.5",
      "10-bound": [0.45, 0.56],
      "25-mid": "0.58",
      "25-bound": [0.52, 0.65],
      "50-mid": "0.65",
      "50-bound": [0.58, 0.72],
      "100-mid": "0.72",
      "100-bound": [0.64, 0.79]
    },
    "10min": {
      "2-mid": "0.57",
      "2-bound": [0.51, 0.63],
      "5-mid": "0.69",
      "5-bound": [0.62, 0.76],
      "10-mid": "0.78",
      "10-bound": [0.7, 0.86],
      "25-mid": "0.9",
      "25-bound": [0.8, 0.99],
      "50-mid": "0.99",
      "50-bound": [0.88, 1.09],
      "100-mid": "1.08",
      "100-bound": [0.95, 1.19]
    },
    "15min": {
      "2-mid": "0.69",
      "2-bound": [0.63, 0.77],
      "5-mid": "0.84",
      "5-bound": [0.76, 0.94],
      "10-mid": "0.95",
      "10-bound": [0.86, 1.06],
      "25-mid": "1.11",
      "25-bound": [0.99, 1.22],
      "50-mid": "1.22",
      "50-bound": [1.08, 1.35],
      "100-mid": "1.34",
      "100-bound": [1.19, 1.48]
    },
    "30min": {
      "2-mid": "0.93",
      "2-bound": [0.84, 1.04],
      "5-mid": "1.15",
      "5-bound": [1.04, 1.28],
      "10-mid": "1.33",
      "10-bound": [1.19, 1.47],
      "25-mid": "1.56",
      "25-bound": [1.39, 1.73],
      "50-mid": "1.75",
      "50-bound": [1.55, 1.93],
      "100-mid": "1.94",
      "100-bound": [1.71, 2.14]
    },
    "60min": {
      "2-mid": "1.14",
      "2-bound": [1.03, 1.27],
      "5-mid": "1.45",
      "5-bound": [1.3, 1.61],
      "10-mid": "1.69",
      "10-bound": [1.51, 1.87],
      "25-mid": "2.02",
      "25-bound": [1.8, 2.24],
      "50-mid": "2.3",
      "50-bound": [2.04, 2.54],
      "100-mid": "2.59",
      "100-bound": [2.29, 2.86]
    },
    "2hr": {
      "2-mid": "1.33",
      "2-bound": [1.2, 1.47],
      "5-mid": "1.69",
      "5-bound": [1.52, 1.87],
      "10-mid": "1.99",
      "10-bound": [1.78, 2.19],
      "25-mid": "2.42",
      "25-bound": [2.16, 2.66],
      "50-mid": "2.79",
      "50-bound": [2.47, 3.06],
      "100-mid": "3.2",
      "100-bound": [2.81, 3.5]
    },
    "3hr": {
      "2-mid": "1.43",
      "2-bound": [1.29, 1.59],
      "5-mid": "1.8",
      "5-bound": [1.62, 2.0],
      "10-mid": "2.12",
      "10-bound": [1.9, 2.34],
      "25-mid": "2.58",
      "25-bound": [2.3, 2.85],
      "50-mid": "2.97",
      "50-bound": [2.64, 3.28],
      "100-mid": "3.41",
      "100-bound": [3.0, 3.75]
    },
    "6hr": {
      "2-mid": "1.75",
      "2-bound": [1.58, 1.96],
      "5-mid": "2.19",
      "5-bound": [1.97, 2.45],
      "10-mid": "2.56",
      "10-bound": [2.29, 2.85],
      "25-mid": "3.1",
      "25-bound": [2.76, 3.45],
      "50-mid": "3.57",
      "50-bound": [3.16, 3.96],
      "100-mid": "4.09",
      "100-bound": [3.59, 4.52]
    },
    "12hr": {
      "2-mid": "2.11",
      "2-bound": [1.9, 2.39],
      "5-mid": "2.62",
      "5-bound": [2.35, 2.96],
      "10-mid": "3.06",
      "10-bound": [2.73, 3.44],
      "25-mid": "3.72",
      "25-bound": [3.3, 4.17],
      "50-mid": "4.29",
      "50-bound": [3.78, 4.8],
      "100-mid": "4.92",
      "100-bound": [4.3, 5.48]
    },
    "24hr": {
      "2-mid": "2.46",
      "2-bound": [2.28, 2.69],
      "5-mid": "3.06",
      "5-bound": [2.82, 3.33],
      "10-mid": "3.58",
      "10-bound": [3.29, 3.89],
      "25-mid": "4.37",
      "25-bound": [3.98, 4.74],
      "50-mid": "5.06",
      "50-bound": [4.57, 5.47],
      "100-mid": "5.82",
      "100-bound": [5.2, 6.29]
    },
    "2day": {
      "2-mid": "2.88",
      "2-bound": [2.68, 3.14],
      "5-mid": "3.56",
      "5-bound": [3.3, 3.87],
      "10-mid": "4.15",
      "10-bound": [3.82, 4.5],
      "25-mid": "5.02",
      "25-bound": [4.6, 5.44],
      "50-mid": "5.77",
      "50-bound": [5.24, 6.25],
      "100-mid": "6.6",
      "100-bound": [5.93, 7.16]
    },
    "3day": {
      "2-mid": "3.1",
      "2-bound": [2.88, 3.35],
      "5-mid": "3.8",
      "5-bound": [3.52, 4.11],
      "10-mid": "4.39",
      "10-bound": [4.06, 4.74],
      "25-mid": "5.27",
      "25-bound": [4.84, 5.68],
      "50-mid": "6.0",
      "50-bound": [5.48, 6.48],
      "100-mid": "6.81",
      "100-bound": [6.15, 7.36]
    },
    "4day": {
      "2-mid": "3.31",
      "2-bound": [3.08, 3.57],
      "5-mid": "4.04",
      "5-bound": [3.75, 4.35],
      "10-mid": "4.64",
      "10-bound": [4.3, 4.99],
      "25-mid": "5.52",
      "25-bound": [5.08, 5.93],
      "50-mid": "6.24",
      "50-bound": [5.71, 6.71],
      "100-mid": "7.01",
      "100-bound": [6.37, 7.55]
    },
    "7day": {
      "2-mid": "3.95",
      "2-bound": [3.7, 4.22],
      "5-mid": "4.75",
      "5-bound": [4.45, 5.07],
      "10-mid": "5.41",
      "10-bound": [5.05, 5.77],
      "25-mid": "6.32",
      "25-bound": [5.88, 6.73],
      "50-mid": "7.06",
      "50-bound": [6.53, 7.52],
      "100-mid": "7.82",
      "100-bound": [7.19, 8.35]
    }
  },
  "USC00446712 6": {
    "fips": "51137",
    "station_name": "PIEDMONT RESEARCH STA",
    "state": "VA",
    "latitude": "38.2320",
    "longitude": "-78.1200",
    "5min": {
      "2-mid": "0.42",
      "2-bound": [0.38, 0.47],
      "5-mid": "0.5",
      "5-bound": [0.45, 0.55],
      "10-mid": "0.56",
      "10-bound": [0.5, 0.62],
      "25-mid": "0.63",
      "25-bound": [0.56, 0.69],
      "50-mid": "0.68",
      "50-bound": [0.61, 0.75],
      "100-mid": "0.74",
      "100-bound": [0.65, 0.81]
    },
    "10min": {
      "2-mid": "0.67",
      "2-bound": [0.61, 0.74],
      "5-mid": "0.8",
      "5-bound": [0.72, 0.88],
      "10-mid": "0.89",
      "10-bound": [0.8, 0.98],
      "25-mid": "1.0",
      "25-bound": [0.9, 1.1],
      "50-mid": "1.09",
      "50-bound": [0.97, 1.19],
      "100-mid": "1.17",
      "100-bound": [1.04, 1.28]
    },
    "15min": {
      "2-mid": "0.85",
      "2-bound": [0.77, 0.93],
      "5-mid": "1.0",
      "5-bound": [0.91, 1.11],
      "10-mid": "1.13",
      "10-bound": [1.02, 1.24],
      "25-mid": "1.27",
      "25-bound": [1.14, 1.39],
      "50-mid": "1.38",
      "50-bound": [1.23, 1.51],
      "100-mid": "1.47",
      "100-bound": [1.31, 1.62]
    },
    "30min": {
      "2-mid": "1.17",
      "2-bound": [1.06, 1.29],
      "5-mid": "1.43",
      "5-bound": [1.29, 1.57],
      "10-mid": "1.63",
      "10-bound": [1.47, 1.8],
      "25-mid": "1.87",
      "25-bound": [1.68, 2.06],
      "50-mid": "2.07",
      "50-bound": [1.85, 2.27],
      "100-mid": "2.25",
      "100-bound": [2.0, 2.47]
    },
    "60min": {
      "2-mid": "1.47",
      "2-bound": [1.32, 1.62],
      "5-mid": "1.83",
      "5-bound": [1.65, 2.01],
      "10-mid": "2.12",
      "10-bound": [1.91, 2.34],
      "25-mid": "2.5",
      "25-bound": [2.24, 2.74],
      "50-mid": "2.8",
      "50-bound": [2.5, 3.07],
      "100-mid": "3.1",
      "100-bound": [2.76, 3.4]
    },
    "2hr": {
      "2-mid": "1.73",
      "2-bound": [1.54, 1.94],
      "5-mid": "2.18",
      "5-bound": [1.94, 2.44],
      "10-mid": "2.55",
      "10-bound": [2.27, 2.86],
      "25-mid": "3.05",
      "25-bound": [2.69, 3.4],
      "50-mid": "3.45",
      "50-bound": [3.03, 3.86],
      "100-mid": "3.88",
      "100-bound": [3.38, 4.31]
    },
    "3hr": {
      "2-mid": "1.89",
      "2-bound": [1.66, 2.16],
      "5-mid": "2.37",
      "5-bound": [2.08, 2.71],
      "10-mid": "2.77",
      "10-bound": [2.42, 3.17],
      "25-mid": "3.31",
      "25-bound": [2.88, 3.77],
      "50-mid": "3.76",
      "50-bound": [3.25, 4.27],
      "100-mid": "4.22",
      "100-bound": [3.62, 4.79]
    },
    "6hr": {
      "2-mid": "2.34",
      "2-bound": [2.04, 2.72],
      "5-mid": "2.92",
      "5-bound": [2.54, 3.4],
      "10-mid": "3.44",
      "10-bound": [2.98, 3.99],
      "25-mid": "4.13",
      "25-bound": [3.56, 4.79],
      "50-mid": "4.72",
      "50-bound": [4.04, 5.46],
      "100-mid": "5.36",
      "100-bound": [4.53, 6.18]
    },
    "12hr": {
      "2-mid": "2.9",
      "2-bound": [2.55, 3.34],
      "5-mid": "3.63",
      "5-bound": [3.19, 4.18],
      "10-mid": "4.3",
      "10-bound": [3.76, 4.93],
      "25-mid": "5.23",
      "25-bound": [4.53, 5.98],
      "50-mid": "6.05",
      "50-bound": [5.19, 6.89],
      "100-mid": "6.93",
      "100-bound": [5.88, 7.88]
    },
    "24hr": {
      "2-mid": "3.37",
      "2-bound": [3.05, 3.76],
      "5-mid": "4.3",
      "5-bound": [3.9, 4.81],
      "10-mid": "5.1",
      "10-bound": [4.6, 5.69],
      "25-mid": "6.28",
      "25-bound": [5.63, 6.99],
      "50-mid": "7.3",
      "50-bound": [6.49, 8.08],
      "100-mid": "8.42",
      "100-bound": [7.43, 9.31]
    },
    "2day": {
      "2-mid": "3.93",
      "2-bound": [3.59, 4.34],
      "5-mid": "5.0",
      "5-bound": [4.56, 5.52],
      "10-mid": "5.89",
      "10-bound": [5.35, 6.49],
      "25-mid": "7.18",
      "25-bound": [6.48, 7.89],
      "50-mid": "8.26",
      "50-bound": [7.41, 9.07],
      "100-mid": "9.43",
      "100-bound": [8.41, 10.4]
    },
    "3day": {
      "2-mid": "4.19",
      "2-bound": [3.83, 4.61],
      "5-mid": "5.32",
      "5-bound": [4.86, 5.85],
      "10-mid": "6.26",
      "10-bound": [5.7, 6.87],
      "25-mid": "7.62",
      "25-bound": [6.9, 8.35],
      "50-mid": "8.77",
      "50-bound": [7.89, 9.6],
      "100-mid": "10.0",
      "100-bound": [8.95, 11.0]
    },
    "4day": {
      "2-mid": "4.44",
      "2-bound": [4.07, 4.87],
      "5-mid": "5.64",
      "5-bound": [5.15, 6.18],
      "10-mid": "6.63",
      "10-bound": [6.05, 7.25],
      "25-mid": "8.07",
      "25-bound": [7.33, 8.82],
      "50-mid": "9.28",
      "50-bound": [8.38, 10.1],
      "100-mid": "10.6",
      "100-bound": [9.49, 11.6]
    },
    "7day": {
      "2-mid": "5.12",
      "2-bound": [4.7, 5.61],
      "5-mid": "6.4",
      "5-bound": [5.86, 7.01],
      "10-mid": "7.46",
      "10-bound": [6.81, 8.16],
      "25-mid": "8.99",
      "25-bound": [8.17, 9.83],
      "50-mid": "10.3",
      "50-bound": [9.28, 11.2],
      "100-mid": "11.6",
      "100-bound": [10.4, 12.7]
    }
  },
  "USC00441614 6": {
    "fips": "51143",
    "station_name": "CHATHAM",
    "state": "VA",
    "latitude": "36.8220",
    "longitude": "-79.4100",
    "5min": {
      "2-mid": "0.43",
      "2-bound": [0.39, 0.47],
      "5-mid": "0.51",
      "5-bound": [0.46, 0.56],
      "10-mid": "0.56",
      "10-bound": [0.51, 0.62],
      "25-mid": "0.63",
      "25-bound": [0.57, 0.69],
      "50-mid": "0.68",
      "50-bound": [0.61, 0.74],
      "100-mid": "0.72",
      "100-bound": [0.65, 0.79]
    },
    "10min": {
      "2-mid": "0.69",
      "2-bound": [0.62, 0.75],
      "5-mid": "0.81",
      "5-bound": [0.74, 0.89],
      "10-mid": "0.9",
      "10-bound": [0.82, 0.98],
      "25-mid": "1.01",
      "25-bound": [0.91, 1.1],
      "50-mid": "1.08",
      "50-bound": [0.97, 1.18],
      "100-mid": "1.15",
      "100-bound": [1.03, 1.25]
    },
    "15min": {
      "2-mid": "0.86",
      "2-bound": [0.78, 0.94],
      "5-mid": "1.03",
      "5-bound": [0.93, 1.13],
      "10-mid": "1.14",
      "10-bound": [1.04, 1.25],
      "25-mid": "1.28",
      "25-bound": [1.16, 1.39],
      "50-mid": "1.37",
      "50-bound": [1.23, 1.49],
      "100-mid": "1.45",
      "100-bound": [1.3, 1.58]
    },
    "30min": {
      "2-mid": "1.19",
      "2-bound": [1.08, 1.3],
      "5-mid": "1.46",
      "5-bound": [1.33, 1.6],
      "10-mid": "1.65",
      "10-bound": [1.5, 1.8],
      "25-mid": "1.89",
      "25-bound": [1.71, 2.06],
      "50-mid": "2.06",
      "50-bound": [1.86, 2.24],
      "100-mid": "2.22",
      "100-bound": [1.99, 2.42]
    },
    "60min": {
      "2-mid": "1.49",
      "2-bound": [1.36, 1.63],
      "5-mid": "1.88",
      "5-bound": [1.7, 2.05],
      "10-mid": "2.15",
      "10-bound": [1.95, 2.35],
      "25-mid": "2.52",
      "25-bound": [2.28, 2.75],
      "50-mid": "2.79",
      "50-bound": [2.51, 3.04],
      "100-mid": "3.06",
      "100-bound": [2.75, 3.34]
    },
    "2hr": {
      "2-mid": "1.77",
      "2-bound": [1.6, 1.95],
      "5-mid": "2.24",
      "5-bound": [2.02, 2.46],
      "10-mid": "2.6",
      "10-bound": [2.34, 2.85],
      "25-mid": "3.08",
      "25-bound": [2.76, 3.38],
      "50-mid": "3.47",
      "50-bound": [3.09, 3.79],
      "100-mid": "3.86",
      "100-bound": [3.41, 4.21]
    },
    "3hr": {
      "2-mid": "1.91",
      "2-bound": [1.73, 2.1],
      "5-mid": "2.41",
      "5-bound": [2.18, 2.66],
      "10-mid": "2.8",
      "10-bound": [2.52, 3.07],
      "25-mid": "3.32",
      "25-bound": [2.97, 3.64],
      "50-mid": "3.72",
      "50-bound": [3.32, 4.08],
      "100-mid": "4.15",
      "100-bound": [3.68, 4.54]
    },
    "6hr": {
      "2-mid": "2.34",
      "2-bound": [2.12, 2.61],
      "5-mid": "2.95",
      "5-bound": [2.66, 3.28],
      "10-mid": "3.44",
      "10-bound": [3.1, 3.83],
      "25-mid": "4.13",
      "25-bound": [3.69, 4.57],
      "50-mid": "4.69",
      "50-bound": [4.16, 5.18],
      "100-mid": "5.28",
      "100-bound": [4.64, 5.82]
    },
    "12hr": {
      "2-mid": "2.84",
      "2-bound": [2.57, 3.15],
      "5-mid": "3.6",
      "5-bound": [3.25, 3.98],
      "10-mid": "4.23",
      "10-bound": [3.81, 4.67],
      "25-mid": "5.14",
      "25-bound": [4.58, 5.65],
      "50-mid": "5.9",
      "50-bound": [5.22, 6.47],
      "100-mid": "6.74",
      "100-bound": [5.89, 7.36]
    },
    "24hr": {
      "2-mid": "3.4",
      "2-bound": [3.14, 3.7],
      "5-mid": "4.33",
      "5-bound": [3.99, 4.72],
      "10-mid": "5.13",
      "10-bound": [4.71, 5.57],
      "25-mid": "6.29",
      "25-bound": [5.73, 6.81],
      "50-mid": "7.29",
      "50-bound": [6.6, 7.88],
      "100-mid": "8.38",
      "100-bound": [7.52, 9.04]
    },
    "2day": {
      "2-mid": "4.02",
      "2-bound": [3.71, 4.36],
      "5-mid": "5.1",
      "5-bound": [4.7, 5.53],
      "10-mid": "5.98",
      "10-bound": [5.5, 6.48],
      "25-mid": "7.26",
      "25-bound": [6.64, 7.86],
      "50-mid": "8.33",
      "50-bound": [7.59, 9.02],
      "100-mid": "9.48",
      "100-bound": [8.57, 10.3]
    },
    "3day": {
      "2-mid": "4.24",
      "2-bound": [3.92, 4.62],
      "5-mid": "5.38",
      "5-bound": [4.96, 5.85],
      "10-mid": "6.31",
      "10-bound": [5.81, 6.86],
      "25-mid": "7.65",
      "25-bound": [7.0, 8.31],
      "50-mid": "8.78",
      "50-bound": [7.99, 9.53],
      "100-mid": "9.98",
      "100-bound": [9.02, 10.8]
    },
    "4day": {
      "2-mid": "4.46",
      "2-bound": [4.13, 4.87],
      "5-mid": "5.66",
      "5-bound": [5.22, 6.16],
      "10-mid": "6.64",
      "10-bound": [6.11, 7.24],
      "25-mid": "8.05",
      "25-bound": [7.36, 8.76],
      "50-mid": "9.22",
      "50-bound": [8.39, 10.0],
      "100-mid": "10.5",
      "100-bound": [9.47, 11.4]
    },
    "7day": {
      "2-mid": "5.08",
      "2-bound": [4.72, 5.5],
      "5-mid": "6.34",
      "5-bound": [5.88, 6.86],
      "10-mid": "7.37",
      "10-bound": [6.82, 7.97],
      "25-mid": "8.85",
      "25-bound": [8.14, 9.56],
      "50-mid": "10.1",
      "50-bound": [9.22, 10.9],
      "100-mid": "11.4",
      "100-bound": [10.3, 12.3]
    }
  },
  "USW00013741 6": {
    "fips": "51770",
    "station_name": "ROANOKE INTL AP",
    "state": "VA",
    "latitude": "37.3160",
    "longitude": "-79.9740",
    "5min": {
      "2-mid": "0.37",
      "2-bound": [0.34, 0.41],
      "5-mid": "0.45",
      "5-bound": [0.41, 0.5],
      "10-mid": "0.51",
      "10-bound": [0.46, 0.56],
      "25-mid": "0.58",
      "25-bound": [0.52, 0.64],
      "50-mid": "0.62",
      "50-bound": [0.56, 0.69],
      "100-mid": "0.67",
      "100-bound": [0.59, 0.75]
    },
    "10min": {
      "2-mid": "0.59",
      "2-bound": [0.54, 0.66],
      "5-mid": "0.72",
      "5-bound": [0.65, 0.8],
      "10-mid": "0.81",
      "10-bound": [0.73, 0.9],
      "25-mid": "0.92",
      "25-bound": [0.82, 1.01],
      "50-mid": "1.0",
      "50-bound": [0.89, 1.1],
      "100-mid": "1.07",
      "100-bound": [0.94, 1.19]
    },
    "15min": {
      "2-mid": "0.75",
      "2-bound": [0.68, 0.83],
      "5-mid": "0.91",
      "5-bound": [0.83, 1.01],
      "10-mid": "1.03",
      "10-bound": [0.93, 1.13],
      "25-mid": "1.16",
      "25-bound": [1.04, 1.28],
      "50-mid": "1.26",
      "50-bound": [1.12, 1.4],
      "100-mid": "1.35",
      "100-bound": [1.19, 1.5]
    },
    "30min": {
      "2-mid": "1.03",
      "2-bound": [0.94, 1.14],
      "5-mid": "1.3",
      "5-bound": [1.17, 1.43],
      "10-mid": "1.49",
      "10-bound": [1.34, 1.64],
      "25-mid": "1.72",
      "25-bound": [1.54, 1.9],
      "50-mid": "1.9",
      "50-bound": [1.69, 2.1],
      "100-mid": "2.07",
      "100-bound": [1.82, 2.3]
    },
    "60min": {
      "2-mid": "1.3",
      "2-bound": [1.18, 1.43],
      "5-mid": "1.66",
      "5-bound": [1.5, 1.84],
      "10-mid": "1.94",
      "10-bound": [1.75, 2.14],
      "25-mid": "2.3",
      "25-bound": [2.06, 2.53],
      "50-mid": "2.57",
      "50-bound": [2.29, 2.85],
      "100-mid": "2.85",
      "100-bound": [2.51, 3.16]
    },
    "2hr": {
      "2-mid": "1.53",
      "2-bound": [1.39, 1.69],
      "5-mid": "1.98",
      "5-bound": [1.79, 2.18],
      "10-mid": "2.31",
      "10-bound": [2.09, 2.55],
      "25-mid": "2.77",
      "25-bound": [2.49, 3.06],
      "50-mid": "3.13",
      "50-bound": [2.8, 3.46],
      "100-mid": "3.5",
      "100-bound": [3.1, 3.88]
    },
    "3hr": {
      "2-mid": "1.65",
      "2-bound": [1.51, 1.83],
      "5-mid": "2.12",
      "5-bound": [1.93, 2.34],
      "10-mid": "2.48",
      "10-bound": [2.25, 2.74],
      "25-mid": "2.97",
      "25-bound": [2.68, 3.28],
      "50-mid": "3.36",
      "50-bound": [3.0, 3.72],
      "100-mid": "3.77",
      "100-bound": [3.33, 4.18]
    },
    "6hr": {
      "2-mid": "2.05",
      "2-bound": [1.89, 2.26],
      "5-mid": "2.6",
      "5-bound": [2.39, 2.87],
      "10-mid": "3.05",
      "10-bound": [2.78, 3.36],
      "25-mid": "3.67",
      "25-bound": [3.31, 4.04],
      "50-mid": "4.18",
      "50-bound": [3.74, 4.62],
      "100-mid": "4.73",
      "100-bound": [4.18, 5.24]
    },
    "12hr": {
      "2-mid": "2.51",
      "2-bound": [2.31, 2.76],
      "5-mid": "3.18",
      "5-bound": [2.92, 3.49],
      "10-mid": "3.73",
      "10-bound": [3.41, 4.1],
      "25-mid": "4.55",
      "25-bound": [4.1, 4.99],
      "50-mid": "5.24",
      "50-bound": [4.66, 5.76],
      "100-mid": "6.0",
      "100-bound": [5.25, 6.62]
    },
    "24hr": {
      "2-mid": "3.14",
      "2-bound": [2.89, 3.44],
      "5-mid": "4.0",
      "5-bound": [3.67, 4.36],
      "10-mid": "4.7",
      "10-bound": [4.3, 5.12],
      "25-mid": "5.72",
      "25-bound": [5.2, 6.22],
      "50-mid": "6.57",
      "50-bound": [5.94, 7.15],
      "100-mid": "7.5",
      "100-bound": [6.73, 8.14]
    },
    "2day": {
      "2-mid": "3.71",
      "2-bound": [3.42, 4.04],
      "5-mid": "4.69",
      "5-bound": [4.33, 5.1],
      "10-mid": "5.49",
      "10-bound": [5.04, 5.96],
      "25-mid": "6.63",
      "25-bound": [6.06, 7.18],
      "50-mid": "7.57",
      "50-bound": [6.89, 8.2],
      "100-mid": "8.58",
      "100-bound": [7.75, 9.29]
    },
    "3day": {
      "2-mid": "3.94",
      "2-bound": [3.64, 4.29],
      "5-mid": "4.97",
      "5-bound": [4.59, 5.41],
      "10-mid": "5.81",
      "10-bound": [5.34, 6.3],
      "25-mid": "7.0",
      "25-bound": [6.4, 7.58],
      "50-mid": "7.98",
      "50-bound": [7.26, 8.64],
      "100-mid": "9.02",
      "100-bound": [8.16, 9.78]
    },
    "4day": {
      "2-mid": "4.18",
      "2-bound": [3.86, 4.54],
      "5-mid": "5.26",
      "5-bound": [4.85, 5.71],
      "10-mid": "6.13",
      "10-bound": [5.64, 6.65],
      "25-mid": "7.37",
      "25-bound": [6.74, 7.99],
      "50-mid": "8.39",
      "50-bound": [7.64, 9.09],
      "100-mid": "9.46",
      "100-bound": [8.57, 10.3]
    },
    "7day": {
      "2-mid": "4.8",
      "2-bound": [4.46, 5.18],
      "5-mid": "5.98",
      "5-bound": [5.55, 6.44],
      "10-mid": "6.91",
      "10-bound": [6.4, 7.44],
      "25-mid": "8.21",
      "25-bound": [7.57, 8.83],
      "50-mid": "9.26",
      "50-bound": [8.51, 9.97],
      "100-mid": "10.4",
      "100-bound": [9.45, 11.2]
    }
  },
  "USW00093720 6": {
    "fips": "24045",
    "station_name": "SALISBURY-WICOMICO REGIONAL AIRPORT",
    "state": "MD",
    "latitude": "38.3408",
    "longitude": "-75.5132",
    "5min": {
      "2-mid": "0.43",
      "2-bound": [0.38, 0.47],
      "5-mid": "0.5",
      "5-bound": [0.45, 0.55],
      "10-mid": "0.56",
      "10-bound": [0.51, 0.62],
      "25-mid": "0.64",
      "25-bound": [0.57, 0.71],
      "50-mid": "0.7",
      "50-bound": [0.62, 0.78],
      "100-mid": "0.76",
      "100-bound": [0.67, 0.84]
    },
    "10min": {
      "2-mid": "0.68",
      "2-bound": [0.61, 0.76],
      "5-mid": "0.8",
      "5-bound": [0.72, 0.89],
      "10-mid": "0.9",
      "10-bound": [0.81, 1.0],
      "25-mid": "1.02",
      "25-bound": [0.91, 1.13],
      "50-mid": "1.11",
      "50-bound": [0.99, 1.24],
      "100-mid": "1.2",
      "100-bound": [1.06, 1.34]
    },
    "15min": {
      "2-mid": "0.86",
      "2-bound": [0.77, 0.95],
      "5-mid": "1.01",
      "5-bound": [0.91, 1.12],
      "10-mid": "1.14",
      "10-bound": [1.02, 1.26],
      "25-mid": "1.29",
      "25-bound": [1.15, 1.43],
      "50-mid": "1.41",
      "50-bound": [1.25, 1.57],
      "100-mid": "1.52",
      "100-bound": [1.34, 1.69]
    },
    "30min": {
      "2-mid": "1.19",
      "2-bound": [1.07, 1.31],
      "5-mid": "1.44",
      "5-bound": [1.29, 1.59],
      "10-mid": "1.66",
      "10-bound": [1.48, 1.83],
      "25-mid": "1.91",
      "25-bound": [1.71, 2.12],
      "50-mid": "2.12",
      "50-bound": [1.89, 2.36],
      "100-mid": "2.32",
      "100-bound": [2.06, 2.59]
    },
    "60min": {
      "2-mid": "1.49",
      "2-bound": [1.34, 1.65],
      "5-mid": "1.84",
      "5-bound": [1.66, 2.04],
      "10-mid": "2.16",
      "10-bound": [1.93, 2.39],
      "25-mid": "2.55",
      "25-bound": [2.28, 2.83],
      "50-mid": "2.88",
      "50-bound": [2.56, 3.2],
      "100-mid": "3.2",
      "100-bound": [2.84, 3.57]
    },
    "2hr": {
      "2-mid": "1.84",
      "2-bound": [1.64, 2.05],
      "5-mid": "2.3",
      "5-bound": [2.04, 2.56],
      "10-mid": "2.71",
      "10-bound": [2.41, 3.02],
      "25-mid": "3.23",
      "25-bound": [2.86, 3.61],
      "50-mid": "3.68",
      "50-bound": [3.24, 4.12],
      "100-mid": "4.14",
      "100-bound": [3.62, 4.64]
    },
    "3hr": {
      "2-mid": "2.0",
      "2-bound": [1.79, 2.24],
      "5-mid": "2.51",
      "5-bound": [2.24, 2.81],
      "10-mid": "2.97",
      "10-bound": [2.64, 3.32],
      "25-mid": "3.57",
      "25-bound": [3.15, 3.98],
      "50-mid": "4.1",
      "50-bound": [3.59, 4.57],
      "100-mid": "4.63",
      "100-bound": [4.03, 5.18]
    },
    "6hr": {
      "2-mid": "2.45",
      "2-bound": [2.19, 2.75],
      "5-mid": "3.05",
      "5-bound": [2.72, 3.42],
      "10-mid": "3.63",
      "10-bound": [3.22, 4.06],
      "25-mid": "4.41",
      "25-bound": [3.88, 4.93],
      "50-mid": "5.1",
      "50-bound": [4.46, 5.72],
      "100-mid": "5.83",
      "100-bound": [5.05, 6.56]
    },
    "12hr": {
      "2-mid": "2.9",
      "2-bound": [2.58, 3.27],
      "5-mid": "3.64",
      "5-bound": [3.23, 4.1],
      "10-mid": "4.37",
      "10-bound": [3.87, 4.92],
      "25-mid": "5.39",
      "25-bound": [4.73, 6.06],
      "50-mid": "6.34",
      "50-bound": [5.5, 7.13],
      "100-mid": "7.36",
      "100-bound": [6.31, 8.3]
    },
    "24hr": {
      "2-mid": "3.47",
      "2-bound": [3.21, 3.78],
      "5-mid": "4.51",
      "5-bound": [4.16, 4.91],
      "10-mid": "5.41",
      "10-bound": [4.98, 5.88],
      "25-mid": "6.78",
      "25-bound": [6.2, 7.34],
      "50-mid": "7.99",
      "50-bound": [7.24, 8.62],
      "100-mid": "9.35",
      "100-bound": [8.4, 10.1]
    },
    "2day": {
      "2-mid": "4.0",
      "2-bound": [3.7, 4.35],
      "5-mid": "5.2",
      "5-bound": [4.81, 5.65],
      "10-mid": "6.23",
      "10-bound": [5.74, 6.77],
      "25-mid": "7.79",
      "25-bound": [7.13, 8.44],
      "50-mid": "9.15",
      "50-bound": [8.32, 9.89],
      "100-mid": "10.7",
      "100-bound": [9.63, 11.5]
    },
    "3day": {
      "2-mid": "4.24",
      "2-bound": [3.94, 4.6],
      "5-mid": "5.48",
      "5-bound": [5.09, 5.94],
      "10-mid": "6.55",
      "10-bound": [6.06, 7.08],
      "25-mid": "8.15",
      "25-bound": [7.48, 8.8],
      "50-mid": "9.54",
      "50-bound": [8.7, 10.3],
      "100-mid": "11.1",
      "100-bound": [10.0, 11.9]
    },
    "4day": {
      "2-mid": "4.48",
      "2-bound": [4.17, 4.84],
      "5-mid": "5.77",
      "5-bound": [5.37, 6.24],
      "10-mid": "6.87",
      "10-bound": [6.37, 7.4],
      "25-mid": "8.51",
      "25-bound": [7.83, 9.16],
      "50-mid": "9.92",
      "50-bound": [9.09, 10.7],
      "100-mid": "11.5",
      "100-bound": [10.4, 12.3]
    },
    "7day": {
      "2-mid": "5.11",
      "2-bound": [4.76, 5.51],
      "5-mid": "6.47",
      "5-bound": [6.02, 6.98],
      "10-mid": "7.63",
      "10-bound": [7.09, 8.21],
      "25-mid": "9.35",
      "25-bound": [8.63, 10.0],
      "50-mid": "10.8",
      "50-bound": [9.93, 11.6],
      "100-mid": "12.4",
      "100-bound": [11.3, 13.3]
    }
  },
  "USC00300085 6": {
    "fips": "36003",
    "station_name": "ALFRED",
    "state": "NY",
    "latitude": "42.2798",
    "longitude": "-77.7656",
    "5min": {
      "2-mid": "0.33",
      "2-bound": [0.26, 0.41],
      "5-mid": "0.42",
      "5-bound": [0.33, 0.52],
      "10-mid": "0.49",
      "10-bound": [0.39, 0.62],
      "25-mid": "0.6",
      "25-bound": [0.45, 0.78],
      "50-mid": "0.68",
      "50-bound": [0.5, 0.91],
      "100-mid": "0.76",
      "100-bound": [0.54, 1.06]
    },
    "10min": {
      "2-mid": "0.47",
      "2-bound": [0.37, 0.58],
      "5-mid": "0.6",
      "5-bound": [0.47, 0.74],
      "10-mid": "0.7",
      "10-bound": [0.55, 0.87],
      "25-mid": "0.85",
      "25-bound": [0.64, 1.11],
      "50-mid": "0.96",
      "50-bound": [0.71, 1.29],
      "100-mid": "1.07",
      "100-bound": [0.77, 1.5]
    },
    "15min": {
      "2-mid": "0.55",
      "2-bound": [0.44, 0.68],
      "5-mid": "0.7",
      "5-bound": [0.56, 0.87],
      "10-mid": "0.82",
      "10-bound": [0.65, 1.03],
      "25-mid": "1.0",
      "25-bound": [0.76, 1.31],
      "50-mid": "1.13",
      "50-bound": [0.84, 1.51],
      "100-mid": "1.26",
      "100-bound": [0.91, 1.76]
    },
    "30min": {
      "2-mid": "0.78",
      "2-bound": [0.62, 0.96],
      "5-mid": "0.98",
      "5-bound": [0.78, 1.22],
      "10-mid": "1.16",
      "10-bound": [0.91, 1.44],
      "25-mid": "1.39",
      "25-bound": [1.06, 1.83],
      "50-mid": "1.57",
      "50-bound": [1.17, 2.11],
      "100-mid": "1.76",
      "100-bound": [1.26, 2.46]
    },
    "60min": {
      "2-mid": "1.0",
      "2-bound": [0.8, 1.23],
      "5-mid": "1.27",
      "5-bound": [1.01, 1.57],
      "10-mid": "1.49",
      "10-bound": [1.17, 1.86],
      "25-mid": "1.79",
      "25-bound": [1.36, 2.35],
      "50-mid": "2.02",
      "50-bound": [1.5, 2.71],
      "100-mid": "2.26",
      "100-bound": [1.62, 3.16]
    },
    "2hr": {
      "2-mid": "1.24",
      "2-bound": [0.99, 1.52],
      "5-mid": "1.59",
      "5-bound": [1.27, 1.96],
      "10-mid": "1.88",
      "10-bound": [1.49, 2.33],
      "25-mid": "2.28",
      "25-bound": [1.74, 2.96],
      "50-mid": "2.58",
      "50-bound": [1.92, 3.44],
      "100-mid": "2.89",
      "100-bound": [2.08, 4.01]
    },
    "3hr": {
      "2-mid": "1.39",
      "2-bound": [1.12, 1.7],
      "5-mid": "1.79",
      "5-bound": [1.44, 2.2],
      "10-mid": "2.12",
      "10-bound": [1.69, 2.62],
      "25-mid": "2.58",
      "25-bound": [1.98, 3.34],
      "50-mid": "2.92",
      "50-bound": [2.19, 3.88],
      "100-mid": "3.28",
      "100-bound": [2.37, 4.55]
    },
    "6hr": {
      "2-mid": "1.69",
      "2-bound": [1.37, 2.05],
      "5-mid": "2.16",
      "5-bound": [1.75, 2.64],
      "10-mid": "2.56",
      "10-bound": [2.05, 3.14],
      "25-mid": "3.1",
      "25-bound": [2.4, 4.02],
      "50-mid": "3.51",
      "50-bound": [2.66, 4.67],
      "100-mid": "3.94",
      "100-bound": [2.9, 5.51]
    },
    "12hr": {
      "2-mid": "2.03",
      "2-bound": [1.66, 2.45],
      "5-mid": "2.58",
      "5-bound": [2.1, 3.12],
      "10-mid": "3.03",
      "10-bound": [2.45, 3.69],
      "25-mid": "3.66",
      "25-bound": [2.87, 4.74],
      "50-mid": "4.1",
      "50-bound": [3.16, 5.5],
      "100-mid": "4.62",
      "100-bound": [3.47, 6.54]
    },
    "24hr": {
      "2-mid": "2.39",
      "2-bound": [1.97, 2.86],
      "5-mid": "3.05",
      "5-bound": [2.5, 3.66],
      "10-mid": "3.59",
      "10-bound": [2.92, 4.34],
      "25-mid": "4.34",
      "25-bound": [3.43, 5.6],
      "50-mid": "4.87",
      "50-bound": [3.78, 6.51],
      "100-mid": "5.49",
      "100-bound": [4.17, 7.78]
    },
    "2day": {
      "2-mid": "2.77",
      "2-bound": [2.29, 3.29],
      "5-mid": "3.59",
      "5-bound": [2.96, 4.28],
      "10-mid": "4.26",
      "10-bound": [3.49, 5.12],
      "25-mid": "5.2",
      "25-bound": [4.12, 6.65],
      "50-mid": "5.88",
      "50-bound": [4.56, 7.75],
      "100-mid": "6.64",
      "100-bound": [5.03, 9.26]
    },
    "3day": {
      "2-mid": "3.03",
      "2-bound": [2.52, 3.58],
      "5-mid": "3.93",
      "5-bound": [3.25, 4.67],
      "10-mid": "4.67",
      "10-bound": [3.84, 5.59],
      "25-mid": "5.7",
      "25-bound": [4.53, 7.26],
      "50-mid": "6.45",
      "50-bound": [5.02, 8.46],
      "100-mid": "7.29",
      "100-bound": [5.52, 10.1]
    },
    "4day": {
      "2-mid": "3.25",
      "2-bound": [2.71, 3.83],
      "5-mid": "4.19",
      "5-bound": [3.48, 4.97],
      "10-mid": "4.98",
      "10-bound": [4.1, 5.94],
      "25-mid": "6.06",
      "25-bound": [4.82, 7.68],
      "50-mid": "6.84",
      "50-bound": [5.33, 8.94],
      "100-mid": "7.72",
      "100-bound": [5.85, 10.6]
    },
    "7day": {
      "2-mid": "3.83",
      "2-bound": [3.21, 4.49],
      "5-mid": "4.84",
      "5-bound": [4.04, 5.7],
      "10-mid": "5.68",
      "10-bound": [4.71, 6.74],
      "25-mid": "6.84",
      "25-bound": [5.46, 8.59],
      "50-mid": "7.68",
      "50-bound": [6.0, 9.93],
      "100-mid": "8.62",
      "100-bound": [6.53, 11.7]
    }
  },
  "USC00440166 6": {
    "fips": "51031",
    "station_name": "ALTAVISTA",
    "state": "VA",
    "latitude": "37.1120",
    "longitude": "-79.2750",
    "5min": {
      "2-mid": "0.41",
      "2-bound": [0.37, 0.45],
      "5-mid": "0.48",
      "5-bound": [0.44, 0.53],
      "10-mid": "0.54",
      "10-bound": [0.49, 0.59],
      "25-mid": "0.61",
      "25-bound": [0.55, 0.67],
      "50-mid": "0.66",
      "50-bound": [0.59, 0.72],
      "100-mid": "0.7",
      "100-bound": [0.63, 0.77]
    },
    "10min": {
      "2-mid": "0.65",
      "2-bound": [0.59, 0.71],
      "5-mid": "0.78",
      "5-bound": [0.71, 0.85],
      "10-mid": "0.87",
      "10-bound": [0.79, 0.94],
      "25-mid": "0.97",
      "25-bound": [0.88, 1.06],
      "50-mid": "1.04",
      "50-bound": [0.94, 1.14],
      "100-mid": "1.12",
      "100-bound": [1.0, 1.22]
    },
    "15min": {
      "2-mid": "0.82",
      "2-bound": [0.75, 0.9],
      "5-mid": "0.98",
      "5-bound": [0.9, 1.08],
      "10-mid": "1.1",
      "10-bound": [0.99, 1.2],
      "25-mid": "1.23",
      "25-bound": [1.12, 1.34],
      "50-mid": "1.32",
      "50-bound": [1.19, 1.44],
      "100-mid": "1.41",
      "100-bound": [1.26, 1.54]
    },
    "30min": {
      "2-mid": "1.13",
      "2-bound": [1.03, 1.24],
      "5-mid": "1.4",
      "5-bound": [1.27, 1.53],
      "10-mid": "1.59",
      "10-bound": [1.44, 1.73],
      "25-mid": "1.82",
      "25-bound": [1.65, 1.99],
      "50-mid": "1.99",
      "50-bound": [1.8, 2.17],
      "100-mid": "2.16",
      "100-bound": [1.94, 2.36]
    },
    "60min": {
      "2-mid": "1.42",
      "2-bound": [1.3, 1.55],
      "5-mid": "1.79",
      "5-bound": [1.63, 1.96],
      "10-mid": "2.07",
      "10-bound": [1.88, 2.26],
      "25-mid": "2.43",
      "25-bound": [2.2, 2.65],
      "50-mid": "2.7",
      "50-bound": [2.43, 2.95],
      "100-mid": "2.98",
      "100-bound": [2.67, 3.25]
    },
    "2hr": {
      "2-mid": "1.67",
      "2-bound": [1.52, 1.84],
      "5-mid": "2.12",
      "5-bound": [1.93, 2.32],
      "10-mid": "2.47",
      "10-bound": [2.24, 2.7],
      "25-mid": "2.94",
      "25-bound": [2.66, 3.21],
      "50-mid": "3.31",
      "50-bound": [2.98, 3.61],
      "100-mid": "3.7",
      "100-bound": [3.3, 4.04]
    },
    "3hr": {
      "2-mid": "1.79",
      "2-bound": [1.64, 1.97],
      "5-mid": "2.27",
      "5-bound": [2.07, 2.49],
      "10-mid": "2.64",
      "10-bound": [2.4, 2.9],
      "25-mid": "3.15",
      "25-bound": [2.84, 3.44],
      "50-mid": "3.55",
      "50-bound": [3.18, 3.88],
      "100-mid": "3.96",
      "100-bound": [3.53, 4.32]
    },
    "6hr": {
      "2-mid": "2.21",
      "2-bound": [2.01, 2.44],
      "5-mid": "2.79",
      "5-bound": [2.54, 3.08],
      "10-mid": "3.27",
      "10-bound": [2.96, 3.6],
      "25-mid": "3.92",
      "25-bound": [3.53, 4.31],
      "50-mid": "4.47",
      "50-bound": [3.99, 4.9],
      "100-mid": "5.05",
      "100-bound": [4.47, 5.53]
    },
    "12hr": {
      "2-mid": "2.68",
      "2-bound": [2.45, 2.98],
      "5-mid": "3.4",
      "5-bound": [3.1, 3.77],
      "10-mid": "4.01",
      "10-bound": [3.63, 4.43],
      "25-mid": "4.89",
      "25-bound": [4.39, 5.38],
      "50-mid": "5.63",
      "50-bound": [5.0, 6.17],
      "100-mid": "6.44",
      "100-bound": [5.65, 7.04]
    },
    "24hr": {
      "2-mid": "3.32",
      "2-bound": [3.06, 3.64],
      "5-mid": "4.25",
      "5-bound": [3.9, 4.65],
      "10-mid": "5.03",
      "10-bound": [4.6, 5.5],
      "25-mid": "6.18",
      "25-bound": [5.61, 6.73],
      "50-mid": "7.16",
      "50-bound": [6.46, 7.79],
      "100-mid": "8.24",
      "100-bound": [7.38, 8.96]
    },
    "2day": {
      "2-mid": "3.94",
      "2-bound": [3.63, 4.3],
      "5-mid": "5.0",
      "5-bound": [4.6, 5.46],
      "10-mid": "5.88",
      "10-bound": [5.39, 6.41],
      "25-mid": "7.15",
      "25-bound": [6.52, 7.78],
      "50-mid": "8.22",
      "50-bound": [7.45, 8.93],
      "100-mid": "9.36",
      "100-bound": [8.44, 10.2]
    },
    "3day": {
      "2-mid": "4.16",
      "2-bound": [3.84, 4.55],
      "5-mid": "5.29",
      "5-bound": [4.86, 5.77],
      "10-mid": "6.21",
      "10-bound": [5.69, 6.77],
      "25-mid": "7.55",
      "25-bound": [6.88, 8.22],
      "50-mid": "8.67",
      "50-bound": [7.86, 9.43],
      "100-mid": "9.87",
      "100-bound": [8.89, 10.7]
    },
    "4day": {
      "2-mid": "4.39",
      "2-bound": [4.04, 4.8],
      "5-mid": "5.57",
      "5-bound": [5.12, 6.08],
      "10-mid": "6.54",
      "10-bound": [5.99, 7.13],
      "25-mid": "7.94",
      "25-bound": [7.23, 8.65],
      "50-mid": "9.12",
      "50-bound": [8.26, 9.93],
      "100-mid": "10.4",
      "100-bound": [9.34, 11.3]
    },
    "7day": {
      "2-mid": "5.03",
      "2-bound": [4.64, 5.48],
      "5-mid": "6.28",
      "5-bound": [5.79, 6.83],
      "10-mid": "7.31",
      "10-bound": [6.72, 7.94],
      "25-mid": "8.78",
      "25-bound": [8.03, 9.53],
      "50-mid": "10.0",
      "50-bound": [9.1, 10.8],
      "100-mid": "11.3",
      "100-bound": [10.2, 12.3]
    }
  },
  "USC00367477 6": {
    "fips": "42047",
    "station_name": "RIDGWAY",
    "state": "PA",
    "latitude": "41.4190",
    "longitude": "-78.7492",
    "5min": {
      "2-mid": "0.36",
      "2-bound": [0.33, 0.41],
      "5-mid": "0.44",
      "5-bound": [0.39, 0.49],
      "10-mid": "0.5",
      "10-bound": [0.45, 0.55],
      "25-mid": "0.57",
      "25-bound": [0.51, 0.64],
      "50-mid": "0.63",
      "50-bound": [0.56, 0.7],
      "100-mid": "0.69",
      "100-bound": [0.61, 0.77]
    },
    "10min": {
      "2-mid": "0.57",
      "2-bound": [0.51, 0.63],
      "5-mid": "0.68",
      "5-bound": [0.61, 0.76],
      "10-mid": "0.77",
      "10-bound": [0.69, 0.85],
      "25-mid": "0.88",
      "25-bound": [0.78, 0.97],
      "50-mid": "0.96",
      "50-bound": [0.85, 1.06],
      "100-mid": "1.04",
      "100-bound": [0.92, 1.15]
    },
    "15min": {
      "2-mid": "0.69",
      "2-bound": [0.62, 0.77],
      "5-mid": "0.84",
      "5-bound": [0.75, 0.93],
      "10-mid": "0.95",
      "10-bound": [0.85, 1.05],
      "25-mid": "1.09",
      "25-bound": [0.97, 1.2],
      "50-mid": "1.19",
      "50-bound": [1.06, 1.32],
      "100-mid": "1.3",
      "100-bound": [1.14, 1.43]
    },
    "30min": {
      "2-mid": "0.93",
      "2-bound": [0.83, 1.03],
      "5-mid": "1.15",
      "5-bound": [1.03, 1.28],
      "10-mid": "1.32",
      "10-bound": [1.18, 1.46],
      "25-mid": "1.53",
      "25-bound": [1.37, 1.7],
      "50-mid": "1.7",
      "50-bound": [1.51, 1.88],
      "100-mid": "1.87",
      "100-bound": [1.65, 2.06]
    },
    "60min": {
      "2-mid": "1.14",
      "2-bound": [1.02, 1.27],
      "5-mid": "1.44",
      "5-bound": [1.29, 1.6],
      "10-mid": "1.67",
      "10-bound": [1.5, 1.86],
      "25-mid": "1.99",
      "25-bound": [1.77, 2.2],
      "50-mid": "2.24",
      "50-bound": [1.99, 2.48],
      "100-mid": "2.5",
      "100-bound": [2.21, 2.76]
    },
    "2hr": {
      "2-mid": "1.31",
      "2-bound": [1.18, 1.46],
      "5-mid": "1.65",
      "5-bound": [1.48, 1.84],
      "10-mid": "1.92",
      "10-bound": [1.72, 2.14],
      "25-mid": "2.3",
      "25-bound": [2.05, 2.55],
      "50-mid": "2.6",
      "50-bound": [2.31, 2.88],
      "100-mid": "2.92",
      "100-bound": [2.57, 3.22]
    },
    "3hr": {
      "2-mid": "1.42",
      "2-bound": [1.28, 1.59],
      "5-mid": "1.79",
      "5-bound": [1.61, 2.0],
      "10-mid": "2.08",
      "10-bound": [1.87, 2.32],
      "25-mid": "2.49",
      "25-bound": [2.22, 2.76],
      "50-mid": "2.83",
      "50-bound": [2.51, 3.13],
      "100-mid": "3.18",
      "100-bound": [2.81, 3.51]
    },
    "6hr": {
      "2-mid": "1.72",
      "2-bound": [1.56, 1.92],
      "5-mid": "2.14",
      "5-bound": [1.94, 2.38],
      "10-mid": "2.49",
      "10-bound": [2.24, 2.76],
      "25-mid": "2.98",
      "25-bound": [2.68, 3.29],
      "50-mid": "3.38",
      "50-bound": [3.02, 3.72],
      "100-mid": "3.81",
      "100-bound": [3.38, 4.18]
    },
    "12hr": {
      "2-mid": "2.09",
      "2-bound": [1.92, 2.31],
      "5-mid": "2.58",
      "5-bound": [2.36, 2.84],
      "10-mid": "2.99",
      "10-bound": [2.72, 3.28],
      "25-mid": "3.58",
      "25-bound": [3.24, 3.91],
      "50-mid": "4.06",
      "50-bound": [3.67, 4.43],
      "100-mid": "4.59",
      "100-bound": [4.11, 4.99]
    },
    "24hr": {
      "2-mid": "2.48",
      "2-bound": [2.31, 2.67],
      "5-mid": "3.02",
      "5-bound": [2.82, 3.26],
      "10-mid": "3.48",
      "10-bound": [3.24, 3.75],
      "25-mid": "4.12",
      "25-bound": [3.82, 4.43],
      "50-mid": "4.65",
      "50-bound": [4.3, 4.99],
      "100-mid": "5.21",
      "100-bound": [4.8, 5.57]
    },
    "2day": {
      "2-mid": "2.88",
      "2-bound": [2.69, 3.1],
      "5-mid": "3.49",
      "5-bound": [3.26, 3.76],
      "10-mid": "4.0",
      "10-bound": [3.72, 4.29],
      "25-mid": "4.7",
      "25-bound": [4.36, 5.03],
      "50-mid": "5.27",
      "50-bound": [4.88, 5.64],
      "100-mid": "5.87",
      "100-bound": [5.41, 6.27]
    },
    "3day": {
      "2-mid": "3.09",
      "2-bound": [2.9, 3.32],
      "5-mid": "3.73",
      "5-bound": [3.49, 4.0],
      "10-mid": "4.24",
      "10-bound": [3.97, 4.54],
      "25-mid": "4.96",
      "25-bound": [4.62, 5.29],
      "50-mid": "5.55",
      "50-bound": [5.15, 5.91],
      "100-mid": "6.15",
      "100-bound": [5.69, 6.55]
    },
    "4day": {
      "2-mid": "3.31",
      "2-bound": [3.12, 3.53],
      "5-mid": "3.96",
      "5-bound": [3.73, 4.23],
      "10-mid": "4.49",
      "10-bound": [4.21, 4.78],
      "25-mid": "5.22",
      "25-bound": [4.89, 5.56],
      "50-mid": "5.82",
      "50-bound": [5.43, 6.18],
      "100-mid": "6.43",
      "100-bound": [5.98, 6.83]
    },
    "7day": {
      "2-mid": "3.97",
      "2-bound": [3.74, 4.24],
      "5-mid": "4.69",
      "5-bound": [4.41, 5.0],
      "10-mid": "5.26",
      "10-bound": [4.95, 5.6],
      "25-mid": "6.05",
      "25-bound": [5.67, 6.43],
      "50-mid": "6.67",
      "50-bound": [6.24, 7.08],
      "100-mid": "7.3",
      "100-bound": [6.81, 7.74]
    }
  },
  "USW00013740 6": {
    "fips": "51087",
    "station_name": "RICHMOND INTERNATIONAL AP",
    "state": "VA",
    "latitude": "37.5115",
    "longitude": "-77.3234",
    "5min": {
      "2-mid": "0.45",
      "2-bound": [0.41, 0.49],
      "5-mid": "0.52",
      "5-bound": [0.48, 0.57],
      "10-mid": "0.58",
      "10-bound": [0.53, 0.64],
      "25-mid": "0.66",
      "25-bound": [0.59, 0.72],
      "50-mid": "0.71",
      "50-bound": [0.64, 0.78],
      "100-mid": "0.76",
      "100-bound": [0.68, 0.83]
    },
    "10min": {
      "2-mid": "0.71",
      "2-bound": [0.65, 0.78],
      "5-mid": "0.84",
      "5-bound": [0.76, 0.92],
      "10-mid": "0.94",
      "10-bound": [0.85, 1.03],
      "25-mid": "1.05",
      "25-bound": [0.95, 1.15],
      "50-mid": "1.13",
      "50-bound": [1.02, 1.24],
      "100-mid": "1.21",
      "100-bound": [1.08, 1.32]
    },
    "15min": {
      "2-mid": "0.9",
      "2-bound": [0.82, 0.98],
      "5-mid": "1.06",
      "5-bound": [0.96, 1.16],
      "10-mid": "1.18",
      "10-bound": [1.07, 1.3],
      "25-mid": "1.33",
      "25-bound": [1.2, 1.45],
      "50-mid": "1.43",
      "50-bound": [1.29, 1.57],
      "100-mid": "1.53",
      "100-bound": [1.37, 1.68]
    },
    "30min": {
      "2-mid": "1.24",
      "2-bound": [1.13, 1.36],
      "5-mid": "1.5",
      "5-bound": [1.37, 1.65],
      "10-mid": "1.72",
      "10-bound": [1.56, 1.88],
      "25-mid": "1.96",
      "25-bound": [1.78, 2.15],
      "50-mid": "2.16",
      "50-bound": [1.94, 2.36],
      "100-mid": "2.34",
      "100-bound": [2.1, 2.57]
    },
    "60min": {
      "2-mid": "1.55",
      "2-bound": [1.42, 1.71],
      "5-mid": "1.93",
      "5-bound": [1.76, 2.12],
      "10-mid": "2.23",
      "10-bound": [2.03, 2.45],
      "25-mid": "2.62",
      "25-bound": [2.36, 2.86],
      "50-mid": "2.92",
      "50-bound": [2.64, 3.2],
      "100-mid": "3.22",
      "100-bound": [2.89, 3.53]
    },
    "2hr": {
      "2-mid": "1.85",
      "2-bound": [1.68, 2.04],
      "5-mid": "2.32",
      "5-bound": [2.11, 2.56],
      "10-mid": "2.72",
      "10-bound": [2.46, 3.0],
      "25-mid": "3.24",
      "25-bound": [2.92, 3.56],
      "50-mid": "3.67",
      "50-bound": [3.28, 4.03],
      "100-mid": "4.11",
      "100-bound": [3.65, 4.5]
    },
    "3hr": {
      "2-mid": "2.0",
      "2-bound": [1.81, 2.22],
      "5-mid": "2.51",
      "5-bound": [2.27, 2.78],
      "10-mid": "2.94",
      "10-bound": [2.65, 3.25],
      "25-mid": "3.51",
      "25-bound": [3.14, 3.87],
      "50-mid": "3.98",
      "50-bound": [3.54, 4.39],
      "100-mid": "4.47",
      "100-bound": [3.95, 4.91]
    },
    "6hr": {
      "2-mid": "2.41",
      "2-bound": [2.17, 2.69],
      "5-mid": "3.02",
      "5-bound": [2.7, 3.37],
      "10-mid": "3.55",
      "10-bound": [3.18, 3.96],
      "25-mid": "4.28",
      "25-bound": [3.81, 4.76],
      "50-mid": "4.9",
      "50-bound": [4.33, 5.43],
      "100-mid": "5.56",
      "100-bound": [4.87, 6.16]
    },
    "12hr": {
      "2-mid": "2.87",
      "2-bound": [2.59, 3.22],
      "5-mid": "3.62",
      "5-bound": [3.26, 4.06],
      "10-mid": "4.3",
      "10-bound": [3.85, 4.81],
      "25-mid": "5.25",
      "25-bound": [4.65, 5.85],
      "50-mid": "6.08",
      "50-bound": [5.33, 6.77],
      "100-mid": "6.97",
      "100-bound": [6.05, 7.73]
    },
    "24hr": {
      "2-mid": "3.32",
      "2-bound": [3.04, 3.65],
      "5-mid": "4.25",
      "5-bound": [3.89, 4.67],
      "10-mid": "5.04",
      "10-bound": [4.6, 5.54],
      "25-mid": "6.22",
      "25-bound": [5.63, 6.81],
      "50-mid": "7.23",
      "50-bound": [6.51, 7.91],
      "100-mid": "8.35",
      "100-bound": [7.45, 9.11]
    },
    "2day": {
      "2-mid": "3.87",
      "2-bound": [3.54, 4.24],
      "5-mid": "4.93",
      "5-bound": [4.51, 5.4],
      "10-mid": "5.82",
      "10-bound": [5.3, 6.37],
      "25-mid": "7.11",
      "25-bound": [6.44, 7.77],
      "50-mid": "8.2",
      "50-bound": [7.38, 8.96],
      "100-mid": "9.38",
      "100-bound": [8.39, 10.3]
    },
    "3day": {
      "2-mid": "4.09",
      "2-bound": [3.76, 4.48],
      "5-mid": "5.21",
      "5-bound": [4.78, 5.7],
      "10-mid": "6.13",
      "10-bound": [5.61, 6.71],
      "25-mid": "7.49",
      "25-bound": [6.81, 8.18],
      "50-mid": "8.63",
      "50-bound": [7.79, 9.42],
      "100-mid": "9.86",
      "100-bound": [8.85, 10.8]
    },
    "4day": {
      "2-mid": "4.31",
      "2-bound": [3.97, 4.72],
      "5-mid": "5.48",
      "5-bound": [5.04, 6.0],
      "10-mid": "6.45",
      "10-bound": [5.92, 7.05],
      "25-mid": "7.87",
      "25-bound": [7.18, 8.59],
      "50-mid": "9.06",
      "50-bound": [8.21, 9.88],
      "100-mid": "10.3",
      "100-bound": [9.31, 11.3]
    },
    "7day": {
      "2-mid": "4.94",
      "2-bound": [4.55, 5.38],
      "5-mid": "6.18",
      "5-bound": [5.69, 6.74],
      "10-mid": "7.21",
      "10-bound": [6.63, 7.85],
      "25-mid": "8.7",
      "25-bound": [7.96, 9.46],
      "50-mid": "9.94",
      "50-bound": [9.04, 10.8],
      "100-mid": "11.3",
      "100-bound": [10.2, 12.3]
    }
  },
  "USC00361832 6": {
    "fips": "42117",
    "station_name": "COVINGTON 2 WSW",
    "state": "PA",
    "latitude": "41.7370",
    "longitude": "-77.1150",
    "5min": {
      "2-mid": "0.32",
      "2-bound": [0.29, 0.37],
      "5-mid": "0.39",
      "5-bound": [0.34, 0.44],
      "10-mid": "0.44",
      "10-bound": [0.39, 0.5],
      "25-mid": "0.5",
      "25-bound": [0.44, 0.57],
      "50-mid": "0.55",
      "50-bound": [0.48, 0.62],
      "100-mid": "0.6",
      "100-bound": [0.52, 0.68]
    },
    "10min": {
      "2-mid": "0.51",
      "2-bound": [0.45, 0.58],
      "5-mid": "0.6",
      "5-bound": [0.54, 0.68],
      "10-mid": "0.67",
      "10-bound": [0.6, 0.77],
      "25-mid": "0.77",
      "25-bound": [0.68, 0.87],
      "50-mid": "0.83",
      "50-bound": [0.73, 0.94],
      "100-mid": "0.9",
      "100-bound": [0.79, 1.02]
    },
    "15min": {
      "2-mid": "0.62",
      "2-bound": [0.55, 0.7],
      "5-mid": "0.74",
      "5-bound": [0.66, 0.84],
      "10-mid": "0.83",
      "10-bound": [0.74, 0.94],
      "25-mid": "0.94",
      "25-bound": [0.83, 1.07],
      "50-mid": "1.03",
      "50-bound": [0.91, 1.17],
      "100-mid": "1.12",
      "100-bound": [0.98, 1.26]
    },
    "30min": {
      "2-mid": "0.83",
      "2-bound": [0.74, 0.94],
      "5-mid": "1.01",
      "5-bound": [0.9, 1.15],
      "10-mid": "1.15",
      "10-bound": [1.02, 1.31],
      "25-mid": "1.34",
      "25-bound": [1.18, 1.51],
      "50-mid": "1.47",
      "50-bound": [1.29, 1.67],
      "100-mid": "1.62",
      "100-bound": [1.41, 1.83]
    },
    "60min": {
      "2-mid": "1.02",
      "2-bound": [0.9, 1.16],
      "5-mid": "1.27",
      "5-bound": [1.13, 1.44],
      "10-mid": "1.46",
      "10-bound": [1.3, 1.66],
      "25-mid": "1.73",
      "25-bound": [1.53, 1.96],
      "50-mid": "1.94",
      "50-bound": [1.7, 2.2],
      "100-mid": "2.16",
      "100-bound": [1.88, 2.44]
    },
    "2hr": {
      "2-mid": "1.16",
      "2-bound": [1.04, 1.32],
      "5-mid": "1.46",
      "5-bound": [1.3, 1.64],
      "10-mid": "1.69",
      "10-bound": [1.5, 1.9],
      "25-mid": "2.03",
      "25-bound": [1.8, 2.28],
      "50-mid": "2.32",
      "50-bound": [2.04, 2.6],
      "100-mid": "2.64",
      "100-bound": [2.31, 2.95]
    },
    "3hr": {
      "2-mid": "1.27",
      "2-bound": [1.14, 1.43],
      "5-mid": "1.58",
      "5-bound": [1.42, 1.78],
      "10-mid": "1.83",
      "10-bound": [1.64, 2.07],
      "25-mid": "2.2",
      "25-bound": [1.96, 2.47],
      "50-mid": "2.53",
      "50-bound": [2.23, 2.83],
      "100-mid": "2.88",
      "100-bound": [2.52, 3.22]
    },
    "6hr": {
      "2-mid": "1.6",
      "2-bound": [1.43, 1.82],
      "5-mid": "1.97",
      "5-bound": [1.76, 2.23],
      "10-mid": "2.28",
      "10-bound": [2.03, 2.58],
      "25-mid": "2.73",
      "25-bound": [2.41, 3.08],
      "50-mid": "3.12",
      "50-bound": [2.74, 3.51],
      "100-mid": "3.55",
      "100-bound": [3.1, 3.98]
    },
    "12hr": {
      "2-mid": "1.98",
      "2-bound": [1.78, 2.25],
      "5-mid": "2.44",
      "5-bound": [2.18, 2.76],
      "10-mid": "2.82",
      "10-bound": [2.52, 3.19],
      "25-mid": "3.39",
      "25-bound": [3.0, 3.82],
      "50-mid": "3.89",
      "50-bound": [3.42, 4.37],
      "100-mid": "4.45",
      "100-bound": [3.88, 4.99]
    },
    "24hr": {
      "2-mid": "2.38",
      "2-bound": [2.19, 2.62],
      "5-mid": "2.93",
      "5-bound": [2.69, 3.22],
      "10-mid": "3.4",
      "10-bound": [3.11, 3.72],
      "25-mid": "4.11",
      "25-bound": [3.74, 4.49],
      "50-mid": "4.74",
      "50-bound": [4.29, 5.17],
      "100-mid": "5.47",
      "100-bound": [4.9, 5.95]
    },
    "2day": {
      "2-mid": "2.76",
      "2-bound": [2.5, 3.1],
      "5-mid": "3.39",
      "5-bound": [3.06, 3.8],
      "10-mid": "3.93",
      "10-bound": [3.54, 4.4],
      "25-mid": "4.78",
      "25-bound": [4.28, 5.33],
      "50-mid": "5.55",
      "50-bound": [4.93, 6.16],
      "100-mid": "6.44",
      "100-bound": [5.66, 7.13]
    },
    "3day": {
      "2-mid": "2.92",
      "2-bound": [2.66, 3.26],
      "5-mid": "3.57",
      "5-bound": [3.25, 3.97],
      "10-mid": "4.13",
      "10-bound": [3.74, 4.58],
      "25-mid": "5.01",
      "25-bound": [4.51, 5.54],
      "50-mid": "5.8",
      "50-bound": [5.18, 6.39],
      "100-mid": "6.71",
      "100-bound": [5.94, 7.38]
    },
    "4day": {
      "2-mid": "3.08",
      "2-bound": [2.82, 3.41],
      "5-mid": "3.75",
      "5-bound": [3.43, 4.14],
      "10-mid": "4.33",
      "10-bound": [3.95, 4.77],
      "25-mid": "5.23",
      "25-bound": [4.74, 5.74],
      "50-mid": "6.04",
      "50-bound": [5.43, 6.62],
      "100-mid": "6.98",
      "100-bound": [6.23, 7.63]
    },
    "7day": {
      "2-mid": "3.63",
      "2-bound": [3.34, 3.98],
      "5-mid": "4.31",
      "5-bound": [3.96, 4.73],
      "10-mid": "4.9",
      "10-bound": [4.49, 5.36],
      "25-mid": "5.8",
      "25-bound": [5.28, 6.33],
      "50-mid": "6.59",
      "50-bound": [5.98, 7.18],
      "100-mid": "7.48",
      "100-bound": [6.74, 8.14]
    }
  },
  "USC00360868 6": {
    "fips": "42083",
    "station_name": "BRADFORD 4SW RES 5",
    "state": "PA",
    "latitude": "41.8980",
    "longitude": "-78.7143",
    "5min": {
      "2-mid": "0.36",
      "2-bound": [0.33, 0.4],
      "5-mid": "0.44",
      "5-bound": [0.39, 0.48],
      "10-mid": "0.49",
      "10-bound": [0.45, 0.55],
      "25-mid": "0.57",
      "25-bound": [0.51, 0.63],
      "50-mid": "0.63",
      "50-bound": [0.56, 0.69],
      "100-mid": "0.68",
      "100-bound": [0.61, 0.75]
    },
    "10min": {
      "2-mid": "0.56",
      "2-bound": [0.51, 0.62],
      "5-mid": "0.68",
      "5-bound": [0.61, 0.75],
      "10-mid": "0.76",
      "10-bound": [0.69, 0.84],
      "25-mid": "0.87",
      "25-bound": [0.78, 0.96],
      "50-mid": "0.95",
      "50-bound": [0.85, 1.04],
      "100-mid": "1.03",
      "100-bound": [0.91, 1.12]
    },
    "15min": {
      "2-mid": "0.69",
      "2-bound": [0.62, 0.76],
      "5-mid": "0.83",
      "5-bound": [0.75, 0.92],
      "10-mid": "0.94",
      "10-bound": [0.85, 1.04],
      "25-mid": "1.08",
      "25-bound": [0.96, 1.18],
      "50-mid": "1.18",
      "50-bound": [1.05, 1.29],
      "100-mid": "1.27",
      "100-bound": [1.14, 1.4]
    },
    "30min": {
      "2-mid": "0.92",
      "2-bound": [0.83, 1.02],
      "5-mid": "1.14",
      "5-bound": [1.03, 1.26],
      "10-mid": "1.31",
      "10-bound": [1.18, 1.44],
      "25-mid": "1.52",
      "25-bound": [1.36, 1.67],
      "50-mid": "1.68",
      "50-bound": [1.5, 1.84],
      "100-mid": "1.84",
      "100-bound": [1.64, 2.02]
    },
    "60min": {
      "2-mid": "1.13",
      "2-bound": [1.02, 1.25],
      "5-mid": "1.43",
      "5-bound": [1.29, 1.58],
      "10-mid": "1.66",
      "10-bound": [1.5, 1.83],
      "25-mid": "1.97",
      "25-bound": [1.77, 2.17],
      "50-mid": "2.21",
      "50-bound": [1.98, 2.43],
      "100-mid": "2.46",
      "100-bound": [2.19, 2.7]
    },
    "2hr": {
      "2-mid": "1.32",
      "2-bound": [1.19, 1.45],
      "5-mid": "1.66",
      "5-bound": [1.5, 1.83],
      "10-mid": "1.92",
      "10-bound": [1.74, 2.12],
      "25-mid": "2.29",
      "25-bound": [2.06, 2.52],
      "50-mid": "2.58",
      "50-bound": [2.32, 2.83],
      "100-mid": "2.88",
      "100-bound": [2.57, 3.15]
    },
    "3hr": {
      "2-mid": "1.44",
      "2-bound": [1.3, 1.59],
      "5-mid": "1.8",
      "5-bound": [1.63, 2.0],
      "10-mid": "2.09",
      "10-bound": [1.89, 2.32],
      "25-mid": "2.5",
      "25-bound": [2.25, 2.76],
      "50-mid": "2.82",
      "50-bound": [2.53, 3.1],
      "100-mid": "3.16",
      "100-bound": [2.82, 3.46]
    },
    "6hr": {
      "2-mid": "1.74",
      "2-bound": [1.59, 1.94],
      "5-mid": "2.17",
      "5-bound": [1.98, 2.41],
      "10-mid": "2.52",
      "10-bound": [2.28, 2.78],
      "25-mid": "3.01",
      "25-bound": [2.72, 3.32],
      "50-mid": "3.41",
      "50-bound": [3.06, 3.74],
      "100-mid": "3.82",
      "100-bound": [3.42, 4.19]
    },
    "12hr": {
      "2-mid": "2.1",
      "2-bound": [1.93, 2.32],
      "5-mid": "2.6",
      "5-bound": [2.38, 2.86],
      "10-mid": "3.0",
      "10-bound": [2.74, 3.3],
      "25-mid": "3.59",
      "25-bound": [3.25, 3.93],
      "50-mid": "4.06",
      "50-bound": [3.66, 4.44],
      "100-mid": "4.57",
      "100-bound": [4.09, 4.97]
    },
    "24hr": {
      "2-mid": "2.47",
      "2-bound": [2.31, 2.67],
      "5-mid": "3.02",
      "5-bound": [2.82, 3.25],
      "10-mid": "3.47",
      "10-bound": [3.23, 3.73],
      "25-mid": "4.12",
      "25-bound": [3.82, 4.41],
      "50-mid": "4.64",
      "50-bound": [4.29, 4.96],
      "100-mid": "5.2",
      "100-bound": [4.79, 5.54]
    },
    "2day": {
      "2-mid": "2.89",
      "2-bound": [2.68, 3.12],
      "5-mid": "3.49",
      "5-bound": [3.24, 3.78],
      "10-mid": "3.99",
      "10-bound": [3.7, 4.31],
      "25-mid": "4.68",
      "25-bound": [4.32, 5.04],
      "50-mid": "5.25",
      "50-bound": [4.82, 5.64],
      "100-mid": "5.84",
      "100-bound": [5.34, 6.27]
    },
    "3day": {
      "2-mid": "3.09",
      "2-bound": [2.88, 3.33],
      "5-mid": "3.72",
      "5-bound": [3.46, 4.01],
      "10-mid": "4.23",
      "10-bound": [3.94, 4.56],
      "25-mid": "4.94",
      "25-bound": [4.58, 5.31],
      "50-mid": "5.52",
      "50-bound": [5.1, 5.92],
      "100-mid": "6.12",
      "100-bound": [5.64, 6.56]
    },
    "4day": {
      "2-mid": "3.3",
      "2-bound": [3.09, 3.55],
      "5-mid": "3.95",
      "5-bound": [3.69, 4.24],
      "10-mid": "4.48",
      "10-bound": [4.18, 4.8],
      "25-mid": "5.21",
      "25-bound": [4.84, 5.58],
      "50-mid": "5.8",
      "50-bound": [5.38, 6.2],
      "100-mid": "6.41",
      "100-bound": [5.93, 6.86]
    },
    "7day": {
      "2-mid": "3.97",
      "2-bound": [3.73, 4.24],
      "5-mid": "4.69",
      "5-bound": [4.41, 5.01],
      "10-mid": "5.27",
      "10-bound": [4.94, 5.62],
      "25-mid": "6.05",
      "25-bound": [5.66, 6.44],
      "50-mid": "6.67",
      "50-bound": [6.23, 7.1],
      "100-mid": "7.3",
      "100-bound": [6.8, 7.76]
    }
  },
  "USC00308248 6": {
    "fips": "36043",
    "station_name": "STILLWATER RESERVOIR",
    "state": "NY",
    "latitude": "43.8990",
    "longitude": "-75.0360",
    "5min": {
      "2-mid": "0.33",
      "2-bound": [0.27, 0.41],
      "5-mid": "0.43",
      "5-bound": [0.35, 0.52],
      "10-mid": "0.5",
      "10-bound": [0.41, 0.62],
      "25-mid": "0.61",
      "25-bound": [0.47, 0.8],
      "50-mid": "0.69",
      "50-bound": [0.52, 0.93],
      "100-mid": "0.77",
      "100-bound": [0.56, 1.09]
    },
    "10min": {
      "2-mid": "0.47",
      "2-bound": [0.39, 0.58],
      "5-mid": "0.6",
      "5-bound": [0.49, 0.74],
      "10-mid": "0.71",
      "10-bound": [0.57, 0.88],
      "25-mid": "0.86",
      "25-bound": [0.67, 1.13],
      "50-mid": "0.97",
      "50-bound": [0.74, 1.31],
      "100-mid": "1.09",
      "100-bound": [0.8, 1.54]
    },
    "15min": {
      "2-mid": "0.56",
      "2-bound": [0.45, 0.68],
      "5-mid": "0.71",
      "5-bound": [0.58, 0.87],
      "10-mid": "0.84",
      "10-bound": [0.68, 1.04],
      "25-mid": "1.01",
      "25-bound": [0.79, 1.33],
      "50-mid": "1.15",
      "50-bound": [0.87, 1.54],
      "100-mid": "1.29",
      "100-bound": [0.94, 1.82]
    },
    "30min": {
      "2-mid": "0.77",
      "2-bound": [0.63, 0.94],
      "5-mid": "0.98",
      "5-bound": [0.8, 1.21],
      "10-mid": "1.16",
      "10-bound": [0.94, 1.43],
      "25-mid": "1.4",
      "25-bound": [1.09, 1.84],
      "50-mid": "1.58",
      "50-bound": [1.2, 2.14],
      "100-mid": "1.78",
      "100-bound": [1.3, 2.51]
    },
    "60min": {
      "2-mid": "0.99",
      "2-bound": [0.8, 1.2],
      "5-mid": "1.26",
      "5-bound": [1.02, 1.54],
      "10-mid": "1.48",
      "10-bound": [1.2, 1.83],
      "25-mid": "1.79",
      "25-bound": [1.39, 2.34],
      "50-mid": "2.02",
      "50-bound": [1.53, 2.73],
      "100-mid": "2.27",
      "100-bound": [1.65, 3.21]
    },
    "2hr": {
      "2-mid": "1.21",
      "2-bound": [0.99, 1.46],
      "5-mid": "1.51",
      "5-bound": [1.23, 1.84],
      "10-mid": "1.76",
      "10-bound": [1.43, 2.16],
      "25-mid": "2.11",
      "25-bound": [1.65, 2.75],
      "50-mid": "2.36",
      "50-bound": [1.81, 3.18],
      "100-mid": "2.64",
      "100-bound": [1.96, 3.76]
    },
    "3hr": {
      "2-mid": "1.36",
      "2-bound": [1.12, 1.64],
      "5-mid": "1.69",
      "5-bound": [1.38, 2.04],
      "10-mid": "1.96",
      "10-bound": [1.6, 2.39],
      "25-mid": "2.33",
      "25-bound": [1.84, 3.04],
      "50-mid": "2.6",
      "50-bound": [2.0, 3.5],
      "100-mid": "2.91",
      "100-bound": [2.18, 4.14]
    },
    "6hr": {
      "2-mid": "1.69",
      "2-bound": [1.4, 2.02],
      "5-mid": "2.08",
      "5-bound": [1.72, 2.5],
      "10-mid": "2.41",
      "10-bound": [1.98, 2.92],
      "25-mid": "2.86",
      "25-bound": [2.27, 3.69],
      "50-mid": "3.19",
      "50-bound": [2.47, 4.24],
      "100-mid": "3.56",
      "100-bound": [2.68, 5.0]
    },
    "12hr": {
      "2-mid": "2.11",
      "2-bound": [1.76, 2.51],
      "5-mid": "2.61",
      "5-bound": [2.17, 3.12],
      "10-mid": "3.03",
      "10-bound": [2.5, 3.64],
      "25-mid": "3.6",
      "25-bound": [2.86, 4.58],
      "50-mid": "4.03",
      "50-bound": [3.12, 5.26],
      "100-mid": "4.49",
      "100-bound": [3.36, 6.15]
    },
    "24hr": {
      "2-mid": "2.55",
      "2-bound": [2.14, 3.02],
      "5-mid": "3.15",
      "5-bound": [2.63, 3.74],
      "10-mid": "3.64",
      "10-bound": [3.02, 4.35],
      "25-mid": "4.32",
      "25-bound": [3.44, 5.42],
      "50-mid": "4.84",
      "50-bound": [3.74, 6.21],
      "100-mid": "5.37",
      "100-bound": [4.0, 7.18]
    },
    "2day": {
      "2-mid": "2.99",
      "2-bound": [2.52, 3.51],
      "5-mid": "3.61",
      "5-bound": [3.04, 4.26],
      "10-mid": "4.13",
      "10-bound": [3.45, 4.9],
      "25-mid": "4.84",
      "25-bound": [3.87, 6.0],
      "50-mid": "5.39",
      "50-bound": [4.19, 6.82],
      "100-mid": "5.94",
      "100-bound": [4.43, 7.82]
    },
    "3day": {
      "2-mid": "3.29",
      "2-bound": [2.79, 3.85],
      "5-mid": "3.93",
      "5-bound": [3.32, 4.61],
      "10-mid": "4.46",
      "10-bound": [3.74, 5.26],
      "25-mid": "5.18",
      "25-bound": [4.16, 6.38],
      "50-mid": "5.74",
      "50-bound": [4.47, 7.22],
      "100-mid": "6.3",
      "100-bound": [4.71, 8.22]
    },
    "4day": {
      "2-mid": "3.56",
      "2-bound": [3.03, 4.15],
      "5-mid": "4.2",
      "5-bound": [3.56, 4.92],
      "10-mid": "4.74",
      "10-bound": [3.99, 5.58],
      "25-mid": "5.48",
      "25-bound": [4.41, 6.72],
      "50-mid": "6.05",
      "50-bound": [4.73, 7.57],
      "100-mid": "6.62",
      "100-bound": [4.95, 8.58]
    },
    "7day": {
      "2-mid": "4.27",
      "2-bound": [3.66, 4.96],
      "5-mid": "4.96",
      "5-bound": [4.22, 5.77],
      "10-mid": "5.53",
      "10-bound": [4.67, 6.47],
      "25-mid": "6.31",
      "25-bound": [5.1, 7.66],
      "50-mid": "6.91",
      "50-bound": [5.42, 8.56],
      "100-mid": "7.51",
      "100-bound": [5.63, 9.61]
    }
  },
  "USC00181790 6": {
    "fips": "24043",
    "station_name": "HAGERSTOWN 1 E",
    "state": "MD",
    "latitude": "39.6403",
    "longitude": "-77.6977",
    "5min": {
      "2-mid": "0.4",
      "2-bound": [0.36, 0.45],
      "5-mid": "0.48",
      "5-bound": [0.43, 0.54],
      "10-mid": "0.55",
      "10-bound": [0.49, 0.61],
      "25-mid": "0.64",
      "25-bound": [0.56, 0.71],
      "50-mid": "0.71",
      "50-bound": [0.62, 0.79],
      "100-mid": "0.78",
      "100-bound": [0.68, 0.86]
    },
    "10min": {
      "2-mid": "0.62",
      "2-bound": [0.56, 0.7],
      "5-mid": "0.75",
      "5-bound": [0.67, 0.84],
      "10-mid": "0.85",
      "10-bound": [0.76, 0.95],
      "25-mid": "0.98",
      "25-bound": [0.86, 1.09],
      "50-mid": "1.08",
      "50-bound": [0.95, 1.2],
      "100-mid": "1.18",
      "100-bound": [1.04, 1.31]
    },
    "15min": {
      "2-mid": "0.77",
      "2-bound": [0.69, 0.86],
      "5-mid": "0.93",
      "5-bound": [0.83, 1.04],
      "10-mid": "1.05",
      "10-bound": [0.93, 1.17],
      "25-mid": "1.22",
      "25-bound": [1.07, 1.35],
      "50-mid": "1.34",
      "50-bound": [1.18, 1.49],
      "100-mid": "1.47",
      "100-bound": [1.29, 1.63]
    },
    "30min": {
      "2-mid": "1.03",
      "2-bound": [0.92, 1.16],
      "5-mid": "1.28",
      "5-bound": [1.14, 1.43],
      "10-mid": "1.47",
      "10-bound": [1.3, 1.64],
      "25-mid": "1.72",
      "25-bound": [1.52, 1.92],
      "50-mid": "1.93",
      "50-bound": [1.7, 2.14],
      "100-mid": "2.14",
      "100-bound": [1.88, 2.38]
    },
    "60min": {
      "2-mid": "1.27",
      "2-bound": [1.13, 1.42],
      "5-mid": "1.61",
      "5-bound": [1.43, 1.8],
      "10-mid": "1.87",
      "10-bound": [1.66, 2.09],
      "25-mid": "2.24",
      "25-bound": [1.98, 2.5],
      "50-mid": "2.55",
      "50-bound": [2.24, 2.83],
      "100-mid": "2.88",
      "100-bound": [2.52, 3.19]
    },
    "2hr": {
      "2-mid": "1.48",
      "2-bound": [1.32, 1.67],
      "5-mid": "1.88",
      "5-bound": [1.67, 2.12],
      "10-mid": "2.2",
      "10-bound": [1.95, 2.48],
      "25-mid": "2.68",
      "25-bound": [2.36, 3.0],
      "50-mid": "3.09",
      "50-bound": [2.7, 3.45],
      "100-mid": "3.54",
      "100-bound": [3.08, 3.95]
    },
    "3hr": {
      "2-mid": "1.59",
      "2-bound": [1.42, 1.81],
      "5-mid": "2.01",
      "5-bound": [1.79, 2.28],
      "10-mid": "2.35",
      "10-bound": [2.08, 2.66],
      "25-mid": "2.86",
      "25-bound": [2.52, 3.23],
      "50-mid": "3.3",
      "50-bound": [2.88, 3.7],
      "100-mid": "3.79",
      "100-bound": [3.29, 4.24]
    },
    "6hr": {
      "2-mid": "1.97",
      "2-bound": [1.76, 2.23],
      "5-mid": "2.46",
      "5-bound": [2.19, 2.78],
      "10-mid": "2.87",
      "10-bound": [2.55, 3.24],
      "25-mid": "3.48",
      "25-bound": [3.07, 3.91],
      "50-mid": "4.0",
      "50-bound": [3.51, 4.49],
      "100-mid": "4.59",
      "100-bound": [3.99, 5.13]
    },
    "12hr": {
      "2-mid": "2.41",
      "2-bound": [2.15, 2.72],
      "5-mid": "3.0",
      "5-bound": [2.67, 3.38],
      "10-mid": "3.5",
      "10-bound": [3.11, 3.94],
      "25-mid": "4.26",
      "25-bound": [3.76, 4.76],
      "50-mid": "4.93",
      "50-bound": [4.31, 5.49],
      "100-mid": "5.68",
      "100-bound": [4.92, 6.3]
    },
    "24hr": {
      "2-mid": "2.84",
      "2-bound": [2.6, 3.12],
      "5-mid": "3.53",
      "5-bound": [3.22, 3.87],
      "10-mid": "4.11",
      "10-bound": [3.75, 4.51],
      "25-mid": "4.97",
      "25-bound": [4.5, 5.42],
      "50-mid": "5.71",
      "50-bound": [5.14, 6.22],
      "100-mid": "6.52",
      "100-bound": [5.84, 7.09]
    },
    "2day": {
      "2-mid": "3.28",
      "2-bound": [3.0, 3.59],
      "5-mid": "4.07",
      "5-bound": [3.72, 4.46],
      "10-mid": "4.74",
      "10-bound": [4.32, 5.18],
      "25-mid": "5.72",
      "25-bound": [5.18, 6.24],
      "50-mid": "6.57",
      "50-bound": [5.92, 7.16],
      "100-mid": "7.5",
      "100-bound": [6.72, 8.17]
    },
    "3day": {
      "2-mid": "3.49",
      "2-bound": [3.19, 3.84],
      "5-mid": "4.32",
      "5-bound": [3.94, 4.74],
      "10-mid": "5.02",
      "10-bound": [4.57, 5.5],
      "25-mid": "6.05",
      "25-bound": [5.48, 6.62],
      "50-mid": "6.94",
      "50-bound": [6.24, 7.57],
      "100-mid": "7.9",
      "100-bound": [7.07, 8.62]
    },
    "4day": {
      "2-mid": "3.71",
      "2-bound": [3.39, 4.08],
      "5-mid": "4.57",
      "5-bound": [4.17, 5.03],
      "10-mid": "5.3",
      "10-bound": [4.82, 5.82],
      "25-mid": "6.38",
      "25-bound": [5.77, 6.99],
      "50-mid": "7.3",
      "50-bound": [6.57, 7.99],
      "100-mid": "8.3",
      "100-bound": [7.42, 9.08]
    },
    "7day": {
      "2-mid": "4.3",
      "2-bound": [3.97, 4.7],
      "5-mid": "5.25",
      "5-bound": [4.83, 5.73],
      "10-mid": "6.03",
      "10-bound": [5.54, 6.57],
      "25-mid": "7.14",
      "25-bound": [6.54, 7.78],
      "50-mid": "8.07",
      "50-bound": [7.35, 8.77],
      "100-mid": "9.06",
      "100-bound": [8.21, 9.86]
    }
  },
  "USC00364992 6": {
    "fips": "42087",
    "station_name": "LEWISTOWN",
    "state": "PA",
    "latitude": "40.5860",
    "longitude": "-77.5690",
    "5min": {
      "2-mid": "0.4",
      "2-bound": [0.36, 0.45],
      "5-mid": "0.49",
      "5-bound": [0.43, 0.55],
      "10-mid": "0.56",
      "10-bound": [0.49, 0.63],
      "25-mid": "0.65",
      "25-bound": [0.57, 0.73],
      "50-mid": "0.72",
      "50-bound": [0.63, 0.81],
      "100-mid": "0.79",
      "100-bound": [0.69, 0.89]
    },
    "10min": {
      "2-mid": "0.63",
      "2-bound": [0.56, 0.71],
      "5-mid": "0.76",
      "5-bound": [0.67, 0.85],
      "10-mid": "0.86",
      "10-bound": [0.76, 0.97],
      "25-mid": "0.99",
      "25-bound": [0.87, 1.11],
      "50-mid": "1.09",
      "50-bound": [0.95, 1.22],
      "100-mid": "1.19",
      "100-bound": [1.04, 1.33]
    },
    "15min": {
      "2-mid": "0.77",
      "2-bound": [0.68, 0.87],
      "5-mid": "0.93",
      "5-bound": [0.83, 1.05],
      "10-mid": "1.06",
      "10-bound": [0.94, 1.19],
      "25-mid": "1.23",
      "25-bound": [1.08, 1.37],
      "50-mid": "1.35",
      "50-bound": [1.18, 1.51],
      "100-mid": "1.48",
      "100-bound": [1.29, 1.66]
    },
    "30min": {
      "2-mid": "1.03",
      "2-bound": [0.92, 1.16],
      "5-mid": "1.28",
      "5-bound": [1.13, 1.44],
      "10-mid": "1.47",
      "10-bound": [1.3, 1.65],
      "25-mid": "1.73",
      "25-bound": [1.52, 1.94],
      "50-mid": "1.93",
      "50-bound": [1.69, 2.16],
      "100-mid": "2.14",
      "100-bound": [1.87, 2.39]
    },
    "60min": {
      "2-mid": "1.26",
      "2-bound": [1.12, 1.42],
      "5-mid": "1.6",
      "5-bound": [1.42, 1.8],
      "10-mid": "1.87",
      "10-bound": [1.65, 2.1],
      "25-mid": "2.24",
      "25-bound": [1.98, 2.52],
      "50-mid": "2.54",
      "50-bound": [2.22, 2.85],
      "100-mid": "2.86",
      "100-bound": [2.49, 3.2]
    },
    "2hr": {
      "2-mid": "1.44",
      "2-bound": [1.26, 1.65],
      "5-mid": "1.83",
      "5-bound": [1.6, 2.1],
      "10-mid": "2.15",
      "10-bound": [1.87, 2.46],
      "25-mid": "2.6",
      "25-bound": [2.26, 2.96],
      "50-mid": "2.98",
      "50-bound": [2.57, 3.39],
      "100-mid": "3.39",
      "100-bound": [2.91, 3.83]
    },
    "3hr": {
      "2-mid": "1.56",
      "2-bound": [1.38, 1.77],
      "5-mid": "1.97",
      "5-bound": [1.74, 2.24],
      "10-mid": "2.3",
      "10-bound": [2.03, 2.62],
      "25-mid": "2.79",
      "25-bound": [2.44, 3.16],
      "50-mid": "3.2",
      "50-bound": [2.79, 3.6],
      "100-mid": "3.65",
      "100-bound": [3.16, 4.1]
    },
    "6hr": {
      "2-mid": "1.95",
      "2-bound": [1.76, 2.19],
      "5-mid": "2.43",
      "5-bound": [2.18, 2.73],
      "10-mid": "2.83",
      "10-bound": [2.53, 3.17],
      "25-mid": "3.41",
      "25-bound": [3.04, 3.8],
      "50-mid": "3.9",
      "50-bound": [3.45, 4.34],
      "100-mid": "4.44",
      "100-bound": [3.89, 4.92]
    },
    "12hr": {
      "2-mid": "2.42",
      "2-bound": [2.18, 2.69],
      "5-mid": "3.0",
      "5-bound": [2.7, 3.33],
      "10-mid": "3.49",
      "10-bound": [3.14, 3.86],
      "25-mid": "4.22",
      "25-bound": [3.76, 4.66],
      "50-mid": "4.84",
      "50-bound": [4.29, 5.34],
      "100-mid": "5.53",
      "100-bound": [4.85, 6.08]
    },
    "24hr": {
      "2-mid": "2.84",
      "2-bound": [2.64, 3.07],
      "5-mid": "3.53",
      "5-bound": [3.28, 3.81],
      "10-mid": "4.11",
      "10-bound": [3.8, 4.43],
      "25-mid": "4.97",
      "25-bound": [4.57, 5.33],
      "50-mid": "5.7",
      "50-bound": [5.22, 6.12],
      "100-mid": "6.51",
      "100-bound": [5.91, 6.96]
    },
    "2day": {
      "2-mid": "3.3",
      "2-bound": [3.06, 3.58],
      "5-mid": "4.1",
      "5-bound": [3.8, 4.44],
      "10-mid": "4.77",
      "10-bound": [4.41, 5.16],
      "25-mid": "5.77",
      "25-bound": [5.3, 6.22],
      "50-mid": "6.63",
      "50-bound": [6.04, 7.14],
      "100-mid": "7.58",
      "100-bound": [6.85, 8.16]
    },
    "3day": {
      "2-mid": "3.48",
      "2-bound": [3.23, 3.76],
      "5-mid": "4.3",
      "5-bound": [3.99, 4.65],
      "10-mid": "5.0",
      "10-bound": [4.62, 5.4],
      "25-mid": "6.03",
      "25-bound": [5.54, 6.5],
      "50-mid": "6.91",
      "50-bound": [6.32, 7.44],
      "100-mid": "7.88",
      "100-bound": [7.15, 8.48]
    },
    "4day": {
      "2-mid": "3.65",
      "2-bound": [3.4, 3.95],
      "5-mid": "4.51",
      "5-bound": [4.19, 4.87],
      "10-mid": "5.23",
      "10-bound": [4.84, 5.64],
      "25-mid": "6.28",
      "25-bound": [5.79, 6.77],
      "50-mid": "7.18",
      "50-bound": [6.59, 7.73],
      "100-mid": "8.17",
      "100-bound": [7.44, 8.79]
    },
    "7day": {
      "2-mid": "4.27",
      "2-bound": [3.98, 4.6],
      "5-mid": "5.21",
      "5-bound": [4.85, 5.62],
      "10-mid": "5.98",
      "10-bound": [5.56, 6.44],
      "25-mid": "7.09",
      "25-bound": [6.56, 7.63],
      "50-mid": "8.0",
      "50-bound": [7.36, 8.59],
      "100-mid": "8.99",
      "100-bound": [8.24, 9.65]
    }
  },
  "USC00364934 6": {
    "fips": "42025",
    "station_name": "LEHIGHTON 1SSW",
    "state": "PA",
    "latitude": "40.8220",
    "longitude": "-75.6960",
    "5min": {
      "2-mid": "0.4",
      "2-bound": [0.35, 0.45],
      "5-mid": "0.47",
      "5-bound": [0.41, 0.53],
      "10-mid": "0.54",
      "10-bound": [0.47, 0.6],
      "25-mid": "0.62",
      "25-bound": [0.54, 0.7],
      "50-mid": "0.69",
      "50-bound": [0.6, 0.78],
      "100-mid": "0.78",
      "100-bound": [0.66, 0.87]
    },
    "10min": {
      "2-mid": "0.62",
      "2-bound": [0.55, 0.7],
      "5-mid": "0.74",
      "5-bound": [0.66, 0.84],
      "10-mid": "0.84",
      "10-bound": [0.74, 0.95],
      "25-mid": "0.97",
      "25-bound": [0.84, 1.09],
      "50-mid": "1.08",
      "50-bound": [0.93, 1.21],
      "100-mid": "1.19",
      "100-bound": [1.02, 1.34]
    },
    "15min": {
      "2-mid": "0.77",
      "2-bound": [0.68, 0.87],
      "5-mid": "0.93",
      "5-bound": [0.82, 1.04],
      "10-mid": "1.05",
      "10-bound": [0.92, 1.18],
      "25-mid": "1.21",
      "25-bound": [1.06, 1.36],
      "50-mid": "1.35",
      "50-bound": [1.16, 1.51],
      "100-mid": "1.5",
      "100-bound": [1.28, 1.68]
    },
    "30min": {
      "2-mid": "1.05",
      "2-bound": [0.93, 1.18],
      "5-mid": "1.29",
      "5-bound": [1.14, 1.46],
      "10-mid": "1.49",
      "10-bound": [1.3, 1.67],
      "25-mid": "1.75",
      "25-bound": [1.52, 1.97],
      "50-mid": "1.98",
      "50-bound": [1.7, 2.22],
      "100-mid": "2.22",
      "100-bound": [1.9, 2.5]
    },
    "60min": {
      "2-mid": "1.3",
      "2-bound": [1.15, 1.47],
      "5-mid": "1.64",
      "5-bound": [1.44, 1.85],
      "10-mid": "1.91",
      "10-bound": [1.68, 2.15],
      "25-mid": "2.3",
      "25-bound": [2.0, 2.58],
      "50-mid": "2.64",
      "50-bound": [2.28, 2.96],
      "100-mid": "3.02",
      "100-bound": [2.58, 3.39]
    },
    "2hr": {
      "2-mid": "1.57",
      "2-bound": [1.4, 1.77],
      "5-mid": "1.98",
      "5-bound": [1.75, 2.23],
      "10-mid": "2.33",
      "10-bound": [2.05, 2.62],
      "25-mid": "2.86",
      "25-bound": [2.51, 3.21],
      "50-mid": "3.35",
      "50-bound": [2.92, 3.75],
      "100-mid": "3.92",
      "100-bound": [3.38, 4.39]
    },
    "3hr": {
      "2-mid": "1.74",
      "2-bound": [1.55, 1.94],
      "5-mid": "2.17",
      "5-bound": [1.93, 2.42],
      "10-mid": "2.54",
      "10-bound": [2.25, 2.82],
      "25-mid": "3.11",
      "25-bound": [2.73, 3.46],
      "50-mid": "3.63",
      "50-bound": [3.17, 4.04],
      "100-mid": "4.24",
      "100-bound": [3.67, 4.72]
    },
    "6hr": {
      "2-mid": "2.2",
      "2-bound": [1.97, 2.46],
      "5-mid": "2.71",
      "5-bound": [2.42, 3.03],
      "10-mid": "3.15",
      "10-bound": [2.8, 3.52],
      "25-mid": "3.86",
      "25-bound": [3.4, 4.31],
      "50-mid": "4.51",
      "50-bound": [3.95, 5.04],
      "100-mid": "5.28",
      "100-bound": [4.57, 5.91]
    },
    "12hr": {
      "2-mid": "2.73",
      "2-bound": [2.46, 3.05],
      "5-mid": "3.39",
      "5-bound": [3.04, 3.78],
      "10-mid": "3.97",
      "10-bound": [3.55, 4.42],
      "25-mid": "4.89",
      "25-bound": [4.33, 5.45],
      "50-mid": "5.74",
      "50-bound": [5.04, 6.4],
      "100-mid": "6.76",
      "100-bound": [5.86, 7.53]
    },
    "24hr": {
      "2-mid": "3.22",
      "2-bound": [2.98, 3.5],
      "5-mid": "4.0",
      "5-bound": [3.7, 4.34],
      "10-mid": "4.68",
      "10-bound": [4.32, 5.07],
      "25-mid": "5.78",
      "25-bound": [5.29, 6.22],
      "50-mid": "6.8",
      "50-bound": [6.17, 7.28],
      "100-mid": "8.0",
      "100-bound": [7.2, 8.53]
    },
    "2day": {
      "2-mid": "3.76",
      "2-bound": [3.5, 4.09],
      "5-mid": "4.66",
      "5-bound": [4.33, 5.06],
      "10-mid": "5.46",
      "10-bound": [5.05, 5.9],
      "25-mid": "6.72",
      "25-bound": [6.17, 7.25],
      "50-mid": "7.89",
      "50-bound": [7.19, 8.48],
      "100-mid": "9.28",
      "100-bound": [8.38, 9.93]
    },
    "3day": {
      "2-mid": "3.97",
      "2-bound": [3.7, 4.3],
      "5-mid": "4.89",
      "5-bound": [4.55, 5.3],
      "10-mid": "5.71",
      "10-bound": [5.29, 6.16],
      "25-mid": "7.0",
      "25-bound": [6.44, 7.53],
      "50-mid": "8.19",
      "50-bound": [7.48, 8.77],
      "100-mid": "9.59",
      "100-bound": [8.68, 10.2]
    },
    "4day": {
      "2-mid": "4.17",
      "2-bound": [3.89, 4.51],
      "5-mid": "5.12",
      "5-bound": [4.77, 5.54],
      "10-mid": "5.96",
      "10-bound": [5.53, 6.42],
      "25-mid": "7.27",
      "25-bound": [6.7, 7.81],
      "50-mid": "8.48",
      "50-bound": [7.76, 9.07],
      "100-mid": "9.9",
      "100-bound": [8.98, 10.6]
    },
    "7day": {
      "2-mid": "4.93",
      "2-bound": [4.59, 5.36],
      "5-mid": "6.01",
      "5-bound": [5.58, 6.51],
      "10-mid": "6.95",
      "10-bound": [6.43, 7.52],
      "25-mid": "8.42",
      "25-bound": [7.74, 9.09],
      "50-mid": "9.76",
      "50-bound": [8.91, 10.5],
      "100-mid": "11.3",
      "100-bound": [10.3, 12.2]
    }
  },
  "USC00445690 6": {
    "fips": "51125",
    "station_name": "MONTEBELLO FISH CULTURAL STATION",
    "state": "VA",
    "latitude": "37.8440",
    "longitude": "-79.1300",
    "5min": {
      "2-mid": "0.42",
      "2-bound": [0.39, 0.45],
      "5-mid": "0.5",
      "5-bound": [0.46, 0.54],
      "10-mid": "0.57",
      "10-bound": [0.52, 0.61],
      "25-mid": "0.65",
      "25-bound": [0.59, 0.7],
      "50-mid": "0.7",
      "50-bound": [0.64, 0.76],
      "100-mid": "0.76",
      "100-bound": [0.68, 0.83]
    },
    "10min": {
      "2-mid": "0.67",
      "2-bound": [0.62, 0.72],
      "5-mid": "0.8",
      "5-bound": [0.74, 0.87],
      "10-mid": "0.91",
      "10-bound": [0.83, 0.98],
      "25-mid": "1.03",
      "25-bound": [0.94, 1.11],
      "50-mid": "1.12",
      "50-bound": [1.02, 1.22],
      "100-mid": "1.21",
      "100-bound": [1.08, 1.32]
    },
    "15min": {
      "2-mid": "0.84",
      "2-bound": [0.77, 0.91],
      "5-mid": "1.02",
      "5-bound": [0.94, 1.1],
      "10-mid": "1.14",
      "10-bound": [1.05, 1.24],
      "25-mid": "1.3",
      "25-bound": [1.19, 1.41],
      "50-mid": "1.42",
      "50-bound": [1.29, 1.54],
      "100-mid": "1.52",
      "100-bound": [1.37, 1.66]
    },
    "30min": {
      "2-mid": "1.16",
      "2-bound": [1.07, 1.25],
      "5-mid": "1.44",
      "5-bound": [1.34, 1.56],
      "10-mid": "1.66",
      "10-bound": [1.53, 1.79],
      "25-mid": "1.93",
      "25-bound": [1.77, 2.09],
      "50-mid": "2.13",
      "50-bound": [1.94, 2.32],
      "100-mid": "2.34",
      "100-bound": [2.1, 2.55]
    },
    "60min": {
      "2-mid": "1.45",
      "2-bound": [1.34, 1.57],
      "5-mid": "1.85",
      "5-bound": [1.71, 2.0],
      "10-mid": "2.16",
      "10-bound": [1.99, 2.33],
      "25-mid": "2.57",
      "25-bound": [2.35, 2.78],
      "50-mid": "2.89",
      "50-bound": [2.62, 3.14],
      "100-mid": "3.22",
      "100-bound": [2.89, 3.51]
    },
    "2hr": {
      "2-mid": "1.75",
      "2-bound": [1.61, 1.89],
      "5-mid": "2.26",
      "5-bound": [2.08, 2.44],
      "10-mid": "2.66",
      "10-bound": [2.45, 2.88],
      "25-mid": "3.18",
      "25-bound": [2.9, 3.44],
      "50-mid": "3.61",
      "50-bound": [3.26, 3.91],
      "100-mid": "4.06",
      "100-bound": [3.63, 4.41]
    },
    "3hr": {
      "2-mid": "1.96",
      "2-bound": [1.8, 2.12],
      "5-mid": "2.51",
      "5-bound": [2.31, 2.73],
      "10-mid": "2.95",
      "10-bound": [2.71, 3.2],
      "25-mid": "3.55",
      "25-bound": [3.22, 3.86],
      "50-mid": "4.04",
      "50-bound": [3.64, 4.4],
      "100-mid": "4.54",
      "100-bound": [4.05, 4.98]
    },
    "6hr": {
      "2-mid": "2.61",
      "2-bound": [2.39, 2.9],
      "5-mid": "3.32",
      "5-bound": [3.03, 3.67],
      "10-mid": "3.89",
      "10-bound": [3.53, 4.31],
      "25-mid": "4.7",
      "25-bound": [4.23, 5.22],
      "50-mid": "5.38",
      "50-bound": [4.79, 5.98],
      "100-mid": "6.11",
      "100-bound": [5.36, 6.81]
    },
    "12hr": {
      "2-mid": "3.35",
      "2-bound": [3.02, 3.78],
      "5-mid": "4.23",
      "5-bound": [3.81, 4.79],
      "10-mid": "5.0",
      "10-bound": [4.47, 5.67],
      "25-mid": "6.11",
      "25-bound": [5.4, 6.91],
      "50-mid": "7.06",
      "50-bound": [6.15, 7.98],
      "100-mid": "8.1",
      "100-bound": [6.94, 9.24]
    },
    "24hr": {
      "2-mid": "4.14",
      "2-bound": [3.8, 4.55],
      "5-mid": "5.26",
      "5-bound": [4.82, 5.78],
      "10-mid": "6.19",
      "10-bound": [5.65, 6.8],
      "25-mid": "7.54",
      "25-bound": [6.85, 8.27],
      "50-mid": "8.68",
      "50-bound": [7.84, 9.52],
      "100-mid": "9.93",
      "100-bound": [8.89, 10.9]
    },
    "2day": {
      "2-mid": "4.89",
      "2-bound": [4.49, 5.35],
      "5-mid": "6.19",
      "5-bound": [5.67, 6.77],
      "10-mid": "7.26",
      "10-bound": [6.61, 7.93],
      "25-mid": "8.77",
      "25-bound": [7.94, 9.59],
      "50-mid": "10.0",
      "50-bound": [9.04, 11.0],
      "100-mid": "11.4",
      "100-bound": [10.2, 12.5]
    },
    "3day": {
      "2-mid": "5.24",
      "2-bound": [4.8, 5.73],
      "5-mid": "6.61",
      "5-bound": [6.04, 7.24],
      "10-mid": "7.73",
      "10-bound": [7.04, 8.46],
      "25-mid": "9.32",
      "25-bound": [8.43, 10.2],
      "50-mid": "10.6",
      "50-bound": [9.57, 11.7],
      "100-mid": "12.1",
      "100-bound": [10.8, 13.2]
    },
    "4day": {
      "2-mid": "5.58",
      "2-bound": [5.1, 6.12],
      "5-mid": "7.03",
      "5-bound": [6.42, 7.71],
      "10-mid": "8.21",
      "10-bound": [7.47, 8.99],
      "25-mid": "9.87",
      "25-bound": [8.92, 10.8],
      "50-mid": "11.2",
      "50-bound": [10.1, 12.3],
      "100-mid": "12.7",
      "100-bound": [11.3, 14.0]
    },
    "7day": {
      "2-mid": "6.47",
      "2-bound": [5.94, 7.05],
      "5-mid": "8.07",
      "5-bound": [7.4, 8.79],
      "10-mid": "9.34",
      "10-bound": [8.53, 10.2],
      "25-mid": "11.1",
      "25-bound": [10.1, 12.1],
      "50-mid": "12.6",
      "50-bound": [11.3, 13.7],
      "100-mid": "14.1",
      "100-bound": [12.6, 15.4]
    }
  },
  "USC00186620 6": {
    "fips": "24023",
    "station_name": "OAKLAND 1 SE",
    "state": "MD",
    "latitude": "39.4131",
    "longitude": "-79.4002",
    "5min": {
      "2-mid": "0.33",
      "2-bound": [0.3, 0.36],
      "5-mid": "0.36",
      "5-bound": [0.33, 0.4],
      "10-mid": "0.44",
      "10-bound": [0.4, 0.48],
      "25-mid": "0.51",
      "25-bound": [0.46, 0.56],
      "50-mid": "0.59",
      "50-bound": [0.53, 0.64],
      "100-mid": "0.65",
      "100-bound": [0.58, 0.71]
    },
    "10min": {
      "2-mid": "0.51",
      "2-bound": [0.46, 0.56],
      "5-mid": "0.56",
      "5-bound": [0.51, 0.62],
      "10-mid": "0.68",
      "10-bound": [0.61, 0.75],
      "25-mid": "0.78",
      "25-bound": [0.7, 0.85],
      "50-mid": "0.89",
      "50-bound": [0.8, 0.97],
      "100-mid": "0.98",
      "100-bound": [0.87, 1.07]
    },
    "15min": {
      "2-mid": "0.62",
      "2-bound": [0.56, 0.69],
      "5-mid": "0.69",
      "5-bound": [0.62, 0.76],
      "10-mid": "0.84",
      "10-bound": [0.76, 0.92],
      "25-mid": "0.96",
      "25-bound": [0.86, 1.05],
      "50-mid": "1.1",
      "50-bound": [0.99, 1.2],
      "100-mid": "1.22",
      "100-bound": [1.09, 1.33]
    },
    "30min": {
      "2-mid": "0.83",
      "2-bound": [0.76, 0.92],
      "5-mid": "0.94",
      "5-bound": [0.85, 1.04],
      "10-mid": "1.16",
      "10-bound": [1.05, 1.28],
      "25-mid": "1.36",
      "25-bound": [1.22, 1.49],
      "50-mid": "1.58",
      "50-bound": [1.41, 1.72],
      "100-mid": "1.76",
      "100-bound": [1.57, 1.92]
    },
    "60min": {
      "2-mid": "1.02",
      "2-bound": [0.93, 1.13],
      "5-mid": "1.18",
      "5-bound": [1.07, 1.3],
      "10-mid": "1.48",
      "10-bound": [1.34, 1.63],
      "25-mid": "1.76",
      "25-bound": [1.58, 1.93],
      "50-mid": "2.08",
      "50-bound": [1.86, 2.27],
      "100-mid": "2.35",
      "100-bound": [2.1, 2.57]
    },
    "2hr": {
      "2-mid": "1.22",
      "2-bound": [1.1, 1.34],
      "5-mid": "1.39",
      "5-bound": [1.26, 1.54],
      "10-mid": "1.76",
      "10-bound": [1.59, 1.94],
      "25-mid": "2.12",
      "25-bound": [1.9, 2.31],
      "50-mid": "2.53",
      "50-bound": [2.26, 2.76],
      "100-mid": "2.9",
      "100-bound": [2.57, 3.17]
    },
    "3hr": {
      "2-mid": "1.31",
      "2-bound": [1.19, 1.45],
      "5-mid": "1.49",
      "5-bound": [1.36, 1.66],
      "10-mid": "1.88",
      "10-bound": [1.7, 2.07],
      "25-mid": "2.24",
      "25-bound": [2.03, 2.47],
      "50-mid": "2.68",
      "50-bound": [2.4, 2.94],
      "100-mid": "3.08",
      "100-bound": [2.75, 3.38]
    },
    "6hr": {
      "2-mid": "1.61",
      "2-bound": [1.45, 1.8],
      "5-mid": "1.82",
      "5-bound": [1.64, 2.03],
      "10-mid": "2.27",
      "10-bound": [2.04, 2.52],
      "25-mid": "2.7",
      "25-bound": [2.42, 2.99],
      "50-mid": "3.22",
      "50-bound": [2.87, 3.55],
      "100-mid": "3.7",
      "100-bound": [3.28, 4.08]
    },
    "12hr": {
      "2-mid": "1.95",
      "2-bound": [1.77, 2.2],
      "5-mid": "2.2",
      "5-bound": [1.99, 2.48],
      "10-mid": "2.73",
      "10-bound": [2.46, 3.05],
      "25-mid": "3.26",
      "25-bound": [2.92, 3.64],
      "50-mid": "3.89",
      "50-bound": [3.47, 4.32],
      "100-mid": "4.48",
      "100-bound": [3.96, 4.97]
    },
    "24hr": {
      "2-mid": "2.48",
      "2-bound": [2.33, 2.69],
      "5-mid": "3.09",
      "5-bound": [2.89, 3.34],
      "10-mid": "3.63",
      "10-bound": [3.37, 3.92],
      "25-mid": "4.45",
      "25-bound": [4.09, 4.79],
      "50-mid": "5.16",
      "50-bound": [4.71, 5.57],
      "100-mid": "5.96",
      "100-bound": [5.37, 6.44]
    },
    "2day": {
      "2-mid": "2.96",
      "2-bound": [2.77, 3.17],
      "5-mid": "3.64",
      "5-bound": [3.41, 3.91],
      "10-mid": "4.23",
      "10-bound": [3.94, 4.54],
      "25-mid": "5.11",
      "25-bound": [4.71, 5.48],
      "50-mid": "5.87",
      "50-bound": [5.36, 6.31],
      "100-mid": "6.7",
      "100-bound": [6.04, 7.23]
    },
    "3day": {
      "2-mid": "3.21",
      "2-bound": [3.02, 3.42],
      "5-mid": "3.92",
      "5-bound": [3.69, 4.18],
      "10-mid": "4.53",
      "10-bound": [4.25, 4.83],
      "25-mid": "5.42",
      "25-bound": [5.04, 5.78],
      "50-mid": "6.18",
      "50-bound": [5.68, 6.61],
      "100-mid": "6.99",
      "100-bound": [6.35, 7.51]
    },
    "4day": {
      "2-mid": "3.46",
      "2-bound": [3.28, 3.67],
      "5-mid": "4.21",
      "5-bound": [3.98, 4.46],
      "10-mid": "4.83",
      "10-bound": [4.56, 5.13],
      "25-mid": "5.73",
      "25-bound": [5.36, 6.09],
      "50-mid": "6.48",
      "50-bound": [6.0, 6.91],
      "100-mid": "7.28",
      "100-bound": [6.66, 7.79]
    },
    "7day": {
      "2-mid": "4.18",
      "2-bound": [3.96, 4.42],
      "5-mid": "5.02",
      "5-bound": [4.76, 5.3],
      "10-mid": "5.7",
      "10-bound": [5.39, 6.02],
      "25-mid": "6.66",
      "25-bound": [6.25, 7.03],
      "50-mid": "7.43",
      "50-bound": [6.93, 7.87],
      "100-mid": "8.23",
      "100-bound": [7.61, 8.76]
    }
  },
  "USC00440243 6": {
    "fips": "51011",
    "station_name": "APPOMATTOX",
    "state": "VA",
    "latitude": "37.3260",
    "longitude": "-78.8270",
    "5min": {
      "2-mid": "0.41",
      "2-bound": [0.37, 0.46],
      "5-mid": "0.48",
      "5-bound": [0.43, 0.53],
      "10-mid": "0.54",
      "10-bound": [0.49, 0.6],
      "25-mid": "0.61",
      "25-bound": [0.55, 0.67],
      "50-mid": "0.66",
      "50-bound": [0.59, 0.73],
      "100-mid": "0.71",
      "100-bound": [0.63, 0.78]
    },
    "10min": {
      "2-mid": "0.66",
      "2-bound": [0.59, 0.73],
      "5-mid": "0.77",
      "5-bound": [0.7, 0.86],
      "10-mid": "0.87",
      "10-bound": [0.78, 0.96],
      "25-mid": "0.97",
      "25-bound": [0.87, 1.07],
      "50-mid": "1.05",
      "50-bound": [0.94, 1.16],
      "100-mid": "1.12",
      "100-bound": [1.0, 1.24]
    },
    "15min": {
      "2-mid": "0.83",
      "2-bound": [0.75, 0.92],
      "5-mid": "0.98",
      "5-bound": [0.88, 1.08],
      "10-mid": "1.1",
      "10-bound": [0.99, 1.21],
      "25-mid": "1.23",
      "25-bound": [1.11, 1.36],
      "50-mid": "1.33",
      "50-bound": [1.19, 1.47],
      "100-mid": "1.42",
      "100-bound": [1.26, 1.56]
    },
    "30min": {
      "2-mid": "1.14",
      "2-bound": [1.03, 1.26],
      "5-mid": "1.39",
      "5-bound": [1.25, 1.54],
      "10-mid": "1.59",
      "10-bound": [1.43, 1.76],
      "25-mid": "1.83",
      "25-bound": [1.64, 2.01],
      "50-mid": "2.01",
      "50-bound": [1.79, 2.21],
      "100-mid": "2.18",
      "100-bound": [1.93, 2.4]
    },
    "60min": {
      "2-mid": "1.43",
      "2-bound": [1.29, 1.58],
      "5-mid": "1.78",
      "5-bound": [1.61, 1.97],
      "10-mid": "2.07",
      "10-bound": [1.87, 2.29],
      "25-mid": "2.43",
      "25-bound": [2.18, 2.68],
      "50-mid": "2.72",
      "50-bound": [2.43, 2.99],
      "100-mid": "3.0",
      "100-bound": [2.66, 3.3]
    },
    "2hr": {
      "2-mid": "1.69",
      "2-bound": [1.52, 1.89],
      "5-mid": "2.12",
      "5-bound": [1.9, 2.37],
      "10-mid": "2.49",
      "10-bound": [2.23, 2.77],
      "25-mid": "2.96",
      "25-bound": [2.63, 3.29],
      "50-mid": "3.36",
      "50-bound": [2.96, 3.72],
      "100-mid": "3.75",
      "100-bound": [3.29, 4.15]
    },
    "3hr": {
      "2-mid": "1.83",
      "2-bound": [1.64, 2.05],
      "5-mid": "2.29",
      "5-bound": [2.05, 2.56],
      "10-mid": "2.68",
      "10-bound": [2.4, 3.0],
      "25-mid": "3.2",
      "25-bound": [2.84, 3.56],
      "50-mid": "3.62",
      "50-bound": [3.19, 4.02],
      "100-mid": "4.04",
      "100-bound": [3.55, 4.49]
    },
    "6hr": {
      "2-mid": "2.28",
      "2-bound": [2.04, 2.56],
      "5-mid": "2.84",
      "5-bound": [2.54, 3.19],
      "10-mid": "3.35",
      "10-bound": [2.99, 3.76],
      "25-mid": "4.03",
      "25-bound": [3.56, 4.5],
      "50-mid": "4.6",
      "50-bound": [4.05, 5.14],
      "100-mid": "5.21",
      "100-bound": [4.54, 5.8]
    },
    "12hr": {
      "2-mid": "2.81",
      "2-bound": [2.53, 3.16],
      "5-mid": "3.52",
      "5-bound": [3.15, 3.95],
      "10-mid": "4.18",
      "10-bound": [3.73, 4.68],
      "25-mid": "5.08",
      "25-bound": [4.5, 5.67],
      "50-mid": "5.88",
      "50-bound": [5.15, 6.54],
      "100-mid": "6.73",
      "100-bound": [5.83, 7.47]
    },
    "24hr": {
      "2-mid": "3.43",
      "2-bound": [3.14, 3.79],
      "5-mid": "4.38",
      "5-bound": [4.01, 4.85],
      "10-mid": "5.19",
      "10-bound": [4.72, 5.73],
      "25-mid": "6.38",
      "25-bound": [5.77, 7.03],
      "50-mid": "7.4",
      "50-bound": [6.65, 8.15],
      "100-mid": "8.53",
      "100-bound": [7.6, 9.37]
    },
    "2day": {
      "2-mid": "4.05",
      "2-bound": [3.72, 4.44],
      "5-mid": "5.15",
      "5-bound": [4.72, 5.64],
      "10-mid": "6.05",
      "10-bound": [5.53, 6.64],
      "25-mid": "7.36",
      "25-bound": [6.68, 8.07],
      "50-mid": "8.46",
      "50-bound": [7.65, 9.27],
      "100-mid": "9.64",
      "100-bound": [8.66, 10.6]
    },
    "3day": {
      "2-mid": "4.29",
      "2-bound": [3.94, 4.71],
      "5-mid": "5.45",
      "5-bound": [4.99, 5.98],
      "10-mid": "6.41",
      "10-bound": [5.85, 7.03],
      "25-mid": "7.79",
      "25-bound": [7.06, 8.54],
      "50-mid": "8.95",
      "50-bound": [8.08, 9.8],
      "100-mid": "10.2",
      "100-bound": [9.14, 11.2]
    },
    "4day": {
      "2-mid": "4.54",
      "2-bound": [4.15, 4.99],
      "5-mid": "5.76",
      "5-bound": [5.27, 6.32],
      "10-mid": "6.76",
      "10-bound": [6.16, 7.42],
      "25-mid": "8.22",
      "25-bound": [7.45, 9.01],
      "50-mid": "9.43",
      "50-bound": [8.51, 10.3],
      "100-mid": "10.7",
      "100-bound": [9.62, 11.8]
    },
    "7day": {
      "2-mid": "5.2",
      "2-bound": [4.8, 5.66],
      "5-mid": "6.5",
      "5-bound": [5.98, 7.06],
      "10-mid": "7.57",
      "10-bound": [6.94, 8.22],
      "25-mid": "9.1",
      "25-bound": [8.29, 9.87],
      "50-mid": "10.4",
      "50-bound": [9.4, 11.3],
      "100-mid": "11.7",
      "100-bound": [10.6, 12.7]
    }
  },
  "USC00441999 6": {
    "fips": "51063",
    "station_name": "COPPER HILL",
    "state": "VA",
    "latitude": "37.0816",
    "longitude": "-80.1349",
    "5min": {
      "2-mid": "0.41",
      "2-bound": [0.37, 0.45],
      "5-mid": "0.48",
      "5-bound": [0.44, 0.53],
      "10-mid": "0.54",
      "10-bound": [0.49, 0.59],
      "25-mid": "0.61",
      "25-bound": [0.55, 0.67],
      "50-mid": "0.66",
      "50-bound": [0.59, 0.72],
      "100-mid": "0.7",
      "100-bound": [0.62, 0.78]
    },
    "10min": {
      "2-mid": "0.65",
      "2-bound": [0.59, 0.71],
      "5-mid": "0.78",
      "5-bound": [0.7, 0.85],
      "10-mid": "0.86",
      "10-bound": [0.78, 0.95],
      "25-mid": "0.97",
      "25-bound": [0.87, 1.07],
      "50-mid": "1.05",
      "50-bound": [0.94, 1.15],
      "100-mid": "1.12",
      "100-bound": [0.99, 1.24]
    },
    "15min": {
      "2-mid": "0.81",
      "2-bound": [0.74, 0.9],
      "5-mid": "0.98",
      "5-bound": [0.89, 1.08],
      "10-mid": "1.09",
      "10-bound": [0.99, 1.2],
      "25-mid": "1.23",
      "25-bound": [1.11, 1.35],
      "50-mid": "1.32",
      "50-bound": [1.18, 1.46],
      "100-mid": "1.42",
      "100-bound": [1.26, 1.56]
    },
    "30min": {
      "2-mid": "1.12",
      "2-bound": [1.02, 1.24],
      "5-mid": "1.39",
      "5-bound": [1.26, 1.54],
      "10-mid": "1.58",
      "10-bound": [1.43, 1.74],
      "25-mid": "1.82",
      "25-bound": [1.64, 2.0],
      "50-mid": "2.0",
      "50-bound": [1.78, 2.2],
      "100-mid": "2.17",
      "100-bound": [1.92, 2.39]
    },
    "60min": {
      "2-mid": "1.41",
      "2-bound": [1.28, 1.56],
      "5-mid": "1.78",
      "5-bound": [1.62, 1.97],
      "10-mid": "2.06",
      "10-bound": [1.86, 2.27],
      "25-mid": "2.43",
      "25-bound": [2.18, 2.67],
      "50-mid": "2.7",
      "50-bound": [2.42, 2.98],
      "100-mid": "2.99",
      "100-bound": [2.65, 3.3]
    },
    "2hr": {
      "2-mid": "1.7",
      "2-bound": [1.54, 1.87],
      "5-mid": "2.16",
      "5-bound": [1.96, 2.38],
      "10-mid": "2.51",
      "10-bound": [2.27, 2.76],
      "25-mid": "2.98",
      "25-bound": [2.68, 3.29],
      "50-mid": "3.36",
      "50-bound": [3.0, 3.7],
      "100-mid": "3.74",
      "100-bound": [3.32, 4.13]
    },
    "3hr": {
      "2-mid": "1.84",
      "2-bound": [1.68, 2.02],
      "5-mid": "2.33",
      "5-bound": [2.12, 2.56],
      "10-mid": "2.71",
      "10-bound": [2.46, 2.98],
      "25-mid": "3.22",
      "25-bound": [2.9, 3.54],
      "50-mid": "3.63",
      "50-bound": [3.25, 3.99],
      "100-mid": "4.06",
      "100-bound": [3.6, 4.47]
    },
    "6hr": {
      "2-mid": "2.27",
      "2-bound": [2.09, 2.5],
      "5-mid": "2.86",
      "5-bound": [2.62, 3.14],
      "10-mid": "3.33",
      "10-bound": [3.04, 3.66],
      "25-mid": "3.99",
      "25-bound": [3.62, 4.38],
      "50-mid": "4.54",
      "50-bound": [4.08, 4.99],
      "100-mid": "5.12",
      "100-bound": [4.54, 5.65]
    },
    "12hr": {
      "2-mid": "2.79",
      "2-bound": [2.55, 3.07],
      "5-mid": "3.51",
      "5-bound": [3.21, 3.86],
      "10-mid": "4.12",
      "10-bound": [3.75, 4.53],
      "25-mid": "5.0",
      "25-bound": [4.5, 5.49],
      "50-mid": "5.74",
      "50-bound": [5.11, 6.31],
      "100-mid": "6.56",
      "100-bound": [5.75, 7.23]
    },
    "24hr": {
      "2-mid": "3.36",
      "2-bound": [3.08, 3.68],
      "5-mid": "4.27",
      "5-bound": [3.92, 4.67],
      "10-mid": "5.03",
      "10-bound": [4.59, 5.49],
      "25-mid": "6.13",
      "25-bound": [5.56, 6.69],
      "50-mid": "7.05",
      "50-bound": [6.35, 7.7],
      "100-mid": "8.06",
      "100-bound": [7.2, 8.79]
    },
    "2day": {
      "2-mid": "3.98",
      "2-bound": [3.66, 4.34],
      "5-mid": "5.03",
      "5-bound": [4.62, 5.49],
      "10-mid": "5.89",
      "10-bound": [5.39, 6.42],
      "25-mid": "7.12",
      "25-bound": [6.48, 7.76],
      "50-mid": "8.14",
      "50-bound": [7.37, 8.87],
      "100-mid": "9.24",
      "100-bound": [8.3, 10.1]
    },
    "3day": {
      "2-mid": "4.21",
      "2-bound": [3.88, 4.59],
      "5-mid": "5.32",
      "5-bound": [4.89, 5.8],
      "10-mid": "6.21",
      "10-bound": [5.69, 6.76],
      "25-mid": "7.5",
      "25-bound": [6.83, 8.15],
      "50-mid": "8.56",
      "50-bound": [7.76, 9.29],
      "100-mid": "9.68",
      "100-bound": [8.73, 10.5]
    },
    "4day": {
      "2-mid": "4.44",
      "2-bound": [4.09, 4.84],
      "5-mid": "5.61",
      "5-bound": [5.15, 6.1],
      "10-mid": "6.54",
      "10-bound": [6.0, 7.11],
      "25-mid": "7.87",
      "25-bound": [7.18, 8.54],
      "50-mid": "8.97",
      "50-bound": [8.14, 9.72],
      "100-mid": "10.1",
      "100-bound": [9.16, 11.0]
    },
    "7day": {
      "2-mid": "5.08",
      "2-bound": [4.69, 5.51],
      "5-mid": "6.33",
      "5-bound": [5.83, 6.86],
      "10-mid": "7.32",
      "10-bound": [6.74, 7.93],
      "25-mid": "8.72",
      "25-bound": [7.99, 9.42],
      "50-mid": "9.85",
      "50-bound": [8.99, 10.6],
      "100-mid": "11.0",
      "100-bound": [10.0, 11.9]
    }
  },
  "USC00186350 6": {
    "fips": "24033",
    "station_name": "NATIONAL ARBORETUM DC",
    "state": "DC",
    "latitude": "38.9130",
    "longitude": "-76.9000",
    "5min": {
      "2-mid": "0.42",
      "2-bound": [0.38, 0.46],
      "5-mid": "0.5",
      "5-bound": [0.45, 0.55],
      "10-mid": "0.56",
      "10-bound": [0.5, 0.61],
      "25-mid": "0.63",
      "25-bound": [0.57, 0.7],
      "50-mid": "0.69",
      "50-bound": [0.61, 0.76],
      "100-mid": "0.74",
      "100-bound": [0.66, 0.82]
    },
    "10min": {
      "2-mid": "0.67",
      "2-bound": [0.61, 0.74],
      "5-mid": "0.8",
      "5-bound": [0.72, 0.88],
      "10-mid": "0.89",
      "10-bound": [0.81, 0.98],
      "25-mid": "1.01",
      "25-bound": [0.9, 1.11],
      "50-mid": "1.09",
      "50-bound": [0.97, 1.21],
      "100-mid": "1.18",
      "100-bound": [1.04, 1.3]
    },
    "15min": {
      "2-mid": "0.84",
      "2-bound": [0.77, 0.93],
      "5-mid": "1.01",
      "5-bound": [0.92, 1.11],
      "10-mid": "1.13",
      "10-bound": [1.02, 1.24],
      "25-mid": "1.28",
      "25-bound": [1.14, 1.41],
      "50-mid": "1.38",
      "50-bound": [1.24, 1.53],
      "100-mid": "1.49",
      "100-bound": [1.32, 1.64]
    },
    "30min": {
      "2-mid": "1.16",
      "2-bound": [1.06, 1.28],
      "5-mid": "1.44",
      "5-bound": [1.3, 1.58],
      "10-mid": "1.63",
      "10-bound": [1.48, 1.8],
      "25-mid": "1.89",
      "25-bound": [1.69, 2.08],
      "50-mid": "2.08",
      "50-bound": [1.86, 2.3],
      "100-mid": "2.28",
      "100-bound": [2.02, 2.52]
    },
    "60min": {
      "2-mid": "1.46",
      "2-bound": [1.33, 1.61],
      "5-mid": "1.84",
      "5-bound": [1.67, 2.03],
      "10-mid": "2.13",
      "10-bound": [1.92, 2.34],
      "25-mid": "2.52",
      "25-bound": [2.26, 2.77],
      "50-mid": "2.82",
      "50-bound": [2.52, 3.12],
      "100-mid": "3.13",
      "100-bound": [2.78, 3.47]
    },
    "2hr": {
      "2-mid": "1.71",
      "2-bound": [1.56, 1.89],
      "5-mid": "2.17",
      "5-bound": [1.97, 2.38],
      "10-mid": "2.52",
      "10-bound": [2.28, 2.77],
      "25-mid": "3.02",
      "25-bound": [2.72, 3.32],
      "50-mid": "3.42",
      "50-bound": [3.06, 3.77],
      "100-mid": "3.84",
      "100-bound": [3.42, 4.24]
    },
    "3hr": {
      "2-mid": "1.84",
      "2-bound": [1.67, 2.03],
      "5-mid": "2.33",
      "5-bound": [2.11, 2.57],
      "10-mid": "2.72",
      "10-bound": [2.46, 3.0],
      "25-mid": "3.28",
      "25-bound": [2.94, 3.61],
      "50-mid": "3.74",
      "50-bound": [3.33, 4.12],
      "100-mid": "4.23",
      "100-bound": [3.73, 4.67]
    },
    "6hr": {
      "2-mid": "2.26",
      "2-bound": [2.05, 2.5],
      "5-mid": "2.85",
      "5-bound": [2.58, 3.15],
      "10-mid": "3.34",
      "10-bound": [3.01, 3.69],
      "25-mid": "4.07",
      "25-bound": [3.63, 4.49],
      "50-mid": "4.68",
      "50-bound": [4.14, 5.18],
      "100-mid": "5.35",
      "100-bound": [4.69, 5.93]
    },
    "12hr": {
      "2-mid": "2.73",
      "2-bound": [2.46, 3.07],
      "5-mid": "3.47",
      "5-bound": [3.11, 3.9],
      "10-mid": "4.11",
      "10-bound": [3.66, 4.61],
      "25-mid": "5.08",
      "25-bound": [4.48, 5.7],
      "50-mid": "5.93",
      "50-bound": [5.17, 6.66],
      "100-mid": "6.88",
      "100-bound": [5.92, 7.75]
    },
    "24hr": {
      "2-mid": "3.17",
      "2-bound": [2.89, 3.52],
      "5-mid": "4.08",
      "5-bound": [3.71, 4.52],
      "10-mid": "4.87",
      "10-bound": [4.42, 5.38],
      "25-mid": "6.1",
      "25-bound": [5.48, 6.7],
      "50-mid": "7.19",
      "50-bound": [6.41, 7.86],
      "100-mid": "8.41",
      "100-bound": [7.44, 9.17]
    },
    "2day": {
      "2-mid": "3.68",
      "2-bound": [3.36, 4.07],
      "5-mid": "4.72",
      "5-bound": [4.31, 5.21],
      "10-mid": "5.62",
      "10-bound": [5.1, 6.19],
      "25-mid": "6.96",
      "25-bound": [6.28, 7.65],
      "50-mid": "8.14",
      "50-bound": [7.29, 8.91],
      "100-mid": "9.44",
      "100-bound": [8.39, 10.3]
    },
    "3day": {
      "2-mid": "3.88",
      "2-bound": [3.55, 4.29],
      "5-mid": "4.98",
      "5-bound": [4.54, 5.49],
      "10-mid": "5.91",
      "10-bound": [5.38, 6.51],
      "25-mid": "7.32",
      "25-bound": [6.61, 8.03],
      "50-mid": "8.54",
      "50-bound": [7.67, 9.36],
      "100-mid": "9.9",
      "100-bound": [8.82, 10.8]
    },
    "4day": {
      "2-mid": "4.09",
      "2-bound": [3.74, 4.51],
      "5-mid": "5.22",
      "5-bound": [4.78, 5.76],
      "10-mid": "6.2",
      "10-bound": [5.65, 6.82],
      "25-mid": "7.67",
      "25-bound": [6.94, 8.41],
      "50-mid": "8.95",
      "50-bound": [8.05, 9.8],
      "100-mid": "10.4",
      "100-bound": [9.25, 11.3]
    },
    "7day": {
      "2-mid": "4.72",
      "2-bound": [4.35, 5.18],
      "5-mid": "5.97",
      "5-bound": [5.48, 6.54],
      "10-mid": "7.04",
      "10-bound": [6.45, 7.7],
      "25-mid": "8.63",
      "25-bound": [7.86, 9.42],
      "50-mid": "10.0",
      "50-bound": [9.06, 10.9],
      "100-mid": "11.5",
      "100-bound": [10.4, 12.6]
    }
  },
  "USC00448129 6": {
    "fips": "51183",
    "station_name": "STONY CREEK 2 N",
    "state": "VA",
    "latitude": "36.9740",
    "longitude": "-77.4040",
    "5min": {
      "2-mid": "0.47",
      "2-bound": [0.42, 0.53],
      "5-mid": "0.54",
      "5-bound": [0.49, 0.61],
      "10-mid": "0.61",
      "10-bound": [0.55, 0.69],
      "25-mid": "0.69",
      "25-bound": [0.61, 0.77],
      "50-mid": "0.75",
      "50-bound": [0.66, 0.83],
      "100-mid": "0.81",
      "100-bound": [0.71, 0.9]
    },
    "10min": {
      "2-mid": "0.75",
      "2-bound": [0.67, 0.84],
      "5-mid": "0.87",
      "5-bound": [0.78, 0.97],
      "10-mid": "0.98",
      "10-bound": [0.88, 1.1],
      "25-mid": "1.1",
      "25-bound": [0.98, 1.22],
      "50-mid": "1.19",
      "50-bound": [1.06, 1.33],
      "100-mid": "1.28",
      "100-bound": [1.13, 1.43]
    },
    "15min": {
      "2-mid": "0.94",
      "2-bound": [0.85, 1.06],
      "5-mid": "1.1",
      "5-bound": [0.99, 1.23],
      "10-mid": "1.24",
      "10-bound": [1.11, 1.38],
      "25-mid": "1.39",
      "25-bound": [1.24, 1.55],
      "50-mid": "1.51",
      "50-bound": [1.34, 1.68],
      "100-mid": "1.62",
      "100-bound": [1.42, 1.8]
    },
    "30min": {
      "2-mid": "1.3",
      "2-bound": [1.17, 1.46],
      "5-mid": "1.56",
      "5-bound": [1.4, 1.75],
      "10-mid": "1.8",
      "10-bound": [1.6, 2.01],
      "25-mid": "2.06",
      "25-bound": [1.83, 2.3],
      "50-mid": "2.27",
      "50-bound": [2.01, 2.54],
      "100-mid": "2.48",
      "100-bound": [2.18, 2.76]
    },
    "60min": {
      "2-mid": "1.64",
      "2-bound": [1.47, 1.83],
      "5-mid": "2.01",
      "5-bound": [1.8, 2.24],
      "10-mid": "2.34",
      "10-bound": [2.09, 2.61],
      "25-mid": "2.74",
      "25-bound": [2.44, 3.06],
      "50-mid": "3.08",
      "50-bound": [2.73, 3.44],
      "100-mid": "3.41",
      "100-bound": [3.0, 3.8]
    },
    "2hr": {
      "2-mid": "1.94",
      "2-bound": [1.73, 2.18],
      "5-mid": "2.41",
      "5-bound": [2.15, 2.7],
      "10-mid": "2.84",
      "10-bound": [2.53, 3.18],
      "25-mid": "3.39",
      "25-bound": [3.0, 3.79],
      "50-mid": "3.87",
      "50-bound": [3.4, 4.32],
      "100-mid": "4.35",
      "100-bound": [3.8, 4.85]
    },
    "3hr": {
      "2-mid": "2.08",
      "2-bound": [1.85, 2.35],
      "5-mid": "2.59",
      "5-bound": [2.3, 2.92],
      "10-mid": "3.06",
      "10-bound": [2.71, 3.45],
      "25-mid": "3.68",
      "25-bound": [3.23, 4.14],
      "50-mid": "4.21",
      "50-bound": [3.68, 4.73],
      "100-mid": "4.76",
      "100-bound": [4.14, 5.35]
    },
    "6hr": {
      "2-mid": "2.49",
      "2-bound": [2.21, 2.82],
      "5-mid": "3.09",
      "5-bound": [2.74, 3.51],
      "10-mid": "3.68",
      "10-bound": [3.24, 4.17],
      "25-mid": "4.45",
      "25-bound": [3.9, 5.03],
      "50-mid": "5.14",
      "50-bound": [4.47, 5.79],
      "100-mid": "5.86",
      "100-bound": [5.05, 6.58]
    },
    "12hr": {
      "2-mid": "2.94",
      "2-bound": [2.62, 3.34],
      "5-mid": "3.68",
      "5-bound": [3.26, 4.17],
      "10-mid": "4.4",
      "10-bound": [3.89, 4.97],
      "25-mid": "5.38",
      "25-bound": [4.71, 6.06],
      "50-mid": "6.26",
      "50-bound": [5.44, 7.04],
      "100-mid": "7.21",
      "100-bound": [6.2, 8.07]
    },
    "24hr": {
      "2-mid": "3.48",
      "2-bound": [3.17, 3.84],
      "5-mid": "4.48",
      "5-bound": [4.07, 4.95],
      "10-mid": "5.31",
      "10-bound": [4.8, 5.85],
      "25-mid": "6.5",
      "25-bound": [5.85, 7.16],
      "50-mid": "7.5",
      "50-bound": [6.7, 8.27],
      "100-mid": "8.57",
      "100-bound": [7.6, 9.45]
    },
    "2day": {
      "2-mid": "4.01",
      "2-bound": [3.69, 4.42],
      "5-mid": "5.13",
      "5-bound": [4.7, 5.64],
      "10-mid": "6.04",
      "10-bound": [5.52, 6.64],
      "25-mid": "7.35",
      "25-bound": [6.69, 8.06],
      "50-mid": "8.44",
      "50-bound": [7.63, 9.26],
      "100-mid": "9.6",
      "100-bound": [8.62, 10.5]
    },
    "3day": {
      "2-mid": "4.25",
      "2-bound": [3.91, 4.66],
      "5-mid": "5.4",
      "5-bound": [4.97, 5.92],
      "10-mid": "6.34",
      "10-bound": [5.82, 6.94],
      "25-mid": "7.69",
      "25-bound": [7.02, 8.4],
      "50-mid": "8.79",
      "50-bound": [7.98, 9.61],
      "100-mid": "9.97",
      "100-bound": [8.98, 10.9]
    },
    "4day": {
      "2-mid": "4.48",
      "2-bound": [4.14, 4.9],
      "5-mid": "5.68",
      "5-bound": [5.24, 6.2],
      "10-mid": "6.65",
      "10-bound": [6.12, 7.24],
      "25-mid": "8.02",
      "25-bound": [7.35, 8.74],
      "50-mid": "9.14",
      "50-bound": [8.34, 9.96],
      "100-mid": "10.3",
      "100-bound": [9.35, 11.3]
    },
    "7day": {
      "2-mid": "5.2",
      "2-bound": [4.82, 5.67],
      "5-mid": "6.51",
      "5-bound": [6.02, 7.09],
      "10-mid": "7.56",
      "10-bound": [6.98, 8.22],
      "25-mid": "9.03",
      "25-bound": [8.29, 9.82],
      "50-mid": "10.2",
      "50-bound": [9.33, 11.1],
      "100-mid": "11.5",
      "100-bound": [10.4, 12.5]
    }
  },
  "USC00448829 6": {
    "fips": "51097",
    "station_name": "WALKERTON 2 NW",
    "state": "VA",
    "latitude": "37.7430",
    "longitude": "-77.0000",
    "5min": {
      "2-mid": "0.45",
      "2-bound": [0.41, 0.49],
      "5-mid": "0.52",
      "5-bound": [0.47, 0.57],
      "10-mid": "0.59",
      "10-bound": [0.53, 0.65],
      "25-mid": "0.66",
      "25-bound": [0.59, 0.73],
      "50-mid": "0.72",
      "50-bound": [0.65, 0.79],
      "100-mid": "0.78",
      "100-bound": [0.69, 0.85]
    },
    "10min": {
      "2-mid": "0.72",
      "2-bound": [0.65, 0.79],
      "5-mid": "0.83",
      "5-bound": [0.75, 0.92],
      "10-mid": "0.94",
      "10-bound": [0.85, 1.04],
      "25-mid": "1.05",
      "25-bound": [0.95, 1.16],
      "50-mid": "1.15",
      "50-bound": [1.03, 1.26],
      "100-mid": "1.23",
      "100-bound": [1.1, 1.36]
    },
    "15min": {
      "2-mid": "0.9",
      "2-bound": [0.81, 0.99],
      "5-mid": "1.05",
      "5-bound": [0.95, 1.16],
      "10-mid": "1.19",
      "10-bound": [1.07, 1.31],
      "25-mid": "1.33",
      "25-bound": [1.2, 1.47],
      "50-mid": "1.45",
      "50-bound": [1.3, 1.6],
      "100-mid": "1.56",
      "100-bound": [1.39, 1.72]
    },
    "30min": {
      "2-mid": "1.24",
      "2-bound": [1.12, 1.37],
      "5-mid": "1.49",
      "5-bound": [1.35, 1.65],
      "10-mid": "1.72",
      "10-bound": [1.55, 1.9],
      "25-mid": "1.98",
      "25-bound": [1.78, 2.18],
      "50-mid": "2.18",
      "50-bound": [1.96, 2.41],
      "100-mid": "2.38",
      "100-bound": [2.12, 2.63]
    },
    "60min": {
      "2-mid": "1.56",
      "2-bound": [1.41, 1.72],
      "5-mid": "1.92",
      "5-bound": [1.73, 2.12],
      "10-mid": "2.24",
      "10-bound": [2.02, 2.47],
      "25-mid": "2.63",
      "25-bound": [2.37, 2.9],
      "50-mid": "2.96",
      "50-bound": [2.65, 3.27],
      "100-mid": "3.28",
      "100-bound": [2.93, 3.62]
    },
    "2hr": {
      "2-mid": "1.85",
      "2-bound": [1.67, 2.06],
      "5-mid": "2.3",
      "5-bound": [2.08, 2.55],
      "10-mid": "2.72",
      "10-bound": [2.45, 3.02],
      "25-mid": "3.25",
      "25-bound": [2.9, 3.59],
      "50-mid": "3.7",
      "50-bound": [3.29, 4.09],
      "100-mid": "4.15",
      "100-bound": [3.67, 4.59]
    },
    "3hr": {
      "2-mid": "2.01",
      "2-bound": [1.8, 2.25],
      "5-mid": "2.5",
      "5-bound": [2.24, 2.79],
      "10-mid": "2.96",
      "10-bound": [2.65, 3.3],
      "25-mid": "3.55",
      "25-bound": [3.15, 3.95],
      "50-mid": "4.06",
      "50-bound": [3.58, 4.51],
      "100-mid": "4.58",
      "100-bound": [4.02, 5.08]
    },
    "6hr": {
      "2-mid": "2.42",
      "2-bound": [2.17, 2.73],
      "5-mid": "3.01",
      "5-bound": [2.68, 3.39],
      "10-mid": "3.58",
      "10-bound": [3.18, 4.03],
      "25-mid": "4.32",
      "25-bound": [3.82, 4.86],
      "50-mid": "4.99",
      "50-bound": [4.38, 5.6],
      "100-mid": "5.68",
      "100-bound": [4.94, 6.37]
    },
    "12hr": {
      "2-mid": "2.89",
      "2-bound": [2.58, 3.29],
      "5-mid": "3.61",
      "5-bound": [3.21, 4.1],
      "10-mid": "4.33",
      "10-bound": [3.83, 4.91],
      "25-mid": "5.3",
      "25-bound": [4.64, 5.99],
      "50-mid": "6.19",
      "50-bound": [5.37, 6.99],
      "100-mid": "7.13",
      "100-bound": [6.13, 8.03]
    },
    "24hr": {
      "2-mid": "3.24",
      "2-bound": [2.95, 3.62],
      "5-mid": "4.19",
      "5-bound": [3.81, 4.68],
      "10-mid": "5.02",
      "10-bound": [4.54, 5.59],
      "25-mid": "6.26",
      "25-bound": [5.62, 6.95],
      "50-mid": "7.35",
      "50-bound": [6.55, 8.13],
      "100-mid": "8.57",
      "100-bound": [7.58, 9.44]
    },
    "2day": {
      "2-mid": "3.76",
      "2-bound": [3.44, 4.17],
      "5-mid": "4.86",
      "5-bound": [4.43, 5.38],
      "10-mid": "5.8",
      "10-bound": [5.27, 6.42],
      "25-mid": "7.2",
      "25-bound": [6.51, 7.96],
      "50-mid": "8.43",
      "50-bound": [7.56, 9.28],
      "100-mid": "9.78",
      "100-bound": [8.71, 10.8]
    },
    "3day": {
      "2-mid": "3.99",
      "2-bound": [3.66, 4.41],
      "5-mid": "5.14",
      "5-bound": [4.7, 5.68],
      "10-mid": "6.12",
      "10-bound": [5.57, 6.74],
      "25-mid": "7.57",
      "25-bound": [6.85, 8.33],
      "50-mid": "8.83",
      "50-bound": [7.94, 9.69],
      "100-mid": "10.2",
      "100-bound": [9.12, 11.2]
    },
    "4day": {
      "2-mid": "4.23",
      "2-bound": [3.88, 4.66],
      "5-mid": "5.42",
      "5-bound": [4.96, 5.98],
      "10-mid": "6.44",
      "10-bound": [5.87, 7.07],
      "25-mid": "7.94",
      "25-bound": [7.2, 8.7],
      "50-mid": "9.23",
      "50-bound": [8.32, 10.1],
      "100-mid": "10.6",
      "100-bound": [9.54, 11.6]
    },
    "7day": {
      "2-mid": "4.86",
      "2-bound": [4.46, 5.33],
      "5-mid": "6.13",
      "5-bound": [5.62, 6.73],
      "10-mid": "7.2",
      "10-bound": [6.59, 7.91],
      "25-mid": "8.79",
      "25-bound": [7.99, 9.64],
      "50-mid": "10.1",
      "50-bound": [9.16, 11.1],
      "100-mid": "11.6",
      "100-bound": [10.4, 12.7]
    }
  },
  "USC00364763 6": {
    "fips": "42071",
    "station_name": "LANCASTER 2 NE FILT PLANT",
    "state": "PA",
    "latitude": "40.0490",
    "longitude": "-76.2740",
    "5min": {
      "2-mid": "0.39",
      "2-bound": [0.35, 0.43],
      "5-mid": "0.46",
      "5-bound": [0.41, 0.51],
      "10-mid": "0.51",
      "10-bound": [0.45, 0.56],
      "25-mid": "0.56",
      "25-bound": [0.5, 0.63],
      "50-mid": "0.61",
      "50-bound": [0.54, 0.67],
      "100-mid": "0.65",
      "100-bound": [0.57, 0.72]
    },
    "10min": {
      "2-mid": "0.62",
      "2-bound": [0.56, 0.69],
      "5-mid": "0.73",
      "5-bound": [0.66, 0.81],
      "10-mid": "0.81",
      "10-bound": [0.72, 0.9],
      "25-mid": "0.9",
      "25-bound": [0.8, 1.0],
      "50-mid": "0.96",
      "50-bound": [0.86, 1.07],
      "100-mid": "1.03",
      "100-bound": [0.91, 1.14]
    },
    "15min": {
      "2-mid": "0.78",
      "2-bound": [0.7, 0.87],
      "5-mid": "0.92",
      "5-bound": [0.83, 1.03],
      "10-mid": "1.02",
      "10-bound": [0.92, 1.14],
      "25-mid": "1.14",
      "25-bound": [1.02, 1.27],
      "50-mid": "1.22",
      "50-bound": [1.09, 1.36],
      "100-mid": "1.3",
      "100-bound": [1.15, 1.44]
    },
    "30min": {
      "2-mid": "1.07",
      "2-bound": [0.97, 1.2],
      "5-mid": "1.31",
      "5-bound": [1.18, 1.46],
      "10-mid": "1.48",
      "10-bound": [1.33, 1.65],
      "25-mid": "1.69",
      "25-bound": [1.51, 1.88],
      "50-mid": "1.84",
      "50-bound": [1.64, 2.04],
      "100-mid": "1.99",
      "100-bound": [1.76, 2.21]
    },
    "60min": {
      "2-mid": "1.35",
      "2-bound": [1.21, 1.5],
      "5-mid": "1.68",
      "5-bound": [1.51, 1.87],
      "10-mid": "1.93",
      "10-bound": [1.73, 2.14],
      "25-mid": "2.25",
      "25-bound": [2.01, 2.5],
      "50-mid": "2.49",
      "50-bound": [2.22, 2.77],
      "100-mid": "2.74",
      "100-bound": [2.43, 3.04]
    },
    "2hr": {
      "2-mid": "1.6",
      "2-bound": [1.44, 1.8],
      "5-mid": "2.02",
      "5-bound": [1.81, 2.27],
      "10-mid": "2.36",
      "10-bound": [2.1, 2.63],
      "25-mid": "2.82",
      "25-bound": [2.51, 3.14],
      "50-mid": "3.19",
      "50-bound": [2.82, 3.56],
      "100-mid": "3.59",
      "100-bound": [3.15, 3.99]
    },
    "3hr": {
      "2-mid": "1.74",
      "2-bound": [1.57, 1.96],
      "5-mid": "2.2",
      "5-bound": [1.97, 2.47],
      "10-mid": "2.57",
      "10-bound": [2.29, 2.87],
      "25-mid": "3.07",
      "25-bound": [2.72, 3.42],
      "50-mid": "3.47",
      "50-bound": [3.07, 3.87],
      "100-mid": "3.9",
      "100-bound": [3.43, 4.35]
    },
    "6hr": {
      "2-mid": "2.16",
      "2-bound": [1.94, 2.42],
      "5-mid": "2.72",
      "5-bound": [2.44, 3.04],
      "10-mid": "3.18",
      "10-bound": [2.84, 3.56],
      "25-mid": "3.85",
      "25-bound": [3.42, 4.29],
      "50-mid": "4.41",
      "50-bound": [3.89, 4.9],
      "100-mid": "5.01",
      "100-bound": [4.39, 5.56]
    },
    "12hr": {
      "2-mid": "2.62",
      "2-bound": [2.35, 2.95],
      "5-mid": "3.32",
      "5-bound": [2.98, 3.74],
      "10-mid": "3.92",
      "10-bound": [3.5, 4.4],
      "25-mid": "4.8",
      "25-bound": [4.25, 5.37],
      "50-mid": "5.57",
      "50-bound": [4.88, 6.2],
      "100-mid": "6.42",
      "100-bound": [5.57, 7.14]
    },
    "24hr": {
      "2-mid": "3.02",
      "2-bound": [2.79, 3.31],
      "5-mid": "3.85",
      "5-bound": [3.54, 4.21],
      "10-mid": "4.56",
      "10-bound": [4.18, 4.97],
      "25-mid": "5.63",
      "25-bound": [5.12, 6.12],
      "50-mid": "6.57",
      "50-bound": [5.92, 7.12],
      "100-mid": "7.6",
      "100-bound": [6.79, 8.22]
    },
    "2day": {
      "2-mid": "3.49",
      "2-bound": [3.23, 3.83],
      "5-mid": "4.44",
      "5-bound": [4.1, 4.87],
      "10-mid": "5.24",
      "10-bound": [4.82, 5.73],
      "25-mid": "6.42",
      "25-bound": [5.87, 6.99],
      "50-mid": "7.43",
      "50-bound": [6.74, 8.08],
      "100-mid": "8.53",
      "100-bound": [7.68, 9.26]
    },
    "3day": {
      "2-mid": "3.7",
      "2-bound": [3.41, 4.04],
      "5-mid": "4.69",
      "5-bound": [4.33, 5.12],
      "10-mid": "5.53",
      "10-bound": [5.08, 6.03],
      "25-mid": "6.77",
      "25-bound": [6.18, 7.35],
      "50-mid": "7.83",
      "50-bound": [7.1, 8.48],
      "100-mid": "8.98",
      "100-bound": [8.09, 9.72]
    },
    "4day": {
      "2-mid": "3.9",
      "2-bound": [3.6, 4.25],
      "5-mid": "4.94",
      "5-bound": [4.55, 5.38],
      "10-mid": "5.82",
      "10-bound": [5.35, 6.32],
      "25-mid": "7.11",
      "25-bound": [6.5, 7.7],
      "50-mid": "8.22",
      "50-bound": [7.46, 8.89],
      "100-mid": "9.43",
      "100-bound": [8.51, 10.2]
    },
    "7day": {
      "2-mid": "4.55",
      "2-bound": [4.21, 4.94],
      "5-mid": "5.71",
      "5-bound": [5.27, 6.19],
      "10-mid": "6.68",
      "10-bound": [6.16, 7.24],
      "25-mid": "8.12",
      "25-bound": [7.45, 8.78],
      "50-mid": "9.34",
      "50-bound": [8.52, 10.1],
      "100-mid": "10.7",
      "100-bound": [9.67, 11.5]
    }
  },
  "USC00362721 6": {
    "fips": "42009",
    "station_name": "EVERETT",
    "state": "PA",
    "latitude": "40.0130",
    "longitude": "-78.3650",
    "5min": {
      "2-mid": "0.37",
      "2-bound": [0.33, 0.41],
      "5-mid": "0.45",
      "5-bound": [0.4, 0.5],
      "10-mid": "0.52",
      "10-bound": [0.45, 0.57],
      "25-mid": "0.6",
      "25-bound": [0.53, 0.67],
      "50-mid": "0.67",
      "50-bound": [0.58, 0.74],
      "100-mid": "0.73",
      "100-bound": [0.63, 0.81]
    },
    "10min": {
      "2-mid": "0.58",
      "2-bound": [0.51, 0.65],
      "5-mid": "0.7",
      "5-bound": [0.62, 0.78],
      "10-mid": "0.79",
      "10-bound": [0.7, 0.89],
      "25-mid": "0.92",
      "25-bound": [0.81, 1.02],
      "50-mid": "1.01",
      "50-bound": [0.88, 1.12],
      "100-mid": "1.1",
      "100-bound": [0.95, 1.22]
    },
    "15min": {
      "2-mid": "0.7",
      "2-bound": [0.63, 0.79],
      "5-mid": "0.86",
      "5-bound": [0.76, 0.96],
      "10-mid": "0.98",
      "10-bound": [0.86, 1.09],
      "25-mid": "1.13",
      "25-bound": [1.0, 1.26],
      "50-mid": "1.25",
      "50-bound": [1.09, 1.39],
      "100-mid": "1.37",
      "100-bound": [1.19, 1.52]
    },
    "30min": {
      "2-mid": "0.94",
      "2-bound": [0.84, 1.06],
      "5-mid": "1.18",
      "5-bound": [1.04, 1.32],
      "10-mid": "1.36",
      "10-bound": [1.2, 1.52],
      "25-mid": "1.6",
      "25-bound": [1.41, 1.78],
      "50-mid": "1.78",
      "50-bound": [1.56, 1.98],
      "100-mid": "1.98",
      "100-bound": [1.71, 2.2]
    },
    "60min": {
      "2-mid": "1.16",
      "2-bound": [1.03, 1.3],
      "5-mid": "1.48",
      "5-bound": [1.31, 1.65],
      "10-mid": "1.73",
      "10-bound": [1.52, 1.93],
      "25-mid": "2.08",
      "25-bound": [1.82, 2.31],
      "50-mid": "2.35",
      "50-bound": [2.06, 2.61],
      "100-mid": "2.65",
      "100-bound": [2.29, 2.94]
    },
    "2hr": {
      "2-mid": "1.33",
      "2-bound": [1.19, 1.48],
      "5-mid": "1.71",
      "5-bound": [1.52, 1.9],
      "10-mid": "2.0",
      "10-bound": [1.78, 2.22],
      "25-mid": "2.43",
      "25-bound": [2.14, 2.69],
      "50-mid": "2.78",
      "50-bound": [2.44, 3.06],
      "100-mid": "3.15",
      "100-bound": [2.74, 3.46]
    },
    "3hr": {
      "2-mid": "1.43",
      "2-bound": [1.3, 1.59],
      "5-mid": "1.82",
      "5-bound": [1.64, 2.02],
      "10-mid": "2.13",
      "10-bound": [1.91, 2.36],
      "25-mid": "2.58",
      "25-bound": [2.3, 2.85],
      "50-mid": "2.94",
      "50-bound": [2.61, 3.24],
      "100-mid": "3.35",
      "100-bound": [2.95, 3.68]
    },
    "6hr": {
      "2-mid": "1.78",
      "2-bound": [1.62, 1.98],
      "5-mid": "2.23",
      "5-bound": [2.02, 2.47],
      "10-mid": "2.6",
      "10-bound": [2.35, 2.87],
      "25-mid": "3.13",
      "25-bound": [2.8, 3.45],
      "50-mid": "3.58",
      "50-bound": [3.18, 3.92],
      "100-mid": "4.04",
      "100-bound": [3.57, 4.43]
    },
    "12hr": {
      "2-mid": "2.18",
      "2-bound": [1.99, 2.43],
      "5-mid": "2.71",
      "5-bound": [2.46, 3.0],
      "10-mid": "3.16",
      "10-bound": [2.85, 3.48],
      "25-mid": "3.82",
      "25-bound": [3.43, 4.18],
      "50-mid": "4.36",
      "50-bound": [3.89, 4.77],
      "100-mid": "4.96",
      "100-bound": [4.39, 5.41]
    },
    "24hr": {
      "2-mid": "2.63",
      "2-bound": [2.43, 2.86],
      "5-mid": "3.28",
      "5-bound": [3.02, 3.56],
      "10-mid": "3.82",
      "10-bound": [3.51, 4.14],
      "25-mid": "4.59",
      "25-bound": [4.2, 4.98],
      "50-mid": "5.24",
      "50-bound": [4.77, 5.68],
      "100-mid": "5.94",
      "100-bound": [5.37, 6.42]
    },
    "2day": {
      "2-mid": "3.03",
      "2-bound": [2.81, 3.29],
      "5-mid": "3.76",
      "5-bound": [3.48, 4.09],
      "10-mid": "4.38",
      "10-bound": [4.03, 4.75],
      "25-mid": "5.27",
      "25-bound": [4.83, 5.7],
      "50-mid": "6.02",
      "50-bound": [5.48, 6.5],
      "100-mid": "6.83",
      "100-bound": [6.17, 7.37]
    },
    "3day": {
      "2-mid": "3.25",
      "2-bound": [3.02, 3.52],
      "5-mid": "4.02",
      "5-bound": [3.72, 4.35],
      "10-mid": "4.67",
      "10-bound": [4.31, 5.04],
      "25-mid": "5.6",
      "25-bound": [5.15, 6.04],
      "50-mid": "6.38",
      "50-bound": [5.83, 6.87],
      "100-mid": "7.22",
      "100-bound": [6.55, 7.77]
    },
    "4day": {
      "2-mid": "3.47",
      "2-bound": [3.22, 3.74],
      "5-mid": "4.28",
      "5-bound": [3.97, 4.61],
      "10-mid": "4.96",
      "10-bound": [4.59, 5.33],
      "25-mid": "5.93",
      "25-bound": [5.46, 6.37],
      "50-mid": "6.74",
      "50-bound": [6.18, 7.24],
      "100-mid": "7.6",
      "100-bound": [6.92, 8.16]
    },
    "7day": {
      "2-mid": "4.04",
      "2-bound": [3.79, 4.32],
      "5-mid": "4.93",
      "5-bound": [4.61, 5.26],
      "10-mid": "5.64",
      "10-bound": [5.27, 6.03],
      "25-mid": "6.64",
      "25-bound": [6.17, 7.09],
      "50-mid": "7.44",
      "50-bound": [6.88, 7.95],
      "100-mid": "8.27",
      "100-bound": [7.6, 8.84]
    }
  },
  "USC00460527 6": {
    "fips": "54023",
    "station_name": "BAYARD",
    "state": "WV",
    "latitude": "39.2720",
    "longitude": "-79.3680",
    "5min": {
      "2-mid": "0.35",
      "2-bound": [0.31, 0.4],
      "5-mid": "0.42",
      "5-bound": [0.37, 0.47],
      "10-mid": "0.48",
      "10-bound": [0.43, 0.54],
      "25-mid": "0.56",
      "25-bound": [0.49, 0.62],
      "50-mid": "0.63",
      "50-bound": [0.55, 0.7],
      "100-mid": "0.69",
      "100-bound": [0.61, 0.77]
    },
    "10min": {
      "2-mid": "0.55",
      "2-bound": [0.49, 0.62],
      "5-mid": "0.65",
      "5-bound": [0.58, 0.73],
      "10-mid": "0.74",
      "10-bound": [0.66, 0.83],
      "25-mid": "0.86",
      "25-bound": [0.76, 0.95],
      "50-mid": "0.95",
      "50-bound": [0.84, 1.06],
      "100-mid": "1.05",
      "100-bound": [0.92, 1.16]
    },
    "15min": {
      "2-mid": "0.67",
      "2-bound": [0.6, 0.76],
      "5-mid": "0.8",
      "5-bound": [0.71, 0.89],
      "10-mid": "0.92",
      "10-bound": [0.82, 1.02],
      "25-mid": "1.06",
      "25-bound": [0.94, 1.18],
      "50-mid": "1.18",
      "50-bound": [1.04, 1.31],
      "100-mid": "1.3",
      "100-bound": [1.14, 1.44]
    },
    "30min": {
      "2-mid": "0.9",
      "2-bound": [0.81, 1.01],
      "5-mid": "1.09",
      "5-bound": [0.98, 1.22],
      "10-mid": "1.28",
      "10-bound": [1.14, 1.43],
      "25-mid": "1.5",
      "25-bound": [1.33, 1.67],
      "50-mid": "1.69",
      "50-bound": [1.49, 1.88],
      "100-mid": "1.89",
      "100-bound": [1.65, 2.09]
    },
    "60min": {
      "2-mid": "1.11",
      "2-bound": [0.99, 1.25],
      "5-mid": "1.37",
      "5-bound": [1.23, 1.54],
      "10-mid": "1.63",
      "10-bound": [1.45, 1.82],
      "25-mid": "1.95",
      "25-bound": [1.72, 2.17],
      "50-mid": "2.24",
      "50-bound": [1.97, 2.48],
      "100-mid": "2.53",
      "100-bound": [2.21, 2.8]
    },
    "2hr": {
      "2-mid": "1.33",
      "2-bound": [1.18, 1.49],
      "5-mid": "1.64",
      "5-bound": [1.46, 1.84],
      "10-mid": "1.96",
      "10-bound": [1.75, 2.19],
      "25-mid": "2.38",
      "25-bound": [2.1, 2.65],
      "50-mid": "2.77",
      "50-bound": [2.43, 3.07],
      "100-mid": "3.16",
      "100-bound": [2.76, 3.51]
    },
    "3hr": {
      "2-mid": "1.43",
      "2-bound": [1.28, 1.61],
      "5-mid": "1.76",
      "5-bound": [1.57, 1.98],
      "10-mid": "2.1",
      "10-bound": [1.87, 2.36],
      "25-mid": "2.54",
      "25-bound": [2.25, 2.84],
      "50-mid": "2.95",
      "50-bound": [2.6, 3.3],
      "100-mid": "3.39",
      "100-bound": [2.96, 3.77]
    },
    "6hr": {
      "2-mid": "1.77",
      "2-bound": [1.57, 2.01],
      "5-mid": "2.15",
      "5-bound": [1.9, 2.44],
      "10-mid": "2.55",
      "10-bound": [2.25, 2.89],
      "25-mid": "3.07",
      "25-bound": [2.7, 3.47],
      "50-mid": "3.56",
      "50-bound": [3.11, 4.01],
      "100-mid": "4.08",
      "100-bound": [3.53, 4.59]
    },
    "12hr": {
      "2-mid": "2.18",
      "2-bound": [1.94, 2.49],
      "5-mid": "2.64",
      "5-bound": [2.35, 3.01],
      "10-mid": "3.12",
      "10-bound": [2.77, 3.55],
      "25-mid": "3.78",
      "25-bound": [3.32, 4.28],
      "50-mid": "4.39",
      "50-bound": [3.84, 4.96],
      "100-mid": "5.04",
      "100-bound": [4.37, 5.68]
    },
    "24hr": {
      "2-mid": "2.62",
      "2-bound": [2.44, 2.84],
      "5-mid": "3.26",
      "5-bound": [3.04, 3.54],
      "10-mid": "3.84",
      "10-bound": [3.55, 4.15],
      "25-mid": "4.71",
      "25-bound": [4.3, 5.08],
      "50-mid": "5.47",
      "50-bound": [4.95, 5.92],
      "100-mid": "6.33",
      "100-bound": [5.63, 6.88]
    },
    "2day": {
      "2-mid": "3.1",
      "2-bound": [2.9, 3.34],
      "5-mid": "3.83",
      "5-bound": [3.57, 4.12],
      "10-mid": "4.47",
      "10-bound": [4.14, 4.8],
      "25-mid": "5.41",
      "25-bound": [4.97, 5.83],
      "50-mid": "6.23",
      "50-bound": [5.66, 6.74],
      "100-mid": "7.13",
      "100-bound": [6.39, 7.77]
    },
    "3day": {
      "2-mid": "3.37",
      "2-bound": [3.17, 3.6],
      "5-mid": "4.13",
      "5-bound": [3.88, 4.41],
      "10-mid": "4.77",
      "10-bound": [4.46, 5.1],
      "25-mid": "5.72",
      "25-bound": [5.3, 6.12],
      "50-mid": "6.52",
      "50-bound": [5.98, 7.01],
      "100-mid": "7.39",
      "100-bound": [6.68, 7.99]
    },
    "4day": {
      "2-mid": "3.64",
      "2-bound": [3.44, 3.87],
      "5-mid": "4.42",
      "5-bound": [4.18, 4.7],
      "10-mid": "5.08",
      "10-bound": [4.78, 5.39],
      "25-mid": "6.03",
      "25-bound": [5.62, 6.4],
      "50-mid": "6.81",
      "50-bound": [6.3, 7.27],
      "100-mid": "7.65",
      "100-bound": [6.98, 8.21]
    },
    "7day": {
      "2-mid": "4.23",
      "2-bound": [4.0, 4.5],
      "5-mid": "5.07",
      "5-bound": [4.79, 5.39],
      "10-mid": "5.76",
      "10-bound": [5.42, 6.12],
      "25-mid": "6.72",
      "25-bound": [6.29, 7.15],
      "50-mid": "7.49",
      "50-bound": [6.96, 8.0],
      "100-mid": "8.3",
      "100-bound": [7.64, 8.91]
    }
  },
  "USC00306085 6": {
    "fips": "36017",
    "station_name": "NORWICH",
    "state": "NY",
    "latitude": "42.5110",
    "longitude": "-75.5190",
    "5min": {
      "2-mid": "0.35",
      "2-bound": [0.27, 0.42],
      "5-mid": "0.44",
      "5-bound": [0.35, 0.55],
      "10-mid": "0.53",
      "10-bound": [0.41, 0.65],
      "25-mid": "0.64",
      "25-bound": [0.48, 0.83],
      "50-mid": "0.72",
      "50-bound": [0.54, 0.96],
      "100-mid": "0.81",
      "100-bound": [0.59, 1.13]
    },
    "10min": {
      "2-mid": "0.49",
      "2-bound": [0.39, 0.6],
      "5-mid": "0.63",
      "5-bound": [0.5, 0.78],
      "10-mid": "0.74",
      "10-bound": [0.58, 0.92],
      "25-mid": "0.91",
      "25-bound": [0.69, 1.18],
      "50-mid": "1.02",
      "50-bound": [0.76, 1.37],
      "100-mid": "1.15",
      "100-bound": [0.83, 1.6]
    },
    "15min": {
      "2-mid": "0.58",
      "2-bound": [0.46, 0.71],
      "5-mid": "0.74",
      "5-bound": [0.58, 0.91],
      "10-mid": "0.88",
      "10-bound": [0.69, 1.09],
      "25-mid": "1.06",
      "25-bound": [0.81, 1.39],
      "50-mid": "1.2",
      "50-bound": [0.89, 1.61],
      "100-mid": "1.36",
      "100-bound": [0.98, 1.89]
    },
    "30min": {
      "2-mid": "0.77",
      "2-bound": [0.61, 0.95],
      "5-mid": "0.99",
      "5-bound": [0.78, 1.22],
      "10-mid": "1.17",
      "10-bound": [0.92, 1.45],
      "25-mid": "1.42",
      "25-bound": [1.08, 1.85],
      "50-mid": "1.61",
      "50-bound": [1.2, 2.15],
      "100-mid": "1.81",
      "100-bound": [1.3, 2.52]
    },
    "60min": {
      "2-mid": "0.96",
      "2-bound": [0.76, 1.18],
      "5-mid": "1.24",
      "5-bound": [0.98, 1.53],
      "10-mid": "1.47",
      "10-bound": [1.15, 1.82],
      "25-mid": "1.78",
      "25-bound": [1.35, 2.32],
      "50-mid": "2.01",
      "50-bound": [1.5, 2.69],
      "100-mid": "2.26",
      "100-bound": [1.63, 3.15]
    },
    "2hr": {
      "2-mid": "1.21",
      "2-bound": [0.96, 1.47],
      "5-mid": "1.51",
      "5-bound": [1.2, 1.85],
      "10-mid": "1.76",
      "10-bound": [1.4, 2.17],
      "25-mid": "2.11",
      "25-bound": [1.61, 2.73],
      "50-mid": "2.37",
      "50-bound": [1.77, 3.14],
      "100-mid": "2.65",
      "100-bound": [1.92, 3.65]
    },
    "3hr": {
      "2-mid": "1.37",
      "2-bound": [1.1, 1.67],
      "5-mid": "1.7",
      "5-bound": [1.36, 2.07],
      "10-mid": "1.98",
      "10-bound": [1.57, 2.42],
      "25-mid": "2.35",
      "25-bound": [1.81, 3.02],
      "50-mid": "2.63",
      "50-bound": [1.98, 3.47],
      "100-mid": "2.93",
      "100-bound": [2.14, 4.03]
    },
    "6hr": {
      "2-mid": "1.7",
      "2-bound": [1.37, 2.04],
      "5-mid": "2.1",
      "5-bound": [1.7, 2.55],
      "10-mid": "2.44",
      "10-bound": [1.96, 2.97],
      "25-mid": "2.91",
      "25-bound": [2.25, 3.71],
      "50-mid": "3.26",
      "50-bound": [2.46, 4.25],
      "100-mid": "3.63",
      "100-bound": [2.66, 4.94]
    },
    "12hr": {
      "2-mid": "2.07",
      "2-bound": [1.69, 2.48],
      "5-mid": "2.61",
      "5-bound": [2.13, 3.14],
      "10-mid": "3.06",
      "10-bound": [2.48, 3.7],
      "25-mid": "3.68",
      "25-bound": [2.87, 4.66],
      "50-mid": "4.14",
      "50-bound": [3.15, 5.36],
      "100-mid": "4.63",
      "100-bound": [3.41, 6.24]
    },
    "24hr": {
      "2-mid": "2.47",
      "2-bound": [2.04, 2.94],
      "5-mid": "3.15",
      "5-bound": [2.58, 3.76],
      "10-mid": "3.7",
      "10-bound": [3.02, 4.45],
      "25-mid": "4.47",
      "25-bound": [3.52, 5.63],
      "50-mid": "5.04",
      "50-bound": [3.87, 6.49],
      "100-mid": "5.66",
      "100-bound": [4.2, 7.58]
    },
    "2day": {
      "2-mid": "2.89",
      "2-bound": [2.4, 3.41],
      "5-mid": "3.64",
      "5-bound": [3.02, 4.32],
      "10-mid": "4.27",
      "10-bound": [3.52, 5.09],
      "25-mid": "5.14",
      "25-bound": [4.08, 6.42],
      "50-mid": "5.78",
      "50-bound": [4.48, 7.39],
      "100-mid": "6.47",
      "100-bound": [4.86, 8.63]
    },
    "3day": {
      "2-mid": "3.18",
      "2-bound": [2.66, 3.74],
      "5-mid": "3.97",
      "5-bound": [3.31, 4.69],
      "10-mid": "4.63",
      "10-bound": [3.83, 5.5],
      "25-mid": "5.54",
      "25-bound": [4.41, 6.88],
      "50-mid": "6.2",
      "50-bound": [4.82, 7.88],
      "100-mid": "6.93",
      "100-bound": [5.21, 9.17]
    },
    "4day": {
      "2-mid": "3.43",
      "2-bound": [2.88, 4.02],
      "5-mid": "4.24",
      "5-bound": [3.55, 4.99],
      "10-mid": "4.91",
      "10-bound": [4.08, 5.81],
      "25-mid": "5.84",
      "25-bound": [4.67, 7.22],
      "50-mid": "6.53",
      "50-bound": [5.09, 8.25],
      "100-mid": "7.27",
      "100-bound": [5.46, 9.55]
    },
    "7day": {
      "2-mid": "4.07",
      "2-bound": [3.45, 4.75],
      "5-mid": "4.92",
      "5-bound": [4.15, 5.76],
      "10-mid": "5.62",
      "10-bound": [4.7, 6.61],
      "25-mid": "6.58",
      "25-bound": [5.29, 8.06],
      "50-mid": "7.3",
      "50-bound": [5.71, 9.13],
      "100-mid": "8.07",
      "100-bound": [6.07, 10.5]
    }
  },
  "USC00449159 6": {
    "fips": "51017",
    "station_name": "WILLIAMSVILLE 2 S",
    "state": "VA",
    "latitude": "38.1793",
    "longitude": "-79.5816",
    "5min": {
      "2-mid": "0.34",
      "2-bound": [0.31, 0.38],
      "5-mid": "0.41",
      "5-bound": [0.37, 0.46],
      "10-mid": "0.47",
      "10-bound": [0.41, 0.52],
      "25-mid": "0.53",
      "25-bound": [0.47, 0.59],
      "50-mid": "0.58",
      "50-bound": [0.51, 0.64],
      "100-mid": "0.62",
      "100-bound": [0.54, 0.69]
    },
    "10min": {
      "2-mid": "0.54",
      "2-bound": [0.49, 0.61],
      "5-mid": "0.66",
      "5-bound": [0.59, 0.74],
      "10-mid": "0.74",
      "10-bound": [0.66, 0.83],
      "25-mid": "0.84",
      "25-bound": [0.75, 0.94],
      "50-mid": "0.92",
      "50-bound": [0.81, 1.02],
      "100-mid": "0.99",
      "100-bound": [0.86, 1.1]
    },
    "15min": {
      "2-mid": "0.68",
      "2-bound": [0.61, 0.77],
      "5-mid": "0.84",
      "5-bound": [0.75, 0.93],
      "10-mid": "0.94",
      "10-bound": [0.84, 1.05],
      "25-mid": "1.07",
      "25-bound": [0.95, 1.19],
      "50-mid": "1.16",
      "50-bound": [1.02, 1.29],
      "100-mid": "1.25",
      "100-bound": [1.09, 1.39]
    },
    "30min": {
      "2-mid": "0.94",
      "2-bound": [0.85, 1.06],
      "5-mid": "1.19",
      "5-bound": [1.07, 1.33],
      "10-mid": "1.36",
      "10-bound": [1.22, 1.52],
      "25-mid": "1.58",
      "25-bound": [1.4, 1.76],
      "50-mid": "1.75",
      "50-bound": [1.54, 1.94],
      "100-mid": "1.91",
      "100-bound": [1.67, 2.13]
    },
    "60min": {
      "2-mid": "1.19",
      "2-bound": [1.06, 1.32],
      "5-mid": "1.52",
      "5-bound": [1.37, 1.7],
      "10-mid": "1.78",
      "10-bound": [1.58, 1.98],
      "25-mid": "2.11",
      "25-bound": [1.87, 2.34],
      "50-mid": "2.37",
      "50-bound": [2.08, 2.63],
      "100-mid": "2.63",
      "100-bound": [2.3, 2.94]
    },
    "2hr": {
      "2-mid": "1.39",
      "2-bound": [1.26, 1.54],
      "5-mid": "1.78",
      "5-bound": [1.61, 1.97],
      "10-mid": "2.08",
      "10-bound": [1.88, 2.3],
      "25-mid": "2.48",
      "25-bound": [2.22, 2.75],
      "50-mid": "2.8",
      "50-bound": [2.49, 3.11],
      "100-mid": "3.13",
      "100-bound": [2.76, 3.48]
    },
    "3hr": {
      "2-mid": "1.5",
      "2-bound": [1.37, 1.66],
      "5-mid": "1.91",
      "5-bound": [1.74, 2.12],
      "10-mid": "2.23",
      "10-bound": [2.02, 2.47],
      "25-mid": "2.67",
      "25-bound": [2.4, 2.95],
      "50-mid": "3.02",
      "50-bound": [2.69, 3.34],
      "100-mid": "3.38",
      "100-bound": [2.99, 3.76]
    },
    "6hr": {
      "2-mid": "1.9",
      "2-bound": [1.73, 2.12],
      "5-mid": "2.38",
      "5-bound": [2.16, 2.66],
      "10-mid": "2.78",
      "10-bound": [2.5, 3.09],
      "25-mid": "3.34",
      "25-bound": [2.99, 3.71],
      "50-mid": "3.8",
      "50-bound": [3.36, 4.23],
      "100-mid": "4.29",
      "100-bound": [3.75, 4.78]
    },
    "12hr": {
      "2-mid": "2.36",
      "2-bound": [2.13, 2.66],
      "5-mid": "2.94",
      "5-bound": [2.65, 3.32],
      "10-mid": "3.44",
      "10-bound": [3.08, 3.88],
      "25-mid": "4.17",
      "25-bound": [3.69, 4.7],
      "50-mid": "4.78",
      "50-bound": [4.19, 5.4],
      "100-mid": "5.47",
      "100-bound": [4.71, 6.2]
    },
    "24hr": {
      "2-mid": "2.99",
      "2-bound": [2.73, 3.3],
      "5-mid": "3.73",
      "5-bound": [3.4, 4.11],
      "10-mid": "4.34",
      "10-bound": [3.94, 4.78],
      "25-mid": "5.21",
      "25-bound": [4.7, 5.73],
      "50-mid": "5.92",
      "50-bound": [5.32, 6.52],
      "100-mid": "6.69",
      "100-bound": [5.96, 7.37]
    },
    "2day": {
      "2-mid": "3.49",
      "2-bound": [3.21, 3.84],
      "5-mid": "4.34",
      "5-bound": [3.98, 4.76],
      "10-mid": "5.02",
      "10-bound": [4.6, 5.5],
      "25-mid": "5.98",
      "25-bound": [5.44, 6.56],
      "50-mid": "6.76",
      "50-bound": [6.12, 7.42],
      "100-mid": "7.59",
      "100-bound": [6.82, 8.34]
    },
    "3day": {
      "2-mid": "3.75",
      "2-bound": [3.45, 4.09],
      "5-mid": "4.64",
      "5-bound": [4.26, 5.06],
      "10-mid": "5.35",
      "10-bound": [4.91, 5.84],
      "25-mid": "6.35",
      "25-bound": [5.8, 6.92],
      "50-mid": "7.16",
      "50-bound": [6.5, 7.81],
      "100-mid": "8.01",
      "100-bound": [7.23, 8.75]
    },
    "4day": {
      "2-mid": "4.0",
      "2-bound": [3.7, 4.34],
      "5-mid": "4.93",
      "5-bound": [4.55, 5.36],
      "10-mid": "5.68",
      "10-bound": [5.22, 6.16],
      "25-mid": "6.71",
      "25-bound": [6.15, 7.28],
      "50-mid": "7.55",
      "50-bound": [6.88, 8.2],
      "100-mid": "8.43",
      "100-bound": [7.64, 9.17]
    },
    "7day": {
      "2-mid": "4.64",
      "2-bound": [4.31, 5.01],
      "5-mid": "5.67",
      "5-bound": [5.26, 6.12],
      "10-mid": "6.48",
      "10-bound": [6.0, 6.98],
      "25-mid": "7.58",
      "25-bound": [6.99, 8.17],
      "50-mid": "8.46",
      "50-bound": [7.76, 9.12],
      "100-mid": "9.36",
      "100-bound": [8.55, 10.1]
    }
  },
  "USC00364432 6": {
    "fips": "42083",
    "station_name": "KANE 1NNE",
    "state": "PA",
    "latitude": "41.6760",
    "longitude": "-78.8030",
    "5min": {
      "2-mid": "0.37",
      "2-bound": [0.33, 0.4],
      "5-mid": "0.44",
      "5-bound": [0.4, 0.49],
      "10-mid": "0.5",
      "10-bound": [0.45, 0.55],
      "25-mid": "0.58",
      "25-bound": [0.52, 0.64],
      "50-mid": "0.64",
      "50-bound": [0.57, 0.7],
      "100-mid": "0.69",
      "100-bound": [0.62, 0.76]
    },
    "10min": {
      "2-mid": "0.57",
      "2-bound": [0.52, 0.63],
      "5-mid": "0.69",
      "5-bound": [0.62, 0.76],
      "10-mid": "0.78",
      "10-bound": [0.7, 0.85],
      "25-mid": "0.88",
      "25-bound": [0.79, 0.97],
      "50-mid": "0.96",
      "50-bound": [0.86, 1.06],
      "100-mid": "1.04",
      "100-bound": [0.93, 1.14]
    },
    "15min": {
      "2-mid": "0.7",
      "2-bound": [0.63, 0.77],
      "5-mid": "0.84",
      "5-bound": [0.76, 0.93],
      "10-mid": "0.95",
      "10-bound": [0.86, 1.05],
      "25-mid": "1.09",
      "25-bound": [0.98, 1.2],
      "50-mid": "1.19",
      "50-bound": [1.06, 1.31],
      "100-mid": "1.29",
      "100-bound": [1.15, 1.42]
    },
    "30min": {
      "2-mid": "0.94",
      "2-bound": [0.84, 1.03],
      "5-mid": "1.16",
      "5-bound": [1.04, 1.28],
      "10-mid": "1.32",
      "10-bound": [1.19, 1.46],
      "25-mid": "1.54",
      "25-bound": [1.38, 1.69],
      "50-mid": "1.7",
      "50-bound": [1.52, 1.87],
      "100-mid": "1.87",
      "100-bound": [1.66, 2.05]
    },
    "60min": {
      "2-mid": "1.15",
      "2-bound": [1.04, 1.27],
      "5-mid": "1.45",
      "5-bound": [1.3, 1.6],
      "10-mid": "1.68",
      "10-bound": [1.51, 1.86],
      "25-mid": "2.0",
      "25-bound": [1.79, 2.2],
      "50-mid": "2.24",
      "50-bound": [2.0, 2.46],
      "100-mid": "2.5",
      "100-bound": [2.22, 2.74]
    },
    "2hr": {
      "2-mid": "1.33",
      "2-bound": [1.2, 1.48],
      "5-mid": "1.67",
      "5-bound": [1.5, 1.86],
      "10-mid": "1.94",
      "10-bound": [1.74, 2.15],
      "25-mid": "2.32",
      "25-bound": [2.07, 2.56],
      "50-mid": "2.61",
      "50-bound": [2.33, 2.88],
      "100-mid": "2.92",
      "100-bound": [2.59, 3.22]
    },
    "3hr": {
      "2-mid": "1.44",
      "2-bound": [1.3, 1.61],
      "5-mid": "1.8",
      "5-bound": [1.63, 2.01],
      "10-mid": "2.1",
      "10-bound": [1.89, 2.34],
      "25-mid": "2.51",
      "25-bound": [2.24, 2.78],
      "50-mid": "2.84",
      "50-bound": [2.52, 3.14],
      "100-mid": "3.18",
      "100-bound": [2.82, 3.51]
    },
    "6hr": {
      "2-mid": "1.74",
      "2-bound": [1.58, 1.93],
      "5-mid": "2.16",
      "5-bound": [1.96, 2.4],
      "10-mid": "2.51",
      "10-bound": [2.27, 2.77],
      "25-mid": "3.0",
      "25-bound": [2.71, 3.31],
      "50-mid": "3.4",
      "50-bound": [3.05, 3.73],
      "100-mid": "3.82",
      "100-bound": [3.41, 4.19]
    },
    "12hr": {
      "2-mid": "2.1",
      "2-bound": [1.93, 2.31],
      "5-mid": "2.6",
      "5-bound": [2.38, 2.85],
      "10-mid": "3.0",
      "10-bound": [2.74, 3.28],
      "25-mid": "3.59",
      "25-bound": [3.26, 3.91],
      "50-mid": "4.07",
      "50-bound": [3.68, 4.42],
      "100-mid": "4.58",
      "100-bound": [4.12, 4.96]
    },
    "24hr": {
      "2-mid": "2.48",
      "2-bound": [2.31, 2.67],
      "5-mid": "3.02",
      "5-bound": [2.81, 3.26],
      "10-mid": "3.47",
      "10-bound": [3.23, 3.73],
      "25-mid": "4.11",
      "25-bound": [3.81, 4.4],
      "50-mid": "4.63",
      "50-bound": [4.28, 4.95],
      "100-mid": "5.18",
      "100-bound": [4.76, 5.52]
    },
    "2day": {
      "2-mid": "2.89",
      "2-bound": [2.69, 3.11],
      "5-mid": "3.5",
      "5-bound": [3.26, 3.76],
      "10-mid": "4.0",
      "10-bound": [3.72, 4.29],
      "25-mid": "4.68",
      "25-bound": [4.34, 5.01],
      "50-mid": "5.24",
      "50-bound": [4.85, 5.6],
      "100-mid": "5.81",
      "100-bound": [5.36, 6.21]
    },
    "3day": {
      "2-mid": "3.1",
      "2-bound": [2.9, 3.32],
      "5-mid": "3.73",
      "5-bound": [3.49, 4.0],
      "10-mid": "4.24",
      "10-bound": [3.96, 4.54],
      "25-mid": "4.95",
      "25-bound": [4.6, 5.28],
      "50-mid": "5.52",
      "50-bound": [5.12, 5.88],
      "100-mid": "6.1",
      "100-bound": [5.64, 6.5]
    },
    "4day": {
      "2-mid": "3.32",
      "2-bound": [3.12, 3.54],
      "5-mid": "3.96",
      "5-bound": [3.72, 4.23],
      "10-mid": "4.49",
      "10-bound": [4.21, 4.79],
      "25-mid": "5.21",
      "25-bound": [4.87, 5.55],
      "50-mid": "5.8",
      "50-bound": [5.4, 6.16],
      "100-mid": "6.39",
      "100-bound": [5.94, 6.79]
    },
    "7day": {
      "2-mid": "3.99",
      "2-bound": [3.75, 4.27],
      "5-mid": "4.71",
      "5-bound": [4.42, 5.04],
      "10-mid": "5.29",
      "10-bound": [4.95, 5.64],
      "25-mid": "6.07",
      "25-bound": [5.67, 6.47],
      "50-mid": "6.68",
      "50-bound": [6.23, 7.11],
      "100-mid": "7.29",
      "100-bound": [6.79, 7.76]
    }
  },
  "USC00368668 6": {
    "fips": "42097",
    "station_name": "SUNBURY",
    "state": "PA",
    "latitude": "40.8530",
    "longitude": "-76.7890",
    "5min": {
      "2-mid": "0.4",
      "2-bound": [0.36, 0.45],
      "5-mid": "0.47",
      "5-bound": [0.42, 0.52],
      "10-mid": "0.52",
      "10-bound": [0.47, 0.57],
      "25-mid": "0.58",
      "25-bound": [0.52, 0.64],
      "50-mid": "0.62",
      "50-bound": [0.56, 0.69],
      "100-mid": "0.67",
      "100-bound": [0.6, 0.74]
    },
    "10min": {
      "2-mid": "0.63",
      "2-bound": [0.57, 0.69],
      "5-mid": "0.73",
      "5-bound": [0.66, 0.81],
      "10-mid": "0.8",
      "10-bound": [0.72, 0.88],
      "25-mid": "0.88",
      "25-bound": [0.8, 0.98],
      "50-mid": "0.94",
      "50-bound": [0.85, 1.04],
      "100-mid": "1.01",
      "100-bound": [0.9, 1.11]
    },
    "15min": {
      "2-mid": "0.77",
      "2-bound": [0.7, 0.85],
      "5-mid": "0.9",
      "5-bound": [0.81, 0.99],
      "10-mid": "0.98",
      "10-bound": [0.89, 1.09],
      "25-mid": "1.09",
      "25-bound": [0.99, 1.21],
      "50-mid": "1.17",
      "50-bound": [1.05, 1.29],
      "100-mid": "1.25",
      "100-bound": [1.12, 1.38]
    },
    "30min": {
      "2-mid": "1.03",
      "2-bound": [0.93, 1.14],
      "5-mid": "1.23",
      "5-bound": [1.11, 1.36],
      "10-mid": "1.37",
      "10-bound": [1.24, 1.51],
      "25-mid": "1.55",
      "25-bound": [1.4, 1.71],
      "50-mid": "1.68",
      "50-bound": [1.51, 1.85],
      "100-mid": "1.81",
      "100-bound": [1.62, 2.0]
    },
    "60min": {
      "2-mid": "1.27",
      "2-bound": [1.15, 1.4],
      "5-mid": "1.54",
      "5-bound": [1.4, 1.71],
      "10-mid": "1.74",
      "10-bound": [1.58, 1.93],
      "25-mid": "2.0",
      "25-bound": [1.81, 2.21],
      "50-mid": "2.21",
      "50-bound": [1.98, 2.44],
      "100-mid": "2.42",
      "100-bound": [2.17, 2.68]
    },
    "2hr": {
      "2-mid": "1.46",
      "2-bound": [1.32, 1.62],
      "5-mid": "1.8",
      "5-bound": [1.62, 1.99],
      "10-mid": "2.07",
      "10-bound": [1.86, 2.3],
      "25-mid": "2.48",
      "25-bound": [2.21, 2.74],
      "50-mid": "2.82",
      "50-bound": [2.5, 3.12],
      "100-mid": "3.21",
      "100-bound": [2.83, 3.56]
    },
    "3hr": {
      "2-mid": "1.57",
      "2-bound": [1.42, 1.76],
      "5-mid": "1.94",
      "5-bound": [1.75, 2.17],
      "10-mid": "2.25",
      "10-bound": [2.02, 2.52],
      "25-mid": "2.72",
      "25-bound": [2.42, 3.03],
      "50-mid": "3.12",
      "50-bound": [2.76, 3.48],
      "100-mid": "3.58",
      "100-bound": [3.15, 4.01]
    },
    "6hr": {
      "2-mid": "1.95",
      "2-bound": [1.76, 2.19],
      "5-mid": "2.4",
      "5-bound": [2.16, 2.7],
      "10-mid": "2.79",
      "10-bound": [2.5, 3.13],
      "25-mid": "3.36",
      "25-bound": [2.99, 3.76],
      "50-mid": "3.86",
      "50-bound": [3.41, 4.33],
      "100-mid": "4.44",
      "100-bound": [3.9, 4.97]
    },
    "12hr": {
      "2-mid": "2.39",
      "2-bound": [2.16, 2.68],
      "5-mid": "2.96",
      "5-bound": [2.66, 3.3],
      "10-mid": "3.44",
      "10-bound": [3.08, 3.83],
      "25-mid": "4.17",
      "25-bound": [3.71, 4.64],
      "50-mid": "4.83",
      "50-bound": [4.26, 5.36],
      "100-mid": "5.58",
      "100-bound": [4.89, 6.21]
    },
    "24hr": {
      "2-mid": "2.82",
      "2-bound": [2.58, 3.12],
      "5-mid": "3.49",
      "5-bound": [3.2, 3.85],
      "10-mid": "4.09",
      "10-bound": [3.73, 4.5],
      "25-mid": "5.04",
      "25-bound": [4.56, 5.51],
      "50-mid": "5.92",
      "50-bound": [5.32, 6.45],
      "100-mid": "6.96",
      "100-bound": [6.19, 7.55]
    },
    "2day": {
      "2-mid": "3.28",
      "2-bound": [2.99, 3.65],
      "5-mid": "4.06",
      "5-bound": [3.69, 4.5],
      "10-mid": "4.75",
      "10-bound": [4.3, 5.25],
      "25-mid": "5.85",
      "25-bound": [5.26, 6.44],
      "50-mid": "6.87",
      "50-bound": [6.13, 7.53],
      "100-mid": "8.08",
      "100-bound": [7.15, 8.83]
    },
    "3day": {
      "2-mid": "3.49",
      "2-bound": [3.18, 3.89],
      "5-mid": "4.3",
      "5-bound": [3.91, 4.78],
      "10-mid": "5.02",
      "10-bound": [4.54, 5.56],
      "25-mid": "6.15",
      "25-bound": [5.53, 6.78],
      "50-mid": "7.21",
      "50-bound": [6.44, 7.92],
      "100-mid": "8.45",
      "100-bound": [7.49, 9.26]
    },
    "4day": {
      "2-mid": "3.71",
      "2-bound": [3.38, 4.13],
      "5-mid": "4.54",
      "5-bound": [4.13, 5.06],
      "10-mid": "5.28",
      "10-bound": [4.79, 5.87],
      "25-mid": "6.46",
      "25-bound": [5.81, 7.13],
      "50-mid": "7.55",
      "50-bound": [6.74, 8.31],
      "100-mid": "8.83",
      "100-bound": [7.83, 9.69]
    },
    "7day": {
      "2-mid": "4.34",
      "2-bound": [3.99, 4.77],
      "5-mid": "5.28",
      "5-bound": [4.84, 5.79],
      "10-mid": "6.11",
      "10-bound": [5.58, 6.68],
      "25-mid": "7.41",
      "25-bound": [6.73, 8.08],
      "50-mid": "8.6",
      "50-bound": [7.76, 9.36],
      "100-mid": "9.99",
      "100-bound": [8.95, 10.8]
    }
  },
  "USW00013773 6": {
    "fips": "51179",
    "station_name": "QUANTICO MCAS",
    "state": "VA",
    "latitude": "38.5036",
    "longitude": "-77.3050",
    "5min": {
      "2-mid": "0.43",
      "2-bound": [0.39, 0.47],
      "5-mid": "0.51",
      "5-bound": [0.46, 0.56],
      "10-mid": "0.57",
      "10-bound": [0.51, 0.63],
      "25-mid": "0.64",
      "25-bound": [0.58, 0.71],
      "50-mid": "0.7",
      "50-bound": [0.62, 0.77],
      "100-mid": "0.76",
      "100-bound": [0.67, 0.83]
    },
    "10min": {
      "2-mid": "0.68",
      "2-bound": [0.62, 0.76],
      "5-mid": "0.81",
      "5-bound": [0.74, 0.9],
      "10-mid": "0.91",
      "10-bound": [0.82, 1.0],
      "25-mid": "1.02",
      "25-bound": [0.92, 1.13],
      "50-mid": "1.11",
      "50-bound": [0.99, 1.23],
      "100-mid": "1.2",
      "100-bound": [1.06, 1.32]
    },
    "15min": {
      "2-mid": "0.86",
      "2-bound": [0.78, 0.95],
      "5-mid": "1.03",
      "5-bound": [0.93, 1.14],
      "10-mid": "1.15",
      "10-bound": [1.04, 1.27],
      "25-mid": "1.3",
      "25-bound": [1.16, 1.43],
      "50-mid": "1.41",
      "50-bound": [1.26, 1.55],
      "100-mid": "1.52",
      "100-bound": [1.34, 1.67]
    },
    "30min": {
      "2-mid": "1.19",
      "2-bound": [1.08, 1.31],
      "5-mid": "1.46",
      "5-bound": [1.32, 1.62],
      "10-mid": "1.66",
      "10-bound": [1.5, 1.84],
      "25-mid": "1.92",
      "25-bound": [1.72, 2.12],
      "50-mid": "2.12",
      "50-bound": [1.89, 2.34],
      "100-mid": "2.32",
      "100-bound": [2.06, 2.56]
    },
    "60min": {
      "2-mid": "1.49",
      "2-bound": [1.35, 1.64],
      "5-mid": "1.88",
      "5-bound": [1.7, 2.07],
      "10-mid": "2.17",
      "10-bound": [1.96, 2.39],
      "25-mid": "2.56",
      "25-bound": [2.3, 2.82],
      "50-mid": "2.88",
      "50-bound": [2.56, 3.17],
      "100-mid": "3.2",
      "100-bound": [2.84, 3.53]
    },
    "2hr": {
      "2-mid": "1.73",
      "2-bound": [1.56, 1.92],
      "5-mid": "2.2",
      "5-bound": [1.98, 2.43],
      "10-mid": "2.56",
      "10-bound": [2.3, 2.83],
      "25-mid": "3.07",
      "25-bound": [2.74, 3.39],
      "50-mid": "3.48",
      "50-bound": [3.1, 3.85],
      "100-mid": "3.92",
      "100-bound": [3.46, 4.34]
    },
    "3hr": {
      "2-mid": "1.87",
      "2-bound": [1.68, 2.09],
      "5-mid": "2.37",
      "5-bound": [2.12, 2.64],
      "10-mid": "2.77",
      "10-bound": [2.47, 3.08],
      "25-mid": "3.33",
      "25-bound": [2.95, 3.71],
      "50-mid": "3.8",
      "50-bound": [3.35, 4.23],
      "100-mid": "4.29",
      "100-bound": [3.75, 4.78]
    },
    "6hr": {
      "2-mid": "2.28",
      "2-bound": [2.06, 2.56],
      "5-mid": "2.89",
      "5-bound": [2.59, 3.24],
      "10-mid": "3.38",
      "10-bound": [3.02, 3.79],
      "25-mid": "4.11",
      "25-bound": [3.64, 4.59],
      "50-mid": "4.72",
      "50-bound": [4.14, 5.28],
      "100-mid": "5.38",
      "100-bound": [4.68, 6.02]
    },
    "12hr": {
      "2-mid": "2.76",
      "2-bound": [2.47, 3.11],
      "5-mid": "3.5",
      "5-bound": [3.13, 3.95],
      "10-mid": "4.14",
      "10-bound": [3.67, 4.65],
      "25-mid": "5.09",
      "25-bound": [4.48, 5.72],
      "50-mid": "5.92",
      "50-bound": [5.16, 6.65],
      "100-mid": "6.85",
      "100-bound": [5.89, 7.69]
    },
    "24hr": {
      "2-mid": "3.12",
      "2-bound": [2.83, 3.49],
      "5-mid": "4.03",
      "5-bound": [3.66, 4.51],
      "10-mid": "4.83",
      "10-bound": [4.37, 5.39],
      "25-mid": "6.06",
      "25-bound": [5.43, 6.72],
      "50-mid": "7.13",
      "50-bound": [6.35, 7.89],
      "100-mid": "8.34",
      "100-bound": [7.37, 9.19]
    },
    "2day": {
      "2-mid": "3.62",
      "2-bound": [3.29, 4.03],
      "5-mid": "4.68",
      "5-bound": [4.24, 5.2],
      "10-mid": "5.59",
      "10-bound": [5.04, 6.2],
      "25-mid": "6.97",
      "25-bound": [6.25, 7.69],
      "50-mid": "8.16",
      "50-bound": [7.28, 8.99],
      "100-mid": "9.5",
      "100-bound": [8.4, 10.4]
    },
    "3day": {
      "2-mid": "3.84",
      "2-bound": [3.49, 4.27],
      "5-mid": "4.95",
      "5-bound": [4.49, 5.49],
      "10-mid": "5.9",
      "10-bound": [5.33, 6.53],
      "25-mid": "7.32",
      "25-bound": [6.57, 8.08],
      "50-mid": "8.56",
      "50-bound": [7.64, 9.42],
      "100-mid": "9.93",
      "100-bound": [8.8, 10.9]
    },
    "4day": {
      "2-mid": "4.06",
      "2-bound": [3.69, 4.51],
      "5-mid": "5.22",
      "5-bound": [4.74, 5.78],
      "10-mid": "6.2",
      "10-bound": [5.61, 6.87],
      "25-mid": "7.68",
      "25-bound": [6.9, 8.47],
      "50-mid": "8.95",
      "50-bound": [8.01, 9.86],
      "100-mid": "10.4",
      "100-bound": [9.2, 11.4]
    },
    "7day": {
      "2-mid": "4.7",
      "2-bound": [4.31, 5.16],
      "5-mid": "5.95",
      "5-bound": [5.45, 6.53],
      "10-mid": "7.01",
      "10-bound": [6.4, 7.68],
      "25-mid": "8.58",
      "25-bound": [7.8, 9.39],
      "50-mid": "9.93",
      "50-bound": [8.98, 10.8],
      "100-mid": "11.4",
      "100-bound": [10.3, 12.4]
    }
  },
  "USC00303050 6": {
    "fips": "36109",
    "station_name": "FREEVILLE 1 NE",
    "state": "NY",
    "latitude": "42.5190",
    "longitude": "-76.3300",
    "5min": {
      "2-mid": "0.37",
      "2-bound": [0.28, 0.47],
      "5-mid": "0.47",
      "5-bound": [0.37, 0.6],
      "10-mid": "0.56",
      "10-bound": [0.43, 0.72],
      "25-mid": "0.68",
      "25-bound": [0.51, 0.91],
      "50-mid": "0.77",
      "50-bound": [0.56, 1.05],
      "100-mid": "0.87",
      "100-bound": [0.62, 1.23]
    },
    "10min": {
      "2-mid": "0.52",
      "2-bound": [0.4, 0.66],
      "5-mid": "0.67",
      "5-bound": [0.52, 0.85],
      "10-mid": "0.79",
      "10-bound": [0.61, 1.02],
      "25-mid": "0.96",
      "25-bound": [0.72, 1.29],
      "50-mid": "1.09",
      "50-bound": [0.8, 1.49],
      "100-mid": "1.23",
      "100-bound": [0.88, 1.74]
    },
    "15min": {
      "2-mid": "0.61",
      "2-bound": [0.47, 0.78],
      "5-mid": "0.79",
      "5-bound": [0.61, 1.01],
      "10-mid": "0.93",
      "10-bound": [0.72, 1.2],
      "25-mid": "1.14",
      "25-bound": [0.85, 1.52],
      "50-mid": "1.29",
      "50-bound": [0.94, 1.76],
      "100-mid": "1.45",
      "100-bound": [1.03, 2.05]
    },
    "30min": {
      "2-mid": "0.82",
      "2-bound": [0.64, 1.05],
      "5-mid": "1.05",
      "5-bound": [0.82, 1.35],
      "10-mid": "1.25",
      "10-bound": [0.96, 1.6],
      "25-mid": "1.51",
      "25-bound": [1.13, 2.02],
      "50-mid": "1.71",
      "50-bound": [1.25, 2.33],
      "100-mid": "1.92",
      "100-bound": [1.36, 2.71]
    },
    "60min": {
      "2-mid": "1.04",
      "2-bound": [0.81, 1.32],
      "5-mid": "1.32",
      "5-bound": [1.02, 1.69],
      "10-mid": "1.56",
      "10-bound": [1.2, 2.0],
      "25-mid": "1.88",
      "25-bound": [1.41, 2.52],
      "50-mid": "2.13",
      "50-bound": [1.56, 2.91],
      "100-mid": "2.39",
      "100-bound": [1.7, 3.38]
    },
    "2hr": {
      "2-mid": "1.27",
      "2-bound": [0.99, 1.61],
      "5-mid": "1.6",
      "5-bound": [1.24, 2.02],
      "10-mid": "1.86",
      "10-bound": [1.44, 2.38],
      "25-mid": "2.23",
      "25-bound": [1.68, 2.97],
      "50-mid": "2.51",
      "50-bound": [1.85, 3.41],
      "100-mid": "2.8",
      "100-bound": [2.0, 3.94]
    },
    "3hr": {
      "2-mid": "1.43",
      "2-bound": [1.12, 1.8],
      "5-mid": "1.78",
      "5-bound": [1.4, 2.25],
      "10-mid": "2.08",
      "10-bound": [1.62, 2.64],
      "25-mid": "2.48",
      "25-bound": [1.87, 3.29],
      "50-mid": "2.79",
      "50-bound": [2.06, 3.77],
      "100-mid": "3.11",
      "100-bound": [2.23, 4.36]
    },
    "6hr": {
      "2-mid": "1.73",
      "2-bound": [1.37, 2.17],
      "5-mid": "2.18",
      "5-bound": [1.72, 2.74],
      "10-mid": "2.55",
      "10-bound": [2.0, 3.22],
      "25-mid": "3.07",
      "25-bound": [2.32, 4.03],
      "50-mid": "3.45",
      "50-bound": [2.56, 4.63],
      "100-mid": "3.86",
      "100-bound": [2.78, 5.37]
    },
    "12hr": {
      "2-mid": "2.09",
      "2-bound": [1.67, 2.6],
      "5-mid": "2.69",
      "5-bound": [2.13, 3.35],
      "10-mid": "3.18",
      "10-bound": [2.51, 3.99],
      "25-mid": "3.86",
      "25-bound": [2.94, 5.05],
      "50-mid": "4.37",
      "50-bound": [3.26, 5.83],
      "100-mid": "4.91",
      "100-bound": [3.55, 6.79]
    },
    "24hr": {
      "2-mid": "2.48",
      "2-bound": [1.98, 3.06],
      "5-mid": "3.21",
      "5-bound": [2.56, 3.97],
      "10-mid": "3.82",
      "10-bound": [3.03, 4.75],
      "25-mid": "4.66",
      "25-bound": [3.57, 6.05],
      "50-mid": "5.28",
      "50-bound": [3.96, 7.01],
      "100-mid": "5.95",
      "100-bound": [4.33, 8.19]
    },
    "2day": {
      "2-mid": "2.86",
      "2-bound": [2.31, 3.51],
      "5-mid": "3.68",
      "5-bound": [2.96, 4.53],
      "10-mid": "4.36",
      "10-bound": [3.48, 5.39],
      "25-mid": "5.3",
      "25-bound": [4.09, 6.85],
      "50-mid": "5.99",
      "50-bound": [4.53, 7.91],
      "100-mid": "6.74",
      "100-bound": [4.95, 9.24]
    },
    "3day": {
      "2-mid": "3.13",
      "2-bound": [2.53, 3.82],
      "5-mid": "4.0",
      "5-bound": [3.22, 4.9],
      "10-mid": "4.72",
      "10-bound": [3.78, 5.81],
      "25-mid": "5.71",
      "25-bound": [4.42, 7.35],
      "50-mid": "6.45",
      "50-bound": [4.89, 8.48],
      "100-mid": "7.24",
      "100-bound": [5.33, 9.89]
    },
    "4day": {
      "2-mid": "3.36",
      "2-bound": [2.72, 4.09],
      "5-mid": "4.26",
      "5-bound": [3.44, 5.2],
      "10-mid": "5.01",
      "10-bound": [4.02, 6.15],
      "25-mid": "6.04",
      "25-bound": [4.69, 7.75],
      "50-mid": "6.8",
      "50-bound": [5.17, 8.92],
      "100-mid": "7.62",
      "100-bound": [5.62, 10.4]
    },
    "7day": {
      "2-mid": "3.96",
      "2-bound": [3.24, 4.8],
      "5-mid": "4.92",
      "5-bound": [4.0, 5.98],
      "10-mid": "5.72",
      "10-bound": [4.62, 6.98],
      "25-mid": "6.81",
      "25-bound": [5.31, 8.67],
      "50-mid": "7.63",
      "50-bound": [5.82, 9.92],
      "100-mid": "8.5",
      "100-bound": [6.27, 11.5]
    }
  },
  "USC00367409 6": {
    "fips": "42035",
    "station_name": "RENOVO",
    "state": "PA",
    "latitude": "41.3290",
    "longitude": "-77.7380",
    "5min": {
      "2-mid": "0.35",
      "2-bound": [0.32, 0.39],
      "5-mid": "0.42",
      "5-bound": [0.38, 0.47],
      "10-mid": "0.48",
      "10-bound": [0.43, 0.53],
      "25-mid": "0.55",
      "25-bound": [0.5, 0.61],
      "50-mid": "0.61",
      "50-bound": [0.54, 0.67],
      "100-mid": "0.67",
      "100-bound": [0.59, 0.73]
    },
    "10min": {
      "2-mid": "0.55",
      "2-bound": [0.5, 0.61],
      "5-mid": "0.66",
      "5-bound": [0.59, 0.73],
      "10-mid": "0.74",
      "10-bound": [0.67, 0.82],
      "25-mid": "0.85",
      "25-bound": [0.76, 0.93],
      "50-mid": "0.92",
      "50-bound": [0.82, 1.02],
      "100-mid": "1.0",
      "100-bound": [0.89, 1.1]
    },
    "15min": {
      "2-mid": "0.67",
      "2-bound": [0.61, 0.74],
      "5-mid": "0.81",
      "5-bound": [0.73, 0.9],
      "10-mid": "0.91",
      "10-bound": [0.82, 1.01],
      "25-mid": "1.05",
      "25-bound": [0.94, 1.15],
      "50-mid": "1.14",
      "50-bound": [1.02, 1.26],
      "100-mid": "1.24",
      "100-bound": [1.1, 1.37]
    },
    "30min": {
      "2-mid": "0.9",
      "2-bound": [0.81, 1.0],
      "5-mid": "1.11",
      "5-bound": [1.0, 1.23],
      "10-mid": "1.26",
      "10-bound": [1.14, 1.4],
      "25-mid": "1.48",
      "25-bound": [1.32, 1.63],
      "50-mid": "1.63",
      "50-bound": [1.46, 1.8],
      "100-mid": "1.8",
      "100-bound": [1.59, 1.98]
    },
    "60min": {
      "2-mid": "1.1",
      "2-bound": [1.0, 1.22],
      "5-mid": "1.39",
      "5-bound": [1.26, 1.54],
      "10-mid": "1.61",
      "10-bound": [1.45, 1.78],
      "25-mid": "1.92",
      "25-bound": [1.72, 2.11],
      "50-mid": "2.15",
      "50-bound": [1.92, 2.37],
      "100-mid": "2.4",
      "100-bound": [2.13, 2.64]
    },
    "2hr": {
      "2-mid": "1.27",
      "2-bound": [1.14, 1.41],
      "5-mid": "1.6",
      "5-bound": [1.44, 1.77],
      "10-mid": "1.86",
      "10-bound": [1.67, 2.06],
      "25-mid": "2.23",
      "25-bound": [1.99, 2.46],
      "50-mid": "2.54",
      "50-bound": [2.26, 2.8],
      "100-mid": "2.88",
      "100-bound": [2.54, 3.16]
    },
    "3hr": {
      "2-mid": "1.38",
      "2-bound": [1.24, 1.53],
      "5-mid": "1.72",
      "5-bound": [1.56, 1.91],
      "10-mid": "2.0",
      "10-bound": [1.8, 2.21],
      "25-mid": "2.41",
      "25-bound": [2.16, 2.65],
      "50-mid": "2.74",
      "50-bound": [2.44, 3.01],
      "100-mid": "3.11",
      "100-bound": [2.75, 3.4]
    },
    "6hr": {
      "2-mid": "1.72",
      "2-bound": [1.57, 1.89],
      "5-mid": "2.12",
      "5-bound": [1.94, 2.34],
      "10-mid": "2.46",
      "10-bound": [2.24, 2.7],
      "25-mid": "2.94",
      "25-bound": [2.66, 3.22],
      "50-mid": "3.35",
      "50-bound": [3.01, 3.65],
      "100-mid": "3.79",
      "100-bound": [3.38, 4.12]
    },
    "12hr": {
      "2-mid": "2.15",
      "2-bound": [1.97, 2.38],
      "5-mid": "2.66",
      "5-bound": [2.42, 2.93],
      "10-mid": "3.08",
      "10-bound": [2.8, 3.37],
      "25-mid": "3.69",
      "25-bound": [3.34, 4.03],
      "50-mid": "4.21",
      "50-bound": [3.78, 4.6],
      "100-mid": "4.79",
      "100-bound": [4.25, 5.22]
    },
    "24hr": {
      "2-mid": "2.61",
      "2-bound": [2.42, 2.83],
      "5-mid": "3.19",
      "5-bound": [2.96, 3.47],
      "10-mid": "3.67",
      "10-bound": [3.4, 3.98],
      "25-mid": "4.34",
      "25-bound": [4.0, 4.69],
      "50-mid": "4.89",
      "50-bound": [4.48, 5.28],
      "100-mid": "5.46",
      "100-bound": [4.98, 5.88]
    },
    "2day": {
      "2-mid": "3.0",
      "2-bound": [2.79, 3.25],
      "5-mid": "3.68",
      "5-bound": [3.41, 3.98],
      "10-mid": "4.23",
      "10-bound": [3.91, 4.56],
      "25-mid": "5.0",
      "25-bound": [4.6, 5.39],
      "50-mid": "5.64",
      "50-bound": [5.17, 6.07],
      "100-mid": "6.3",
      "100-bound": [5.75, 6.78]
    },
    "3day": {
      "2-mid": "3.2",
      "2-bound": [2.98, 3.44],
      "5-mid": "3.89",
      "5-bound": [3.62, 4.19],
      "10-mid": "4.46",
      "10-bound": [4.14, 4.79],
      "25-mid": "5.24",
      "25-bound": [4.86, 5.63],
      "50-mid": "5.89",
      "50-bound": [5.43, 6.31],
      "100-mid": "6.56",
      "100-bound": [6.02, 7.03]
    },
    "4day": {
      "2-mid": "3.39",
      "2-bound": [3.18, 3.64],
      "5-mid": "4.1",
      "5-bound": [3.84, 4.4],
      "10-mid": "4.68",
      "10-bound": [4.38, 5.01],
      "25-mid": "5.49",
      "25-bound": [5.11, 5.86],
      "50-mid": "6.14",
      "50-bound": [5.69, 6.55],
      "100-mid": "6.81",
      "100-bound": [6.3, 7.27]
    },
    "7day": {
      "2-mid": "4.0",
      "2-bound": [3.77, 4.26],
      "5-mid": "4.75",
      "5-bound": [4.47, 5.04],
      "10-mid": "5.33",
      "10-bound": [5.01, 5.66],
      "25-mid": "6.13",
      "25-bound": [5.74, 6.5],
      "50-mid": "6.76",
      "50-bound": [6.31, 7.16],
      "100-mid": "7.38",
      "100-bound": [6.88, 7.82]
    }
  },
  "USC00464971 6": {
    "fips": "54083",
    "station_name": "KUMBRABOW",
    "state": "WV",
    "latitude": "38.6312",
    "longitude": "-80.0854",
    "5min": {
      "2-mid": "0.36",
      "2-bound": [0.33, 0.4],
      "5-mid": "0.44",
      "5-bound": [0.4, 0.48],
      "10-mid": "0.49",
      "10-bound": [0.45, 0.54],
      "25-mid": "0.56",
      "25-bound": [0.5, 0.61],
      "50-mid": "0.6",
      "50-bound": [0.54, 0.66],
      "100-mid": "0.65",
      "100-bound": [0.58, 0.71]
    },
    "10min": {
      "2-mid": "0.58",
      "2-bound": [0.53, 0.64],
      "5-mid": "0.69",
      "5-bound": [0.64, 0.76],
      "10-mid": "0.78",
      "10-bound": [0.71, 0.85],
      "25-mid": "0.88",
      "25-bound": [0.8, 0.96],
      "50-mid": "0.95",
      "50-bound": [0.85, 1.04],
      "100-mid": "1.02",
      "100-bound": [0.91, 1.12]
    },
    "15min": {
      "2-mid": "0.72",
      "2-bound": [0.66, 0.8],
      "5-mid": "0.87",
      "5-bound": [0.8, 0.96],
      "10-mid": "0.98",
      "10-bound": [0.89, 1.07],
      "25-mid": "1.11",
      "25-bound": [1.0, 1.21],
      "50-mid": "1.2",
      "50-bound": [1.08, 1.31],
      "100-mid": "1.29",
      "100-bound": [1.15, 1.41]
    },
    "30min": {
      "2-mid": "0.99",
      "2-bound": [0.91, 1.09],
      "5-mid": "1.23",
      "5-bound": [1.13, 1.35],
      "10-mid": "1.4",
      "10-bound": [1.28, 1.54],
      "25-mid": "1.63",
      "25-bound": [1.47, 1.78],
      "50-mid": "1.79",
      "50-bound": [1.61, 1.95],
      "100-mid": "1.95",
      "100-bound": [1.74, 2.14]
    },
    "60min": {
      "2-mid": "1.24",
      "2-bound": [1.13, 1.36],
      "5-mid": "1.57",
      "5-bound": [1.44, 1.72],
      "10-mid": "1.82",
      "10-bound": [1.66, 1.99],
      "25-mid": "2.15",
      "25-bound": [1.95, 2.35],
      "50-mid": "2.41",
      "50-bound": [2.16, 2.63],
      "100-mid": "2.68",
      "100-bound": [2.38, 2.93]
    },
    "2hr": {
      "2-mid": "1.51",
      "2-bound": [1.39, 1.65],
      "5-mid": "1.9",
      "5-bound": [1.74, 2.08],
      "10-mid": "2.21",
      "10-bound": [2.02, 2.41],
      "25-mid": "2.64",
      "25-bound": [2.39, 2.88],
      "50-mid": "2.98",
      "50-bound": [2.69, 3.26],
      "100-mid": "3.35",
      "100-bound": [3.0, 3.66]
    },
    "3hr": {
      "2-mid": "1.64",
      "2-bound": [1.51, 1.8],
      "5-mid": "2.06",
      "5-bound": [1.89, 2.26],
      "10-mid": "2.4",
      "10-bound": [2.18, 2.62],
      "25-mid": "2.87",
      "25-bound": [2.6, 3.13],
      "50-mid": "3.25",
      "50-bound": [2.93, 3.56],
      "100-mid": "3.66",
      "100-bound": [3.27, 4.01]
    },
    "6hr": {
      "2-mid": "2.01",
      "2-bound": [1.85, 2.2],
      "5-mid": "2.5",
      "5-bound": [2.29, 2.73],
      "10-mid": "2.9",
      "10-bound": [2.64, 3.16],
      "25-mid": "3.48",
      "25-bound": [3.15, 3.8],
      "50-mid": "3.96",
      "50-bound": [3.56, 4.32],
      "100-mid": "4.48",
      "100-bound": [3.99, 4.9]
    },
    "12hr": {
      "2-mid": "2.45",
      "2-bound": [2.25, 2.69],
      "5-mid": "3.03",
      "5-bound": [2.77, 3.32],
      "10-mid": "3.52",
      "10-bound": [3.2, 3.86],
      "25-mid": "4.25",
      "25-bound": [3.82, 4.66],
      "50-mid": "4.87",
      "50-bound": [4.33, 5.35],
      "100-mid": "5.55",
      "100-bound": [4.88, 6.11]
    },
    "24hr": {
      "2-mid": "2.73",
      "2-bound": [2.53, 2.96],
      "5-mid": "3.32",
      "5-bound": [3.07, 3.61],
      "10-mid": "3.8",
      "10-bound": [3.51, 4.13],
      "25-mid": "4.49",
      "25-bound": [4.12, 4.89],
      "50-mid": "5.07",
      "50-bound": [4.62, 5.52],
      "100-mid": "5.67",
      "100-bound": [5.13, 6.19]
    },
    "2day": {
      "2-mid": "3.25",
      "2-bound": [3.03, 3.49],
      "5-mid": "3.91",
      "5-bound": [3.64, 4.19],
      "10-mid": "4.44",
      "10-bound": [4.13, 4.77],
      "25-mid": "5.19",
      "25-bound": [4.8, 5.58],
      "50-mid": "5.8",
      "50-bound": [5.33, 6.25],
      "100-mid": "6.42",
      "100-bound": [5.87, 6.95]
    },
    "3day": {
      "2-mid": "3.59",
      "2-bound": [3.36, 3.85],
      "5-mid": "4.29",
      "5-bound": [4.0, 4.6],
      "10-mid": "4.85",
      "10-bound": [4.52, 5.2],
      "25-mid": "5.62",
      "25-bound": [5.2, 6.04],
      "50-mid": "6.23",
      "50-bound": [5.74, 6.72],
      "100-mid": "6.87",
      "100-bound": [6.29, 7.42]
    },
    "4day": {
      "2-mid": "3.93",
      "2-bound": [3.68, 4.21],
      "5-mid": "4.67",
      "5-bound": [4.37, 5.0],
      "10-mid": "5.26",
      "10-bound": [4.9, 5.64],
      "25-mid": "6.05",
      "25-bound": [5.61, 6.5],
      "50-mid": "6.67",
      "50-bound": [6.16, 7.18],
      "100-mid": "7.31",
      "100-bound": [6.71, 7.89]
    },
    "7day": {
      "2-mid": "4.92",
      "2-bound": [4.63, 5.23],
      "5-mid": "5.78",
      "5-bound": [5.44, 6.15],
      "10-mid": "6.45",
      "10-bound": [6.06, 6.86],
      "25-mid": "7.33",
      "25-bound": [6.86, 7.8],
      "50-mid": "8.01",
      "50-bound": [7.46, 8.55],
      "100-mid": "8.69",
      "100-bound": [8.06, 9.3]
    }
  },
  "USC00445050 6": {
    "fips": "51109",
    "station_name": "LOUISA",
    "state": "VA",
    "latitude": "38.0420",
    "longitude": "-78.0060",
    "5min": {
      "2-mid": "0.42",
      "2-bound": [0.38, 0.46],
      "5-mid": "0.49",
      "5-bound": [0.44, 0.54],
      "10-mid": "0.55",
      "10-bound": [0.5, 0.61],
      "25-mid": "0.62",
      "25-bound": [0.56, 0.69],
      "50-mid": "0.68",
      "50-bound": [0.6, 0.74],
      "100-mid": "0.73",
      "100-bound": [0.65, 0.8]
    },
    "10min": {
      "2-mid": "0.67",
      "2-bound": [0.6, 0.74],
      "5-mid": "0.78",
      "5-bound": [0.7, 0.86],
      "10-mid": "0.88",
      "10-bound": [0.79, 0.98],
      "25-mid": "0.99",
      "25-bound": [0.89, 1.09],
      "50-mid": "1.08",
      "50-bound": [0.96, 1.19],
      "100-mid": "1.16",
      "100-bound": [1.02, 1.27]
    },
    "15min": {
      "2-mid": "0.84",
      "2-bound": [0.76, 0.93],
      "5-mid": "0.99",
      "5-bound": [0.89, 1.1],
      "10-mid": "1.12",
      "10-bound": [1.0, 1.24],
      "25-mid": "1.26",
      "25-bound": [1.12, 1.38],
      "50-mid": "1.36",
      "50-bound": [1.22, 1.5],
      "100-mid": "1.46",
      "100-bound": [1.3, 1.61]
    },
    "30min": {
      "2-mid": "1.16",
      "2-bound": [1.05, 1.28],
      "5-mid": "1.4",
      "5-bound": [1.27, 1.56],
      "10-mid": "1.62",
      "10-bound": [1.46, 1.79],
      "25-mid": "1.86",
      "25-bound": [1.66, 2.05],
      "50-mid": "2.05",
      "50-bound": [1.83, 2.26],
      "100-mid": "2.24",
      "100-bound": [1.98, 2.46]
    },
    "60min": {
      "2-mid": "1.46",
      "2-bound": [1.31, 1.61],
      "5-mid": "1.8",
      "5-bound": [1.62, 1.99],
      "10-mid": "2.11",
      "10-bound": [1.9, 2.33],
      "25-mid": "2.48",
      "25-bound": [2.22, 2.73],
      "50-mid": "2.78",
      "50-bound": [2.48, 3.07],
      "100-mid": "3.08",
      "100-bound": [2.73, 3.39]
    },
    "2hr": {
      "2-mid": "1.72",
      "2-bound": [1.53, 1.93],
      "5-mid": "2.14",
      "5-bound": [1.91, 2.4],
      "10-mid": "2.53",
      "10-bound": [2.25, 2.84],
      "25-mid": "3.02",
      "25-bound": [2.66, 3.37],
      "50-mid": "3.42",
      "50-bound": [3.01, 3.83],
      "100-mid": "3.84",
      "100-bound": [3.35, 4.28]
    },
    "3hr": {
      "2-mid": "1.87",
      "2-bound": [1.65, 2.12],
      "5-mid": "2.33",
      "5-bound": [2.06, 2.64],
      "10-mid": "2.74",
      "10-bound": [2.42, 3.11],
      "25-mid": "3.27",
      "25-bound": [2.86, 3.7],
      "50-mid": "3.72",
      "50-bound": [3.24, 4.2],
      "100-mid": "4.17",
      "100-bound": [3.61, 4.7]
    },
    "6hr": {
      "2-mid": "2.31",
      "2-bound": [2.03, 2.66],
      "5-mid": "2.86",
      "5-bound": [2.51, 3.29],
      "10-mid": "3.38",
      "10-bound": [2.96, 3.88],
      "25-mid": "4.06",
      "25-bound": [3.53, 4.65],
      "50-mid": "4.66",
      "50-bound": [4.02, 5.32],
      "100-mid": "5.28",
      "100-bound": [4.52, 6.02]
    },
    "12hr": {
      "2-mid": "2.84",
      "2-bound": [2.52, 3.26],
      "5-mid": "3.53",
      "5-bound": [3.12, 4.04],
      "10-mid": "4.2",
      "10-bound": [3.69, 4.8],
      "25-mid": "5.11",
      "25-bound": [4.45, 5.82],
      "50-mid": "5.92",
      "50-bound": [5.11, 6.73],
      "100-mid": "6.79",
      "100-bound": [5.79, 7.69]
    },
    "24hr": {
      "2-mid": "3.32",
      "2-bound": [3.01, 3.7],
      "5-mid": "4.24",
      "5-bound": [3.84, 4.73],
      "10-mid": "5.02",
      "10-bound": [4.53, 5.59],
      "25-mid": "6.18",
      "25-bound": [5.54, 6.86],
      "50-mid": "7.18",
      "50-bound": [6.38, 7.95],
      "100-mid": "8.27",
      "100-bound": [7.3, 9.15]
    },
    "2day": {
      "2-mid": "3.88",
      "2-bound": [3.53, 4.3],
      "5-mid": "4.94",
      "5-bound": [4.49, 5.46],
      "10-mid": "5.81",
      "10-bound": [5.26, 6.42],
      "25-mid": "7.08",
      "25-bound": [6.37, 7.8],
      "50-mid": "8.14",
      "50-bound": [7.29, 8.96],
      "100-mid": "9.29",
      "100-bound": [8.26, 10.2]
    },
    "3day": {
      "2-mid": "4.12",
      "2-bound": [3.77, 4.54],
      "5-mid": "5.24",
      "5-bound": [4.78, 5.77],
      "10-mid": "6.17",
      "10-bound": [5.61, 6.78],
      "25-mid": "7.5",
      "25-bound": [6.79, 8.24],
      "50-mid": "8.63",
      "50-bound": [7.76, 9.48],
      "100-mid": "9.84",
      "100-bound": [8.79, 10.8]
    },
    "4day": {
      "2-mid": "4.36",
      "2-bound": [4.0, 4.79],
      "5-mid": "5.54",
      "5-bound": [5.08, 6.08],
      "10-mid": "6.52",
      "10-bound": [5.95, 7.15],
      "25-mid": "7.93",
      "25-bound": [7.21, 8.69],
      "50-mid": "9.12",
      "50-bound": [8.24, 9.99],
      "100-mid": "10.4",
      "100-bound": [9.33, 11.4]
    },
    "7day": {
      "2-mid": "5.01",
      "2-bound": [4.62, 5.48],
      "5-mid": "6.27",
      "5-bound": [5.77, 6.85],
      "10-mid": "7.31",
      "10-bound": [6.71, 7.97],
      "25-mid": "8.8",
      "25-bound": [8.04, 9.58],
      "50-mid": "10.0",
      "50-bound": [9.12, 10.9],
      "100-mid": "11.4",
      "100-bound": [10.2, 12.4]
    }
  },
  "USC00444128 6": {
    "fips": "51017",
    "station_name": "HOT SPRINGS",
    "state": "VA",
    "latitude": "37.9995",
    "longitude": "-79.8322",
    "5min": {
      "2-mid": "0.34",
      "2-bound": [0.31, 0.39],
      "5-mid": "0.42",
      "5-bound": [0.38, 0.47],
      "10-mid": "0.47",
      "10-bound": [0.42, 0.53],
      "25-mid": "0.54",
      "25-bound": [0.48, 0.6],
      "50-mid": "0.59",
      "50-bound": [0.52, 0.65],
      "100-mid": "0.63",
      "100-bound": [0.55, 0.71]
    },
    "10min": {
      "2-mid": "0.55",
      "2-bound": [0.49, 0.62],
      "5-mid": "0.67",
      "5-bound": [0.6, 0.75],
      "10-mid": "0.76",
      "10-bound": [0.68, 0.84],
      "25-mid": "0.86",
      "25-bound": [0.76, 0.95],
      "50-mid": "0.93",
      "50-bound": [0.82, 1.04],
      "100-mid": "1.0",
      "100-bound": [0.88, 1.12]
    },
    "15min": {
      "2-mid": "0.69",
      "2-bound": [0.62, 0.77],
      "5-mid": "0.85",
      "5-bound": [0.77, 0.95],
      "10-mid": "0.96",
      "10-bound": [0.85, 1.06],
      "25-mid": "1.09",
      "25-bound": [0.97, 1.21],
      "50-mid": "1.18",
      "50-bound": [1.04, 1.32],
      "100-mid": "1.27",
      "100-bound": [1.11, 1.42]
    },
    "30min": {
      "2-mid": "0.96",
      "2-bound": [0.86, 1.07],
      "5-mid": "1.21",
      "5-bound": [1.09, 1.35],
      "10-mid": "1.38",
      "10-bound": [1.24, 1.54],
      "25-mid": "1.61",
      "25-bound": [1.43, 1.79],
      "50-mid": "1.78",
      "50-bound": [1.57, 1.98],
      "100-mid": "1.94",
      "100-bound": [1.7, 2.17]
    },
    "60min": {
      "2-mid": "1.2",
      "2-bound": [1.08, 1.34],
      "5-mid": "1.55",
      "5-bound": [1.4, 1.73],
      "10-mid": "1.8",
      "10-bound": [1.61, 2.0],
      "25-mid": "2.15",
      "25-bound": [1.91, 2.38],
      "50-mid": "2.41",
      "50-bound": [2.13, 2.68],
      "100-mid": "2.68",
      "100-bound": [2.35, 2.99]
    },
    "2hr": {
      "2-mid": "1.42",
      "2-bound": [1.28, 1.56],
      "5-mid": "1.84",
      "5-bound": [1.66, 2.03],
      "10-mid": "2.15",
      "10-bound": [1.94, 2.38],
      "25-mid": "2.57",
      "25-bound": [2.3, 2.84],
      "50-mid": "2.9",
      "50-bound": [2.58, 3.21],
      "100-mid": "3.25",
      "100-bound": [2.86, 3.6]
    },
    "3hr": {
      "2-mid": "1.53",
      "2-bound": [1.39, 1.7],
      "5-mid": "1.96",
      "5-bound": [1.78, 2.19],
      "10-mid": "2.3",
      "10-bound": [2.08, 2.56],
      "25-mid": "2.76",
      "25-bound": [2.47, 3.06],
      "50-mid": "3.12",
      "50-bound": [2.78, 3.47],
      "100-mid": "3.5",
      "100-bound": [3.08, 3.9]
    },
    "6hr": {
      "2-mid": "1.93",
      "2-bound": [1.75, 2.18],
      "5-mid": "2.45",
      "5-bound": [2.21, 2.76],
      "10-mid": "2.87",
      "10-bound": [2.57, 3.22],
      "25-mid": "3.45",
      "25-bound": [3.07, 3.87],
      "50-mid": "3.93",
      "50-bound": [3.46, 4.42],
      "100-mid": "4.44",
      "100-bound": [3.87, 5.0]
    },
    "12hr": {
      "2-mid": "2.4",
      "2-bound": [2.17, 2.72],
      "5-mid": "3.03",
      "5-bound": [2.73, 3.44],
      "10-mid": "3.55",
      "10-bound": [3.18, 4.02],
      "25-mid": "4.32",
      "25-bound": [3.83, 4.89],
      "50-mid": "4.97",
      "50-bound": [4.35, 5.63],
      "100-mid": "5.69",
      "100-bound": [4.9, 6.47]
    },
    "24hr": {
      "2-mid": "2.99",
      "2-bound": [2.77, 3.28],
      "5-mid": "3.76",
      "5-bound": [3.47, 4.12],
      "10-mid": "4.4",
      "10-bound": [4.04, 4.81],
      "25-mid": "5.31",
      "25-bound": [4.84, 5.8],
      "50-mid": "6.08",
      "50-bound": [5.51, 6.64],
      "100-mid": "6.9",
      "100-bound": [6.2, 7.55]
    },
    "2day": {
      "2-mid": "3.51",
      "2-bound": [3.26, 3.85],
      "5-mid": "4.4",
      "5-bound": [4.07, 4.83],
      "10-mid": "5.12",
      "10-bound": [4.72, 5.61],
      "25-mid": "6.14",
      "25-bound": [5.62, 6.73],
      "50-mid": "6.98",
      "50-bound": [6.35, 7.66],
      "100-mid": "7.86",
      "100-bound": [7.1, 8.64]
    },
    "3day": {
      "2-mid": "3.77",
      "2-bound": [3.51, 4.09],
      "5-mid": "4.71",
      "5-bound": [4.38, 5.11],
      "10-mid": "5.46",
      "10-bound": [5.06, 5.92],
      "25-mid": "6.53",
      "25-bound": [6.01, 7.08],
      "50-mid": "7.4",
      "50-bound": [6.77, 8.03],
      "100-mid": "8.32",
      "100-bound": [7.56, 9.05]
    },
    "4day": {
      "2-mid": "4.03",
      "2-bound": [3.77, 4.33],
      "5-mid": "5.02",
      "5-bound": [4.68, 5.39],
      "10-mid": "5.81",
      "10-bound": [5.4, 6.24],
      "25-mid": "6.92",
      "25-bound": [6.4, 7.43],
      "50-mid": "7.82",
      "50-bound": [7.2, 8.41],
      "100-mid": "8.78",
      "100-bound": [8.03, 9.46]
    },
    "7day": {
      "2-mid": "4.7",
      "2-bound": [4.41, 5.02],
      "5-mid": "5.78",
      "5-bound": [5.42, 6.18],
      "10-mid": "6.64",
      "10-bound": [6.21, 7.1],
      "25-mid": "7.83",
      "25-bound": [7.28, 8.36],
      "50-mid": "8.78",
      "50-bound": [8.13, 9.39],
      "100-mid": "9.76",
      "100-bound": [8.98, 10.5]
    }
  },
  "USC00072730 6": {
    "fips": "10001",
    "station_name": "DOVER",
    "state": "DE",
    "latitude": "39.1460",
    "longitude": "-75.5050",
    "5min": {
      "2-mid": "0.42",
      "2-bound": [0.38, 0.47],
      "5-mid": "0.49",
      "5-bound": [0.44, 0.54],
      "10-mid": "0.55",
      "10-bound": [0.49, 0.61],
      "25-mid": "0.62",
      "25-bound": [0.55, 0.69],
      "50-mid": "0.67",
      "50-bound": [0.6, 0.75],
      "100-mid": "0.73",
      "100-bound": [0.64, 0.81]
    },
    "10min": {
      "2-mid": "0.67",
      "2-bound": [0.6, 0.74],
      "5-mid": "0.79",
      "5-bound": [0.7, 0.87],
      "10-mid": "0.88",
      "10-bound": [0.79, 0.98],
      "25-mid": "0.99",
      "25-bound": [0.88, 1.1],
      "50-mid": "1.07",
      "50-bound": [0.95, 1.19],
      "100-mid": "1.15",
      "100-bound": [1.02, 1.29]
    },
    "15min": {
      "2-mid": "0.84",
      "2-bound": [0.75, 0.94],
      "5-mid": "0.99",
      "5-bound": [0.89, 1.1],
      "10-mid": "1.11",
      "10-bound": [0.99, 1.24],
      "25-mid": "1.25",
      "25-bound": [1.12, 1.39],
      "50-mid": "1.36",
      "50-bound": [1.2, 1.51],
      "100-mid": "1.46",
      "100-bound": [1.28, 1.63]
    },
    "30min": {
      "2-mid": "1.16",
      "2-bound": [1.04, 1.29],
      "5-mid": "1.41",
      "5-bound": [1.26, 1.56],
      "10-mid": "1.61",
      "10-bound": [1.44, 1.79],
      "25-mid": "1.86",
      "25-bound": [1.65, 2.06],
      "50-mid": "2.05",
      "50-bound": [1.81, 2.28],
      "100-mid": "2.23",
      "100-bound": [1.97, 2.49]
    },
    "60min": {
      "2-mid": "1.46",
      "2-bound": [1.31, 1.62],
      "5-mid": "1.81",
      "5-bound": [1.62, 2.01],
      "10-mid": "2.1",
      "10-bound": [1.88, 2.34],
      "25-mid": "2.47",
      "25-bound": [2.2, 2.75],
      "50-mid": "2.78",
      "50-bound": [2.46, 3.09],
      "100-mid": "3.08",
      "100-bound": [2.71, 3.43]
    },
    "2hr": {
      "2-mid": "1.77",
      "2-bound": [1.57, 1.99],
      "5-mid": "2.21",
      "5-bound": [1.96, 2.48],
      "10-mid": "2.59",
      "10-bound": [2.29, 2.9],
      "25-mid": "3.07",
      "25-bound": [2.7, 3.45],
      "50-mid": "3.48",
      "50-bound": [3.04, 3.9],
      "100-mid": "3.88",
      "100-bound": [3.38, 4.37]
    },
    "3hr": {
      "2-mid": "1.92",
      "2-bound": [1.72, 2.16],
      "5-mid": "2.4",
      "5-bound": [2.14, 2.69],
      "10-mid": "2.83",
      "10-bound": [2.51, 3.17],
      "25-mid": "3.38",
      "25-bound": [2.98, 3.78],
      "50-mid": "3.85",
      "50-bound": [3.37, 4.31],
      "100-mid": "4.32",
      "100-bound": [3.76, 4.85]
    },
    "6hr": {
      "2-mid": "2.36",
      "2-bound": [2.11, 2.66],
      "5-mid": "2.94",
      "5-bound": [2.62, 3.31],
      "10-mid": "3.47",
      "10-bound": [3.08, 3.9],
      "25-mid": "4.18",
      "25-bound": [3.69, 4.71],
      "50-mid": "4.81",
      "50-bound": [4.21, 5.41],
      "100-mid": "5.46",
      "100-bound": [4.73, 6.17]
    },
    "12hr": {
      "2-mid": "2.84",
      "2-bound": [2.53, 3.22],
      "5-mid": "3.56",
      "5-bound": [3.15, 4.03],
      "10-mid": "4.24",
      "10-bound": [3.75, 4.8],
      "25-mid": "5.2",
      "25-bound": [4.55, 5.88],
      "50-mid": "6.06",
      "50-bound": [5.26, 6.87],
      "100-mid": "7.0",
      "100-bound": [6.0, 7.95]
    },
    "24hr": {
      "2-mid": "3.31",
      "2-bound": [3.02, 3.66],
      "5-mid": "4.3",
      "5-bound": [3.92, 4.76],
      "10-mid": "5.17",
      "10-bound": [4.68, 5.7],
      "25-mid": "6.48",
      "25-bound": [5.83, 7.12],
      "50-mid": "7.63",
      "50-bound": [6.81, 8.35],
      "100-mid": "8.92",
      "100-bound": [7.91, 9.75]
    },
    "2day": {
      "2-mid": "3.82",
      "2-bound": [3.49, 4.23],
      "5-mid": "4.97",
      "5-bound": [4.52, 5.5],
      "10-mid": "5.95",
      "10-bound": [5.4, 6.58],
      "25-mid": "7.45",
      "25-bound": [6.71, 8.2],
      "50-mid": "8.75",
      "50-bound": [7.83, 9.61],
      "100-mid": "10.2",
      "100-bound": [9.06, 11.2]
    },
    "3day": {
      "2-mid": "4.02",
      "2-bound": [3.68, 4.43],
      "5-mid": "5.21",
      "5-bound": [4.75, 5.73],
      "10-mid": "6.22",
      "10-bound": [5.66, 6.83],
      "25-mid": "7.74",
      "25-bound": [6.99, 8.48],
      "50-mid": "9.06",
      "50-bound": [8.13, 9.91],
      "100-mid": "10.5",
      "100-bound": [9.38, 11.5]
    },
    "4day": {
      "2-mid": "4.23",
      "2-bound": [3.87, 4.63],
      "5-mid": "5.44",
      "5-bound": [4.98, 5.96],
      "10-mid": "6.48",
      "10-bound": [5.91, 7.09],
      "25-mid": "8.02",
      "25-bound": [7.28, 8.76],
      "50-mid": "9.36",
      "50-bound": [8.44, 10.2],
      "100-mid": "10.8",
      "100-bound": [9.71, 11.8]
    },
    "7day": {
      "2-mid": "4.9",
      "2-bound": [4.51, 5.36],
      "5-mid": "6.21",
      "5-bound": [5.71, 6.78],
      "10-mid": "7.32",
      "10-bound": [6.71, 7.98],
      "25-mid": "8.97",
      "25-bound": [8.18, 9.75],
      "50-mid": "10.4",
      "50-bound": [9.41, 11.3],
      "100-mid": "11.9",
      "100-bound": [10.7, 12.9]
    }
  },
  "USC00447904 6": {
    "fips": "51137",
    "station_name": "SOMERSET",
    "state": "VA",
    "latitude": "38.2450",
    "longitude": "-78.2700",
    "5min": {
      "2-mid": "0.42",
      "2-bound": [0.38, 0.46],
      "5-mid": "0.49",
      "5-bound": [0.44, 0.54],
      "10-mid": "0.55",
      "10-bound": [0.5, 0.61],
      "25-mid": "0.62",
      "25-bound": [0.56, 0.69],
      "50-mid": "0.68",
      "50-bound": [0.61, 0.75],
      "100-mid": "0.73",
      "100-bound": [0.65, 0.81]
    },
    "10min": {
      "2-mid": "0.67",
      "2-bound": [0.6, 0.74],
      "5-mid": "0.79",
      "5-bound": [0.71, 0.87],
      "10-mid": "0.88",
      "10-bound": [0.8, 0.97],
      "25-mid": "1.0",
      "25-bound": [0.89, 1.1],
      "50-mid": "1.08",
      "50-bound": [0.97, 1.19],
      "100-mid": "1.17",
      "100-bound": [1.04, 1.28]
    },
    "15min": {
      "2-mid": "0.84",
      "2-bound": [0.76, 0.92],
      "5-mid": "0.99",
      "5-bound": [0.9, 1.1],
      "10-mid": "1.12",
      "10-bound": [1.01, 1.23],
      "25-mid": "1.26",
      "25-bound": [1.13, 1.38],
      "50-mid": "1.37",
      "50-bound": [1.22, 1.5],
      "100-mid": "1.47",
      "100-bound": [1.31, 1.62]
    },
    "30min": {
      "2-mid": "1.16",
      "2-bound": [1.04, 1.28],
      "5-mid": "1.41",
      "5-bound": [1.27, 1.56],
      "10-mid": "1.62",
      "10-bound": [1.46, 1.78],
      "25-mid": "1.86",
      "25-bound": [1.67, 2.05],
      "50-mid": "2.06",
      "50-bound": [1.84, 2.26],
      "100-mid": "2.25",
      "100-bound": [2.0, 2.47]
    },
    "60min": {
      "2-mid": "1.45",
      "2-bound": [1.31, 1.6],
      "5-mid": "1.8",
      "5-bound": [1.63, 1.99],
      "10-mid": "2.1",
      "10-bound": [1.89, 2.32],
      "25-mid": "2.48",
      "25-bound": [2.22, 2.72],
      "50-mid": "2.79",
      "50-bound": [2.49, 3.06],
      "100-mid": "3.1",
      "100-bound": [2.75, 3.4]
    },
    "2hr": {
      "2-mid": "1.72",
      "2-bound": [1.54, 1.93],
      "5-mid": "2.16",
      "5-bound": [1.93, 2.42],
      "10-mid": "2.54",
      "10-bound": [2.26, 2.84],
      "25-mid": "3.04",
      "25-bound": [2.68, 3.38],
      "50-mid": "3.45",
      "50-bound": [3.03, 3.85],
      "100-mid": "3.88",
      "100-bound": [3.39, 4.32]
    },
    "3hr": {
      "2-mid": "1.88",
      "2-bound": [1.66, 2.14],
      "5-mid": "2.35",
      "5-bound": [2.07, 2.68],
      "10-mid": "2.76",
      "10-bound": [2.43, 3.13],
      "25-mid": "3.3",
      "25-bound": [2.88, 3.73],
      "50-mid": "3.76",
      "50-bound": [3.26, 4.24],
      "100-mid": "4.23",
      "100-bound": [3.65, 4.78]
    },
    "6hr": {
      "2-mid": "2.34",
      "2-bound": [2.06, 2.7],
      "5-mid": "2.92",
      "5-bound": [2.56, 3.35],
      "10-mid": "3.44",
      "10-bound": [3.01, 3.94],
      "25-mid": "4.13",
      "25-bound": [3.59, 4.74],
      "50-mid": "4.74",
      "50-bound": [4.09, 5.41],
      "100-mid": "5.38",
      "100-bound": [4.59, 6.14]
    },
    "12hr": {
      "2-mid": "2.92",
      "2-bound": [2.58, 3.34],
      "5-mid": "3.64",
      "5-bound": [3.21, 4.17],
      "10-mid": "4.31",
      "10-bound": [3.78, 4.92],
      "25-mid": "5.24",
      "25-bound": [4.56, 5.97],
      "50-mid": "6.07",
      "50-bound": [5.23, 6.9],
      "100-mid": "6.97",
      "100-bound": [5.93, 7.91]
    },
    "24hr": {
      "2-mid": "3.45",
      "2-bound": [3.09, 3.91],
      "5-mid": "4.41",
      "5-bound": [3.93, 4.99],
      "10-mid": "5.21",
      "10-bound": [4.64, 5.89],
      "25-mid": "6.41",
      "25-bound": [5.66, 7.23],
      "50-mid": "7.43",
      "50-bound": [6.52, 8.35],
      "100-mid": "8.56",
      "100-bound": [7.45, 9.6]
    },
    "2day": {
      "2-mid": "4.04",
      "2-bound": [3.66, 4.51],
      "5-mid": "5.13",
      "5-bound": [4.64, 5.72],
      "10-mid": "6.03",
      "10-bound": [5.44, 6.72],
      "25-mid": "7.34",
      "25-bound": [6.58, 8.15],
      "50-mid": "8.43",
      "50-bound": [7.5, 9.35],
      "100-mid": "9.61",
      "100-bound": [8.5, 10.7]
    },
    "3day": {
      "2-mid": "4.3",
      "2-bound": [3.91, 4.77],
      "5-mid": "5.46",
      "5-bound": [4.96, 6.06],
      "10-mid": "6.42",
      "10-bound": [5.81, 7.1],
      "25-mid": "7.8",
      "25-bound": [7.02, 8.62],
      "50-mid": "8.97",
      "50-bound": [8.02, 9.89],
      "100-mid": "10.2",
      "100-bound": [9.08, 11.3]
    },
    "4day": {
      "2-mid": "4.56",
      "2-bound": [4.16, 5.04],
      "5-mid": "5.8",
      "5-bound": [5.27, 6.39],
      "10-mid": "6.81",
      "10-bound": [6.18, 7.49],
      "25-mid": "8.27",
      "25-bound": [7.48, 9.09],
      "50-mid": "9.5",
      "50-bound": [8.54, 10.4],
      "100-mid": "10.8",
      "100-bound": [9.65, 11.9]
    },
    "7day": {
      "2-mid": "5.27",
      "2-bound": [4.8, 5.82],
      "5-mid": "6.59",
      "5-bound": [5.99, 7.28],
      "10-mid": "7.67",
      "10-bound": [6.96, 8.47],
      "25-mid": "9.23",
      "25-bound": [8.32, 10.2],
      "50-mid": "10.5",
      "50-bound": [9.45, 11.6],
      "100-mid": "11.9",
      "100-bound": [10.6, 13.1]
    }
  },
  "USC00301974 6": {
    "fips": "36051",
    "station_name": "DANSVILLE",
    "state": "NY",
    "latitude": "42.5647",
    "longitude": "-77.7176",
    "5min": {
      "2-mid": "0.32",
      "2-bound": [0.24, 0.4],
      "5-mid": "0.41",
      "5-bound": [0.31, 0.52],
      "10-mid": "0.48",
      "10-bound": [0.36, 0.62],
      "25-mid": "0.58",
      "25-bound": [0.43, 0.78],
      "50-mid": "0.66",
      "50-bound": [0.47, 0.91],
      "100-mid": "0.74",
      "100-bound": [0.52, 1.06]
    },
    "10min": {
      "2-mid": "0.45",
      "2-bound": [0.34, 0.57],
      "5-mid": "0.57",
      "5-bound": [0.43, 0.73],
      "10-mid": "0.68",
      "10-bound": [0.51, 0.87],
      "25-mid": "0.82",
      "25-bound": [0.6, 1.11],
      "50-mid": "0.93",
      "50-bound": [0.67, 1.28],
      "100-mid": "1.04",
      "100-bound": [0.74, 1.5]
    },
    "15min": {
      "2-mid": "0.53",
      "2-bound": [0.4, 0.67],
      "5-mid": "0.68",
      "5-bound": [0.51, 0.86],
      "10-mid": "0.8",
      "10-bound": [0.6, 1.03],
      "25-mid": "0.97",
      "25-bound": [0.71, 1.3],
      "50-mid": "1.09",
      "50-bound": [0.79, 1.51],
      "100-mid": "1.23",
      "100-bound": [0.87, 1.76]
    },
    "30min": {
      "2-mid": "0.73",
      "2-bound": [0.56, 0.94],
      "5-mid": "0.93",
      "5-bound": [0.71, 1.19],
      "10-mid": "1.1",
      "10-bound": [0.83, 1.41],
      "25-mid": "1.32",
      "25-bound": [0.97, 1.78],
      "50-mid": "1.49",
      "50-bound": [1.08, 2.05],
      "100-mid": "1.67",
      "100-bound": [1.18, 2.39]
    },
    "60min": {
      "2-mid": "0.94",
      "2-bound": [0.72, 1.2],
      "5-mid": "1.19",
      "5-bound": [0.9, 1.52],
      "10-mid": "1.39",
      "10-bound": [1.05, 1.79],
      "25-mid": "1.67",
      "25-bound": [1.23, 2.26],
      "50-mid": "1.88",
      "50-bound": [1.36, 2.6],
      "100-mid": "2.11",
      "100-bound": [1.49, 3.02]
    },
    "2hr": {
      "2-mid": "1.15",
      "2-bound": [0.88, 1.44],
      "5-mid": "1.46",
      "5-bound": [1.12, 1.84],
      "10-mid": "1.72",
      "10-bound": [1.31, 2.18],
      "25-mid": "2.07",
      "25-bound": [1.54, 2.76],
      "50-mid": "2.34",
      "50-bound": [1.7, 3.18],
      "100-mid": "2.62",
      "100-bound": [1.86, 3.7]
    },
    "3hr": {
      "2-mid": "1.28",
      "2-bound": [0.99, 1.6],
      "5-mid": "1.62",
      "5-bound": [1.26, 2.04],
      "10-mid": "1.92",
      "10-bound": [1.47, 2.42],
      "25-mid": "2.32",
      "25-bound": [1.73, 3.06],
      "50-mid": "2.61",
      "50-bound": [1.92, 3.53],
      "100-mid": "2.93",
      "100-bound": [2.1, 4.12]
    },
    "6hr": {
      "2-mid": "1.53",
      "2-bound": [1.2, 1.9],
      "5-mid": "1.94",
      "5-bound": [1.52, 2.41],
      "10-mid": "2.28",
      "10-bound": [1.77, 2.85],
      "25-mid": "2.74",
      "25-bound": [2.08, 3.6],
      "50-mid": "3.09",
      "50-bound": [2.3, 4.15],
      "100-mid": "3.46",
      "100-bound": [2.52, 4.84]
    },
    "12hr": {
      "2-mid": "1.84",
      "2-bound": [1.46, 2.25],
      "5-mid": "2.3",
      "5-bound": [1.82, 2.82],
      "10-mid": "2.68",
      "10-bound": [2.12, 3.31],
      "25-mid": "3.21",
      "25-bound": [2.47, 4.17],
      "50-mid": "3.59",
      "50-bound": [2.72, 4.79],
      "100-mid": "4.02",
      "100-bound": [2.98, 5.61]
    },
    "24hr": {
      "2-mid": "2.18",
      "2-bound": [1.76, 2.64],
      "5-mid": "2.72",
      "5-bound": [2.19, 3.31],
      "10-mid": "3.17",
      "10-bound": [2.54, 3.88],
      "25-mid": "3.79",
      "25-bound": [2.96, 4.88],
      "50-mid": "4.24",
      "50-bound": [3.25, 5.6],
      "100-mid": "4.75",
      "100-bound": [3.57, 6.56]
    },
    "2day": {
      "2-mid": "2.53",
      "2-bound": [2.07, 3.03],
      "5-mid": "3.21",
      "5-bound": [2.61, 3.85],
      "10-mid": "3.77",
      "10-bound": [3.05, 4.55],
      "25-mid": "4.54",
      "25-bound": [3.57, 5.75],
      "50-mid": "5.11",
      "50-bound": [3.95, 6.63],
      "100-mid": "5.73",
      "100-bound": [4.32, 7.75]
    },
    "3day": {
      "2-mid": "2.78",
      "2-bound": [2.29, 3.31],
      "5-mid": "3.52",
      "5-bound": [2.89, 4.2],
      "10-mid": "4.14",
      "10-bound": [3.38, 4.96],
      "25-mid": "4.99",
      "25-bound": [3.95, 6.27],
      "50-mid": "5.62",
      "50-bound": [4.36, 7.22],
      "100-mid": "6.3",
      "100-bound": [4.76, 8.42]
    },
    "4day": {
      "2-mid": "2.99",
      "2-bound": [2.48, 3.54],
      "5-mid": "3.78",
      "5-bound": [3.12, 4.48],
      "10-mid": "4.42",
      "10-bound": [3.63, 5.28],
      "25-mid": "5.32",
      "25-bound": [4.23, 6.64],
      "50-mid": "5.99",
      "50-bound": [4.67, 7.65],
      "100-mid": "6.7",
      "100-bound": [5.08, 8.9]
    },
    "7day": {
      "2-mid": "3.53",
      "2-bound": [2.96, 4.14],
      "5-mid": "4.39",
      "5-bound": [3.67, 5.16],
      "10-mid": "5.1",
      "10-bound": [4.24, 6.04],
      "25-mid": "6.09",
      "25-bound": [4.89, 7.51],
      "50-mid": "6.82",
      "50-bound": [5.36, 8.6],
      "100-mid": "7.6",
      "100-bound": [5.8, 9.95]
    }
  },
  "USC00180700 6": {
    "fips": "24033",
    "station_name": "BELTSVILLE",
    "state": "MD",
    "latitude": "39.0300",
    "longitude": "-76.9310",
    "5min": {
      "2-mid": "0.41",
      "2-bound": [0.38, 0.46],
      "5-mid": "0.49",
      "5-bound": [0.45, 0.54],
      "10-mid": "0.55",
      "10-bound": [0.5, 0.61],
      "25-mid": "0.62",
      "25-bound": [0.56, 0.69],
      "50-mid": "0.68",
      "50-bound": [0.61, 0.75],
      "100-mid": "0.73",
      "100-bound": [0.65, 0.81]
    },
    "10min": {
      "2-mid": "0.66",
      "2-bound": [0.6, 0.73],
      "5-mid": "0.79",
      "5-bound": [0.72, 0.87],
      "10-mid": "0.88",
      "10-bound": [0.8, 0.97],
      "25-mid": "0.99",
      "25-bound": [0.89, 1.1],
      "50-mid": "1.08",
      "50-bound": [0.96, 1.19],
      "100-mid": "1.16",
      "100-bound": [1.03, 1.29]
    },
    "15min": {
      "2-mid": "0.83",
      "2-bound": [0.76, 0.92],
      "5-mid": "1.0",
      "5-bound": [0.91, 1.1],
      "10-mid": "1.12",
      "10-bound": [1.01, 1.23],
      "25-mid": "1.26",
      "25-bound": [1.13, 1.39],
      "50-mid": "1.37",
      "50-bound": [1.22, 1.51],
      "100-mid": "1.47",
      "100-bound": [1.3, 1.63]
    },
    "30min": {
      "2-mid": "1.15",
      "2-bound": [1.04, 1.27],
      "5-mid": "1.42",
      "5-bound": [1.29, 1.57],
      "10-mid": "1.62",
      "10-bound": [1.46, 1.78],
      "25-mid": "1.87",
      "25-bound": [1.68, 2.06],
      "50-mid": "2.06",
      "50-bound": [1.84, 2.28],
      "100-mid": "2.25",
      "100-bound": [2.0, 2.49]
    },
    "60min": {
      "2-mid": "1.44",
      "2-bound": [1.31, 1.59],
      "5-mid": "1.82",
      "5-bound": [1.65, 2.01],
      "10-mid": "2.1",
      "10-bound": [1.9, 2.32],
      "25-mid": "2.49",
      "25-bound": [2.23, 2.74],
      "50-mid": "2.79",
      "50-bound": [2.49, 3.08],
      "100-mid": "3.1",
      "100-bound": [2.75, 3.43]
    },
    "2hr": {
      "2-mid": "1.71",
      "2-bound": [1.56, 1.89],
      "5-mid": "2.17",
      "5-bound": [1.98, 2.38],
      "10-mid": "2.52",
      "10-bound": [2.29, 2.77],
      "25-mid": "3.02",
      "25-bound": [2.72, 3.32],
      "50-mid": "3.43",
      "50-bound": [3.07, 3.77],
      "100-mid": "3.85",
      "100-bound": [3.42, 4.24]
    },
    "3hr": {
      "2-mid": "1.85",
      "2-bound": [1.68, 2.04],
      "5-mid": "2.34",
      "5-bound": [2.13, 2.58],
      "10-mid": "2.74",
      "10-bound": [2.47, 3.01],
      "25-mid": "3.3",
      "25-bound": [2.96, 3.63],
      "50-mid": "3.76",
      "50-bound": [3.35, 4.14],
      "100-mid": "4.25",
      "100-bound": [3.75, 4.69]
    },
    "6hr": {
      "2-mid": "2.28",
      "2-bound": [2.08, 2.52],
      "5-mid": "2.88",
      "5-bound": [2.62, 3.18],
      "10-mid": "3.38",
      "10-bound": [3.05, 3.73],
      "25-mid": "4.11",
      "25-bound": [3.67, 4.54],
      "50-mid": "4.73",
      "50-bound": [4.19, 5.23],
      "100-mid": "5.41",
      "100-bound": [4.75, 6.0]
    },
    "12hr": {
      "2-mid": "2.78",
      "2-bound": [2.5, 3.12],
      "5-mid": "3.53",
      "5-bound": [3.17, 3.97],
      "10-mid": "4.18",
      "10-bound": [3.72, 4.69],
      "25-mid": "5.17",
      "25-bound": [4.56, 5.8],
      "50-mid": "6.04",
      "50-bound": [5.27, 6.78],
      "100-mid": "7.0",
      "100-bound": [6.03, 7.89]
    },
    "24hr": {
      "2-mid": "3.2",
      "2-bound": [2.93, 3.54],
      "5-mid": "4.11",
      "5-bound": [3.75, 4.55],
      "10-mid": "4.92",
      "10-bound": [4.47, 5.42],
      "25-mid": "6.15",
      "25-bound": [5.54, 6.74],
      "50-mid": "7.25",
      "50-bound": [6.47, 7.91],
      "100-mid": "8.49",
      "100-bound": [7.51, 9.24]
    },
    "2day": {
      "2-mid": "3.72",
      "2-bound": [3.39, 4.09],
      "5-mid": "4.76",
      "5-bound": [4.34, 5.23],
      "10-mid": "5.66",
      "10-bound": [5.14, 6.21],
      "25-mid": "7.01",
      "25-bound": [6.33, 7.66],
      "50-mid": "8.19",
      "50-bound": [7.34, 8.94],
      "100-mid": "9.5",
      "100-bound": [8.45, 10.4]
    },
    "3day": {
      "2-mid": "3.92",
      "2-bound": [3.58, 4.32],
      "5-mid": "5.01",
      "5-bound": [4.58, 5.52],
      "10-mid": "5.95",
      "10-bound": [5.42, 6.54],
      "25-mid": "7.37",
      "25-bound": [6.66, 8.07],
      "50-mid": "8.6",
      "50-bound": [7.72, 9.4],
      "100-mid": "9.97",
      "100-bound": [8.88, 10.9]
    },
    "4day": {
      "2-mid": "4.12",
      "2-bound": [3.78, 4.55],
      "5-mid": "5.27",
      "5-bound": [4.82, 5.8],
      "10-mid": "6.25",
      "10-bound": [5.7, 6.88],
      "25-mid": "7.73",
      "25-bound": [7.0, 8.48],
      "50-mid": "9.01",
      "50-bound": [8.11, 9.87],
      "100-mid": "10.4",
      "100-bound": [9.32, 11.4]
    },
    "7day": {
      "2-mid": "4.76",
      "2-bound": [4.39, 5.23],
      "5-mid": "6.02",
      "5-bound": [5.54, 6.6],
      "10-mid": "7.1",
      "10-bound": [6.51, 7.77],
      "25-mid": "8.71",
      "25-bound": [7.93, 9.51],
      "50-mid": "10.1",
      "50-bound": [9.14, 11.0],
      "100-mid": "11.6",
      "100-bound": [10.5, 12.7]
    }
  },
  "USW00014748 6": {
    "fips": "36015",
    "station_name": "ELMIRA CORNING REGIONAL AP",
    "state": "NY",
    "latitude": "42.1594",
    "longitude": "-76.8919",
    "5min": {
      "2-mid": "0.37",
      "2-bound": [0.28, 0.48],
      "5-mid": "0.47",
      "5-bound": [0.35, 0.62],
      "10-mid": "0.56",
      "10-bound": [0.42, 0.74],
      "25-mid": "0.67",
      "25-bound": [0.49, 0.93],
      "50-mid": "0.76",
      "50-bound": [0.55, 1.08],
      "100-mid": "0.85",
      "100-bound": [0.6, 1.25]
    },
    "10min": {
      "2-mid": "0.52",
      "2-bound": [0.39, 0.69],
      "5-mid": "0.67",
      "5-bound": [0.5, 0.88],
      "10-mid": "0.79",
      "10-bound": [0.59, 1.04],
      "25-mid": "0.95",
      "25-bound": [0.7, 1.32],
      "50-mid": "1.08",
      "50-bound": [0.77, 1.52],
      "100-mid": "1.21",
      "100-bound": [0.85, 1.77]
    },
    "15min": {
      "2-mid": "0.61",
      "2-bound": [0.46, 0.81],
      "5-mid": "0.78",
      "5-bound": [0.59, 1.04],
      "10-mid": "0.92",
      "10-bound": [0.69, 1.23],
      "25-mid": "1.12",
      "25-bound": [0.82, 1.55],
      "50-mid": "1.27",
      "50-bound": [0.91, 1.79],
      "100-mid": "1.42",
      "100-bound": [1.0, 2.08]
    },
    "30min": {
      "2-mid": "0.81",
      "2-bound": [0.61, 1.07],
      "5-mid": "1.04",
      "5-bound": [0.78, 1.37],
      "10-mid": "1.23",
      "10-bound": [0.92, 1.63],
      "25-mid": "1.48",
      "25-bound": [1.09, 2.06],
      "50-mid": "1.68",
      "50-bound": [1.21, 2.38],
      "100-mid": "1.88",
      "100-bound": [1.32, 2.76]
    },
    "60min": {
      "2-mid": "1.01",
      "2-bound": [0.77, 1.33],
      "5-mid": "1.29",
      "5-bound": [0.98, 1.71],
      "10-mid": "1.53",
      "10-bound": [1.15, 2.03],
      "25-mid": "1.85",
      "25-bound": [1.35, 2.57],
      "50-mid": "2.09",
      "50-bound": [1.5, 2.96],
      "100-mid": "2.35",
      "100-bound": [1.65, 3.44]
    },
    "2hr": {
      "2-mid": "1.24",
      "2-bound": [0.94, 1.62],
      "5-mid": "1.58",
      "5-bound": [1.2, 2.07],
      "10-mid": "1.86",
      "10-bound": [1.41, 2.45],
      "25-mid": "2.25",
      "25-bound": [1.66, 3.11],
      "50-mid": "2.54",
      "50-bound": [1.85, 3.58],
      "100-mid": "2.85",
      "100-bound": [2.04, 4.19]
    },
    "3hr": {
      "2-mid": "1.39",
      "2-bound": [1.07, 1.8],
      "5-mid": "1.77",
      "5-bound": [1.36, 2.31],
      "10-mid": "2.09",
      "10-bound": [1.59, 2.73],
      "25-mid": "2.52",
      "25-bound": [1.88, 3.47],
      "50-mid": "2.84",
      "50-bound": [2.08, 4.0],
      "100-mid": "3.2",
      "100-bound": [2.29, 4.69]
    },
    "6hr": {
      "2-mid": "1.7",
      "2-bound": [1.32, 2.18],
      "5-mid": "2.16",
      "5-bound": [1.67, 2.79],
      "10-mid": "2.55",
      "10-bound": [1.96, 3.31],
      "25-mid": "3.08",
      "25-bound": [2.31, 4.2],
      "50-mid": "3.48",
      "50-bound": [2.56, 4.85],
      "100-mid": "3.9",
      "100-bound": [2.82, 5.68]
    },
    "12hr": {
      "2-mid": "2.07",
      "2-bound": [1.62, 2.63],
      "5-mid": "2.64",
      "5-bound": [2.06, 3.37],
      "10-mid": "3.12",
      "10-bound": [2.42, 4.0],
      "25-mid": "3.78",
      "25-bound": [2.85, 5.09],
      "50-mid": "4.26",
      "50-bound": [3.16, 5.88],
      "100-mid": "4.79",
      "100-bound": [3.47, 6.89]
    },
    "24hr": {
      "2-mid": "2.45",
      "2-bound": [1.94, 3.08],
      "5-mid": "3.15",
      "5-bound": [2.48, 3.98],
      "10-mid": "3.73",
      "10-bound": [2.92, 4.74],
      "25-mid": "4.53",
      "25-bound": [3.44, 6.03],
      "50-mid": "5.12",
      "50-bound": [3.82, 6.98],
      "100-mid": "5.76",
      "100-bound": [4.19, 8.18]
    },
    "2day": {
      "2-mid": "2.8",
      "2-bound": [2.24, 3.5],
      "5-mid": "3.63",
      "5-bound": [2.89, 4.54],
      "10-mid": "4.31",
      "10-bound": [3.41, 5.42],
      "25-mid": "5.24",
      "25-bound": [4.02, 6.92],
      "50-mid": "5.94",
      "50-bound": [4.46, 8.03],
      "100-mid": "6.69",
      "100-bound": [4.89, 9.42]
    },
    "3day": {
      "2-mid": "3.05",
      "2-bound": [2.45, 3.78],
      "5-mid": "3.93",
      "5-bound": [3.15, 4.88],
      "10-mid": "4.65",
      "10-bound": [3.7, 5.82],
      "25-mid": "5.65",
      "25-bound": [4.36, 7.42],
      "50-mid": "6.4",
      "50-bound": [4.83, 8.6],
      "100-mid": "7.2",
      "100-bound": [5.29, 10.1]
    },
    "4day": {
      "2-mid": "3.27",
      "2-bound": [2.64, 4.03],
      "5-mid": "4.17",
      "5-bound": [3.36, 5.16],
      "10-mid": "4.92",
      "10-bound": [3.94, 6.13],
      "25-mid": "5.96",
      "25-bound": [4.61, 7.79],
      "50-mid": "6.73",
      "50-bound": [5.1, 9.0],
      "100-mid": "7.55",
      "100-bound": [5.56, 10.5]
    },
    "7day": {
      "2-mid": "3.84",
      "2-bound": [3.13, 4.7],
      "5-mid": "4.79",
      "5-bound": [3.88, 5.88],
      "10-mid": "5.58",
      "10-bound": [4.5, 6.89],
      "25-mid": "6.66",
      "25-bound": [5.19, 8.63],
      "50-mid": "7.47",
      "50-bound": [5.69, 9.9],
      "100-mid": "8.34",
      "100-bound": [6.16, 11.5]
    }
  },
  "USW00014777 6": {
    "fips": "42079",
    "station_name": "WILKES-BARRE/SCRANTON INTERNATIONAL AIRPORT",
    "state": "PA",
    "latitude": "41.3330",
    "longitude": "-75.7260",
    "5min": {
      "2-mid": "0.35",
      "2-bound": [0.32, 0.39],
      "5-mid": "0.41",
      "5-bound": [0.37, 0.46],
      "10-mid": "0.46",
      "10-bound": [0.42, 0.52],
      "25-mid": "0.53",
      "25-bound": [0.47, 0.58],
      "50-mid": "0.58",
      "50-bound": [0.52, 0.64],
      "100-mid": "0.63",
      "100-bound": [0.56, 0.7]
    },
    "10min": {
      "2-mid": "0.55",
      "2-bound": [0.49, 0.61],
      "5-mid": "0.64",
      "5-bound": [0.58, 0.71],
      "10-mid": "0.72",
      "10-bound": [0.65, 0.79],
      "25-mid": "0.81",
      "25-bound": [0.72, 0.89],
      "50-mid": "0.88",
      "50-bound": [0.78, 0.98],
      "100-mid": "0.95",
      "100-bound": [0.84, 1.06]
    },
    "15min": {
      "2-mid": "0.67",
      "2-bound": [0.6, 0.74],
      "5-mid": "0.79",
      "5-bound": [0.71, 0.88],
      "10-mid": "0.88",
      "10-bound": [0.79, 0.98],
      "25-mid": "1.0",
      "25-bound": [0.89, 1.1],
      "50-mid": "1.09",
      "50-bound": [0.97, 1.21],
      "100-mid": "1.18",
      "100-bound": [1.05, 1.31]
    },
    "30min": {
      "2-mid": "0.9",
      "2-bound": [0.81, 0.99],
      "5-mid": "1.08",
      "5-bound": [0.97, 1.2],
      "10-mid": "1.22",
      "10-bound": [1.1, 1.36],
      "25-mid": "1.41",
      "25-bound": [1.26, 1.56],
      "50-mid": "1.56",
      "50-bound": [1.39, 1.73],
      "100-mid": "1.71",
      "100-bound": [1.51, 1.9]
    },
    "60min": {
      "2-mid": "1.1",
      "2-bound": [0.99, 1.22],
      "5-mid": "1.36",
      "5-bound": [1.22, 1.51],
      "10-mid": "1.56",
      "10-bound": [1.4, 1.73],
      "25-mid": "1.82",
      "25-bound": [1.63, 2.02],
      "50-mid": "2.05",
      "50-bound": [1.83, 2.28],
      "100-mid": "2.28",
      "100-bound": [2.02, 2.54]
    },
    "2hr": {
      "2-mid": "1.29",
      "2-bound": [1.18, 1.44],
      "5-mid": "1.61",
      "5-bound": [1.46, 1.79],
      "10-mid": "1.88",
      "10-bound": [1.7, 2.08],
      "25-mid": "2.28",
      "25-bound": [2.05, 2.53],
      "50-mid": "2.63",
      "50-bound": [2.35, 2.93],
      "100-mid": "3.04",
      "100-bound": [2.7, 3.39]
    },
    "3hr": {
      "2-mid": "1.44",
      "2-bound": [1.31, 1.6],
      "5-mid": "1.79",
      "5-bound": [1.63, 1.98],
      "10-mid": "2.09",
      "10-bound": [1.89, 2.31],
      "25-mid": "2.54",
      "25-bound": [2.29, 2.8],
      "50-mid": "2.96",
      "50-bound": [2.64, 3.27],
      "100-mid": "3.44",
      "100-bound": [3.04, 3.82]
    },
    "6hr": {
      "2-mid": "1.78",
      "2-bound": [1.62, 1.97],
      "5-mid": "2.19",
      "5-bound": [1.99, 2.43],
      "10-mid": "2.55",
      "10-bound": [2.3, 2.82],
      "25-mid": "3.11",
      "25-bound": [2.78, 3.44],
      "50-mid": "3.61",
      "50-bound": [3.21, 4.0],
      "100-mid": "4.2",
      "100-bound": [3.69, 4.65]
    },
    "12hr": {
      "2-mid": "2.17",
      "2-bound": [1.96, 2.42],
      "5-mid": "2.68",
      "5-bound": [2.42, 2.99],
      "10-mid": "3.13",
      "10-bound": [2.81, 3.49],
      "25-mid": "3.84",
      "25-bound": [3.43, 4.27],
      "50-mid": "4.49",
      "50-bound": [3.96, 4.99],
      "100-mid": "5.26",
      "100-bound": [4.59, 5.84]
    },
    "24hr": {
      "2-mid": "2.54",
      "2-bound": [2.32, 2.84],
      "5-mid": "3.15",
      "5-bound": [2.87, 3.51],
      "10-mid": "3.69",
      "10-bound": [3.35, 4.1],
      "25-mid": "4.55",
      "25-bound": [4.1, 5.02],
      "50-mid": "5.35",
      "50-bound": [4.78, 5.88],
      "100-mid": "6.3",
      "100-bound": [5.58, 6.89]
    },
    "2day": {
      "2-mid": "3.0",
      "2-bound": [2.75, 3.33],
      "5-mid": "3.71",
      "5-bound": [3.39, 4.11],
      "10-mid": "4.34",
      "10-bound": [3.95, 4.79],
      "25-mid": "5.35",
      "25-bound": [4.83, 5.88],
      "50-mid": "6.28",
      "50-bound": [5.63, 6.87],
      "100-mid": "7.39",
      "100-bound": [6.56, 8.04]
    },
    "3day": {
      "2-mid": "3.18",
      "2-bound": [2.93, 3.52],
      "5-mid": "3.92",
      "5-bound": [3.6, 4.32],
      "10-mid": "4.57",
      "10-bound": [4.18, 5.02],
      "25-mid": "5.6",
      "25-bound": [5.08, 6.13],
      "50-mid": "6.56",
      "50-bound": [5.91, 7.14],
      "100-mid": "7.7",
      "100-bound": [6.87, 8.34]
    },
    "4day": {
      "2-mid": "3.37",
      "2-bound": [3.1, 3.7],
      "5-mid": "4.13",
      "5-bound": [3.8, 4.53],
      "10-mid": "4.8",
      "10-bound": [4.4, 5.26],
      "25-mid": "5.86",
      "25-bound": [5.34, 6.38],
      "50-mid": "6.84",
      "50-bound": [6.2, 7.42],
      "100-mid": "8.0",
      "100-bound": [7.18, 8.63]
    },
    "7day": {
      "2-mid": "3.95",
      "2-bound": [3.66, 4.3],
      "5-mid": "4.8",
      "5-bound": [4.44, 5.22],
      "10-mid": "5.54",
      "10-bound": [5.11, 6.01],
      "25-mid": "6.72",
      "25-bound": [6.16, 7.26],
      "50-mid": "7.79",
      "50-bound": [7.1, 8.39],
      "100-mid": "9.04",
      "100-bound": [8.17, 9.7]
    }
  },
  "USC00448837 6": {
    "fips": "51550",
    "station_name": "WALLACETON-LAKE DRUMMOND",
    "state": "VA",
    "latitude": "36.5950",
    "longitude": "-76.4380",
    "5min": {
      "2-mid": "0.54",
      "2-bound": [0.49, 0.6],
      "5-mid": "0.61",
      "5-bound": [0.56, 0.68],
      "10-mid": "0.7",
      "10-bound": [0.63, 0.77],
      "25-mid": "0.79",
      "25-bound": [0.71, 0.87],
      "50-mid": "0.86",
      "50-bound": [0.78, 0.95],
      "100-mid": "0.94",
      "100-bound": [0.84, 1.03]
    },
    "10min": {
      "2-mid": "0.87",
      "2-bound": [0.79, 0.95],
      "5-mid": "0.98",
      "5-bound": [0.89, 1.08],
      "10-mid": "1.12",
      "10-bound": [1.01, 1.23],
      "25-mid": "1.25",
      "25-bound": [1.13, 1.38],
      "50-mid": "1.38",
      "50-bound": [1.24, 1.52],
      "100-mid": "1.49",
      "100-bound": [1.33, 1.64]
    },
    "15min": {
      "2-mid": "1.09",
      "2-bound": [0.99, 1.2],
      "5-mid": "1.24",
      "5-bound": [1.13, 1.37],
      "10-mid": "1.41",
      "10-bound": [1.28, 1.56],
      "25-mid": "1.59",
      "25-bound": [1.43, 1.75],
      "50-mid": "1.74",
      "50-bound": [1.57, 1.92],
      "100-mid": "1.88",
      "100-bound": [1.68, 2.07]
    },
    "30min": {
      "2-mid": "1.5",
      "2-bound": [1.37, 1.66],
      "5-mid": "1.76",
      "5-bound": [1.6, 1.95],
      "10-mid": "2.05",
      "10-bound": [1.86, 2.26],
      "25-mid": "2.35",
      "25-bound": [2.12, 2.59],
      "50-mid": "2.63",
      "50-bound": [2.36, 2.89],
      "100-mid": "2.88",
      "100-bound": [2.58, 3.18]
    },
    "60min": {
      "2-mid": "1.89",
      "2-bound": [1.72, 2.08],
      "5-mid": "2.26",
      "5-bound": [2.06, 2.5],
      "10-mid": "2.67",
      "10-bound": [2.42, 2.94],
      "25-mid": "3.14",
      "25-bound": [2.83, 3.45],
      "50-mid": "3.56",
      "50-bound": [3.2, 3.92],
      "100-mid": "3.97",
      "100-bound": [3.55, 4.38]
    },
    "2hr": {
      "2-mid": "2.19",
      "2-bound": [1.98, 2.43],
      "5-mid": "2.68",
      "5-bound": [2.42, 2.97],
      "10-mid": "3.21",
      "10-bound": [2.89, 3.56],
      "25-mid": "3.85",
      "25-bound": [3.45, 4.25],
      "50-mid": "4.44",
      "50-bound": [3.96, 4.91],
      "100-mid": "5.04",
      "100-bound": [4.46, 5.56]
    },
    "3hr": {
      "2-mid": "2.36",
      "2-bound": [2.12, 2.64],
      "5-mid": "2.89",
      "5-bound": [2.6, 3.23],
      "10-mid": "3.49",
      "10-bound": [3.13, 3.9],
      "25-mid": "4.23",
      "25-bound": [3.77, 4.71],
      "50-mid": "4.94",
      "50-bound": [4.37, 5.48],
      "100-mid": "5.65",
      "100-bound": [4.97, 6.27]
    },
    "6hr": {
      "2-mid": "2.82",
      "2-bound": [2.54, 3.16],
      "5-mid": "3.47",
      "5-bound": [3.11, 3.88],
      "10-mid": "4.2",
      "10-bound": [3.75, 4.69],
      "25-mid": "5.11",
      "25-bound": [4.54, 5.7],
      "50-mid": "5.98",
      "50-bound": [5.28, 6.65],
      "100-mid": "6.88",
      "100-bound": [6.02, 7.64]
    },
    "12hr": {
      "2-mid": "3.32",
      "2-bound": [2.96, 3.73],
      "5-mid": "4.1",
      "5-bound": [3.65, 4.61],
      "10-mid": "4.98",
      "10-bound": [4.42, 5.6],
      "25-mid": "6.1",
      "25-bound": [5.38, 6.84],
      "50-mid": "7.2",
      "50-bound": [6.3, 8.06],
      "100-mid": "8.34",
      "100-bound": [7.23, 9.31]
    },
    "24hr": {
      "2-mid": "3.74",
      "2-bound": [3.45, 4.08],
      "5-mid": "4.82",
      "5-bound": [4.44, 5.27],
      "10-mid": "5.74",
      "10-bound": [5.26, 6.25],
      "25-mid": "7.09",
      "25-bound": [6.46, 7.71],
      "50-mid": "8.26",
      "50-bound": [7.46, 8.97],
      "100-mid": "9.54",
      "100-bound": [8.52, 10.4]
    },
    "2day": {
      "2-mid": "4.35",
      "2-bound": [4.04, 4.73],
      "5-mid": "5.59",
      "5-bound": [5.18, 6.07],
      "10-mid": "6.65",
      "10-bound": [6.13, 7.21],
      "25-mid": "8.25",
      "25-bound": [7.54, 8.91],
      "50-mid": "9.62",
      "50-bound": [8.72, 10.4],
      "100-mid": "11.2",
      "100-bound": [10.0, 12.1]
    },
    "3day": {
      "2-mid": "4.65",
      "2-bound": [4.33, 5.03],
      "5-mid": "5.94",
      "5-bound": [5.52, 6.42],
      "10-mid": "7.04",
      "10-bound": [6.51, 7.58],
      "25-mid": "8.65",
      "25-bound": [7.94, 9.31],
      "50-mid": "10.0",
      "50-bound": [9.13, 10.8],
      "100-mid": "11.5",
      "100-bound": [10.4, 12.4]
    },
    "4day": {
      "2-mid": "4.95",
      "2-bound": [4.62, 5.33],
      "5-mid": "6.3",
      "5-bound": [5.87, 6.77],
      "10-mid": "7.42",
      "10-bound": [6.89, 7.96],
      "25-mid": "9.05",
      "25-bound": [8.35, 9.72],
      "50-mid": "10.4",
      "50-bound": [9.54, 11.2],
      "100-mid": "11.9",
      "100-bound": [10.8, 12.8]
    },
    "7day": {
      "2-mid": "5.81",
      "2-bound": [5.45, 6.23],
      "5-mid": "7.31",
      "5-bound": [6.84, 7.82],
      "10-mid": "8.55",
      "10-bound": [7.97, 9.12],
      "25-mid": "10.3",
      "25-bound": [9.57, 11.0],
      "50-mid": "11.8",
      "50-bound": [10.9, 12.6],
      "100-mid": "13.4",
      "100-bound": [12.2, 14.3]
    }
  },
  "USC00364214 6": {
    "fips": "42063",
    "station_name": "INDIANA 3 SE",
    "state": "PA",
    "latitude": "40.5970",
    "longitude": "-79.1180",
    "5min": {
      "2-mid": "0.38",
      "2-bound": [0.35, 0.42],
      "5-mid": "0.46",
      "5-bound": [0.42, 0.51],
      "10-mid": "0.53",
      "10-bound": [0.48, 0.58],
      "25-mid": "0.61",
      "25-bound": [0.55, 0.67],
      "50-mid": "0.67",
      "50-bound": [0.6, 0.73],
      "100-mid": "0.73",
      "100-bound": [0.65, 0.8]
    },
    "10min": {
      "2-mid": "0.6",
      "2-bound": [0.55, 0.66],
      "5-mid": "0.72",
      "5-bound": [0.66, 0.79],
      "10-mid": "0.81",
      "10-bound": [0.74, 0.89],
      "25-mid": "0.93",
      "25-bound": [0.84, 1.02],
      "50-mid": "1.01",
      "50-bound": [0.91, 1.11],
      "100-mid": "1.1",
      "100-bound": [0.98, 1.2]
    },
    "15min": {
      "2-mid": "0.73",
      "2-bound": [0.67, 0.81],
      "5-mid": "0.89",
      "5-bound": [0.8, 0.97],
      "10-mid": "1.0",
      "10-bound": [0.91, 1.1],
      "25-mid": "1.15",
      "25-bound": [1.03, 1.26],
      "50-mid": "1.26",
      "50-bound": [1.13, 1.38],
      "100-mid": "1.36",
      "100-bound": [1.22, 1.49]
    },
    "30min": {
      "2-mid": "0.98",
      "2-bound": [0.89, 1.08],
      "5-mid": "1.21",
      "5-bound": [1.1, 1.33],
      "10-mid": "1.39",
      "10-bound": [1.26, 1.52],
      "25-mid": "1.62",
      "25-bound": [1.46, 1.78],
      "50-mid": "1.79",
      "50-bound": [1.61, 1.96],
      "100-mid": "1.97",
      "100-bound": [1.76, 2.15]
    },
    "60min": {
      "2-mid": "1.2",
      "2-bound": [1.1, 1.33],
      "5-mid": "1.52",
      "5-bound": [1.38, 1.67],
      "10-mid": "1.77",
      "10-bound": [1.6, 1.94],
      "25-mid": "2.1",
      "25-bound": [1.89, 2.3],
      "50-mid": "2.36",
      "50-bound": [2.12, 2.59],
      "100-mid": "2.63",
      "100-bound": [2.36, 2.88]
    },
    "2hr": {
      "2-mid": "1.4",
      "2-bound": [1.27, 1.53],
      "5-mid": "1.76",
      "5-bound": [1.61, 1.94],
      "10-mid": "2.05",
      "10-bound": [1.86, 2.25],
      "25-mid": "2.45",
      "25-bound": [2.22, 2.68],
      "50-mid": "2.77",
      "50-bound": [2.5, 3.03],
      "100-mid": "3.11",
      "100-bound": [2.79, 3.4]
    },
    "3hr": {
      "2-mid": "1.5",
      "2-bound": [1.37, 1.66],
      "5-mid": "1.89",
      "5-bound": [1.72, 2.08],
      "10-mid": "2.2",
      "10-bound": [2.0, 2.41],
      "25-mid": "2.63",
      "25-bound": [2.38, 2.88],
      "50-mid": "2.99",
      "50-bound": [2.69, 3.27],
      "100-mid": "3.36",
      "100-bound": [3.0, 3.66]
    },
    "6hr": {
      "2-mid": "1.8",
      "2-bound": [1.65, 1.99],
      "5-mid": "2.24",
      "5-bound": [2.05, 2.47],
      "10-mid": "2.6",
      "10-bound": [2.37, 2.87],
      "25-mid": "3.12",
      "25-bound": [2.83, 3.42],
      "50-mid": "3.55",
      "50-bound": [3.2, 3.88],
      "100-mid": "4.0",
      "100-bound": [3.59, 4.37]
    },
    "12hr": {
      "2-mid": "2.19",
      "2-bound": [2.01, 2.41],
      "5-mid": "2.7",
      "5-bound": [2.48, 2.98],
      "10-mid": "3.13",
      "10-bound": [2.86, 3.44],
      "25-mid": "3.75",
      "25-bound": [3.41, 4.11],
      "50-mid": "4.26",
      "50-bound": [3.85, 4.66],
      "100-mid": "4.82",
      "100-bound": [4.32, 5.25]
    },
    "24hr": {
      "2-mid": "2.58",
      "2-bound": [2.38, 2.81],
      "5-mid": "3.16",
      "5-bound": [2.92, 3.44],
      "10-mid": "3.64",
      "10-bound": [3.36, 3.96],
      "25-mid": "4.33",
      "25-bound": [3.97, 4.7],
      "50-mid": "4.9",
      "50-bound": [4.48, 5.3],
      "100-mid": "5.5",
      "100-bound": [5.0, 5.95]
    },
    "2day": {
      "2-mid": "2.98",
      "2-bound": [2.77, 3.24],
      "5-mid": "3.62",
      "5-bound": [3.36, 3.93],
      "10-mid": "4.15",
      "10-bound": [3.84, 4.49],
      "25-mid": "4.88",
      "25-bound": [4.5, 5.27],
      "50-mid": "5.48",
      "50-bound": [5.04, 5.92],
      "100-mid": "6.11",
      "100-bound": [5.59, 6.59]
    },
    "3day": {
      "2-mid": "3.19",
      "2-bound": [2.97, 3.45],
      "5-mid": "3.85",
      "5-bound": [3.58, 4.16],
      "10-mid": "4.39",
      "10-bound": [4.07, 4.73],
      "25-mid": "5.14",
      "25-bound": [4.75, 5.54],
      "50-mid": "5.75",
      "50-bound": [5.3, 6.19],
      "100-mid": "6.38",
      "100-bound": [5.86, 6.87]
    },
    "4day": {
      "2-mid": "3.4",
      "2-bound": [3.18, 3.67],
      "5-mid": "4.08",
      "5-bound": [3.8, 4.39],
      "10-mid": "4.63",
      "10-bound": [4.31, 4.98],
      "25-mid": "5.39",
      "25-bound": [5.0, 5.8],
      "50-mid": "6.01",
      "50-bound": [5.56, 6.46],
      "100-mid": "6.65",
      "100-bound": [6.13, 7.15]
    },
    "7day": {
      "2-mid": "4.1",
      "2-bound": [3.85, 4.39],
      "5-mid": "4.85",
      "5-bound": [4.56, 5.19],
      "10-mid": "5.46",
      "10-bound": [5.11, 5.83],
      "25-mid": "6.28",
      "25-bound": [5.87, 6.7],
      "50-mid": "6.93",
      "50-bound": [6.46, 7.39],
      "100-mid": "7.59",
      "100-bound": [7.05, 8.09]
    }
  },
  "USC00185865 6": {
    "fips": "24037",
    "station_name": "MECHANICSVILLE 5 NE",
    "state": "MD",
    "latitude": "38.4920",
    "longitude": "-76.7250",
    "5min": {
      "2-mid": "0.43",
      "2-bound": [0.39, 0.48],
      "5-mid": "0.52",
      "5-bound": [0.47, 0.57],
      "10-mid": "0.58",
      "10-bound": [0.52, 0.64],
      "25-mid": "0.65",
      "25-bound": [0.59, 0.72],
      "50-mid": "0.71",
      "50-bound": [0.63, 0.79],
      "100-mid": "0.77",
      "100-bound": [0.68, 0.85]
    },
    "10min": {
      "2-mid": "0.7",
      "2-bound": [0.63, 0.77],
      "5-mid": "0.83",
      "5-bound": [0.75, 0.91],
      "10-mid": "0.92",
      "10-bound": [0.83, 1.02],
      "25-mid": "1.04",
      "25-bound": [0.93, 1.15],
      "50-mid": "1.13",
      "50-bound": [1.01, 1.25],
      "100-mid": "1.22",
      "100-bound": [1.08, 1.35]
    },
    "15min": {
      "2-mid": "0.88",
      "2-bound": [0.79, 0.96],
      "5-mid": "1.05",
      "5-bound": [0.95, 1.16],
      "10-mid": "1.17",
      "10-bound": [1.05, 1.29],
      "25-mid": "1.32",
      "25-bound": [1.18, 1.46],
      "50-mid": "1.43",
      "50-bound": [1.28, 1.58],
      "100-mid": "1.54",
      "100-bound": [1.37, 1.7]
    },
    "30min": {
      "2-mid": "1.21",
      "2-bound": [1.1, 1.33],
      "5-mid": "1.49",
      "5-bound": [1.35, 1.64],
      "10-mid": "1.69",
      "10-bound": [1.53, 1.86],
      "25-mid": "1.96",
      "25-bound": [1.75, 2.16],
      "50-mid": "2.16",
      "50-bound": [1.93, 2.38],
      "100-mid": "2.36",
      "100-bound": [2.09, 2.61]
    },
    "60min": {
      "2-mid": "1.52",
      "2-bound": [1.37, 1.67],
      "5-mid": "1.91",
      "5-bound": [1.73, 2.1],
      "10-mid": "2.2",
      "10-bound": [1.99, 2.43],
      "25-mid": "2.6",
      "25-bound": [2.34, 2.87],
      "50-mid": "2.92",
      "50-bound": [2.61, 3.23],
      "100-mid": "3.25",
      "100-bound": [2.88, 3.6]
    },
    "2hr": {
      "2-mid": "1.84",
      "2-bound": [1.66, 2.04],
      "5-mid": "2.32",
      "5-bound": [2.1, 2.57],
      "10-mid": "2.7",
      "10-bound": [2.43, 2.98],
      "25-mid": "3.23",
      "25-bound": [2.89, 3.57],
      "50-mid": "3.66",
      "50-bound": [3.26, 4.05],
      "100-mid": "4.11",
      "100-bound": [3.64, 4.57]
    },
    "3hr": {
      "2-mid": "2.0",
      "2-bound": [1.8, 2.22],
      "5-mid": "2.53",
      "5-bound": [2.27, 2.81],
      "10-mid": "2.95",
      "10-bound": [2.64, 3.28],
      "25-mid": "3.55",
      "25-bound": [3.15, 3.94],
      "50-mid": "4.05",
      "50-bound": [3.56, 4.5],
      "100-mid": "4.57",
      "100-bound": [4.0, 5.09]
    },
    "6hr": {
      "2-mid": "2.44",
      "2-bound": [2.2, 2.72],
      "5-mid": "3.08",
      "5-bound": [2.77, 3.43],
      "10-mid": "3.61",
      "10-bound": [3.23, 4.01],
      "25-mid": "4.38",
      "25-bound": [3.89, 4.87],
      "50-mid": "5.04",
      "50-bound": [4.44, 5.62],
      "100-mid": "5.75",
      "100-bound": [5.02, 6.43]
    },
    "12hr": {
      "2-mid": "2.92",
      "2-bound": [2.61, 3.29],
      "5-mid": "3.71",
      "5-bound": [3.31, 4.17],
      "10-mid": "4.38",
      "10-bound": [3.89, 4.93],
      "25-mid": "5.41",
      "25-bound": [4.76, 6.08],
      "50-mid": "6.31",
      "50-bound": [5.5, 7.1],
      "100-mid": "7.32",
      "100-bound": [6.29, 8.25]
    },
    "24hr": {
      "2-mid": "3.46",
      "2-bound": [3.12, 3.88],
      "5-mid": "4.49",
      "5-bound": [4.05, 5.03],
      "10-mid": "5.39",
      "10-bound": [4.84, 6.02],
      "25-mid": "6.75",
      "25-bound": [6.02, 7.51],
      "50-mid": "7.95",
      "50-bound": [7.04, 8.82],
      "100-mid": "9.31",
      "100-bound": [8.17, 10.3]
    },
    "2day": {
      "2-mid": "3.92",
      "2-bound": [3.53, 4.39],
      "5-mid": "5.08",
      "5-bound": [4.57, 5.7],
      "10-mid": "6.08",
      "10-bound": [5.45, 6.8],
      "25-mid": "7.59",
      "25-bound": [6.76, 8.47],
      "50-mid": "8.92",
      "50-bound": [7.89, 9.92],
      "100-mid": "10.4",
      "100-bound": [9.12, 11.6]
    },
    "3day": {
      "2-mid": "4.15",
      "2-bound": [3.75, 4.63],
      "5-mid": "5.36",
      "5-bound": [4.84, 5.98],
      "10-mid": "6.4",
      "10-bound": [5.76, 7.12],
      "25-mid": "7.96",
      "25-bound": [7.12, 8.83],
      "50-mid": "9.31",
      "50-bound": [8.28, 10.3],
      "100-mid": "10.8",
      "100-bound": [9.54, 12.0]
    },
    "4day": {
      "2-mid": "4.38",
      "2-bound": [3.98, 4.87],
      "5-mid": "5.64",
      "5-bound": [5.11, 6.26],
      "10-mid": "6.72",
      "10-bound": [6.07, 7.44],
      "25-mid": "8.32",
      "25-bound": [7.47, 9.2],
      "50-mid": "9.71",
      "50-bound": [8.67, 10.7],
      "100-mid": "11.2",
      "100-bound": [9.96, 12.4]
    },
    "7day": {
      "2-mid": "5.04",
      "2-bound": [4.62, 5.54],
      "5-mid": "6.39",
      "5-bound": [5.86, 7.01],
      "10-mid": "7.53",
      "10-bound": [6.89, 8.26],
      "25-mid": "9.22",
      "25-bound": [8.39, 10.1],
      "50-mid": "10.7",
      "50-bound": [9.66, 11.6],
      "100-mid": "12.3",
      "100-bound": [11.0, 13.4]
    }
  },
  "USC00301110 6": {
    "fips": "36065",
    "station_name": "CAMDEN",
    "state": "NY",
    "latitude": "43.3300",
    "longitude": "-75.8410",
    "5min": {
      "2-mid": "0.34",
      "2-bound": [0.28, 0.42],
      "5-mid": "0.43",
      "5-bound": [0.35, 0.53],
      "10-mid": "0.5",
      "10-bound": [0.41, 0.62],
      "25-mid": "0.6",
      "25-bound": [0.47, 0.76],
      "50-mid": "0.68",
      "50-bound": [0.52, 0.86],
      "100-mid": "0.76",
      "100-bound": [0.56, 0.98]
    },
    "10min": {
      "2-mid": "0.49",
      "2-bound": [0.4, 0.59],
      "5-mid": "0.61",
      "5-bound": [0.49, 0.75],
      "10-mid": "0.71",
      "10-bound": [0.57, 0.87],
      "25-mid": "0.86",
      "25-bound": [0.67, 1.07],
      "50-mid": "0.96",
      "50-bound": [0.74, 1.22],
      "100-mid": "1.07",
      "100-bound": [0.8, 1.39]
    },
    "15min": {
      "2-mid": "0.57",
      "2-bound": [0.47, 0.7],
      "5-mid": "0.72",
      "5-bound": [0.58, 0.88],
      "10-mid": "0.84",
      "10-bound": [0.68, 1.03],
      "25-mid": "1.01",
      "25-bound": [0.79, 1.26],
      "50-mid": "1.13",
      "50-bound": [0.87, 1.44],
      "100-mid": "1.26",
      "100-bound": [0.94, 1.63]
    },
    "30min": {
      "2-mid": "0.8",
      "2-bound": [0.65, 0.98],
      "5-mid": "1.0",
      "5-bound": [0.81, 1.22],
      "10-mid": "1.17",
      "10-bound": [0.94, 1.43],
      "25-mid": "1.4",
      "25-bound": [1.09, 1.75],
      "50-mid": "1.57",
      "50-bound": [1.2, 1.99],
      "100-mid": "1.75",
      "100-bound": [1.3, 2.26]
    },
    "60min": {
      "2-mid": "1.03",
      "2-bound": [0.84, 1.26],
      "5-mid": "1.28",
      "5-bound": [1.04, 1.57],
      "10-mid": "1.5",
      "10-bound": [1.21, 1.83],
      "25-mid": "1.79",
      "25-bound": [1.4, 2.24],
      "50-mid": "2.01",
      "50-bound": [1.54, 2.54],
      "100-mid": "2.24",
      "100-bound": [1.67, 2.89]
    },
    "2hr": {
      "2-mid": "1.34",
      "2-bound": [1.09, 1.62],
      "5-mid": "1.67",
      "5-bound": [1.36, 2.02],
      "10-mid": "1.94",
      "10-bound": [1.58, 2.36],
      "25-mid": "2.32",
      "25-bound": [1.83, 2.89],
      "50-mid": "2.61",
      "50-bound": [2.02, 3.29],
      "100-mid": "2.91",
      "100-bound": [2.18, 3.74]
    },
    "3hr": {
      "2-mid": "1.53",
      "2-bound": [1.25, 1.84],
      "5-mid": "1.91",
      "5-bound": [1.56, 2.31],
      "10-mid": "2.22",
      "10-bound": [1.81, 2.7],
      "25-mid": "2.66",
      "25-bound": [2.1, 3.3],
      "50-mid": "2.99",
      "50-bound": [2.32, 3.75],
      "100-mid": "3.33",
      "100-bound": [2.51, 4.26]
    },
    "6hr": {
      "2-mid": "1.88",
      "2-bound": [1.55, 2.24],
      "5-mid": "2.34",
      "5-bound": [1.92, 2.8],
      "10-mid": "2.72",
      "10-bound": [2.23, 3.27],
      "25-mid": "3.25",
      "25-bound": [2.58, 4.01],
      "50-mid": "3.65",
      "50-bound": [2.85, 4.55],
      "100-mid": "4.06",
      "100-bound": [3.09, 5.18]
    },
    "12hr": {
      "2-mid": "2.24",
      "2-bound": [1.86, 2.66],
      "5-mid": "2.77",
      "5-bound": [2.3, 3.3],
      "10-mid": "3.22",
      "10-bound": [2.66, 3.85],
      "25-mid": "3.84",
      "25-bound": [3.08, 4.7],
      "50-mid": "4.3",
      "50-bound": [3.38, 5.34],
      "100-mid": "4.79",
      "100-bound": [3.67, 6.06]
    },
    "24hr": {
      "2-mid": "2.63",
      "2-bound": [2.2, 3.11],
      "5-mid": "3.24",
      "5-bound": [2.71, 3.84],
      "10-mid": "3.75",
      "10-bound": [3.11, 4.45],
      "25-mid": "4.44",
      "25-bound": [3.58, 5.4],
      "50-mid": "4.97",
      "50-bound": [3.93, 6.11],
      "100-mid": "5.52",
      "100-bound": [4.25, 6.93]
    },
    "2day": {
      "2-mid": "3.12",
      "2-bound": [2.62, 3.66],
      "5-mid": "3.79",
      "5-bound": [3.18, 4.45],
      "10-mid": "4.34",
      "10-bound": [3.63, 5.12],
      "25-mid": "5.11",
      "25-bound": [4.15, 6.16],
      "50-mid": "5.7",
      "50-bound": [4.53, 6.94],
      "100-mid": "6.29",
      "100-bound": [4.87, 7.82]
    },
    "3day": {
      "2-mid": "3.47",
      "2-bound": [2.94, 4.06],
      "5-mid": "4.18",
      "5-bound": [3.52, 4.89],
      "10-mid": "4.76",
      "10-bound": [3.99, 5.59],
      "25-mid": "5.56",
      "25-bound": [4.53, 6.68],
      "50-mid": "6.17",
      "50-bound": [4.93, 7.49],
      "100-mid": "6.8",
      "100-bound": [5.27, 8.4]
    },
    "4day": {
      "2-mid": "3.77",
      "2-bound": [3.2, 4.4],
      "5-mid": "4.49",
      "5-bound": [3.8, 5.24],
      "10-mid": "5.09",
      "10-bound": [4.28, 5.96],
      "25-mid": "5.91",
      "25-bound": [4.82, 7.07],
      "50-mid": "6.54",
      "50-bound": [5.23, 7.9],
      "100-mid": "7.17",
      "100-bound": [5.58, 8.84]
    },
    "7day": {
      "2-mid": "4.54",
      "2-bound": [3.86, 5.26],
      "5-mid": "5.28",
      "5-bound": [4.48, 6.13],
      "10-mid": "5.89",
      "10-bound": [4.98, 6.86],
      "25-mid": "6.74",
      "25-bound": [5.53, 8.0],
      "50-mid": "7.39",
      "50-bound": [5.94, 8.87],
      "100-mid": "8.04",
      "100-bound": [6.28, 9.82]
    }
  },
  "USC00303773 6": {
    "fips": "36051",
    "station_name": "HEMLOCK",
    "state": "NY",
    "latitude": "42.7740",
    "longitude": "-77.6080",
    "5min": {
      "2-mid": "0.32",
      "2-bound": [0.25, 0.41],
      "5-mid": "0.41",
      "5-bound": [0.32, 0.53],
      "10-mid": "0.49",
      "10-bound": [0.38, 0.64],
      "25-mid": "0.6",
      "25-bound": [0.44, 0.8],
      "50-mid": "0.68",
      "50-bound": [0.49, 0.92],
      "100-mid": "0.76",
      "100-bound": [0.54, 1.07]
    },
    "10min": {
      "2-mid": "0.45",
      "2-bound": [0.35, 0.58],
      "5-mid": "0.58",
      "5-bound": [0.45, 0.75],
      "10-mid": "0.69",
      "10-bound": [0.53, 0.9],
      "25-mid": "0.84",
      "25-bound": [0.63, 1.14],
      "50-mid": "0.96",
      "50-bound": [0.7, 1.31],
      "100-mid": "1.08",
      "100-bound": [0.77, 1.52]
    },
    "15min": {
      "2-mid": "0.53",
      "2-bound": [0.41, 0.69],
      "5-mid": "0.69",
      "5-bound": [0.53, 0.89],
      "10-mid": "0.82",
      "10-bound": [0.62, 1.06],
      "25-mid": "0.99",
      "25-bound": [0.74, 1.34],
      "50-mid": "1.13",
      "50-bound": [0.82, 1.54],
      "100-mid": "1.27",
      "100-bound": [0.9, 1.78]
    },
    "30min": {
      "2-mid": "0.74",
      "2-bound": [0.57, 0.95],
      "5-mid": "0.95",
      "5-bound": [0.73, 1.23],
      "10-mid": "1.13",
      "10-bound": [0.86, 1.46],
      "25-mid": "1.37",
      "25-bound": [1.02, 1.84],
      "50-mid": "1.56",
      "50-bound": [1.13, 2.12],
      "100-mid": "1.75",
      "100-bound": [1.24, 2.46]
    },
    "60min": {
      "2-mid": "0.94",
      "2-bound": [0.72, 1.21],
      "5-mid": "1.21",
      "5-bound": [0.93, 1.57],
      "10-mid": "1.44",
      "10-bound": [1.1, 1.87],
      "25-mid": "1.75",
      "25-bound": [1.3, 2.35],
      "50-mid": "1.99",
      "50-bound": [1.45, 2.71],
      "100-mid": "2.24",
      "100-bound": [1.59, 3.15]
    },
    "2hr": {
      "2-mid": "1.15",
      "2-bound": [0.9, 1.47],
      "5-mid": "1.47",
      "5-bound": [1.14, 1.88],
      "10-mid": "1.74",
      "10-bound": [1.34, 2.23],
      "25-mid": "2.1",
      "25-bound": [1.58, 2.79],
      "50-mid": "2.38",
      "50-bound": [1.75, 3.21],
      "100-mid": "2.67",
      "100-bound": [1.92, 3.72]
    },
    "3hr": {
      "2-mid": "1.29",
      "2-bound": [1.01, 1.63],
      "5-mid": "1.64",
      "5-bound": [1.28, 2.07],
      "10-mid": "1.92",
      "10-bound": [1.5, 2.45],
      "25-mid": "2.32",
      "25-bound": [1.76, 3.06],
      "50-mid": "2.62",
      "50-bound": [1.94, 3.5],
      "100-mid": "2.93",
      "100-bound": [2.12, 4.05]
    },
    "6hr": {
      "2-mid": "1.56",
      "2-bound": [1.24, 1.94],
      "5-mid": "1.95",
      "5-bound": [1.55, 2.44],
      "10-mid": "2.28",
      "10-bound": [1.8, 2.87],
      "25-mid": "2.73",
      "25-bound": [2.09, 3.55],
      "50-mid": "3.07",
      "50-bound": [2.3, 4.05],
      "100-mid": "3.43",
      "100-bound": [2.51, 4.66]
    },
    "12hr": {
      "2-mid": "1.87",
      "2-bound": [1.5, 2.31],
      "5-mid": "2.32",
      "5-bound": [1.86, 2.87],
      "10-mid": "2.7",
      "10-bound": [2.15, 3.35],
      "25-mid": "3.21",
      "25-bound": [2.48, 4.11],
      "50-mid": "3.6",
      "50-bound": [2.73, 4.68],
      "100-mid": "4.0",
      "100-bound": [2.96, 5.35]
    },
    "24hr": {
      "2-mid": "2.2",
      "2-bound": [1.79, 2.68],
      "5-mid": "2.72",
      "5-bound": [2.21, 3.32],
      "10-mid": "3.15",
      "10-bound": [2.54, 3.86],
      "25-mid": "3.74",
      "25-bound": [2.93, 4.73],
      "50-mid": "4.19",
      "50-bound": [3.21, 5.37],
      "100-mid": "4.65",
      "100-bound": [3.47, 6.12]
    },
    "2day": {
      "2-mid": "2.53",
      "2-bound": [2.09, 3.05],
      "5-mid": "3.13",
      "5-bound": [2.57, 3.78],
      "10-mid": "3.62",
      "10-bound": [2.96, 4.39],
      "25-mid": "4.3",
      "25-bound": [3.41, 5.38],
      "50-mid": "4.82",
      "50-bound": [3.75, 6.11],
      "100-mid": "5.36",
      "100-bound": [4.05, 6.97]
    },
    "3day": {
      "2-mid": "2.77",
      "2-bound": [2.3, 3.32],
      "5-mid": "3.42",
      "5-bound": [2.83, 4.09],
      "10-mid": "3.95",
      "10-bound": [3.25, 4.75],
      "25-mid": "4.68",
      "25-bound": [3.74, 5.8],
      "50-mid": "5.23",
      "50-bound": [4.1, 6.57],
      "100-mid": "5.8",
      "100-bound": [4.42, 7.49]
    },
    "4day": {
      "2-mid": "2.98",
      "2-bound": [2.49, 3.55],
      "5-mid": "3.66",
      "5-bound": [3.04, 4.36],
      "10-mid": "4.21",
      "10-bound": [3.49, 5.04],
      "25-mid": "4.98",
      "25-bound": [4.0, 6.14],
      "50-mid": "5.56",
      "50-bound": [4.38, 6.95],
      "100-mid": "6.17",
      "100-bound": [4.72, 7.9]
    },
    "7day": {
      "2-mid": "3.52",
      "2-bound": [2.98, 4.15],
      "5-mid": "4.27",
      "5-bound": [3.59, 5.04],
      "10-mid": "4.89",
      "10-bound": [4.09, 5.8],
      "25-mid": "5.75",
      "25-bound": [4.66, 7.0],
      "50-mid": "6.39",
      "50-bound": [5.08, 7.89],
      "100-mid": "7.06",
      "100-bound": [5.45, 8.93]
    }
  },
  "USC00447506 6": {
    "fips": "51173",
    "station_name": "SALTVILLE 1N",
    "state": "VA",
    "latitude": "36.8890",
    "longitude": "-81.7710",
    "5min": {
      "2-mid": "0.34",
      "2-bound": [0.31, 0.39],
      "5-mid": "0.41",
      "5-bound": [0.36, 0.46],
      "10-mid": "0.46",
      "10-bound": [0.41, 0.52],
      "25-mid": "0.53",
      "25-bound": [0.47, 0.6],
      "50-mid": "0.59",
      "50-bound": [0.51, 0.67],
      "100-mid": "0.65",
      "100-bound": [0.56, 0.74]
    },
    "10min": {
      "2-mid": "0.55",
      "2-bound": [0.49, 0.62],
      "5-mid": "0.65",
      "5-bound": [0.58, 0.73],
      "10-mid": "0.74",
      "10-bound": [0.66, 0.83],
      "25-mid": "0.85",
      "25-bound": [0.75, 0.96],
      "50-mid": "0.94",
      "50-bound": [0.82, 1.06],
      "100-mid": "1.03",
      "100-bound": [0.89, 1.17]
    },
    "15min": {
      "2-mid": "0.69",
      "2-bound": [0.62, 0.78],
      "5-mid": "0.83",
      "5-bound": [0.74, 0.93],
      "10-mid": "0.93",
      "10-bound": [0.83, 1.05],
      "25-mid": "1.08",
      "25-bound": [0.95, 1.21],
      "50-mid": "1.19",
      "50-bound": [1.03, 1.34],
      "100-mid": "1.3",
      "100-bound": [1.12, 1.48]
    },
    "30min": {
      "2-mid": "0.96",
      "2-bound": [0.86, 1.08],
      "5-mid": "1.18",
      "5-bound": [1.05, 1.32],
      "10-mid": "1.35",
      "10-bound": [1.2, 1.52],
      "25-mid": "1.59",
      "25-bound": [1.4, 1.8],
      "50-mid": "1.79",
      "50-bound": [1.56, 2.02],
      "100-mid": "2.0",
      "100-bound": [1.72, 2.27]
    },
    "60min": {
      "2-mid": "1.2",
      "2-bound": [1.08, 1.35],
      "5-mid": "1.51",
      "5-bound": [1.35, 1.69],
      "10-mid": "1.76",
      "10-bound": [1.56, 1.98],
      "25-mid": "2.12",
      "25-bound": [1.86, 2.39],
      "50-mid": "2.43",
      "50-bound": [2.11, 2.74],
      "100-mid": "2.75",
      "100-bound": [2.36, 3.13]
    },
    "2hr": {
      "2-mid": "1.36",
      "2-bound": [1.22, 1.52],
      "5-mid": "1.7",
      "5-bound": [1.52, 1.91],
      "10-mid": "2.0",
      "10-bound": [1.78, 2.24],
      "25-mid": "2.46",
      "25-bound": [2.16, 2.76],
      "50-mid": "2.85",
      "50-bound": [2.48, 3.21],
      "100-mid": "3.28",
      "100-bound": [2.81, 3.72]
    },
    "3hr": {
      "2-mid": "1.45",
      "2-bound": [1.31, 1.63],
      "5-mid": "1.82",
      "5-bound": [1.63, 2.04],
      "10-mid": "2.13",
      "10-bound": [1.9, 2.39],
      "25-mid": "2.6",
      "25-bound": [2.29, 2.92],
      "50-mid": "3.01",
      "50-bound": [2.62, 3.4],
      "100-mid": "3.46",
      "100-bound": [2.97, 3.93]
    },
    "6hr": {
      "2-mid": "1.75",
      "2-bound": [1.59, 1.95],
      "5-mid": "2.16",
      "5-bound": [1.95, 2.4],
      "10-mid": "2.51",
      "10-bound": [2.26, 2.79],
      "25-mid": "3.02",
      "25-bound": [2.7, 3.37],
      "50-mid": "3.46",
      "50-bound": [3.06, 3.88],
      "100-mid": "3.94",
      "100-bound": [3.43, 4.43]
    },
    "12hr": {
      "2-mid": "2.11",
      "2-bound": [1.93, 2.34],
      "5-mid": "2.57",
      "5-bound": [2.34, 2.84],
      "10-mid": "2.95",
      "10-bound": [2.68, 3.26],
      "25-mid": "3.48",
      "25-bound": [3.14, 3.86],
      "50-mid": "3.92",
      "50-bound": [3.51, 4.36],
      "100-mid": "4.38",
      "100-bound": [3.89, 4.9]
    },
    "24hr": {
      "2-mid": "2.56",
      "2-bound": [2.38, 2.76],
      "5-mid": "3.1",
      "5-bound": [2.89, 3.34],
      "10-mid": "3.55",
      "10-bound": [3.3, 3.82],
      "25-mid": "4.19",
      "25-bound": [3.87, 4.5],
      "50-mid": "4.71",
      "50-bound": [4.32, 5.06],
      "100-mid": "5.27",
      "100-bound": [4.79, 5.66]
    },
    "2day": {
      "2-mid": "3.08",
      "2-bound": [2.88, 3.31],
      "5-mid": "3.7",
      "5-bound": [3.46, 3.98],
      "10-mid": "4.22",
      "10-bound": [3.93, 4.55],
      "25-mid": "4.94",
      "25-bound": [4.57, 5.34],
      "50-mid": "5.54",
      "50-bound": [5.09, 5.99],
      "100-mid": "6.16",
      "100-bound": [5.6, 6.68]
    },
    "3day": {
      "2-mid": "3.34",
      "2-bound": [3.13, 3.59],
      "5-mid": "4.01",
      "5-bound": [3.75, 4.3],
      "10-mid": "4.55",
      "10-bound": [4.25, 4.9],
      "25-mid": "5.32",
      "25-bound": [4.92, 5.72],
      "50-mid": "5.92",
      "50-bound": [5.46, 6.4],
      "100-mid": "6.56",
      "100-bound": [5.99, 7.11]
    },
    "4day": {
      "2-mid": "3.6",
      "2-bound": [3.38, 3.87],
      "5-mid": "4.32",
      "5-bound": [4.04, 4.63],
      "10-mid": "4.89",
      "10-bound": [4.57, 5.25],
      "25-mid": "5.69",
      "25-bound": [5.28, 6.11],
      "50-mid": "6.32",
      "50-bound": [5.83, 6.81],
      "100-mid": "6.97",
      "100-bound": [6.39, 7.54]
    },
    "7day": {
      "2-mid": "4.34",
      "2-bound": [4.08, 4.64],
      "5-mid": "5.15",
      "5-bound": [4.83, 5.5],
      "10-mid": "5.76",
      "10-bound": [5.39, 6.16],
      "25-mid": "6.57",
      "25-bound": [6.13, 7.04],
      "50-mid": "7.19",
      "50-bound": [6.68, 7.71],
      "100-mid": "7.79",
      "100-bound": [7.2, 8.38]
    }
  },
  "USC00182060 6": {
    "fips": "24025",
    "station_name": "CONOWINGO DAM",
    "state": "MD",
    "latitude": "39.6556",
    "longitude": "-76.1750",
    "5min": {
      "2-mid": "0.41",
      "2-bound": [0.36, 0.46],
      "5-mid": "0.48",
      "5-bound": [0.43, 0.54],
      "10-mid": "0.54",
      "10-bound": [0.48, 0.6],
      "25-mid": "0.6",
      "25-bound": [0.53, 0.68],
      "50-mid": "0.65",
      "50-bound": [0.57, 0.73],
      "100-mid": "0.69",
      "100-bound": [0.61, 0.78]
    },
    "10min": {
      "2-mid": "0.65",
      "2-bound": [0.58, 0.74],
      "5-mid": "0.77",
      "5-bound": [0.69, 0.87],
      "10-mid": "0.86",
      "10-bound": [0.76, 0.96],
      "25-mid": "0.96",
      "25-bound": [0.85, 1.08],
      "50-mid": "1.03",
      "50-bound": [0.91, 1.16],
      "100-mid": "1.1",
      "100-bound": [0.97, 1.24]
    },
    "15min": {
      "2-mid": "0.82",
      "2-bound": [0.73, 0.93],
      "5-mid": "0.98",
      "5-bound": [0.87, 1.1],
      "10-mid": "1.09",
      "10-bound": [0.96, 1.22],
      "25-mid": "1.22",
      "25-bound": [1.08, 1.37],
      "50-mid": "1.31",
      "50-bound": [1.15, 1.47],
      "100-mid": "1.4",
      "100-bound": [1.22, 1.57]
    },
    "30min": {
      "2-mid": "1.14",
      "2-bound": [1.01, 1.28],
      "5-mid": "1.39",
      "5-bound": [1.24, 1.56],
      "10-mid": "1.57",
      "10-bound": [1.4, 1.77],
      "25-mid": "1.8",
      "25-bound": [1.59, 2.02],
      "50-mid": "1.97",
      "50-bound": [1.74, 2.21],
      "100-mid": "2.14",
      "100-bound": [1.88, 2.4]
    },
    "60min": {
      "2-mid": "1.42",
      "2-bound": [1.27, 1.6],
      "5-mid": "1.78",
      "5-bound": [1.59, 2.0],
      "10-mid": "2.05",
      "10-bound": [1.82, 2.3],
      "25-mid": "2.4",
      "25-bound": [2.12, 2.69],
      "50-mid": "2.67",
      "50-bound": [2.35, 3.0],
      "100-mid": "2.94",
      "100-bound": [2.58, 3.31]
    },
    "2hr": {
      "2-mid": "1.72",
      "2-bound": [1.53, 1.92],
      "5-mid": "2.17",
      "5-bound": [1.93, 2.42],
      "10-mid": "2.52",
      "10-bound": [2.23, 2.81],
      "25-mid": "3.0",
      "25-bound": [2.65, 3.34],
      "50-mid": "3.39",
      "50-bound": [2.98, 3.78],
      "100-mid": "3.81",
      "100-bound": [3.33, 4.25]
    },
    "3hr": {
      "2-mid": "1.86",
      "2-bound": [1.68, 2.08],
      "5-mid": "2.35",
      "5-bound": [2.11, 2.62],
      "10-mid": "2.74",
      "10-bound": [2.45, 3.05],
      "25-mid": "3.27",
      "25-bound": [2.91, 3.64],
      "50-mid": "3.71",
      "50-bound": [3.29, 4.13],
      "100-mid": "4.18",
      "100-bound": [3.67, 4.64]
    },
    "6hr": {
      "2-mid": "2.31",
      "2-bound": [2.08, 2.58],
      "5-mid": "2.9",
      "5-bound": [2.61, 3.24],
      "10-mid": "3.4",
      "10-bound": [3.04, 3.79],
      "25-mid": "4.11",
      "25-bound": [3.66, 4.58],
      "50-mid": "4.71",
      "50-bound": [4.16, 5.24],
      "100-mid": "5.36",
      "100-bound": [4.69, 5.96]
    },
    "12hr": {
      "2-mid": "2.84",
      "2-bound": [2.53, 3.22],
      "5-mid": "3.6",
      "5-bound": [3.2, 4.08],
      "10-mid": "4.24",
      "10-bound": [3.76, 4.81],
      "25-mid": "5.21",
      "25-bound": [4.57, 5.9],
      "50-mid": "6.05",
      "50-bound": [5.26, 6.83],
      "100-mid": "6.99",
      "100-bound": [6.01, 7.89]
    },
    "24hr": {
      "2-mid": "3.26",
      "2-bound": [3.01, 3.57],
      "5-mid": "4.17",
      "5-bound": [3.85, 4.56],
      "10-mid": "4.98",
      "10-bound": [4.56, 5.43],
      "25-mid": "6.19",
      "25-bound": [5.63, 6.72],
      "50-mid": "7.26",
      "50-bound": [6.55, 7.86],
      "100-mid": "8.46",
      "100-bound": [7.56, 9.14]
    },
    "2day": {
      "2-mid": "3.8",
      "2-bound": [3.5, 4.16],
      "5-mid": "4.86",
      "5-bound": [4.46, 5.32],
      "10-mid": "5.76",
      "10-bound": [5.27, 6.29],
      "25-mid": "7.1",
      "25-bound": [6.46, 7.73],
      "50-mid": "8.26",
      "50-bound": [7.46, 8.97],
      "100-mid": "9.55",
      "100-bound": [8.55, 10.3]
    },
    "3day": {
      "2-mid": "3.99",
      "2-bound": [3.68, 4.36],
      "5-mid": "5.09",
      "5-bound": [4.68, 5.56],
      "10-mid": "6.02",
      "10-bound": [5.53, 6.57],
      "25-mid": "7.42",
      "25-bound": [6.76, 8.07],
      "50-mid": "8.63",
      "50-bound": [7.81, 9.36],
      "100-mid": "9.97",
      "100-bound": [8.95, 10.8]
    },
    "4day": {
      "2-mid": "4.17",
      "2-bound": [3.85, 4.55],
      "5-mid": "5.32",
      "5-bound": [4.9, 5.8],
      "10-mid": "6.3",
      "10-bound": [5.79, 6.84],
      "25-mid": "7.75",
      "25-bound": [7.07, 8.4],
      "50-mid": "9.0",
      "50-bound": [8.16, 9.75],
      "100-mid": "10.4",
      "100-bound": [9.35, 11.2]
    },
    "7day": {
      "2-mid": "4.86",
      "2-bound": [4.5, 5.28],
      "5-mid": "6.12",
      "5-bound": [5.67, 6.64],
      "10-mid": "7.2",
      "10-bound": [6.64, 7.8],
      "25-mid": "8.8",
      "25-bound": [8.06, 9.51],
      "50-mid": "10.2",
      "50-bound": [9.25, 11.0],
      "100-mid": "11.7",
      "100-bound": [10.6, 12.6]
    }
  },
  "USC00441136 6": {
    "fips": "51029",
    "station_name": "BUCKINGHAM",
    "state": "VA",
    "latitude": "37.5080",
    "longitude": "-78.5330",
    "5min": {
      "2-mid": "0.41",
      "2-bound": [0.37, 0.45],
      "5-mid": "0.47",
      "5-bound": [0.42, 0.52],
      "10-mid": "0.54",
      "10-bound": [0.48, 0.6],
      "25-mid": "0.6",
      "25-bound": [0.54, 0.67],
      "50-mid": "0.66",
      "50-bound": [0.59, 0.73],
      "100-mid": "0.71",
      "100-bound": [0.63, 0.78]
    },
    "10min": {
      "2-mid": "0.65",
      "2-bound": [0.59, 0.72],
      "5-mid": "0.76",
      "5-bound": [0.68, 0.84],
      "10-mid": "0.86",
      "10-bound": [0.77, 0.95],
      "25-mid": "0.96",
      "25-bound": [0.86, 1.06],
      "50-mid": "1.05",
      "50-bound": [0.93, 1.16],
      "100-mid": "1.12",
      "100-bound": [0.99, 1.24]
    },
    "15min": {
      "2-mid": "0.82",
      "2-bound": [0.74, 0.91],
      "5-mid": "0.96",
      "5-bound": [0.86, 1.06],
      "10-mid": "1.09",
      "10-bound": [0.98, 1.2],
      "25-mid": "1.22",
      "25-bound": [1.09, 1.35],
      "50-mid": "1.33",
      "50-bound": [1.18, 1.46],
      "100-mid": "1.42",
      "100-bound": [1.26, 1.57]
    },
    "30min": {
      "2-mid": "1.13",
      "2-bound": [1.02, 1.25],
      "5-mid": "1.36",
      "5-bound": [1.22, 1.51],
      "10-mid": "1.58",
      "10-bound": [1.42, 1.75],
      "25-mid": "1.81",
      "25-bound": [1.62, 2.0],
      "50-mid": "2.0",
      "50-bound": [1.78, 2.21],
      "100-mid": "2.17",
      "100-bound": [1.92, 2.4]
    },
    "60min": {
      "2-mid": "1.42",
      "2-bound": [1.28, 1.57],
      "5-mid": "1.74",
      "5-bound": [1.57, 1.94],
      "10-mid": "2.05",
      "10-bound": [1.84, 2.27],
      "25-mid": "2.41",
      "25-bound": [2.16, 2.66],
      "50-mid": "2.71",
      "50-bound": [2.41, 2.99],
      "100-mid": "2.99",
      "100-bound": [2.65, 3.3]
    },
    "2hr": {
      "2-mid": "1.69",
      "2-bound": [1.51, 1.89],
      "5-mid": "2.09",
      "5-bound": [1.87, 2.34],
      "10-mid": "2.48",
      "10-bound": [2.21, 2.77],
      "25-mid": "2.95",
      "25-bound": [2.61, 3.28],
      "50-mid": "3.35",
      "50-bound": [2.95, 3.73],
      "100-mid": "3.74",
      "100-bound": [3.28, 4.17]
    },
    "3hr": {
      "2-mid": "1.82",
      "2-bound": [1.62, 2.05],
      "5-mid": "2.25",
      "5-bound": [2.0, 2.53],
      "10-mid": "2.67",
      "10-bound": [2.37, 3.0],
      "25-mid": "3.17",
      "25-bound": [2.8, 3.56],
      "50-mid": "3.6",
      "50-bound": [3.17, 4.04],
      "100-mid": "4.03",
      "100-bound": [3.52, 4.51]
    },
    "6hr": {
      "2-mid": "2.27",
      "2-bound": [2.02, 2.57],
      "5-mid": "2.79",
      "5-bound": [2.48, 3.17],
      "10-mid": "3.32",
      "10-bound": [2.94, 3.76],
      "25-mid": "3.98",
      "25-bound": [3.5, 4.5],
      "50-mid": "4.58",
      "50-bound": [3.99, 5.16],
      "100-mid": "5.18",
      "100-bound": [4.48, 5.83]
    },
    "12hr": {
      "2-mid": "2.79",
      "2-bound": [2.49, 3.18],
      "5-mid": "3.45",
      "5-bound": [3.07, 3.91],
      "10-mid": "4.13",
      "10-bound": [3.66, 4.68],
      "25-mid": "5.01",
      "25-bound": [4.4, 5.65],
      "50-mid": "5.82",
      "50-bound": [5.06, 6.55],
      "100-mid": "6.67",
      "100-bound": [5.74, 7.48]
    },
    "24hr": {
      "2-mid": "3.38",
      "2-bound": [3.1, 3.75],
      "5-mid": "4.33",
      "5-bound": [3.95, 4.79],
      "10-mid": "5.12",
      "10-bound": [4.66, 5.66],
      "25-mid": "6.3",
      "25-bound": [5.68, 6.94],
      "50-mid": "7.31",
      "50-bound": [6.55, 8.04],
      "100-mid": "8.42",
      "100-bound": [7.49, 9.24]
    },
    "2day": {
      "2-mid": "3.97",
      "2-bound": [3.65, 4.35],
      "5-mid": "5.05",
      "5-bound": [4.63, 5.53],
      "10-mid": "5.94",
      "10-bound": [5.43, 6.49],
      "25-mid": "7.22",
      "25-bound": [6.57, 7.88],
      "50-mid": "8.3",
      "50-bound": [7.51, 9.05],
      "100-mid": "9.46",
      "100-bound": [8.51, 10.3]
    },
    "3day": {
      "2-mid": "4.21",
      "2-bound": [3.87, 4.62],
      "5-mid": "5.35",
      "5-bound": [4.91, 5.86],
      "10-mid": "6.29",
      "10-bound": [5.76, 6.88],
      "25-mid": "7.65",
      "25-bound": [6.96, 8.34],
      "50-mid": "8.79",
      "50-bound": [7.96, 9.58],
      "100-mid": "10.0",
      "100-bound": [9.0, 10.9]
    },
    "4day": {
      "2-mid": "4.46",
      "2-bound": [4.09, 4.88],
      "5-mid": "5.66",
      "5-bound": [5.19, 6.19],
      "10-mid": "6.65",
      "10-bound": [6.08, 7.27],
      "25-mid": "8.08",
      "25-bound": [7.35, 8.81],
      "50-mid": "9.28",
      "50-bound": [8.4, 10.1],
      "100-mid": "10.6",
      "100-bound": [9.5, 11.5]
    },
    "7day": {
      "2-mid": "5.11",
      "2-bound": [4.74, 5.54],
      "5-mid": "6.38",
      "5-bound": [5.91, 6.92],
      "10-mid": "7.43",
      "10-bound": [6.86, 8.05],
      "25-mid": "8.94",
      "25-bound": [8.2, 9.66],
      "50-mid": "10.2",
      "50-bound": [9.3, 11.0],
      "100-mid": "11.5",
      "100-bound": [10.4, 12.5]
    }
  },
  "USC00301152 6": {
    "fips": "36069",
    "station_name": "CANANDAIGUA 3 S",
    "state": "NY",
    "latitude": "42.8450",
    "longitude": "-77.2807",
    "5min": {
      "2-mid": "0.32",
      "2-bound": [0.26, 0.4],
      "5-mid": "0.42",
      "5-bound": [0.33, 0.52],
      "10-mid": "0.5",
      "10-bound": [0.39, 0.63],
      "25-mid": "0.6",
      "25-bound": [0.46, 0.8],
      "50-mid": "0.69",
      "50-bound": [0.51, 0.93],
      "100-mid": "0.77",
      "100-bound": [0.56, 1.08]
    },
    "10min": {
      "2-mid": "0.46",
      "2-bound": [0.37, 0.57],
      "5-mid": "0.59",
      "5-bound": [0.47, 0.74],
      "10-mid": "0.7",
      "10-bound": [0.56, 0.89],
      "25-mid": "0.86",
      "25-bound": [0.66, 1.13],
      "50-mid": "0.97",
      "50-bound": [0.72, 1.31],
      "100-mid": "1.09",
      "100-bound": [0.79, 1.54]
    },
    "15min": {
      "2-mid": "0.54",
      "2-bound": [0.43, 0.67],
      "5-mid": "0.7",
      "5-bound": [0.56, 0.87],
      "10-mid": "0.83",
      "10-bound": [0.66, 1.04],
      "25-mid": "1.01",
      "25-bound": [0.77, 1.33],
      "50-mid": "1.14",
      "50-bound": [0.85, 1.54],
      "100-mid": "1.28",
      "100-bound": [0.93, 1.81]
    },
    "30min": {
      "2-mid": "0.73",
      "2-bound": [0.58, 0.91],
      "5-mid": "0.94",
      "5-bound": [0.75, 1.18],
      "10-mid": "1.12",
      "10-bound": [0.89, 1.42],
      "25-mid": "1.37",
      "25-bound": [1.04, 1.81],
      "50-mid": "1.55",
      "50-bound": [1.16, 2.1],
      "100-mid": "1.74",
      "100-bound": [1.26, 2.45]
    },
    "60min": {
      "2-mid": "0.92",
      "2-bound": [0.74, 1.15],
      "5-mid": "1.19",
      "5-bound": [0.95, 1.5],
      "10-mid": "1.42",
      "10-bound": [1.12, 1.79],
      "25-mid": "1.72",
      "25-bound": [1.32, 2.28],
      "50-mid": "1.96",
      "50-bound": [1.46, 2.64],
      "100-mid": "2.2",
      "100-bound": [1.59, 3.1]
    },
    "2hr": {
      "2-mid": "1.13",
      "2-bound": [0.91, 1.4],
      "5-mid": "1.45",
      "5-bound": [1.17, 1.81],
      "10-mid": "1.72",
      "10-bound": [1.37, 2.16],
      "25-mid": "2.09",
      "25-bound": [1.6, 2.74],
      "50-mid": "2.37",
      "50-bound": [1.78, 3.16],
      "100-mid": "2.66",
      "100-bound": [1.93, 3.69]
    },
    "3hr": {
      "2-mid": "1.26",
      "2-bound": [1.02, 1.56],
      "5-mid": "1.62",
      "5-bound": [1.3, 2.01],
      "10-mid": "1.91",
      "10-bound": [1.53, 2.38],
      "25-mid": "2.31",
      "25-bound": [1.78, 3.01],
      "50-mid": "2.62",
      "50-bound": [1.97, 3.48],
      "100-mid": "2.94",
      "100-bound": [2.13, 4.04]
    },
    "6hr": {
      "2-mid": "1.52",
      "2-bound": [1.24, 1.86],
      "5-mid": "1.92",
      "5-bound": [1.56, 2.37],
      "10-mid": "2.26",
      "10-bound": [1.82, 2.8],
      "25-mid": "2.73",
      "25-bound": [2.11, 3.52],
      "50-mid": "3.08",
      "50-bound": [2.33, 4.05],
      "100-mid": "3.44",
      "100-bound": [2.51, 4.68]
    },
    "12hr": {
      "2-mid": "1.82",
      "2-bound": [1.49, 2.22],
      "5-mid": "2.28",
      "5-bound": [1.86, 2.79],
      "10-mid": "2.67",
      "10-bound": [2.16, 3.28],
      "25-mid": "3.2",
      "25-bound": [2.49, 4.09],
      "50-mid": "3.6",
      "50-bound": [2.74, 4.69],
      "100-mid": "4.01",
      "100-bound": [2.95, 5.41]
    },
    "24hr": {
      "2-mid": "2.15",
      "2-bound": [1.78, 2.61],
      "5-mid": "2.69",
      "5-bound": [2.21, 3.27],
      "10-mid": "3.13",
      "10-bound": [2.56, 3.83],
      "25-mid": "3.75",
      "25-bound": [2.94, 4.76],
      "50-mid": "4.21",
      "50-bound": [3.23, 5.44],
      "100-mid": "4.69",
      "100-bound": [3.47, 6.27]
    },
    "2day": {
      "2-mid": "2.53",
      "2-bound": [2.1, 3.05],
      "5-mid": "3.16",
      "5-bound": [2.61, 3.82],
      "10-mid": "3.68",
      "10-bound": [3.03, 4.47],
      "25-mid": "4.4",
      "25-bound": [3.48, 5.55],
      "50-mid": "4.94",
      "50-bound": [3.82, 6.34],
      "100-mid": "5.5",
      "100-bound": [4.11, 7.31]
    },
    "3day": {
      "2-mid": "2.8",
      "2-bound": [2.34, 3.36],
      "5-mid": "3.49",
      "5-bound": [2.89, 4.19],
      "10-mid": "4.05",
      "10-bound": [3.34, 4.9],
      "25-mid": "4.83",
      "25-bound": [3.84, 6.07],
      "50-mid": "5.42",
      "50-bound": [4.2, 6.93],
      "100-mid": "6.04",
      "100-bound": [4.53, 7.98]
    },
    "4day": {
      "2-mid": "3.02",
      "2-bound": [2.53, 3.62],
      "5-mid": "3.75",
      "5-bound": [3.12, 4.5],
      "10-mid": "4.35",
      "10-bound": [3.6, 5.24],
      "25-mid": "5.18",
      "25-bound": [4.12, 6.47],
      "50-mid": "5.8",
      "50-bound": [4.51, 7.38],
      "100-mid": "6.45",
      "100-bound": [4.85, 8.49]
    },
    "7day": {
      "2-mid": "3.59",
      "2-bound": [3.01, 4.26],
      "5-mid": "4.4",
      "5-bound": [3.68, 5.24],
      "10-mid": "5.06",
      "10-bound": [4.21, 6.06],
      "25-mid": "5.99",
      "25-bound": [4.79, 7.43],
      "50-mid": "6.68",
      "50-bound": [5.22, 8.44],
      "100-mid": "7.41",
      "100-bound": [5.58, 9.65]
    }
  },
  "USC00300785 6": {
    "fips": "36065",
    "station_name": "BOONVILLE 4 SSW",
    "state": "NY",
    "latitude": "43.4360",
    "longitude": "-75.3690",
    "5min": {
      "2-mid": "0.36",
      "2-bound": [0.3, 0.44],
      "5-mid": "0.46",
      "5-bound": [0.37, 0.56],
      "10-mid": "0.53",
      "10-bound": [0.43, 0.65],
      "25-mid": "0.64",
      "25-bound": [0.49, 0.8],
      "50-mid": "0.72",
      "50-bound": [0.54, 0.92],
      "100-mid": "0.8",
      "100-bound": [0.58, 1.05]
    },
    "10min": {
      "2-mid": "0.52",
      "2-bound": [0.42, 0.63],
      "5-mid": "0.65",
      "5-bound": [0.53, 0.79],
      "10-mid": "0.75",
      "10-bound": [0.61, 0.92],
      "25-mid": "0.9",
      "25-bound": [0.7, 1.14],
      "50-mid": "1.01",
      "50-bound": [0.77, 1.3],
      "100-mid": "1.13",
      "100-bound": [0.82, 1.48]
    },
    "15min": {
      "2-mid": "0.61",
      "2-bound": [0.5, 0.74],
      "5-mid": "0.76",
      "5-bound": [0.62, 0.93],
      "10-mid": "0.89",
      "10-bound": [0.72, 1.09],
      "25-mid": "1.06",
      "25-bound": [0.82, 1.34],
      "50-mid": "1.19",
      "50-bound": [0.9, 1.53],
      "100-mid": "1.33",
      "100-bound": [0.96, 1.74]
    },
    "30min": {
      "2-mid": "0.82",
      "2-bound": [0.67, 0.99],
      "5-mid": "1.02",
      "5-bound": [0.84, 1.25],
      "10-mid": "1.19",
      "10-bound": [0.97, 1.46],
      "25-mid": "1.42",
      "25-bound": [1.11, 1.8],
      "50-mid": "1.6",
      "50-bound": [1.21, 2.05],
      "100-mid": "1.78",
      "100-bound": [1.3, 2.35]
    },
    "60min": {
      "2-mid": "1.02",
      "2-bound": [0.84, 1.25],
      "5-mid": "1.28",
      "5-bound": [1.05, 1.56],
      "10-mid": "1.5",
      "10-bound": [1.22, 1.83],
      "25-mid": "1.79",
      "25-bound": [1.39, 2.26],
      "50-mid": "2.01",
      "50-bound": [1.53, 2.58],
      "100-mid": "2.24",
      "100-bound": [1.63, 2.95]
    },
    "2hr": {
      "2-mid": "1.34",
      "2-bound": [1.11, 1.62],
      "5-mid": "1.65",
      "5-bound": [1.36, 2.01],
      "10-mid": "1.92",
      "10-bound": [1.57, 2.34],
      "25-mid": "2.28",
      "25-bound": [1.8, 2.87],
      "50-mid": "2.55",
      "50-bound": [1.96, 3.27],
      "100-mid": "2.84",
      "100-bound": [2.1, 3.75]
    },
    "3hr": {
      "2-mid": "1.54",
      "2-bound": [1.28, 1.86],
      "5-mid": "1.9",
      "5-bound": [1.58, 2.3],
      "10-mid": "2.2",
      "10-bound": [1.81, 2.67],
      "25-mid": "2.61",
      "25-bound": [2.07, 3.28],
      "50-mid": "2.92",
      "50-bound": [2.26, 3.73],
      "100-mid": "3.25",
      "100-bound": [2.43, 4.29]
    },
    "6hr": {
      "2-mid": "1.93",
      "2-bound": [1.61, 2.31],
      "5-mid": "2.38",
      "5-bound": [1.99, 2.86],
      "10-mid": "2.76",
      "10-bound": [2.28, 3.33],
      "25-mid": "3.28",
      "25-bound": [2.62, 4.09],
      "50-mid": "3.66",
      "50-bound": [2.86, 4.66],
      "100-mid": "4.08",
      "100-bound": [3.08, 5.35]
    },
    "12hr": {
      "2-mid": "2.35",
      "2-bound": [1.98, 2.8],
      "5-mid": "2.92",
      "5-bound": [2.45, 3.48],
      "10-mid": "3.39",
      "10-bound": [2.83, 4.06],
      "25-mid": "4.04",
      "25-bound": [3.24, 5.0],
      "50-mid": "4.53",
      "50-bound": [3.55, 5.69],
      "100-mid": "5.04",
      "100-bound": [3.82, 6.53]
    },
    "24hr": {
      "2-mid": "2.79",
      "2-bound": [2.37, 3.3],
      "5-mid": "3.45",
      "5-bound": [2.91, 4.08],
      "10-mid": "3.99",
      "10-bound": [3.35, 4.74],
      "25-mid": "4.74",
      "25-bound": [3.83, 5.81],
      "50-mid": "5.3",
      "50-bound": [4.18, 6.6],
      "100-mid": "5.89",
      "100-bound": [4.48, 7.53]
    },
    "2day": {
      "2-mid": "3.26",
      "2-bound": [2.78, 3.82],
      "5-mid": "3.94",
      "5-bound": [3.35, 4.63],
      "10-mid": "4.5",
      "10-bound": [3.81, 5.32],
      "25-mid": "5.28",
      "25-bound": [4.3, 6.42],
      "50-mid": "5.88",
      "50-bound": [4.66, 7.24],
      "100-mid": "6.48",
      "100-bound": [4.96, 8.2]
    },
    "3day": {
      "2-mid": "3.59",
      "2-bound": [3.07, 4.19],
      "5-mid": "4.28",
      "5-bound": [3.66, 5.02],
      "10-mid": "4.86",
      "10-bound": [4.12, 5.72],
      "25-mid": "5.66",
      "25-bound": [4.62, 6.84],
      "50-mid": "6.27",
      "50-bound": [5.0, 7.69],
      "100-mid": "6.89",
      "100-bound": [5.29, 8.65]
    },
    "4day": {
      "2-mid": "3.87",
      "2-bound": [3.32, 4.51],
      "5-mid": "4.58",
      "5-bound": [3.92, 5.36],
      "10-mid": "5.18",
      "10-bound": [4.4, 6.07],
      "25-mid": "5.99",
      "25-bound": [4.91, 7.22],
      "50-mid": "6.61",
      "50-bound": [5.29, 8.08],
      "100-mid": "7.25",
      "100-bound": [5.58, 9.06]
    },
    "7day": {
      "2-mid": "4.64",
      "2-bound": [4.01, 5.38],
      "5-mid": "5.4",
      "5-bound": [4.65, 6.27],
      "10-mid": "6.03",
      "10-bound": [5.15, 7.03],
      "25-mid": "6.89",
      "25-bound": [5.68, 8.25],
      "50-mid": "7.55",
      "50-bound": [6.08, 9.16],
      "100-mid": "8.22",
      "100-bound": [6.38, 10.2]
    }
  },
  "USC00441082 6": {
    "fips": "51031",
    "station_name": "BROOKNEAL",
    "state": "VA",
    "latitude": "37.0670",
    "longitude": "-78.9510",
    "5min": {
      "2-mid": "0.42",
      "2-bound": [0.38, 0.46],
      "5-mid": "0.5",
      "5-bound": [0.45, 0.55],
      "10-mid": "0.55",
      "10-bound": [0.5, 0.61],
      "25-mid": "0.62",
      "25-bound": [0.56, 0.69],
      "50-mid": "0.67",
      "50-bound": [0.6, 0.74],
      "100-mid": "0.72",
      "100-bound": [0.64, 0.79]
    },
    "10min": {
      "2-mid": "0.67",
      "2-bound": [0.61, 0.74],
      "5-mid": "0.79",
      "5-bound": [0.72, 0.88],
      "10-mid": "0.89",
      "10-bound": [0.8, 0.98],
      "25-mid": "0.99",
      "25-bound": [0.89, 1.09],
      "50-mid": "1.07",
      "50-bound": [0.96, 1.18],
      "100-mid": "1.14",
      "100-bound": [1.02, 1.26]
    },
    "15min": {
      "2-mid": "0.84",
      "2-bound": [0.76, 0.93],
      "5-mid": "1.0",
      "5-bound": [0.91, 1.11],
      "10-mid": "1.12",
      "10-bound": [1.01, 1.24],
      "25-mid": "1.26",
      "25-bound": [1.13, 1.38],
      "50-mid": "1.35",
      "50-bound": [1.21, 1.49],
      "100-mid": "1.44",
      "100-bound": [1.28, 1.59]
    },
    "30min": {
      "2-mid": "1.16",
      "2-bound": [1.05, 1.29],
      "5-mid": "1.43",
      "5-bound": [1.29, 1.58],
      "10-mid": "1.62",
      "10-bound": [1.46, 1.79],
      "25-mid": "1.86",
      "25-bound": [1.68, 2.05],
      "50-mid": "2.04",
      "50-bound": [1.82, 2.24],
      "100-mid": "2.21",
      "100-bound": [1.97, 2.43]
    },
    "60min": {
      "2-mid": "1.46",
      "2-bound": [1.32, 1.61],
      "5-mid": "1.83",
      "5-bound": [1.65, 2.02],
      "10-mid": "2.12",
      "10-bound": [1.91, 2.33],
      "25-mid": "2.48",
      "25-bound": [2.23, 2.73],
      "50-mid": "2.76",
      "50-bound": [2.47, 3.04],
      "100-mid": "3.04",
      "100-bound": [2.71, 3.35]
    },
    "2hr": {
      "2-mid": "1.72",
      "2-bound": [1.55, 1.91],
      "5-mid": "2.17",
      "5-bound": [1.95, 2.4],
      "10-mid": "2.54",
      "10-bound": [2.28, 2.8],
      "25-mid": "3.02",
      "25-bound": [2.69, 3.32],
      "50-mid": "3.4",
      "50-bound": [3.02, 3.75],
      "100-mid": "3.8",
      "100-bound": [3.35, 4.18]
    },
    "3hr": {
      "2-mid": "1.84",
      "2-bound": [1.66, 2.05],
      "5-mid": "2.32",
      "5-bound": [2.09, 2.58],
      "10-mid": "2.71",
      "10-bound": [2.44, 3.0],
      "25-mid": "3.23",
      "25-bound": [2.88, 3.57],
      "50-mid": "3.64",
      "50-bound": [3.24, 4.02],
      "100-mid": "4.06",
      "100-bound": [3.59, 4.48]
    },
    "6hr": {
      "2-mid": "2.26",
      "2-bound": [2.04, 2.53],
      "5-mid": "2.85",
      "5-bound": [2.56, 3.18],
      "10-mid": "3.34",
      "10-bound": [2.99, 3.72],
      "25-mid": "4.01",
      "25-bound": [3.57, 4.46],
      "50-mid": "4.58",
      "50-bound": [4.04, 5.08],
      "100-mid": "5.17",
      "100-bound": [4.53, 5.73]
    },
    "12hr": {
      "2-mid": "2.75",
      "2-bound": [2.49, 3.08],
      "5-mid": "3.47",
      "5-bound": [3.13, 3.87],
      "10-mid": "4.1",
      "10-bound": [3.68, 4.56],
      "25-mid": "5.0",
      "25-bound": [4.45, 5.53],
      "50-mid": "5.76",
      "50-bound": [5.09, 6.36],
      "100-mid": "6.6",
      "100-bound": [5.76, 7.25]
    },
    "24hr": {
      "2-mid": "3.29",
      "2-bound": [3.0, 3.65],
      "5-mid": "4.21",
      "5-bound": [3.82, 4.66],
      "10-mid": "4.98",
      "10-bound": [4.51, 5.51],
      "25-mid": "6.13",
      "25-bound": [5.51, 6.75],
      "50-mid": "7.11",
      "50-bound": [6.36, 7.83],
      "100-mid": "8.19",
      "100-bound": [7.26, 8.99]
    },
    "2day": {
      "2-mid": "3.89",
      "2-bound": [3.56, 4.29],
      "5-mid": "4.93",
      "5-bound": [4.52, 5.44],
      "10-mid": "5.8",
      "10-bound": [5.3, 6.39],
      "25-mid": "7.06",
      "25-bound": [6.4, 7.78],
      "50-mid": "8.11",
      "50-bound": [7.32, 8.93],
      "100-mid": "9.24",
      "100-bound": [8.28, 10.2]
    },
    "3day": {
      "2-mid": "4.11",
      "2-bound": [3.77, 4.54],
      "5-mid": "5.22",
      "5-bound": [4.77, 5.76],
      "10-mid": "6.14",
      "10-bound": [5.59, 6.76],
      "25-mid": "7.46",
      "25-bound": [6.76, 8.22],
      "50-mid": "8.57",
      "50-bound": [7.72, 9.42],
      "100-mid": "9.76",
      "100-bound": [8.74, 10.7]
    },
    "4day": {
      "2-mid": "4.34",
      "2-bound": [3.97, 4.79],
      "5-mid": "5.51",
      "5-bound": [5.02, 6.07],
      "10-mid": "6.48",
      "10-bound": [5.89, 7.13],
      "25-mid": "7.87",
      "25-bound": [7.12, 8.66],
      "50-mid": "9.03",
      "50-bound": [8.13, 9.92],
      "100-mid": "10.3",
      "100-bound": [9.2, 11.3]
    },
    "7day": {
      "2-mid": "4.98",
      "2-bound": [4.57, 5.44],
      "5-mid": "6.22",
      "5-bound": [5.7, 6.78],
      "10-mid": "7.24",
      "10-bound": [6.63, 7.89],
      "25-mid": "8.7",
      "25-bound": [7.92, 9.48],
      "50-mid": "9.92",
      "50-bound": [8.97, 10.8],
      "100-mid": "11.2",
      "100-bound": [10.1, 12.2]
    }
  },
  "USC00442245 6": {
    "fips": "51590",
    "station_name": "DANVILLE 2 SE",
    "state": "VA",
    "latitude": "36.5626",
    "longitude": "-79.3633",
    "5min": {
      "2-mid": "0.44",
      "2-bound": [0.4, 0.48],
      "5-mid": "0.52",
      "5-bound": [0.47, 0.57],
      "10-mid": "0.57",
      "10-bound": [0.52, 0.63],
      "25-mid": "0.64",
      "25-bound": [0.58, 0.69],
      "50-mid": "0.68",
      "50-bound": [0.61, 0.74],
      "100-mid": "0.72",
      "100-bound": [0.65, 0.79]
    },
    "10min": {
      "2-mid": "0.7",
      "2-bound": [0.64, 0.77],
      "5-mid": "0.83",
      "5-bound": [0.76, 0.91],
      "10-mid": "0.92",
      "10-bound": [0.83, 1.0],
      "25-mid": "1.02",
      "25-bound": [0.92, 1.11],
      "50-mid": "1.08",
      "50-bound": [0.98, 1.18],
      "100-mid": "1.15",
      "100-bound": [1.03, 1.25]
    },
    "15min": {
      "2-mid": "0.88",
      "2-bound": [0.81, 0.97],
      "5-mid": "1.05",
      "5-bound": [0.95, 1.15],
      "10-mid": "1.16",
      "10-bound": [1.05, 1.27],
      "25-mid": "1.29",
      "25-bound": [1.17, 1.4],
      "50-mid": "1.37",
      "50-bound": [1.24, 1.49],
      "100-mid": "1.45",
      "100-bound": [1.3, 1.58]
    },
    "30min": {
      "2-mid": "1.22",
      "2-bound": [1.11, 1.34],
      "5-mid": "1.49",
      "5-bound": [1.36, 1.63],
      "10-mid": "1.68",
      "10-bound": [1.53, 1.83],
      "25-mid": "1.91",
      "25-bound": [1.73, 2.08],
      "50-mid": "2.06",
      "50-bound": [1.86, 2.25],
      "100-mid": "2.22",
      "100-bound": [1.99, 2.42]
    },
    "60min": {
      "2-mid": "1.53",
      "2-bound": [1.4, 1.68],
      "5-mid": "1.91",
      "5-bound": [1.74, 2.09],
      "10-mid": "2.19",
      "10-bound": [1.99, 2.39],
      "25-mid": "2.54",
      "25-bound": [2.3, 2.77],
      "50-mid": "2.8",
      "50-bound": [2.52, 3.05],
      "100-mid": "3.06",
      "100-bound": [2.74, 3.33]
    },
    "2hr": {
      "2-mid": "1.8",
      "2-bound": [1.64, 1.98],
      "5-mid": "2.26",
      "5-bound": [2.06, 2.48],
      "10-mid": "2.62",
      "10-bound": [2.37, 2.87],
      "25-mid": "3.08",
      "25-bound": [2.78, 3.37],
      "50-mid": "3.45",
      "50-bound": [3.09, 3.76],
      "100-mid": "3.82",
      "100-bound": [3.39, 4.16]
    },
    "3hr": {
      "2-mid": "1.93",
      "2-bound": [1.76, 2.13],
      "5-mid": "2.43",
      "5-bound": [2.21, 2.67],
      "10-mid": "2.81",
      "10-bound": [2.55, 3.08],
      "25-mid": "3.32",
      "25-bound": [2.99, 3.62],
      "50-mid": "3.7",
      "50-bound": [3.32, 4.04],
      "100-mid": "4.1",
      "100-bound": [3.66, 4.47]
    },
    "6hr": {
      "2-mid": "2.36",
      "2-bound": [2.15, 2.6],
      "5-mid": "2.96",
      "5-bound": [2.69, 3.26],
      "10-mid": "3.44",
      "10-bound": [3.12, 3.78],
      "25-mid": "4.1",
      "25-bound": [3.69, 4.5],
      "50-mid": "4.63",
      "50-bound": [4.14, 5.07],
      "100-mid": "5.19",
      "100-bound": [4.6, 5.67]
    },
    "12hr": {
      "2-mid": "2.83",
      "2-bound": [2.58, 3.12],
      "5-mid": "3.57",
      "5-bound": [3.25, 3.93],
      "10-mid": "4.18",
      "10-bound": [3.79, 4.59],
      "25-mid": "5.06",
      "25-bound": [4.54, 5.52],
      "50-mid": "5.77",
      "50-bound": [5.15, 6.29],
      "100-mid": "6.55",
      "100-bound": [5.78, 7.11]
    },
    "24hr": {
      "2-mid": "3.33",
      "2-bound": [3.1, 3.6],
      "5-mid": "4.22",
      "5-bound": [3.92, 4.55],
      "10-mid": "4.94",
      "10-bound": [4.59, 5.33],
      "25-mid": "6.0",
      "25-bound": [5.52, 6.45],
      "50-mid": "6.88",
      "50-bound": [6.29, 7.39],
      "100-mid": "7.82",
      "100-bound": [7.11, 8.42]
    },
    "2day": {
      "2-mid": "3.92",
      "2-bound": [3.65, 4.21],
      "5-mid": "4.92",
      "5-bound": [4.58, 5.28],
      "10-mid": "5.73",
      "10-bound": [5.32, 6.14],
      "25-mid": "6.88",
      "25-bound": [6.36, 7.36],
      "50-mid": "7.82",
      "50-bound": [7.2, 8.37],
      "100-mid": "8.82",
      "100-bound": [8.06, 9.45]
    },
    "3day": {
      "2-mid": "4.13",
      "2-bound": [3.85, 4.44],
      "5-mid": "5.19",
      "5-bound": [4.83, 5.57],
      "10-mid": "6.04",
      "10-bound": [5.61, 6.48],
      "25-mid": "7.25",
      "25-bound": [6.7, 7.77],
      "50-mid": "8.24",
      "50-bound": [7.58, 8.84],
      "100-mid": "9.29",
      "100-bound": [8.49, 9.98]
    },
    "4day": {
      "2-mid": "4.35",
      "2-bound": [4.05, 4.68],
      "5-mid": "5.45",
      "5-bound": [5.08, 5.86],
      "10-mid": "6.35",
      "10-bound": [5.9, 6.83],
      "25-mid": "7.62",
      "25-bound": [7.04, 8.18],
      "50-mid": "8.66",
      "50-bound": [7.96, 9.3],
      "100-mid": "9.76",
      "100-bound": [8.92, 10.5]
    },
    "7day": {
      "2-mid": "4.95",
      "2-bound": [4.65, 5.3],
      "5-mid": "6.12",
      "5-bound": [5.74, 6.54],
      "10-mid": "7.07",
      "10-bound": [6.61, 7.55],
      "25-mid": "8.41",
      "25-bound": [7.83, 8.98],
      "50-mid": "9.5",
      "50-bound": [8.8, 10.1],
      "100-mid": "10.6",
      "100-bound": [9.81, 11.4]
    }
  },
  "USC00466674 6": {
    "fips": "54065",
    "station_name": "CACAPON ST PRK # 2",
    "state": "WV",
    "latitude": "39.5093",
    "longitude": "-78.2973",
    "5min": {
      "2-mid": "0.38",
      "2-bound": [0.34, 0.42],
      "5-mid": "0.46",
      "5-bound": [0.41, 0.51],
      "10-mid": "0.52",
      "10-bound": [0.47, 0.58],
      "25-mid": "0.61",
      "25-bound": [0.54, 0.68],
      "50-mid": "0.68",
      "50-bound": [0.6, 0.75],
      "100-mid": "0.76",
      "100-bound": [0.67, 0.83]
    },
    "10min": {
      "2-mid": "0.59",
      "2-bound": [0.53, 0.66],
      "5-mid": "0.71",
      "5-bound": [0.64, 0.79],
      "10-mid": "0.81",
      "10-bound": [0.72, 0.89],
      "25-mid": "0.94",
      "25-bound": [0.83, 1.03],
      "50-mid": "1.04",
      "50-bound": [0.92, 1.14],
      "100-mid": "1.14",
      "100-bound": [1.0, 1.25]
    },
    "15min": {
      "2-mid": "0.72",
      "2-bound": [0.65, 0.8],
      "5-mid": "0.88",
      "5-bound": [0.79, 0.97],
      "10-mid": "0.99",
      "10-bound": [0.89, 1.1],
      "25-mid": "1.16",
      "25-bound": [1.03, 1.28],
      "50-mid": "1.28",
      "50-bound": [1.14, 1.41],
      "100-mid": "1.41",
      "100-bound": [1.24, 1.56]
    },
    "30min": {
      "2-mid": "0.96",
      "2-bound": [0.87, 1.07],
      "5-mid": "1.2",
      "5-bound": [1.08, 1.33],
      "10-mid": "1.38",
      "10-bound": [1.24, 1.53],
      "25-mid": "1.63",
      "25-bound": [1.45, 1.8],
      "50-mid": "1.83",
      "50-bound": [1.62, 2.02],
      "100-mid": "2.04",
      "100-bound": [1.8, 2.24]
    },
    "60min": {
      "2-mid": "1.18",
      "2-bound": [1.07, 1.32],
      "5-mid": "1.5",
      "5-bound": [1.35, 1.67],
      "10-mid": "1.75",
      "10-bound": [1.57, 1.94],
      "25-mid": "2.12",
      "25-bound": [1.88, 2.34],
      "50-mid": "2.41",
      "50-bound": [2.14, 2.66],
      "100-mid": "2.73",
      "100-bound": [2.4, 3.0]
    },
    "2hr": {
      "2-mid": "1.39",
      "2-bound": [1.24, 1.56],
      "5-mid": "1.77",
      "5-bound": [1.58, 1.98],
      "10-mid": "2.08",
      "10-bound": [1.85, 2.32],
      "25-mid": "2.53",
      "25-bound": [2.24, 2.81],
      "50-mid": "2.91",
      "50-bound": [2.55, 3.22],
      "100-mid": "3.32",
      "100-bound": [2.9, 3.66]
    },
    "3hr": {
      "2-mid": "1.5",
      "2-bound": [1.35, 1.67],
      "5-mid": "1.9",
      "5-bound": [1.7, 2.11],
      "10-mid": "2.22",
      "10-bound": [1.98, 2.47],
      "25-mid": "2.7",
      "25-bound": [2.39, 2.99],
      "50-mid": "3.1",
      "50-bound": [2.73, 3.42],
      "100-mid": "3.55",
      "100-bound": [3.11, 3.9]
    },
    "6hr": {
      "2-mid": "1.88",
      "2-bound": [1.71, 2.06],
      "5-mid": "2.35",
      "5-bound": [2.13, 2.57],
      "10-mid": "2.74",
      "10-bound": [2.48, 2.99],
      "25-mid": "3.3",
      "25-bound": [2.97, 3.6],
      "50-mid": "3.79",
      "50-bound": [3.39, 4.12],
      "100-mid": "4.32",
      "100-bound": [3.84, 4.69]
    },
    "12hr": {
      "2-mid": "2.32",
      "2-bound": [2.1, 2.57],
      "5-mid": "2.88",
      "5-bound": [2.6, 3.18],
      "10-mid": "3.35",
      "10-bound": [3.02, 3.69],
      "25-mid": "4.06",
      "25-bound": [3.63, 4.45],
      "50-mid": "4.67",
      "50-bound": [4.14, 5.1],
      "100-mid": "5.35",
      "100-bound": [4.71, 5.82]
    },
    "24hr": {
      "2-mid": "2.72",
      "2-bound": [2.5, 2.96],
      "5-mid": "3.38",
      "5-bound": [3.1, 3.68],
      "10-mid": "3.93",
      "10-bound": [3.6, 4.26],
      "25-mid": "4.73",
      "25-bound": [4.31, 5.11],
      "50-mid": "5.41",
      "50-bound": [4.9, 5.84],
      "100-mid": "6.15",
      "100-bound": [5.54, 6.62]
    },
    "2day": {
      "2-mid": "3.14",
      "2-bound": [2.9, 3.4],
      "5-mid": "3.9",
      "5-bound": [3.6, 4.22],
      "10-mid": "4.55",
      "10-bound": [4.18, 4.9],
      "25-mid": "5.5",
      "25-bound": [5.02, 5.92],
      "50-mid": "6.32",
      "50-bound": [5.73, 6.79],
      "100-mid": "7.22",
      "100-bound": [6.5, 7.73]
    },
    "3day": {
      "2-mid": "3.36",
      "2-bound": [3.12, 3.64],
      "5-mid": "4.17",
      "5-bound": [3.86, 4.5],
      "10-mid": "4.84",
      "10-bound": [4.46, 5.22],
      "25-mid": "5.82",
      "25-bound": [5.33, 6.26],
      "50-mid": "6.64",
      "50-bound": [6.05, 7.14],
      "100-mid": "7.54",
      "100-bound": [6.82, 8.09]
    },
    "4day": {
      "2-mid": "3.59",
      "2-bound": [3.33, 3.88],
      "5-mid": "4.43",
      "5-bound": [4.11, 4.78],
      "10-mid": "5.13",
      "10-bound": [4.74, 5.53],
      "25-mid": "6.14",
      "25-bound": [5.64, 6.6],
      "50-mid": "6.97",
      "50-bound": [6.37, 7.49],
      "100-mid": "7.86",
      "100-bound": [7.15, 8.44]
    },
    "7day": {
      "2-mid": "4.18",
      "2-bound": [3.89, 4.48],
      "5-mid": "5.1",
      "5-bound": [4.74, 5.46],
      "10-mid": "5.83",
      "10-bound": [5.42, 6.25],
      "25-mid": "6.85",
      "25-bound": [6.35, 7.34],
      "50-mid": "7.68",
      "50-bound": [7.09, 8.22],
      "100-mid": "8.53",
      "100-bound": [7.84, 9.14]
    }
  },
  "USC00441593 6": {
    "fips": "51003",
    "station_name": "CHARLOTTESVILLE 2W",
    "state": "VA",
    "latitude": "38.0320",
    "longitude": "-78.5220",
    "5min": {
      "2-mid": "0.42",
      "2-bound": [0.38, 0.47],
      "5-mid": "0.49",
      "5-bound": [0.44, 0.55],
      "10-mid": "0.55",
      "10-bound": [0.5, 0.61],
      "25-mid": "0.62",
      "25-bound": [0.56, 0.69],
      "50-mid": "0.68",
      "50-bound": [0.6, 0.75],
      "100-mid": "0.73",
      "100-bound": [0.64, 0.8]
    },
    "10min": {
      "2-mid": "0.67",
      "2-bound": [0.6, 0.74],
      "5-mid": "0.79",
      "5-bound": [0.71, 0.87],
      "10-mid": "0.88",
      "10-bound": [0.79, 0.98],
      "25-mid": "0.99",
      "25-bound": [0.89, 1.1],
      "50-mid": "1.08",
      "50-bound": [0.96, 1.19],
      "100-mid": "1.16",
      "100-bound": [1.02, 1.27]
    },
    "15min": {
      "2-mid": "0.84",
      "2-bound": [0.76, 0.94],
      "5-mid": "1.0",
      "5-bound": [0.9, 1.1],
      "10-mid": "1.12",
      "10-bound": [1.0, 1.24],
      "25-mid": "1.26",
      "25-bound": [1.12, 1.39],
      "50-mid": "1.36",
      "50-bound": [1.22, 1.5],
      "100-mid": "1.46",
      "100-bound": [1.29, 1.61]
    },
    "30min": {
      "2-mid": "1.16",
      "2-bound": [1.05, 1.29],
      "5-mid": "1.42",
      "5-bound": [1.28, 1.57],
      "10-mid": "1.62",
      "10-bound": [1.46, 1.79],
      "25-mid": "1.86",
      "25-bound": [1.67, 2.06],
      "50-mid": "2.06",
      "50-bound": [1.83, 2.26],
      "100-mid": "2.24",
      "100-bound": [1.98, 2.46]
    },
    "60min": {
      "2-mid": "1.46",
      "2-bound": [1.32, 1.62],
      "5-mid": "1.82",
      "5-bound": [1.64, 2.01],
      "10-mid": "2.11",
      "10-bound": [1.9, 2.34],
      "25-mid": "2.48",
      "25-bound": [2.22, 2.74],
      "50-mid": "2.78",
      "50-bound": [2.48, 3.07],
      "100-mid": "3.08",
      "100-bound": [2.73, 3.39]
    },
    "2hr": {
      "2-mid": "1.75",
      "2-bound": [1.54, 2.0],
      "5-mid": "2.19",
      "5-bound": [1.92, 2.5],
      "10-mid": "2.57",
      "10-bound": [2.26, 2.92],
      "25-mid": "3.07",
      "25-bound": [2.67, 3.48],
      "50-mid": "3.47",
      "50-bound": [3.01, 3.94],
      "100-mid": "3.9",
      "100-bound": [3.36, 4.41]
    },
    "3hr": {
      "2-mid": "1.92",
      "2-bound": [1.67, 2.2],
      "5-mid": "2.4",
      "5-bound": [2.09, 2.76],
      "10-mid": "2.81",
      "10-bound": [2.44, 3.22],
      "25-mid": "3.35",
      "25-bound": [2.9, 3.83],
      "50-mid": "3.8",
      "50-bound": [3.28, 4.34],
      "100-mid": "4.27",
      "100-bound": [3.65, 4.87]
    },
    "6hr": {
      "2-mid": "2.44",
      "2-bound": [2.16, 2.76],
      "5-mid": "3.04",
      "5-bound": [2.67, 3.43],
      "10-mid": "3.57",
      "10-bound": [3.13, 4.03],
      "25-mid": "4.29",
      "25-bound": [3.74, 4.84],
      "50-mid": "4.92",
      "50-bound": [4.25, 5.53],
      "100-mid": "5.58",
      "100-bound": [4.78, 6.27]
    },
    "12hr": {
      "2-mid": "3.07",
      "2-bound": [2.71, 3.51],
      "5-mid": "3.83",
      "5-bound": [3.37, 4.38],
      "10-mid": "4.53",
      "10-bound": [3.97, 5.17],
      "25-mid": "5.52",
      "25-bound": [4.79, 6.27],
      "50-mid": "6.39",
      "50-bound": [5.49, 7.25],
      "100-mid": "7.33",
      "100-bound": [6.23, 8.32]
    },
    "24hr": {
      "2-mid": "3.68",
      "2-bound": [3.32, 4.12],
      "5-mid": "4.71",
      "5-bound": [4.22, 5.26],
      "10-mid": "5.57",
      "10-bound": [4.98, 6.2],
      "25-mid": "6.84",
      "25-bound": [6.07, 7.59],
      "50-mid": "7.93",
      "50-bound": [6.99, 8.79],
      "100-mid": "9.14",
      "100-bound": [7.98, 10.1]
    },
    "2day": {
      "2-mid": "4.35",
      "2-bound": [3.91, 4.86],
      "5-mid": "5.53",
      "5-bound": [4.96, 6.17],
      "10-mid": "6.51",
      "10-bound": [5.81, 7.25],
      "25-mid": "7.92",
      "25-bound": [7.02, 8.8],
      "50-mid": "9.1",
      "50-bound": [8.01, 10.1],
      "100-mid": "10.4",
      "100-bound": [9.07, 11.5]
    },
    "3day": {
      "2-mid": "4.63",
      "2-bound": [4.21, 5.12],
      "5-mid": "5.88",
      "5-bound": [5.34, 6.5],
      "10-mid": "6.91",
      "10-bound": [6.25, 7.63],
      "25-mid": "8.41",
      "25-bound": [7.56, 9.27],
      "50-mid": "9.66",
      "50-bound": [8.63, 10.6],
      "100-mid": "11.0",
      "100-bound": [9.76, 12.1]
    },
    "4day": {
      "2-mid": "4.91",
      "2-bound": [4.51, 5.38],
      "5-mid": "6.24",
      "5-bound": [5.72, 6.84],
      "10-mid": "7.32",
      "10-bound": [6.7, 8.01],
      "25-mid": "8.9",
      "25-bound": [8.1, 9.73],
      "50-mid": "10.2",
      "50-bound": [9.24, 11.2],
      "100-mid": "11.6",
      "100-bound": [10.5, 12.7]
    },
    "7day": {
      "2-mid": "5.67",
      "2-bound": [5.22, 6.17],
      "5-mid": "7.09",
      "5-bound": [6.52, 7.71],
      "10-mid": "8.25",
      "10-bound": [7.57, 8.97],
      "25-mid": "9.92",
      "25-bound": [9.05, 10.8],
      "50-mid": "11.3",
      "50-bound": [10.3, 12.3],
      "100-mid": "12.8",
      "100-bound": [11.5, 13.9]
    }
  },
  "USC00441159 6": {
    "fips": "51530",
    "station_name": "BUENA VISTA",
    "state": "VA",
    "latitude": "37.7260",
    "longitude": "-79.3620",
    "5min": {
      "2-mid": "0.35",
      "2-bound": [0.32, 0.39],
      "5-mid": "0.43",
      "5-bound": [0.38, 0.47],
      "10-mid": "0.48",
      "10-bound": [0.43, 0.53],
      "25-mid": "0.55",
      "25-bound": [0.49, 0.6],
      "50-mid": "0.59",
      "50-bound": [0.53, 0.66],
      "100-mid": "0.64",
      "100-bound": [0.56, 0.71]
    },
    "10min": {
      "2-mid": "0.56",
      "2-bound": [0.51, 0.62],
      "5-mid": "0.68",
      "5-bound": [0.61, 0.76],
      "10-mid": "0.77",
      "10-bound": [0.69, 0.85],
      "25-mid": "0.87",
      "25-bound": [0.78, 0.96],
      "50-mid": "0.94",
      "50-bound": [0.84, 1.04],
      "100-mid": "1.01",
      "100-bound": [0.89, 1.12]
    },
    "15min": {
      "2-mid": "0.71",
      "2-bound": [0.64, 0.79],
      "5-mid": "0.86",
      "5-bound": [0.78, 0.96],
      "10-mid": "0.97",
      "10-bound": [0.87, 1.07],
      "25-mid": "1.1",
      "25-bound": [0.98, 1.22],
      "50-mid": "1.19",
      "50-bound": [1.06, 1.32],
      "100-mid": "1.28",
      "100-bound": [1.13, 1.42]
    },
    "30min": {
      "2-mid": "0.98",
      "2-bound": [0.88, 1.08],
      "5-mid": "1.23",
      "5-bound": [1.1, 1.36],
      "10-mid": "1.4",
      "10-bound": [1.26, 1.55],
      "25-mid": "1.63",
      "25-bound": [1.46, 1.8],
      "50-mid": "1.8",
      "50-bound": [1.59, 1.99],
      "100-mid": "1.96",
      "100-bound": [1.73, 2.17]
    },
    "60min": {
      "2-mid": "1.22",
      "2-bound": [1.11, 1.36],
      "5-mid": "1.57",
      "5-bound": [1.42, 1.74],
      "10-mid": "1.83",
      "10-bound": [1.64, 2.02],
      "25-mid": "2.17",
      "25-bound": [1.94, 2.4],
      "50-mid": "2.44",
      "50-bound": [2.16, 2.7],
      "100-mid": "2.7",
      "100-bound": [2.38, 3.0]
    },
    "2hr": {
      "2-mid": "1.42",
      "2-bound": [1.29, 1.58],
      "5-mid": "1.83",
      "5-bound": [1.66, 2.03],
      "10-mid": "2.15",
      "10-bound": [1.93, 2.38],
      "25-mid": "2.56",
      "25-bound": [2.3, 2.83],
      "50-mid": "2.89",
      "50-bound": [2.57, 3.2],
      "100-mid": "3.23",
      "100-bound": [2.85, 3.58]
    },
    "3hr": {
      "2-mid": "1.52",
      "2-bound": [1.38, 1.69],
      "5-mid": "1.95",
      "5-bound": [1.77, 2.16],
      "10-mid": "2.28",
      "10-bound": [2.06, 2.53],
      "25-mid": "2.72",
      "25-bound": [2.44, 3.02],
      "50-mid": "3.08",
      "50-bound": [2.74, 3.41],
      "100-mid": "3.44",
      "100-bound": [3.04, 3.82]
    },
    "6hr": {
      "2-mid": "1.88",
      "2-bound": [1.7, 2.1],
      "5-mid": "2.38",
      "5-bound": [2.15, 2.65],
      "10-mid": "2.78",
      "10-bound": [2.5, 3.09],
      "25-mid": "3.34",
      "25-bound": [2.98, 3.71],
      "50-mid": "3.8",
      "50-bound": [3.36, 4.22],
      "100-mid": "4.28",
      "100-bound": [3.75, 4.76]
    },
    "12hr": {
      "2-mid": "2.28",
      "2-bound": [2.06, 2.58],
      "5-mid": "2.88",
      "5-bound": [2.58, 3.25],
      "10-mid": "3.38",
      "10-bound": [3.02, 3.81],
      "25-mid": "4.1",
      "25-bound": [3.63, 4.62],
      "50-mid": "4.71",
      "50-bound": [4.12, 5.3],
      "100-mid": "5.38",
      "100-bound": [4.64, 6.06]
    },
    "24hr": {
      "2-mid": "2.89",
      "2-bound": [2.68, 3.14],
      "5-mid": "3.67",
      "5-bound": [3.4, 3.98],
      "10-mid": "4.31",
      "10-bound": [3.98, 4.67],
      "25-mid": "5.24",
      "25-bound": [4.81, 5.66],
      "50-mid": "6.02",
      "50-bound": [5.49, 6.49],
      "100-mid": "6.85",
      "100-bound": [6.21, 7.38]
    },
    "2day": {
      "2-mid": "3.39",
      "2-bound": [3.15, 3.66],
      "5-mid": "4.28",
      "5-bound": [3.97, 4.62],
      "10-mid": "5.0",
      "10-bound": [4.62, 5.39],
      "25-mid": "6.03",
      "25-bound": [5.55, 6.5],
      "50-mid": "6.88",
      "50-bound": [6.3, 7.41],
      "100-mid": "7.78",
      "100-bound": [7.08, 8.37]
    },
    "3day": {
      "2-mid": "3.62",
      "2-bound": [3.35, 3.92],
      "5-mid": "4.56",
      "5-bound": [4.22, 4.94],
      "10-mid": "5.33",
      "10-bound": [4.91, 5.75],
      "25-mid": "6.41",
      "25-bound": [5.88, 6.91],
      "50-mid": "7.29",
      "50-bound": [6.66, 7.87],
      "100-mid": "8.23",
      "100-bound": [7.47, 8.88]
    },
    "4day": {
      "2-mid": "3.86",
      "2-bound": [3.56, 4.18],
      "5-mid": "4.85",
      "5-bound": [4.47, 5.25],
      "10-mid": "5.65",
      "10-bound": [5.2, 6.11],
      "25-mid": "6.78",
      "25-bound": [6.21, 7.33],
      "50-mid": "7.7",
      "50-bound": [7.02, 8.32],
      "100-mid": "8.68",
      "100-bound": [7.86, 9.39]
    },
    "7day": {
      "2-mid": "4.43",
      "2-bound": [4.11, 4.76],
      "5-mid": "5.51",
      "5-bound": [5.11, 5.92],
      "10-mid": "6.36",
      "10-bound": [5.89, 6.82],
      "25-mid": "7.55",
      "25-bound": [6.96, 8.09],
      "50-mid": "8.5",
      "50-bound": [7.81, 9.11],
      "100-mid": "9.49",
      "100-bound": [8.67, 10.2]
    }
  },
  "USW00013764 6": {
    "fips": "10005",
    "station_name": "GEORGETOWN-DELAWARE COASTAL AIRPORT",
    "state": "DE",
    "latitude": "38.6897",
    "longitude": "-75.3625",
    "5min": {
      "2-mid": "0.42",
      "2-bound": [0.38, 0.46],
      "5-mid": "0.49",
      "5-bound": [0.45, 0.55],
      "10-mid": "0.56",
      "10-bound": [0.5, 0.61],
      "25-mid": "0.63",
      "25-bound": [0.56, 0.69],
      "50-mid": "0.68",
      "50-bound": [0.61, 0.76],
      "100-mid": "0.74",
      "100-bound": [0.66, 0.82]
    },
    "10min": {
      "2-mid": "0.67",
      "2-bound": [0.6, 0.74],
      "5-mid": "0.79",
      "5-bound": [0.71, 0.88],
      "10-mid": "0.89",
      "10-bound": [0.8, 0.98],
      "25-mid": "1.0",
      "25-bound": [0.9, 1.11],
      "50-mid": "1.09",
      "50-bound": [0.97, 1.2],
      "100-mid": "1.17",
      "100-bound": [1.04, 1.3]
    },
    "15min": {
      "2-mid": "0.84",
      "2-bound": [0.76, 0.93],
      "5-mid": "1.0",
      "5-bound": [0.9, 1.11],
      "10-mid": "1.12",
      "10-bound": [1.01, 1.24],
      "25-mid": "1.27",
      "25-bound": [1.14, 1.4],
      "50-mid": "1.38",
      "50-bound": [1.23, 1.52],
      "100-mid": "1.48",
      "100-bound": [1.32, 1.64]
    },
    "30min": {
      "2-mid": "1.16",
      "2-bound": [1.05, 1.28],
      "5-mid": "1.42",
      "5-bound": [1.28, 1.57],
      "10-mid": "1.63",
      "10-bound": [1.46, 1.8],
      "25-mid": "1.88",
      "25-bound": [1.69, 2.08],
      "50-mid": "2.08",
      "50-bound": [1.85, 2.3],
      "100-mid": "2.27",
      "100-bound": [2.02, 2.51]
    },
    "60min": {
      "2-mid": "1.46",
      "2-bound": [1.32, 1.61],
      "5-mid": "1.83",
      "5-bound": [1.64, 2.02],
      "10-mid": "2.12",
      "10-bound": [1.91, 2.34],
      "25-mid": "2.5",
      "25-bound": [2.24, 2.77],
      "50-mid": "2.81",
      "50-bound": [2.51, 3.11],
      "100-mid": "3.13",
      "100-bound": [2.78, 3.46]
    },
    "2hr": {
      "2-mid": "1.8",
      "2-bound": [1.61, 2.01],
      "5-mid": "2.27",
      "5-bound": [2.03, 2.53],
      "10-mid": "2.66",
      "10-bound": [2.38, 2.97],
      "25-mid": "3.18",
      "25-bound": [2.82, 3.54],
      "50-mid": "3.6",
      "50-bound": [3.18, 4.01],
      "100-mid": "4.04",
      "100-bound": [3.54, 4.51]
    },
    "3hr": {
      "2-mid": "1.97",
      "2-bound": [1.77, 2.19],
      "5-mid": "2.49",
      "5-bound": [2.24, 2.77],
      "10-mid": "2.93",
      "10-bound": [2.62, 3.25],
      "25-mid": "3.52",
      "25-bound": [3.13, 3.9],
      "50-mid": "4.01",
      "50-bound": [3.55, 4.45],
      "100-mid": "4.53",
      "100-bound": [3.97, 5.04]
    },
    "6hr": {
      "2-mid": "2.41",
      "2-bound": [2.17, 2.68],
      "5-mid": "3.03",
      "5-bound": [2.72, 3.37],
      "10-mid": "3.58",
      "10-bound": [3.2, 3.98],
      "25-mid": "4.34",
      "25-bound": [3.86, 4.82],
      "50-mid": "5.0",
      "50-bound": [4.41, 5.56],
      "100-mid": "5.71",
      "100-bound": [4.98, 6.36]
    },
    "12hr": {
      "2-mid": "2.85",
      "2-bound": [2.57, 3.2],
      "5-mid": "3.61",
      "5-bound": [3.23, 4.03],
      "10-mid": "4.31",
      "10-bound": [3.85, 4.81],
      "25-mid": "5.31",
      "25-bound": [4.7, 5.92],
      "50-mid": "6.21",
      "50-bound": [5.45, 6.93],
      "100-mid": "7.19",
      "100-bound": [6.23, 8.06]
    },
    "24hr": {
      "2-mid": "3.42",
      "2-bound": [3.16, 3.72],
      "5-mid": "4.44",
      "5-bound": [4.11, 4.83],
      "10-mid": "5.33",
      "10-bound": [4.91, 5.78],
      "25-mid": "6.68",
      "25-bound": [6.12, 7.22],
      "50-mid": "7.87",
      "50-bound": [7.15, 8.47],
      "100-mid": "9.2",
      "100-bound": [8.29, 9.89]
    },
    "2day": {
      "2-mid": "3.95",
      "2-bound": [3.65, 4.31],
      "5-mid": "5.13",
      "5-bound": [4.74, 5.59],
      "10-mid": "6.15",
      "10-bound": [5.66, 6.69],
      "25-mid": "7.69",
      "25-bound": [7.03, 8.34],
      "50-mid": "9.03",
      "50-bound": [8.2, 9.78],
      "100-mid": "10.5",
      "100-bound": [9.48, 11.4]
    },
    "3day": {
      "2-mid": "4.18",
      "2-bound": [3.87, 4.56],
      "5-mid": "5.41",
      "5-bound": [5.0, 5.89],
      "10-mid": "6.46",
      "10-bound": [5.95, 7.02],
      "25-mid": "8.04",
      "25-bound": [7.36, 8.71],
      "50-mid": "9.41",
      "50-bound": [8.56, 10.2],
      "100-mid": "10.9",
      "100-bound": [9.87, 11.8]
    },
    "4day": {
      "2-mid": "4.42",
      "2-bound": [4.1, 4.8],
      "5-mid": "5.69",
      "5-bound": [5.27, 6.19],
      "10-mid": "6.77",
      "10-bound": [6.25, 7.34],
      "25-mid": "8.38",
      "25-bound": [7.69, 9.08],
      "50-mid": "9.78",
      "50-bound": [8.92, 10.6],
      "100-mid": "11.3",
      "100-bound": [10.3, 12.2]
    },
    "7day": {
      "2-mid": "5.06",
      "2-bound": [4.72, 5.47],
      "5-mid": "6.4",
      "5-bound": [5.96, 6.92],
      "10-mid": "7.55",
      "10-bound": [7.01, 8.15],
      "25-mid": "9.24",
      "25-bound": [8.54, 9.94],
      "50-mid": "10.7",
      "50-bound": [9.81, 11.5],
      "100-mid": "12.3",
      "100-bound": [11.2, 13.2]
    }
  },
  "USC00446955 6": {
    "fips": "51155",
    "station_name": "PULASKI 2 E",
    "state": "VA",
    "latitude": "37.0558",
    "longitude": "-80.7841",
    "5min": {
      "2-mid": "0.33",
      "2-bound": [0.3, 0.37],
      "5-mid": "0.4",
      "5-bound": [0.36, 0.44],
      "10-mid": "0.45",
      "10-bound": [0.41, 0.5],
      "25-mid": "0.52",
      "25-bound": [0.46, 0.57],
      "50-mid": "0.56",
      "50-bound": [0.5, 0.62],
      "100-mid": "0.61",
      "100-bound": [0.53, 0.68]
    },
    "10min": {
      "2-mid": "0.53",
      "2-bound": [0.48, 0.59],
      "5-mid": "0.64",
      "5-bound": [0.58, 0.71],
      "10-mid": "0.72",
      "10-bound": [0.65, 0.8],
      "25-mid": "0.82",
      "25-bound": [0.73, 0.91],
      "50-mid": "0.89",
      "50-bound": [0.79, 0.99],
      "100-mid": "0.96",
      "100-bound": [0.84, 1.08]
    },
    "15min": {
      "2-mid": "0.67",
      "2-bound": [0.6, 0.74],
      "5-mid": "0.81",
      "5-bound": [0.73, 0.9],
      "10-mid": "0.91",
      "10-bound": [0.82, 1.01],
      "25-mid": "1.04",
      "25-bound": [0.93, 1.15],
      "50-mid": "1.13",
      "50-bound": [1.0, 1.26],
      "100-mid": "1.22",
      "100-bound": [1.07, 1.36]
    },
    "30min": {
      "2-mid": "0.92",
      "2-bound": [0.83, 1.02],
      "5-mid": "1.16",
      "5-bound": [1.04, 1.28],
      "10-mid": "1.32",
      "10-bound": [1.19, 1.46],
      "25-mid": "1.54",
      "25-bound": [1.38, 1.71],
      "50-mid": "1.7",
      "50-bound": [1.51, 1.89],
      "100-mid": "1.87",
      "100-bound": [1.63, 2.08]
    },
    "60min": {
      "2-mid": "1.16",
      "2-bound": [1.04, 1.28],
      "5-mid": "1.48",
      "5-bound": [1.34, 1.64],
      "10-mid": "1.72",
      "10-bound": [1.55, 1.91],
      "25-mid": "2.06",
      "25-bound": [1.83, 2.27],
      "50-mid": "2.31",
      "50-bound": [2.04, 2.57],
      "100-mid": "2.57",
      "100-bound": [2.25, 2.87]
    },
    "2hr": {
      "2-mid": "1.32",
      "2-bound": [1.19, 1.46],
      "5-mid": "1.7",
      "5-bound": [1.54, 1.88],
      "10-mid": "2.0",
      "10-bound": [1.8, 2.2],
      "25-mid": "2.4",
      "25-bound": [2.14, 2.65],
      "50-mid": "2.72",
      "50-bound": [2.41, 3.01],
      "100-mid": "3.05",
      "100-bound": [2.67, 3.39]
    },
    "3hr": {
      "2-mid": "1.4",
      "2-bound": [1.27, 1.54],
      "5-mid": "1.79",
      "5-bound": [1.62, 1.97],
      "10-mid": "2.09",
      "10-bound": [1.9, 2.3],
      "25-mid": "2.52",
      "25-bound": [2.26, 2.77],
      "50-mid": "2.86",
      "50-bound": [2.54, 3.15],
      "100-mid": "3.2",
      "100-bound": [2.82, 3.55]
    },
    "6hr": {
      "2-mid": "1.63",
      "2-bound": [1.5, 1.78],
      "5-mid": "2.07",
      "5-bound": [1.9, 2.26],
      "10-mid": "2.42",
      "10-bound": [2.21, 2.64],
      "25-mid": "2.91",
      "25-bound": [2.63, 3.18],
      "50-mid": "3.31",
      "50-bound": [2.97, 3.62],
      "100-mid": "3.72",
      "100-bound": [3.3, 4.11]
    },
    "12hr": {
      "2-mid": "1.94",
      "2-bound": [1.8, 2.1],
      "5-mid": "2.42",
      "5-bound": [2.25, 2.62],
      "10-mid": "2.83",
      "10-bound": [2.61, 3.06],
      "25-mid": "3.41",
      "25-bound": [3.12, 3.69],
      "50-mid": "3.9",
      "50-bound": [3.52, 4.22],
      "100-mid": "4.41",
      "100-bound": [3.92, 4.81]
    },
    "24hr": {
      "2-mid": "2.37",
      "2-bound": [2.2, 2.55],
      "5-mid": "2.99",
      "5-bound": [2.78, 3.21],
      "10-mid": "3.49",
      "10-bound": [3.24, 3.74],
      "25-mid": "4.22",
      "25-bound": [3.9, 4.51],
      "50-mid": "4.82",
      "50-bound": [4.43, 5.14],
      "100-mid": "5.45",
      "100-bound": [4.98, 5.81]
    },
    "2day": {
      "2-mid": "2.82",
      "2-bound": [2.63, 3.03],
      "5-mid": "3.54",
      "5-bound": [3.3, 3.8],
      "10-mid": "4.12",
      "10-bound": [3.82, 4.41],
      "25-mid": "4.93",
      "25-bound": [4.56, 5.28],
      "50-mid": "5.6",
      "50-bound": [5.15, 5.98],
      "100-mid": "6.28",
      "100-bound": [5.76, 6.73]
    },
    "3day": {
      "2-mid": "3.01",
      "2-bound": [2.81, 3.23],
      "5-mid": "3.76",
      "5-bound": [3.51, 4.04],
      "10-mid": "4.37",
      "10-bound": [4.06, 4.68],
      "25-mid": "5.22",
      "25-bound": [4.83, 5.58],
      "50-mid": "5.9",
      "50-bound": [5.45, 6.31],
      "100-mid": "6.62",
      "100-bound": [6.08, 7.08]
    },
    "4day": {
      "2-mid": "3.19",
      "2-bound": [2.99, 3.43],
      "5-mid": "3.99",
      "5-bound": [3.73, 4.27],
      "10-mid": "4.62",
      "10-bound": [4.3, 4.94],
      "25-mid": "5.5",
      "25-bound": [5.1, 5.87],
      "50-mid": "6.21",
      "50-bound": [5.74, 6.64],
      "100-mid": "6.96",
      "100-bound": [6.4, 7.43]
    },
    "7day": {
      "2-mid": "3.76",
      "2-bound": [3.52, 4.03],
      "5-mid": "4.63",
      "5-bound": [4.33, 4.96],
      "10-mid": "5.32",
      "10-bound": [4.96, 5.69],
      "25-mid": "6.26",
      "25-bound": [5.82, 6.69],
      "50-mid": "7.01",
      "50-bound": [6.49, 7.5],
      "100-mid": "7.78",
      "100-bound": [7.17, 8.33]
    }
  },
  "USC00442208 6": {
    "fips": "51165",
    "station_name": "DALE ENTERPRISE",
    "state": "VA",
    "latitude": "38.4540",
    "longitude": "-78.9350",
    "5min": {
      "2-mid": "0.34",
      "2-bound": [0.31, 0.39],
      "5-mid": "0.42",
      "5-bound": [0.38, 0.47],
      "10-mid": "0.48",
      "10-bound": [0.43, 0.53],
      "25-mid": "0.55",
      "25-bound": [0.48, 0.61],
      "50-mid": "0.6",
      "50-bound": [0.53, 0.67],
      "100-mid": "0.65",
      "100-bound": [0.57, 0.72]
    },
    "10min": {
      "2-mid": "0.55",
      "2-bound": [0.49, 0.61],
      "5-mid": "0.67",
      "5-bound": [0.6, 0.74],
      "10-mid": "0.75",
      "10-bound": [0.67, 0.83],
      "25-mid": "0.86",
      "25-bound": [0.76, 0.95],
      "50-mid": "0.94",
      "50-bound": [0.83, 1.04],
      "100-mid": "1.02",
      "100-bound": [0.89, 1.13]
    },
    "15min": {
      "2-mid": "0.68",
      "2-bound": [0.61, 0.76],
      "5-mid": "0.83",
      "5-bound": [0.75, 0.93],
      "10-mid": "0.94",
      "10-bound": [0.84, 1.05],
      "25-mid": "1.08",
      "25-bound": [0.96, 1.2],
      "50-mid": "1.18",
      "50-bound": [1.04, 1.3],
      "100-mid": "1.28",
      "100-bound": [1.12, 1.42]
    },
    "30min": {
      "2-mid": "0.93",
      "2-bound": [0.83, 1.04],
      "5-mid": "1.17",
      "5-bound": [1.05, 1.3],
      "10-mid": "1.34",
      "10-bound": [1.2, 1.49],
      "25-mid": "1.57",
      "25-bound": [1.39, 1.74],
      "50-mid": "1.74",
      "50-bound": [1.54, 1.93],
      "100-mid": "1.92",
      "100-bound": [1.68, 2.13]
    },
    "60min": {
      "2-mid": "1.16",
      "2-bound": [1.04, 1.29],
      "5-mid": "1.48",
      "5-bound": [1.33, 1.65],
      "10-mid": "1.73",
      "10-bound": [1.55, 1.93],
      "25-mid": "2.07",
      "25-bound": [1.84, 2.29],
      "50-mid": "2.34",
      "50-bound": [2.06, 2.59],
      "100-mid": "2.62",
      "100-bound": [2.29, 2.9]
    },
    "2hr": {
      "2-mid": "1.37",
      "2-bound": [1.23, 1.53],
      "5-mid": "1.76",
      "5-bound": [1.58, 1.96],
      "10-mid": "2.07",
      "10-bound": [1.85, 2.3],
      "25-mid": "2.49",
      "25-bound": [2.22, 2.77],
      "50-mid": "2.85",
      "50-bound": [2.52, 3.16],
      "100-mid": "3.22",
      "100-bound": [2.82, 3.57]
    },
    "3hr": {
      "2-mid": "1.47",
      "2-bound": [1.32, 1.64],
      "5-mid": "1.87",
      "5-bound": [1.68, 2.09],
      "10-mid": "2.19",
      "10-bound": [1.96, 2.44],
      "25-mid": "2.65",
      "25-bound": [2.36, 2.95],
      "50-mid": "3.03",
      "50-bound": [2.67, 3.37],
      "100-mid": "3.43",
      "100-bound": [3.0, 3.82]
    },
    "6hr": {
      "2-mid": "1.82",
      "2-bound": [1.64, 2.03],
      "5-mid": "2.28",
      "5-bound": [2.05, 2.55],
      "10-mid": "2.67",
      "10-bound": [2.39, 2.98],
      "25-mid": "3.24",
      "25-bound": [2.88, 3.6],
      "50-mid": "3.71",
      "50-bound": [3.28, 4.12],
      "100-mid": "4.23",
      "100-bound": [3.69, 4.7]
    },
    "12hr": {
      "2-mid": "2.22",
      "2-bound": [2.0, 2.5],
      "5-mid": "2.78",
      "5-bound": [2.5, 3.13],
      "10-mid": "3.27",
      "10-bound": [2.92, 3.68],
      "25-mid": "4.0",
      "25-bound": [3.54, 4.47],
      "50-mid": "4.62",
      "50-bound": [4.05, 5.17],
      "100-mid": "5.31",
      "100-bound": [4.59, 5.95]
    },
    "24hr": {
      "2-mid": "2.62",
      "2-bound": [2.42, 2.86],
      "5-mid": "3.31",
      "5-bound": [3.05, 3.6],
      "10-mid": "3.89",
      "10-bound": [3.57, 4.22],
      "25-mid": "4.73",
      "25-bound": [4.32, 5.13],
      "50-mid": "5.43",
      "50-bound": [4.93, 5.9],
      "100-mid": "6.2",
      "100-bound": [5.58, 6.72]
    },
    "2day": {
      "2-mid": "3.04",
      "2-bound": [2.83, 3.3],
      "5-mid": "3.82",
      "5-bound": [3.55, 4.14],
      "10-mid": "4.47",
      "10-bound": [4.14, 4.83],
      "25-mid": "5.39",
      "25-bound": [4.96, 5.82],
      "50-mid": "6.15",
      "50-bound": [5.62, 6.65],
      "100-mid": "6.96",
      "100-bound": [6.31, 7.53]
    },
    "3day": {
      "2-mid": "3.21",
      "2-bound": [3.0, 3.46],
      "5-mid": "4.02",
      "5-bound": [3.75, 4.34],
      "10-mid": "4.69",
      "10-bound": [4.36, 5.05],
      "25-mid": "5.64",
      "25-bound": [5.21, 6.07],
      "50-mid": "6.42",
      "50-bound": [5.9, 6.91],
      "100-mid": "7.26",
      "100-bound": [6.61, 7.82]
    },
    "4day": {
      "2-mid": "3.38",
      "2-bound": [3.16, 3.63],
      "5-mid": "4.22",
      "5-bound": [3.94, 4.54],
      "10-mid": "4.91",
      "10-bound": [4.58, 5.26],
      "25-mid": "5.89",
      "25-bound": [5.46, 6.31],
      "50-mid": "6.7",
      "50-bound": [6.17, 7.17],
      "100-mid": "7.55",
      "100-bound": [6.91, 8.1]
    },
    "7day": {
      "2-mid": "3.88",
      "2-bound": [3.64, 4.15],
      "5-mid": "4.8",
      "5-bound": [4.49, 5.13],
      "10-mid": "5.53",
      "10-bound": [5.17, 5.89],
      "25-mid": "6.55",
      "25-bound": [6.09, 6.98],
      "50-mid": "7.37",
      "50-bound": [6.82, 7.87],
      "100-mid": "8.22",
      "100-bound": [7.56, 8.78]
    }
  },
  "USC00460509 6": {
    "fips": "54075",
    "station_name": "BARTOW 1S",
    "state": "WV",
    "latitude": "38.5310",
    "longitude": "-79.7710",
    "5min": {
      "2-mid": "0.34",
      "2-bound": [0.3, 0.38],
      "5-mid": "0.41",
      "5-bound": [0.37, 0.45],
      "10-mid": "0.46",
      "10-bound": [0.41, 0.51],
      "25-mid": "0.52",
      "25-bound": [0.46, 0.58],
      "50-mid": "0.57",
      "50-bound": [0.5, 0.63],
      "100-mid": "0.61",
      "100-bound": [0.54, 0.68]
    },
    "10min": {
      "2-mid": "0.54",
      "2-bound": [0.48, 0.6],
      "5-mid": "0.65",
      "5-bound": [0.59, 0.73],
      "10-mid": "0.73",
      "10-bound": [0.66, 0.81],
      "25-mid": "0.83",
      "25-bound": [0.74, 0.92],
      "50-mid": "0.9",
      "50-bound": [0.8, 1.0],
      "100-mid": "0.97",
      "100-bound": [0.85, 1.08]
    },
    "15min": {
      "2-mid": "0.68",
      "2-bound": [0.61, 0.76],
      "5-mid": "0.83",
      "5-bound": [0.74, 0.92],
      "10-mid": "0.93",
      "10-bound": [0.83, 1.03],
      "25-mid": "1.05",
      "25-bound": [0.94, 1.17],
      "50-mid": "1.14",
      "50-bound": [1.01, 1.26],
      "100-mid": "1.23",
      "100-bound": [1.08, 1.36]
    },
    "30min": {
      "2-mid": "0.94",
      "2-bound": [0.84, 1.05],
      "5-mid": "1.17",
      "5-bound": [1.05, 1.3],
      "10-mid": "1.34",
      "10-bound": [1.2, 1.49],
      "25-mid": "1.56",
      "25-bound": [1.39, 1.73],
      "50-mid": "1.72",
      "50-bound": [1.52, 1.9],
      "100-mid": "1.88",
      "100-bound": [1.65, 2.09]
    },
    "60min": {
      "2-mid": "1.18",
      "2-bound": [1.06, 1.32],
      "5-mid": "1.5",
      "5-bound": [1.35, 1.67],
      "10-mid": "1.75",
      "10-bound": [1.56, 1.94],
      "25-mid": "2.08",
      "25-bound": [1.84, 2.3],
      "50-mid": "2.33",
      "50-bound": [2.06, 2.58],
      "100-mid": "2.59",
      "100-bound": [2.27, 2.88]
    },
    "2hr": {
      "2-mid": "1.38",
      "2-bound": [1.25, 1.54],
      "5-mid": "1.76",
      "5-bound": [1.59, 1.95],
      "10-mid": "2.05",
      "10-bound": [1.85, 2.28],
      "25-mid": "2.45",
      "25-bound": [2.19, 2.72],
      "50-mid": "2.78",
      "50-bound": [2.47, 3.09],
      "100-mid": "3.12",
      "100-bound": [2.75, 3.46]
    },
    "3hr": {
      "2-mid": "1.5",
      "2-bound": [1.36, 1.66],
      "5-mid": "1.89",
      "5-bound": [1.71, 2.1],
      "10-mid": "2.2",
      "10-bound": [1.99, 2.45],
      "25-mid": "2.64",
      "25-bound": [2.37, 2.93],
      "50-mid": "3.0",
      "50-bound": [2.67, 3.33],
      "100-mid": "3.37",
      "100-bound": [2.97, 3.74]
    },
    "6hr": {
      "2-mid": "1.84",
      "2-bound": [1.67, 2.04],
      "5-mid": "2.29",
      "5-bound": [2.08, 2.54],
      "10-mid": "2.67",
      "10-bound": [2.41, 2.95],
      "25-mid": "3.2",
      "25-bound": [2.87, 3.54],
      "50-mid": "3.65",
      "50-bound": [3.24, 4.03],
      "100-mid": "4.13",
      "100-bound": [3.63, 4.57]
    },
    "12hr": {
      "2-mid": "2.19",
      "2-bound": [1.99, 2.44],
      "5-mid": "2.72",
      "5-bound": [2.46, 3.02],
      "10-mid": "3.17",
      "10-bound": [2.86, 3.52],
      "25-mid": "3.84",
      "25-bound": [3.43, 4.25],
      "50-mid": "4.4",
      "50-bound": [3.89, 4.88],
      "100-mid": "5.02",
      "100-bound": [4.38, 5.58]
    },
    "24hr": {
      "2-mid": "2.7",
      "2-bound": [2.49, 2.94],
      "5-mid": "3.29",
      "5-bound": [3.03, 3.59],
      "10-mid": "3.78",
      "10-bound": [3.47, 4.12],
      "25-mid": "4.48",
      "25-bound": [4.08, 4.89],
      "50-mid": "5.06",
      "50-bound": [4.57, 5.53],
      "100-mid": "5.67",
      "100-bound": [5.08, 6.22]
    },
    "2day": {
      "2-mid": "3.18",
      "2-bound": [2.95, 3.43],
      "5-mid": "3.83",
      "5-bound": [3.56, 4.14],
      "10-mid": "4.37",
      "10-bound": [4.04, 4.72],
      "25-mid": "5.12",
      "25-bound": [4.69, 5.54],
      "50-mid": "5.72",
      "50-bound": [5.21, 6.21],
      "100-mid": "6.35",
      "100-bound": [5.73, 6.93]
    },
    "3day": {
      "2-mid": "3.42",
      "2-bound": [3.19, 3.69],
      "5-mid": "4.1",
      "5-bound": [3.81, 4.41],
      "10-mid": "4.64",
      "10-bound": [4.31, 5.0],
      "25-mid": "5.38",
      "25-bound": [4.96, 5.81],
      "50-mid": "5.97",
      "50-bound": [5.47, 6.46],
      "100-mid": "6.58",
      "100-bound": [5.97, 7.14]
    },
    "4day": {
      "2-mid": "3.67",
      "2-bound": [3.44, 3.94],
      "5-mid": "4.36",
      "5-bound": [4.07, 4.68],
      "10-mid": "4.91",
      "10-bound": [4.57, 5.28],
      "25-mid": "5.65",
      "25-bound": [5.23, 6.08],
      "50-mid": "6.22",
      "50-bound": [5.73, 6.71],
      "100-mid": "6.8",
      "100-bound": [6.22, 7.36]
    },
    "7day": {
      "2-mid": "4.39",
      "2-bound": [4.13, 4.68],
      "5-mid": "5.17",
      "5-bound": [4.85, 5.51],
      "10-mid": "5.76",
      "10-bound": [5.4, 6.16],
      "25-mid": "6.55",
      "25-bound": [6.11, 7.01],
      "50-mid": "7.16",
      "50-bound": [6.64, 7.68],
      "100-mid": "7.75",
      "100-bound": [7.15, 8.34]
    }
  }
};

// Removed Cayuga, as there is no data for it FIPS = "36011"
export const counties = ["10001", "10003", "10005", "11001", "24001", "24003", "24005", "24009", "24011", "24013", "24015", "24017", "24019", "24021", "24023", "24025", "24027", "24029", "24031", "24033", "24035", "24037", "24039", "24041", "24043", "24045", "24047", "24510", "36003", "36007", "36015", "36017", "36023", "36025", "36043", "36051", "36053", "36057", "36065", "36067", "36069", "36077", "36095", "36097", "36101", "36107", "36109", "36123", "42001", "42009", "42011", "42013", "42015", "42021", "42023", "42025", "42027", "42029", "42033", "42035", "42037", "42041", "42043", "42047", "42055", "42057", "42061", "42063", "42065", "42067", "42069", "42071", "42075", "42079", "42081", "42083", "42087", "42093", "42097", "42099", "42105", "42107", "42109", "42111", "42113", "42115", "42117", "42119", "42127", "42131", "42133", "51001", "51003", "51005", "51007", "51009", "51011", "51013", "51015", "51017", "51019", "51023", "51029", "51031", "51033", "51036", "51037", "51041", "51043", "51045", "51047", "51049", "51053", "51057", "51059", "51061", "51065", "51069", "51071", "51073", "51075", "51079", "51085", "51087", "51091", "51093", "51095", "51097", "51099", "51101", "51103", "51107", "51109", "51111", "51113", "51115", "51119", "51121", "51125", "51127", "51131", "51133", "51135", "51137", "51139", "51145", "51147", "51149", "51153", "51157", "51159", "51161", "51163", "51165", "51171", "51177", "51179", "51181", "51187", "51193", "51199", "51510", "51530", "51540", "51550", "51570", "51580", "51600", "51630", "51650", "51660", "51670", "51678", "51680", "51683", "51700", "51710", "51730", "51735", "51740", "51760", "51770", "51775", "51790", "51800", "51810", "51820", "51830", "51840", "54003", "54023", "54025", "54027", "54031", "54037", "54057", "54063", "54065", "54071", "54075", "54077", "54083", "54093"];

// Missing Bedford Station because there is no data for FIPS 51515 in the cf_rcp85_20x0-2xx0_dxxx.json files
export const virginiaCounties = [
  "51000",
  "51001",
  "51003",
  "51005",
  "51007",
  "51009",
  "51011",
  "51013",
  "51015",
  "51017",
  "51019",
  "51021",
  "51023",
  "51025",
  "51027",
  "51029",
  "51031",
  "51033",
  "51035",
  "51036",
  "51037",
  "51041",
  "51043",
  "51045",
  "51047",
  "51049",
  "51051",
  "51053",
  "51057",
  "51059",
  "51061",
  "51063",
  "51065",
  "51067",
  "51069",
  "51071",
  "51073",
  "51075",
  "51077",
  "51079",
  "51081",
  "51083",
  "51085",
  "51087",
  "51089",
  "51091",
  "51093",
  "51095",
  "51097",
  "51099",
  "51101",
  "51103",
  "51105",
  "51107",
  "51109",
  "51111",
  "51113",
  "51115",
  "51117",
  "51119",
  "51121",
  "51125",
  "51127",
  "51131",
  "51133",
  "51135",
  "51137",
  "51139",
  "51141",
  "51143",
  "51145",
  "51147",
  "51149",
  "51153",
  "51155",
  "51157",
  "51159",
  "51161",
  "51163",
  "51165",
  "51167",
  "51169",
  "51171",
  "51173",
  "51175",
  "51177",
  "51179",
  "51181",
  "51183",
  "51185",
  "51187",
  "51191",
  "51193",
  "51195",
  "51197",
  "51199",
  "51510",
  "51520",
  "51530",
  "51540",
  "51550",
  "51570",
  "51580",
  "51590",
  "51595",
  "51600",
  "51610",
  "51620",
  "51630",
  "51640",
  "51650",
  "51660",
  "51670",
  "51678",
  "51680",
  "51683",
  "51685",
  "51690",
  "51700",
  "51710",
  "51720",
  "51730",
  "51735",
  "51740",
  "51750",
  "51760",
  "51770",
  "51775",
  "51790",
  "51800",
  "51810",
  "51820",
  "51830",
  "51840"
];